import React__default, { createElement, useState, useRef, useEffect, useCallback, Fragment, useMemo, useContext, createContext } from 'react';
import { spError, spErrorTags, checkClaimsWeb, EventrDate, spLogTags, isDateInPast, isDateInRange as isDateInRange$1, getTimezoneName, CountryCodesWithNames, useItinInfo, getTimezoneNumber, getUserPref, setUserPref, daysInMonthInt, daysInMonthStr, getJsonKeyFromField, spLog, ValidationTypes, RegExpCheckInteger } from '@eventr/common';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Box, LinearProgress, Stack, Typography as Typography$1, Divider, IconButton, Snackbar, Card, Button, TextField, Tooltip as Tooltip$1, InputAdornment, Paper, Radio, Checkbox, useMediaQuery, ToggleButton, DialogContent, DialogTitle, DialogContentText, DialogActions, Dialog, Select, MenuItem, Autocomplete, Collapse, Drawer, FormLabel, Popover, List as List$1, ListItem, ListItemButton, ListItemText, styled, FormGroup, FormControlLabel, Switch, FormControl, InputLabel, Chip, FormHelperText, CircularProgress, useTheme, Backdrop, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination } from '@mui/material';
import axios from 'axios';
import { create } from 'zustand';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { isMobile } from 'react-device-detect';
import { createTheme } from '@mui/material/styles';
import { DateTime } from 'luxon';
import { useShallow } from 'zustand/react/shallow';
import { LocalizationProvider, StaticTimePicker, MultiSectionDigitalClock } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { VirtualScroller } from 'primereact/virtualscroller';
import { DateRangePicker as DateRangePicker$1 } from 'rsuite';
import CloseIcon from '@mui/icons-material/Close';
import { Controller } from 'react-hook-form';
import DateRangePicker$2 from 'rsuite/DateRangePicker';
import { persist } from 'zustand/middleware';
import ApiClient from '@eventr/common/lib/httpRequests/httpRequest';
import { useDropzone } from 'react-dropzone';
import { motion, AnimatePresence } from 'framer-motion';
import { ErrorBoundary } from 'react-error-boundary';
import PullToRefresh from 'react-simple-pull-to-refresh';

const AdminBobbin = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '200',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M189.5 381C256.603 381 311 371.598 311 360C311 348.402 256.603 339 189.5 339C122.397 339 68 348.402 68 360C68 371.598 122.397 381 189.5 381Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M48.0588 252.821C73.0025 331.473 156.773 374.952 235.17 349.925C271.472 338.341 300.253 314.092 318.213 283.589C319.702 281.059 321.119 278.486 322.456 275.875C323.566 273.716 324.618 271.533 325.613 269.323C326.987 266.319 328.245 263.263 329.402 260.174C340.829 229.81 342.517 195.519 331.95 162.184C328.005 149.749 322.595 138.193 315.949 127.648C314.802 125.808 313.608 123.992 312.373 122.213C311.585 121.069 310.776 119.942 309.96 118.825C307.372 115.308 304.655 111.926 301.803 108.678C263.917 65.5897 202.901 46.5376 144.839 65.0736C66.4384 90.1075 23.1084 174.151 48.0521 252.817L48.0588 252.821Z',
  fill: '#0A2040'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M265.725 336.257C262.891 337.935 259.998 339.52 257.045 340.997C254.885 342.093 252.698 343.131 250.48 344.114C247.805 345.308 245.085 346.418 242.342 347.449C209.245 359.906 171.637 360.671 136.105 346.819C59.3609 316.917 21.3364 230.224 51.1721 153.188C55.0783 143.102 59.9509 133.687 65.6474 125C53.5321 193.883 91.0683 263.988 158.498 290.26C194.034 304.112 231.641 303.347 264.735 290.89C267.478 289.855 270.198 288.746 272.873 287.555C275.091 286.572 277.278 285.534 279.438 284.438C282.391 282.962 285.283 281.373 288.118 279.698C307.412 268.32 324.261 252.542 337 233.109C335.335 242.63 332.711 252.123 329.093 261.474C316.445 294.115 293.652 319.785 265.729 336.254L265.725 336.257Z',
  fill: '#091E36'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M189.5 238C222.361 238 249 211.361 249 178.5C249 145.639 222.361 119 189.5 119C156.639 119 130 145.639 130 178.5C130 211.361 156.639 238 189.5 238Z',
  fill: '#091E36'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M189.5 233C222.361 233 249 206.361 249 173.5C249 140.639 222.361 114 189.5 114C156.639 114 130 140.639 130 173.5C130 206.361 156.639 233 189.5 233Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M204 213C220.569 213 234 199.569 234 183C234 166.431 220.569 153 204 153C187.431 153 174 166.431 174 183C174 199.569 187.431 213 204 213Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M225.5 177C230.747 177 235 172.747 235 167.5C235 162.253 230.747 158 225.5 158C220.253 158 216 162.253 216 167.5C216 172.747 220.253 177 225.5 177Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M155.759 366.57C164.632 362.883 166.737 347.655 160.462 332.558C154.187 317.461 141.908 308.212 133.036 311.899C124.164 315.587 122.058 330.815 128.333 345.912C134.608 361.009 146.887 370.258 155.759 366.57Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M251.141 346.096C257.416 330.999 255.311 315.771 246.439 312.084C237.566 308.396 225.287 317.645 219.012 332.742C212.737 347.839 214.843 363.067 223.715 366.755C232.587 370.442 244.866 361.193 251.141 346.096Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M47.4188 197.72L92 287.273L91.5148 306.617C91.4845 307.749 90.2311 308.388 89.3181 307.742L73.685 296.656L29.1038 207.103C26.5499 201.972 28.5782 195.71 33.6354 193.119C36.1622 191.823 38.9722 191.693 41.4654 192.52C43.9552 193.355 46.1419 195.153 47.4188 197.716V197.72Z',
  fill: '#F3C722'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M33.4232 212L30.2916 214.695C29.0863 215.731 28.6774 217.373 29.2657 218.816L42 250',
  fill: '#F3C722'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M33.4232 212L30.2916 214.695C29.0863 215.731 28.6774 217.373 29.2657 218.816L42 250',
  stroke: '#0A2040',
  strokeWidth: '17.01',
  strokeMiterlimit: '10',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M375.285 210.786L301.605 184.651C294.294 182.058 286.265 185.882 283.671 193.193L250.046 287.992C247.452 295.303 251.277 303.332 258.588 305.926L332.268 332.06C339.579 334.654 347.608 330.829 350.201 323.518L383.827 228.719C386.42 221.408 382.596 213.379 375.285 210.786Z',
  fill: '#66461B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M352.324 194.356L331.065 186.815C329.248 186.171 327.253 187.121 326.608 188.938L323.721 197.078C323.076 198.895 324.027 200.89 325.844 201.535L347.103 209.076C348.92 209.72 350.915 208.77 351.56 206.953L354.447 198.813C355.091 196.996 354.141 195.001 352.324 194.356Z',
  fill: '#6D6F71'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M246.975 253.147C246.975 253.175 246.975 253.198 246.975 253.226C246.975 254.882 246.788 256.495 246.435 257.948C244.985 263.914 240.273 268.874 234.626 272.035C227.449 276.055 218.761 277.165 213.369 273.739C210.554 271.947 208.12 268.589 207.37 264.677C207.299 264.314 207.241 263.944 207.203 263.571C206.905 260.776 207.465 257.605 208.813 255.049C209.699 253.368 210.925 251.952 212.473 251.073C216.632 248.713 218.849 250.71 222.356 247.668C224.285 245.994 225.157 245.742 227.055 243.43C230.012 239.831 236.029 237.733 240.317 239.516C244.893 241.417 246.971 247.515 246.971 253.147H246.975Z',
  fill: 'url(#paint0_linear_1149_9567)'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M246.975 253.147C246.975 253.175 246.975 253.198 246.975 253.226C246.965 253.925 246.924 254.614 246.849 255.286L213.271 255.076C212.785 255.076 212.415 254.662 212.412 254.163C212.405 252.876 211.213 251.786 212.473 251.073C216.632 248.713 218.849 250.71 222.356 247.668C224.285 245.994 225.157 245.742 227.055 243.43C230.012 239.831 236.029 237.733 240.317 239.516C244.894 241.417 246.971 247.515 246.971 253.147H246.975Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M234.626 272.035C227.449 276.055 218.761 277.165 213.369 273.739C210.554 271.947 208.12 268.589 207.37 264.677C210.228 263.499 213.76 262.81 217.579 262.834C226.668 262.892 234.08 266.952 234.626 272.035Z',
  fill: '#C4678B'
}), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
  id: 'paint0_linear_1149_9567',
  x1: '208.027',
  y1: '256.795',
  x2: '247.854',
  y2: '257.045',
  gradientUnits: 'userSpaceOnUse'
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: '#A64B73'
}), /*#__PURE__*/React__default.createElement("stop", {
  offset: '1',
  stopColor: '#8B2F5B'
})))));

const AdminBobbinDark = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '200',
  viewBox: '0 0 200 200',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M94.75 190.5C128.301 190.5 155.5 185.799 155.5 180C155.5 174.201 128.301 169.5 94.75 169.5C61.1987 169.5 34 174.201 34 180C34 185.799 61.1987 190.5 94.75 190.5Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M24.0294 126.41C36.5012 165.737 78.3864 187.476 117.585 174.962C135.736 169.171 150.126 157.046 159.106 141.794C159.851 140.53 160.56 139.243 161.228 137.938C161.783 136.858 162.309 135.767 162.806 134.662C163.493 133.159 164.123 131.632 164.701 130.087C170.414 114.905 171.259 97.7593 165.975 81.0921C164.003 74.8744 161.297 69.0963 157.975 63.8241C157.401 62.904 156.804 61.9959 156.186 61.1065C155.792 60.5344 155.388 59.9709 154.98 59.4124C153.686 57.6539 152.327 55.9632 150.901 54.3388C131.958 32.7948 101.451 23.2688 72.4195 32.5368C33.2192 45.0537 11.5542 87.0756 24.026 126.409L24.0294 126.41Z',
  fill: '#FFC900'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M132.863 168.129C131.445 168.967 129.999 169.76 128.522 170.499C127.442 171.046 126.349 171.565 125.24 172.057C123.902 172.654 122.543 173.209 121.171 173.724C104.622 179.953 85.8186 180.336 68.0525 173.41C29.6804 158.458 10.6682 115.112 25.586 76.5938C27.5392 71.5511 29.9754 66.8435 32.8237 62.5C26.766 96.9417 45.5342 131.994 79.2489 145.13C97.0168 152.056 115.82 151.673 132.368 145.445C133.739 144.928 135.099 144.373 136.437 143.778C137.545 143.286 138.639 142.767 139.719 142.219C141.196 141.481 142.642 140.686 144.059 139.849C153.706 134.16 162.13 126.271 168.5 116.555C167.668 121.315 166.355 126.062 164.546 130.737C158.222 147.058 146.826 159.893 132.864 168.127L132.863 168.129Z',
  fill: '#F5BF00'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M94.75 119C111.18 119 124.5 105.68 124.5 89.25C124.5 72.8195 111.18 59.5 94.75 59.5C78.3195 59.5 65 72.8195 65 89.25C65 105.68 78.3195 119 94.75 119Z',
  fill: '#F5BF00'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M94.75 116.5C111.18 116.5 124.5 103.18 124.5 86.75C124.5 70.3195 111.18 57 94.75 57C78.3195 57 65 70.3195 65 86.75C65 103.18 78.3195 116.5 94.75 116.5Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M102 106.5C110.284 106.5 117 99.7843 117 91.5C117 83.2157 110.284 76.5 102 76.5C93.7157 76.5 87 83.2157 87 91.5C87 99.7843 93.7157 106.5 102 106.5Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.75 88.5C115.373 88.5 117.5 86.3734 117.5 83.75C117.5 81.1266 115.373 79 112.75 79C110.127 79 108 81.1266 108 83.75C108 86.3734 110.127 88.5 112.75 88.5Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M77.8804 183.286C82.3165 181.442 83.3693 173.828 80.2318 166.28C77.0943 158.731 70.9547 154.107 66.5186 155.95C62.0825 157.794 61.0298 165.408 64.1672 172.957C67.3047 180.505 73.4443 185.13 77.8804 183.286Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M125.57 173.049C128.707 165.5 127.654 157.886 123.218 156.042C118.782 154.198 112.643 158.823 109.505 166.371C106.368 173.92 107.42 181.534 111.856 183.378C116.293 185.221 122.432 180.597 125.57 173.049Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M23.7094 98.8599L46 143.637L45.7574 153.309C45.7422 153.874 45.1156 154.194 44.659 153.871L36.8425 148.328L14.5519 103.552C13.275 100.986 14.2891 97.8549 16.8177 96.5593C18.0811 95.9116 19.4861 95.8466 20.7327 96.2602C21.9776 96.6773 23.0709 97.5763 23.7094 98.8582V98.8599Z',
  fill: '#F32222'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M16.7116 106L15.1458 107.347C14.5431 107.866 14.3387 108.686 14.6328 109.408L21 125',
  fill: '#F3C722'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M16.7116 106L15.1458 107.347C14.5431 107.866 14.3387 108.686 14.6328 109.408L21 125',
  stroke: 'white',
  strokeWidth: '8.505',
  strokeMiterlimit: '10',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M187.642 105.392L150.803 92.3243C147.147 91.0277 143.132 92.9399 141.836 96.5954L125.023 143.995C123.726 147.65 125.638 151.665 129.294 152.962L166.134 166.029C169.789 167.326 173.804 165.413 175.101 161.758L191.914 114.358C193.21 110.703 191.298 106.688 187.642 105.392Z',
  fill: '#66461B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M176.161 97.1781L165.531 93.4076C164.623 93.0854 163.626 93.5606 163.303 94.469L161.86 98.5392C161.537 99.4475 162.013 100.445 162.921 100.767L173.551 104.538C174.459 104.86 175.457 104.385 175.779 103.476L177.223 99.4063C177.545 98.4979 177.07 97.5003 176.161 97.1781Z',
  fill: '#6D6F71'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M123.487 126.573C123.487 126.586 123.487 126.598 123.487 126.612C123.487 127.44 123.394 128.246 123.217 128.973C122.492 131.956 120.136 134.436 117.313 136.016C113.724 138.026 109.38 138.581 106.684 136.869C105.277 135.972 104.06 134.293 103.685 132.338C103.649 132.156 103.62 131.971 103.602 131.784C103.452 130.387 103.732 128.802 104.406 127.523C104.849 126.683 105.462 125.975 106.236 125.535C108.316 124.356 109.424 125.354 111.178 123.833C112.142 122.996 112.579 122.87 113.527 121.714C115.006 119.915 118.014 118.866 120.158 119.757C122.447 120.707 123.486 123.756 123.486 126.573H123.487Z',
  fill: 'url(#paint0_linear_9182_35196)'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M123.487 126.573C123.487 126.586 123.487 126.598 123.487 126.612C123.482 126.961 123.462 127.306 123.424 127.642L106.635 127.537C106.392 127.537 106.207 127.33 106.206 127.08C106.202 126.437 105.606 125.892 106.236 125.535C108.316 124.356 109.424 125.354 111.178 123.833C112.142 122.996 112.578 122.87 113.527 121.714C115.006 119.915 118.014 118.866 120.158 119.757C122.446 120.707 123.485 123.756 123.485 126.573H123.487Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M117.314 136.015C113.725 138.025 109.381 138.58 106.685 136.867C105.278 135.971 104.061 134.292 103.686 132.336C105.115 131.747 106.88 131.402 108.79 131.414C113.335 131.443 117.041 133.474 117.314 136.015Z',
  fill: '#C4678B'
}), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
  id: 'paint0_linear_9182_35196',
  x1: '104.014',
  y1: '128.396',
  x2: '123.927',
  y2: '128.522',
  gradientUnits: 'userSpaceOnUse'
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: '#A64B73'
}), /*#__PURE__*/React__default.createElement("stop", {
  offset: '1',
  stopColor: '#8B2F5B'
})))));

const BobbingInBed = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '250',
  height: '250',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M202.5 376C308.263 376 394 361.673 394 344C394 326.327 308.263 312 202.5 312C96.7375 312 11 326.327 11 344C11 361.673 96.7375 376 202.5 376Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M48.8274 229H358V322.315C358 324.348 356.335 326 354.286 326H45.7139C43.6651 326 42 324.348 42 322.315V235.777C42 232.037 45.0609 229 48.8305 229H48.8274Z',
  fill: '#256D67'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M351.335 335.6C342.701 346.757 338.268 327.801 324.429 327.801C310.59 327.801 310.59 333.552 296.751 333.552C282.912 333.552 282.912 343.966 269.074 343.966C255.235 343.966 255.235 336.105 241.396 336.105C227.557 336.105 227.557 334.849 213.718 334.849C199.879 334.849 199.879 343.687 186.04 343.687C172.202 343.687 172.201 333.115 158.366 333.115C144.527 333.115 144.527 340.963 130.688 340.963C116.849 340.963 116.849 342.84 103.01 342.84C89.1714 342.84 89.1714 334.449 75.3294 334.449C61.4906 334.449 54.4475 350.446 43.9479 341.034C34.931 332.95 40.9948 324.128 40.9948 311.723C40.9948 299.315 49.8511 299.315 49.8511 286.911C49.8511 274.502 51.9763 274.503 51.9763 262.098C51.9763 249.69 41.767 249.175 50.7839 241.091C61.2804 231.679 61.4875 240.815 75.3263 240.815C89.1652 240.815 89.1652 240.446 103.004 240.446C116.843 240.446 116.843 231.478 130.682 231.478C144.521 231.478 144.521 243.309 158.36 243.309C172.198 243.309 172.198 236.1 186.037 236.1C199.876 236.1 199.876 242.601 213.715 242.601C227.554 242.601 227.554 231 241.39 231C255.225 231 255.229 242.921 269.067 242.921C282.906 242.921 282.906 246.457 296.745 246.457C310.584 246.457 310.584 238.079 324.426 238.079C338.268 238.079 336.989 233.485 347.489 242.896C356.506 250.98 357.624 249.69 357.624 262.098C357.624 274.506 356.323 274.506 356.323 286.911C356.323 299.319 354.489 299.576 356.954 311.714C359.511 324.305 361.445 322.537 351.335 335.603V335.6Z',
  fill: '#256D67'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M351.337 335.6C345.972 342.53 342.228 337.839 336.846 333.292C336.241 332.78 335.611 332.272 334.959 331.778C332.08 329.61 328.703 327.802 324.431 327.802C321.135 327.802 318.624 328.127 316.523 328.624C313.125 329.427 310.805 330.68 307.979 331.719C305.353 332.687 302.289 333.472 297.519 333.546C297.269 333.549 297.012 333.553 296.753 333.553C291.569 333.553 288.326 335.014 285.57 336.844C280.971 339.893 277.73 343.966 269.075 343.966C261.958 343.966 258.501 341.884 254.939 339.868C253.978 339.322 253.011 338.782 251.961 338.289C249.332 337.052 246.2 336.105 241.4 336.105C236.599 336.105 233.603 335.96 231.011 335.77C228.379 335.575 226.275 335.333 223.566 335.147C221.083 334.973 218.092 334.849 213.721 334.849C211.068 334.849 208.921 335.175 207.089 335.702C204.133 336.549 201.992 337.92 199.848 339.291C196.401 341.494 192.941 343.69 186.043 343.69C182.991 343.69 180.609 343.175 178.608 342.371C176.414 341.494 174.672 340.271 172.992 339H172.989C169.248 336.171 165.806 333.115 158.368 333.115C147.485 333.115 145.159 337.97 137.934 340.042C137.921 340.045 137.906 340.048 137.893 340.051C135.941 340.613 133.627 340.963 130.69 340.963C127.752 340.963 125.534 341.044 123.603 341.174C118.265 341.528 116.094 338.875 110.348 342.616C108.68 343.702 106.014 342.843 103.011 342.843C98.4735 342.843 95.4215 341.94 92.8823 340.724C87.6802 338.24 84.6314 334.449 75.3301 334.449C65.5624 334.449 59.1834 342.415 52.5851 343.795C49.8296 344.375 47.0402 343.804 43.948 341.034C34.9309 332.954 40.9948 324.129 40.9948 311.724C40.9948 299.32 49.8513 299.317 49.8513 286.912C49.8513 274.508 51.9765 274.504 51.9765 262.097C51.9765 249.689 41.7671 249.177 50.7841 241.094C61.2809 231.679 61.4879 240.814 75.327 240.814C89.1661 240.814 89.163 240.445 103.002 240.445C116.841 240.445 116.841 231.478 130.68 231.478C144.52 231.478 144.519 243.308 158.359 243.308C172.198 243.308 172.198 236.1 186.037 236.1C199.876 236.1 199.876 242.601 213.712 242.601C227.548 242.601 227.551 231 241.39 231C255.229 231 255.229 242.921 269.069 242.921C282.908 242.921 282.908 246.454 296.747 246.454C310.586 246.454 310.586 238.075 324.428 238.075C338.27 238.075 336.991 233.485 347.491 242.896C356.508 250.976 357.624 249.689 357.624 262.097C357.624 274.504 356.323 274.501 356.323 286.909C356.323 299.317 354.488 299.574 356.953 311.712C359.511 324.303 361.445 322.535 351.337 335.6Z',
  fill: '#256D67'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M132.935 192.446C143.315 225.327 178.173 243.506 210.793 233.042C225.898 228.198 237.875 218.06 245.349 205.309C245.968 204.252 246.56 203.177 247.115 202.084C247.577 201.183 248.015 200.269 248.428 199.343C248.998 198.088 249.522 196.808 250.006 195.519C254.761 182.823 255.464 168.488 251.066 154.553C249.426 149.355 247.173 144.524 244.409 140.115C243.931 139.344 243.435 138.586 242.92 137.844C242.59 137.365 242.254 136.893 241.915 136.427C240.837 134.957 239.709 133.544 238.519 132.186C222.754 114.172 197.368 106.208 173.208 113.957C140.585 124.422 122.555 159.562 132.935 192.449V192.446Z',
  fill: '#503574'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M223.383 227.325C222.205 228.026 221.002 228.689 219.778 229.306C218.88 229.764 217.97 230.2 217.051 230.611C215.937 231.109 214.809 231.573 213.667 232.006C199.914 237.217 184.288 237.534 169.52 231.742C137.63 219.238 121.828 182.993 134.228 150.785C135.85 146.568 137.876 142.631 140.242 139C135.208 167.798 150.806 197.11 178.825 208.098C193.591 213.89 209.22 213.569 222.973 208.362C224.114 207.929 225.243 207.465 226.357 206.967C227.279 206.556 228.186 206.123 229.083 205.662C230.311 205.046 231.514 204.382 232.689 203.681C240.705 198.923 247.707 192.327 253 184.204C252.309 188.185 251.217 192.155 249.712 196.064C244.456 209.711 234.987 220.443 223.383 227.329V227.325Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191.5 187C205.031 187 216 175.583 216 161.5C216 147.417 205.031 136 191.5 136C177.969 136 167 147.417 167 161.5C167 175.583 177.969 187 191.5 187Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191.5 184C205.031 184 216 172.807 216 159C216 145.193 205.031 134 191.5 134C177.969 134 167 145.193 167 159C167 172.807 177.969 184 191.5 184Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191 172C197.627 172 203 166.18 203 159C203 151.82 197.627 146 191 146C184.373 146 179 151.82 179 159C179 166.18 184.373 172 191 172Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M214.679 234.239C217.291 227.954 216.414 221.615 212.72 220.079C209.026 218.544 203.914 222.394 201.301 228.679C198.689 234.964 199.566 241.304 203.26 242.84C206.954 244.375 212.066 240.525 214.679 234.239Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M179.713 242.722C183.407 241.187 184.284 234.847 181.672 228.562C179.059 222.277 173.947 218.426 170.253 219.962C166.559 221.497 165.682 227.837 168.294 234.122C170.907 240.407 176.019 244.258 179.713 242.722Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M213.076 192.576C215.691 196.332 212.385 201.598 207.795 201.963C205.476 202.198 203.177 201.293 201.683 199.668C200.261 198.141 199.649 196 200.202 194.235C200.43 193.505 201.23 193.095 201.983 193.315C202.352 193.412 202.611 193.674 202.839 193.94C204.133 195.321 205.58 195.988 207.051 195.77C208.573 195.457 209.639 194.386 210.451 192.995L210.626 192.703C211.12 191.819 212.488 191.759 213.076 192.579V192.576Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M129.128 227.647C135.618 224.369 139.317 218.618 137.39 214.804C135.463 210.989 128.64 210.554 122.15 213.832C115.659 217.111 111.96 222.861 113.887 226.676C115.814 230.491 122.638 230.925 129.128 227.647Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M268.232 226.62C270.159 222.805 266.46 217.055 259.969 213.777C253.479 210.498 246.656 210.933 244.729 214.748C242.802 218.563 246.501 224.313 252.991 227.591C259.481 230.87 266.305 230.435 268.232 226.62Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M33.0062 187H35.9969C39.3117 187 42 189.692 42 193.005V347H27V193.005C27 189.689 29.6914 187 33.0031 187H33.0062Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M364.006 156H366.997C370.312 156 373 158.686 373 161.991V347H358V161.991C358 158.683 360.691 156 364.003 156H364.006Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M300.267 199H358V229H279.416C278.635 229 278 228.356 278 227.565V221.581C278 209.117 287.978 199 300.27 199H300.267Z',
  fill: '#95D5CF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M93 340.907C87.7072 338.404 84.6052 334.587 75.1417 334.587C65.2036 334.587 58.7134 342.61 52 344L81.3082 271.688C81.7293 270.645 83.2757 270.832 83.4297 271.951L93 340.907Z',
  fill: '#2E645B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M178.997 342C176.788 341.126 175.034 339.908 173.342 338.642H173.338C169.571 335.824 166.106 332.781 158.615 332.781C147.637 332.781 145.304 337.635 138 339.692L157.075 276.967C157.89 274.282 161.748 274.369 162.441 277.087L179 342H178.997Z',
  fill: '#2E645B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M252 338C249.364 336.766 246.222 335.823 241.408 335.823C236.594 335.823 233.589 335.678 230.99 335.49C228.351 335.295 226.241 335.054 223.524 334.868C221.033 334.695 218.035 334.571 213.651 334.571C210.99 334.571 208.837 334.896 207 335.422L228.205 278.799C229.128 276.332 232.66 276.424 233.45 278.941L252 338Z',
  fill: '#2E645B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M124 340.597C118.362 340.941 116.068 338.361 110 342L114.287 322.171C114.914 319.276 119.39 319.276 120.016 322.171L124 340.597Z',
  fill: '#2E645B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M297 333.688C296.77 333.692 296.534 333.695 296.295 333.695C291.523 333.695 288.537 335.162 286 337L289.165 309.442C289.538 306.186 293.843 306.186 294.216 309.442L297 333.688Z',
  fill: '#2E645B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M337 333C336.404 332.489 335.784 331.98 335.143 331.488C332.309 329.322 328.987 327.515 324.782 327.515C321.539 327.515 319.067 327.84 317 328.336L323.974 279.375C324.424 276.208 328.908 276.208 329.361 279.375L337 333Z',
  fill: '#2E645B'
})));

const BobbinGroup = () => ( /*#__PURE__*/React__default.createElement("svg", {
  viewBox: '0 0 400 244',
  height: '244px',
  width: '280px',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M297.906 200.156C329.003 200.156 354.213 195.851 354.213 190.541C354.213 185.23 329.003 180.925 297.906 180.925C266.808 180.925 241.598 185.23 241.598 190.541C241.598 195.851 266.808 200.156 297.906 200.156Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M291.121 184.713C291.894 180.33 286.474 175.711 279.015 174.396C271.556 173.081 264.883 175.568 264.11 179.951C263.338 184.334 268.757 188.953 276.216 190.268C283.675 191.583 290.348 189.096 291.121 184.713Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M319.594 190.27C327.053 188.955 332.473 184.336 331.7 179.953C330.927 175.57 324.254 173.083 316.796 174.398C309.337 175.713 303.917 180.332 304.69 184.715C305.463 189.098 312.136 191.585 319.594 190.27Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M230.153 124.454C241.748 160.89 280.688 181.031 317.13 169.437C334.005 164.071 347.384 152.838 355.732 138.707C356.424 137.536 357.083 136.344 357.705 135.134C358.221 134.134 358.71 133.123 359.172 132.099C359.811 130.707 360.396 129.292 360.934 127.861C366.245 113.795 367.03 97.9089 362.118 82.4668C360.284 76.706 357.769 71.3526 354.68 66.4679C354.147 65.6155 353.592 64.7741 353.018 63.95C352.651 63.4201 352.275 62.8979 351.896 62.3805C350.693 60.7512 349.43 59.1848 348.104 57.6798C330.496 37.7209 302.133 28.8966 275.144 37.4834C238.698 49.0788 218.558 88.0136 230.153 124.454Z',
  fill: '#F3C823'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M331.291 162.959C329.976 163.735 328.634 164.468 327.264 165.15C326.262 165.657 325.248 166.136 324.219 166.591C322.978 167.143 321.717 167.655 320.444 168.132C305.092 173.89 287.648 174.243 271.166 167.841C235.568 154.02 217.93 113.952 231.77 78.3462C233.581 73.6848 235.842 69.3332 238.484 65.3181C232.864 97.1554 250.275 129.557 281.553 141.7C298.036 148.102 315.48 147.748 330.831 141.991C332.104 141.513 333.365 141 334.606 140.45C335.635 139.995 336.649 139.515 337.651 139.009C339.021 138.327 340.363 137.592 341.677 136.818C350.627 131.559 358.442 124.267 364.351 115.285C363.579 119.686 362.362 124.073 360.684 128.395C354.817 143.482 344.244 155.346 331.292 162.958L331.291 162.959Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M370.622 135.985C370.622 135.985 370.62 135.983 370.62 135.98H370.607L370.622 135.985Z',
  fill: '#8A5024'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M296.136 117.726C311.381 117.726 323.739 105.369 323.739 90.1254C323.739 74.8821 311.381 62.5249 296.136 62.5249C280.891 62.5249 268.533 74.8821 268.533 90.1254C268.533 105.369 280.891 117.726 296.136 117.726Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M296.136 115.367C311.381 115.367 323.739 103.01 323.739 87.7665C323.739 72.5232 311.381 60.166 296.136 60.166C280.891 60.166 268.533 72.5232 268.533 87.7665C268.533 103.01 280.891 115.367 296.136 115.367Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M300.216 105.423C307.904 105.423 314.136 99.1912 314.136 91.5044C314.136 83.8176 307.904 77.5862 300.216 77.5862C292.528 77.5862 286.296 83.8176 286.296 91.5044C286.296 99.1912 292.528 105.423 300.216 105.423Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M310.439 88.1234C312.828 88.1234 314.765 86.1871 314.765 83.7985C314.765 81.4099 312.828 79.4736 310.439 79.4736C308.051 79.4736 306.114 81.4099 306.114 83.7985C306.114 86.1871 308.051 88.1234 310.439 88.1234Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M384.313 128.906C387.959 126.353 387.393 119.255 383.049 113.051C378.705 106.848 372.228 103.888 368.582 106.441C364.936 108.994 365.502 116.092 369.846 122.296C374.19 128.499 380.667 131.459 384.313 128.906Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M222.463 122.296C226.807 116.092 227.373 108.994 223.727 106.441C220.081 103.889 213.604 106.848 209.259 113.052C204.915 119.255 204.349 126.353 207.995 128.906C211.641 131.459 218.119 128.499 222.463 122.296Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M312.289 128.516C312.555 128.516 312.769 128.738 312.759 129.004C312.501 136.985 305.949 143.378 297.904 143.378C289.859 143.378 283.307 136.987 283.049 129.004C283.041 128.738 283.253 128.516 283.519 128.516H312.289Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M312.13 132.913C310.282 139.015 304.612 143.457 297.906 143.457C297.391 143.457 296.882 143.43 296.381 143.379C296.378 141.027 297.204 138.463 298.874 136.207C302.338 131.526 308.12 129.932 311.789 132.644C311.907 132.731 312.02 132.822 312.13 132.913Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M312.759 129.045C312.692 130.768 312.294 132.418 311.619 133.942H285.644C285.076 133.942 284.615 133.533 284.615 133.028V128.516H312.187C312.511 128.516 312.77 128.757 312.759 129.045Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M359.189 151.81H295.523L312.006 148.596C333.909 144.326 352.821 132.577 364.351 116.074V147.391C364.351 149.832 362.041 151.81 359.189 151.81Z',
  fill: '#E8F0F7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M233.46 151.81H297.127L280.644 148.596C258.74 144.326 239.829 132.577 228.298 116.074V147.391C228.298 149.832 230.609 151.81 233.46 151.81Z',
  fill: '#E8F0F7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M345.875 151.809C341.571 156.2 336.728 159.97 331.5 163.049C330.179 163.83 328.827 164.57 327.45 165.257C326.443 165.768 325.422 166.252 324.387 166.71C323.139 167.265 321.869 167.781 320.589 168.264C305.147 174.067 287.597 174.424 271.015 167.971C261.483 164.264 253.234 158.681 246.518 151.809H295.516L296.323 151.652L297.13 151.809H345.874H345.875Z',
  fill: '#E1E6EA'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M297.064 151.901H295.46L296.262 151.745L297.064 151.901Z',
  fill: '#E1E6EA'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M297.064 151.901H295.46L296.262 151.745L297.064 151.901Z',
  fill: '#E1E6EA'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M292.665 156.464L287.224 183.722C286.864 185.524 288.244 187.205 290.081 187.205H300.962C302.8 187.205 304.178 185.524 303.818 183.722L298.377 156.464C297.755 153.341 293.288 153.341 292.663 156.464H292.665Z',
  fill: '#1DAA4E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M298.047 159.289L302.001 152.418C303.12 150.475 301.717 148.052 299.477 148.052H291.567C289.326 148.052 287.924 150.475 289.043 152.418L292.997 159.289C294.117 161.236 296.926 161.236 298.047 159.289Z',
  fill: '#39B555'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M98.3945 200.057C125.43 200.057 147.347 196.222 147.347 191.491C147.347 186.759 125.43 182.924 98.3945 182.924C71.3588 182.924 49.442 186.759 49.442 191.491C49.442 196.222 71.3588 200.057 98.3945 200.057Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M30.7761 122.372C42.6589 159.587 82.5657 180.159 119.913 168.317C137.207 162.836 150.917 151.363 159.473 136.93C160.182 135.733 160.858 134.516 161.494 133.281C162.023 132.259 162.524 131.226 162.998 130.18C163.653 128.759 164.252 127.313 164.804 125.851C170.247 111.485 171.051 95.2594 166.017 79.4872C164.138 73.6033 161.56 68.1355 158.395 63.1463C157.848 62.2757 157.279 61.4163 156.691 60.5746C156.315 60.0333 155.93 59.5 155.542 58.9716C154.309 57.3074 153.014 55.7076 151.655 54.1703C133.607 33.7832 104.54 24.7687 76.8806 33.5391C39.5318 45.3839 18.8902 85.1494 30.7729 122.371L30.7761 122.372Z',
  fill: '#503574'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M134.449 161.861C133.099 162.654 131.721 163.403 130.314 164.101C129.286 164.619 128.244 165.11 127.188 165.574C125.913 166.139 124.618 166.663 123.312 167.15C107.547 173.038 89.6352 173.4 72.7114 166.853C36.1586 152.72 18.0478 111.745 32.2583 75.334C34.1188 70.5671 36.4396 66.1171 39.1529 62.0112C33.3824 94.5686 51.2607 127.703 83.377 140.121C100.302 146.668 118.215 146.306 133.977 140.418C135.284 139.929 136.579 139.405 137.853 138.842C138.91 138.377 139.951 137.887 140.98 137.369C142.387 136.671 143.764 135.92 145.114 135.129C154.304 129.751 162.329 122.293 168.397 113.108C167.604 117.608 166.354 122.095 164.63 126.515C158.606 141.943 147.75 154.075 134.45 161.859L134.449 161.861Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M98.3945 115.859C113.805 115.859 126.297 103.147 126.297 87.4662C126.297 71.7855 113.805 59.0737 98.3945 59.0737C82.9842 59.0737 70.4916 71.7855 70.4916 87.4662C70.4916 103.147 82.9842 115.859 98.3945 115.859Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M98.3945 112.922C113.805 112.922 126.297 100.429 126.297 85.0186C126.297 69.6083 113.805 57.1157 98.3945 57.1157C82.9842 57.1157 70.4916 69.6083 70.4916 85.0186C70.4916 100.429 82.9842 112.922 98.3945 112.922Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M98.3945 99.215C106.235 99.215 112.591 92.8591 112.591 85.0187C112.591 77.1784 106.235 70.8225 98.3945 70.8225C90.5542 70.8225 84.1983 77.1784 84.1983 85.0187C84.1983 92.8591 90.5542 99.215 98.3945 99.215Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M108.675 81.5917C111.108 81.5917 113.08 79.5097 113.08 76.9413C113.08 74.3729 111.108 72.2908 108.675 72.2908C106.241 72.2908 104.269 74.3729 104.269 76.9413C104.269 79.5097 106.241 81.5917 108.675 81.5917Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M92.1726 174.161C92.963 169.678 87.4201 164.953 79.7921 163.608C72.1641 162.263 65.3396 164.807 64.5491 169.29C63.7587 173.773 69.3016 178.497 76.9296 179.842C84.5576 181.187 91.3821 178.643 92.1726 174.161Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M119.683 191.101C127.311 189.756 132.854 185.031 132.064 180.549C131.273 176.066 124.449 173.522 116.821 174.867C109.193 176.212 103.65 180.937 104.44 185.419C105.231 189.902 112.055 192.446 119.683 191.101Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M187.011 107.207C188.356 99.5788 185.812 92.7543 181.329 91.9638C176.846 91.1734 172.122 96.7163 170.777 104.344C169.432 111.972 171.976 118.797 176.459 119.587C180.941 120.378 185.666 114.835 187.011 107.207Z',
  fill: '#503574'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M19.3515 119.586C23.8343 118.796 26.378 111.972 25.033 104.344C23.688 96.7156 18.9636 91.1726 14.4807 91.9631C9.99789 92.7535 7.45419 99.578 8.79921 107.206C10.1442 114.834 14.8686 120.377 19.3515 119.586Z',
  fill: '#503574'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.596 122.497C112.867 122.497 113.086 122.724 113.077 122.996C112.813 131.159 106.112 137.698 97.884 137.698C89.6564 137.698 82.9552 131.161 82.6914 122.996C82.6834 122.724 82.9005 122.497 83.1724 122.497H112.596Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.433 126.994C110.543 133.235 104.744 137.778 97.8856 137.778C97.3597 137.778 96.8385 137.751 96.327 137.699C96.3238 135.293 97.1682 132.671 98.8765 130.363C102.418 125.576 108.331 123.945 112.084 126.719C112.205 126.808 112.321 126.901 112.433 126.994Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M113.077 123.038C113.007 124.8 112.6 126.488 111.91 128.047H85.3455C84.7648 128.047 84.2935 127.628 84.2935 127.112V122.497H112.491C112.822 122.497 113.088 122.743 113.077 123.038Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M193.675 226.92C227.87 226.92 255.59 222.277 255.59 216.55C255.59 210.823 227.87 206.18 193.675 206.18C159.48 206.18 131.76 210.823 131.76 216.55C131.76 222.277 159.48 226.92 193.675 226.92Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M187.948 211.715C188.795 206.914 182.858 201.854 174.689 200.413C166.52 198.973 159.211 201.697 158.364 206.498C157.517 211.299 163.454 216.359 171.623 217.8C179.793 219.24 187.102 216.516 187.948 211.715Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M219.134 217.801C227.303 216.361 233.24 211.301 232.393 206.5C231.547 201.699 224.238 198.974 216.068 200.415C207.899 201.855 201.962 206.915 202.809 211.716C203.655 216.517 210.964 219.242 219.134 217.801Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M120.718 145.938C133.432 185.893 176.129 207.98 216.088 195.266C234.591 189.382 249.261 177.063 258.415 161.568C259.174 160.283 259.896 158.976 260.578 157.649C261.143 156.553 261.68 155.444 262.187 154.321C262.887 152.795 263.528 151.243 264.118 149.673C269.942 134.249 270.803 116.829 265.417 99.8951C263.406 93.578 260.648 87.7075 257.261 82.351C256.676 81.4163 256.068 80.4936 255.438 79.5899C255.036 79.0088 254.624 78.4362 254.209 77.8688C252.889 76.0821 251.504 74.3645 250.051 72.714C230.74 50.8257 199.641 41.1474 170.046 50.5636C130.086 63.2806 108.001 105.974 120.714 145.936L120.718 145.938Z',
  fill: '#13B1AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M232.12 187.778C230.677 188.625 229.205 189.426 227.701 190.171C226.602 190.724 225.488 191.248 224.36 191.745C222.998 192.348 221.614 192.908 220.217 193.428C203.37 199.717 184.227 200.103 166.14 193.11C127.076 178.015 107.721 134.25 122.908 95.3598C124.896 90.2683 127.376 85.5153 130.276 81.1299C124.109 115.904 143.216 151.295 177.539 164.558C195.627 171.551 214.77 171.164 231.616 164.876C233.012 164.353 234.396 163.793 235.758 163.192C236.887 162.696 238 162.172 239.1 161.619C240.603 160.873 242.075 160.071 243.518 159.226C253.339 153.482 261.915 145.516 268.4 135.706C267.553 140.513 266.217 145.305 264.375 150.026C257.937 166.504 246.335 179.463 232.121 187.777L232.12 187.778Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M193.675 138.47C210.351 138.47 223.87 124.815 223.87 107.97C223.87 91.1255 210.351 77.4702 193.675 77.4702C176.999 77.4702 163.48 91.1255 163.48 107.97C163.48 124.815 176.999 138.47 193.675 138.47Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M193.675 135.42C210.351 135.42 223.87 122.038 223.87 105.53C223.87 89.0221 210.351 75.6399 193.675 75.6399C176.999 75.6399 163.48 89.0221 163.48 105.53C163.48 122.038 176.999 135.42 193.675 135.42Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M193.37 120.78C201.792 120.78 208.62 113.952 208.62 105.53C208.62 97.1074 201.792 90.2798 193.37 90.2798C184.948 90.2798 178.12 97.1074 178.12 105.53C178.12 113.952 184.948 120.78 193.37 120.78Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M204.655 101.87C207.182 101.87 209.23 99.8219 209.23 97.2952C209.23 94.7685 207.182 92.7202 204.655 92.7202C202.128 92.7202 200.08 94.7685 200.08 97.2952C200.08 99.8219 202.128 101.87 204.655 101.87Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M290.02 150.584C294.014 147.788 293.394 140.012 288.636 133.217C283.878 126.422 276.783 123.18 272.79 125.976C268.796 128.772 269.416 136.548 274.174 143.343C278.932 150.138 286.027 153.38 290.02 150.584Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.747 143.343C117.505 136.548 118.125 128.773 114.131 125.976C110.138 123.18 103.043 126.422 98.2853 133.217C93.5272 140.013 92.9074 147.788 96.9008 150.584C100.894 153.381 107.989 150.139 112.747 143.343Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M211.134 150.156C211.425 150.156 211.66 150.399 211.649 150.69C211.367 159.433 204.19 166.436 195.378 166.436C186.567 166.436 179.39 159.435 179.107 150.69C179.099 150.399 179.331 150.156 179.622 150.156H211.134Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M210.959 154.973C208.934 161.657 202.724 166.522 195.378 166.522C194.815 166.522 194.257 166.492 193.709 166.437C193.706 163.86 194.61 161.052 196.44 158.58C200.233 153.453 206.566 151.706 210.585 154.678C210.714 154.773 210.838 154.873 210.959 154.973Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M211.648 150.735C211.574 152.623 211.138 154.43 210.399 156.099H181.948C181.326 156.099 180.821 155.651 180.821 155.098V150.156H211.021C211.376 150.156 211.66 150.42 211.648 150.735Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M164.936 139.137C170.118 146.029 187.595 149.816 203.971 147.594C211.554 146.565 217.571 144.429 221.333 141.748C221.644 141.525 221.942 141.299 222.222 141.071C222.455 140.881 222.675 140.689 222.884 140.495C223.171 140.231 223.436 139.962 223.679 139.691C226.074 137.023 226.438 134.014 224.243 131.093C223.424 130.003 222.297 128.991 220.914 128.069C220.675 127.908 220.427 127.748 220.168 127.594C220.004 127.495 219.835 127.395 219.666 127.297C219.127 126.99 218.561 126.694 217.966 126.409C210.07 122.641 197.337 120.99 185.208 122.636C168.829 124.858 159.755 132.245 164.938 139.139L164.936 139.137Z',
  fill: '#13B1AB'
})));

const BobbinGroupDark = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '324',
  height: '200',
  viewBox: '0 0 324 200',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("path", {
  d: 'M239.124 151.402C239.757 147.81 235.315 144.024 229.201 142.946C223.087 141.868 217.618 143.906 216.984 147.499C216.35 151.092 220.793 154.878 226.907 155.956C233.02 157.034 238.49 154.995 239.124 151.402Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M262.463 155.96C268.576 154.883 273.019 151.096 272.385 147.504C271.752 143.911 266.282 141.873 260.168 142.951C254.055 144.029 249.612 147.815 250.246 151.407C250.879 155 256.349 157.038 262.463 155.96Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M189.149 102.013C198.654 131.878 230.572 148.387 260.443 138.884C274.275 134.486 285.241 125.278 292.084 113.696C292.651 112.735 293.191 111.758 293.7 110.767C294.123 109.947 294.524 109.118 294.903 108.279C295.427 107.138 295.906 105.978 296.347 104.805C300.701 93.2753 301.344 80.2543 297.318 67.5968C295.815 62.8749 293.753 58.4869 291.221 54.483C290.784 53.7843 290.329 53.0947 289.858 52.4192C289.558 51.9848 289.25 51.5568 288.939 51.1327C287.953 49.7972 286.918 48.5133 285.831 47.2796C271.398 30.9199 248.15 23.6869 226.027 30.7253C196.154 40.2296 179.645 72.1434 189.149 102.013Z',
  fill: '#FFC900'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M272.049 133.573C270.972 134.208 269.872 134.809 268.749 135.369C267.928 135.784 267.096 136.177 266.253 136.549C265.236 137.002 264.202 137.422 263.159 137.813C250.575 142.532 236.277 142.822 222.767 137.574C193.588 126.246 179.131 93.4026 190.475 64.2178C191.96 60.397 193.813 56.8301 195.979 53.5391C191.372 79.6352 205.644 106.194 231.281 116.147C244.792 121.395 259.09 121.105 271.673 116.386C272.716 115.994 273.75 115.573 274.767 115.122C275.61 114.75 276.442 114.357 277.263 113.941C278.386 113.382 279.486 112.78 280.563 112.146C287.899 107.835 294.305 101.858 299.149 94.4957C298.516 98.1026 297.518 101.699 296.142 105.241C291.333 117.608 282.667 127.332 272.051 133.572L272.049 133.573Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M304.291 111.466C304.291 111.466 304.288 111.464 304.288 111.461H304.276L304.291 111.466Z',
  fill: '#8A5024'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M243.234 96.4967C255.73 96.4967 265.86 86.3679 265.86 73.8734C265.86 61.3788 255.73 51.25 243.234 51.25C230.739 51.25 220.609 61.3788 220.609 73.8734C220.609 86.3679 230.739 96.4967 243.234 96.4967Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M243.234 94.5631C255.73 94.5631 265.86 84.4343 265.86 71.9398C265.86 59.4452 255.73 49.3164 243.234 49.3164C230.739 49.3164 220.609 59.4452 220.609 71.9398C220.609 84.4343 230.739 94.5631 243.234 94.5631Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M246.579 86.4105C252.88 86.4105 257.988 81.3028 257.988 75.0021C257.988 68.7014 252.88 63.5938 246.579 63.5938C240.278 63.5938 235.169 68.7014 235.169 75.0021C235.169 81.3028 240.278 86.4105 246.579 86.4105Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M254.958 72.2306C256.916 72.2306 258.504 70.6434 258.504 68.6856C258.504 66.7278 256.916 65.1406 254.958 65.1406C253 65.1406 251.413 66.7278 251.413 68.6856C251.413 70.6434 253 72.2306 254.958 72.2306Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M315.511 105.66C318.5 103.568 318.036 97.7496 314.475 92.6648C310.914 87.58 305.605 85.1541 302.616 87.2465C299.628 89.3389 300.092 95.1572 303.652 100.242C307.213 105.327 312.522 107.753 315.511 105.66Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M182.846 100.241C186.407 95.1567 186.871 89.3384 183.883 87.246C180.894 85.1536 175.585 87.5794 172.024 92.6642C168.463 97.749 167.999 103.567 170.988 105.66C173.976 107.752 179.286 105.326 182.846 100.241Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M256.475 105.34C256.693 105.34 256.868 105.522 256.86 105.739C256.649 112.282 251.278 117.522 244.684 117.522C238.089 117.522 232.718 112.283 232.507 105.739C232.501 105.522 232.675 105.34 232.892 105.34H256.475Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M256.344 108.945C254.83 113.947 250.182 117.587 244.685 117.587C244.263 117.587 243.846 117.565 243.436 117.524C243.433 115.595 244.11 113.494 245.479 111.644C248.318 107.808 253.057 106.501 256.065 108.725C256.161 108.795 256.254 108.87 256.344 108.945Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M256.86 105.773C256.805 107.186 256.478 108.538 255.925 109.787H234.634C234.169 109.787 233.791 109.452 233.791 109.038V105.34H256.391C256.656 105.34 256.869 105.537 256.86 105.773Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M294.918 124.436H242.732L256.243 121.801C274.196 118.302 289.698 108.671 299.149 95.1445V120.814C299.149 122.815 297.255 124.436 294.918 124.436Z',
  fill: '#E8F0F7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191.861 124.436H244.047L230.536 121.801C212.582 118.302 197.081 108.671 187.63 95.1445V120.814C187.63 122.815 189.524 124.436 191.861 124.436Z',
  fill: '#E8F0F7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M284.004 124.434C280.476 128.033 276.506 131.123 272.221 133.647C271.138 134.287 270.031 134.893 268.901 135.457C268.076 135.875 267.24 136.273 266.391 136.648C265.368 137.103 264.327 137.525 263.278 137.921C250.62 142.678 236.235 142.971 222.643 137.681C214.831 134.643 208.069 130.067 202.564 124.434H242.727L243.388 124.305L244.049 124.434H284.003H284.004Z',
  fill: '#E1E6EA'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M243.995 124.507H242.68L243.338 124.379L243.995 124.507Z',
  fill: '#E1E6EA'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M243.995 124.507H242.68L243.338 124.379L243.995 124.507Z',
  fill: '#E1E6EA'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M240.389 128.248L235.93 150.591C235.635 152.068 236.765 153.446 238.271 153.446H247.19C248.697 153.446 249.826 152.068 249.531 150.591L245.072 128.248C244.561 125.688 240.9 125.688 240.388 128.248H240.389Z',
  fill: '#1DAA4E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M244.801 130.566L248.042 124.934C248.959 123.342 247.809 121.355 245.973 121.355H239.489C237.652 121.355 236.504 123.342 237.42 124.934L240.661 130.566C241.579 132.162 243.882 132.162 244.801 130.566Z',
  fill: '#39B555'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M25.7265 100.303C35.4665 130.807 68.177 147.67 98.7894 137.963C112.965 133.471 124.203 124.066 131.216 112.236C131.797 111.255 132.351 110.257 132.873 109.245C133.306 108.407 133.717 107.561 134.105 106.704C134.642 105.538 135.133 104.353 135.585 103.155C140.047 91.3793 140.706 78.0799 136.58 65.1519C135.039 60.329 132.927 55.8472 130.332 51.7577C129.884 51.0441 129.418 50.3397 128.935 49.6498C128.628 49.2061 128.312 48.769 127.993 48.3358C126.983 46.9718 125.922 45.6604 124.808 44.4004C110.014 27.6896 86.189 20.3006 63.5171 27.4895C32.9033 37.1984 15.9839 69.793 25.7239 100.302L25.7265 100.303Z',
  fill: '#A43AB6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M110.704 132.672C109.597 133.322 108.468 133.936 107.315 134.508C106.472 134.933 105.618 135.335 104.752 135.716C103.708 136.179 102.646 136.608 101.575 137.008C88.6538 141.834 73.9717 142.13 60.0997 136.764C30.1384 125.179 15.2934 91.5933 26.9415 61.7484C28.4665 57.8411 30.3687 54.1936 32.5927 50.8281C27.8628 77.5145 42.5172 104.674 68.842 114.852C82.7153 120.219 97.3975 119.922 110.318 115.096C111.389 114.695 112.45 114.266 113.495 113.804C114.36 113.423 115.214 113.021 116.058 112.597C117.211 112.025 118.34 111.409 119.446 110.76C126.979 106.352 133.557 100.24 138.53 92.7111C137.88 96.3995 136.856 100.077 135.443 103.7C130.505 116.346 121.607 126.291 110.705 132.671L110.704 132.672Z',
  fill: '#8F319F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M81.151 94.9669C93.7825 94.9669 104.022 84.5474 104.022 71.6944C104.022 58.8413 93.7825 48.4219 81.151 48.4219C68.5196 48.4219 58.2798 58.8413 58.2798 71.6944C58.2798 84.5474 68.5196 94.9669 81.151 94.9669Z',
  fill: '#8F319F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M81.151 92.5589C93.7825 92.5589 104.022 82.3191 104.022 69.6877C104.022 57.0562 93.7825 46.8164 81.151 46.8164C68.5196 46.8164 58.2798 57.0562 58.2798 69.6877C58.2798 82.3191 68.5196 92.5589 81.151 92.5589Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M81.1514 81.3233C87.5779 81.3233 92.7876 76.1136 92.7876 69.687C92.7876 63.2605 87.5779 58.0508 81.1514 58.0508C74.7249 58.0508 69.5151 63.2605 69.5151 69.687C69.5151 76.1136 74.7249 81.3233 81.1514 81.3233Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M89.5776 66.8777C91.572 66.8777 93.1888 65.171 93.1888 63.0658C93.1888 60.9605 91.572 59.2539 89.5776 59.2539C87.5831 59.2539 85.9663 60.9605 85.9663 63.0658C85.9663 65.171 87.5831 66.8777 89.5776 66.8777Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M76.0511 142.753C76.6991 139.079 72.1557 135.206 65.9032 134.104C59.6508 133.001 54.0569 135.086 53.409 138.761C52.7611 142.435 57.3045 146.308 63.5569 147.41C69.8094 148.513 75.4032 146.428 76.0511 142.753Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M98.6009 156.638C104.853 155.536 109.397 151.663 108.749 147.989C108.101 144.314 102.507 142.229 96.2547 143.332C90.0022 144.434 85.4588 148.307 86.1067 151.981C86.7546 155.656 92.3485 157.741 98.6009 156.638Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M153.787 87.8729C154.89 81.6204 152.805 76.0265 149.13 75.3786C145.456 74.7307 141.584 79.2741 140.481 85.5266C139.379 91.779 141.464 97.3729 145.138 98.0208C148.813 98.6687 152.685 94.1253 153.787 87.8729Z',
  fill: '#503574'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M16.3619 98.0198C20.0364 97.3719 22.1214 91.778 21.0189 85.5256C19.9164 79.2731 16.044 74.7297 12.3695 75.3776C8.69505 76.0255 6.61004 81.6194 7.71252 87.8719C8.815 94.1243 12.6875 98.6677 16.3619 98.0198Z',
  fill: '#8F319F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M92.7916 100.406C93.0144 100.406 93.1937 100.592 93.1858 100.815C92.9696 107.506 87.4769 112.866 80.7329 112.866C73.9889 112.866 68.4962 107.507 68.28 100.815C68.2734 100.592 68.4514 100.406 68.6742 100.406H92.7916Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M92.6584 104.092C91.1092 109.208 86.3561 112.931 80.7341 112.931C80.303 112.931 79.8758 112.908 79.4566 112.866C79.4539 110.894 80.1461 108.745 81.5463 106.853C84.4496 102.929 89.2963 101.592 92.3723 103.866C92.4711 103.939 92.5661 104.015 92.6584 104.092Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M93.1859 100.849C93.1292 102.294 92.7957 103.677 92.23 104.955H70.4555C69.9796 104.955 69.5933 104.612 69.5933 104.189V100.406H92.706C92.9776 100.406 93.1952 100.608 93.1859 100.849Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M162.5 183C230.707 183 286 172.479 286 159.5C286 146.521 230.707 136 162.5 136C94.2928 136 39 146.521 39 159.5C39 172.479 94.2928 183 162.5 183Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M154.556 173.537C155.25 169.602 150.384 165.454 143.688 164.274C136.992 163.093 131.001 165.326 130.307 169.261C129.613 173.196 134.479 177.344 141.175 178.525C147.871 179.705 153.862 177.472 154.556 173.537Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M180.118 178.527C186.814 177.346 191.68 173.199 190.986 169.264C190.292 165.328 184.302 163.095 177.605 164.276C170.909 165.457 166.043 169.604 166.737 173.54C167.431 177.475 173.422 179.708 180.118 178.527Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M99.4491 119.621C109.87 152.371 144.868 170.475 177.621 160.054C192.788 155.231 204.812 145.133 212.315 132.432C212.937 131.379 213.53 130.308 214.088 129.221C214.552 128.322 214.991 127.413 215.407 126.492C215.981 125.241 216.507 123.969 216.99 122.683C221.764 110.04 222.469 95.7611 218.055 81.8811C216.406 76.7031 214.146 71.8912 211.37 67.5006C210.891 66.7345 210.392 65.9782 209.876 65.2375C209.546 64.7611 209.208 64.2918 208.868 63.8267C207.786 62.3622 206.651 60.9543 205.46 59.6015C189.631 41.6602 164.14 33.7272 139.882 41.4454C107.128 51.8692 89.0252 86.864 99.4463 119.62L99.4491 119.621Z',
  fill: '#13B1AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M190.762 153.917C189.579 154.611 188.373 155.267 187.14 155.878C186.239 156.332 185.327 156.761 184.401 157.168C183.285 157.662 182.151 158.121 181.006 158.548C167.197 163.702 151.506 164.019 136.681 158.287C104.661 145.914 88.7958 110.041 101.244 78.1638C102.874 73.9905 104.907 70.0946 107.284 66.5C102.229 95.0035 117.89 124.012 146.024 134.884C160.85 140.615 176.541 140.299 190.349 135.144C191.493 134.716 192.628 134.257 193.744 133.764C194.67 133.357 195.582 132.928 196.483 132.474C197.716 131.863 198.922 131.206 200.105 130.513C208.155 125.805 215.185 119.276 220.5 111.235C219.805 115.174 218.71 119.103 217.201 122.972C211.924 136.479 202.414 147.101 190.763 153.915L190.762 153.917Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M159.25 113.5C172.919 113.5 184 102.307 184 88.5C184 74.6929 172.919 63.5 159.25 63.5C145.581 63.5 134.5 74.6929 134.5 88.5C134.5 102.307 145.581 113.5 159.25 113.5Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M159.25 111C172.919 111 184 100.031 184 86.5C184 72.969 172.919 62 159.25 62C145.581 62 134.5 72.969 134.5 86.5C134.5 100.031 145.581 111 159.25 111Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M159 99C165.904 99 171.5 93.4036 171.5 86.5C171.5 79.5964 165.904 74 159 74C152.096 74 146.5 79.5964 146.5 86.5C146.5 93.4036 152.096 99 159 99Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M168.25 83.5C170.321 83.5 172 81.8211 172 79.75C172 77.6789 170.321 76 168.25 76C166.179 76 164.5 77.6789 164.5 79.75C164.5 81.8211 166.179 83.5 168.25 83.5Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M239.866 104.64C237.04 101.815 230.852 103.422 226.044 108.23C221.236 113.038 219.629 119.226 222.455 122.052C225.28 124.877 231.468 123.27 236.277 118.462C241.085 113.654 242.692 107.466 239.866 104.64Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M92.9155 117.496C96.8156 111.926 97.3237 105.553 94.0504 103.261C90.777 100.969 84.9618 103.626 81.0617 109.196C77.1616 114.766 76.6536 121.139 79.9269 123.431C83.2002 125.723 89.0154 123.066 92.9155 117.496Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M135.693 114.047C139.941 119.696 154.266 122.8 167.69 120.979C173.905 120.136 178.837 118.385 181.92 116.187C182.175 116.004 182.419 115.819 182.649 115.632C182.84 115.476 183.021 115.318 183.192 115.16C183.427 114.943 183.644 114.723 183.843 114.501C185.807 112.314 186.105 109.848 184.306 107.453C183.634 106.56 182.711 105.73 181.577 104.974C181.381 104.842 181.178 104.712 180.966 104.585C180.831 104.504 180.693 104.422 180.554 104.342C180.112 104.091 179.649 103.847 179.161 103.614C172.689 100.525 162.252 99.1722 152.31 100.521C138.885 102.342 131.447 108.398 135.695 114.048L135.693 114.047Z',
  fill: '#13B1AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M190.678 120.48C190.678 120.498 190.678 120.514 190.678 120.532C190.678 121.625 190.555 122.69 190.322 123.648C189.366 127.585 186.256 130.858 182.53 132.944C177.794 135.597 172.06 136.329 168.503 134.069C166.645 132.886 165.039 130.67 164.544 128.089C164.497 127.849 164.459 127.605 164.434 127.359C164.237 125.515 164.607 123.422 165.496 121.735C166.081 120.626 166.89 119.692 167.911 119.112C170.656 117.554 172.119 118.872 174.433 116.864C175.706 115.76 176.281 115.594 177.534 114.068C179.485 111.694 183.455 110.309 186.285 111.485C189.305 112.74 190.676 116.764 190.676 120.48H190.678Z',
  fill: 'url(#paint0_linear_9182_35302)'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M190.677 120.48C190.677 120.498 190.677 120.514 190.677 120.532C190.671 120.994 190.644 121.448 190.594 121.892L168.437 121.753C168.116 121.753 167.872 121.48 167.87 121.15C167.865 120.301 167.079 119.582 167.91 119.112C170.655 117.554 172.118 118.872 174.432 116.864C175.704 115.76 176.28 115.594 177.533 114.068C179.484 111.694 183.454 110.309 186.284 111.485C189.304 112.74 190.675 116.764 190.675 120.48H190.677Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M182.53 132.943C177.793 135.596 172.06 136.328 168.502 134.068C166.645 132.885 165.039 130.669 164.543 128.088C166.43 127.311 168.76 126.856 171.28 126.871C177.278 126.91 182.169 129.589 182.53 132.943Z',
  fill: '#C4678B'
}), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
  id: 'paint0_linear_9182_35302',
  x1: '164.583',
  y1: '123.019',
  x2: '190.86',
  y2: '123.184',
  gradientUnits: 'userSpaceOnUse'
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: '#A64B73'
}), /*#__PURE__*/React__default.createElement("stop", {
  offset: '1',
  stopColor: '#8B2F5B'
})))));

const BriefcaseRobbin = () => ( /*#__PURE__*/createElement("svg", {
  width: '159',
  height: '144',
  viewBox: '0 0 159 144',
  fill: 'none'
}, /*#__PURE__*/createElement("rect", {
  width: '158.455',
  height: '144',
  fill: 'url(#pattern0)'
}), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("pattern", {
  id: 'pattern0',
  patternContentUnits: 'objectBoundingBox',
  width: '1',
  height: '1'
}, /*#__PURE__*/createElement("use", {
  xlinkHref: '#image0_8178_67619',
  transform: 'scale(0.000860585 0.00094697)'
})), /*#__PURE__*/createElement("image", {
  id: 'image0_8178_67619',
  width: '1162',
  height: '1056',
  xlinkHref: 'data:image/png;base64,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'
}))));

const BobbinBus = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '250',
  height: '250',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M162 35C161.692 37.0204 160.91 37.1986 160 36.8685C160.664 36.2479 161.332 35.6206 162 35Z',
  fill: '#233256'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M28.7443 243.825C27.8822 223.572 28.0978 203.331 29.4388 183.103C33.1335 182.725 34.3634 180.766 34.2437 177.025C33.9614 168.221 34.1103 159.403 34.0846 150.591C35.1639 147.233 36.2416 143.875 37.3209 140.517C38.6774 139.684 40.3332 138.976 38.7903 136.949C42.3208 125.918 46.9991 122.299 58.2731 121.021C79.7009 118.594 101.207 118.089 122.741 117.552C151.473 116.835 180.199 116.888 208.924 117.304C240.4 117.759 271.868 118.597 303.299 120.468C319 121.404 334.668 122.678 350.296 124.498C364.709 126.178 370.562 131.768 373.985 147.542C378.157 166.772 377.726 186.151 376.188 205.629C375.015 220.49 373.143 235.239 370.798 249.943C370.212 253.617 369.512 257.274 368.867 260.938C361.283 260.743 353.696 260.425 346.11 260.424C343.563 260.424 342.581 259.502 341.861 257.17C337.951 244.516 327.589 235.946 315.967 235.523C303.354 235.065 292.673 242.395 287.884 255.27C286.752 258.314 285.299 259.094 282.229 259.04C260.276 258.646 238.32 258.39 216.363 258.19C191.781 257.965 167.199 257.846 142.616 257.692C140.532 257.678 138.729 257.777 137.536 255.266C129.26 237.862 118.821 232.85 100.554 237.258C98.4004 232.793 100.438 228.314 100.557 223.851C100.877 211.877 100.643 199.907 101.094 187.919C101.667 172.677 101.909 157.363 100.788 142.053C100.403 136.787 97.788 135.863 94.1224 135.271C81.0351 133.16 67.8863 132.704 54.6981 134.356C48.3897 135.146 46.4449 137.213 45.9112 143.802C45.9967 143.988 45.9659 144.154 45.8188 144.296C44.7651 144.997 45.0149 146.053 45.0696 147.055C45.1295 147.262 45.0901 147.448 44.9533 147.616C43.4207 147.702 43.4685 148.892 43.2017 149.971C41.5938 156.499 40.9883 163.201 39.7807 169.781C36.9942 184.965 36.8882 200.336 35.9816 215.639C35.3624 226.088 35.8687 236.603 35.8721 247.088C33.698 245.561 31.2126 244.714 28.7478 243.826L28.7443 243.825ZM266.381 201.491C293.792 200.974 327.891 202.358 361.974 200.752C365.581 200.582 367.199 198.759 368.207 195.959C368.894 194.05 369.124 191.989 369.182 189.883C369.435 180.638 368.633 171.42 367.22 162.362C366.262 156.218 365.53 149.776 362.514 144.092C360.906 141.061 359.037 137.83 355.109 137.731C344.109 137.452 333.139 136.759 322.159 136.084C311.853 135.449 301.513 135.793 291.177 135.387C269.612 134.542 248.001 134.799 226.413 134.558C188.634 134.137 150.818 133.367 113.063 135.984C108.983 136.267 107.15 137.834 106.31 142.25C103.96 154.614 103.426 167.135 104.016 179.627C104.276 185.114 103.937 190.976 106.953 196.099C108.191 198.205 109.544 199.885 112.367 199.864C118.282 199.82 124.193 200.304 130.09 200.494C146.069 201.008 162.068 201.044 178.06 201.349C205.265 201.865 232.489 201.491 266.379 201.491H266.381ZM144.869 251.777C145.207 252.851 145.804 252.8 146.326 252.872C159.194 254.656 172.18 253.234 185.1 254.399C193.459 255.153 201.945 254.416 210.371 254.568C231.351 254.946 252.296 253.236 273.278 253.648C276.644 253.715 280.027 252.86 283.77 252.384C282.542 250.833 281.507 250.372 280.385 250.427C275.134 250.685 269.949 249.64 264.734 249.606C246.635 249.486 228.535 249.521 210.435 249.562C190.293 249.608 170.145 249.146 150.017 250.354C148.19 250.463 146.487 250.733 144.869 251.775V251.777Z',
  fill: '#F3C823'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M100.552 237.258C118.821 232.85 129.258 237.862 137.534 255.266C138.728 257.776 140.531 257.678 142.614 257.692C167.196 257.847 191.78 257.967 216.362 258.19C238.318 258.39 260.274 258.646 282.227 259.04C285.298 259.094 286.75 258.314 287.882 255.27C292.672 242.395 303.352 235.065 315.966 235.523C327.587 235.946 337.948 244.516 341.859 257.17C342.58 259.502 343.561 260.423 346.108 260.423C353.695 260.425 361.283 260.745 368.865 260.938C371.472 261.109 374.081 261.311 376.691 261.446C378.776 261.554 380.038 262.302 379.999 264.679C379.958 267.137 378.502 267.647 376.491 267.695C362.714 268.025 348.938 268.365 335.161 268.702C335.75 260.877 333.882 254.19 327.512 248.847C320.661 243.101 307.875 243.027 301.26 248.987C295.201 254.445 293.294 261.245 293.831 269.045C257.962 269.14 222.092 269.25 186.222 269.328C167.877 269.368 149.531 269.352 131.186 269.363C131.578 263.249 131.131 257.536 127.245 252.18C120.724 243.197 105.121 242.513 98.1746 248.706C91.9294 254.274 89.8631 260.913 89.7759 268.718C69.6738 268.771 49.5751 268.569 29.4901 267.709C23.688 267.461 20.9375 264.907 20.219 259.229C19.9077 256.77 19.8992 254.281 20.3833 251.825C21.4712 246.315 23.0944 244.77 28.7443 243.821C31.2126 244.709 33.698 245.556 35.8704 247.083C37.5706 248.989 37.846 251.305 37.5723 253.681C37.2114 256.816 38.171 257.95 41.6092 257.854C54.7084 257.493 67.8161 257.463 80.9205 257.374C82.4394 257.363 83.4863 257.226 84.0798 255.521C86.998 247.143 92.8873 241.384 100.552 237.254V237.258Z',
  fill: '#3A494E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M123.629 281.872C115.112 287.375 106.625 287.693 98.1763 281.72C93.7751 278.422 91.8182 273.545 89.7759 268.721C89.8631 260.916 91.9294 254.278 98.1746 248.71C105.123 242.516 120.724 243.198 127.245 252.184C131.131 257.54 131.579 263.251 131.186 269.366C130.387 274.575 127.243 278.365 123.627 281.872H123.629ZM111.005 276.248C117.423 276.169 122.264 271.198 122.115 264.84C121.973 258.754 116.881 253.787 110.872 253.876C104.661 253.968 99.584 259.228 99.7329 265.417C99.88 271.588 104.808 276.323 111.005 276.248Z',
  fill: '#58707A'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M326.889 281.981C318.489 287.746 309.741 287.457 301.108 281.126C297.355 277.9 295.266 273.67 293.831 269.048C293.294 261.248 295.202 254.449 301.26 248.99C307.875 243.031 320.661 243.104 327.512 248.85C333.883 254.194 335.751 260.88 335.161 268.706C334.07 274.169 331.213 278.533 326.889 281.983V281.981ZM325.881 264.941C325.793 258.85 320.387 253.672 314.33 253.876C308.061 254.086 303.332 259.17 303.489 265.524C303.641 271.65 308.576 276.393 314.701 276.306C320.988 276.215 325.972 271.149 325.88 264.941H325.881Z',
  fill: '#58707A'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M38.7902 136.949C40.3348 138.976 38.679 139.684 37.3209 140.516C35.5317 140.5 33.7408 140.504 31.9515 140.461C30.7644 140.434 29.4593 140.555 29.6731 142.059C30.0187 144.498 27.7402 148.206 32.6477 148.736C33.1883 148.795 33.609 149.946 34.0863 150.589C34.1119 159.402 33.9631 168.219 34.2454 177.023C34.3651 180.764 33.1335 182.723 29.4405 183.101C22.7472 182.879 22.6446 182.887 22.0613 176.216C21.4592 169.338 21.4421 162.424 22.0613 155.556C22.3196 152.689 21.4506 149.2 25.6072 147.592C27.145 146.997 26.223 144.284 26.2504 142.544C26.3376 137.165 26.2846 137.185 31.7737 137.153C34.1137 137.139 36.4537 137.019 38.7937 136.948L38.7902 136.949Z',
  fill: '#58707A'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M44.9515 147.614C45.0884 147.448 45.126 147.26 45.0679 147.053C46.2858 146.396 45.9881 145.329 45.8171 144.294C45.9642 144.15 45.995 143.986 45.9094 143.8C47.6644 138.591 52.0143 137.644 56.6909 137.23C58.2611 137.031 59.9768 137.729 61.3726 136.463C64.9254 136.374 68.4764 136.285 72.0292 136.197C72.1215 136.426 72.2105 136.657 72.2977 136.888C72.4551 137.688 72.4979 138.531 72.7852 139.282C79.0303 155.659 85.2276 172.056 91.6592 188.359C92.5572 190.637 92.5538 193.624 95.2872 194.975C95.7285 197.929 95.8859 200.885 95.3967 203.849L95.4223 203.829C84.9847 204.233 74.5471 204.301 64.1111 203.781C64.2976 201.918 63.5946 200.221 62.9138 198.591C57.6129 185.892 53.0338 172.92 48.0886 160.087C47.1119 157.554 46.8092 154.537 44.4179 152.643C43.8671 150.89 45.6238 149.38 44.9498 147.613L44.9515 147.614Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M266.381 201.491C232.49 201.491 205.267 201.865 178.061 201.349C162.07 201.046 146.071 201.008 130.091 200.493C124.197 200.304 118.283 199.821 112.368 199.864C109.546 199.885 108.193 198.205 106.955 196.099C103.939 190.976 104.278 185.114 104.018 179.627C103.428 167.135 103.961 154.614 106.312 142.25C107.151 137.833 108.987 136.267 113.065 135.984C150.821 133.367 188.636 134.137 226.414 134.558C248.003 134.799 269.614 134.541 291.178 135.387C301.515 135.793 311.855 135.449 322.161 136.084C333.141 136.759 344.111 137.452 355.111 137.731C359.038 137.83 360.908 141.061 362.516 144.092C365.531 149.776 366.262 156.218 367.221 162.362C368.634 171.418 369.437 180.638 369.183 189.883C369.125 191.989 368.896 194.05 368.208 195.959C367.201 198.761 365.583 200.582 361.975 200.752C327.893 202.358 293.794 200.974 266.383 201.491H266.381ZM301.293 139.193C300.992 138.364 300.511 137.715 299.538 137.726C287.723 137.869 275.902 137.207 264.096 138.061C262.057 138.709 260.086 137.709 258.069 137.811C257.503 136.838 256.934 136.826 256.359 137.803C255.545 137.799 254.73 137.794 253.916 137.791C249.631 135.842 245.14 137.038 240.752 137.074C239.274 137.086 238.426 138.458 239.609 140.066C239.608 159.193 239.606 178.32 239.603 197.447C239.231 200.786 241.811 199.768 243.342 199.775C261.268 199.845 279.194 199.826 297.121 199.814C301.753 199.811 302.759 198.91 302.771 194.303C302.818 177.07 302.794 159.836 302.783 142.602C302.783 141.275 303.149 139.734 301.293 139.195V139.193ZM172.661 197.861C179.51 198.061 186.35 198.903 193.215 198.183C198.74 198.234 204.266 198.285 209.791 198.342C213.197 199.12 216.606 199.072 220.019 198.396C224.954 199.057 229.897 198.886 234.84 198.531C236.419 198.827 236.323 197.652 236.325 196.727C236.346 178.082 236.33 159.436 236.359 140.791C236.363 138.738 235.585 137.721 233.44 137.756C226.681 137.869 219.923 137.922 213.165 137.999C212.617 137.957 212.072 137.916 211.524 137.873C211.04 137.864 210.556 137.856 210.072 137.847C207.782 137.842 205.491 137.837 203.201 137.832C197.746 137.837 192.291 137.842 186.836 137.849C184.647 137.796 182.457 137.7 180.268 137.698C171.708 137.689 167.886 142.094 168.8 150.914C168.207 163.084 168.498 175.258 168.684 187.432C168.628 189.738 168.742 192.062 168.477 194.344C168.077 197.813 169.529 198.754 172.661 197.861ZM320.281 139.176C319.689 139.192 319.098 139.205 318.506 139.221C316.898 138.105 315.281 138.145 313.656 139.18C313.049 139.332 312.442 139.486 311.836 139.638C311.301 139.474 310.766 139.308 310.23 139.144C310.001 138.783 309.753 138.754 309.483 139.103C307.984 139.566 306.178 138.714 304.91 140.163C302.748 141.116 303.703 143.049 303.698 144.527C303.628 160.797 303.651 177.068 303.657 193.338C303.657 199.048 304.382 199.657 310.023 199.84C324.439 200.309 338.81 198.704 353.219 198.995C354.504 199.021 355.706 198.908 356.579 197.813C359.144 196.739 362.143 198.306 364.587 196.498C366.294 195.976 365.656 194.505 365.855 193.373C365.908 189.969 365.961 186.565 366.014 183.161C367.199 177.812 367.033 172.574 364.719 167.516C364.036 165.876 364.127 164.169 364.279 162.456C364.55 160.385 364.851 158.305 362.955 156.733C362.875 156.15 362.793 155.565 362.713 154.981C363.303 150.902 362.37 147.291 359.411 144.308C359.22 144.089 359.126 143.834 359.131 143.543C359.127 141.436 357.795 140.931 356.018 140.964C353.748 140.89 351.454 141.224 349.222 140.557C344.682 138.14 339.975 139.342 335.298 139.919C334.68 139.831 334.065 139.744 333.449 139.659C329.133 137.512 324.706 138.359 320.281 139.175V139.176ZM164.697 197.361C165.424 190.702 165.02 184.033 164.906 177.365C165.078 177.138 165.073 176.916 164.894 176.695C164.844 176.127 164.794 175.557 164.745 174.989C165.598 163.361 164.835 151.716 165.145 140.085C165.193 138.277 164.374 137.654 162.675 137.698C158.296 137.813 153.915 137.868 149.537 137.946C142.558 137.738 135.58 137.68 128.629 138.506C128.124 137.83 127.63 137.84 127.146 138.528C125.967 138.567 124.789 138.605 123.61 138.644C120.637 138.495 117.649 138.111 114.76 139.228C113.278 139.7 110.969 138.194 110.47 141.018C109.25 141.733 109.048 142.974 108.889 144.2C108.113 150.182 107.057 156.129 107.153 162.207C107.309 172.073 106.522 181.968 108.658 191.754C109.291 194.652 110.788 196.222 113.578 196.351C119.737 196.635 125.866 197.82 132.063 197.047C137.908 197.178 143.753 197.308 149.598 197.44C154.634 198.133 159.671 198.709 164.697 197.361Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M72.0274 136.197C68.4747 136.285 64.9236 136.374 61.3726 136.463C59.6415 135.673 58.0439 135.706 56.6908 137.23C52.0143 137.642 47.6644 138.591 45.9094 143.8C46.4448 137.211 48.388 135.145 54.6981 134.354C67.8862 132.702 81.035 133.159 94.1223 135.269C97.7879 135.861 100.403 136.785 100.788 142.052C101.909 157.361 101.667 172.675 101.094 187.918C100.643 199.907 100.877 211.877 100.557 223.849C100.438 228.313 98.4003 232.792 100.554 237.256C92.889 241.387 86.9979 247.145 84.0798 255.523C83.4862 257.228 82.4394 257.365 80.9204 257.375C67.8161 257.466 54.7066 257.495 41.6091 257.856C38.171 257.95 37.2114 256.818 37.5723 253.682C37.846 251.306 37.5723 248.99 35.8703 247.085C35.8669 236.599 35.3606 226.083 35.9798 215.635C36.8864 200.333 36.9924 184.962 39.7789 169.778C40.9865 163.197 41.5937 156.495 43.1999 149.968C43.4651 148.889 43.4172 147.698 44.9515 147.613C45.6237 149.38 43.867 150.888 44.4178 152.642C41.8862 166.623 42.2489 180.863 40.6837 194.933C39.8216 195.701 39.8353 196.481 40.6512 197.273C40.7094 199.342 40.7676 201.412 40.8274 203.482C40.9694 203.648 41.1148 203.808 41.2653 203.968C48.8823 203.998 56.501 204.358 64.1128 203.783C74.5487 204.303 84.9864 204.234 95.4223 203.831L95.3966 203.851C95.8858 200.887 95.7285 197.929 95.2872 194.975C95.5164 191.289 95.7439 187.605 95.9697 183.92C96.5786 182.95 96.529 181.96 96.0637 180.954C95.542 178.347 95.5318 175.739 96.0364 173.128C96.5923 170.207 96.6522 167.285 96.0056 164.367C95.7849 162.963 95.566 161.558 95.3453 160.156C95.5625 152.89 95.7798 145.623 95.997 138.359C95.8653 138.126 95.7353 137.895 95.6036 137.662C94.6953 137.505 93.7887 137.348 92.8804 137.192C90.3437 135.665 87.6822 135.635 84.9419 136.523C83.7326 136.498 82.5249 136.472 81.3156 136.446C80.9581 136.361 80.6006 136.277 80.2431 136.191C79.5828 136.395 78.9208 136.598 78.2606 136.804C76.7057 135.822 74.9199 136.468 73.2778 136.096C72.8604 136.13 72.4431 136.166 72.0257 136.2L72.0274 136.197ZM78.9294 239.682C83.3528 235.13 87.6993 230.479 93.8931 228.247C95.3008 227.74 95.6481 226.683 95.6395 225.313C95.6087 221.033 95.5848 216.752 95.6532 212.474C95.6823 210.594 95.0152 209.754 93.0395 209.676C84.492 209.335 75.9531 208.726 67.3919 209.227C59.5337 209.161 51.6739 209.12 43.8157 209.014C41.4432 208.981 40.6889 210.189 40.7282 212.363C40.8924 221.181 40.4169 230.007 41.5527 238.808C42.7124 247.788 43.0819 248.26 52.1101 248.939C53.068 249.011 54.0173 249.331 54.9718 249.327C64.0974 249.303 74.6941 253.012 78.8114 240.077C78.8524 239.945 78.8918 239.813 78.9311 239.68L78.9294 239.682Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M144.869 251.777C146.487 250.735 148.189 250.465 150.017 250.355C170.145 249.148 190.293 249.609 210.435 249.563C228.534 249.522 246.635 249.486 264.734 249.608C269.949 249.642 275.134 250.687 280.385 250.429C281.505 250.374 282.542 250.832 283.77 252.386C280.026 252.861 276.642 253.716 273.278 253.65C252.296 253.237 231.351 254.948 210.371 254.57C201.945 254.418 193.461 255.155 185.1 254.401C172.181 253.236 159.192 254.656 146.326 252.873C145.804 252.801 145.209 252.853 144.869 251.778V251.777Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M45.8153 144.294C45.9864 145.327 46.284 146.396 45.0661 147.053C45.0114 146.051 44.7616 144.996 45.8153 144.294Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M111.005 276.248C104.808 276.323 99.8817 271.588 99.7329 265.417C99.5858 259.226 104.661 253.966 110.872 253.876C116.881 253.787 121.973 258.754 122.115 264.84C122.264 271.198 117.421 276.171 111.005 276.248ZM113.682 265.025C113.32 263.845 112.753 262.647 111.075 262.615C109.471 262.582 108.424 263.448 108.368 265.039C108.315 266.592 109.228 267.639 110.832 267.731C112.48 267.825 113.22 266.705 113.682 265.025ZM112.895 257.129C112.57 256.4 112.033 255.518 110.95 255.585C109.745 255.658 108.853 256.443 109.021 257.735C109.178 258.941 110.015 259.724 111.33 259.431C112.345 259.206 112.93 258.467 112.894 257.131L112.895 257.129ZM120.381 265.321C120.34 264.096 119.729 263.422 118.619 263.359C117.485 263.294 116.724 263.995 116.689 265.059C116.657 266.097 117.309 266.879 118.463 266.924C119.594 266.966 120.235 266.363 120.381 265.321ZM103.277 263.314C102.213 263.504 101.428 264.07 101.5 265.211C101.568 266.292 102.276 266.997 103.409 266.963C104.546 266.929 105.227 266.147 105.207 265.093C105.184 264.005 104.391 263.408 103.277 263.314ZM112.806 272.702C112.634 271.585 112.004 270.916 110.897 270.967C109.83 271.017 109.042 271.648 109.113 272.774C109.18 273.824 109.873 274.542 110.998 274.518C112.131 274.494 112.67 273.759 112.806 272.702Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M325.881 264.941C325.972 271.148 320.989 276.215 314.703 276.306C308.576 276.395 303.643 271.65 303.491 265.524C303.333 259.168 308.063 254.086 314.332 253.876C320.389 253.672 325.792 258.85 325.883 264.941H325.881ZM314.577 267.799C316.155 267.585 317.088 266.754 317.101 265.153C317.115 263.518 316.176 262.608 314.583 262.642C313.03 262.676 312.011 263.608 312.018 265.186C312.024 266.763 313.087 267.558 314.575 267.798L314.577 267.799ZM316.434 272.604C316.203 271.509 315.594 270.878 314.459 270.989C313.34 271.101 312.721 271.79 312.828 272.902C312.934 273.996 313.653 274.59 314.773 274.511C315.943 274.431 316.34 273.617 316.434 272.602V272.604ZM324.058 265.006C323.731 264 323.169 263.206 322.04 263.381C321.03 263.537 320.214 264.159 320.385 265.322C320.539 266.368 321.219 267.041 322.37 266.932C323.517 266.822 323.959 266.039 324.06 265.008L324.058 265.006ZM316.537 257.548C316.268 256.419 315.728 255.482 314.412 255.627C313.381 255.74 312.716 256.482 312.739 257.55C312.769 258.821 313.537 259.524 314.807 259.46C315.943 259.404 316.325 258.521 316.537 257.548Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M40.8257 203.482C40.7676 201.412 40.7094 199.342 40.6512 197.274C40.6632 196.494 40.6735 195.714 40.6837 194.934C42.2489 180.865 41.8862 166.625 44.4178 152.643C46.8091 154.537 47.1119 157.554 48.0886 160.089C53.0337 172.922 57.6128 185.894 62.9137 198.593C63.5945 200.225 64.2976 201.92 64.1111 203.783C56.4993 204.358 48.8806 203.998 41.267 203.969C41.3098 203.643 41.161 203.48 40.8257 203.484V203.482Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M95.9714 183.919C95.7439 187.603 95.5147 191.289 95.2872 194.975C92.5538 193.626 92.5572 190.638 91.6592 188.361C85.2276 172.058 79.0304 155.661 72.7852 139.284C72.4996 138.533 72.4551 137.69 72.2994 136.889C72.6279 136.624 72.9546 136.359 73.2813 136.094C74.9234 136.467 76.7092 135.822 78.264 136.8C84.0046 152.016 89.7451 167.231 95.4873 182.448C95.6498 182.938 95.8106 183.429 95.9731 183.919H95.9714Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M56.6892 137.23C58.0422 135.707 59.6399 135.675 61.3709 136.463C59.9751 137.729 58.2578 137.031 56.6892 137.23Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M73.2796 136.092C72.9529 136.357 72.6244 136.622 72.2977 136.888C72.2105 136.657 72.1215 136.426 72.0275 136.197C72.4448 136.162 72.8622 136.128 73.2796 136.092Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M258.069 137.811C260.086 137.707 262.057 138.709 264.094 138.063C265.892 139.917 268.259 138.417 270.257 139.104C271.076 140.998 271.974 142.863 272.7 144.792C279.429 162.65 286.127 180.52 292.834 198.386C276.379 198.424 259.925 198.456 243.47 198.506C242.069 198.509 240.728 198.396 239.603 197.447C239.604 178.32 239.606 159.193 239.609 140.066C240.581 138.482 242.011 138.229 243.793 138.208C247.166 138.17 250.589 138.957 253.916 137.791C254.73 137.794 255.545 137.799 256.359 137.803C256.925 138.442 257.496 138.449 258.069 137.811Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M164.906 177.365C165.02 184.033 165.424 190.702 164.7 197.36C159.668 197.385 154.634 197.413 149.598 197.438C143.753 197.307 137.908 197.177 132.064 197.045C129.299 189.592 126.669 182.085 123.738 174.697C119.288 163.481 115.678 151.933 110.47 141.015C110.969 138.191 113.277 139.696 114.756 139.226C117.712 139.14 120.731 139.953 123.608 138.643C124.787 138.603 125.966 138.566 127.142 138.526C127.649 139.344 128.145 139.325 128.627 138.504C135.579 137.678 142.554 137.736 149.533 137.945C151.683 141.148 152.963 144.753 154.276 148.336C157.559 157.301 160.636 166.348 164.745 174.99C164.794 175.557 164.844 176.127 164.894 176.693C164.825 176.758 164.687 176.844 164.697 176.89C164.738 177.056 164.832 177.208 164.906 177.365Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M168.8 150.916C167.886 142.101 171.708 137.696 180.268 137.7C182.457 137.702 184.647 137.798 186.834 137.851C194.486 158.014 202.14 178.176 209.793 198.34C204.268 198.289 198.741 198.237 193.218 198.184C188.75 198.892 186.479 196.717 185.192 192.598C183.764 188.024 182.091 183.503 180.17 179.114C176.106 169.822 173.612 159.901 168.8 150.916Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M349.22 140.555C351.452 141.226 353.746 140.894 356.014 140.966C356.83 142.091 357.735 143.114 359.129 143.545C359.124 143.836 359.218 144.091 359.408 144.308C360.508 147.866 361.609 151.424 362.711 154.982C362.791 155.565 362.873 156.15 362.952 156.733C362.41 158.868 363.178 160.702 364.278 162.457C364.127 164.169 364.035 165.876 364.715 167.515C364.387 172.792 365.827 177.923 366.014 183.159C365.961 186.563 365.908 189.967 365.855 193.369C365.03 194.248 364.365 195.193 364.587 196.496C362.143 198.304 359.143 196.737 356.578 197.81C356.356 197.64 356.134 197.474 355.911 197.309C352.008 186.784 348.07 176.273 344.215 165.732C341.167 157.4 337.282 149.364 335.301 140.654C339.942 140.62 344.581 140.588 349.222 140.553L349.22 140.555Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M310.23 139.146C310.766 139.31 311.301 139.476 311.836 139.64C312.153 141.109 312.295 142.644 312.813 144.038C316.354 153.56 320.043 163.028 323.55 172.562C326.673 181.059 330.603 189.267 332.684 198.136C324.693 198.249 316.699 198.307 308.711 198.504C305.921 198.573 305.164 197.244 305.191 194.717C305.27 187.55 305.251 180.383 305.205 173.214C305.134 162.198 305.011 151.183 304.909 140.167C306.18 138.716 307.984 139.568 309.483 139.104L309.849 139.25L310.228 139.146H310.23Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M211.524 137.875C212.072 137.917 212.617 137.958 213.165 138.001C213.266 138.82 213.206 139.703 213.491 140.452C218.101 152.549 222.832 164.6 227.372 176.721C230.068 183.917 233.491 190.874 234.84 198.533C229.897 198.887 224.954 199.057 220.019 198.4C219.463 197.153 218.751 195.949 218.373 194.647C213.478 177.79 206.386 161.747 200.094 145.409C197.746 139.308 197.467 139.33 203.199 137.833C205.489 137.839 207.78 137.844 210.069 137.849C210.541 138.518 211.026 138.502 211.523 137.875H211.524Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M335.3 140.658C337.28 149.368 341.167 157.404 344.213 165.736C348.069 176.278 352.008 186.789 355.91 197.312C351.25 197.469 346.591 197.628 341.933 197.786C340.71 196.966 340.298 195.678 339.802 194.375C333.422 177.617 326.978 160.883 320.642 144.108C320.131 142.751 318.682 141.161 320.538 139.642C324.842 139.737 329.143 140.374 333.447 139.659C334.065 139.746 334.68 139.833 335.296 139.92C335.243 140.167 335.247 140.411 335.3 140.656V140.658Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M110.47 141.019C115.678 151.935 119.288 163.483 123.738 174.701C126.67 182.088 129.299 189.596 132.064 197.049C125.865 197.822 119.736 196.635 113.576 196.352C110.786 196.224 109.29 194.654 108.657 191.756C106.52 181.97 107.307 172.075 107.151 162.209C107.056 156.133 108.111 150.185 108.888 144.202C109.047 142.975 109.247 141.735 110.468 141.02L110.47 141.019Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M234.84 198.533C233.491 190.874 230.066 183.917 227.372 176.721C222.833 164.598 218.101 152.547 213.491 140.452C213.206 139.703 213.266 138.82 213.165 138.001C219.923 137.926 226.681 137.871 233.44 137.758C235.583 137.722 236.363 138.742 236.359 140.793C236.332 159.437 236.346 178.084 236.325 196.729C236.325 197.654 236.421 198.827 234.84 198.533Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M203.201 137.833C197.469 139.33 197.748 139.31 200.096 145.409C206.386 161.747 213.479 177.79 218.375 194.647C218.753 195.949 219.464 197.153 220.02 198.4C216.608 199.074 213.199 199.122 209.793 198.342C202.14 178.176 194.486 158.013 186.834 137.851C192.291 137.845 197.746 137.84 203.201 137.835V137.833Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M320.538 139.642C318.684 141.16 320.131 142.751 320.642 144.108C326.978 160.883 333.421 177.617 339.802 194.375C340.298 195.678 340.712 196.966 341.935 197.782C338.876 198.549 335.775 198.229 332.684 198.133C330.604 189.266 326.673 181.055 323.55 172.559C320.045 163.024 316.356 153.557 312.813 144.034C312.295 142.64 312.153 141.106 311.836 139.636C312.444 139.484 313.051 139.33 313.656 139.178C315.273 139.192 316.889 139.205 318.506 139.219C319.097 139.204 319.689 139.19 320.281 139.175C320.341 139.342 320.428 139.498 320.538 139.638V139.642Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M168.8 150.916C173.612 159.901 176.106 169.82 180.17 179.114C182.09 183.503 183.764 188.026 185.192 192.598C186.479 196.717 188.752 198.892 193.218 198.184C186.352 198.903 179.512 198.063 172.661 197.863C171.886 194.177 170.853 190.59 168.684 187.434C168.498 175.26 168.207 163.086 168.8 150.916Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M164.745 174.99C160.636 166.348 157.561 157.303 154.276 148.336C152.964 144.753 151.683 141.149 149.533 137.945C153.914 137.866 158.294 137.811 162.673 137.697C164.372 137.652 165.191 138.275 165.143 140.083C164.834 151.716 165.597 163.361 164.743 174.988L164.745 174.99Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M239.603 197.447C240.73 198.396 242.069 198.509 243.47 198.506C259.925 198.456 276.379 198.424 292.834 198.384C294.618 198.436 296.406 198.439 298.186 198.552C300.448 198.694 301.359 197.786 301.347 195.435C301.241 176.722 301.226 158.007 301.181 139.294L301.294 139.193C303.15 139.732 302.784 141.275 302.784 142.602C302.796 159.836 302.82 177.07 302.772 194.303C302.76 198.91 301.754 199.811 297.122 199.814C279.196 199.826 261.27 199.845 243.343 199.775C241.811 199.77 239.233 200.788 239.604 197.447H239.603Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M332.682 198.135C335.775 198.231 338.875 198.55 341.933 197.784C346.591 197.628 351.25 197.471 355.91 197.314C356.134 197.48 356.356 197.647 356.577 197.815C355.703 198.913 354.5 199.024 353.216 198.999C338.806 198.708 324.436 200.311 310.02 199.844C304.378 199.661 303.655 199.05 303.653 193.342C303.65 177.071 303.624 160.801 303.694 144.53C303.701 143.052 302.747 141.118 304.907 140.167C305.008 151.183 305.131 162.198 305.201 173.214C305.247 180.381 305.266 187.55 305.188 194.717C305.16 197.244 305.918 198.573 308.708 198.504C316.698 198.307 324.689 198.249 332.681 198.136L332.682 198.135Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M270.255 139.104C268.257 138.417 265.892 139.917 264.092 138.063C275.902 137.208 287.723 137.869 299.538 137.726C300.511 137.714 300.992 138.362 301.293 139.193L301.18 139.294C290.872 139.149 280.566 138.629 270.255 139.104Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M168.684 187.434C170.853 190.59 171.885 194.176 172.661 197.863C169.531 198.756 168.077 197.813 168.479 194.346C168.742 192.064 168.629 189.739 168.686 187.434H168.684Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M253.916 137.791C250.589 138.957 247.167 138.17 243.793 138.208C242.011 138.229 240.581 138.48 239.609 140.066C238.424 138.458 239.274 137.086 240.752 137.074C245.141 137.038 249.631 135.844 253.916 137.791Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M335.3 140.658C335.245 140.413 335.243 140.167 335.296 139.922C339.975 139.346 344.682 138.143 349.222 140.558C344.581 140.591 339.94 140.623 335.301 140.658H335.3Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M320.538 139.642C320.428 139.501 320.343 139.346 320.281 139.178C324.706 138.362 329.133 137.515 333.447 139.66C329.142 140.374 324.84 139.737 320.538 139.642Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M366.012 183.162C365.826 177.926 364.387 172.795 364.714 167.518C367.032 172.578 367.198 177.814 366.012 183.162Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M362.711 154.983C361.609 151.425 360.508 147.867 359.408 144.31C362.367 147.293 363.299 150.902 362.711 154.983Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M149.598 197.439C154.632 197.411 159.668 197.386 164.7 197.36C159.671 198.708 154.636 198.133 149.598 197.439Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M364.276 162.46C363.178 160.703 362.41 158.871 362.95 156.737C364.845 158.309 364.544 160.389 364.276 162.46Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M123.608 138.644C120.73 139.955 117.712 139.142 114.756 139.228C117.649 138.111 120.637 138.495 123.608 138.644Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M359.129 143.547C357.737 143.114 356.832 142.093 356.014 140.967C357.793 140.935 359.124 141.441 359.129 143.547Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M364.586 196.499C364.363 195.196 365.027 194.25 365.853 193.373C365.655 194.507 366.293 195.979 364.586 196.499Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M318.506 139.221C316.889 139.207 315.271 139.195 313.656 139.18C315.283 138.143 316.9 138.106 318.506 139.221Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M128.627 138.504C128.145 139.327 127.649 139.344 127.142 138.526C127.628 137.839 128.122 137.828 128.627 138.504Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M258.069 137.811C257.495 138.449 256.925 138.442 256.359 137.803C256.934 136.828 257.505 136.84 258.069 137.811Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M211.524 137.875C211.026 138.502 210.541 138.518 210.07 137.849C210.556 137.857 211.04 137.866 211.524 137.875Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M310.23 139.146L309.85 139.25L309.484 139.104C309.753 138.756 310.001 138.785 310.232 139.146H310.23Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M164.906 177.365C164.832 177.208 164.74 177.056 164.697 176.89C164.685 176.844 164.823 176.758 164.894 176.693C165.073 176.916 165.078 177.138 164.906 177.365Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M78.9294 239.682C78.8901 239.813 78.8525 239.947 78.8097 240.079C74.6925 253.014 64.0975 249.303 54.9701 249.329C54.0173 249.332 53.068 249.013 52.1084 248.941C43.0802 248.262 42.7108 247.79 41.551 238.809C40.4152 230.009 40.8908 221.182 40.7265 212.365C40.6855 210.189 41.4415 208.983 43.814 209.015C51.6722 209.121 59.5304 209.163 67.3902 209.228C67.474 212.048 68.9177 214.438 69.9218 216.949C72.9443 224.518 75.1629 232.409 78.9294 239.682Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M78.9295 239.682C75.1629 232.407 72.9443 224.518 69.9218 216.949C68.9195 214.438 67.4758 212.048 67.3903 209.227C75.9514 208.728 84.4904 209.337 93.0379 209.677C95.0135 209.756 95.6824 210.596 95.6516 212.476C95.5831 216.756 95.6088 221.035 95.6379 225.315C95.6481 226.683 95.2992 227.74 93.8914 228.249C87.6976 230.479 83.3495 235.132 78.9278 239.683L78.9295 239.682Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M95.4856 182.447C89.7451 167.231 84.0046 152.014 78.2623 136.8C78.9226 136.598 79.5846 136.395 80.2465 136.19C80.604 136.274 80.9615 136.359 81.3173 136.445C82.5267 136.47 83.7343 136.496 84.9419 136.522C85.438 136.852 85.9358 137.182 86.4318 137.512C86.7209 142.941 89.7776 147.46 91.4385 152.438C92.3382 155.135 92.7693 158.238 95.3436 160.156C95.5643 161.56 95.7832 162.965 96.0022 164.367C95.5711 167.289 95.4788 170.21 96.033 173.128C95.5284 175.739 95.5386 178.347 96.0586 180.954C95.8654 181.452 95.6738 181.95 95.4805 182.447H95.4856Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M95.347 160.154C92.7727 158.237 92.3416 155.135 91.4419 152.436C89.7827 147.459 86.726 142.939 86.4352 137.512C88.5853 137.406 90.7337 137.296 92.8839 137.189C93.7922 137.346 94.6987 137.503 95.6053 137.659C95.6139 137.96 95.7456 138.193 95.9987 138.355C95.7815 145.622 95.5643 152.888 95.347 160.152V160.154Z',
  fill: '#CFD7D8'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M92.8839 137.19C90.7337 137.298 88.5853 137.408 86.4352 137.514C85.9374 137.182 85.4414 136.852 84.9453 136.522C87.6856 135.634 90.3489 135.661 92.8839 137.19Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M96.0364 173.127C95.4821 170.207 95.5745 167.285 96.0056 164.365C96.6539 167.285 96.5923 170.205 96.0364 173.127Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M95.4856 182.448C95.6772 181.95 95.8705 181.45 96.0638 180.954C96.529 181.96 96.5786 182.952 95.9714 183.922C95.8106 183.429 95.6481 182.94 95.4873 182.449L95.4856 182.448Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M40.6837 194.933C40.6735 195.713 40.6615 196.493 40.6512 197.273C39.8353 196.481 39.8216 195.701 40.6837 194.933Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M95.9988 138.357C95.7456 138.194 95.6139 137.962 95.6053 137.661C95.7371 137.893 95.8671 138.124 95.9988 138.357Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M40.8258 203.482C41.1611 203.478 41.3099 203.641 41.2671 203.968C41.1132 203.809 40.9678 203.646 40.8258 203.482Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M81.3191 136.443C80.9633 136.357 80.6058 136.274 80.2483 136.188C80.6041 136.274 80.9616 136.357 81.3191 136.443Z',
  fill: '#F7BE2F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M113.682 265.025C113.22 266.703 112.48 267.823 110.832 267.731C109.23 267.64 108.315 266.593 108.368 265.038C108.422 263.448 109.471 262.582 111.075 262.615C112.753 262.649 113.32 263.846 113.682 265.025Z',
  fill: '#3A494E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.895 257.129C112.931 258.465 112.345 259.204 111.332 259.43C110.017 259.722 109.18 258.939 109.023 257.733C108.855 256.441 109.745 255.656 110.952 255.583C112.035 255.518 112.57 256.399 112.897 257.127L112.895 257.129Z',
  fill: '#58707A'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M120.381 265.321C120.235 266.362 119.594 266.968 118.463 266.923C117.307 266.879 116.655 266.097 116.689 265.059C116.723 263.995 117.485 263.292 118.619 263.359C119.729 263.424 120.34 264.096 120.381 265.321Z',
  fill: '#3A494E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M103.277 263.319C104.389 263.408 105.184 264.005 105.207 265.093C105.227 266.147 104.548 266.93 103.409 266.963C102.276 266.997 101.568 266.291 101.5 265.211C101.428 264.07 102.211 263.504 103.277 263.319Z',
  fill: '#3A494E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.806 272.702C112.67 273.757 112.131 274.493 110.998 274.518C109.873 274.542 109.18 273.826 109.113 272.774C109.042 271.648 109.83 271.017 110.898 270.967C112.006 270.916 112.635 271.585 112.806 272.702Z',
  fill: '#3A494E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M314.577 267.799C313.088 267.558 312.026 266.764 312.019 265.187C312.012 263.608 313.032 262.676 314.585 262.644C316.178 262.61 317.117 263.52 317.103 265.155C317.089 266.756 316.155 267.587 314.578 267.801L314.577 267.799Z',
  fill: '#3A494E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M316.434 272.604C316.338 273.619 315.943 274.433 314.773 274.513C313.653 274.59 312.935 273.998 312.828 272.904C312.721 271.792 313.34 271.102 314.459 270.991C315.596 270.878 316.205 271.509 316.434 272.606V272.604Z',
  fill: '#3A494E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M324.058 265.006C323.959 266.039 323.516 266.823 322.368 266.93C321.217 267.04 320.538 266.366 320.384 265.321C320.213 264.158 321.029 263.535 322.038 263.379C323.167 263.205 323.731 263.998 324.056 265.004L324.058 265.006Z',
  fill: '#3A494E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M316.535 257.552C316.323 258.521 315.942 259.402 314.806 259.461C313.535 259.526 312.767 258.823 312.738 257.55C312.714 256.481 313.381 255.74 314.411 255.627C315.726 255.484 316.267 256.421 316.533 257.552H316.535Z',
  fill: '#58707A'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M270.255 139.105C280.566 138.629 290.872 139.149 301.18 139.294C301.224 158.008 301.241 176.722 301.346 195.436C301.359 197.786 300.448 198.692 298.185 198.552C296.404 198.441 294.616 198.436 292.832 198.384C286.125 180.52 279.425 162.65 272.698 144.792C271.971 142.863 271.073 141 270.255 139.105Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M220.144 330.524C244.346 330.524 263.966 327.174 263.966 323.041C263.966 318.908 244.346 315.557 220.144 315.557C195.941 315.557 176.322 318.908 176.322 323.041C176.322 327.174 195.941 330.524 220.144 330.524Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M159.769 261.416C170.378 294.757 206.01 313.188 239.353 302.579C254.794 297.669 267.034 287.39 274.674 274.458C275.306 273.386 275.91 272.296 276.478 271.19C276.95 270.274 277.398 269.349 277.821 268.412C278.406 267.137 278.941 265.842 279.434 264.534C284.295 251.662 285.012 237.124 280.518 222.996C278.84 217.725 276.54 212.825 273.712 208.355C273.225 207.575 272.717 206.805 272.192 206.051C271.856 205.567 271.512 205.088 271.165 204.614C270.064 203.124 268.909 201.691 267.695 200.314C251.581 182.049 225.629 173.972 200.933 181.83C167.586 192.442 149.157 228.071 159.767 261.417L159.769 261.416Z',
  fill: '#F1585F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M252.31 296.651C251.108 297.359 249.879 298.031 248.626 298.655C247.709 299.119 246.782 299.559 245.841 299.974C244.705 300.479 243.55 300.948 242.386 301.385C228.339 306.654 212.376 306.977 197.296 301.119C164.724 288.471 148.586 251.804 161.249 219.224C162.906 214.958 164.974 210.976 167.393 207.301C162.251 236.435 178.183 266.085 206.8 277.199C221.882 283.057 237.842 282.734 251.889 277.465C253.054 277.029 254.207 276.559 255.345 276.054C256.285 275.639 257.214 275.199 258.129 274.735C259.381 274.111 260.611 273.439 261.814 272.731C270.004 267.917 277.154 261.245 282.559 253.027C281.853 257.054 280.739 261.07 279.203 265.025C273.835 278.83 264.162 289.687 252.31 296.652V296.651Z',
  fill: '#E44A55'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M220.144 269.113C234.093 269.113 245.401 257.805 245.401 243.855C245.401 229.906 234.093 218.598 220.144 218.598C206.194 218.598 194.886 229.906 194.886 243.855C194.886 257.805 206.194 269.113 220.144 269.113Z',
  fill: '#E44A55'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M220.144 266.954C234.093 266.954 245.401 255.646 245.401 241.697C245.401 227.747 234.093 216.439 220.144 216.439C206.194 216.439 194.886 227.747 194.886 241.697C194.886 255.646 206.194 266.954 220.144 266.954Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M220.144 254.433C227.178 254.433 232.88 248.731 232.88 241.697C232.88 234.662 227.178 228.96 220.144 228.96C213.109 228.96 207.407 234.662 207.407 241.697C207.407 248.731 213.109 254.433 220.144 254.433Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M229.497 238.604C231.683 238.604 233.455 236.832 233.455 234.646C233.455 232.46 231.683 230.688 229.497 230.688C227.311 230.688 225.539 232.46 225.539 234.646C225.539 236.832 227.311 238.604 229.497 238.604Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M214.599 307.635C215.306 303.625 210.347 299.398 203.523 298.195C196.699 296.991 190.594 299.267 189.886 303.278C189.179 307.289 194.138 311.515 200.962 312.719C207.786 313.922 213.891 311.646 214.599 307.635Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M239.213 322.792C246.037 321.589 250.996 317.362 250.288 313.351C249.581 309.34 243.476 307.065 236.652 308.268C229.828 309.471 224.869 313.698 225.576 317.709C226.283 321.719 232.389 323.995 239.213 322.792Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M300.393 281.915C303.729 279.579 303.211 273.084 299.237 267.408C295.262 261.732 289.336 259.024 286 261.36C282.664 263.696 283.181 270.191 287.156 275.867C291.13 281.543 297.057 284.251 300.393 281.915Z',
  fill: '#E44A55'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M152.303 275.866C156.277 270.19 156.795 263.695 153.459 261.359C150.123 259.023 144.196 261.731 140.222 267.407C136.247 273.083 135.73 279.578 139.066 281.914C142.402 284.25 148.328 281.542 152.303 275.866Z',
  fill: '#E44A55'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M192.209 235.871C192.209 221.615 204.889 210.057 220.532 210.057C236.173 210.057 248.855 221.613 248.855 235.871',
  fill: '#F1585F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M234.519 270.931C234.916 271.658 235.042 272.568 234.907 273.446C234.507 276.148 231.854 278.093 229.225 278.196C225.929 278.458 222.03 275.902 222.335 272.324C222.414 271.612 223.387 271.422 223.731 272.038C224.736 273.921 226.945 274.824 228.985 274.669C230.947 274.457 232.62 273.347 233.098 271.222C233.185 270.483 234.167 270.283 234.522 270.931H234.519Z',
  fill: '#DB495B'
})));

const BobbinCar = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '250',
  height: '250',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M162 35C161.692 37.0204 160.91 37.1986 160 36.8685C160.664 36.2479 161.332 35.6206 162 35Z',
  fill: '#233256'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M380.22 257.857C382.692 257.883 385.203 257.659 387.545 258.714C389.356 259.532 390.661 260.866 391.364 262.752C391.485 263.075 391.51 263.478 392 263.476V273.111C391.358 273.151 391.312 273.736 391.092 274.139C389.627 276.84 387.395 278.235 384.293 278.199C382.959 278.183 381.624 278.199 380.287 278.199C379.937 277.659 379.392 277.923 378.945 277.923C372.745 277.904 366.546 277.91 360.346 277.91C352.764 277.91 345.184 277.895 337.601 277.929C336.75 277.933 336.455 277.72 336.452 276.846C336.452 275.647 336.326 274.443 336.186 273.25C335.547 267.775 333.644 262.737 330.855 258.009C331.387 257.986 331.921 257.942 332.453 257.942C347.842 257.937 363.231 257.94 378.619 257.935C379.151 257.935 379.684 257.885 380.216 257.857H380.22Z',
  fill: '#E3E3E7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M144.548 87.0063C145.796 87.0084 147.042 87.0127 148.289 87.0127C183.822 87.0127 219.354 87.0127 254.887 87.0127C255.599 87.0127 256.312 87.0042 257.024 87C262.292 87.644 265.854 90.5093 268.274 95.1821C281.805 121.325 295.413 147.427 308.952 173.566C309.55 174.719 310.187 175.12 311.488 175.107C317.78 175.039 324.077 174.987 330.365 175.13C342.451 175.405 352.996 179.763 361.939 187.801C372.923 197.675 378.793 210.137 379.996 224.816C380.478 230.693 380.144 236.586 380.203 242.471C380.256 247.599 380.218 252.73 380.218 257.859C379.686 257.887 379.154 257.937 378.622 257.937C363.233 257.942 347.844 257.939 332.455 257.944C331.923 257.944 331.389 257.988 330.857 258.013C328.501 254.426 325.735 251.2 322.375 248.505C315.962 243.362 308.591 240.729 300.432 240.165C300.424 225.042 300.415 209.922 300.407 194.799C300.407 194.442 300.382 194.083 300.411 193.728C300.468 193.021 300.139 192.787 299.463 192.804C298.169 192.833 296.874 192.812 295.58 192.812C294.336 192.812 293.713 193.436 293.713 194.683C293.707 209.939 293.699 225.194 293.692 240.45C293.346 240.534 293.004 240.642 292.653 240.699C284.902 241.966 278.217 245.353 272.535 250.76C268.563 254.54 265.677 259.044 263.54 264.059C262.871 264.048 262.201 264.027 261.532 264.025C227.839 264.025 194.145 264.025 160.452 264.025C159.31 264.025 158.739 263.44 158.739 262.27C158.739 239.702 158.739 217.135 158.739 194.567C158.739 194.21 158.714 193.851 158.744 193.496C158.801 192.799 158.499 192.546 157.808 192.563C156.469 192.597 155.131 192.571 153.792 192.571C152.629 192.571 152.047 193.143 152.046 194.286C152.046 216.721 152.046 239.153 152.046 261.588C152.046 263.211 151.255 264.023 149.675 264.025C143.294 264.035 136.913 264.048 130.532 264.061C130.32 263.619 130.097 263.187 129.902 262.739C121.585 243.575 98.7175 234.837 79.7519 243.552C72.7839 246.753 67.351 251.67 63.1807 258.049C62.6507 258.016 62.1208 257.952 61.5908 257.95C49.779 257.944 37.9672 257.946 26.1554 257.942C25.6233 257.942 25.0912 257.893 24.5591 257.866C26.0815 243.93 28.9869 230.262 32.7116 216.769C38.6196 195.363 46.0036 174.484 55.6469 154.452C61.2973 142.716 67.4565 131.226 75.7759 121.124C90.3305 103.444 108.971 92.5491 131.526 88.3999C135.832 87.6081 140.179 87.2175 144.548 87.0063ZM355.038 226.691C357.595 226.702 359.55 225.462 361.153 223.625C365.446 218.706 365.648 210.006 361.59 204.888C359.928 202.791 357.887 201.3 355.047 201.307C354.234 199.284 352.631 198.661 350.598 198.805C348.416 198.773 346.235 198.75 344.054 198.703C343.364 198.688 343.26 199.079 343.26 199.641C343.266 209.172 343.271 218.703 343.252 228.235C343.252 228.999 343.535 229.244 344.274 229.227C346.366 229.176 348.461 229.179 350.553 229.16C352.614 229.369 354.219 228.744 355.036 226.693L355.038 226.691ZM96.6102 167.871C99.1123 167.858 101.614 167.846 104.117 167.833C113.308 167.848 122.502 167.865 131.693 167.877C134.55 167.881 137.407 167.911 140.261 167.867C142.728 167.829 144.045 166.471 144.06 164.034C144.075 161.716 144.069 159.395 144.062 157.077C144.045 149.898 144.026 142.719 144.007 135.539C144.058 135.482 144.073 135.417 144.052 135.345C144.299 135.151 144.261 134.872 144.254 134.612C144.172 130.727 144.083 126.842 143.997 122.955C144.254 122.613 144.271 122.222 144.271 121.812C144.267 115.079 144.267 108.343 144.269 101.61C144.269 101.065 144.221 100.545 143.764 100.163C142.848 98.4254 141.326 97.7159 139.436 98.2396C137.506 98.7738 135.597 99.3798 133.68 99.9605C123.04 103.189 113.145 107.908 104.6 115.092C94.6507 123.457 86.1582 133.196 78.6053 143.749C74.8131 149.049 71.65 154.722 68.9789 160.666L68.9937 160.658C68.9283 160.761 68.8628 160.865 68.7974 160.968C68.4384 161.579 68.0414 162.17 67.7247 162.801C66.4219 165.398 67.9633 167.875 70.9173 167.917C73.0584 167.949 75.2016 167.934 77.3426 167.922C81.0885 167.9 84.8343 167.865 88.578 167.835C91.2554 167.848 93.9307 167.858 96.6081 167.871H96.6102ZM234.781 167.858C250.518 167.865 266.253 167.877 281.99 167.875C286.779 167.875 289.157 164 286.98 159.735C283.523 152.959 280.041 146.196 276.562 139.433C275.791 137.936 274.978 136.46 274.184 134.974C273.183 132.934 272.18 130.892 271.179 128.852C270.865 128.272 270.54 127.695 270.238 127.108C267.961 122.695 265.689 118.28 263.415 113.867C261.118 109.409 258.827 104.948 256.513 100.499C256.272 100.034 255.962 99.5804 255.455 99.3312C254.467 98.3684 253.246 98.0728 251.91 98.0728C222.642 98.0749 193.374 98.0728 164.105 98.0791C160.904 98.0791 158.737 100.248 158.737 103.466C158.727 123.13 158.727 142.792 158.737 162.457C158.737 165.643 160.908 167.848 164.107 167.869C169.191 167.903 174.276 167.865 179.358 167.858C180.201 167.877 181.043 167.913 181.884 167.909C187.739 167.888 193.596 167.86 199.451 167.835C208.822 167.843 218.193 167.852 227.564 167.858C229.969 167.858 232.374 167.858 234.779 167.86L234.781 167.858ZM180.684 205.663C177.834 205.663 174.983 205.658 172.133 205.663C169.704 205.667 168.37 206.919 168.374 209.168C168.378 211.229 169.856 212.616 172.078 212.618C177.823 212.624 183.569 212.624 189.314 212.618C191.54 212.616 193.018 211.227 193.024 209.155C193.03 207.001 191.649 205.671 189.371 205.663C186.476 205.652 183.581 205.661 180.686 205.661L180.684 205.663Z',
  fill: '#E24C4C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M263.54 264.052C265.679 259.04 268.563 254.534 272.535 250.754C278.217 245.346 284.902 241.962 292.653 240.693C293.004 240.636 293.346 240.528 293.692 240.444C295.939 240.348 298.188 240.253 300.434 240.158C308.591 240.722 315.964 243.355 322.377 248.499C325.736 251.193 328.503 254.42 330.859 258.007C333.646 262.733 335.549 267.773 336.191 273.248C336.33 274.441 336.454 275.645 336.457 276.844C336.457 277.72 336.752 277.931 337.605 277.927C345.188 277.893 352.768 277.908 360.35 277.908C366.55 277.908 372.749 277.902 378.949 277.921C379.394 277.921 379.939 277.657 380.292 278.197C379.88 281.907 377.441 284.107 373.664 284.11C359.248 284.118 344.833 284.124 330.418 284.091C329.36 284.088 328.925 284.314 328.64 285.427C324.845 300.275 311.175 309.948 295.911 308.66C283.094 307.579 271.876 298.022 268.85 285.535C268.584 284.435 268.217 284.084 267.053 284.086C220.372 284.12 173.689 284.12 127.007 284.086C125.827 284.086 125.487 284.458 125.223 285.552C122.292 297.617 111.802 306.92 99.4775 308.47C83.6032 310.465 69.1224 300.598 65.3576 285.163C65.1274 284.217 64.7241 284.103 63.9154 284.105C51.4639 284.124 39.0123 284.12 26.5607 284.118C23.0767 284.118 20.8026 282.581 19.9411 279.644C19.8039 279.179 19.7659 278.685 19.6814 278.206C20.3254 277.604 21.1151 277.933 21.8246 277.931C33.3218 277.904 44.8189 277.908 56.314 277.923C57.0931 277.923 57.6506 277.959 57.621 276.869C57.5872 275.632 57.7519 274.382 57.8976 273.144C58.5353 267.72 60.442 262.733 63.1827 258.041C67.353 251.664 72.7859 246.746 79.7539 243.543C98.7195 234.829 121.587 243.566 129.904 262.731C130.099 263.178 130.322 263.613 130.534 264.052C131.893 268.022 133.04 272.051 133.004 276.284C132.994 277.661 133.395 277.952 134.723 277.952C176.267 277.914 217.813 277.923 259.357 277.923C259.625 277.923 259.893 277.902 260.159 277.925C260.782 277.98 261.042 277.729 261.031 277.087C260.968 272.57 262.091 268.28 263.542 264.052H263.54ZM285.379 281.572C285.286 283.028 285.552 284.576 286.015 286.05C286.703 288.25 287.362 290.564 289.429 291.933C293.314 294.502 297.596 295.408 302.166 294.41C312.003 292.26 317.766 282.458 314.79 272.866C314.1 270.638 313.262 268.353 311.049 267.042C307.432 264.901 303.5 264.168 299.391 264.844C291.367 266.166 285.379 273.343 285.379 281.572ZM82.1146 281.724C81.9118 283.689 82.3975 285.769 83.2273 287.752C83.8164 289.165 84.2704 290.738 85.6302 291.656C89.2641 294.11 93.2105 295.227 97.6468 294.568C107.856 293.052 114.362 283.18 111.517 273.286C110.764 270.668 109.758 268.098 107.119 266.696C103.631 264.844 99.9125 264.215 96.0252 264.848C87.9782 266.16 81.7028 273.848 82.1167 281.724H82.1146Z',
  fill: '#4E4E4E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M63.1785 258.041C60.4378 262.735 58.5332 267.72 57.8934 273.144C57.7477 274.382 57.583 275.63 57.6168 276.869C57.6464 277.959 57.0889 277.923 56.3098 277.923C44.8126 277.906 33.3154 277.904 21.8204 277.931C21.113 277.931 20.3233 277.602 19.6772 278.206C18.7418 278.206 17.7916 278.102 16.871 278.216C12.8169 278.719 8.69099 274.673 9.01827 270.349C9.13863 268.755 9.14285 267.133 9.01616 265.539C8.75644 262.262 11.9089 258.476 15.6252 258.077C18.6109 257.756 21.5839 257.988 24.559 257.861C25.0911 257.889 25.6232 257.937 26.1553 257.937C37.9671 257.942 49.7789 257.937 61.5907 257.946C62.1207 257.946 62.6507 258.009 63.1806 258.045L63.1785 258.041Z',
  fill: '#E3E3E7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M179.358 167.856C174.274 167.862 169.189 167.9 164.107 167.867C160.908 167.846 158.737 165.641 158.737 162.455C158.727 142.79 158.727 123.128 158.737 103.463C158.737 100.246 160.904 98.0791 164.105 98.077C193.372 98.0707 222.64 98.0728 251.91 98.0707C253.246 98.0707 254.467 98.3663 255.455 99.3291C253.255 101.32 251.057 103.309 248.856 105.3C245.991 107.891 243.141 110.501 240.256 113.071C236.479 116.437 232.663 119.758 228.888 123.126C225.972 125.727 223.107 128.388 220.191 130.987C216.447 134.323 212.659 137.609 208.917 140.947C205.967 143.578 203.068 146.266 200.125 148.903C196.06 152.548 191.981 156.177 187.893 159.796C185.933 161.532 183.889 163.175 181.987 164.97C181.047 165.854 179.863 166.562 179.36 167.858L179.358 167.856Z',
  fill: '#E3E3E7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M263.54 264.052C262.089 268.28 260.966 272.57 261.029 277.087C261.038 277.729 260.78 277.98 260.157 277.925C259.891 277.902 259.623 277.923 259.355 277.923C217.811 277.923 176.265 277.916 134.721 277.952C133.393 277.952 132.991 277.661 133.002 276.284C133.038 272.051 131.891 268.022 130.531 264.052C136.912 264.04 143.293 264.027 149.674 264.016C151.255 264.014 152.046 263.201 152.046 261.58C152.046 239.145 152.046 216.712 152.046 194.277C152.046 193.134 152.628 192.563 153.792 192.563C155.131 192.563 156.469 192.588 157.808 192.554C158.498 192.537 158.8 192.791 158.743 193.488C158.714 193.842 158.739 194.201 158.739 194.558C158.739 217.126 158.739 239.694 158.739 262.262C158.739 263.43 159.31 264.015 160.452 264.016C194.145 264.016 227.838 264.016 261.532 264.016C262.201 264.016 262.87 264.037 263.54 264.05V264.052Z',
  fill: '#C13C3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M143.766 100.165C144.223 100.548 144.271 101.067 144.271 101.612C144.269 108.345 144.269 115.081 144.273 121.815C144.273 122.222 144.254 122.615 143.999 122.957C143.832 123.01 143.627 123.016 143.5 123.12C139.609 126.268 135.726 129.429 131.841 132.583C128.16 135.569 124.478 138.55 120.797 141.536C116.91 144.689 113.021 147.841 109.136 150.998C105.043 154.321 100.943 157.632 96.874 160.983C94.1059 163.264 91.2152 165.394 88.5843 167.837C84.8384 167.867 81.0926 167.903 77.3489 167.924C75.2078 167.936 73.0647 167.951 70.9236 167.919C67.9696 167.877 66.4282 165.4 67.731 162.803C68.0477 162.172 68.4447 161.581 68.8036 160.971C68.8691 160.867 68.9345 160.764 69 160.66L68.9852 160.669C69.3315 160.723 69.5638 160.529 69.8129 160.324C73.3476 157.434 76.8802 154.541 80.4296 151.667C84.3908 148.462 88.3837 145.293 92.3385 142.077C96.9121 138.356 101.45 134.591 106.019 130.867C109.661 127.898 113.335 124.971 116.98 122.007C121.452 118.371 125.884 114.688 130.375 111.078C134.864 107.471 139.383 103.898 143.769 100.163L143.766 100.165Z',
  fill: '#FFFFFE'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M179.358 167.856C179.861 166.56 181.045 165.854 181.985 164.968C183.887 163.175 185.931 161.53 187.891 159.794C191.979 156.175 196.056 152.546 200.123 148.901C203.066 146.264 205.965 143.574 208.915 140.945C212.659 137.609 216.445 134.321 220.188 130.985C223.107 128.386 225.97 125.725 228.886 123.124C232.661 119.756 236.477 116.434 240.254 113.069C243.138 110.499 245.989 107.891 248.854 105.298C251.055 103.309 253.253 101.318 255.453 99.327C255.96 99.5762 256.27 100.03 256.511 100.495C258.825 104.944 261.116 109.405 263.413 113.863C260.873 116.012 258.335 118.162 255.795 120.309C252.78 122.858 249.769 125.411 246.745 127.951C243.043 131.059 239.325 134.148 235.626 137.258C232.537 139.857 229.473 142.484 226.384 145.083C222.684 148.196 218.97 151.289 215.264 154.393C212.612 156.614 209.952 158.825 207.317 161.065C204.682 163.306 202.072 165.576 199.451 167.833C193.596 167.858 187.739 167.886 181.884 167.907C181.041 167.909 180.199 167.873 179.358 167.856Z',
  fill: '#FFFFFE'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M199.453 167.833C202.074 165.576 204.684 163.306 207.319 161.065C209.954 158.825 212.614 156.614 215.266 154.393C218.972 151.289 222.686 148.196 226.386 145.083C229.475 142.484 232.539 139.857 235.628 137.258C239.327 134.148 243.046 131.059 246.747 127.951C249.771 125.41 252.782 122.858 255.797 120.309C258.337 118.162 260.877 116.012 263.415 113.863C265.689 118.278 267.961 122.693 270.238 127.104C270.539 127.691 270.865 128.267 271.179 128.848C269.769 129.41 268.88 130.615 267.792 131.578C264.04 134.902 260.267 138.204 256.523 141.538C253.673 144.076 250.864 146.665 248.016 149.207C244.078 152.725 240.125 156.226 236.17 159.725C234.112 161.547 231.971 163.282 229.992 165.187C229.137 166.011 227.87 166.515 227.568 167.854C218.197 167.845 208.826 167.837 199.455 167.831L199.453 167.833Z',
  fill: '#E3E3E7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M274.182 134.971C274.976 136.458 275.789 137.934 276.559 139.431C280.041 146.194 283.521 152.957 286.978 159.733C289.155 163.998 286.777 167.873 281.988 167.873C266.251 167.875 250.516 167.862 234.781 167.856C236.626 166.684 238.189 165.158 239.868 163.781C242.815 161.361 245.723 158.895 248.654 156.454C252.163 153.532 255.674 150.614 259.188 147.698C262.702 144.782 266.255 141.912 269.716 138.935C271.221 137.638 272.953 136.585 274.18 134.971H274.182Z',
  fill: '#E3E3E7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M143.766 100.165C139.381 103.9 134.864 107.473 130.373 111.08C125.88 114.688 121.448 118.373 116.978 122.009C113.333 124.973 109.659 127.9 106.017 130.869C101.448 134.593 96.9099 138.358 92.3363 142.079C88.3815 145.295 84.3886 148.462 80.4274 151.669C76.878 154.541 73.3454 157.436 69.8107 160.326C69.5616 160.531 69.3293 160.723 68.983 160.671C71.6541 154.727 74.8171 149.053 78.6094 143.753C86.1623 133.2 94.6527 123.462 104.604 115.096C113.15 107.912 123.044 103.191 133.684 99.9646C135.601 99.384 137.51 98.778 139.44 98.2437C141.33 97.7201 142.852 98.4296 143.769 100.167L143.766 100.165Z',
  fill: '#E3E3E7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M144.009 135.539C144.028 142.719 144.047 149.898 144.064 157.077C144.068 159.395 144.075 161.716 144.062 164.034C144.047 166.471 142.732 167.829 140.263 167.867C137.409 167.911 134.552 167.881 131.695 167.877C122.504 167.865 113.31 167.848 104.119 167.833C106.097 166.194 108.069 164.547 110.058 162.922C114.52 159.271 118.982 155.622 123.458 151.99C128.483 147.913 133.509 143.829 138.572 139.798C140.373 138.365 142.058 136.781 144.011 135.542L144.009 135.539Z',
  fill: '#E3E3E7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M274.182 134.971C272.953 136.582 271.224 137.638 269.718 138.935C266.257 141.912 262.704 144.781 259.19 147.697C255.677 150.613 252.163 153.532 248.656 156.454C245.725 158.895 242.818 161.363 239.87 163.781C238.191 165.158 236.629 166.684 234.783 167.856C232.378 167.856 229.973 167.856 227.568 167.856C227.87 166.517 229.137 166.013 229.992 165.189C231.971 163.285 234.112 161.549 236.171 159.727C240.125 156.228 244.078 152.727 248.016 149.209C250.865 146.667 253.671 144.078 256.523 141.54C260.267 138.206 264.04 134.906 267.793 131.58C268.88 130.617 269.769 129.412 271.179 128.85C272.18 130.89 273.183 132.932 274.184 134.971H274.182Z',
  fill: '#FFFFFE'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M88.5821 167.835C91.213 165.39 94.1037 163.259 96.8719 160.981C100.941 157.63 105.043 154.319 109.133 150.996C113.019 147.839 116.908 144.686 120.795 141.534C124.476 138.548 128.16 135.569 131.838 132.581C135.726 129.426 139.607 126.266 143.498 123.117C143.625 123.014 143.828 123.007 143.997 122.955C144.083 126.84 144.17 130.725 144.254 134.612C144.26 134.87 144.299 135.151 144.051 135.345C144.051 133.354 144.051 131.363 144.051 128.998C141.938 130.702 140.086 132.182 138.247 133.677C134.224 136.948 130.219 140.24 126.188 143.5C121.779 147.066 117.345 150.599 112.932 154.163C108.348 157.864 103.749 161.551 99.2241 165.322C98.3014 166.091 97.0492 166.587 96.61 167.871C93.9326 167.858 91.2574 167.848 88.58 167.835H88.5821Z',
  fill: '#E3E3E7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M300.434 240.161C298.188 240.256 295.941 240.351 293.692 240.446C293.699 225.19 293.705 209.934 293.713 194.679C293.713 193.433 294.336 192.809 295.58 192.808C296.874 192.808 298.169 192.831 299.463 192.799C300.141 192.785 300.47 193.017 300.411 193.724C300.382 194.079 300.407 194.438 300.407 194.795C300.415 209.917 300.424 225.038 300.432 240.161H300.434Z',
  fill: '#C13C3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M96.6101 167.871C97.0493 166.587 98.3015 166.091 99.2242 165.322C103.749 161.549 108.348 157.864 112.932 154.163C117.343 150.601 121.779 147.066 126.188 143.5C130.219 140.24 134.225 136.948 138.247 133.677C140.086 132.182 141.938 130.702 144.052 128.998C144.052 131.365 144.052 133.354 144.052 135.345C144.073 135.419 144.058 135.482 144.007 135.539C142.054 136.779 140.369 138.365 138.568 139.796C133.505 143.827 128.481 147.909 123.454 151.988C118.977 155.62 114.516 159.269 110.054 162.919C108.065 164.545 106.095 166.194 104.114 167.831C101.612 167.843 99.1102 167.856 96.608 167.869L96.6101 167.871Z',
  fill: '#FFFFFE'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M350.555 229.157C348.463 229.176 346.368 229.176 344.276 229.227C343.537 229.244 343.254 228.999 343.254 228.235C343.271 218.703 343.266 209.172 343.262 199.641C343.262 199.077 343.363 198.688 344.056 198.703C346.237 198.75 348.418 198.773 350.597 198.805C350.583 208.923 350.57 219.039 350.555 229.157Z',
  fill: '#C13C3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M355.046 201.309C357.884 201.302 359.928 202.795 361.59 204.89C365.648 210.008 365.448 218.708 361.153 223.627C359.55 225.462 357.595 226.704 355.038 226.693C355.173 218.233 355.156 209.77 355.046 201.309Z',
  fill: '#FED402'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M180.684 205.663C183.579 205.663 186.474 205.654 189.369 205.665C191.647 205.673 193.03 207.004 193.022 209.157C193.015 211.229 191.539 212.618 189.312 212.62C183.566 212.627 177.821 212.627 172.075 212.62C169.854 212.618 168.378 211.229 168.372 209.17C168.368 206.921 169.702 205.671 172.13 205.665C174.981 205.659 177.831 205.665 180.682 205.665L180.684 205.663Z',
  fill: '#C13C3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M355.046 201.309C355.156 209.77 355.173 218.233 355.038 226.693C354.221 228.744 352.618 229.369 350.555 229.16C350.57 219.041 350.583 208.923 350.597 198.807C352.631 198.665 354.233 199.286 355.046 201.311V201.309Z',
  fill: '#4E4E4E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M285.379 281.571C285.379 273.343 291.365 266.164 299.391 264.844C303.502 264.168 307.434 264.901 311.049 267.042C313.262 268.353 314.1 270.638 314.79 272.866C317.763 282.46 312.003 292.26 302.166 294.409C297.596 295.408 293.314 294.5 289.429 291.933C287.36 290.564 286.703 288.25 286.015 286.05C285.554 284.576 285.286 283.028 285.379 281.571Z',
  fill: '#818080'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M82.1144 281.724C81.7006 273.848 87.976 266.16 96.023 264.848C99.9103 264.215 103.629 264.844 107.117 266.696C109.756 268.098 110.763 270.668 111.515 273.286C114.361 283.18 107.854 293.052 97.6446 294.568C93.2104 295.227 89.2619 294.11 85.628 291.656C84.2682 290.738 83.8163 289.165 83.2251 287.752C82.3974 285.769 81.9096 283.689 82.1123 281.724H82.1144Z',
  fill: '#818080'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M142.516 320.66C143.6 314.514 136.001 308.037 125.543 306.193C115.085 304.349 105.729 307.837 104.646 313.982C103.562 320.128 111.161 326.605 121.619 328.449C132.076 330.293 141.433 326.806 142.516 320.66Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M182.437 328.449C192.895 326.605 200.494 320.128 199.411 313.983C198.327 307.837 188.971 304.349 178.513 306.193C168.055 308.037 160.456 314.514 161.54 320.66C162.624 326.806 171.98 330.293 182.437 328.449Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M58.4952 249.834C74.7522 300.925 129.349 329.167 180.445 312.91C204.105 305.386 222.862 289.634 234.568 269.82C235.538 268.177 236.462 266.506 237.333 264.81C238.056 263.407 238.742 261.989 239.391 260.554C240.286 258.602 241.106 256.617 241.86 254.611C249.308 234.887 250.408 212.612 243.521 190.959C240.95 182.881 237.424 175.374 233.092 168.525C232.345 167.33 231.566 166.15 230.761 164.994C230.248 164.251 229.721 163.519 229.189 162.793C227.502 160.509 225.731 158.312 223.872 156.202C199.18 128.213 159.413 115.837 121.572 127.878C70.4741 144.139 42.2338 198.732 58.4908 249.832L58.4952 249.834Z',
  fill: '#F3C823'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.298 303.827C198.455 304.914 196.574 305.942 194.653 306.899C193.248 307.609 191.826 308.282 190.384 308.919C188.644 309.693 186.875 310.412 185.091 311.08C163.566 319.153 139.108 319.65 115.999 310.672C66.0879 291.292 41.3584 235.107 60.7622 185.181C63.3026 178.645 66.4716 172.543 70.1764 166.913C62.2971 211.556 86.709 256.99 130.562 274.017C153.673 282.994 178.131 282.498 199.654 274.425C201.438 273.754 203.207 273.035 204.947 272.263C206.389 271.626 207.812 270.954 209.216 270.243C211.137 269.286 213.018 268.257 214.862 267.172C227.41 259.797 238.367 249.572 246.652 236.978C245.57 243.148 243.863 249.3 241.51 255.36C233.284 276.515 218.461 293.151 200.301 303.825L200.298 303.827Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M175.074 266.005C175.074 266.005 175.069 266.001 175.069 265.996H175.048L175.074 266.005Z',
  fill: '#8A5024'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M151.009 240.4C172.384 240.4 189.711 223.073 189.711 201.698C189.711 180.324 172.384 162.996 151.009 162.996C129.635 162.996 112.307 180.324 112.307 201.698C112.307 223.073 129.635 240.4 151.009 240.4Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M151.009 237.092C172.384 237.092 189.711 219.765 189.711 198.39C189.711 177.016 172.384 159.688 151.009 159.688C129.635 159.688 112.307 177.016 112.307 198.39C112.307 219.765 129.635 237.092 151.009 237.092Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M151.009 217.907C161.788 217.907 170.525 209.169 170.525 198.39C170.525 187.612 161.788 178.874 151.009 178.874C140.231 178.874 131.493 187.612 131.493 198.39C131.493 209.169 140.231 217.907 151.009 217.907Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M165.343 193.649C168.692 193.649 171.408 190.934 171.408 187.585C171.408 184.235 168.692 181.52 165.343 181.52C161.994 181.52 159.279 184.235 159.279 187.585C159.279 190.934 161.994 193.649 165.343 193.649Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M150.326 346.359C193.927 346.359 229.273 340.323 229.273 332.876C229.273 325.43 193.927 319.394 150.326 319.394C106.724 319.394 71.3783 325.43 71.3783 332.876C71.3783 340.323 106.724 346.359 150.326 346.359Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M279.948 256.077C285.06 252.497 284.267 242.544 278.176 233.846C272.085 225.147 263.004 220.997 257.892 224.577C252.78 228.156 253.573 238.109 259.664 246.808C265.755 255.507 274.836 259.656 279.948 256.077Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M47.7147 246.809C53.8055 238.111 54.599 228.157 49.487 224.578C44.375 220.999 35.2933 225.148 29.2025 233.847C23.1117 242.546 22.3182 252.499 27.4302 256.078C32.5422 259.658 41.6239 255.508 47.7147 246.809Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M166.137 258.501C167.286 260.801 166.605 263.82 164.975 265.771C163.938 267.033 162.556 268.018 161.019 268.576C157.722 269.824 153.808 269.121 151.066 267.028C149.104 265.553 147.593 263.074 147.812 260.576C147.909 259.561 149.296 259.378 149.668 260.309C151.263 263.687 155.51 265.246 158.979 264.448C161.704 263.775 163.852 261.921 164.3 258.875C164.368 257.89 165.698 257.623 166.137 258.501Z',
  fill: '#EDBD21'
})));

const CelebrateBobbin = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '200',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("g", {
  clipPath: 'url(#clip0_1378_2)'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M170.169 239L165.169 230L178.169 221L183.169 230L170.169 239Z',
  fill: '#66FF99'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M-4.8313 128L5.1687 137L-4.8313 144V128Z',
  fill: '#66D6FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M156.169 147L137.169 146L150.169 130L156.169 147Z',
  fill: '#667DFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M389.169 279V265H405.169V279H389.169Z',
  fill: '#7066FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M256.169 42L266.169 30L278.169 41L268.169 52L256.169 42Z',
  fill: '#6EFF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M33.4304 36.0069C29.0182 35.7756 25.3242 37.8237 25.1797 40.5813C25.0351 43.339 28.4948 45.7619 32.907 45.9932C37.3192 46.2244 41.0132 44.1764 41.1577 41.4187C41.3023 38.6611 37.8426 36.2381 33.4304 36.0069Z',
  fill: '#6691FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M90.1687 238L66.1687 250',
  stroke: '#66FF9C',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M97.6687 127C91.6687 127.667 90.3354 130.333 93.6687 135C97.002 140.333 95.6687 143.333 89.6687 144C83.6687 144.667 82.3354 147.333 85.6687 152C89.6687 156.667 88.6687 159.667 82.6687 161',
  stroke: '#66FF73',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M302.169 194L291.169 200L285.169 188L297.169 183L302.169 194Z',
  fill: '#FF8766'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M5.66871 179.5C2.33538 184.167 3.66871 186.167 9.66871 185.5C15.002 184.167 16.3354 186.167 13.6687 191.5C9.66871 196.167 10.6687 197.833 16.6687 196.5C22.6687 195.833 24.002 197.833 20.6687 202.5',
  stroke: '#FF666E',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M235.169 257L281.169 269',
  stroke: '#BA66FF',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M-15.8313 278L18.1687 274',
  stroke: '#66FFBA',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M361.264 23.7945L358.457 22.3375L357.939 19.218L355.494 21.8682L352.531 21.3989L354.193 23.6872L351.749 26.3373L354.868 25.819L357.362 29.2513L357.988 25.3006L361.264 23.7945Z',
  fill: '#66BFFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M134.169 20L123.169 30L115.169 21L126.169 11L134.169 20Z',
  fill: '#FF66C9'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M380.169 181L350.169 187',
  stroke: '#6673FF',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M302.606 69.1367L301.505 74.408L295.769 76.4347L300.403 79.6794L299.475 85.9355L304.863 81.9392L310.482 85.0102L308.455 79.275L312.685 74.4675L306.602 74.5246L302.606 69.1367Z',
  fill: '#666EFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M167.975 86.7232C169.479 89.0392 172.576 89.6974 174.892 88.1934C177.208 86.6894 177.866 83.5928 176.362 81.2768C174.858 78.9609 171.761 78.3027 169.446 79.8067C167.13 81.3107 166.471 84.4073 167.975 86.7232Z',
  fill: '#E6FF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M265.023 110.706C270.801 108.829 274.654 104.752 273.63 101.601C272.606 98.4493 267.092 97.4164 261.315 99.2937C255.537 101.171 251.683 105.248 252.707 108.399C253.731 111.551 259.245 112.584 265.023 110.706Z',
  fill: '#6666FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M343.669 109.5C340.335 114.167 341.669 116.167 347.669 115.5C353.002 114.167 354.335 116.167 351.669 121.5C347.669 126.167 348.669 127.833 354.669 126.5C360.669 125.833 362.002 127.833 358.669 132.5',
  stroke: '#FFA866',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M261.169 160L243.169 165L254.169 146L261.169 160Z',
  fill: '#66C7FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M197.169 168L163.169 160',
  stroke: '#FF66BF',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M162.321 269.65L154.737 268.96L150.672 262.92L148.722 269.863L141.755 271.075L147.413 275.545L146.723 283.13L152.763 279.064L159.063 282.274L157.851 275.308L162.321 269.65Z',
  fill: '#CCFF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M69.1687 84C65.1687 79.3333 61.502 80 58.1687 86C55.502 91.3333 52.1687 91.6667 48.1687 87C44.1687 82.3333 40.502 83 37.1687 89C34.502 94.3333 31.1687 94.6667 27.1687 90',
  stroke: '#66CFFF',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M107.169 74L113.169 92',
  stroke: '#6694FF',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M369.169 91L355.169 119',
  stroke: '#66FFD1',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M354.669 274C356.002 267.333 353.335 264.333 346.669 265C340.002 265.667 337.335 262.667 338.669 256C340.002 249.333 337.335 246.333 330.669 247C324.002 247 321.669 244 323.669 238',
  stroke: '#FF66F2',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M347.016 252.395L347.216 247.927L350.87 246.3L346.503 243.866L345.789 239.805L342.948 243.259L338.074 242.146L341.021 246.307L338.587 250.674L343.562 249.554L347.016 252.395Z',
  fill: '#FFBF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M180.169 28L172.169 34L162.169 22L170.169 16L180.169 28Z',
  fill: '#BDFF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M142.169 184L149.169 168L160.169 183L142.169 184Z',
  fill: '#FF66ED'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M400.883 -5.57514L402.939 -3.17286L400.879 0.255808L404.996 -0.77058L407.052 1.6317L406.883 -1.96988L410.142 -3.5113L407.056 -4.19925L406.887 -7.80083L404.484 -5.74436L400.883 -5.57514Z',
  fill: '#6682FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M296.169 116L292.169 148',
  stroke: '#66A1FF',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M90.1687 252L81.1687 244L92.1687 231L102.169 240L90.1687 252Z',
  fill: '#8A66FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M293.214 176.061C291.266 173.38 287.876 172.523 285.642 174.146C283.408 175.769 283.176 179.258 285.124 181.939C287.071 184.62 290.461 185.477 292.695 183.854C294.929 182.231 295.162 178.742 293.214 176.061Z',
  fill: '#66FCFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M195.169 9L187.169 22L175.169 14L184.169 1L195.169 9Z',
  fill: '#666BFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M296.169 1L322.169 -17',
  stroke: '#8FFF66',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M9.1687 77V97H-10.8313V77H9.1687Z',
  fill: '#ED66FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M194.169 -2L214.169 6',
  stroke: '#66EBFF',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M29.1687 255.5C31.1687 250.167 29.502 248.167 24.1687 249.5C18.1687 250.833 16.1687 248.5 18.1687 242.5C20.1687 237.167 18.502 235.167 13.1687 236.5C7.1687 237.833 5.1687 235.833 7.1687 230.5',
  stroke: '#66FFBA',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M201 385C256.228 385 301 377.165 301 367.5C301 357.835 256.228 350 201 350C145.772 350 101 357.835 101 367.5C101 377.165 145.772 385 201 385Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M62.8693 226.305C87.1434 302.327 168.665 344.351 244.957 320.161C280.285 308.965 308.293 285.527 325.771 256.044C327.22 253.599 328.599 251.112 329.9 248.589C330.98 246.502 332.004 244.392 332.972 242.256C334.309 239.352 335.534 236.398 336.66 233.412C347.78 204.064 349.423 170.919 339.14 138.7C335.3 126.68 330.035 115.511 323.568 105.319C322.452 103.54 321.29 101.785 320.088 100.065C319.321 98.9595 318.534 97.8701 317.74 96.7905C315.221 93.391 312.577 90.1228 309.801 86.9826C272.933 45.3358 213.555 26.9209 157.051 44.8371C80.7555 69.0337 38.5887 150.267 62.8627 226.302L62.8693 226.305Z',
  fill: '#0A2041'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M274.652 306.973C271.894 308.592 269.079 310.123 266.206 311.549C264.104 312.607 261.976 313.609 259.819 314.558C257.216 315.712 254.57 316.783 251.901 317.778C219.697 329.806 183.106 330.545 148.535 317.17C73.8647 288.299 36.8678 204.595 65.8972 130.216C69.6978 120.478 74.4387 111.387 79.9813 103C68.1934 169.508 104.715 237.196 170.322 262.562C204.897 275.936 241.488 275.197 273.688 263.169C276.357 262.171 279.003 261.1 281.606 259.95C283.764 259 285.892 257.998 287.993 256.94C290.867 255.515 293.681 253.98 296.439 252.364C315.212 241.378 331.605 226.144 344 207.381C342.38 216.574 339.827 225.74 336.306 234.768C324 266.284 301.824 291.068 274.655 306.969L274.652 306.973Z',
  fill: '#08182E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M201 213C232.48 213 258 187.033 258 155C258 122.967 232.48 97 201 97C169.52 97 144 122.967 144 155C144 187.033 169.52 213 201 213Z',
  fill: '#08182E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M201 207C232.48 207 258 181.48 258 150C258 118.52 232.48 93 201 93C169.52 93 144 118.52 144 150C144 181.48 169.52 207 201 207Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M201 179C217.016 179 230 166.016 230 150C230 133.984 217.016 121 201 121C184.984 121 172 133.984 172 150C172 166.016 184.984 179 201 179Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M222 143C226.971 143 231 138.747 231 133.5C231 128.253 226.971 124 222 124C217.029 124 213 128.253 213 133.5C213 138.747 217.029 143 222 143Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M188.29 332.099C189.905 322.941 178.582 313.29 162.999 310.542C147.417 307.795 133.476 312.991 131.861 322.149C130.246 331.306 141.569 340.957 157.152 343.705C172.734 346.452 186.675 341.256 188.29 332.099Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M244.488 366.704C260.071 363.957 271.394 354.306 269.779 345.148C268.164 335.991 254.223 330.795 238.641 333.542C223.059 336.29 211.735 345.941 213.35 355.098C214.965 364.256 228.906 369.452 244.488 366.704Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M382.485 114.116C387.03 98.9598 383.495 84.508 374.588 81.8368C365.681 79.1655 354.776 89.2862 350.23 104.442C345.685 119.598 349.22 134.05 358.127 136.721C367.034 139.392 377.939 129.272 382.485 114.116Z',
  fill: '#051427'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M46.831 133.979C54.8933 129.345 55.0381 114.468 47.1544 100.749C39.2706 87.0303 26.3437 79.6648 18.2814 84.298C10.219 88.9311 10.0742 103.808 17.958 117.527C25.8418 131.246 38.7686 138.612 46.831 133.979Z',
  fill: '#051427'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M230.01 226.561C230.565 226.561 231.012 227.024 230.993 227.579C230.454 244.255 216.765 257.612 199.957 257.612C183.15 257.612 169.461 244.258 168.922 227.579C168.905 227.024 169.349 226.561 169.904 226.561H230.01Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M229.678 235.748C225.817 248.497 213.972 257.777 199.96 257.777C198.886 257.777 197.821 257.721 196.776 257.616C196.77 252.7 198.495 247.344 201.985 242.629C209.22 232.85 221.299 229.518 228.965 235.186C229.212 235.367 229.448 235.557 229.678 235.748Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M230.993 227.665C230.851 231.266 230.02 234.713 228.61 237.897H174.344C173.157 237.897 172.195 237.043 172.195 235.988V226.561H229.796C230.473 226.561 231.016 227.063 230.993 227.665Z',
  fill: 'white'
})), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
  id: 'clip0_1378_2'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'white'
})))));

const CelebrateBobbinDark = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '200',
  viewBox: '0 0 200 200',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("g", {
  clipPath: 'url(#clip0_9182_35018)'
}, /*#__PURE__*/React__default.createElement("path", {
  d: 'M85.0845 119.5L82.5845 115L89.0845 110.5L91.5845 115L85.0845 119.5Z',
  fill: '#66FF99'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M-2.41553 64L2.58447 68.5L-2.41553 72V64Z',
  fill: '#66D6FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M202.084 -9L213.084 1',
  stroke: '#FFBA66',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M78.0845 73.5L68.5845 73L75.0845 65L78.0845 73.5Z',
  fill: '#667DFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M194.584 139.5V132.5H202.584V139.5H194.584Z',
  fill: '#7066FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M128.084 21L133.084 15L139.084 20.5L134.084 26L128.084 21Z',
  fill: '#6EFF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M16.7154 18.0045C14.5093 17.8889 12.6623 18.913 12.59 20.2918C12.5178 21.6706 14.2476 22.8821 16.4537 22.9977C18.6598 23.1133 20.5068 22.0893 20.5791 20.7105C20.6513 19.3316 18.9215 18.1202 16.7154 18.0045Z',
  fill: '#6691FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M45.0845 119L33.0845 125',
  stroke: '#66FF9C',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M48.8345 63.5C45.8345 63.8333 45.1678 65.1667 46.8345 67.5C48.5011 70.1667 47.8345 71.6667 44.8345 72C41.8345 72.3333 41.1678 73.6667 42.8345 76C44.8345 78.3333 44.3345 79.8333 41.3345 80.5',
  stroke: '#66FF73',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M151.084 97L145.584 100L142.584 94L148.584 91.5L151.084 97Z',
  fill: '#FF8766'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M2.83426 89.75C1.1676 92.0833 1.83426 93.0833 4.83426 92.75C7.50093 92.0833 8.1676 93.0833 6.83426 95.75C4.83426 98.0833 5.33426 98.9167 8.33426 98.25C11.3343 97.9167 12.0009 98.9167 10.3343 101.25',
  stroke: '#FF666E',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M117.584 128.5L140.584 134.5',
  stroke: '#BA66FF',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M-7.91553 139L9.08447 137',
  stroke: '#66FFBA',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M180.632 11.8973L179.229 11.1688L178.969 9.60901L177.747 10.9341L176.266 10.6995L177.097 11.8436L175.874 13.1687L177.434 12.9095L178.681 14.6257L178.994 12.6503L180.632 11.8973Z',
  fill: '#66BFFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M67.0845 10L61.5845 15L57.5845 10.5L63.0845 5.5L67.0845 10Z',
  fill: '#FF66C9'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M190.084 90.5L175.084 93.5',
  stroke: '#6673FF',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M151.303 34.5671L150.752 37.2028L147.885 38.2161L150.202 39.8385L149.738 42.9665L152.432 40.9684L155.241 42.5039L154.228 39.6363L156.342 37.2325L153.301 37.2611L151.303 34.5671Z',
  fill: '#666EFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M83.9876 43.3628C84.7396 44.5208 86.2879 44.8499 87.4459 44.0979C88.6038 43.3459 88.9329 41.7976 88.1809 40.6396C87.4289 39.4817 85.8806 39.1526 84.7227 39.9046C83.5647 40.6566 83.2356 42.2049 83.9876 43.3628Z',
  fill: '#E6FF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M132.511 55.3544C135.4 54.4157 137.327 52.3774 136.815 50.8016C136.303 49.2259 133.546 48.7094 130.657 49.6481C127.768 50.5867 125.841 52.6251 126.353 54.2008C126.865 55.7766 129.622 56.2931 132.511 55.3544Z',
  fill: '#6666FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M171.834 54.75C170.168 57.0833 170.834 58.0833 173.834 57.75C176.501 57.0833 177.168 58.0833 175.834 60.75C173.834 63.0833 174.334 63.9167 177.334 63.25C180.334 62.9167 181.001 63.9167 179.334 66.25',
  stroke: '#FFA866',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M130.584 80L121.584 82.5L127.084 73L130.584 80Z',
  fill: '#66C7FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M98.5845 84L81.5845 80',
  stroke: '#FF66BF',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M81.1608 134.826L77.3686 134.481L75.336 131.461L74.3609 134.932L70.8777 135.538L73.7069 137.773L73.3618 141.565L76.3815 139.533L79.5317 141.138L78.9257 137.655L81.1608 134.826Z',
  fill: '#CCFF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M34.5845 42C32.5845 39.6667 30.7511 40 29.0845 43C27.7511 45.6667 26.0845 45.8333 24.0845 43.5C22.0845 41.1667 20.2511 41.5 18.5845 44.5C17.2511 47.1667 15.5845 47.3333 13.5845 45',
  stroke: '#66CFFF',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M53.5845 37L56.5845 46',
  stroke: '#6694FF',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M184.584 45.5L177.584 59.5',
  stroke: '#66FFD1',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M177.334 137C178.001 133.667 176.668 132.167 173.334 132.5C170.001 132.833 168.668 131.333 169.334 128C170.001 124.667 168.668 123.167 165.334 123.5C162.001 123.5 160.834 122 161.834 119',
  stroke: '#FF66F2',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M173.508 126.197L173.608 123.963L175.435 123.149L173.251 121.932L172.895 119.902L171.474 121.629L169.037 121.072L170.511 123.153L169.294 125.336L171.781 124.776L173.508 126.197Z',
  fill: '#FFBF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M90.0845 14L86.0845 17L81.0845 11L85.0845 8L90.0845 14Z',
  fill: '#BDFF66'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M71.0845 92L74.5845 84L80.0845 91.5L71.0845 92Z',
  fill: '#FF66ED'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.441 -2.78745L201.47 -1.58631L200.44 0.128026L202.498 -0.385168L203.526 0.815973L203.441 -0.984816L205.071 -1.75553L203.528 -2.0995L203.443 -3.90029L202.242 -2.87206L200.441 -2.78745Z',
  fill: '#6682FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M148.084 58L146.084 74',
  stroke: '#66A1FF',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M45.0845 126L40.5845 122L46.0845 115.5L51.0845 120L45.0845 126Z',
  fill: '#8A66FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M146.607 88.0325C145.633 86.692 143.938 86.2633 142.821 87.0749C141.704 87.8864 141.588 89.631 142.562 90.9714C143.536 92.3118 145.231 92.7405 146.348 91.929C147.465 91.1174 147.581 89.3729 146.607 88.0325Z',
  fill: '#66FCFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M97.5845 4.5L93.5845 11L87.5845 7L92.0845 0.5L97.5845 4.5Z',
  fill: '#666BFF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M148.084 0.5L161.084 -8.5',
  stroke: '#8FFF66',
  strokeWidth: '3',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M4.58447 38.5V48.5H-5.41553V38.5H4.58447Z',
  fill: '#ED66FF'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M97.0845 -1L107.084 3',
  stroke: '#66EBFF',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M14.5845 127.75C15.5845 125.083 14.7511 124.083 12.0845 124.75C9.08447 125.417 8.08447 124.25 9.08447 121.25C10.0845 118.583 9.25114 117.583 6.58447 118.25C3.58447 118.917 2.58447 117.917 3.58447 115.25',
  stroke: '#66FFBA',
  strokeWidth: '4',
  strokeLinecap: 'round'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M100.5 192.5C128.114 192.5 150.5 188.582 150.5 183.75C150.5 178.918 128.114 175 100.5 175C72.8858 175 50.5 178.918 50.5 183.75C50.5 188.582 72.8858 192.5 100.5 192.5Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M31.4347 113.153C43.5717 151.164 84.3324 172.176 122.479 160.081C140.143 154.483 154.147 142.763 162.885 128.022C163.61 126.8 164.3 125.556 164.95 124.294C165.49 123.251 166.002 122.196 166.486 121.128C167.155 119.676 167.767 118.199 168.33 116.706C173.89 102.032 174.711 85.4596 169.57 69.3499C167.65 63.3401 165.018 57.7553 161.784 52.6594C161.226 51.7701 160.645 50.8924 160.044 50.0326C159.66 49.4797 159.267 48.935 158.87 48.3953C157.611 46.6955 156.289 45.0614 154.901 43.4913C136.466 22.6679 106.777 13.4605 78.5257 22.4185C40.3777 34.5168 19.2944 75.1333 31.4314 113.151L31.4347 113.153Z',
  fill: '#18B1AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M137.326 153.486C135.947 154.296 134.54 155.062 133.103 155.775C132.052 156.303 130.988 156.804 129.909 157.279C128.608 157.856 127.285 158.391 125.95 158.889C109.849 164.903 91.5532 165.272 74.2673 158.585C36.9323 144.149 18.4339 102.298 32.9486 65.1078C34.8489 60.239 37.2194 55.6937 39.9906 51.5C34.0967 84.7541 52.3576 118.598 85.1611 131.281C102.449 137.968 120.744 137.598 136.844 131.585C138.179 131.085 139.502 130.55 140.803 129.975C141.882 129.5 142.946 128.999 143.997 128.47C145.434 127.757 146.841 126.99 148.22 126.182C157.606 120.689 165.803 113.072 172 103.691C171.19 108.287 169.913 112.87 168.153 117.384C162 133.142 150.912 145.534 137.327 153.485L137.326 153.486Z',
  fill: '#1DA29D'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M100.5 106.5C116.24 106.5 129 93.5163 129 77.5C129 61.4837 116.24 48.5 100.5 48.5C84.7599 48.5 72 61.4837 72 77.5C72 93.5163 84.7599 106.5 100.5 106.5Z',
  fill: '#1DA29D'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M100.5 103.5C116.24 103.5 129 90.7401 129 75C129 59.2599 116.24 46.5 100.5 46.5C84.7599 46.5 72 59.2599 72 75C72 90.7401 84.7599 103.5 100.5 103.5Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M100.5 89.5C108.508 89.5 115 83.0081 115 75C115 66.9919 108.508 60.5 100.5 60.5C92.4919 60.5 86 66.9919 86 75C86 83.0081 92.4919 89.5 100.5 89.5Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M111 71.5C113.485 71.5 115.5 69.3734 115.5 66.75C115.5 64.1266 113.485 62 111 62C108.515 62 106.5 64.1266 106.5 66.75C106.5 69.3734 108.515 71.5 111 71.5Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M94.1451 166.048C94.9525 161.469 89.291 156.643 81.4997 155.27C73.7085 153.896 66.738 156.494 65.9306 161.073C65.1232 165.651 70.7848 170.477 78.576 171.851C86.3673 173.225 93.3378 170.626 94.1451 166.048Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M122.244 183.351C130.036 181.978 135.697 177.152 134.89 172.573C134.082 167.995 127.112 165.397 119.321 166.77C111.529 168.144 105.868 172.97 106.675 177.548C107.483 182.127 114.453 184.725 122.244 183.351Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191.242 57.0571C193.515 49.4792 191.747 42.2533 187.294 40.9176C182.841 39.582 177.388 44.6424 175.115 52.2203C172.842 59.7983 174.61 67.0242 179.064 68.3598C183.517 69.6954 188.97 64.6351 191.242 57.0571Z',
  fill: '#1DA29D'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M23.4157 66.9895C27.4469 64.6729 27.5193 57.2343 23.5774 50.3748C19.6355 43.5154 13.1721 39.8326 9.14089 42.1492C5.10971 44.4658 5.03733 51.9044 8.97921 58.7639C12.9211 65.6233 19.3845 69.3061 23.4157 66.9895Z',
  fill: '#1DA29D'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M115.005 113.281C115.282 113.281 115.506 113.513 115.496 113.791C115.227 122.129 108.382 128.807 99.9783 128.807C91.5746 128.807 84.7301 122.13 84.4607 113.791C84.4525 113.513 84.6743 113.281 84.9519 113.281H115.005Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M114.839 117.873C112.909 124.248 106.986 128.888 99.9802 128.888C99.443 128.888 98.9107 128.86 98.3882 128.807C98.3849 126.349 99.2475 123.671 100.992 121.314C104.61 116.424 110.65 114.758 114.483 117.592C114.606 117.683 114.724 117.778 114.839 117.873Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M115.496 113.833C115.425 115.634 115.01 117.357 114.305 118.949H87.1717C86.5786 118.949 86.0972 118.522 86.0972 117.995V113.281H114.898C115.237 113.281 115.508 113.533 115.496 113.833Z',
  fill: 'white'
})), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
  id: 'clip0_9182_35018'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '200',
  height: '200',
  fill: 'white'
})))));

const Clive = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '215',
  height: '215',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M194 378C287.336 378 363 365.016 363 349C363 332.984 287.336 320 194 320C100.664 320 25 332.984 25 349C25 365.016 100.664 378 194 378Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M331.099 215.86C323.371 164.581 258.308 124.549 179.191 124.549C94.8736 124.549 26.5195 170.017 26.5195 226.112C26.5195 264.677 58.8325 298.23 106.443 315.409C110.763 316.981 115.205 318.409 119.772 319.687H119.79C123.208 320.655 126.685 321.539 130.234 322.34C145.615 325.79 162.086 327.672 179.221 327.672C192.401 327.672 205.18 326.564 217.377 324.476C283.219 313.19 331.869 273.433 331.869 226.112C331.869 222.653 331.612 219.229 331.099 215.863V215.86ZM216.036 275.306C215.005 275.566 213.963 275.813 212.911 276.049C212.792 276.076 212.672 276.103 212.55 276.127C211.552 276.351 210.546 276.563 209.53 276.769C209.345 276.805 209.156 276.841 208.974 276.877C208.012 277.065 207.041 277.25 206.065 277.421C205.781 277.471 205.491 277.513 205.204 277.561C204.314 277.71 203.424 277.86 202.525 277.994C201.33 278.173 200.126 278.341 198.913 278.493C198.116 278.598 197.312 278.69 196.514 278.774C194.904 278.953 193.276 279.102 191.639 279.234C190.824 279.291 190.002 279.356 189.169 279.404C187.523 279.509 185.859 279.583 184.177 279.64C182.504 279.688 180.813 279.715 179.114 279.715C177.202 279.715 175.299 279.676 173.414 279.61C172.805 279.592 172.192 279.562 171.583 279.536C170.095 279.47 168.626 279.386 167.165 279.273C166.484 279.216 165.803 279.159 165.122 279.102C164.36 279.037 163.598 278.962 162.839 278.887C159.804 278.577 156.82 278.182 153.898 277.701C137.083 274.956 122.231 269.54 110.787 262.308L110.778 262.299C108.988 258.718 108.044 254.936 108.044 251.034C108.044 228.445 139.897 210.127 179.185 210.127C218.474 210.127 250.345 228.445 250.345 251.034C250.345 254.918 249.407 258.67 247.635 262.233C238.936 267.766 228.233 272.232 216.191 275.267C216.138 275.279 216.087 275.294 216.033 275.306H216.036Z',
  fill: '#F492BB'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.42',
  d: 'M331.896 226.112C331.896 282.206 263.542 327.675 179.221 327.675C94.9004 327.675 26.5434 282.206 26.5434 226.112C26.5434 222.623 26.8093 219.172 27.3231 215.767C35.1198 266.998 100.146 306.985 179.221 306.985C258.297 306.985 323.32 267.001 331.119 215.767C331.633 219.172 331.899 222.623 331.899 226.112H331.896Z',
  fill: '#CF73A8'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.64',
  d: 'M179.194 138.654C110.088 138.654 54.0709 170.863 54.0709 210.593C54.0709 250.323 110.088 282.532 179.194 282.532C248.301 282.532 304.318 250.323 304.318 210.593C304.318 170.863 248.301 138.654 179.194 138.654ZM196.514 278.774C194.904 278.953 193.276 279.103 191.639 279.234C190.824 279.291 190.002 279.356 189.169 279.404C187.523 279.509 185.859 279.583 184.177 279.64C182.504 279.688 180.813 279.715 179.114 279.715C177.202 279.715 175.299 279.676 173.414 279.61C172.805 279.592 172.192 279.563 171.583 279.536C170.095 279.47 168.626 279.386 167.165 279.273C166.484 279.216 165.803 279.159 165.122 279.103C164.36 279.037 163.598 278.962 162.839 278.887C159.804 278.577 156.82 278.182 153.898 277.702C137.083 274.956 122.231 269.54 110.787 262.308L110.778 262.299C108.988 258.718 108.044 254.936 108.044 251.034C108.044 228.445 139.897 210.127 179.185 210.127C218.474 210.127 250.345 228.445 250.345 251.034C250.345 254.918 249.407 258.67 247.635 262.234C238.936 267.766 228.233 272.232 216.191 275.267C216.138 275.279 216.087 275.294 216.033 275.306C215.002 275.566 213.96 275.814 212.908 276.05C212.789 276.076 212.669 276.103 212.547 276.127C211.549 276.351 210.543 276.563 209.527 276.77C209.342 276.805 209.153 276.841 208.971 276.877C208.009 277.065 207.038 277.25 206.062 277.421C205.778 277.471 205.488 277.513 205.201 277.561C204.311 277.71 203.421 277.86 202.522 277.994C201.327 278.173 200.123 278.341 198.91 278.493C198.113 278.598 197.309 278.69 196.511 278.774H196.514Z',
  fill: '#F6ABCB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191.639 279.234C193.276 279.103 194.904 278.953 196.514 278.774C194.904 278.962 193.276 279.111 191.639 279.234Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M208.974 276.874C208.009 277.062 207.044 277.247 206.065 277.418C207.041 277.247 208.009 277.062 208.974 276.874Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M206.065 277.418C205.781 277.469 205.491 277.51 205.204 277.558C205.491 277.51 205.781 277.466 206.065 277.418Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M205.204 277.558C204.314 277.707 203.427 277.857 202.525 277.991C203.424 277.857 204.314 277.707 205.204 277.558Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M216.036 275.306C215.005 275.563 213.963 275.813 212.911 276.049C213.963 275.813 215.002 275.566 216.036 275.306Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M216.194 275.264C228.236 272.229 238.939 267.763 247.638 262.23C249.409 258.667 250.348 254.915 250.348 251.031C250.348 228.442 218.486 210.124 179.188 210.124C139.891 210.124 108.047 228.442 108.047 251.031C108.047 254.933 108.994 258.715 110.781 262.296C95.8773 252.854 86.7871 240.328 86.7871 226.581C86.7871 197.24 128.163 173.45 179.197 173.45C230.231 173.45 271.608 197.24 271.608 226.581C271.608 248.352 248.812 267.067 216.197 275.264H216.194Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M212.553 276.127C211.552 276.348 210.548 276.566 209.533 276.769C210.548 276.566 211.555 276.351 212.553 276.127Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M209.53 276.766C209.345 276.802 209.156 276.838 208.974 276.874C209.159 276.838 209.348 276.805 209.53 276.766Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M212.911 276.05C212.792 276.076 212.672 276.103 212.55 276.127C212.669 276.1 212.792 276.076 212.911 276.05Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M110.787 262.305C122.231 269.537 137.083 274.953 153.898 277.698C137.107 274.971 122.258 269.582 110.813 262.371C110.804 262.353 110.796 262.323 110.787 262.305Z',
  fill: '#F173A6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M153.898 277.701C156.82 278.182 159.801 278.577 162.839 278.887C159.804 278.586 156.82 278.182 153.898 277.701Z',
  fill: '#F173A6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M250.342 251.031C250.342 254.915 249.404 258.667 247.641 262.231C230.736 272.97 206.301 279.712 179.12 279.712C151.939 279.712 127.724 273.026 110.819 262.371C109.015 258.768 108.05 254.96 108.05 251.028C108.05 228.439 139.903 210.121 179.194 210.121C218.486 210.121 250.344 228.439 250.344 251.028L250.342 251.031Z',
  fill: '#F173A6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M319.852 157.782C327.729 169.79 334.411 182.609 335.439 191.316C342.519 251.5 309.904 279.628 296.494 290.998C283.751 301.802 270.544 308.076 261.977 311.687C258.261 308.171 250.817 298.269 246.93 285.358C246.01 282.293 240.364 262.535 249.586 244.922C256.94 230.882 265.693 233.571 276.139 218.593C277.929 216.027 289.346 199.203 287.646 180.037C286.628 168.592 281.257 159.846 275.354 152.784C272.071 151.007 268.77 148.748 265.565 145.88C262.831 143.437 246.649 128.955 246.933 109.036C247.304 82.4524 276.832 58.7247 305.349 58.7247C337.611 58.7247 363.764 81.2455 363.764 109.036C363.764 132.507 345.097 152.228 319.855 157.785L319.852 157.782Z',
  fill: '#F59CBC'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M338.534 147.12C352.465 147.12 363.758 135.121 363.758 120.319C363.758 105.517 352.465 93.5172 338.534 93.5172C324.603 93.5172 313.31 105.517 313.31 120.319C313.31 135.121 324.603 147.12 338.534 147.12Z',
  fill: '#FFD865'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M375.31 155.583C370.805 166.642 361.458 172.18 357.025 174.391C356.989 166.558 356.123 157.334 352.601 150.487C351.122 147.589 349.156 145.116 346.581 143.359C342.68 140.698 340.093 144.031 336.323 144.3C331.98 144.608 322.845 138.433 322.25 137.182C320.282 133.083 319.272 128.363 319.553 123.39C320.315 109.81 330.839 98.8255 343.633 98.246C347.6 98.0668 351.382 98.8644 354.778 100.43C370.33 104.089 383.952 134.398 375.313 155.583H375.31Z',
  fill: '#FBCD0B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M343.791 141.863C344.729 142.245 345.661 142.732 346.581 143.356C349.156 145.116 351.122 147.589 352.601 150.484C356.123 157.331 356.992 166.555 357.025 174.388C361.458 172.177 370.805 166.639 375.31 155.58C380.642 142.502 377.487 125.953 370.638 114.338C369.219 114.515 367.809 114.774 366.417 115.145C353.279 118.634 346.578 129.322 343.794 141.863H343.791Z',
  fill: '#3E0A3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M312.04 97.278C313.952 97.278 315.502 95.6303 315.502 93.5978C315.502 91.5652 313.952 89.9175 312.04 89.9175C310.128 89.9175 308.578 91.5652 308.578 93.5978C308.578 95.6303 310.128 97.278 312.04 97.278Z',
  fill: '#3E0A3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M339.054 90.5329C340.966 90.5329 342.516 88.8852 342.516 86.8526C342.516 84.8201 340.966 83.1724 339.054 83.1724C337.141 83.1724 335.591 84.8201 335.591 86.8526C335.591 88.8852 337.141 90.5329 339.054 90.5329Z',
  fill: '#3E0A3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M277.068 72.0867C276.549 62.4977 284.348 55.0355 291.975 50.3426C297.426 46.9909 303.177 44.2098 309.121 42.053C310.054 41.7154 310.69 43.0776 309.88 43.6781C305.235 47.1253 301.408 51.887 298.947 57.4014C298.58 58.2229 299.416 59.0803 300.136 58.6113C312.321 50.6473 326.513 46.3546 340.768 46.2441C341.763 46.2351 341.954 47.7825 340.995 48.0573C334.889 49.8198 329.133 52.9863 324.237 57.3148C323.568 57.9063 324.082 59.0743 324.933 58.9309C333.157 57.5359 341.784 58.9966 349.345 62.9099C350.286 63.3968 349.742 64.9323 348.744 64.6186C339.986 61.8584 330.247 62.1422 321.029 62.8203C306.573 63.8837 292.169 65.5626 277.77 67.2504C277.34 67.3012 277.021 67.6985 277.027 68.1674L277.074 72.0867H277.068Z',
  fill: '#F59CBC'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M174.5 283C228.348 283 272 239.348 272 185.5C272 131.652 228.348 88 174.5 88C120.652 88 77 131.652 77 185.5C77 239.348 120.652 283 174.5 283Z',
  fill: '#0A2041'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M252.18 245.33C219.625 288.314 158.419 296.743 115.473 264.162C103.031 254.723 93.4877 242.878 87 229.768C90.5751 233.52 94.4964 237.032 98.7549 240.264C141.701 272.848 202.905 264.416 235.46 221.432C258.585 190.9 261.032 151.148 245.117 119C277.576 153.059 281.504 206.611 252.18 245.33Z',
  fill: '#08182E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M198.772 178.557C216.914 154.62 216.914 124.069 198.772 110.319C180.63 96.5684 151.216 104.826 133.074 128.762C114.932 152.698 114.931 183.249 133.073 197C151.215 210.75 180.629 202.493 198.772 178.557Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M178.933 163.52C186.119 154.041 186.118 141.941 178.933 136.494C171.747 131.048 160.098 134.318 152.912 143.798C145.727 153.278 145.728 165.378 152.913 170.824C160.099 176.27 171.748 173 178.933 163.52Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M131 118.482C147.067 93.5524 178.626 85.5449 201.489 100.599C224.354 115.653 229.863 148.067 213.796 173',
  fill: '#0A2041'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M182.5 164C187.194 164 191 160.194 191 155.5C191 150.806 187.194 147 182.5 147C177.806 147 174 150.806 174 155.5C174 160.194 177.806 164 182.5 164Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M289.219 261.147C297.382 258.949 300.967 245.908 297.227 232.018C293.487 218.128 283.838 208.649 275.675 210.847C267.512 213.045 263.927 226.087 267.667 239.977C271.407 253.867 281.056 263.345 289.219 261.147Z',
  fill: '#0A2041'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M56.1094 176.705C69.9994 172.965 79.4777 163.316 77.2797 155.153C75.0818 146.99 62.04 143.405 48.15 147.145C34.26 150.885 24.7818 160.534 26.9797 168.697C29.1776 176.86 42.2195 180.445 56.1094 176.705Z',
  fill: '#0A2041'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M90.6622 240.724C96.1508 227.428 94.2656 214.034 86.4515 210.808C78.6374 207.583 67.8535 215.747 62.365 229.043C56.8765 242.34 58.7617 255.733 66.5757 258.959C74.3898 262.184 85.1737 254.02 90.6622 240.724Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M147.243 270.15C152.731 256.854 150.846 243.46 143.032 240.235C135.218 237.009 124.434 245.173 118.946 258.47C113.457 271.766 115.342 285.16 123.156 288.385C130.97 291.611 141.754 283.447 147.243 270.15Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M193.784 217.542C193.784 217.565 193.784 217.586 193.784 217.61C193.784 219.068 193.62 220.487 193.309 221.766C192.034 227.014 187.887 231.378 182.919 234.16C176.604 237.696 168.96 238.673 164.216 235.659C161.74 234.082 159.598 231.128 158.938 227.686C158.875 227.367 158.824 227.041 158.792 226.712C158.529 224.254 159.022 221.464 160.208 219.214C160.987 217.736 162.066 216.49 163.428 215.716C167.087 213.64 169.038 215.397 172.124 212.72C173.82 211.247 174.588 211.026 176.258 208.992C178.86 205.826 184.153 203.979 187.926 205.548C191.953 207.221 193.781 212.586 193.781 217.542H193.784Z',
  fill: 'url(#paint0_linear_1149_9606)'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M193.784 217.542C193.784 217.565 193.784 217.586 193.784 217.61C193.775 218.226 193.739 218.832 193.674 219.423L164.13 219.238C163.703 219.238 163.377 218.874 163.374 218.435C163.368 217.303 162.319 216.344 163.428 215.716C167.087 213.64 169.038 215.397 172.124 212.72C173.82 211.247 174.588 211.026 176.258 208.992C178.86 205.826 184.153 203.979 187.926 205.548C191.953 207.221 193.781 212.586 193.781 217.542H193.784Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M182.919 234.157C176.604 237.693 168.96 238.67 164.216 235.656C161.74 234.079 159.598 231.125 158.938 227.683C161.453 226.647 164.56 226.04 167.921 226.061C175.917 226.112 182.439 229.685 182.919 234.157Z',
  fill: '#C4678B'
}), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
  id: 'paint0_linear_1149_9606',
  x1: '158.99',
  y1: '220.926',
  x2: '194.027',
  y2: '221.146',
  gradientUnits: 'userSpaceOnUse'
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: '#A64B73'
}), /*#__PURE__*/React__default.createElement("stop", {
  offset: '1',
  stopColor: '#8B2F5B'
})))));

const CliveDark = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '216',
  height: '215',
  viewBox: '0 0 216 215',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M99 188C149.258 188 190 173.897 190 156.5C190 139.103 149.258 125 99 125C48.7421 125 8 139.103 8 156.5C8 173.897 48.7421 188 99 188Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M178.463 116.021C174.309 88.4586 139.339 66.9414 96.8131 66.9414C51.4922 66.9414 14.752 91.3809 14.752 121.532C14.752 142.26 32.1202 160.295 57.7109 169.529C60.0327 170.374 62.4202 171.141 64.8753 171.828H64.8849C66.7218 172.349 68.5907 172.824 70.4982 173.254C78.7657 175.109 87.6192 176.12 96.8292 176.12C103.913 176.12 110.782 175.525 117.338 174.402C152.728 168.336 178.877 146.967 178.877 121.532C178.877 119.672 178.739 117.832 178.463 116.023V116.021ZM116.617 147.973C116.063 148.113 115.503 148.246 114.938 148.373C114.873 148.388 114.809 148.402 114.743 148.415C114.207 148.535 113.666 148.649 113.12 148.76C113.02 148.779 112.919 148.799 112.821 148.818C112.304 148.919 111.783 149.019 111.257 149.11C111.105 149.137 110.949 149.16 110.795 149.186C110.317 149.266 109.838 149.346 109.355 149.418C108.713 149.515 108.065 149.605 107.414 149.687C106.985 149.743 106.553 149.793 106.124 149.837C105.259 149.934 104.384 150.014 103.504 150.085C103.065 150.115 102.624 150.151 102.176 150.176C101.291 150.232 100.397 150.273 99.4929 150.303C98.5938 150.329 97.685 150.343 96.7713 150.343C95.7437 150.343 94.7209 150.322 93.7078 150.287C93.3802 150.277 93.0511 150.261 92.7235 150.247C91.9239 150.212 91.1339 150.167 90.3488 150.106C89.9827 150.075 89.6166 150.045 89.2505 150.014C88.8411 149.979 88.4316 149.939 88.0238 149.898C86.3925 149.731 84.7884 149.52 83.2181 149.261C74.18 147.785 66.1967 144.874 60.0455 140.987L60.0407 140.982C59.0789 139.057 58.5715 137.024 58.5715 134.927C58.5715 122.786 75.6925 112.94 96.8099 112.94C117.927 112.94 135.058 122.786 135.058 134.927C135.058 137.015 134.554 139.032 133.602 140.947C128.926 143.921 123.173 146.321 116.701 147.952C116.672 147.959 116.644 147.967 116.615 147.973H116.617Z',
  fill: '#F492BB'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.42',
  d: 'M178.887 121.533C178.887 151.684 142.147 176.123 96.8246 176.123C51.5022 176.123 14.7603 151.684 14.7603 121.533C14.7603 119.658 14.9032 117.803 15.1793 115.973C19.3701 143.509 54.3217 165.003 96.8246 165.003C139.328 165.003 174.278 143.511 178.47 115.973C178.746 117.803 178.889 119.658 178.889 121.533H178.887Z',
  fill: '#CF73A8'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.64',
  d: 'M96.8125 74.5273C59.6676 74.5273 29.5586 91.8394 29.5586 113.194C29.5586 134.549 59.6676 151.861 96.8125 151.861C133.957 151.861 164.066 134.549 164.066 113.194C164.066 91.8394 133.957 74.5273 96.8125 74.5273ZM106.122 149.842C105.257 149.938 104.381 150.018 103.502 150.089C103.063 150.119 102.622 150.155 102.174 150.18C101.289 150.237 100.395 150.277 99.4907 150.307C98.5916 150.333 97.6828 150.347 96.7691 150.347C95.7415 150.347 94.7188 150.326 93.7056 150.291C93.378 150.282 93.0489 150.265 92.7213 150.251C91.9217 150.216 91.1317 150.171 90.3466 150.11C89.9805 150.079 89.6144 150.049 89.2483 150.018C88.8389 149.983 88.4294 149.943 88.0216 149.903C86.3903 149.736 84.7862 149.524 83.2159 149.265C74.1778 147.79 66.1945 144.879 60.0433 140.991L60.0385 140.986C59.0767 139.061 58.5693 137.029 58.5693 134.932C58.5693 122.79 75.6903 112.944 96.8077 112.944C117.925 112.944 135.056 122.79 135.056 134.932C135.056 137.019 134.551 139.036 133.599 140.951C128.924 143.925 123.171 146.325 116.698 147.957C116.669 147.963 116.642 147.971 116.613 147.977C116.059 148.117 115.499 148.25 114.934 148.377C114.87 148.392 114.805 148.406 114.739 148.419C114.203 148.539 113.662 148.653 113.116 148.764C113.017 148.783 112.915 148.803 112.818 148.822C112.301 148.923 111.779 149.023 111.254 149.114C111.101 149.142 110.945 149.164 110.791 149.19C110.313 149.27 109.834 149.35 109.351 149.423C108.709 149.519 108.062 149.609 107.41 149.691C106.981 149.747 106.549 149.797 106.12 149.842H106.122Z',
  fill: '#F6ABCB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M103.498 150.087C104.378 150.016 105.253 149.936 106.118 149.84C105.253 149.941 104.378 150.021 103.498 150.087Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.822 148.82C112.304 148.921 111.785 149.021 111.258 149.113C111.783 149.021 112.304 148.921 112.822 148.82Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M111.259 149.113C111.106 149.141 110.951 149.163 110.796 149.189C110.951 149.163 111.106 149.139 111.259 149.113Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M110.801 149.188C110.322 149.268 109.845 149.348 109.36 149.42C109.844 149.348 110.322 149.268 110.801 149.188Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M116.617 147.977C116.063 148.115 115.502 148.25 114.937 148.376C115.502 148.25 116.061 148.116 116.617 147.977Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M116.701 147.956C123.173 146.324 128.926 143.924 133.602 140.95C134.554 139.035 135.058 137.018 135.058 134.931C135.058 122.789 117.932 112.943 96.8102 112.943C75.688 112.943 58.5719 122.789 58.5719 134.931C58.5719 137.028 59.0809 139.06 60.041 140.985C52.0305 135.91 47.1445 129.178 47.1445 121.788C47.1445 106.018 69.3843 93.2305 96.8151 93.2305C124.246 93.2305 146.486 106.018 146.486 121.788C146.486 133.49 134.233 143.55 116.703 147.956H116.701Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M114.746 148.418C114.208 148.537 113.669 148.654 113.123 148.763C113.669 148.654 114.21 148.538 114.746 148.418Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M113.119 148.762C113.019 148.781 112.918 148.8 112.82 148.82C112.92 148.8 113.021 148.783 113.119 148.762Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M114.938 148.375C114.874 148.389 114.809 148.404 114.744 148.417C114.808 148.402 114.874 148.389 114.938 148.375Z',
  fill: '#F285B3'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M60.0449 140.988C66.1961 144.876 74.1794 147.787 83.2175 149.262C74.1922 147.796 66.2106 144.9 60.0594 141.024C60.0546 141.014 60.0497 140.998 60.0449 140.988Z',
  fill: '#F173A6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M83.2246 149.266C84.7949 149.524 86.3974 149.736 88.0303 149.903C86.399 149.741 84.7949 149.524 83.2246 149.266Z',
  fill: '#F173A6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M135.057 134.931C135.057 137.018 134.553 139.035 133.605 140.95C124.519 146.723 111.385 150.346 96.775 150.346C82.1653 150.346 69.1499 146.753 60.0636 141.026C59.0938 139.089 58.5752 137.042 58.5752 134.929C58.5752 122.787 75.6962 112.941 96.8152 112.941C117.934 112.941 135.058 122.787 135.058 134.929L135.057 134.931Z',
  fill: '#F173A6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M172.418 84.8095C176.652 91.2642 180.244 98.154 180.797 102.834C184.602 135.183 167.071 150.302 159.864 156.413C153.014 162.221 145.916 165.593 141.311 167.534C139.313 165.644 135.312 160.321 133.223 153.382C132.728 151.734 129.694 141.115 134.65 131.648C138.603 124.101 143.308 125.546 148.923 117.496C149.885 116.116 156.021 107.073 155.108 96.7715C154.56 90.6203 151.673 85.919 148.501 82.1232C146.736 81.1679 144.962 79.954 143.239 78.4126C141.77 77.0992 133.072 69.315 133.225 58.6086C133.424 44.32 149.295 31.5664 164.623 31.5664C181.964 31.5664 196.021 43.6713 196.021 58.6086C196.021 71.2242 185.988 81.8246 172.42 84.8111L172.418 84.8095Z',
  fill: '#F59CBC'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M182.463 79.0773C189.951 79.0773 196.021 72.6276 196.021 64.6714C196.021 56.7153 189.951 50.2656 182.463 50.2656C174.975 50.2656 168.905 56.7153 168.905 64.6714C168.905 72.6276 174.975 79.0773 182.463 79.0773Z',
  fill: '#FFD865'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M202.225 83.625C199.804 89.5691 194.78 92.5459 192.397 93.7341C192.378 89.5241 191.912 84.5659 190.019 80.8858C189.224 79.3283 188.168 77.9988 186.784 77.0547C184.687 75.6241 183.296 77.416 181.27 77.5605C178.935 77.7259 174.025 74.407 173.706 73.7342C172.648 71.5313 172.105 68.9944 172.256 66.321C172.665 59.0218 178.322 53.1178 185.199 52.8063C187.331 52.71 189.364 53.1387 191.19 53.98C199.549 55.9469 206.87 72.2378 202.227 83.625H202.225Z',
  fill: '#FBCD0B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M185.282 76.2553C185.786 76.4608 186.287 76.7226 186.782 77.0581C188.166 78.0039 189.222 79.3333 190.017 80.8892C191.91 84.5693 192.378 89.5276 192.395 93.7375C194.778 92.5494 199.802 89.5725 202.223 83.6284C205.089 76.5989 203.394 67.7037 199.712 61.4609C198.949 61.5557 198.192 61.6954 197.443 61.8945C190.382 63.7699 186.78 69.5148 185.284 76.2553H185.282Z',
  fill: '#3E0A3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M168.213 52.2883C169.241 52.2883 170.074 51.4027 170.074 50.3102C170.074 49.2177 169.241 48.332 168.213 48.332C167.185 48.332 166.352 49.2177 166.352 50.3102C166.352 51.4027 167.185 52.2883 168.213 52.2883Z',
  fill: '#3E0A3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M182.742 48.6594C183.77 48.6594 184.603 47.7738 184.603 46.6813C184.603 45.5888 183.77 44.7031 182.742 44.7031C181.715 44.7031 180.881 45.5888 180.881 46.6813C180.881 47.7738 181.715 48.6594 182.742 48.6594Z',
  fill: '#3E0A3B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M149.427 38.7458C149.147 33.5917 153.34 29.5808 157.439 27.0584C160.369 25.2568 163.46 23.762 166.655 22.6027C167.156 22.4213 167.498 23.1534 167.063 23.4762C164.566 25.3291 162.51 27.8885 161.187 30.8525C160.989 31.294 161.439 31.7549 161.826 31.5028C168.375 27.2221 176.003 24.9148 183.666 24.8554C184.2 24.8506 184.303 25.6823 183.788 25.83C180.506 26.7774 177.412 28.4794 174.78 30.8059C174.42 31.1238 174.696 31.7516 175.154 31.6746C179.574 30.9247 184.211 31.7099 188.275 33.8133C188.781 34.075 188.489 34.9003 187.953 34.7317C183.245 33.2481 178.01 33.4006 173.055 33.7651C165.286 34.3367 157.543 35.2391 149.804 36.1463C149.573 36.1736 149.401 36.3871 149.404 36.6392L149.43 38.7458H149.427Z',
  fill: '#F59CBC'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M94.294 152.113C123.237 152.113 146.7 128.65 146.7 99.707C146.7 70.7639 123.237 47.3008 94.294 47.3008C65.3508 47.3008 41.8877 70.7639 41.8877 99.707C41.8877 128.65 65.3508 152.113 94.294 152.113Z',
  fill: '#FFC900'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M136.047 131.863C118.549 154.967 85.6503 159.498 62.5667 141.985C55.8795 136.912 50.7498 130.545 47.2627 123.499C49.1843 125.515 51.292 127.403 53.581 129.14C76.6645 146.654 109.561 142.122 127.06 119.018C139.489 102.607 140.805 81.2403 132.25 63.9609C149.697 82.2678 151.808 111.052 136.047 131.863Z',
  fill: '#F5BF00'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M107.337 95.9731C117.088 83.1074 117.088 66.6862 107.337 59.2953C97.5858 51.9045 81.7758 56.3427 72.0243 69.2084C62.2728 82.0742 62.2726 98.4954 72.0239 105.886C81.7751 113.277 97.5852 108.839 107.337 95.9731Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M96.6788 87.8903C100.541 82.7949 100.541 76.2912 96.6784 73.3639C92.8163 70.4366 86.5545 72.1942 82.6925 77.2896C78.8305 82.385 78.8306 88.8887 82.6928 91.816C86.555 94.7433 92.8167 92.9857 96.6788 87.8903Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M70.9126 63.6849C79.5484 50.2852 96.5117 45.9812 108.8 54.0726C121.09 62.1641 124.051 79.587 115.416 92.9883',
  fill: '#FFC900'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M98.5937 88.1492C101.117 88.1492 103.162 86.1037 103.162 83.5805C103.162 81.0572 101.117 79.0117 98.5937 79.0117C96.0704 79.0117 94.0249 81.0572 94.0249 83.5805C94.0249 86.1037 96.0704 88.1492 98.5937 88.1492Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M155.961 140.366C160.349 139.185 162.276 132.175 160.266 124.709C158.256 117.243 153.069 112.148 148.682 113.33C144.294 114.511 142.367 121.521 144.377 128.987C146.387 136.453 151.574 141.547 155.961 140.366Z',
  fill: '#F5BF00'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M30.6586 94.9832C38.1245 92.973 43.219 87.7865 42.0377 83.399C40.8563 79.0114 33.8463 77.0842 26.3804 79.0945C18.9146 81.1047 13.82 86.2912 15.0014 90.6787C16.1828 95.0663 23.1928 96.9935 30.6586 94.9832Z',
  fill: '#F5BF00'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M49.2364 129.389C52.1865 122.242 51.1732 115.043 46.9732 113.309C42.7731 111.575 36.9768 115.963 34.0267 123.11C31.0766 130.257 32.0899 137.456 36.2899 139.19C40.49 140.924 46.2863 136.535 49.2364 129.389Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M79.6388 145.205C82.5889 138.058 81.5756 130.859 77.3755 129.125C73.1754 127.392 67.3791 131.78 64.429 138.927C61.4789 146.074 62.4922 153.273 66.6923 155.006C70.8923 156.74 76.6887 152.352 79.6388 145.205Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M104.657 116.932C104.657 116.945 104.657 116.956 104.657 116.969C104.657 117.753 104.569 118.515 104.402 119.202C103.716 122.024 101.488 124.369 98.8173 125.864C95.423 127.765 91.3142 128.29 88.7644 126.67C87.4333 125.822 86.2821 124.235 85.9272 122.385C85.8935 122.213 85.8662 122.038 85.8486 121.861C85.7073 120.54 85.9722 119.04 86.6096 117.831C87.0287 117.036 87.6083 116.367 88.3405 115.951C90.3074 114.835 91.3559 115.779 93.0145 114.341C93.9265 113.549 94.3392 113.43 95.2368 112.337C96.6353 110.635 99.4805 109.642 101.508 110.485C103.673 111.385 104.655 114.268 104.655 116.932H104.657Z',
  fill: 'url(#paint0_linear_9182_35794)'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M104.652 116.932C104.652 116.945 104.652 116.956 104.652 116.969C104.647 117.3 104.628 117.626 104.593 117.944L88.713 117.844C88.4834 117.844 88.3084 117.648 88.3068 117.412C88.3036 116.804 87.74 116.288 88.3357 115.951C90.3026 114.835 91.3511 115.779 93.0097 114.341C93.9217 113.549 94.3344 113.43 95.2319 112.337C96.6305 110.635 99.4756 109.642 101.504 110.485C103.668 111.385 104.651 114.268 104.651 116.932H104.652Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M98.8193 125.859C95.425 127.76 91.3161 128.286 88.7664 126.665C87.4353 125.818 86.284 124.23 85.9292 122.38C87.2811 121.823 88.951 121.497 90.7574 121.508C95.0557 121.535 98.5608 123.456 98.8193 125.859Z',
  fill: '#C4678B'
}), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
  id: 'paint0_linear_9182_35794',
  x1: '85.9553',
  y1: '118.751',
  x2: '104.788',
  y2: '118.87',
  gradientUnits: 'userSpaceOnUse'
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: '#A64B73'
}), /*#__PURE__*/React__default.createElement("stop", {
  offset: '1',
  stopColor: '#8B2F5B'
})))));

const EmailBobbin = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '270',
  height: '270',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("g", {
  clipPath: 'url(#clip0_1371_138)'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M-5.21814 330.475C30.7175 300.189 108.89 225.605 101.716 136.451C99.365 107.228 85.1653 71.7484 65.888 70.3091C49.8816 69.1129 28.8777 86.6304 36.1239 106.687C45.641 133.036 104.133 133.423 145.263 133.697C182.696 133.945 242.811 133.313 306 112.5',
  stroke: '#BCBEC0',
  strokeWidth: '1.56638',
  strokeMiterlimit: '10',
  strokeLinecap: 'round',
  strokeDasharray: '8 8'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M178.425 375C222.506 375 258.241 368.897 258.241 361.369C258.241 353.841 222.506 347.739 178.425 347.739C134.343 347.739 98.608 353.841 98.608 361.369C98.608 368.897 134.343 375 178.425 375Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M155.525 345.581C158.679 340.118 153.7 331.337 144.403 325.97C135.106 320.602 125.013 320.68 121.858 326.144C118.704 331.607 123.683 340.388 132.98 345.755C142.277 351.123 152.37 351.045 155.525 345.581Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M213.557 360.983C224.129 359.118 231.811 352.571 230.716 346.358C229.62 340.144 220.162 336.619 209.59 338.483C199.018 340.347 191.336 346.895 192.431 353.108C193.527 359.321 202.985 362.847 213.557 360.983Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M82.3835 267.682C98.8181 319.337 154.02 347.888 205.678 331.453C229.599 323.845 248.561 307.922 260.399 287.887C261.38 286.227 262.316 284.536 263.195 282.824C263.927 281.406 264.62 279.973 265.275 278.52C266.181 276.547 267.01 274.539 267.772 272.511C275.303 252.571 276.414 230.047 269.452 208.159C266.852 199.993 263.286 192.402 258.907 185.479C258.153 184.269 257.363 183.078 256.551 181.909C256.031 181.158 255.498 180.417 254.962 179.683C253.255 177.373 251.467 175.152 249.586 173.019C224.623 144.722 184.417 132.21 146.158 144.382C94.4947 160.822 65.9461 216.019 82.3835 267.679V267.682Z',
  fill: '#13B1AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M225.75 322.268C223.886 323.367 221.985 324.406 220.043 325.373C218.623 326.091 217.186 326.771 215.728 327.417C213.968 328.199 212.181 328.926 210.377 329.603C188.616 337.766 163.885 338.266 140.522 329.191C90.0606 309.596 65.0592 252.792 84.6763 202.317C87.2455 195.708 90.4501 189.54 94.1962 183.846C86.2317 228.981 110.913 274.917 155.247 292.131C178.612 301.206 203.34 300.706 225.101 292.543C226.905 291.866 228.693 291.139 230.452 290.357C231.911 289.714 233.348 289.031 234.767 288.313C236.71 287.346 238.61 286.305 240.475 285.208C253.161 277.752 264.239 267.414 272.615 254.681C271.518 260.919 269.794 267.141 267.416 273.268C259.1 294.656 244.113 311.475 225.753 322.265L225.75 322.268Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M281.508 284.031C281.508 284.031 281.502 284.025 281.502 284.023H281.48L281.505 284.031H281.508Z',
  fill: '#8A5024'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M216.675 250.844C238.286 250.844 255.805 233.325 255.805 211.715C255.805 190.104 238.286 172.586 216.675 172.586C195.065 172.586 177.546 190.104 177.546 211.715C177.546 233.325 195.065 250.844 216.675 250.844Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M216.675 247.502C238.286 247.502 255.805 229.983 255.805 208.372C255.805 186.762 238.286 169.243 216.675 169.243C195.065 169.243 177.546 186.762 177.546 208.372C177.546 229.983 195.065 247.502 216.675 247.502Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M220.253 216.348C231.15 216.348 239.983 207.514 239.983 196.617C239.983 185.721 231.15 176.887 220.253 176.887C209.356 176.887 200.523 185.721 200.523 196.617C200.523 207.514 209.356 216.348 220.253 216.348Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M208.208 214.502C211.594 214.502 214.338 211.758 214.338 208.372C214.338 204.987 211.594 202.242 208.208 202.242C204.822 202.242 202.078 204.987 202.078 208.372C202.078 211.758 204.822 214.502 208.208 214.502Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M130.446 272.56C136.604 263.766 137.406 253.704 132.238 250.085C127.07 246.467 117.889 250.662 111.731 259.456C105.574 268.249 104.772 278.311 109.94 281.93C115.108 285.549 124.289 281.354 130.446 272.56Z',
  fill: '#188E82'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M203.371 268.027C203.374 268.044 203.379 268.061 203.385 268.077C203.664 269.127 204.053 270.121 204.52 270.986C206.443 274.531 210.266 276.887 214.38 277.945C219.612 279.293 225.314 278.539 228.159 275.459C229.646 273.848 230.626 271.307 230.447 268.699C230.43 268.456 230.405 268.213 230.367 267.967C230.088 266.141 229.201 264.223 227.914 262.828C227.071 261.911 226.054 261.215 224.924 260.919C221.888 260.118 220.814 261.759 218.079 260.417C216.573 259.679 215.979 259.665 214.385 258.516C211.902 256.728 207.73 256.405 205.307 258.256C202.722 260.231 202.426 264.453 203.371 268.027Z',
  fill: 'url(#paint0_linear_1371_138)'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M203.371 268.028C203.374 268.044 203.379 268.061 203.385 268.077C203.509 268.519 203.65 268.95 203.81 269.365L225.093 263.594C225.4 263.511 225.568 263.187 225.485 262.87C225.273 262.052 225.847 261.16 224.927 260.917C221.891 260.115 220.817 261.756 218.082 260.414C216.576 259.676 215.982 259.662 214.388 258.513C211.904 256.726 207.733 256.403 205.31 258.253C202.724 260.229 202.429 264.45 203.374 268.025L203.371 268.028Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M214.382 277.942C219.615 279.291 225.317 278.536 228.162 275.456C229.648 273.845 230.629 271.304 230.45 268.696C228.438 268.428 226.079 268.583 223.659 269.24C217.899 270.801 213.874 274.625 214.382 277.942Z',
  fill: '#C4678B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M396.763 24L266.631 73.6436L298.473 78.3787L396.763 24Z',
  fill: '#83D4F1'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M396.762 24L298.376 78.3234L313.415 111.82L396.762 24Z',
  fill: '#29AAE1'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M319.634 84.6277L313.415 111.82L335.817 93.6558L319.634 84.6277Z',
  fill: '#0E72BA'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M396.762 24L319.634 84.6277L365.07 109.977L396.762 24Z',
  fill: '#83D4F1'
})), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
  id: 'paint0_linear_1371_138',
  x1: '227.922',
  y1: '264.316',
  x2: '202.682',
  y2: '271.159',
  gradientUnits: 'userSpaceOnUse'
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: '#A64B73'
}), /*#__PURE__*/React__default.createElement("stop", {
  offset: '1',
  stopColor: '#8B2F5B'
})), /*#__PURE__*/React__default.createElement("clipPath", {
  id: 'clip0_1371_138'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'white'
})))));

const ErrorBobbin = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '270',
  height: '270',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M200.5 353C264.289 353 316 344.27 316 333.5C316 322.73 264.289 314 200.5 314C136.711 314 85 322.73 85 333.5C85 344.27 136.711 353 200.5 353Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M64.7035 231.699C88.3916 306.669 167.945 348.111 242.396 324.256C276.871 313.215 304.203 290.101 321.259 261.026C322.673 258.615 324.019 256.162 325.289 253.674C326.343 251.616 327.342 249.535 328.287 247.429C329.591 244.565 330.787 241.652 331.885 238.708C342.737 209.766 344.34 177.08 334.305 145.306C330.558 133.453 325.42 122.438 319.11 112.387C318.02 110.633 316.886 108.902 315.713 107.206C314.964 106.116 314.196 105.041 313.422 103.977C310.964 100.624 308.384 97.4014 305.675 94.3046C269.696 53.2343 211.752 35.0743 156.612 52.7424C82.1579 76.6041 41.009 156.713 64.6971 231.695L64.7035 231.699Z',
  fill: '#F1585F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M272.096 310.33C269.396 311.921 266.64 313.425 263.826 314.825C261.769 315.864 259.685 316.848 257.572 317.781C255.024 318.913 252.433 319.965 249.819 320.943C218.287 332.756 182.458 333.482 148.607 320.346C75.4925 291.99 39.2664 209.781 67.691 136.73C71.4124 127.166 76.0546 118.238 81.4817 110C69.9394 175.32 105.7 241.799 169.941 266.712C203.795 279.848 239.624 279.122 271.153 267.309C273.766 266.328 276.357 265.276 278.906 264.147C281.019 263.215 283.102 262.23 285.16 261.191C287.974 259.791 290.729 258.284 293.43 256.697C311.811 245.907 327.863 230.945 340 212.517C338.414 221.546 335.913 230.548 332.467 239.415C320.417 270.368 298.702 294.71 272.1 310.327L272.096 310.33Z',
  fill: '#E44A55'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200 217C231.48 217 257 191.704 257 160.5C257 129.296 231.48 104 200 104C168.52 104 143 129.296 143 160.5C143 191.704 168.52 217 200 217Z',
  fill: '#E44A55'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200 213C231.48 213 257 187.48 257 156C257 124.52 231.48 99 200 99C168.52 99 143 124.52 143 156C143 187.48 168.52 213 200 213Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200 184C216.016 184 229 171.24 229 155.5C229 139.76 216.016 127 200 127C183.984 127 171 139.76 171 155.5C171 171.24 183.984 184 200 184Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M221 149C225.971 149 230 144.971 230 140C230 135.029 225.971 131 221 131C216.029 131 212 135.029 212 140C212 144.971 216.029 149 221 149Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M255.253 320.589C261.217 306.24 259.215 291.766 250.783 288.261C242.35 284.756 230.679 293.547 224.715 307.896C218.751 322.245 220.752 336.718 229.185 340.223C237.618 343.728 249.288 334.938 255.253 320.589Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M175.567 340.131C183.999 336.626 186 322.153 180.036 307.804C174.072 293.455 162.401 284.664 153.969 288.169C145.536 291.674 143.535 306.148 149.499 320.496C155.463 334.845 167.134 343.636 175.567 340.131Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M220.927 248.109C218.539 242.309 220.973 234.95 225.847 231.434C231.121 227.433 238.537 228.563 242.99 233.374C245.72 236.244 247.32 240.421 246.946 244.436C246.797 245.982 244.801 246.286 244.243 244.872C243.655 243.364 242.954 242.008 242.101 240.86C238.158 235.511 231.183 234.055 226.753 239.764C225.004 241.957 224.043 244.654 223.65 247.628C223.511 249.181 221.515 249.519 220.927 248.105V248.109Z',
  fill: '#E44A55'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M381.294 233.176C388.775 227.938 387.614 213.373 378.701 200.644C369.788 187.915 356.499 181.843 349.018 187.08C341.538 192.318 342.699 206.883 351.612 219.612C360.525 232.341 373.814 238.414 381.294 233.176Z',
  fill: '#E44A55'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M49.2275 219.613C58.1403 206.884 59.3015 192.319 51.8209 187.082C44.3404 181.844 31.051 187.916 22.1381 200.645C13.2253 213.374 12.0642 227.939 19.5447 233.177C27.0252 238.415 40.3146 232.342 49.2275 219.613Z',
  fill: '#E44A55'
})));

const FlightBobbin = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '200',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M200.5 372C256.557 372 302 364.389 302 355C302 345.611 256.557 338 200.5 338C144.443 338 99 345.611 99 355C99 364.389 144.443 372 200.5 372Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191.112 347.074C192.5 339.203 182.768 330.908 169.375 328.547C155.983 326.185 144.001 330.651 142.613 338.522C141.225 346.393 150.957 354.687 164.35 357.049C177.742 359.41 189.724 354.944 191.112 347.074Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M242.236 357.051C255.629 354.689 265.36 346.395 263.973 338.524C262.585 330.654 250.603 326.188 237.21 328.549C223.818 330.91 214.086 339.205 215.474 347.076C216.861 354.946 228.843 359.412 242.236 357.051Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M80.8982 239.242C101.74 304.742 171.736 340.95 237.243 320.108C267.576 310.461 291.624 290.267 306.631 264.865C307.875 262.759 309.06 260.616 310.176 258.441C311.104 256.643 311.983 254.825 312.814 252.985C313.962 250.483 315.014 247.938 315.981 245.366C325.528 220.079 326.939 191.522 318.109 163.762C314.813 153.406 310.292 143.782 304.74 135.001C303.781 133.469 302.783 131.956 301.751 130.475C301.092 129.522 300.417 128.584 299.735 127.653C297.573 124.724 295.302 121.909 292.919 119.203C261.263 83.3205 210.28 67.4544 161.765 82.8908C96.2555 103.738 60.0503 173.728 80.8925 239.239L80.8982 239.242Z',
  fill: '#13B1AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M263.524 307.834C261.159 309.222 258.745 310.534 256.281 311.756C254.478 312.663 252.653 313.522 250.803 314.336C248.57 315.324 246.301 316.242 244.012 317.095C216.393 327.405 185.012 328.038 155.361 316.575C91.3215 291.828 59.5915 220.082 84.4882 156.328C87.7478 147.981 91.8138 140.189 96.5673 133C86.4576 190.007 117.78 248.025 174.047 269.767C203.7 281.231 235.082 280.597 262.698 270.288C264.987 269.432 267.256 268.514 269.489 267.528C271.339 266.715 273.164 265.856 274.967 264.949C277.431 263.727 279.845 262.412 282.21 261.026C298.31 251.61 312.37 238.552 323 222.47C321.611 230.349 319.421 238.205 316.402 245.944C305.848 272.958 286.828 294.201 263.527 307.831L263.524 307.834Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.5 227C227.838 227 250 204.614 250 177C250 149.386 227.838 127 200.5 127C173.162 127 151 149.386 151 177C151 204.614 173.162 227 200.5 227Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.5 222C227.838 222 250 200.062 250 173C250 145.938 227.838 124 200.5 124C173.162 124 151 145.938 151 173C151 200.062 173.162 222 200.5 222Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200 198C213.807 198 225 186.807 225 173C225 159.193 213.807 148 200 148C186.193 148 175 159.193 175 173C175 186.807 186.193 198 200 198Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M218.5 167C222.642 167 226 163.642 226 159.5C226 155.358 222.642 152 218.5 152C214.358 152 211 155.358 211 159.5C211 163.642 214.358 167 218.5 167Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M358.443 246.859C364.99 242.275 363.974 229.528 356.173 218.388C348.373 207.248 336.743 201.934 330.196 206.518C323.649 211.102 324.666 223.848 332.466 234.988C340.266 246.128 351.896 251.443 358.443 246.859Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M67.8311 234.989C75.6312 223.85 76.6474 211.103 70.1007 206.519C63.5541 201.935 51.9237 207.249 44.1235 218.389C36.3233 229.529 35.3071 242.276 41.8538 246.86C48.4005 251.444 60.0309 246.129 67.8311 234.989Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M229.122 246.157C229.599 246.157 229.983 246.555 229.966 247.032C229.503 261.365 217.738 272.845 203.292 272.845C188.847 272.845 177.082 261.368 176.619 247.032C176.604 246.555 176.986 246.157 177.463 246.157H229.122Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M228.834 254.053C225.516 265.011 215.335 272.986 203.292 272.986C202.369 272.986 201.454 272.938 200.556 272.848C200.55 268.623 202.033 264.02 205.032 259.967C211.251 251.562 221.632 248.699 228.221 253.57C228.433 253.726 228.636 253.889 228.834 254.053Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M229.964 247.106C229.842 250.201 229.128 253.164 227.916 255.9H181.276C180.256 255.9 179.429 255.166 179.429 254.259V246.157H228.935C229.517 246.157 229.983 246.589 229.964 247.106Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M161.851 35.2726C170.605 30.8177 180.083 29.1785 189.726 28.445C205.559 27.2431 221.152 28.2023 235.943 34.7365C237.396 35.377 238.758 36.2234 240.163 36.971C239.279 38.3422 240.738 39.0504 241.253 39.7021C244.464 43.762 247.291 48.0758 249.984 52.4686C254.852 60.4078 260.587 67.7631 265.409 75.7418C269.221 82.0503 273.101 88.3136 276.576 94.8112C280.676 102.482 284.754 110.176 287 118.657C286.233 118.699 285.462 118.739 284.695 118.781L284.715 118.798C282.163 116.51 279.105 115.745 275.763 115.822L275.774 115.841C274.639 114.374 272.852 114.002 271.271 113.604C254.036 109.262 236.527 106.311 218.793 105.417C200.142 104.477 181.431 104.892 162.939 107.727C151.393 109.499 139.833 111.609 128.689 115.28C126.367 116.044 123.385 115.573 121.808 118.18C121.68 118.324 121.536 118.347 121.375 118.245C120.607 117.929 119.927 117.873 119.596 118.843L119.423 118.745L119.605 118.824C117.636 118.307 116.065 119.577 114.306 120C111.117 113.5 111.415 106.954 114.099 100.403C119.429 87.408 127.987 76.3709 136.777 65.7261C143.486 57.6006 150.122 49.3313 157.411 41.646C158.759 40.2269 161.013 38.7174 160.234 36.0061C160.234 36.0061 160.214 36.0682 160.217 36.0682C160.962 36.2065 161.602 36.1331 161.854 35.2698L161.851 35.2726ZM148.609 68.0706L148.541 68.0339C148.853 68.8013 149.43 68.8888 150.136 68.6518L150.15 68.6151C150.784 70.2599 152.492 69.8903 153.636 70.1245C155.431 70.4941 157.215 70.6352 158.654 71.9132C158.767 72.3251 158.881 72.7342 158.994 73.1462C159.274 73.4255 159.557 73.7048 159.838 73.9841L159.937 73.8825C166.162 74.6556 170.288 79.7876 176.031 81.5678C177.546 82.8346 179.37 82.3155 181.001 82.1942C183.949 81.9769 186.418 82.0305 186.365 85.9211C186.365 88.5055 186.382 91.0616 187.557 93.4936C190.802 100.217 198.935 103.23 206.154 100.307C213.392 97.3786 216.222 90.393 213.449 82.3098C216.655 82.2901 219.863 82.2873 223.069 82.2478C224.259 82.2337 225.643 82.5609 226.057 80.8569C227.445 78.6421 230.772 80.349 232.052 77.9142C234.051 75.2875 236.674 74.3311 239.945 74.791C241.168 74.9631 242.094 74.3198 242.227 72.9346C242.154 72.7766 242.193 72.6609 242.352 72.5847C243.802 71.3123 245.172 70.1838 247.401 70.1894C249.174 70.1922 250.958 69.3204 252.722 68.79C253.813 68.4627 254.294 67.6671 254.184 66.5386C254.073 65.3988 253.249 65.2859 252.329 65.2069C249.763 64.9869 247.206 64.5242 244.643 64.5016C234.895 64.417 225.145 64.4677 215.398 64.4621C214.033 64.4621 212.631 64.3295 211.832 65.8051C206.701 66.8066 206.539 67.1903 208.694 71.9245C209.439 73.5637 209.895 75.3327 210.484 77.0424C210.433 77.381 210.382 77.7224 210.331 78.0609C203.939 73.7189 197.517 73.3578 191.057 77.9198C190.496 76.038 191.584 74.3791 191.782 72.5988L191.901 72.2998C193.651 71.2107 194.05 69.4756 193.705 67.6925C193.354 65.8812 191.564 66.1521 190.213 65.884C188.684 64.6822 186.888 64.4536 185.019 64.4565C176.144 64.4649 167.249 64.1207 158.402 64.6201C154.701 64.8289 150.66 64.1179 147.171 66.2734L147.182 67.0775C147.25 67.9944 147.864 68.1298 148.615 68.0706H148.609Z',
  fill: '#2F4269'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M160.841 37C161.616 39.6774 159.371 41.1695 158.034 42.5752C150.785 50.1696 144.187 58.3441 137.515 66.3792C128.774 76.902 120.263 87.8125 114.963 100.659C112.29 107.135 111.995 113.605 115.166 120.031C115.002 120.399 114.839 120.764 114.676 121.133L114.538 121.177C108.753 121.872 103.777 124.226 99.6233 128.281L99.6289 128.272C98.3335 128.214 97.0042 128.108 96.9113 129.954L96.8268 130.029C95.5511 129.653 94.7034 129.898 94.7372 131.432L94.6104 131.535C93.4192 131.059 92.9827 131.583 93.0052 132.718V132.701C92.7321 132.93 92.4561 133.159 92.1829 133.385L92.197 133.376C91.5155 133.359 90.8875 133.404 91.0762 134.361L90.8987 134.508C90.3777 134.313 90.1834 134.514 90.2425 135.033L90.1525 135.114C89.6258 135.044 89.4231 135.267 89.5357 135.777L89.4597 135.856C88.0572 135.775 87.7672 136.662 87.7446 137.783L87.7559 137.766C87.5278 138.039 87.2996 138.31 87.0743 138.583L87.0913 138.569C86.6238 138.661 86.4041 138.923 86.4971 139.406L86.4689 139.453C85.6832 139.635 84.9003 139.819 84.1146 140C77.8627 130.908 72.2331 121.487 69.048 110.855C66.3839 101.961 68.8424 94.5312 75.9279 88.5237C84.3793 81.3588 94.3119 76.6761 104.476 72.6711C117.83 67.4111 129.593 59.8976 140.438 50.6967C146.696 45.3893 153.148 40.2603 160.847 37.0084L160.841 37Z',
  fill: '#233256'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M286.889 117.982C284.657 109.574 280.596 101.947 276.515 94.3415C273.056 87.9 269.195 81.6906 265.402 75.4365C260.602 67.5238 254.892 60.2348 250.05 52.364C247.37 48.009 244.557 43.7324 241.361 39.7075C240.848 39.0642 239.399 38.3593 240.276 37C247.761 40.4795 253.776 45.9141 259.7 51.4549C262.485 54.059 265.19 56.7413 267.966 59.3537C273.319 64.3883 279.42 68.0524 286.509 70.3711C296.573 73.666 306.438 77.551 315.521 83.0975C331.936 93.1164 335.019 104.274 326.082 121.19C322.92 127.173 318.827 132.549 314.859 138C313.275 137.443 313.599 135.371 312.184 134.68C312.131 134.053 311.942 133.558 311.156 133.651L311.119 133.603C311.195 133.1 310.978 132.867 310.465 132.904L310.406 132.848C310.431 132.342 310.195 132.132 309.69 132.227L309.628 132.168C309.662 130.82 308.794 130.496 307.666 130.465L307.68 130.476C307.413 130.247 307.145 130.017 306.874 129.788L306.866 129.796C306.626 127.464 305.054 126.988 303.056 127.106L302.951 127.022C302.788 125.223 301.508 125.282 300.198 125.388L300.212 125.397C300.076 124.949 299.82 124.748 299.346 124.966L299.155 124.862C298.118 122.219 295.942 121.763 293.442 121.928L293.343 121.892C292.162 119.006 288.684 119.861 286.886 117.985L286.889 117.982Z',
  fill: '#233256'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M86 140C85.5514 140.667 85.1064 141.333 84.6579 142C83.7428 141.749 83.3158 141.178 83 140.533C84.0012 140.355 84.9988 140.178 86 140Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M162 35C161.692 37.0204 160.91 37.1986 160 36.8685C160.664 36.2479 161.332 35.6206 162 35Z',
  fill: '#233256'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M213.956 82.7241C216.718 90.877 213.899 97.923 206.695 100.877C199.511 103.822 191.417 100.783 188.187 94.0045C187.017 91.5515 187.003 88.9733 187 86.3666C187.538 84.9238 188.074 83.4811 188.612 82.0354C188.838 81.7253 189.06 81.4151 189.286 81.1049C189.503 80.8089 189.717 80.5101 189.934 80.2142C190.87 79.9069 191.115 78.9621 191.667 78.3019C198.093 73.6975 204.486 74.0618 210.847 78.4413C211.075 78.6007 211.304 78.76 211.532 78.9194C211.521 80.4049 212.772 80.9085 213.657 81.6911C213.66 81.6854 213.665 81.8362 213.665 81.8362C213.764 82.1322 213.86 82.431 213.959 82.7269L213.956 82.7241ZM207.098 96.9014C211.662 96.1957 214.063 89.9579 211.585 85.2511L211.605 85.3365C211.182 81.4265 206.095 77.0498 202.552 77.4795C200.591 77.7185 202.27 79.0133 201.853 79.682C201.433 79.4316 201.013 79.184 200.591 78.9336C200.689 77.8693 200.362 77.4055 199.162 77.5051C195.314 77.8181 191.225 81.2557 189.855 85.4617C188.612 89.2806 189.782 93.6516 192.747 96.2782C193.387 96.8445 193.981 97.5502 194.954 96.8985L194.892 96.8672C196.676 100.33 199.9 99.6987 202.752 99.3629C204.348 99.1751 206.836 99.6759 207.163 96.853L207.098 96.9014Z',
  fill: '#E8ECF1'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M170.931 108.15C155.118 109.591 139.7 112.938 124.521 117.437C123.697 117.681 122.841 117.814 122 118C123.578 115.438 126.56 115.902 128.886 115.147C140.032 111.533 151.594 109.46 163.142 107.717C181.635 104.928 200.353 104.52 219.007 105.444C236.744 106.324 254.258 109.23 271.496 113.498C273.08 113.89 274.864 114.259 276 115.699C268.794 114.128 261.594 112.533 254.382 110.987C244.605 108.891 234.668 107.914 224.726 106.973C218.092 106.349 211.447 105.944 204.777 105.991C196.404 106.049 188.028 105.944 179.726 107.284L179.483 107.215L179.239 107.281C176.458 107.467 173.608 107.01 170.931 108.147V108.15Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M211.807 78C211.582 77.8542 211.36 77.7084 211.135 77.5627C211.185 77.2503 211.235 76.9379 211.285 76.6229C212.587 75.2874 211.504 74.0093 211.069 72.8014C209.223 67.6808 209.292 67.5376 215.149 67.0795C215.632 67.0404 216.12 67.056 216.609 67.056C226.096 67.0612 235.584 67.0482 245.072 67.0977C246.035 67.1029 247.262 66.5953 248 67.8448C246.482 69.274 243.648 67.3788 242.615 69.779C242.615 69.779 242.59 69.8935 242.593 69.8909C233.788 69.8597 224.981 69.917 216.176 69.753C213.089 69.6957 211.984 70.3882 212.925 73.4365C213.378 74.8996 214.596 77.0212 211.812 78H211.807Z',
  fill: '#FAD873'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191.962 72.4232L191.841 72.71C189.533 73.8546 190.341 76.3007 189.358 78C188.301 76.1817 188.673 74.32 189.249 72.4882C189.842 70.5968 189.137 69.8662 187.092 69.8824C177.557 69.9528 168.021 69.969 158.486 70.0069C158.242 69.969 158.022 69.8797 157.824 69.7417C157.635 69.3845 157.4 69.3656 157.125 69.6605C156.635 69.6253 156.148 69.5875 155.658 69.5523C155.699 68.497 154.218 68.7514 154 67.8963C154.851 67.274 155.782 67.0412 156.801 67.0412C166.821 67.0467 176.844 66.9114 186.857 67.1035C192.062 67.2036 192.119 67.5283 191.959 72.4286L191.962 72.4232Z',
  fill: '#FAD873'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M241.997 72.4249C241.837 72.4936 241.797 72.6005 241.872 72.743C238.996 74.6132 235.581 73.2901 232.511 74C227.025 73.9186 221.539 73.8448 216.055 73.7455C214.723 73.7226 212.888 73.9593 213.005 72.1756C213.114 70.5115 214.945 71.173 216.018 71.1603C224.631 71.0585 233.244 71.0433 241.857 71C241.906 71.4758 241.951 71.9491 242 72.4249H241.997Z',
  fill: '#FAD873'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M241.817 70.3638C242.833 67.6858 245.625 69.7974 247.116 68.2057C246.39 66.8144 245.182 67.3779 244.235 67.3721C234.899 67.3169 225.562 67.3315 216.226 67.3256C215.748 67.3256 215.268 67.3082 214.79 67.3518C209.026 67.863 208.958 68.0227 210.775 73.7361C211.203 75.0838 212.271 76.5099 210.988 78C210.419 76.2398 209.98 74.4186 209.261 72.7311C207.183 67.8543 207.338 67.4622 212.288 66.431C225.543 65.5567 238.766 66.0825 252 67.3779C248.919 69.9049 245.382 70.1954 241.815 70.3667L241.817 70.3638Z',
  fill: '#D8C990'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M192.068 72C192.228 67.5708 192.171 67.2773 186.986 67.1868C177.008 67.0131 167.025 67.1354 157.046 67.1305C156.031 67.1305 155.103 67.3384 154.256 67.9034C154.473 68.6738 155.948 68.4463 155.908 69.4002C153.942 69.2021 151.976 69.004 150.013 68.8034C150.013 68.8034 149.999 68.8352 149.999 68.8377C149.616 68.3241 149.014 68.2947 148.392 68.302C148.392 68.302 148.461 68.3338 148.458 68.3338C148.236 67.7297 147.713 67.4925 147.014 67.4729C147.011 67.2406 147.006 67.0082 147 66.7759C161.452 66.2232 175.901 65.5335 190.367 66.4384C191.728 66.6732 193.532 66.4384 193.886 68.0061C194.234 69.5518 193.831 71.0559 192.068 72Z',
  fill: '#D8C990'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M242.071 69.0919C245.825 68.9281 249.55 68.6507 252.789 66.2365C238.863 65.0016 224.949 64.4966 211 65.3318C211.811 63.8805 213.236 64.011 214.619 64.011C224.512 64.0165 234.408 63.9638 244.302 64.0498C246.903 64.072 249.501 64.5271 252.102 64.7435C253.036 64.8212 253.876 64.9295 253.985 66.0533C254.094 67.1633 253.608 67.9458 252.502 68.2677C250.711 68.7894 248.903 69.6469 247.101 69.6441C244.839 69.6385 243.451 70.7485 241.976 72C241.93 71.4811 241.881 70.965 241.835 70.4488C241.904 70.0381 241.973 69.6247 242.042 69.2112L242.068 69.0891L242.071 69.0919Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M190 66.3934C175.656 64.7671 161.327 66.0066 147 67C150.485 63.6418 154.523 64.7495 158.22 64.4242C167.059 63.6462 175.945 64.1781 184.811 64.1693C186.679 64.1693 188.472 64.5209 190 66.3934Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M175.794 81C170.161 79.1498 166.109 73.8047 160 73C162.568 73.1145 165.136 73.2261 167.704 73.3407C167.96 73.8076 168.215 74.2746 168.471 74.7386C169.588 78.3539 172.704 76.7269 174.913 77.4787C174.986 77.8282 175.058 78.1777 175.13 78.5301C174.733 79.3025 174.885 79.8664 175.686 80.1865C175.797 80.3656 175.9 80.5477 176 80.7357L175.792 81H175.794Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M188 81.3429C187.457 82.8953 186.917 84.4476 186.374 86C186.425 81.7777 183.949 81.7195 180.989 81.9553C179.352 82.087 177.518 82.6473 176 81.2756L176.213 81C180.142 81.1133 184.071 81.2266 188 81.3399V81.3429Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M232.966 74.3994C235.929 73.6062 239.225 75.0793 242 73C241.871 74.3909 240.967 75.0368 239.781 74.864C236.601 74.4023 234.051 75.3626 232.107 78L232 77.9094C232.73 77.2663 232.647 76.4023 232.6 75.5496C232.721 75.1671 232.845 74.7819 232.966 74.3994Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M231.997 78.0893C230.761 80.4977 227.536 78.8093 226.192 81L226.074 80.8772C226.049 80.3777 226.025 79.8809 226 79.3814C226.096 79.0298 226.189 78.6753 226.285 78.3237C228.155 78.2149 230.023 78.106 231.893 78L232 78.0893H231.997Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M213.294 83C213.194 82.6279 213.097 82.2522 213 81.8801C216.733 81.6798 220.492 82.5456 224.199 81.4222L225.877 81C225.877 81 226 81.1538 226 81.1574C225.583 83.3184 224.188 82.9034 222.989 82.9213C219.758 82.9714 216.525 82.9785 213.294 83Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M293 123C289.888 121.963 286.73 121.036 284 119.126C284.785 119.083 285.573 119.043 286.359 119C288.21 120.921 291.786 120.045 292.997 123H293Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M284 119C281.178 118.523 278.495 117.578 276 116.005C278.986 115.929 281.722 116.698 284 119Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M150 68C151.984 68.2772 153.964 68.5543 155.948 68.8349C156.44 68.8794 156.93 68.9273 157.422 68.9718L157.765 69.1189L158.128 69.0744C158.326 69.2489 158.548 69.3584 158.793 69.4098C158.862 69.7314 158.931 70.053 159 70.3747C158.882 70.9153 158.764 71.4594 158.646 72C157.183 70.45 155.372 70.2789 153.544 69.8306C152.381 69.5466 150.645 69.9949 150 68Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M159 72.1064C159.113 71.7384 159.226 71.368 159.34 71C159.558 71.1351 159.776 71.2702 159.994 71.4076C160.333 73.1359 161.948 73.1661 163.503 73.3036C165.005 73.4363 166.611 72.9076 168 73.788L167.906 74C165.355 73.9115 162.804 73.8207 160.253 73.7321L160.157 73.816C159.883 73.5854 159.607 73.3548 159.334 73.1242C159.224 72.7842 159.113 72.4464 159.003 72.1064H159Z',
  fill: '#D8C990'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M189.007 78.1118C190.191 76.1485 189.217 73.3224 192 72C191.758 73.9726 190.436 75.8109 191.12 77.896C190.443 78.6213 190.146 79.6624 189 80C189.003 79.3716 189.007 78.7401 189.01 78.1118H189.007Z',
  fill: '#D8C990'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M120 119.101C118.29 120.319 116.091 120.55 114 121C114.17 120.693 114.34 120.384 114.513 120.077C116.334 119.726 117.962 118.672 120 119.101Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M122 118.258C121.334 118.504 120.666 118.754 120 119C120.373 117.794 121.137 117.861 122 118.258Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M149 68.0013C149.385 67.9898 149.76 68.0397 150 68.8425C149.559 69.1651 149.197 69.0422 149 68.0013Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M147 67C147.968 67.0225 148.688 67.2947 149 67.9881C147.953 68.0471 147.099 67.9123 147 67Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M159 73C159.332 73.3333 159.664 73.6667 160 74C159.668 73.6667 159.336 73.3333 159 73Z',
  fill: '#42494B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M114 121C109.001 123.334 103.999 125.668 99 128C103.178 124.005 108.182 121.682 114 121Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M99 128.029C98.2702 129.14 97.1895 129.66 96 130C96.1056 127.836 97.5683 127.96 99 128.029Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M96 130.202C95.5291 131.187 94.8618 131.781 94.0008 132C93.9712 130.033 94.7811 129.715 96 130.202Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M94 132.13C93.5652 132.602 92.9409 132.924 92.001 133C91.973 132.163 92.5166 131.779 94 132.13Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M88 136.005C87.6059 136.883 87.0082 137.599 86 138C86.0263 136.84 86.3646 135.922 88 136.005Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M92 133.005C91.6754 133.668 91.3509 134.337 91.0288 135C90.8677 133.062 91.4094 132.971 92 133.005Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M89 135.018C88.6821 135.344 88.3598 135.67 88.0463 136C87.872 135.245 88.1899 134.915 89 135.018Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M299 126C296.866 125.259 294.803 124.382 293 123.029C295.626 122.865 297.911 123.326 299 126Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M306 131C304.811 130.38 303.792 129.422 303 128.018C304.573 127.888 305.809 128.415 306 131Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M303 127C301.759 126.893 300.712 126.611 300 126.026C301.428 125.963 302.822 125.929 303 127Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M309.999 133C309.103 132.816 308.408 132.502 308 132C309.149 132.018 310.033 132.209 309.999 133Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M311.953 135C311.302 134.67 310.651 134.336 310 134.005C311.53 133.954 312.19 134.284 311.953 135Z',
  fill: '#564F2E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M217 117.038C196.543 116.273 176.242 117.691 156 120C158.964 118.165 162.622 118.504 165.936 118.12C182.047 116.264 198.269 115.781 214.526 116.084C215.515 116.103 216.596 115.97 216.997 117.036L217 117.038Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M180 107.675C188.118 105.944 196.307 106.08 204.494 106.005C211.016 105.944 217.514 106.467 224 107.274C222.912 108.299 221.651 107.98 220.485 107.847C208.072 106.449 195.665 106.983 183.251 107.872C182.174 107.951 181.086 107.747 180 107.671V107.675Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M246 120C237.001 118.881 228.002 117.762 219 116.643C223.065 115.269 227.099 116.454 231.106 116.92C235.75 117.457 240.355 118.355 244.969 119.152C245.351 119.219 245.657 119.709 246 120Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M270 126C262 124 254 122 246 120C254.361 120.533 262.449 122.169 270 126Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M156 120.138C152.763 121.691 149.392 122.408 146 123C149.04 120.242 152.441 119.692 156 120.138Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M140 124.126C137.773 125.062 135.447 125.705 133 126C134.934 124.22 137.317 123.736 140 124.126Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M170 107.841C172.9 106.736 175.99 107.181 179 107C176.174 108.723 173.01 107.655 170 107.841Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M143 123.159C142.149 123.986 141.061 123.944 140 124C140.711 122.652 141.882 123.005 143 123.159Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M309.036 140.964C321.166 167.497 292.937 138.829 280.605 136.424C264.193 129.263 247.519 124.464 229.959 122.32C182.824 116.903 134.116 123.73 94.1253 152.551C87.6536 159.179 86.916 150.873 89.123 145.133C91.33 141.948 94.2548 139.342 97.1515 136.91C148.943 103.95 260.925 99.427 309.039 140.961L309.036 140.964Z',
  fill: '#14A399'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M146 122.522C144.804 123.893 143.428 124.11 142 123.959C143.002 121.328 144.499 121.905 146 122.522Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M194.584 95.9658L194.645 95.9972C196.129 91.4009 197.001 87.01 191.177 84.806C191.08 84.7689 191.1 84.4068 191 83.8137C195.957 85.0227 199.508 83.7595 200.184 78C200.596 78.2509 201.008 78.499 201.424 78.7499C202.179 83.1465 204.64 84.9057 208.932 84.019C209.572 83.8879 210.308 84.2671 211 84.4125L210.981 84.3269C206.804 86.6735 203.522 89.3908 206.693 94.9137C206.837 95.1646 206.621 95.6322 206.574 96L206.638 95.9515C202.769 91.9569 198.869 91.5435 194.916 95.8318C194.842 95.9116 194.698 95.9202 194.584 95.9629V95.9658Z',
  fill: '#F2F5F7'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M225.942 78.0518C225.845 78.3862 225.749 78.7232 225.654 79.0602C222.487 79.092 219.317 79.092 216.15 79.1663C215.031 79.1929 213.572 78.7019 213.237 80.4321C213.175 80.6179 213.13 80.8089 213.105 81C212.227 80.2649 210.989 79.7979 211 78.41C213.801 77.4096 212.574 75.2495 212.121 73.7582C211.173 70.6508 212.286 69.9449 215.395 70.0033C224.259 70.1731 233.133 70.1147 242 70.1439C241.933 70.5393 241.866 70.9347 241.799 71.3274C233.359 71.3699 224.916 71.3858 216.479 71.492C215.428 71.5052 213.633 70.8153 213.527 72.5508C213.413 74.4083 215.21 74.1615 216.516 74.1881C221.892 74.2916 227.265 74.3659 232.64 74.4534C232.517 74.8143 232.392 75.1726 232.269 75.5335C226.893 75.5627 221.517 75.5839 216.141 75.6317C215.319 75.6396 214.223 75.5282 214.193 76.6666C214.159 77.8315 215.255 77.7068 216.08 77.7493C219.364 77.9138 222.674 77.4096 225.942 78.0518Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M188.91 78.4249C188.91 78.9893 188.905 79.5566 188.902 80.121C188.688 80.4131 188.477 80.7079 188.264 81C188.058 80.986 187.853 80.9803 187.648 80.986C187.237 79.2505 185.847 79.6661 184.695 79.6408C181.54 79.5706 178.384 79.5425 175.229 79.4976C175.157 79.1634 175.085 78.8293 175.012 78.4923C177.985 77.7565 181.009 78.3547 183.998 78.1244C184.97 78.0486 186.557 78.6467 186.618 77.0713C186.682 75.4257 185.072 75.9228 184.106 75.9115C178.931 75.8582 173.755 75.8778 168.577 75.875C168.322 75.4285 168.066 74.9848 167.811 74.5383L167.905 74.2828C173.367 74.3165 178.828 74.3389 184.29 74.3979C185.713 74.412 187.326 74.3165 187.209 72.5417C187.09 70.6995 185.291 71.5364 184.262 71.5223C176.128 71.424 167.991 71.4353 159.858 71.4128C159.638 71.2471 159.419 71.0842 159.2 70.9214C159.133 70.6574 159.067 70.3934 159 70.1295C168.238 70.0929 177.477 70.0733 186.715 70.0003C188.697 69.9834 189.376 70.7444 188.805 72.7046C188.25 74.6057 187.886 76.5378 188.91 78.4249Z',
  fill: '#CCA22C'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M199.987 79.3215C199.314 84.58 195.776 85.7364 190.837 84.6321C190.937 85.1738 190.917 85.5046 191.014 85.5384C196.816 87.5517 195.947 91.5626 194.469 95.7611C193.518 96.3575 192.936 95.7116 192.31 95.1933C189.409 92.7893 188.265 88.7914 189.481 85.2936C190.821 81.4442 194.825 78.2979 198.586 78.0114C199.76 77.9229 200.08 78.3474 199.984 79.3189L199.987 79.3215Z',
  fill: '#3A4A6B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M194 96.2043C194.113 96.1612 194.256 96.1526 194.331 96.0721C198.263 91.7519 202.148 92.1684 206 96.1928C205.678 99.0423 203.247 98.5367 201.688 98.7263C198.899 99.0624 195.744 99.7001 194.003 96.2071L194 96.2043Z',
  fill: '#3A4A6B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M206.232 96C206.282 95.6219 206.514 95.1412 206.359 94.8832C202.96 89.2057 206.478 86.4123 210.954 84C213.562 88.8481 211.034 95.2702 206.232 96Z',
  fill: '#3A4A6B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M211 83.9978C210.297 83.8896 209.547 83.5995 208.9 83.6991C204.543 84.3702 202.042 83.0366 201.274 79.6982C201.69 79.1873 200.015 78.2044 201.971 78.0226C205.505 77.6935 210.578 81.0254 211 84V83.9978Z',
  fill: '#3A4A6B'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M188.358 81.0023C188.572 80.9963 188.786 81.0023 189 81.0173C188.769 81.3449 188.54 81.6724 188.309 82C184.314 81.8888 180.319 81.7806 176.324 81.6694C176.223 81.4771 176.113 81.2908 176 81.1075C180.119 81.0714 184.239 81.0384 188.358 81.0023Z',
  fill: '#D8C990'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M169 75.029C174.163 75.0353 179.329 75.0098 184.493 75.0704C185.453 75.0831 187.059 74.5189 186.998 76.387C186.937 78.1753 185.354 77.4995 184.385 77.5824C181.403 77.8438 178.385 77.1648 175.42 78C173.219 77.1871 170.116 78.95 169.003 75.0258L169 75.029Z',
  fill: '#FAD873'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M188 80.8761C183.93 80.9186 179.86 80.9575 175.79 81C174.967 80.6106 174.808 79.931 175.216 79C178.463 79.0566 181.714 79.0885 184.958 79.1805C186.144 79.2124 187.577 78.692 187.997 80.8761H188Z',
  fill: '#FAD873'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M226.33 78C222.898 77.235 219.428 77.8356 215.981 77.6396C215.113 77.589 213.966 77.7376 214.001 76.3498C214.033 74.9937 215.183 75.1233 216.045 75.117C221.687 75.0601 227.328 75.0379 232.969 75C233.019 75.9515 233.107 76.9125 232.329 77.6301C230.329 77.7534 228.331 77.8767 226.33 77.9968V78Z',
  fill: '#FAD873'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M224.29 81C220.525 80.8622 216.764 80.7243 213 80.5835C213.349 78.5865 214.868 79.1531 216.031 79.1225C219.327 79.0337 222.626 79.0337 225.921 79C225.948 79.5452 225.974 80.0934 226 80.6386L224.29 81Z',
  fill: '#FAD873'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M159 71.068C167.328 71.09 175.653 71.0817 183.978 71.1755C185.028 71.1865 186.869 70.3677 186.994 72.1762C187.113 73.9186 185.463 74.0151 184.006 73.9986C178.416 73.9407 172.827 73.9214 167.237 73.8855C165.808 72.8406 164.158 73.4692 162.613 73.3093C161.011 73.1467 159.349 73.1108 159.003 71.0652L159 71.068Z',
  fill: '#FAD873'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M312.24 135.537C313.66 136.226 313.332 138.305 314.918 138.862C314.944 142.308 314.972 145.753 315 149.196C305.196 141.666 294.619 135.478 282.998 131.116C281.522 130.562 280.139 129.646 278.454 129.766C275.584 128.618 272.717 127.469 269.847 126.321C262.349 122.575 254.312 120.976 246.007 120.455L246.001 120.499C245.654 120.202 245.343 119.707 244.957 119.642C240.283 118.835 235.621 117.931 230.914 117.384C226.856 116.914 222.77 115.715 218.652 117.104C217.933 117.062 217.213 117.023 216.493 116.981C216.098 115.72 215.035 115.877 214.061 115.855C198.057 115.493 182.087 116.065 166.227 118.264C162.962 118.715 159.364 118.317 156.443 120.488L156.454 120.443C152.715 120.096 149.148 120.527 145.956 122.693L145.652 122.74C144.664 122.477 143.682 122.233 143.024 123.357L143.075 123.326C141.929 123.172 140.73 122.819 140.002 124.166L139.722 124.208C137.002 123.76 134.586 124.312 132.625 126.346C126.117 128.906 119.325 130.8 113.235 134.329C110.271 136.047 106.973 137.167 104.289 139.366C99.3332 140.812 95.6928 144.529 91.2255 146.823C89.2867 147.818 87.6697 149.389 85.5108 150C85.3415 147.235 85.1693 144.47 85 141.705C85.3528 141.022 85.7027 140.338 86.0554 139.655C86.0554 139.655 86.0837 139.607 86.0809 139.607C86.2784 139.327 86.4787 139.047 86.6791 138.767L86.6622 138.781C86.8908 138.506 87.1194 138.235 87.3451 137.96L87.3338 137.977C88.2002 137.59 88.7138 136.893 89.0525 136.041C89.0525 136.041 89.1287 135.963 89.1259 135.963C89.3319 135.741 89.5379 135.517 89.7439 135.296L89.8342 135.215C90.0543 135.038 90.2716 134.865 90.4917 134.691C90.4917 134.691 90.6695 134.542 90.6695 134.54C91.042 134.209 91.4174 133.881 91.7927 133.554L91.7786 133.562C92.0523 133.332 92.3289 133.105 92.6026 132.876C92.6026 132.876 92.6026 132.892 92.5998 132.892C93.3561 132.789 93.8585 132.349 94.2084 131.705L94.3354 131.601C95.2356 131.43 95.9383 130.965 96.4321 130.195L96.5168 130.119C97.5948 129.828 98.5797 129.385 99.2429 128.43L99.2372 128.438C104.218 126.06 109.202 123.682 114.183 121.306L114.321 121.261C116.333 120.724 118.45 120.446 120.095 118.99L119.914 118.911L120.087 119.009C120.676 118.81 121.269 118.614 121.859 118.418C122.023 118.519 122.166 118.496 122.291 118.351C123.129 118.163 123.984 118.029 124.802 117.782C139.923 113.241 155.283 109.863 171.042 108.409C173.813 108.216 176.722 109.325 179.321 107.532L179.564 107.465L179.807 107.535C180.91 107.594 182.022 107.753 183.12 107.692C195.766 106.994 208.408 106.577 221.06 107.672C222.248 107.776 223.535 108.025 224.641 107.224C234.546 108.174 244.446 109.16 254.188 111.275C261.373 112.835 268.546 114.443 275.726 116.031C275.726 116.031 275.714 116.012 275.714 116.009C278.497 117.561 281.488 118.494 284.635 118.964L284.615 118.947C287.271 120.813 290.347 121.724 293.38 122.738L293.479 122.774C295.198 124.113 297.162 124.982 299.199 125.715C299.199 125.715 299.391 125.819 299.391 125.816C299.679 125.959 299.967 126.105 300.255 126.251L300.241 126.242C300.895 127.225 301.858 127.699 302.998 127.878L303.102 127.962C304.107 129.231 305.402 130.097 306.918 130.657L306.926 130.649C307.194 130.878 307.462 131.108 307.73 131.338L307.716 131.326C308.117 132.184 308.8 132.719 309.68 133.032C309.68 133.032 309.743 133.091 309.743 133.089C309.982 133.296 310.219 133.503 310.456 133.713L310.516 133.769C310.733 134.002 310.95 134.237 311.168 134.47C311.168 134.47 311.204 134.517 311.207 134.517C311.34 135.066 311.602 135.489 312.234 135.551L312.24 135.537Z',
  fill: '#F5B918'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M153.387 228.093C161.883 239.392 190.532 245.6 217.379 241.958C229.81 240.271 239.674 236.769 245.841 232.374C246.351 232.008 246.839 231.637 247.298 231.264C247.68 230.952 248.041 230.637 248.383 230.319C248.854 229.887 249.288 229.445 249.686 229.001C253.613 224.628 254.211 219.696 250.611 214.907C249.269 213.119 247.422 211.461 245.154 209.949C244.762 209.685 244.355 209.423 243.932 209.17C243.663 209.007 243.385 208.844 243.108 208.684C242.225 208.181 241.297 207.695 240.322 207.228C227.378 201.051 206.504 198.344 186.619 201.042C159.769 204.685 144.894 216.795 153.39 228.096L153.387 228.093Z',
  fill: '#13B1AB'
})));

const MicrophoneBobbin = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '200',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M200.865 350.952C251.358 350.952 292.291 343.951 292.291 335.315C292.291 326.68 251.358 319.679 200.865 319.679C150.371 319.679 109.438 326.68 109.438 335.315C109.438 343.951 150.371 350.952 200.865 350.952Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M74.9032 206.553C97.0377 276.217 171.374 314.727 240.942 292.56C273.156 282.3 298.696 260.822 314.633 233.804C315.954 231.564 317.212 229.285 318.398 226.973C319.383 225.06 320.317 223.127 321.2 221.169C322.419 218.508 323.536 215.802 324.562 213.066C334.702 186.172 336.2 155.799 326.823 126.274C323.322 115.259 318.521 105.024 312.624 95.6841C311.607 94.0543 310.547 92.4456 309.451 90.87C308.751 89.8566 308.034 88.8583 307.31 87.8691C305.013 84.7539 302.602 81.759 300.071 78.8813C266.458 40.7204 212.31 23.8485 160.787 40.2663C91.2159 62.4364 52.7686 136.879 74.9032 206.553Z',
  fill: '#F3C823'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M267.974 280.174C265.464 281.657 262.903 283.058 260.288 284.363C258.375 285.331 256.438 286.249 254.475 287.118C252.106 288.173 249.698 289.153 247.269 290.064C217.961 301.073 184.66 301.749 153.197 289.508C85.2378 263.086 51.5705 186.476 77.9897 118.402C81.4486 109.489 85.7632 101.169 90.8074 93.4922C80.0794 154.365 113.317 216.316 173.025 239.533C204.492 251.774 237.793 251.097 267.097 240.089C269.526 239.175 271.934 238.195 274.303 237.142C276.267 236.273 278.204 235.356 280.116 234.388C282.731 233.083 285.292 231.679 287.803 230.199C304.887 220.144 319.806 206.201 331.087 189.028C329.613 197.442 327.289 205.831 324.085 214.094C312.886 242.94 292.703 265.624 267.977 280.178L267.974 280.174Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M343.061 228.603C343.061 228.603 343.055 228.597 343.055 228.591H343.028L343.061 228.603Z',
  fill: '#8A5024'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.865 193.689C229.967 193.689 253.559 170.062 253.559 140.917C253.559 111.772 229.967 88.1458 200.865 88.1458C171.763 88.1458 148.171 111.772 148.171 140.917C148.171 170.062 171.763 193.689 200.865 193.689Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.865 189.179C229.967 189.179 253.559 165.552 253.559 136.407C253.559 107.262 229.967 83.6355 200.865 83.6355C171.763 83.6355 148.171 107.262 148.171 136.407C148.171 165.552 171.763 189.179 200.865 189.179Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.865 163.018C215.54 163.018 227.437 151.104 227.437 136.407C227.437 121.71 215.54 109.796 200.865 109.796C186.189 109.796 174.292 121.71 174.292 136.407C174.292 151.104 186.189 163.018 200.865 163.018Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M220.381 129.942C224.941 129.942 228.638 126.24 228.638 121.673C228.638 117.106 224.941 113.404 220.381 113.404C215.821 113.404 212.124 117.106 212.124 121.673C212.124 126.24 215.821 129.942 220.381 129.942Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M189.3 303.125C190.775 294.745 180.429 285.913 166.19 283.399C151.952 280.884 139.213 285.639 137.737 294.019C136.262 302.399 146.609 311.231 160.847 313.745C175.086 316.26 187.824 311.505 189.3 303.125Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M240.654 334.796C254.893 332.281 265.24 323.45 263.764 315.07C262.289 306.69 249.55 301.935 235.311 304.449C221.073 306.963 210.726 315.795 212.202 324.175C213.677 332.555 226.416 337.31 240.654 334.796Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M366.327 177.963C368.837 163.703 364.089 150.946 355.722 149.468C347.354 147.991 338.535 158.353 336.024 172.612C333.514 186.872 338.262 199.629 346.63 201.107C354.997 202.584 363.816 192.223 366.327 177.963Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M53.3701 201.109C61.7379 199.631 66.486 186.874 63.9753 172.614C61.4647 158.355 52.646 147.993 44.2782 149.471C35.9105 150.948 31.1624 163.706 33.673 177.965C36.1836 192.225 45.0023 202.586 53.3701 201.109Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M227.422 206.55C227.929 206.55 228.338 206.974 228.32 207.482C227.827 222.742 215.319 234.965 199.961 234.965C184.603 234.965 172.095 222.745 171.602 207.482C171.587 206.974 171.993 206.55 172.5 206.55H227.422Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M227.119 214.957C223.591 226.624 212.767 235.116 199.964 235.116C198.982 235.116 198.009 235.064 197.055 234.968C197.049 230.47 198.625 225.569 201.814 221.254C208.425 212.305 219.462 209.256 226.467 214.443C226.692 214.608 226.909 214.783 227.119 214.957Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M228.32 207.56C228.191 210.856 227.431 214.01 226.143 216.924H176.556C175.472 216.924 174.593 216.142 174.593 215.177V206.55H227.227C227.845 206.55 228.341 207.01 228.32 207.56Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M109.414 93.4922H102.869V348.54H109.414V93.4922Z',
  fill: '#16181F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M107.42 93.4922H104.148V348.54H107.42V93.4922Z',
  fill: '#374350'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M108.072 93.4922H104.799V348.54H108.072V93.4922Z',
  fill: '#273037'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M88.8378 347.981H124.03C128.996 347.981 133.032 352.019 133.032 356.996V362.591C133.032 363.923 131.954 365.003 130.624 365.003H82.2473C80.9171 365.003 79.8392 363.923 79.8392 362.591V356.996C79.8392 352.022 83.8716 347.981 88.8408 347.981H88.8378Z',
  fill: '#273037'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M133.032 361.407C133.032 363.391 131.425 365 129.444 365H126.468C128.45 365 130.056 363.391 130.056 361.407C130.056 357.699 128.558 354.343 126.129 351.911C123.7 349.478 120.349 347.978 116.647 347.978H119.623C123.325 347.978 126.682 349.478 129.105 351.911C131.528 354.343 133.032 357.699 133.032 361.407Z',
  fill: '#16181F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M88.8378 347.981H113.401V362.588C113.401 363.921 112.323 365 110.993 365H82.2473C80.9171 365 79.8392 363.921 79.8392 362.588V356.993C79.8392 352.019 83.8716 347.978 88.8408 347.978L88.8378 347.981Z',
  fill: '#374350'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M100.674 225.133H112.191V238.964C112.191 242.149 109.612 244.732 106.433 244.732C103.253 244.732 100.674 242.149 100.674 238.964V225.133Z',
  fill: '#374350'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.194 225.133V238.961C112.194 242.149 109.618 244.732 106.436 244.732C106.105 244.732 105.778 244.705 105.463 244.648C108.18 244.184 110.249 241.815 110.249 238.961V225.133H112.194Z',
  fill: '#16181F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.191 236.661V239.031C112.191 242.215 109.615 244.798 106.433 244.798C103.25 244.798 100.674 242.215 100.674 239.031V236.661C100.674 239.848 103.253 242.428 106.433 242.428C109.612 242.428 112.191 239.848 112.191 236.661Z',
  fill: '#273037'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M133.071 222.658L132.32 223.034L130.375 224.011L78.3681 250.129C76.0021 251.32 73.1227 250.403 71.8766 248.063L70.8137 246.067C69.6308 243.848 70.3243 241.093 72.4111 239.701L120.115 207.846L122.046 206.559L123.28 205.735C125.625 204.168 128.804 204.911 130.213 207.356L135.107 215.847C136.512 218.283 135.578 221.398 133.071 222.658Z',
  fill: '#374350'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M133.05 222.658L132.299 223.034L130.354 224.011L78.3471 250.129C75.9811 251.32 73.1017 250.403 71.8556 248.06L70.7928 246.067C70.5075 245.532 70.3304 244.969 70.2583 244.398L70.4355 244.729C71.6785 247.068 74.5609 247.985 76.9239 246.795L128.933 220.676L130.879 219.699L131.63 219.323C133.494 218.385 134.488 216.422 134.296 214.476L135.086 215.847C136.491 218.283 135.557 221.398 133.05 222.658Z',
  fill: '#323B44'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M149.182 220.526C145.838 222.676 142.003 223.428 138.358 222.934C137.83 222.862 137.358 222.565 137.076 222.111L125.42 203.365C125.147 202.923 125.072 202.382 125.237 201.889C126.378 198.446 128.681 195.37 131.996 193.301C139.598 188.559 149.621 190.95 154.266 198.654C158.911 206.357 156.479 215.841 149.185 220.526H149.182Z',
  fill: '#16181F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M156.013 211.117C155.749 208.408 154.893 205.717 153.404 203.248C148.198 194.612 137.238 191.662 128.486 196.257C129.486 195.132 130.657 194.134 131.996 193.301C139.598 188.559 149.621 190.95 154.263 198.654C156.599 202.526 157.1 207.031 156.013 211.117Z',
  fill: '#273037'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M137.557 221.831C137.782 222.192 137.584 222.667 137.169 222.76L136.166 222.989C135.497 223.139 134.785 222.835 134.398 222.231L129.153 214.046L124.132 205.72C123.76 205.103 123.802 204.334 124.234 203.795L124.88 202.993C125.147 202.662 125.661 202.692 125.886 203.053L137.56 221.828L137.557 221.831Z',
  fill: '#A3A5AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M151.499 219.442L134.179 191.586C133.875 191.099 133.235 190.949 132.748 191.253C132.261 191.557 132.112 192.198 132.415 192.686L149.735 220.542C150.038 221.03 150.679 221.179 151.166 220.875C151.653 220.571 151.802 219.93 151.499 219.442Z',
  fill: '#A3A5AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M140.942 202.465L151.497 219.442C151.801 219.93 151.651 220.572 151.165 220.875C150.678 221.179 150.037 221.03 149.734 220.542L139.178 203.565L140.942 202.465Z',
  fill: '#374350'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M118.131 222.683C119.854 221.686 120.444 219.48 119.449 217.754C118.455 216.028 116.251 215.437 114.528 216.433L108.893 219.691C107.17 220.687 106.579 222.894 107.574 224.62C108.569 226.346 110.773 226.937 112.496 225.941L118.131 222.683Z',
  fill: '#262D33'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M119.629 218.072C118.56 216.617 116.53 216.166 114.93 217.089L109.297 220.345C107.697 221.269 107.072 223.259 107.796 224.916C107.715 224.811 107.643 224.696 107.573 224.579C106.583 222.859 107.177 220.64 108.895 219.648L114.527 216.391C116.245 215.399 118.458 215.994 119.448 217.711C119.518 217.829 119.578 217.949 119.629 218.072Z',
  fill: '#32393F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M112.498 225.938C114.222 224.942 114.812 222.735 113.817 221.009C112.822 219.283 110.618 218.692 108.895 219.688C107.172 220.685 106.581 222.891 107.576 224.617C108.571 226.343 110.775 226.934 112.498 225.938Z',
  fill: '#3C474F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M114.311 222.814C114.311 224.062 113.666 225.274 112.51 225.941C111.942 226.269 111.324 226.426 110.711 226.426C109.465 226.426 108.255 225.779 107.589 224.621C107.552 224.561 107.522 224.501 107.492 224.438C108.18 225.463 109.318 226.032 110.486 226.032C111.095 226.032 111.714 225.875 112.281 225.548C113.437 224.88 114.086 223.665 114.086 222.417C114.086 221.882 113.966 221.341 113.717 220.836C113.756 220.893 113.792 220.953 113.828 221.013C114.155 221.581 114.311 222.201 114.311 222.814Z',
  fill: '#475259'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M106.433 97.0735C108.636 97.0735 110.423 95.2843 110.423 93.0773C110.423 90.8702 108.636 89.0811 106.433 89.0811C104.229 89.0811 102.442 90.8702 102.442 93.0773C102.442 95.2843 104.229 97.0735 106.433 97.0735Z',
  fill: '#16181F'
})));

const BobbinParking = () => ( /*#__PURE__*/React__default.createElement("svg", {
  id: 'Layer_2',
  "data-name": 'Layer 2',
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 1813.86 1219.27',
  height: '250',
  width: '250'
}, /*#__PURE__*/React__default.createElement("g", {
  id: 'Layer_1-2',
  "data-name": 'Layer 1'
}, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M1758.08,809.17c11.71.12,23.6-.94,34.69,4.06,8.58,3.87,14.76,10.19,18.09,19.12.57,1.53.69,3.44,3.01,3.43v45.63c-3.04.19-3.26,2.96-4.3,4.87-6.94,12.79-17.51,19.4-32.2,19.23-6.32-.08-12.64,0-18.97,0-1.66-2.56-4.24-1.31-6.36-1.31-29.36-.09-58.72-.06-88.08-.06-35.91,0-71.81-.07-107.72.09-4.03.02-5.43-.99-5.44-5.13,0-5.68-.6-11.38-1.26-17.03-3.03-25.93-12.04-49.79-25.25-72.18,2.52-.11,5.05-.32,7.57-.32,72.88-.02,145.76-.01,218.64-.03,2.52,0,5.04-.24,7.56-.37Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e24d4c',
  d: 'M641.95.03c5.91.01,11.81.03,17.72.03,168.28,0,336.56,0,504.84,0,3.37,0,6.75-.04,10.12-.06,24.95,3.05,41.82,16.62,53.28,38.75,64.08,123.81,128.53,247.43,192.65,371.22,2.83,5.46,5.85,7.36,12.01,7.3,29.8-.32,59.62-.57,89.4.11,57.24,1.3,107.18,21.94,149.53,60.01,52.02,46.76,79.82,105.78,85.52,175.3,2.28,27.83.7,55.74.98,83.61.25,24.29.07,48.59.07,72.88-2.52.13-5.04.37-7.56.37-72.88.02-145.76.01-218.64.03-2.52,0-5.05.21-7.57.33-11.16-16.99-24.26-32.27-40.17-45.03-30.37-24.36-65.28-36.83-103.92-39.5-.04-71.62-.08-143.23-.12-214.85,0-1.69-.12-3.39.02-5.07.27-3.35-1.29-4.46-4.49-4.38-6.13.14-12.26.04-18.39.04q-8.84,0-8.84,8.86c-.03,72.25-.07,144.5-.1,216.75-1.64.4-3.26.91-4.92,1.18-36.71,6-68.37,22.04-95.28,47.65-18.81,17.9-32.48,39.23-42.6,62.98-3.17-.05-6.34-.15-9.51-.16-159.57,0-319.14,0-478.71,0q-8.11,0-8.11-8.31c0-106.88,0-213.76,0-320.64,0-1.69-.12-3.39.02-5.07.27-3.3-1.16-4.5-4.43-4.42-6.34.16-12.68.04-19.02.04q-8.26,0-8.27,8.12c0,106.25,0,212.49,0,318.74q0,11.53-11.23,11.54c-30.22.05-60.44.11-90.66.17-1-2.09-2.06-4.14-2.98-6.26-39.39-90.76-147.69-132.14-237.51-90.87-33,15.16-58.73,38.45-78.48,68.66-2.51-.16-5.02-.46-7.53-.47-55.94-.03-111.88-.02-167.82-.04-2.52,0-5.04-.23-7.56-.36,7.21-66,20.97-130.73,38.61-194.63,27.98-101.38,62.95-200.26,108.62-295.13,26.76-55.58,55.93-110,95.33-157.84C385.18,77.88,473.46,26.28,580.28,6.63c20.39-3.75,40.98-5.6,61.67-6.6ZM1638.82,661.57c12.11.05,21.37-5.82,28.96-14.52,20.33-23.3,21.29-64.5,2.07-88.74-7.87-9.93-17.54-16.99-30.99-16.96-3.85-9.58-11.44-12.53-21.07-11.85-10.33-.15-20.66-.26-30.99-.48-3.27-.07-3.76,1.78-3.76,4.44.03,45.14.05,90.28-.04,135.42,0,3.62,1.34,4.78,4.84,4.7,9.91-.24,19.83-.23,29.74-.32,9.76.99,17.36-1.97,21.23-11.68ZM414.93,383c11.85-.06,23.7-.12,35.55-.18,43.53.07,87.07.15,130.6.21,13.53.02,27.06.16,40.58-.05,11.68-.18,17.92-6.61,17.99-18.15.07-10.98.04-21.97.01-32.95-.08-34-.17-68-.26-102,.24-.27.31-.58.21-.92,1.17-.92.99-2.24.96-3.47-.39-18.4-.81-36.8-1.22-55.21,1.22-1.62,1.3-3.47,1.3-5.41-.02-31.89-.02-63.79-.01-95.68,0-2.58-.23-5.04-2.39-6.85-4.34-8.23-11.55-11.59-20.5-9.11-9.14,2.53-18.18,5.4-27.26,8.15-50.39,15.29-97.25,37.64-137.72,71.66-47.12,39.62-87.34,85.74-123.11,135.72-17.96,25.1-32.94,51.97-45.59,80.12,0,0,.07-.04.07-.04-.31.49-.62.98-.93,1.47-1.7,2.89-3.58,5.69-5.08,8.68-6.17,12.3,1.13,24.03,15.12,24.23,10.14.15,20.29.08,30.43.02,17.74-.1,35.48-.27,53.21-.41,12.68.06,25.35.11,38.03.17ZM1069.29,382.94c74.53.03,149.05.09,223.58.08,22.68,0,33.94-18.35,23.63-38.55-16.37-32.09-32.86-64.12-49.34-96.15-3.65-7.09-7.5-14.08-11.26-21.12-4.74-9.66-9.49-19.33-14.23-28.99-1.49-2.75-3.03-5.48-4.46-8.26-10.78-20.9-21.54-41.81-32.31-62.71-10.88-21.11-21.73-42.24-32.69-63.31-1.14-2.2-2.61-4.35-5.01-5.53-4.68-4.56-10.46-5.96-16.79-5.96-138.61.01-277.22,0-415.84.03-15.16,0-25.42,10.27-25.42,25.51-.05,93.13-.05,186.25,0,279.38,0,15.09,10.28,25.53,25.43,25.63,24.08.16,48.16-.02,72.23-.05,3.99.09,7.98.26,11.96.24,27.73-.1,55.47-.23,83.2-.35,44.38.04,88.76.08,133.14.11,11.39,0,22.78,0,34.17.01ZM813.09,561.98c-13.5,0-27-.02-40.5,0-11.5.02-17.82,5.95-17.8,16.6.02,9.76,7.02,16.33,17.54,16.34,27.21.03,54.42.03,81.63,0,10.54-.01,17.54-6.59,17.57-16.4.03-10.2-6.51-16.5-17.3-16.54-13.71-.05-27.42-.01-41.13-.01Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#4f4e4f',
  d: 'M1205.49,838.51c10.13-23.74,23.79-45.08,42.6-62.98,26.91-25.61,58.57-41.64,95.28-47.65,1.66-.27,3.28-.78,4.92-1.18,10.64-.45,21.29-.9,31.93-1.35,38.63,2.67,73.55,15.14,103.92,39.5,15.91,12.76,29.01,28.04,40.17,45.03,13.2,22.38,22.21,46.25,25.25,72.18.66,5.65,1.25,11.35,1.26,17.03,0,4.15,1.4,5.15,5.44,5.13,35.91-.16,71.81-.09,107.72-.09,29.36,0,58.72-.03,88.08.06,2.11,0,4.69-1.25,6.36,1.31-1.95,17.57-13.5,27.99-31.39,28-68.27.04-136.54.07-204.81-.09-5.01-.01-7.07,1.06-8.42,6.33-17.97,70.32-82.71,116.13-155,110.03-60.7-5.12-113.83-50.38-128.16-109.52-1.26-5.21-3-6.87-8.51-6.86-221.08.16-442.17.16-663.25,0-5.59,0-7.2,1.76-8.45,6.94-13.88,57.14-63.56,101.2-121.93,108.54-75.18,9.45-143.76-37.28-161.59-110.38-1.09-4.48-3-5.02-6.83-5.01-58.97.09-117.94.07-176.91.06-16.5,0-27.27-7.28-31.35-21.19-.65-2.2-.83-4.54-1.23-6.81,3.05-2.85,6.79-1.29,10.15-1.3,54.45-.13,108.9-.11,163.34-.04,3.69,0,6.33.17,6.19-4.99-.16-5.86.62-11.78,1.31-17.64,3.02-25.69,12.05-49.31,25.03-71.53,19.75-30.2,45.48-53.49,78.48-68.66,89.82-41.27,198.12.11,237.51,90.87.92,2.12,1.98,4.18,2.98,6.26,6.44,18.8,11.87,37.88,11.7,57.93-.05,6.52,1.85,7.9,8.14,7.9,196.75-.18,393.51-.14,590.26-.14,1.27,0,2.54-.1,3.8.01,2.95.26,4.18-.93,4.13-3.97-.3-21.39,5.02-41.71,11.89-61.73ZM1308.92,921.48c-.44,6.9.82,14.23,3.01,21.21,3.26,10.42,6.38,21.38,16.17,27.86,18.4,12.17,38.68,16.46,60.32,11.73,46.59-10.18,73.88-56.6,59.79-102.03-3.27-10.55-7.24-21.37-17.72-27.58-17.13-10.14-35.75-13.61-55.21-10.41-38,6.26-66.36,40.25-66.36,79.22ZM346.27,922.2c-.96,9.31,1.34,19.16,5.27,28.55,2.79,6.69,4.94,14.14,11.38,18.49,17.21,11.62,35.9,16.91,56.91,13.79,48.35-7.18,79.16-53.93,65.69-100.79-3.57-12.4-8.33-24.57-20.83-31.21-16.52-8.77-34.13-11.75-52.54-8.75-38.11,6.21-67.83,42.62-65.87,79.92Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M256.59,810.04c-12.98,22.23-22,45.84-25.03,71.53-.69,5.86-1.47,11.77-1.31,17.64.14,5.16-2.5,4.99-6.19,4.99-54.45-.08-108.9-.09-163.34.04-3.35,0-7.09-1.56-10.15,1.3-4.43,0-8.93-.49-13.29.05-19.2,2.38-38.74-16.78-37.19-37.26.57-7.55.59-15.23-.01-22.78-1.23-15.52,13.7-33.45,31.3-35.34,14.14-1.52,28.22-.42,42.31-1.02,2.52.13,5.04.36,7.56.36,55.94.02,111.88,0,167.82.04,2.51,0,5.02.3,7.53.47Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M806.81,382.93c-24.08.03-48.16.21-72.23.05-15.15-.1-25.43-10.54-25.43-25.63-.05-93.13-.05-186.25,0-279.38,0-15.24,10.26-25.5,25.42-25.51,138.61-.03,277.22-.02,415.84-.03,6.33,0,12.11,1.4,16.79,5.96-10.42,9.43-20.83,18.85-31.25,28.28-13.57,12.27-27.07,24.63-40.73,36.8-17.89,15.94-35.96,31.67-53.84,47.62-13.81,12.32-27.38,24.92-41.19,37.23-17.73,15.8-35.67,31.36-53.39,47.17-13.97,12.46-27.7,25.19-41.64,37.68-19.25,17.26-38.57,34.45-57.93,51.59-9.28,8.22-18.96,16-27.97,24.5-4.45,4.19-10.06,7.54-12.44,13.68Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#c33d3c',
  d: 'M1205.49,838.51c-6.87,20.02-12.19,40.34-11.89,61.73.04,3.04-1.18,4.23-4.13,3.97-1.26-.11-2.53-.01-3.8-.01-196.75,0-393.51-.03-590.26.14-6.29,0-8.19-1.38-8.14-7.9.17-20.05-5.26-39.13-11.7-57.93,30.22-.06,60.44-.12,90.66-.17q11.23-.02,11.23-11.54c0-106.25,0-212.49,0-318.74q0-8.12,8.27-8.12c6.34,0,12.68.12,19.02-.04,3.27-.08,4.7,1.12,4.43,4.42-.14,1.68-.02,3.38-.02,5.07,0,106.88,0,213.76,0,320.64q0,8.3,8.11,8.31c159.57,0,319.14,0,478.71,0,3.17,0,6.34.1,9.51.16Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#fff',
  d: 'M638.25,62.35c2.16,1.81,2.39,4.27,2.39,6.85-.01,31.89-.01,63.79.01,95.68,0,1.93-.09,3.79-1.3,5.41-.79.25-1.76.28-2.36.77-18.43,14.91-36.82,29.88-55.22,44.82-17.43,14.14-34.87,28.26-52.3,42.4-18.41,14.93-36.83,29.86-55.23,44.81-19.38,15.74-38.8,31.42-58.07,47.29-13.11,10.8-26.8,20.89-39.26,32.46-17.74.14-35.48.31-53.21.41-10.14.06-20.29.13-30.43-.02-13.99-.2-21.29-11.93-15.12-24.23,1.5-2.99,3.38-5.79,5.08-8.68.31-.49.62-.98.93-1.47,0,0-.07.04-.07.04,1.64.26,2.74-.66,3.92-1.63,16.74-13.69,33.47-27.39,50.28-41,18.76-15.18,37.67-30.19,56.4-45.42,21.66-17.62,43.15-35.45,64.79-53.09,17.25-14.06,34.65-27.92,51.91-41.96,21.18-17.22,42.17-34.66,63.44-51.76,21.26-17.08,42.66-34,63.43-51.69Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#fff',
  d: 'M806.81,382.93c2.38-6.14,7.99-9.48,12.44-13.68,9.01-8.49,18.69-16.28,27.97-24.5,19.36-17.14,38.67-34.33,57.93-51.59,13.94-12.49,27.67-25.23,41.64-37.68,17.73-15.8,35.66-31.37,53.39-47.17,13.82-12.31,27.38-24.91,41.19-37.23,17.88-15.95,35.95-31.68,53.84-47.62,13.66-12.17,27.16-24.52,40.73-36.8,10.42-9.42,20.83-18.85,31.25-28.28,2.4,1.18,3.87,3.33,5.01,5.53,10.96,21.07,21.81,42.2,32.69,63.31-12.03,10.18-24.05,20.36-36.08,30.53-14.28,12.07-28.54,24.16-42.86,36.19-17.53,14.72-35.14,29.35-52.66,44.08-14.63,12.31-29.14,24.75-43.77,37.06-17.52,14.74-35.11,29.39-52.66,44.09-12.56,10.52-25.16,20.99-37.64,31.6-12.48,10.61-24.84,21.36-37.25,32.05-27.73.12-55.47.25-83.2.35-3.99.01-7.98-.16-11.96-.24Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M901.98,382.82c12.41-10.69,24.77-21.44,37.25-32.05,12.48-10.61,25.08-21.08,37.64-31.6,17.55-14.7,35.14-29.35,52.66-44.09,14.63-12.31,29.14-24.75,43.77-37.06,17.52-14.73,35.13-29.36,52.66-44.08,14.32-12.03,28.58-24.12,42.86-36.19,12.03-10.17,24.06-20.35,36.08-30.53,10.77,20.91,21.53,41.82,32.31,62.71,1.43,2.78,2.97,5.51,4.46,8.26-6.68,2.66-10.89,8.37-16.04,12.93-17.77,15.74-35.64,31.38-53.37,47.17-13.5,12.02-26.8,24.28-40.29,36.32-18.65,16.66-37.37,33.24-56.1,49.81-9.75,8.63-19.89,16.85-29.26,25.87-4.05,3.9-10.05,6.29-11.48,12.63-44.38-.04-88.76-.08-133.14-.11Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M1255.89,227.19c3.76,7.04,7.61,14.03,11.26,21.12,16.49,32.03,32.97,64.06,49.34,96.15,10.31,20.2-.95,38.55-23.63,38.55-74.53.01-149.05-.05-223.57-.08,8.74-5.55,16.14-12.78,24.09-19.3,13.96-11.46,27.73-23.14,41.61-34.7,16.62-13.84,33.25-27.66,49.89-41.47,16.64-13.81,33.47-27.4,49.86-41.5,7.13-6.14,15.33-11.13,21.14-18.77Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M638.25,62.35c-20.77,17.69-42.16,34.61-63.43,51.69-21.28,17.09-42.27,34.54-63.44,51.76-17.26,14.04-34.66,27.9-51.91,41.96-21.64,17.64-43.13,35.47-64.79,53.09-18.73,15.23-37.64,30.23-56.4,45.42-16.81,13.6-33.54,27.31-50.28,41-1.18.97-2.28,1.88-3.92,1.63,12.65-28.15,27.63-55.02,45.59-80.12,35.77-49.98,75.98-96.1,123.11-135.72,40.47-34.02,87.33-56.38,137.72-71.66,9.08-2.75,18.12-5.62,27.26-8.15,8.95-2.48,16.16.88,20.5,9.11Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M639.4,229.88c.09,34,.18,68,.26,102,.02,10.98.05,21.97-.01,32.95-.07,11.54-6.3,17.97-17.99,18.15-13.52.21-27.05.07-40.58.05-43.53-.06-87.07-.14-130.6-.21,9.37-7.76,18.71-15.56,28.13-23.26,21.13-17.29,42.26-34.57,63.46-51.77,23.8-19.31,47.6-38.65,71.58-57.74,8.53-6.79,16.51-14.29,25.76-20.16Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#fff',
  d: 'M1255.89,227.19c-5.82,7.63-14.01,12.63-21.14,18.77-16.39,14.1-33.22,27.69-49.86,41.5-16.64,13.81-33.28,27.63-49.89,41.47-13.88,11.56-27.65,23.25-41.61,34.7-7.95,6.52-15.35,13.75-24.09,19.3-11.39,0-22.78,0-34.17,0,1.43-6.34,7.43-8.73,11.48-12.63,9.37-9.02,19.51-17.24,29.26-25.87,18.73-16.57,37.45-33.15,56.1-49.81,13.49-12.04,26.78-24.3,40.29-36.32,17.73-15.79,35.6-31.42,53.37-47.17,5.15-4.56,9.36-10.27,16.04-12.93,4.74,9.66,9.49,19.33,14.23,28.99Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M376.9,382.83c12.46-11.58,26.15-21.67,39.26-32.46,19.27-15.87,38.7-31.55,58.07-47.29,18.4-14.95,36.82-29.88,55.23-44.81,17.43-14.14,34.88-28.25,52.3-42.4,18.41-14.94,36.79-29.91,55.22-44.82.6-.49,1.56-.52,2.36-.77.41,18.4.82,36.8,1.22,55.21.03,1.22.21,2.55-.96,3.47,0-9.43,0-18.86,0-30.06-10.01,8.07-18.78,15.08-27.49,22.16-19.05,15.49-38.02,31.08-57.11,46.52-20.88,16.89-41.88,33.62-62.78,50.5-21.71,17.53-43.49,34.99-64.92,52.85-4.37,3.64-10.3,5.99-12.38,12.07-12.68-.06-25.35-.11-38.03-.17Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#c33d3c',
  d: 'M1380.22,725.36c-10.64.45-21.28.9-31.93,1.35.03-72.25.06-144.5.1-216.75q0-8.85,8.84-8.86c6.13,0,12.26.11,18.39-.04,3.21-.07,4.77,1.03,4.49,4.38-.14,1.68-.02,3.38-.02,5.07.04,71.62.08,143.23.12,214.85Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#fff',
  d: 'M414.93,383c2.08-6.08,8.01-8.43,12.38-12.07,21.43-17.87,43.21-35.32,64.92-52.85,20.89-16.87,41.9-33.61,62.78-50.5,19.09-15.44,38.06-31.03,57.11-46.52,8.71-7.08,17.48-14.09,27.49-22.16,0,11.21,0,20.63,0,30.06.1.35.03.65-.21.92-9.25,5.87-17.23,13.38-25.76,20.16-23.98,19.09-47.77,38.42-71.58,57.74-21.2,17.2-42.33,34.48-63.46,51.77-9.42,7.7-18.75,15.51-28.13,23.26-11.85.06-23.7.12-35.55.18Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#c33d3c',
  d: 'M1617.6,673.25c-9.91.09-19.83.09-29.74.33-3.5.08-4.84-1.08-4.84-4.7.08-45.14.06-90.28.04-135.42,0-2.67.48-4.51,3.76-4.44,10.33.22,20.66.33,30.98.48-.07,47.92-.13,95.83-.2,143.75Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#fed400',
  d: 'M1638.86,541.36c13.44-.03,23.12,7.04,30.99,16.96,19.22,24.24,18.27,65.44-2.07,88.74-7.59,8.69-16.85,14.57-28.96,14.52.64-40.07.56-80.15.04-120.22Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#c33d3c',
  d: 'M813.09,561.98c13.71,0,27.42-.04,41.13.01,10.79.04,17.34,6.34,17.3,16.54-.03,9.81-7.02,16.39-17.57,16.4-27.21.03-54.42.03-81.63,0-10.52-.01-17.51-6.59-17.54-16.34-.02-10.65,6.3-16.57,17.8-16.6,13.5-.03,27,0,40.5,0Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#4f4e4f',
  d: 'M1638.86,541.36c.52,40.07.6,80.15-.04,120.22-3.87,9.71-11.46,12.67-21.23,11.68.07-47.92.13-95.84.2-143.75,9.63-.67,17.22,2.27,21.07,11.86Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e4e7',
  d: 'M284.14,348.84c-.31.49-.62.98-.93,1.47.31-.49.62-.98.93-1.47Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#818080',
  d: 'M1308.92,921.48c0-38.97,28.35-72.97,66.36-79.22,19.47-3.2,38.09.27,55.21,10.41,10.48,6.21,14.45,17.03,17.72,27.58,14.08,45.44-13.2,91.85-59.79,102.03-21.64,4.73-41.92.43-60.32-11.73-9.8-6.48-12.91-17.44-16.17-27.86-2.18-6.98-3.45-14.31-3.01-21.21Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#818080',
  d: 'M346.27,922.2c-1.96-37.3,27.76-73.71,65.87-79.92,18.41-3,36.02-.02,52.54,8.75,12.5,6.64,17.27,18.81,20.83,31.21,13.48,46.86-17.34,93.61-65.69,100.79-21,3.12-39.7-2.17-56.91-13.79-6.44-4.35-8.58-11.8-11.38-18.49-3.92-9.39-6.23-19.24-5.27-28.55Z'
})), /*#__PURE__*/React__default.createElement("path", {
  fill: '#27aae1',
  d: 'M275.21,788.1c73.72,231.68,321.3,359.75,553,286.03,107.29-34.12,192.35-105.55,245.43-195.4,4.4-7.45,8.59-15.03,12.54-22.72,3.28-6.36,6.39-12.79,9.33-19.3,4.06-8.85,7.78-17.85,11.2-26.95,33.77-89.44,38.76-190.45,7.53-288.64-11.66-36.63-27.65-70.67-47.29-101.73-3.39-5.42-6.92-10.77-10.57-16.01-2.33-3.37-4.72-6.69-7.13-9.98-7.65-10.36-15.68-20.32-24.11-29.89-111.97-126.92-292.3-183.04-463.9-128.44-231.71,73.74-359.77,321.3-286.05,553.02Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#4a94c6',
  d: 'M916.28,1035.38c-8.36,4.93-16.89,9.59-25.6,13.93-6.37,3.22-12.82,6.27-19.36,9.16-7.89,3.51-15.91,6.77-24,9.8-97.61,36.61-208.52,38.86-313.31-1.85-226.33-87.88-338.47-342.66-250.48-569.06,11.52-29.64,25.89-57.31,42.69-82.84-35.73,202.44,74.97,408.47,273.83,485.68,104.8,40.71,215.71,38.46,313.31,1.85,8.09-3.04,16.11-6.3,24-9.8,6.54-2.89,12.99-5.94,19.36-9.16,8.71-4.34,17.24-9.01,25.6-13.93,56.9-33.44,106.59-79.81,144.16-136.92-4.91,27.98-12.65,55.88-23.32,83.36-37.3,95.93-104.52,171.37-186.87,219.77Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#8a5024',
  d: 'M1166.35,863.88s-.02-.02-.02-.04h-.09s.11.04.11.04Z'
}), /*#__PURE__*/React__default.createElement("circle", {
  fill: '#4a94c6',
  cx: '692.76',
  cy: '572.26',
  r: '175.5'
}), /*#__PURE__*/React__default.createElement("circle", {
  fill: '#fff',
  cx: '692.76',
  cy: '557.26',
  r: '175.5'
}), /*#__PURE__*/React__default.createElement("circle", {
  fill: '#010101',
  cx: '692.76',
  cy: '557.26',
  r: '88.5'
}), /*#__PURE__*/React__default.createElement("circle", {
  fill: '#fff',
  cx: '757.76',
  cy: '508.26',
  r: '27.5'
}), /*#__PURE__*/React__default.createElement("ellipse", {
  fill: '#895522',
  cx: '544.44',
  cy: '1114.06',
  rx: '51.24',
  ry: '87.19',
  transform: 'translate(-647.23 1456.77) rotate(-80)'
}), /*#__PURE__*/React__default.createElement("ellipse", {
  fill: '#895522',
  cx: '816.38',
  cy: '1166.57',
  rx: '87.19',
  ry: '51.24',
  transform: 'translate(-190.17 159.49) rotate(-10)'
}), /*#__PURE__*/React__default.createElement("ellipse", {
  fill: '#4a94c6',
  cx: '1193.38',
  cy: '686.57',
  rx: '87.19',
  ry: '51.24',
  transform: 'translate(310.01 1742.6) rotate(-80)'
}), /*#__PURE__*/React__default.createElement("ellipse", {
  fill: '#4a94c6',
  cx: '186.38',
  cy: '686.57',
  rx: '51.24',
  ry: '87.19',
  transform: 'translate(-116.39 42.8) rotate(-10)'
}), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: '#c067a4',
  d: 'M781.22,790.53c1.69,0,3.05,1.41,2.99,3.1-1.64,50.75-43.3,91.4-94.45,91.4s-92.81-40.64-94.45-91.4c-.05-1.69,1.3-3.1,2.99-3.1h182.92Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#ab3c6f',
  d: 'M780.2,818.49c-11.75,38.8-47.8,67.04-90.44,67.04-3.27,0-6.51-.17-9.69-.49-.02-14.96,5.23-31.26,15.85-45.61,22.02-29.76,58.78-39.9,82.11-22.65.75.55,1.47,1.13,2.17,1.71Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#fff',
  d: 'M784.2,793.89c-.43,10.96-2.96,21.45-7.25,31.14h-165.15c-3.61,0-6.54-2.6-6.54-5.81v-28.69h175.3c2.06,0,3.71,1.53,3.64,3.36Z'
})), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e522',
  d: 'M1041.52,505.47s85.54-7.78,84.47,1.33l-22.46,190.48c-.09.8-.13,1.59-.11,2.39.21,7.59.63,55.88,22.71,55.88h17.62c1.03,0,1.78.31,2.31.8,4.65,4.33-4.73,25.29-12.22,40.19-26.3,59.31-52.59,118.62-78.89,177.93,0,9.87-22.11,30.94-32.81,30.84-84.94-.76-59.08-.53-144.03-1.29-10.6-.1-19.12-8.07-19.06-17.84.64-105.87,1.28-211.73,1.92-317.6,0-1.21.15-2.41.42-3.59,0,0,133.1-147.35,180.14-159.54Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#b9b4c3',
  d: 'M1012.74,806.47h-34.04s1.71-257.25,1.71-257.25l12.87-11.04c.55-.48,9.32-7.6,9.89-8.04l10-7.47-.42,283.81Z'
}), /*#__PURE__*/React__default.createElement("polygon", {
  fill: '#b9b4c3',
  points: '1114.44 834.76 861.77 835.17 861.77 800.52 1130.02 800.52 1114.44 834.76'
}), /*#__PURE__*/React__default.createElement("polygon", {
  fill: '#b9b4c3',
  points: '1079.13 913.64 861.77 913.51 861.99 879.02 1094.78 878.15 1079.13 913.64'
})), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: '#e4e522',
  d: 'M344.91,515.06s-85.54-7.78-84.47,1.33l22.46,190.48c.09.8.13,1.59.11,2.39-.21,7.59-.63,55.88-22.71,55.88h-17.62c-1.03,0-1.78.31-2.31.8-4.65,4.33,4.73,25.29,12.22,40.19,26.3,59.31,52.59,118.62,78.89,177.93,0,9.87,22.11,30.94,32.81,30.84,84.94-.76,59.08-.53,144.03-1.29,10.6-.1,19.12-8.07,19.06-17.84-.64-105.87-1.28-211.73-1.92-317.6,0-1.21-.15-2.41-.42-3.59,0,0-133.1-147.35-180.14-159.54Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#b9b4c3',
  d: 'M373.69,816.06h34.04s-1.71-257.25-1.71-257.25l-12.87-11.04c-.55-.48-9.32-7.6-9.89-8.04l-10-7.47.42,283.81Z'
}), /*#__PURE__*/React__default.createElement("polygon", {
  fill: '#b9b4c3',
  points: '271.98 844.35 524.65 844.76 524.65 810.1 256.4 810.1 271.98 844.35'
}), /*#__PURE__*/React__default.createElement("polygon", {
  fill: '#b9b4c3',
  points: '307.29 923.23 524.65 923.1 524.44 888.61 291.65 887.74 307.29 923.23'
})))));

const RunningBobbin = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '200',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '200',
  height: '200',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M201 385C256.228 385 301 377.165 301 367.5C301 357.835 256.228 350 201 350C145.772 350 101 357.835 101 367.5C101 377.165 145.772 385 201 385Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M62.8693 226.305C87.1434 302.327 168.665 344.351 244.957 320.161C280.285 308.965 308.293 285.527 325.771 256.044C327.22 253.599 328.599 251.112 329.9 248.589C330.98 246.502 332.004 244.392 332.972 242.256C334.309 239.352 335.534 236.398 336.66 233.412C347.78 204.064 349.423 170.919 339.14 138.7C335.3 126.68 330.035 115.511 323.568 105.319C322.452 103.54 321.29 101.785 320.088 100.065C319.321 98.9595 318.534 97.8701 317.74 96.7905C315.221 93.391 312.577 90.1228 309.801 86.9826C272.933 45.3358 213.555 26.9209 157.051 44.8371C80.7555 69.0337 38.5887 150.267 62.8627 226.302L62.8693 226.305Z',
  fill: '#503574'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M274.652 306.973C271.894 308.592 269.079 310.123 266.206 311.549C264.104 312.607 261.976 313.609 259.819 314.558C257.216 315.712 254.57 316.783 251.901 317.778C219.697 329.806 183.106 330.545 148.535 317.17C73.8647 288.299 36.8678 204.595 65.8972 130.216C69.6978 120.478 74.4387 111.387 79.9813 103C68.1934 169.508 104.715 237.196 170.322 262.562C204.897 275.936 241.488 275.197 273.688 263.169C276.357 262.171 279.003 261.1 281.606 259.95C283.764 259 285.892 257.998 287.993 256.94C290.867 255.515 293.681 253.98 296.439 252.364C315.212 241.378 331.605 226.144 344 207.381C342.38 216.574 339.827 225.74 336.306 234.768C324 266.284 301.824 291.068 274.655 306.969L274.652 306.973Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M201 213C232.48 213 258 187.033 258 155C258 122.967 232.48 97 201 97C169.52 97 144 122.967 144 155C144 187.033 169.52 213 201 213Z',
  fill: '#462F69'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M201 207C232.48 207 258 181.48 258 150C258 118.52 232.48 93 201 93C169.52 93 144 118.52 144 150C144 181.48 169.52 207 201 207Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M201 179C217.016 179 230 166.016 230 150C230 133.984 217.016 121 201 121C184.984 121 172 133.984 172 150C172 166.016 184.984 179 201 179Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M222 143C226.971 143 231 138.747 231 133.5C231 128.253 226.971 124 222 124C217.029 124 213 128.253 213 133.5C213 138.747 217.029 143 222 143Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M188.29 332.099C189.905 322.941 178.582 313.29 162.999 310.542C147.417 307.795 133.476 312.991 131.861 322.149C130.246 331.306 141.569 340.957 157.152 343.705C172.734 346.452 186.675 341.256 188.29 332.099Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M244.488 366.704C260.071 363.957 271.394 354.306 269.779 345.148C268.164 335.991 254.223 330.794 238.641 333.542C223.059 336.29 211.735 345.941 213.35 355.098C214.965 364.256 228.906 369.452 244.488 366.704Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M382.025 195.325C384.773 179.743 379.576 165.802 370.419 164.187C361.261 162.572 351.61 173.895 348.863 189.478C346.115 205.06 351.311 219.001 360.469 220.616C369.626 222.231 379.277 210.908 382.025 195.325Z',
  fill: '#503574'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M39.5311 220.615C48.6887 219 53.8849 205.059 51.1373 189.476C48.3897 173.894 38.7387 162.571 29.5812 164.186C20.4236 165.8 15.2274 179.741 17.975 195.324C20.7226 210.906 30.3736 222.229 39.5311 220.615Z',
  fill: '#503574'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M230.01 226.56C230.565 226.56 231.012 227.024 230.992 227.579C230.454 244.255 216.765 257.612 199.957 257.612C183.15 257.612 169.461 244.258 168.922 227.579C168.905 227.024 169.349 226.56 169.904 226.56H230.01Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M229.678 235.748C225.817 248.497 213.972 257.776 199.96 257.776C198.886 257.776 197.821 257.721 196.776 257.615C196.77 252.7 198.495 247.344 201.985 242.628C209.22 232.85 221.299 229.518 228.965 235.186C229.212 235.367 229.448 235.557 229.678 235.748Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M230.992 227.664C230.851 231.266 230.02 234.713 228.61 237.897H174.344C173.157 237.897 172.195 237.042 172.195 235.988V226.56H229.796C230.473 226.56 231.015 227.063 230.992 227.664Z',
  fill: 'white'
})));

const RunningBobbinDark = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '201',
  viewBox: '0 0 200 201',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M100.5 193C128.114 193 150.5 189.082 150.5 184.25C150.5 179.418 128.114 175.5 100.5 175.5C72.8858 175.5 50.5 179.418 50.5 184.25C50.5 189.082 72.8858 193 100.5 193Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M31.4347 113.653C43.5717 151.664 84.3324 172.676 122.479 160.581C140.143 154.983 154.147 143.263 162.885 128.522C163.61 127.3 164.3 126.056 164.95 124.794C165.49 123.751 166.002 122.696 166.486 121.628C167.155 120.176 167.767 118.699 168.33 117.206C173.89 102.532 174.711 85.9596 169.57 69.8499C167.65 63.8401 165.018 58.2553 161.784 53.1594C161.226 52.2701 160.645 51.3924 160.044 50.5326C159.66 49.9797 159.267 49.435 158.87 48.8953C157.611 47.1955 156.289 45.5614 154.901 43.9913C136.466 23.1679 106.777 13.9605 78.5257 22.9185C40.3777 35.0168 19.2944 75.6333 31.4314 113.651L31.4347 113.653Z',
  fill: '#A53AB6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M137.326 153.986C135.947 154.796 134.54 155.562 133.103 156.275C132.052 156.803 130.988 157.304 129.909 157.779C128.608 158.356 127.285 158.891 125.95 159.389C109.849 165.403 91.5532 165.772 74.2673 159.085C36.9323 144.649 18.4339 102.798 32.9486 65.6078C34.8489 60.739 37.2194 56.1937 39.9906 52C34.0967 85.2541 52.3576 119.098 85.1611 131.781C102.449 138.468 120.744 138.098 136.844 132.085C138.179 131.585 139.502 131.05 140.803 130.475C141.882 130 142.946 129.499 143.997 128.97C145.434 128.257 146.841 127.49 148.22 126.682C157.606 121.189 165.803 113.572 172 104.191C171.19 108.787 169.913 113.37 168.153 117.884C162 133.642 150.912 146.034 137.327 153.985L137.326 153.986Z',
  fill: '#8F319F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M100.5 107C116.24 107 129 94.0163 129 78C129 61.9837 116.24 49 100.5 49C84.7599 49 72 61.9837 72 78C72 94.0163 84.7599 107 100.5 107Z',
  fill: '#8F319F'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M100.5 104C116.24 104 129 91.2401 129 75.5C129 59.7599 116.24 47 100.5 47C84.7599 47 72 59.7599 72 75.5C72 91.2401 84.7599 104 100.5 104Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M100.5 90C108.508 90 115 83.5081 115 75.5C115 67.4919 108.508 61 100.5 61C92.4919 61 86 67.4919 86 75.5C86 83.5081 92.4919 90 100.5 90Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M111 72C113.485 72 115.5 69.8734 115.5 67.25C115.5 64.6266 113.485 62.5 111 62.5C108.515 62.5 106.5 64.6266 106.5 67.25C106.5 69.8734 108.515 72 111 72Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M94.1451 166.548C94.9525 161.969 89.291 157.143 81.4997 155.77C73.7085 154.396 66.738 156.994 65.9306 161.573C65.1232 166.151 70.7848 170.977 78.576 172.351C86.3673 173.725 93.3378 171.126 94.1451 166.548Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M122.244 183.851C130.036 182.478 135.697 177.652 134.89 173.073C134.082 168.495 127.112 165.897 119.321 167.27C111.529 168.644 105.868 173.47 106.675 178.048C107.483 182.627 114.453 185.225 122.244 183.851Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M191.012 98.1641C192.385 90.3729 189.787 83.4023 185.208 82.595C180.63 81.7876 175.804 87.4492 174.43 95.2404C173.057 103.032 175.655 110.002 180.233 110.81C184.812 111.617 189.638 105.955 191.012 98.1641Z',
  fill: '#A53AB6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M19.7656 110.807C24.3443 110 26.9425 103.029 25.5687 95.2383C24.1949 87.447 19.3693 81.7855 14.7906 82.5928C10.2118 83.4002 7.61369 90.3707 8.98749 98.162C10.3613 105.953 15.1868 111.615 19.7656 110.807Z',
  fill: '#A53AB6'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M115.004 113.781C115.282 113.781 115.505 114.013 115.496 114.291C115.226 122.629 108.382 129.307 99.9779 129.307C91.5742 129.307 84.7296 122.63 84.4602 114.291C84.452 114.013 84.6738 113.781 84.9514 113.781H115.004Z',
  fill: '#C066A4'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M114.838 118.377C112.908 124.752 106.985 129.392 99.9792 129.392C99.442 129.392 98.9097 129.364 98.3872 129.311C98.3839 126.853 99.2465 124.175 100.991 121.818C104.609 116.928 110.649 115.262 114.482 118.096C114.605 118.187 114.723 118.282 114.838 118.377Z',
  fill: '#AB3C6E'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M115.497 114.333C115.426 116.134 115.011 117.857 114.306 119.449H87.1726C86.5795 119.449 86.0981 119.022 86.0981 118.495V113.781H114.899C115.238 113.781 115.509 114.033 115.497 114.333Z',
  fill: 'white'
})));

const SnorkelBobbin = () => ( /*#__PURE__*/React__default.createElement("svg", {
  width: '200',
  height: '200',
  viewBox: '0 0 400 400',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/React__default.createElement("rect", {
  width: '400',
  height: '400',
  fill: 'none'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M188.008 330.005C189.568 321.157 178.628 311.833 163.573 309.178C148.517 306.523 135.048 311.544 133.488 320.391C131.928 329.239 142.868 338.564 157.923 341.218C172.978 343.873 186.448 338.852 188.008 330.005Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M245.479 341.219C260.534 338.565 271.474 329.24 269.914 320.392C268.354 311.545 254.885 306.524 239.829 309.179C224.774 311.833 213.834 321.158 215.394 330.006C216.954 338.853 230.424 343.874 245.479 341.219Z',
  fill: '#895522'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M66.6325 228.441C90.0695 302.096 168.78 342.811 242.442 319.374C276.551 308.527 303.593 285.818 320.469 257.254C321.867 254.885 323.199 252.475 324.455 250.031C325.498 248.009 326.487 245.964 327.421 243.895C328.712 241.081 329.895 238.22 330.982 235.327C341.718 206.893 343.305 174.78 333.376 143.564C329.669 131.919 324.586 121.097 318.342 111.222C317.264 109.499 316.142 107.798 314.981 106.132C314.241 105.061 313.481 104.006 312.715 102.96C310.282 99.6661 307.73 96.4996 305.05 93.4572C269.452 53.1074 212.122 35.266 157.567 52.6241C83.9018 76.0672 43.1891 154.77 66.6261 228.438L66.6325 228.441Z',
  fill: '#F3C823'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M271.3 305.598C268.648 307.168 265.941 308.651 263.177 310.032C261.156 311.057 259.109 312.027 257.034 312.947C254.53 314.064 251.985 315.102 249.418 316.066C218.445 327.718 183.252 328.434 150 315.477C78.1823 287.508 42.5986 206.42 70.5191 134.365C74.1746 124.932 78.7345 116.125 84.0654 108C72.7277 172.43 107.854 238.002 170.956 262.575C204.21 275.532 239.404 274.816 270.374 263.164C272.941 262.197 275.486 261.159 277.989 260.045C280.065 259.125 282.111 258.155 284.133 257.13C286.896 255.748 289.603 254.262 292.256 252.696C310.311 242.054 326.078 227.296 338 209.119C336.442 218.024 333.986 226.904 330.6 235.65C318.764 266.181 297.434 290.191 271.304 305.595L271.3 305.598Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.5 215C231.152 215 256 189.928 256 159C256 128.072 231.152 103 200.5 103C169.848 103 145 128.072 145 159C145 189.928 169.848 215 200.5 215Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200.5 209C231.152 209 256 184.376 256 154C256 123.624 231.152 99 200.5 99C169.848 99 145 123.624 145 154C145 184.376 169.848 209 200.5 209Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M200 182C215.464 182 228 169.464 228 154C228 138.536 215.464 126 200 126C184.536 126 172 138.536 172 154C172 169.464 184.536 182 200 182Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M221 147C225.971 147 230 143.194 230 138.5C230 133.806 225.971 130 221 130C216.029 130 212 133.806 212 138.5C212 143.194 216.029 147 221 147Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.45',
  d: 'M144.186 84H254.811C283.063 84 306 106.909 306 135.127C306 191.353 260.298 237 204.003 237H194.997C138.702 237 93 191.353 93 135.127C93 106.909 115.937 84 144.189 84H144.186Z',
  fill: '#010101'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M319.52 110.612L312.778 98.9289C311.785 97.2107 309.58 96.6158 307.863 97.6094L300.548 101.831C291.37 88.6449 276.114 80 258.884 80H140.005C122.607 80 107.234 88.8031 98.0844 102.191L90.1399 97.6062C88.4226 96.6126 86.2183 97.2075 85.2252 98.9257L78.4825 110.608C77.4895 112.333 78.0777 114.532 79.8014 115.526L88.2234 120.392C88.8527 120.756 89.5485 120.908 90.2316 120.87C89.5928 124.069 89.2607 127.376 89.2607 130.762C89.2607 191.545 138.683 241 199.439 241C260.196 241 309.618 191.545 309.618 130.762C309.618 127.36 309.286 124.031 308.641 120.81C309.027 120.737 309.41 120.601 309.773 120.389L318.205 115.523C319.922 114.529 320.51 112.333 319.517 110.605L319.52 110.612ZM199.449 232.301C143.49 232.301 97.9673 186.748 97.9673 130.765C97.9673 107.571 116.82 88.6987 140.011 88.6987H258.89C282.072 88.6987 300.934 107.571 300.934 130.765C300.934 186.748 255.405 232.301 199.452 232.301H199.449Z',
  fill: '#14B1AB'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M203.53 264C199.481 263.974 195.895 260.919 195.141 256.561C194.289 251.63 197.381 246.902 202.05 245.999L267.559 233.324C289.569 229.064 306.359 210.487 309.369 187.079L323.862 41.1341C324.356 36.1491 328.585 32.5312 333.302 33.0494C338.022 33.5708 341.447 38.0312 340.953 43.0162L326.418 189.349C322.462 220.642 300.049 245.487 270.645 251.175L205.136 263.85C204.594 263.955 204.059 264.003 203.53 264Z',
  fill: '#14B1AB'
}), /*#__PURE__*/React__default.createElement("g", {
  opacity: '0.09'
}, /*#__PURE__*/React__default.createElement("path", {
  d: 'M272.78 233.896L207.123 246.56C202.443 247.465 199.345 252.189 200.199 257.11C200.71 260.056 202.52 262.405 204.897 263.621C204.437 263.697 203.983 263.729 203.532 263.726C199.475 263.704 195.878 260.65 195.126 256.297C194.272 251.376 197.37 246.652 202.05 245.747L267.706 233.083C289.764 228.826 306.59 210.273 309.613 186.891L324.15 41.1263C324.648 36.1484 328.887 32.5292 333.614 33.0498C334.639 33.1641 335.614 33.4625 336.493 33.9134C332.712 34.5229 329.642 37.7453 329.223 41.9391L314.686 187.704C311.664 211.083 294.834 229.636 272.78 233.896Z',
  fill: '#0C4844'
})), /*#__PURE__*/React__default.createElement("path", {
  d: 'M230.94 254.695C231.007 243.378 220.606 234.141 207.709 234.064C194.811 233.988 184.301 243.1 184.234 254.418C184.167 265.736 194.568 274.973 207.465 275.049C220.363 275.126 230.873 266.013 230.94 254.695Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M224.868 263C220.647 262.975 216.912 259.081 216.142 253.532C215.271 247.267 218.507 241.264 223.37 240.123L261.478 231.188C266.341 230.05 270.987 234.202 271.858 240.467C272.729 246.731 269.493 252.734 264.63 253.876L226.522 262.811C225.968 262.94 225.413 263.003 224.868 263Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M223.931 254.327C223.978 246.443 216.733 240.008 207.748 239.954C198.764 239.901 191.444 246.25 191.397 254.134C191.35 262.019 198.595 268.454 207.579 268.507C216.563 268.561 223.884 262.212 223.931 254.327Z',
  fill: '#EBEBEA'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M222.432 254.143C222.475 246.958 215.872 241.094 207.684 241.046C199.495 240.997 192.823 246.782 192.781 253.967C192.738 261.153 199.341 267.017 207.529 267.065C215.717 267.114 222.389 261.329 222.432 254.143Z',
  fill: 'white'
}), /*#__PURE__*/React__default.createElement("path", {
  opacity: '0.05',
  d: 'M199.5 367C262.184 367 313 358.493 313 348C313 337.507 262.184 329 199.5 329C136.816 329 86 337.507 86 348C86 358.493 136.816 367 199.5 367Z',
  fill: '#0F1027'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M378.218 237.03C385.578 231.877 384.435 217.548 375.667 205.025C366.898 192.503 353.824 186.528 346.465 191.681C339.105 196.834 340.247 211.164 349.016 223.686C357.785 236.209 370.859 242.184 378.218 237.03Z',
  fill: '#EDBD21'
}), /*#__PURE__*/React__default.createElement("path", {
  d: 'M51.5277 223.686C60.2963 211.163 61.4386 196.834 54.0792 191.681C46.7198 186.528 33.6455 192.502 24.8769 205.025C16.1083 217.548 14.966 231.877 22.3254 237.03C29.6848 242.183 42.7592 236.209 51.5277 223.686Z',
  fill: '#EDBD21'
})));

const TicketLine = props => ( /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: '70px',
  height: '6px',
  fill: 'none'
}, props, {
  viewBox: '0 0 70 6'
}), /*#__PURE__*/createElement("path", {
  fill: '#BFC5CB',
  d: 'M.333 3a2.667 2.667 0 1 0 5.334 0A2.667 2.667 0 0 0 .333 3Zm64 0a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0ZM6.2 3.5a.5.5 0 0 0 0-1v1Zm6.4-1a.5.5 0 0 0 0 1v-1Zm6.4 1a.5.5 0 0 0 0-1v1Zm6.4-1a.5.5 0 0 0 0 1v-1Zm6.4 1a.5.5 0 0 0 0-1v1Zm6.4-1a.5.5 0 0 0 0 1v-1Zm6.4 1a.5.5 0 0 0 0-1v1Zm6.4-1a.5.5 0 0 0 0 1v-1Zm6.4 1a.5.5 0 0 0 0-1v1Zm6.4-1a.5.5 0 0 0 0 1v-1ZM3 3.5h3.2v-1H3v1Zm9.6 0H19v-1h-6.4v1Zm12.8 0h6.4v-1h-6.4v1Zm12.8 0h6.4v-1h-6.4v1Zm12.8 0h6.4v-1H51v1Zm12.8 0H67v-1h-3.2v1Z'
})));

const DefaultCoverImage = props => ( /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 391 175',
  fill: 'none'
}, props), /*#__PURE__*/createElement("g", {
  clipPath: 'url(#a)'
}, /*#__PURE__*/createElement("path", {
  fill: '#10375C',
  d: 'M0 0h391v175H0z'
}), /*#__PURE__*/createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/createElement("path", {
  fill: '#18B1AB',
  d: 'M224.059 56.118c17.705 0 32.059-14.354 32.059-32.06C256.118 6.354 241.764-8 224.059-8 206.353-8 192 6.353 192 24.059c0 17.705 14.353 32.059 32.059 32.059Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#464D77',
  d: 'M301 56.118c17.706 0 32.059-14.354 32.059-32.06C333.059 6.354 318.706-8 301-8c-17.705 0-32.059 14.353-32.059 32.059 0 17.705 14.354 32.059 32.059 32.059Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#18B1AB',
  d: 'M377.942 56.118c17.705 0 32.058-14.354 32.058-32.06C410 6.354 395.647-8 377.942-8c-17.706 0-32.059 14.353-32.059 32.059 0 17.705 14.353 32.059 32.059 32.059Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#fff',
  d: 'M224.059 133.059c17.705 0 32.059-14.353 32.059-32.059 0-17.705-14.354-32.059-32.059-32.059C206.353 68.941 192 83.295 192 101c0 17.706 14.353 32.059 32.059 32.059Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#FF565C',
  d: 'M301 133.059c17.706 0 32.059-14.353 32.059-32.059 0-17.705-14.353-32.059-32.059-32.059-17.705 0-32.059 14.354-32.059 32.059 0 17.706 14.354 32.059 32.059 32.059Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#F3C724',
  d: 'M377.942 133.059C395.647 133.059 410 118.706 410 101c0-17.705-14.353-32.059-32.058-32.059-17.706 0-32.059 14.354-32.059 32.059 0 17.706 14.353 32.059 32.059 32.059Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#18B1AB',
  d: 'M224.059 210c17.705 0 32.059-14.353 32.059-32.058 0-17.706-14.354-32.059-32.059-32.059-17.706 0-32.059 14.353-32.059 32.059C192 195.647 206.353 210 224.059 210Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#464D77',
  d: 'M301 210c17.706 0 32.059-14.353 32.059-32.058 0-17.706-14.353-32.059-32.059-32.059-17.705 0-32.059 14.353-32.059 32.059C268.941 195.647 283.295 210 301 210Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#18B1AB',
  d: 'M377.942 210C395.647 210 410 195.647 410 177.942c0-17.706-14.353-32.059-32.058-32.059-17.706 0-32.059 14.353-32.059 32.059 0 17.705 14.353 32.058 32.059 32.058Z'
}))), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
  id: 'a'
}, /*#__PURE__*/createElement("path", {
  fill: '#fff',
  d: 'M0 0h391v175H0z'
})))));

const MuiShaddows = ['none', '0px 2px 4px 0px rgba(51, 82, 111, 0.1)', '0px 4px 8px 0px rgba(51, 82, 111, 0.1)', '0px 6px 12px 0px rgba(16, 55, 92, 0.1)', '0px 8px 16px 0px rgba(16, 55, 92, 0.1)', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];

var core = {
	primary: "#FFFFFF",
	secondary: "#18B1AB",
	secondaryHover: "#6DBEBB",
	secondaryActive: "#398481"
};
var font = {
	primary: "#FFFFFF",
	secondary: "#E9E9E9"
};
var coreBrights = {
	primary: "#FF565C",
	secondary: "#FFC900",
	tertiary: "#A53AB6"
};
var coreLights = {
	primary: "#0E6D6A",
	secondary: "#B33C40",
	tertiary: "#997900"
};
var backgrounds = {
	primary: "#191919",
	secondary: "#2B2B2B",
	dialogue: "#2B2B2B",
	header: "#2B2B2B",
	input: "#2B2B2B",
	card: "#1B1B1B",
	navbar: "#2B2B2B"
};
var shades = {
	shade0: "#000000",
	shade1: "#838383",
	shade2: "#606060",
	shade3: "#4C4C4C",
	shade4: "#3B3B3B",
	shade5: "#FFFFFF"
};
var states = {
	success: "#8CD246",
	successLight: "#E3F4D1",
	successLightBlue: "#F0F5FE",
	warning: "#F5AB1A",
	warningLight: "#F5E0B7",
	error: "#CF1E0B",
	errorLight: "#FFE6E7",
	errorHover: "#BE6D6D",
	errorActive: "#843939"
};
var navbar = {
	light: true,
	icons: "#FFFFFF",
	highlighted: "#18B1AB"
};
var settings = {
	advanced: false
};
var sections = {
	section1: "#FF85C7",
	section2: "#F3C724",
	section3: "#18B1AB",
	section4: "#FF565C",
	section5: "#004BDC",
	section8: "#64C916",
	section9: "#A53AB6"
};
var graphing = {
	graph1: "#FFC700",
	graph2: "#B0DB43",
	graph3: "#064789",
	graph4: "#E75A7C",
	graph5: "#8DDBE0",
	graph6: "#8D3B72",
	graph7: "#F24236",
	graph8: "#FFA630",
	graph9: "#BDE4A7",
	graph10: "#034C3C",
	graph11: "#93032E",
	graph12: "#B3B3F1"
};
var tags = [
	{
		name: "Dark Red",
		hex: "#8D0800"
	},
	{
		name: "Pale Red",
		hex: "#E36969"
	},
	{
		name: "Orange",
		hex: "#EC8D00"
	},
	{
		name: "Yellow",
		hex: "#FFC700"
	},
	{
		name: "Lime",
		hex: "#92A903"
	},
	{
		name: "Bright Green",
		hex: "#64C916"
	},
	{
		name: "Forest Green",
		hex: "#007830"
	},
	{
		name: "Aqua",
		hex: "#00E2BA"
	},
	{
		name: "Petrol",
		hex: "#1D9CC4"
	},
	{
		name: "Royal Blue",
		hex: "#004BDC"
	},
	{
		name: "Indigo",
		hex: "#3C0089"
	},
	{
		name: "Lilac",
		hex: "#A57BFF"
	},
	{
		name: "Plum",
		hex: "#79008C"
	},
	{
		name: "Magenta",
		hex: "#D600B3"
	},
	{
		name: "Pink",
		hex: "#FF85C7"
	}
];
var messaging = {
	send: "#127A77",
	receive: "#2B2B2B"
};
var dark = {
	core: core,
	font: font,
	coreBrights: coreBrights,
	coreLights: coreLights,
	backgrounds: backgrounds,
	shades: shades,
	states: states,
	navbar: navbar,
	settings: settings,
	sections: sections,
	graphing: graphing,
	tags: tags,
	messaging: messaging
};

var core$1 = {
	primary: "#0A1F41",
	secondary: "#18B1AB",
	secondaryHover: "#6DBEBB",
	secondaryActive: "#398481"
};
var font$1 = {
	primary: "#0A1F41",
	secondary: "#758696"
};
var coreBrights$1 = {
	primary: "#FF565C",
	secondary: "#F3C724",
	tertiary: "#4F3473"
};
var coreLights$1 = {
	primary: "#EBF9F8",
	secondary: "#FFCDCF",
	tertiary: "#FCEFBE"
};
var backgrounds$1 = {
	primary: "#FFFFFF",
	secondary: "#F0F5FE",
	dialogue: "#FFFFFF",
	header: "#0A1F41",
	input: "#FFFFFF",
	card: "#FFFFFF",
	navbar: "#FFFFFF"
};
var shades$1 = {
	shade0: "#000000",
	shade1: "#67727D",
	shade2: "#BFC5CB",
	shade3: "#D8DDE0",
	shade4: "#F5F9FA",
	shade5: "#FFFFFF"
};
var states$1 = {
	success: "#8CD246",
	successLight: "#E3F4D1",
	successLightBlue: "#F0F5FE",
	warning: "#F5AB1A",
	warningLight: "#F5E0B7",
	error: "#CF1E0B",
	errorLight: "#FFE6E7",
	errorHover: "#BE6D6D",
	errorActive: "#843939"
};
var navbar$1 = {
	light: false,
	icons: "#10375C",
	highlighted: "#18B1AB"
};
var settings$1 = {
	advanced: true
};
var sections$1 = {
	section1: "#FF85C7",
	section2: "#F3C724",
	section3: "#18B1AB",
	section4: "#FF565C",
	section5: "#004BDC",
	section8: "#64C916",
	section9: "#A53AB6"
};
var graphing$1 = {
	graph1: "#FFC700",
	graph2: "#B0DB43",
	graph3: "#064789",
	graph4: "#E75A7C",
	graph5: "#8DDBE0",
	graph6: "#8D3B72",
	graph7: "#F24236",
	graph8: "#FFA630",
	graph9: "#BDE4A7",
	graph10: "#034C3C",
	graph11: "#93032E",
	graph12: "#B3B3F1"
};
var tags$1 = [
	{
		name: "Dark Red",
		hex: "#8D0800"
	},
	{
		name: "Pale Red",
		hex: "#E36969"
	},
	{
		name: "Orange",
		hex: "#EC8D00"
	},
	{
		name: "Yellow",
		hex: "#FFC700"
	},
	{
		name: "Lime",
		hex: "#92A903"
	},
	{
		name: "Bright Green",
		hex: "#64C916"
	},
	{
		name: "Forest Green",
		hex: "#007830"
	},
	{
		name: "Aqua",
		hex: "#00E2BA"
	},
	{
		name: "Petrol",
		hex: "#1D9CC4"
	},
	{
		name: "Royal Blue",
		hex: "#004BDC"
	},
	{
		name: "Indigo",
		hex: "#3C0089"
	},
	{
		name: "Lilac",
		hex: "#A57BFF"
	},
	{
		name: "Plum",
		hex: "#79008C"
	},
	{
		name: "Magenta",
		hex: "#D600B3"
	},
	{
		name: "Pink",
		hex: "#FF85C7"
	}
];
var messaging$1 = {
	send: "#D4FFFD",
	receive: "#F0F5FE"
};
var light = {
	core: core$1,
	font: font$1,
	coreBrights: coreBrights$1,
	coreLights: coreLights$1,
	backgrounds: backgrounds$1,
	shades: shades$1,
	states: states$1,
	navbar: navbar$1,
	settings: settings$1,
	sections: sections$1,
	graphing: graphing$1,
	tags: tags$1,
	messaging: messaging$1
};

let ColoursObj = coloursSwitch('light');
let SelectedTheme = 'light';
function setColourScheme(set, customColours) {
  ColoursObj = set === 'custom' && customColours ? mergeTColourSchemeType(customColours, light) : coloursSwitch(set);
  SelectedTheme = set;
}
function coloursSwitch(set) {
  switch (set) {
    case 'light':
      return light;
    case 'dark':
      return dark;
    case 'custom':
      return light;
  }
}
function mergeTColourSchemeType(customColours, defaultColours) {
  const mergedColours = {
    ...defaultColours,
    core: {
      ...defaultColours.core,
      ...customColours.core
    },
    font: {
      ...defaultColours.font,
      ...customColours.font
    },
    coreBrights: {
      ...defaultColours.coreBrights,
      ...customColours.coreBrights
    },
    coreLights: {
      ...defaultColours.coreLights,
      ...customColours.coreLights
    },
    backgrounds: {
      ...defaultColours.backgrounds,
      ...customColours.backgrounds
    },
    states: {
      ...defaultColours.states,
      ...customColours.states
    },
    navbar: {
      ...defaultColours.navbar,
      ...customColours.navbar
    },
    sections: {
      ...defaultColours.sections,
      ...customColours.sections
    },
    graphing: {
      ...defaultColours.graphing,
      ...customColours.graphing
    },
    shades: {
      ...defaultColours.shades,
      ...customColours.shades
    },
    messaging: {
      ...defaultColours.messaging,
      ...customColours.messaging
    }
  };
  return mergedColours;
}
function getContrastYIQ(hexcolor, darkColour, lightColour) {
  hexcolor = hexcolor.replace('#', '');
  const r = parseInt(hexcolor.substring(0, 2), 16);
  const g = parseInt(hexcolor.substring(2, 4), 16);
  const b = parseInt(hexcolor.substring(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 136 ? darkColour ?? ColoursObj.shades.shade0 : lightColour ?? ColoursObj.shades.shade5;
}
function getTagColourHex(name) {
  try {
    var _ColoursObj$tags, _ColoursObj$tags$find;
    return ((_ColoursObj$tags = ColoursObj.tags) === null || _ColoursObj$tags === void 0 ? void 0 : (_ColoursObj$tags$find = _ColoursObj$tags.find(Colour => {
      return Colour.name === name;
    })) === null || _ColoursObj$tags$find === void 0 ? void 0 : _ColoursObj$tags$find.hex) ?? ColoursObj.core.primary;
  } catch {
    spError('Something wrong with colours. Maybe wrong tag name.');
    return ColoursObj.core.primary;
  }
}
function getSectionColour(sectionid) {
  switch (sectionid) {
    case 1:
      return ColoursObj.sections.section1;
    case 2:
      return ColoursObj.sections.section2;
    case 3:
      return ColoursObj.sections.section3;
    case 4:
      return ColoursObj.sections.section4;
    case 5:
      return ColoursObj.sections.section5;
    case 8:
      return ColoursObj.sections.section8;
    case 9:
      return ColoursObj.sections.section9;
    default:
      return ColoursObj.shades.shade0;
  }
}
function getGraphColour(index) {
  const remainder = index % 12;
  switch (remainder) {
    case 0:
      return ColoursObj.graphing.graph1;
    case 1:
      return ColoursObj.graphing.graph2;
    case 2:
      return ColoursObj.graphing.graph3;
    case 3:
      return ColoursObj.graphing.graph4;
    case 4:
      return ColoursObj.graphing.graph5;
    case 5:
      return ColoursObj.graphing.graph6;
    case 6:
      return ColoursObj.graphing.graph7;
    case 7:
      return ColoursObj.graphing.graph8;
    case 8:
      return ColoursObj.graphing.graph9;
    case 9:
      return ColoursObj.graphing.graph10;
    case 10:
      return ColoursObj.graphing.graph11;
    case 11:
      return ColoursObj.graphing.graph12;
    default:
      return ColoursObj.shades.shade0;
  }
}

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

// Asynchronously await a promise and pass the result to a finally continuation
function _finallyRethrows(body, finalizer) {
	try {
		var result = body();
	} catch (e) {
		return finalizer(true, e);
	}
	if (result && result.then) {
		return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
	}
	return finalizer(false, result);
}

const useToken = create()((set, _) => ({
  getToken: () => {
    return 'token';
  },
  setTokenAccessFunction: func => {
    set(() => ({
      getToken: func
    }));
  }
}));

const AuthImage = props => {
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef(null);
  const {
    component = 'div',
    src: propsSrc,
    addLoading,
    onLoad,
    onError,
    ...rest
  } = props;
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    if (!propsSrc) {
      if (component === 'img') {
        element.src = '';
      } else {
        element.style.backgroundImage = '';
      }
      return;
    }
    if (propsSrc.startsWith('blob:') || propsSrc.startsWith('data:')) {
      if (component === 'img') {
        element.src = propsSrc;
      } else {
        element.style.backgroundImage = `url(${propsSrc})`;
      }
      if (onLoad) onLoad();
      return;
    }
    const loadImage = function () {
      try {
        let _exit = false;
        function _temp2(_result) {
          if (_exit) return _result;
          setIsLoading(true);
          axios.get(propsSrc, {
            responseType: 'arraybuffer',
            headers: {
              Authorization: `Bearer ${useToken.getState().getToken()}`
            }
          }).then(response => {
            const base64 = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            const dataUrl = `data:image/png;base64,${base64}`;
            Filesystem.writeFile({
              path: filePath,
              data: base64,
              directory: Directory.Cache,
              recursive: true
            }).catch(err => console.error('Failed to write image to cache', err));
            setIsLoading(false);
            if (ref.current) {
              if (component === 'img') {
                ;
                ref.current.src = dataUrl;
              } else {
                ;
                ref.current.style.backgroundImage = `url(${dataUrl})`;
              }
              if (onLoad) onLoad();
            }
          }).catch(err => {
            setIsLoading(false);
            spErrorTags('Error Fetching image', ['AuthImage'], err);
            if (onError) {
              onError();
            }
            if (ref.current) {
              if (component === 'img') {
                ;
                ref.current.src = '';
              } else {
                ;
                ref.current.style.backgroundImage = '';
              }
            }
          });
        }
        const filePath = propsSrc.replace(/^(?:\/\/|[^/]+)*\//, '');
        const _temp = _catch(function () {
          return Promise.resolve(Filesystem.readFile({
            path: filePath,
            directory: Directory.Cache
          })).then(function (cacheImage) {
            if (cacheImage.data) {
              const dataUrl = `data:image/png;base64,${cacheImage.data}`;
              if (component === 'img') {
                ;
                element.src = dataUrl;
              } else {
                ;
                element.style.backgroundImage = `url(${dataUrl})`;
              }
              if (onLoad) onLoad();
              _exit = true;
            }
          });
        }, function () {});
        return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
      } catch (e) {
        return Promise.reject(e);
      }
    };
    loadImage();
  }, [propsSrc, component, onLoad, onError]);
  const {
    sx,
    style,
    color,
    bgcolor,
    ...imgCompatibleProps
  } = rest;
  const imgStyle = {
    display: 'block',
    ...(typeof style === 'object' ? style : {})
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'relative',
      height: 'inherit',
      width: 'inherit'
    }
  }, component === 'img' ? (
  /*#__PURE__*/
  React__default.createElement("img", Object.assign({
    ref: ref
  }, imgCompatibleProps, {
    style: imgStyle
  }))) : ( /*#__PURE__*/React__default.createElement(Box, Object.assign({
    ref: ref,
    component: component,
    sx: {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      ...sx
    },
    style: style,
    color: color,
    bgcolor: bgcolor
  }, imgCompatibleProps))), addLoading && isLoading && ( /*#__PURE__*/React__default.createElement(LinearProgress, {
    variant: 'query',
    color: 'secondary',
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 500
    }
  })));
};

function ImageRenderer({
  variant,
  src,
  width,
  height
}) {
  if (src) {
    return /*#__PURE__*/React__default.createElement(AuthImage, {
      display: 'inline',
      borderRadius: '10px',
      component: 'img',
      src: src,
      width: width,
      height: height,
      style: {
        objectFit: 'cover'
      },
      onLoad: () => {},
      onError: () => {}
    });
  } else {
    return getBobbins(variant);
  }
}
const getBobbins = src => {
  const isLightTheme = SelectedTheme === 'light' || SelectedTheme === 'custom';
  switch (src) {
    case 'noItins':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(RunningBobbin, null) : /*#__PURE__*/React__default.createElement(RunningBobbinDark, null);
    case 'homeEmpty':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(AdminBobbin, null) : /*#__PURE__*/React__default.createElement(AdminBobbinDark, null);
    case 'eventEnded':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(CelebrateBobbin, null) : /*#__PURE__*/React__default.createElement(CelebrateBobbinDark, null);
    case 'Clive':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(Clive, null) : /*#__PURE__*/React__default.createElement(CliveDark, null);
    case 'teamEmpty':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(BobbinGroup, null) : /*#__PURE__*/React__default.createElement(BobbinGroupDark, null);
    case 'chatEmpty':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(MicrophoneBobbin, null) : /*#__PURE__*/React__default.createElement(MicrophoneBobbin, null);
    case 'error':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(ErrorBobbin, null) : /*#__PURE__*/React__default.createElement(ErrorBobbin, null);
    case 'emailSent':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(EmailBobbin, null) : /*#__PURE__*/React__default.createElement(EmailBobbin, null);
    case 'flights':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(FlightBobbin, null) : /*#__PURE__*/React__default.createElement(FlightBobbin, null);
    case 'hotels':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(BobbingInBed, null) : /*#__PURE__*/React__default.createElement(BobbingInBed, null);
    case 'activities':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(SnorkelBobbin, null) : /*#__PURE__*/React__default.createElement(SnorkelBobbin, null);
    case 'hireCars':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(BobbinCar, null) : /*#__PURE__*/React__default.createElement(BobbinCar, null);
    case 'transport':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(BobbinBus, null) : /*#__PURE__*/React__default.createElement(BobbinBus, null);
    case 'parkings':
      return isLightTheme ? /*#__PURE__*/React__default.createElement(BobbinParking, null) : /*#__PURE__*/React__default.createElement(BobbinParking, null);
  }
};

/*! Capacitor: https://capacitorjs.com/ - MIT License */

var ExceptionCode;
(function (ExceptionCode) {
    /**
     * API is not implemented.
     *
     * This usually means the API can't be used because it is not implemented for
     * the current platform.
     */
    ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
    /**
     * API is not available.
     *
     * This means the API can't be used right now because:
     *   - it is currently missing a prerequisite, such as network connectivity
     *   - it requires a particular platform or browser version
     */
    ExceptionCode["Unavailable"] = "UNAVAILABLE";
})(ExceptionCode || (ExceptionCode = {}));
class CapacitorException extends Error {
    constructor(message, code, data) {
        super(message);
        this.message = message;
        this.code = code;
        this.data = data;
    }
}
const getPlatformId = (win) => {
    var _a, _b;
    if (win === null || win === void 0 ? void 0 : win.androidBridge) {
        return 'android';
    }
    else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) {
        return 'ios';
    }
    else {
        return 'web';
    }
};

const createCapacitor = (win) => {
    var _a, _b, _c, _d, _e;
    const capCustomPlatform = win.CapacitorCustomPlatform || null;
    const cap = win.Capacitor || {};
    const Plugins = (cap.Plugins = cap.Plugins || {});
    /**
     * @deprecated Use `capCustomPlatform` instead, default functions like registerPlugin will function with the new object.
     */
    const capPlatforms = win.CapacitorPlatforms;
    const defaultGetPlatform = () => {
        return capCustomPlatform !== null
            ? capCustomPlatform.name
            : getPlatformId(win);
    };
    const getPlatform = ((_a = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _a === void 0 ? void 0 : _a.getPlatform) || defaultGetPlatform;
    const defaultIsNativePlatform = () => getPlatform() !== 'web';
    const isNativePlatform = ((_b = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _b === void 0 ? void 0 : _b.isNativePlatform) || defaultIsNativePlatform;
    const defaultIsPluginAvailable = (pluginName) => {
        const plugin = registeredPlugins.get(pluginName);
        if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) {
            // JS implementation available for the current platform.
            return true;
        }
        if (getPluginHeader(pluginName)) {
            // Native implementation available.
            return true;
        }
        return false;
    };
    const isPluginAvailable = ((_c = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _c === void 0 ? void 0 : _c.isPluginAvailable) ||
        defaultIsPluginAvailable;
    const defaultGetPluginHeader = (pluginName) => { var _a; return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find(h => h.name === pluginName); };
    const getPluginHeader = ((_d = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _d === void 0 ? void 0 : _d.getPluginHeader) || defaultGetPluginHeader;
    const handleError = (err) => win.console.error(err);
    const pluginMethodNoop = (_target, prop, pluginName) => {
        return Promise.reject(`${pluginName} does not have an implementation of "${prop}".`);
    };
    const registeredPlugins = new Map();
    const defaultRegisterPlugin = (pluginName, jsImplementations = {}) => {
        const registeredPlugin = registeredPlugins.get(pluginName);
        if (registeredPlugin) {
            console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
            return registeredPlugin.proxy;
        }
        const platform = getPlatform();
        const pluginHeader = getPluginHeader(pluginName);
        let jsImplementation;
        const loadPluginImplementation = async () => {
            if (!jsImplementation && platform in jsImplementations) {
                jsImplementation =
                    typeof jsImplementations[platform] === 'function'
                        ? (jsImplementation = await jsImplementations[platform]())
                        : (jsImplementation = jsImplementations[platform]);
            }
            else if (capCustomPlatform !== null &&
                !jsImplementation &&
                'web' in jsImplementations) {
                jsImplementation =
                    typeof jsImplementations['web'] === 'function'
                        ? (jsImplementation = await jsImplementations['web']())
                        : (jsImplementation = jsImplementations['web']);
            }
            return jsImplementation;
        };
        const createPluginMethod = (impl, prop) => {
            var _a, _b;
            if (pluginHeader) {
                const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find(m => prop === m.name);
                if (methodHeader) {
                    if (methodHeader.rtype === 'promise') {
                        return (options) => cap.nativePromise(pluginName, prop.toString(), options);
                    }
                    else {
                        return (options, callback) => cap.nativeCallback(pluginName, prop.toString(), options, callback);
                    }
                }
                else if (impl) {
                    return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
                }
            }
            else if (impl) {
                return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
            }
            else {
                throw new CapacitorException(`"${pluginName}" plugin is not implemented on ${platform}`, ExceptionCode.Unimplemented);
            }
        };
        const createPluginMethodWrapper = (prop) => {
            let remove;
            const wrapper = (...args) => {
                const p = loadPluginImplementation().then(impl => {
                    const fn = createPluginMethod(impl, prop);
                    if (fn) {
                        const p = fn(...args);
                        remove = p === null || p === void 0 ? void 0 : p.remove;
                        return p;
                    }
                    else {
                        throw new CapacitorException(`"${pluginName}.${prop}()" is not implemented on ${platform}`, ExceptionCode.Unimplemented);
                    }
                });
                if (prop === 'addListener') {
                    p.remove = async () => remove();
                }
                return p;
            };
            // Some flair ✨
            wrapper.toString = () => `${prop.toString()}() { [capacitor code] }`;
            Object.defineProperty(wrapper, 'name', {
                value: prop,
                writable: false,
                configurable: false,
            });
            return wrapper;
        };
        const addListener = createPluginMethodWrapper('addListener');
        const removeListener = createPluginMethodWrapper('removeListener');
        const addListenerNative = (eventName, callback) => {
            const call = addListener({ eventName }, callback);
            const remove = async () => {
                const callbackId = await call;
                removeListener({
                    eventName,
                    callbackId,
                }, callback);
            };
            const p = new Promise(resolve => call.then(() => resolve({ remove })));
            p.remove = async () => {
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            };
            return p;
        };
        const proxy = new Proxy({}, {
            get(_, prop) {
                switch (prop) {
                    // https://github.com/facebook/react/issues/20030
                    case '$$typeof':
                        return undefined;
                    case 'toJSON':
                        return () => ({});
                    case 'addListener':
                        return pluginHeader ? addListenerNative : addListener;
                    case 'removeListener':
                        return removeListener;
                    default:
                        return createPluginMethodWrapper(prop);
                }
            },
        });
        Plugins[pluginName] = proxy;
        registeredPlugins.set(pluginName, {
            name: pluginName,
            proxy,
            platforms: new Set([
                ...Object.keys(jsImplementations),
                ...(pluginHeader ? [platform] : []),
            ]),
        });
        return proxy;
    };
    const registerPlugin = ((_e = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _e === void 0 ? void 0 : _e.registerPlugin) || defaultRegisterPlugin;
    // Add in convertFileSrc for web, it will already be available in native context
    if (!cap.convertFileSrc) {
        cap.convertFileSrc = filePath => filePath;
    }
    cap.getPlatform = getPlatform;
    cap.handleError = handleError;
    cap.isNativePlatform = isNativePlatform;
    cap.isPluginAvailable = isPluginAvailable;
    cap.pluginMethodNoop = pluginMethodNoop;
    cap.registerPlugin = registerPlugin;
    cap.Exception = CapacitorException;
    cap.DEBUG = !!cap.DEBUG;
    cap.isLoggingEnabled = !!cap.isLoggingEnabled;
    // Deprecated props
    cap.platform = cap.getPlatform();
    cap.isNative = cap.isNativePlatform();
    return cap;
};
const initCapacitorGlobal = (win) => (win.Capacitor = createCapacitor(win));

const Capacitor = /*#__PURE__*/ initCapacitorGlobal(typeof globalThis !== 'undefined'
    ? globalThis
    : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
            ? window
            : typeof global !== 'undefined'
                ? global
                : {});
const registerPlugin = Capacitor.registerPlugin;

/**
 * Base class web plugins should extend.
 */
class WebPlugin {
    constructor(config) {
        this.listeners = {};
        this.windowListeners = {};
        if (config) {
            // TODO: add link to upgrade guide
            console.warn(`Capacitor WebPlugin "${config.name}" config object was deprecated in v3 and will be removed in v4.`);
            this.config = config;
        }
    }
    addListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(listenerFunc);
        // If we haven't added a window listener for this event and it requires one,
        // go ahead and add it
        const windowListener = this.windowListeners[eventName];
        if (windowListener && !windowListener.registered) {
            this.addWindowListener(windowListener);
        }
        const remove = async () => this.removeListener(eventName, listenerFunc);
        const p = Promise.resolve({ remove });
        Object.defineProperty(p, 'remove', {
            value: async () => {
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            },
        });
        return p;
    }
    async removeAllListeners() {
        this.listeners = {};
        for (const listener in this.windowListeners) {
            this.removeWindowListener(this.windowListeners[listener]);
        }
        this.windowListeners = {};
    }
    notifyListeners(eventName, data) {
        const listeners = this.listeners[eventName];
        if (listeners) {
            listeners.forEach(listener => listener(data));
        }
    }
    hasListeners(eventName) {
        return !!this.listeners[eventName].length;
    }
    registerWindowListener(windowEventName, pluginEventName) {
        this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName,
            pluginEventName,
            handler: event => {
                this.notifyListeners(pluginEventName, event);
            },
        };
    }
    unimplemented(msg = 'not implemented') {
        return new Capacitor.Exception(msg, ExceptionCode.Unimplemented);
    }
    unavailable(msg = 'not available') {
        return new Capacitor.Exception(msg, ExceptionCode.Unavailable);
    }
    async removeListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            return;
        }
        const index = listeners.indexOf(listenerFunc);
        this.listeners[eventName].splice(index, 1);
        // If there are no more listeners for this type of event,
        // remove the window listener
        if (!this.listeners[eventName].length) {
            this.removeWindowListener(this.windowListeners[eventName]);
        }
    }
    addWindowListener(handle) {
        window.addEventListener(handle.windowEventName, handle.handler);
        handle.registered = true;
    }
    removeWindowListener(handle) {
        if (!handle) {
            return;
        }
        window.removeEventListener(handle.windowEventName, handle.handler);
        handle.registered = false;
    }
}
/******** END WEB VIEW PLUGIN ********/
/******** COOKIES PLUGIN ********/
/**
 * Safely web encode a string value (inspired by js-cookie)
 * @param str The string value to encode
 */
const encode = (str) => encodeURIComponent(str)
    .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
    .replace(/[()]/g, escape);
/**
 * Safely web decode a string value (inspired by js-cookie)
 * @param str The string value to decode
 */
const decode = (str) => str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class CapacitorCookiesPluginWeb extends WebPlugin {
    async getCookies() {
        const cookies = document.cookie;
        const cookieMap = {};
        cookies.split(';').forEach(cookie => {
            if (cookie.length <= 0)
                return;
            // Replace first "=" with CAP_COOKIE to prevent splitting on additional "="
            let [key, value] = cookie.replace(/=/, 'CAP_COOKIE').split('CAP_COOKIE');
            key = decode(key).trim();
            value = decode(value).trim();
            cookieMap[key] = value;
        });
        return cookieMap;
    }
    async setCookie(options) {
        try {
            // Safely Encoded Key/Value
            const encodedKey = encode(options.key);
            const encodedValue = encode(options.value);
            // Clean & sanitize options
            const expires = `; expires=${(options.expires || '').replace('expires=', '')}`; // Default is "; expires="
            const path = (options.path || '/').replace('path=', ''); // Default is "path=/"
            const domain = options.url != null && options.url.length > 0
                ? `domain=${options.url}`
                : '';
            document.cookie = `${encodedKey}=${encodedValue || ''}${expires}; path=${path}; ${domain};`;
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async deleteCookie(options) {
        try {
            document.cookie = `${options.key}=; Max-Age=0`;
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async clearCookies() {
        try {
            const cookies = document.cookie.split(';') || [];
            for (const cookie of cookies) {
                document.cookie = cookie
                    .replace(/^ +/, '')
                    .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
            }
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async clearAllCookies() {
        try {
            await this.clearCookies();
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
const CapacitorCookies = registerPlugin('CapacitorCookies', {
    web: () => new CapacitorCookiesPluginWeb(),
});
// UTILITY FUNCTIONS
/**
 * Read in a Blob value and return it as a base64 string
 * @param blob The blob value to convert to a base64 string
 */
const readBlobAsBase64 = async (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
        const base64String = reader.result;
        // remove prefix "data:application/pdf;base64,"
        resolve(base64String.indexOf(',') >= 0
            ? base64String.split(',')[1]
            : base64String);
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(blob);
});
/**
 * Normalize an HttpHeaders map by lowercasing all of the values
 * @param headers The HttpHeaders object to normalize
 */
const normalizeHttpHeaders = (headers = {}) => {
    const originalKeys = Object.keys(headers);
    const loweredKeys = Object.keys(headers).map(k => k.toLocaleLowerCase());
    const normalized = loweredKeys.reduce((acc, key, index) => {
        acc[key] = headers[originalKeys[index]];
        return acc;
    }, {});
    return normalized;
};
/**
 * Builds a string of url parameters that
 * @param params A map of url parameters
 * @param shouldEncode true if you should encodeURIComponent() the values (true by default)
 */
const buildUrlParams = (params, shouldEncode = true) => {
    if (!params)
        return null;
    const output = Object.entries(params).reduce((accumulator, entry) => {
        const [key, value] = entry;
        let encodedValue;
        let item;
        if (Array.isArray(value)) {
            item = '';
            value.forEach(str => {
                encodedValue = shouldEncode ? encodeURIComponent(str) : str;
                item += `${key}=${encodedValue}&`;
            });
            // last character will always be "&" so slice it off
            item.slice(0, -1);
        }
        else {
            encodedValue = shouldEncode ? encodeURIComponent(value) : value;
            item = `${key}=${encodedValue}`;
        }
        return `${accumulator}&${item}`;
    }, '');
    // Remove initial "&" from the reduce
    return output.substr(1);
};
/**
 * Build the RequestInit object based on the options passed into the initial request
 * @param options The Http plugin options
 * @param extra Any extra RequestInit values
 */
const buildRequestInit = (options, extra = {}) => {
    const output = Object.assign({ method: options.method || 'GET', headers: options.headers }, extra);
    // Get the content-type
    const headers = normalizeHttpHeaders(options.headers);
    const type = headers['content-type'] || '';
    // If body is already a string, then pass it through as-is.
    if (typeof options.data === 'string') {
        output.body = options.data;
    }
    // Build request initializers based off of content-type
    else if (type.includes('application/x-www-form-urlencoded')) {
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(options.data || {})) {
            params.set(key, value);
        }
        output.body = params.toString();
    }
    else if (type.includes('multipart/form-data') ||
        options.data instanceof FormData) {
        const form = new FormData();
        if (options.data instanceof FormData) {
            options.data.forEach((value, key) => {
                form.append(key, value);
            });
        }
        else {
            for (const key of Object.keys(options.data)) {
                form.append(key, options.data[key]);
            }
        }
        output.body = form;
        const headers = new Headers(output.headers);
        headers.delete('content-type'); // content-type will be set by `window.fetch` to includy boundary
        output.headers = headers;
    }
    else if (type.includes('application/json') ||
        typeof options.data === 'object') {
        output.body = JSON.stringify(options.data);
    }
    return output;
};
// WEB IMPLEMENTATION
class CapacitorHttpPluginWeb extends WebPlugin {
    /**
     * Perform an Http request given a set of options
     * @param options Options to build the HTTP request
     */
    async request(options) {
        const requestInit = buildRequestInit(options, options.webFetchExtra);
        const urlParams = buildUrlParams(options.params, options.shouldEncodeUrlParams);
        const url = urlParams ? `${options.url}?${urlParams}` : options.url;
        const response = await fetch(url, requestInit);
        const contentType = response.headers.get('content-type') || '';
        // Default to 'text' responseType so no parsing happens
        let { responseType = 'text' } = response.ok ? options : {};
        // If the response content-type is json, force the response to be json
        if (contentType.includes('application/json')) {
            responseType = 'json';
        }
        let data;
        let blob;
        switch (responseType) {
            case 'arraybuffer':
            case 'blob':
                blob = await response.blob();
                data = await readBlobAsBase64(blob);
                break;
            case 'json':
                data = await response.json();
                break;
            case 'document':
            case 'text':
            default:
                data = await response.text();
        }
        // Convert fetch headers to Capacitor HttpHeaders
        const headers = {};
        response.headers.forEach((value, key) => {
            headers[key] = value;
        });
        return {
            data,
            headers,
            status: response.status,
            url: response.url,
        };
    }
    /**
     * Perform an Http GET request given a set of options
     * @param options Options to build the HTTP request
     */
    async get(options) {
        return this.request(Object.assign(Object.assign({}, options), { method: 'GET' }));
    }
    /**
     * Perform an Http POST request given a set of options
     * @param options Options to build the HTTP request
     */
    async post(options) {
        return this.request(Object.assign(Object.assign({}, options), { method: 'POST' }));
    }
    /**
     * Perform an Http PUT request given a set of options
     * @param options Options to build the HTTP request
     */
    async put(options) {
        return this.request(Object.assign(Object.assign({}, options), { method: 'PUT' }));
    }
    /**
     * Perform an Http PATCH request given a set of options
     * @param options Options to build the HTTP request
     */
    async patch(options) {
        return this.request(Object.assign(Object.assign({}, options), { method: 'PATCH' }));
    }
    /**
     * Perform an Http DELETE request given a set of options
     * @param options Options to build the HTTP request
     */
    async delete(options) {
        return this.request(Object.assign(Object.assign({}, options), { method: 'DELETE' }));
    }
}
const CapacitorHttp = registerPlugin('CapacitorHttp', {
    web: () => new CapacitorHttpPluginWeb(),
});
//# sourceMappingURL=index.js.map

const NativeUtils = {
  hapticFeedback: function (feedbackType) {
    try {
      let _exit = false;
      function _temp4(_result) {
        let _exit2 = false;
        if (_exit) return _result;
        function _temp2(_result2) {
          return _exit2 ? _result2 : Promise.resolve(Haptics.impact({
            style: feedbackmap[feedbackType]
          }));
        }
        const _temp = function () {
          if (feedbackType === 'vibrate') {
            return Promise.resolve(Haptics.vibrate()).then(function (_await$Haptics$vibrat) {
              _exit2 = true;
              return _await$Haptics$vibrat;
            });
          }
        }();
        return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
      }
      if (!Capacitor.isNativePlatform()) return Promise.resolve();
      const feedbackmap = {
        light: ImpactStyle.Light,
        medium: ImpactStyle.Medium,
        heavy: ImpactStyle.Heavy
      };
      const _temp3 = function () {
        if (feedbackType === 'selectionClick') {
          return Promise.resolve(Haptics.selectionStart()).then(function (_await$Haptics$select) {
            _exit = true;
            return _await$Haptics$select;
          });
        }
      }();
      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3));
    } catch (e) {
      return Promise.reject(e);
    }
  }
};
function getSafariVersion() {
  const userAgent = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
  if (isSafari) {
    const match = userAgent.match(/Version\/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1]) : null;
  }
  return null;
}

const HorizontalExpander = ({
  children,
  open = false,
  transition = 'ease 0.2s',
  onInnerClick
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: open ? '1fr' : '0fr',
      gridTemplateRows: '1fr',
      transition: transition
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflow: 'hidden'
    },
    onClick: onInnerClick
  }, children));
};

const LogoDark = props => ( /*#__PURE__*/React__default.createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 168,
  height: 168,
  fill: 'none',
  viewBox: '0 0 168 168'
}, props), /*#__PURE__*/React__default.createElement("path", {
  fill: '#18B1AB',
  d: 'M36 56c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#A53AB6',
  d: 'M84 56c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#18B1AB',
  d: 'M132 56c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#0A1F41',
  d: 'M36 104c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#FF565C',
  d: 'M84 104c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#FFC900',
  d: 'M132 104c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#18B1AB',
  d: 'M36 152c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#A53AB6',
  d: 'M84 152c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/React__default.createElement("path", {
  fill: '#18B1AB',
  d: 'M132 152c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
})));
const LoadingSpinner = ({
  size = '16px',
  type = 'bouncy'
}) => {
  switch (type) {
    case 'static':
      return /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(LogoDark, {
        width: size
      }));
    case 'bouncy':
      return /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: 'grid',
          gridTemplateColumns: '1fr',
          height: '64px',
          alignItems: 'center',
          justifyItems: 'center',
          borderRadius: '8px'
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          '--a': 'no-repeat radial-gradient(closest-side, #18b1ab 0 0, #18b1ab 95%, transparent)',
          '--b': 'no-repeat radial-gradient(closest-side, #a53ab6 0 0, #a53ab6 95%, transparent)',
          '--c': 'no-repeat radial-gradient(closest-side, #0a1f41 0 0, #0a1f41 95%, transparent)',
          '--d': 'no-repeat radial-gradient(closest-side, #ff565c 0 0, #ff565c 95%, transparent)',
          '--e': 'no-repeat radial-gradient(closest-side, #ffc900 0 0, #ffc900 95%, transparent)',
          background: 'var(--a) 0 0, var(--c) 0 50%, var(--a) 0 100%, var(--b) 50% 0, var(--d) 50% 50%, var(--b) 50% 100%, var(--a) 100% 0, var(--e) 100% 50%, var(--a) 100% 100%',
          backgroundSize: '16px 16px',
          animation: 'l31 0.5s infinite alternate',
          '@keyframes l31': {
            '0%, 20%': {
              width: '48px',
              height: '48px'
            },
            '90%, 100%': {
              width: '64px',
              height: '64px'
            }
          }
        }
      }));
    case 'swirly':
      return null;
  }
};

const VerticalExpander = ({
  children,
  open = false,
  transition = 'linear 0.2s',
  onInnerClick,
  startingHeight = '0px',
  unmountOnClose = false
}) => {
  const [shouldRenderChildren, setShouldRenderChildren] = useState(unmountOnClose ? open : true);
  useEffect(() => {
    if (open) {
      setShouldRenderChildren(true);
    }
  }, [open]);
  const handleTransitionEnd = () => {
    if (!open && unmountOnClose) {
      setShouldRenderChildren(false);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateRows: open ? '1fr' : '0fr',
      transition: transition
    },
    onTransitionEnd: handleTransitionEnd
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflow: 'hidden',
      minHeight: startingHeight
    },
    onClick: onInnerClick
  }, shouldRenderChildren && children));
};

const Activity = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M8.878 16.821 12 15.057l3.122 1.79-.833-3.338 2.762-2.245-3.618-.302L12 7.799l-1.433 3.152-3.618.288 2.762 2.255-.833 3.327ZM12 18.216l-4.542 2.577a1.42 1.42 0 0 1-.837.203 1.422 1.422 0 0 1-.753-.269 1.583 1.583 0 0 1-.494-.597 1.126 1.126 0 0 1-.062-.793l1.207-4.859L2.492 11.2c-.242-.2-.393-.43-.454-.688-.06-.258-.05-.509.033-.753.083-.245.23-.45.44-.617.211-.167.479-.268.803-.302l5.3-.433 2.062-4.593c.121-.28.305-.486.55-.617a1.625 1.625 0 0 1 1.548 0c.245.13.429.336.55.617l2.062 4.593 5.3.433c.325.034.592.135.803.302.21.167.357.372.44.617.082.244.093.495.033.753s-.212.487-.454.688l-4.027 3.28 1.207 4.858c.074.288.054.553-.062.793-.116.241-.28.44-.494.597a1.422 1.422 0 0 1-.753.269 1.42 1.42 0 0 1-.837-.203L12 18.216Z'
}))));

const Add = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12 20c-.402 0-.744-.14-1.025-.422a1.396 1.396 0 0 1-.422-1.025v-5.106H5.447c-.402 0-.744-.14-1.025-.422A1.396 1.396 0 0 1 4 12c0-.402.14-.744.422-1.025a1.396 1.396 0 0 1 1.025-.422h5.106V5.447c0-.402.14-.744.422-1.025A1.396 1.396 0 0 1 12 4c.402 0 .744.14 1.025.422.281.281.422.623.422 1.025v5.106h5.106c.402 0 .744.14 1.025.422.281.281.422.623.422 1.025 0 .402-.14.744-.422 1.025a1.396 1.396 0 0 1-1.025.422h-5.106v5.106c0 .402-.14.744-.422 1.025A1.396 1.396 0 0 1 12 20Z'
}))));

const Add_Group = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 -960 960 960'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M500-482q29-32 44.5-73t15.5-85q0-44-15.5-85T500-798q60 8 100 53t40 105q0 60-40 105t-100 53Zm198 322q11-18 16.5-38.5T720-240v-40q0-36-16-68.5T662-406q51 18 94.5 46.5T800-280v40q0 33-23.5 56.5T720-160h-22Zm102-360h-40q-17 0-28.5-11.5T720-560q0-17 11.5-28.5T760-600h40v-40q0-17 11.5-28.5T840-680q17 0 28.5 11.5T880-640v40h40q17 0 28.5 11.5T960-560q0 17-11.5 28.5T920-520h-40v40q0 17-11.5 28.5T840-440q-17 0-28.5-11.5T800-480v-40Zm-480 40q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM0-240v-32q0-34 17.5-62.5T64-378q62-31 126-46.5T320-440q66 0 130 15.5T576-378q29 15 46.5 43.5T640-272v32q0 33-23.5 56.5T560-160H80q-33 0-56.5-23.5T0-240Zm320-320q33 0 56.5-23.5T400-640q0-33-23.5-56.5T320-720q-33 0-56.5 23.5T240-640q0 33 23.5 56.5T320-560ZM80-240h480v-32q0-11-5.5-20T540-306q-54-27-109-40.5T320-360q-56 0-111 13.5T100-306q-9 5-14.5 14T80-272v32Zm240-400Zm0 400Z'
}))));

const Add_User = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M18.485 13.452a.97.97 0 0 1-.978-.994v-1.585H15.95a.97.97 0 0 1-.978-.994.97.97 0 0 1 .978-.995h1.559V7.299a.97.97 0 0 1 .977-.994c.278 0 .51.095.697.286a.97.97 0 0 1 .282.708v1.585h1.558a.97.97 0 0 1 .978.994.97.97 0 0 1-.978.995h-1.558v1.585a.97.97 0 0 1-.979.994Zm-9.034-1.458c-1.09 0-2.02-.39-2.786-1.17-.767-.78-1.15-1.724-1.15-2.833 0-1.11.383-2.052 1.15-2.828A3.773 3.773 0 0 1 9.45 4c1.09 0 2.02.388 2.786 1.163.767.776 1.15 1.718 1.15 2.828 0 1.109-.383 2.053-1.15 2.833-.767.78-1.695 1.17-2.786 1.17ZM3.164 20c-.323 0-.598-.115-.824-.345-.227-.23-.34-.51-.34-.839v-1.772c0-.585.15-1.122.449-1.612.3-.49.697-.864 1.193-1.122a13.53 13.53 0 0 1 2.854-1.064c.97-.24 1.955-.359 2.955-.359 1.016 0 2.01.118 2.98.353.97.235 1.913.587 2.83 1.057.495.257.893.63 1.192 1.117.3.488.45 1.03.45 1.63v1.772c0 .329-.114.609-.34.839-.227.23-.502.345-.825.345H3.164Zm1.164-2.368h10.246v-.525a.779.779 0 0 0-.121-.425.843.843 0 0 0-.319-.297 11.08 11.08 0 0 0-2.282-.841 9.985 9.985 0 0 0-2.4-.29 10.415 10.415 0 0 0-4.683 1.13.843.843 0 0 0-.32.298.778.778 0 0 0-.12.425v.525Zm5.123-8.006c.442 0 .82-.16 1.136-.48.315-.32.472-.705.472-1.155 0-.45-.157-.833-.472-1.149a1.545 1.545 0 0 0-1.136-.474c-.442 0-.82.159-1.135.476a1.57 1.57 0 0 0-.473 1.147c0 .45.157.834.472 1.155.315.32.693.48 1.136.48Z'
}))));

const Additional_Information = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M17 20.975C16.7167 20.975 16.4792 20.8792 16.2875 20.6875C16.0958 20.4958 16 20.2583 16 19.975V17.975H14C13.7167 17.975 13.4792 17.8792 13.2875 17.6875C13.0958 17.4958 13 17.2583 13 16.975C13 16.6917 13.0958 16.4542 13.2875 16.2625C13.4792 16.0708 13.7167 15.975 14 15.975H16V13.975C16 13.6917 16.0958 13.4542 16.2875 13.2625C16.4792 13.0708 16.7167 12.975 17 12.975C17.2833 12.975 17.5208 13.0708 17.7125 13.2625C17.9042 13.4542 18 13.6917 18 13.975V15.975H20C20.2833 15.975 20.5208 16.0708 20.7125 16.2625C20.9042 16.4542 21 16.6917 21 16.975C21 17.2583 20.9042 17.4958 20.7125 17.6875C20.5208 17.8792 20.2833 17.975 20 17.975H18V19.975C18 20.2583 17.9042 20.4958 17.7125 20.6875C17.5208 20.8792 17.2833 20.975 17 20.975ZM5 18C4.71667 18 4.47917 17.9042 4.2875 17.7125C4.09583 17.5208 4 17.2833 4 17C4 16.7167 4.09583 16.4792 4.2875 16.2875C4.47917 16.0958 4.71667 16 5 16H11.075C11.025 16.35 11.0042 16.6833 11.0125 17C11.0208 17.3167 11.05 17.65 11.1 18H5ZM5 14C4.71667 14 4.47917 13.9042 4.2875 13.7125C4.09583 13.5208 4 13.2833 4 13C4 12.7167 4.09583 12.4792 4.2875 12.2875C4.47917 12.0958 4.71667 12 5 12H13.65C13.2667 12.2667 12.9208 12.5667 12.6125 12.9C12.3042 13.2333 12.0333 13.6 11.8 14H5ZM5 10C4.71667 10 4.47917 9.90417 4.2875 9.7125C4.09583 9.52083 4 9.28333 4 9C4 8.71667 4.09583 8.47917 4.2875 8.2875C4.47917 8.09583 4.71667 8 5 8H18C18.2833 8 18.5208 8.09583 18.7125 8.2875C18.9042 8.47917 19 8.71667 19 9C19 9.28333 18.9042 9.52083 18.7125 9.7125C18.5208 9.90417 18.2833 10 18 10H5ZM5 6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H18C18.2833 4 18.5208 4.09583 18.7125 4.2875C18.9042 4.47917 19 4.71667 19 5C19 5.28333 18.9042 5.52083 18.7125 5.7125C18.5208 5.90417 18.2833 6 18 6H5Z'
}))));

const Admin = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M16.475 15.141a2.434 2.434 0 0 1-1.788-.736 2.434 2.434 0 0 1-.736-1.788c0-.701.245-1.297.736-1.788a2.434 2.434 0 0 1 1.788-.736c.701 0 1.297.245 1.788.736.49.491.736 1.087.736 1.788 0 .701-.245 1.297-.736 1.788-.49.49-1.087.736-1.788.736ZM12.901 20c-.329 0-.608-.115-.838-.345-.23-.23-.346-.51-.346-.839v-.357c0-.414.108-.797.324-1.15.216-.353.52-.613.913-.781a7.777 7.777 0 0 1 1.724-.521 10.138 10.138 0 0 1 3.591 0 7.8 7.8 0 0 1 1.715.521c.393.168.7.428.92.781.219.353.329.736.329 1.15v.357c0 .329-.115.609-.345.839-.23.23-.51.345-.839.345h-7.148Zm-3.324-8.006c-1.11 0-2.054-.39-2.833-1.17-.78-.78-1.17-1.724-1.17-2.833 0-1.11.39-2.052 1.17-2.828C7.524 4.388 8.468 4 9.577 4c1.11 0 2.054.388 2.833 1.163.78.776 1.17 1.718 1.17 2.828 0 1.109-.39 2.053-1.17 2.833-.78.78-1.724 1.17-2.833 1.17ZM3.184 20c-.33 0-.609-.115-.839-.345-.23-.23-.345-.51-.345-.839v-1.875c0-.522.153-1.013.459-1.472.306-.46.736-.836 1.291-1.127.88-.457 1.813-.814 2.8-1.07a11.984 11.984 0 0 1 3.027-.385c.394 0 .824.03 1.29.09.467.06.91.14 1.327.242v1.275a3.62 3.62 0 0 0-.694.4 3.016 3.016 0 0 0-.513.499 6.125 6.125 0 0 0-.705-.106 7.83 7.83 0 0 0-.705-.032c-.83 0-1.646.098-2.447.294-.801.196-1.573.474-2.316.836a.844.844 0 0 0-.328.301.779.779 0 0 0-.118.42v.526H9.93V20H3.184ZM9.577 9.626c.45 0 .834-.16 1.155-.48.32-.32.48-.705.48-1.155 0-.45-.16-.833-.48-1.149a1.584 1.584 0 0 0-1.155-.474c-.45 0-.834.159-1.155.476-.32.318-.48.7-.48 1.147 0 .45.16.834.48 1.155.32.32.705.48 1.155.48Z'
}))));

const Admin_Boarder = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.516 21c-.701 0-1.296-.22-1.784-.662-.488-.442-.732-.98-.732-1.614V6.994c0-.635.244-1.173.732-1.614.488-.442 1.083-.663 1.784-.663H9.06c.284-.523.686-.94 1.205-1.25A3.313 3.313 0 0 1 12 3c.637 0 1.215.155 1.735.466.519.311.92.728 1.205 1.251h3.544c.701 0 1.296.221 1.784.663.488.441.732.98.732 1.613v11.731c0 .634-.244 1.172-.732 1.614-.488.441-1.083.662-1.784.662H5.516ZM12 6.3a.846.846 0 0 0 .59-.206.687.687 0 0 0 .23-.535.687.687 0 0 0-.23-.534.846.846 0 0 0-.59-.207.846.846 0 0 0-.59.207.687.687 0 0 0-.23.534c0 .219.077.397.23.535.152.138.348.207.59.207ZM5.516 17.495a9.726 9.726 0 0 1 2.898-1.677c1.077-.4 2.273-.6 3.586-.6 1.313 0 2.509.196 3.586.588a9.526 9.526 0 0 1 2.898 1.665V6.993H5.516v10.501ZM12 13.96c.954 0 1.764-.301 2.43-.904.667-.603 1-1.336 1-2.198 0-.863-.333-1.594-1-2.193-.666-.599-1.476-.898-2.43-.898-.954 0-1.764.3-2.43.898-.667.6-1 1.33-1 2.193 0 .862.333 1.595 1 2.198.666.603 1.476.904 2.43.904Zm-4.747 4.764h9.494v-.13a6.963 6.963 0 0 0-2.208-1.114A8.78 8.78 0 0 0 12 17.116a8.78 8.78 0 0 0-2.54.364 6.964 6.964 0 0 0-2.207 1.115v.13Zm4.744-6.663c-.367 0-.677-.117-.932-.351a1.114 1.114 0 0 1-.382-.852c0-.334.129-.616.385-.846a1.35 1.35 0 0 1 .935-.346c.367 0 .677.117.932.349.254.232.382.514.382.845 0 .332-.129.615-.385.85a1.337 1.337 0 0 1-.935.35Z'
}))));

const Airline = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.553 17.504h10.072l1.986-11.008H13.83L6.553 17.504ZM2 20l9.584-14.519a3.328 3.328 0 0 1 1.17-1.088A3.1 3.1 0 0 1 14.283 4h4.315c.764 0 1.383.3 1.855.902.473.602.639 1.286.5 2.053L18.604 20H2Zm12.314-6.117c.634 0 1.17-.227 1.607-.682.437-.455.656-1.013.656-1.672 0-.66-.219-1.216-.656-1.672a2.143 2.143 0 0 0-1.607-.682c-.634 0-1.17.227-1.607.682-.438.456-.656 1.013-.656 1.672 0 .66.219 1.217.656 1.672.438.455.973.682 1.607.682Z'
}))));

const Amenities = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.222 19.85a.88.88 0 0 1-.846-.19A1.052 1.052 0 0 1 3 18.817c0-.2.079-.394.237-.58a1.52 1.52 0 0 1 .62-.428c.32-.12.622-.265.908-.434.286-.17.73-.255 1.33-.255.823 0 1.403.14 1.74.42.338.278.742.418 1.213.418.479 0 .885-.14 1.218-.419.334-.28.911-.419 1.734-.419s1.4.14 1.734.42c.333.278.74.418 1.218.418.48 0 .886-.14 1.219-.419.333-.28.911-.419 1.734-.419.6 0 1.043.085 1.33.255.286.17.589.314.908.434.255.1.462.238.62.418a.873.873 0 0 1 .237.59c0 .349-.125.63-.375.843a.88.88 0 0 1-.847.19c-.42-.119-.748-.264-.985-.433-.237-.17-.533-.255-.888-.255-.48 0-.885.14-1.219.42-.333.278-.911.418-1.734.418-.822 0-1.4-.14-1.733-.419-.334-.279-.74-.419-1.219-.419-.479 0-.885.14-1.219.42-.333.278-.91.418-1.733.418-.823 0-1.401-.14-1.734-.419-.334-.279-.74-.419-1.219-.419-.355 0-.65.085-.888.255-.237.17-.565.314-.985.434Zm0-3.958a.88.88 0 0 1-.846-.191A1.051 1.051 0 0 1 3 14.859c0-.201.079-.393.237-.575.158-.182.365-.323.62-.422a5.71 5.71 0 0 0 .908-.434c.286-.17.73-.254 1.33-.254.823 0 1.402.14 1.739.418.336.28.741.42 1.214.42.479 0 .885-.14 1.218-.42.334-.279.911-.418 1.734-.418s1.405.14 1.746.418c.342.28.744.42 1.206.42.48 0 .886-.14 1.219-.42.333-.279.911-.418 1.734-.418.6 0 1.043.084 1.33.254.286.17.589.314.908.434.255.1.462.237.62.412.158.175.237.37.237.585 0 .348-.125.629-.375.842a.88.88 0 0 1-.847.191c-.42-.12-.748-.262-.985-.428-.237-.165-.533-.248-.888-.248-.48 0-.879.14-1.198.418-.32.28-.905.42-1.755.42-.829 0-1.408-.14-1.738-.42-.33-.279-.735-.418-1.214-.418-.5 0-.905.14-1.214.418-.309.28-.888.42-1.738.42s-1.435-.14-1.755-.42c-.32-.279-.719-.418-1.198-.418-.355 0-.65.083-.888.248-.237.166-.565.309-.985.428Zm4.826-3.797c-.325 0-.647-.061-.965-.184a4.428 4.428 0 0 1-.89-.46l2.944-2.798-.745-.707a4.683 4.683 0 0 0-1.035-.749 4.356 4.356 0 0 0-1.33-.425 1.549 1.549 0 0 1-.86-.431 1.122 1.122 0 0 1-.347-.823c0-.363.135-.667.404-.913.27-.245.58-.346.932-.303.828.094 1.56.28 2.195.56.635.28 1.223.677 1.765 1.192l5.69 5.396a4.428 4.428 0 0 1-.889.461c-.318.123-.64.184-.965.184-.545 0-.982-.14-1.312-.42-.329-.278-.876-.418-1.64-.418-.764 0-1.311.14-1.64.419-.33.28-.767.419-1.312.419Zm7.269-3.552c-.675 0-1.245-.218-1.708-.655a2.133 2.133 0 0 1-.695-1.616c0-.62.232-1.154.695-1.601.463-.447 1.033-.671 1.708-.671s1.242.224 1.7.671c.46.447.69.98.69 1.6 0 .642-.23 1.181-.69 1.617-.458.437-1.025.655-1.7.655Z'
}))));

const Archive = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 -960 960 960',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M480-560q-17 0-28.5 11.5T440-520v128l-36-36q-11-11-28-11t-28 11q-11 11-11 28t11 28l104 104q12 12 28 12t28-12l104-104q11-11 11-28t-11-28q-11-11-28-11t-28 11l-36 36v-128q0-17-11.5-28.5T480-560Zm-280-80v440h560v-440H200Zm0 520q-33 0-56.5-23.5T120-200v-499q0-14 4.5-27t13.5-24l50-61q11-14 27.5-21.5T250-840h460q18 0 34.5 7.5T772-811l50 61q9 11 13.5 24t4.5 27v499q0 33-23.5 56.5T760-120H200Zm16-600h528l-34-40H250l-34 40Zm264 300Z'
}))));

const Arrive = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.279 21c-.355 0-.657-.12-.906-.359A1.165 1.165 0 0 1 3 19.769c0-.342.124-.632.373-.872s.55-.359.906-.359H19.72c.355 0 .657.12.906.36.249.239.373.53.373.871 0 .342-.124.633-.373.872-.249.24-.55.359-.906.359H4.28Zm14.25-4.764L3.932 12.334a1.237 1.237 0 0 1-.67-.43A1.148 1.148 0 0 1 3 11.163v-3.38c0-.4.14-.694.423-.882.282-.189.622-.219 1.02-.091.159.048.313.145.463.29.15.144.25.292.3.444l.476 1.399 4.074 1.083V4.252c0-.437.157-.773.471-1.007.314-.235.698-.301 1.152-.197.231.064.46.195.688.393.227.199.377.41.45.633l2.383 7.33 4.662 1.261c.433.11.781.333 1.044.668s.394.715.394 1.141c0 .616-.256 1.105-.767 1.467-.512.362-1.08.46-1.704.295Z'
}))));

const Attach = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M10.709 21c-1.592 0-2.941-.497-4.048-1.492C5.554 18.513 5 17.301 5 15.871v-9.1c0-1.037.408-1.925 1.225-2.663C7.04 3.369 8.027 3 9.182 3c1.154 0 2.143.37 2.965 1.108.822.738 1.233 1.626 1.233 2.662v6.881h-1.832v-6.88c0-.595-.229-1.098-.686-1.509-.457-.41-1.017-.615-1.678-.615-.662 0-1.222.205-1.679.615-.457.411-.686.914-.686 1.508v9.101c0 .967.38 1.79 1.138 2.472.759.682 1.676 1.023 2.752 1.023.386 0 .753-.048 1.101-.142.349-.095.667-.23.956-.407v1.817c-.318.116-.65.206-.995.27-.345.064-.699.096-1.062.096Zm3.948-3.578h-1.584a1.28 1.28 0 0 1-.888-.329 1.033 1.033 0 0 1-.365-.797c0-.313.122-.579.365-.797a1.28 1.28 0 0 1 .888-.329h1.584v-1.423c0-.313.122-.578.365-.797a1.28 1.28 0 0 1 .888-.329c.348 0 .644.11.888.329.243.219.365.484.365.797v1.423h1.584c.348 0 .644.11.888.329.243.218.365.484.365.797 0 .313-.122.578-.365.797a1.28 1.28 0 0 1-.888.329h-1.584v1.423c0 .312-.122.578-.365.797a1.28 1.28 0 0 1-.888.328 1.28 1.28 0 0 1-.888-.328 1.033 1.033 0 0 1-.365-.797v-1.423Zm-3.948-1.731v1.635c-.742 0-1.373-.234-1.892-.7-.52-.467-.78-1.034-.78-1.7V7.587a.74.74 0 0 1 .268-.586.967.967 0 0 1 .655-.232c.259 0 .475.078.65.232.173.154.26.35.26.586v7.337c0 .217.08.4.241.546.161.147.36.22.598.22Zm3.89-4.493v-3.61c0-.232.085-.427.257-.583a.931.931 0 0 1 .652-.235c.263 0 .48.078.652.232.172.154.258.35.258.586v3.61h-1.82Z'
}))));

const Bike = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.167 20.083c-1.153 0-2.136-.406-2.948-1.218C2.406 18.052 2 17.069 2 15.917c0-1.153.406-2.136 1.219-2.948.812-.813 1.795-1.219 2.948-1.219 1.152 0 2.135.406 2.948 1.219.812.812 1.218 1.795 1.218 2.948 0 1.152-.406 2.135-1.218 2.948-.813.812-1.796 1.218-2.948 1.218Zm0-1.666c.694 0 1.284-.243 1.77-.73a2.41 2.41 0 0 0 .73-1.77c0-.695-.243-1.285-.73-1.771a2.41 2.41 0 0 0-1.77-.73 2.41 2.41 0 0 0-1.771.73 2.411 2.411 0 0 0-.73 1.77c0 .695.244 1.285.73 1.771.486.487 1.076.73 1.77.73ZM13 8.5l-2 2 1.375 1.438c.153.152.267.326.344.52.076.195.114.403.114.625v3.667c0 .236-.08.434-.24.594a.806.806 0 0 1-.593.24.806.806 0 0 1-.594-.24.806.806 0 0 1-.24-.594v-3.333L8.5 11.083a1.483 1.483 0 0 1-.375-.53A1.646 1.646 0 0 1 8 9.916c0-.223.045-.434.135-.636.09-.201.212-.378.365-.531l2.333-2.333a1.64 1.64 0 0 1 .573-.375c.215-.084.441-.125.677-.125.236 0 .462.041.677.125.216.083.407.208.573.375L14.917 8c.32.32.67.58 1.052.781a3.94 3.94 0 0 0 1.219.406c.236.042.42.153.552.334.132.18.177.389.135.625a.835.835 0 0 1-.333.552.785.785 0 0 1-.625.135 6.323 6.323 0 0 1-1.76-.583 5.802 5.802 0 0 1-1.49-1.083L13 8.5Zm1.917-2.167c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.176c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49.458 0 .85.163 1.177.49.326.326.49.718.49 1.177 0 .458-.164.85-.49 1.177-.327.326-.719.49-1.177.49Zm2.916 13.75c-1.152 0-2.135-.406-2.948-1.218-.812-.813-1.218-1.796-1.218-2.948 0-1.153.406-2.136 1.218-2.948.813-.813 1.796-1.219 2.948-1.219 1.153 0 2.136.406 2.948 1.219.813.812 1.219 1.795 1.219 2.948 0 1.152-.406 2.135-1.219 2.948-.812.812-1.795 1.218-2.948 1.218Zm0-1.666c.695 0 1.285-.243 1.771-.73a2.41 2.41 0 0 0 .73-1.77 2.41 2.41 0 0 0-.73-1.771 2.41 2.41 0 0 0-1.77-.73 2.41 2.41 0 0 0-1.771.73 2.411 2.411 0 0 0-.73 1.77c0 .695.243 1.285.73 1.771.486.487 1.076.73 1.77.73Z'
}))));

const Billing = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M11 17H13V16H14C14.2833 16 14.5208 15.9042 14.7125 15.7125C14.9042 15.5208 15 15.2833 15 15V12C15 11.7167 14.9042 11.4792 14.7125 11.2875C14.5208 11.0958 14.2833 11 14 11H11V10H15V8H13V7H11V8H10C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V12C9 12.2833 9.09583 12.5208 9.2875 12.7125C9.47917 12.9042 9.71667 13 10 13H13V14H9V16H11V17ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V6H4V18Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Building = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M16.515 9.395h1.766V7.658h-1.766v1.737Zm0 3.473h1.766v-1.736h-1.766v1.736Zm0 3.474h1.766v-1.737h-1.766v1.737Zm0 3.658v-2.105h3.345V6.105h-7.573v1.093l-2.078-1.492c.075-.488.308-.894.7-1.219A2.093 2.093 0 0 1 12.287 4h7.373c.643 0 1.194.225 1.653.676.458.45.687.993.687 1.625V17.7c0 .632-.23 1.174-.687 1.625-.459.45-1.01.676-1.653.676h-3.145ZM2 18.85v-6.632c0-.383.087-.738.261-1.064.174-.326.416-.597.727-.813l4.04-2.823a2.347 2.347 0 0 1 1.355-.424c.491 0 .941.142 1.35.424l4.028 2.823a2.255 2.255 0 0 1 .988 1.877v6.631a1.1 1.1 0 0 1-.341.815 1.138 1.138 0 0 1-.83.336H9.265v-4.71H7.498V20H3.17c-.325 0-.601-.112-.829-.336A1.1 1.1 0 0 1 2 18.85Zm2.153-.955h1.579v-4.342h5.298v4.342h1.566v-5.797L8.381 9.162l-4.228 2.939v5.794Z'
}))));

const Bus = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.612 22.045a1.58 1.58 0 0 1-1.176-.509 1.708 1.708 0 0 1-.493-1.234V18.72a4.737 4.737 0 0 1-.684-1.205A3.841 3.841 0 0 1 4 16.103V6.496c0-1.534.643-2.659 1.93-3.376 1.285-.717 3.31-1.075 6.076-1.075 2.864 0 4.913.343 6.145 1.029C19.384 3.76 20 4.9 20 6.496v9.607c0 .499-.087.97-.26 1.412-.172.442-.4.843-.683 1.204v1.583c0 .484-.165.895-.493 1.234a1.58 1.58 0 0 1-1.176.509c-.482 0-.878-.169-1.189-.505a1.704 1.704 0 0 1-.466-1.196v-.287H8.267v.287c0 .46-.156.86-.466 1.196-.311.336-.707.505-1.19.505ZM6.5 10.638h11v-2.98h-11v2.98Zm2.278 5.877a1.33 1.33 0 0 0 1.003-.434c.275-.29.412-.642.412-1.056 0-.414-.137-.766-.412-1.056a1.33 1.33 0 0 0-1.003-.434 1.33 1.33 0 0 0-1.002.434c-.275.29-.413.642-.413 1.056 0 .414.138.766.413 1.056.275.29.61.434 1.002.434Zm6.444 0a1.33 1.33 0 0 0 1.002-.434c.275-.29.413-.642.413-1.056 0-.414-.138-.766-.413-1.056a1.33 1.33 0 0 0-1.002-.434 1.33 1.33 0 0 0-1.003.434c-.275.29-.412.642-.412 1.056 0 .414.137.766.412 1.056.276.29.61.434 1.003.434ZM6.764 5.671H17.33c-.236-.282-.743-.518-1.521-.708-.778-.19-2.032-.286-3.762-.286-1.682 0-2.912.104-3.69.31-.779.208-1.31.436-1.593.684Zm1.623 11.754h7.226c.52 0 .963-.195 1.333-.584.37-.39.554-.857.554-1.403v-2.813h-11v2.813c0 .546.185 1.014.554 1.403.37.39.814.584 1.333.584Z'
}))));

const Calendar = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.516 21c-.701 0-1.296-.22-1.784-.662-.488-.442-.732-.98-.732-1.614V6.994c0-.635.244-1.173.732-1.614.488-.442 1.083-.663 1.784-.663h.788v-.725c0-.275.109-.51.327-.703.217-.193.479-.289.783-.289.305 0 .564.096.777.29.214.192.32.427.32.702v.725h6.978v-.725c0-.275.109-.51.326-.703.218-.193.48-.289.784-.289.305 0 .564.096.777.29.213.192.32.427.32.702v.725h.788c.701 0 1.296.221 1.784.663.488.441.732.98.732 1.613v11.731c0 .634-.244 1.172-.732 1.614-.488.441-1.083.662-1.784.662H5.516Zm0-2.276h12.968v-8.441H5.516v8.441Zm0-10.159h12.968V6.993H5.516v1.572ZM12 13.815c-.3 0-.55-.092-.753-.275a.881.881 0 0 1-.304-.681c0-.271.102-.498.304-.681a1.08 1.08 0 0 1 .753-.275c.3 0 .55.091.753.275.202.183.304.41.304.68 0 .272-.102.499-.304.682a1.08 1.08 0 0 1-.753.275Zm-3.797 0c-.3 0-.55-.092-.753-.275a.881.881 0 0 1-.304-.681c0-.271.101-.498.304-.681a1.08 1.08 0 0 1 .753-.275c.3 0 .55.091.753.275.202.183.303.41.303.68 0 .272-.1.499-.303.682a1.08 1.08 0 0 1-.753.275Zm7.594 0a1.09 1.09 0 0 1-.743-.275.87.87 0 0 1-.313-.681.87.87 0 0 1 .313-.681 1.1 1.1 0 0 1 .75-.275c.291 0 .54.091.743.275.205.183.307.41.307.68 0 .272-.101.499-.304.682a1.08 1.08 0 0 1-.753.275ZM12 17.25c-.3 0-.55-.095-.753-.284a.896.896 0 0 1-.304-.678c0-.264.102-.488.304-.673.203-.185.454-.277.753-.277.3 0 .55.092.753.275.202.183.304.41.304.68a.89.89 0 0 1-.304.673 1.062 1.062 0 0 1-.753.284Zm-3.797 0c-.3 0-.55-.095-.753-.284a.896.896 0 0 1-.304-.678c0-.264.101-.488.304-.673.202-.185.453-.277.753-.277s.55.092.753.275c.202.183.303.41.303.68a.89.89 0 0 1-.303.673 1.062 1.062 0 0 1-.753.284Zm7.594 0c-.287 0-.534-.095-.743-.284a.884.884 0 0 1 0-1.35c.209-.186.459-.278.75-.278s.54.092.743.275c.205.183.307.41.307.68 0 .26-.101.484-.304.673a1.061 1.061 0 0 1-.753.284Z'
}))));

const Calendar_Today = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V3c0-.283.096-.52.287-.712A.968.968 0 0 1 7 2c.283 0 .52.096.713.288.191.191.287.429.287.712v1h8V3c0-.283.096-.52.288-.712A.968.968 0 0 1 17 2c.283 0 .52.096.712.288.192.191.288.429.288.712v1h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Z'
}), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  stroke: props.fill ?? ColoursObj.core.primary,
  strokeWidth: 0.3,
  d: 'M9.006 14.676a.644.644 0 0 0-.476-.207.644.644 0 0 0-.476.206.704.704 0 0 0-.204.481.656.656 0 0 0 .19.49l2.222 2.298a.637.637 0 0 0 .939 0l4.752-4.918a.68.68 0 0 0 .197-.485.68.68 0 0 0-.197-.485.644.644 0 0 0-.476-.206.644.644 0 0 0-.476.206l-4.27 4.418-1.725-1.798Z'
}))));

const Camera = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.746 16.678c1.043 0 1.93-.365 2.66-1.095.73-.73 1.095-1.617 1.095-2.66 0-1.043-.365-1.93-1.095-2.66-.73-.73-1.617-1.095-2.66-1.095-1.043 0-1.93.365-2.66 1.095-.73.73-1.095 1.617-1.095 2.66 0 1.043.365 1.93 1.095 2.66.73.73 1.617 1.095 2.66 1.095ZM5.211 20a2.134 2.134 0 0 1-1.567-.644A2.134 2.134 0 0 1 3 17.788v-9.73c0-.617.215-1.14.644-1.569.429-.429.951-.643 1.567-.643h2.393l1.043-1.138c.2-.236.446-.413.736-.531A2.36 2.36 0 0 1 10.28 4h2.934c.307 0 .606.059.896.177.29.118.536.295.736.53l1.043 1.139h2.393c.616 0 1.139.214 1.568.643.429.43.643.952.643 1.568v9.731c0 .617-.214 1.14-.643 1.568-.43.43-.952.644-1.568.644H5.21Zm13.07-2.212v-9.73H5.21v9.73h13.07Z'
}))));

const Cancel = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm12 13.336 2.296 2.296c.182.182.405.27.668.266a.93.93 0 0 0 .668-.278.908.908 0 0 0 .273-.668.908.908 0 0 0-.273-.668L13.336 12l2.296-2.296a.908.908 0 0 0 .273-.668.908.908 0 0 0-.273-.668.908.908 0 0 0-.668-.272.908.908 0 0 0-.668.272L12 10.664 9.704 8.368a.901.901 0 0 0-.662-.272c-.26 0-.48.09-.662.272a.908.908 0 0 0-.272.668c0 .263.09.486.272.668L10.664 12l-2.296 2.296a.88.88 0 0 0-.266.662c.004.26.097.48.278.662a.908.908 0 0 0 .668.272c.264 0 .486-.09.668-.272L12 13.336ZM12 21a8.797 8.797 0 0 1-3.519-.707 9.063 9.063 0 0 1-2.854-1.92 9.064 9.064 0 0 1-1.92-2.854A8.798 8.798 0 0 1 3 12c0-1.253.236-2.426.707-3.519a9.063 9.063 0 0 1 1.92-2.854c.81-.81 1.76-1.45 2.854-1.92A8.798 8.798 0 0 1 12 3c1.253 0 2.426.236 3.519.707a9.064 9.064 0 0 1 2.854 1.92c.81.81 1.45 1.76 1.92 2.854A8.797 8.797 0 0 1 21 12a8.797 8.797 0 0 1-.707 3.519 9.063 9.063 0 0 1-1.92 2.854c-.81.81-1.76 1.45-2.854 1.92A8.797 8.797 0 0 1 12 21Zm0-2.276c1.886 0 3.478-.649 4.776-1.948 1.299-1.298 1.948-2.89 1.948-4.776 0-1.886-.649-3.478-1.948-4.776-1.298-1.299-2.89-1.948-4.776-1.948-1.886 0-3.478.649-4.776 1.948C5.925 8.522 5.276 10.114 5.276 12c0 1.886.649 3.478 1.948 4.776 1.298 1.299 2.89 1.948 4.776 1.948Z'
}))));

const Cancel_Event = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm12 15.912-1.23 1.253a.858.858 0 0 1-.651.266.9.9 0 0 1-.65-.279.917.917 0 0 1-.268-.667c0-.264.089-.487.267-.668l1.22-1.24-1.231-1.253a.896.896 0 0 1-.262-.668.938.938 0 0 1 .273-.668.885.885 0 0 1 .657-.273c.259 0 .477.091.656.273L12 13.24l1.23-1.253a.885.885 0 0 1 .657-.273c.26 0 .478.091.656.273a.916.916 0 0 1 .268.668c0 .263-.089.486-.268.668l-1.23 1.252 1.23 1.253a.909.909 0 0 1 .268.662c0 .26-.089.48-.268.662a.884.884 0 0 1-.656.272.885.885 0 0 1-.656-.273L12 15.912ZM6.236 21c-.623 0-1.151-.22-1.585-.662A2.215 2.215 0 0 1 4 18.724V6.994c0-.635.217-1.173.65-1.614a2.139 2.139 0 0 1 1.586-.663h.701v-.725c0-.275.097-.51.29-.703A.952.952 0 0 1 7.924 3c.27 0 .501.096.69.29.19.192.285.427.285.702v.725H15.1v-.725c0-.275.097-.51.29-.703A.952.952 0 0 1 16.088 3c.27 0 .501.096.69.29.19.192.285.427.285.702v.725h.7c.624 0 1.152.221 1.586.663.434.441.651.98.651 1.613v11.731c0 .634-.217 1.172-.65 1.614a2.139 2.139 0 0 1-1.586.662H6.236Zm0-2.276h11.528v-8.441H6.236v8.441Zm0-10.159h11.528V6.993H6.236v1.572Z'
}))));

const Car_Allocation = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M8.88506 16.1696C9.49284 16.1696 10.0161 15.9531 10.4549 15.5203C10.8936 15.0875 11.113 14.5672 11.113 13.9595C11.113 13.3517 10.8936 12.8308 10.4549 12.3967C10.0161 11.9627 9.49284 11.7456 8.88506 11.7456C8.27727 11.7456 7.75698 11.962 7.32418 12.3948C6.89136 12.8276 6.67496 13.3479 6.67496 13.9557C6.67496 14.5635 6.89136 15.0844 7.32418 15.5185C7.75698 15.9525 8.27727 16.1696 8.88506 16.1696ZM15.1149 16.1696C15.7227 16.1696 16.243 15.9531 16.6758 15.5203C17.1086 15.0875 17.325 14.5672 17.325 13.9595C17.325 13.3517 17.1086 12.8308 16.6758 12.3967C16.243 11.9627 15.7227 11.7456 15.1149 11.7456C14.5071 11.7456 13.9838 11.962 13.5451 12.3948C13.1063 12.8276 12.8869 13.3479 12.8869 13.9557C12.8869 14.5635 13.1063 15.0844 13.5451 15.5185C13.9838 15.9525 14.5071 16.1696 15.1149 16.1696ZM11.9981 10.9152C12.6059 10.9152 13.1268 10.6988 13.5609 10.266C13.9949 9.83317 14.212 9.31287 14.212 8.70511C14.212 8.09732 13.9955 7.57405 13.5627 7.13528C13.1299 6.69652 12.6096 6.47713 12.0019 6.47713C11.3941 6.47713 10.8732 6.69652 10.4391 7.13528C10.005 7.57405 9.78801 8.09732 9.78801 8.70511C9.78801 9.31287 10.0044 9.83317 10.4372 10.266C10.87 10.6988 11.3903 10.9152 11.9981 10.9152ZM12 22.4805C10.5413 22.4805 9.1754 22.2058 7.90233 21.6564C6.62925 21.1071 5.52185 20.3616 4.58013 19.4198C3.6384 18.4781 2.89286 17.3707 2.34353 16.0976C1.7942 14.8246 1.51953 13.4587 1.51953 12C1.51953 10.5413 1.7942 9.1754 2.34353 7.90233C2.89286 6.62925 3.6384 5.52185 4.58013 4.58013C5.52185 3.6384 6.62925 2.89287 7.90233 2.34353C9.1754 1.7942 10.5413 1.51953 12 1.51953C13.4587 1.51953 14.8246 1.7942 16.0976 2.34353C17.3707 2.89287 18.4781 3.6384 19.4198 4.58013C20.3616 5.52185 21.1071 6.62925 21.6564 7.90233C22.2058 9.1754 22.4804 10.5413 22.4804 12C22.4804 13.4587 22.2058 14.8246 21.6564 16.0976C21.1071 17.3707 20.3616 18.4781 19.4198 19.4198C18.4781 20.3616 17.3707 21.1071 16.0976 21.6564C14.8246 22.2058 13.4587 22.4805 12 22.4805ZM12 19.8304C14.1956 19.8304 16.0496 19.0742 17.5619 17.5619C19.0742 16.0496 19.8304 14.1956 19.8304 12C19.8304 9.80433 19.0742 7.95035 17.5619 6.43803C16.0496 4.92571 14.1956 4.16956 12 4.16956C9.80433 4.16956 7.95035 4.92571 6.43803 6.43803C4.92571 7.95035 4.16956 9.80433 4.16956 12C4.16956 14.1956 4.92571 16.0496 6.43803 17.5619C7.95035 19.0742 9.80433 19.8304 12 19.8304Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Car_Type = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M6.34432 18.1133V18.345C6.34432 18.8047 6.1824 19.1955 5.85855 19.5173C5.53472 19.8391 5.14149 20 4.67885 20C4.22071 20 3.82636 19.8358 3.49581 19.5073C3.16527 19.1788 3 18.787 3 18.3317V11.4001C3 11.2545 3.01014 11.1134 3.03043 10.9767C3.05073 10.84 3.08564 10.7067 3.13516 10.5768L4.87491 5.67343C5.05514 5.17168 5.35834 4.76733 5.7845 4.4604C6.21067 4.15347 6.69652 4 7.24205 4H16.758C17.3035 4 17.7893 4.15347 18.2155 4.4604C18.6417 4.76733 18.9449 5.17168 19.1251 5.67343L20.8648 10.5768C20.9144 10.7067 20.9493 10.84 20.9696 10.9767C20.9899 11.1134 21 11.2545 21 11.4001V18.345C21 18.8047 20.8381 19.1955 20.5143 19.5173C20.1904 19.8391 19.7972 20 19.3346 20C18.8764 20 18.482 19.8358 18.1515 19.5073C17.821 19.1788 17.6557 18.787 17.6557 18.3317V18.1133H6.34432ZM6.302 9.16996H17.698L16.7683 6.49989H7.23172L6.302 9.16996ZM7.80853 14.7501C8.20408 14.7501 8.5403 14.6125 8.81718 14.3374C9.09407 14.0622 9.23251 13.7281 9.23251 13.335C9.23251 12.942 9.09407 12.6079 8.81718 12.3327C8.5403 12.0576 8.20408 11.92 7.80853 11.92C7.41298 11.92 7.07676 12.0576 6.79988 12.3327C6.52299 12.6079 6.38455 12.942 6.38455 13.335C6.38455 13.7281 6.52299 14.0622 6.79988 14.3374C7.07676 14.6125 7.41298 14.7501 7.80853 14.7501ZM16.1915 14.7501C16.587 14.7501 16.9232 14.6125 17.2001 14.3374C17.477 14.0622 17.6155 13.7281 17.6155 13.335C17.6155 12.942 17.477 12.6079 17.2001 12.3327C16.9232 12.0576 16.587 11.92 16.1915 11.92C15.7959 11.92 15.4597 12.0576 15.1828 12.3327C14.9059 12.6079 14.7675 12.942 14.7675 13.335C14.7675 13.7281 14.9059 14.0622 15.1828 14.3374C15.4597 14.6125 15.7959 14.7501 16.1915 14.7501ZM5.51573 15.6134H18.4843V11.0567H5.51573V15.6134Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Chart = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.48 21c-.69 0-1.275-.24-1.757-.72A2.374 2.374 0 0 1 3 18.533v-7.659c0-.686.241-1.269.723-1.748a2.399 2.399 0 0 1 1.757-.72c.69 0 1.276.24 1.758.72.482.479.723 1.062.723 1.748v7.66c0 .686-.241 1.268-.723 1.748S6.17 21 5.48 21ZM12 21c-.69 0-1.276-.24-1.758-.72a2.374 2.374 0 0 1-.722-1.748V5.468c0-.687.24-1.27.723-1.749A2.399 2.399 0 0 1 12 3c.69 0 1.276.24 1.758.72.481.479.722 1.061.722 1.748v13.064c0 .687-.24 1.27-.723 1.749-.481.48-1.067.719-1.757.719Zm6.52 0c-.69 0-1.276-.24-1.758-.72a2.374 2.374 0 0 1-.723-1.748v-3.335c0-.686.241-1.269.723-1.748a2.398 2.398 0 0 1 1.758-.72c.69 0 1.275.24 1.757.72S21 14.51 21 15.197v3.335c0 .687-.24 1.27-.723 1.749-.482.48-1.068.719-1.757.719Z'
}))));

const Chat = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M4.16629 17.3081C4.23041 17.042 4.28604 16.7586 4.33271 16.4592C4.41058 15.9595 4.24891 15.4614 3.98596 15.0294C3.33848 13.9659 3.00002 12.7882 3.00002 11.5789C3.00002 7.39986 7.03742 4 12 4C16.9626 4 21 7.39986 21 11.5789C21 15.758 16.9626 19.1579 12 19.1579C11.0353 19.1579 10.0954 19.0318 9.19409 18.7819C8.63566 18.6271 8.03765 18.6657 7.50369 18.8909C7.04376 19.0848 6.56916 19.2488 6.11237 19.3862C5.90181 19.4496 5.69502 19.5073 5.4952 19.5597C4.59612 19.7953 3.83808 19.9231 3.51089 19.9729C3.51084 19.9729 3.51094 19.9729 3.51089 19.9729C3.41614 19.9873 3.35739 19.9952 3.34202 19.9972C3.32792 19.9992 3.31382 20 3.30002 20C3.18752 20 3.08282 19.9408 3.03152 19.8445C2.97392 19.7367 2.99672 19.6062 3.08792 19.5208C3.14397 19.4684 3.1986 19.4113 3.25177 19.3495C3.2532 19.3479 3.25464 19.3462 3.25607 19.3445C3.27084 19.3273 3.28549 19.3097 3.30002 19.2917C3.61693 18.9004 3.8796 18.3415 4.07813 17.6443C4.10909 17.5355 4.13849 17.4234 4.16629 17.3081ZM6.84424 16.4677C7.81399 16.1322 8.86819 16.0973 9.862 16.3728C10.5395 16.5606 11.2543 16.6579 12 16.6579C16.0017 16.6579 18.5 13.992 18.5 11.5789C18.5 9.16594 16.0017 6.5 12 6.5C7.99831 6.5 5.50002 9.16594 5.50002 11.5789C5.50002 12.3115 5.70275 13.0418 6.12137 13.7294C6.5236 14.3901 6.91609 15.3479 6.84424 16.4677Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Chat_Notf = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  fillRule: 'evenodd',
  d: 'M2.524 19.966a8.42 8.42 0 0 1-.201.031.284.284 0 0 1-.293-.153.279.279 0 0 1 .053-.323c.05-.05.099-.103.146-.16l.004-.006a2.35 2.35 0 0 0 .05-.063c.302-.395.552-.96.74-1.665a11.888 11.888 0 0 0 .29-1.576c.027-.24-.042-.48-.174-.682A6.927 6.927 0 0 1 2 11.58C2 7.399 5.813 4 10.5 4c.703 0 1.387.077 2.041.22.775.172.881 1.199.414 1.84-.288.396-.783.618-1.264.537A7.206 7.206 0 0 0 10.5 6.5c-3.583 0-6 2.542-6 5.079 0 .842.244 1.672.736 2.429.393.605.666 1.42.56 2.332-.001.006.005.01.01.009a3.648 3.648 0 0 1 2.482-.05 6.839 6.839 0 0 0 2.212.359c2.15 0 3.88-.915 4.92-2.195a1.33 1.33 0 0 1 1.141-.482c.145.013.291.019.439.019.689 0 1.303.658.94 1.242-1.451 2.333-4.242 3.916-7.44 3.916a9.342 9.342 0 0 1-3.016-.492 1.149 1.149 0 0 0-.879.06c-.492.244-1.014.446-1.518.613a17.999 17.999 0 0 1-2.563.628Z',
  clipRule: 'evenodd'
}), /*#__PURE__*/createElement("path", {
  fill: '#FF565C',
  d: 'M22 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z'
}))));

const Chevron_Down = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M17.62 8.415A1.225 1.225 0 0 0 16.678 8c-.374 0-.688.138-.942.415L12 12.498 8.264 8.415A1.225 1.225 0 0 0 7.322 8c-.374 0-.688.138-.942.415-.253.277-.38.62-.38 1.03 0 .408.127.752.38 1.028l4.678 5.111A1.235 1.235 0 0 0 12 16a1.235 1.235 0 0 0 .942-.415l4.678-5.112c.253-.277.38-.62.38-1.029 0-.409-.127-.752-.38-1.029Z'
}))));

const Chevron_Expand = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12.46 7.068c0-.352.135-.663.404-.932a1.28 1.28 0 0 1 .932-.403h4.408a1.2 1.2 0 0 1 .515.105c.149.07.284.165.405.286.12.12.219.258.294.413a.987.987 0 0 1 .096.506v4.424c0 .352-.134.66-.403.924s-.58.396-.932.396a1.28 1.28 0 0 1-.932-.404 1.28 1.28 0 0 1-.403-.931l-.01-3.039H13.77c-.352 0-.659-.136-.919-.408a1.317 1.317 0 0 1-.39-.937ZM6.579 18.67a1.26 1.26 0 0 1-.277-.413 1.584 1.584 0 0 1-.114-.506v-4.409c0-.352.135-.663.403-.931a1.28 1.28 0 0 1 .932-.404c.353 0 .664.135.932.403.27.27.403.58.403.932l.01 3.039h3.064c.353 0 .659.136.92.408.26.272.39.584.39.937 0 .352-.135.663-.403.932a1.28 1.28 0 0 1-.932.403H7.497c-.171 0-.337-.035-.497-.105a1.354 1.354 0 0 1-.422-.286Z'
}))));

const Chevron_Left = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M15.585 17.62c.276-.254.415-.568.415-.942s-.139-.688-.415-.942L11.502 12l4.082-3.736c.277-.254.416-.568.416-.942s-.139-.688-.415-.942c-.277-.253-.62-.38-1.03-.38-.409 0-.752.127-1.028.38l-5.112 4.678A1.235 1.235 0 0 0 8 12a1.235 1.235 0 0 0 .415.942l5.112 4.678c.277.253.62.38 1.029.38.409 0 .752-.127 1.029-.38Z'
}))));

const Chevron_Right = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M8.415 17.62A1.225 1.225 0 0 1 8 16.678c0-.374.138-.688.415-.942L12.498 12 8.415 8.264A1.225 1.225 0 0 1 8 7.322c0-.374.138-.688.415-.942.277-.253.62-.38 1.03-.38.408 0 .752.127 1.028.38l5.111 4.678A1.235 1.235 0 0 1 16 12a1.235 1.235 0 0 1-.415.942l-5.112 4.678c-.277.253-.62.38-1.029.38-.409 0-.752-.127-1.029-.38Z'
}))));

const Chevron_Up = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.38 15.585c.254.276.568.415.942.415s.688-.139.942-.415L12 11.502l3.736 4.082c.254.277.568.416.942.416s.688-.139.942-.415c.253-.277.38-.62.38-1.03 0-.409-.127-.752-.38-1.028l-4.678-5.112A1.235 1.235 0 0 0 12 8a1.235 1.235 0 0 0-.942.415L6.38 13.527c-.253.277-.38.62-.38 1.029 0 .409.127.752.38 1.029Z'
}))));

const Circle = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, /*#__PURE__*/createElement("rect", {
  width: '16',
  height: '16',
  rx: '8',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Contact_Phone = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M19.572 21c-2.107 0-4.155-.469-6.146-1.407a18.722 18.722 0 0 1-5.299-3.72 18.72 18.72 0 0 1-3.72-5.3C3.469 8.584 3 6.536 3 4.429c0-.408.136-.748.408-1.02A1.384 1.384 0 0 1 4.428 3h3.837c.428 0 .783.112 1.065.335.281.223.465.535.55.936l.605 3.046c.068.365.064.688-.012.968-.075.281-.234.529-.475.743L7.612 11.25c.594.98 1.325 1.899 2.192 2.758.867.86 1.81 1.605 2.825 2.235l2.329-2.288c.24-.232.521-.395.84-.489.32-.093.657-.102 1.014-.025l2.917.625c.41.101.724.282.943.542.219.26.328.596.328 1.006v3.944A1.404 1.404 0 0 1 19.572 21ZM6.4 8.946l1.555-1.448-.377-1.979H5.557c.061.587.156 1.166.285 1.737.129.57.315 1.134.558 1.69Zm12.08 9.46v-2.024l-1.965-.425-1.566 1.539c.565.242 1.143.438 1.736.588.592.15 1.19.257 1.796.322Z'
}))));

const Copy = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M10 18c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 8 16V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 10 2h9c.55 0 1.02.196 1.413.587C20.803 2.98 21 3.45 21 4v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 18h-9Zm0-2h9V4h-9v12Zm-4 6c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 4 20V7c0-.283.096-.52.287-.713A.968.968 0 0 1 5 6c.283 0 .52.096.713.287.191.192.287.43.287.713v13h10c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 16 22H6Z'
}))));

const Cross = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm12 13.703-5.962 5.962c-.223.224-.507.335-.852.335-.344 0-.628-.111-.851-.335-.223-.223-.335-.507-.335-.851 0-.345.112-.629.335-.852L10.297 12 4.335 6.038C4.112 5.815 4 5.531 4 5.186c0-.344.112-.628.335-.851.223-.223.507-.335.851-.335.345 0 .629.112.852.335L12 10.297l5.962-5.962c.223-.223.507-.335.852-.335.344 0 .628.112.851.335.224.223.335.507.335.851 0 .345-.111.629-.335.852L13.703 12l5.962 5.962c.224.223.335.507.335.852 0 .344-.111.628-.335.851-.223.224-.507.335-.851.335-.345 0-.629-.111-.852-.335L12 13.703Z'
}))));

const Customise = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12 21a8.654 8.654 0 0 1-3.484-.713A9.183 9.183 0 0 1 5.65 18.35a9.181 9.181 0 0 1-1.937-2.866A8.655 8.655 0 0 1 3 12c0-1.244.24-2.413.722-3.506a9.08 9.08 0 0 1 1.968-2.86 9.338 9.338 0 0 1 2.907-1.926A8.96 8.96 0 0 1 12.143 3c1.196 0 2.33.207 3.398.62a9.037 9.037 0 0 1 2.818 1.717 8.204 8.204 0 0 1 1.928 2.593c.475.998.713 2.075.713 3.23 0 1.694-.507 3.042-1.521 4.044-1.014 1.002-2.29 1.502-3.826 1.502h-1.31c-.096 0-.167.028-.213.083a.302.302 0 0 0-.069.2c0 .156.083.346.25.57.165.226.248.526.248.9 0 .78-.24 1.4-.723 1.856-.483.457-1.095.685-1.836.685Zm-4.577-8.141c.372 0 .68-.122.923-.365s.365-.551.365-.923c0-.373-.122-.68-.365-.923a1.251 1.251 0 0 0-.923-.365c-.373 0-.68.121-.924.365a1.251 1.251 0 0 0-.365.923c0 .372.122.68.365.923.244.243.551.365.924.365Zm2.503-3.326c.372 0 .68-.122.923-.365s.365-.551.365-.923-.122-.68-.365-.923a1.251 1.251 0 0 0-.923-.365c-.372 0-.68.121-.923.365a1.251 1.251 0 0 0-.365.923c0 .372.121.68.365.923.243.243.55.365.923.365Zm4.148 0c.372 0 .68-.122.923-.365.244-.243.365-.551.365-.923s-.121-.68-.365-.923a1.251 1.251 0 0 0-.923-.365c-.372 0-.68.121-.923.365a1.251 1.251 0 0 0-.365.923c0 .372.122.68.365.923s.55.365.923.365Zm2.467 3.326c.372 0 .68-.122.923-.365.244-.243.365-.551.365-.923 0-.373-.122-.68-.365-.923a1.251 1.251 0 0 0-.923-.365c-.372 0-.68.121-.923.365a1.251 1.251 0 0 0-.365.923c0 .372.122.68.365.923s.55.365.923.365Zm-4.614 5.865c.11 0 .2-.031.268-.093a.317.317 0 0 0 .1-.245c0-.2-.108-.422-.327-.666-.219-.243-.328-.62-.328-1.132 0-.642.221-1.162.665-1.56.443-.398.985-.597 1.627-.597h1.721c.929 0 1.673-.272 2.232-.815.56-.543.84-1.333.84-2.371 0-1.732-.655-3.16-1.962-4.284-1.308-1.123-2.848-1.685-4.62-1.685-1.899 0-3.518.653-4.858 1.96-1.34 1.307-2.01 2.897-2.01 4.77 0 1.859.65 3.444 1.947 4.753 1.298 1.31 2.866 1.965 4.705 1.965Z'
}))));

const Dashboard = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12.81 7.877V4.214c0-.338.118-.624.354-.86.235-.236.521-.354.857-.354h5.768c.336 0 .622.118.858.354.235.236.353.522.353.86v3.663c0 .337-.118.624-.353.86a1.166 1.166 0 0 1-.858.354h-5.768c-.336 0-.622-.118-.857-.354a1.172 1.172 0 0 1-.353-.86ZM3 12.058V4.214c0-.338.118-.624.353-.86.236-.236.522-.354.858-.354h5.767c.337 0 .623.118.858.354.236.236.353.522.353.86v7.844c0 .337-.117.624-.353.86a1.167 1.167 0 0 1-.858.354H4.211c-.336 0-.622-.118-.858-.354a1.172 1.172 0 0 1-.353-.86Zm9.81 7.728v-7.844c0-.337.118-.624.354-.86.235-.236.521-.354.857-.354h5.768c.336 0 .622.118.858.354.235.236.353.523.353.86v7.844c0 .338-.118.624-.353.86a1.166 1.166 0 0 1-.858.354h-5.768c-.336 0-.622-.118-.857-.354a1.172 1.172 0 0 1-.353-.86Zm-9.81 0v-3.663c0-.337.118-.624.353-.86.236-.236.522-.354.858-.354h5.767c.337 0 .623.118.858.354.236.236.353.523.353.86v3.663c0 .338-.117.624-.353.86a1.167 1.167 0 0 1-.858.354H4.211c-.336 0-.622-.118-.858-.354a1.172 1.172 0 0 1-.353-.86Zm2.422-8.941h3.346V5.427H5.422v5.418Zm9.81 7.728h3.346v-5.418h-3.345v5.418Zm0-11.91h3.346V5.427h-3.345v1.237Zm-9.81 11.91h3.346v-1.236H5.422v1.236Z'
}))));

const Delete = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M7.483 20a2.234 2.234 0 0 1-1.646-.68 2.258 2.258 0 0 1-.676-1.654V6.5c-.323 0-.597-.113-.822-.34A1.129 1.129 0 0 1 4 5.334c0-.324.113-.6.339-.827.225-.226.5-.34.822-.34h3.938c0-.324.113-.6.339-.827.225-.227.5-.34.822-.34h3.48c.322 0 .597.113.822.34.226.227.339.503.339.827h3.938c.323 0 .597.114.822.34.226.227.339.503.339.827 0 .324-.113.6-.339.827-.225.227-.5.34-.822.34v11.165c0 .65-.225 1.202-.676 1.655-.45.453-.999.679-1.646.679H7.483Zm0-13.499v11.165h9.034V6.5H7.483Zm1.666 8.522c0 .283.098.523.295.721a.974.974 0 0 0 .717.297.994.994 0 0 0 .723-.297.974.974 0 0 0 .302-.72v-5.88c0-.283-.1-.525-.302-.727a.984.984 0 0 0-.723-.303.964.964 0 0 0-.717.303 1.005 1.005 0 0 0-.295.727v5.88Zm3.665 0c0 .283.1.523.302.721a.994.994 0 0 0 .723.297c.281 0 .52-.099.717-.297a.984.984 0 0 0 .295-.72v-5.88c0-.283-.098-.525-.295-.727a.964.964 0 0 0-.717-.303.984.984 0 0 0-.723.303.995.995 0 0 0-.302.727v5.88Z'
}))));

const Depart = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.708 21c-.327 0-.606-.13-.835-.39a1.38 1.38 0 0 1-.344-.946c0-.372.114-.687.344-.947.229-.26.508-.39.835-.39H18.95c.328 0 .606.13.835.39.23.26.344.575.344.947 0 .37-.114.686-.344.946-.229.26-.508.39-.835.39H4.708Zm1.478-5.273a1.023 1.023 0 0 1-.74-.047 1.186 1.186 0 0 1-.567-.55l-1.703-3.253c-.199-.373-.23-.725-.09-1.055.138-.33.402-.539.793-.625a.895.895 0 0 1 .476.032c.18.055.323.14.43.252l1.156 1.146 3.757-1.14L6.87 5.07c-.214-.414-.252-.813-.115-1.198.138-.384.413-.654.825-.81.213-.077.451-.081.713-.013.262.069.477.184.644.347l5.504 5.61 4.3-1.29c.575-.163 1.096-.044 1.56.356.466.4.699.939.699 1.615 0 .446-.123.845-.37 1.197a1.785 1.785 0 0 1-.937.708L6.186 15.727Z'
}))));

const Diagonal_Enlarge = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.137 20c-.316 0-.584-.11-.805-.331A1.096 1.096 0 0 1 4 18.863v-5.147c0-.316.11-.584.332-.805.22-.221.489-.332.805-.332.316 0 .584.11.805.332.221.22.332.489.332.805v2.41l9.851-9.853h-2.41c-.315 0-.583-.11-.804-.331a1.096 1.096 0 0 1-.332-.805c0-.316.11-.584.332-.805.22-.221.489-.332.805-.332h5.147c.316 0 .585.11.806.332.22.22.331.489.331.805v5.147c0 .316-.11.584-.331.805-.221.221-.49.332-.806.332-.316 0-.584-.11-.805-.332a1.096 1.096 0 0 1-.331-.805v-2.41l-9.852 9.853h2.41c.315 0 .583.11.804.331.221.221.332.49.332.805 0 .316-.11.585-.332.806-.22.22-.489.331-.805.331H5.137Z'
}))));

const Document = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M7.875 20c-.523 0-.966-.196-1.33-.589-.363-.392-.545-.87-.545-1.434V6.023c0-.564.182-1.042.546-1.434A1.744 1.744 0 0 1 7.875 4h4.906c.25 0 .49.05.716.152.227.102.428.248.605.438l3.351 3.616c.177.19.312.408.406.652.094.245.141.502.141.772v8.347c0 .564-.182 1.042-.546 1.434a1.744 1.744 0 0 1-1.329.589h-8.25Zm4.713-11.172V6.023H7.875v11.954h8.25V9.84h-2.6a.872.872 0 0 1-.664-.295 1.016 1.016 0 0 1-.274-.716Z'
}))));

const Download = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12.014 15.222c-.172 0-.339-.03-.5-.09a1.232 1.232 0 0 1-.434-.279L7.233 11.09a1.228 1.228 0 0 1-.377-.914c0-.364.125-.668.377-.915a1.31 1.31 0 0 1 .94-.374c.375-.004.688.118.94.364l1.564 1.53V4.308c0-.363.13-.672.39-.927.26-.254.576-.381.947-.381.372 0 .688.127.947.381.26.255.39.564.39.927v6.473l1.564-1.53c.252-.246.565-.368.94-.364.376.003.69.128.94.374.252.247.378.551.378.915 0 .363-.126.668-.377.914l-3.847 3.763c-.13.127-.275.22-.435.28-.16.06-.327.09-.5.09ZM5.674 21c-.745 0-1.377-.254-1.896-.761A2.496 2.496 0 0 1 3 18.384v-2.505c0-.363.13-.672.39-.926.26-.255.576-.382.947-.382.372 0 .687.127.947.382.26.254.39.563.39.926v2.505h12.652v-2.505c0-.363.13-.672.39-.926.26-.255.575-.382.947-.382.371 0 .687.127.947.382.26.254.39.563.39.926v2.505c0 .729-.26 1.347-.778 1.855-.52.507-1.151.761-1.896.761H5.674Z'
}))));

const Dress_Code = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M9.505 21a2.214 2.214 0 0 1-1.607-.653 2.123 2.123 0 0 1-.667-1.574v-3.15H5.647c-.73 0-1.353-.252-1.87-.76A2.47 2.47 0 0 1 3 13.034c0-.52.14-1 .42-1.442.281-.441.702-.78 1.262-1.014l6.043-2.545v-.439c-.518-.165-.952-.484-1.301-.957a2.623 2.623 0 0 1-.525-1.6c0-.853.299-1.573.897-2.158C10.393 2.293 11.128 2 12 2c.706 0 1.31.169 1.816.507.504.338.849.763 1.033 1.276.13.366.086.686-.134.96-.219.273-.535.41-.947.41-.253 0-.46-.05-.619-.149a1.369 1.369 0 0 1-.4-.374.9.9 0 0 0-.321-.3.88.88 0 0 0-.428-.104.806.806 0 0 0-.585.237.8.8 0 0 0 0 1.146c.16.167.356.25.585.25.317 0 .585.107.803.321.218.214.327.476.327.786v1.002l6.188 2.61c.481.2.882.516 1.202.949.32.433.48.935.48 1.505a2.47 2.47 0 0 1-.776 1.832 2.577 2.577 0 0 1-1.87.76h-1.585v3.15c0 .614-.222 1.138-.667 1.573-.444.435-.98.653-1.607.653h-4.99Zm-3.858-7.603H7.79c.22-.252.466-.45.74-.594.275-.144.6-.216.974-.216h4.99c.375 0 .7.072.974.216.274.143.52.342.74.594h2.144c.131 0 .226-.04.285-.124a.443.443 0 0 0 .088-.26.382.382 0 0 0-.058-.208.35.35 0 0 0-.175-.138L12 9.927l-6.493 2.74a.389.389 0 0 0-.181.145.382.382 0 0 0-.052.2c0 .105.03.195.093.271.062.076.156.114.28.114Zm3.858 5.376h4.99v-3.972h-4.99v3.972Z'
}))));

const Driver = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 -960 960 960',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-84v-120q-60-12-102-54t-54-102H164q12 109 89.5 185T440-164Zm80 0q109-12 186.5-89.5T796-440H676q-12 60-54 102t-102 54v120ZM164-520h116l97-97q11-11 25.5-17t30.5-6h94q16 0 30.5 6t25.5 17l97 97h116q-15-121-105-200.5T480-800q-121 0-211 79.5T164-520Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Duplicate = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M6.27825 21C5.64343 21 5.10501 20.7859 4.66301 20.3576C4.221 19.9294 4 19.4078 4 18.7927V8.37685C4 8.07024 4.11074 7.80965 4.33221 7.59508C4.55367 7.38052 4.82265 7.27325 5.13914 7.27325C5.45561 7.27325 5.72458 7.38052 5.94606 7.59508C6.16752 7.80965 6.27825 8.07024 6.27825 8.37685V18.7927H14.4501C14.7666 18.7927 15.0356 18.9 15.2571 19.1146C15.4785 19.3292 15.5893 19.5897 15.5893 19.8964C15.5893 20.203 15.4785 20.4636 15.2571 20.6781C15.0356 20.8927 14.7666 21 14.4501 21L6.27825 21ZM10.2759 17.1269C9.64112 17.1269 9.10269 16.9128 8.66068 16.4846C8.21867 16.0563 7.99767 15.5347 7.99767 14.9197V5.20723C7.99767 4.5922 8.21867 4.07057 8.66068 3.64234C9.10269 3.21411 9.64112 3 10.2759 3H17.7217C18.3566 3 18.895 3.21411 19.337 3.64234C19.779 4.07057 20 4.5922 20 5.20723V14.9197C20 15.5347 19.779 16.0563 19.337 16.4846C18.895 16.9128 18.3566 17.1269 17.7217 17.1269H10.2759ZM10.2759 14.9197H17.7217V5.20723H10.2759V14.9197Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Edit = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.17 18.837h1.145l8.273-8.31-1.145-1.149-8.272 8.31v1.149Zm13.876-9.715-4.213-4.19 1.283-1.3c.41-.412.91-.623 1.5-.632.591-.009 1.11.202 1.557.632l1.173 1.162c.447.43.665.935.654 1.515a2.092 2.092 0 0 1-.633 1.489l-1.32 1.324ZM4.292 21c-.359 0-.664-.126-.915-.378A1.251 1.251 0 0 1 3 19.704v-2.39c0-.176.034-.344.1-.503.068-.159.164-.301.289-.427l10.03-10.059 4.227 4.226L7.616 20.61a1.322 1.322 0 0 1-.941.39H4.292ZM14.03 9.952l-.587-.574 1.145 1.148-.558-.574Z'
}))));

const Edit_Text = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.267 21c-.631 0-1.167-.22-1.607-.66-.44-.439-.66-.974-.66-1.605V7.061c0-.632.22-1.167.66-1.606.44-.44.976-.66 1.607-.66h7.625l-2.268 2.266H5.267v11.674h11.69v-5.348l2.267-2.264v7.612c0 .631-.22 1.166-.66 1.606-.44.44-.976.659-1.608.659H5.267ZM14.48 5.625l1.46 1.438-5.562 5.52v1.049h1.029l5.572-5.541 1.424 1.414-5.475 5.48a2.3 2.3 0 0 1-.733.495 2.192 2.192 0 0 1-.864.175H9.485c-.315 0-.582-.11-.803-.33-.22-.22-.33-.488-.33-.802V12.68a2.236 2.236 0 0 1 .66-1.595l5.467-5.46Zm3.923 3.88-3.923-3.88 1.957-1.955a2.183 2.183 0 0 1 1.63-.67c.63.008 1.166.24 1.607.694l.69.699c.425.448.637.98.637 1.595s-.22 1.142-.661 1.583l-1.937 1.934Z'
}))));

const Email = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.529 20a2.454 2.454 0 0 1-1.793-.727A2.398 2.398 0 0 1 2 17.5v-11c0-.697.245-1.287.736-1.772A2.454 2.454 0 0 1 4.529 4H19.47c.705 0 1.303.242 1.793.728.49.485.736 1.075.736 1.772v11c0 .697-.245 1.288-.736 1.773a2.454 2.454 0 0 1-1.793.727H4.53ZM19.47 8.8l-6.795 4.29a1.288 1.288 0 0 1-.676.195 1.27 1.27 0 0 1-.676-.195L4.529 8.8v8.7H19.47V8.8ZM12 11.217 19.471 6.5H4.53L12 11.217ZM4.529 7.422v.03V6.5v.955-.033Z'
}))));

const Emergency_Contact = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M10.268 13.732v1.39c0 .48.168.89.505 1.227a1.67 1.67 0 0 0 1.227.505c.481 0 .89-.168 1.227-.505a1.67 1.67 0 0 0 .505-1.228v-1.389h1.39c.48 0 .89-.168 1.227-.505A1.67 1.67 0 0 0 16.854 12c0-.481-.168-.89-.505-1.227a1.67 1.67 0 0 0-1.228-.505h-1.389v-1.39c0-.48-.168-.89-.505-1.227A1.67 1.67 0 0 0 12 7.146c-.481 0-.89.169-1.227.505a1.67 1.67 0 0 0-.505 1.228v1.389h-1.39c-.48 0-.89.168-1.227.505A1.67 1.67 0 0 0 7.146 12c0 .481.169.89.505 1.227a1.67 1.67 0 0 0 1.228.505h1.389ZM5.516 21a2.427 2.427 0 0 1-1.784-.732A2.427 2.427 0 0 1 3 18.484V5.516c0-.701.244-1.296.732-1.784A2.427 2.427 0 0 1 5.516 3h12.968c.701 0 1.296.244 1.784.732S21 4.815 21 5.516v12.968c0 .701-.244 1.296-.732 1.784a2.427 2.427 0 0 1-1.784.732H5.516Zm0-2.516h12.968V5.516H5.516v12.968Z'
}))));

const Enhance = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M17.9 8.957a.71.71 0 0 1-.319-.077.513.513 0 0 1-.238-.254l-.692-1.457-1.507-.664a.565.565 0 0 1-.272-.222.569.569 0 0 1 .272-.831L16.65 4.8l.692-1.457a.545.545 0 0 1 .238-.26.632.632 0 0 1 .63 0c.099.055.176.142.231.26l.693 1.457 1.507.652a.553.553 0 0 1 .272.228.569.569 0 0 1 0 .604.565.565 0 0 1-.272.221l-1.507.664-.693 1.457a.521.521 0 0 1-.231.254.672.672 0 0 1-.312.077ZM17.9 21a.71.71 0 0 1-.319-.077.513.513 0 0 1-.238-.254l-.692-1.457-1.507-.664a.565.565 0 0 1-.272-.222.568.568 0 0 1 .272-.831l1.507-.652.692-1.457a.545.545 0 0 1 .238-.26.633.633 0 0 1 .63 0c.099.055.176.142.231.26l.693 1.457 1.507.652a.553.553 0 0 1 .272.228.568.568 0 0 1 0 .604.565.565 0 0 1-.272.221l-1.507.664-.693 1.457a.521.521 0 0 1-.231.254.672.672 0 0 1-.312.077Zm-8.924-3.265a1.206 1.206 0 0 1-1.074-.665l-1.321-2.768-2.887-1.266a1.182 1.182 0 0 1-.515-.438A1.087 1.087 0 0 1 3 12.005c0-.206.06-.403.179-.591.12-.188.29-.334.515-.438L6.58 9.71l1.321-2.768A1.206 1.206 0 0 1 9.6 6.449c.2.114.355.279.464.493l1.309 2.768 2.887 1.267c.224.104.395.25.515.438.119.188.179.385.179.591 0 .206-.06.403-.18.591-.119.188-.29.334-.514.439l-2.887 1.267-1.31 2.767a1.153 1.153 0 0 1-.462.493 1.24 1.24 0 0 1-.624.172Zm0-3.02.898-1.849 1.929-.86-1.93-.86-.897-1.85-.897 1.85-1.93.86 1.93.86.897 1.85Z'
}))));

const Enlarge = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.118 9.802c-.31 0-.575-.108-.792-.326A1.078 1.078 0 0 1 4 8.684V5.118c0-.31.109-.575.326-.792.217-.217.481-.326.792-.326h3.566c.31 0 .575.109.792.326.218.217.326.481.326.792 0 .31-.108.575-.326.792a1.078 1.078 0 0 1-.792.326H7.8L9.38 7.817c.21.21.314.466.31.767-.004.3-.114.559-.33.775-.211.21-.472.316-.782.316-.31 0-.571-.105-.782-.316L6.236 7.8v.885c0 .31-.108.575-.326.792a1.078 1.078 0 0 1-.792.326Zm9.523-.443c-.21-.21-.316-.47-.316-.781 0-.31.105-.571.316-.782l1.56-1.56h-.885c-.31 0-.575-.108-.792-.326a1.078 1.078 0 0 1-.326-.792c0-.31.108-.575.326-.792.217-.217.481-.326.792-.326h3.566c.31 0 .575.109.792.326.217.217.326.481.326.792v3.566c0 .31-.109.575-.326.792a1.078 1.078 0 0 1-.792.326c-.31 0-.575-.108-.792-.326a1.078 1.078 0 0 1-.326-.792V7.8L16.183 9.38c-.21.21-.466.314-.767.31a1.08 1.08 0 0 1-.775-.33ZM15.316 20c-.31 0-.575-.109-.792-.326a1.078 1.078 0 0 1-.326-.792c0-.31.108-.575.326-.792.217-.218.481-.326.792-.326h.885l-1.581-1.581a1.023 1.023 0 0 1-.31-.767c.004-.3.114-.559.33-.775.211-.21.471-.316.782-.316.31 0 .571.105.782.316l1.56 1.56v-.885c0-.31.108-.575.326-.792.217-.218.481-.326.792-.326.31 0 .575.108.792.326.217.217.326.481.326.792v3.566c0 .31-.109.575-.326.792a1.078 1.078 0 0 1-.792.326h-3.566ZM5.118 20c-.31 0-.575-.109-.792-.326A1.078 1.078 0 0 1 4 18.882v-3.566c0-.31.109-.575.326-.792.217-.218.481-.326.792-.326.31 0 .575.108.792.326.218.217.326.481.326.792v.885l1.581-1.581c.21-.21.466-.314.767-.31.3.004.559.114.775.33.21.211.316.471.316.782 0 .31-.105.571-.316.782l-1.56 1.56h.885c.31 0 .575.108.792.326.218.217.326.481.326.792 0 .31-.108.575-.326.792a1.078 1.078 0 0 1-.792.326H5.118Z'
}))));

const Event_Session = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm12.006 16.695-1.504 1.153a.523.523 0 0 1-.358.123.633.633 0 0 1-.562-.39.529.529 0 0 1-.005-.381l.582-1.9-1.471-1.054a.54.54 0 0 1-.223-.31.605.605 0 0 1 .011-.35.653.653 0 0 1 .202-.29.534.534 0 0 1 .358-.123h1.804l.6-1.977a.587.587 0 0 1 .223-.319.584.584 0 0 1 .337-.105c.122 0 .235.035.338.105.102.07.176.177.222.319l.6 1.977h1.804c.141 0 .26.041.358.123a.653.653 0 0 1 .202.29.605.605 0 0 1 .011.35.541.541 0 0 1-.223.31L13.841 15.3l.582 1.893a.53.53 0 0 1-.005.382.627.627 0 0 1-.56.39.518.518 0 0 1-.353-.123l-1.499-1.147Z'
}), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.236 21c-.623 0-1.151-.22-1.585-.662A2.215 2.215 0 0 1 4 18.724V6.994c0-.635.217-1.173.65-1.614a2.139 2.139 0 0 1 1.586-.663h.701v-.725c0-.275.097-.51.29-.703A.952.952 0 0 1 7.924 3c.27 0 .501.096.69.29.19.192.285.427.285.702v.725H15.1v-.725c0-.275.097-.51.29-.703A.952.952 0 0 1 16.088 3c.27 0 .501.096.69.29.19.192.285.427.285.702v.725h.7c.624 0 1.152.221 1.586.663.434.441.651.98.651 1.613v11.731c0 .634-.217 1.172-.65 1.614a2.139 2.139 0 0 1-1.586.662H6.236Zm0-2.276h11.528v-8.441H6.236v8.441Zm0-10.159h11.528V6.993H6.236v1.572Z'
}))));

const Event_Type = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M5.16956 21.4805C4.44079 21.4805 3.81693 21.221 3.29798 20.702C2.77901 20.1831 2.51953 19.5592 2.51953 18.8304V5.16958C2.51953 4.44082 2.77901 3.81696 3.29798 3.29801C3.81693 2.77904 4.44079 2.51956 5.16956 2.51956H8.80758C9.04743 1.90796 9.46358 1.40995 10.056 1.02553C10.6485 0.641099 11.2964 0.448883 12 0.448883C12.7137 0.448883 13.3661 0.641099 13.9571 1.02553C14.548 1.40995 14.9681 1.90796 15.2174 2.51956H18.8304C19.5592 2.51956 20.183 2.77904 20.702 3.29801C21.2209 3.81696 21.4804 4.44082 21.4804 5.16958V18.8304C21.4804 19.5592 21.2209 20.1831 20.702 20.702C20.183 21.221 19.5592 21.4805 18.8304 21.4805H5.16956ZM5.16956 18.8304H18.8304V5.16958H16.9293V8.39568H7.07063V5.16958H5.16956V18.8304ZM12 4.95761C12.2833 4.95761 12.5208 4.86177 12.7125 4.67011C12.9041 4.47844 13 4.24094 13 3.95761C13 3.67428 12.9041 3.43677 12.7125 3.24511C12.5208 3.05344 12.2833 2.95761 12 2.95761C11.7166 2.95761 11.4791 3.05344 11.2875 3.24511C11.0958 3.43677 11 3.67428 11 3.95761C11 4.24094 11.0958 4.47844 11.2875 4.67011C11.4791 4.86177 11.7166 4.95761 12 4.95761Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Exit = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm12 13.61-4.064 4.065A1.094 1.094 0 0 1 7.13 18c-.32 0-.588-.108-.805-.325A1.094 1.094 0 0 1 6 16.869c0-.32.108-.588.325-.805L10.39 12 6.325 7.936A1.094 1.094 0 0 1 6 7.13c0-.32.108-.588.325-.805C6.542 6.108 6.81 6 7.13 6c.32 0 .589.108.806.325L12 10.39l4.064-4.064c.217-.217.485-.325.805-.325.32 0 .59.108.806.325.217.217.325.485.325.805 0 .32-.108.589-.325.806L13.61 12l4.064 4.064c.217.217.325.485.325.805 0 .32-.108.59-.325.806a1.094 1.094 0 0 1-.806.325c-.32 0-.588-.108-.805-.325L12 13.61Z'
}))));

const Expand_Field = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M18.733 20c.352 0 .651-.123.898-.37.246-.246.369-.545.369-.897v-8.605c0-.352-.123-.65-.37-.897a1.222 1.222 0 0 0-.897-.37c-.352 0-.65.124-.897.37-.246.246-.37.545-.37.897v7.338h-7.338c-.352 0-.65.123-.897.37-.246.246-.37.545-.37.897s.124.651.37.898c.246.246.545.369.897.369h8.605Zm-4.861-4.861c.352 0 .65-.124.897-.37.246-.246.37-.545.37-.897V5.267c0-.352-.124-.651-.37-.898A1.222 1.222 0 0 0 13.872 4c-.352 0-.651.123-.898.37-.246.246-.37.545-.37.897v7.338H5.268c-.352 0-.651.123-.898.37-.246.246-.369.545-.369.897s.123.65.37.897c.246.246.545.37.897.37h8.605Z'
}))));

const Ferry = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M3.41304 18.8728L1.80979 13.0772C1.70326 12.67 1.70996 12.267 1.82989 11.8685C1.94982 11.4699 2.21161 11.1971 2.61524 11.05L3.51957 10.7272V6C3.51957 5.32753 3.7625 4.75307 4.24837 4.27662C4.73425 3.80015 5.31813 3.56192 6.00002 3.56192H8.51957V1.88695C8.51957 1.51883 8.64837 1.20596 8.90597 0.948346C9.16358 0.690729 9.47645 0.56192 9.84457 0.56192H14.1555C14.5236 0.56192 14.8365 0.690729 15.0941 0.948346C15.3517 1.20596 15.4805 1.51883 15.4805 1.88695V3.56192H18C18.6819 3.56192 19.2658 3.80015 19.7517 4.27662C20.2375 4.75307 20.4805 5.32753 20.4805 6V10.7272L21.3848 11.05C21.7725 11.1927 22.0326 11.4545 22.1652 11.8353C22.2979 12.2161 22.3062 12.6301 22.1902 13.0772L20.587 18.8728C19.8073 18.8728 19.087 18.7554 18.4261 18.5206C17.7652 18.2859 17.1826 17.9873 16.6783 17.625C16.4855 17.4511 16.2618 17.3665 16.0071 17.3712C15.7524 17.3759 15.5333 17.4699 15.35 17.6532C14.8834 18.0344 14.3667 18.333 13.8 18.5489C13.2334 18.7648 12.6334 18.8728 12 18.8728C11.8334 18.8728 11.675 18.8668 11.525 18.8549C11.375 18.8429 11.225 18.8203 11.075 18.7869C10.5917 18.6964 10.1334 18.5426 9.70002 18.3255C9.26668 18.1085 8.86668 17.8427 8.50002 17.5282C8.35727 17.3949 8.18643 17.3235 7.98752 17.3141C7.7886 17.3047 7.61306 17.3667 7.46089 17.5C6.93769 17.95 6.30182 18.2913 5.55327 18.5239C4.8047 18.7565 4.09129 18.8728 3.41304 18.8728ZM12 23.4381C11.3167 23.4381 10.6375 23.3547 9.96252 23.1881C9.28752 23.0214 8.63335 22.7714 8.00002 22.4381C7.36668 22.7714 6.71668 23.0214 6.05002 23.1881C5.38335 23.3547 4.70002 23.4381 4.00002 23.4381H3.32504C2.95691 23.4381 2.64404 23.3093 2.38644 23.0516C2.12882 22.794 2.00002 22.4812 2.00002 22.113C2.00002 21.7449 2.12882 21.4321 2.38644 21.1744C2.64404 20.9168 2.95691 20.788 3.32504 20.788H4.00002C4.5906 20.788 5.18589 20.707 5.78589 20.5451C6.38589 20.3831 6.9348 20.1485 7.43262 19.8413C7.60872 19.7319 7.79785 19.6772 8.00002 19.6772C8.20218 19.6772 8.39132 19.7319 8.56742 19.8413C8.95292 20.0746 9.36903 20.2616 9.81577 20.4022C10.2625 20.5427 10.7073 20.638 11.15 20.688C11.2833 20.7047 11.425 20.7172 11.575 20.7255C11.725 20.7339 11.8667 20.738 12 20.738C12.5812 20.738 13.1553 20.6701 13.7223 20.5342C14.2893 20.3984 14.8312 20.1815 15.3478 19.8837C15.5522 19.7648 15.7696 19.7054 16 19.7054C16.2305 19.7054 16.4478 19.7648 16.6522 19.8837C17.1689 20.1888 17.7107 20.4158 18.2777 20.5647C18.8448 20.7136 19.4188 20.788 20 20.788H20.675C21.0431 20.788 21.356 20.9168 21.6136 21.1744C21.8712 21.4321 22 21.7449 22 22.113C22 22.4812 21.8712 22.794 21.6136 23.0516C21.356 23.3093 21.0431 23.4381 20.675 23.4381H20C19.3 23.4381 18.6167 23.3547 17.95 23.1881C17.2834 23.0214 16.6334 22.7714 16 22.4381C15.3667 22.7714 14.7125 23.0214 14.0375 23.1881C13.3625 23.3547 12.6834 23.4381 12 23.4381ZM6.16959 9.92175L11.1913 8.29892C11.4573 8.2134 11.7268 8.17065 12 8.17065C12.2732 8.17065 12.5428 8.2134 12.8087 8.29892L17.8304 9.92175V6.21197H6.16959V9.92175ZM12 16.8728C12.5 16.8728 12.9714 16.7471 13.4141 16.4956C13.8569 16.2442 14.2591 15.9446 14.6207 15.5967C15.0112 15.2105 15.4747 15.0098 16.0109 14.9946C16.5471 14.9794 16.9975 15.1649 17.362 15.5511C17.5359 15.725 17.7145 15.8877 17.8978 16.0391C18.0812 16.1906 18.2801 16.3283 18.4946 16.4522L19.538 12.6217L12 10.1424L4.41199 12.6217L5.47719 16.4304C5.70327 16.3065 5.91034 16.1695 6.09839 16.0195C6.28644 15.8695 6.47213 15.7029 6.65547 15.5195C7.02502 15.1522 7.46323 14.9572 7.97012 14.9348C8.477 14.9123 8.90218 15.0895 9.24567 15.4663C9.49783 15.7351 9.77138 15.9844 10.0663 16.2141C10.3613 16.4438 10.6895 16.617 11.0511 16.7337C11.2033 16.7837 11.3573 16.8194 11.5131 16.8407C11.6689 16.8621 11.8312 16.8728 12 16.8728Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Filter = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.17 19.093c-.332 0-.61-.114-.834-.342A1.136 1.136 0 0 1 3 17.924c0-.324.112-.598.336-.821.225-.224.502-.335.834-.335h3.86c.328 0 .608.11.838.332.23.222.346.496.346.824 0 .324-.116.6-.346.827-.23.228-.51.342-.838.342H4.17Zm0-11.86c-.332 0-.61-.112-.834-.333A1.111 1.111 0 0 1 3 6.076c0-.324.112-.6.336-.827.225-.228.502-.342.834-.342h7.72c.329 0 .608.114.839.342.23.227.345.503.345.827 0 .324-.115.598-.345.821a1.16 1.16 0 0 1-.838.335H4.17ZM12.11 21c-.329 0-.608-.114-.839-.342a1.12 1.12 0 0 1-.345-.827v-3.814c0-.328.115-.602.345-.824.23-.221.51-.332.838-.332.328 0 .605.11.831.332.226.222.339.496.339.824v.75h6.551c.332 0 .61.112.834.333.224.222.336.496.336.824 0 .324-.112.6-.336.827a1.123 1.123 0 0 1-.834.342H13.28v.738c0 .324-.112.6-.336.827a1.123 1.123 0 0 1-.834.342Zm-4.08-5.937c-.328 0-.605-.11-.83-.332a1.107 1.107 0 0 1-.34-.824v-.751H4.17c-.332 0-.61-.111-.834-.333A1.111 1.111 0 0 1 3 12c0-.327.112-.602.336-.823.225-.222.502-.333.834-.333h2.69v-.751c0-.328.113-.602.337-.824.224-.221.502-.332.833-.332.328 0 .608.11.838.332.23.222.346.496.346.824v3.814c0 .328-.116.602-.346.824-.23.221-.51.332-.838.332Zm4.08-1.907c-.329 0-.608-.111-.839-.333a1.096 1.096 0 0 1-.345-.823c0-.327.115-.602.345-.823.23-.222.51-.333.838-.333h7.721c.332 0 .61.111.834.333.224.221.336.496.336.823 0 .327-.112.602-.336.823a1.139 1.139 0 0 1-.834.333h-7.72Zm3.86-4.017c-.328 0-.608-.11-.838-.332a1.096 1.096 0 0 1-.346-.823V4.169c0-.324.116-.6.346-.827.23-.228.51-.342.838-.342.328 0 .605.114.83.342.226.227.34.503.34.827v.738h2.69c.332 0 .61.114.834.342.224.227.336.503.336.827 0 .324-.112.598-.336.821a1.134 1.134 0 0 1-.834.335h-2.69v.752c0 .327-.113.601-.337.823a1.139 1.139 0 0 1-.833.332Z'
}))));

const Filter2 = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11 20a.965.965 0 0 1-.712-.288A.965.965 0 0 1 10 19v-6L4.2 5.6c-.25-.333-.287-.683-.112-1.05S4.567 4 5 4h14c.433 0 .738.183.913.55.175.367.137.717-.113 1.05L14 13v6c0 .283-.096.52-.287.712A.968.968 0 0 1 13 20h-2Z'
}))));

const Find = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12 12.763a.739.739 0 0 1-.544-.22.739.739 0 0 1-.22-.543c0-.216.074-.398.22-.544a.739.739 0 0 1 .544-.22c.216 0 .398.074.544.22.146.146.22.328.22.544a.739.739 0 0 1-.22.544.739.739 0 0 1-.544.22ZM12 20a7.81 7.81 0 0 1-3.128-.629 8.066 8.066 0 0 1-2.536-1.707 8.066 8.066 0 0 1-1.707-2.536A7.809 7.809 0 0 1 4 12c0-1.114.21-2.156.629-3.128a8.065 8.065 0 0 1 1.707-2.536A8.065 8.065 0 0 1 8.872 4.63 7.81 7.81 0 0 1 12 4c1.114 0 2.156.21 3.128.629.972.42 1.817.988 2.536 1.707a8.066 8.066 0 0 1 1.707 2.536A7.81 7.81 0 0 1 20 12a7.81 7.81 0 0 1-.629 3.128 8.067 8.067 0 0 1-1.707 2.536 8.067 8.067 0 0 1-2.536 1.707A7.81 7.81 0 0 1 12 20Zm0-2.023c1.676 0 3.091-.577 4.246-1.731 1.154-1.155 1.731-2.57 1.731-4.246 0-1.676-.577-3.091-1.731-4.246C15.09 6.6 13.676 6.023 12 6.023c-1.676 0-3.091.577-4.246 1.731C6.6 8.91 6.023 10.324 6.023 12c0 1.676.577 3.091 1.731 4.246C8.91 17.4 10.324 17.977 12 17.977Zm-3.46-2.146 4.717-2.028c.12-.053.227-.127.323-.223s.17-.204.223-.323l2.028-4.717c.056-.12.039-.226-.053-.318-.092-.091-.198-.11-.318-.053l-4.717 2.028c-.12.053-.227.127-.323.223s-.17.204-.223.323L8.169 15.46c-.056.12-.038.226.053.318.092.091.198.11.318.053Z'
}))));

const Flight = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M9.87 20.948c-.337.099-.622.057-.855-.125-.233-.182-.35-.448-.35-.797 0-.167.048-.34.142-.519a1.24 1.24 0 0 1 .334-.415l1.268-.967v-4.322L4.493 15.55c-.412.121-.763.072-1.055-.148-.292-.22-.438-.552-.438-.997 0-.203.06-.41.179-.62.119-.21.267-.365.445-.463l6.785-4.044v-4.67c0-.465.152-.85.457-1.153A1.542 1.542 0 0 1 12 3c.46 0 .84.152 1.14.455.3.304.45.688.45 1.153v4.67l6.786 4.044c.178.098.326.254.445.468a1.3 1.3 0 0 1 .179.637c0 .43-.146.756-.438.976-.292.219-.643.268-1.055.147l-5.916-1.748v4.323l1.28.967c.129.098.238.236.328.415.09.179.135.352.135.52 0 .348-.116.614-.349.796-.233.182-.518.224-.855.125L12 20.334l-2.13.614Z'
}))));

const Flight_Booking = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm11.877 12.849-2.29.566-1.026-.755c-.048-.031-.175-.063-.382-.094l-.119.047a.43.43 0 0 0-.31.248.38.38 0 0 0 .024.389l1.043 1.78c.073.121.172.21.3.267a.592.592 0 0 0 .41.025l8.031-2.097a.82.82 0 0 0 .532-.428.94.94 0 0 0 .084-.703.829.829 0 0 0-.417-.53.892.892 0 0 0-.68-.083l-2.338.613-3.554-3.301a.565.565 0 0 0-.286-.154.687.687 0 0 0-.334.012l-.12.024a.616.616 0 0 0-.465.377.62.62 0 0 0 .036.59l1.86 3.207ZM4.529 20a2.454 2.454 0 0 1-1.793-.727A2.398 2.398 0 0 1 2 17.5v-3.258c0-.177.054-.326.163-.448a.712.712 0 0 1 .42-.228c.373-.108.687-.303.942-.584.256-.281.383-.611.383-.989 0-.377-.127-.707-.383-.988a1.908 1.908 0 0 0-.942-.57.71.71 0 0 1-.42-.232.642.642 0 0 1-.163-.44V6.5c0-.697.245-1.287.736-1.772A2.454 2.454 0 0 1 4.529 4H19.47c.705 0 1.303.242 1.793.728.49.485.736 1.075.736 1.772v11c0 .697-.245 1.288-.736 1.773a2.454 2.454 0 0 1-1.793.727H4.53Zm0-2.5H19.47v-11H4.53v2.179a3.87 3.87 0 0 1 1.402 1.408c.337.584.506 1.22.506 1.908s-.169 1.326-.506 1.913a3.858 3.858 0 0 1-1.402 1.413v2.18Z'
}))));

const Flight_Side = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M3.05174 9.8701C2.95343 9.53279 2.99524 9.24776 3.17716 9.01499C3.35909 8.78223 3.62464 8.66585 3.97382 8.66585C4.14105 8.66585 4.31404 8.71291 4.49277 8.80703C4.67151 8.90115 4.81003 9.01231 4.90834 9.14054L5.87541 10.4092L10.1975 10.4092L8.45009 4.49323C8.3288 4.0814 8.37796 3.72957 8.59755 3.43775C8.81713 3.14592 9.14969 3 9.59525 3C9.79825 3 10.0049 3.05953 10.2152 3.1786C10.4256 3.29767 10.5799 3.44627 10.6782 3.6244L14.7217 10.4092L19.3923 10.4092C19.857 10.4092 20.2412 10.5614 20.5447 10.8659C20.8482 11.1703 21 11.5484 21 12C21 12.4598 20.8482 12.8399 20.5447 13.1403C20.2412 13.4406 19.857 13.5908 19.3923 13.5908L14.7217 13.5908L10.6782 20.3756C10.5799 20.5537 10.424 20.7023 10.2105 20.8214C9.99694 20.9405 9.78453 21 9.57323 21C9.14235 21 8.81712 20.8541 8.59755 20.5622C8.37795 20.2704 8.3288 19.9186 8.45009 19.5068L10.1975 13.5908L5.87541 13.5908L4.90834 14.8718C4.81003 15 4.67151 15.1091 4.49277 15.1991C4.31404 15.2891 4.14105 15.3342 3.97382 15.3342C3.62463 15.3342 3.35908 15.2178 3.17716 14.985C2.99524 14.7522 2.95343 14.4672 3.05172 14.1299L3.6655 12L3.05174 9.8701Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Free_Edit = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm12.504 15.609 7.129-7.322-.834-.856-7.128 7.322.833.856Zm-8.328-1.23c0 .338.134.607.403.807.269.2.699.337 1.29.411a.951.951 0 0 1 .682.411c.165.236.241.502.227.799-.015.31-.122.569-.322.774a.82.82 0 0 1-.732.251c-1.261-.165-2.197-.534-2.808-1.105-.61-.571-.916-1.358-.916-2.36 0-.999.383-1.811 1.148-2.438.765-.626 1.85-1.024 3.256-1.193.613-.078 1.044-.171 1.293-.279.25-.107.374-.262.374-.464 0-.26-.143-.47-.43-.63-.288-.16-.738-.292-1.35-.396a.989.989 0 0 1-.681-.429 1.167 1.167 0 0 1-.206-.803c.03-.31.155-.563.377-.757a.898.898 0 0 1 .767-.22c1.24.211 2.167.583 2.78 1.116.613.533.919 1.24.919 2.12 0 .803-.295 1.455-.884 1.954-.589.5-1.454.829-2.596.985-.86.116-1.506.295-1.94.536-.434.24-.651.544-.651.91Zm8.862 3.852-3.92-4.027 8.43-8.658A1.703 1.703 0 0 1 18.81 5c.488 0 .909.182 1.263.546l1.395 1.433c.355.364.532.799.532 1.303 0 .505-.177.94-.532 1.304l-8.43 8.645Zm-3.52.747c-.328.068-.614-.024-.86-.276a.94.94 0 0 1-.268-.882l.728-3.616 3.92 4.027-3.52.747Z'
}))));

const Globe = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.999 18.724a5.867 5.867 0 0 0 1.424-.171l-1.005-1.51H9.484v-.839c0-.46.164-.856.492-1.184a1.612 1.612 0 0 1 1.183-.492h1.675V12h-1.667a.828.828 0 0 1-.601-.241.801.801 0 0 1-.247-.598V9.485h-.377c-.363 0-.671-.123-.924-.369a1.228 1.228 0 0 1-.38-.917 1.39 1.39 0 0 1 .215-.738l1.294-1.905c-1.414.406-2.58 1.196-3.496 2.372C5.734 9.103 5.276 10.46 5.276 12h.846v-.833c0-.236.08-.437.241-.601a.8.8 0 0 1 .597-.247h1.675a.82.82 0 0 1 .603.247.818.818 0 0 1 .246.6V12a.818.818 0 0 1-.246.6.82.82 0 0 1-.603.248v.838c0 .461-.164.856-.492 1.184a1.61 1.61 0 0 1-1.182.493h-.774a6.922 6.922 0 0 0 2.418 2.436c1.02.618 2.151.926 3.394.926Zm6.385-4.669a6.32 6.32 0 0 0 .34-2.055c0-1.568-.476-2.95-1.429-4.147-.952-1.197-2.157-1.985-3.614-2.363v2.312c.462 0 .857.165 1.185.494.329.33.493.726.493 1.188v1.681c.266 0 .502.03.709.091.206.06.41.19.61.391l1.706 2.408ZM12 21a8.786 8.786 0 0 1-3.519-.708 9.073 9.073 0 0 1-2.853-1.92 9.073 9.073 0 0 1-1.92-2.853A8.786 8.786 0 0 1 3 12c0-1.253.236-2.426.708-3.519a9.074 9.074 0 0 1 1.92-2.853 9.074 9.074 0 0 1 2.853-1.92A8.786 8.786 0 0 1 12 3c1.253 0 2.426.236 3.519.708a9.073 9.073 0 0 1 2.853 1.92 9.073 9.073 0 0 1 1.92 2.853A8.786 8.786 0 0 1 21 12a8.786 8.786 0 0 1-.708 3.519 9.073 9.073 0 0 1-1.92 2.853 9.073 9.073 0 0 1-2.853 1.92A8.786 8.786 0 0 1 12 21Z'
}))));

const Group = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M10.576 18.553c.632-1.27 1.473-2.122 2.523-2.554 1.05-.433 1.947-.649 2.689-.649.313 0 .627.029.942.086.316.057.62.129.913.215.335-.528.6-1.102.797-1.72.197-.62.295-1.268.295-1.943 0-1.87-.654-3.455-1.962-4.758-1.307-1.303-2.896-1.954-4.767-1.954-1.87 0-3.46.651-4.767 1.954-1.308 1.303-1.962 2.888-1.962 4.758 0 .635.083 1.242.247 1.822.165.579.404 1.106.717 1.583a9.367 9.367 0 0 1 1.79-.647 7.708 7.708 0 0 1 1.875-.23c.442 0 .873.039 1.291.118.419.078.827.182 1.227.31-.322.18-.627.38-.917.596-.29.217-.563.454-.82.712a3.113 3.113 0 0 0-.435-.043h-.346a6.27 6.27 0 0 0-1.346.144 5.56 5.56 0 0 0-1.269.445 6.484 6.484 0 0 0 3.285 1.755ZM12.006 21a8.78 8.78 0 0 1-3.508-.707 9.088 9.088 0 0 1-2.863-1.926 9.08 9.08 0 0 1-1.928-2.861A8.767 8.767 0 0 1 3 11.999a8.76 8.76 0 0 1 .707-3.506 9.084 9.084 0 0 1 1.928-2.86 9.088 9.088 0 0 1 2.863-1.926A8.783 8.783 0 0 1 12.008 3c1.244 0 2.411.236 3.501.707a9.11 9.11 0 0 1 2.856 1.926 9.08 9.08 0 0 1 1.928 2.861A8.767 8.767 0 0 1 21 12.001a8.76 8.76 0 0 1-.707 3.506 9.083 9.083 0 0 1-1.928 2.86 9.1 9.1 0 0 1-2.859 1.926 8.74 8.74 0 0 1-3.5.707Zm-2.1-7.736a2.855 2.855 0 0 1-2.096-.862 2.85 2.85 0 0 1-.863-2.095c0-.822.288-1.519.863-2.09.575-.57 1.274-.855 2.096-.855.823 0 1.52.285 2.09.856.572.57.857 1.267.857 2.089 0 .822-.285 1.52-.856 2.095-.571.575-1.268.862-2.09.862Zm0-1.693c.342 0 .636-.126.883-.376s.37-.547.37-.888c0-.342-.123-.636-.37-.882a1.205 1.205 0 0 0-.883-.37c-.342 0-.638.123-.888.37-.251.246-.376.54-.376.882 0 .341.125.637.376.888.25.25.546.376.888.376Zm5.897 2.527a2.055 2.055 0 0 1-1.498-.607 2.008 2.008 0 0 1-.617-1.488c0-.587.206-1.084.617-1.49a2.05 2.05 0 0 1 1.498-.611c.587 0 1.083.202 1.489.607.405.406.608.902.608 1.488 0 .587-.203 1.084-.608 1.49-.406.408-.902.611-1.49.611Z'
}))));

const Hamburger = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.137 17c-.316 0-.584-.108-.805-.325a1.065 1.065 0 0 1-.332-.79c0-.31.11-.573.332-.79.22-.216.489-.325.805-.325h13.726c.316 0 .585.109.806.325.22.217.331.48.331.79 0 .31-.11.573-.331.79-.221.217-.49.325-.806.325H5.137Zm0-4.385c-.316 0-.584-.108-.805-.325A1.065 1.065 0 0 1 4 11.5c0-.31.11-.573.332-.79.22-.217.489-.325.805-.325h13.726c.316 0 .585.108.806.325.22.217.331.48.331.79 0 .31-.11.573-.331.79-.221.217-.49.325-.806.325H5.137Zm0-4.385c-.316 0-.584-.109-.805-.325A1.065 1.065 0 0 1 4 7.115c0-.31.11-.573.332-.79.22-.217.489-.325.805-.325h13.726c.316 0 .585.108.806.325.22.217.331.48.331.79 0 .31-.11.573-.331.79-.221.216-.49.325-.806.325H5.137Z'
}))));

const Help = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.92 17.152c.334 0 .618-.117.854-.353s.354-.521.354-.855c0-.334-.118-.617-.354-.847a1.176 1.176 0 0 0-.853-.346c-.333 0-.618.115-.853.346a1.14 1.14 0 0 0-.354.847c0 .334.118.619.354.855.235.236.52.354.853.354ZM12 21a8.786 8.786 0 0 1-3.519-.708 9.073 9.073 0 0 1-2.853-1.92 9.073 9.073 0 0 1-1.92-2.853A8.786 8.786 0 0 1 3 12c0-1.253.236-2.426.708-3.519a9.074 9.074 0 0 1 1.92-2.853 9.074 9.074 0 0 1 2.853-1.92A8.786 8.786 0 0 1 12 3c1.253 0 2.426.236 3.519.708a9.073 9.073 0 0 1 2.853 1.92 9.073 9.073 0 0 1 1.92 2.853A8.786 8.786 0 0 1 21 12a8.786 8.786 0 0 1-.708 3.519 9.073 9.073 0 0 1-1.92 2.853 9.073 9.073 0 0 1-2.853 1.92A8.786 8.786 0 0 1 12 21Zm0-2.276c1.886 0 3.478-.649 4.776-1.948 1.299-1.298 1.948-2.89 1.948-4.776 0-1.886-.649-3.478-1.948-4.776-1.298-1.299-2.89-1.948-4.776-1.948-1.886 0-3.478.649-4.776 1.948C5.925 8.522 5.276 10.114 5.276 12c0 1.886.649 3.478 1.948 4.776 1.298 1.299 2.89 1.948 4.776 1.948Zm.05-10.162c.292 0 .547.096.763.288a.923.923 0 0 1 .325.72 1.2 1.2 0 0 1-.248.74c-.164.22-.352.42-.563.603-.33.286-.621.605-.876.956a1.952 1.952 0 0 0-.382 1.172.74.74 0 0 0 .259.573.875.875 0 0 0 .603.232.891.891 0 0 0 .631-.245c.175-.163.3-.364.375-.603.074-.268.196-.506.368-.714.172-.208.36-.407.566-.598.329-.306.603-.652.823-1.036.22-.384.33-.802.33-1.251 0-.747-.29-1.362-.872-1.848a3.09 3.09 0 0 0-2.042-.728c-.576 0-1.117.123-1.623.368a2.763 2.763 0 0 0-1.194 1.1.875.875 0 0 0-.11.633.74.74 0 0 0 .352.513c.224.139.462.18.713.125.252-.055.465-.19.64-.407.142-.182.315-.327.52-.433.204-.107.418-.16.642-.16Z'
}))));

const Hide = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm15.73 12.786-1.834-1.604c.075-.346-.044-.675-.356-.987-.313-.313-.711-.436-1.197-.37L10.61 8.308A4.015 4.015 0 0 1 12 8.063c1.114 0 2.06.341 2.84 1.023.78.682 1.17 1.51 1.17 2.484 0 .194-.023.399-.07.615a2.469 2.469 0 0 1-.21.6Zm3.179 2.763-1.544-1.333a9.42 9.42 0 0 0 1.359-1.177c.4-.422.765-.912 1.093-1.469-.759-1.304-1.825-2.345-3.197-3.121-1.372-.777-2.912-1.165-4.62-1.165a9.462 9.462 0 0 0-2.269.257L8.022 6.046c.61-.22 1.25-.386 1.922-.497.673-.11 1.358-.165 2.056-.165 2.15 0 4.098.496 5.846 1.487 1.748.992 3.083 2.325 4.005 4a.736.736 0 0 1 .12.32c.02.127.029.253.029.38 0 .125-.013.252-.04.378a1.204 1.204 0 0 1-.11.321 9.278 9.278 0 0 1-1.28 1.81 9.77 9.77 0 0 1-1.661 1.47Zm-.808 4.204-2.817-2.447c-.503.15-1.027.263-1.57.338a12.53 12.53 0 0 1-1.714.113c-2.15 0-4.098-.498-5.846-1.493-1.748-.996-3.083-2.327-4.005-3.994a.738.738 0 0 1-.12-.32 2.547 2.547 0 0 1 0-.755.734.734 0 0 1 .12-.316 9.048 9.048 0 0 1 1.083-1.562c.418-.486.874-.937 1.369-1.353L2.891 6.45a.765.765 0 0 1-.284-.597.78.78 0 0 1 .293-.605c.188-.165.42-.247.693-.247.274 0 .505.082.693.247L19.487 18.54a.786.786 0 0 1 .288.602.77.77 0 0 1-.288.61c-.188.166-.42.248-.693.248-.274 0-.505-.082-.693-.247ZM6.138 9.275c-.414.353-.776.708-1.086 1.067-.31.359-.596.768-.857 1.228.743 1.312 1.802 2.355 3.178 3.127 1.377.773 2.919 1.16 4.627 1.16.222 0 .454-.011.699-.032.244-.022.515-.052.812-.091l-.802-.74a2.41 2.41 0 0 1-.354.065 3.357 3.357 0 0 1-.355.018c-1.114 0-2.06-.34-2.84-1.022-.78-.682-1.17-1.51-1.17-2.485 0-.099.004-.2.014-.304.01-.104.028-.21.056-.316L6.138 9.275Z'
}))));

const Hire_Car = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M8.036 7.83c-.837 0-1.553-.283-2.146-.848S5 5.73 5 4.923c0-.807.297-1.496.89-2.067C6.483 2.286 7.199 2 8.036 2c.616 0 1.176.166 1.679.497.502.33.877.769 1.123 1.314h7.008c.32 0 .592.108.817.324.225.216.337.478.337.786 0 .308-.112.568-.337.78a1.147 1.147 0 0 1-.817.318v.713c0 .311-.11.572-.328.782-.218.21-.49.315-.813.315-.323 0-.593-.105-.812-.315a1.041 1.041 0 0 1-.328-.782V6.02h-4.727c-.246.545-.62.983-1.123 1.314a2.986 2.986 0 0 1-1.679.496Zm0-2.003a.93.93 0 0 0 .67-.26.86.86 0 0 0 .271-.646.86.86 0 0 0-.27-.645.93.93 0 0 0-.67-.26.93.93 0 0 0-.671.26.86.86 0 0 0-.271.645c0 .257.09.472.27.645a.93.93 0 0 0 .671.26Zm1.14 11.702a.93.93 0 0 0 .671-.26.86.86 0 0 0 .27-.646.86.86 0 0 0-.27-.645.93.93 0 0 0-.67-.26.93.93 0 0 0-.67.26.86.86 0 0 0-.271.645c0 .257.09.472.27.645a.93.93 0 0 0 .67.26Zm5.647 0c.267 0 .49-.087.67-.26a.86.86 0 0 0 .271-.646.86.86 0 0 0-.27-.645.93.93 0 0 0-.67-.26.93.93 0 0 0-.671.26.86.86 0 0 0-.27.645c0 .257.09.472.27.645a.93.93 0 0 0 .67.26ZM6.353 22a1.33 1.33 0 0 1-.956-.382 1.23 1.23 0 0 1-.397-.92v-5.846l1.58-4.449c.104-.288.283-.519.535-.693.252-.174.531-.262.838-.262h8.094c.296 0 .567.083.81.249.244.166.419.388.524.668L19 14.852v5.846c0 .359-.132.665-.397.92a1.33 1.33 0 0 1-.956.382 1.33 1.33 0 0 1-.957-.382 1.23 1.23 0 0 1-.397-.92v-.509H7.707v.509c0 .359-.133.665-.397.92a1.33 1.33 0 0 1-.957.382Zm1.553-8.546h8.188l-.659-1.81h-6.87l-.659 1.81Zm-.612 4.527h9.412v-2.716H7.293v2.716Z'
}))));

const History = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.932 21c-2.071 0-3.912-.614-5.521-1.842-1.61-1.229-2.677-2.802-3.202-4.72a.87.87 0 0 1 .184-.848c.213-.256.496-.409.848-.458.336-.05.646.01.93.176.284.167.48.408.586.724a6.309 6.309 0 0 0 2.334 3.213c1.128.826 2.408 1.24 3.841 1.24 1.82 0 3.364-.63 4.632-1.888 1.268-1.258 1.901-2.79 1.901-4.597 0-1.806-.633-3.339-1.901-4.597-1.268-1.258-2.812-1.887-4.632-1.887a6.35 6.35 0 0 0-2.814.645 6.565 6.565 0 0 0-2.266 1.814h1.187c.298 0 .55.102.756.306.206.204.309.454.309.75s-.103.548-.31.757a1.02 1.02 0 0 1-.755.313H4.267c-.352 0-.651-.122-.897-.366A1.208 1.208 0 0 1 3 8.843v-3.73c0-.296.103-.543.309-.743.206-.2.458-.3.756-.3s.547.1.749.3c.2.2.302.447.302.743V6.1a8.8 8.8 0 0 1 3.058-2.296A8.989 8.989 0 0 1 11.932 3a8.85 8.85 0 0 1 3.529.71 9.191 9.191 0 0 1 2.881 1.928 9.114 9.114 0 0 1 1.943 2.86A8.671 8.671 0 0 1 21 12c0 1.24-.238 2.408-.715 3.502a9.114 9.114 0 0 1-1.943 2.86 9.191 9.191 0 0 1-2.881 1.928 8.85 8.85 0 0 1-3.529.71Zm1.092-9.38 2.27 2.24c.202.2.303.449.303.744 0 .296-.101.545-.303.745-.203.201-.453.302-.751.302s-.548-.1-.75-.302l-2.517-2.497a1.223 1.223 0 0 1-.368-.89V8.298c0-.296.103-.544.31-.744.205-.2.457-.3.755-.3s.548.1.749.3c.201.2.302.448.302.744v3.323Z'
}))));

const Home = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.5 18.41h2.363v-6.015h6.274v6.015H17.5V9.863L12 5.59 6.5 9.863v8.547Zm0 2.59c-.688 0-1.276-.254-1.766-.76A2.54 2.54 0 0 1 4 18.41V9.863c0-.412.091-.802.274-1.17.182-.368.427-.67.734-.904l5.487-4.26c.226-.176.467-.309.722-.397a2.382 2.382 0 0 1 1.566 0c.255.088.496.22.722.397l5.487 4.26c.315.237.562.54.74.907.179.368.268.757.268 1.167v8.547a2.54 2.54 0 0 1-.734 1.83c-.49.506-1.078.76-1.766.76h-4.663v-6.223h-1.674V21H6.5Z'
}))));

const Hotel = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.472 21a2.38 2.38 0 0 1-1.746-.726A2.38 2.38 0 0 1 3 18.529V9.202c0-.68.242-1.261.726-1.745a2.38 2.38 0 0 1 1.746-.726H6.73V5.47c0-.68.242-1.261.726-1.745A2.38 2.38 0 0 1 9.202 3h5.596c.68 0 1.261.242 1.745.726a2.38 2.38 0 0 1 .726 1.746v4.99h1.26c.68 0 1.261.241 1.745.725A2.38 2.38 0 0 1 21 12.933v5.596a2.38 2.38 0 0 1-.726 1.745 2.38 2.38 0 0 1-1.745.726h-5.596v-4.337h-1.866V21H5.472Zm0-2.471h1.865v-1.866H5.472v1.866Zm0-3.731h1.865v-1.865H5.472v1.865Zm0-3.73h1.865V9.201H5.472v1.865Zm3.73 3.73h1.865v-1.865H9.202v1.865Zm0-3.73h1.865V9.201H9.202v1.865Zm0-3.731h1.865V5.472H9.202v1.865Zm3.73 7.46h1.866v-1.864h-1.865v1.865Zm0-3.73h1.866V9.202h-1.865v1.865Zm0-3.73h1.866V5.472h-1.865v1.865Zm3.731 11.192h1.866v-1.866h-1.866v1.866Zm0-3.731h1.866v-1.865h-1.866v1.865Z'
}))));

const Important = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.997 16.706c.342 0 .63-.116.864-.347.233-.232.35-.518.35-.86 0-.343-.116-.633-.348-.87a1.154 1.154 0 0 0-.86-.356c-.342 0-.63.119-.864.356-.233.237-.35.527-.35.87 0 .342.116.629.348.86.231.231.518.347.86.347ZM12 12.883c.316 0 .585-.11.806-.332.221-.221.332-.49.332-.806V8.59c0-.316-.11-.584-.332-.806A1.097 1.097 0 0 0 12 7.451c-.316 0-.585.111-.806.332-.221.222-.332.49-.332.806v3.156c0 .316.11.585.332.806.221.221.49.332.806.332ZM12 21a8.786 8.786 0 0 1-3.519-.708 9.073 9.073 0 0 1-2.853-1.92 9.073 9.073 0 0 1-1.92-2.853A8.786 8.786 0 0 1 3 12c0-1.253.236-2.426.708-3.519a9.074 9.074 0 0 1 1.92-2.853 9.074 9.074 0 0 1 2.853-1.92A8.786 8.786 0 0 1 12 3c1.253 0 2.426.236 3.519.708a9.073 9.073 0 0 1 2.853 1.92 9.073 9.073 0 0 1 1.92 2.853A8.786 8.786 0 0 1 21 12a8.786 8.786 0 0 1-.708 3.519 9.073 9.073 0 0 1-1.92 2.853 9.073 9.073 0 0 1-2.853 1.92A8.786 8.786 0 0 1 12 21Zm0-2.276c1.886 0 3.478-.649 4.776-1.948 1.299-1.298 1.948-2.89 1.948-4.776 0-1.886-.649-3.478-1.948-4.776-1.298-1.299-2.89-1.948-4.776-1.948-1.886 0-3.478.649-4.776 1.948C5.925 8.522 5.276 10.114 5.276 12c0 1.886.649 3.478 1.948 4.776 1.298 1.299 2.89 1.948 4.776 1.948Z'
}))));

const Info = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.545 16.368c.295 0 .542-.1.742-.3.199-.199.299-.446.299-.74v-3.254c0-.295-.1-.542-.3-.741-.199-.2-.446-.3-.741-.3s-.542.1-.742.3c-.2.199-.299.446-.299.741v3.253c0 .295.1.542.3.742.199.2.446.299.74.299Zm0-6.81c.312 0 .574-.105.785-.316.21-.211.316-.473.316-.785 0-.312-.105-.574-.316-.785a1.066 1.066 0 0 0-.785-.316c-.312 0-.574.105-.785.316a1.066 1.066 0 0 0-.316.785c0 .312.105.574.316.785.211.211.473.317.785.317Zm0 11.334a8.786 8.786 0 0 1-3.519-.707 9.073 9.073 0 0 1-2.853-1.921 9.073 9.073 0 0 1-1.92-2.853 8.786 8.786 0 0 1-.708-3.519c0-1.253.236-2.425.708-3.519a9.074 9.074 0 0 1 1.92-2.853A9.074 9.074 0 0 1 8.026 3.6a8.786 8.786 0 0 1 3.519-.708c1.253 0 2.425.236 3.519.708a9.074 9.074 0 0 1 2.853 1.92 9.073 9.073 0 0 1 1.92 2.853 8.784 8.784 0 0 1 .708 3.52 8.784 8.784 0 0 1-.708 3.518 9.073 9.073 0 0 1-1.92 2.853 9.073 9.073 0 0 1-2.853 1.92 8.786 8.786 0 0 1-3.52.708Zm0-2.276c1.885 0 3.478-.649 4.776-1.948 1.299-1.298 1.948-2.89 1.948-4.776 0-1.885-.65-3.477-1.948-4.776-1.299-1.299-2.89-1.948-4.776-1.948-1.886 0-3.478.65-4.776 1.948-1.3 1.299-1.948 2.89-1.948 4.776 0 1.886.649 3.478 1.948 4.776 1.298 1.3 2.89 1.948 4.776 1.948Z'
}))));

const Internet = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12 21a8.652 8.652 0 0 1-3.485-.713A9.186 9.186 0 0 1 5.65 18.35a9.186 9.186 0 0 1-1.937-2.865A8.651 8.651 0 0 1 3 12c0-1.236.238-2.4.713-3.49A9.201 9.201 0 0 1 5.65 5.65a9.186 9.186 0 0 1 2.865-1.937A8.65 8.65 0 0 1 12 3c1.236 0 2.4.238 3.49.713a9.2 9.2 0 0 1 2.86 1.937 9.202 9.202 0 0 1 1.937 2.86A8.642 8.642 0 0 1 21 12c0 1.23-.238 2.392-.713 3.485a9.186 9.186 0 0 1-1.937 2.865 9.201 9.201 0 0 1-2.86 1.937A8.643 8.643 0 0 1 12 21Zm-.024-2.306c.34-.5.645-1.026.917-1.58s.494-1.138.666-1.752h-3.13a11.277 11.277 0 0 0 1.547 3.332Zm-2.172-.344a7.767 7.767 0 0 1-.677-1.446 17.426 17.426 0 0 1-.458-1.542h-2.46c.39.7.89 1.31 1.501 1.832a5.97 5.97 0 0 0 2.094 1.156Zm4.356 0a6.096 6.096 0 0 0 2.106-1.157 6.57 6.57 0 0 0 1.514-1.83h-2.46a15.15 15.15 0 0 1-.472 1.54c-.185.509-.414.99-.688 1.447Zm-8.67-4.669h2.835A10.712 10.712 0 0 1 8.196 12a10.646 10.646 0 0 1 .13-1.681H5.49A6.552 6.552 0 0 0 5.275 12a6.596 6.596 0 0 0 .215 1.681Zm4.553 0h3.902c.043-.286.071-.565.085-.836a17.128 17.128 0 0 0 0-1.696 8.44 8.44 0 0 0-.085-.83h-3.902A10.64 10.64 0 0 0 9.914 12a10.707 10.707 0 0 0 .129 1.681Zm5.62 0h2.822A6.592 6.592 0 0 0 18.7 12a6.548 6.548 0 0 0-.215-1.681h-2.822A13.116 13.116 0 0 1 15.768 12a13.198 13.198 0 0 1-.105 1.681Zm-.344-5.055h2.46A6.486 6.486 0 0 0 16.267 6.8a6.15 6.15 0 0 0-2.106-1.15c.274.456.503.936.688 1.44.185.504.342 1.016.471 1.536Zm-4.89 0h3.13a9.392 9.392 0 0 0-.654-1.746 12.202 12.202 0 0 0-.93-1.574c-.339.5-.639 1.024-.899 1.574s-.475 1.132-.647 1.746Zm-4.22 0h2.46c.128-.52.281-1.032.458-1.536s.403-.984.677-1.44A6.022 6.022 0 0 0 7.71 6.8a6.582 6.582 0 0 0-1.502 1.826Z'
}))));

const Itinerary = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M8.283 16.666h4.747c.269 0 .494-.09.676-.273a.919.919 0 0 0 .273-.676.919.919 0 0 0-.273-.677.919.919 0 0 0-.676-.272H8.283a.919.919 0 0 0-.676.272.919.919 0 0 0-.273.677c0 .269.09.494.273.676a.918.918 0 0 0 .676.273Zm0-3.717h7.434a.919.919 0 0 0 .676-.273.918.918 0 0 0 .273-.676.918.918 0 0 0-.273-.676.919.919 0 0 0-.676-.273H8.283a.919.919 0 0 0-.676.273.919.919 0 0 0-.273.676c0 .269.09.494.273.676a.919.919 0 0 0 .676.273Zm0-3.716h7.434a.919.919 0 0 0 .676-.273.918.918 0 0 0 .273-.677.918.918 0 0 0-.273-.676.919.919 0 0 0-.676-.273H8.283a.919.919 0 0 0-.676.273.919.919 0 0 0-.273.676c0 .27.09.495.273.677a.919.919 0 0 0 .676.273ZM5.516 21a2.427 2.427 0 0 1-1.784-.732A2.427 2.427 0 0 1 3 18.484V5.516c0-.701.244-1.296.732-1.784A2.427 2.427 0 0 1 5.516 3h12.968c.701 0 1.296.244 1.784.732S21 4.815 21 5.516v12.968c0 .701-.244 1.296-.732 1.784a2.427 2.427 0 0 1-1.784.732H5.516Zm0-2.516h12.968V5.516H5.516v12.968Z'
}))));

const Kebab = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M14 17.949a2 2 0 0 1-.588 1.449A1.903 1.903 0 0 1 12 20a1.9 1.9 0 0 1-1.418-.6A2.002 2.002 0 0 1 10 17.953c0-.566.194-1.05.582-1.454a1.886 1.886 0 0 1 1.412-.604 1.91 1.91 0 0 1 1.417.603c.393.402.589.885.589 1.45Zm0-5.956c0 .566-.196 1.05-.588 1.45a1.903 1.903 0 0 1-1.412.603 1.9 1.9 0 0 1-1.418-.601A2.002 2.002 0 0 1 10 12c0-.57.194-1.053.582-1.45a1.9 1.9 0 0 1 1.412-.596c.552 0 1.025.199 1.417.596.393.397.589.878.589 1.443Zm0-5.951c0 .567-.196 1.053-.588 1.457A1.897 1.897 0 0 1 12 8.105c-.557 0-1.03-.202-1.418-.606A2.027 2.027 0 0 1 10 6.042c0-.567.194-1.05.582-1.446A1.9 1.9 0 0 1 11.994 4c.552 0 1.025.199 1.417.596.393.397.589.879.589 1.446Z'
}))));

const Keyboard = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.48828 20C3.79493 20 3.20688 19.7312 2.72413 19.1935C2.24138 18.6559 2 18.0009 2 17.2287V6.77126C2 5.99906 2.24138 5.34413 2.72413 4.80648C3.20688 4.26883 3.79493 4 4.48828 4H19.5117C20.2051 4 20.7931 4.26883 21.2759 4.80648C21.7586 5.34413 22 5.99906 22 6.77126V17.2287C22 18.0009 21.7586 18.6559 21.2759 19.1935C20.7931 19.7312 20.2051 20 19.5117 20H4.48828ZM4.48828 17.2287H19.5117V6.77126H4.48828V17.2287ZM9.18311 16.183H14.8169C15.0829 16.183 15.3059 16.0828 15.4859 15.8823C15.6659 15.6819 15.7559 15.4335 15.7559 15.1372C15.7559 14.841 15.6659 14.5926 15.4859 14.3921C15.3059 14.1917 15.0829 14.0915 14.8169 14.0915H9.18311C8.91707 14.0915 8.69406 14.1917 8.51409 14.3921C8.33413 14.5926 8.24414 14.841 8.24414 15.1372C8.24414 15.4335 8.33413 15.6819 8.51409 15.8823C8.69406 16.0828 8.91707 16.183 9.18311 16.183ZM5.42725 13.0457H7.30518V10.9543H5.42725V13.0457ZM8.24414 13.0457H10.1221V10.9543H8.24414V13.0457ZM11.061 13.0457H12.939V10.9543H11.061V13.0457ZM13.8779 13.0457H15.7559V10.9543H13.8779V13.0457ZM16.6948 13.0457H18.5728V10.9543H16.6948V13.0457ZM5.42725 9.9085H7.30518V7.81701H5.42725V9.9085ZM8.24414 9.9085H10.1221V7.81701H8.24414V9.9085ZM11.061 9.9085H12.939V7.81701H11.061V9.9085ZM13.8779 9.9085H15.7559V7.81701H13.8779V9.9085ZM16.6948 9.9085H18.5728V7.81701H16.6948V9.9085Z'
}))));

const Keyboard_Hide = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.646 19.852 9.51 17.705c-.163-.164-.202-.35-.117-.558a.468.468 0 0 1 .47-.311h4.275c.229 0 .386.104.47.311.086.208.047.394-.116.558l-2.137 2.147A.48.48 0 0 1 12 20a.48.48 0 0 1-.354-.148Zm-5.623-4.387a1.947 1.947 0 0 1-1.434-.592A1.966 1.966 0 0 1 4 13.432v-7.4c0-.566.196-1.046.589-1.44C4.98 4.197 5.459 4 6.023 4h11.954c.564 0 1.042.197 1.434.592.393.394.589.874.589 1.44v7.4c0 .566-.196 1.047-.589 1.441-.392.394-.87.592-1.434.592H6.023Zm0-2.033h11.954v-7.4H6.023v7.4Zm3.687-.68h4.58a.737.737 0 0 0 .544-.22.744.744 0 0 0 .22-.547c0-.218-.074-.4-.22-.547a.736.736 0 0 0-.544-.22H9.71a.737.737 0 0 0-.544.22.744.744 0 0 0-.22.547c0 .217.074.4.22.546.146.147.328.22.544.22Zm-2.956-2.247H8.28V8.97H6.754v1.534Zm2.247 0h1.526V8.97H9.001v1.534Zm2.236 0h1.526V8.97h-1.526v1.534Zm2.236 0h1.526V8.97h-1.526v1.534Zm2.247 0h1.526V8.97H15.72v1.534ZM6.754 8.204H8.28V6.67H6.754v1.534Zm2.247 0h1.526V6.67H9.001v1.534Zm2.236 0h1.526V6.67h-1.526v1.534Zm2.236 0h1.526V6.67h-1.526v1.534Zm2.247 0h1.526V6.67H15.72v1.534Z'
}))));

const Languages = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M13.228 20c-.325 0-.562-.103-.708-.308-.147-.205-.164-.454-.05-.748l3.05-7.762a1.25 1.25 0 0 1 .464-.549c.222-.154.46-.23.714-.23.24 0 .475.076.704.23.23.155.387.337.474.549l3.05 7.75c.113.302.097.555-.05.76-.147.205-.39.308-.729.308a.692.692 0 0 1-.43-.156.94.94 0 0 1-.293-.358l-.688-1.943h-4.015l-.73 1.954a.864.864 0 0 1-.306.353.785.785 0 0 1-.457.15Zm1.982-3.852h2.987l-1.46-3.956h-.079l-1.448 3.956ZM8.105 9.226c.22.378.455.732.705 1.063.25.33.541.673.874 1.027a11.289 11.289 0 0 0 1.525-1.969c.403-.67.745-1.383 1.025-2.14H3.829a.817.817 0 0 1-.59-.232A.758.758 0 0 1 3 6.408c0-.225.08-.416.24-.574a.807.807 0 0 1 .59-.236h4.985v-.8c0-.223.08-.413.24-.567A.817.817 0 0 1 9.645 4c.232 0 .429.077.589.231.16.154.24.344.24.568v.799h4.974c.233 0 .43.079.59.236.16.158.24.35.24.574 0 .224-.08.413-.24.567a.817.817 0 0 1-.59.232h-1.556a14.515 14.515 0 0 1-1.195 2.752c-.504.9-1.122 1.74-1.854 2.523l1.999 1.953-.608 1.636-2.59-2.473-3.566 3.436a.882.882 0 0 1-.658.265c-.248-.007-.415-.099-.5-.276a.765.765 0 0 1-.23-.558c0-.217.076-.4.23-.547l3.617-3.475c-.373-.41-.718-.827-1.034-1.252a11.423 11.423 0 0 1-.854-1.328c-.161-.283-.17-.53-.026-.741.144-.212.389-.318.735-.318.14 0 .283.04.43.12.145.079.251.18.317.302Z'
}))));

const Layover = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M10.626 19c-.337 0-.624-.122-.86-.366a1.23 1.23 0 0 1-.354-.888c0-.349.118-.645.354-.888.236-.244.523-.366.86-.366h.618c-.248-1.845-1.033-3.378-2.356-4.6-1.322-1.22-2.884-1.946-4.687-2.176a1.415 1.415 0 0 1-.854-.446A1.266 1.266 0 0 1 3 8.375c0-.349.12-.643.359-.882.24-.24.52-.339.842-.299 1.763.183 3.367.74 4.813 1.672a9.964 9.964 0 0 1 3.405 3.669 10.51 10.51 0 0 1 2.142-2.961c.864-.831 1.755-1.52 2.671-2.066h-2.026c-.337 0-.624-.122-.86-.365a1.23 1.23 0 0 1-.354-.889c0-.348.118-.644.354-.888S14.87 5 15.206 5h4.58c.337 0 .624.122.86.366s.354.54.354.888v4.866c0 .349-.118.645-.354.889a1.152 1.152 0 0 1-.86.365c-.337 0-.624-.121-.86-.365a1.23 1.23 0 0 1-.353-.889V9.585c-1.113.657-2.155 1.561-3.126 2.714-.972 1.153-1.563 2.55-1.775 4.193h.618c.337 0 .624.122.86.366.236.243.354.54.354.888s-.118.644-.354.888a1.151 1.151 0 0 1-.86.366h-3.664Z'
}))));

const Leave_App = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.516 21a2.427 2.427 0 0 1-1.784-.732A2.427 2.427 0 0 1 3 18.484V5.516c0-.701.244-1.296.732-1.784A2.427 2.427 0 0 1 5.516 3h5.226c.35 0 .647.122.891.367.245.244.367.541.367.89 0 .35-.122.647-.367.892a1.213 1.213 0 0 1-.89.367H5.515v12.968h12.968v-5.226c0-.35.123-.647.367-.891.245-.245.542-.367.891-.367.35 0 .647.122.891.367.245.244.367.541.367.89v5.227c0 .701-.244 1.296-.732 1.784a2.427 2.427 0 0 1-1.784.732H5.516Zm3.837-6.353a1.186 1.186 0 0 1-.355-.873c0-.345.119-.635.355-.872l7.386-7.386h-1.583c-.349 0-.646-.123-.89-.367a1.213 1.213 0 0 1-.367-.891c0-.35.122-.647.367-.891.244-.245.541-.367.89-.367h4.586c.35 0 .647.122.891.367.245.244.367.541.367.89v4.586c0 .35-.122.647-.367.892a1.213 1.213 0 0 1-.89.366c-.35 0-.647-.122-.892-.366a1.213 1.213 0 0 1-.367-.892V7.261l-7.41 7.41c-.227.227-.51.341-.848.341a1.19 1.19 0 0 1-.873-.365Z'
}))));

const Left = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M10.731 17.602c.253-.261.376-.58.368-.96a1.37 1.37 0 0 0-.392-.96l-2.27-2.339h10.256c.363 0 .672-.13.926-.393.254-.261.381-.58.381-.954s-.127-.692-.381-.954a1.241 1.241 0 0 0-.926-.392H8.437l2.294-2.365c.253-.261.38-.577.38-.947s-.127-.686-.38-.947A1.24 1.24 0 0 0 9.806 6c-.364 0-.673.13-.926.391L4.37 11.055c-.127.13-.22.277-.28.438a1.442 1.442 0 0 0 0 1.007c.06.161.153.307.28.438l4.536 4.689c.246.253.548.378.908.373.36-.005.665-.138.918-.398Z'
}))));

const LetterT = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M5.50008 7.11415C5.22391 7.11399 5.00017 6.88995 5.00037 6.61378L5.00158 4.99992C5.00178 4.72381 5.22576 4.50013 5.50187 4.50029L18.4999 4.50779C18.7761 4.50795 18.9998 4.73199 18.9996 5.00817L18.9984 6.62203C18.9982 6.89814 18.7742 7.12181 18.4981 7.12165L14.2799 7.11922C14.0038 7.11906 13.7798 7.34274 13.7796 7.61885L13.7711 19.0001C13.7709 19.2762 13.5469 19.4999 13.2708 19.4997L10.7089 19.4982C10.4327 19.4981 10.209 19.274 10.2092 18.9979L10.2177 7.61696C10.2179 7.34078 9.99415 7.11675 9.71798 7.11659L5.50008 7.11415Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Link = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M6.99998 17.4805C5.48371 17.4805 4.19124 16.9462 3.12256 15.8777C2.05387 14.8093 1.51953 13.5171 1.51953 12.0011C1.51953 10.4852 2.05387 9.19257 3.12256 8.12335C4.19124 7.05415 5.48371 6.51955 6.99998 6.51955H9.46301C9.83112 6.51955 10.144 6.64835 10.4016 6.90595C10.6592 7.16357 10.788 7.47643 10.788 7.84455C10.788 8.21268 10.6592 8.52555 10.4016 8.78315C10.144 9.04077 9.83112 9.16958 9.46301 9.16958H6.99998C6.21375 9.16958 5.54546 9.44476 4.99511 9.99513C4.44474 10.5455 4.16956 11.2138 4.16956 12C4.16956 12.7862 4.44474 13.4545 4.99511 14.0049C5.54546 14.5552 6.21375 14.8304 6.99998 14.8304H9.46301C9.83112 14.8304 10.144 14.9592 10.4016 15.2169C10.6592 15.4745 10.788 15.7873 10.788 16.1555C10.788 16.5236 10.6592 16.8364 10.4016 17.094C10.144 17.3516 9.83112 17.4805 9.46301 17.4805H6.99998ZM8.78801 13.1131C8.47264 13.1131 8.20829 13.0064 7.99496 12.793C7.78162 12.5797 7.67496 12.3154 7.67496 12C7.67496 11.6846 7.78162 11.4203 7.99496 11.207C8.20829 10.9936 8.47264 10.887 8.78801 10.887H15.212C15.5273 10.887 15.7917 10.9936 16.005 11.207C16.2183 11.4203 16.325 11.6846 16.325 12C16.325 12.3154 16.2183 12.5797 16.005 12.793C15.7917 13.0064 15.5273 13.1131 15.212 13.1131H8.78801ZM14.537 17.4805C14.1688 17.4805 13.856 17.3516 13.5984 17.094C13.3408 16.8364 13.212 16.5236 13.212 16.1555C13.212 15.7873 13.3408 15.4745 13.5984 15.2169C13.856 14.9592 14.1688 14.8304 14.537 14.8304H17C17.7862 14.8304 18.4545 14.5552 19.0049 14.0049C19.5552 13.4545 19.8304 12.7862 19.8304 12C19.8304 11.2138 19.5552 10.5455 19.0049 9.99513C18.4545 9.44476 17.7862 9.16958 17 9.16958H14.537C14.1688 9.16958 13.856 9.04077 13.5984 8.78315C13.3408 8.52555 13.212 8.21268 13.212 7.84455C13.212 7.47643 13.3408 7.16357 13.5984 6.90595C13.856 6.64835 14.1688 6.51955 14.537 6.51955H17C18.5162 6.51955 19.8087 7.05378 20.8774 8.12225C21.9461 9.19073 22.4804 10.483 22.4804 11.9989C22.4804 13.5149 21.9461 14.8074 20.8774 15.8767C19.8087 16.9458 18.5162 17.4805 17 17.4805H14.537Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const List = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M8.68 8.475c-.35 0-.647-.117-.892-.351a1.138 1.138 0 0 1-.367-.854c0-.335.122-.62.367-.854.245-.235.543-.352.893-.352h11.06c.35 0 .647.117.892.352.245.234.367.519.367.854 0 .335-.122.62-.367.854a1.243 1.243 0 0 1-.893.351H8.68Zm0 4.23c-.35 0-.647-.117-.892-.351a1.138 1.138 0 0 1-.367-.854c0-.335.122-.62.367-.854.245-.234.543-.351.893-.351h11.06c.35 0 .647.117.892.351.245.234.367.52.367.854 0 .335-.122.62-.367.854a1.243 1.243 0 0 1-.893.351H8.68Zm0 4.23c-.35 0-.647-.116-.892-.35a1.138 1.138 0 0 1-.367-.855c0-.335.122-.62.367-.854.245-.234.543-.351.893-.351h11.06c.35 0 .647.117.892.351.245.235.367.52.367.854 0 .335-.122.62-.367.854a1.243 1.243 0 0 1-.893.352H8.68ZM4.328 8.54c-.368 0-.681-.123-.94-.37a1.198 1.198 0 0 1-.387-.9c0-.351.13-.651.388-.898S3.959 6 4.327 6s.679.124.933.37c.253.248.38.548.38.9s-.127.651-.38.899c-.254.247-.565.37-.933.37Zm0 4.23a1.31 1.31 0 0 1-.94-.37A1.198 1.198 0 0 1 3 11.5c0-.352.13-.652.388-.899a1.31 1.31 0 0 1 .939-.37c.368 0 .679.123.933.37.253.247.38.547.38.899s-.127.652-.38.899c-.254.247-.565.37-.933.37Zm0 4.231a1.31 1.31 0 0 1-.94-.37 1.198 1.198 0 0 1-.387-.9c0-.352.13-.651.388-.899a1.31 1.31 0 0 1 .939-.37c.368 0 .679.123.933.37.253.248.38.547.38.9 0 .351-.127.651-.38.898-.254.247-.565.371-.933.371Z'
}))));

var style = {"loading":"_1ori_","rotateLoading":"_2h6ML"};

const Loading = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  },
  className: style.loading
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none'
}, props, {
  className: style.loading
}), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M8.647 7.035A6 6 0 0 1 18.016 12a1 1 0 1 0 2 0 8 8 0 0 0-15.747-1.998 1 1 0 0 0 1.937.5 6 6 0 0 1 2.441-3.467ZM5.083 13.39A1 1 0 0 1 6.359 14a6 6 0 0 0 2.715 3.23 1 1 0 0 1-.981 1.742 8 8 0 0 1-3.62-4.305 1 1 0 0 1 .61-1.276Zm13.154 1.97a1 1 0 0 1 .21 1.398 8 8 0 0 1-4.723 3.056 1 1 0 1 1-.427-1.953 6 6 0 0 0 3.542-2.293 1 1 0 0 1 1.398-.209Z',
  clipRule: 'evenodd'
}))));

const Location = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm10.19 13.814-5.372-2.172a1.318 1.318 0 0 1-.595-.489A1.288 1.288 0 0 1 4 10.42c0-.269.075-.51.224-.723a1.28 1.28 0 0 1 .594-.464l13.624-5.145a.973.973 0 0 1 .668-.05c.216.064.397.17.545.318.148.147.252.327.31.538a.982.982 0 0 1-.055.661L14.774 19.17a1.211 1.211 0 0 1-.487.623 1.3 1.3 0 0 1-.703.207c-.248 0-.485-.07-.713-.207a1.312 1.312 0 0 1-.52-.61l-2.161-5.369Zm3.342 2.185 3.34-8.876-8.869 3.351 3.966 1.55 1.563 3.975Z'
}))));

const Location_Pin = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.997 11.816c.558 0 1.036-.194 1.435-.583.4-.389.599-.856.599-1.401a1.9 1.9 0 0 0-.596-1.405 1.97 1.97 0 0 0-1.432-.585c-.558 0-1.036.194-1.435.583a1.886 1.886 0 0 0-.599 1.401 1.9 1.9 0 0 0 .596 1.404c.397.39.875.586 1.432.586ZM12 18.209c1.848-1.674 3.219-3.196 4.113-4.564.893-1.368 1.34-2.579 1.34-3.632 0-1.618-.526-2.942-1.578-3.974-1.052-1.031-2.343-1.547-3.872-1.547-1.53 0-2.82.516-3.875 1.547-1.054 1.032-1.581 2.356-1.581 3.974 0 1.053.446 2.264 1.34 3.632.894 1.368 2.265 2.89 4.113 4.564ZM12 21a1.628 1.628 0 0 1-1.033-.378c-2.338-2.048-4.084-3.95-5.237-5.704C4.577 13.165 4 11.53 4 10.018c0-2.444.804-4.391 2.412-5.842C8.02 2.725 9.882 2 12 2c2.116 0 3.979.725 5.588 2.175C19.195 5.625 20 7.573 20 10.017c0 1.513-.577 3.147-1.73 4.902-1.153 1.754-2.899 3.655-5.237 5.703A1.628 1.628 0 0 1 12 21Z'
}))));

const Lock_Visibility = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.92 13.76a2.115 2.115 0 0 1-1.512-.593 1.913 1.913 0 0 1-.624-1.44c0-.565.207-1.046.622-1.443a2.104 2.104 0 0 1 1.51-.595c.592 0 1.097.198 1.513.593.416.395.624.876.624 1.44 0 .566-.207 1.046-.622 1.443a2.104 2.104 0 0 1-1.51.596Zm.002 4.69c-2.053 0-3.954-.527-5.704-1.58-1.75-1.052-3.084-2.451-4.003-4.198a1.98 1.98 0 0 1-.164-.464 2.295 2.295 0 0 1 0-.968c.033-.156.088-.31.164-.463.92-1.746 2.254-3.146 4.003-4.198A10.859 10.859 0 0 1 11.918 5c2.23 0 4.253.598 6.07 1.795C19.803 7.992 21.14 9.57 22 11.53h-2.41A8.433 8.433 0 0 0 16.41 8.27c-1.368-.803-2.865-1.205-4.49-1.205-1.664 0-3.191.422-4.582 1.267a8.514 8.514 0 0 0-3.197 3.393 8.515 8.515 0 0 0 3.197 3.393c1.391.844 2.918 1.266 4.581 1.266.313 0 .622-.014.926-.042.305-.029.605-.075.9-.14V18.3c-.295.052-.596.09-.903.114-.306.024-.613.036-.919.036Zm-.004-2.913a4.204 4.204 0 0 0 1.886-.45c.1-.627.335-1.194.707-1.703.37-.509.83-.92 1.379-1.236a.988.988 0 0 0 .025-.211v-.212c0-1.06-.388-1.96-1.166-2.7-.777-.742-1.72-1.112-2.83-1.112s-2.054.37-2.832 1.111c-.777.742-1.165 1.642-1.165 2.7 0 1.06.388 1.96 1.165 2.701.778.741 1.721 1.112 2.831 1.112ZM16.41 20a.881.881 0 0 1-.632-.244.8.8 0 0 1-.256-.603V16.61a.8.8 0 0 1 .256-.603.882.882 0 0 1 .632-.244v-.847c0-.466.174-.865.522-1.196a1.753 1.753 0 0 1 1.255-.498c.488 0 .906.166 1.254.498.348.331.522.73.522 1.196v.847c.252 0 .463.082.633.244a.8.8 0 0 1 .255.603v2.542a.8.8 0 0 1-.255.603.881.881 0 0 1-.633.244h-3.553Zm.889-4.236h1.776v-.847a.8.8 0 0 0-.256-.603.881.881 0 0 0-.632-.244.881.881 0 0 0-.633.244.8.8 0 0 0-.255.603v.847Z'
}))));

const Locked = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.5 22a2.442 2.442 0 0 1-1.766-.714A2.309 2.309 0 0 1 4 19.569v-8.86c0-.669.245-1.241.734-1.717A2.442 2.442 0 0 1 6.5 8.278h.583V6.819c0-1.338.478-2.475 1.433-3.413C9.472 2.47 10.633 2 12 2s2.528.469 3.484 1.406c.955.938 1.433 2.075 1.433 3.413v1.459h.583c.688 0 1.276.238 1.766.714S20 10.04 20 10.708v8.861c0 .669-.245 1.241-.734 1.717A2.442 2.442 0 0 1 17.5 22h-11Zm0-2.43h11v-8.862h-11v8.861Zm5.5-2.597c.519 0 .963-.18 1.332-.539.37-.359.555-.79.555-1.295 0-.505-.185-.936-.555-1.296A1.843 1.843 0 0 0 12 13.305c-.519 0-.963.18-1.332.538-.37.36-.555.791-.555 1.296 0 .504.185.936.555 1.295.369.36.813.54 1.332.54ZM9.583 8.278h4.834V6.819a2.3 2.3 0 0 0-.699-1.692c-.466-.464-1.038-.696-1.718-.696-.68 0-1.252.232-1.718.696a2.3 2.3 0 0 0-.699 1.692v1.459Z'
}))));

const Log_Out = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M9.24 15.989a1.166 1.166 0 0 1-.31-.801c0-.304.104-.56.31-.771l1.272-1.299H5.095c-.304 0-.563-.109-.776-.326A1.09 1.09 0 0 1 4 12c0-.31.106-.575.32-.792.212-.217.471-.326.775-.326h5.417l-1.284-1.31a1.054 1.054 0 0 1-.312-.78c.004-.304.112-.565.324-.781a1.01 1.01 0 0 1 .76-.325c.302 0 .556.105.762.316l3.162 3.216c.107.109.183.23.229.364a1.275 1.275 0 0 1 0 .836.964.964 0 0 1-.229.364L10.75 16.01a.976.976 0 0 1-.76.31 1.066 1.066 0 0 1-.75-.331ZM13.002 20c-.305 0-.563-.109-.776-.326a1.09 1.09 0 0 1-.32-.792c0-.31.107-.575.32-.792.213-.218.471-.326.776-.326h4.807V6.236h-4.807c-.305 0-.563-.108-.776-.326a1.09 1.09 0 0 1-.32-.792c0-.31.107-.575.32-.792.213-.217.471-.326.776-.326h4.807c.61 0 1.128.217 1.553.65.426.435.638.963.638 1.586v11.528a2.18 2.18 0 0 1-.637 1.585c-.425.434-.943.651-1.553.651h-4.808Z'
}))));

const Low_Data = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("mask", {
  id: 'mask0_7399_13873',
  style: {
    maskType: 'alpha'
  },
  maskUnits: 'userSpaceOnUse',
  x: '0',
  y: '0',
  width: '24',
  height: '24'
}, /*#__PURE__*/createElement("rect", {
  width: '24',
  height: '24',
  fill: '#D9D9D9'
})), /*#__PURE__*/createElement("g", {
  mask: 'url(#mask0_7399_13873)'
}, /*#__PURE__*/createElement("path", {
  d: 'M5.91536 20.4814C5.40841 20.4814 4.9775 20.304 4.62263 19.9491C4.26777 19.5943 4.09033 19.1633 4.09033 18.6564V16.7586C4.09033 16.2517 4.26777 15.8208 4.62263 15.4659C4.9775 15.111 5.40841 14.9336 5.91536 14.9336C6.42231 14.9336 6.85322 15.111 7.20808 15.4659C7.56293 15.8208 7.74036 16.2517 7.74036 16.7586V18.6564C7.74036 19.1633 7.56293 19.5943 7.20808 19.9491C6.85322 20.304 6.42231 20.4814 5.91536 20.4814Z',
  fill: props.fill ?? ColoursObj.core.primary
}), /*#__PURE__*/createElement("path", {
  d: 'M11.9998 20.4804C11.4929 20.4804 11.0619 20.303 10.7071 19.9482C10.3522 19.5933 10.1748 19.1624 10.1748 18.6554V11.7577C10.1748 11.2507 10.3522 10.8198 10.7071 10.4649C11.0619 10.1101 11.4929 9.93263 11.9998 9.93263C12.5068 9.93263 12.9377 10.1101 13.2925 10.4649C13.6474 10.8198 13.8248 11.2507 13.8248 11.7577V18.6554C13.8248 19.1624 13.6474 19.5933 13.2925 19.9482C12.9377 20.303 12.5068 20.4804 11.9998 20.4804ZM18.0846 20.4804C17.5777 20.4804 17.1467 20.303 16.7919 19.9482C16.437 19.5933 16.2596 19.1624 16.2596 18.6554V5.34453C16.2596 4.83758 16.437 4.40667 16.7919 4.05181C17.1467 3.69696 17.5777 3.51953 18.0846 3.51953C18.5916 3.51953 19.0225 3.69696 19.3773 4.05181C19.7322 4.40667 19.9096 4.83758 19.9096 5.34453V18.6554C19.9096 19.1624 19.7322 19.5933 19.3773 19.9482C19.0225 20.303 18.5916 20.4804 18.0846 20.4804Z',
  fill: props.fill ?? ColoursObj.core.primary,
  fillOpacity: '0.32'
})))));

const Map$1 = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M14.35 20.775 9 18.9l-4.65 1.8a.912.912 0 0 1-.487.063 1.158 1.158 0 0 1-.438-.163.87.87 0 0 1-.313-.338A1.026 1.026 0 0 1 3 19.776V5.75c0-.217.063-.408.188-.575A1.13 1.13 0 0 1 3.7 4.8l4.65-1.575a1.9 1.9 0 0 1 .313-.075 2.217 2.217 0 0 1 .987.075L15 5.1l4.65-1.8a.912.912 0 0 1 .488-.063c.158.026.304.08.437.163a.871.871 0 0 1 .313.337c.074.142.112.305.112.488V18.25a.933.933 0 0 1-.188.575 1.129 1.129 0 0 1-.512.375l-4.65 1.575c-.1.033-.204.058-.313.075a2.213 2.213 0 0 1-.987-.075ZM14 18.55V6.85l-4-1.4v11.7l4 1.4Zm2 0 3-1V5.7l-3 1.15v11.7ZM5 18.3l3-1.15V5.45l-3 1V18.3Z'
}))));

const Meal = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M17.972 21a.975.975 0 0 1-.732-.307 1.055 1.055 0 0 1-.295-.761V13.95h-.489c-.586 0-1.075-.231-1.467-.693-.392-.461-.588-1.009-.588-1.643v-4.02c0-1.286.451-2.373 1.354-3.261C16.658 3.444 17.739 3 19 3v16.932c0 .303-.099.556-.295.76a.975.975 0 0 1-.733.308Zm-9.03 0a.975.975 0 0 1-.732-.307 1.055 1.055 0 0 1-.295-.761v-6.959c-.777-.205-1.457-.658-2.04-1.357S5 10.101 5 9.17v-5.1c0-.303.098-.557.295-.762A.975.975 0 0 1 6.028 3c.288 0 .533.102.735.307.203.205.304.459.304.761V9.17h.848v-5.1c0-.303.098-.557.295-.762A.975.975 0 0 1 8.943 3c.29 0 .535.102.732.307.197.205.295.459.295.761V9.17h.848v-5.1c0-.303.101-.557.304-.762A.997.997 0 0 1 11.858 3c.288 0 .531.102.73.307.198.205.297.459.297.761V9.17c0 .932-.291 1.748-.875 2.447-.583.7-1.263 1.152-2.04 1.357v6.959c0 .303-.098.556-.295.76a.975.975 0 0 1-.732.308Z'
}))));

const Minimise = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.13 9.802c-.31 0-.577-.108-.798-.326A1.069 1.069 0 0 1 4 8.684c0-.31.109-.574.326-.792.217-.217.481-.326.792-.326h.885l-1.56-1.56a1.069 1.069 0 0 1-.315-.787c0-.315.105-.578.315-.788.21-.21.47-.315.782-.315.31 0 .57.105.781.315l1.56 1.56v-.873c0-.31.109-.575.326-.792C8.11 4.11 8.374 4 8.684 4c.31 0 .575.109.792.326.218.217.326.481.326.792v3.566c0 .31-.108.575-.326.792a1.078 1.078 0 0 1-.792.326H5.13Zm13.752 0h-3.554c-.311 0-.575-.108-.792-.326a1.079 1.079 0 0 1-.326-.792V5.118c0-.31.108-.575.326-.792.217-.217.481-.326.792-.326.31 0 .574.109.792.326.217.217.326.481.326.792v.873l1.56-1.56c.21-.21.47-.315.781-.315.311 0 .572.105.782.315.21.21.315.473.315.788 0 .314-.105.577-.315.787l-1.56 1.56h.873c.31 0 .574.109.792.326.217.218.326.482.326.792 0 .31-.109.575-.326.792a1.078 1.078 0 0 1-.792.326ZM4.443 19.557c-.21-.21-.315-.47-.315-.781 0-.311.105-.572.315-.782l1.56-1.56H5.13c-.31 0-.575-.109-.792-.326a1.078 1.078 0 0 1-.326-.792c0-.31.109-.575.326-.792.217-.218.481-.326.792-.326h3.554c.31 0 .575.108.792.326.218.217.326.481.326.792v3.566c0 .31-.108.574-.326.792a1.078 1.078 0 0 1-.792.326c-.31 0-.574-.109-.792-.326a1.078 1.078 0 0 1-.326-.792v-.873l-1.56 1.548c-.21.21-.47.316-.781.316-.311 0-.572-.106-.782-.316ZM15.328 20c-.311 0-.575-.109-.792-.326a1.079 1.079 0 0 1-.326-.792v-3.566c0-.31.108-.575.326-.792.217-.218.481-.326.792-.326h3.554c.31 0 .574.108.792.326.217.217.326.481.326.792 0 .31-.109.574-.326.792a1.079 1.079 0 0 1-.792.326h-.873l1.56 1.56c.21.21.315.47.315.782 0 .31-.105.57-.315.781-.21.21-.47.316-.782.316-.31 0-.57-.106-.781-.316l-1.56-1.548v.873c0 .31-.109.574-.326.792a1.078 1.078 0 0 1-.792.326Z'
}))));

const More = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.051 14a2 2 0 0 1-1.449-.588A1.903 1.903 0 0 1 4 12c0-.557.2-1.03.6-1.418.402-.388.883-.582 1.446-.582.566 0 1.05.194 1.454.582.403.388.605.859.605 1.412A1.91 1.91 0 0 1 7.5 13.41a2.002 2.002 0 0 1-1.45.589Zm5.956 0a2.002 2.002 0 0 1-1.45-.588A1.903 1.903 0 0 1 9.953 12c0-.557.2-1.03.601-1.418.4-.388.882-.582 1.445-.582.57 0 1.053.194 1.45.582a1.9 1.9 0 0 1 .596 1.412c0 .552-.199 1.025-.596 1.417a1.978 1.978 0 0 1-1.443.589Zm5.951 0a2.018 2.018 0 0 1-1.457-.588A1.897 1.897 0 0 1 15.895 12c0-.557.202-1.03.606-1.418.404-.388.89-.582 1.457-.582.567 0 1.05.194 1.446.582A1.9 1.9 0 0 1 20 11.994c0 .552-.198 1.025-.596 1.417a1.98 1.98 0 0 1-1.446.589Z'
}))));

const New_Itinerary = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M5.46347 19.4781C4.82878 19.4781 4.28545 19.2521 3.83348 18.8001C3.38151 18.3482 3.15552 17.8048 3.15552 17.1701V5.27265C3.15552 4.63796 3.38151 4.09462 3.83348 3.64264C4.28545 3.19066 4.82878 2.96467 5.46347 2.96467H17.361C17.9957 2.96467 18.539 3.19066 18.991 3.64264C19.4429 4.09462 19.6689 4.63796 19.6689 5.27265V11.5262C19.3193 11.3053 18.9522 11.119 18.5675 10.9672C18.1828 10.8155 17.7806 10.7096 17.361 10.6496V5.27265H5.46347V17.1701H10.4126C10.4397 17.5961 10.5107 18.0015 10.6255 18.3861C10.7404 18.7708 10.8878 19.1348 11.0676 19.4781H5.46347ZM5.46347 17.1701V5.27265V10.6496V10.5966V17.1701ZM7.20531 14.5574C7.20531 14.8041 7.28878 15.011 7.4557 15.1779C7.62263 15.3448 7.82947 15.4283 8.07623 15.4283H10.5328C10.5927 15.1235 10.6801 14.8259 10.795 14.5356C10.9099 14.2453 11.0418 13.9623 11.1907 13.6865H8.07623C7.82947 13.6865 7.62263 13.7699 7.4557 13.9369C7.28878 14.1038 7.20531 14.3106 7.20531 14.5574ZM7.20531 11.2214C7.20531 11.4682 7.28878 11.675 7.4557 11.8419C7.62263 12.0089 7.82947 12.0923 8.07623 12.0923H12.4933C12.925 11.7143 13.4049 11.4027 13.9332 11.1575C14.4614 10.9123 15.0234 10.743 15.6191 10.6496C15.5131 10.5549 15.3803 10.4814 15.2206 10.4291C15.0609 10.3767 14.9035 10.3505 14.7482 10.3505H8.07623C7.82947 10.3505 7.62263 10.4339 7.4557 10.6009C7.28878 10.7678 7.20531 10.9746 7.20531 11.2214ZM7.20531 7.88541C7.20531 8.13217 7.28878 8.33901 7.4557 8.50594C7.62263 8.67286 7.82947 8.75633 8.07623 8.75633H14.7482C14.995 8.75633 15.2018 8.67286 15.3687 8.50594C15.5357 8.33901 15.6191 8.13217 15.6191 7.88541C15.6191 7.63865 15.5357 7.43181 15.3687 7.26488C15.2018 7.09795 14.995 7.01449 14.7482 7.01449H8.07623C7.82947 7.01449 7.62263 7.09795 7.4557 7.26488C7.28878 7.43181 7.20531 7.63865 7.20531 7.88541ZM16.49 21.0353C15.2853 21.0353 14.2583 20.6108 13.4092 19.7616C12.56 18.9125 12.1355 17.8855 12.1355 16.6807C12.1355 15.476 12.56 14.449 13.4092 13.5999C14.2583 12.7507 15.2853 12.3261 16.49 12.3261C17.6948 12.3261 18.7218 12.7507 19.5709 13.5999C20.4201 14.449 20.8446 15.476 20.8446 16.6807C20.8446 17.8855 20.4201 18.9125 19.5709 19.7616C18.7218 20.6108 17.6948 21.0353 16.49 21.0353ZM15.87 17.3008V18.858C15.87 19.0234 15.932 19.1681 16.056 19.2921C16.18 19.4161 16.3247 19.4781 16.49 19.4781C16.6554 19.4781 16.8001 19.4161 16.9241 19.2921C17.0481 19.1681 17.1101 19.0234 17.1101 18.858V17.3008H18.6673C18.8327 17.3008 18.9774 17.2388 19.1014 17.1148C19.2254 16.9908 19.2874 16.8461 19.2874 16.6807C19.2874 16.5154 19.2254 16.3707 19.1014 16.2467C18.9774 16.1227 18.8327 16.0607 18.6673 16.0607H17.1101V14.5034C17.1101 14.3381 17.0481 14.1934 16.9241 14.0694C16.8001 13.9454 16.6554 13.8834 16.49 13.8834C16.3247 13.8834 16.18 13.9454 16.056 14.0694C15.932 14.1934 15.87 14.3381 15.87 14.5034V16.0607H14.3128C14.1474 16.0607 14.0027 16.1227 13.8787 16.2467C13.7547 16.3707 13.6927 16.5154 13.6927 16.6807C13.6927 16.8461 13.7547 16.9908 13.8787 17.1148C14.0027 17.2388 14.1474 17.3008 14.3128 17.3008H15.87Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Night = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12.256 21a9.08 9.08 0 0 1-3.604-.718 9.437 9.437 0 0 1-2.935-1.948 9.242 9.242 0 0 1-1.985-2.88A8.629 8.629 0 0 1 3 11.914c0-1.89.547-3.61 1.64-5.156C5.734 5.212 7.19 4.09 9.007 3.398c.208-.073.424-.097.647-.07.222.025.412.097.57.213.135.11.236.255.303.433s.105.413.113.705c.046 1.242.29 2.395.732 3.459a8.378 8.378 0 0 0 4.682 4.608c1.074.434 2.26.685 3.56.756.304.016.544.056.72.12.176.063.32.161.433.294.118.154.192.348.221.582.029.233.006.448-.068.646a8.974 8.974 0 0 1-3.406 4.254C15.935 20.466 14.183 21 12.256 21Zm0-2.319a6.84 6.84 0 0 0 3.25-.802 6.596 6.596 0 0 0 2.459-2.238 11.617 11.617 0 0 1-3.444-1.026 10.82 10.82 0 0 1-2.937-2.062 10.863 10.863 0 0 1-2.112-2.876 10.656 10.656 0 0 1-1.046-3.374 6.702 6.702 0 0 0-2.251 2.425 6.538 6.538 0 0 0-.812 3.187c0 1.887.668 3.486 2.005 4.798 1.337 1.312 2.966 1.968 4.888 1.968Zm3.942-11.304-1.586-.713c-.237-.097-.356-.272-.356-.523s.119-.426.356-.524l1.586-.712.725-1.556A.536.536 0 0 1 17.457 3c.256 0 .434.116.533.349l.726 1.556 1.598.712a.52.52 0 0 1 .35.53.54.54 0 0 1-.363.53l-1.585.7-.713 1.556c-.1.232-.28.35-.54.355-.26.004-.44-.11-.54-.343l-.725-1.568Z'
}))));

const Notification = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.203 18.37c-.334 0-.618-.11-.852-.33A1.064 1.064 0 0 1 4 17.234c0-.315.117-.583.35-.803.235-.221.519-.331.853-.331h.754v-5.548c0-1.297.401-2.455 1.205-3.472.804-1.018 1.862-1.681 3.175-1.991v-.527c0-.434.16-.803.483-1.107A1.647 1.647 0 0 1 11.994 3c.46 0 .851.152 1.173.456.322.304.483.673.483 1.107v.527c1.322.31 2.382.973 3.182 1.99a5.471 5.471 0 0 1 1.198 3.473v5.548h.767c.334 0 .618.11.852.33.234.221.351.49.351.804 0 .316-.117.584-.35.804-.235.22-.519.331-.853.331H5.203ZM12.006 21c-.541 0-1.005-.18-1.39-.542-.386-.362-.58-.796-.58-1.304h3.927c0 .511-.191.947-.575 1.307-.383.36-.844.539-1.382.539Zm-3.644-4.9h7.263v-5.547c0-.942-.356-1.748-1.067-2.419-.711-.67-1.566-1.006-2.564-1.006-.999 0-1.854.335-2.565 1.006-.711.67-1.067 1.477-1.067 2.42V16.1Z'
}))));

const Okay = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm10.761 13.121-1.53-1.53a1.046 1.046 0 0 0-.771-.31 1.046 1.046 0 0 0-1.074 1.08c.004.308.109.565.315.771l2.253 2.254c.231.228.501.342.81.342.308 0 .576-.114.805-.342l4.67-4.67c.206-.206.309-.461.309-.765s-.103-.56-.31-.765a1.046 1.046 0 0 0-.77-.31c-.308 0-.565.104-.771.31L10.76 13.12ZM12 21a8.786 8.786 0 0 1-3.519-.708 9.073 9.073 0 0 1-2.853-1.92 9.073 9.073 0 0 1-1.92-2.853A8.786 8.786 0 0 1 3 12c0-1.253.236-2.426.708-3.519a9.074 9.074 0 0 1 1.92-2.853 9.074 9.074 0 0 1 2.853-1.92A8.786 8.786 0 0 1 12 3c1.253 0 2.426.236 3.519.708a9.073 9.073 0 0 1 2.853 1.92 9.073 9.073 0 0 1 1.92 2.853A8.786 8.786 0 0 1 21 12a8.786 8.786 0 0 1-.708 3.519 9.073 9.073 0 0 1-1.92 2.853 9.073 9.073 0 0 1-2.853 1.92A8.786 8.786 0 0 1 12 21Zm0-2.276c1.886 0 3.478-.649 4.776-1.948 1.299-1.298 1.948-2.89 1.948-4.776 0-1.886-.649-3.478-1.948-4.776-1.298-1.299-2.89-1.948-4.776-1.948-1.886 0-3.478.649-4.776 1.948C5.925 8.522 5.276 10.114 5.276 12c0 1.886.649 3.478 1.948 4.776 1.298 1.299 2.89 1.948 4.776 1.948Z'
}))));

const Parking = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.276 21c-.634 0-1.172-.22-1.614-.662A2.196 2.196 0 0 1 3 18.724V5.276c0-.634.22-1.172.662-1.614.442-.441.98-.662 1.614-.662h13.448c.634 0 1.172.22 1.614.662.441.442.662.98.662 1.614v13.448c0 .634-.22 1.172-.662 1.614-.442.441-.98.662-1.614.662H5.276Zm0-2.276h13.448V5.276H5.276v13.448Zm4.293-4.86a.83.83 0 0 0 .612-.248.83.83 0 0 0 .247-.612.831.831 0 0 0-.247-.611.83.83 0 0 0-.612-.247.83.83 0 0 0-.611.246.831.831 0 0 0-.247.612.83.83 0 0 0 .247.612.83.83 0 0 0 .611.247Zm4.862 0a.831.831 0 0 0 .612-.248.831.831 0 0 0 .246-.612.831.831 0 0 0-.246-.611.831.831 0 0 0-.612-.247.831.831 0 0 0-.612.246.831.831 0 0 0-.247.612c0 .244.082.448.247.612a.831.831 0 0 0 .612.247Zm-8.297-2.491v5.485c0 .2.065.365.194.494a.669.669 0 0 0 .493.193h.344c.2 0 .365-.064.494-.193a.669.669 0 0 0 .193-.494v-.848h8.296v.848c0 .2.064.365.193.494a.669.669 0 0 0 .494.193h.344c.2 0 .365-.064.493-.193a.669.669 0 0 0 .194-.494v-5.485l-1.38-4.025a1.374 1.374 0 0 0-.367-.542.82.82 0 0 0-.572-.242H8.453c-.21 0-.4.076-.573.23a1.259 1.259 0 0 0-.365.554l-1.38 4.025ZM8.41 9.999l.601-1.718h5.978l.6 1.718H8.41Zm-.558 4.293v-2.576h8.296v2.577H7.852Z'
}))));

const Phone = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M9.751 9.806a.79.79 0 0 1-.575-.226.752.752 0 0 1-.232-.56c0-.224.078-.41.232-.561a.79.79 0 0 1 .575-.226h4.498a.79.79 0 0 1 .575.226c.154.15.232.337.232.56 0 .223-.078.41-.232.561a.79.79 0 0 1-.575.226H9.751ZM8.138 21a2.09 2.09 0 0 1-1.516-.607A1.987 1.987 0 0 1 6 18.915V5.085c0-.58.207-1.074.622-1.478A2.09 2.09 0 0 1 8.138 3h7.724c.596 0 1.101.202 1.516.607.415.404.622.897.622 1.478v13.83c0 .58-.207 1.074-.622 1.478a2.09 2.09 0 0 1-1.516.607H8.138Zm0-2.872v.787h7.724v-.787H8.138Zm0-1.574h7.724V7.446H8.138v9.108Zm0-10.682h7.724v-.787H8.138v.787Z'
}))));

const Photos = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("mask", {
  id: 'mask0_4985_4298',
  style: {
    maskType: 'alpha'
  },
  maskUnits: 'userSpaceOnUse',
  x: '0',
  y: '0',
  width: 24,
  height: 24
}, /*#__PURE__*/createElement("rect", {
  width: '24',
  height: '24',
  fill: '#D9D9D9'
})), /*#__PURE__*/createElement("g", {
  mask: 'url(#mask0_4985_4298)'
}, /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M13.5751 12.175L12.5523 10.8445C12.4146 10.6735 12.2388 10.588 12.0251 10.588C11.8113 10.588 11.6356 10.6735 11.4979 10.8445L10.1479 12.6065C9.97689 12.8297 9.95125 13.0636 10.071 13.3081C10.1907 13.5527 10.3921 13.675 10.6751 13.675H17.9751C18.2581 13.675 18.4594 13.5527 18.5792 13.3081C18.6989 13.0636 18.6732 12.8297 18.5022 12.6065L16.4023 9.86954C16.2646 9.69853 16.0888 9.61302 15.8751 9.61302C15.6613 9.61302 15.4856 9.69853 15.3479 9.86954L13.5751 12.175ZM8.49466 18.1554C7.75624 18.1554 7.12996 17.8984 6.61581 17.3842C6.10167 16.8701 5.84461 16.2438 5.84461 15.5054V3.84454C5.84461 3.10613 6.10167 2.47985 6.61581 1.96572C7.12996 1.45159 7.75624 1.19452 8.49466 1.19452H20.1555C20.8939 1.19452 21.5202 1.45159 22.0343 1.96572C22.5485 2.47985 22.8055 3.10613 22.8055 3.84454V15.5054C22.8055 16.2438 22.5485 16.8701 22.0343 17.3842C21.5202 17.8984 20.8939 18.1554 20.1555 18.1554H8.49466ZM8.49466 15.5054H20.1555V3.84454H8.49466V15.5054ZM3.84461 22.8055C3.10619 22.8055 2.47991 22.5484 1.96578 22.0343C1.45165 21.5201 1.19458 20.8939 1.19458 20.1554V7.16957C1.19458 6.80145 1.32339 6.48859 1.58101 6.23097C1.83861 5.97335 2.15147 5.84454 2.51961 5.84454C2.88772 5.84454 3.20059 5.97335 3.45821 6.23097C3.71581 6.48859 3.84461 6.80145 3.84461 7.16957V20.1554H16.8305C17.1986 20.1554 17.5115 20.2842 17.7691 20.5418C18.0267 20.7995 18.1555 21.1123 18.1555 21.4804C18.1555 21.8486 18.0267 22.1614 17.7691 22.419C17.5115 22.6767 17.1986 22.8055 16.8305 22.8055H3.84461Z'
})))));

const Private = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M11.3734 8.66674C10.1334 8.66674 9.09337 9.55341 8.82671 10.7334C8.19337 10.4601 7.61337 10.5334 7.17337 10.7267C6.90004 9.54008 5.86004 8.66674 4.62671 8.66674C3.18004 8.66674 2.00004 9.86008 2.00004 11.3334C2.00004 12.8067 3.18004 14.0001 4.62671 14.0001C6.00004 14.0001 7.12004 12.9201 7.22671 11.5467C7.45337 11.3867 8.04671 11.0867 8.77337 11.5601C8.89337 12.9267 10 14.0001 11.3734 14.0001C12.82 14.0001 14 12.8067 14 11.3334C14 9.86008 12.82 8.66674 11.3734 8.66674ZM4.62671 13.2401C3.58671 13.2401 2.75337 12.3867 2.75337 11.3334C2.75337 10.2801 3.59337 9.42674 4.62671 9.42674C5.66671 9.42674 6.50004 10.2801 6.50004 11.3334C6.50004 12.3867 5.66671 13.2401 4.62671 13.2401ZM11.3734 13.2401C10.3334 13.2401 9.50004 12.3867 9.50004 11.3334C9.50004 10.2801 10.3334 9.42674 11.3734 9.42674C12.4134 9.42674 13.2534 10.2801 13.2534 11.3334C13.2534 12.3867 12.4067 13.2401 11.3734 13.2401ZM14.6667 7.50008C14.6667 7.22393 14.4429 7.00008 14.1667 7.00008L1.83337 7.00008C1.55723 7.00008 1.33337 7.22393 1.33337 7.50008C1.33337 7.77622 1.55723 8.00008 1.83337 8.00008L14.1667 8.00008C14.4429 8.00008 14.6667 7.77622 14.6667 7.50008ZM10.3534 1.75341C10.2067 1.42674 9.83337 1.25341 9.48004 1.36674L8.00004 1.86008L6.51337 1.36674L6.48004 1.36008C6.12671 1.26008 5.75337 1.44674 5.62004 1.78674L4.00004 6.00008L12 6.00008L10.3734 1.78674L10.3534 1.75341Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Public = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 16,
    width: props.width ?? 16,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, props), /*#__PURE__*/createElement("g", {
  clipPath: 'url(#clip0_9681_7669)'
}, /*#__PURE__*/createElement("path", {
  d: 'M15.324 8.64614L13.5625 8.64614C13.3853 8.64614 13.237 8.58633 13.1175 8.46671C12.9979 8.34722 12.938 8.19887 12.938 8.02166C12.938 7.84444 12.9979 7.69609 13.1175 7.57661C13.237 7.45699 13.3853 7.39717 13.5625 7.39717L15.324 7.39717C15.5012 7.39717 15.6495 7.45699 15.769 7.57661C15.8887 7.69609 15.9485 7.84444 15.9485 8.02166C15.9485 8.19887 15.8887 8.34722 15.769 8.46671C15.6495 8.58633 15.5012 8.64614 15.324 8.64614ZM11.8604 11.9463C11.9671 11.8001 12.1035 11.7157 12.2696 11.6932C12.4356 11.6709 12.5917 11.713 12.738 11.8198L14.1423 12.8749C14.2885 12.9818 14.3728 13.1182 14.3952 13.2842C14.4177 13.4502 14.3755 13.6063 14.2686 13.7525C14.1619 13.8987 14.0255 13.983 13.8596 14.0055C13.6936 14.0279 13.5375 13.9858 13.3912 13.8789L11.987 12.8237C11.8407 12.717 11.7564 12.5807 11.734 12.4147C11.7116 12.2487 11.7537 12.0926 11.8604 11.9463ZM14.1102 3.13632L12.7059 4.19149C12.5597 4.29821 12.4036 4.3404 12.2376 4.31806C12.0716 4.29557 11.9352 4.2112 11.8283 4.06493C11.7216 3.9188 11.6795 3.76268 11.702 3.59657C11.7243 3.43059 11.8086 3.29425 11.9549 3.18753L13.3592 2.13236C13.5054 2.02565 13.6615 1.98346 13.8275 2.0058C13.9935 2.02828 14.1299 2.11259 14.2368 2.25872C14.3435 2.40499 14.3856 2.56111 14.3631 2.72708C14.3408 2.89319 14.2565 3.02961 14.1102 3.13632ZM2.35389 10.1674L1.50521 10.1674C1.09 10.1674 0.735364 10.0203 0.441302 9.72608C0.147101 9.43202 0 9.07738 0 8.66217L0 7.38115C0 6.96593 0.147101 6.6113 0.441302 6.31723C0.735364 6.02303 1.09 5.87593 1.50521 5.87593L4.7238 5.87593L7.31291 4.32763C7.56381 4.17706 7.8168 4.17574 8.07186 4.32368C8.32707 4.47147 8.45467 4.68893 8.45467 4.97605L8.45467 11.0673C8.45467 11.3544 8.32707 11.5718 8.07186 11.7196C7.8168 11.8676 7.56381 11.8663 7.31291 11.7157L4.7238 10.1674L3.60285 10.1674L3.60285 12.7933C3.60285 12.9705 3.54304 13.1189 3.42342 13.2384C3.30393 13.358 3.15558 13.4178 2.97837 13.4178C2.80115 13.4178 2.6528 13.358 2.53332 13.2384C2.4137 13.1189 2.35389 12.9705 2.35389 12.7933L2.35389 10.1674ZM7.2057 10.1738L7.2057 5.86948L5.06955 7.1249L1.50521 7.1249C1.44124 7.1249 1.38254 7.15161 1.32911 7.20504C1.27568 7.25847 1.24897 7.31717 1.24897 7.38115L1.24897 8.66217C1.24897 8.72614 1.27568 8.78485 1.32911 8.83827C1.38254 8.8917 1.44124 8.91842 1.50521 8.91842L5.06955 8.91842L7.2057 10.1738ZM9.60747 10.6189L9.60747 5.42443C9.93414 5.72016 10.1973 6.0927 10.3968 6.54205C10.5965 6.99154 10.6964 7.48474 10.6964 8.02166C10.6964 8.55857 10.5965 9.05178 10.3968 9.50127C10.1973 9.95062 9.93414 10.3232 9.60747 10.6189Z',
  fill: props.fill ?? ColoursObj.core.primary
})), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
  id: 'clip0_9681_7669'
}, /*#__PURE__*/createElement("rect", {
  width: '16',
  height: '16',
  fill: 'white'
}))))));

const Push_Pin = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm16.48 11.505 2 2v2.665h-5.155v5.943L12 23.438l-1.325-1.325V16.17H5.52v-2.665l2-2V4.873h-1v-2.65h10.96v2.65h-1v6.632ZM9.26 13.52h5.48l-.91-.91V4.873h-3.66v7.737l-.91.91Z'
}))));

const Qr_Code = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M13.158 21v-2.032h2.031V21h-2.031Zm-2.032-2.032v-4.936h2.032v4.936h-2.032Zm7.744-3.004V12H20.9v3.964H18.87ZM16.838 12V9.968h2.032V12h-2.032ZM5.032 14.032V12h2.031v2.032H5.032ZM3 12V9.968h2.032V12H3Zm9-6.968V3h2.032v2.032H12Zm-7.307 2.37h2.708V4.692H4.693v2.708Zm-.535 1.693c-.322 0-.595-.113-.82-.338A1.117 1.117 0 0 1 3 7.937v-3.78c0-.32.113-.594.338-.82.225-.224.498-.337.82-.337h3.779c.322 0 .595.113.82.338.225.225.338.498.338.82v3.779c0 .322-.113.595-.338.82a1.117 1.117 0 0 1-.82.338h-3.78Zm.535 10.211h2.708V16.6H4.693v2.707ZM4.158 21c-.322 0-.595-.113-.82-.338a1.117 1.117 0 0 1-.338-.82v-3.779c0-.322.113-.595.338-.82.225-.225.498-.338.82-.338h3.779c.322 0 .595.113.82.338.225.225.338.498.338.82v3.78c0 .32-.113.594-.338.82a1.117 1.117 0 0 1-.82.337h-3.78Zm12.44-13.599h2.709V4.693h-2.708v2.708Zm-.535 1.694c-.322 0-.595-.113-.82-.338a1.117 1.117 0 0 1-.338-.82v-3.78c0-.32.113-.594.338-.82.225-.224.498-.337.82-.337h3.78c.32 0 .594.113.82.338.224.225.337.498.337.82v3.779c0 .322-.113.595-.338.82a1.117 1.117 0 0 1-.82.338h-3.779ZM17.036 21v-3.004H15.09v-2.032h3.78v3.004H20.9V21h-3.865Zm-3.878-6.968V12h3.68v2.032h-3.68Zm-4.063 0V12H7.063V9.968h6.095V12h-2.032v2.032H9.095Zm.873-4.937V5.032H12v2.13h2.032v1.933H9.968ZM5.435 6.659V5.435H6.66V6.66H5.435Zm0 11.906V17.34H6.66v1.225H5.435ZM17.34 6.659V5.435h1.225V6.66H17.34Z'
}))));

const Redo = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M10.139 19c-1.678 0-3.12-.55-4.328-1.65C4.604 16.252 4 14.889 4 13.262c0-1.627.604-2.99 1.811-4.09 1.207-1.1 2.65-1.649 4.328-1.649h5.446l-1.33-1.329a1.239 1.239 0 0 1-.369-.912c0-.363.123-.667.369-.913A1.24 1.24 0 0 1 15.168 4c.363 0 .667.123.913.368l3.55 3.547c.127.127.22.268.28.425a1.359 1.359 0 0 1 0 .975c-.06.157-.153.299-.28.425l-3.55 3.547a1.24 1.24 0 0 1-.913.368 1.24 1.24 0 0 1-.913-.368 1.239 1.239 0 0 1-.369-.913c0-.362.123-.666.369-.912l1.33-1.329h-5.446c-.952 0-1.778.296-2.477.888-.7.592-1.049 1.338-1.049 2.24 0 .902.35 1.649 1.05 2.24.698.592 1.524.888 2.476.888h6.015c.363 0 .672.127.926.38.254.255.38.563.38.926 0 .362-.126.67-.38.924a1.26 1.26 0 0 1-.926.381H10.14Z'
}))));

const Refresh = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12 21a7.829 7.829 0 0 0 3.12-.625 8.097 8.097 0 0 0 2.539-1.698 8.026 8.026 0 0 0 1.71-2.519c.421-.964.631-1.992.631-3.084 0-.308-.108-.57-.326-.784a1.081 1.081 0 0 0-.79-.324c-.31 0-.574.108-.791.324a1.064 1.064 0 0 0-.326.784c0 1.591-.56 2.94-1.68 4.048-1.122 1.108-2.484 1.663-4.087 1.663-1.603 0-2.965-.556-4.086-1.668-1.12-1.112-1.681-2.464-1.681-4.055 0-1.59.562-2.94 1.687-4.048s2.489-1.662 4.092-1.662h.138l-.561.557a.87.87 0 0 0-.272.65c.003.25.094.467.272.65a.934.934 0 0 0 .672.28.903.903 0 0 0 .671-.27l2.206-2.189c.224-.222.336-.484.336-.786 0-.301-.112-.564-.336-.786L12.932 3.27a.903.903 0 0 0-.671-.27.915.915 0 0 0-.672.29.902.902 0 0 0-.266.657c0 .254.093.473.278.656l.537.533h-.126a7.829 7.829 0 0 0-3.12.626A8.17 8.17 0 0 0 6.347 7.46 7.997 7.997 0 0 0 4.63 9.972c-.42.96-.63 1.99-.63 3.09 0 1.1.21 2.133.63 3.096.42.964.99 1.804 1.711 2.519a8.097 8.097 0 0 0 2.539 1.698A7.829 7.829 0 0 0 12 21Z'
}))));

const Reports = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.138 21c-.316 0-.585-.122-.806-.367a1.281 1.281 0 0 1-.332-.89c0-.35.11-.647.332-.892.221-.244.49-.367.806-.367h15.724c.316 0 .585.123.806.367.221.245.332.542.332.891 0 .35-.11.647-.332.891-.221.245-.49.367-.806.367H4.138Zm1.288-3.733c-.435 0-.805-.169-1.11-.506a1.764 1.764 0 0 1-.457-1.227v-3.207c0-.481.152-.89.457-1.227a1.442 1.442 0 0 1 1.11-.505c.435 0 .805.168 1.11.505.305.337.457.746.457 1.227v3.207c0 .481-.152.89-.457 1.227a1.442 1.442 0 0 1-1.11.506Zm4.379 0c-.436 0-.806-.169-1.11-.506a1.764 1.764 0 0 1-.458-1.227V7.58c0-.48.153-.89.457-1.227a1.442 1.442 0 0 1 1.11-.505c.436 0 .806.168 1.11.505.306.337.458.746.458 1.227v7.954c0 .481-.152.89-.457 1.227a1.442 1.442 0 0 1-1.11.506Zm4.378 0c-.435 0-.805-.169-1.11-.506a1.764 1.764 0 0 1-.457-1.227v-5.106c0-.48.152-.89.457-1.227a1.442 1.442 0 0 1 1.11-.505c.436 0 .806.168 1.11.505.305.337.458.746.458 1.227v5.106c0 .481-.153.89-.458 1.227a1.442 1.442 0 0 1-1.11.506Zm4.391 0c-.435 0-.805-.169-1.11-.506a1.764 1.764 0 0 1-.457-1.227V4.733c0-.482.152-.89.457-1.228A1.442 1.442 0 0 1 18.574 3c.435 0 .805.168 1.11.505.305.337.457.746.457 1.228v10.801c0 .481-.152.89-.457 1.227a1.442 1.442 0 0 1-1.11.506Z'
}))));

const Right = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M13.269 17.602a1.283 1.283 0 0 1-.368-.96 1.37 1.37 0 0 1 .392-.96l2.27-2.339H5.307c-.363 0-.672-.13-.926-.393A1.32 1.32 0 0 1 4 11.996c0-.374.127-.692.381-.954.254-.261.563-.392.926-.392h10.256L13.27 8.285a1.31 1.31 0 0 1-.38-.947c0-.37.127-.686.38-.947A1.24 1.24 0 0 1 14.194 6c.364 0 .673.13.926.391l4.511 4.664c.127.13.22.277.28.438a1.441 1.441 0 0 1 0 1.007c-.06.161-.153.307-.28.438l-4.536 4.689a1.192 1.192 0 0 1-.908.373 1.257 1.257 0 0 1-.918-.398Z'
}))));

const Room_Leave = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M4 21C3.71667 21 3.47917 20.9042 3.2875 20.7125C3.09583 20.5208 3 20.2833 3 20C3 19.7167 3.09583 19.4792 3.2875 19.2875C3.47917 19.0958 3.71667 19 4 19H5V4C5 3.71667 5.09583 3.47917 5.2875 3.2875C5.47917 3.09583 5.71667 3 6 3H14C14.2833 3 14.5208 3.09583 14.7125 3.2875C14.9042 3.47917 15 3.71667 15 4H18C18.2833 4 18.5208 4.09583 18.7125 4.2875C18.9042 4.47917 19 4.71667 19 5V19H20C20.2833 19 20.5208 19.0958 20.7125 19.2875C20.9042 19.4792 21 19.7167 21 20C21 20.2833 20.9042 20.5208 20.7125 20.7125C20.5208 20.9042 20.2833 21 20 21H18C17.7167 21 17.4792 20.9042 17.2875 20.7125C17.0958 20.5208 17 20.2833 17 20V6H15V20C15 20.2833 14.9042 20.5208 14.7125 20.7125C14.5208 20.9042 14.2833 21 14 21H4ZM12 12C12 11.7167 11.9042 11.4792 11.7125 11.2875C11.5208 11.0958 11.2833 11 11 11C10.7167 11 10.4792 11.0958 10.2875 11.2875C10.0958 11.4792 10 11.7167 10 12C10 12.2833 10.0958 12.5208 10.2875 12.7125C10.4792 12.9042 10.7167 13 11 13C11.2833 13 11.5208 12.9042 11.7125 12.7125C11.9042 12.5208 12 12.2833 12 12ZM7 19H13V5H7V19Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Room_Type = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M7.799 15.188H16.2v.462c0 .238.081.436.243.592.163.156.36.234.596.234a.79.79 0 0 0 .588-.243.82.82 0 0 0 .238-.596v-2.654c0-.3-.058-.582-.172-.846a2.22 2.22 0 0 0-.473-.695v-2.2c0-.473-.168-.877-.504-1.213a1.654 1.654 0 0 0-1.213-.505h-2.645a1.52 1.52 0 0 0-.859.258 1.52 1.52 0 0 0-.859-.258H8.496c-.472 0-.877.168-1.213.505-.336.336-.505.74-.505 1.213v2.2c-.2.2-.357.433-.472.697a2.114 2.114 0 0 0-.172.849v2.662c0 .238.081.436.244.592.162.156.36.234.595.234a.79.79 0 0 0 .589-.243.82.82 0 0 0 .237-.596v-.45Zm0-1.652v-.677a.83.83 0 0 1 .247-.612.83.83 0 0 1 .611-.247h6.685c.244 0 .448.082.612.247a.83.83 0 0 1 .247.612v.677H7.8Zm.644-2.824V9.176h2.913v1.536H8.443Zm4.201 0V9.176h2.913v1.536h-2.913ZM5.276 21c-.634 0-1.172-.22-1.614-.662A2.196 2.196 0 0 1 3 18.724V5.276c0-.634.22-1.172.662-1.614.442-.441.98-.662 1.614-.662h13.448c.634 0 1.172.22 1.614.662.441.442.662.98.662 1.614v13.448c0 .634-.22 1.172-.662 1.614-.442.441-.98.662-1.614.662H5.276Zm0-2.276h13.448V5.276H5.276v13.448Z'
}))));

const Route = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M9 21C7.9 21 6.95833 20.6083 6.175 19.825C5.39167 19.0417 5 18.1 5 17V8.825C4.41667 8.60833 3.9375 8.24583 3.5625 7.7375C3.1875 7.22917 3 6.65 3 6C3 5.16667 3.29167 4.45833 3.875 3.875C4.45833 3.29167 5.16667 3 6 3C6.83333 3 7.54167 3.29167 8.125 3.875C8.70833 4.45833 9 5.16667 9 6C9 6.65 8.8125 7.22917 8.4375 7.7375C8.0625 8.24583 7.58333 8.60833 7 8.825V17C7 17.55 7.19583 18.0208 7.5875 18.4125C7.97917 18.8042 8.45 19 9 19C9.55 19 10.0208 18.8042 10.4125 18.4125C10.8042 18.0208 11 17.55 11 17V7C11 5.9 11.3917 4.95833 12.175 4.175C12.9583 3.39167 13.9 3 15 3C16.1 3 17.0417 3.39167 17.825 4.175C18.6083 4.95833 19 5.9 19 7V15.175C19.5833 15.3917 20.0625 15.7542 20.4375 16.2625C20.8125 16.7708 21 17.35 21 18C21 18.8333 20.7083 19.5417 20.125 20.125C19.5417 20.7083 18.8333 21 18 21C17.1667 21 16.4583 20.7083 15.875 20.125C15.2917 19.5417 15 18.8333 15 18C15 17.35 15.1875 16.7667 15.5625 16.25C15.9375 15.7333 16.4167 15.375 17 15.175V7C17 6.45 16.8042 5.97917 16.4125 5.5875C16.0208 5.19583 15.55 5 15 5C14.45 5 13.9792 5.19583 13.5875 5.5875C13.1958 5.97917 13 6.45 13 7V17C13 18.1 12.6083 19.0417 11.825 19.825C11.0417 20.6083 10.1 21 9 21ZM6 7C6.28333 7 6.52083 6.90417 6.7125 6.7125C6.90417 6.52083 7 6.28333 7 6C7 5.71667 6.90417 5.47917 6.7125 5.2875C6.52083 5.09583 6.28333 5 6 5C5.71667 5 5.47917 5.09583 5.2875 5.2875C5.09583 5.47917 5 5.71667 5 6C5 6.28333 5.09583 6.52083 5.2875 6.7125C5.47917 6.90417 5.71667 7 6 7ZM18 19C18.2833 19 18.5208 18.9042 18.7125 18.7125C18.9042 18.5208 19 18.2833 19 18C19 17.7167 18.9042 17.4792 18.7125 17.2875C18.5208 17.0958 18.2833 17 18 17C17.7167 17 17.4792 17.0958 17.2875 17.2875C17.0958 17.4792 17 17.7167 17 18C17 18.2833 17.0958 18.5208 17.2875 18.7125C17.4792 18.9042 17.7167 19 18 19Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Schedule = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12.068 21a8.85 8.85 0 0 1-3.529-.71 9.192 9.192 0 0 1-2.881-1.928 9.115 9.115 0 0 1-1.943-2.86A8.673 8.673 0 0 1 3 12c0-1.24.238-2.408.715-3.502a9.115 9.115 0 0 1 1.943-2.86A9.192 9.192 0 0 1 8.539 3.71 8.85 8.85 0 0 1 12.068 3c1.325 0 2.578.268 3.758.804A8.8 8.8 0 0 1 18.884 6.1v-.987c0-.296.103-.543.31-.743.205-.2.457-.3.755-.3s.548.1.749.3c.201.2.302.447.302.743v3.73c0 .35-.123.647-.37.892a1.227 1.227 0 0 1-.897.366h-3.758c-.299 0-.553-.104-.763-.313a1.027 1.027 0 0 1-.316-.757c0-.296.103-.546.31-.75.205-.204.457-.306.755-.306h1.187a6.565 6.565 0 0 0-2.266-1.814 6.35 6.35 0 0 0-2.814-.645c-1.82 0-3.364.629-4.632 1.887C6.168 8.661 5.535 10.193 5.535 12c0 1.806.633 3.339 1.901 4.597 1.268 1.258 2.812 1.887 4.632 1.887 1.433 0 2.713-.413 3.841-1.239a6.309 6.309 0 0 0 2.334-3.213c.107-.316.302-.557.586-.724.284-.167.593-.226.93-.176.352.05.635.202.848.458a.87.87 0 0 1 .184.847c-.525 1.919-1.593 3.492-3.202 4.72-1.61 1.229-3.45 1.843-5.521 1.843Zm1.05-9.38 2.27 2.24c.203.2.304.449.304.744 0 .296-.101.545-.304.745-.202.201-.453.302-.75.302-.299 0-.549-.1-.751-.302l-2.516-2.497a1.224 1.224 0 0 1-.368-.89V8.298c0-.296.103-.544.309-.744.206-.2.458-.3.756-.3s.547.1.749.3c.201.2.302.448.302.744v3.323Z'
}))));

const Search = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M18.7838 20.6324L13.413 15.2522C12.9316 15.6084 12.3743 15.8919 11.741 16.1028C11.1077 16.3136 10.4267 16.4191 9.69776 16.4191C7.83176 16.4191 6.24897 15.7681 4.94938 14.4663C3.64979 13.1644 3 11.5788 3 9.70954C3 7.84026 3.64979 6.25469 4.94938 4.95281C6.24897 3.65094 7.83176 3 9.69776 3C11.5637 3 13.1465 3.65094 14.4461 4.95281C15.7457 6.25469 16.3955 7.84026 16.3955 9.70954C16.3955 10.449 16.2903 11.1313 16.0798 11.7564C15.8693 12.3815 15.5863 12.9305 15.2307 13.4036L20.6399 18.8361C20.8845 19.0812 21.0045 19.3788 20.9999 19.7289C20.9952 20.0791 20.8671 20.3802 20.6153 20.6324C20.3707 20.8775 20.0654 21 19.6996 21C19.3337 21 19.0284 20.8775 18.7838 20.6324ZM9.69776 13.8139C10.8412 13.8139 11.81 13.4162 12.6039 12.6208C13.3979 11.8255 13.7949 10.855 13.7949 9.70954C13.7949 8.56404 13.3979 7.59361 12.6039 6.79825C11.81 6.00289 10.8412 5.60521 9.69776 5.60521C8.55427 5.60521 7.58554 6.00289 6.79158 6.79825C5.99762 7.59361 5.60063 8.56404 5.60063 9.70954C5.60063 10.855 5.99762 11.8255 6.79158 12.6208C7.58554 13.4162 8.55427 13.8139 9.69776 13.8139Z'
}))));

const Seat = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M8.514 19.624c-.7 0-1.295-.226-1.782-.679C6.244 18.492 6 17.941 6 17.291V8.857c0-.303.11-.556.33-.76.22-.205.494-.308.82-.308.322 0 .597.103.823.307.227.205.34.458.34.76v8.621h5.477c.322 0 .597.102.823.307.227.205.34.458.34.76 0 .3-.113.555-.34.765-.226.21-.5.315-.823.315H8.514ZM11.88 6.91c-.58 0-1.076-.191-1.488-.573-.411-.381-.617-.84-.617-1.375 0-.54.205-1.001.616-1.385.411-.384.905-.576 1.482-.576.585 0 1.08.191 1.488.574.407.383.61.844.61 1.381 0 .538-.203.998-.61 1.38-.408.383-.901.574-1.481.574ZM16.944 21c-.295 0-.543-.094-.743-.282a.92.92 0 0 1-.3-.698v-3.424H11.16a1.9 1.9 0 0 1-1.34-.517c-.372-.345-.558-.76-.558-1.244v-4.62c0-.674.254-1.247.762-1.719.508-.471 1.125-.707 1.851-.707.727 0 1.344.236 1.852.707.507.472.761 1.045.761 1.72v3.552h1.616a1.9 1.9 0 0 1 1.34.517c.371.345.557.76.557 1.244v4.49c0 .279-.101.511-.304.7a1.063 1.063 0 0 1-.752.281Z'
}))));

const Security = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.915 22c-.173 0-.334-.01-.483-.03a1.798 1.798 0 0 1-.413-.101c-2.083-.77-3.787-2.157-5.114-4.16-1.326-2.005-1.99-4.203-1.99-6.594v-4.45c0-.532.15-1.015.449-1.452.299-.437.692-.75 1.178-.941l5.5-2.11c.29-.108.582-.162.873-.162.292 0 .583.054.874.162l5.5 2.11c.486.19.879.504 1.178.94.299.438.448.921.448 1.452v4.451c0 2.391-.663 4.59-1.99 6.593-1.326 2.004-3.03 3.391-5.114 4.16a1.798 1.798 0 0 1-.412.103c-.15.02-.31.029-.484.029Zm0-2.517c1.463-.539 2.694-1.495 3.694-2.868a9.315 9.315 0 0 0 1.76-4.629h-5.454V4.555l-5.5 2.11v4.886c0 .13.016.276.047.435h5.453v7.497Z'
}))));

const Send = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  stroke: '#10375C',
  strokeWidth: 0.5,
  d: 'm15.365 19.732 5.627-14.7c.16-.408.258-.794.258-1.13 0-.33-.103-.625-.315-.837-.212-.212-.506-.315-.837-.315-.336 0-.722.098-1.13.257L4.19 8.67c-.733.28-1.441.775-1.441 1.574 0 .474.187.81.5 1.053.295.229.693.368 1.104.492h.002l6.072 1.784 1.766 5.995c.128.431.27.848.498 1.156.243.327.582.527 1.065.527.792 0 1.287-.685 1.608-1.518Zm1.386-13.756-5.805 5.805-5.522-1.688 11.35-4.299h.001c.096-.036.192-.074.288-.113-.111.1-.216.2-.312.295Zm-2.844 12.6-1.688-5.522 5.804-5.805-.176-.176.176.176a8.82 8.82 0 0 0 .294-.31c-.039.096-.076.19-.111.286v.001l-4.299 11.35Z'
}))));

const Settings = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M13.735 21h-3.483c-.285 0-.538-.096-.761-.288a1.1 1.1 0 0 1-.39-.706l-.25-1.887a2.324 2.324 0 0 1-.357-.173 7.769 7.769 0 0 1-.338-.213l-1.794.736a1.233 1.233 0 0 1-.824.028 1.102 1.102 0 0 1-.63-.505l-1.745-2.975a1.097 1.097 0 0 1-.14-.802c.056-.283.2-.51.434-.679L5 12.386a2.072 2.072 0 0 1-.01-.193v-.386c0-.06.004-.125.01-.193l-1.543-1.15a1.115 1.115 0 0 1-.434-.692 1.06 1.06 0 0 1 .14-.789l1.745-2.976c.143-.248.354-.414.632-.497.277-.082.551-.071.822.033l1.818.736c.111-.074.222-.143.33-.207.11-.063.223-.119.34-.166l.251-1.912c.038-.287.165-.525.384-.713A1.14 1.14 0 0 1 10.252 3h3.483c.294 0 .55.094.768.281.218.188.346.426.383.713l.25 1.912c.125.047.244.103.358.166.114.064.227.133.338.207l1.794-.736c.27-.104.543-.113.817-.028.275.086.487.25.637.492l1.757 2.976c.15.251.196.518.14.802-.056.283-.205.51-.446.679l-1.556 1.15c.006.068.01.133.01.193V12c0 .068-.002.132-.007.193-.004.06-.012.125-.025.193l1.556 1.15c.233.17.378.396.434.68.056.283.01.55-.14.8l-1.758 2.967c-.15.251-.361.42-.635.51-.273.088-.55.08-.828-.023l-1.775-.737c-.11.074-.221.145-.33.213-.11.068-.223.125-.34.173l-.25 1.887a1.11 1.11 0 0 1-.384.706 1.127 1.127 0 0 1-.768.288Zm-1.734-5.994c.846 0 1.569-.294 2.168-.88A2.868 2.868 0 0 0 15.066 12c0-.83-.299-1.539-.898-2.125a2.984 2.984 0 0 0-2.167-.88c-.854 0-1.578.293-2.173.88A2.875 2.875 0 0 0 8.935 12c0 .83.297 1.539.893 2.125.595.587 1.32.88 2.173.88Zm0-1.718a1.28 1.28 0 0 1-.931-.376 1.23 1.23 0 0 1-.383-.912c0-.358.127-.662.383-.912a1.28 1.28 0 0 1 .93-.376c.366 0 .676.125.931.376.256.25.383.554.383.912s-.127.662-.383.912a1.28 1.28 0 0 1-.93.376Zm-.747 5.436h1.445l.32-2.251c.46-.115.894-.285 1.302-.51a4.363 4.363 0 0 0 1.093-.86l2.156.88.705-1.242-1.846-1.37A4.219 4.219 0 0 0 16.651 12a4.356 4.356 0 0 0-.222-1.37L18.3 9.259l-.73-1.242-2.144.902a4.492 4.492 0 0 0-1.093-.881 4.725 4.725 0 0 0-1.315-.51l-.284-2.252h-1.47l-.282 2.239a4.784 4.784 0 0 0-2.445 1.382l-2.131-.88-.718 1.242 1.834 1.337A4.399 4.399 0 0 0 7.3 12c0 .237.018.471.056.702.037.23.093.462.166.693L5.688 14.74l.718 1.242 2.13-.89c.33.346.703.635 1.118.87.416.233.859.408 1.328.522l.272 2.24Z'
}))));

const Share = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12 15.775c-.357 0-.66-.115-.91-.346a1.104 1.104 0 0 1-.374-.841V6.023l-.667.617a1.233 1.233 0 0 1-.885.33 1.298 1.298 0 0 1-.896-.352 1.118 1.118 0 0 1-.363-.842c0-.33.121-.608.363-.831l2.834-2.622c.118-.109.255-.19.413-.243a1.505 1.505 0 0 1 .97 0c.158.053.295.134.413.243l2.848 2.634c.258.239.382.52.373.847-.01.325-.138.6-.386.824-.25.223-.55.335-.903.335-.354 0-.651-.112-.893-.335l-.653-.605v8.565c0 .33-.125.61-.374.841-.25.23-.553.346-.91.346ZM6.568 22c-.715 0-1.322-.23-1.82-.691C4.248 20.848 4 20.286 4 19.624v-8.771c0-.662.25-1.224.747-1.685.499-.46 1.106-.691 1.821-.691h1.09c.356 0 .632.115.827.346.195.231.292.512.292.842 0 .33-.097.61-.292.841-.195.231-.47.347-.827.347h-1.09v8.771h10.864v-8.771h-1.09c-.356 0-.632-.116-.827-.347a1.261 1.261 0 0 1-.292-.841c0-.33.097-.61.292-.842.195-.23.47-.346.827-.346h1.09c.715 0 1.322.23 1.82.691.499.461.748 1.023.748 1.685v8.771c0 .662-.25 1.224-.747 1.685-.499.46-1.106.691-1.821.691H6.568Z'
}))));

const Share_Location = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M14.175 21.775a.863.863 0 0 1-.788-.188c-.225-.191-.337-.454-.337-.787 0-.233.079-.446.237-.637.158-.192.354-.321.588-.388.416-.1.82-.23 1.212-.387.392-.159.77-.355 1.138-.588.216-.133.454-.188.712-.163.258.026.47.121.638.288.233.233.337.5.312.8a.876.876 0 0 1-.437.7 9.284 9.284 0 0 1-1.588.825c-.542.217-1.104.392-1.687.525ZM19 17.5a.995.995 0 0 1-.288-.625c-.025-.25.03-.475.163-.675.216-.367.408-.742.575-1.125.166-.383.3-.792.4-1.225a1.2 1.2 0 0 1 .4-.6c.2-.167.416-.25.65-.25.333 0 .595.117.787.35.192.233.246.5.163.8-.134.6-.313 1.17-.538 1.713a8.327 8.327 0 0 1-.837 1.537.881.881 0 0 1-.688.413c-.292.024-.554-.08-.787-.313Zm1.875-6.5a.949.949 0 0 1-.638-.25 1.23 1.23 0 0 1-.387-.6 7.405 7.405 0 0 0-.4-1.237 8.237 8.237 0 0 0-.575-1.113 1.001 1.001 0 0 1-.163-.675A.995.995 0 0 1 19 6.5c.233-.233.495-.342.787-.325.292.017.52.15.688.4a8.55 8.55 0 0 1 .85 1.563c.233.558.416 1.129.55 1.712.066.3 0 .567-.2.8-.2.233-.467.35-.8.35ZM9.95 21.75c-2.284-.533-4.163-1.7-5.638-3.5C2.837 16.45 2.1 14.367 2.1 12c0-2.383.733-4.483 2.2-6.3C5.766 3.883 7.64 2.725 9.925 2.225a.863.863 0 0 1 .787.188.952.952 0 0 1 .338.762c0 .233-.08.446-.238.638-.158.191-.354.32-.587.387-1.784.433-3.25 1.375-4.4 2.825C4.675 8.475 4.1 10.133 4.1 12c0 1.867.575 3.512 1.725 4.938 1.15 1.425 2.616 2.37 4.4 2.837.233.067.429.2.587.4.158.2.238.417.238.65 0 .317-.109.567-.325.75-.217.183-.475.242-.775.175ZM16.3 5.225a9.855 9.855 0 0 0-1.175-.612A7.303 7.303 0 0 0 13.9 4.2a1.231 1.231 0 0 1-.6-.387.949.949 0 0 1-.25-.638c0-.317.112-.57.337-.762a.863.863 0 0 1 .788-.188c.583.133 1.15.308 1.7.525.55.217 1.083.492 1.6.825.266.167.412.4.437.7.025.3-.08.567-.312.8-.167.167-.371.267-.613.3a1.013 1.013 0 0 1-.687-.15ZM12.075 16.65c-.134 0-.263-.02-.388-.063a.783.783 0 0 1-.312-.187c-1.1-1.017-1.925-1.967-2.475-2.85s-.825-1.7-.825-2.45c0-1.167.379-2.142 1.137-2.925C9.97 7.392 10.925 7 12.075 7s2.104.392 2.862 1.175 1.138 1.758 1.138 2.925c0 .75-.275 1.567-.825 2.45-.55.883-1.375 1.833-2.475 2.85a.783.783 0 0 1-.313.188 1.217 1.217 0 0 1-.387.062Zm0-4.65c.3 0 .554-.104.762-.313.208-.208.313-.462.313-.762s-.105-.554-.313-.763a1.037 1.037 0 0 0-.762-.312c-.3 0-.555.104-.763.313a1.038 1.038 0 0 0-.312.762c0 .3.104.554.312.762.208.209.463.313.763.313Z'
}))));

const Sidebar_Left = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V6H4V18Z',
  fill: '#0A1F41'
}), /*#__PURE__*/createElement("rect", {
  x: '9',
  y: '6',
  width: '2',
  height: '12',
  fill: props.fill ?? ColoursObj.core.primary
}), /*#__PURE__*/createElement("rect", {
  x: '8',
  y: '7',
  width: '2',
  height: '3',
  rx: '1',
  transform: 'rotate(90 8 7)',
  fill: props.fill ?? ColoursObj.core.primary
}), /*#__PURE__*/createElement("rect", {
  x: '8',
  y: '10',
  width: '2',
  height: '3',
  rx: '1',
  transform: 'rotate(90 8 10)',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Sidebar_Right = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V6H4V18Z',
  fill: props.fill ?? ColoursObj.core.primary
}), /*#__PURE__*/createElement("rect", {
  x: '13',
  y: '6',
  width: '2',
  height: '12',
  fill: props.fill ?? ColoursObj.core.primary
}), /*#__PURE__*/createElement("rect", {
  x: '19',
  y: '7',
  width: '2',
  height: '3',
  rx: '1',
  transform: 'rotate(90 19 7)',
  fill: props.fill ?? ColoursObj.core.primary
}), /*#__PURE__*/createElement("rect", {
  x: '19',
  y: '10',
  width: '2',
  height: '3',
  rx: '1',
  transform: 'rotate(90 19 10)',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Sort = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M13.69 17.633v-5.235c0-.358.13-.661.391-.91.261-.25.578-.376.95-.376.374 0 .69.125.951.375s.392.553.392.91v5.236l1.34-1.284a1.35 1.35 0 0 1 .94-.375c.374-.008.69.117.95.375.26.242.392.54.396.893.004.354-.125.655-.384.903l-3.646 3.492a1.24 1.24 0 0 1-.437.275 1.454 1.454 0 0 1-1.002 0 1.241 1.241 0 0 1-.437-.275l-3.646-3.492a1.157 1.157 0 0 1-.371-.886c.004-.349.137-.652.396-.91.26-.242.573-.364.938-.368.366-.004.678.12.938.368l1.341 1.284ZM7.614 6.367 6.273 7.65c-.277.265-.598.39-.963.373a1.359 1.359 0 0 1-.913-.373A1.23 1.23 0 0 1 4 6.748c-.005-.354.12-.652.372-.893l3.646-3.492a1.24 1.24 0 0 1 .436-.275 1.453 1.453 0 0 1 1.003 0c.161.059.306.15.436.275l3.646 3.492c.243.232.365.532.365.898s-.122.665-.365.898c-.27.249-.588.373-.957.373-.37 0-.684-.124-.944-.373l-1.34-1.284v5.235c0 .358-.131.661-.392.91-.26.25-.578.376-.95.376-.373 0-.69-.125-.951-.375a1.213 1.213 0 0 1-.391-.91V6.366Z'
}))));

const Sort_Down = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M9.552 7.603h4.885l-2.442-2.718-2.443 2.718Zm-3.175.13 4.766-5.348c.126-.142.26-.241.403-.299.142-.057.292-.086.449-.086.157 0 .307.029.449.086.142.058.276.157.403.299l4.779 5.347c.387.433.473.927.26 1.484-.213.556-.591.834-1.135.834H7.239c-.544 0-.92-.278-1.13-.834-.208-.557-.119-1.051.268-1.484Zm0 8.52c-.387-.433-.476-.927-.267-1.483.208-.556.585-.835 1.129-.835h9.512c.544 0 .92.279 1.129.835.209.556.12 1.05-.267 1.483l-4.766 5.348a1.187 1.187 0 0 1-.403.306 1.106 1.106 0 0 1-.45.093c-.156 0-.306-.031-.448-.093a1.187 1.187 0 0 1-.403-.306l-4.766-5.348Z'
}))));

const Sort_Up = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm9.552 16.382 2.443 2.718 2.442-2.718H9.552Zm-3.175-.129c-.387-.433-.476-.927-.267-1.483.208-.556.585-.835 1.129-.835h9.512c.544 0 .92.279 1.129.835.209.556.12 1.05-.267 1.483l-4.766 5.348a1.187 1.187 0 0 1-.403.306 1.106 1.106 0 0 1-.45.093c-.156 0-.306-.031-.448-.093a1.187 1.187 0 0 1-.403-.306l-4.766-5.348Zm0-8.52 4.766-5.348c.126-.142.26-.241.403-.299.142-.057.292-.086.449-.086.157 0 .307.029.449.086.142.058.276.157.403.299l4.779 5.347c.387.433.473.927.26 1.484-.213.556-.591.834-1.135.834H7.239c-.544 0-.92-.278-1.13-.834-.208-.557-.119-1.051.268-1.484Z'
}))));

const Stand = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 -960 960 960',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M201-120q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518v318q0 33-23.5 56.5T761-120H201Zm368-440q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z'
}))));

const Stays = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M3.264 19c-.351 0-.65-.12-.895-.362A1.184 1.184 0 0 1 2 17.76v-4.824c0-.457.087-.878.262-1.266.175-.387.406-.705.692-.954v-2.46c0-.894.326-1.66.977-2.298A3.229 3.229 0 0 1 6.275 5h3.817c.348 0 .683.06 1.005.179.323.12.624.278.903.477.28-.199.58-.358.903-.477.322-.12.657-.179 1.005-.179h3.817c.912 0 1.693.32 2.344.958.651.638.977 1.404.977 2.299v2.46c.286.248.517.566.692.953.175.388.262.81.262 1.266v4.824c0 .345-.123.637-.369.878a1.231 1.231 0 0 1-.895.362c-.352 0-.65-.12-.896-.362a1.184 1.184 0 0 1-.369-.878v-.632H4.53v.632c0 .345-.123.637-.37.878a1.231 1.231 0 0 1-.895.362Zm9.69-8.871h5.563V8.257a.744.744 0 0 0-.227-.554.776.776 0 0 0-.565-.223h-3.979a.774.774 0 0 0-.792.777v1.872Zm-7.471 0h5.563V8.257a.744.744 0 0 0-.228-.554.776.776 0 0 0-.564-.223H6.275a.775.775 0 0 0-.792.777v1.872Zm-.954 4.52H19.47v-1.872a.744.744 0 0 0-.227-.554.776.776 0 0 0-.565-.223H5.321a.775.775 0 0 0-.792.777v1.872Z'
}))));

const Subtract = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.447 13.894c-.402 0-.744-.14-1.025-.422A1.395 1.395 0 0 1 4 12.447c0-.402.14-.744.422-1.025A1.396 1.396 0 0 1 5.447 11h13.106c.402 0 .744.14 1.025.422.281.281.422.623.422 1.025 0 .402-.14.744-.422 1.025a1.396 1.396 0 0 1-1.025.422H5.447Z'
}))));

const Subway = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.633 21.833a.7.7 0 0 1-.523-.235.77.77 0 0 1-.223-.548c0-.12.032-.25.096-.392a.675.675 0 0 1 .256-.31l1.063-.746c-.937-.13-1.721-.595-2.354-1.393A4.312 4.312 0 0 1 4 15.454V6.265c0-1.527.645-2.647 1.936-3.361 1.29-.714 3.31-1.071 6.06-1.071 2.85 0 4.895.344 6.139 1.034C19.378 3.556 20 4.689 20 6.265v9.19a4.312 4.312 0 0 1-.948 2.754c-.633.798-1.417 1.263-2.354 1.393l1.063.747a.698.698 0 0 1 .256.3.92.92 0 0 1 .096.4.77.77 0 0 1-.223.55.701.701 0 0 1-.523.234H6.633ZM6.5 10.39h4.557V7.421H6.5v2.968Zm6.443 0H17.5V7.421h-4.557v2.968Zm-4.165 5.852c.393 0 .727-.145 1.003-.433.275-.289.412-.64.412-1.051 0-.412-.137-.763-.412-1.052a1.333 1.333 0 0 0-1.003-.432c-.393 0-.727.144-1.002.432a1.467 1.467 0 0 0-.413 1.052c0 .412.138.762.413 1.05.275.29.61.434 1.002.434Zm6.444 0c.393 0 .727-.145 1.002-.433.275-.289.413-.64.413-1.051 0-.412-.138-.763-.413-1.052a1.333 1.333 0 0 0-1.002-.432c-.393 0-.727.144-1.003.432a1.468 1.468 0 0 0-.412 1.052c0 .412.137.762.412 1.05.276.29.61.434 1.003.434Zm-7.094.905h7.744c.462 0 .849-.16 1.16-.48.312-.32.468-.724.468-1.213v-3.086h-11v3.085c0 .49.156.894.467 1.214.312.32.7.48 1.161.48ZM12 4.454c-1.352 0-2.472.083-3.36.248-.889.165-1.514.412-1.876.742H17.17c-.292-.34-.858-.589-1.697-.75-.84-.16-1.997-.24-3.473-.24Z'
}))));

const Suitcase = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M7.461 20.768a2.369 2.369 0 0 1-1.738-.724A2.374 2.374 0 0 1 5 18.304V7.986c0-.6.211-1.11.634-1.53a2.084 2.084 0 0 1 1.525-.632h1.648V3.232c0-.342.12-.633.359-.873S9.696 2 10.037 2h3.925c.342 0 .633.12.872.36.24.239.36.53.36.872v2.592h1.345c.677 0 1.256.241 1.738.724.482.482.723 1.062.723 1.74v10.016c0 .678-.241 1.258-.723 1.74a2.369 2.369 0 0 1-1.738.724c0 .342-.12.633-.36.873-.238.24-.529.359-.87.359-.343 0-.633-.12-.873-.36-.239-.239-.358-.53-.358-.872H9.922c0 .342-.12.633-.358.873-.24.24-.53.359-.872.359-.342 0-.633-.12-.872-.36-.24-.239-.359-.53-.359-.872Zm3.343-14.944h2.392V3.999h-2.392v1.825ZM7.46 18.304h9.078V8.288H7.46v10.016Zm.719-1.627c0 .254.088.47.263.645.175.175.39.263.644.263a.853.853 0 0 0 .637-.263.888.888 0 0 0 .256-.645V9.915a.894.894 0 0 0-.253-.645.85.85 0 0 0-.64-.263.875.875 0 0 0-.644.263.877.877 0 0 0-.263.645v6.762Zm2.927 0c0 .254.084.47.253.645a.85.85 0 0 0 .64.263.85.85 0 0 0 .64-.263.894.894 0 0 0 .253-.645V9.915a.894.894 0 0 0-.253-.645.85.85 0 0 0-.64-.263.85.85 0 0 0-.64.263.894.894 0 0 0-.253.645v6.762Zm2.913 0c0 .254.084.47.253.645a.85.85 0 0 0 .64.263.875.875 0 0 0 .644-.263.877.877 0 0 0 .263-.645V9.915a.876.876 0 0 0-.263-.645.875.875 0 0 0-.643-.263.854.854 0 0 0-.638.263.888.888 0 0 0-.256.645v6.762Z'
}))));

const Swap = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.367 13.69h5.235c.358 0 .661.13.91.391.25.261.376.578.376.95 0 .374-.125.69-.375.951s-.553.392-.91.392H6.366l1.284 1.34c.242.253.367.566.375.94.008.374-.117.69-.375.95a1.19 1.19 0 0 1-.893.396 1.187 1.187 0 0 1-.904-.384L2.363 15.97a1.24 1.24 0 0 1-.275-.437 1.454 1.454 0 0 1 0-1.002 1.24 1.24 0 0 1 .275-.437l3.491-3.646c.242-.252.538-.376.887-.371.349.004.652.137.91.396.242.26.364.573.368.938.003.366-.12.678-.368.938L6.367 13.69Zm11.266-6.076L16.35 6.273a1.264 1.264 0 0 1-.373-.963c.016-.366.14-.67.373-.913.249-.26.55-.392.904-.397.353-.005.65.12.892.372l3.492 3.646c.125.13.216.275.275.436a1.453 1.453 0 0 1 0 1.003c-.059.161-.15.306-.275.436l-3.492 3.646c-.232.243-.532.365-.898.365s-.665-.122-.898-.365a1.364 1.364 0 0 1-.373-.957c0-.37.124-.684.373-.944l1.284-1.34h-5.235c-.358 0-.661-.131-.91-.392a1.324 1.324 0 0 1-.376-.95c0-.373.125-.69.375-.951s.553-.391.91-.391h5.236Z'
}))));

const Sync = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M5.855 12.048c0 .67.145 1.327.435 1.97.29.643.738 1.245 1.344 1.807l.148.132v-.964c0-.3.116-.553.348-.756.231-.204.515-.305.85-.305.337 0 .618.101.845.305.227.203.34.455.34.756v3.727c0 .356-.139.658-.416.907A1.461 1.461 0 0 1 8.737 20H4.595c-.336 0-.617-.104-.844-.312a.996.996 0 0 1-.34-.763c0-.301.116-.553.348-.756.232-.204.516-.306.851-.306h1.262l-.233-.201c-.944-.795-1.62-1.681-2.028-2.658A7.619 7.619 0 0 1 3 12.048c0-1.604.474-3.06 1.422-4.37.949-1.308 2.21-2.297 3.787-2.966.323-.147.646-.135.97.037a1.293 1.293 0 0 1 .584 1.717c-.144.31-.383.547-.715.712a5.963 5.963 0 0 0-2.324 2.028 5 5 0 0 0-.869 2.842Zm12.29-.096c0-.67-.145-1.327-.435-1.97-.29-.643-.738-1.245-1.344-1.807l-.148-.132v.964a.975.975 0 0 1-.34.756 1.217 1.217 0 0 1-.844.305 1.23 1.23 0 0 1-.851-.312.987.987 0 0 1-.348-.763V5.28c0-.356.139-.658.416-.907A1.461 1.461 0 0 1 15.264 4h4.142c.336 0 .617.102.844.305.227.203.34.455.34.756a.996.996 0 0 1-.34.764 1.202 1.202 0 0 1-.844.311h-1.277l.233.202c.91.825 1.578 1.719 2.002 2.68.425.963.637 1.94.637 2.934 0 1.604-.474 3.06-1.422 4.37-.948 1.308-2.21 2.297-3.787 2.966a1.045 1.045 0 0 1-.97-.037 1.293 1.293 0 0 1-.584-1.717c.144-.31.383-.547.715-.712a5.963 5.963 0 0 0 2.324-2.028 5 5 0 0 0 .869-2.842Z'
}))));

const TagIcon = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  height: '24px',
  viewBox: '0 -960 960 960',
  width: '24px',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM513-160l286-286-353-354H160v286l353 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Zm220 160Z'
}))));

const Taxi = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.679 21c-.458 0-.853-.163-1.183-.49A1.588 1.588 0 0 1 3 19.34v-7.32l2.02-5.7c.131-.378.358-.68.68-.906a1.842 1.842 0 0 1 1.079-.337h2.266v-.833c0-.346.122-.64.367-.881a1.22 1.22 0 0 1 .89-.363h3.395c.35 0 .647.12.891.363.245.242.367.535.367.881v.833h2.266c.396 0 .755.112 1.078.337.323.226.55.528.68.907L21 12.02v7.32c0 .453-.165.843-.496 1.17-.33.327-.725.49-1.183.49-.485 0-.884-.161-1.196-.484a1.58 1.58 0 0 1-.47-1.136v-.258H6.346v.258c0 .435-.157.814-.47 1.136-.312.323-.711.484-1.196.484Zm1.623-10.778h11.396l-.93-2.657H7.232l-.93 2.657Zm1.507 5.553c.395 0 .731-.137 1.008-.41a1.35 1.35 0 0 0 .416-.998 1.35 1.35 0 0 0-.416-.998 1.381 1.381 0 0 0-1.008-.41c-.396 0-.732.137-1.01.41a1.35 1.35 0 0 0-.414.998c0 .391.138.724.415.997.277.274.613.411 1.009.411Zm8.383 0c.395 0 .731-.137 1.008-.41a1.35 1.35 0 0 0 .416-.998 1.35 1.35 0 0 0-.416-.998 1.381 1.381 0 0 0-1.008-.41c-.396 0-.732.137-1.01.41a1.35 1.35 0 0 0-.415.998c0 .391.139.724.416.997.277.274.613.411 1.009.411Zm-10.676.86h12.968v-4.536H5.516v4.535Z'
}))));

const Team_Code = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M7.62853 17.6286C6.07257 17.6286 4.74547 17.0795 3.64723 15.9813C2.549 14.883 1.99988 13.5559 1.99988 12C1.99988 10.444 2.549 9.1169 3.64723 8.01866C4.74547 6.92043 6.07257 6.37131 7.62853 6.37131C8.92411 6.37131 10.0271 6.72134 10.9375 7.4214C11.8479 8.12146 12.4944 8.97008 12.8771 9.96725H19.9672C20.5387 9.96725 21.0203 10.1632 21.4122 10.555C21.804 10.9469 21.9999 11.4285 21.9999 12C21.9999 12.541 21.8281 12.9924 21.4844 13.3542C21.1407 13.7159 20.7297 13.9297 20.2514 13.9956V15.4971C20.2514 16.052 20.0658 16.5131 19.6945 16.8802C19.3233 17.2474 18.8601 17.4309 18.3052 17.4309C17.7502 17.4309 17.2891 17.2474 16.922 16.8802C16.5549 16.5131 16.3713 16.052 16.3713 15.4971V14.0327H12.8771C12.4944 15.0298 11.8479 15.8785 10.9375 16.5785C10.0271 17.2786 8.92411 17.6286 7.62853 17.6286ZM7.62853 13.9338C8.16704 13.9338 8.62398 13.7441 8.99935 13.3646C9.37472 12.9851 9.56241 12.5302 9.56241 12C9.56241 11.4615 9.37472 11.0045 8.99935 10.6291C8.62398 10.2538 8.16704 10.0661 7.62853 10.0661C7.09827 10.0661 6.64339 10.2538 6.2639 10.6291C5.8844 11.0045 5.69466 11.4615 5.69466 12C5.69466 12.5302 5.8844 12.9851 6.2639 13.3646C6.64339 13.7441 7.09827 13.9338 7.62853 13.9338Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Team_Members = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM4.10674 16.0391C4.27847 16.2109 4.48705 16.2968 4.73247 16.2968H6.6607V15.0794C6.6607 14.7564 6.70153 14.4522 6.78317 14.1665C6.86482 13.8809 6.98969 13.6112 7.1578 13.3576C7.08115 13.348 7.00275 13.3407 6.92262 13.3359C6.84248 13.331 6.75711 13.3286 6.66652 13.3286C5.82885 13.3286 5.14987 13.4896 4.62955 13.8115C4.10927 14.1334 3.84912 14.5616 3.84912 15.096V15.4134C3.84912 15.6588 3.93499 15.8674 4.10674 16.0391ZM8.10674 16.0391C8.27848 16.2109 8.48706 16.2968 8.73247 16.2968H15.2672C15.5126 16.2968 15.7212 16.2109 15.893 16.0391C16.0647 15.8674 16.1506 15.6588 16.1506 15.4134V15.0794C16.1506 14.3124 15.7701 13.69 15.0091 13.2121C14.2482 12.7342 13.2451 12.4953 11.9999 12.4953C10.7607 12.4953 9.75915 12.7342 8.99514 13.2121C8.23113 13.69 7.84912 14.3124 7.84912 15.0794V15.4134C7.84912 15.6588 7.93499 15.8674 8.10674 16.0391ZM17.339 15.0794V16.2968H19.2672C19.5126 16.2968 19.7212 16.2109 19.893 16.0391C20.0647 15.8674 20.1506 15.6588 20.1506 15.4134V15.096C20.1506 14.5616 19.8904 14.1334 19.3702 13.8115C18.8499 13.4896 18.1709 13.3286 17.3332 13.3286C17.2426 13.3286 17.1572 13.331 17.0771 13.3359C16.997 13.3407 16.9186 13.348 16.8419 13.3576C17.0052 13.605 17.1289 13.8737 17.2129 14.1638C17.297 14.4539 17.339 14.7591 17.339 15.0794ZM10.5778 14.2707C11.0118 14.1455 11.4859 14.083 11.9999 14.083C12.5139 14.083 12.9867 14.1443 13.4183 14.267C13.85 14.3897 14.1472 14.5371 14.31 14.7091H9.68972C9.8477 14.5419 10.1437 14.3958 10.5778 14.2707ZM5.65419 12.2844C5.93101 12.5612 6.26845 12.6996 6.66652 12.6996C7.06459 12.6996 7.40203 12.5612 7.67884 12.2844C7.95565 12.0076 8.09405 11.6702 8.09405 11.2721C8.09405 10.874 7.95565 10.5366 7.67884 10.2598C7.40203 9.98296 7.06459 9.84456 6.66652 9.84456C6.26845 9.84456 5.93102 9.98296 5.6542 10.2598C5.37738 10.5366 5.23897 10.874 5.23897 11.2721C5.23897 11.6702 5.37738 12.0076 5.65419 12.2844ZM16.3209 12.2844C16.5977 12.5612 16.9351 12.6996 17.3332 12.6996C17.7313 12.6996 18.0687 12.5612 18.3455 12.2844C18.6223 12.0076 18.7607 11.6702 18.7607 11.2721C18.7607 10.874 18.6223 10.5366 18.3455 10.2598C18.0687 9.98296 17.7313 9.84456 17.3332 9.84456C16.9351 9.84456 16.5977 9.98296 16.3209 10.2598C16.0441 10.5366 15.9057 10.874 15.9057 11.2721C15.9057 11.6702 16.0441 12.0076 16.3209 12.2844ZM10.4749 11.3768C10.892 11.7954 11.3996 12.0047 11.9976 12.0047C12.5957 12.0047 13.104 11.7961 13.5226 11.379C13.9413 10.9618 14.1506 10.4542 14.1506 9.85619C14.1506 9.25816 13.942 8.74982 13.5249 8.33119C13.1077 7.91256 12.6001 7.70324 12.0021 7.70324C11.404 7.70324 10.8957 7.91182 10.4771 8.32897C10.0584 8.74613 9.84912 9.25373 9.84912 9.85176C9.84912 10.4498 10.0577 10.9581 10.4749 11.3768ZM11.5908 9.44658C11.6997 9.33654 11.8355 9.28153 11.9982 9.28153C12.1609 9.28153 12.2972 9.33599 12.4073 9.44493C12.5173 9.55386 12.5723 9.68966 12.5723 9.85232C12.5723 10.015 12.5178 10.1513 12.4089 10.2614C12.3 10.3714 12.1642 10.4264 12.0015 10.4264C11.8388 10.4264 11.7025 10.372 11.5925 10.263C11.4824 10.1541 11.4274 10.0183 11.4274 9.85564C11.4274 9.69298 11.4819 9.55662 11.5908 9.44658Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Tick = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M9.562 17.5c-.17 0-.334-.03-.493-.088a1.217 1.217 0 0 1-.429-.275l-4.28-4.18a1.182 1.182 0 0 1-.36-.912c.009-.366.137-.67.385-.912s.56-.364.936-.364.688.121.936.364l3.305 3.227 8.183-7.99c.248-.242.56-.365.934-.37.375-.004.691.119.949.37.248.243.372.55.372.92s-.124.676-.372.919l-9.144 8.928c-.128.124-.27.216-.429.275a1.404 1.404 0 0 1-.493.088Z'
}))));

const Ticket = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M4.529 20a2.454 2.454 0 0 1-1.793-.727A2.398 2.398 0 0 1 2 17.5v-3.258c0-.177.054-.326.163-.448a.712.712 0 0 1 .42-.228c.373-.108.687-.303.942-.584.256-.281.383-.611.383-.989 0-.377-.127-.707-.383-.988a1.908 1.908 0 0 0-.942-.57.71.71 0 0 1-.42-.232.642.642 0 0 1-.163-.44V6.5c0-.697.245-1.287.736-1.772A2.454 2.454 0 0 1 4.529 4H19.47c.705 0 1.303.242 1.793.728.49.485.736 1.075.736 1.772v3.277a.619.619 0 0 1-.163.436.72.72 0 0 1-.42.221c-.373.1-.687.29-.942.57-.256.282-.383.612-.383.99 0 .377.127.707.383.988.255.281.57.476.942.584.171.03.311.103.42.22a.619.619 0 0 1 .163.437V17.5c0 .697-.245 1.288-.736 1.773a2.454 2.454 0 0 1-1.793.727H4.53Zm0-2.5H19.47v-2.179a4.04 4.04 0 0 1-1.388-1.411 3.696 3.696 0 0 1-.52-1.915c0-.69.173-1.327.52-1.91a4.054 4.054 0 0 1 1.389-1.406v-2.18H4.528v2.18a3.87 3.87 0 0 1 1.402 1.408c.337.584.506 1.22.506 1.908s-.169 1.326-.506 1.913a3.858 3.858 0 0 1-1.402 1.413v2.18Zm7.478-.89c.293 0 .542-.101.747-.305a1 1 0 0 0 .308-.738c0-.29-.102-.536-.305-.739a1.029 1.029 0 0 0-.757-.305c-.288 0-.537.101-.747.302a.995.995 0 0 0-.315.748c0 .285.105.53.315.732.21.204.46.305.754.305Zm0-3.56c.293 0 .542-.104.747-.311.205-.208.308-.456.308-.746s-.102-.535-.305-.739A1.03 1.03 0 0 0 12 10.95c-.288 0-.537.1-.747.302a.995.995 0 0 0-.315.748c0 .285.105.531.315.739.21.207.46.311.754.311Zm0-3.573c.293 0 .542-.104.747-.312.205-.207.308-.456.308-.745a.983.983 0 0 0-.305-.732A1.041 1.041 0 0 0 12 7.39c-.288 0-.537.1-.747.298a.976.976 0 0 0-.315.739c0 .285.105.53.315.738.21.208.46.312.754.312Z'
}))));

const Time = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M13.04 11.56V8.807c0-.295-.099-.542-.298-.742-.2-.2-.447-.299-.742-.299s-.542.1-.742.3c-.199.199-.299.446-.299.74v3.135c0 .155.028.3.083.437.055.136.138.259.248.368l2.64 2.64a.983.983 0 0 0 .722.296c.284 0 .529-.099.734-.297a.978.978 0 0 0 .31-.734c0-.292-.104-.54-.31-.747l-2.345-2.346ZM12 21a8.786 8.786 0 0 1-3.519-.708 9.073 9.073 0 0 1-2.853-1.92 9.073 9.073 0 0 1-1.92-2.853A8.786 8.786 0 0 1 3 12c0-1.253.236-2.426.708-3.519a9.074 9.074 0 0 1 1.92-2.853 9.074 9.074 0 0 1 2.853-1.92A8.786 8.786 0 0 1 12 3c1.253 0 2.426.236 3.519.708a9.073 9.073 0 0 1 2.853 1.92 9.073 9.073 0 0 1 1.92 2.853A8.786 8.786 0 0 1 21 12a8.786 8.786 0 0 1-.708 3.519 9.073 9.073 0 0 1-1.92 2.853 9.073 9.073 0 0 1-2.853 1.92A8.786 8.786 0 0 1 12 21Zm0-2.276c1.863 0 3.45-.653 4.76-1.959 1.31-1.305 1.964-2.894 1.964-4.765 0-1.871-.655-3.46-1.964-4.766C15.45 5.93 13.863 5.276 12 5.276s-3.45.653-4.76 1.958C5.93 8.54 5.277 10.13 5.277 12s.655 3.46 1.964 4.765c1.31 1.306 2.897 1.96 4.76 1.96Z'
}))));

const ToDo = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M14.3967 18.6628L12.5756 16.8181C12.1311 16.3744 12.1311 15.6434 12.5756 15.1997C13.0117 14.7559 13.7213 14.7559 14.1573 15.1997L15.1833 16.2438L19.072 12.2972C19.5166 11.8447 20.2348 11.8534 20.6708 12.2972H20.6794C21.1069 12.7584 21.1069 13.4719 20.6794 13.9157L16.0212 18.6541C15.5766 19.1153 14.8498 19.1153 14.3967 18.6541V18.6628ZM16.0126 11.7017C15.568 12.1629 14.8413 12.1629 14.3882 11.7017L12.5671 9.85703C12.1225 9.41326 12.1225 8.68234 12.5671 8.23857C13.0031 7.7948 13.7127 7.7948 14.1488 8.23857L15.1747 9.28273L19.0635 5.3361C19.5081 4.88363 20.2263 4.89233 20.6623 5.3361L20.6708 5.3361C21.0983 5.79727 21.0983 6.51079 20.6708 6.95456L16.0126 11.693V11.7017ZM3 16.4875C3 15.8523 3.50443 15.3302 4.12856 15.3302H9.83974C10.4639 15.3302 10.9683 15.8436 10.9683 16.4788C10.9683 17.114 10.4639 17.6361 9.83974 17.6361H4.12856C3.50443 17.6361 3 17.1227 3 16.4875ZM3 9.52637C3 8.89117 3.50443 8.36909 4.12856 8.36909H9.83974C10.4639 8.36909 10.9683 8.88247 10.9683 9.51767C10.9683 10.1529 10.4639 10.675 9.83974 10.675H4.12856C3.50443 10.675 3 10.1616 3 9.52637Z'
}))));

const Train = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M6.633 22a.7.7 0 0 1-.523-.234.77.77 0 0 1-.223-.549c0-.12.032-.25.097-.39a.719.719 0 0 1 .255-.311l1.063-.746c-.937-.13-1.721-.595-2.354-1.393A4.312 4.312 0 0 1 4 15.622v-9.19c0-1.526.645-2.647 1.936-3.36C7.226 2.356 9.248 2 12 2c2.847 0 4.891.345 6.135 1.034C19.378 3.724 20 4.856 20 6.433v9.189a4.312 4.312 0 0 1-.948 2.755c-.633.798-1.417 1.262-2.354 1.393l1.063.746a.73.73 0 0 1 .255.3.899.899 0 0 1 .097.401.77.77 0 0 1-.223.549.7.7 0 0 1-.523.234H6.633ZM6.5 10.558h11V7.59h-11v2.968ZM12 16.41c.393 0 .727-.144 1.002-.433.275-.288.413-.639.413-1.05 0-.413-.138-.763-.413-1.052A1.333 1.333 0 0 0 12 13.442c-.393 0-.727.144-1.002.433a1.468 1.468 0 0 0-.413 1.051c0 .412.138.763.413 1.051.275.289.609.433 1.002.433Zm-3.872.906h7.744a1.55 1.55 0 0 0 1.16-.484c.312-.322.468-.726.468-1.21v-3.085h-11v3.085c0 .485.156.888.467 1.21a1.55 1.55 0 0 0 1.161.484ZM12 4.622c-1.352 0-2.472.082-3.36.247-.889.165-1.514.412-1.876.742H17.17c-.292-.339-.858-.589-1.697-.749-.84-.16-1.997-.24-3.473-.24Z'
}))));

const Tram = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M3.51953 17.288V8C3.51953 6.21376 4.23492 5.03767 5.66571 4.47172C7.09651 3.90577 8.8746 3.58838 11 3.51955L11.7217 2.06192H7.53801C7.32134 2.06192 7.14217 1.99109 7.00051 1.84942C6.85884 1.70775 6.78801 1.52859 6.78801 1.31192C6.78801 1.09525 6.85884 0.916087 7.00051 0.77442C7.14217 0.632754 7.32134 0.56192 7.53801 0.56192H16.462C16.6786 0.56192 16.8578 0.632754 16.9995 0.77442C17.1411 0.916087 17.212 1.09525 17.212 1.31192C17.212 1.52859 17.1411 1.70775 16.9995 1.84942C16.8578 1.99109 16.6786 2.06192 16.462 2.06192H13.7217L13 3.51955C15.2094 3.58838 17.0085 3.90395 18.3973 4.46627C19.786 5.0286 20.4804 6.20651 20.4804 8V17.288C20.4804 18.4504 20.0911 19.4467 19.3125 20.2772C18.5339 21.1076 17.5822 21.5511 16.4576 21.6076L16.9576 22.1076C17.288 22.4381 17.3665 22.8131 17.1929 23.2326C17.0194 23.6522 16.6961 23.862 16.2232 23.862C16.0852 23.862 15.955 23.8365 15.8326 23.7854C15.7101 23.7343 15.5978 23.6624 15.4956 23.5696L13.5619 21.65H10.4381L8.50433 23.5696C8.40216 23.6623 8.28926 23.7343 8.16561 23.7853C8.04197 23.8364 7.91358 23.862 7.78043 23.862C7.32173 23.862 7.00144 23.6522 6.81956 23.2326C6.63767 22.8131 6.71195 22.4381 7.04238 22.1076L7.54238 21.6076C6.41773 21.5511 5.46609 21.1076 4.68746 20.2772C3.90884 19.4467 3.51953 18.4504 3.51953 17.288ZM12 18.0848C12.4166 18.0848 12.7708 17.9389 13.0625 17.6473C13.3541 17.3556 13.5 17.0014 13.5 16.5848C13.5 16.1681 13.3541 15.8139 13.0625 15.5223C12.7708 15.2306 12.4166 15.0848 12 15.0848C11.5833 15.0848 11.2291 15.2306 10.9375 15.5223C10.6458 15.8139 10.5 16.1681 10.5 16.5848C10.5 17.0014 10.6458 17.3556 10.9375 17.6473C11.2291 17.9389 11.5833 18.0848 12 18.0848ZM6.16956 12.1696H17.8304V9.16957H6.16956V12.1696ZM7.89566 19H16.1043C16.5942 19 17.0043 18.8383 17.3348 18.5149C17.6652 18.1916 17.8304 17.7826 17.8304 17.288V14.1696H6.16956V17.288C6.16956 17.7826 6.33477 18.1916 6.66521 18.5149C6.99564 18.8383 7.40579 19 7.89566 19ZM11.95 6.16957C9.71665 6.16957 8.28331 6.2904 7.64998 6.53207C7.01665 6.77374 6.59998 6.98624 6.39998 7.16957H17.65C17.45 6.93624 17.0166 6.71124 16.35 6.49457C15.6833 6.2779 14.2166 6.16957 11.95 6.16957Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Transfer = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M16.477 21a.993.993 0 0 1-.44-.114.898.898 0 0 1-.34-.268l-2.531-3.69H9.972c-.366 0-.677-.108-.933-.325a1.005 1.005 0 0 1-.385-.797c0-.314.128-.582.385-.803.256-.22.567-.331.933-.331h3.194l2.53-3.677a.95.95 0 0 1 .341-.275.996.996 0 0 1 .467-.12c.304 0 .532.087.685.262.153.175.184.39.092.644l-1.095 3.166h2.76l.557-.626a.803.803 0 0 1 .312-.216c.134-.056.266-.084.396-.084.296 0 .514.086.653.257.139.172.171.377.097.616l-.43 1.187.43 1.187c.074.24.037.443-.11.61-.148.167-.37.25-.666.25a.947.947 0 0 1-.376-.084.81.81 0 0 1-.306-.215l-.557-.626h-2.76l1.095 3.166c.092.255.06.47-.098.644-.156.175-.392.262-.706.262Zm-8.981-7.6c-.304 0-.53-.087-.678-.262-.148-.175-.18-.39-.1-.644l1.096-3.166h-2.76l-.557.626a.803.803 0 0 1-.312.216 1.022 1.022 0 0 1-.396.084c-.296 0-.514-.086-.653-.257-.139-.172-.171-.377-.097-.616l.43-1.187-.43-1.187c-.074-.24-.037-.443.11-.61.149-.167.37-.25.667-.25.12 0 .245.028.375.084a.81.81 0 0 1 .306.215l.557.626h2.76L6.719 3.906c-.082-.254-.047-.47.105-.644.152-.175.385-.262.699-.262.14 0 .287.036.44.107a.799.799 0 0 1 .34.275l2.531 3.69h3.194c.366 0 .677.108.933.325.257.217.385.482.385.797 0 .314-.128.582-.385.803a1.381 1.381 0 0 1-.933.331h-3.194l-2.53 3.677a.843.843 0 0 1-.341.282 1.042 1.042 0 0 1-.467.113Z'
}))));

const Undo = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M7.846 19a1.26 1.26 0 0 1-.926-.38 1.258 1.258 0 0 1-.38-.925c0-.363.126-.671.38-.925a1.26 1.26 0 0 1 .926-.38h6.015c.952 0 1.778-.297 2.477-.889.7-.591 1.049-1.338 1.049-2.24 0-.902-.35-1.648-1.05-2.24-.698-.592-1.524-.888-2.476-.888H8.415l1.33 1.329c.246.246.369.55.369.912 0 .363-.123.667-.369.913a1.24 1.24 0 0 1-.913.368 1.24 1.24 0 0 1-.913-.368L4.369 9.74a1.201 1.201 0 0 1-.28-.425 1.36 1.36 0 0 1 0-.975c.06-.157.153-.298.28-.425l3.55-3.547A1.24 1.24 0 0 1 8.832 4c.363 0 .667.123.913.368.246.246.369.55.369.913 0 .362-.123.667-.369.912l-1.33 1.33h5.446c1.678 0 3.12.549 4.328 1.648 1.207 1.1 1.811 2.463 1.811 4.09 0 1.627-.604 2.99-1.811 4.09-1.207 1.1-2.65 1.649-4.328 1.649H7.846Z'
}))));

const Unlocked = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 -960 960 960',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h360v-80q0-50-35-85t-85-35q-42 0-73.5 25.5T364-751q-4 14-16.5 22.5T320-720q-17 0-28.5-11t-8.5-26q14-69 69-116t128-47q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM240-160v-400 400Z'
}))));

const Upload = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12.014 15.6c-.371 0-.687-.131-.947-.394a1.308 1.308 0 0 1-.39-.956V7.584l-1.564 1.58a1.285 1.285 0 0 1-.927.398c-.36.005-.677-.132-.953-.41a1.28 1.28 0 0 1-.383-.949 1.3 1.3 0 0 1 .383-.938L11.08 3.38c.13-.13.274-.227.435-.289a1.382 1.382 0 0 1 .999 0c.16.062.305.158.435.289l3.847 3.884c.259.261.386.578.382.95a1.3 1.3 0 0 1-.382.937 1.294 1.294 0 0 1-.94.398 1.255 1.255 0 0 1-.94-.387l-1.565-1.58v6.667c0 .375-.13.694-.39.956-.26.263-.575.394-.947.394ZM5.674 21a2.568 2.568 0 0 1-1.896-.786C3.26 19.69 3 19.052 3 18.3v-2.585c0-.375.13-.694.39-.956.26-.263.576-.394.947-.394.372 0 .687.131.947.394.26.262.39.581.39.956V18.3h12.652v-2.585c0-.375.13-.694.39-.956.26-.263.575-.394.947-.394.371 0 .687.131.947.394.26.262.39.581.39.956V18.3c0 .752-.26 1.39-.778 1.914a2.568 2.568 0 0 1-1.896.786H5.674Z'
}))));

const User = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M11.915 12.123c-1.17 0-2.168-.39-2.991-1.17-.824-.78-1.235-1.724-1.235-2.833 0-1.11.411-2.052 1.235-2.827.823-.776 1.82-1.164 2.991-1.164s2.169.388 2.992 1.164c.823.775 1.235 1.718 1.235 2.827s-.412 2.053-1.235 2.833c-.823.78-1.82 1.17-2.992 1.17Zm5.5 8.006h-11c-.696 0-1.287-.23-1.772-.689a2.225 2.225 0 0 1-.728-1.678v-.589c0-.584.16-1.122.482-1.612.322-.49.748-.864 1.28-1.122a15.216 15.216 0 0 1 3.065-1.064 14.494 14.494 0 0 1 6.372-.006c1.042.235 2.055.588 3.039 1.058.532.256.959.629 1.28 1.116.322.488.482 1.031.482 1.63v.589c0 .66-.242 1.219-.727 1.678-.485.46-1.076.69-1.773.69Zm-11-2.367h11v-.526a.739.739 0 0 0-.13-.424.884.884 0 0 0-.341-.297 12.463 12.463 0 0 0-2.45-.842 11.473 11.473 0 0 0-2.579-.289c-.862 0-1.722.096-2.577.29-.856.192-1.673.472-2.451.84a.883.883 0 0 0-.342.298.74.74 0 0 0-.13.424v.526Zm5.5-8.007c.475 0 .881-.16 1.22-.48.338-.32.507-.705.507-1.155 0-.45-.169-.832-.507-1.149a1.721 1.721 0 0 0-1.22-.474c-.474 0-.88.159-1.219.477-.338.318-.507.7-.507 1.146 0 .45.169.835.507 1.155.338.32.744.48 1.219.48Z'
}))));

const Users = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M3.158 20c-.321 0-.595-.118-.82-.355a1.202 1.202 0 0 1-.338-.86v-1.82c0-.6.149-1.152.447-1.655a3.024 3.024 0 0 1 1.187-1.152 13.203 13.203 0 0 1 2.84-1.093 11.879 11.879 0 0 1 2.94-.368 12.182 12.182 0 0 1 5.78 1.448c.494.263.89.646 1.188 1.146.298.501.446 1.059.446 1.674v1.82c0 .337-.112.624-.337.86a1.091 1.091 0 0 1-.821.355H3.158Zm15.053 0a1.613 1.613 0 0 0 .551-1.238V16.82c0-.707-.174-1.392-.523-2.055-.349-.662-.863-1.28-1.544-1.853a11.018 11.018 0 0 1 3.552 1.233c.557.306.989.695 1.294 1.167.306.472.459.988.459 1.547v1.925c0 .338-.113.625-.338.861a1.092 1.092 0 0 1-.82.355h-2.63Zm-8.797-8.22c-1.027 0-1.902-.38-2.624-1.137-.722-.757-1.083-1.675-1.083-2.753s.361-1.996 1.083-2.754C7.512 4.38 8.387 4 9.414 4c1.028 0 1.903.379 2.625 1.136.721.758 1.082 1.676 1.082 2.754s-.36 1.996-1.082 2.753c-.722.758-1.597 1.137-2.625 1.137Zm9.348-3.89c0 1.07-.363 1.985-1.088 2.747-.726.762-1.598 1.143-2.617 1.143a3.59 3.59 0 0 1-.614-.064 4.8 4.8 0 0 1-.649-.159c.41-.506.723-1.074.938-1.704.216-.63.323-1.283.323-1.961 0-.678-.107-1.333-.323-1.964a5.529 5.529 0 0 0-.938-1.706c.212-.085.42-.143.624-.175.205-.031.415-.047.631-.047 1.021 0 1.896.38 2.623 1.143.727.761 1.09 1.677 1.09 2.747ZM4.317 17.569h10.195v-.54a.85.85 0 0 0-.437-.74 10.803 10.803 0 0 0-2.272-.864 9.643 9.643 0 0 0-2.389-.297c-.8 0-1.596.099-2.389.297-.793.197-1.55.485-2.271.864a.85.85 0 0 0-.437.74v.54Zm5.095-8.026c.433 0 .804-.162 1.114-.485.31-.323.464-.712.464-1.166 0-.454-.154-.844-.462-1.168a1.478 1.478 0 0 0-1.112-.487c-.433 0-.804.161-1.113.485-.31.323-.464.712-.464 1.166 0 .454.154.843.462 1.168.308.325.679.487 1.111.487Z'
}))));

const Visible = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'M12 15.968c1.114 0 2.06-.386 2.84-1.157.78-.772 1.17-1.709 1.17-2.811 0-1.102-.39-2.04-1.17-2.81-.78-.772-1.726-1.158-2.84-1.158-1.114 0-2.06.386-2.84 1.157-.78.772-1.17 1.709-1.17 2.811 0 1.102.39 2.04 1.17 2.81.78.772 1.726 1.158 2.84 1.158Zm.002-1.849c-.594 0-1.1-.206-1.518-.617a2.027 2.027 0 0 1-.626-1.5c0-.588.208-1.088.624-1.502.416-.413.921-.62 1.516-.62.594 0 1.1.207 1.518.618.417.412.626.912.626 1.5s-.208 1.088-.624 1.502c-.416.413-.921.62-1.516.62ZM12 19c-2.123 0-4.066-.563-5.83-1.689a10.945 10.945 0 0 1-4.02-4.52.918.918 0 0 1-.12-.36 3.154 3.154 0 0 1 0-.861.918.918 0 0 1 .12-.362 10.945 10.945 0 0 1 4.02-4.52C7.935 5.564 9.878 5 12 5s4.067.563 5.83 1.689a10.945 10.945 0 0 1 4.02 4.52c.06.096.1.216.12.36a3.152 3.152 0 0 1 0 .861.918.918 0 0 1-.12.362 10.945 10.945 0 0 1-4.02 4.52C16.066 18.436 14.122 19 12 19Zm.001-2.15c1.67 0 3.202-.44 4.597-1.318A8.741 8.741 0 0 0 19.805 12a8.738 8.738 0 0 0-3.208-3.532 8.462 8.462 0 0 0-4.598-1.318c-1.67 0-3.202.44-4.597 1.318A8.74 8.74 0 0 0 4.195 12a8.738 8.738 0 0 0 3.208 3.532 8.463 8.463 0 0 0 4.598 1.318Z'
}))));

const Walk = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: props.fill ?? ColoursObj.core.primary,
  d: 'm10.646 13.972-1.209 5.433a.72.72 0 0 1-.27.428.778.778 0 0 1-.493.167.724.724 0 0 1-.595-.28.726.726 0 0 1-.149-.632l1.898-9.581-1.34.52v1.787a.72.72 0 0 1-.214.53.72.72 0 0 1-.53.214.72.72 0 0 1-.53-.214.72.72 0 0 1-.214-.53v-2.27c0-.149.04-.282.12-.4a.773.773 0 0 1 .327-.27l3.311-1.414c.174-.074.357-.117.549-.13.192-.012.375.013.549.075.174.062.338.148.493.26.155.112.282.254.381.428l.744 1.19c.162.249.35.484.568.708.217.223.462.415.735.576.173.1.366.19.577.27.21.08.421.14.632.177a.864.864 0 0 1 .493.27c.13.142.195.32.195.53a.676.676 0 0 1-.762.688 4.898 4.898 0 0 1-1.87-.65 6.053 6.053 0 0 1-1.442-1.21l-.465 2.288 1.34 1.265a.745.745 0 0 1 .223.54v4.52a.72.72 0 0 1-.214.531.72.72 0 0 1-.53.214.72.72 0 0 1-.53-.214.72.72 0 0 1-.215-.53v-4.093l-1.563-1.19Zm1.935-6.995c-.409 0-.76-.146-1.05-.437a1.433 1.433 0 0 1-.438-1.052c0-.409.146-.76.437-1.05A1.433 1.433 0 0 1 12.581 4c.41 0 .76.146 1.052.437.291.292.437.642.437 1.051 0 .41-.146.76-.437 1.052a1.433 1.433 0 0 1-1.052.437Z'
}))));

const Wifi = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M11.9999 17C11.2999 17 10.7082 16.7583 10.2249 16.275C9.74152 15.7917 9.49986 15.2 9.49986 14.5C9.49986 13.8 9.74152 13.2083 10.2249 12.725C10.7082 12.2417 11.2999 12 11.9999 12C12.6999 12 13.2915 12.2417 13.7749 12.725C14.2582 13.2083 14.4999 13.8 14.4999 14.5C14.4999 15.2 14.2582 15.7917 13.7749 16.275C13.2915 16.7583 12.6999 17 11.9999 17ZM11.9999 6C13.2216 6 14.3785 6.19058 15.4705 6.57175C16.5625 6.9529 17.5622 7.47463 18.4694 8.13695C18.8404 8.4058 19.0325 8.77265 19.0455 9.2375C19.0586 9.70235 18.8962 10.1036 18.5586 10.4413C18.2281 10.7718 17.8263 10.9482 17.3531 10.9707C16.8799 10.9931 16.4484 10.8783 16.0585 10.6261C15.4723 10.2493 14.8406 9.95708 14.1634 9.74948C13.4863 9.54188 12.7651 9.43808 11.9999 9.43808C11.2441 9.43808 10.5299 9.53952 9.85748 9.7424C9.18501 9.9453 8.55567 10.2352 7.96946 10.612C7.57017 10.8641 7.13158 10.9795 6.65368 10.9582C6.17578 10.9368 5.77161 10.7609 5.44115 10.4304C5.11072 10.0928 4.95021 9.69385 4.95963 9.2337C4.96906 8.77355 5.15929 8.40906 5.53031 8.14023C6.43754 7.47791 7.43717 6.95563 8.52921 6.57338C9.62124 6.19113 10.7781 6 11.9999 6ZM11.9999 0C14.0455 0 15.9727 0.33225 17.7814 0.99675C19.5901 1.66123 21.223 2.59493 22.6803 3.79783C23.0607 4.10943 23.264 4.49946 23.2901 4.96792C23.3162 5.43641 23.1557 5.8442 22.8086 6.1913C22.4781 6.52175 22.0763 6.69349 21.6031 6.70652C21.1299 6.71957 20.6984 6.57863 20.3085 6.2837C19.1462 5.37573 17.8663 4.67447 16.4689 4.1799C15.0714 3.68535 13.5817 3.43808 11.9999 3.43808C10.418 3.43808 8.9283 3.68535 7.53085 4.1799C6.13339 4.67447 4.8535 5.37573 3.69118 6.2837C3.30133 6.57863 2.87216 6.71957 2.40368 6.70652C1.93518 6.69349 1.53572 6.52175 1.2053 6.1913C0.858188 5.8442 0.695322 5.43641 0.716705 4.96792C0.738088 4.49946 0.938997 4.10943 1.31943 3.79783C2.77668 2.59493 4.40965 1.66123 6.21833 0.99675C8.02703 0.33225 9.9542 0 11.9999 0Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));

const Wifi_Off = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height ?? 24,
    width: props.width ?? 24,
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  d: 'M18.852 18.9689L10.4629 10.558C10.0122 10.6653 9.58465 10.8001 9.1803 10.9624C8.77595 11.1247 8.39842 11.3193 8.04771 11.5461C7.62234 11.7982 7.17125 11.9285 6.69443 11.9368C6.21761 11.9452 5.80928 11.7758 5.46943 11.4287C5.12233 11.0816 4.95892 10.6672 4.97921 10.1857C4.99949 9.70421 5.20456 9.32432 5.59443 9.04605C5.92123 8.80982 6.26416 8.59152 6.62323 8.39115C6.98228 8.1908 7.35383 8.00475 7.73788 7.833L5.81291 5.90803C5.43609 6.12253 5.07414 6.33774 4.72706 6.55368C4.37996 6.76961 4.043 6.99932 3.71618 7.2428C3.32633 7.53773 2.893 7.6852 2.41618 7.6852C1.93935 7.6852 1.53572 7.51164 1.2053 7.16453C0.858188 6.81743 0.695322 6.40963 0.716705 5.94115C0.738088 5.47268 0.938997 5.08628 1.31943 4.78193C1.639 4.51961 1.96218 4.2745 2.28898 4.0466C2.6158 3.8187 2.95348 3.60692 3.30203 3.41127L2.01508 2.12433C1.80348 1.91273 1.70003 1.65584 1.70473 1.35368C1.70945 1.05149 1.81761 0.7946 2.02921 0.583C2.24079 0.371417 2.50003 0.265625 2.80693 0.265625C3.11381 0.265625 3.37305 0.371417 3.58463 0.583L20.4183 17.4167C20.6372 17.6355 20.7466 17.8943 20.7466 18.1928C20.7466 18.4914 20.6372 18.75 20.4183 18.9689C20.1995 19.1805 19.9384 19.2881 19.6352 19.2917C19.3319 19.2953 19.0709 19.1877 18.852 18.9689ZM11.9999 17.9982C11.2999 17.9982 10.7082 17.7524 10.2249 17.2607C9.74152 16.7691 9.49986 16.1816 9.49986 15.4982C9.49986 14.7982 9.74152 14.2066 10.2249 13.7232C10.7082 13.2399 11.2999 12.9982 11.9999 12.9982C12.6999 12.9982 13.2915 13.2399 13.7749 13.7232C14.2582 14.2066 14.4999 14.7982 14.4999 15.4982C14.4999 16.1816 14.2582 16.7691 13.7749 17.2607C13.2915 17.7524 12.6999 17.9982 11.9999 17.9982ZM18.9096 11.0385C18.6618 11.2863 18.3752 11.4084 18.0499 11.4047C17.7245 11.4011 17.4379 11.2754 17.1901 11.0276L16.6618 10.4993L13.2173 7.06888C14.289 7.19714 15.2888 7.4553 16.2167 7.84335C17.1446 8.23138 17.9933 8.72793 18.7629 9.333C19.0346 9.5475 19.189 9.82341 19.226 10.1607C19.2629 10.498 19.1575 10.7906 18.9096 11.0385ZM22.8086 7.17868C22.4781 7.51636 22.0763 7.69172 21.6031 7.70475C21.1299 7.7178 20.6984 7.57686 20.3085 7.28193C19.1462 6.37396 17.8663 5.67269 16.4689 5.17812C15.0714 4.68357 13.5817 4.4363 11.9999 4.4363C11.7723 4.4363 11.5502 4.44173 11.3336 4.4526C11.1169 4.46347 10.8984 4.48448 10.6782 4.51562L7.69008 1.52758C8.42341 1.32758 9.12921 1.18935 9.80748 1.1129C10.4857 1.03645 11.2165 0.998225 11.9999 0.998225C14.0549 0.998225 15.9892 1.33464 17.8026 2.00748C19.616 2.68029 21.256 3.62033 22.7227 4.82758C23.0843 5.12974 23.2734 5.51271 23.2901 5.97648C23.3067 6.44026 23.1462 6.84099 22.8086 7.17868Z',
  fill: props.fill ?? ColoursObj.core.primary
}))));



var Icons = {
  __proto__: null,
  Activity: Activity,
  Add: Add,
  Add_Group: Add_Group,
  Add_User: Add_User,
  Additional_Information: Additional_Information,
  Admin: Admin,
  Admin_Boarder: Admin_Boarder,
  Airline: Airline,
  Amenities: Amenities,
  Archive: Archive,
  Arrive: Arrive,
  Attach: Attach,
  Bike: Bike,
  Billing: Billing,
  Building: Building,
  Bus: Bus,
  Calendar: Calendar,
  Calendar_Today: Calendar_Today,
  Camera: Camera,
  Cancel: Cancel,
  Cancel_Event: Cancel_Event,
  Car_Allocation: Car_Allocation,
  Car_Type: Car_Type,
  Chart: Chart,
  Chat: Chat,
  Chat_Notf: Chat_Notf,
  Chevron_Down: Chevron_Down,
  Chevron_Expand: Chevron_Expand,
  Chevron_Left: Chevron_Left,
  Chevron_Right: Chevron_Right,
  Chevron_Up: Chevron_Up,
  Circle: Circle,
  Contact_Phone: Contact_Phone,
  Copy: Copy,
  Cross: Cross,
  Customise: Customise,
  Dashboard: Dashboard,
  Delete: Delete,
  Depart: Depart,
  Diagonal_Enlarge: Diagonal_Enlarge,
  Document: Document,
  Download: Download,
  Dress_Code: Dress_Code,
  Driver: Driver,
  Duplicate: Duplicate,
  Edit: Edit,
  Edit_Text: Edit_Text,
  Email: Email,
  Emergency_Contact: Emergency_Contact,
  Enhance: Enhance,
  Enlarge: Enlarge,
  Event_Session: Event_Session,
  Event_Type: Event_Type,
  Exit: Exit,
  Expand_Field: Expand_Field,
  Ferry: Ferry,
  Filter: Filter,
  Filter2: Filter2,
  Find: Find,
  Flight: Flight,
  Flight_Booking: Flight_Booking,
  Flight_Side: Flight_Side,
  Free_Edit: Free_Edit,
  Globe: Globe,
  Group: Group,
  Hamburger: Hamburger,
  Help: Help,
  Hide: Hide,
  Hire_Car: Hire_Car,
  History: History,
  Home: Home,
  Hotel: Hotel,
  Important: Important,
  Info: Info,
  Internet: Internet,
  Itinerary: Itinerary,
  Kebab: Kebab,
  Keyboard: Keyboard,
  Keyboard_Hide: Keyboard_Hide,
  Languages: Languages,
  Layover: Layover,
  Leave_App: Leave_App,
  Left: Left,
  LetterT: LetterT,
  Link: Link,
  List: List,
  Loading: Loading,
  Location: Location,
  Location_Pin: Location_Pin,
  Lock_Visibility: Lock_Visibility,
  Locked: Locked,
  Log_Out: Log_Out,
  Low_Data: Low_Data,
  Map: Map$1,
  Meal: Meal,
  Minimise: Minimise,
  More: More,
  New_Itinerary: New_Itinerary,
  Night: Night,
  Notification: Notification,
  Okay: Okay,
  Parking: Parking,
  Phone: Phone,
  Photos: Photos,
  Private: Private,
  Public: Public,
  Push_Pin: Push_Pin,
  Qr_Code: Qr_Code,
  Redo: Redo,
  Refresh: Refresh,
  Reports: Reports,
  Right: Right,
  Room_Leave: Room_Leave,
  Room_Type: Room_Type,
  Route: Route,
  Schedule: Schedule,
  Search: Search,
  Seat: Seat,
  Security: Security,
  Send: Send,
  Settings: Settings,
  Share: Share,
  Share_Location: Share_Location,
  Sidebar_Left: Sidebar_Left,
  Sidebar_Right: Sidebar_Right,
  Sort: Sort,
  Sort_Down: Sort_Down,
  Sort_Up: Sort_Up,
  Stand: Stand,
  Stays: Stays,
  Subtract: Subtract,
  Subway: Subway,
  Suitcase: Suitcase,
  Swap: Swap,
  Sync: Sync,
  TagIcon: TagIcon,
  Taxi: Taxi,
  Team_Code: Team_Code,
  Team_Members: Team_Members,
  Tick: Tick,
  Ticket: Ticket,
  Time: Time,
  ToDo: ToDo,
  Train: Train,
  Tram: Tram,
  Transfer: Transfer,
  Undo: Undo,
  Unlocked: Unlocked,
  Upload: Upload,
  User: User,
  Users: Users,
  Visible: Visible,
  Walk: Walk,
  Wifi: Wifi,
  Wifi_Off: Wifi_Off
};

const IconsArrows = ['Chevron_Down', 'Chevron_Expand', 'Chevron_Left', 'Chevron_Right', 'Chevron_Up', 'Diagonal_Enlarge', 'Enlarge', 'Expand_Field', 'Left', 'Minimise', 'Refresh', 'Right', 'Sort', 'Sort_Down', 'Sort_Up', 'Swap', 'Sync'];
const IconsNavigation = ['Dashboard', 'Notification', 'Calendar', 'Reports', 'Chart', 'List', 'Hamburger', 'Enhance', 'More', 'Kebab', 'Settings', 'Itinerary', 'Home', 'Users', 'User', 'Log_Out', 'Security', 'Search', 'Location', 'Admin', 'Chat', 'Chat_Notf', 'Customise', 'Event_Session', 'Sidebar_Right', 'Sidebar_Left', 'Cross', 'Map', 'Calendar_Today'];
const IconsGeneral = ['Archive', 'Flight', 'Flight_Side', 'Depart', 'Arrive', 'Transfer', 'Stays', 'Car_Type', 'Hire_Car', 'Car_Allocation', 'Bus', 'Taxi', 'Train', 'Subway', 'Tram', 'Ferry', 'Parking', 'Suitcase', 'Seat', 'Admin_Boarder', 'Room_Type', 'Group', 'Dress_Code', 'Driver', 'Hotel', 'Phone', 'Building', 'Document', 'Cancel_Event', 'Contact_Phone', 'Filter', 'Filter2', 'Flight_Booking', 'Email', 'Languages', 'Emergency_Contact', 'Internet', 'Globe', 'Ticket', 'Night', 'Meal', 'Airline', 'Layover', 'Amenities', 'Keyboard_Hide', 'Camera', 'Duplicate', 'Event_Type', 'Activity', 'Billing', 'Team_Code', 'Wifi_Off', 'Wifi', 'Low_Data', 'TagIcon', 'Room_Leave', 'Walk', 'Bike', 'ToDo', 'Additional_Information', 'Circle', 'LetterT', 'Stand'];
const IconsActions = ['Visible', 'Hide', 'Lock_Visibility', 'Edit', 'Edit_Text', 'Free_Edit', 'Qr_Code', 'Add', 'Subtract', 'Exit', 'Tick', 'Send', 'Delete', 'Undo', 'Redo', 'Find', 'Location_Pin', 'Attach', 'New_Itinerary', 'Link', 'Keyboard', 'Push_Pin', 'Photos', 'Add_Group', 'Copy', 'Share_Location', 'Route'];
const IconsStatus = ['Help', 'Cancel', 'Important', 'Okay', 'Info', 'History', 'Time', 'Schedule', 'Locked', 'Unlocked', 'Download', 'Upload', 'Add_User', 'Share', 'Leave_App', 'Public', 'Private'];
const ActivityIcons = ['Flight', 'Flight_Side', 'Depart', 'Arrive', 'Transfer', 'Stays', 'Car_Type', 'Hire_Car', 'Car_Allocation', 'Bus', 'Taxi', 'Train', 'Subway', 'Tram', 'Ferry', 'Parking', 'Suitcase', 'Seat', 'Admin_Boarder', 'Room_Type', 'Group', 'Dress_Code', 'Driver', 'Hotel', 'Phone', 'Building', 'Document', 'Cancel_Event', 'Contact_Phone', 'Filter', 'Filter2', 'Flight_Booking', 'Email', 'Languages', 'Emergency_Contact', 'Internet', 'Globe', 'Ticket', 'Night', 'Meal', 'Airline', 'Layover', 'Amenities', 'Camera', 'Event_Type', 'Activity', 'Billing', 'Team_Code', 'Wifi_Off', 'Wifi', 'Low_Data', 'TagIcon', 'Room_Leave', 'Walk', 'Bike', 'ToDo', 'Additional_Information', 'Circle', 'LetterT', 'Stand'];
const IconsOther = ['Loading'];
const CEventrIcons = [...IconsActions, ...IconsGeneral, ...IconsNavigation, ...IconsStatus, ...IconsArrows, ...IconsOther];
const Icon = ({
  name,
  iconColour,
  height = '24px',
  width = '24px',
  onClick,
  bubble,
  bubbleColour = ColoursObj.core.primary,
  borderColour
}) => {
  if (bubble) {
    const randNumberForId = Math.random();
    const maskPathComp = Icons[name]({
      fill: iconColour ?? ColoursObj.backgrounds.primary
    }).props.children;
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'grid',
        alignItems: 'center',
        justifyItems: 'center',
        height: height,
        width: width,
        backgroundColor: 'transparent'
      },
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        height: height ?? '24px',
        width: width ?? '24px',
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React__default.createElement("svg", {
      height: height ?? '24px',
      width: width ?? '24px',
      viewBox: '0 0 24 24',
      overflow: 'visible'
    }, /*#__PURE__*/React__default.createElement("ellipse", {
      cx: '12',
      cy: '12',
      rx: '11',
      ry: '11',
      fill: bubbleColour,
      mask: `url(#${randNumberForId})`,
      stroke: borderColour,
      strokeWidth: 2,
      vectorEffect: 'non-scaling-stroke'
    }), /*#__PURE__*/React__default.createElement("svg", {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '-4 -4 32 32',
      fill: 'none'
    }, maskPathComp))));
  }
  if (CEventrIcons.includes(name)) {
    try {
      return /*#__PURE__*/React__default.createElement(Icons[name], {
        fill: iconColour,
        height: height,
        width: width,
        onClick: onClick
      });
    } catch {
      return /*#__PURE__*/React__default.createElement(Exit, {
        fill: ColoursObj.states.error,
        height: height,
        width: width,
        onClick: onClick
      });
    }
  } else {
    return /*#__PURE__*/React__default.createElement(Exit, {
      fill: ColoursObj.states.error,
      height: height,
      width: width,
      onClick: onClick
    });
  }
};

const SnackBarAlert = ({
  severity,
  icon,
  text,
  onXClick
}) => {
  var bgColour = () => {
    switch (severity) {
      case 'error':
        {
          return ColoursObj.states.error;
        }
      case 'warning':
        {
          return ColoursObj.states.warning;
        }
      case 'success':
        {
          return ColoursObj.states.success;
        }
      default:
        {
          return ColoursObj.shades.shade2;
        }
    }
  };
  return /*#__PURE__*/React__default.createElement(Stack, {
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    sx: {
      backgroundColor: bgColour,
      borderRadius: '10px'
    },
    padding: '8px 16px 8px 16px'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    alignItems: 'center',
    direction: 'row',
    spacing: '16px'
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: icon ?? 'Important',
    iconColour: ColoursObj.shades.shade5
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    textAlign: 'center',
    variant: 'bodySubtext',
    color: ColoursObj.shades.shade5
  }, text)), onXClick && ( /*#__PURE__*/React__default.createElement(Stack, {
    marginLeft: '16px',
    direction: 'row',
    spacing: '16px'
  }, /*#__PURE__*/React__default.createElement(Divider, {
    color: 'white',
    orientation: 'vertical',
    flexItem: true
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: onXClick
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Exit',
    iconColour: ColoursObj.shades.shade5
  })))));
};

const CoverImageUploadButtonPreview = ({
  state,
  setState,
  text,
  label,
  maxSize = 6000000,
  maxHeight = 720,
  maxWidth = 1280,
  quality = 0.8
}) => {
  const inputRef = useRef(null);
  const [errorSnack, setErrorSnack] = useState(false);
  const onUpload = function (e) {
    try {
      if (e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (maxSize === 0 || file.size <= maxSize) {
          const blobURL = URL.createObjectURL(file);
          const img = new Image();
          img.src = blobURL;
          img.onload = function () {
            const [newWidth, newHeight] = calculateSize(img, maxWidth, maxHeight);
            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;
            const ctx = canvas.getContext('2d');
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0, newWidth, newHeight);
            const base64 = canvas.toDataURL('image/jpeg', quality);
            setState(base64);
          };
        } else {
          setErrorSnack(true);
        }
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  const calculateSize = (img, maxWidth, maxHeight) => {
    let width = img.width;
    let height = img.height;
    if (width > height) {
      if (width > maxWidth) {
        height = Math.round(height * maxWidth / width);
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width = Math.round(width * maxHeight / height);
        height = maxHeight;
      }
    }
    return [width, height];
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Snackbar, {
    open: errorSnack,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(SnackBarAlert, {
    severity: 'error',
    text: 'File size too big. Max size is: ' + maxSize + ' Bytes',
    onXClick: () => {
      setErrorSnack(false);
    }
  }))), /*#__PURE__*/React__default.createElement(Typography$1, {
    color: ColoursObj.font.primary
  }, label), /*#__PURE__*/React__default.createElement(Card, {
    variant: 'outlined',
    style: {
      background: ColoursObj.backgrounds.input,
      height: 'fit-content'
    },
    onClick: () => {
      if (inputRef.current) {
        inputRef.current.click();
      }
    }
  }, ' ', /*#__PURE__*/React__default.createElement("input", {
    ref: inputRef,
    style: {
      display: 'none'
    },
    type: 'file',
    accept: 'image/*',
    onChange: onUpload
  }), /*#__PURE__*/React__default.createElement(Stack, {
    borderRadius: 'inherit',
    style: {
      height: 'calc(100vw * 6 / 16)',
      backgroundImage: 'url(' + state + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    padding: '16px'
  }, !state && ( /*#__PURE__*/React__default.createElement(Stack, {
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    height: '100%'
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Upload'
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyBold',
    align: 'center'
  }, text), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext'
  }, `PNG or JPG  ${maxSize > 0 ? `(max ${maxSize})` : ''}`))))));
};

const Typography = props => {
  return /*#__PURE__*/React__default.createElement(Typography$1, Object.assign({}, props));
};

const NumberCounter = ({
  counter,
  backgroundColour = ColoursObj.shades.shade3,
  textColour = ColoursObj.font.primary
}) => {
  if (counter === null) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'grid',
      alignItems: 'center',
      justifyItems: 'center',
      minWidth: '24px',
      minHeight: '24px',
      maxWidth: 'max-content',
      maxHeight: 'max-content',
      padding: '4px',
      borderRadius: '24px',
      backgroundColor: backgroundColour
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: textColour
  }, counter));
};

const MenuButton = ({
  id,
  children,
  text,
  disabled = false,
  startIcon,
  startIconColour,
  endIcon,
  endIconColour,
  style,
  onClick,
  counter = null
}) => {
  return /*#__PURE__*/React__default.createElement(Button, {
    id: id,
    variant: 'menuButton',
    disabled: disabled ? true : false,
    disableRipple: true,
    style: {
      color: disabled ? ColoursObj.shades.shade2 : ColoursObj.core.primary,
      ...style,
      display: 'grid',
      gridTemplateColumns: 'auto auto 1fr auto 8px auto'
    },
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Box, null, startIcon && ( /*#__PURE__*/React__default.createElement(Icon, {
    name: startIcon,
    iconColour: disabled ? ColoursObj.shades.shade2 : startIconColour ?? undefined
  }))), /*#__PURE__*/React__default.createElement(Typography$1, {
    color: disabled ? ColoursObj.shades.shade2 : undefined,
    variant: 'bodyRegular',
    style: {
      marginLeft: startIcon ? '8px' : '0'
    }
  }, text), /*#__PURE__*/React__default.createElement(Box, null, children), /*#__PURE__*/React__default.createElement(Box, null, counter !== null && ( /*#__PURE__*/React__default.createElement(NumberCounter, {
    counter: counter,
    textColour: ColoursObj.shades.shade5,
    backgroundColour: ColoursObj.shades.shade2
  }))), /*#__PURE__*/React__default.createElement(Box, null), /*#__PURE__*/React__default.createElement(Box, null, endIcon && ( /*#__PURE__*/React__default.createElement(Icon, {
    name: endIcon,
    iconColour: disabled ? ColoursObj.shades.shade2 : endIconColour ?? undefined
  }))));
};

const MainButton = ({
  id,
  children,
  text,
  size = 'large',
  variant,
  disabled = false,
  icon,
  iconPosition,
  style,
  onClick,
  loading = false,
  wrap = false,
  iconColour,
  fontColour,
  fontColourHover,
  hapticFeedback,
  tabIndex
}) => {
  function getFontColour(hover) {
    if (hover && !isMobile) {
      if (fontColourHover) {
        return fontColourHover;
      } else if (fontColour) {
        return fontColour;
      } else if (variant === 'secondary') {
        return ColoursObj.shades.shade5;
      } else if (variant === 'ghost') {
        return ColoursObj.shades.shade5;
      } else if (variant === 'borderless') {
        return ColoursObj.core.secondary;
      } else if (variant === 'dialogue') {
        return ColoursObj.backgrounds.dialogue;
      } else if (variant === 'destructive') {
        return ColoursObj.shades.shade5;
      } else if (variant === 'destructiveSecondary') {
        return ColoursObj.shades.shade5;
      } else if (variant === 'destructiveGhost') {
        return ColoursObj.states.error;
      } else if (variant === 'destructiveBorderless') {
        return ColoursObj.states.error;
      } else {
        return ColoursObj.shades.shade5;
      }
    } else {
      if (fontColour) {
        return fontColour;
      } else if (variant === 'secondary') {
        return ColoursObj.core.secondary;
      } else if (variant === 'ghost') {
        return ColoursObj.shades.shade5;
      } else if (variant === 'borderless') {
        return ColoursObj.core.secondary;
      } else if (variant === 'dialogue') {
        return ColoursObj.backgrounds.dialogue;
      } else if (variant === 'destructive') {
        return ColoursObj.shades.shade5;
      } else if (variant === 'destructiveSecondary') {
        return ColoursObj.states.error;
      } else if (variant === 'destructiveGhost') {
        return ColoursObj.states.error;
      } else if (variant === 'destructiveBorderless') {
        return ColoursObj.states.error;
      } else {
        return ColoursObj.shades.shade5;
      }
    }
  }
  return /*#__PURE__*/React__default.createElement(Button, {
    id: id,
    variant: variant,
    size: size ?? 'large',
    disabled: disabled ? true : false,
    disableRipple: true,
    style: {
      color: disabled ? ColoursObj.shades.shade2 : undefined,
      width: wrap ? 'max-content' : undefined,
      ...style
    },
    sx: {
      color: disabled ? ColoursObj.shades.shade2 : getFontColour(),
      ':hover': {
        color: disabled ? ColoursObj.shades.shade2 : getFontColour(true)
      },
      ':focus': {
        color: disabled ? ColoursObj.shades.shade2 : getFontColour(true)
      }
    },
    startIcon: !loading && icon && iconPosition === 'left' ? ( /*#__PURE__*/React__default.createElement(Icon, {
      name: icon,
      iconColour: iconColour ?? 'currentColor'
    })) : null,
    endIcon: !loading && icon && iconPosition === 'right' ? ( /*#__PURE__*/React__default.createElement(Icon, {
      name: icon,
      iconColour: iconColour ?? 'currentColor'
    })) : null,
    onClick: e => {
      NativeUtils.hapticFeedback(hapticFeedback ?? 'light'), onClick && onClick(e);
    },
    tabIndex: tabIndex
  }, loading && ( /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      position: 'absolute'
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Loading',
    iconColour: 'currentColor'
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      visibility: loading ? 'hidden' : undefined,
      display: 'flex',
      gap: text ? '8px' : '0',
      alignItems: 'center',
      fill: 'red'
    },
    color: 'inherit'
  }, !iconPosition && icon && /*#__PURE__*/React__default.createElement(Icon, {
    name: icon,
    iconColour: iconColour ?? 'currentColor'
  }), text && ( /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyRegular',
    color: 'inherit'
  }, text)), children));
};

const TextInputField = props => {
  return /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, props.muiTextFieldProps, {
    multiline: props.multiline,
    id: props.id,
    rows: props.rows,
    fullWidth: props.multiline,
    "data-testid": props['data-testid'],
    value: props.value ?? '',
    placeholder: props.helperText,
    error: props.error,
    disabled: props.disabled,
    autoComplete: 'new-password',
    label: props.fieldLabel && ( /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: 'bodySubtext',
      style: {
        color: ColoursObj.font.primary,
        opacity: props.disabled ? '0.38' : '1'
      }
    }, props.fieldLabel, props.required && ' *'), props.helperTooltip && ( /*#__PURE__*/React__default.createElement(Tooltip$1, {
      title: props.helperTooltip,
      placement: 'right-start',
      arrow: true
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        height: 'fit-content',
        padding: '0 0 0 8px'
      }
    }, props.helperIcon && props.helperIcon, !props.helperIcon && /*#__PURE__*/React__default.createElement(Help, {
      height: 16,
      width: 16
    })))))),
    defaultValue: props.defaultValue,
    onChange: props.onChange,
    onClick: e => {
      NativeUtils.hapticFeedback(props.hapticFeedback ?? 'light'), props.onClick && props.onClick(e);
    },
    onFocus: props.onFocus && props.onFocus,
    onBlur: props.onBlur && props.onBlur,
    helperText: props.errorMessage ? props.errorMessage : null,
    type: props.type,
    style: {
      marginTop: props.fieldLabel ? '8px' : '0px',
      ...props.style
    },
    inputRef: props.inputRef,
    InputProps: {
      ...props.inputProps,
      readOnly: props.readOnly,
      startAdornment: props.iconLeft ? /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: 'start'
      }, props.iconLeft) : null,
      endAdornment: props.iconRight ? /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: 'end'
      }, props.iconRight) : null,
      style: props.inputStyle
    },
    sx: {
      Label: {
        transform: 'translateY(-8px)',
        padding: '0 0 0 8px'
      },
      ...(props.multiline && {
        '& .MuiOutlinedInput-root': {
          height: `${32 * (props.rows ?? 1)}px`,
          padding: '0px 8px',
          transition: 'none'
        }
      })
    }
  }), props.children);
};

const FilterButtonDropdown = ({
  filterTitle,
  onChange,
  selected,
  sections,
  entries,
  radioButtons,
  singleSelect,
  removeSearch
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState();
  const [search, setSearch] = useState();
  const [selectedSection, setSelectedSection] = useState();
  const [options, setOptions] = useState({
    entries: entries,
    sections: sections
  });
  const [filteredOptions, setFilteredOptions] = useState({
    entries: entries,
    sections: sections
  });
  const [selectedOptions, setSelectedOptions] = useState(selected ?? []);
  const clickHandler = useCallback(e => {
    setSubMenuOpen(undefined);
    setMenuOpen(false);
  }, []);
  useEffect(() => {
    window.addEventListener('click', clickHandler);
    return () => window.removeEventListener('click', clickHandler);
  }, []);
  useEffect(() => {
    onChange(selectedOptions);
  }, [selectedOptions]);
  useEffect(() => {
    selected && setSelectedOptions(selected);
  }, [selected]);
  useEffect(() => {
    setOptions({
      entries: entries,
      sections: sections
    });
  }, [entries, sections]);
  useEffect(() => {
    function filterEntries(entries) {
      return entries.filter(entry => {
        if (entry.displayName.toString().toLowerCase().includes(search ? search.toLowerCase() : '') || entry.id.toString().toLowerCase().includes(search ? search.toLowerCase() : '')) {
          return true;
        } else {
          return false;
        }
      });
    }
    const tempEntries = filterEntries(options.entries ?? []);
    let tempSections = [];
    if (options.sections) {
      var _options$sections;
      (_options$sections = options.sections) === null || _options$sections === void 0 ? void 0 : _options$sections.forEach(section => {
        const tempSection = {
          ...section,
          entries: filterEntries(section.entries ?? [])
        };
        if (tempSection.entries.length > 0) {
          tempSections.push(tempSection);
        }
      });
    }
    setFilteredOptions({
      entries: tempEntries,
      sections: tempSections
    });
  }, [search, options]);
  useEffect(() => {
    if (subMenuOpen !== undefined) {
      if (filteredOptions.sections) {
        const filteredSelectedSection = filteredOptions.sections.find(section => {
          return section.id === (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.id);
        });
        if (filteredSelectedSection) {
          setSelectedSection(filteredSelectedSection);
        } else {
          selectedSection && setSelectedSection({
            ...selectedSection,
            entries: []
          });
        }
      }
    }
  }, [filteredOptions.sections]);
  function getNumberSelectedSection(section) {
    if (section.entries) {
      const included = section.entries.filter(entry => {
        return selectedOptions.includes(entry.id);
      });
      return included.length;
    } else {
      return 0;
    }
  }
  function returnSections(section) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        backgroundColor: subMenuOpen === section.id ? '#EBF9F8' : 'unset',
        position: 'relative'
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        boxSizing: 'border-box',
        padding: '10px 16px 10px 22px',
        height: '60px',
        border: 'solid ' + ColoursObj.shades.shade3,
        borderWidth: '0 0 1px 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      onClick: e => {
        e.stopPropagation();
        section === selectedSection ? setSelectedSection(undefined) : setSelectedSection(section);
        section.id === subMenuOpen ? setSubMenuOpen(undefined) : setSubMenuOpen(section.id);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        width: 'fit-content',
        gap: '8px'
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: 'bodyRegular'
    }, section.displayName), getNumberSelectedSection(section) > 0 ? ( /*#__PURE__*/React__default.createElement("div", {
      style: {
        backgroundColor: ColoursObj.core.secondary,
        color: ColoursObj.shades.shade5,
        height: '26px',
        width: '24px',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, getNumberSelectedSection(section) > 0 && getNumberSelectedSection(section))) : ( /*#__PURE__*/React__default.createElement("div", {
      style: {
        backgroundColor: subMenuOpen === section.id ? '#EBF9F8' : 'unset',
        height: '26px',
        width: '24px'
      }
    }))), /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Chevron_Right'
    })));
  }
  function returnEntry(entry) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        boxSizing: 'border-box',
        height: '60px',
        padding: '5px 8px',
        border: 'solid ' + ColoursObj.shades.shade3,
        borderWidth: '0 0 1px 0',
        display: 'flex',
        position: 'relative',
        alignItems: 'center'
      },
      onClick: e => {
        e.stopPropagation();
        singleSelect ? selectedOptions.includes(entry.id) ? setSelectedOptions([]) : setSelectedOptions([entry.id]) : selectedOptions.includes(entry.id) ? setSelectedOptions(selectedOptions.filter(entryId => entryId !== entry.id)) : setSelectedOptions(selectedOptions.concat(entry.id));
      }
    }, radioButtons ? ( /*#__PURE__*/React__default.createElement(Radio, {
      style: {
        paddingLeft: '0'
      },
      checked: selectedOptions.includes(entry.id)
    })) : ( /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: selectedOptions.includes(entry.id)
    })), /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: 'bodyRegular',
      style: {
        maxWidth: '286px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }, entry.displayName));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    style: {
      position: 'relative',
      width: 'fit-content',
      borderRadius: '4px',
      border: '1px solid ' + ColoursObj.shades.shade3,
      backgroundColor: ColoursObj.shades.shade5
    },
    text: filterTitle,
    fontColour: ColoursObj.font.primary,
    icon: 'Chevron_Down',
    iconPosition: 'right',
    iconColour: ColoursObj.font.primary,
    onClick: e => {
      e.stopPropagation();
      setMenuOpen(!menuOpen);
      setSubMenuOpen(undefined);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: selectedOptions.length > 0 ? ColoursObj.core.secondary : ColoursObj.shades.shade5,
      color: ColoursObj.shades.shade5,
      height: '26px',
      width: '24px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, selectedOptions.length > 0 && selectedOptions.length)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: '0px',
      width: '0px',
      position: 'relative'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      gap: '4px',
      paddingTop: '12px',
      width: 'fit-content'
    }
  }, menuOpen && ( /*#__PURE__*/React__default.createElement(Paper, {
    style: {
      width: '350px',
      maxHeight: '459px',
      borderRadius: '4px',
      border: '1px solid ' + ColoursObj.shades.shade3,
      backgroundColor: ColoursObj.shades.shade5,
      boxSizing: 'border-box'
    }
  }, removeSearch ? ( /*#__PURE__*/React__default.createElement("div", null)) : ( /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '8px',
      height: '40px',
      border: 'solid ' + ColoursObj.shades.shade3,
      borderWidth: '0 0 1px 0'
    }
  }, /*#__PURE__*/React__default.createElement(TextInputField, {
    value: search,
    style: {
      margin: '0px',
      borderRadius: '4px'
    },
    inputStyle: {
      margin: '0',
      borderRadius: '4px'
    },
    helperText: 'Search',
    iconLeft: /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Search',
      iconColour: ColoursObj.shades.shade2
    }),
    onClick: e => {
      e.stopPropagation();
    },
    onChange: e => {
      setSearch(e.currentTarget.value);
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxHeight: '400px',
      borderRadius: '4px',
      backgroundColor: ColoursObj.shades.shade5,
      boxSizing: 'border-box',
      overflow: 'auto'
    }
  }, filteredOptions.entries && filteredOptions.entries.map((entry, i) => /*#__PURE__*/React__default.createElement("div", {
    key: i
  }, returnEntry(entry))), filteredOptions.sections && filteredOptions.sections.map((section, i) => /*#__PURE__*/React__default.createElement("div", {
    key: i
  }, returnSections(section)))))), subMenuOpen && ( /*#__PURE__*/React__default.createElement(Paper, {
    style: {
      height: 'fit-content',
      width: '350px',
      maxWidth: '500px',
      maxHeight: '457px',
      borderRadius: '4px',
      border: '1px solid ' + ColoursObj.shades.shade3,
      backgroundColor: ColoursObj.shades.shade5,
      boxSizing: 'border-box'
    }
  }, selectedSection && selectedSection.entries && selectedSection.entries.map((entry, i) => /*#__PURE__*/React__default.createElement("div", {
    key: i
  }, returnEntry(entry))))))));
};

const ImageUploadButton = ({
  setState,
  maxSize = 0,
  maxHeight = 180,
  maxWidth = 320,
  quality = 0.8
}) => {
  const inputRef = useRef(null);
  const [errorSnack, setErrorSnack] = useState(false);
  const onUpload = function (e) {
    try {
      if (e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (maxSize === 0 || file.size <= maxSize) {
          const blobURL = URL.createObjectURL(file);
          const img = new Image();
          img.src = blobURL;
          img.onload = function () {
            const [newWidth, newHeight] = calculateSize(img, maxWidth, maxHeight);
            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;
            const ctx = canvas.getContext('2d');
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0, newWidth, newHeight);
            const base64 = canvas.toDataURL('image/jpeg', quality);
            setState(base64);
          };
        } else {
          setErrorSnack(true);
        }
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  const calculateSize = (img, maxWidth, maxHeight) => {
    let width = img.width;
    let height = img.height;
    if (width > height) {
      if (width > maxWidth) {
        height = Math.round(height * maxWidth / width);
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width = Math.round(width * maxHeight / height);
        height = maxHeight;
      }
    }
    return [width, height];
  };
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Snackbar, {
    open: errorSnack,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(SnackBarAlert, {
    severity: 'error',
    text: 'File size too big. Max size is: ' + maxSize + ' Bytes',
    onXClick: () => {
      setErrorSnack(false);
    }
  }))), /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'uploadImageButton',
    icon: 'Camera',
    iconPosition: 'left',
    wrap: true,
    onClick: () => {
      if (inputRef.current) {
        inputRef.current.click();
      }
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    onClick: e => {
      e.stopPropagation();
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    ref: inputRef,
    style: {
      display: 'none'
    },
    type: 'file',
    accept: 'image/*',
    onChange: onUpload
  }), "Upload Image")));
};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(interopRequireDefault);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(objectWithoutPropertiesLoose);

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(_extends_1);

var createBreakpoints_1 = createCommonjsModule(function (module, exports) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpointKeys = void 0;
exports.default = createBreakpoints;
var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
var _extends2 = interopRequireDefault(_extends_1);
const _excluded = ["values", "unit", "step"];
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const breakpointKeys = exports.breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl'];
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return (0, _extends2.default)({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },
      unit = 'px',
      step = 5
    } = breakpoints,
    other = (0, _objectWithoutPropertiesLoose2.default)(breakpoints, _excluded);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return (0, _extends2.default)({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
});

var createBreakpoints = unwrapExports(createBreakpoints_1);

const widthBreakpoints = createBreakpoints({
  values: {
    largeDesktop: 2000,
    mediumDesktop: 1712,
    desktop: 990,
    smallWeb: 767,
    tablet: 480,
    mobile: 375,
    xs: 0
  }
});
const theme = generateTheme(ColoursObj);
function generateTheme(ColoursObj) {
  return createTheme({
    breakpoints: widthBreakpoints,
    palette: {
      primary: {
        main: ColoursObj.core.primary
      },
      secondary: {
        main: ColoursObj.core.secondary
      },
      grey: {
        '400': ColoursObj.shades.shade2
      }
    },
    shadows: MuiShaddows,
    typography: {
      allVariants: {
        fontSize: '16px',
        fontWeight: '400',
        fontFamily: 'CountryFlags, Inter-100-500',
        lineHeight: '24px',
        letterSpacing: '0',
        color: ColoursObj.font.primary
      }
    },
    components: {
      MuiTypography: {
        defaultProps: {},
        variants: [{
          props: {
            variant: 'desktopH1'
          },
          style: {
            fontSize: '56px',
            fontWeight: '700',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '64px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'desktopH2'
          },
          style: {
            fontSize: '20px',
            fontWeight: '700',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '28px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'desktopH3'
          },
          style: {
            fontSize: '18px',
            fontWeight: '700',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '32px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'mobileH1'
          },
          style: {
            fontSize: '24px',
            fontWeight: '700',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '32px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'mobileH2'
          },
          style: {
            fontSize: '20px',
            fontWeight: '700',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '32px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'mobileH3'
          },
          style: {
            fontSize: '18px',
            fontWeight: '700',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '24px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodyRegular'
          },
          style: {
            fontSize: '16px',
            fontWeight: '400',
            fontFamily: 'CountryFlags, Inter-100-500',
            lineHeight: '24px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodyBold'
          },
          style: {
            fontSize: '16px',
            fontWeight: '600',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '24px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodyBoldUnderlined'
          },
          style: {
            fontSize: '16px',
            fontWeight: '600',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '24px',
            textDecoration: 'underline',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodyRegularUnderlined'
          },
          style: {
            fontSize: '16px',
            fontWeight: '400',
            fontFamily: 'CountryFlags, Inter-100-500',
            lineHeight: '24px',
            textDecoration: 'underline',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodyRegularStrikethrough'
          },
          style: {
            fontSize: '16px',
            fontWeight: '400',
            fontFamily: 'CountryFlags, Inter-100-500',
            lineHeight: '24px',
            textDecoration: 'line-through',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodySubtext'
          },
          style: {
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'CountryFlags, Inter-100-500',
            lineHeight: '16px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodySubtextBold'
          },
          style: {
            fontSize: '14px',
            fontWeight: '700',
            fontFamily: 'CountryFlags, Inter-600-900',
            lineHeight: '16px',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodySubtextUnderlined'
          },
          style: {
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'CountryFlags, Inter-100-500',
            lineHeight: '16px',
            textDecoration: 'underline',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodySubtextStrikethrough'
          },
          style: {
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'CountryFlags, Inter-100-500',
            lineHeight: '16px',
            textDecoration: 'line-through',
            color: ColoursObj.font.primary
          }
        }, {
          props: {
            variant: 'bodyError'
          },
          style: {
            fontSize: '16px',
            fontWeight: '400',
            fontFamily: 'CountryFlags, Inter-100-500',
            lineHeight: '24px',
            color: ColoursObj.states.error
          }
        }, {
          props: {
            variant: 'timeSmall'
          },
          style: {
            fontSize: '12px',
            fontWeight: '400',
            fontFamily: 'CountryFlags, Inter-100-500',
            lineHeight: '16px',
            color: ColoursObj.font.secondary
          }
        }]
      },
      MuiButton: {
        styleOverrides: {
          root: {
            boxSizing: 'border-box',
            height: '44px',
            minWidth: '44px',
            backgroundColor: ColoursObj.core.secondary,
            color: ColoursObj.shades.shade5,
            textTransform: 'none',
            borderRadius: '8px',
            padding: '0px 16px',
            margin: 0,
            border: '1px solid ' + ColoursObj.core.secondary,
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '24px',
            '&.Mui-disabled': {
              backgroundColor: ColoursObj.shades.shade4,
              color: ColoursObj.shades.shade2,
              border: '1px solid',
              borderColor: ColoursObj.shades.shade2
            },
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondaryHover
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondary
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondaryHover
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondary
              }
            },
            '&:active': {
              backgroundColor: ColoursObj.core.secondaryActive
            },
            '&.MuiButton-sizeSmall': {
              height: '32px',
              minWidth: '20px',
              padding: '4px 16px'
            }
          },
          startIcon: {
            margin: '0 8px 0 0'
          },
          endIcon: {
            margin: '0 0 0 8px'
          }
        },
        variants: [{
          props: {
            variant: 'secondary'
          },
          style: {
            backgroundColor: ColoursObj.backgrounds.primary,
            border: '1px solid',
            borderColor: ColoursObj.core.secondary,
            '&.Mui-disabled': {
              backgroundColor: ColoursObj.shades.shade4,
              color: ColoursObj.shades.shade3,
              border: '1px solid',
              borderColor: ColoursObj.shades.shade2
            },
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondary
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: ColoursObj.backgrounds.primary
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondary
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: ColoursObj.backgrounds.primary
              }
            },
            '&:active': {
              backgroundColor: ColoursObj.backgrounds.secondary
            }
          }
        }, {
          props: {
            variant: 'ghost'
          },
          style: {
            backgroundColor: 'transparent',
            border: '1px solid',
            borderColor: ColoursObj.shades.shade5,
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: '#C9D9D8'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: '#C9D9D8'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:active': {
              backgroundColor: 'transparent',
              padding: '8px 14px',
              border: '2px solid'
            },
            '&.Mui-disabled': {
              backgroundColor: 'transparent',
              color: ColoursObj.shades.shade2,
              borderColor: ColoursObj.shades.shade2
            }
          }
        }, {
          props: {
            variant: 'borderless'
          },
          style: {
            backgroundColor: 'transparent',
            color: ColoursObj.core.secondary,
            border: '1px solid transparent',
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                borderColor: ColoursObj.core.secondary,
                backgroundColor: 'transparent',
                border: '1px solid'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent',
                borderColor: 'transparent'
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                borderColor: ColoursObj.core.secondary,
                backgroundColor: 'transparent',
                border: '1px solid'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent',
                borderColor: 'transparent'
              }
            },
            '&:active': {
              backgroundColor: '#C9D9D8'
            },
            '&.Mui-disabled': {
              backgroundColor: 'transparent',
              color: ColoursObj.shades.shade3,
              border: 'none'
            }
          }
        }, {
          props: {
            variant: 'dialogue'
          },
          style: {
            backgroundColor: 'transparent',
            border: 'none',
            color: ColoursObj.core.secondary,
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: 'transparent'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: 'transparent'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:active': {
              backgroundColor: '#C9D9D8'
            },
            '&.Mui-disabled': {
              backgroundColor: 'transparent',
              color: ColoursObj.shades.shade3,
              border: 'none'
            }
          }
        }, {
          props: {
            variant: 'destructive'
          },
          style: {
            backgroundColor: ColoursObj.states.error,
            border: '1px solid ' + ColoursObj.states.error,
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.states.errorHover
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: ColoursObj.states.error
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.states.errorHover
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: ColoursObj.states.error
              }
            },
            '&:active': {
              backgroundColor: ColoursObj.states.errorActive
            }
          }
        }, {
          props: {
            variant: 'destructiveSecondary'
          },
          style: {
            backgroundColor: 'transparent',
            border: '1px solid',
            borderColor: ColoursObj.states.error,
            color: ColoursObj.states.error,
            '&.Mui-disabled': {
              backgroundColor: ColoursObj.shades.shade4,
              color: ColoursObj.shades.shade3,
              border: '1px solid',
              borderColor: ColoursObj.shades.shade2
            },
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.states.errorHover,
                color: ColoursObj.shades.shade5
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.states.errorHover,
                color: ColoursObj.shades.shade5
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:active': {
              backgroundColor: ColoursObj.states.error,
              border: '1px solid',
              borderColor: ColoursObj.states.error,
              color: ColoursObj.states.error
            }
          }
        }, {
          props: {
            variant: 'destructiveGhost'
          },
          style: {
            backgroundColor: 'transparent',
            border: '1px solid',
            borderColor: ColoursObj.states.error,
            color: ColoursObj.states.error,
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: '#DCCAC8'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: '#DCCAC8'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:active': {
              backgroundColor: ColoursObj.states.error,
              border: '1px solid'
            },
            '&.Mui-disabled': {
              backgroundColor: 'transparent',
              color: ColoursObj.shades.shade2,
              borderColor: ColoursObj.shades.shade2
            }
          }
        }, {
          props: {
            variant: 'destructiveBorderless'
          },
          style: {
            backgroundColor: 'transparent',
            color: ColoursObj.states.error,
            border: '1px solid transparent',
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                borderColor: ColoursObj.states.error,
                backgroundColor: 'transparent',
                border: '1px solid'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:focus': {
              [widthBreakpoints.up('smallWeb')]: {
                borderColor: ColoursObj.states.error,
                backgroundColor: 'transparent',
                border: '1px solid'
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: 'transparent'
              }
            },
            '&:active': {
              backgroundColor: '#DCCAC8'
            },
            '&.Mui-disabled': {
              backgroundColor: 'transparent',
              color: ColoursObj.shades.shade3,
              border: 'none'
            }
          }
        }, {
          props: {
            variant: 'menuButton'
          },
          style: {
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            justifyItems: 'start',
            backgroundColor: ColoursObj.shades.shade4,
            width: '100%',
            height: '56px',
            border: 'none',
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: ColoursObj.shades.shade4
            },
            '&:focus': {
              backgroundColor: ColoursObj.shades.shade4
            }
          }
        }]
      },
      MuiToggleButton: {
        styleOverrides: {
          root: {
            boxSizing: 'border-box',
            height: '44px',
            minWidth: '44px',
            backgroundColor: ColoursObj.core.secondary,
            color: ColoursObj.shades.shade5,
            textTransform: 'none',
            borderRadius: '8px',
            padding: '10px 16px',
            margin: '0',
            border: 'none',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '24px',
            '&.Mui-disabled': {
              backgroundColor: ColoursObj.shades.shade4,
              color: ColoursObj.shades.shade2
            },
            ':hover': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondaryHover
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondary
              }
            },
            ':focus': {
              [widthBreakpoints.up('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondaryHover
              },
              [widthBreakpoints.down('smallWeb')]: {
                backgroundColor: ColoursObj.core.secondary
              }
            },
            '&.Mui-selected': {
              backgroundColor: ColoursObj.core.secondaryActive,
              color: ColoursObj.shades.shade5,
              ':hover': {
                backgroundColor: ColoursObj.core.secondaryActive,
                color: ColoursObj.shades.shade5
              },
              ':focus': {
                backgroundColor: ColoursObj.core.secondaryActive,
                color: ColoursObj.shades.shade5
              }
            },
            '&.MuiToggleButton-sizeSmall': {
              height: '32px',
              minWidth: '20px',
              padding: '4px 16px'
            }
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            backgroundColor: ColoursObj.shades.shade5,
            color: ColoursObj.shades.shade3,
            '&::placeholder': {
              color: ColoursObj.shades.shade3
            },
            '&.MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
              padding: 0
            }
          }
        }
      },
      MuiInput: {
        styleOverrides: {
          root: {
            border: '1px solid ' + ColoursObj.shades.shade3,
            '&::focus': {
              border: '1px solid ' + ColoursObj.shades.shade3,
              display: 'none'
            }
          }
        }
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            width: '100%',
            border: '1px solid ' + ColoursObj.shades.shade2,
            borderRadius: '8px',
            marginTop: '12px',
            color: ColoursObj.font.primary,
            height: '44px',
            padding: '14px 14px',
            '&:hover': {
              [widthBreakpoints.up('smallWeb')]: {
                border: '2px solid #BBDEE6',
                padding: '14px 13px'
              }
            },
            '&:focus': {
              border: '2px solid ' + ColoursObj.core.secondary,
              padding: '14px 13px'
            },
            '&.Mui-error': {
              border: '2px solid ' + ColoursObj.states.error,
              padding: '14px 13px'
            },
            '&.Mui-focused': {
              border: '2px solid ' + ColoursObj.core.secondary,
              padding: '14px 13px'
            }
          },
          notchedOutline: {
            outline: 'none',
            border: 'none'
          },
          input: {
            padding: '8px 0px',
            color: ColoursObj.core.primary,
            '&focus': {
              border: '2px solid ' + ColoursObj.core.secondary
            },
            '&.Mui-disabled': {
              opacity: '0.38'
            }
          }
        }
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginTop: '0px',
            minHeight: '20px'
          }
        }
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            display: 'block',
            marginTop: '8px'
          }
        }
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            '&.Mui-disabled': {
              backgroundColor: ColoursObj.shades.shade4
            }
          },
          underline: {
            '&&&:before': {
              border: 'none'
            }
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            width: '100%',
            height: '38px',
            color: ColoursObj.core.primary
          }
        }
      },
      MuiList: {
        styleOverrides: {
          root: {
            padding: '0px 0px',
            height: 'auto',
            color: ColoursObj.core.primary
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          root: {
            backgroundColor: ColoursObj.core.secondary,
            color: ColoursObj.shades.shade5,
            margin: '4px 0'
          }
        }
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: ColoursObj.shades.shade1,
            '&.Mui-checked': {
              color: ColoursObj.core.secondary
            }
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            borderRadius: '8px'
          }
        },
        variants: [{
          props: {
            variant: 'tagBox'
          },
          style: {
            padding: '0 12px 0 12px',
            margin: '0',
            height: '24px'
          }
        }, {
          props: {
            variant: 'outlined'
          },
          style: {
            border: '1px solid ' + ColoursObj.shades.shade2
          }
        }, {
          props: {
            variant: 'elevation'
          },
          style: {
            boxShadow: '0px 8px 16px 0px rgba(16, 55, 92, 0.1)'
          }
        }]
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: ColoursObj.core.primary + '!important'
          },
          arrow: {
            color: ColoursObj.core.primary + '!important'
          }
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          size: 'small'
        },
        styleOverrides: {
          root: {
            '& .MuiChip-filledDefault': {
              width: '100px'
            }
          },
          inputRoot: {
            padding: 14,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            '&:hover': {
              padding: '13px'
            },
            '&:focus': {
              padding: '13px'
            }
          },
          input: {
            padding: '0',
            '&.MuiAutocomplete-input': {
              width: '100%',
              padding: 0
            }
          }
        }
      },
      MuiSwitch: {
        styleOverrides: {
          root: {
            alignItems: 'center',
            justifyContent: 'center',
            padding: '8px',
            '& .MuiButtonBase-root': {
              padding: '19%',
              '& .MuiSwitch-thumb': {
                height: 16,
                width: 16,
                boxShadow: 'none',
                backgroundColor: ColoursObj.shades.shade5
              }
            },
            '& .MuiSwitch-track': {
              height: 20,
              width: 40,
              borderRadius: 12,
              backgroundColor: ColoursObj.shades.shade2,
              opacity: '1 !important'
            },
            '& .Mui-checked+.MuiSwitch-track': {
              opacity: '1 !important',
              backgroundColor: ColoursObj.core.secondary + ' !important'
            }
          }
        }
      },
      MuiTextField: {
        defaultProps: {
          InputLabelProps: {
            shrink: true,
            style: {
              padding: '0px'
            }
          }
        },
        styleOverrides: {
          root: {
            width: '100%',
            borderRadius: '8px',
            '& .MuiOutlinedInput-root': {
              background: ColoursObj.backgrounds.input
            },
            '& .MuiOutlinedInput-root.Mui-focused': {
              BorderColor: ColoursObj.shades.shade2
            }
          }
        }
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            transform: 'translate(0px, -8px)'
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: '0px'
          }
        }
      },
      MuiDialog: {
        styleOverrides: {
          root: {},
          paper: {
            borderRadius: '12px'
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            '& .MuiPickersCalendarHeader-root': {
              '& .MuiSvgIcon-root': {
                color: ColoursObj.core.secondary
              }
            }
          }
        }
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            '& .MuiSvgIcon-root': {
              fontSize: '1.75rem'
            },
            '&.Mui-checked': {
              color: ColoursObj.core.secondary
            }
          }
        }
      },
      MuiPickersLayout: {
        styleOverrides: {
          root: {
            '& .MuiPickersLayout-toolbar': {
              display: 'grid',
              gridTemplateRows: '0px 1fr',
              gridTemplateColumns: '1fr'
            }
          },
          toolbar: {}
        }
      },
      MuiPickersToolbarText: {
        styleOverrides: {
          root: {
            padding: '8px',
            borderRadius: '4px',
            border: 'none',
            fontSize: '56px',
            lineHeight: '1em',
            color: ColoursObj.shades.shade1,
            '&.Mui-selected': {
              padding: '6px',
              border: '2px solid ' + ColoursObj.core.secondary,
              color: ColoursObj.core.secondary
            }
          }
        }
      },
      MuiPickersToolbarButton: {
        styleOverrides: {
          root: {
            borderRadius: '4px',
            boxSizing: 'border-box',
            border: 'none',
            backgroundColor: '#ebf9f8',
            height: 'fit-content',
            ':hover': {
              backgroundColor: '#ebf9f8'
            },
            ':focus': {
              backgroundColor: '#ebf9f8'
            }
          }
        }
      },
      MuiPickersToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: 'none'
          },
          content: {
            width: '100%',
            backgroundColor: ColoursObj.shades.shade5,
            justifyContent: 'center'
          }
        }
      },
      MuiTimePickerToolbar: {
        styleOverrides: {
          hourMinuteLabel: {
            height: '60px',
            alignItems: 'center',
            width: '220px'
          },
          separator: {
            alignItems: 'center',
            lineHeight: '75px',
            margin: '0 4px'
          },
          ampmSelection: {
            marginRight: '0',
            borderRadius: '4px',
            backgroundColor: '#ebf9f8'
          }
        }
      },
      MuiClock: {
        styleOverrides: {
          pin: {
            backgroundColor: ColoursObj.core.secondary
          }
        }
      },
      MuiClockPointer: {
        styleOverrides: {
          root: {
            backgroundColor: ColoursObj.core.secondary
          },
          thumb: {
            borderColor: ColoursObj.core.secondary,
            backgroundColor: ColoursObj.core.secondary
          }
        }
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            paddingBottom: 'env(safe-area-inset-bottom)'
          }
        }
      },
      MuiPopover: {
        styleOverrides: {
          paper: {
            background: ColoursObj.backgrounds.secondary
          }
        }
      },
      MuiClockNumber: {
        styleOverrides: {
          root: {
            color: ColoursObj.font.primary
          }
        }
      }
    }
  });
}

const SelectButton = ({
  children,
  text,
  size = 'large',
  variant,
  disabled = false,
  icon,
  iconPosition,
  style,
  onClick,
  selected
}) => {
  const disabledColor = variant === 'secondary' ? ColoursObj.shades.shade3 : ColoursObj.shades.shade2;
  const hover = useMediaQuery(generateTheme(ColoursObj).breakpoints.up('smallWeb'));
  switch (variant) {
    case undefined:
      return /*#__PURE__*/React__default.createElement(ToggleButton, {
        value: 'toggle',
        selected: selected,
        size: size,
        disabled: disabled ? true : false,
        disableRipple: true,
        style: {
          color: disabled ? disabledColor : undefined,
          ...style
        },
        onClick: onClick
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginRight: iconPosition === 'left' ? '8px' : '0'
        }
      }, iconPosition === 'left' && icon && ( /*#__PURE__*/React__default.createElement(Icon, {
        name: icon,
        iconColour: disabled ? ColoursObj.shades.shade2 : ColoursObj.shades.shade5
      }))), /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'flex'
        }
      }, !iconPosition && icon && ( /*#__PURE__*/React__default.createElement(Icon, {
        name: icon,
        iconColour: disabled ? ColoursObj.shades.shade2 : ColoursObj.shades.shade5
      })), text, children), /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginLeft: iconPosition === 'right' ? '8px' : '0'
        }
      }, iconPosition === 'right' && icon && ( /*#__PURE__*/React__default.createElement(Icon, {
        name: icon,
        iconColour: disabled ? ColoursObj.shades.shade2 : ColoursObj.shades.shade5
      }))));
    case 'secondary':
      return /*#__PURE__*/React__default.createElement(ToggleButton, {
        value: 'toggle',
        selected: selected,
        size: size,
        disabled: disabled ? true : false,
        disableRipple: true,
        style: {
          ...style
        },
        sx: {
          color: disabled ? disabledColor : ColoursObj.core.secondary,
          backgroundColor: ColoursObj.shades.shade5,
          borderColor: ColoursObj.core.secondary,
          ':hover': {
            backgroundColor: hover ? ColoursObj.shades.shade5 : ColoursObj.core.secondary,
            color: hover ? ColoursObj.core.secondary : ColoursObj.shades.shade5
          },
          ':fpocus': {
            backgroundColor: hover ? ColoursObj.shades.shade5 : ColoursObj.core.secondary,
            color: hover ? ColoursObj.core.secondary : ColoursObj.shades.shade5
          },
          '&.Mui-selected': {
            backgroundColor: ColoursObj.core.secondaryActive,
            color: ColoursObj.shades.shade5,
            ':hover': {
              backgroundColor: ColoursObj.core.secondaryActive,
              color: ColoursObj.shades.shade5
            },
            ':focus': {
              backgroundColor: ColoursObj.core.secondaryActive,
              color: ColoursObj.shades.shade5
            }
          }
        },
        onClick: onClick
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginRight: iconPosition === 'left' ? '8px' : '0'
        }
      }, iconPosition === 'left' && icon && ( /*#__PURE__*/React__default.createElement(Icon, {
        name: icon,
        iconColour: disabled ? ColoursObj.shades.shade2 : ColoursObj.core.secondary
      }))), /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'flex'
        }
      }, !iconPosition && icon && ( /*#__PURE__*/React__default.createElement(Icon, {
        name: icon,
        iconColour: disabled ? ColoursObj.shades.shade2 : ColoursObj.core.secondary
      })), text, children), /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginLeft: iconPosition === 'right' ? '8px' : '0'
        }
      }, iconPosition === 'right' && icon && ( /*#__PURE__*/React__default.createElement(Icon, {
        name: icon,
        iconColour: disabled ? ColoursObj.shades.shade2 : ColoursObj.core.secondary
      }))));
    case 'borderless':
      return /*#__PURE__*/React__default.createElement("div", null);
    case 'ghost':
      return /*#__PURE__*/React__default.createElement("div", null);
    case 'destructive':
      return /*#__PURE__*/React__default.createElement("div", null);
    case 'destructiveSecondary':
      return /*#__PURE__*/React__default.createElement("div", null);
    case 'destructiveGhost':
      return /*#__PURE__*/React__default.createElement("div", null);
    case 'destructiveBorderless':
      return /*#__PURE__*/React__default.createElement("div", null);
    default:
      return /*#__PURE__*/React__default.createElement("div", null);
  }
};

const ClaimHide = ({
  children,
  paths,
  claims
}) => {
  if (checkClaimsWeb(paths, claims)) {
    return /*#__PURE__*/React__default.createElement("div", null, children);
  } else {
    return /*#__PURE__*/React__default.createElement("div", null);
  }
};

const CoreImagesStoriesComp = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: '175px',
      width: '683px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'mobileH1'
  }, "DefaultCoverImage"), /*#__PURE__*/React__default.createElement(DefaultCoverImage, null));
};

const TicketIcon = ({
  name,
  iconColour
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'grid',
      gridTemplateRows: '0px 0px',
      padding: '0px',
      height: '24px',
      width: '70px'
    }
  }, /*#__PURE__*/React__default.createElement(TicketLine, {
    height: '24px'
  }), /*#__PURE__*/React__default.createElement(Icon, {
    name: name,
    width: '70px',
    iconColour: iconColour
  }));
};

const MobileFrameDialog = ({
  children
}) => {
  return /*#__PURE__*/React__default.createElement(DialogContent, {
    style: {
      background: ColoursObj.backgrounds.dialogue,
      padding: '0px'
    }
  }, /*#__PURE__*/React__default.createElement(Stack, null, children));
};

const MobileConfirmDialog = ({
  header,
  onCancel,
  onConfirm,
  text,
  confirmBtnTextColour,
  cancelBtnTextColour,
  secondaryText,
  footerText,
  cancelText = 'Cancel',
  confirmText = 'Yes',
  confirmBtnStyle = 'dialogue',
  cancelBtnStyle = 'dialogue'
}) => {
  return /*#__PURE__*/React__default.createElement(MobileFrameDialog, null, header && ( /*#__PURE__*/React__default.createElement(DialogTitle, {
    id: 'overlay-mobile-confirm-dialogue-header',
    display: 'flex',
    justifyContent: 'center',
    style: {
      background: ColoursObj.backgrounds.dialogue
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyBold'
  }, header))), /*#__PURE__*/React__default.createElement(DialogContent, {
    style: {
      background: ColoursObj.backgrounds.dialogue
    }
  }, /*#__PURE__*/React__default.createElement(DialogContentText, {
    display: 'flex',
    justifyContent: 'center',
    id: 'alert-dialog-slide-description'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'column'
  }, secondaryText && ( /*#__PURE__*/React__default.createElement(Typography, {
    textAlign: 'center',
    variant: 'bodySubtextBold'
  }, secondaryText)), /*#__PURE__*/React__default.createElement(Typography, {
    textAlign: 'center',
    variant: 'bodyRegular'
  }, text), footerText && ( /*#__PURE__*/React__default.createElement(Typography, {
    textAlign: 'center',
    variant: 'bodySubtext'
  }, footerText))))), /*#__PURE__*/React__default.createElement(Divider, {
    style: {
      background: ColoursObj.shades.shade3
    }
  }), /*#__PURE__*/React__default.createElement(DialogActions, {
    style: {
      padding: '0px',
      background: ColoursObj.backgrounds.secondary
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    width: '100%',
    minWidth: '200px',
    display: 'grid',
    gridTemplateColumns: confirmText ? '1fr auto 1fr' : '1fr',
    style: {
      background: ColoursObj.backgrounds.dialogue
    }
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'overlay-mobile-confirm-dialogue-cancel-button',
    size: 'large',
    style: {
      height: '56px'
    },
    variant: cancelBtnStyle,
    fontColour: cancelBtnTextColour ?? 'secondary',
    onClick: onCancel
  }, cancelText), confirmText && ( /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Divider, {
    orientation: 'vertical',
    flexItem: true,
    style: {
      background: ColoursObj.shades.shade3,
      height: 'auto'
    }
  }), /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'overlay-mobile-confirm-dialogue-confirm-button',
    size: 'large',
    style: {
      height: '56px'
    },
    variant: confirmBtnStyle,
    onClick: onConfirm
  }, /*#__PURE__*/React__default.createElement(Fragment, null, confirmText.includes('Add') ? ( /*#__PURE__*/React__default.createElement(Typography, {
    color: confirmBtnTextColour ?? 'secondary'
  }, confirmText)) : ( /*#__PURE__*/React__default.createElement(Typography, {
    color: confirmBtnTextColour ?? ColoursObj.states.error
  }, confirmText)))))))));
};

const useDialogStore = create()(set => ({
  dialog: null,
  replaceDialog: dialog => {
    set({
      dialog: dialog
    });
  },
  clearDialog: () => {
    set({
      dialog: null
    });
  }
}));
const MobileDialog = ({
  dialog
}) => {
  const {
    clearDialog
  } = useDialogStore(useShallow(s => ({
    clearDialog: s.clearDialog
  })));
  return /*#__PURE__*/React__default.createElement(Dialog, {
    open: dialog && dialog.node ? true : false,
    style: {
      backdropFilter: 'blur(2px)',
      backgroundColor: ColoursObj.backgrounds.primary + '80'
    },
    onClose: (_, reason) => {
      if (dialog !== null && dialog !== void 0 && dialog.backdropClosable) {
        if (reason === 'backdropClick') {
          clearDialog();
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    key: 'dialog',
    id: 'dialogContent'
  }, dialog && dialog.node));
};

const CalenderDrawer = ({
  eventrDateString,
  close,
  onSave,
  onClear,
  hidePast,
  initialState,
  minDate,
  maxDate,
  extendMinMaxByDays,
  locale = 'en-GB',
  saveText = 'Save',
  clearText = 'Clear'
}) => {
  const extendedMinDate = minDate === null || minDate === void 0 ? void 0 : minDate.getCloneEventrDate();
  if (extendedMinDate && extendMinMaxByDays) {
    extendedMinDate.subtract({
      days: extendMinMaxByDays ?? 0
    });
  }
  const extendedMaxDate = maxDate === null || maxDate === void 0 ? void 0 : maxDate.getCloneEventrDate();
  if (extendedMaxDate && extendMinMaxByDays) {
    extendedMaxDate.add({
      days: extendMinMaxByDays ?? 0
    });
  }
  const todayEventrDate = new EventrDate();
  todayEventrDate.clearTimezone();
  const newCleanEventrDate = new EventrDate(initialState);
  newCleanEventrDate.clearTimezone();
  const [selectedDate, setSelectedDate] = useState(eventrDateString ? new EventrDate(eventrDateString) : newCleanEventrDate);
  const [daysDisplayed, setDaysDisplayed] = useState([]);
  useEffect(() => {
    setDaysDisplayed(datesToDisplay((selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.itinLocalLuxon.month) ?? todayEventrDate.itinLocalLuxon.month ?? 1, (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.itinLocalLuxon.year) ?? todayEventrDate.itinLocalLuxon.year ?? 1));
  }, [selectedDate]);
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: '30vh',
        boxShadow: MuiShaddows[1]
      }
    }
  };
  function handleSave() {
    if (!isDateInRange$1(selectedDate, extendedMaxDate, extendedMinDate)) {
      return;
    } else if (isDateInRange$1(selectedDate, maxDate, minDate)) {
      spLogTags('Saving date: ' + (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.dateTimeString), ['eventrdate']);
      onSave(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.dateTimeString);
      spLogTags('Closing datetime drawer', ['eventrdate']);
      close();
      return;
    } else {
      useDialogStore.getState().replaceDialog({
        node: ( /*#__PURE__*/React__default.createElement(MobileConfirmDialog, {
          text: 'This date is outside of the selectable range. Are you sure you want to select: ' + selectedDate.toItinLocalDateString(),
          onConfirm: () => {
            spLogTags('Saving date: ' + (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.dateTimeString), ['eventrdate']);
            onSave(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.dateTimeString);
            spLogTags('Closing datetime drawer', ['eventrdate']);
            close();
            useDialogStore.getState().clearDialog();
          },
          onCancel: () => {
            useDialogStore.getState().clearDialog();
          }
        })),
        backdropClosable: false
      });
      return;
    }
  }
  function handleClear() {
    spLogTags('Clearing date', ['eventrdate']);
    onClear();
    spLogTags('Closing datetime drawer', ['eventrdate']);
    close();
  }
  function handleClick(day) {
    NativeUtils.hapticFeedback('light');
    if ((maxDate || minDate) && !isDateInRange$1(day, extendedMaxDate, extendedMinDate)) {
      return;
    }
    setSelectedDate(day);
  }
  function handleMonthClick(direction) {
    const newSelectedDate = selectedDate.getCloneEventrDate();
    if (direction === 'left') {
      if (selectedDate.itinLocalLuxon.month === 0) {
        newSelectedDate === null || newSelectedDate === void 0 ? void 0 : newSelectedDate.setFromObject({
          year: newSelectedDate.itinLocalLuxon.year ?? 2024 - 1,
          month: 12
        });
      } else {
        const daysInPrevMonth = DateTime.fromObject({
          year: newSelectedDate.itinLocalLuxon.year,
          month: (newSelectedDate.itinLocalLuxon.month ?? 1) - 1
        }).daysInMonth ?? 31;
        if ((newSelectedDate.itinLocalLuxon.day ?? 1) > daysInPrevMonth) {
          newSelectedDate.setFromObject({
            day: daysInPrevMonth
          });
        }
        newSelectedDate.setFromObject({
          month: (newSelectedDate.itinLocalLuxon.month ?? 1) - 1
        });
      }
      setSelectedDate(newSelectedDate);
    } else if (direction === 'right') {
      if (selectedDate.itinLocalLuxon.month === 11) {
        newSelectedDate === null || newSelectedDate === void 0 ? void 0 : newSelectedDate.setFromObject({
          year: (newSelectedDate.itinLocalLuxon.year ?? 2024) + 1,
          month: 0
        });
      } else {
        const daysInNextMonth = DateTime.fromObject({
          year: newSelectedDate.itinLocalLuxon.year,
          month: (newSelectedDate.itinLocalLuxon.month ?? 1) + 1
        }).daysInMonth ?? 31;
        if ((newSelectedDate.itinLocalLuxon.day ?? 1) > daysInNextMonth) {
          newSelectedDate.setFromObject({
            day: daysInNextMonth
          });
        }
        newSelectedDate.setFromObject({
          month: (newSelectedDate.itinLocalLuxon.month ?? 0) + 1
        });
      }
      setSelectedDate(newSelectedDate);
    } else {
      return;
    }
  }
  function handleChangeMonth(month) {
    const newSelectedDate = selectedDate.getCloneEventrDate();
    const daysInSelectedMonth = DateTime.fromObject({
      year: newSelectedDate.itinLocalLuxon.year,
      month: newSelectedDate.itinLocalLuxon.month
    }).daysInMonth ?? 31;
    if ((newSelectedDate.itinLocalLuxon.day ?? 1) > daysInSelectedMonth) {
      newSelectedDate.setFromObject({
        day: daysInSelectedMonth
      });
    }
    newSelectedDate.setFromObject({
      month: month
    });
    setSelectedDate(newSelectedDate);
  }
  function getYears() {
    const thisYear = Number(todayEventrDate.itinLocalLuxon.year);
    var years = [];
    for (let i = thisYear - 90; i < thisYear + 10; i++) {
      const yearDate = new Date();
      yearDate.setFullYear(i);
      years = years.concat(i.toString());
    }
    return years;
  }
  function monthFromValue(value) {
    const newEventrDate = new EventrDate();
    newEventrDate.clearTimezone();
    newEventrDate.setFromObject({
      month: value
    });
    return newEventrDate.utcLuxon.setLocale(locale).toLocaleString({
      month: 'long'
    });
  }
  function getMonths() {
    var months = [];
    for (let monthId = 1; monthId <= 12; monthId++) {
      months.push( /*#__PURE__*/React__default.createElement(MenuItem, {
        value: monthId,
        key: monthId,
        style: {
          background: ColoursObj.backgrounds.primary
        },
        id: 'month:' + monthFromValue(monthId).toLocaleLowerCase()
      }, monthFromValue(monthId)));
    }
    return months;
  }
  function getWeekDays() {
    let weekdays = [];
    for (let dayId = 1; dayId <= 7; dayId++) {
      const newEventrDate = new EventrDate(0);
      newEventrDate.clearTimezone();
      newEventrDate.setFromObject({
        hour: 12,
        weekday: dayId
      });
      weekdays.push(newEventrDate.utcLuxon.setLocale(locale).toLocaleString({
        weekday: 'short'
      }));
    }
    return weekdays;
  }
  function getLabelRow() {
    const weekdays = getWeekDays();
    return weekdays.map((day, index) => ( /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1 0 0'
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: 'bodySubtext',
      color: ColoursObj.core.primary
    }, day))));
  }
  function datesToDisplay(month, year) {
    var days = [];
    const first_day_of_month = selectedDate.getCloneEventrDate();
    first_day_of_month.setFromObject({
      year: year,
      month: month,
      day: 1
    });
    const number_of_days_of_last_month = first_day_of_month.itinLocalLuxon.weekday === 1 ? 7 : (first_day_of_month.itinLocalLuxon.weekday ?? 1) - 1;
    const last_day_previous_month = new EventrDate();
    last_day_previous_month.setFromObject({
      year: year,
      month: month,
      day: 0
    });
    for (let i = last_day_previous_month.itinLocalLuxon.day - number_of_days_of_last_month + 1; i <= last_day_previous_month.itinLocalLuxon.day; i++) {
      const tmpDayToBeAdded = first_day_of_month.getCloneEventrDate();
      tmpDayToBeAdded.setFromObject({
        year: month === 0 ? year - 1 : year,
        month: month === 1 ? 12 : month - 1,
        day: i
      });
      days = days.concat(tmpDayToBeAdded);
    }
    const next_current_month = new EventrDate();
    next_current_month.setFromObject({
      year: month === 11 ? year + 1 : year,
      month: month === 11 ? 0 : month + 1,
      day: 0
    });
    for (let i = 1; i <= next_current_month.itinLocalLuxon.day; i++) {
      const tmpDayToBeAdded = first_day_of_month.getCloneEventrDate();
      tmpDayToBeAdded.setFromObject({
        year: year,
        month: month,
        day: i
      });
      days = days.concat(tmpDayToBeAdded);
    }
    const a = days.length;
    for (let i = 1; i <= 42 - a; i++) {
      const tmpDayToBeAdded = first_day_of_month.getCloneEventrDate();
      tmpDayToBeAdded.setFromObject({
        year: month === 12 ? year + 1 : year,
        month: month === 12 ? 1 : month + 1,
        day: i
      });
      days = days.concat(tmpDayToBeAdded);
    }
    return days;
  }
  function isYearInRange(year, max, min) {
    if (year) {
      if (max) {
        if (year > (max.itinLocalLuxon.year ?? 0)) {
          return false;
        }
      }
      if (min) {
        if (year < (min.itinLocalLuxon.year ?? 0)) {
          return false;
        }
      }
      return true;
    } else {
      return true;
    }
  }
  function calendarRows() {
    return /*#__PURE__*/React__default.createElement(Stack, {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
      gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 1fr',
      height: '80%'
    }, daysDisplayed.map((day, index) => ( /*#__PURE__*/React__default.createElement(Stack, {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: '1 0 0',
      key: index,
      onClick: () => {
        handleClick(day);
      },
      id: 'calendarDates-' + day.dateTimeString,
      style: {
        backgroundColor: (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.itinLocalLuxon.day) === day.itinLocalLuxon.day && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.itinLocalLuxon.month) === day.itinLocalLuxon.month && selectedDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? ColoursObj.core.secondary : todayEventrDate.itinLocalLuxon.day === day.itinLocalLuxon.day && todayEventrDate.itinLocalLuxon.month === day.itinLocalLuxon.month && todayEventrDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? ColoursObj.shades.shade3 : ColoursObj.backgrounds.primary,
        borderRadius: (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.itinLocalLuxon.day) === day.itinLocalLuxon.day && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.itinLocalLuxon.month) === day.itinLocalLuxon.month && selectedDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? '4px' : todayEventrDate.itinLocalLuxon.day === day.itinLocalLuxon.day && todayEventrDate.itinLocalLuxon.month === day.itinLocalLuxon.month && todayEventrDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? '4px' : '0'
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      color: (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.itinLocalLuxon.day) === day.itinLocalLuxon.day && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.itinLocalLuxon.month) === day.itinLocalLuxon.month && selectedDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? ColoursObj.shades.shade5 : day.itinLocalLuxon.month != selectedDate.itinLocalLuxon.month ? ColoursObj.shades.shade2 : hidePast && isDateInPast(day) ? ColoursObj.shades.shade2 : !isDateInRange$1(day, extendedMaxDate, extendedMinDate) ? ColoursObj.shades.shade2 : ColoursObj.core.primary
    }, day.itinLocalLuxon.day)))));
  }
  useEffect(() => {
    spLogTags('Setting selected date: ' + (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.dateTimeString), ['eventrdate']);
  }, [selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.dateTimeString]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Stack, {
    style: {
      height: '70vh',
      maxWidth: '600px',
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    padding: '10px 16px 0 16px',
    gap: '8px',
    flexDirection: 'row'
  }, /*#__PURE__*/React__default.createElement(Select, {
    id: 'monthDropdown',
    defaultValue: todayEventrDate.itinLocalLuxon.month,
    value: selectedDate.itinLocalLuxon.month,
    MenuProps: MenuProps,
    onChange: e => {
      handleChangeMonth(Number(e.target.value));
    },
    sx: {
      background: ColoursObj.backgrounds.primary
    }
  }, getMonths()), /*#__PURE__*/React__default.createElement(Select, {
    id: 'yearDropdown',
    defaultValue: todayEventrDate.itinLocalLuxon.year,
    value: selectedDate.itinLocalLuxon.year,
    MenuProps: MenuProps,
    onChange: e => {
      if (!isNaN(Number(e.target.value)) && isYearInRange(Number(e.target.value), extendedMaxDate, extendedMinDate)) {
        const newSelectedDate = selectedDate.getCloneEventrDate();
        newSelectedDate.setFromObject({
          year: Number(e.target.value)
        });
        setSelectedDate(newSelectedDate);
      }
    },
    sx: {
      background: ColoursObj.backgrounds.primary
    }
  }, getYears().map((year, index) => ( /*#__PURE__*/React__default.createElement(MenuItem, {
    key: index,
    value: Number(year),
    style: {
      background: ColoursObj.backgrounds.primary
    },
    id: 'year:' + year
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    color: isYearInRange(Number(year), extendedMaxDate, extendedMinDate) ? ColoursObj.core.primary : ColoursObj.shades.shade3
  }, year)))))), /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '16px'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'leftChevronButton',
    variant: 'ghost',
    icon: 'Chevron_Left',
    iconColour: ColoursObj.shades.shade2,
    style: {
      margin: '0 16px'
    },
    onClick: () => {
      handleMonthClick('left');
    }
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyBold',
    color: ColoursObj.core.primary
  }, monthFromValue(selectedDate.itinLocalLuxon.month ?? 1)), /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'rightChevronButton',
    variant: 'ghost',
    icon: 'Chevron_Right',
    iconColour: ColoursObj.shades.shade2,
    style: {
      margin: '0 16px'
    },
    onClick: () => handleMonthClick('right')
  })), /*#__PURE__*/React__default.createElement(Stack, {
    flex: '1 0 0',
    padding: '0 16px'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    flexDirection: 'row',
    height: '20%',
    paddingTop: '16px',
    boxSizing: 'border-box'
  }, getLabelRow()), calendarRows()), /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    padding: '16px'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: isDateInRange$1(selectedDate, extendedMaxDate, extendedMinDate) ? 'datePickerSaveButtonEnabled' : 'datePickerSaveButtonDisabled',
    hapticFeedback: 'light',
    style: {
      width: '100%'
    },
    text: isDateInRange$1(selectedDate, extendedMaxDate, extendedMinDate) ? saveText : 'Select a date in range',
    disabled: !isDateInRange$1(selectedDate, extendedMaxDate, extendedMinDate),
    onClick: handleSave
  }), /*#__PURE__*/React__default.createElement(MainButton, {
    text: clearText,
    id: 'clearButton',
    onClick: handleClear
  }))));
};

const AutoCompleteInputFieldV2 = props => {
  const {
    freeSolo = false,
    listLimit = 10,
    disabled = false,
    readOnly = false,
    fullWidth = false,
    leftAdornment,
    onChange,
    fieldLabel,
    value,
    placeholder,
    onInputKeyDown,
    ...toDomProps
  } = props;
  const filterOptionsCreated = props.filterOptions ?? createFilterOptions({
    limit: listLimit
  });
  return /*#__PURE__*/React__default.createElement(Autocomplete, Object.assign({}, toDomProps, {
    value: value,
    disableClearable: true,
    onChange: (_, value) => {
      if (props.onChange) {
        props.onChange(value);
      }
    },
    freeSolo: freeSolo,
    isOptionEqualToValue: (option, value) => {
      if (option && typeof option === 'object' && 'label' in option && value && typeof value === 'object' && 'label' in value) {
        return option.id === value.id;
      } else if (option && typeof option === 'object' && 'label' in option && value && typeof value === 'string') {
        return option.label === value;
      } else return false;
    },
    filterOptions: filterOptionsCreated,
    renderInput: params => (
    /*#__PURE__*/
    React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, params, {
      size: 'medium',
      placeholder: placeholder,
      style: {
        padding: '0'
      },
      label: /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React__default.createElement(Typography$1, {
        variant: 'bodySubtext',
        style: {
          color: ColoursObj.font.primary,
          opacity: disabled ? '0.38' : '1'
        }
      }, props.fieldLabel)),
      InputLabelProps: {
        shrink: true
      },
      disabled: disabled,
      sx: {
        Label: {
          transform: 'translateY(-8px)',
          '& .MuiOutlinedInput-root': {
            marginTop: '0'
          }
        },
        '& .MuiOutlinedInput-root': {
          opacity: disabled ? '0.38' : '1'
        }
      },
      onKeyDown: e => {
        if (onInputKeyDown) {
          onInputKeyDown(e);
        }
      },
      InputProps: {
        ...params.InputProps,
        startAdornment: leftAdornment,
        style: {
          flexWrap: 'wrap'
        }
      }
    })))),
    disabled: disabled,
    readOnly: readOnly,
    fullWidth: fullWidth,
    PaperComponent: props => /*#__PURE__*/React__default.createElement(Paper, Object.assign({}, props, {
      style: {
        background: ColoursObj.backgrounds.primary
      }
    }))
  }));
};

function getCountryCodeFromTimezoneEnum(enumVal) {
  const enumValName = getTimezoneName(enumVal);
  if (enumValName) {
    const countryObj = CountryCodesWithNames.find(country => {
      if (country.timezones.includes(enumValName)) {
        return true;
      } else {
        return false;
      }
    });
    if (countryObj) {
      return countryObj;
    }
  }
  return undefined;
}

function getFlagEmojiFromCountryCode(countryCode) {
  try {
    const codePoints = countryCode.toUpperCase().split('').map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  } catch {
    return '';
  }
}
function getFlagEmojiFromTimezoneEnum(enumVal) {
  const enumValName = getTimezoneName(enumVal);
  if (enumValName) {
    const countryObj = CountryCodesWithNames.find(country => {
      if (country.timezones.includes(enumValName)) {
        return true;
      } else {
        return false;
      }
    });
    if (countryObj) {
      return getFlagEmojiFromCountryCode(countryObj.id);
    }
  }
  return '';
}

const MappedTimezones = (withOutItinDefaultOption, defaultTZText) => {
  let mappedList = [];
  if (!withOutItinDefaultOption) {
    const itinTZ = useItinInfo().timezone;
    if (itinTZ) {
      const countryObj = getCountryCodeFromTimezoneEnum(getTimezoneNumber(itinTZ));
      mappedList.push({
        cc: (countryObj === null || countryObj === void 0 ? void 0 : countryObj.id) ?? 'Default',
        ccDisplayName: defaultTZText,
        timezone: itinTZ
      });
    } else {
      mappedList.push({
        cc: '',
        ccDisplayName: defaultTZText,
        timezone: 'Default'
      });
    }
  }
  CountryCodesWithNames.forEach(country => {
    const base = {
      cc: country.id,
      ccDisplayName: country.displayName
    };
    country.timezones.forEach(timezone => {
      const toAddToList = {
        ...base,
        timezone: timezone
      };
      mappedList.push(toAddToList);
    });
  });
  return mappedList;
};
const MappedTimezonesForAutoComplete = (withOutItinDefaultOption, defaultTZText) => {
  let mappedList = [];
  MappedTimezones(withOutItinDefaultOption, defaultTZText).forEach(mappedTimezone => {
    const tmp = new EventrDate().setTimezone(mappedTimezone.timezone).itinLocalLuxon.offset;
    const hours = Math.floor(Math.abs(tmp) / 60);
    const minutes = Math.abs(tmp) % 60;
    mappedList.push({
      id: mappedTimezone.timezone,
      label: `${getFlagEmojiFromCountryCode(mappedTimezone.cc)} ${mappedTimezone.ccDisplayName} - ${mappedTimezone.timezone.split('/')[mappedTimezone.timezone.split('/').length - 1].replaceAll('_', ' ')} ${tmp >= 0 ? '+' : '-'}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`,
      obj: mappedTimezone
    });
  });
  return mappedList;
};

const TimezoneDropdown = props => {
  const {
    selectedDateTimeString,
    defaultTZText,
    withOutItinDefaultOption = false,
    onBackClick,
    ...toDomProps
  } = props;
  const mapCountriesToItemOptions = MappedTimezonesForAutoComplete(withOutItinDefaultOption ?? false, defaultTZText);
  const eventrDate = new EventrDate(selectedDateTimeString);
  return /*#__PURE__*/React__default.createElement(AutoCompleteInputFieldV2, Object.assign({}, toDomProps, {
    id: 'timezoneDropdown',
    renderOption: (optionProps, option) => {
      return /*#__PURE__*/React__default.createElement("li", Object.assign({}, optionProps), /*#__PURE__*/React__default.createElement(Typography$1, null, (option === null || option === void 0 ? void 0 : option.label) ?? ''));
    },
    options: mapCountriesToItemOptions,
    listLimit: 1000,
    value: props.selectedDateTimeString && eventrDate.timezoneNumber ? mapCountriesToItemOptions.find(country => {
      if (eventrDate.timezoneNumber) {
        return getTimezoneName(eventrDate.timezoneNumber) === country.id;
      } else {
        return false;
      }
    }) : mapCountriesToItemOptions[0],
    leftAdornment: onBackClick ? ( /*#__PURE__*/React__default.createElement(Box, {
      padding: '0 12px 0 0',
      sx: {
        '&:hover': {
          cursor: 'pointer'
        }
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Left',
      onClick: onBackClick
    }))) : undefined
  }));
};

const ClockFaceDrawer = ({
  eventrDateString,
  close,
  onSave,
  onClear,
  hourText = 'Hour',
  minuteText = 'Minute',
  saveText = 'Save',
  clearText = 'Clear',
  maxTime,
  minTime
}) => {
  const defaultManualInput = getUserPref('component', 'timePickerManualInput');
  const [selectedTime, setSelectedTime] = useState(eventrDateString ? new EventrDate(eventrDateString) : undefined);
  const [manualInput, setManualInput] = useState(defaultManualInput);
  const [hourFocus, setHourFocus] = useState(false);
  const [minuteFocus, setMinuteFocus] = useState(false);
  function handleSave() {
    if (selectedTime && selectedTime.isValid) {
      spLogTags('Saving time: ' + (selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.dateTimeString), ['eventrdate']);
      onSave(selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.dateTimeString);
    }
    spLogTags('Closing datetime drawer', ['eventrdate']);
    close();
  }
  function handleClear() {
    spLogTags('Clearing time: ' + (selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.dateTimeString), ['eventrdate']);
    onClear();
    spLogTags('Closing datetime drawer', ['eventrdate']);
    close();
  }
  function EventrDateToDateJS() {
    if (selectedTime && selectedTime.isValid) {
      let timeToDispaly = dayjs(selectedTime.toItinLocalDateTimeString());
      return dayjs(timeToDispaly);
    } else {
      return undefined;
    }
  }
  useEffect(() => {
    const manualInputPref = getUserPref('component', 'timePickerManualInput');
    manualInput !== manualInputPref && setManualInput(manualInputPref);
  }, [open, setManualInput]);
  useEffect(() => {
    setTimeout(() => {
      if (manualInput) {
        const tmp = document.getElementById('hour_input');
        if (tmp) {
          tmp.select();
          tmp.focus();
        }
      }
    }, 100);
  }, []);
  return /*#__PURE__*/React__default.createElement(Stack, {
    width: '100%'
  }, manualInput ? ( /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '48px 16px'
  }, /*#__PURE__*/React__default.createElement(TextField, {
    id: 'hour_input',
    autoFocus: true,
    value: ('0' + Math.trunc((selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.itinLocalLuxon.hour) ?? 0).toString()).slice(-2),
    type: 'tel',
    helperText: hourText,
    FormHelperTextProps: {
      style: {
        paddingTop: '8px',
        margin: '0',
        fontSize: '12px',
        color: ColoursObj.shades.shade2
      }
    },
    onFocus: () => {
      setHourFocus(true);
    },
    onBlur: () => {
      setHourFocus(false);
    },
    onClick: () => {
      NativeUtils.hapticFeedback('light');
      const tmp = document.getElementById('hour_input');
      tmp.select();
      tmp.focus();
    },
    onChange: e => {
      try {
        if (Number(e.target.value) >= 0 && Number(e.target.value) < 24) {
          let newEventrDate;
          if (!selectedTime) {
            newEventrDate = new EventrDate();
            newEventrDate.clearTimezone();
          } else {
            newEventrDate = selectedTime.getCloneEventrDate();
          }
          newEventrDate.setFromObject({
            hour: Number(e.target.value)
          });
          setSelectedTime(newEventrDate);
          if (!['0', '00', '000', '1', '01', '001', '2', '02', '002'].includes(e.target.value)) {
            const tmp = document.getElementById('minute_input');
            tmp.focus();
            tmp.select();
          }
        }
        return;
      } catch {
        return;
      }
    },
    style: {
      width: '80px',
      height: '56px',
      padding: hourFocus ? '6px' : '8px',
      fontSize: '56px',
      lineHeight: '1em',
      borderRadius: '4px',
      textAlign: 'center',
      border: hourFocus ? '2px solid ' + ColoursObj.core.secondary : 'none',
      backgroundColor: hourFocus ? ColoursObj.shades.shade5 : '#EBF9F8'
    },
    sx: {
      input: {
        width: hourFocus ? '92px' : '96px',
        height: hourFocus ? '68px' : '72px',
        padding: '0px',
        fontSize: '56px',
        lineHeight: '1em',
        borderRadius: '4px',
        textAlign: 'center',
        border: 'none',
        color: hourFocus ? ColoursObj.core.secondary : ColoursObj.shades.shade1,
        backgroundColor: hourFocus ? ColoursObj.shades.shade5 : '#EBF9F8'
      }
    },
    InputProps: {
      style: {
        width: '80px',
        height: '56px',
        padding: '0px',
        fontSize: '56px',
        lineHeight: '1em',
        borderRadius: '4px',
        textAlign: 'center',
        border: 'none',
        margin: '0',
        backgroundColor: hourFocus ? ColoursObj.shades.shade5 : '#EBF9F8'
      }
    }
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyRegular',
    padding: '8px',
    fontSize: '56px',
    textAlign: 'center',
    lineHeight: '1em',
    color: ColoursObj.shades.shade1
  }, ":"), /*#__PURE__*/React__default.createElement(TextField, {
    id: 'minute_input',
    value: ('0' + Math.trunc((selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.itinLocalLuxon.minute) ?? 0).toString()).slice(-2),
    type: 'tel',
    helperText: minuteText,
    FormHelperTextProps: {
      style: {
        paddingTop: '8px',
        margin: '0',
        fontSize: '12px',
        color: ColoursObj.shades.shade2
      }
    },
    onFocus: () => {
      setMinuteFocus(true);
    },
    onBlur: () => {
      setMinuteFocus(false);
    },
    onClick: () => {
      NativeUtils.hapticFeedback('light');
      try {
        const tmp = document.getElementById('minute_input');
        tmp.focus();
        tmp.select();
      } catch {}
    },
    onChange: e => {
      if (Number(e.target.value) <= 60 && Number(e.target.value) >= 0) {
        let newEventrDate;
        if (!selectedTime) {
          newEventrDate = new EventrDate();
          newEventrDate.clearTimezone();
        } else {
          newEventrDate = selectedTime.getCloneEventrDate();
        }
        newEventrDate.setFromObject({
          minute: Number(e.target.value)
        });
        setSelectedTime(newEventrDate);
      }
    },
    style: {
      width: '80px',
      height: '56px',
      padding: minuteFocus ? '6px' : '8px',
      fontSize: '56px',
      lineHeight: '1em',
      borderRadius: '4px',
      textAlign: 'center',
      border: minuteFocus ? '2px solid ' + ColoursObj.core.secondary : 'none',
      backgroundColor: minuteFocus ? ColoursObj.shades.shade5 : '#EBF9F8'
    },
    sx: {
      input: {
        width: minuteFocus ? '92px' : '96px',
        height: minuteFocus ? '68px' : '72px',
        padding: '0px',
        fontSize: '56px',
        lineHeight: '1em',
        borderRadius: '4px',
        textAlign: 'center',
        border: 'none',
        color: minuteFocus ? ColoursObj.core.secondary : ColoursObj.shades.shade1,
        backgroundColor: minuteFocus ? ColoursObj.shades.shade5 : '#EBF9F8'
      }
    },
    InputProps: {
      style: {
        width: '80px',
        height: '56px',
        padding: '0px',
        fontSize: '56px',
        lineHeight: '1em',
        borderRadius: '4px',
        textAlign: 'center',
        border: 'none',
        margin: '0',
        backgroundColor: minuteFocus ? ColoursObj.shades.shade5 : '#EBF9F8'
      }
    }
  }))) : ( /*#__PURE__*/React__default.createElement(LocalizationProvider, {
    dateAdapter: AdapterDayjs
  }, /*#__PURE__*/React__default.createElement(StaticTimePicker, {
    minutesStep: 5,
    value: EventrDateToDateJS(),
    maxTime: maxTime ? dayjs(maxTime.toItinLocalDateTimeString()) : undefined,
    minTime: minTime ? dayjs(minTime.toItinLocalDateTimeString()) : undefined,
    sx: {
      background: ColoursObj.backgrounds.primary,
      '& .MuiPickersToolbar-root': {
        background: ColoursObj.backgrounds.primary,
        '& .MuiPickersToolbar-content': {
          background: ColoursObj.backgrounds.primary,
          '& .MuiTimePickerToolbar-ampmSelection': {
            background: ColoursObj.backgrounds.primary
          }
        },
        '& .MuiButtonBase-root': {
          background: ColoursObj.backgrounds.secondary
        }
      },
      '& .MuiPickersLayout-contentWrapper': {
        '& .MuiTimeClock-root': {
          '& .MuiClock-root': {
            '& .MuiClock-clock': {
              background: ColoursObj.backgrounds.secondary
            }
          }
        }
      }
    },
    onChange: e => {
      NativeUtils.hapticFeedback('light');
      let newEventrDate;
      if (!selectedTime) {
        newEventrDate = new EventrDate();
        newEventrDate.clearTimezone();
      } else {
        newEventrDate = selectedTime.getCloneEventrDate();
      }
      newEventrDate.setFromObject({
        minute: Number(e.minute()),
        hour: Number(e.hour())
      });
      setSelectedTime(newEventrDate);
    },
    slotProps: {
      leftArrowIcon: {
        style: {
          display: 'none'
        }
      },
      rightArrowIcon: {
        style: {
          display: 'none'
        }
      },
      actionBar: {
        style: {
          display: 'none'
        }
      },
      toolbar: {}
    }
  }))), /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: '100%',
    padding: '0 16px'
  }, /*#__PURE__*/React__default.createElement(TimezoneDropdown, {
    fieldLabel: '',
    placeholder: 'Itinerary Default',
    onChange: value => {
      let newEventrDate;
      if (!selectedTime) {
        newEventrDate = new EventrDate();
        newEventrDate.clearTimezone();
      } else {
        newEventrDate = selectedTime.getCloneEventrDate();
      }
      if ((value === null || value === void 0 ? void 0 : value.id) === 'Default') {
        newEventrDate.clearTimezone();
      } else if (value !== null && value !== void 0 && value.id && typeof value.id === 'string') {
        newEventrDate.setTimezone(value === null || value === void 0 ? void 0 : value.id);
      }
      if (newEventrDate.isValid) {
        setSelectedTime(newEventrDate);
      }
    },
    selectedDateTimeString: (selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.dateTimeString) ?? undefined,
    defaultTZText: ''
  }))), /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    padding: '16px'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    icon: 'Keyboard',
    onClick: () => {
      setUserPref('component', 'timePickerManualInput', !manualInput);
      setManualInput(!manualInput);
    }
  }), /*#__PURE__*/React__default.createElement(MainButton, {
    style: {
      width: '100%'
    },
    onClick: handleSave,
    text: saveText
  }), /*#__PURE__*/React__default.createElement(MainButton, {
    onClick: handleClear,
    text: clearText
  })));
};

const defaultDrawerStore = {
  drawer: null,
  openState: false
};
const useDrawerStore = create(set => ({
  ...defaultDrawerStore,
  openDrawer: drawer => {
    set({
      drawer: drawer,
      openState: true
    });
  },
  closeDrawer: () => {
    set({
      openState: false
    });
  }
}));
const MobileDrawer = ({
  drawer,
  openState
}) => {
  return /*#__PURE__*/React__default.createElement(Fragment, null, openState && drawer && drawer.node && !drawer.noDim && ( /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      backdropFilter: 'blur(3px) grayscale(0.5)',
      zIndex: 1100
    },
    onClick: () => {
      if (drawer.onBackdropClick) {
        drawer.onBackdropClick();
      }
    }
  })), /*#__PURE__*/React__default.createElement(Box, {
    position: 'absolute',
    bottom: 0,
    width: '100dvw',
    left: 0,
    zIndex: 1110
  }, /*#__PURE__*/React__default.createElement(Collapse, {
    timeout: 200,
    in: openState,
    unmountOnExit: true,
    onEntered: () => {
      if (drawer !== null && drawer !== void 0 && drawer.onOpen) {
        drawer === null || drawer === void 0 ? void 0 : drawer.onOpen();
      }
    },
    onExited: () => {
      if (drawer !== null && drawer !== void 0 && drawer.onClose) {
        drawer.onClose();
      }
    }
  }, /*#__PURE__*/React__default.createElement(Box, null, drawer && drawer.node))));
};
const drawerStore = useDrawerStore.getState;

const Gutters = ({
  children,
  gutterWidth = '5%',
  topPadding = '16px',
  style
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: gutterWidth + ' 1fr ' + gutterWidth,
      padding: topPadding + ' 0 0 0',
      ...style
    }
  }, /*#__PURE__*/React__default.createElement("div", null), children, /*#__PURE__*/React__default.createElement("div", null));
};

var MobileDateRangePickerUtils;
(function (MobileDateRangePickerUtils) {
  function getDrawerTitle(startEventrDate, endEventrDate, fieldLabel, language) {
    if (!startEventrDate || !endEventrDate) {
      return fieldLabel || '';
    }
    if (startEventrDate.itinLocalLuxon.year === endEventrDate.itinLocalLuxon.year && startEventrDate.itinLocalLuxon.month === endEventrDate.itinLocalLuxon.month && startEventrDate.itinLocalLuxon.day === endEventrDate.itinLocalLuxon.day) {
      return endEventrDate.itinLocalLuxon.setLocale(language).toFormat('d LLL yyyy');
    }
    if (startEventrDate.itinLocalLuxon.year === endEventrDate.itinLocalLuxon.year && startEventrDate.itinLocalLuxon.month === endEventrDate.itinLocalLuxon.month) {
      return startEventrDate.itinLocalLuxon.setLocale(language).toFormat('d') + ' - ' + endEventrDate.itinLocalLuxon.setLocale(language).toFormat('d LLL yyyy');
    }
    if (startEventrDate.itinLocalLuxon.year === endEventrDate.itinLocalLuxon.year) {
      return startEventrDate.itinLocalLuxon.setLocale(language).toFormat('d LLL') + ' - ' + endEventrDate.itinLocalLuxon.setLocale(language).toFormat('d LLL yyyy');
    }
    return startEventrDate.itinLocalLuxon.setLocale(language).toFormat('d LLL yyyy') + ' - ' + endEventrDate.itinLocalLuxon.setLocale(language).toFormat('d LLL yyyy');
  }
  MobileDateRangePickerUtils.getDrawerTitle = getDrawerTitle;
  function generateShownDays(shownValues, language) {
    const daysInMonth = daysInMonthInt(shownValues.year, shownValues.month);
    let daysToReturn = [];
    for (let date = 1; date <= daysInMonth; date++) {
      const luxonDate = DateTime.fromObject({
        day: date,
        month: shownValues.month,
        year: shownValues.year,
        hour: 12,
        minute: 0
      }, {
        zone: 'UTC',
        locale: language
      });
      daysToReturn.push({
        day: luxonDate.day,
        month: luxonDate.month,
        year: luxonDate.year,
        millis: luxonDate.toMillis()
      });
    }
    const startOfMonth = DateTime.fromObject({
      day: 1,
      month: shownValues.month,
      year: shownValues.year,
      hour: 12,
      minute: 0
    }, {
      zone: 'UTC',
      locale: language
    });
    for (let startDOW = 1; startDOW < startOfMonth.weekday; startDOW++) {
      daysToReturn.unshift(false);
    }
    return {
      month: shownValues.month,
      year: shownValues.year,
      dayList: daysToReturn,
      genericDateTime: startOfMonth,
      isCurrentMonth: startOfMonth.month === MobileDateRangePickerUtils.todayEventrDate.utcLuxon.month && startOfMonth.year === MobileDateRangePickerUtils.todayEventrDate.utcLuxon.year
    };
  }
  MobileDateRangePickerUtils.generateShownDays = generateShownDays;
  function getWeekDays(language) {
    let weekdays = [];
    for (let dayId = 1; dayId <= 7; dayId++) {
      const newEventrDate = new EventrDate(0);
      newEventrDate.clearTimezone();
      newEventrDate.setFromObject({
        hour: 12,
        weekday: dayId
      });
      weekdays.push(newEventrDate.utcLuxon.setLocale(language).toLocaleString({
        weekday: 'short'
      }));
    }
    return weekdays;
  }
  MobileDateRangePickerUtils.getWeekDays = getWeekDays;
  MobileDateRangePickerUtils.todayEventrDate = new EventrDate();
  function isTodayDay(date) {
    return isSameDay(date, MobileDateRangePickerUtils.todayEventrDate.utcLuxon);
  }
  function isSameDay(day, luxon) {
    if (day.day === luxon.day && day.month === luxon.month && day.year === luxon.year) {
      return true;
    } else {
      return false;
    }
  }
  function isSameEventrDate(comp1, comp2) {
    if (comp1.itinLocalLuxon.hasSame(comp2.itinLocalLuxon, 'day') && comp1.itinLocalLuxon.hasSame(comp2.itinLocalLuxon, 'month') && comp1.itinLocalLuxon.hasSame(comp2.itinLocalLuxon, 'year')) {
      return true;
    } else {
      return false;
    }
  }
  MobileDateRangePickerUtils.isSameEventrDate = isSameEventrDate;
  function isBetweenDay(day, start, end) {
    if (day.millis - 1 > start.toMillis() && day.millis + 1 < end.toMillis()) {
      return true;
    } else {
      return false;
    }
  }
  function isInPastDay(day, today) {
    return isBetweenDay(day, DateTime.fromObject({
      year: 1971
    }), today.utcLuxon.startOf('day'));
  }
  MobileDateRangePickerUtils.isInPastDay = isInPastDay;
  function getMonthName(date, language) {
    return date.setLocale(language).toLocaleString({
      month: 'long'
    });
  }
  MobileDateRangePickerUtils.getMonthName = getMonthName;
  function isViewable(month, year, monthValue) {
    if (year === monthValue.year) {
      if ([0, 1, -1, -2, -3].includes(month - monthValue.month)) {
        return true;
      }
    } else if (month > 3 && month < 9) {
      return false;
    } else if (year - monthValue.year === 1) {
      if (monthValue.month === 12) {
        return true;
      }
    } else if (year - monthValue.year === -1) {
      if (monthValue.month === 1) {
        return true;
      }
    }
    return false;
  }
  MobileDateRangePickerUtils.isViewable = isViewable;
  MobileDateRangePickerUtils.DrawerWrapper = ({
    title,
    children
  }) => ( /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto'
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    height: '52px',
    alignItems: 'center',
    sx: {
      backgroundColor: ColoursObj.backgrounds.header,
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '16px',
      zIndex: 6,
      boxShadow: `0px 0px 8px 4px ${ColoursObj.backgrounds.primary}, 0px 8px 8px ${ColoursObj.backgrounds.primary}`
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    padding: '0 16px'
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: ColoursObj.shades.shade5
  }, title), /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Cross',
    iconColour: ColoursObj.backgrounds.header,
    bubble: true,
    bubbleColour: 'white',
    onClick: () => {
      useDrawerStore.getState().closeDrawer();
    }
  }))), /*#__PURE__*/React__default.createElement(Gutters, {
    topPadding: '0px',
    gutterWidth: '8px',
    style: {
      backgroundColor: ColoursObj.backgrounds.primary
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    justifyItems: 'center'
  }, children)), /*#__PURE__*/React__default.createElement(Box, {
    height: '32px',
    sx: {
      backgroundColor: ColoursObj.backgrounds.primary
    }
  })));
  MobileDateRangePickerUtils.DayBox = ({
    day,
    selectedEnd,
    selectedStart,
    onClick,
    hidePast,
    possiblyToday,
    highlightStart,
    highlightEnd
  }) => {
    var _ColoursObj$shades, _ColoursObj$shades2, _ColoursObj$font;
    const isStart = selectedStart && isSameDay(day, selectedStart === null || selectedStart === void 0 ? void 0 : selectedStart.itinLocalLuxon);
    const isEnd = selectedEnd && isSameDay(day, selectedEnd === null || selectedEnd === void 0 ? void 0 : selectedEnd.itinLocalLuxon);
    const isSelected = isStart || isEnd;
    const isBetweenConst = selectedStart && selectedEnd ? isBetweenDay(day, selectedStart === null || selectedStart === void 0 ? void 0 : selectedStart.itinLocalLuxon, selectedEnd === null || selectedEnd === void 0 ? void 0 : selectedEnd.itinLocalLuxon) : false;
    const isTodayConst = possiblyToday ? isTodayDay(day) : false;
    const isPast = hidePast ? isInPastDay(day, MobileDateRangePickerUtils.todayEventrDate) : false;
    const isHighlightStart = highlightStart ? isSameDay(day, highlightStart.itinLocalLuxon) : false;
    const isHighlightEnd = highlightEnd ? isSameDay(day, highlightEnd.itinLocalLuxon) : false;
    const isHighlight = highlightStart && highlightEnd ? isBetweenDay(day, highlightStart.itinLocalLuxon, highlightEnd.itinLocalLuxon) : false;
    return /*#__PURE__*/React__default.createElement(Box, {
      id: `mobileDatePickerDrawer-${day.day}-${day.month}-${day.year}-dateCell`,
      sx: {
        display: 'grid',
        backgroundColor: isSelected ? ColoursObj.core.secondary : isBetweenConst ? ColoursObj.coreLights.primary : isTodayConst ? ColoursObj.shades.shade3 : isHighlight ? ColoursObj.coreLights.primary : 'transparent',
        borderRadius: isEnd && isStart ? '8px' : isEnd ? '0px 8px 8px 0px' : isStart ? '8px 0px 0px 8px' : isHighlightStart ? '8px 0px 0px 8px' : isHighlightEnd ? '0px 8px 8px 0px' : isBetweenConst || isHighlight ? '0' : '8px',
        height: '38px',
        width: '100%',
        justifyItems: 'center',
        alignItems: 'center',
        margin: '6px 0px'
      },
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(Typography, {
      color: isSelected ? ColoursObj === null || ColoursObj === void 0 ? void 0 : (_ColoursObj$shades = ColoursObj.shades) === null || _ColoursObj$shades === void 0 ? void 0 : _ColoursObj$shades.shade5 : isPast ? ColoursObj === null || ColoursObj === void 0 ? void 0 : (_ColoursObj$shades2 = ColoursObj.shades) === null || _ColoursObj$shades2 === void 0 ? void 0 : _ColoursObj$shades2.shade3 : ColoursObj === null || ColoursObj === void 0 ? void 0 : (_ColoursObj$font = ColoursObj.font) === null || _ColoursObj$font === void 0 ? void 0 : _ColoursObj$font.primary
    }, day.day));
  };
})(MobileDateRangePickerUtils || (MobileDateRangePickerUtils = {}));

const STARTING_PARAMS = {
  startingMonthsCount: 1200,
  boundaryToAddMonth: 6,
  startingMonth: {
    month: 1,
    year: 1950
  }
};
const initialState = {
  monthsToShow: [],
  initialized: false,
  virtualScrollSize: 800
};
const useMobileDateRangePickerStore = create((set, get) => {
  const windowHeight = window.innerHeight;
  const size = windowHeight * 0.8 - 50;
  return {
    ...initialState,
    virtualScrollSize: size,
    addToMonthsToShow: (month, year, language, last) => {
      const currentList = get().monthsToShow.slice();
      if (last) {
        currentList.unshift(MobileDateRangePickerUtils.generateShownDays({
          month: month,
          year: year
        }, language));
      } else {
        currentList.push(MobileDateRangePickerUtils.generateShownDays({
          month: month,
          year: year
        }, language));
      }
      set({
        monthsToShow: currentList
      });
    },
    addNextMonthToShownMonthsNew: language => {
      const lastMonth = get().monthsToShow.slice()[get().monthsToShow.length - 1];
      const nextDateTime = lastMonth.genericDateTime.plus({
        month: 1
      });
      get().addToMonthsToShow(nextDateTime.month, nextDateTime.year, language);
    },
    initializeMonthsToShow: language => {
      let monthsToShow = get().monthsToShow;
      if (monthsToShow.length > 0) {
        return;
      }
      get().addToMonthsToShow(STARTING_PARAMS.startingMonth.month, STARTING_PARAMS.startingMonth.year, language);
      for (let mIndex = 1; mIndex <= STARTING_PARAMS.startingMonthsCount; mIndex++) {
        get().addNextMonthToShownMonthsNew(language);
      }
      set({
        initialized: true
      });
    },
    scrollTo: (scrollRef, month, year, behavior) => {
      if (scrollRef && get().initialized) {
        const mIndex = get().monthsToShow.findIndex(monthObj => {
          return monthObj.month === month && monthObj.year === year;
        });
        scrollRef.scrollToIndex(mIndex, behavior);
      }
    }
  };
});

const MobileRangeCalenderForDrawer = ({
  fieldLabel,
  translationString,
  onSave,
  language = 'en-GB',
  startDateTimeString,
  endDateTimeString,
  openTo,
  onClear,
  hidePast,
  isSingleDate,
  highlightRangeStart,
  highlightRangeEnd,
  outOfRangePopup
}) => {
  const scrollRef = useRef(null);
  const {
    monthsToShow,
    scrollTo,
    size
  } = useMobileDateRangePickerStore(useShallow(s => ({
    monthsToShow: s.monthsToShow,
    scrollTo: s.scrollTo,
    size: s.virtualScrollSize
  })));
  const openToEventrDate = new EventrDate(openTo);
  const openToDate = {
    month: openToEventrDate.itinLocalLuxon.month,
    year: openToEventrDate.itinLocalLuxon.year
  };
  const highlightRangeStartEventrDate = new EventrDate(highlightRangeStart);
  const highlightRangeEndEventrDate = new EventrDate(highlightRangeEnd);
  const [startEventrDate, setStartEventrDate] = useState(startDateTimeString ? new EventrDate(startDateTimeString) : undefined);
  const [endEventrDate, setEndEventrDate] = useState(endDateTimeString ? new EventrDate(endDateTimeString) : undefined);
  useEffect(() => {
    setTimeout(() => {
      scrollTo(scrollRef.current, openToDate.month, openToDate.year, 'auto');
    }, 25);
  }, [scrollRef]);
  const singleDateNotInRange = isSingleDate && !isDateInRange(startEventrDate, highlightRangeEndEventrDate, highlightRangeStartEventrDate);
  function save() {
    if (onSave && startEventrDate && endEventrDate) {
      if (outOfRangePopup) {
        if (singleDateNotInRange) {
          useDialogStore.getState().replaceDialog({
            node: ( /*#__PURE__*/React__default.createElement(MobileConfirmDialog, {
              text: `This date is outside of the selectable range. Are you sure you want to select: ${isSingleDate ? startEventrDate === null || startEventrDate === void 0 ? void 0 : startEventrDate.toItinLocalDateString() : (startEventrDate === null || startEventrDate === void 0 ? void 0 : startEventrDate.toItinLocalDateString()) + '-' + (endEventrDate === null || endEventrDate === void 0 ? void 0 : endEventrDate.toItinLocalDateString())}
              `,
              onConfirm: () => {
                spLogTags('Saving date: ' + (startEventrDate === null || startEventrDate === void 0 ? void 0 : startEventrDate.dateTimeString), ['eventrdate']);
                if (onSave && startEventrDate && endEventrDate) {
                  onSave(startEventrDate.clearTimezone().dateTimeString, endEventrDate.clearTimezone().dateTimeString);
                  useDrawerStore.getState().closeDrawer();
                }
                spLogTags('Closing datetime drawer', ['eventrdate']);
                close();
                useDialogStore.getState().clearDialog();
              },
              onCancel: () => {
                useDialogStore.getState().clearDialog();
              }
            })),
            backdropClosable: false
          });
          return;
        } else {
          onSave(startEventrDate.clearTimezone().dateTimeString, endEventrDate.clearTimezone().dateTimeString);
        }
      } else {
        onSave(startEventrDate.clearTimezone().dateTimeString, endEventrDate.clearTimezone().dateTimeString);
      }
    }
    if (!startEventrDate && !endEventrDate) {
      clear();
    }
    useDrawerStore.getState().closeDrawer();
  }
  function setStartEventrDateSafe(date) {
    const tmpDate = date.getCloneEventrDate();
    if (isSingleDate) {
      setStartEventrDate(tmpDate);
      return;
    }
    setStartEventrDate(tmpDate.setFromObject({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 1
    }));
  }
  function setEndEventrDateSafe(date) {
    const tmpDate = date.getCloneEventrDate();
    if (isSingleDate) {
      setEndEventrDate(tmpDate);
      return;
    }
    setEndEventrDate(tmpDate.setFromObject({
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999
    }));
  }
  function setDay(day) {
    NativeUtils.hapticFeedback('light');
    const newEventrDate = new EventrDate(startDateTimeString).setFromObject({
      day: day.day,
      month: day.month,
      year: day.year
    });
    if (isSingleDate) {
      setStartEventrDateSafe(newEventrDate);
      setEndEventrDateSafe(newEventrDate);
      return;
    }
    if (hidePast && !startEventrDate && !endEventrDate && MobileDateRangePickerUtils.isInPastDay(day, MobileDateRangePickerUtils.todayEventrDate)) {
      return;
    }
    if (hidePast && startEventrDate && endEventrDate && MobileDateRangePickerUtils.isInPastDay(day, MobileDateRangePickerUtils.todayEventrDate)) {
      if (MobileDateRangePickerUtils.isSameEventrDate(startEventrDate, newEventrDate)) {
        setStartEventrDate(undefined);
        setEndEventrDate(undefined);
        return;
      }
    }
    if (!startEventrDate && !endEventrDate) {
      setStartEventrDateSafe(newEventrDate);
      setEndEventrDateSafe(newEventrDate);
      return;
    }
    if (!startEventrDate) {
      setStartEventrDateSafe(newEventrDate);
      return;
    }
    if (!endEventrDate) {
      setEndEventrDateSafe(newEventrDate);
      return;
    }
    if (MobileDateRangePickerUtils.isSameEventrDate(startEventrDate, newEventrDate) && MobileDateRangePickerUtils.isSameEventrDate(startEventrDate, endEventrDate)) {
      setStartEventrDate(undefined);
      setEndEventrDate(undefined);
      return;
    }
    if (MobileDateRangePickerUtils.isSameEventrDate(startEventrDate, newEventrDate)) {
      setStartEventrDateSafe(endEventrDate);
      return;
    }
    if (MobileDateRangePickerUtils.isSameEventrDate(endEventrDate, newEventrDate)) {
      setEndEventrDateSafe(startEventrDate);
      return;
    }
    if (newEventrDate.getUnixMs < startEventrDate.getUnixMs) {
      setStartEventrDateSafe(newEventrDate);
      setEndEventrDateSafe(newEventrDate);
      return;
    }
    if (newEventrDate.getUnixMs > startEventrDate.getUnixMs) {
      setEndEventrDateSafe(newEventrDate);
      return;
    }
  }
  function clear() {
    if (onClear) {
      setStartEventrDate(undefined);
      setEndEventrDate(undefined);
      onClear();
    }
  }
  return /*#__PURE__*/React__default.createElement(MobileDateRangePickerUtils.DrawerWrapper, {
    title: MobileDateRangePickerUtils.getDrawerTitle(startEventrDate, endEventrDate, fieldLabel, language)
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    width: '100%',
    height: '80vh'
  }, /*#__PURE__*/React__default.createElement(VirtualScroller, {
    ref: scrollRef,
    items: monthsToShow,
    style: {
      height: `${size}px`,
      width: '100%'
    },
    itemSize: 356,
    itemTemplate: monthValues => {
      return /*#__PURE__*/React__default.createElement(Box, {
        height: '356px',
        display: 'grid',
        width: '100%',
        key: monthValues.month + language + monthValues.year,
        gap: '8px'
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        padding: '0 0 8px 8px',
        width: 'fit-content',
        gap: '8px'
      }, /*#__PURE__*/React__default.createElement(Typography, {
        style: {
          alignSelf: 'flex-end'
        },
        variant: 'bodyBold'
      }, MobileDateRangePickerUtils.getMonthName(monthValues.genericDateTime, language)), /*#__PURE__*/React__default.createElement(Typography, {
        style: {
          alignSelf: 'flex-end'
        },
        variant: 'bodyBold'
      }, monthValues.year)), /*#__PURE__*/React__default.createElement(Box, {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr'
      }, MobileDateRangePickerUtils.getWeekDays(language).map((day, weekdayIndex) => {
        return /*#__PURE__*/React__default.createElement(Box, {
          key: weekdayIndex,
          display: 'grid',
          justifyItems: 'center',
          alignItems: 'center'
        }, /*#__PURE__*/React__default.createElement(Typography, {
          variant: 'bodySubtext'
        }, day));
      }), monthValues.dayList.map((day, dayIndex) => {
        if (day) {
          return /*#__PURE__*/React__default.createElement(MobileDateRangePickerUtils.DayBox, {
            key: day.day + day.month + day.year,
            day: day,
            selectedStart: startEventrDate,
            selectedEnd: endEventrDate,
            onClick: () => {
              if (day) {
                setDay(day);
              }
            },
            hidePast: hidePast,
            possiblyToday: monthValues.isCurrentMonth,
            highlightStart: highlightRangeStart ? highlightRangeStartEventrDate : undefined,
            highlightEnd: highlightRangeEnd ? highlightRangeEndEventrDate : undefined
          });
        } else {
          return /*#__PURE__*/React__default.createElement(Box, {
            key: dayIndex
          });
        }
      })));
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    gap: '8px',
    gridTemplateColumns: onClear ? 'auto auto 1fr' : 'auto 1fr',
    sx: {
      boxShadow: '0px -16px 8px ' + ColoursObj.backgrounds.primary,
      padding: '4px 0 0 0'
    },
    width: '100%'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'mobileDatePickerDrawer-calendarTodayButton',
    variant: 'secondary',
    icon: 'Calendar_Today',
    onClick: () => {
      if (startEventrDate) {
        scrollTo(scrollRef.current, startEventrDate.itinLocalLuxon.month, startEventrDate.itinLocalLuxon.year, 'smooth');
      } else {
        scrollTo(scrollRef.current, openToDate.month, openToDate.year, 'smooth');
      }
    }
  }), onClear && ( /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'mobileDatePickerDrawer-clearButton',
    variant: 'destructiveSecondary',
    icon: 'Cancel',
    onClick: () => {
      clear();
    }
  })), /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'mobileDatePickerDrawer-saveButton',
    text: translationString.saveButton,
    onClick: () => {
      save();
    }
  }))));
};
function isDateInRange(date, max, min, ignoreTime = false) {
  if (date) {
    if (date && ignoreTime === false) {
      if (min) {
        if (date.getUnixMs < min.getUnixMs) {
          return false;
        }
      }
      if (max) {
        if (date.getUnixMs > max.getUnixMs) {
          return false;
        }
      }
      return true;
    } else if (date && ignoreTime === true) {
      const dateNormalised = date.getCloneEventrDate();
      dateNormalised.setFromObject({
        hour: 12,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      if (min) {
        const minNormalised = min.getCloneEventrDate();
        minNormalised.setFromObject({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        });
        if (dateNormalised.getUnixMs < minNormalised.getUnixMs) {
          return false;
        }
      }
      if (max) {
        const maxNormalised = max.getCloneEventrDate();
        maxNormalised.setFromObject({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999
        });
        if (dateNormalised.getUnixMs > maxNormalised.getUnixMs) {
          return false;
        }
      }
      return true;
    } else {
      return true;
    }
  } else return false;
}

const DatePicker = ({
  id,
  date,
  onSave = () => {},
  hidePast,
  fieldLabel,
  helperText,
  drawerHeader,
  required,
  isError,
  textError,
  initialState,
  locale = 'en-GB',
  selectText = 'Select date',
  saveText = 'Save',
  highlightRangeStart,
  highlightRangeEnd,
  outOfRangePopup = false
}) => {
  const dateText = () => {
    if (date) {
      const eventrDate = new EventrDate(date);
      return eventrDate.itinLocalLuxon.setLocale(locale).toLocaleString(DateTime.DATE_SHORT);
    } else {
      return selectText;
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TextInputField, {
    id: id,
    value: dateText(),
    onClick: () => {
      spLogTags('Opening date picker', ['eventrdate']);
      drawerStore().openDrawer({
        node: ( /*#__PURE__*/React__default.createElement(MobileRangeCalenderForDrawer, {
          fieldLabel: drawerHeader,
          startDateTimeString: date,
          endDateTimeString: date,
          outOfRangePopup: outOfRangePopup,
          onSave: onSave,
          onClear: () => onSave(undefined),
          translationString: {
            saveButton: saveText
          },
          hidePast: hidePast,
          openTo: initialState || date || undefined,
          language: locale,
          isSingleDate: true,
          highlightRangeStart: highlightRangeStart,
          highlightRangeEnd: highlightRangeEnd
        })),
        onBackdropClick: () => {
          drawerStore().closeDrawer();
        },
        onClose: () => {}
      });
    },
    readOnly: true,
    fieldLabel: fieldLabel,
    helperText: helperText,
    required: required,
    error: isError,
    errorMessage: textError
  }));
};

const DateRangePicker = ({
  id,
  label,
  width,
  required,
  errorText,
  errored,
  ...rest
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    id: id,
    width: width
  }, label && ( /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext'
  }, label + (required ? ' *' : '')))), /*#__PURE__*/React__default.createElement(DateRangePicker$1, Object.assign({
    block: true,
    size: 'lg',
    limitStartYear: 100,
    limitEndYear: 50
  }, rest, {
    editable: false
  })), errored && errorText && ( /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      padding: '2px 0 0 16px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyError'
  }, errorText))));
};

const DateTimeDrawer = ({
  children,
  setOpen,
  open,
  headerContent,
  headerTitle
}) => {
  function toggleDrawer() {
    spLogTags('Closing datetime drawer', ['eventrdate']);
    setOpen(!open);
  }
  return /*#__PURE__*/React__default.createElement(Drawer, {
    anchor: 'bottom',
    open: open,
    onClose: () => {
      toggleDrawer();
    },
    PaperProps: {
      style: {
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        background: ColoursObj.backgrounds.primary
      }
    }
  }, headerContent ? headerContent : ( /*#__PURE__*/React__default.createElement(Stack, {
    boxShadow: ' 0px 2px 4px 0px rgba(51, 82, 111, 0.10)',
    zIndex: 10
  }, /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
    width: '100%'
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '50px',
      height: '4px',
      borderRadius: '10px',
      backgroundColor: ColoursObj.shades.shade2,
      border: 'none'
    }
  })), /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    style: {
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      padding: '16px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '32px'
    }
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyBold',
    display: 'flex',
    alignItems: 'center',
    color: ColoursObj.core.primary
  }, headerTitle ?? ''), /*#__PURE__*/React__default.createElement("div", {
    onClick: toggleDrawer,
    style: {
      width: '32px',
      height: '32px',
      borderRadius: '16px',
      backgroundColor: ColoursObj.shades.shade4,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Exit',
    iconColour: 'ColoursObj.shades.shade1'
  }))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, children));
};

const MobileDrawerFrame = ({
  children,
  minHeight = '40dvh',
  title,
  withCloseButton = false,
  withBackButton
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    id: 'mobileDrawerFrameDrawer',
    display: 'grid',
    gridTemplateRows: 'auto auto 1fr auto',
    sx: {
      minHeight: minHeight
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    height: '52px',
    alignItems: 'center',
    justifyItems: 'center',
    sx: {
      gridTemplateColumns: '50px 1fr 50px',
      backgroundColor: ColoursObj.backgrounds.header,
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '16px',
      zIndex: 6,
      boxShadow: `0px 0px 8px 4px ${ColoursObj.backgrounds.primary}, 0px 8px 8px ${ColoursObj.backgrounds.primary}`
    }
  }, title && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    justifyItems: 'end',
    width: '50px'
  }, withBackButton && ( /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Chevron_Left',
    iconColour: ColoursObj.backgrounds.header,
    bubble: true,
    bubbleColour: 'white',
    onClick: () => {
      withBackButton();
    }
  }))), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    id: 'mobileDrawerFrameDrawerTitle',
    variant: 'bodyBold',
    color: ColoursObj.shades.shade5
  }, title)), /*#__PURE__*/React__default.createElement(Box, {
    id: 'mobileDrawerFrameDrawerCrossIcon',
    width: '50px'
  }, withCloseButton && ( /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Cross',
    iconColour: ColoursObj.backgrounds.header,
    bubble: true,
    bubbleColour: 'white',
    onClick: () => {
      useDrawerStore.getState().closeDrawer();
    }
  })))))), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Gutters, {
    topPadding: '0px',
    gutterWidth: '8px',
    style: {
      backgroundColor: ColoursObj.backgrounds.primary
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    id: 'mobileDrawerFrameDrawerBody',
    display: 'grid',
    justifyItems: 'center',
    width: '100%'
  }, children)), /*#__PURE__*/React__default.createElement(Box, {
    height: '32px',
    sx: {
      backgroundColor: ColoursObj.backgrounds.primary
    }
  }));
};

const DateTimePicker = ({
  eventrDateString,
  onChange,
  id,
  fieldLabel,
  required,
  disabled,
  helperTooltip,
  style,
  dateHeaderTitle,
  timeHeaderTitle,
  isError,
  textError,
  initialState,
  minDate,
  maxDate,
  outOfRangePopup = false,
  locale = 'en-GB',
  selectDateText = 'Select date',
  selectTimeText = 'Select time',
  hourText = 'Hour',
  minuteText = 'Minute',
  saveText = 'Save',
  clearText = 'Clear',
  highlightRangeStart,
  highlightRangeEnd
}) => {
  const itineraryTZ = useItinInfo.getState().timezone ?? 'Unset (UTC)';
  const timeText = () => {
    if (eventrDateString) {
      const eventrDate = new EventrDate(eventrDateString);
      return eventrDate.itinLocalLuxon.setLocale(locale).toLocaleString({
        hour: '2-digit',
        minute: '2-digit'
      }) + ' ' + (eventrDate.timezoneNumber ? getFlagEmojiFromTimezoneEnum(eventrDate.timezoneNumber) + ' ' + getTimezoneName(eventrDate.timezoneNumber).split('/')[getTimezoneName(eventrDate.timezoneNumber).split('/').length - 1].replaceAll('_', ' ') : getFlagEmojiFromTimezoneEnum(getTimezoneNumber(itineraryTZ ?? '')) + ' ' + (itineraryTZ === null || itineraryTZ === void 0 ? void 0 : itineraryTZ.split('/')[itineraryTZ.split('/').length - 1])).replaceAll('_', ' ');
    } else {
      return selectTimeText;
    }
  };
  return /*#__PURE__*/React__default.createElement(Stack, {
    spacing: '8px',
    sx: style
  }, fieldLabel && ( /*#__PURE__*/React__default.createElement(Stack, {
    direction: 'row',
    alignItems: 'center',
    spacing: '8px'
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext',
    style: {
      color: ColoursObj.core.primary,
      opacity: disabled ? '0.38' : '1'
    }
  }, fieldLabel, required && ' *'), helperTooltip && ( /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: helperTooltip,
    placement: 'right-start',
    arrow: true
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: 'fit-content'
    }
  }, /*#__PURE__*/React__default.createElement(Help, {
    height: 24,
    width: 24
  })))))), /*#__PURE__*/React__default.createElement(Stack, {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: '8px'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: id,
    onClick: () => {
      spLogTags('Opening date drawer in datetime picker', ['eventrdate']);
      drawerStore().openDrawer({
        node: ( /*#__PURE__*/React__default.createElement(MobileRangeCalenderForDrawer, {
          fieldLabel: dateHeaderTitle,
          startDateTimeString: eventrDateString,
          outOfRangePopup: outOfRangePopup,
          endDateTimeString: eventrDateString,
          translationString: {
            saveButton: saveText
          },
          language: locale,
          onSave: onChange,
          onClear: () => {
            onChange(undefined);
          },
          isSingleDate: true,
          openTo: initialState || eventrDateString || undefined,
          highlightRangeStart: highlightRangeStart,
          highlightRangeEnd: highlightRangeEnd
        })),
        onBackdropClick: () => {
          drawerStore().closeDrawer();
        },
        onClose: () => {}
      });
    },
    variant: isError ? 'destructiveSecondary' : 'secondary',
    disabled: disabled
  }, eventrDateString ? new EventrDate(eventrDateString).itinLocalLuxon.setLocale(locale).toLocaleString(DateTime.DATE_SHORT) : selectDateText), /*#__PURE__*/React__default.createElement(MainButton, {
    id: id,
    onClick: () => {
      spLogTags('Opening time drawer in datetime picker', ['eventrdate']);
      drawerStore().openDrawer({
        node: ( /*#__PURE__*/React__default.createElement(MobileDrawerFrame, {
          title: timeHeaderTitle
        }, /*#__PURE__*/React__default.createElement(ClockFaceDrawer, {
          eventrDateString: eventrDateString,
          close: () => {
            drawerStore().closeDrawer();
          },
          onSave: onChange,
          onClear: () => {
            onChange(undefined);
          },
          hourText: hourText,
          minuteText: minuteText,
          saveText: saveText,
          clearText: clearText,
          maxTime: maxDate,
          minTime: minDate
        }))),
        onBackdropClick: () => {
          drawerStore().closeDrawer();
        }
      });
    },
    variant: isError ? 'destructiveSecondary' : 'secondary',
    disabled: disabled
  }, timeText())), /*#__PURE__*/React__default.createElement(Stack, {
    direction: 'row',
    justifyContent: 'flex-start',
    spacing: '8px'
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'body1',
    style: {
      color: ColoursObj.states.error
    }
  }, isError && textError)));
};

const Tooltip = props => {
  if (window.screen.width > 850) {
    return /*#__PURE__*/React__default.createElement(Tooltip$1, {
      style: {
        position: 'relative',
        backgroundColor: '#10375C'
      },
      title: /*#__PURE__*/React__default.createElement(Typography$1, {
        variant: 'bodySubtext',
        style: {
          color: 'white',
          whiteSpace: 'pre-line'
        }
      }, props.text),
      placement: 'right-start',
      arrow: true
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        height: 'fit-content',
        padding: '0 0 0 8px'
      }
    }, /*#__PURE__*/React__default.createElement(Help, {
      height: 16,
      width: 16
    })));
  } else {
    return /*#__PURE__*/React__default.createElement("span", null);
  }
};

const yearList = Array.from({
  length: 150
}, (_, i) => i + 1940);
const DatetimePickerV3YearSelector = props => {
  const uniqueNumber = Date.now();
  useEffect(() => {
    var _window$document$getE;
    (_window$document$getE = window.document.getElementById('selectedYear' + uniqueNumber)) === null || _window$document$getE === void 0 ? void 0 : _window$document$getE.scrollIntoView({
      block: 'center'
    });
  }, [window]);
  return /*#__PURE__*/React__default.createElement(Paper, {
    style: {
      position: 'absolute',
      height: '0px',
      overflow: 'visible',
      zIndex: 131,
      top: '36px',
      margin: '0 0 0 24px'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      borderRadius: '6px',
      border: '1px solid ' + ColoursObj.shades.shade2,
      backgroundColor: ColoursObj.shades.shade5,
      filter: `drop-shadow(0 0 8px ${ColoursObj.shades.shade2})`,
      zIndex: 131,
      display: 'grid',
      opacity: 1,
      animation: '.2s ease-in 1 onOpen',
      '@keyframes onOpen': {
        '0%': {
          opacity: '0'
        },
        '100%': {
          opacity: '1'
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'grid',
      maxHeight: '372px',
      overflowX: 'hidden',
      overflowY: 'scroll',
      scrollbarColor: ColoursObj.shades.shade2 + ' transparent'
    }
  }, yearList.map(year => {
    return /*#__PURE__*/React__default.createElement(Box, {
      key: year,
      id: props.year === year ? 'selectedYear' + uniqueNumber : undefined,
      padding: '0 16px',
      onClick: () => {
        props.onClick(year);
      },
      sx: {
        padding: '0 8px',
        margin: '2px 4px',
        backgroundColor: props.year === year ? ColoursObj.core.secondary : ColoursObj.backgrounds.primary,
        borderRadius: '8px',
        ':hover': {
          cursor: 'pointer'
        }
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      color: props.year === year ? ColoursObj.backgrounds.primary : ColoursObj.core.primary
    }, year));
  }))));
};

const DatetimePickerV3Calendar = ({
  eventrDateString,
  onChange,
  hidePast,
  minDate,
  maxDate,
  extendMinMaxByDays,
  locale = 'en-GB'
}) => {
  const [yearSelectorOpen, setYearSelectorOpen] = useState(false);
  const extendedMinDate = minDate === null || minDate === void 0 ? void 0 : minDate.getCloneEventrDate();
  if (extendedMinDate && extendMinMaxByDays) {
    extendedMinDate.subtract({
      days: extendMinMaxByDays ?? 1
    });
  }
  const extendedMaxDate = maxDate === null || maxDate === void 0 ? void 0 : maxDate.getCloneEventrDate();
  if (extendedMaxDate && extendMinMaxByDays) {
    extendedMaxDate.add({
      days: extendMinMaxByDays ?? 1
    });
  }
  const todayEventrDate = new EventrDate();
  const [daysDisplayed, setDaysDisplayed] = useState([]);
  function handleOnChange(change) {
    if (change[0] && change[1] && change[2]) {
      onChange(change);
    }
  }
  useEffect(() => {
    const tmpEventrDate = new EventrDate(eventrDateString);
    setDaysDisplayed(datesToDisplay(tmpEventrDate === null || tmpEventrDate === void 0 ? void 0 : tmpEventrDate.itinLocalLuxon.month, tmpEventrDate === null || tmpEventrDate === void 0 ? void 0 : tmpEventrDate.itinLocalLuxon.year));
  }, [eventrDateString]);
  function handleClick(day) {
    if ((maxDate || minDate) && !isDateInRange$1(day, extendedMaxDate, extendedMinDate, true)) {
      return;
    }
    handleOnChange([day.itinLocalLuxon.day, day.itinLocalLuxon.month, day.itinLocalLuxon.year]);
  }
  function handleMonthClick(direction) {
    const newSelectedDate = new EventrDate(eventrDateString);
    if (direction === 'left') {
      if (newSelectedDate.itinLocalLuxon.month === 0) {
        newSelectedDate === null || newSelectedDate === void 0 ? void 0 : newSelectedDate.setFromObject({
          year: newSelectedDate.itinLocalLuxon.year ?? 2024 - 1,
          month: 12
        });
      } else {
        const daysInPrevMonth = DateTime.fromObject({
          year: newSelectedDate.itinLocalLuxon.year,
          month: (newSelectedDate.itinLocalLuxon.month ?? 1) - 1
        }).daysInMonth ?? 31;
        if ((newSelectedDate.itinLocalLuxon.day ?? 1) > daysInPrevMonth) {
          newSelectedDate.setFromObject({
            day: daysInPrevMonth
          });
        }
        newSelectedDate.setFromObject({
          month: (newSelectedDate.itinLocalLuxon.month ?? 1) - 1
        });
      }
      handleOnChange([newSelectedDate.itinLocalLuxon.day, newSelectedDate.itinLocalLuxon.month, newSelectedDate.itinLocalLuxon.year]);
    } else if (direction === 'right') {
      if (newSelectedDate.itinLocalLuxon.month === 11) {
        newSelectedDate === null || newSelectedDate === void 0 ? void 0 : newSelectedDate.setFromObject({
          year: (newSelectedDate.itinLocalLuxon.year ?? 2024) + 1,
          month: 0
        });
      } else {
        const daysInNextMonth = DateTime.fromObject({
          year: newSelectedDate.itinLocalLuxon.year,
          month: (newSelectedDate.itinLocalLuxon.month ?? 1) + 1
        }).daysInMonth ?? 31;
        if ((newSelectedDate.itinLocalLuxon.day ?? 1) > daysInNextMonth) {
          newSelectedDate.setFromObject({
            day: daysInNextMonth
          });
        }
        newSelectedDate.setFromObject({
          month: (newSelectedDate.itinLocalLuxon.month ?? 0) + 1
        });
      }
      handleOnChange([newSelectedDate.itinLocalLuxon.day, newSelectedDate.itinLocalLuxon.month, newSelectedDate.itinLocalLuxon.year]);
    } else {
      return;
    }
  }
  function handleYearClick(direction) {
    const newSelectedDate = new EventrDate(eventrDateString);
    if (direction === 'down') {
      newSelectedDate.subtract({
        year: 1
      });
      handleOnChange([newSelectedDate.itinLocalLuxon.day, newSelectedDate.itinLocalLuxon.month, newSelectedDate.itinLocalLuxon.year]);
    } else if (direction === 'up') {
      newSelectedDate.add({
        year: 1
      });
      handleOnChange([newSelectedDate.itinLocalLuxon.day, newSelectedDate.itinLocalLuxon.month, newSelectedDate.itinLocalLuxon.year]);
    } else {
      return;
    }
  }
  function handleYearSelect(select) {
    const newSelectedDate = new EventrDate(eventrDateString);
    newSelectedDate.setFromObject({
      year: select
    });
    handleOnChange([newSelectedDate.itinLocalLuxon.day, newSelectedDate.itinLocalLuxon.month, newSelectedDate.itinLocalLuxon.year]);
    setYearSelectorOpen(false);
  }
  function monthFromValue() {
    const newEventrDate = new EventrDate(eventrDateString);
    return newEventrDate.itinLocalLuxon.setLocale(locale).toLocaleString({
      month: 'long'
    });
  }
  function yearFromValue() {
    const newEventrDate = new EventrDate(eventrDateString);
    return newEventrDate.itinLocalLuxon.setLocale(locale).toLocaleString({
      year: 'numeric'
    });
  }
  function getWeekDays() {
    let weekdays = [];
    for (let dayId = 1; dayId <= 7; dayId++) {
      const newEventrDate = new EventrDate(0);
      newEventrDate.clearTimezone();
      newEventrDate.setFromObject({
        hour: 12,
        weekday: dayId
      });
      weekdays.push(newEventrDate.utcLuxon.setLocale(locale).toLocaleString({
        weekday: 'short'
      }));
    }
    return weekdays;
  }
  function getLabelRow() {
    const weekdays = getWeekDays();
    return weekdays.map((day, index) => ( /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1 0 0'
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: 'bodySubtext',
      color: ColoursObj.core.primary
    }, day))));
  }
  function datesToDisplay(month, year) {
    var days = [];
    const tmpEventrDate = new EventrDate(eventrDateString);
    const first_day_of_month = tmpEventrDate.getCloneEventrDate();
    first_day_of_month.setFromObject({
      year: year,
      month: month,
      day: 1
    });
    const number_of_days_of_last_month = first_day_of_month.itinLocalLuxon.weekday === 1 ? 7 : (first_day_of_month.itinLocalLuxon.weekday ?? 1) - 1;
    const last_day_previous_month = new EventrDate();
    last_day_previous_month.setFromObject({
      year: year,
      month: month,
      day: 0
    });
    for (let i = last_day_previous_month.itinLocalLuxon.day - number_of_days_of_last_month + 1; i <= last_day_previous_month.itinLocalLuxon.day; i++) {
      const tmpDayToBeAdded = first_day_of_month.getCloneEventrDate();
      tmpDayToBeAdded.setFromObject({
        year: month === 0 ? year - 1 : year,
        month: month === 1 ? 12 : month - 1,
        day: i
      });
      days = days.concat(tmpDayToBeAdded);
    }
    const next_current_month = new EventrDate();
    next_current_month.setFromObject({
      year: month === 11 ? year + 1 : year,
      month: month === 11 ? 0 : month + 1,
      day: 0
    });
    for (let i = 1; i <= next_current_month.itinLocalLuxon.day; i++) {
      const tmpDayToBeAdded = first_day_of_month.getCloneEventrDate();
      tmpDayToBeAdded.setFromObject({
        year: year,
        month: month,
        day: i
      });
      days = days.concat(tmpDayToBeAdded);
    }
    const a = days.length;
    for (let i = 1; i <= 42 - a; i++) {
      const tmpDayToBeAdded = first_day_of_month.getCloneEventrDate();
      tmpDayToBeAdded.setFromObject({
        year: month === 12 ? year + 1 : year,
        month: month === 12 ? 1 : month + 1,
        day: i
      });
      days = days.concat(tmpDayToBeAdded);
    }
    return days;
  }
  function calendarRows() {
    const tmpEventrDate = new EventrDate(eventrDateString);
    return /*#__PURE__*/React__default.createElement(Stack, {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
      gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 1fr',
      height: '80%'
    }, daysDisplayed.map((day, index) => ( /*#__PURE__*/React__default.createElement(Stack, {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: '1 0 0',
      key: index,
      onClick: () => {
        handleClick(day);
      },
      id: 'calendarDates-' + day.dateTimeString,
      sx: {
        backgroundColor: (tmpEventrDate === null || tmpEventrDate === void 0 ? void 0 : tmpEventrDate.itinLocalLuxon.day) === day.itinLocalLuxon.day && (tmpEventrDate === null || tmpEventrDate === void 0 ? void 0 : tmpEventrDate.itinLocalLuxon.month) === day.itinLocalLuxon.month && tmpEventrDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? ColoursObj.core.secondary : todayEventrDate.itinLocalLuxon.day === day.itinLocalLuxon.day && todayEventrDate.itinLocalLuxon.month === day.itinLocalLuxon.month && todayEventrDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? ColoursObj.shades.shade3 : ColoursObj.backgrounds.primary,
        borderRadius: (tmpEventrDate === null || tmpEventrDate === void 0 ? void 0 : tmpEventrDate.itinLocalLuxon.day) === day.itinLocalLuxon.day && (tmpEventrDate === null || tmpEventrDate === void 0 ? void 0 : tmpEventrDate.itinLocalLuxon.month) === day.itinLocalLuxon.month && tmpEventrDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? '4px' : todayEventrDate.itinLocalLuxon.day === day.itinLocalLuxon.day && todayEventrDate.itinLocalLuxon.month === day.itinLocalLuxon.month && todayEventrDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? '4px' : '0',
        ':hover': {
          cursor: 'pointer'
        }
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      color: (tmpEventrDate === null || tmpEventrDate === void 0 ? void 0 : tmpEventrDate.itinLocalLuxon.day) === day.itinLocalLuxon.day && (tmpEventrDate === null || tmpEventrDate === void 0 ? void 0 : tmpEventrDate.itinLocalLuxon.month) === day.itinLocalLuxon.month && tmpEventrDate.itinLocalLuxon.year === day.itinLocalLuxon.year ? ColoursObj.shades.shade5 : day.itinLocalLuxon.month != tmpEventrDate.itinLocalLuxon.month ? ColoursObj.shades.shade2 : hidePast && isDateInPast(day) ? ColoursObj.shades.shade2 : !isDateInRange$1(day, extendedMaxDate, extendedMinDate, true) ? ColoursObj.shades.shade2 : ColoursObj.core.primary
    }, day.itinLocalLuxon.day)))));
  }
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Stack, {
    style: {
      minHeight: '330px',
      padding: '0 0 8px 0',
      minWidth: '280px'
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '8px'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'leftChevronButton',
    variant: 'ghost',
    icon: 'Chevron_Left',
    iconColour: ColoursObj.shades.shade2,
    style: {
      margin: '0 4px',
      width: '24px'
    },
    onClick: () => {
      handleMonthClick('left');
    },
    size: 'small'
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyBold',
    color: ColoursObj.core.primary
  }, monthFromValue()), /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'rightChevronButton',
    variant: 'ghost',
    icon: 'Chevron_Right',
    iconColour: ColoursObj.shades.shade2,
    style: {
      margin: '0 4px',
      width: '24px'
    },
    onClick: () => handleMonthClick('right'),
    size: 'small'
  })), /*#__PURE__*/React__default.createElement(Stack, null), /*#__PURE__*/React__default.createElement(Stack, {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '8px'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'leftChevronButton',
    variant: 'ghost',
    icon: 'Chevron_Down',
    iconColour: ColoursObj.shades.shade2,
    style: {
      margin: '0 4px',
      width: '24px'
    },
    onClick: () => {
      handleYearClick('down');
    },
    size: 'small'
  }), yearSelectorOpen && ( /*#__PURE__*/React__default.createElement(DatetimePickerV3YearSelector, {
    year: new EventrDate(eventrDateString).itinLocalLuxon.year,
    onClick: handleYearSelect
  })), /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => {
      setYearSelectorOpen(!yearSelectorOpen);
    },
    sx: {
      ':hover': {
        cursor: 'pointer'
      }
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyBold',
    color: ColoursObj.core.primary
  }, yearFromValue())), /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'leftChevronButton',
    variant: 'ghost',
    icon: 'Chevron_Up',
    iconColour: ColoursObj.shades.shade2,
    style: {
      margin: '0 4px',
      width: '24px'
    },
    onClick: () => {
      handleYearClick('up');
    },
    size: 'small'
  }))), /*#__PURE__*/React__default.createElement(Stack, {
    flex: '1 0 0',
    padding: '0 8px'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    flexDirection: 'row',
    height: '20%',
    paddingTop: '8px',
    boxSizing: 'border-box'
  }, getLabelRow()), calendarRows())));
};

const maxHeight = '500px';
function getDayJsValue(datetimeString) {
  if (datetimeString) {
    const tmpEventrDate = new EventrDate(datetimeString);
    let timeToDispaly = dayjs(tmpEventrDate.toItinLocalDateTimeString());
    return dayjs(timeToDispaly);
  } else {
    return null;
  }
}
const DatetimePickerPopover = props => {
  if (!props.datetimeString) {
    return null;
  }
  const minDate = new EventrDate(props.minDateTimeString);
  const maxDate = new EventrDate(props.maxDateTimeString);
  if (props.extendMinMaxByDays) {
    minDate.subtract({
      days: props.extendMinMaxByDays
    });
    maxDate.add({
      days: props.extendMinMaxByDays
    });
  }
  function getLimitValueIfOnDay(limitDate, minMax) {
    const selectedEventrDateLuxon = new EventrDate(props.datetimeString).itinLocalLuxon;
    const limitEventrDateLuxon = limitDate.itinLocalLuxon;
    if (selectedEventrDateLuxon.day === limitEventrDateLuxon.day && selectedEventrDateLuxon.month === limitEventrDateLuxon.month && selectedEventrDateLuxon.year === limitEventrDateLuxon.year) {
      const dateToUse = limitDate.getCloneEventrDate();
      const itinTz = useItinInfo.getState().timezone;
      if (itinTz && dateToUse.isOverriden) {
        dateToUse.setTimezone(itinTz, false);
      }
      switch (minMax) {
        case 'min':
          return getDayJsValue(dateToUse.dateTimeString);
        case 'max':
          return getDayJsValue(dateToUse.dateTimeString);
      }
    } else {
      return null;
    }
  }
  return /*#__PURE__*/React__default.createElement(Paper, {
    style: {
      position: props.popoverPosition,
      height: '0px',
      overflow: 'visible',
      zIndex: 130
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: props.width,
      borderRadius: '6px',
      border: '1px solid ' + ColoursObj.shades.shade2,
      backgroundColor: ColoursObj.shades.shade5,
      filter: `drop-shadow(0 0 8px ${ColoursObj.shades.shade2})`,
      zIndex: 130,
      display: 'grid',
      maxHeight: maxHeight,
      opacity: 1,
      animation: '.2s ease-in 1 onOpen',
      '@keyframes onOpen': {
        '0%': {
          opacity: '0'
        },
        '100%': {
          opacity: '1'
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(LocalizationProvider, {
    dateAdapter: AdapterDayjs
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    gridTemplateColumns: '1fr auto'
  }, /*#__PURE__*/React__default.createElement(DatetimePickerV3Calendar, {
    eventrDateString: props.datetimeString,
    onChange: change => {
      const tmpEventrDate = new EventrDate(props.datetimeString);
      tmpEventrDate.setFromObject({
        day: change[0],
        month: change[1],
        year: change[2]
      });
      props.updateState({
        day: String(tmpEventrDate.itinLocalLuxon.day).padStart(2, '0'),
        month: String(tmpEventrDate.itinLocalLuxon.month).padStart(2, '0'),
        year: String(tmpEventrDate.itinLocalLuxon.year).padStart(4, '0')
      });
    },
    minDate: props.minDateTimeString ? minDate : undefined,
    maxDate: props.maxDateTimeString ? maxDate : undefined,
    extendMinMaxByDays: props.extendMinMaxByDays
  }), (props.datetimeV3FormatList.includes('hour') || props.datetimeV3FormatList.includes('minute')) && ( /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    borderLeft: '1px solid ' + ColoursObj.shades.shade2
  }, /*#__PURE__*/React__default.createElement(MultiSectionDigitalClock, {
    ampm: false,
    timeSteps: {
      minutes: 1
    },
    autoFocus: false,
    sx: {
      width: '100%',
      height: '100%',
      maxHeight: maxHeight,
      borderBottom: 'none',
      '& .MuiList-root': {
        width: '50%',
        height: '100%',
        maxHeight: '100%',
        overflowY: 'scroll',
        scrollbarColor: ColoursObj.shades.shade2 + ' transparent'
      },
      '& .MuiMenuItem-root': {
        width: '38px'
      },
      '& .Mui-selected': {
        backgroundColor: ColoursObj.core.secondary + ' !important',
        borderRadius: '4px'
      }
    },
    value: getDayJsValue(props.datetimeString),
    onChange: value => {
      if (value) {
        props.updateState({
          hour: String(value.hour()).padStart(2, '0'),
          minute: String(value.minute()).padStart(2, '0')
        });
      }
    },
    minTime: props.minDateTimeString ? getLimitValueIfOnDay(minDate, 'min') : null,
    maxTime: props.maxDateTimeString ? getLimitValueIfOnDay(maxDate, 'max') : null
  })))))));
};

const inputStyle = {
  outline: 'none',
  width: '100%',
  height: '40px',
  textAlign: 'center',
  padding: '0',
  border: 'none',
  backgroundColor: 'transparent',
  fontSize: '16px',
  fontWeight: '400',
  fontFamily: 'Inter-100-500',
  lineHeight: '24px',
  color: ColoursObj.font.primary,
  margin: '0'
};
const NumberInputForDatetimePickerV3 = props => {
  inputStyle.opacity = props.disabled ? '0.38' : '1';
  return /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: props.tooltip
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("input", {
    type: 'text',
    ref: props.refPass,
    value: props.value,
    onChange: () => {},
    onKeyDown: props.onKeyDown,
    onClick: props.onClick,
    onFocus: props.onFocus,
    placeholder: props.placeholder,
    maxLength: props.maxLength,
    style: {
      ...inputStyle,
      padding: '0 ' + 2 * props.maxLength + 'px'
    },
    disabled: props.disabled,
    tabIndex: props.tabAble ? undefined : -1
  })));
};

const DatetimeV3FormatList = ['day', 'month', 'year', 'hour', 'minute'];
const DatetimeV3SeparatorsList = ['/', '-', '.', ':', ',', ' '];
const datetimeV3FormatConfig = {
  day: {
    minValue: 1,
    maxValue: 31,
    niceName: 'Day',
    placeholder: 'DD',
    length: 2
  },
  month: {
    minValue: 1,
    maxValue: 12,
    niceName: 'Month',
    placeholder: 'MM',
    length: 2
  },
  year: {
    minValue: 1940,
    maxValue: 2099,
    niceName: 'Year',
    placeholder: 'YYYY',
    length: 4
  },
  hour: {
    minValue: 0,
    maxValue: 23,
    niceName: 'Hour',
    placeholder: 'HH',
    length: 2
  },
  minute: {
    minValue: 0,
    maxValue: 59,
    niceName: 'Minute',
    placeholder: 'MM',
    length: 2
  }
};
function getMinValueFromV3Format(datetimeV3Format) {
  return datetimeV3FormatConfig[datetimeV3Format].minValue;
}
function getMaxValueFromV3Format(datetimeV3Format, year, month) {
  let objMax = datetimeV3FormatConfig[datetimeV3Format].maxValue;
  if (datetimeV3Format === 'day') {
    objMax = daysInMonthStr(year ?? '2024', month ?? '01');
  }
  return objMax;
}
function getLengthValueFromV3Format(datetimeV3Format) {
  return datetimeV3FormatConfig[datetimeV3Format].length;
}
function getNiceNameFromV3Format(datetimeV3Format) {
  return datetimeV3FormatConfig[datetimeV3Format].niceName;
}
function getPlaceholderFromV3Format(datetimeV3Format) {
  return datetimeV3FormatConfig[datetimeV3Format].placeholder;
}
function isLastInFromV3FormatList(datetimeV3Format, datetimeV3FormatList) {
  if (!datetimeV3FormatList.includes(datetimeV3Format)) {
    return false;
  }
  if (datetimeV3FormatList[datetimeV3FormatList.length - 1] === datetimeV3Format) {
    return true;
  }
  return false;
}
function getBeforeSeparatorFromV3Format(datetimeV3Format, datetimeFormat) {
  let separator = '';
  datetimeFormat.forEach((item, index) => {
    if (item === datetimeV3Format) {
      if (index > 0 && DatetimeV3SeparatorsList.includes(datetimeFormat[index - 1])) {
        separator = datetimeFormat[index - 1];
      }
    }
  });
  return /*#__PURE__*/React__default.createElement(Fragment, null, separator);
}
function getPrevInputFromV3Format(datetimeV3Format, datetimeV3FormatList) {
  let currIndex = -1;
  datetimeV3FormatList.forEach((item, index) => {
    if (item === datetimeV3Format) {
      currIndex = index;
    }
  });
  if (currIndex === -1) {
    return datetimeV3FormatList[0];
  }
  if (currIndex === 0) {
    return datetimeV3FormatList[datetimeV3FormatList.length - 1];
  }
  return datetimeV3FormatList[currIndex - 1];
}
function getNextInputFromV3Format(datetimeV3Format, datetimeV3FormatList) {
  let currIndex = -1;
  datetimeV3FormatList.forEach((item, index) => {
    if (item === datetimeV3Format) {
      currIndex = index;
    }
  });
  if (currIndex === -1) {
    return datetimeV3FormatList[datetimeV3FormatList.length - 1];
  }
  if (currIndex === datetimeV3FormatList.length - 1) {
    return datetimeV3FormatList[0];
  }
  return datetimeV3FormatList[currIndex + 1];
}

function v3HelperGetEventrDateFromDatetimeString(dateTimeString, withoutTZ, setToTimeOfDay) {
  if (!dateTimeString) return undefined;
  const newEventrDate = new EventrDate(dateTimeString);
  if (withoutTZ) {
    newEventrDate.clearTimezone();
  }
  if (setToTimeOfDay) {
    switch (setToTimeOfDay) {
      case 'start':
        newEventrDate.setFromObject({
          hour: 0,
          minute: 0,
          second: 1
        });
        break;
      case 'end':
        newEventrDate.setFromObject({
          hour: 23,
          minute: 59,
          second: 59
        });
        break;
      case 'middle':
        newEventrDate.setFromObject({
          hour: 12,
          minute: 0,
          second: 1
        });
        break;
    }
  }
  if (newEventrDate.isValid) {
    return newEventrDate;
  }
  return undefined;
}
const selectInputText = input => {
  if (input) {
    input.focus();
    input.setSelectionRange(0, input.value.length);
  }
};
function isStringNotValidNumber(value) {
  if (!value) {
    return true;
  }
  if (isNaN(Number(value))) {
    return true;
  }
  return false;
}
function v3HelperGetEventrDateFromObj(newObj, oldDatetimeString, withoutTZ, setToTimeOfDay, onOpenDateTimeString) {
  const tmpEventrDate = new EventrDate(oldDatetimeString || onOpenDateTimeString);
  if (!oldDatetimeString) {
    tmpEventrDate.clearTimezone();
  }
  if (setToTimeOfDay) {
    switch (setToTimeOfDay) {
      case 'start':
        tmpEventrDate.setFromObject({
          hour: 0,
          minute: 0,
          second: 1
        });
        break;
      case 'end':
        tmpEventrDate.setFromObject({
          hour: 23,
          minute: 59,
          second: 59
        });
        break;
      case 'middle':
        tmpEventrDate.setFromObject({
          hour: 12,
          minute: 0,
          second: 1
        });
        break;
    }
  }
  if (withoutTZ) {
    tmpEventrDate.clearTimezone();
  }
  for (const jsonKey of DatetimeV3FormatList) {
    if (!isStringNotValidNumber(newObj[jsonKey]) && parseInt(newObj[jsonKey], 10) >= getMinValueFromV3Format(jsonKey)) {
      tmpEventrDate.setFromObject({
        [jsonKey]: parseInt(newObj[jsonKey], 10)
      });
    }
  }
  if (tmpEventrDate.isValid) {
    return tmpEventrDate;
  }
  return undefined;
}
function v3HelperGetDatetimeDisplayObjFromEventrDate(eventrDate) {
  let newObjToSet = {};
  for (const jsonKey of DatetimeV3FormatList) {
    newObjToSet[jsonKey] = eventrDate !== null && eventrDate !== void 0 && eventrDate.itinLocalLuxon[jsonKey] || (eventrDate === null || eventrDate === void 0 ? void 0 : eventrDate.itinLocalLuxon[jsonKey]) === 0 ? String((eventrDate === null || eventrDate === void 0 ? void 0 : eventrDate.itinLocalLuxon[jsonKey]) ?? '').padStart(getLengthValueFromV3Format(jsonKey), '0') : '';
  }
  return newObjToSet;
}
function getTimezoneTextForV3DatePicker(datetimeString, itineraryTZ) {
  const eventrDate = new EventrDate(datetimeString);
  const typoStyle = {
    maxHeight: '30px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: '50px',
    overflow: 'hidden'
  };
  if (datetimeString && eventrDate.timezoneNumber) {
    return /*#__PURE__*/React__default.createElement(Typography, {
      variant: 'bodyBold',
      sx: typoStyle
    }, getFlagEmojiFromTimezoneEnum(eventrDate.timezoneNumber), ' ', getTimezoneName(eventrDate.timezoneNumber).split('/')[getTimezoneName(eventrDate.timezoneNumber).split('/').length - 1].replaceAll('_', ' '));
  }
  return /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular',
    sx: typoStyle
  }, itineraryTZ ? getFlagEmojiFromTimezoneEnum(getTimezoneNumber(itineraryTZ)) + ' ' + itineraryTZ.split('/')[itineraryTZ.split('/').length - 1].replaceAll('_', ' ') : 'Unset (UTC)');
}

function createCancellablePromise(action) {
  let timeoutId;
  const promise = new Promise(resolve => {
    timeoutId = setTimeout(() => {
      action();
      resolve();
    }, 2000);
  });
  return {
    promise,
    cancel: () => {
      clearTimeout(timeoutId);
    },
    action
  };
}
let cancellable = null;
const completePendingAction = () => {
  var _cancellable, _cancellable2;
  (_cancellable = cancellable) === null || _cancellable === void 0 ? void 0 : _cancellable.action();
  (_cancellable2 = cancellable) === null || _cancellable2 === void 0 ? void 0 : _cancellable2.cancel();
  cancellable = null;
};
const cancelPendingAction = () => {
  var _cancellable3;
  (_cancellable3 = cancellable) === null || _cancellable3 === void 0 ? void 0 : _cancellable3.cancel();
  cancellable = null;
};
const DatetimePickerV3 = ({
  id,
  datetimeString = undefined,
  setDatetimeString = () => {},
  onClear = () => {},
  datetimeFormat = ['day', '/', 'month', '/', 'year', ' ', 'hour', ':', 'minute'],
  disabled = false,
  withoutTZ = false,
  label = '',
  dropdownPlaceholderText = 'Please Select',
  defaultTZText = 'Event TZ',
  width = '408px',
  required = false,
  toolTip = '',
  errored = false,
  errorText = '',
  setToTimeOfDay = undefined,
  minDateTimeString,
  maxDateTimeString,
  onOpenDateTimeString = undefined,
  timezoneTooltip = 'Select Timezone',
  clearTooltip = 'Clear Datetime',
  popoverPosition = 'sticky',
  onClose,
  error,
  errorMessage,
  noBorder = false,
  tabAble = true,
  extendMinMaxByDays
}) => {
  const itineraryTZ = useItinInfo(s => s.timezone);
  const datetimeV3FormatList = datetimeFormat.filter(item => {
    return DatetimeV3FormatList.includes(item);
  });
  const [openTimezoneSelector, setOpenTimezoneSelector] = useState(false);
  const [previousFocused, setPreviousFocused] = useState(false);
  const [focusedOnThis, setFocusedOnThis] = useState(false);
  const datetimeToDisplayObjInit = () => {
    const tmpEventrDate = v3HelperGetEventrDateFromDatetimeString(datetimeString, withoutTZ, setToTimeOfDay);
    return v3HelperGetDatetimeDisplayObjFromEventrDate(tmpEventrDate);
  };
  const [datetimeToDisplayObj, setDatetimeToDisplayObj] = useState(datetimeToDisplayObjInit());
  useEffect(() => {
    setDatetimeToDisplayObj(datetimeToDisplayObjInit());
  }, [datetimeString]);
  useEffect(() => {
    if (onClose && previousFocused && !focusedOnThis) {
      setPreviousFocused(false);
      onClose();
    }
  }, [focusedOnThis]);
  const handleClickOutside = useCallback(() => {
    setFocusedOnThis(false);
  }, []);
  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);
  const hourRef = useRef(null);
  const minuteRef = useRef(null);
  function updateState(objectToAdd, updateDatetimeString = true) {
    const newObjToSave = {
      ...datetimeToDisplayObj,
      ...objectToAdd
    };
    setDatetimeToDisplayObj(newObjToSave);
    if (updateDatetimeString) if (setDatetimeString) {
      const newEventrDatetime = v3HelperGetEventrDateFromObj(newObjToSave, datetimeString, withoutTZ, setToTimeOfDay, onOpenDateTimeString);
      setDatetimeString(newEventrDatetime ? newEventrDatetime.dateTimeString : undefined);
    }
  }
  const handleIncrement = (value, min, max, step) => {
    let newValue = parseInt(value || '0', 10) + step;
    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;
    return newValue.toString().padStart(2, '0');
  };
  const handleKeyDown = (datetimeV3Format, e, nextInput, prevInput, min, max, value, tabAble) => {
    if (e.key === 'Tab') {
      completePendingAction();
      if (!tabAble) {
        setFocusedOnThis(false);
      } else if (isLastInFromV3FormatList(datetimeV3Format, datetimeV3FormatList)) {
        setFocusedOnThis(false);
      }
    }
    if (e.key === 'Backspace') {
      e.preventDefault();
      if (value === '') {
        selectInputText(prevInput.current);
      } else {
        handleValueChange(datetimeV3Format, '');
      }
    }
    if (e.key === 'ArrowUp') {
      completePendingAction();
      e.preventDefault();
      handleValueChange(datetimeV3Format, handleIncrement(value, min, max, 1));
    } else if (e.key === 'ArrowDown') {
      completePendingAction();
      e.preventDefault();
      handleValueChange(datetimeV3Format, handleIncrement(value, min, max, -1));
    }
    if (e.key === 'ArrowRight') {
      completePendingAction();
      e.preventDefault();
      selectInputText(nextInput.current);
    } else if (e.key === 'ArrowLeft') {
      completePendingAction();
      e.preventDefault();
      selectInputText(prevInput.current);
    }
    if (e.key === 'Escape') {
      completePendingAction();
      e.preventDefault();
      setFocusedOnThis(false);
    }
    if (DatetimeV3SeparatorsList.includes(e.key)) {
      completePendingAction();
      e.preventDefault();
      selectInputText(nextInput.current);
    }
    if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(e.key)) {
      e.preventDefault();
      if (datetimeV3Format === 'day') {
        handleDayChange(e.key, value);
        return;
      }
      if (datetimeV3Format === 'month') {
        handleMonthChange(e.key, value);
        return;
      }
      if (datetimeV3Format === 'year') {
        handleYearChange(e.key, value);
        return;
      }
      if (datetimeV3Format === 'hour') {
        handleHourChange(e.key, value);
        return;
      }
      if (datetimeV3Format === 'minute') {
        handleMinuteChange(e.key, value);
        return;
      }
    }
  };
  const handleDayChange = (newValue, value) => {
    cancelPendingAction();
    if (parseInt(newValue, 10) > 3) {
      if (value.length === 0 || value.length > 1) {
        handleValueChange('day', `0${newValue}`);
        return;
      } else {
        const max = getMaxValueFromV3Format('day', datetimeToDisplayObj.year, datetimeToDisplayObj.month);
        if (max < parseInt(`${value}${newValue}`, 10)) {
          cancellable = createCancellablePromise(() => {
            handleValueChange('day', `0${value}`);
          });
          return;
        } else {
          handleValueChange('day', `${value}${newValue}`);
          return;
        }
      }
    }
    if (parseInt(newValue, 10) === 1) {
      if (value.length === 0 || value.length === 2) {
        handleValueChange('day', newValue, false);
        cancellable = createCancellablePromise(() => {
          handleValueChange('day', `0${newValue}`);
        });
      } else {
        cancelPendingAction();
        cancellable = null;
        const max = getMaxValueFromV3Format('day', datetimeToDisplayObj.year, datetimeToDisplayObj.month);
        if (max < parseInt(`${value}${newValue}`, 10)) {
          cancellable = createCancellablePromise(() => {
            handleValueChange('day', `0${value}`);
          });
          return;
        } else {
          handleValueChange('day', `${value}${newValue}`);
          return;
        }
      }
    }
    if (parseInt(newValue, 10) === 2) {
      if (value.length === 0 || value.length === 2) {
        handleValueChange('day', newValue, false);
        cancellable = createCancellablePromise(() => {
          handleValueChange('day', `0${newValue}`);
        });
      } else {
        const max = getMaxValueFromV3Format('day', datetimeToDisplayObj.year, datetimeToDisplayObj.month);
        if (max < parseInt(`${value}${newValue}`, 10)) {
          cancellable = createCancellablePromise(() => {
            handleValueChange('day', `0${value}`);
          });
          return;
        } else {
          handleValueChange('day', `${value}${newValue}`);
          return;
        }
      }
    }
    if (parseInt(newValue, 10) === 3) {
      if (value.length === 0 || value.length === 2) {
        const max = getMaxValueFromV3Format('day', datetimeToDisplayObj.year, datetimeToDisplayObj.month);
        if (max < 31) {
          handleValueChange('day', `0${newValue}`);
        } else {
          handleValueChange('day', newValue, false);
          cancellable = createCancellablePromise(() => {
            handleValueChange('day', `0${newValue}`);
          });
        }
      } else {
        const max = getMaxValueFromV3Format('day', datetimeToDisplayObj.year, datetimeToDisplayObj.month);
        if (max < parseInt(`${value}${newValue}`, 10)) {
          cancellable = createCancellablePromise(() => {
            handleValueChange('day', `0${value}`);
          });
          return;
        } else {
          handleValueChange('day', `${value}${newValue}`);
          return;
        }
      }
    }
    if (parseInt(newValue, 10) === 0) {
      if (value.length === 0 || value.length === 2) {
        handleValueChange('day', newValue, false);
        cancellable = createCancellablePromise(() => {
          handleValueChange('day', `01`);
        });
      } else {
        const max = getMaxValueFromV3Format('day', datetimeToDisplayObj.year, datetimeToDisplayObj.month);
        if (`${value}${newValue}` === '00') {
          handleValueChange('day', '01');
          cancelPendingAction();
          return;
        }
        if (max < parseInt(`${value}${newValue}`, 10)) {
          cancellable = createCancellablePromise(() => {
            handleValueChange('day', `0${value}`);
          });
          return;
        } else {
          handleValueChange('day', `${value}${newValue}`);
          return;
        }
      }
    }
  };
  const handleMonthChange = (newValue, value) => {
    cancelPendingAction();
    const intNewValue = parseInt(newValue, 10);
    if (value.length === 0 || value.length > 1) {
      handleValueChange('month', newValue, false);
      cancellable = createCancellablePromise(() => {
        if (intNewValue === 0) {
          handleValueChange('month', `01`);
        } else {
          handleValueChange('month', `0${newValue}`);
        }
      });
      return;
    }
    if (value.length === 1) {
      if (value === '0') {
        if (intNewValue === 0) {
          handleValueChange('month', `01`);
          return;
        } else {
          handleValueChange('month', `${value}${newValue}`);
          return;
        }
      }
      if (value === '1') {
        if (intNewValue < 3) {
          handleValueChange('month', `${value}${newValue}`);
          return;
        }
        cancelPendingAction();
        cancellable = createCancellablePromise(() => {
          handleValueChange('month', `0${value}`);
        });
      }
      return;
    }
    if (intNewValue > 1) {
      if (value.length === 0 || value.length > 1) {
        handleValueChange('month', `0${newValue}`);
        return;
      } else {
        if (intNewValue < 3 && value === '0') {
          handleValueChange('month', `${value}${newValue}`);
          return;
        } else {
          cancellable = createCancellablePromise(() => {
            handleValueChange('month', `0${value}`);
          });
          return;
        }
      }
    }
    if (intNewValue === 1) {
      if (value.length === 0 || value.length > 1) {
        handleValueChange('month', newValue, false);
        cancellable = createCancellablePromise(() => {
          handleValueChange('month', `0${newValue}`);
        });
        return;
      } else {
        handleValueChange('month', `${value}${newValue}`);
        return;
      }
    }
    if (intNewValue === 0) {
      console.log('month 0');
      if (value.length === 0 || value.length > 1) {
        handleValueChange('month', newValue, false);
        cancellable = createCancellablePromise(() => {
          handleValueChange('month', `01`);
        });
        return;
      } else {
        if (`${value}${newValue}` === '00') {
          handleValueChange('month', '01');
          cancelPendingAction();
          return;
        }
        console.log('month 0');
        handleValueChange('month', `${value}${newValue}`);
        return;
      }
    }
  };
  const handleYearChange = (newValue, value) => {
    cancelPendingAction();
    if (value.length === 0 || value.length > 3) {
      handleValueChange('year', newValue, false);
      cancellable = createCancellablePromise(() => {
        handleValueChange('year', `200${newValue}`);
      });
      return;
    }
    if (value.length === 1) {
      const enteredValue = `${value}${newValue}`;
      handleValueChange('year', enteredValue, false);
      cancellable = createCancellablePromise(() => {
        handleValueChange('year', `20${enteredValue}`);
      });
      return;
    }
    if (value.length === 2) {
      const enteredValue = `${value}${newValue}`;
      if (value === '20' || value === '19') {
        handleValueChange('year', enteredValue, false);
        cancellable = createCancellablePromise(() => {
          handleValueChange('year', `${enteredValue}0`);
        });
        return;
      } else {
        cancellable = createCancellablePromise(() => {
          handleValueChange('year', `20${value}`);
        });
        return;
      }
    }
    if (value.length === 3) {
      handleValueChange('year', `${value}${newValue}`);
      return;
    }
  };
  const handleHourChange = (newValue, value) => {
    cancelPendingAction();
    if (value.length === 0 || value.length > 1) {
      handleValueChange('hour', newValue, false);
      cancellable = createCancellablePromise(() => {
        handleValueChange('hour', `0${newValue}`);
      });
      return;
    }
    if (value.length === 1) {
      const enteredValue = `${value}${newValue}`;
      const enteredValueInt = parseInt(enteredValue, 10);
      if (enteredValueInt > 23) {
        cancelPendingAction();
        cancellable = createCancellablePromise(() => {
          handleValueChange('hour', `0${value}`);
        });
        return;
      }
      handleValueChange('hour', enteredValue);
      return;
    }
  };
  const handleMinuteChange = (newValue, value) => {
    cancelPendingAction();
    if (value.length === 0 || value.length > 1) {
      handleValueChange('minute', newValue, false);
      cancellable = createCancellablePromise(() => {
        handleValueChange('minute', `0${newValue}`);
      });
      return;
    }
    if (value.length === 1) {
      const enteredValue = `${value}${newValue}`;
      const enteredValueInt = parseInt(enteredValue, 10);
      if (enteredValueInt > 59) {
        cancelPendingAction();
        cancellable = createCancellablePromise(() => {
          handleValueChange('minute', `0${value}`);
        });
        return;
      }
      handleValueChange('minute', enteredValue);
      return;
    }
  };
  function handleValueChange(datetimeV3Format, newValue, pushUpdate = true) {
    if (newValue === '') {
      updateState({
        [datetimeV3Format]: newValue
      });
    }
    if (!/^\d+$/.test(newValue)) return;
    updateState({
      [datetimeV3Format]: newValue
    }, pushUpdate);
  }
  const handleInputOnClick = event => {
    selectInputText(event.currentTarget);
  };
  function onTimezoneChange(value) {
    if ((value === null || value === void 0 ? void 0 : value.obj.ccDisplayName) === defaultTZText) {
      if (datetimeString && setDatetimeString) {
        const newEventrDate = new EventrDate(datetimeString);
        newEventrDate.clearTimezone();
        setDatetimeString(newEventrDate.dateTimeString);
      }
    } else if (value !== null && value !== void 0 && value.id && typeof value.id === 'string') {
      if (setDatetimeString) {
        const newEventrDate = new EventrDate(datetimeString);
        newEventrDate.setTimezone(value === null || value === void 0 ? void 0 : value.id);
        setDatetimeString(newEventrDate.dateTimeString);
      }
    }
  }
  function getRefFromV3Format(datetimeV3Format) {
    switch (datetimeV3Format) {
      case 'day':
        return dayRef;
      case 'month':
        return monthRef;
      case 'year':
        return yearRef;
      case 'hour':
        return hourRef;
      case 'minute':
        return minuteRef;
    }
  }
  function onKeydownGeneric(datetimeV3Format, e, tabAble = true) {
    handleKeyDown(datetimeV3Format, e, getRefFromV3Format(getNextInputFromV3Format(datetimeV3Format, datetimeV3FormatList)), getRefFromV3Format(getPrevInputFromV3Format(datetimeV3Format, datetimeV3FormatList)), getMinValueFromV3Format(datetimeV3Format), getMaxValueFromV3Format(datetimeV3Format, datetimeToDisplayObj.year, datetimeToDisplayObj.month), datetimeToDisplayObj[datetimeV3Format], tabAble);
  }
  function handleOnFocus() {
    if (disabled) return;
    if (!datetimeString) {
      updateState({});
    }
    setFocusedOnThis(true);
    setPreviousFocused(true);
  }
  function showClearButton() {
    if ((datetimeToDisplayObj.day || datetimeToDisplayObj.month || datetimeToDisplayObj.year || datetimeToDisplayObj.hour || datetimeToDisplayObj.minute) && !disabled) {
      return true;
    }
    return false;
  }
  if (openTimezoneSelector) {
    return /*#__PURE__*/React__default.createElement(Box, {
      width: width
    }, /*#__PURE__*/React__default.createElement(TimezoneDropdown, {
      fieldLabel: label ?? '',
      placeholder: dropdownPlaceholderText,
      onChange: onTimezoneChange,
      selectedDateTimeString: datetimeString,
      onClose: () => {
        setOpenTimezoneSelector(false);
      },
      defaultTZText: defaultTZText,
      onBackClick: () => {
        setOpenTimezoneSelector(false);
      }
    }));
  }
  const outerStyle = {
    display: 'grid',
    gridAutoFlow: 'column',
    borderRadius: noBorder ? '0' : '8px',
    width: width,
    maxWidth: width,
    border: noBorder ? '' : `${error ? '2px ' : '1px'} solid`,
    borderColor: noBorder ? '' : `${error ? ColoursObj.states.error : ColoursObj.shades.shade2}`,
    alignItems: 'center',
    justifyItems: 'center',
    height: `${error ? '38px ' : '42px'}`
  };
  if (disabled) {
    outerStyle.backgroundColor = ColoursObj.shades.shade4;
  }
  return /*#__PURE__*/React__default.createElement(Box, {
    id: id,
    onClick: e => {
      e.stopPropagation();
    }
  }, label && ( /*#__PURE__*/React__default.createElement(FormLabel, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      padding: '3px 0px 4px 0'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodySubtext',
    style: {
      opacity: disabled ? '0.38' : '1'
    }
  }, label + (required ? ' *' : '')), toolTip && ( /*#__PURE__*/React__default.createElement("div", {
    style: {
      alignContent: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    text: toolTip
  }))))), /*#__PURE__*/React__default.createElement("div", {
    style: outerStyle
  }, /*#__PURE__*/React__default.createElement(Box, null), datetimeV3FormatList.map(datetimeV3Format => {
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: datetimeV3Format + 'Frag'
    }, getBeforeSeparatorFromV3Format(datetimeV3Format, datetimeFormat), /*#__PURE__*/React__default.createElement(NumberInputForDatetimePickerV3, {
      key: datetimeV3Format,
      refPass: getRefFromV3Format(datetimeV3Format),
      value: datetimeToDisplayObj[datetimeV3Format],
      onKeyDown: e => {
        onKeydownGeneric(datetimeV3Format, e, tabAble);
      },
      onFocus: handleOnFocus,
      onClick: handleInputOnClick,
      placeholder: getPlaceholderFromV3Format(datetimeV3Format),
      maxLength: getLengthValueFromV3Format(datetimeV3Format),
      tooltip: getNiceNameFromV3Format(datetimeV3Format),
      disabled: disabled,
      tabAble: tabAble
    }));
  }), /*#__PURE__*/React__default.createElement(HorizontalExpander, {
    open: showClearButton()
  }, /*#__PURE__*/React__default.createElement(Box, {
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: clearTooltip,
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement("div", {
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    variant: 'borderless',
    size: 'small',
    onClick: () => {
      setFocusedOnThis(false);
      onClear();
    },
    style: {
      width: '24px'
    },
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement(CloseIcon, {
    htmlColor: ColoursObj.shades.shade2
  })))))), !withoutTZ && ( /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: timezoneTooltip
  }, /*#__PURE__*/React__default.createElement("div", {
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => {
      if (disabled) {
        return;
      }
      setOpenTimezoneSelector(true);
    },
    sx: {
      display: 'grid',
      alignItems: 'center',
      height: '39px',
      '&:hover': {
        cursor: 'pointer'
      },
      padding: '0 8px 0 0',
      opacity: disabled ? '0.38' : '1'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    gridAutoFlow: 'column',
    gap: '8px',
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular',
    color: ColoursObj.core.secondary
  }, "|"), getTimezoneTextForV3DatePicker(datetimeString, itineraryTZ))))))), error && ( /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular',
    height: '24px',
    margin: '0 14px 0 14px',
    color: ColoursObj.states.error
  }, errorMessage)), focusedOnThis && ( /*#__PURE__*/React__default.createElement(DatetimePickerPopover, {
    datetimeString: datetimeString,
    datetimeV3FormatList: datetimeV3FormatList,
    width: width,
    updateState: updateState,
    minDateTimeString: minDateTimeString,
    maxDateTimeString: maxDateTimeString,
    popoverPosition: popoverPosition,
    extendMinMaxByDays: extendMinMaxByDays
  })), errored && errorText && ( /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      padding: '2px 0 0 16px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyError'
  }, errorText))));
};

const FormDatePicker = props => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: props.name,
    control: props.control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(DatePicker, Object.assign({}, props, {
        onSave: onChange,
        date: value,
        textError: error ? error.message : '',
        isError: !!error
      }));
    }
  });
};

const MobileDateOfBirthPicker = ({
  id,
  date,
  onSave = () => {},
  hidePast,
  fieldLabel,
  helperText,
  drawerHeader,
  required,
  isError,
  textError,
  initialState,
  minDate,
  maxDate,
  locale = 'en-GB',
  selectText = 'Select date',
  saveText = 'Save',
  clearText = 'Clear'
}) => {
  const dateText = () => {
    if (date) {
      const eventrDate = new EventrDate(date);
      return eventrDate.itinLocalLuxon.setLocale(locale).toLocaleString(DateTime.DATE_SHORT);
    } else {
      return selectText;
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TextInputField, {
    id: id,
    value: dateText(),
    onClick: () => {
      spLogTags('Opening date picker', ['eventrdate']);
      drawerStore().openDrawer({
        node: ( /*#__PURE__*/React__default.createElement(MobileDrawerFrame, {
          title: drawerHeader
        }, /*#__PURE__*/React__default.createElement(CalenderDrawer, {
          eventrDateString: date,
          close: () => {
            drawerStore().closeDrawer();
          },
          onSave: onSave,
          onClear: () => {
            onSave(undefined);
          },
          hidePast: hidePast,
          initialState: initialState,
          minDate: minDate,
          maxDate: maxDate,
          locale: locale,
          saveText: saveText,
          clearText: clearText
        }))),
        onBackdropClick: () => {
          drawerStore().closeDrawer();
        }
      });
    },
    readOnly: true,
    fieldLabel: fieldLabel,
    helperText: helperText,
    required: required,
    error: isError,
    errorMessage: textError
  }));
};

const FormMobileDateOfBirthPicker = props => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: props.name,
    control: props.control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(MobileDateOfBirthPicker, Object.assign({}, props, {
        onSave: onChange,
        date: value,
        textError: error ? error.message : '',
        isError: !!error
      }));
    }
  });
};

const MobileDateRangePicker = ({
  fieldLabel,
  startDateTimeString,
  endDateTimeString,
  onSave,
  disabled,
  translationString = {
    saveButton: 'Save',
    select: 'Please select a date range'
  },
  openTo,
  onClear,
  language = 'en-GB',
  isError,
  textError,
  hidePast,
  required
}) => {
  function handleOnFocus() {
    if (disabled) return;
    useDrawerStore.getState().openDrawer({
      node: ( /*#__PURE__*/React__default.createElement(MobileRangeCalenderForDrawer, {
        translationString: translationString,
        onSave: onSave,
        fieldLabel: fieldLabel,
        onClear: onClear,
        openTo: openTo,
        startDateTimeString: startDateTimeString,
        endDateTimeString: endDateTimeString,
        language: language,
        hidePast: hidePast
      })),
      onBackdropClick: () => {
        useDrawerStore.getState().closeDrawer();
      },
      onClose: () => {}
    });
  }
  return /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(TextInputField, {
    id: fieldLabel,
    fieldLabel: fieldLabel,
    value: MobileDateRangePickerUtils.getDrawerTitle(startDateTimeString ? new EventrDate(startDateTimeString) : undefined, endDateTimeString ? new EventrDate(endDateTimeString) : undefined, translationString.select, language),
    onClick: () => {
      handleOnFocus();
    },
    readOnly: true,
    error: isError,
    errorMessage: textError,
    required: required
  }));
};

const TimePicker = ({
  id,
  time,
  onSave,
  fieldLabel,
  required,
  disabled,
  helperTooltip,
  style,
  helperText,
  drawerHeader,
  isError,
  textError,
  locale = 'en-GB',
  selectTimeString = 'Select time'
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    id: id
  }, /*#__PURE__*/React__default.createElement(TextInputField, {
    value: time ? String(new EventrDate(time).itinLocalLuxon.setLocale(locale).toLocaleString({
      hour: '2-digit',
      minute: '2-digit'
    })) : selectTimeString,
    onClick: () => {
      spLogTags('Openning Time picker', ['eventrdate']);
      drawerStore().openDrawer({
        node: ( /*#__PURE__*/React__default.createElement(MobileDrawerFrame, {
          title: drawerHeader
        }, /*#__PURE__*/React__default.createElement(ClockFaceDrawer, {
          eventrDateString: time,
          close: () => {
            drawerStore().closeDrawer();
          },
          onSave: onSave,
          onClear: () => {
            onSave(undefined);
          }
        }))),
        onBackdropClick: () => {
          drawerStore().closeDrawer();
        }
      });
    },
    readOnly: true,
    fieldLabel: fieldLabel,
    helperText: helperText,
    required: required,
    disabled: disabled,
    helperTooltip: helperTooltip,
    style: style,
    error: isError,
    errorMessage: textError
  }));
};

const timezones = [{
  name: '-12:00',
  offset: 720
}, {
  name: '-11:30',
  offset: 690
}, {
  name: '-11:00',
  offset: 660
}, {
  name: '-10:30',
  offset: 630
}, {
  name: '-10:00',
  offset: 600
}, {
  name: '-09:30',
  offset: 570
}, {
  name: '-09:00',
  offset: 540
}, {
  name: '-08:30',
  offset: 510
}, {
  name: '-08:00',
  offset: 480
}, {
  name: '-07:30',
  offset: 450
}, {
  name: '-07:00',
  offset: 420
}, {
  name: '-06:30',
  offset: 390
}, {
  name: '-06:00',
  offset: 360
}, {
  name: '-05:30',
  offset: 330
}, {
  name: '-05:00',
  offset: 300
}, {
  name: '-04:30',
  offset: 270
}, {
  name: '-04:00',
  offset: 240
}, {
  name: '-03:30',
  offset: 210
}, {
  name: '-03:00',
  offset: 180
}, {
  name: '-02:30',
  offset: 150
}, {
  name: '-02:00',
  offset: 120
}, {
  name: '-01:30',
  offset: 90
}, {
  name: '-01:00',
  offset: 60
}, {
  name: '-00:30',
  offset: 30
}, {
  name: '+00:00',
  offset: 0
}, {
  name: '+00:30',
  offset: -30
}, {
  name: '+01:00',
  offset: -60
}, {
  name: '+01:30',
  offset: -90
}, {
  name: '+02:00',
  offset: -120
}, {
  name: '+02:30',
  offset: -150
}, {
  name: '+03:00',
  offset: -180
}, {
  name: '+03:30',
  offset: -210
}, {
  name: '+04:00',
  offset: -240
}, {
  name: '+04:30',
  offset: -270
}, {
  name: '+05:00',
  offset: -300
}, {
  name: '+05:30',
  offset: -330
}, {
  name: '+06:00',
  offset: -360
}, {
  name: '+06:30',
  offset: -390
}, {
  name: '+07:00',
  offset: -420
}, {
  name: '+07:30',
  offset: -450
}, {
  name: '+08:00',
  offset: -480
}, {
  name: '+08:30',
  offset: -510
}, {
  name: '+09:00',
  offset: -540
}, {
  name: '+09:30',
  offset: -570
}, {
  name: '+10:00',
  offset: -600
}, {
  name: '+10:30',
  offset: -630
}, {
  name: '+11:00',
  offset: -660
}, {
  name: '+11:30',
  offset: -690
}, {
  name: '+12:00',
  offset: -720
}];
const TimeZoneClickable = ({
  onChange,
  viewOnly,
  isOverriden
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'timezone-popover' : undefined;
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = event => {
    if (viewOnly) return;
    setAnchorEl(event.currentTarget);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular',
    color: ColoursObj.font.secondary
  }, !isOverriden && 'Override Time Zone', isOverriden && 'Time Zone override: ' + 'something borken??/')), /*#__PURE__*/React__default.createElement(Popover, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    style: {
      width: 160,
      height: 400
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(List$1, null, timezones.map((tz, index) => ( /*#__PURE__*/React__default.createElement(ListItem, {
    disablePadding: true,
    key: index
  }, /*#__PURE__*/React__default.createElement(ListItemButton, {
    onClick: () => {
      handleClose();
      onChange(tz.offset);
    }
  }, /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: tz.name
  })))))))));
};

const DateRangeFilterButton = ({
  filterTitle
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState();
  const clickHandler = useCallback(e => {
    setSubMenuOpen(undefined);
    setMenuOpen(false);
  }, []);
  useEffect(() => {
    window.addEventListener('click', clickHandler);
    return () => window.removeEventListener('click', clickHandler);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    }
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    style: {
      position: 'relative',
      width: '400px',
      justifyContent: 'space-between',
      borderRadius: '4px',
      border: '1px solid ' + ColoursObj.shades.shade3,
      backgroundColor: ColoursObj.shades.shade5
    },
    text: filterTitle,
    fontColour: ColoursObj.font.primary,
    icon: 'Chevron_Down',
    iconPosition: 'right',
    iconColour: ColoursObj.font.primary,
    onClick: e => {
      e.stopPropagation();
      setMenuOpen(!menuOpen);
      setSubMenuOpen(undefined);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: ColoursObj.shades.shade5,
      color: ColoursObj.shades.shade5,
      height: '26px',
      width: '24px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }), menuOpen && ( /*#__PURE__*/React__default.createElement(Paper, {
    style: {
      position: 'absolute',
      left: '0px',
      top: '52px',
      borderRadius: '4px',
      border: '1px solid ' + ColoursObj.shades.shade3,
      backgroundColor: ColoursObj.shades.shade5,
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      borderRadius: '4px',
      padding: '8px',
      backgroundColor: ColoursObj.shades.shade5,
      boxSizing: 'border-box',
      overflow: 'auto',
      height: '500px',
      width: '800px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '130px',
      display: 'flex',
      flexDirection: 'column'
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '654px',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: '420px',
      display: 'flex',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '50%'
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '50%'
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: '64px',
      display: 'flex',
      flexDirection: 'row'
    }
  }))))), subMenuOpen && ( /*#__PURE__*/React__default.createElement(Paper, {
    style: {
      position: 'absolute',
      left: '358px',
      top: '52px',
      width: '350px',
      maxWidth: '500px',
      maxHeight: '457px',
      borderRadius: '4px',
      border: '1px solid ' + ColoursObj.shades.shade3,
      backgroundColor: ColoursObj.shades.shade5,
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: '200px',
      width: '200px'
    }
  })))));
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

const RsuiteDateRangePicker = ({
  onChange,
  oneCalendar,
  showMeridian,
  onShortcutClick,
  defaultRanges
}) => {
  const predefinedRanges = [{
    label: 'Today',
    value: [DateTime.fromISO('00:00:00').toJSDate(), new Date()],
    placement: 'left'
  }, {
    label: 'Yesterday',
    value: [addDays(DateTime.fromISO('00:00:00').toJSDate(), -1), addDays(DateTime.fromISO('23:59:99').toJSDate(), -1)],
    placement: 'left'
  }, {
    label: 'This week',
    value: [startOfWeek(new Date()), endOfWeek(new Date())],
    placement: 'left'
  }, {
    label: 'Last 7 days',
    value: [subDays(DateTime.fromISO('00:00:00').toJSDate(), 6), new Date()],
    placement: 'left'
  }, {
    label: 'Last 30 days',
    value: [subDays(DateTime.fromISO('00:00:00').toJSDate(), 29), new Date()],
    placement: 'left'
  }, {
    label: 'This month',
    value: [startOfMonth(new Date()), new Date()],
    placement: 'left'
  }, {
    label: 'Last month',
    value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
    placement: 'left'
  }, {
    label: 'This year',
    value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
    placement: 'left'
  }, {
    label: 'Last year',
    value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
    placement: 'left'
  }, {
    label: 'All time',
    value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date()],
    placement: 'left'
  }, {
    label: 'Last week',
    closeOverlay: false,
    value: value => {
      const [start = new Date()] = value || [];
      return [addDays(startOfWeek(start, {
        weekStartsOn: 0
      }), -7), addDays(endOfWeek(start, {
        weekStartsOn: 0
      }), -7)];
    }
  }, {
    label: 'Next week',
    closeOverlay: false,
    value: value => {
      const [start = new Date()] = value || [];
      return [addDays(startOfWeek(start, {
        weekStartsOn: 0
      }), 7), addDays(endOfWeek(start, {
        weekStartsOn: 0
      }), 7)];
    }
  }];
  return /*#__PURE__*/React__default.createElement("div", {
    className: '',
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    }
  }, /*#__PURE__*/React__default.createElement(DateRangePicker$2, {
    size: 'lg',
    ranges: defaultRanges ?? predefinedRanges,
    placeholder: 'Date',
    style: {
      width: '400px',
      height: '40px'
    },
    onShortcutClick: onShortcutClick,
    showMeridian: showMeridian ?? true,
    format: 'yyyy-MM-dd HH:mm',
    showOneCalendar: oneCalendar,
    onChange: onChange
  }));
};

const AutoCompleteInputField = ({
  options,
  id,
  fieldLabel,
  autoComplete,
  autoSelect,
  freeSolo = false,
  listOnOpen,
  listLimit = 10,
  inputOnChange,
  filterOptions,
  onSelect,
  placeholder,
  disabled = false,
  readOnly = false
}) => {
  const [open, setOpen] = React__default.useState(false);
  const [inputValue, setInputValue] = React__default.useState('');
  const filterOptionsCreated = filterOptions ?? createFilterOptions({
    limit: listLimit
  });
  return /*#__PURE__*/React__default.createElement(Autocomplete, {
    open: open,
    onOpen: () => {
      if (listOnOpen) {
        setOpen(true);
      } else {
        if (inputValue !== '') {
          setOpen(true);
        }
      }
    },
    onClose: () => {
      setOpen(false);
    },
    inputValue: inputValue,
    onInputChange: (event, value) => {
      setInputValue(value);
      if (!value) {
        setOpen(false);
      }
      if (inputOnChange) {
        inputOnChange(event);
      }
    },
    freeSolo: freeSolo,
    autoComplete: autoComplete,
    autoSelect: autoSelect,
    id: id,
    options: !options ? [{
      label: 'test1'
    }, {
      label: 'test2'
    }, {
      label: 'test3'
    }] : options,
    filterOptions: filterOptionsCreated,
    renderInput: params => {
      return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, params, {
        size: 'medium',
        placeholder: placeholder,
        style: {
          padding: '0'
        },
        label: /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/React__default.createElement(Typography$1, {
          variant: 'bodySubtext'
        }, fieldLabel)),
        InputLabelProps: {
          shrink: true
        },
        disabled: disabled,
        sx: {
          Label: {
            transform: 'translateY(-8px)'
          }
        }
      })));
    },
    onSelect: onSelect,
    disabled: disabled,
    readOnly: readOnly,
    PaperComponent: props => ( /*#__PURE__*/React__default.createElement(Paper, Object.assign({}, props, {
      style: {
        background: ColoursObj.backgrounds.primary,
        color: ColoursObj.core.primary
      }
    })))
  });
};

const filterOptions = (options, {
  inputValue
}) => {
  return options.filter(option => {
    var _option$obj;
    return (option.label.toLowerCase() + (option === null || option === void 0 ? void 0 : (_option$obj = option.obj) === null || _option$obj === void 0 ? void 0 : _option$obj.municipality.toLowerCase())).includes(inputValue.toLowerCase());
  });
};
const AirportAutoComplete = args => {
  return /*#__PURE__*/React__default.createElement(AutoCompleteInputField, Object.assign({}, args, {
    options: airports,
    filterOptions: filterOptions
  }));
};
const airports = [{
  label: 'Aalborg Airport (AAL) - DK',
  id: 'AAL',
  obj: {
    iata: 'AAL',
    iso: 'DK',
    coordinates: '9.84924316406, 57.0927589138',
    municipality: 'Aalborg'
  }
}, {
  label: 'Aarhus Airport (AAR) - DK',
  id: 'AAR',
  obj: {
    iata: 'AAR',
    iso: 'DK',
    coordinates: '10.619000434899998, 56.2999992371',
    municipality: 'Aarhus'
  }
}, {
  label: 'Aasiaat Airport (JEG) - GL',
  id: 'JEG',
  obj: {
    iata: 'JEG',
    iso: 'GL',
    coordinates: '-52.7846984863, 68.7218017578',
    municipality: 'Aasiaat'
  }
}, {
  label: 'Hongyuan Airport (AHJ) - CN',
  id: 'AHJ',
  obj: {
    iata: 'AHJ',
    iso: 'CN',
    coordinates: '102.35224, 32.53154',
    municipality: 'Aba'
  }
}, {
  label: 'Abadan Airport (ABD) - IR',
  id: 'ABD',
  obj: {
    iata: 'ABD',
    iso: 'IR',
    coordinates: '48.2282981873, 30.371099472',
    municipality: 'Abadan'
  }
}, {
  label: 'Abakan Airport (ABA) - RU',
  id: 'ABA',
  obj: {
    iata: 'ABA',
    iso: 'RU',
    coordinates: '91.38500213623047, 53.7400016784668',
    municipality: 'Abakan'
  }
}, {
  label: 'Canton Island Airport (CIS) - KI',
  id: 'CIS',
  obj: {
    iata: 'CIS',
    iso: 'KI',
    coordinates: '-171.710006714, -2.7681200504300003',
    municipality: 'Abariringa'
  }
}, {
  label: 'Abbotsford Airport (YXX) - CA',
  id: 'YXX',
  obj: {
    iata: 'YXX',
    iso: 'CA',
    coordinates: '-122.36100006103516, 49.025299072265625',
    municipality: 'Abbotsford'
  }
}, {
  label: 'Aberdeen Dyce Airport (ABZ) - GB',
  id: 'ABZ',
  obj: {
    iata: 'ABZ',
    iso: 'GB',
    coordinates: '-2.197779893875122, 57.201900482177734',
    municipality: 'Aberdeen'
  }
}, {
  label: 'Aberdeen Regional Airport (ABR) - US',
  id: 'ABR',
  obj: {
    iata: 'ABR',
    iso: 'US',
    coordinates: '-98.42179870605469, 45.449100494384766',
    municipality: 'Aberdeen'
  }
}, {
  label: 'Phillips Army Air Field (APG) - US',
  id: 'APG',
  obj: {
    iata: 'APG',
    iso: 'US',
    coordinates: '-76.1688, 39.466202',
    municipality: 'Aberdeen Proving Grounds(Aberdeen)'
  }
}, {
  label: 'Abha Regional Airport (AHB) - SA',
  id: 'AHB',
  obj: {
    iata: 'AHB',
    iso: 'SA',
    coordinates: '42.65660095210001, 18.240400314299997',
    municipality: 'Abha'
  }
}, {
  label: 'Port Bouet Airport (ABJ) - CI',
  id: 'ABJ',
  obj: {
    iata: 'ABJ',
    iso: 'CI',
    coordinates: '-3.9262900352478027, 5.261390209197998',
    municipality: 'Abidjan'
  }
}, {
  label: 'Abilene Regional Airport (ABI) - US',
  id: 'ABI',
  obj: {
    iata: 'ABI',
    iso: 'US',
    coordinates: '-99.68190002440001, 32.4113006592',
    municipality: 'Abilene'
  }
}, {
  label: 'Dyess Air Force Base (DYS) - US',
  id: 'DYS',
  obj: {
    iata: 'DYS',
    iso: 'US',
    coordinates: '-99.854598999, 32.4207992554',
    municipality: 'Abilene'
  }
}, {
  label: 'Mayaguana Airport (MYG) - BS',
  id: 'MYG',
  obj: {
    iata: 'MYG',
    iso: 'BS',
    coordinates: '-73.013494, 22.379499',
    municipality: 'Abrahams Bay'
  }
}, {
  label: 'Abu Dhabi International Airport (AUH) - AE',
  id: 'AUH',
  obj: {
    iata: 'AUH',
    iso: 'AE',
    coordinates: '54.651100158691406, 24.433000564575195',
    municipality: 'Abu Dhabi'
  }
}, {
  label: 'Abu Musa Island Airport (AEU) - IR',
  id: 'AEU',
  obj: {
    iata: 'AEU',
    iso: 'IR',
    coordinates: '55.033001, 25.8757',
    municipality: 'Abu Musa'
  }
}, {
  label: 'Abu Simbel Airport (ABS) - EG',
  id: 'ABS',
  obj: {
    iata: 'ABS',
    iso: 'EG',
    coordinates: '31.611700058, 22.375999450699997',
    municipality: 'Abu Simbel'
  }
}, {
  label: 'Nnamdi Azikiwe International Airport (ABV) - NG',
  id: 'ABV',
  obj: {
    iata: 'ABV',
    iso: 'NG',
    coordinates: '7.263169765472412, 9.006790161132812',
    municipality: 'Abuja'
  }
}, {
  label: 'General Juan N Alvarez International Airport (ACA) - MX',
  id: 'ACA',
  obj: {
    iata: 'ACA',
    iso: 'MX',
    coordinates: '-99.75399780273438, 16.757099151611328',
    municipality: 'Acapulco'
  }
}, {
  label: 'Oswaldo Guevara Mujica Airport (AGV) - VE',
  id: 'AGV',
  obj: {
    iata: 'AGV',
    iso: 'VE',
    coordinates: '-69.23786926269531, 9.553375244140625',
    municipality: 'Acarigua'
  }
}, {
  label: 'Kotoka International Airport (ACC) - GH',
  id: 'ACC',
  obj: {
    iata: 'ACC',
    iso: 'GH',
    coordinates: '-0.16678600013256073, 5.605189800262451',
    municipality: 'Accra'
  }
}, {
  label: 'Achinsk Airport (ACS) - RU',
  id: 'ACS',
  obj: {
    iata: 'ACS',
    iso: 'RU',
    coordinates: '90.57080078125, 56.2682991027832',
    municipality: 'Achinsk'
  }
}, {
  label: 'King Fahd International Airport (DMM) - SA',
  id: 'DMM',
  obj: {
    iata: 'DMM',
    iso: 'SA',
    coordinates: '49.79790115356445, 26.471200942993164',
    municipality: 'Ad Dammam'
  }
}, {
  label: 'Adak Airport (ADK) - US',
  id: 'ADK',
  obj: {
    iata: 'ADK',
    iso: 'US',
    coordinates: '-176.64599609375, 51.87799835205078',
    municipality: 'Adak Island'
  }
}, {
  label: 'Adana Airport (ADA) - TR',
  id: 'ADA',
  obj: {
    iata: 'ADA',
    iso: 'TR',
    coordinates: '35.280399322499996, 36.9822006226',
    municipality: 'Adana'
  }
}, {
  label: '\u00c4\u00b0ncirlik Air Base (UAB) - TR',
  id: 'UAB',
  obj: {
    iata: 'UAB',
    iso: 'TR',
    coordinates: '35.4258995056, 37.002101898199996',
    municipality: 'Adana'
  }
}, {
  label: 'Addis Ababa Bole International Airport (ADD) - ET',
  id: 'ADD',
  obj: {
    iata: 'ADD',
    iso: 'ET',
    coordinates: '38.799301147499996, 8.97789001465',
    municipality: 'Addis Ababa'
  }
}, {
  label: 'Adelaide International Airport (ADL) - AU',
  id: 'ADL',
  obj: {
    iata: 'ADL',
    iso: 'AU',
    coordinates: '138.531006, -34.945',
    municipality: 'Adelaide'
  }
}, {
  label: 'Aden International Airport (ADE) - YE',
  id: 'ADE',
  obj: {
    iata: 'ADE',
    iso: 'YE',
    coordinates: '45.02880096435547, 12.829500198364258',
    municipality: 'Aden'
  }
}, {
  label: 'Ad\u00c4\u00b1yaman Airport (ADF) - TR',
  id: 'ADF',
  obj: {
    iata: 'ADF',
    iso: 'TR',
    coordinates: '38.4688987732, 37.7313995361',
    municipality: 'Ad\u00c4\u00b1yaman'
  }
}, {
  label: 'Afyon Airport (AFY) - TR',
  id: 'AFY',
  obj: {
    iata: 'AFY',
    iso: 'TR',
    coordinates: '30.6011009216, 38.726398468',
    municipality: 'Afyonkarahisar'
  }
}, {
  label: 'Mano Dayak International Airport (AJY) - NE',
  id: 'AJY',
  obj: {
    iata: 'AJY',
    iso: 'NE',
    coordinates: '8.000109672546387, 16.965999603271484',
    municipality: 'Agadez'
  }
}, {
  label: 'Al Massira Airport (AGA) - MA',
  id: 'AGA',
  obj: {
    iata: 'AGA',
    iso: 'MA',
    coordinates: '-9.413069725036621, 30.325000762939453',
    municipality: 'Agadir'
  }
}, {
  label: 'Agartala Airport (IXA) - IN',
  id: 'IXA',
  obj: {
    iata: 'IXA',
    iso: 'IN',
    coordinates: '91.24040222170001, 23.8869991302',
    municipality: 'Agartala'
  }
}, {
  label: 'Agen-La Garenne Airport (AGF) - FR',
  id: 'AGF',
  obj: {
    iata: 'AGF',
    iso: 'FR',
    coordinates: '0.5905560255050659, 44.17470169067383',
    municipality: 'Agen/La Garenne'
  }
}, {
  label: 'Aggeneys Airport (AGZ) - ZA',
  id: 'AGZ',
  obj: {
    iata: 'AGZ',
    iso: 'ZA',
    coordinates: '18.813899993896484, -29.28179931640625',
    municipality: 'Aggeneys'
  }
}, {
  label: 'Aghajari Airport (AKW) - IR',
  id: 'AKW',
  obj: {
    iata: 'AKW',
    iso: 'IR',
    coordinates: '49.6772, 30.7444',
    municipality: 'Aghajari'
  }
}, {
  label: 'Rafael Hernandez Airport (BQN) - PR',
  id: 'BQN',
  obj: {
    iata: 'BQN',
    iso: 'PR',
    coordinates: '-67.12940216064453, 18.49489974975586',
    municipality: 'Aguadilla'
  }
}, {
  label: 'Jes\u00c3\u00bas Ter\u00c3\u00a1n Paredo International Airport (AGU) - MX',
  id: 'AGU',
  obj: {
    iata: 'AGU',
    iso: 'MX',
    coordinates: '-102.318001, 21.705601',
    municipality: 'Aguascalientes'
  }
}, {
  label: 'Ahe Airport (AHE) - PF',
  id: 'AHE',
  obj: {
    iata: 'AHE',
    iso: 'PF',
    coordinates: '-146.2570037841797, -14.428099632263184',
    municipality: 'Ahe Atoll'
  }
}, {
  label: 'Ahmed Al Jaber Air Base (XIJ) - KW',
  id: 'XIJ',
  obj: {
    iata: 'XIJ',
    iso: 'KW',
    coordinates: '47.791900634799994, 28.9347991943',
    municipality: 'Ahmed Al Jaber AB'
  }
}, {
  label: 'Sardar Vallabhbhai Patel International Airport (AMD) - IN',
  id: 'AMD',
  obj: {
    iata: 'AMD',
    iso: 'IN',
    coordinates: '72.63469696039999, 23.0771999359',
    municipality: 'Ahmedabad'
  }
}, {
  label: 'Ahwaz Airport (AWZ) - IR',
  id: 'AWZ',
  obj: {
    iata: 'AWZ',
    iso: 'IR',
    coordinates: '48.7620010376, 31.337400436399996',
    municipality: 'Ahwaz'
  }
}, {
  label: 'Lengpui Airport (AJL) - IN',
  id: 'AJL',
  obj: {
    iata: 'AJL',
    iso: 'IN',
    coordinates: '92.6196975708, 23.840599060099997',
    municipality: 'Aizawl'
  }
}, {
  label: 'Ajaccio-Napol\u00c3\u00a9on Bonaparte Airport (AJA) - FR',
  id: 'AJA',
  obj: {
    iata: 'AJA',
    iso: 'FR',
    coordinates: '8.8029203414917, 41.92359924316406',
    municipality: 'Ajaccio/Napol\u00c3\u00a9on Bonaparte'
  }
}, {
  label: 'Kishangarh Airport (KQH) - IN',
  id: 'KQH',
  obj: {
    iata: 'KQH',
    iso: 'IN',
    coordinates: '74.814147, 26.601473',
    municipality: 'Ajmer'
  }
}, {
  label: 'Akita Airport (AXT) - JP',
  id: 'AXT',
  obj: {
    iata: 'AXT',
    iso: 'JP',
    coordinates: '140.218994140625, 39.6156005859375',
    municipality: 'Akita'
  }
}, {
  label: 'Aklavik/Freddie Carmichael Airport (LAK) - CA',
  id: 'LAK',
  obj: {
    iata: 'LAK',
    iso: 'CA',
    coordinates: '-135.00599, 68.223297',
    municipality: 'Aklavik'
  }
}, {
  label: 'Akola Airport (AKD) - IN',
  id: 'AKD',
  obj: {
    iata: 'AKD',
    iso: 'IN',
    coordinates: '77.058601, 20.698999',
    municipality: 'Akola'
  }
}, {
  label: 'Akron Fulton International Airport (AKC) - US',
  id: 'AKC',
  obj: {
    iata: 'AKC',
    iso: 'US',
    coordinates: '-81.4669036865, 41.0374984741',
    municipality: 'Akron'
  }
}, {
  label: 'Akron Canton Regional Airport (CAK) - US',
  id: 'CAK',
  obj: {
    iata: 'CAK',
    iso: 'US',
    coordinates: '-81.44219970703125, 40.916099548339844',
    municipality: 'Akron'
  }
}, {
  label: 'RAF Akrotiri (AKT) - GB',
  id: 'AKT',
  obj: {
    iata: 'AKT',
    iso: 'GB',
    coordinates: '32.9879, 34.590401',
    municipality: 'Akrotiri'
  }
}, {
  label: 'Aktau Airport (SCO) - KZ',
  id: 'SCO',
  obj: {
    iata: 'SCO',
    iso: 'KZ',
    coordinates: '51.091999, 43.8601',
    municipality: 'Aktau'
  }
}, {
  label: 'Aktobe Airport (AKX) - KZ',
  id: 'AKX',
  obj: {
    iata: 'AKX',
    iso: 'KZ',
    coordinates: '57.206699, 50.2458',
    municipality: 'Aktyubinsk'
  }
}, {
  label: 'Akulivik Airport (AKV) - CA',
  id: 'AKV',
  obj: {
    iata: 'AKV',
    iso: 'CA',
    coordinates: '-78.14859771728516, 60.818599700927734',
    municipality: 'Akulivik'
  }
}, {
  label: 'Akure Airport (AKR) - NG',
  id: 'AKR',
  obj: {
    iata: 'AKR',
    iso: 'NG',
    coordinates: '5.3010101318359375, 7.246739864349365',
    municipality: 'Akure'
  }
}, {
  label: 'Akureyri Airport (AEY) - IS',
  id: 'AEY',
  obj: {
    iata: 'AEY',
    iso: 'IS',
    coordinates: '-18.07270050048828, 65.66000366210938',
    municipality: 'Akureyri'
  }
}, {
  label: 'Al Ain International Airport (AAN) - AE',
  id: 'AAN',
  obj: {
    iata: 'AAN',
    iso: 'AE',
    coordinates: '55.60919952392578, 24.261699676513672',
    municipality: 'Al Ain'
  }
}, {
  label: 'La Abraq Airport (LAQ) - LY',
  id: 'LAQ',
  obj: {
    iata: 'LAQ',
    iso: 'LY',
    coordinates: '21.96430015563965, 32.788700103759766',
    municipality: "Al Bayda'"
  }
}, {
  label: 'Al Taqaddum Air Base (TQD) - IQ',
  id: 'TQD',
  obj: {
    iata: 'TQD',
    iso: 'IQ',
    coordinates: '43.597099304199, 33.33810043335',
    municipality: 'Al Habbaniyah'
  }
}, {
  label: 'Cherif Al Idrissi Airport (AHU) - MA',
  id: 'AHU',
  obj: {
    iata: 'AHU',
    iso: 'MA',
    coordinates: '-3.83951997756958, 35.177101135253906',
    municipality: 'Al Hoceima'
  }
}, {
  label: 'Rustaq Airport (MNH) - OM',
  id: 'MNH',
  obj: {
    iata: 'MNH',
    iso: 'OM',
    coordinates: '57.4875, 23.640556',
    municipality: "Al Masna'ah"
  }
}, {
  label: 'Majeed Bin Abdulaziz Airport (ULH) - SA',
  id: 'ULH',
  obj: {
    iata: 'ULH',
    iso: 'SA',
    coordinates: '38.1288888889, 26.48',
    municipality: 'Al Ula'
  }
}, {
  label: 'Al Wajh Domestic Airport (EJH) - SA',
  id: 'EJH',
  obj: {
    iata: 'EJH',
    iso: 'SA',
    coordinates: '36.47639846801758, 26.19860076904297',
    municipality: 'Al Wajh'
  }
}, {
  label: 'Al-Jawf Domestic Airport (AJF) - SA',
  id: 'AJF',
  obj: {
    iata: 'AJF',
    iso: 'SA',
    coordinates: '40.099998474121094, 29.78510093688965',
    municipality: 'Al-Jawf'
  }
}, {
  label: 'El Obeid Airport (EBD) - SD',
  id: 'EBD',
  obj: {
    iata: 'EBD',
    iso: 'SD',
    coordinates: '30.23270034790039, 13.153200149536133',
    municipality: 'Al-Ubayyid'
  }
}, {
  label: 'Alamogordo White Sands Regional Airport (ALM) - US',
  id: 'ALM',
  obj: {
    iata: 'ALM',
    iso: 'US',
    coordinates: '-105.990997314, 32.8399009705',
    municipality: 'Alamogordo'
  }
}, {
  label: 'Holloman Air Force Base (HMN) - US',
  id: 'HMN',
  obj: {
    iata: 'HMN',
    iso: 'US',
    coordinates: '-106.107002258, 32.8525009155',
    municipality: 'Alamogordo'
  }
}, {
  label: 'San Luis Valley Regional Bergman Field (ALS) - US',
  id: 'ALS',
  obj: {
    iata: 'ALS',
    iso: 'US',
    coordinates: '-105.866997, 37.434898',
    municipality: 'Alamosa'
  }
}, {
  label: 'Vitoria/Foronda Airport (VIT) - ES',
  id: 'VIT',
  obj: {
    iata: 'VIT',
    iso: 'ES',
    coordinates: '-2.7244699001312256, 42.8828010559082',
    municipality: 'Alava'
  }
}, {
  label: 'Albacete-Los Llanos Airport (ABC) - ES',
  id: 'ABC',
  obj: {
    iata: 'ABC',
    iso: 'ES',
    coordinates: '-1.8635200262099998, 38.9485015869',
    municipality: 'Albacete'
  }
}, {
  label: 'Southwest Georgia Regional Airport (ABY) - US',
  id: 'ABY',
  obj: {
    iata: 'ABY',
    iso: 'US',
    coordinates: '-84.19450378417969, 31.535499572753906',
    municipality: 'Albany'
  }
}, {
  label: 'Albany International Airport (ALB) - US',
  id: 'ALB',
  obj: {
    iata: 'ALB',
    iso: 'US',
    coordinates: '-73.80169677734375, 42.74829864501953',
    municipality: 'Albany'
  }
}, {
  label: 'Albany Airport (ALH) - AU',
  id: 'ALH',
  obj: {
    iata: 'ALH',
    iso: 'AU',
    coordinates: '117.80899810791016, -34.94329833984375',
    municipality: 'Albany'
  }
}, {
  label: "Villanova D'Albenga International Airport (ALL) - IT",
  id: 'ALL',
  obj: {
    iata: 'ALL',
    iso: 'IT',
    coordinates: '8.12743, 44.050598',
    municipality: 'Albenga (SV)'
  }
}, {
  label: 'Albi-Le S\u00c3\u00a9questre Airport (LBI) - FR',
  id: 'LBI',
  obj: {
    iata: 'LBI',
    iso: 'FR',
    coordinates: '2.1130599975585938, 43.91389846801758',
    municipality: 'Albi/Le S\u00c3\u00a9questre'
  }
}, {
  label: 'Marcos A. Gelabert International Airport (PAC) - PA',
  id: 'PAC',
  obj: {
    iata: 'PAC',
    iso: 'PA',
    coordinates: '-79.55560302734375, 8.973340034484863',
    municipality: 'Albrook'
  }
}, {
  label: 'Albuquerque International Sunport (ABQ) - US',
  id: 'ABQ',
  obj: {
    iata: 'ABQ',
    iso: 'US',
    coordinates: '-106.609001, 35.040199',
    municipality: 'Albuquerque'
  }
}, {
  label: 'Albury Airport (ABX) - AU',
  id: 'ABX',
  obj: {
    iata: 'ABX',
    iso: 'AU',
    coordinates: '146.95799255371094, -36.06779861450195',
    municipality: 'Albury'
  }
}, {
  label: 'Aleknagik / New Airport (WKK) - US',
  id: 'WKK',
  obj: {
    iata: 'WKK',
    iso: 'US',
    coordinates: '-158.617996216, 59.2826004028',
    municipality: 'Aleknagik'
  }
}, {
  label: 'Aleppo International Airport (ALP) - SY',
  id: 'ALP',
  obj: {
    iata: 'ALP',
    iso: 'SY',
    coordinates: '37.22439956665039, 36.18069839477539',
    municipality: 'Aleppo'
  }
}, {
  label: 'Alert Airport (YLT) - CA',
  id: 'YLT',
  obj: {
    iata: 'YLT',
    iso: 'CA',
    coordinates: '-62.2806015015, 82.51779937740001',
    municipality: 'Alert'
  }
}, {
  label: 'Alert Bay Airport (YAL) - CA',
  id: 'YAL',
  obj: {
    iata: 'YAL',
    iso: 'CA',
    coordinates: '-126.91600036621094, 50.58219909667969',
    municipality: 'Alert Bay'
  }
}, {
  label: 'Alexander Bay Airport (ALJ) - ZA',
  id: 'ALJ',
  obj: {
    iata: 'ALJ',
    iso: 'ZA',
    coordinates: '16.5333, -28.575001',
    municipality: 'Alexander Bay'
  }
}, {
  label: 'Alexandra Airport (ALR) - NZ',
  id: 'ALR',
  obj: {
    iata: 'ALR',
    iso: 'NZ',
    coordinates: '169.3730010986328, -45.211700439453125',
    municipality: 'Alexandra'
  }
}, {
  label: 'El Nouzha Airport (ALY) - EG',
  id: 'ALY',
  obj: {
    iata: 'ALY',
    iso: 'EG',
    coordinates: '29.94890022277832, 31.183900833129883',
    municipality: 'Alexandria'
  }
}, {
  label: 'Borg El Arab International Airport (HBE) - EG',
  id: 'HBE',
  obj: {
    iata: 'HBE',
    iso: 'EG',
    coordinates: '29.696399688720703, 30.917699813842773',
    municipality: 'Alexandria'
  }
}, {
  label: 'Alexandria International Airport (AEX) - US',
  id: 'AEX',
  obj: {
    iata: 'AEX',
    iso: 'US',
    coordinates: '-92.54979705810547, 31.32740020751953',
    municipality: 'Alexandria'
  }
}, {
  label: 'Chandler Field (AXN) - US',
  id: 'AXN',
  obj: {
    iata: 'AXN',
    iso: 'US',
    coordinates: '-95.39469909670001, 45.8662986755',
    municipality: 'Alexandria'
  }
}, {
  label: 'Esler Regional Airport (ESF) - US',
  id: 'ESF',
  obj: {
    iata: 'ESF',
    iso: 'US',
    coordinates: '-92.2957992554, 31.3948993683',
    municipality: 'Alexandria'
  }
}, {
  label: 'Dimokritos Airport (AXD) - GR',
  id: 'AXD',
  obj: {
    iata: 'AXD',
    iso: 'GR',
    coordinates: '25.956300735473633, 40.855899810791016',
    municipality: 'Alexandroupolis'
  }
}, {
  label: 'Alghero-Fertilia Airport (AHO) - IT',
  id: 'AHO',
  obj: {
    iata: 'AHO',
    iso: 'IT',
    coordinates: '8.29077, 40.632099',
    municipality: 'Alghero'
  }
}, {
  label: 'Houari Boumediene Airport (ALG) - DZ',
  id: 'ALG',
  obj: {
    iata: 'ALG',
    iso: 'DZ',
    coordinates: '3.215409994125366, 36.691001892089844',
    municipality: 'Algiers'
  }
}, {
  label: 'Alicante International Airport (ALC) - ES',
  id: 'ALC',
  obj: {
    iata: 'ALC',
    iso: 'ES',
    coordinates: '-0.5581560134887695, 38.28219985961914',
    municipality: 'Alicante'
  }
}, {
  label: 'Alice International Airport (ALI) - US',
  id: 'ALI',
  obj: {
    iata: 'ALI',
    iso: 'US',
    coordinates: '-98.02690124510002, 27.740900039699998',
    municipality: 'Alice'
  }
}, {
  label: 'Alice Springs Airport (ASP) - AU',
  id: 'ASP',
  obj: {
    iata: 'ASP',
    iso: 'AU',
    coordinates: '133.90199279785156, -23.806699752807617',
    municipality: 'Alice Springs'
  }
}, {
  label: 'Allahabad Airport (IXD) - IN',
  id: 'IXD',
  obj: {
    iata: 'IXD',
    iso: 'IN',
    coordinates: '81.733902, 25.4401',
    municipality: 'Allahabad'
  }
}, {
  label: 'Lehigh Valley International Airport (ABE) - US',
  id: 'ABE',
  obj: {
    iata: 'ABE',
    iso: 'US',
    coordinates: '-75.44080352783203, 40.652099609375',
    municipality: 'Allentown'
  }
}, {
  label: 'Alma Airport (YTF) - CA',
  id: 'YTF',
  obj: {
    iata: 'YTF',
    iso: 'CA',
    coordinates: '-71.64189910889999, 48.50889968869999',
    municipality: 'Alma'
  }
}, {
  label: 'Almaty Airport (ALA) - KZ',
  id: 'ALA',
  obj: {
    iata: 'ALA',
    iso: 'KZ',
    coordinates: '77.04049682617188, 43.35210037231445',
    municipality: 'Almaty'
  }
}, {
  label: 'Monte Dourado Airport (MEU) - BR',
  id: 'MEU',
  obj: {
    iata: 'MEU',
    iso: 'BR',
    coordinates: '-52.6022, -0.889839',
    municipality: 'Almeirim'
  }
}, {
  label: 'Almer\u00c3\u00ada International Airport (LEI) - ES',
  id: 'LEI',
  obj: {
    iata: 'LEI',
    iso: 'ES',
    coordinates: '-2.3701000213623047, 36.84389877319336',
    municipality: 'Almer\u00c3\u00ada'
  }
}, {
  label: 'Niue International Airport (IUE) - NU',
  id: 'IUE',
  obj: {
    iata: 'IUE',
    iso: 'NU',
    coordinates: '-169.92559814453125, -19.079030990600586',
    municipality: 'Alofi'
  }
}, {
  label: 'Sultan Abdul Halim Airport (AOR) - MY',
  id: 'AOR',
  obj: {
    iata: 'AOR',
    iso: 'MY',
    coordinates: '100.39800262451172, 6.189670085906982',
    municipality: 'Alor Satar'
  }
}, {
  label: 'Alpena County Regional Airport (APN) - US',
  id: 'APN',
  obj: {
    iata: 'APN',
    iso: 'US',
    coordinates: '-83.56030273, 45.0780983',
    municipality: 'Alpena'
  }
}, {
  label: 'Alpha Airport (ABH) - AU',
  id: 'ABH',
  obj: {
    iata: 'ABH',
    iso: 'AU',
    coordinates: '146.584, -23.646099',
    municipality: 'Alpha'
  }
}, {
  label: 'Sandnessj\u00c3\u00b8en Airport (Stokka) (SSJ) - NO',
  id: 'SSJ',
  obj: {
    iata: 'SSJ',
    iso: 'NO',
    coordinates: '12.468899726868, 65.956802368164',
    municipality: 'Alstahaug'
  }
}, {
  label: 'Alta Airport (ALF) - NO',
  id: 'ALF',
  obj: {
    iata: 'ALF',
    iso: 'NO',
    coordinates: '23.371700286865, 69.976097106934',
    municipality: 'Alta'
  }
}, {
  label: 'Piloto Osvaldo Marques Dias Airport (AFL) - BR',
  id: 'AFL',
  obj: {
    iata: 'AFL',
    iso: 'BR',
    coordinates: '-56.1049995422, -9.8663892746',
    municipality: 'Alta Floresta'
  }
}, {
  label: 'Altai Airport (LTI) - MN',
  id: 'LTI',
  obj: {
    iata: 'LTI',
    iso: 'MN',
    coordinates: '96.22109985351562, 46.376399993896484',
    municipality: 'Altai'
  }
}, {
  label: 'Altamira Airport (ATM) - BR',
  id: 'ATM',
  obj: {
    iata: 'ATM',
    iso: 'BR',
    coordinates: '-52.254001617432, -3.2539100646973',
    municipality: 'Altamira'
  }
}, {
  label: 'Altay Air Base (AAT) - CN',
  id: 'AAT',
  obj: {
    iata: 'AAT',
    iso: 'CN',
    coordinates: '88.08580780030002, 47.7498855591',
    municipality: 'Altay'
  }
}, {
  label: 'Altenburg-Nobitz Airport (AOC) - DE',
  id: 'AOC',
  obj: {
    iata: 'AOC',
    iso: 'DE',
    coordinates: '12.506389, 50.981945',
    municipality: 'Altenburg'
  }
}, {
  label: 'St Gallen Altenrhein Airport (ACH) - CH',
  id: 'ACH',
  obj: {
    iata: 'ACH',
    iso: 'CH',
    coordinates: '9.560770034789998, 47.4850006104',
    municipality: 'Altenrhein'
  }
}, {
  label: 'St Louis Regional Airport (ALN) - US',
  id: 'ALN',
  obj: {
    iata: 'ALN',
    iso: 'US',
    coordinates: '-90.0459976196, 38.89030075069999',
    municipality: 'Alton/St Louis'
  }
}, {
  label: 'Altoona Blair County Airport (AOO) - US',
  id: 'AOO',
  obj: {
    iata: 'AOO',
    iso: 'US',
    coordinates: '-78.31999969, 40.29639816',
    municipality: 'Altoona'
  }
}, {
  label: 'Altus Air Force Base (LTS) - US',
  id: 'LTS',
  obj: {
    iata: 'LTS',
    iso: 'US',
    coordinates: '-99.2667007446, 34.667098999',
    municipality: 'Altus'
  }
}, {
  label: 'Amami Airport (ASJ) - JP',
  id: 'ASJ',
  obj: {
    iata: 'ASJ',
    iso: 'JP',
    coordinates: '129.71299743652344, 28.430599212646484',
    municipality: 'Amami'
  }
}, {
  label: 'Rick Husband Amarillo International Airport (AMA) - US',
  id: 'AMA',
  obj: {
    iata: 'AMA',
    iso: 'US',
    coordinates: '-101.706001, 35.219398',
    municipality: 'Amarillo'
  }
}, {
  label: 'Chacho\u00c3\u00a1n Airport (ATF) - EC',
  id: 'ATF',
  obj: {
    iata: 'ATF',
    iso: 'EC',
    coordinates: '-78.57460021972656, -1.2120699882507324',
    municipality: 'Ambato'
  }
}, {
  label: 'Ambler Airport (ABL) - US',
  id: 'ABL',
  obj: {
    iata: 'ABL',
    iso: 'US',
    coordinates: '-157.856989, 67.1063',
    municipality: 'Ambler'
  }
}, {
  label: 'Pattimura Airport, Ambon (AMQ) - ID',
  id: 'AMQ',
  obj: {
    iata: 'AMQ',
    iso: 'ID',
    coordinates: '128.089004517, -3.7102599144',
    municipality: 'Ambon'
  }
}, {
  label: 'Amboseli Airport (ASV) - KE',
  id: 'ASV',
  obj: {
    iata: 'ASV',
    iso: 'KE',
    coordinates: '37.25310134887695, -2.645050048828125',
    municipality: 'Amboseli National Park'
  }
}, {
  label: 'Amderma Airport (AMV) - RU',
  id: 'AMV',
  obj: {
    iata: 'AMV',
    iso: 'RU',
    coordinates: '61.556400299072266, 69.76329803466797',
    municipality: 'Amderma'
  }
}, {
  label: 'Queen Alia International Airport (AMM) - JO',
  id: 'AMM',
  obj: {
    iata: 'AMM',
    iso: 'JO',
    coordinates: '35.9931983948, 31.7226009369',
    municipality: 'Amman'
  }
}, {
  label: 'Amman-Marka International Airport (ADJ) - JO',
  id: 'ADJ',
  obj: {
    iata: 'ADJ',
    iso: 'JO',
    coordinates: '35.991600036621094, 31.972700119018555',
    municipality: 'Amman'
  }
}, {
  label: 'Amos/Magny Airport (YEY) - CA',
  id: 'YEY',
  obj: {
    iata: 'YEY',
    iso: 'CA',
    coordinates: '-78.249702, 48.563903',
    municipality: 'Amos'
  }
}, {
  label: 'Ampara Airport (ADP) - LK',
  id: 'ADP',
  obj: {
    iata: 'ADP',
    iso: 'LK',
    coordinates: '81.62594, 7.33776',
    municipality: 'Ampara'
  }
}, {
  label: 'Sri Guru Ram Dass Jee International Airport (ATQ) - IN',
  id: 'ATQ',
  obj: {
    iata: 'ATQ',
    iso: 'IN',
    coordinates: '74.7973022461, 31.7096004486',
    municipality: 'Amritsar'
  }
}, {
  label: 'Amsterdam Airport Schiphol (AMS) - NL',
  id: 'AMS',
  obj: {
    iata: 'AMS',
    iso: 'NL',
    coordinates: '4.76389, 52.308601',
    municipality: 'Amsterdam'
  }
}, {
  label: 'In Am\u00c3\u00a9nas Airport (IAM) - DZ',
  id: 'IAM',
  obj: {
    iata: 'IAM',
    iso: 'DZ',
    coordinates: '9.64291, 28.0515',
    municipality: 'Am\u00c3\u00a9nas'
  }
}, {
  label: 'Anaco Airport (AAO) - VE',
  id: 'AAO',
  obj: {
    iata: 'AAO',
    iso: 'VE',
    coordinates: '-64.4707260131836, 9.430225372314453',
    municipality: 'Anaco'
  }
}, {
  label: 'Ugolny Airport (DYR) - RU',
  id: 'DYR',
  obj: {
    iata: 'DYR',
    iso: 'RU',
    coordinates: '177.740997, 64.734902',
    municipality: 'Anadyr'
  }
}, {
  label: 'Anaktuvuk Pass Airport (AKP) - US',
  id: 'AKP',
  obj: {
    iata: 'AKP',
    iso: 'US',
    coordinates: '-151.7429962, 68.13359833',
    municipality: 'Anaktuvuk Pass'
  }
}, {
  label: 'Anapa Vityazevo Airport (AAQ) - RU',
  id: 'AAQ',
  obj: {
    iata: 'AAQ',
    iso: 'RU',
    coordinates: '37.347301483154, 45.002101898193',
    municipality: 'Anapa'
  }
}, {
  label: 'Elmendorf Air Force Base (EDF) - US',
  id: 'EDF',
  obj: {
    iata: 'EDF',
    iso: 'US',
    coordinates: '-149.8070068359375, 61.250999450683594',
    municipality: 'Anchorage'
  }
}, {
  label: 'Merrill Field (MRI) - US',
  id: 'MRI',
  obj: {
    iata: 'MRI',
    iso: 'US',
    coordinates: '-149.843994140625, 61.2135009765625',
    municipality: 'Anchorage'
  }
}, {
  label: 'Ted Stevens Anchorage International Airport (ANC) - US',
  id: 'ANC',
  obj: {
    iata: 'ANC',
    iso: 'US',
    coordinates: '-149.99600219726562, 61.174400329589844',
    municipality: 'Anchorage'
  }
}, {
  label: 'Ancona Falconara Airport (AOI) - IT',
  id: 'AOI',
  obj: {
    iata: 'AOI',
    iso: 'IT',
    coordinates: '13.3623, 43.616299',
    municipality: 'Ancona'
  }
}, {
  label: 'And\u00c3\u00b8ya Airport (ANX) - NO',
  id: 'ANX',
  obj: {
    iata: 'ANX',
    iso: 'NO',
    coordinates: '16.144199371338, 69.292503356934',
    municipality: 'Andenes'
  }
}, {
  label: 'Anderson Regional Airport (AND) - US',
  id: 'AND',
  obj: {
    iata: 'AND',
    iso: 'US',
    coordinates: '-82.70939636230001, 34.4945983887',
    municipality: 'Anderson'
  }
}, {
  label: 'Andravida Air Base (PYR) - GR',
  id: 'PYR',
  obj: {
    iata: 'PYR',
    iso: 'GR',
    coordinates: '21.292601, 37.9207',
    municipality: 'Andravida'
  }
}, {
  label: 'Congo Town Airport (TZN) - BS',
  id: 'TZN',
  obj: {
    iata: 'TZN',
    iso: 'BS',
    coordinates: '-77.589798, 24.158701',
    municipality: 'Andros'
  }
}, {
  label: 'San Andros Airport (SAQ) - BS',
  id: 'SAQ',
  obj: {
    iata: 'SAQ',
    iso: 'BS',
    coordinates: '-78.04900360107422, 25.053800582885742',
    municipality: 'Andros Island'
  }
}, {
  label: 'Diosdado Macapagal International Airport (CRK) - PH',
  id: 'CRK',
  obj: {
    iata: 'CRK',
    iso: 'PH',
    coordinates: '120.559998, 15.186',
    municipality: 'Angeles/Mabalacat'
  }
}, {
  label: 'Anglesey Airport (VLY) - GB',
  id: 'VLY',
  obj: {
    iata: 'VLY',
    iso: 'GB',
    coordinates: '-4.53533983231, 53.2481002808',
    municipality: 'Angelsey'
  }
}, {
  label: 'Angers-Loire Airport (ANE) - FR',
  id: 'ANE',
  obj: {
    iata: 'ANE',
    iso: 'FR',
    coordinates: '-0.312222, 47.560299',
    municipality: 'Angers/Marc\u00c3\u00a9'
  }
}, {
  label: 'Texas Gulf Coast Regional Airport (LJN) - US',
  id: 'LJN',
  obj: {
    iata: 'LJN',
    iso: 'US',
    coordinates: '-95.462097168, 29.1086006165',
    municipality: 'Angleton/Lake Jackson'
  }
}, {
  label: 'Angoul\u00c3\u00aame-Brie-Champniers Airport (ANG) - FR',
  id: 'ANG',
  obj: {
    iata: 'ANG',
    iso: 'FR',
    coordinates: '0.22145600616931915, 45.72919845581055',
    municipality: 'Angoul\u00c3\u00aame/Brie/Champniers'
  }
}, {
  label: 'Aniak Airport (ANI) - US',
  id: 'ANI',
  obj: {
    iata: 'ANI',
    iso: 'US',
    coordinates: '-159.54299926757812, 61.581600189208984',
    municipality: 'Aniak'
  }
}, {
  label: 'Esenbo\u00c4\u009fa International Airport (ESB) - TR',
  id: 'ESB',
  obj: {
    iata: 'ESB',
    iso: 'TR',
    coordinates: '32.995098114, 40.128101348899996',
    municipality: 'Ankara'
  }
}, {
  label: 'Etimesgut Air Base (ANK) - TR',
  id: 'ANK',
  obj: {
    iata: 'ANK',
    iso: 'TR',
    coordinates: '32.6885986328, 39.949798584',
    municipality: 'Ankara'
  }
}, {
  label: 'Rabah Bitat Airport (AAE) - DZ',
  id: 'AAE',
  obj: {
    iata: 'AAE',
    iso: 'DZ',
    coordinates: '7.809174, 36.822201',
    municipality: 'Annaba'
  }
}, {
  label: 'Annecy-Haute-Savoie-Mont Blanc Airport (NCY) - FR',
  id: 'NCY',
  obj: {
    iata: 'NCY',
    iso: 'FR',
    coordinates: '6.1063889, 45.9308333',
    municipality: 'Annecy/Meythet'
  }
}, {
  label: 'Annemasse Airport (QNJ) - FR',
  id: 'QNJ',
  obj: {
    iata: 'QNJ',
    iso: 'FR',
    coordinates: '6.268390178680001, 46.1920013428',
    municipality: 'Annemasse'
  }
}, {
  label: 'Annette Island Airport (ANN) - US',
  id: 'ANN',
  obj: {
    iata: 'ANN',
    iso: 'US',
    coordinates: '-131.57200622558594, 55.04240036010742',
    municipality: 'Annette'
  }
}, {
  label: 'Anniston Regional Airport (ANB) - US',
  id: 'ANB',
  obj: {
    iata: 'ANB',
    iso: 'US',
    coordinates: '-85.8581, 33.5882',
    municipality: 'Anniston'
  }
}, {
  label: 'Comandante FAP German Arias Graziani Airport (ATA) - PE',
  id: 'ATA',
  obj: {
    iata: 'ATA',
    iso: 'PE',
    coordinates: '-77.59839630126953, -9.347439765930176',
    municipality: 'Anta'
  }
}, {
  label: 'Antalya International Airport (AYT) - TR',
  id: 'AYT',
  obj: {
    iata: 'AYT',
    iso: 'TR',
    coordinates: '30.800501, 36.898701',
    municipality: 'Antalya'
  }
}, {
  label: 'Ivato Airport (TNR) - MG',
  id: 'TNR',
  obj: {
    iata: 'TNR',
    iso: 'MG',
    coordinates: '47.478802, -18.7969',
    municipality: 'Antananarivo'
  }
}, {
  label: 'Andr\u00c3\u00a9s Sabella G\u00c3\u00a1lvez International Airport (ANF) - CL',
  id: 'ANF',
  obj: {
    iata: 'ANF',
    iso: 'CL',
    coordinates: '-70.445099, -23.444501',
    municipality: 'Antofagasta'
  }
}, {
  label: 'Ambalabe Airport (WAI) - MG',
  id: 'WAI',
  obj: {
    iata: 'WAI',
    iso: 'MG',
    coordinates: '47.993900299072266, -14.898799896240234',
    municipality: 'Antsohihy'
  }
}, {
  label: 'Antwerp International Airport (Deurne) (ANR) - BE',
  id: 'ANR',
  obj: {
    iata: 'ANR',
    iso: 'BE',
    coordinates: '4.46027994156, 51.1893997192',
    municipality: 'Antwerp'
  }
}, {
  label: 'Anuradhapura Air Force Base (ACJ) - LK',
  id: 'ACJ',
  obj: {
    iata: 'ACJ',
    iso: 'LK',
    coordinates: '80.42790222170001, 8.30148983002',
    municipality: 'Anuradhapura'
  }
}, {
  label: 'Anvik Airport (ANV) - US',
  id: 'ANV',
  obj: {
    iata: 'ANV',
    iso: 'US',
    coordinates: '-160.190994, 62.646702',
    municipality: 'Anvik'
  }
}, {
  label: 'Aomori Airport (AOJ) - JP',
  id: 'AOJ',
  obj: {
    iata: 'AOJ',
    iso: 'JP',
    coordinates: '140.6909942626953, 40.73469924926758',
    municipality: 'Aomori'
  }
}, {
  label: 'Aosta Airport (AOT) - IT',
  id: 'AOT',
  obj: {
    iata: 'AOT',
    iso: 'IT',
    coordinates: '7.36872, 45.738499',
    municipality: 'Aosta'
  }
}, {
  label: 'Faleolo International Airport (APW) - WS',
  id: 'APW',
  obj: {
    iata: 'APW',
    iso: 'WS',
    coordinates: '-172.00799560546875, -13.829999923706055',
    municipality: 'Apia'
  }
}, {
  label: 'Gomez Nino Apiay Air Base (API) - CO',
  id: 'API',
  obj: {
    iata: 'API',
    iso: 'CO',
    coordinates: '-73.5627, 4.07607',
    municipality: 'Apiay'
  }
}, {
  label: 'Aqaba King Hussein International Airport (AQJ) - JO',
  id: 'AQJ',
  obj: {
    iata: 'AQJ',
    iso: 'JO',
    coordinates: '35.01810073852539, 29.611600875854492',
    municipality: 'Aqaba'
  }
}, {
  label: 'Al Udeid Air Base (XJD) - QA',
  id: 'XJD',
  obj: {
    iata: 'XJD',
    iso: 'QA',
    coordinates: '51.3149986267, 25.1173000336',
    municipality: 'Ar Rayyan'
  }
}, {
  label: 'Santa Maria Airport (AJU) - BR',
  id: 'AJU',
  obj: {
    iata: 'AJU',
    iso: 'BR',
    coordinates: '-37.0703010559, -10.984000206',
    municipality: 'Aracaju'
  }
}, {
  label: 'Aracati Airport (ARX) - BR',
  id: 'ARX',
  obj: {
    iata: 'ARX',
    iso: 'BR',
    coordinates: '-37.804722, -4.568611',
    municipality: 'Aracati'
  }
}, {
  label: 'Arad International Airport (ARW) - RO',
  id: 'ARW',
  obj: {
    iata: 'ARW',
    iso: 'RO',
    coordinates: '21.261999130249023, 46.17660140991211',
    municipality: 'Arad'
  }
}, {
  label: 'Aragua\u00c3\u00adna Airport (AUX) - BR',
  id: 'AUX',
  obj: {
    iata: 'AUX',
    iso: 'BR',
    coordinates: '-48.240501, -7.22787',
    municipality: 'Aragua\u00c3\u00adna'
  }
}, {
  label: 'Arandis Airport (ADI) - NA',
  id: 'ADI',
  obj: {
    iata: 'ADI',
    iso: 'NA',
    coordinates: '14.979999542236328, -22.462200164794922',
    municipality: 'Arandis'
  }
}, {
  label: 'Arar Domestic Airport (RAE) - SA',
  id: 'RAE',
  obj: {
    iata: 'RAE',
    iso: 'SA',
    coordinates: '41.13819885253906, 30.906600952148438',
    municipality: 'Arar'
  }
}, {
  label: 'Araraquara Airport (AQA) - BR',
  id: 'AQA',
  obj: {
    iata: 'AQA',
    iso: 'BR',
    coordinates: '-48.1329994202, -21.812000274699997',
    municipality: 'Araraquara'
  }
}, {
  label: 'Santiago Perez Airport (AUC) - CO',
  id: 'AUC',
  obj: {
    iata: 'AUC',
    iso: 'CO',
    coordinates: '-70.7369, 7.06888',
    municipality: 'Arauca'
  }
}, {
  label: 'Ara\u00c3\u00a7atuba Airport (ARU) - BR',
  id: 'ARU',
  obj: {
    iata: 'ARU',
    iso: 'BR',
    coordinates: '-50.4247016907, -21.1413002014',
    municipality: 'Ara\u00c3\u00a7atuba'
  }
}, {
  label: 'Tortol\u00c3\u00ac Airport (TTB) - IT',
  id: 'TTB',
  obj: {
    iata: 'TTB',
    iso: 'IT',
    coordinates: '9.68298, 39.9188',
    municipality: 'Arbatax'
  }
}, {
  label: 'Erbil International Airport (EBL) - IQ',
  id: 'EBL',
  obj: {
    iata: 'EBL',
    iso: 'IQ',
    coordinates: '43.963199615478516, 36.23759841918945',
    municipality: 'Arbil'
  }
}, {
  label: 'California Redwood Coast-Humboldt County Airport (ACV) - US',
  id: 'ACV',
  obj: {
    iata: 'ACV',
    iso: 'US',
    coordinates: '-124.109, 40.978101',
    municipality: 'Arcata/Eureka'
  }
}, {
  label: 'Talagi Airport (ARH) - RU',
  id: 'ARH',
  obj: {
    iata: 'ARH',
    iso: 'RU',
    coordinates: '40.71670150756836, 64.60030364990234',
    municipality: 'Archangelsk'
  }
}, {
  label: 'Arctic Village Airport (ARC) - US',
  id: 'ARC',
  obj: {
    iata: 'ARC',
    iso: 'US',
    coordinates: '-145.578995, 68.1147',
    municipality: 'Arctic Village'
  }
}, {
  label: 'Ardabil Airport (ADU) - IR',
  id: 'ADU',
  obj: {
    iata: 'ADU',
    iso: 'IR',
    coordinates: '48.4244003296, 38.3256988525',
    municipality: 'Ardabil'
  }
}, {
  label: 'Antonio Nery Juarbe Pol Airport (ARE) - PR',
  id: 'ARE',
  obj: {
    iata: 'ARE',
    iso: 'PR',
    coordinates: '-66.6753005981, 18.4500007629',
    municipality: 'Arecibo'
  }
}, {
  label: 'Rodr\u00c3\u00adguez Ball\u00c3\u00b3n International Airport (AQP) - PE',
  id: 'AQP',
  obj: {
    iata: 'AQP',
    iso: 'PE',
    coordinates: '-71.5830993652, -16.3411006927',
    municipality: 'Arequipa'
  }
}, {
  label: 'Chacalluta Airport (ARI) - CL',
  id: 'ARI',
  obj: {
    iata: 'ARI',
    iso: 'CL',
    coordinates: '-70.338699, -18.348499',
    municipality: 'Arica'
  }
}, {
  label: 'El Eden Airport (AXM) - CO',
  id: 'AXM',
  obj: {
    iata: 'AXM',
    iso: 'CO',
    coordinates: '-75.7664, 4.45278',
    municipality: 'Armenia'
  }
}, {
  label: 'Armidale Airport (ARM) - AU',
  id: 'ARM',
  obj: {
    iata: 'ARM',
    iso: 'AU',
    coordinates: '151.617004395, -30.528099060099997',
    municipality: 'Armidale'
  }
}, {
  label: 'Armstrong Airport (YYW) - CA',
  id: 'YYW',
  obj: {
    iata: 'YYW',
    iso: 'CA',
    coordinates: '-88.90969848632812, 50.29029846191406',
    municipality: 'Armstrong'
  }
}, {
  label: "Arthur's Town Airport (ATC) - BS",
  id: 'ATC',
  obj: {
    iata: 'ATC',
    iso: 'BS',
    coordinates: '-75.673797, 24.6294',
    municipality: "Arthur's Town"
  }
}, {
  label: 'Arua Airport (RUA) - UG',
  id: 'RUA',
  obj: {
    iata: 'RUA',
    iso: 'UG',
    coordinates: '30.91699981689453, 3.049999952316284',
    municipality: 'Arua'
  }
}, {
  label: 'Arusha Airport (ARK) - TZ',
  id: 'ARK',
  obj: {
    iata: 'ARK',
    iso: 'TZ',
    coordinates: '36.63330078125, -3.3677899837493896',
    municipality: 'Arusha'
  }
}, {
  label: 'Kilimanjaro International Airport (JRO) - TZ',
  id: 'JRO',
  obj: {
    iata: 'JRO',
    iso: 'TZ',
    coordinates: '37.0745010376, -3.42940998077',
    municipality: 'Arusha'
  }
}, {
  label: 'Arvaikheer Airport (AVK) - MN',
  id: 'AVK',
  obj: {
    iata: 'AVK',
    iso: 'MN',
    coordinates: '102.802001953125, 46.250301361083984',
    municipality: 'Arvaikheer'
  }
}, {
  label: 'Arviat Airport (YEK) - CA',
  id: 'YEK',
  obj: {
    iata: 'YEK',
    iso: 'CA',
    coordinates: '-94.07080078119999, 61.0942001343',
    municipality: 'Arviat'
  }
}, {
  label: 'Arvidsjaur Airport (AJR) - SE',
  id: 'AJR',
  obj: {
    iata: 'AJR',
    iso: 'SE',
    coordinates: '19.28190040588379, 65.59030151367188',
    municipality: 'Arvidsjaur'
  }
}, {
  label: "Arxan Yi'ershi Airport (YIE) - CN",
  id: 'YIE',
  obj: {
    iata: 'YIE',
    iso: 'CN',
    coordinates: '119.9117, 47.3106',
    municipality: 'Arxan'
  }
}, {
  label: 'Assab International Airport (ASA) - ER',
  id: 'ASA',
  obj: {
    iata: 'ASA',
    iso: 'ER',
    coordinates: '42.64500045776367, 13.071800231933594',
    municipality: 'Asab'
  }
}, {
  label: 'Asaba International Airport (ABB) - NG',
  id: 'ABB',
  obj: {
    iata: 'ABB',
    iso: 'NG',
    coordinates: '6.665278, 6.204167',
    municipality: 'Asaba'
  }
}, {
  label: 'Asahikawa Airport (AKJ) - JP',
  id: 'AKJ',
  obj: {
    iata: 'AKJ',
    iso: 'JP',
    coordinates: '142.44700622558594, 43.670799255371094',
    municipality: 'Asahikawa / Hokkaid\u00c5\u008d'
  }
}, {
  label: 'Persian Gulf International Airport (PGU) - IR',
  id: 'PGU',
  obj: {
    iata: 'PGU',
    iso: 'IR',
    coordinates: '52.737701, 27.379601',
    municipality: 'Asalouyeh'
  }
}, {
  label: 'RAF Ascension Island (ASI) - SH',
  id: 'ASI',
  obj: {
    iata: 'ASI',
    iso: 'SH',
    coordinates: '-14.3937, -7.9696',
    municipality: 'Ascension Island'
  }
}, {
  label: 'Asheville Regional Airport (AVL) - US',
  id: 'AVL',
  obj: {
    iata: 'AVL',
    iso: 'US',
    coordinates: '-82.541801, 35.436199',
    municipality: 'Asheville'
  }
}, {
  label: 'Ashgabat International Airport (ASB) - TM',
  id: 'ASB',
  obj: {
    iata: 'ASB',
    iso: 'TM',
    coordinates: '58.361, 37.986801',
    municipality: 'Ashgabat'
  }
}, {
  label: 'Asmara International Airport (ASM) - ER',
  id: 'ASM',
  obj: {
    iata: 'ASM',
    iso: 'ER',
    coordinates: '38.910701751708984, 15.291899681091309',
    municipality: 'Asmara'
  }
}, {
  label: 'Asosa Airport (ASO) - ET',
  id: 'ASO',
  obj: {
    iata: 'ASO',
    iso: 'ET',
    coordinates: '34.586299896240234, 10.018500328063965',
    municipality: 'Asosa'
  }
}, {
  label: 'Aspen-Pitkin Co/Sardy Field (ASE) - US',
  id: 'ASE',
  obj: {
    iata: 'ASE',
    iso: 'US',
    coordinates: '-106.8690033, 39.22320175',
    municipality: 'Aspen'
  }
}, {
  label: 'Astana International Airport (TSE) - KZ',
  id: 'TSE',
  obj: {
    iata: 'TSE',
    iso: 'KZ',
    coordinates: '71.46690368652344, 51.02220153808594',
    municipality: 'Astana'
  }
}, {
  label: 'Astoria Regional Airport (AST) - US',
  id: 'AST',
  obj: {
    iata: 'AST',
    iso: 'US',
    coordinates: '-123.878997803, 46.158000946',
    municipality: 'Astoria'
  }
}, {
  label: 'Astrakhan Airport (ASF) - RU',
  id: 'ASF',
  obj: {
    iata: 'ASF',
    iso: 'RU',
    coordinates: '48.0063018799, 46.2832984924',
    municipality: 'Astrakhan'
  }
}, {
  label: 'Silvio Pettirossi International Airport (ASU) - PY',
  id: 'ASU',
  obj: {
    iata: 'ASU',
    iso: 'PY',
    coordinates: '-57.52000045776367, -25.239999771118164',
    municipality: 'Asunci\u00c3\u00b3n'
  }
}, {
  label: 'Aswan International Airport (ASW) - EG',
  id: 'ASW',
  obj: {
    iata: 'ASW',
    iso: 'EG',
    coordinates: '32.8199996948, 23.9643993378',
    municipality: 'Aswan'
  }
}, {
  label: 'Asyut International Airport (ATZ) - EG',
  id: 'ATZ',
  obj: {
    iata: 'ATZ',
    iso: 'EG',
    coordinates: '31.011999, 27.046499',
    municipality: 'Asyut'
  }
}, {
  label: 'Teniente General Gerardo P\u00c3\u00a9rez Pinedo Airport (AYX) - PE',
  id: 'AYX',
  obj: {
    iata: 'AYX',
    iso: 'PE',
    coordinates: '-73.766502, -10.7291',
    municipality: 'Atalaya'
  }
}, {
  label: 'Atar International Airport (ATR) - MR',
  id: 'ATR',
  obj: {
    iata: 'ATR',
    iso: 'MR',
    coordinates: '-13.04319953918457, 20.506799697875977',
    municipality: 'Atar'
  }
}, {
  label: 'Athens Ben Epps Airport (AHN) - US',
  id: 'AHN',
  obj: {
    iata: 'AHN',
    iso: 'US',
    coordinates: '-83.32630157470703, 33.94860076904297',
    municipality: 'Athens'
  }
}, {
  label: 'Eleftherios Venizelos International Airport (ATH) - GR',
  id: 'ATH',
  obj: {
    iata: 'ATH',
    iso: 'GR',
    coordinates: '23.9444999695, 37.9364013672',
    municipality: 'Athens'
  }
}, {
  label: 'Atikokan Municipal Airport (YIB) - CA',
  id: 'YIB',
  obj: {
    iata: 'YIB',
    iso: 'CA',
    coordinates: '-91.6386032104, 48.7738990784',
    municipality: 'Atikokan'
  }
}, {
  label: 'Hartsfield Jackson Atlanta International Airport (ATL) - US',
  id: 'ATL',
  obj: {
    iata: 'ATL',
    iso: 'US',
    coordinates: '-84.428101, 33.6367',
    municipality: 'Atlanta'
  }
}, {
  label: 'Fulton County Airport Brown Field (FTY) - US',
  id: 'FTY',
  obj: {
    iata: 'FTY',
    iso: 'US',
    coordinates: '-84.5214004517, 33.7790985107',
    municipality: 'Atlanta'
  }
}, {
  label: 'DeKalb Peachtree Airport (PDK) - US',
  id: 'PDK',
  obj: {
    iata: 'PDK',
    iso: 'US',
    coordinates: '-84.3020019531, 33.8755989075',
    municipality: 'Atlanta'
  }
}, {
  label: 'Atlantic City International Airport (ACY) - US',
  id: 'ACY',
  obj: {
    iata: 'ACY',
    iso: 'US',
    coordinates: '-74.57720184326172, 39.45759963989258',
    municipality: 'Atlantic City'
  }
}, {
  label: 'Atqasuk Edward Burnell Sr Memorial Airport (ATK) - US',
  id: 'ATK',
  obj: {
    iata: 'ATK',
    iso: 'US',
    coordinates: '-157.436013, 70.46704',
    municipality: 'Atqasuk'
  }
}, {
  label: 'Attawapiskat Airport (YAT) - CA',
  id: 'YAT',
  obj: {
    iata: 'YAT',
    iso: 'CA',
    coordinates: '-82.43190002441406, 52.9275016784668',
    municipality: 'Attawapiskat'
  }
}, {
  label: 'Atyrau Airport (GUW) - KZ',
  id: 'GUW',
  obj: {
    iata: 'GUW',
    iso: 'KZ',
    coordinates: '51.8213996887207, 47.12189865112305',
    municipality: 'Atyrau'
  }
}, {
  label: 'Aubenas-Ard\u00c3\u00a8che M\u00c3\u00a9ridional Airport (OBS) - FR',
  id: 'OBS',
  obj: {
    iata: 'OBS',
    iso: 'FR',
    coordinates: '4.372192, 44.544203',
    municipality: 'Aubenas/Ard\u00c3\u00a8che M\u00c3\u00a9ridional'
  }
}, {
  label: 'Auckland International Airport (AKL) - NZ',
  id: 'AKL',
  obj: {
    iata: 'AKL',
    iso: 'NZ',
    coordinates: '174.792007446, -37.008098602299995',
    municipality: 'Auckland'
  }
}, {
  label: 'Augsburg Airport (AGB) - DE',
  id: 'AGB',
  obj: {
    iata: 'AGB',
    iso: 'DE',
    coordinates: '10.931667, 48.425278',
    municipality: 'Augsburg'
  }
}, {
  label: 'Augusta Regional At Bush Field (AGS) - US',
  id: 'AGS',
  obj: {
    iata: 'AGS',
    iso: 'US',
    coordinates: '-81.9645004272461, 33.36989974975586',
    municipality: 'Augusta'
  }
}, {
  label: 'Augusta State Airport (AUG) - US',
  id: 'AUG',
  obj: {
    iata: 'AUG',
    iso: 'US',
    coordinates: '-69.7973022461, 44.320598602299995',
    municipality: 'Augusta'
  }
}, {
  label: 'Daniel Field (DNL) - US',
  id: 'DNL',
  obj: {
    iata: 'DNL',
    iso: 'US',
    coordinates: '-82.0393981934, 33.4664993286',
    municipality: 'Augusta'
  }
}, {
  label: 'Aupaluk Airport (YPJ) - CA',
  id: 'YPJ',
  obj: {
    iata: 'YPJ',
    iso: 'CA',
    coordinates: '-69.59970092773438, 59.29669952392578',
    municipality: 'Aupaluk'
  }
}, {
  label: 'Aurangabad Airport (IXU) - IN',
  id: 'IXU',
  obj: {
    iata: 'IXU',
    iso: 'IN',
    coordinates: '75.39810180664062, 19.862699508666992',
    municipality: 'Aurangabad'
  }
}, {
  label: 'Aurillac Airport (AUR) - FR',
  id: 'AUR',
  obj: {
    iata: 'AUR',
    iso: 'FR',
    coordinates: '2.4219400882720947, 44.89139938354492',
    municipality: 'Aurillac'
  }
}, {
  label: 'Buckley Air Force Base (BFK) - US',
  id: 'BFK',
  obj: {
    iata: 'BFK',
    iso: 'US',
    coordinates: '-104.751998901, 39.701698303200004',
    municipality: 'Aurora'
  }
}, {
  label: 'Austin Bergstrom International Airport (AUS) - US',
  id: 'AUS',
  obj: {
    iata: 'AUS',
    iso: 'US',
    coordinates: '-97.6698989868164, 30.194499969482422',
    municipality: 'Austin'
  }
}, {
  label: 'Auxerre-Branches Airport (AUF) - FR',
  id: 'AUF',
  obj: {
    iata: 'AUF',
    iso: 'FR',
    coordinates: '3.497109889984131, 47.85020065307617',
    municipality: 'Auxerre/Branches'
  }
}, {
  label: 'Rarotonga International Airport (RAR) - CK',
  id: 'RAR',
  obj: {
    iata: 'RAR',
    iso: 'CK',
    coordinates: '-159.805999756, -21.2026996613',
    municipality: 'Avarua'
  }
}, {
  label: 'Aviano Air Base (AVB) - IT',
  id: 'AVB',
  obj: {
    iata: 'AVB',
    iso: 'IT',
    coordinates: '12.596503, 46.031898',
    municipality: 'Aviano (PN)'
  }
}, {
  label: 'Avignon-Caumont Airport (AVN) - FR',
  id: 'AVN',
  obj: {
    iata: 'AVN',
    iso: 'FR',
    coordinates: '4.901830196380615, 43.90729904174805',
    municipality: 'Avignon/Caumont'
  }
}, {
  label: 'Coronel FAP Alfredo Mendivil Duarte Airport (AYP) - PE',
  id: 'AYP',
  obj: {
    iata: 'AYP',
    iso: 'PE',
    coordinates: '-74.20439910888672, -13.154800415039062',
    municipality: 'Ayacucho'
  }
}, {
  label: 'JMSDF Atsugi Air Base / Naval Air Facility Atsugi (NJA) - JP',
  id: 'NJA',
  obj: {
    iata: 'NJA',
    iso: 'JP',
    coordinates: '139.449997, 35.454601',
    municipality: 'Ayase / Yamato'
  }
}, {
  label: 'Ayers Rock Connellan Airport (AYQ) - AU',
  id: 'AYQ',
  obj: {
    iata: 'AYQ',
    iso: 'AU',
    coordinates: '130.975998, -25.1861',
    municipality: 'Ayers Rock'
  }
}, {
  label: 'Juan De Ayolas Airport (AYO) - PY',
  id: 'AYO',
  obj: {
    iata: 'AYO',
    iso: 'PY',
    coordinates: '-56.854064, -27.370554',
    municipality: 'Ayolas'
  }
}, {
  label: 'Babelthuap Airport (ROR) - PW',
  id: 'ROR',
  obj: {
    iata: 'ROR',
    iso: 'PW',
    coordinates: '134.544236, 7.36731',
    municipality: 'Babelthuap Island'
  }
}, {
  label: 'Zielona G\u00c3\u00b3ra-Babimost Airport (IEG) - PL',
  id: 'IEG',
  obj: {
    iata: 'IEG',
    iso: 'PL',
    coordinates: '15.7986001968, 52.138500213600004',
    municipality: 'Babimost'
  }
}, {
  label: 'Babo Airport (BXB) - ID',
  id: 'BXB',
  obj: {
    iata: 'BXB',
    iso: 'ID',
    coordinates: '133.43899536132812, -2.5322399139404297',
    municipality: 'Babo-Papua Island'
  }
}, {
  label: 'Bacolod-Silay Airport (BCD) - PH',
  id: 'BCD',
  obj: {
    iata: 'BCD',
    iso: 'PH',
    coordinates: '123.014999, 10.7764',
    municipality: 'Bacolod City'
  }
}, {
  label: 'Bac\u00c4\u0083u Airport (BCM) - RO',
  id: 'BCM',
  obj: {
    iata: 'BCM',
    iso: 'RO',
    coordinates: '26.91029930114746, 46.52190017700195',
    municipality: 'Bac\u00c4\u0083u'
  }
}, {
  label: 'Badajoz Airport (BJZ) - ES',
  id: 'BJZ',
  obj: {
    iata: 'BJZ',
    iso: 'ES',
    coordinates: '-6.8213300704956055, 38.891300201416016',
    municipality: 'Badajoz'
  }
}, {
  label: 'Karlsruhe Baden-Baden Airport (FKB) - DE',
  id: 'FKB',
  obj: {
    iata: 'FKB',
    iso: 'DE',
    coordinates: '8.08049964905, 48.7793998718',
    municipality: 'Baden-Baden'
  }
}, {
  label: 'Bafoussam Airport (BFX) - CM',
  id: 'BFX',
  obj: {
    iata: 'BFX',
    iso: 'CM',
    coordinates: '10.354599952700001, 5.536920070650001',
    municipality: 'Bafoussam'
  }
}, {
  label: 'Baghdad International Airport (BGW) - IQ',
  id: 'BGW',
  obj: {
    iata: 'BGW',
    iso: 'IQ',
    coordinates: '44.2346000671, 33.262500762900004',
    municipality: 'Baghdad'
  }
}, {
  label: 'CFB Bagotville (YBG) - CA',
  id: 'YBG',
  obj: {
    iata: 'YBG',
    iso: 'CA',
    coordinates: '-70.99639892578125, 48.33060073852539',
    municipality: 'Bagotville'
  }
}, {
  label: 'Bagram Air Base (OAI) - AF',
  id: 'OAI',
  obj: {
    iata: 'OAI',
    iso: 'AF',
    coordinates: '69.26499938959999, 34.9460983276',
    municipality: 'Bagram'
  }
}, {
  label: 'Loakan Airport (BAG) - PH',
  id: 'BAG',
  obj: {
    iata: 'BAG',
    iso: 'PH',
    coordinates: '120.62000274658203, 16.375099182128906',
    municipality: 'Baguio City'
  }
}, {
  label: 'Comandante Gustavo Kraemer Airport (BGX) - BR',
  id: 'BGX',
  obj: {
    iata: 'BGX',
    iso: 'BR',
    coordinates: '-54.112201690674, -31.39049911499',
    municipality: 'Bag\u00c3\u00a9'
  }
}, {
  label: 'Bahawalpur Airport (BHV) - PK',
  id: 'BHV',
  obj: {
    iata: 'BHV',
    iso: 'PK',
    coordinates: '71.71800231933594, 29.348100662231445',
    municipality: 'Bahawalpur'
  }
}, {
  label: 'Comandante Espora Airport (BHI) - AR',
  id: 'BHI',
  obj: {
    iata: 'BHI',
    iso: 'AR',
    coordinates: '-62.1693, -38.725',
    municipality: 'Bahia Blanca'
  }
}, {
  label: 'Bahir Dar Airport (BJR) - ET',
  id: 'BJR',
  obj: {
    iata: 'BJR',
    iso: 'ET',
    coordinates: '37.32160186767578, 11.608099937438965',
    municipality: 'Bahir Dar'
  }
}, {
  label: 'Jos\u00c3\u00a9 Celestino Mutis Airport (BSC) - CO',
  id: 'BSC',
  obj: {
    iata: 'BSC',
    iso: 'CO',
    coordinates: '-77.3947, 6.20292',
    municipality: 'Bah\u00c3\u00ada Solano'
  }
}, {
  label: 'Maramure\u00c8\u0099 International Airport (BAY) - RO',
  id: 'BAY',
  obj: {
    iata: 'BAY',
    iso: 'RO',
    coordinates: '23.467252, 47.660598',
    municipality: 'Baia Mare'
  }
}, {
  label: "Baicheng Chang'an Airport (DBC) - CN",
  id: 'DBC',
  obj: {
    iata: 'DBC',
    iso: 'CN',
    coordinates: '123.019722, 45.505278',
    municipality: 'Baicheng'
  }
}, {
  label: 'Baie Comeau Airport (YBC) - CA',
  id: 'YBC',
  obj: {
    iata: 'YBC',
    iso: 'CA',
    coordinates: '-68.204399, 49.1325',
    municipality: 'Baie-Comeau'
  }
}, {
  label: 'Krainiy Airport (BXY) - KZ',
  id: 'BXY',
  obj: {
    iata: 'BXY',
    iso: 'KZ',
    coordinates: '63.210773, 45.621994',
    municipality: 'Baikonur'
  }
}, {
  label: 'Baimuru Airport (VMU) - PG',
  id: 'VMU',
  obj: {
    iata: 'VMU',
    iso: 'PG',
    coordinates: '144.819900513, -7.49686002731',
    municipality: 'Baimuru'
  }
}, {
  label: 'Baise Youjiang Airport (AEB) - CN',
  id: 'AEB',
  obj: {
    iata: 'AEB',
    iso: 'CN',
    coordinates: '106.959999084, 23.7206001282',
    municipality: 'Baise'
  }
}, {
  label: 'Changbaishan Airport (NBS) - CN',
  id: 'NBS',
  obj: {
    iata: 'NBS',
    iso: 'CN',
    coordinates: '127.602222, 42.066944',
    municipality: 'Baishan'
  }
}, {
  label: 'Bakel Airport (BXE) - SN',
  id: 'BXE',
  obj: {
    iata: 'BXE',
    iso: 'SN',
    coordinates: '-12.468299865722656, 14.847299575805664',
    municipality: 'Bakel'
  }
}, {
  label: 'Baker City Municipal Airport (BKE) - US',
  id: 'BKE',
  obj: {
    iata: 'BKE',
    iso: 'US',
    coordinates: '-117.808998108, 44.837299346900004',
    municipality: 'Baker City'
  }
}, {
  label: 'Baker Lake Airport (YBK) - CA',
  id: 'YBK',
  obj: {
    iata: 'YBK',
    iso: 'CA',
    coordinates: '-96.077796936, 64.29889678960001',
    municipality: 'Baker Lake'
  }
}, {
  label: 'Meadows Field (BFL) - US',
  id: 'BFL',
  obj: {
    iata: 'BFL',
    iso: 'US',
    coordinates: '-119.0569992, 35.43360138',
    municipality: 'Bakersfield'
  }
}, {
  label: 'Zabrat Airport (ZXT) - AZ',
  id: 'ZXT',
  obj: {
    iata: 'ZXT',
    iso: 'AZ',
    coordinates: '49.9768066406, 40.4955422161',
    municipality: 'Baku'
  }
}, {
  label: 'Heydar Aliyev International Airport (GYD) - AZ',
  id: 'GYD',
  obj: {
    iata: 'GYD',
    iso: 'AZ',
    coordinates: '50.04669952392578, 40.467498779296875',
    municipality: 'Baku'
  }
}, {
  label: 'Balakovo Airport (BWO) - RU',
  id: 'BWO',
  obj: {
    iata: 'BWO',
    iso: 'RU',
    coordinates: '47.7456016541, 51.8582992554',
    municipality: 'Balakovo'
  }
}, {
  label: 'Tiree Airport (TRE) - GB',
  id: 'TRE',
  obj: {
    iata: 'TRE',
    iso: 'GB',
    coordinates: '-6.869170188903809, 56.49919891357422',
    municipality: 'Balemartine'
  }
}, {
  label: 'Dr.Juan C. Angara Airport (BQA) - PH',
  id: 'BQA',
  obj: {
    iata: 'BQA',
    iso: 'PH',
    coordinates: '121.500034, 15.729309',
    municipality: 'Baler'
  }
}, {
  label: 'Balimo Airport (OPU) - PG',
  id: 'OPU',
  obj: {
    iata: 'OPU',
    iso: 'PG',
    coordinates: '142.932998657, -8.05000019073',
    municipality: 'Balimo'
  }
}, {
  label: 'Benbecula Airport (BEB) - GB',
  id: 'BEB',
  obj: {
    iata: 'BEB',
    iso: 'GB',
    coordinates: '-7.3627800941467285, 57.48109817504883',
    municipality: 'Balivanich'
  }
}, {
  label: 'Balkhash Airport (BXH) - KZ',
  id: 'BXH',
  obj: {
    iata: 'BXH',
    iso: 'KZ',
    coordinates: '75.00499725341797, 46.8932991027832',
    municipality: 'Balkhash'
  }
}, {
  label: 'Ballina Byron Gateway Airport (BNK) - AU',
  id: 'BNK',
  obj: {
    iata: 'BNK',
    iso: 'AU',
    coordinates: '153.56199646, -28.8339004517',
    municipality: 'Ballina'
  }
}, {
  label: 'Balmaceda Airport (BBA) - CL',
  id: 'BBA',
  obj: {
    iata: 'BBA',
    iso: 'CL',
    coordinates: '-71.68949890136719, -45.916099548339844',
    municipality: 'Balmaceda'
  }
}, {
  label: 'Baltimore/Washington International Thurgood Marshall Airport (BWI) - US',
  id: 'BWI',
  obj: {
    iata: 'BWI',
    iso: 'US',
    coordinates: '-76.668297, 39.1754',
    municipality: 'Baltimore'
  }
}, {
  label: 'Martin State Airport (MTN) - US',
  id: 'MTN',
  obj: {
    iata: 'MTN',
    iso: 'US',
    coordinates: '-76.413803, 39.325699',
    municipality: 'Baltimore'
  }
}, {
  label: 'Modibo Keita International Airport (BKO) - ML',
  id: 'BKO',
  obj: {
    iata: 'BKO',
    iso: 'ML',
    coordinates: '-7.94994, 12.5335',
    municipality: 'Bamako'
  }
}, {
  label: 'Bamenda Airport (BPC) - CM',
  id: 'BPC',
  obj: {
    iata: 'BPC',
    iso: 'CM',
    coordinates: '10.122599601745605, 6.039239883422852',
    municipality: 'Bamenda'
  }
}, {
  label: 'Cassidy International Airport (CXI) - KI',
  id: 'CXI',
  obj: {
    iata: 'CXI',
    iso: 'KI',
    coordinates: '-157.35000610351562, 1.9861600399017334',
    municipality: 'Banana'
  }
}, {
  label: 'Sultan Iskandar Muda International Airport (BTJ) - ID',
  id: 'BTJ',
  obj: {
    iata: 'BTJ',
    iso: 'ID',
    coordinates: '95.42063713070002, 5.522872024010001',
    municipality: 'Banda Aceh'
  }
}, {
  label: 'Bandar Abbas International Airport (BND) - IR',
  id: 'BND',
  obj: {
    iata: 'BND',
    iso: 'IR',
    coordinates: '56.37779998779297, 27.218299865722656',
    municipality: 'Bandar Abbas'
  }
}, {
  label: 'Radin Inten II (Branti) Airport (TKG) - ID',
  id: 'TKG',
  obj: {
    iata: 'TKG',
    iso: 'ID',
    coordinates: '105.175556, -5.240556',
    municipality: 'Bandar Lampung-Sumatra Island'
  }
}, {
  label: 'Bandar Lengeh Airport (BDH) - IR',
  id: 'BDH',
  obj: {
    iata: 'BDH',
    iso: 'IR',
    coordinates: '54.824798584, 26.531999588',
    municipality: 'Bandar Lengeh'
  }
}, {
  label: 'Brunei International Airport (BWN) - BN',
  id: 'BWN',
  obj: {
    iata: 'BWN',
    iso: 'BN',
    coordinates: '114.9280014038086, 4.944200038909912',
    municipality: 'Bandar Seri Begawan'
  }
}, {
  label: 'Husein Sastranegara International Airport (BDO) - ID',
  id: 'BDO',
  obj: {
    iata: 'BDO',
    iso: 'ID',
    coordinates: '107.57599639892578, -6.900629997253418',
    municipality: 'Bandung-Java Island'
  }
}, {
  label: 'Kempegowda International Airport (BLR) - IN',
  id: 'BLR',
  obj: {
    iata: 'BLR',
    iso: 'IN',
    coordinates: '77.706299, 13.1979',
    municipality: 'Bangalore'
  }
}, {
  label: 'Don Mueang International Airport (DMK) - TH',
  id: 'DMK',
  obj: {
    iata: 'DMK',
    iso: 'TH',
    coordinates: '100.607002258, 13.9125995636',
    municipality: 'Bangkok'
  }
}, {
  label: 'Suvarnabhumi Airport (BKK) - TH',
  id: 'BKK',
  obj: {
    iata: 'BKK',
    iso: 'TH',
    coordinates: '100.74700164794922, 13.681099891662598',
    municipality: 'Bangkok'
  }
}, {
  label: 'Bangor International Airport (BGR) - US',
  id: 'BGR',
  obj: {
    iata: 'BGR',
    iso: 'US',
    coordinates: '-68.8281021118164, 44.80739974975586',
    municipality: 'Bangor'
  }
}, {
  label: "Bangui M'Poko International Airport (BGF) - CF",
  id: 'BGF',
  obj: {
    iata: 'BGF',
    iso: 'CF',
    coordinates: '18.518800735473633, 4.39847993850708',
    municipality: 'Bangui'
  }
}, {
  label: 'Banja Luka International Airport (BNX) - BA',
  id: 'BNX',
  obj: {
    iata: 'BNX',
    iso: 'BA',
    coordinates: '17.297500610351562, 44.94139862060547',
    municipality: 'Banja Luka'
  }
}, {
  label: 'Banjul International Airport (BJL) - GM',
  id: 'BJL',
  obj: {
    iata: 'BJL',
    iso: 'GM',
    coordinates: '-16.65220069885254, 13.338000297546387',
    municipality: 'Banjul'
  }
}, {
  label: 'Baotou Airport (BAV) - CN',
  id: 'BAV',
  obj: {
    iata: 'BAV',
    iso: 'CN',
    coordinates: '109.99700164794922, 40.560001373291016',
    municipality: 'Baotou'
  }
}, {
  label: 'Hancock County-Bar Harbor Airport (BHB) - US',
  id: 'BHB',
  obj: {
    iata: 'BHB',
    iso: 'US',
    coordinates: '-68.3615036, 44.45000076',
    municipality: 'Bar Harbor'
  }
}, {
  label: 'Gustavo Rizo Airport (BCA) - CU',
  id: 'BCA',
  obj: {
    iata: 'BCA',
    iso: 'CU',
    coordinates: '-74.5062026977539, 20.365299224853516',
    municipality: 'Baracoa'
  }
}, {
  label: 'Maria Montez International Airport (BRX) - DO',
  id: 'BRX',
  obj: {
    iata: 'BRX',
    iso: 'DO',
    coordinates: '-71.12039947509766, 18.25149917602539',
    municipality: 'Barahona'
  }
}, {
  label: 'Barcaldine Airport (BCI) - AU',
  id: 'BCI',
  obj: {
    iata: 'BCI',
    iso: 'AU',
    coordinates: '145.307006836, -23.5652999878',
    municipality: 'Barcaldine'
  }
}, {
  label: 'Barcelona International Airport (BCN) - ES',
  id: 'BCN',
  obj: {
    iata: 'BCN',
    iso: 'ES',
    coordinates: '2.07846, 41.2971',
    municipality: 'Barcelona'
  }
}, {
  label: 'General Jos\u00c3\u00a9 Antonio Anzoategui International Airport (BLA) - VE',
  id: 'BLA',
  obj: {
    iata: 'BLA',
    iso: 'VE',
    coordinates: '-64.692222, 10.111111',
    municipality: 'Barcelona'
  }
}, {
  label: 'Bareilly Air Force Station (BEK) - IN',
  id: 'BEK',
  obj: {
    iata: 'BEK',
    iso: 'IN',
    coordinates: '79.45079803470001, 28.4221000671',
    municipality: 'Bareilly'
  }
}, {
  label: 'Bari Karol Wojty\u00c5\u0082a Airport (BRI) - IT',
  id: 'BRI',
  obj: {
    iata: 'BRI',
    iso: 'IT',
    coordinates: '16.760599, 41.138901',
    municipality: 'Bari'
  }
}, {
  label: 'Barinas Airport (BNS) - VE',
  id: 'BNS',
  obj: {
    iata: 'BNS',
    iso: 'VE',
    coordinates: '-70.21416667, 8.615',
    municipality: 'Barinas'
  }
}, {
  label: 'Bario Airport (BBN) - MY',
  id: 'BBN',
  obj: {
    iata: 'BBN',
    iso: 'MY',
    coordinates: '115.47899627685547, 3.7338900566101074',
    municipality: 'Bario'
  }
}, {
  label: 'Barisal Airport (BZL) - BD',
  id: 'BZL',
  obj: {
    iata: 'BZL',
    iso: 'BD',
    coordinates: '90.30120086669922, 22.801000595092773',
    municipality: 'Barisal'
  }
}, {
  label: 'Barnaul Airport (BAX) - RU',
  id: 'BAX',
  obj: {
    iata: 'BAX',
    iso: 'RU',
    coordinates: '83.53849792480469, 53.363800048828125',
    municipality: 'Barnaul'
  }
}, {
  label: 'Barquisimeto International Airport (BRM) - VE',
  id: 'BRM',
  obj: {
    iata: 'BRM',
    iso: 'VE',
    coordinates: '-69.3586196899414, 10.042746543884277',
    municipality: 'Barquisimeto'
  }
}, {
  label: 'Barra do Gar\u00c3\u00a7as Airport (BPG) - BR',
  id: 'BPG',
  obj: {
    iata: 'BPG',
    iso: 'BR',
    coordinates: '-52.3889007568, -15.861300468400001',
    municipality: 'Barra Do Gar\u00c3\u00a7as'
  }
}, {
  label: 'Yarigu\u00c3\u00ades Airport (EJA) - CO',
  id: 'EJA',
  obj: {
    iata: 'EJA',
    iso: 'CO',
    coordinates: '-73.8068, 7.02433',
    municipality: 'Barrancabermeja'
  }
}, {
  label: 'Ernesto Cortissoz International Airport (BAQ) - CO',
  id: 'BAQ',
  obj: {
    iata: 'BAQ',
    iso: 'CO',
    coordinates: '-74.7808, 10.8896',
    municipality: 'Barranquilla'
  }
}, {
  label: 'Edward F Knapp State Airport (MPV) - US',
  id: 'MPV',
  obj: {
    iata: 'MPV',
    iso: 'US',
    coordinates: '-72.56230164, 44.20349884',
    municipality: 'Barre/Montpelier'
  }
}, {
  label: 'Chafei Amsei Airport (BAT) - BR',
  id: 'BAT',
  obj: {
    iata: 'BAT',
    iso: 'BR',
    coordinates: '-48.594100952148, -20.584499359131',
    municipality: 'Barretos'
  }
}, {
  label: 'Barrow Walney Island Airport (BWF) - GB',
  id: 'BWF',
  obj: {
    iata: 'BWF',
    iso: 'GB',
    coordinates: '-3.2675, 54.1286111',
    municipality: 'Barrow-in-Furness'
  }
}, {
  label: 'Barter Island LRRS Airport (BTI) - US',
  id: 'BTI',
  obj: {
    iata: 'BTI',
    iso: 'US',
    coordinates: '-143.582000732, 70.1340026855',
    municipality: 'Barter Island Lrrs'
  }
}, {
  label: 'Basco Airport (BSO) - PH',
  id: 'BSO',
  obj: {
    iata: 'BSO',
    iso: 'PH',
    coordinates: '121.980003, 20.4513',
    municipality: 'Basco'
  }
}, {
  label: 'Basrah International Airport (BSR) - IQ',
  id: 'BSR',
  obj: {
    iata: 'BSR',
    iso: 'IQ',
    coordinates: '47.66210174560547, 30.549100875854492',
    municipality: 'Basrah'
  }
}, {
  label: 'Robert L. Bradshaw International Airport (SKB) - KN',
  id: 'SKB',
  obj: {
    iata: 'SKB',
    iso: 'KN',
    coordinates: '-62.71870040893555, 17.311199188232422',
    municipality: 'Basseterre'
  }
}, {
  label: 'Bastia-Poretta Airport (BIA) - FR',
  id: 'BIA',
  obj: {
    iata: 'BIA',
    iso: 'FR',
    coordinates: '9.48373031616211, 42.55270004272461',
    municipality: 'Bastia/Poretta'
  }
}, {
  label: 'Batajnica Air Base (BJY) - RS',
  id: 'BJY',
  obj: {
    iata: 'BJY',
    iso: 'RS',
    coordinates: '20.2575, 44.935299',
    municipality: 'Batajnica'
  }
}, {
  label: 'Hang Nadim International Airport (BTH) - ID',
  id: 'BTH',
  obj: {
    iata: 'BTH',
    iso: 'ID',
    coordinates: '104.119003296, 1.12102997303',
    municipality: 'Batam Island'
  }
}, {
  label: 'Bathurst Airport (ZBF) - CA',
  id: 'ZBF',
  obj: {
    iata: 'ZBF',
    iso: 'CA',
    coordinates: '-65.738899231, 47.629699707',
    municipality: 'Bathurst'
  }
}, {
  label: 'Bathurst Airport (BHS) - AU',
  id: 'BHS',
  obj: {
    iata: 'BHS',
    iso: 'AU',
    coordinates: '149.651992798, -33.4094009399',
    municipality: 'Bathurst'
  }
}, {
  label: 'Batman Airport (BAL) - TR',
  id: 'BAL',
  obj: {
    iata: 'BAL',
    iso: 'TR',
    coordinates: '41.1166000366, 37.929000854499996',
    municipality: 'Batman'
  }
}, {
  label: 'Batna Airport (BLJ) - DZ',
  id: 'BLJ',
  obj: {
    iata: 'BLJ',
    iso: 'DZ',
    coordinates: '6.308589935300001, 35.752101898199996',
    municipality: 'Batna'
  }
}, {
  label: 'Baton Rouge Metropolitan Airport (BTR) - US',
  id: 'BTR',
  obj: {
    iata: 'BTR',
    iso: 'US',
    coordinates: '-91.149597, 30.533199',
    municipality: 'Baton Rouge'
  }
}, {
  label: 'Battambang Airport (BBM) - KH',
  id: 'BBM',
  obj: {
    iata: 'BBM',
    iso: 'KH',
    coordinates: '103.2239990234375, 13.095600128173828',
    municipality: 'Battambang'
  }
}, {
  label: 'Batticaloa Airport (BTC) - LK',
  id: 'BTC',
  obj: {
    iata: 'BTC',
    iso: 'LK',
    coordinates: '81.678802, 7.70576',
    municipality: 'Batticaloa'
  }
}, {
  label: 'W K Kellogg Airport (BTL) - US',
  id: 'BTL',
  obj: {
    iata: 'BTL',
    iso: 'US',
    coordinates: '-85.2515029907, 42.307300567599995',
    municipality: 'Battle Creek'
  }
}, {
  label: 'Batumi International Airport (BUS) - GE',
  id: 'BUS',
  obj: {
    iata: 'BUS',
    iso: 'GE',
    coordinates: '41.5997009277, 41.6102981567',
    municipality: 'Batumi'
  }
}, {
  label: 'Cakung Airport (BCH) - TL',
  id: 'BCH',
  obj: {
    iata: 'BCH',
    iso: 'TL',
    coordinates: '126.401000977, -8.489029884339999',
    municipality: 'Baucau'
  }
}, {
  label: 'Sir Abubakar Tafawa Balewa International Airport (BCU) - NG',
  id: 'BCU',
  obj: {
    iata: 'BCU',
    iso: 'NG',
    coordinates: '9.744, 10.482833',
    municipality: 'Bauchi'
  }
}, {
  label: 'Baudette International Airport (BDE) - US',
  id: 'BDE',
  obj: {
    iata: 'BDE',
    iso: 'US',
    coordinates: '-94.612197876, 48.7284011841',
    municipality: 'Baudette'
  }
}, {
  label: 'Bauru Airport (BAU) - BR',
  id: 'BAU',
  obj: {
    iata: 'BAU',
    iso: 'BR',
    coordinates: '-49.0537986755, -22.3449993134',
    municipality: 'Bauru'
  }
}, {
  label: 'Bauru - Arealva Airport (JTC) - BR',
  id: 'JTC',
  obj: {
    iata: 'JTC',
    iso: 'BR',
    coordinates: '-49.0502866745, -22.166859140899998',
    municipality: 'Bauru'
  }
}, {
  label: 'Bayannur Tianjitai Airport (RLK) - CN',
  id: 'RLK',
  obj: {
    iata: 'RLK',
    iso: 'CN',
    coordinates: '107.7428, 40.926',
    municipality: 'Bavannur'
  }
}, {
  label: 'Carlos Manuel de Cespedes Airport (BYM) - CU',
  id: 'BYM',
  obj: {
    iata: 'BYM',
    iso: 'CU',
    coordinates: '-76.62139892578125, 20.396400451660156',
    municipality: 'Bayamo'
  }
}, {
  label: 'Alxa Left Banner Bayanhot Airport (AXF) - CN',
  id: 'AXF',
  obj: {
    iata: 'AXF',
    iso: 'CN',
    coordinates: '105.58858, 38.74831',
    municipality: 'Bayanhot'
  }
}, {
  label: 'Bayankhongor Airport (BYN) - MN',
  id: 'BYN',
  obj: {
    iata: 'BYN',
    iso: 'MN',
    coordinates: '100.7040023803711, 46.163299560546',
    municipality: 'Bayankhongor'
  }
}, {
  label: 'Bayreuth Airport (BYU) - DE',
  id: 'BYU',
  obj: {
    iata: 'BYU',
    iso: 'DE',
    coordinates: '11.64, 49.985001',
    municipality: 'Bayreuth'
  }
}, {
  label: 'Bazaruto Island Airport (BZB) - MZ',
  id: 'BZB',
  obj: {
    iata: 'BZB',
    iso: 'MZ',
    coordinates: '35.4729, -21.5411',
    municipality: 'Bazaruto Island'
  }
}, {
  label: 'Indigo Bay Lodge Airport (IBL) - MZ',
  id: 'IBL',
  obj: {
    iata: 'IBL',
    iso: 'MZ',
    coordinates: '35.452801, -21.708',
    municipality: 'Bazaruto Island'
  }
}, {
  label: 'Southeast Texas Regional Airport (BPT) - US',
  id: 'BPT',
  obj: {
    iata: 'BPT',
    iso: 'US',
    coordinates: '-94.02069854736328, 29.9507999420166',
    municipality: 'Beaumont/Port Arthur'
  }
}, {
  label: 'Paris Beauvais Till\u00c3\u00a9 Airport (BVA) - FR',
  id: 'BVA',
  obj: {
    iata: 'BVA',
    iso: 'FR',
    coordinates: '2.1127800941467285, 49.45439910888672',
    municipality: 'Beauvais/Till\u00c3\u00a9'
  }
}, {
  label: 'Beaver Creek Airport (YXQ) - CA',
  id: 'YXQ',
  obj: {
    iata: 'YXQ',
    iso: 'CA',
    coordinates: '-140.86700439453125, 62.410301208496094',
    municipality: 'Beaver Creek'
  }
}, {
  label: 'Beaver County Airport (BFP) - US',
  id: 'BFP',
  obj: {
    iata: 'BFP',
    iso: 'US',
    coordinates: '-80.39140319820001, 40.7724990845',
    municipality: 'Beaver Falls'
  }
}, {
  label: 'Raleigh County Memorial Airport (BKW) - US',
  id: 'BKW',
  obj: {
    iata: 'BKW',
    iso: 'US',
    coordinates: '-81.1241989136, 37.787300109899995',
    municipality: 'Beckley'
  }
}, {
  label: 'Laurence G Hanscom Field (BED) - US',
  id: 'BED',
  obj: {
    iata: 'BED',
    iso: 'US',
    coordinates: '-71.28900146, 42.47000122',
    municipality: 'Bedford'
  }
}, {
  label: 'Nevatim Air Base (VTM) - IL',
  id: 'VTM',
  obj: {
    iata: 'VTM',
    iso: 'IL',
    coordinates: '35.012298584, 31.208299636799996',
    municipality: 'Beersheba'
  }
}, {
  label: 'Ramon Air Base (MIP) - IL',
  id: 'MIP',
  obj: {
    iata: 'MIP',
    iso: 'IL',
    coordinates: '34.66669845581055, 30.776100158691406',
    municipality: 'Beersheba'
  }
}, {
  label: 'Matsu Beigan Airport (MFK) - TW',
  id: 'MFK',
  obj: {
    iata: 'MFK',
    iso: 'TW',
    coordinates: '120.002998, 26.224199',
    municipality: 'Beigan Island'
  }
}, {
  label: 'Beijing Capital International Airport (PEK) - CN',
  id: 'PEK',
  obj: {
    iata: 'PEK',
    iso: 'CN',
    coordinates: '116.58499908447266, 40.080101013183594',
    municipality: 'Beijing'
  }
}, {
  label: 'Beijing Daxing International Airport (PKX) - CN',
  id: 'PKX',
  obj: {
    iata: 'PKX',
    iso: 'CN',
    coordinates: '116.41092, 39.509945',
    municipality: 'Beijing'
  }
}, {
  label: 'Beijing Nanyuan Airport (NAY) - CN',
  id: 'NAY',
  obj: {
    iata: 'NAY',
    iso: 'CN',
    coordinates: '116.38800048828125, 39.782798767089844',
    municipality: 'Beijing'
  }
}, {
  label: 'Beira Airport (BEW) - MZ',
  id: 'BEW',
  obj: {
    iata: 'BEW',
    iso: 'MZ',
    coordinates: '34.90760040283203, -19.79640007019043',
    municipality: 'Beira'
  }
}, {
  label: 'Beirut Rafic Hariri International Airport (BEY) - LB',
  id: 'BEY',
  obj: {
    iata: 'BEY',
    iso: 'LB',
    coordinates: '35.488399505615234, 33.820899963378906',
    municipality: 'Beirut'
  }
}, {
  label: 'Beja Airport / Airbase (BYJ) - PT',
  id: 'BYJ',
  obj: {
    iata: 'BYJ',
    iso: 'PT',
    coordinates: '-7.9324, 38.078899',
    municipality: 'Beja'
  }
}, {
  label: 'Belaya Gora Airport (BGN) - RU',
  id: 'BGN',
  obj: {
    iata: 'BGN',
    iso: 'RU',
    coordinates: '146.231506, 68.556602',
    municipality: 'Belaya Gora'
  }
}, {
  label: 'Belfast International Airport (BFS) - GB',
  id: 'BFS',
  obj: {
    iata: 'BFS',
    iso: 'GB',
    coordinates: '-6.2158298492399995, 54.6575012207',
    municipality: 'Belfast'
  }
}, {
  label: 'George Best Belfast City Airport (BHD) - GB',
  id: 'BHD',
  obj: {
    iata: 'BHD',
    iso: 'GB',
    coordinates: '-5.872499942779541, 54.618099212646484',
    municipality: 'Belfast'
  }
}, {
  label: 'Belgaum Airport (IXG) - IN',
  id: 'IXG',
  obj: {
    iata: 'IXG',
    iso: 'IN',
    coordinates: '74.6183013916, 15.859299659700001',
    municipality: 'Belgaum'
  }
}, {
  label: 'Belgorod International Airport (EGO) - RU',
  id: 'EGO',
  obj: {
    iata: 'EGO',
    iso: 'RU',
    coordinates: '36.5900993347168, 50.643798828125',
    municipality: 'Belgorod'
  }
}, {
  label: 'Belgrade Nikola Tesla Airport (BEG) - RS',
  id: 'BEG',
  obj: {
    iata: 'BEG',
    iso: 'RS',
    coordinates: '20.3090991974, 44.8184013367',
    municipality: 'Belgrade'
  }
}, {
  label: 'Belize City Municipal Airport (TZA) - BZ',
  id: 'TZA',
  obj: {
    iata: 'TZA',
    iso: 'BZ',
    coordinates: '-88.19444274902344, 17.516389846801758',
    municipality: 'Belize City'
  }
}, {
  label: 'Philip S. W. Goldson International Airport (BZE) - BZ',
  id: 'BZE',
  obj: {
    iata: 'BZE',
    iso: 'BZ',
    coordinates: '-88.30819702148438, 17.539100646972656',
    municipality: 'Belize City'
  }
}, {
  label: 'Bella Coola Airport (QBC) - CA',
  id: 'QBC',
  obj: {
    iata: 'QBC',
    iso: 'CA',
    coordinates: '-126.596001, 52.387501',
    municipality: 'Bella Coola'
  }
}, {
  label: 'Bellary Airport (BEP) - IN',
  id: 'BEP',
  obj: {
    iata: 'BEP',
    iso: 'IN',
    coordinates: '76.88279724121094, 15.162799835205078',
    municipality: 'Bellary'
  }
}, {
  label: 'Scott AFB/Midamerica Airport (BLV) - US',
  id: 'BLV',
  obj: {
    iata: 'BLV',
    iso: 'US',
    coordinates: '-89.835197, 38.5452',
    municipality: 'Belleville'
  }
}, {
  label: 'Bellingham International Airport (BLI) - US',
  id: 'BLI',
  obj: {
    iata: 'BLI',
    iso: 'US',
    coordinates: '-122.53800201416016, 48.79280090332031',
    municipality: 'Bellingham'
  }
}, {
  label: 'Pampulha - Carlos Drummond de Andrade Airport (PLU) - BR',
  id: 'PLU',
  obj: {
    iata: 'PLU',
    iso: 'BR',
    coordinates: '-43.950599670410156, -19.851200103759766',
    municipality: 'Belo Horizonte'
  }
}, {
  label: 'Tancredo Neves International Airport (CNF) - BR',
  id: 'CNF',
  obj: {
    iata: 'CNF',
    iso: 'BR',
    coordinates: '-43.97194290161133, -19.62444305419922',
    municipality: 'Belo Horizonte'
  }
}, {
  label: 'Val de Cans/J\u00c3\u00balio Cezar Ribeiro International Airport (BEL) - BR',
  id: 'BEL',
  obj: {
    iata: 'BEL',
    iso: 'BR',
    coordinates: '-48.4762992859, -1.3792500495900002',
    municipality: 'Bel\u00c3\u00a9m'
  }
}, {
  label: 'Bemidji Regional Airport (BJI) - US',
  id: 'BJI',
  obj: {
    iata: 'BJI',
    iso: 'US',
    coordinates: '-94.93370056, 47.50939941',
    municipality: 'Bemidji'
  }
}, {
  label: 'Benina International Airport (BEN) - LY',
  id: 'BEN',
  obj: {
    iata: 'BEN',
    iso: 'LY',
    coordinates: '20.2695007324, 32.096801757799994',
    municipality: 'Benghazi'
  }
}, {
  label: 'Fatmawati Soekarno Airport (BKS) - ID',
  id: 'BKS',
  obj: {
    iata: 'BKS',
    iso: 'ID',
    coordinates: '102.338997, -3.8637',
    municipality: 'Bengkulu-Sumatra Island'
  }
}, {
  label: 'Benguela Airport (BUG) - AO',
  id: 'BUG',
  obj: {
    iata: 'BUG',
    iso: 'AO',
    coordinates: '13.4036998749, -12.609000206',
    municipality: 'Benguela'
  }
}, {
  label: 'Benguera Island Airport (BCW) - MZ',
  id: 'BCW',
  obj: {
    iata: 'BCW',
    iso: 'MZ',
    coordinates: '35.43830108642578, -21.853300094604492',
    municipality: 'Benguera Island'
  }
}, {
  label: 'Benin Airport (BNI) - NG',
  id: 'BNI',
  obj: {
    iata: 'BNI',
    iso: 'NG',
    coordinates: '5.5995001792907715, 6.316979885101318',
    municipality: 'Benin'
  }
}, {
  label: 'RAF Benson (BEX) - GB',
  id: 'BEX',
  obj: {
    iata: 'BEX',
    iso: 'GB',
    coordinates: '-1.09582996368, 51.616401672399995',
    municipality: 'Benson'
  }
}, {
  label: 'J F Mitchell Airport (BQU) - VC',
  id: 'BQU',
  obj: {
    iata: 'BQU',
    iso: 'VC',
    coordinates: '-61.2620010376, 12.9884004593',
    municipality: 'Bequia'
  }
}, {
  label: 'Berbera Airport (BBO) - SO',
  id: 'BBO',
  obj: {
    iata: 'BBO',
    iso: 'SO',
    coordinates: '44.94110107421875, 10.389200210571289',
    municipality: 'Berbera'
  }
}, {
  label: 'Berb\u00c3\u00a9rati Airport (BBT) - CF',
  id: 'BBT',
  obj: {
    iata: 'BBT',
    iso: 'CF',
    coordinates: '15.786399841308594, 4.2215800285339355',
    municipality: 'Berb\u00c3\u00a9rati'
  }
}, {
  label: 'Berens River Airport (YBV) - CA',
  id: 'YBV',
  obj: {
    iata: 'YBV',
    iso: 'CA',
    coordinates: '-97.018303, 52.358898',
    municipality: 'Berens River'
  }
}, {
  label: 'Milan Bergamo Airport (BGY) - IT',
  id: 'BGY',
  obj: {
    iata: 'BGY',
    iso: 'IT',
    coordinates: '9.70417, 45.673901',
    municipality: 'Bergamo'
  }
}, {
  label: 'Bergen Airport Flesland (BGO) - NO',
  id: 'BGO',
  obj: {
    iata: 'BGO',
    iso: 'NO',
    coordinates: '5.218140125, 60.29339981',
    municipality: 'Bergen'
  }
}, {
  label: 'Woensdrecht Air Base (WOE) - NL',
  id: 'WOE',
  obj: {
    iata: 'WOE',
    iso: 'NL',
    coordinates: '4.34203, 51.4491',
    municipality: 'Bergen Op Zoom'
  }
}, {
  label: 'Bergerac-Roumani\u00c3\u00a8re Airport (EGC) - FR',
  id: 'EGC',
  obj: {
    iata: 'EGC',
    iso: 'FR',
    coordinates: '0.5186110138893127, 44.82529830932617',
    municipality: 'Bergerac/Roumani\u00c3\u00a8re'
  }
}, {
  label: 'Berlev\u00c3\u00a5g Airport (BVG) - NO',
  id: 'BVG',
  obj: {
    iata: 'BVG',
    iso: 'NO',
    coordinates: '29.034201, 70.871399',
    municipality: 'Berlev\u00c3\u00a5g'
  }
}, {
  label: 'Berlin-Sch\u00c3\u00b6nefeld Airport (SXF) - DE',
  id: 'SXF',
  obj: {
    iata: 'SXF',
    iso: 'DE',
    coordinates: '13.5225, 52.380001',
    municipality: 'Berlin'
  }
}, {
  label: 'Berlin-Tegel Airport (TXL) - DE',
  id: 'TXL',
  obj: {
    iata: 'TXL',
    iso: 'DE',
    coordinates: '13.2877, 52.5597',
    municipality: 'Berlin'
  }
}, {
  label: 'Bermejo Airport (BJO) - BO',
  id: 'BJO',
  obj: {
    iata: 'BJO',
    iso: 'BO',
    coordinates: '-64.31289672850001, -22.7733001709',
    municipality: 'Bermejo'
  }
}, {
  label: 'Bern Belp Airport (BRN) - CH',
  id: 'BRN',
  obj: {
    iata: 'BRN',
    iso: 'CH',
    coordinates: '7.497149944309999, 46.914100647',
    municipality: 'Bern'
  }
}, {
  label: 'Beslan Airport (OGZ) - RU',
  id: 'OGZ',
  obj: {
    iata: 'OGZ',
    iso: 'RU',
    coordinates: '44.6066017151, 43.2051010132',
    municipality: 'Beslan'
  }
}, {
  label: 'Bethel Airport (BET) - US',
  id: 'BET',
  obj: {
    iata: 'BET',
    iso: 'US',
    coordinates: '-161.8379974, 60.77980042',
    municipality: 'Bethel'
  }
}, {
  label: 'Bettles Airport (BTT) - US',
  id: 'BTT',
  obj: {
    iata: 'BTT',
    iso: 'US',
    coordinates: '-151.529007, 66.91390228',
    municipality: 'Bettles'
  }
}, {
  label: 'Beverly Municipal Airport (BVY) - US',
  id: 'BVY',
  obj: {
    iata: 'BVY',
    iso: 'US',
    coordinates: '-70.91649627689999, 42.584201812699995',
    municipality: 'Beverly'
  }
}, {
  label: 'Gautam Buddha Airport (BWA) - NP',
  id: 'BWA',
  obj: {
    iata: 'BWA',
    iso: 'NP',
    coordinates: '83.416293, 27.505685',
    municipality: 'Bhairawa'
  }
}, {
  label: 'Bhavnagar Airport (BHU) - IN',
  id: 'BHU',
  obj: {
    iata: 'BHU',
    iso: 'IN',
    coordinates: '72.1852035522, 21.752199173',
    municipality: 'Bhavnagar'
  }
}, {
  label: 'Raja Bhoj International Airport (BHO) - IN',
  id: 'BHO',
  obj: {
    iata: 'BHO',
    iso: 'IN',
    coordinates: '77.3374023438, 23.2875003815',
    municipality: 'Bhopal'
  }
}, {
  label: 'Biju Patnaik Airport (BBI) - IN',
  id: 'BBI',
  obj: {
    iata: 'BBI',
    iso: 'IN',
    coordinates: '85.8178024292, 20.244400024399997',
    municipality: 'Bhubaneswar'
  }
}, {
  label: 'Bhuj Airport (BHJ) - IN',
  id: 'BHJ',
  obj: {
    iata: 'BHJ',
    iso: 'IN',
    coordinates: '69.6701965332, 23.2877998352',
    municipality: 'Bhuj'
  }
}, {
  label: 'Frans Kaisiepo Airport (BIK) - ID',
  id: 'BIK',
  obj: {
    iata: 'BIK',
    iso: 'ID',
    coordinates: '136.10800170898438, -1.190019965171814',
    municipality: 'Biak-Supiori Island'
  }
}, {
  label: 'Biarritz-Anglet-Bayonne Airport (BIQ) - FR',
  id: 'BIQ',
  obj: {
    iata: 'BIQ',
    iso: 'FR',
    coordinates: '-1.5311111, 43.4683333',
    municipality: 'Biarritz/Anglet/Bayonne'
  }
}, {
  label: 'Bia\u00c5\u0082a Podlaska Airfield (BXP) - PL',
  id: 'BXP',
  obj: {
    iata: 'BXP',
    iso: 'PL',
    coordinates: '23.1325278, 52.00078',
    municipality: 'Bia\u00c5\u0082a Podlaska'
  }
}, {
  label: 'Big Creek Airport (BGK) - BZ',
  id: 'BGK',
  obj: {
    iata: 'BGK',
    iso: 'BZ',
    coordinates: '-88.40791320800781, 16.51936912536621',
    municipality: 'Big Creek'
  }
}, {
  label: 'Miley Memorial Field (BPI) - US',
  id: 'BPI',
  obj: {
    iata: 'BPI',
    iso: 'US',
    coordinates: '-110.1110001, 42.58509827',
    municipality: 'Big Piney'
  }
}, {
  label: 'Big Trout Lake Airport (YTL) - CA',
  id: 'YTL',
  obj: {
    iata: 'YTL',
    iso: 'CA',
    coordinates: '-89.89689636230469, 53.81779861450195',
    municipality: 'Big Trout Lake'
  }
}, {
  label: 'Nal Airport (BKB) - IN',
  id: 'BKB',
  obj: {
    iata: 'BKB',
    iso: 'IN',
    coordinates: '73.20719909667969, 28.070600509643555',
    municipality: 'Bikaner'
  }
}, {
  label: 'Bilaspur Airport (PAB) - IN',
  id: 'PAB',
  obj: {
    iata: 'PAB',
    iso: 'IN',
    coordinates: '82.111, 21.9884',
    municipality: 'Bilaspur'
  }
}, {
  label: 'Bilbao Airport (BIO) - ES',
  id: 'BIO',
  obj: {
    iata: 'BIO',
    iso: 'ES',
    coordinates: '-2.9106099605560303, 43.30110168457031',
    municipality: 'Bilbao'
  }
}, {
  label: 'Billings Logan International Airport (BIL) - US',
  id: 'BIL',
  obj: {
    iata: 'BIL',
    iso: 'US',
    coordinates: '-108.54299926757812, 45.807701110839844',
    municipality: 'Billings'
  }
}, {
  label: 'Billund Airport (BLL) - DK',
  id: 'BLL',
  obj: {
    iata: 'BLL',
    iso: 'DK',
    coordinates: '9.15178012848, 55.7402992249',
    municipality: 'Billund'
  }
}, {
  label: 'Thangool Airport (THG) - AU',
  id: 'THG',
  obj: {
    iata: 'THG',
    iso: 'AU',
    coordinates: '150.5760040283203, -24.493900299072266',
    municipality: 'Biloela'
  }
}, {
  label: 'Keesler Air Force Base (BIX) - US',
  id: 'BIX',
  obj: {
    iata: 'BIX',
    iso: 'US',
    coordinates: '-88.92440032959999, 30.4104003906',
    municipality: 'Biloxi'
  }
}, {
  label: 'Greater Binghamton/Edwin A Link field (BGM) - US',
  id: 'BGM',
  obj: {
    iata: 'BGM',
    iso: 'US',
    coordinates: '-75.97979736, 42.20869827',
    municipality: 'Binghamton'
  }
}, {
  label: 'Bintulu Airport (BTU) - MY',
  id: 'BTU',
  obj: {
    iata: 'BTU',
    iso: 'MY',
    coordinates: '113.019996643, 3.12385010719',
    municipality: 'Bintulu'
  }
}, {
  label: 'Biratnagar Airport (BIR) - NP',
  id: 'BIR',
  obj: {
    iata: 'BIR',
    iso: 'NP',
    coordinates: '87.26399993896484, 26.48150062561035',
    municipality: 'Biratnagar'
  }
}, {
  label: 'Birjand Airport (XBJ) - IR',
  id: 'XBJ',
  obj: {
    iata: 'XBJ',
    iso: 'IR',
    coordinates: '59.2661018371582, 32.898101806640625',
    municipality: 'Birjand'
  }
}, {
  label: 'Birmingham International Airport (BHX) - GB',
  id: 'BHX',
  obj: {
    iata: 'BHX',
    iso: 'GB',
    coordinates: '-1.74802994728, 52.453899383499994',
    municipality: 'Birmingham'
  }
}, {
  label: 'Birmingham-Shuttlesworth International Airport (BHM) - US',
  id: 'BHM',
  obj: {
    iata: 'BHM',
    iso: 'US',
    coordinates: '-86.75350189, 33.56290054',
    municipality: 'Birmingham'
  }
}, {
  label: 'Manas International Airport (FRU) - KG',
  id: 'FRU',
  obj: {
    iata: 'FRU',
    iso: 'KG',
    coordinates: '74.4776000977, 43.0612983704',
    municipality: 'Bishkek'
  }
}, {
  label: 'Bisho Airport (BIY) - ZA',
  id: 'BIY',
  obj: {
    iata: 'BIY',
    iso: 'ZA',
    coordinates: '27.279100418099997, -32.8970985413',
    municipality: 'Bisho'
  }
}, {
  label: 'Eastern Sierra Regional Airport (BIH) - US',
  id: 'BIH',
  obj: {
    iata: 'BIH',
    iso: 'US',
    coordinates: '-118.363998413, 37.3731002808',
    municipality: 'Bishop'
  }
}, {
  label: 'Biskra Airport (BSK) - DZ',
  id: 'BSK',
  obj: {
    iata: 'BSK',
    iso: 'DZ',
    coordinates: '5.73823022842, 34.793300628699996',
    municipality: 'Biskra'
  }
}, {
  label: 'Bismarck Municipal Airport (BIS) - US',
  id: 'BIS',
  obj: {
    iata: 'BIS',
    iso: 'US',
    coordinates: '-100.74600219726562, 46.772701263427734',
    municipality: 'Bismarck'
  }
}, {
  label: 'Osvaldo Vieira International Airport (OXB) - GW',
  id: 'OXB',
  obj: {
    iata: 'OXB',
    iso: 'GW',
    coordinates: '-15.65369987487793, 11.894800186157227',
    municipality: 'Bissau'
  }
}, {
  label: 'Bitam Airport (BMM) - GA',
  id: 'BMM',
  obj: {
    iata: 'BMM',
    iso: 'GA',
    coordinates: '11.493200302124023, 2.0756399631500244',
    municipality: 'Bitam'
  }
}, {
  label: 'Blackall Airport (BKQ) - AU',
  id: 'BKQ',
  obj: {
    iata: 'BKQ',
    iso: 'AU',
    coordinates: '145.429000854, -24.427799224900003',
    municipality: 'Blackall'
  }
}, {
  label: 'Blackpool International Airport (BLK) - GB',
  id: 'BLK',
  obj: {
    iata: 'BLK',
    iso: 'GB',
    coordinates: '-3.0286099910736084, 53.77170181274414',
    municipality: 'Blackpool'
  }
}, {
  label: 'Ignatyevo Airport (BQS) - RU',
  id: 'BQS',
  obj: {
    iata: 'BQS',
    iso: 'RU',
    coordinates: '127.41200256347656, 50.42539978027344',
    municipality: 'Blagoveschensk'
  }
}, {
  label: 'Chileka International Airport (BLZ) - MW',
  id: 'BLZ',
  obj: {
    iata: 'BLZ',
    iso: 'MW',
    coordinates: '34.9739990234375, -15.679100036621094',
    municipality: 'Blantyre'
  }
}, {
  label: 'Woodbourne Airport (BHE) - NZ',
  id: 'BHE',
  obj: {
    iata: 'BHE',
    iso: 'NZ',
    coordinates: '173.8699951171875, -41.5182991027832',
    municipality: 'Blenheim'
  }
}, {
  label: 'Bram Fischer International Airport (BFN) - ZA',
  id: 'BFN',
  obj: {
    iata: 'BFN',
    iso: 'ZA',
    coordinates: '26.302401, -29.092699',
    municipality: 'Bloemfontain'
  }
}, {
  label: 'Monroe County Airport (BMG) - US',
  id: 'BMG',
  obj: {
    iata: 'BMG',
    iso: 'US',
    coordinates: '-86.61669921875, 39.145999908447266',
    municipality: 'Bloomington'
  }
}, {
  label: 'Central Illinois Regional Airport at Bloomington-Normal (BMI) - US',
  id: 'BMI',
  obj: {
    iata: 'BMI',
    iso: 'US',
    coordinates: '-88.91590118, 40.47710037',
    municipality: 'Bloomington/Normal'
  }
}, {
  label: 'Mercer County Airport (BLF) - US',
  id: 'BLF',
  obj: {
    iata: 'BLF',
    iso: 'US',
    coordinates: '-81.20770263671875, 37.295799255371094',
    municipality: 'Bluefield'
  }
}, {
  label: 'Bluefields Airport (BEF) - NI',
  id: 'BEF',
  obj: {
    iata: 'BEF',
    iso: 'NI',
    coordinates: '-83.77410125732422, 11.991000175476074',
    municipality: 'Bluefileds'
  }
}, {
  label: 'Blythe Airport (BLH) - US',
  id: 'BLH',
  obj: {
    iata: 'BLH',
    iso: 'US',
    coordinates: '-114.717002869, 33.6192016602',
    municipality: 'Blythe'
  }
}, {
  label: 'Arkansas International Airport (BYH) - US',
  id: 'BYH',
  obj: {
    iata: 'BYH',
    iso: 'US',
    coordinates: '-89.94400024410001, 35.9642982483',
    municipality: 'Blytheville'
  }
}, {
  label: 'Bo Airport (KBS) - SL',
  id: 'KBS',
  obj: {
    iata: 'KBS',
    iso: 'SL',
    coordinates: '-11.76099967956543, 7.944399833679199',
    municipality: 'Bo'
  }
}, {
  label: 'Atlas Brasil Cantanhede Airport (BVB) - BR',
  id: 'BVB',
  obj: {
    iata: 'BVB',
    iso: 'BR',
    coordinates: '-60.6922225952, 2.84138894081',
    municipality: 'Boa Vista'
  }
}, {
  label: 'Bobo Dioulasso Airport (BOY) - BF',
  id: 'BOY',
  obj: {
    iata: 'BOY',
    iso: 'BF',
    coordinates: '-4.33096981048584, 11.160099983215332',
    municipality: 'Bobo Dioulasso'
  }
}, {
  label: 'Milas Bodrum International Airport (BJV) - TR',
  id: 'BJV',
  obj: {
    iata: 'BJV',
    iso: 'TR',
    coordinates: '27.6643009186, 37.25059890749999',
    municipality: 'Bodrum'
  }
}, {
  label: 'Bod\u00c3\u00b8 Airport (BOO) - NO',
  id: 'BOO',
  obj: {
    iata: 'BOO',
    iso: 'NO',
    coordinates: '14.365300178527832, 67.26920318603516',
    municipality: 'Bod\u00c3\u00b8'
  }
}, {
  label: 'El Dorado International Airport (BOG) - CO',
  id: 'BOG',
  obj: {
    iata: 'BOG',
    iso: 'CO',
    coordinates: '-74.1469, 4.70159',
    municipality: 'Bogota'
  }
}, {
  label: 'Boise Air Terminal/Gowen Field (BOI) - US',
  id: 'BOI',
  obj: {
    iata: 'BOI',
    iso: 'US',
    coordinates: '-116.223, 43.5644',
    municipality: 'Boise'
  }
}, {
  label: 'Bojnord Airport (BJB) - IR',
  id: 'BJB',
  obj: {
    iata: 'BJB',
    iso: 'IR',
    coordinates: '57.30820083618164, 37.49300003051758',
    municipality: 'Bojnord'
  }
}, {
  label: 'El Dorado Airport (EOR) - VE',
  id: 'EOR',
  obj: {
    iata: 'EOR',
    iso: 'VE',
    coordinates: '-61.58333206176758, 6.733333110809326',
    municipality: 'Bolivar'
  }
}, {
  label: 'Bologna Guglielmo Marconi Airport (BLQ) - IT',
  id: 'BLQ',
  obj: {
    iata: 'BLQ',
    iso: 'IT',
    coordinates: '11.2887, 44.5354',
    municipality: 'Bologna'
  }
}, {
  label: 'Bolzano Airport (BZO) - IT',
  id: 'BZO',
  obj: {
    iata: 'BZO',
    iso: 'IT',
    coordinates: '11.3264, 46.460201',
    municipality: 'Bolzano'
  }
}, {
  label: 'Bom Jesus da Lapa Airport (LAZ) - BR',
  id: 'LAZ',
  obj: {
    iata: 'LAZ',
    iso: 'BR',
    coordinates: '-43.4081001282, -13.2621002197',
    municipality: 'Bom Jesus Da Lapa'
  }
}, {
  label: 'Bonaventure Airport (YVB) - CA',
  id: 'YVB',
  obj: {
    iata: 'YVB',
    iso: 'CA',
    coordinates: '-65.46029663085938, 48.07109832763672',
    municipality: 'Bonaventure'
  }
}, {
  label: 'Bonnyville Airport (YBY) - CA',
  id: 'YBY',
  obj: {
    iata: 'YBY',
    iso: 'CA',
    coordinates: '-110.744003, 54.304199',
    municipality: 'Bonnyville'
  }
}, {
  label: 'Sherbro International Airport (BTE) - SL',
  id: 'BTE',
  obj: {
    iata: 'BTE',
    iso: 'SL',
    coordinates: '-12.518899917602539, 7.5324201583862305',
    municipality: 'Bonthe'
  }
}, {
  label: 'Podkamennaya Tunguska Airport (TGP) - RU',
  id: 'TGP',
  obj: {
    iata: 'TGP',
    iso: 'RU',
    coordinates: '89.994003, 61.589699',
    municipality: 'Bor'
  }
}, {
  label: 'Bordeaux-M\u00c3\u00a9rignac Airport (BOD) - FR',
  id: 'BOD',
  obj: {
    iata: 'BOD',
    iso: 'FR',
    coordinates: '-0.715556025505, 44.828300476100004',
    municipality: 'Bordeaux/M\u00c3\u00a9rignac'
  }
}, {
  label: 'Barksdale Air Force Base (BAD) - US',
  id: 'BAD',
  obj: {
    iata: 'BAD',
    iso: 'US',
    coordinates: '-93.6626968384, 32.5018005371',
    municipality: 'Bossier City'
  }
}, {
  label: 'General Edward Lawrence Logan International Airport (BOS) - US',
  id: 'BOS',
  obj: {
    iata: 'BOS',
    iso: 'US',
    coordinates: '-71.00520325, 42.36429977',
    municipality: 'Boston'
  }
}, {
  label: 'Bouarfa Airport (UAR) - MA',
  id: 'UAR',
  obj: {
    iata: 'UAR',
    iso: 'MA',
    coordinates: '-1.98305555556, 32.5143055556',
    municipality: 'Bouarfa'
  }
}, {
  label: 'Bourges Airport (BOU) - FR',
  id: 'BOU',
  obj: {
    iata: 'BOU',
    iso: 'FR',
    coordinates: '2.3702800273895264, 47.058101654052734',
    municipality: 'Bourges'
  }
}, {
  label: 'Bournemouth Airport (BOH) - GB',
  id: 'BOH',
  obj: {
    iata: 'BOH',
    iso: 'GB',
    coordinates: '-1.8424999713897705, 50.779998779296875',
    municipality: 'Bournemouth'
  }
}, {
  label: 'Bowling Green Warren County Regional Airport (BWG) - US',
  id: 'BWG',
  obj: {
    iata: 'BWG',
    iso: 'US',
    coordinates: '-86.41970062259999, 36.964500427199994',
    municipality: 'Bowling Green'
  }
}, {
  label: 'Gallatin Field (BZN) - US',
  id: 'BZN',
  obj: {
    iata: 'BZN',
    iso: 'US',
    coordinates: '-111.1529999, 45.77750015',
    municipality: 'Bozeman'
  }
}, {
  label: 'Bradford Regional Airport (BFD) - US',
  id: 'BFD',
  obj: {
    iata: 'BFD',
    iso: 'US',
    coordinates: '-78.64009857177734, 41.8031005859375',
    municipality: 'Bradford'
  }
}, {
  label: 'Curtis Field (BBD) - US',
  id: 'BBD',
  obj: {
    iata: 'BBD',
    iso: 'US',
    coordinates: '-99.3238983154, 31.1793003082',
    municipality: 'Brady'
  }
}, {
  label: 'Braga Municipal Aerodrome (BGZ) - PT',
  id: 'BGZ',
  obj: {
    iata: 'BGZ',
    iso: 'PT',
    coordinates: '-8.445139884949999, 41.5871009827',
    municipality: 'Braga'
  }
}, {
  label: 'Bragan\u00c3\u00a7a Airport (BGC) - PT',
  id: 'BGC',
  obj: {
    iata: 'BGC',
    iso: 'PT',
    coordinates: '-6.70713, 41.8578',
    municipality: 'Bragan\u00c3\u00a7a'
  }
}, {
  label: 'Brainerd Lakes Regional Airport (BRD) - US',
  id: 'BRD',
  obj: {
    iata: 'BRD',
    iso: 'US',
    coordinates: '-94.13809967, 46.39830017',
    municipality: 'Brainerd'
  }
}, {
  label: 'Brak Airport (BCQ) - LY',
  id: 'BCQ',
  obj: {
    iata: 'BCQ',
    iso: 'LY',
    coordinates: '14.272, 27.653',
    municipality: 'Brak'
  }
}, {
  label: 'Brandon Municipal Airport (YBR) - CA',
  id: 'YBR',
  obj: {
    iata: 'YBR',
    iso: 'CA',
    coordinates: '-99.951897, 49.91',
    municipality: 'Brandon'
  }
}, {
  label: 'Presidente Juscelino Kubitschek International Airport (BSB) - BR',
  id: 'BSB',
  obj: {
    iata: 'BSB',
    iso: 'BR',
    coordinates: '-47.920834, -15.869167',
    municipality: 'Bras\u00c3\u00adlia'
  }
}, {
  label: 'M. R. \u00c5\u00a0tef\u00c3\u00a1nik Airport (BTS) - SK',
  id: 'BTS',
  obj: {
    iata: 'BTS',
    iso: 'SK',
    coordinates: '17.21269989013672, 48.17020034790039',
    municipality: 'Bratislava'
  }
}, {
  label: 'Bratsk Airport (BTK) - RU',
  id: 'BTK',
  obj: {
    iata: 'BTK',
    iso: 'RU',
    coordinates: '101.697998046875, 56.370601654052734',
    municipality: 'Bratsk'
  }
}, {
  label: 'Braunschweig-Wolfsburg Airport (BWE) - DE',
  id: 'BWE',
  obj: {
    iata: 'BWE',
    iso: 'DE',
    coordinates: '10.5561, 52.319199',
    municipality: 'Braunschweig'
  }
}, {
  label: 'Maya-Maya Airport (BZV) - CG',
  id: 'BZV',
  obj: {
    iata: 'BZV',
    iso: 'CG',
    coordinates: '15.253000259399414, -4.251699924468994',
    municipality: 'Brazzaville'
  }
}, {
  label: 'Bol Airport (BWK) - HR',
  id: 'BWK',
  obj: {
    iata: 'BWK',
    iso: 'HR',
    coordinates: '16.67970085144043, 43.285701751708984',
    municipality: 'Bra\u00c4\u008d Island'
  }
}, {
  label: 'Gilze Rijen Air Base (GLZ) - NL',
  id: 'GLZ',
  obj: {
    iata: 'GLZ',
    iso: 'NL',
    coordinates: '4.931829929351807, 51.56740188598633',
    municipality: 'Breda'
  }
}, {
  label: 'Bremen Airport (BRE) - DE',
  id: 'BRE',
  obj: {
    iata: 'BRE',
    iso: 'DE',
    coordinates: '8.78666973114, 53.0475006104',
    municipality: 'Bremen'
  }
}, {
  label: 'Bremerton National Airport (PWT) - US',
  id: 'PWT',
  obj: {
    iata: 'PWT',
    iso: 'US',
    coordinates: '-122.76499938965, 47.490200042725',
    municipality: 'Bremerton'
  }
}, {
  label: 'Brest Airport (BQT) - BY',
  id: 'BQT',
  obj: {
    iata: 'BQT',
    iso: 'BY',
    coordinates: '23.8981, 52.108299',
    municipality: 'Brest'
  }
}, {
  label: 'Brest Bretagne Airport (BES) - FR',
  id: 'BES',
  obj: {
    iata: 'BES',
    iso: 'FR',
    coordinates: '-4.418540000915527, 48.447898864746094',
    municipality: 'Brest/Guipavas'
  }
}, {
  label: 'Igor I Sikorsky Memorial Airport (BDR) - US',
  id: 'BDR',
  obj: {
    iata: 'BDR',
    iso: 'US',
    coordinates: '-73.1261978149414, 41.16350173950195',
    municipality: 'Bridgeport'
  }
}, {
  label: 'Grantley Adams International Airport (BGI) - BB',
  id: 'BGI',
  obj: {
    iata: 'BGI',
    iso: 'BB',
    coordinates: '-59.4925, 13.0746',
    municipality: 'Bridgetown'
  }
}, {
  label: 'Shoreham Airport (ESH) - GB',
  id: 'ESH',
  obj: {
    iata: 'ESH',
    iso: 'GB',
    coordinates: '-0.297222, 50.835602',
    municipality: 'Brighton'
  }
}, {
  label: 'Brindisi \u00e2\u0080\u0093 Salento Airport (BDS) - IT',
  id: 'BDS',
  obj: {
    iata: 'BDS',
    iso: 'IT',
    coordinates: '17.947001, 40.6576',
    municipality: 'Brindisi'
  }
}, {
  label: 'Brisbane International Airport (BNE) - AU',
  id: 'BNE',
  obj: {
    iata: 'BNE',
    iso: 'AU',
    coordinates: '153.11700439453125, -27.384199142456055',
    municipality: 'Brisbane'
  }
}, {
  label: 'Bristol Airport (BRS) - GB',
  id: 'BRS',
  obj: {
    iata: 'BRS',
    iso: 'GB',
    coordinates: '-2.71909, 51.382702',
    municipality: 'Bristol'
  }
}, {
  label: 'Tri-Cities Regional TN/VA Airport (TRI) - US',
  id: 'TRI',
  obj: {
    iata: 'TRI',
    iso: 'US',
    coordinates: '-82.407401, 36.475201',
    municipality: 'Bristol/Johnson/Kingsport'
  }
}, {
  label: 'Brive-Souillac (BVE) - FR',
  id: 'BVE',
  obj: {
    iata: 'BVE',
    iso: 'FR',
    coordinates: '1.485556, 45.039722',
    municipality: 'Brive la Gaillarde'
  }
}, {
  label: 'RAF Brize Norton (BZZ) - GB',
  id: 'BZZ',
  obj: {
    iata: 'BZZ',
    iso: 'GB',
    coordinates: '-1.58362, 51.75',
    municipality: 'Brize Norton'
  }
}, {
  label: 'Brno-Tu\u00c5\u0099any Airport (BRQ) - CZ',
  id: 'BRQ',
  obj: {
    iata: 'BRQ',
    iso: 'CZ',
    coordinates: '16.694400787353516, 49.15129852294922',
    municipality: 'Brno'
  }
}, {
  label: 'Brochet Airport (YBT) - CA',
  id: 'YBT',
  obj: {
    iata: 'YBT',
    iso: 'CA',
    coordinates: '-101.679001, 57.8894',
    municipality: 'Brochet'
  }
}, {
  label: 'Broken Hill Airport (BHQ) - AU',
  id: 'BHQ',
  obj: {
    iata: 'BHQ',
    iso: 'AU',
    coordinates: '141.472000122, -32.0013999939',
    municipality: 'Broken Hill'
  }
}, {
  label: 'Bromont (Roland Desourdy) Airport (ZBM) - CA',
  id: 'ZBM',
  obj: {
    iata: 'ZBM',
    iso: 'CA',
    coordinates: '-72.74140167239999, 45.2907981873',
    municipality: 'Bromont'
  }
}, {
  label: 'Broome International Airport (BME) - AU',
  id: 'BME',
  obj: {
    iata: 'BME',
    iso: 'AU',
    coordinates: '122.23200225830078, -17.944700241088867',
    municipality: 'Broome'
  }
}, {
  label: 'Brownsville South Padre Island International Airport (BRO) - US',
  id: 'BRO',
  obj: {
    iata: 'BRO',
    iso: 'US',
    coordinates: '-97.4259033203125, 25.90679931640625',
    municipality: 'Brownsville'
  }
}, {
  label: 'Brunswick Golden Isles Airport (BQK) - US',
  id: 'BQK',
  obj: {
    iata: 'BQK',
    iso: 'US',
    coordinates: '-81.46649932861328, 31.258800506591797',
    municipality: 'Brunswick'
  }
}, {
  label: 'Brunswick Executive Airport (NHZ) - US',
  id: 'NHZ',
  obj: {
    iata: 'NHZ',
    iso: 'US',
    coordinates: '-69.93859863, 43.89220047',
    municipality: 'Brunswick'
  }
}, {
  label: 'Brussels Airport (BRU) - BE',
  id: 'BRU',
  obj: {
    iata: 'BRU',
    iso: 'BE',
    coordinates: '4.48443984985, 50.901401519800004',
    municipality: 'Brussels'
  }
}, {
  label: 'Brussels South Charleroi Airport (CRL) - BE',
  id: 'CRL',
  obj: {
    iata: 'CRL',
    iso: 'BE',
    coordinates: '4.45382, 50.459202',
    municipality: 'Brussels'
  }
}, {
  label: 'Bryansk Airport (BZK) - RU',
  id: 'BZK',
  obj: {
    iata: 'BZK',
    iso: 'RU',
    coordinates: '34.176399, 53.214199',
    municipality: 'Bryansk'
  }
}, {
  label: 'Bryce Canyon Airport (BCE) - US',
  id: 'BCE',
  obj: {
    iata: 'BCE',
    iso: 'US',
    coordinates: '-112.144996643, 37.706401825',
    municipality: 'Bryce Canyon'
  }
}, {
  label: 'Br\u00c3\u00b8nn\u00c3\u00b8ysund Airport (BNN) - NO',
  id: 'BNN',
  obj: {
    iata: 'BNN',
    iso: 'NO',
    coordinates: '12.217499732971, 65.461097717285',
    municipality: 'Br\u00c3\u00b8nn\u00c3\u00b8y'
  }
}, {
  label: 'Palonegro Airport (BGA) - CO',
  id: 'BGA',
  obj: {
    iata: 'BGA',
    iso: 'CO',
    coordinates: '-73.1848, 7.1265',
    municipality: 'Bucaramanga'
  }
}, {
  label: 'B\u00c4\u0083neasa International Airport (BBU) - RO',
  id: 'BBU',
  obj: {
    iata: 'BBU',
    iso: 'RO',
    coordinates: '26.102100372314453, 44.50320053100586',
    municipality: 'Bucharest'
  }
}, {
  label: 'Henri Coand\u00c4\u0083 International Airport (OTP) - RO',
  id: 'OTP',
  obj: {
    iata: 'OTP',
    iso: 'RO',
    coordinates: '26.085, 44.5711111',
    municipality: 'Bucharest'
  }
}, {
  label: 'Buckland Airport (BKC) - US',
  id: 'BKC',
  obj: {
    iata: 'BKC',
    iso: 'US',
    coordinates: '-161.149002, 65.981598',
    municipality: 'Buckland'
  }
}, {
  label: 'Budapest Liszt Ferenc International Airport (BUD) - HU',
  id: 'BUD',
  obj: {
    iata: 'BUD',
    iso: 'HU',
    coordinates: '19.261093, 47.42976',
    municipality: 'Budapest'
  }
}, {
  label: 'Gerardo Tobar L\u00c3\u00b3pez Airport (BUN) - CO',
  id: 'BUN',
  obj: {
    iata: 'BUN',
    iso: 'CO',
    coordinates: '-76.9898, 3.81963',
    municipality: 'Buenaventura'
  }
}, {
  label: 'Jorge Newbery Airpark (AEP) - AR',
  id: 'AEP',
  obj: {
    iata: 'AEP',
    iso: 'AR',
    coordinates: '-58.4156, -34.5592',
    municipality: 'Buenos Aires'
  }
}, {
  label: 'Ministro Pistarini International Airport (EZE) - AR',
  id: 'EZE',
  obj: {
    iata: 'EZE',
    iso: 'AR',
    coordinates: '-58.5358, -34.8222',
    municipality: 'Buenos Aires'
  }
}, {
  label: 'Buffalo Niagara International Airport (BUF) - US',
  id: 'BUF',
  obj: {
    iata: 'BUF',
    iso: 'US',
    coordinates: '-78.73220062, 42.94049835',
    municipality: 'Buffalo'
  }
}, {
  label: 'Bugulma Airport (UUA) - RU',
  id: 'UUA',
  obj: {
    iata: 'UUA',
    iso: 'RU',
    coordinates: '52.801700592041016, 54.63999938964844',
    municipality: 'Bugulma'
  }
}, {
  label: 'Bujumbura International Airport (BJM) - BI',
  id: 'BJM',
  obj: {
    iata: 'BJM',
    iso: 'BI',
    coordinates: '29.318500518798828, -3.3240199089050293',
    municipality: 'Bujumbura'
  }
}, {
  label: 'Buka Airport (BUA) - PG',
  id: 'BUA',
  obj: {
    iata: 'BUA',
    iso: 'PG',
    coordinates: '154.67300415039062, -5.4223198890686035',
    municipality: 'Buka Island'
  }
}, {
  label: 'Bukhara Airport (BHK) - UZ',
  id: 'BHK',
  obj: {
    iata: 'BHK',
    iso: 'UZ',
    coordinates: '64.4832992553711, 39.775001525878906',
    municipality: 'Bukhara'
  }
}, {
  label: 'Joshua Mqabuko Nkomo International Airport (BUQ) - ZW',
  id: 'BUQ',
  obj: {
    iata: 'BUQ',
    iso: 'ZW',
    coordinates: '28.617901, -20.017401',
    municipality: 'Bulawayo'
  }
}, {
  label: 'Great Harbour Cay Airport (GHC) - BS',
  id: 'GHC',
  obj: {
    iata: 'GHC',
    iso: 'BS',
    coordinates: '-77.840103, 25.7383',
    municipality: 'Bullocks Harbour'
  }
}, {
  label: 'Bundaberg Airport (BDB) - AU',
  id: 'BDB',
  obj: {
    iata: 'BDB',
    iso: 'AU',
    coordinates: '152.319000244, -24.903900146499996',
    municipality: 'Bundaberg'
  }
}, {
  label: 'Buon Ma Thuot Airport (BMV) - VN',
  id: 'BMV',
  obj: {
    iata: 'BMV',
    iso: 'VN',
    coordinates: '108.120002747, 12.668299675',
    municipality: 'Buon Ma Thuot'
  }
}, {
  label: 'Bob Hope Airport (BUR) - US',
  id: 'BUR',
  obj: {
    iata: 'BUR',
    iso: 'US',
    coordinates: '-118.35900115966797, 34.20069885253906',
    municipality: 'Burbank'
  }
}, {
  label: 'Burgas Airport (BOJ) - BG',
  id: 'BOJ',
  obj: {
    iata: 'BOJ',
    iso: 'BG',
    coordinates: '27.515199661254883, 42.56959915161133',
    municipality: 'Burgas'
  }
}, {
  label: 'Burgos Airport (RGS) - ES',
  id: 'RGS',
  obj: {
    iata: 'RGS',
    iso: 'ES',
    coordinates: '-3.62076, 42.357601',
    municipality: 'Burgos'
  }
}, {
  label: 'Burley Municipal Airport (BYI) - US',
  id: 'BYI',
  obj: {
    iata: 'BYI',
    iso: 'US',
    coordinates: '-113.772003174, 42.542598724399994',
    municipality: 'Burley'
  }
}, {
  label: 'Southeast Iowa Regional Airport (BRL) - US',
  id: 'BRL',
  obj: {
    iata: 'BRL',
    iso: 'US',
    coordinates: '-91.12550354003906, 40.783199310302734',
    municipality: 'Burlington'
  }
}, {
  label: 'Burlington International Airport (BTV) - US',
  id: 'BTV',
  obj: {
    iata: 'BTV',
    iso: 'US',
    coordinates: '-73.15329742429999, 44.471900939899996',
    municipality: 'Burlington'
  }
}, {
  label: 'Wynyard Airport (BWT) - AU',
  id: 'BWT',
  obj: {
    iata: 'BWT',
    iso: 'AU',
    coordinates: '145.7310028076172, -40.9989013671875',
    municipality: 'Burnie'
  }
}, {
  label: 'Burns Municipal Airport (BNO) - US',
  id: 'BNO',
  obj: {
    iata: 'BNO',
    iso: 'US',
    coordinates: '-118.955001831, 43.5918998718',
    municipality: 'Burns'
  }
}, {
  label: 'Norfolk Island International Airport (NLK) - NF',
  id: 'NLK',
  obj: {
    iata: 'NLK',
    iso: 'NF',
    coordinates: '167.93899536132812, -29.04159927368164',
    municipality: 'Burnt Pine'
  }
}, {
  label: 'Bursa Yeni\u00c5\u009fehir Airport (YEI) - TR',
  id: 'YEI',
  obj: {
    iata: 'YEI',
    iso: 'TR',
    coordinates: '29.5625991821, 40.2551994324',
    municipality: 'Bursa'
  }
}, {
  label: 'Burwash Airport (YDB) - CA',
  id: 'YDB',
  obj: {
    iata: 'YDB',
    iso: 'CA',
    coordinates: '-139.04100036621094, 61.37110137939453',
    municipality: 'Burwash'
  }
}, {
  label: 'Gimhae International Airport (PUS) - KR',
  id: 'PUS',
  obj: {
    iata: 'PUS',
    iso: 'KR',
    coordinates: '128.93800354, 35.1795005798',
    municipality: 'Busan'
  }
}, {
  label: 'Bushehr Airport (BUZ) - IR',
  id: 'BUZ',
  obj: {
    iata: 'BUZ',
    iso: 'IR',
    coordinates: '50.8345985413, 28.9447994232',
    municipality: 'Bushehr'
  }
}, {
  label: 'Bert Mooney Airport (BTM) - US',
  id: 'BTM',
  obj: {
    iata: 'BTM',
    iso: 'US',
    coordinates: '-112.49700164794922, 45.95479965209961',
    municipality: 'Butte'
  }
}, {
  label: 'Butterworth Airport (BWH) - MY',
  id: 'BWH',
  obj: {
    iata: 'BWH',
    iso: 'MY',
    coordinates: '100.39099884033203, 5.4659199714660645',
    municipality: 'Butterworth'
  }
}, {
  label: 'Bancasi Airport (BXU) - PH',
  id: 'BXU',
  obj: {
    iata: 'BXU',
    iso: 'PH',
    coordinates: '125.4788, 8.9515',
    municipality: 'Butuan City'
  }
}, {
  label: 'Bydgoszcz Ignacy Jan Paderewski Airport (BZG) - PL',
  id: 'BZG',
  obj: {
    iata: 'BZG',
    iso: 'PL',
    coordinates: '17.9776992798, 53.096801757799994',
    municipality: 'Bydgoszcz'
  }
}, {
  label: 'EuroAirport Basel-Mulhouse-Freiburg Airport (BSL) - FR',
  id: 'BSL',
  obj: {
    iata: 'BSL',
    iso: 'FR',
    coordinates: '7.529167, 47.59',
    municipality: 'B\u00c3\u00a2le/Mulhouse'
  }
}, {
  label: 'B\u00c3\u00a5tsfjord Airport (BJF) - NO',
  id: 'BJF',
  obj: {
    iata: 'BJF',
    iso: 'NO',
    coordinates: '29.691400527954, 70.60050201416',
    municipality: 'B\u00c3\u00a5tsfjord'
  }
}, {
  label: 'B\u00c3\u00a9char Boudghene Ben Ali Lotfi Airport (CBH) - DZ',
  id: 'CBH',
  obj: {
    iata: 'CBH',
    iso: 'DZ',
    coordinates: '-2.269860029220581, 31.645700454711914',
    municipality: 'B\u00c3\u00a9char'
  }
}, {
  label: 'Soummam Airport (BJA) - DZ',
  id: 'BJA',
  obj: {
    iata: 'BJA',
    iso: 'DZ',
    coordinates: '5.0699200630200005, 36.7120018005',
    municipality: 'B\u00c3\u00a9ja\u00c3\u00afa'
  }
}, {
  label: 'B\u00c3\u00a9ziers-Vias Airport (BZR) - FR',
  id: 'BZR',
  obj: {
    iata: 'BZR',
    iso: 'FR',
    coordinates: '3.3538999557495117, 43.32350158691406',
    municipality: 'B\u00c3\u00a9ziers/Vias'
  }
}, {
  label: 'B\u00c4\u0083l\u00c8\u009bi International Airport (BZY) - MD',
  id: 'BZY',
  obj: {
    iata: 'BZY',
    iso: 'MD',
    coordinates: '27.777222, 47.843056',
    municipality: 'B\u00c4\u0083l\u00c8\u009bi'
  }
}, {
  label: 'C\u00c3\u00a0 Mau Airport (CAH) - VN',
  id: 'CAH',
  obj: {
    iata: 'CAH',
    iso: 'VN',
    coordinates: '105.177778, 9.177667',
    municipality: 'Ca Mau City'
  }
}, {
  label: 'Cabinda Airport (CAB) - AO',
  id: 'CAB',
  obj: {
    iata: 'CAB',
    iso: 'AO',
    coordinates: '12.188400268554688, -5.59699010848999',
    municipality: 'Cabinda'
  }
}, {
  label: 'Umberto Modiano Airport (BZC) - BR',
  id: 'BZC',
  obj: {
    iata: 'BZC',
    iso: 'BR',
    coordinates: '-41.96308, -22.770881',
    municipality: 'Cabo Frio'
  }
}, {
  label: 'Cabo Rojo Airport (CBJ) - DO',
  id: 'CBJ',
  obj: {
    iata: 'CBJ',
    iso: 'DO',
    coordinates: '-71.6447982788086, 17.929000854492188',
    municipality: 'Cabo Rojo'
  }
}, {
  label: 'Caen-Carpiquet Airport (CFR) - FR',
  id: 'CFR',
  obj: {
    iata: 'CFR',
    iso: 'FR',
    coordinates: '-0.44999998807907104, 49.173301696777344',
    municipality: 'Caen/Carpiquet'
  }
}, {
  label: 'Laguindingan Airport (CGY) - PH',
  id: 'CGY',
  obj: {
    iata: 'CGY',
    iso: 'PH',
    coordinates: '124.456496, 8.612203',
    municipality: 'Cagayan de Oro City'
  }
}, {
  label: 'Cagliari Elmas Airport (CAG) - IT',
  id: 'CAG',
  obj: {
    iata: 'CAG',
    iso: 'IT',
    coordinates: '9.05428, 39.251499',
    municipality: 'Cagliari'
  }
}, {
  label: 'Cahors-Lalbenque Airport (ZAO) - FR',
  id: 'ZAO',
  obj: {
    iata: 'ZAO',
    iso: 'FR',
    coordinates: '1.4752800464630127, 44.35139846801758',
    municipality: 'Cahors/Lalbenque'
  }
}, {
  label: 'Cairns International Airport (CNS) - AU',
  id: 'CNS',
  obj: {
    iata: 'CNS',
    iso: 'AU',
    coordinates: '145.755004883, -16.885799408',
    municipality: 'Cairns'
  }
}, {
  label: 'Cairo International Airport (CAI) - EG',
  id: 'CAI',
  obj: {
    iata: 'CAI',
    iso: 'EG',
    coordinates: '31.40559959411621, 30.12190055847168',
    municipality: 'Cairo'
  }
}, {
  label: 'Mayor General FAP Armando Revoredo Iglesias Airport (CJA) - PE',
  id: 'CJA',
  obj: {
    iata: 'CJA',
    iso: 'PE',
    coordinates: '-78.4894027709961, -7.1391801834106445',
    municipality: 'Cajamarca'
  }
}, {
  label: 'Margaret Ekpo International Airport (CBQ) - NG',
  id: 'CBQ',
  obj: {
    iata: 'CBQ',
    iso: 'NG',
    coordinates: '8.347200393676758, 4.976019859313965',
    municipality: 'Calabar'
  }
}, {
  label: 'Calais-Dunkerque Airport (CQF) - FR',
  id: 'CQF',
  obj: {
    iata: 'CQF',
    iso: 'FR',
    coordinates: '1.954759955406189, 50.962100982666016',
    municipality: 'Calais/Dunkerque'
  }
}, {
  label: 'El Loa Airport (CJC) - CL',
  id: 'CJC',
  obj: {
    iata: 'CJC',
    iso: 'CL',
    coordinates: '-68.90360260009766, -22.498199462890625',
    municipality: 'Calama'
  }
}, {
  label: 'Calbayog Airport (CYP) - PH',
  id: 'CYP',
  obj: {
    iata: 'CYP',
    iso: 'PH',
    coordinates: '124.54499816894531, 12.072699546813965',
    municipality: 'Calbayog City'
  }
}, {
  label: 'Calgary International Airport (YYC) - CA',
  id: 'YYC',
  obj: {
    iata: 'YYC',
    iso: 'CA',
    coordinates: '-114.019996643, 51.113899231',
    municipality: 'Calgary'
  }
}, {
  label: 'Alfonso Bonilla Aragon International Airport (CLO) - CO',
  id: 'CLO',
  obj: {
    iata: 'CLO',
    iso: 'CO',
    coordinates: '-76.3816, 3.54322',
    municipality: 'Cali'
  }
}, {
  label: 'Calicut International Airport (CCJ) - IN',
  id: 'CCJ',
  obj: {
    iata: 'CCJ',
    iso: 'IN',
    coordinates: '75.95529937740001, 11.1367998123',
    municipality: 'Calicut'
  }
}, {
  label: 'Modi (XXZ) - US',
  id: 'XXZ',
  obj: {
    iata: 'XXZ',
    iso: 'US',
    coordinates: '179.999894, 89.999845',
    municipality: 'California'
  }
}, {
  label: 'Calvi-Sainte-Catherine Airport (CLY) - FR',
  id: 'CLY',
  obj: {
    iata: 'CLY',
    iso: 'FR',
    coordinates: '8.7930556, 42.5244444',
    municipality: 'Calvi/Sainte-Catherine'
  }
}, {
  label: 'Ignacio Agramonte International Airport (CMW) - CU',
  id: 'CMW',
  obj: {
    iata: 'CMW',
    iso: 'CU',
    coordinates: '-77.84750366210938, 21.420299530029297',
    municipality: 'Camaguey'
  }
}, {
  label: 'Cambridge Airport (CBG) - GB',
  id: 'CBG',
  obj: {
    iata: 'CBG',
    iso: 'GB',
    coordinates: '0.175, 52.205002',
    municipality: 'Cambridge'
  }
}, {
  label: 'Cambridge Bay Airport (YCB) - CA',
  id: 'YCB',
  obj: {
    iata: 'YCB',
    iso: 'CA',
    coordinates: '-105.138000488, 69.1081008911',
    municipality: 'Cambridge Bay'
  }
}, {
  label: 'Volk Field (VOK) - US',
  id: 'VOK',
  obj: {
    iata: 'VOK',
    iso: 'US',
    coordinates: '-90.253402709961, 43.938999176025',
    municipality: 'Camp Douglas'
  }
}, {
  label: 'Bradshaw Army Airfield (BSF) - US',
  id: 'BSF',
  obj: {
    iata: 'BSF',
    iso: 'US',
    coordinates: '-155.554000854, 19.760099411',
    municipality: 'Camp Pohakuloa'
  }
}, {
  label: 'Joint Base Andrews (ADW) - US',
  id: 'ADW',
  obj: {
    iata: 'ADW',
    iso: 'US',
    coordinates: '-76.866997, 38.810799',
    municipality: 'Camp Springs'
  }
}, {
  label: 'Campbell River Airport (YBL) - CA',
  id: 'YBL',
  obj: {
    iata: 'YBL',
    iso: 'CA',
    coordinates: '-125.271004, 49.950802',
    municipality: 'Campbell River'
  }
}, {
  label: 'Campbeltown Airport (CAL) - GB',
  id: 'CAL',
  obj: {
    iata: 'CAL',
    iso: 'GB',
    coordinates: '-5.686389923095703, 55.437198638916016',
    municipality: 'Campbeltown'
  }
}, {
  label: 'Ingeniero Alberto Acu\u00c3\u00b1a Ongay International Airport (CPE) - MX',
  id: 'CPE',
  obj: {
    iata: 'CPE',
    iso: 'MX',
    coordinates: '-90.5002975464, 19.816799163800003',
    municipality: 'Campeche'
  }
}, {
  label: 'Presidente Jo\u00c3\u00a3o Suassuna Airport (CPV) - BR',
  id: 'CPV',
  obj: {
    iata: 'CPV',
    iso: 'BR',
    coordinates: '-35.8964, -7.26992',
    municipality: 'Campina Grande'
  }
}, {
  label: 'Viracopos International Airport (VCP) - BR',
  id: 'VCP',
  obj: {
    iata: 'VCP',
    iso: 'BR',
    coordinates: '-47.1344985962, -23.0074005127',
    municipality: 'Campinas'
  }
}, {
  label: 'Campo Grande Airport (CGR) - BR',
  id: 'CGR',
  obj: {
    iata: 'CGR',
    iso: 'BR',
    coordinates: '-54.6725006104, -20.468700408900002',
    municipality: 'Campo Grande'
  }
}, {
  label: 'Bartolomeu Lisandro Airport (CAW) - BR',
  id: 'CAW',
  obj: {
    iata: 'CAW',
    iso: 'BR',
    coordinates: '-41.301700592, -21.698299408',
    municipality: 'Campos Dos Goytacazes'
  }
}, {
  label: 'Can Tho International Airport (VCA) - VN',
  id: 'VCA',
  obj: {
    iata: 'VCA',
    iso: 'VN',
    coordinates: '105.711997986, 10.085100174',
    municipality: 'Can Tho'
  }
}, {
  label: 'Canaima Airport (CAJ) - VE',
  id: 'CAJ',
  obj: {
    iata: 'CAJ',
    iso: 'VE',
    coordinates: '-62.85443115234375, 6.231988906860352',
    municipality: 'Canaima'
  }
}, {
  label: 'Canberra International Airport (CBR) - AU',
  id: 'CBR',
  obj: {
    iata: 'CBR',
    iso: 'AU',
    coordinates: '149.19500732421875, -35.30690002441406',
    municipality: 'Canberra'
  }
}, {
  label: 'Canc\u00c3\u00ban International Airport (CUN) - MX',
  id: 'CUN',
  obj: {
    iata: 'CUN',
    iso: 'MX',
    coordinates: '-86.8770980835, 21.036500930800003',
    municipality: 'Canc\u00c3\u00ban'
  }
}, {
  label: 'Canefield Airport (DCF) - DM',
  id: 'DCF',
  obj: {
    iata: 'DCF',
    iso: 'DM',
    coordinates: '-61.3922004699707, 15.336700439453125',
    municipality: 'Canefield'
  }
}, {
  label: 'Cannes-Mandelieu Airport (CEQ) - FR',
  id: 'CEQ',
  obj: {
    iata: 'CEQ',
    iso: 'FR',
    coordinates: '6.95348, 43.542',
    municipality: 'Cannes/Mandelieu'
  }
}, {
  label: 'Canouan Airport (CIW) - VC',
  id: 'CIW',
  obj: {
    iata: 'CIW',
    iso: 'VC',
    coordinates: '-61.3424, 12.699',
    municipality: 'Canouan'
  }
}, {
  label: 'Cap Haitien International Airport (CAP) - HT',
  id: 'CAP',
  obj: {
    iata: 'CAP',
    iso: 'HT',
    coordinates: '-72.194702, 19.733',
    municipality: 'Cap Haitien'
  }
}, {
  label: 'Cap Skirring Airport (CSK) - SN',
  id: 'CSK',
  obj: {
    iata: 'CSK',
    iso: 'SN',
    coordinates: '-16.748, 12.39533',
    municipality: 'Cap Skirring'
  }
}, {
  label: 'Cape Dorset Airport (YTE) - CA',
  id: 'YTE',
  obj: {
    iata: 'YTE',
    iso: 'CA',
    coordinates: '-76.5267028809, 64.2300033569',
    municipality: 'Cape Dorset'
  }
}, {
  label: 'Cape Girardeau Regional Airport (CGI) - US',
  id: 'CGI',
  obj: {
    iata: 'CGI',
    iso: 'US',
    coordinates: '-89.57080078125, 37.22529983520508',
    municipality: 'Cape Girardeau'
  }
}, {
  label: 'Cape Lisburne LRRS Airport (LUR) - US',
  id: 'LUR',
  obj: {
    iata: 'LUR',
    iso: 'US',
    coordinates: '-166.1100006, 68.87509918',
    municipality: 'Cape Lisburne'
  }
}, {
  label: 'Cape Newenham LRRS Airport (EHM) - US',
  id: 'EHM',
  obj: {
    iata: 'EHM',
    iso: 'US',
    coordinates: '-162.06300354, 58.646400451699996',
    municipality: 'Cape Newenham'
  }
}, {
  label: 'Cape Romanzof LRRS Airport (CZF) - US',
  id: 'CZF',
  obj: {
    iata: 'CZF',
    iso: 'US',
    coordinates: '-166.0390015, 61.78030014',
    municipality: 'Cape Romanzof'
  }
}, {
  label: 'Cape Town International Airport (CPT) - ZA',
  id: 'CPT',
  obj: {
    iata: 'CPT',
    iso: 'ZA',
    coordinates: '18.6016998291, -33.9648017883',
    municipality: 'Cape Town'
  }
}, {
  label: 'Sim\u00c3\u00b3n Bol\u00c3\u00advar International Airport (CCS) - VE',
  id: 'CCS',
  obj: {
    iata: 'CCS',
    iso: 'VE',
    coordinates: '-66.991222, 10.601194',
    municipality: 'Caracas'
  }
}, {
  label: 'Caransebe\u00c5\u009f Airport (CSB) - RO',
  id: 'CSB',
  obj: {
    iata: 'CSB',
    iso: 'RO',
    coordinates: '22.253299713134766, 45.41999816894531',
    municipality: 'Caransebe\u00c5\u009f'
  }
}, {
  label: 'Caravelas Airport (CRQ) - BR',
  id: 'CRQ',
  obj: {
    iata: 'CRQ',
    iso: 'BR',
    coordinates: '-39.253101, -17.6523',
    municipality: 'Caravelas'
  }
}, {
  label: 'Southern Illinois Airport (MDH) - US',
  id: 'MDH',
  obj: {
    iata: 'MDH',
    iso: 'US',
    coordinates: '-89.25199890136719, 37.778099060058594',
    municipality: 'Carbondale/Murphysboro'
  }
}, {
  label: 'Carcassonne Airport (CCF) - FR',
  id: 'CCF',
  obj: {
    iata: 'CCF',
    iso: 'FR',
    coordinates: '2.3063199520111084, 43.215999603271484',
    municipality: 'Carcassonne/Salvaza'
  }
}, {
  label: 'Cardiff International Airport (CWL) - GB',
  id: 'CWL',
  obj: {
    iata: 'CWL',
    iso: 'GB',
    coordinates: '-3.343329906463623, 51.39670181274414',
    municipality: 'Cardiff'
  }
}, {
  label: 'Antonio Roldan Betancourt Airport (APO) - CO',
  id: 'APO',
  obj: {
    iata: 'APO',
    iso: 'CO',
    coordinates: '-76.7164, 7.81196',
    municipality: 'Carepa'
  }
}, {
  label: 'Caribou Municipal Airport (CAR) - US',
  id: 'CAR',
  obj: {
    iata: 'CAR',
    iso: 'US',
    coordinates: '-68.0178985596, 46.871498107899995',
    municipality: 'Caribou'
  }
}, {
  label: 'Carlisle Airport (CAX) - GB',
  id: 'CAX',
  obj: {
    iata: 'CAX',
    iso: 'GB',
    coordinates: '-2.8091700077056885, 54.9375',
    municipality: 'Carlisle'
  }
}, {
  label: 'Cavern City Air Terminal (CNM) - US',
  id: 'CNM',
  obj: {
    iata: 'CNM',
    iso: 'US',
    coordinates: '-104.26300048828125, 32.337501525878906',
    municipality: 'Carlsbad'
  }
}, {
  label: 'Mc Clellan-Palomar Airport (CLD) - US',
  id: 'CLD',
  obj: {
    iata: 'CLD',
    iso: 'US',
    coordinates: '-117.2799988, 33.12829971',
    municipality: 'Carlsbad'
  }
}, {
  label: 'Carnarvon Airport (CVQ) - AU',
  id: 'CVQ',
  obj: {
    iata: 'CVQ',
    iso: 'AU',
    coordinates: '113.67174, -24.880211',
    municipality: 'Carnarvon'
  }
}, {
  label: 'Brig. Lysias Augusto Rodrigues Airport (CLN) - BR',
  id: 'CLN',
  obj: {
    iata: 'CLN',
    iso: 'BR',
    coordinates: '-47.45869827270508, -7.32043981552124',
    municipality: 'Carolina'
  }
}, {
  label: 'Carora Airport (VCR) - VE',
  id: 'VCR',
  obj: {
    iata: 'VCR',
    iso: 'VE',
    coordinates: '-70.06521606445312, 10.175602912902832',
    municipality: 'Carora'
  }
}, {
  label: 'Rafael Nu\u00c3\u00b1ez International Airport (CTG) - CO',
  id: 'CTG',
  obj: {
    iata: 'CTG',
    iso: 'CO',
    coordinates: '-75.513, 10.4424',
    municipality: 'Cartagena'
  }
}, {
  label: 'Santa Ana Airport (CRC) - CO',
  id: 'CRC',
  obj: {
    iata: 'CRC',
    iso: 'CO',
    coordinates: '-75.9557, 4.75818',
    municipality: 'Cartago'
  }
}, {
  label: 'Cartwright Airport (YRF) - CA',
  id: 'YRF',
  obj: {
    iata: 'YRF',
    iso: 'CA',
    coordinates: '-57.041900634765625, 53.68280029296875',
    municipality: 'Cartwright'
  }
}, {
  label: 'General Francisco Berm\u00c3\u00badez Airport (CUP) - VE',
  id: 'CUP',
  obj: {
    iata: 'CUP',
    iso: 'VE',
    coordinates: '-63.261680603027344, 10.660014152526855',
    municipality: 'Car\u00c3\u00bapano'
  }
}, {
  label: 'Mohammed V International Airport (CMN) - MA',
  id: 'CMN',
  obj: {
    iata: 'CMN',
    iso: 'MA',
    coordinates: '-7.589970111846924, 33.36750030517578',
    municipality: 'Casablanca'
  }
}, {
  label: 'Cascais Airport (CAT) - PT',
  id: 'CAT',
  obj: {
    iata: 'CAT',
    iso: 'PT',
    coordinates: '-9.35523, 38.724998',
    municipality: 'Cascais'
  }
}, {
  label: 'Cascavel Airport (CAC) - BR',
  id: 'CAC',
  obj: {
    iata: 'CAC',
    iso: 'BR',
    coordinates: '-53.500801086399996, -25.0002994537',
    municipality: 'Cascavel'
  }
}, {
  label: 'Casper-Natrona County International Airport (CPR) - US',
  id: 'CPR',
  obj: {
    iata: 'CPR',
    iso: 'US',
    coordinates: '-106.463997, 42.908001',
    municipality: 'Casper'
  }
}, {
  label: 'Castell\u00c3\u00b3n-Costa Azahar Airport (CDT) - ES',
  id: 'CDT',
  obj: {
    iata: 'CDT',
    iso: 'ES',
    coordinates: '0.073333, 40.213889',
    municipality: 'Castell\u00c3\u00b3n de la Plana'
  }
}, {
  label: 'Castlegar/West Kootenay Regional Airport (YCG) - CA',
  id: 'YCG',
  obj: {
    iata: 'YCG',
    iso: 'CA',
    coordinates: '-117.632003784, 49.2963981628',
    municipality: 'Castlegar'
  }
}, {
  label: 'Isle of Man Airport (IOM) - IM',
  id: 'IOM',
  obj: {
    iata: 'IOM',
    iso: 'IM',
    coordinates: '-4.623889923095703, 54.08330154418945',
    municipality: 'Castletown'
  }
}, {
  label: 'Castres-Mazamet Airport (DCM) - FR',
  id: 'DCM',
  obj: {
    iata: 'DCM',
    iso: 'FR',
    coordinates: '2.289180040359497, 43.55630111694336',
    municipality: 'Castres/Mazamet'
  }
}, {
  label: 'George F. L. Charles Airport (SLU) - LC',
  id: 'SLU',
  obj: {
    iata: 'SLU',
    iso: 'LC',
    coordinates: '-60.992901, 14.0202',
    municipality: 'Castries'
  }
}, {
  label: 'New Bight Airport (TBI) - BS',
  id: 'TBI',
  obj: {
    iata: 'TBI',
    iso: 'BS',
    coordinates: '-75.452301, 24.3153',
    municipality: 'Cat Island'
  }
}, {
  label: 'Cat Lake Airport (YAC) - CA',
  id: 'YAC',
  obj: {
    iata: 'YAC',
    iso: 'CA',
    coordinates: '-91.82440185546875, 51.72719955444336',
    municipality: 'Cat Lake'
  }
}, {
  label: 'Catamarca Airport (CTC) - AR',
  id: 'CTC',
  obj: {
    iata: 'CTC',
    iso: 'AR',
    coordinates: '-65.751701355, -28.5956001282',
    municipality: 'Catamarca'
  }
}, {
  label: 'Catania-Fontanarossa Airport (CTA) - IT',
  id: 'CTA',
  obj: {
    iata: 'CTA',
    iso: 'IT',
    coordinates: '15.0664, 37.466801',
    municipality: 'Catania'
  }
}, {
  label: 'Catarman National Airport (CRM) - PH',
  id: 'CRM',
  obj: {
    iata: 'CRM',
    iso: 'PH',
    coordinates: '124.63600158691406, 12.502400398254395',
    municipality: 'Catarman'
  }
}, {
  label: 'Catumbela Airport (CBT) - AO',
  id: 'CBT',
  obj: {
    iata: 'CBT',
    iso: 'AO',
    coordinates: '13.4869, -12.4792',
    municipality: 'Catumbela'
  }
}, {
  label: 'Cauayan Airport (CYZ) - PH',
  id: 'CYZ',
  obj: {
    iata: 'CYZ',
    iso: 'PH',
    coordinates: '121.752998352, 16.9298992157',
    municipality: 'Cauayan City'
  }
}, {
  label: 'Juan H White Airport (CAQ) - CO',
  id: 'CAQ',
  obj: {
    iata: 'CAQ',
    iso: 'CO',
    coordinates: '-75.1985, 7.96847',
    municipality: 'Caucasia'
  }
}, {
  label: 'Hugo Cantergiani Regional Airport (CXJ) - BR',
  id: 'CXJ',
  obj: {
    iata: 'CXJ',
    iso: 'BR',
    coordinates: '-51.1875, -29.197099685699996',
    municipality: 'Caxias Do Sul'
  }
}, {
  label: 'Caye Caulker Airport (CUK) - BZ',
  id: 'CUK',
  obj: {
    iata: 'CUK',
    iso: 'BZ',
    coordinates: '-88.03250122070312, 17.734699249267578',
    municipality: 'Caye Caulker'
  }
}, {
  label: 'Caye Chapel Airport (CYC) - BZ',
  id: 'CYC',
  obj: {
    iata: 'CYC',
    iso: 'BZ',
    coordinates: '-88.04109954833984, 17.7007999420166',
    municipality: 'Caye Chapel'
  }
}, {
  label: 'Cayenne-Rochambeau Airport (CAY) - GF',
  id: 'CAY',
  obj: {
    iata: 'CAY',
    iso: 'GF',
    coordinates: '-52.360401153599994, 4.819809913639999',
    municipality: 'Cayenne / Rochambeau'
  }
}, {
  label: 'Gerrard Smith International Airport (CYB) - KY',
  id: 'CYB',
  obj: {
    iata: 'CYB',
    iso: 'KY',
    coordinates: '-79.88279724121094, 19.687000274658203',
    municipality: 'Cayman Brac'
  }
}, {
  label: 'Jardines Del Rey Airport (CCC) - CU',
  id: 'CCC',
  obj: {
    iata: 'CCC',
    iso: 'CU',
    coordinates: '-78.32839965820001, 22.461000442499998',
    municipality: 'Cayo Coco'
  }
}, {
  label: 'Vilo Acu\u00c3\u00b1a International Airport (CYO) - CU',
  id: 'CYO',
  obj: {
    iata: 'CYO',
    iso: 'CU',
    coordinates: '-81.5459976196, 21.6165008545',
    municipality: 'Cayo Largo del Sur'
  }
}, {
  label: 'Cedar City Regional Airport (CDC) - US',
  id: 'CDC',
  obj: {
    iata: 'CDC',
    iso: 'US',
    coordinates: '-113.0989990234375, 37.70100021362305',
    municipality: 'Cedar City'
  }
}, {
  label: 'The Eastern Iowa Airport (CID) - US',
  id: 'CID',
  obj: {
    iata: 'CID',
    iso: 'US',
    coordinates: '-91.71080017089844, 41.884700775146484',
    municipality: 'Cedar Rapids'
  }
}, {
  label: 'Captain Rogelio Castillo National Airport (CYW) - MX',
  id: 'CYW',
  obj: {
    iata: 'CYW',
    iso: 'MX',
    coordinates: '-100.887001, 20.546',
    municipality: 'Celaya'
  }
}, {
  label: 'Centralia / James T. Field Memorial Aerodrome (YCE) - CA',
  id: 'YCE',
  obj: {
    iata: 'YCE',
    iso: 'CA',
    coordinates: '-81.508301, 43.285599',
    municipality: 'Centralia'
  }
}, {
  label: 'Konarak Airport (ZBR) - IR',
  id: 'ZBR',
  obj: {
    iata: 'ZBR',
    iso: 'IR',
    coordinates: '60.3820991516, 25.443300247199996',
    municipality: 'Chabahar'
  }
}, {
  label: 'Chachapoyas Airport (CHH) - PE',
  id: 'CHH',
  obj: {
    iata: 'CHH',
    iso: 'PE',
    coordinates: '-77.8561019897461, -6.201809883117676',
    municipality: 'Chachapoyas'
  }
}, {
  label: 'Chadron Municipal Airport (CDR) - US',
  id: 'CDR',
  obj: {
    iata: 'CDR',
    iso: 'US',
    coordinates: '-103.095001221, 42.837600708',
    municipality: 'Chadron'
  }
}, {
  label: 'Chait\u00c3\u00a9n Airport (WCH) - CL',
  id: 'WCH',
  obj: {
    iata: 'WCH',
    iso: 'CL',
    coordinates: '-72.6990966796875, -42.93280029296875',
    municipality: 'Chaiten'
  }
}, {
  label: 'Pemba Airport (PMA) - TZ',
  id: 'PMA',
  obj: {
    iata: 'PMA',
    iso: 'TZ',
    coordinates: '39.8114013671875, -5.257259845733643',
    municipality: 'Chake'
  }
}, {
  label: 'Chamb\u00c3\u00a9ry-Savoie Airport (CMF) - FR',
  id: 'CMF',
  obj: {
    iata: 'CMF',
    iso: 'FR',
    coordinates: '5.880229949951172, 45.638099670410156',
    municipality: 'Chamb\u00c3\u00a9ry/Aix-les-Bains'
  }
}, {
  label: 'University of Illinois Willard Airport (CMI) - US',
  id: 'CMI',
  obj: {
    iata: 'CMI',
    iso: 'US',
    coordinates: '-88.27809906, 40.03919983',
    municipality: 'Champaign/Urbana'
  }
}, {
  label: 'Chandigarh Airport (IXC) - IN',
  id: 'IXC',
  obj: {
    iata: 'IXC',
    iso: 'IN',
    coordinates: '76.78849792480469, 30.673500061035156',
    municipality: 'Chandigarh'
  }
}, {
  label: 'Changde Airport (CGD) - CN',
  id: 'CGD',
  obj: {
    iata: 'CGD',
    iso: 'CN',
    coordinates: '111.63999939, 28.9188995361',
    municipality: 'Changde'
  }
}, {
  label: 'Changsha Huanghua International Airport (CSX) - CN',
  id: 'CSX',
  obj: {
    iata: 'CSX',
    iso: 'CN',
    coordinates: '113.220001221, 28.189199447599997',
    municipality: 'Changsha'
  }
}, {
  label: 'Cap Manuel Ni\u00c3\u00b1o International Airport (CHX) - PA',
  id: 'CHX',
  obj: {
    iata: 'CHX',
    iso: 'PA',
    coordinates: '-82.515062, 9.458962',
    municipality: 'Changuinola'
  }
}, {
  label: 'Chanute Martin Johnson Airport (CNU) - US',
  id: 'CNU',
  obj: {
    iata: 'CNU',
    iso: 'US',
    coordinates: '-95.4850997925, 37.668800354',
    municipality: 'Chanute'
  }
}, {
  label: 'Serafin Enoss Bertaso Airport (XAP) - BR',
  id: 'XAP',
  obj: {
    iata: 'XAP',
    iso: 'BR',
    coordinates: '-52.656600952148, -27.134199142456',
    municipality: 'Chapec\u00c3\u00b3'
  }
}, {
  label: 'Aviador C. Campos Airport (CPC) - AR',
  id: 'CPC',
  obj: {
    iata: 'CPC',
    iso: 'AR',
    coordinates: '-71.137299, -40.075401',
    municipality: 'Chapelco/San Martin de los Andes'
  }
}, {
  label: 'Chapleau Airport (YLD) - CA',
  id: 'YLD',
  obj: {
    iata: 'YLD',
    iso: 'CA',
    coordinates: '-83.3467025756836, 47.81999969482422',
    municipality: 'Chapleau'
  }
}, {
  label: 'Northeast Iowa Regional Airport (CCY) - US',
  id: 'CCY',
  obj: {
    iata: 'CCY',
    iso: 'US',
    coordinates: '-92.6108016968, 43.0726013184',
    municipality: 'Charles City'
  }
}, {
  label: 'Ireland West Knock Airport (NOC) - IE',
  id: 'NOC',
  obj: {
    iata: 'NOC',
    iso: 'IE',
    coordinates: '-8.818490028381348, 53.910301208496094',
    municipality: 'Charleston'
  }
}, {
  label: 'Charleston Air Force Base-International Airport (CHS) - US',
  id: 'CHS',
  obj: {
    iata: 'CHS',
    iso: 'US',
    coordinates: '-80.04049683, 32.89860153',
    municipality: 'Charleston'
  }
}, {
  label: 'Yeager Airport (CRW) - US',
  id: 'CRW',
  obj: {
    iata: 'CRW',
    iso: 'US',
    coordinates: '-81.59320068359375, 38.37310028076172',
    municipality: 'Charleston'
  }
}, {
  label: 'Vance W. Amory International Airport (NEV) - KN',
  id: 'NEV',
  obj: {
    iata: 'NEV',
    iso: 'KN',
    coordinates: '-62.589900970458984, 17.205699920654297',
    municipality: 'Charlestown'
  }
}, {
  label: 'Charleville Airport (CTL) - AU',
  id: 'CTL',
  obj: {
    iata: 'CTL',
    iso: 'AU',
    coordinates: '146.261993408, -26.4132995605',
    municipality: 'Charleville'
  }
}, {
  label: 'Charleville-M\u00c3\u00a9zi\u00c3\u00a8res Airport (XCZ) - FR',
  id: 'XCZ',
  obj: {
    iata: 'XCZ',
    iso: 'FR',
    coordinates: '4.647079944610596, 49.78390121459961',
    municipality: 'Charleville-M\u00c3\u00a9zi\u00c3\u00a8res'
  }
}, {
  label: 'Charlevoix Airport (YML) - CA',
  id: 'YML',
  obj: {
    iata: 'YML',
    iso: 'CA',
    coordinates: '-70.2238998413086, 47.59749984741211',
    municipality: 'Charlevoix'
  }
}, {
  label: 'Charlo Airport (YCL) - CA',
  id: 'YCL',
  obj: {
    iata: 'YCL',
    iso: 'CA',
    coordinates: '-66.330299, 47.990799',
    municipality: 'Charlo'
  }
}, {
  label: 'Charlotte Douglas International Airport (CLT) - US',
  id: 'CLT',
  obj: {
    iata: 'CLT',
    iso: 'US',
    coordinates: '-80.94309997558594, 35.2140007019043',
    municipality: 'Charlotte'
  }
}, {
  label: 'Cyril E. King Airport (STT) - VI',
  id: 'STT',
  obj: {
    iata: 'STT',
    iso: 'VI',
    coordinates: '-64.97339630126953, 18.337299346923828',
    municipality: 'Charlotte Amalie, Harry S. Truman Airport'
  }
}, {
  label: 'Charlottesville Albemarle Airport (CHO) - US',
  id: 'CHO',
  obj: {
    iata: 'CHO',
    iso: 'US',
    coordinates: '-78.4529037475586, 38.13859939575195',
    municipality: 'Charlottesville'
  }
}, {
  label: 'Charlottetown Airport (YYG) - CA',
  id: 'YYG',
  obj: {
    iata: 'YYG',
    iso: 'CA',
    coordinates: '-63.12110137939453, 46.290000915527344',
    municipality: 'Charlottetown'
  }
}, {
  label: 'Lovell Field (CHA) - US',
  id: 'CHA',
  obj: {
    iata: 'CHA',
    iso: 'US',
    coordinates: '-85.20379638671875, 35.035301208496094',
    municipality: 'Chattanooga'
  }
}, {
  label: 'Cha\u00c3\u00b1aral Airport (CNR) - CL',
  id: 'CNR',
  obj: {
    iata: 'CNR',
    iso: 'CL',
    coordinates: '-70.6072998046875, -26.332500457763672',
    municipality: 'Cha\u00c3\u00b1aral'
  }
}, {
  label: 'Cheboksary Airport (CSY) - RU',
  id: 'CSY',
  obj: {
    iata: 'CSY',
    iso: 'RU',
    coordinates: '47.3473014831543, 56.090301513671875',
    municipality: 'Cheboksary'
  }
}, {
  label: 'Chelyabinsk Balandino Airport (CEK) - RU',
  id: 'CEK',
  obj: {
    iata: 'CEK',
    iso: 'RU',
    coordinates: '61.5033, 55.305801',
    municipality: 'Chelyabinsk'
  }
}, {
  label: 'Chengde Puning Airport (CDE) - CN',
  id: 'CDE',
  obj: {
    iata: 'CDE',
    iso: 'CN',
    coordinates: '118.073889, 41.1225',
    municipality: 'Chengde'
  }
}, {
  label: 'Chennai International Airport (MAA) - IN',
  id: 'MAA',
  obj: {
    iata: 'MAA',
    iso: 'IN',
    coordinates: '80.16929626464844, 12.990005493164062',
    municipality: 'Chennai'
  }
}, {
  label: 'Cheongju International Airport/Cheongju Air Base (K-59/G-513) (CJJ) - KR',
  id: 'CJJ',
  obj: {
    iata: 'CJJ',
    iso: 'KR',
    coordinates: '127.498741, 36.717008',
    municipality: 'Cheongju'
  }
}, {
  label: 'Cherbourg-Maupertus Airport (CER) - FR',
  id: 'CER',
  obj: {
    iata: 'CER',
    iso: 'FR',
    coordinates: '-1.4702800512313843, 49.65010070800781',
    municipality: 'Cherbourg/Maupertus'
  }
}, {
  label: 'Cherepovets Airport (CEE) - RU',
  id: 'CEE',
  obj: {
    iata: 'CEE',
    iso: 'RU',
    coordinates: '38.015800476100004, 59.273601532',
    municipality: 'Cherepovets'
  }
}, {
  label: 'Cherkasy International Airport (CKC) - UA',
  id: 'CKC',
  obj: {
    iata: 'CKC',
    iso: 'UA',
    coordinates: '31.99530029296875, 49.41559982299805',
    municipality: 'Cherkasy'
  }
}, {
  label: 'Chernivtsi International Airport (CWC) - UA',
  id: 'CWC',
  obj: {
    iata: 'CWC',
    iso: 'UA',
    coordinates: '25.98080062866211, 48.259300231933594',
    municipality: 'Chernivtsi'
  }
}, {
  label: 'Cherskiy Airport (CYX) - RU',
  id: 'CYX',
  obj: {
    iata: 'CYX',
    iso: 'RU',
    coordinates: '161.33799743652344, 68.7406005859375',
    municipality: 'Cherskiy'
  }
}, {
  label: 'Chesterfield Inlet Airport (YCS) - CA',
  id: 'YCS',
  obj: {
    iata: 'YCS',
    iso: 'CA',
    coordinates: '-90.73110198970001, 63.346900939899996',
    municipality: 'Chesterfield Inlet'
  }
}, {
  label: 'Chetumal International Airport (CTM) - MX',
  id: 'CTM',
  obj: {
    iata: 'CTM',
    iso: 'MX',
    coordinates: '-88.32679748535156, 18.50469970703125',
    municipality: 'Chetumal'
  }
}, {
  label: 'Chetwynd Airport (YCQ) - CA',
  id: 'YCQ',
  obj: {
    iata: 'YCQ',
    iso: 'CA',
    coordinates: '-121.62699890136719, 55.687198638916016',
    municipality: 'Chetwynd'
  }
}, {
  label: 'Chevery Airport (YHR) - CA',
  id: 'YHR',
  obj: {
    iata: 'YHR',
    iso: 'CA',
    coordinates: '-59.63669967651367, 50.46889877319336',
    municipality: 'Chevery'
  }
}, {
  label: 'Cheyenne Regional Jerry Olson Field (CYS) - US',
  id: 'CYS',
  obj: {
    iata: 'CYS',
    iso: 'US',
    coordinates: '-104.8119965, 41.15570068',
    municipality: 'Cheyenne'
  }
}, {
  label: 'Chiang Mai International Airport (CNX) - TH',
  id: 'CNX',
  obj: {
    iata: 'CNX',
    iso: 'TH',
    coordinates: '98.962600708, 18.766799926799997',
    municipality: 'Chiang Mai'
  }
}, {
  label: 'Chiang Rai International Airport (CEI) - TH',
  id: 'CEI',
  obj: {
    iata: 'CEI',
    iso: 'TH',
    coordinates: '99.88289642330001, 19.952299118',
    municipality: 'Chiang Rai'
  }
}, {
  label: 'Chiayi Airport (CYI) - TW',
  id: 'CYI',
  obj: {
    iata: 'CYI',
    iso: 'TW',
    coordinates: '120.39299774169922, 23.46179962158203',
    municipality: 'Chiayi City'
  }
}, {
  label: 'Chapais Airport (YMT) - CA',
  id: 'YMT',
  obj: {
    iata: 'YMT',
    iso: 'CA',
    coordinates: '-74.5280990600586, 49.77190017700195',
    municipality: 'Chibougamau'
  }
}, {
  label: 'Chicago Midway International Airport (MDW) - US',
  id: 'MDW',
  obj: {
    iata: 'MDW',
    iso: 'US',
    coordinates: '-87.752403, 41.785999',
    municipality: 'Chicago'
  }
}, {
  label: "Chicago O'Hare International Airport (ORD) - US",
  id: 'ORD',
  obj: {
    iata: 'ORD',
    iso: 'US',
    coordinates: '-87.9048, 41.9786',
    municipality: 'Chicago'
  }
}, {
  label: 'Chicago Executive Airport (PWK) - US',
  id: 'PWK',
  obj: {
    iata: 'PWK',
    iso: 'US',
    coordinates: '-87.901494, 42.114222',
    municipality: 'Chicago/Prospect Heights/Wheeling'
  }
}, {
  label: 'Chicago Rockford International Airport (RFD) - US',
  id: 'RFD',
  obj: {
    iata: 'RFD',
    iso: 'US',
    coordinates: '-89.09719848632812, 42.19540023803711',
    municipality: 'Chicago/Rockford'
  }
}, {
  label: 'Dupage Airport (DPA) - US',
  id: 'DPA',
  obj: {
    iata: 'DPA',
    iso: 'US',
    coordinates: '-88.24859619, 41.90779877',
    municipality: 'Chicago/West Chicago'
  }
}, {
  label: 'Chichen Itza International Airport (CZA) - MX',
  id: 'CZA',
  obj: {
    iata: 'CZA',
    iso: 'MX',
    coordinates: '-88.4461975098, 20.6413002014',
    municipality: 'Chichen Itza'
  }
}, {
  label: 'Capitan FAP Jose A Quinones Gonzales International Airport (CIX) - PE',
  id: 'CIX',
  obj: {
    iata: 'CIX',
    iso: 'PE',
    coordinates: '-79.8281021118164, -6.787479877471924',
    municipality: 'Chiclayo'
  }
}, {
  label: 'Chifeng Airport (CIF) - CN',
  id: 'CIF',
  obj: {
    iata: 'CIF',
    iso: 'CN',
    coordinates: '118.90799713134766, 42.23500061035156',
    municipality: 'Chifeng'
  }
}, {
  label: 'General Roberto Fierro Villalobos International Airport (CUU) - MX',
  id: 'CUU',
  obj: {
    iata: 'CUU',
    iso: 'MX',
    coordinates: '-105.964996338, 28.702899932900003',
    municipality: 'Chihuahua'
  }
}, {
  label: 'Childress Municipal Airport (CDS) - US',
  id: 'CDS',
  obj: {
    iata: 'CDS',
    iso: 'US',
    coordinates: '-100.288002014, 34.4337997437',
    municipality: 'Childress'
  }
}, {
  label: 'Chile Chico Airport (CCH) - CL',
  id: 'CCH',
  obj: {
    iata: 'CCH',
    iso: 'CL',
    coordinates: '-71.6874008178711, -46.58330154418945',
    municipality: 'Chile Chico'
  }
}, {
  label: 'Gral. Bernardo O\u00c2\u00b4Higgins Airport (YAI) - CL',
  id: 'YAI',
  obj: {
    iata: 'YAI',
    iso: 'CL',
    coordinates: '-72.03140258789062, -36.58250045776367',
    municipality: 'Chillan'
  }
}, {
  label: 'Teniente FAP Jaime A De Montreuil Morales Airport (CHM) - PE',
  id: 'CHM',
  obj: {
    iata: 'CHM',
    iso: 'PE',
    coordinates: '-78.5238037109375, -9.149609565734863',
    municipality: 'Chimbote'
  }
}, {
  label: 'Chimoio Airport (VPY) - MZ',
  id: 'VPY',
  obj: {
    iata: 'VPY',
    iso: 'MZ',
    coordinates: '33.42900085449219, -19.15130043029785',
    municipality: 'Chimoio'
  }
}, {
  label: 'Kasompe Airport (CGJ) - ZM',
  id: 'CGJ',
  obj: {
    iata: 'CGJ',
    iso: 'ZM',
    coordinates: '27.893899917603, -12.572799682617',
    municipality: 'Chingola'
  }
}, {
  label: 'Chios Island National Airport (JKH) - GR',
  id: 'JKH',
  obj: {
    iata: 'JKH',
    iso: 'GR',
    coordinates: '26.140600204467773, 38.34320068359375',
    municipality: 'Chios Island'
  }
}, {
  label: 'Buffalo Range Airport (BFO) - ZW',
  id: 'BFO',
  obj: {
    iata: 'BFO',
    iso: 'ZW',
    coordinates: '31.5786, -21.008101',
    municipality: 'Chiredzi'
  }
}, {
  label: 'Chita-Kadala Airport (HTA) - RU',
  id: 'HTA',
  obj: {
    iata: 'HTA',
    iso: 'RU',
    coordinates: '113.306, 52.026299',
    municipality: 'Chita'
  }
}, {
  label: 'Dundo Airport (DUE) - AO',
  id: 'DUE',
  obj: {
    iata: 'DUE',
    iso: 'AO',
    coordinates: '20.818500518798828, -7.400889873504639',
    municipality: 'Chitato'
  }
}, {
  label: 'New Chitose Airport (CTS) - JP',
  id: 'CTS',
  obj: {
    iata: 'CTS',
    iso: 'JP',
    coordinates: '141.69200134277344, 42.77519989013672',
    municipality: 'Chitose / Tomakomai'
  }
}, {
  label: 'Chitral Airport (CJL) - PK',
  id: 'CJL',
  obj: {
    iata: 'CJL',
    iso: 'PK',
    coordinates: '71.80059814453125, 35.886600494384766',
    municipality: 'Chitral'
  }
}, {
  label: 'Alonso Valderrama Airport (CTD) - PA',
  id: 'CTD',
  obj: {
    iata: 'CTD',
    iso: 'PA',
    coordinates: '-80.40969848632812, 7.987840175628662',
    municipality: 'Chitr\u00c3\u00a9'
  }
}, {
  label: 'Shah Amanat International Airport (CGP) - BD',
  id: 'CGP',
  obj: {
    iata: 'CGP',
    iso: 'BD',
    coordinates: '91.81330108642578, 22.24959945678711',
    municipality: 'Chittagong'
  }
}, {
  label: 'Chi\u00c5\u009fin\u00c4\u0083u International Airport (KIV) - MD',
  id: 'KIV',
  obj: {
    iata: 'KIV',
    iso: 'MD',
    coordinates: '28.930999755859375, 46.92770004272461',
    municipality: 'Chi\u00c5\u009fin\u00c4\u0083u'
  }
}, {
  label: 'Chokurdakh Airport (CKH) - RU',
  id: 'CKH',
  obj: {
    iata: 'CKH',
    iso: 'RU',
    coordinates: '147.90199279785156, 70.62310028076172',
    municipality: 'Chokurdah'
  }
}, {
  label: 'Cholet Le Pontreau Airport (CET) - FR',
  id: 'CET',
  obj: {
    iata: 'CET',
    iso: 'FR',
    coordinates: '-0.8770639896392822, 47.08209991455078',
    municipality: 'Cholet/Le Pontreau'
  }
}, {
  label: 'Christchurch International Airport (CHC) - NZ',
  id: 'CHC',
  obj: {
    iata: 'CHC',
    iso: 'NZ',
    coordinates: '172.53199768066406, -43.48939895629883',
    municipality: 'Christchurch'
  }
}, {
  label: 'Henry E Rohlsen Airport (STX) - VI',
  id: 'STX',
  obj: {
    iata: 'STX',
    iso: 'VI',
    coordinates: '-64.79859924316406, 17.701900482177734',
    municipality: 'Christiansted'
  }
}, {
  label: 'Christmas Island Airport (XCH) - CX',
  id: 'XCH',
  obj: {
    iata: 'XCH',
    iso: 'CX',
    coordinates: '105.69000244140625, -10.450599670410156',
    municipality: 'Christmas Island'
  }
}, {
  label: 'Provideniya Bay Airport (PVS) - RU',
  id: 'PVS',
  obj: {
    iata: 'PVS',
    iso: 'RU',
    coordinates: '-173.2429962158203, 64.37809753417969',
    municipality: 'Chukotka'
  }
}, {
  label: 'Churchill Airport (YYQ) - CA',
  id: 'YYQ',
  obj: {
    iata: 'YYQ',
    iso: 'CA',
    coordinates: '-94.06500244140625, 58.739200592041016',
    municipality: 'Churchill'
  }
}, {
  label: 'Ch\u00c3\u00a2teauroux-D\u00c3\u00a9ols "Marcel Dassault" Airport (CHR) - FR',
  id: 'CHR',
  obj: {
    iata: 'CHR',
    iso: 'FR',
    coordinates: '1.721111, 46.860278',
    municipality: 'Ch\u00c3\u00a2teauroux/D\u00c3\u00a9ols'
  }
}, {
  label: 'Maximo Gomez Airport (AVI) - CU',
  id: 'AVI',
  obj: {
    iata: 'AVI',
    iso: 'CU',
    coordinates: '-78.78959655761719, 22.027099609375',
    municipality: 'Ciego de Avila'
  }
}, {
  label: 'Jaime Gonzalez Airport (CFG) - CU',
  id: 'CFG',
  obj: {
    iata: 'CFG',
    iso: 'CU',
    coordinates: '-80.41419982910156, 22.149999618530273',
    municipality: 'Cienfuegos'
  }
}, {
  label: 'Tunggul Wulung Airport (CXP) - ID',
  id: 'CXP',
  obj: {
    iata: 'CXP',
    iso: 'ID',
    coordinates: '109.033996582, -7.645060062410001',
    municipality: 'Cilacap-Java Island'
  }
}, {
  label: 'Cincinnati Municipal Airport Lunken Field (LUK) - US',
  id: 'LUK',
  obj: {
    iata: 'LUK',
    iso: 'US',
    coordinates: '-84.41860199, 39.10329819',
    municipality: 'Cincinnati'
  }
}, {
  label: 'Cincinnati Northern Kentucky International Airport (CVG) - US',
  id: 'CVG',
  obj: {
    iata: 'CVG',
    iso: 'US',
    coordinates: '-84.667801, 39.048801',
    municipality: 'Cincinnati / Covington'
  }
}, {
  label: 'Ciudad Constituci\u00c3\u00b3n Airport (CUA) - MX',
  id: 'CUA',
  obj: {
    iata: 'CUA',
    iso: 'MX',
    coordinates: '-111.614998, 25.053801',
    municipality: 'Ciudad Constituci\u00c3\u00b3n'
  }
}, {
  label: 'Abraham Gonz\u00c3\u00a1lez International Airport (CJS) - MX',
  id: 'CJS',
  obj: {
    iata: 'CJS',
    iso: 'MX',
    coordinates: '-106.42900085449219, 31.63610076904297',
    municipality: 'Ciudad Ju\u00c3\u00a1rez'
  }
}, {
  label: 'Ciudad Obreg\u00c3\u00b3n International Airport (CEN) - MX',
  id: 'CEN',
  obj: {
    iata: 'CEN',
    iso: 'MX',
    coordinates: '-109.83300018310547, 27.39259910583496',
    municipality: 'Ciudad Obreg\u00c3\u00b3n'
  }
}, {
  label: 'General Pedro Jose Mendez International Airport (CVM) - MX',
  id: 'CVM',
  obj: {
    iata: 'CVM',
    iso: 'MX',
    coordinates: '-98.9564971924, 23.7033004761',
    municipality: 'Ciudad Victoria'
  }
}, {
  label: 'Ciudad del Carmen International Airport (CME) - MX',
  id: 'CME',
  obj: {
    iata: 'CME',
    iso: 'MX',
    coordinates: '-91.79900360107422, 18.65369987487793',
    municipality: 'Ciudad del Carmen'
  }
}, {
  label: 'Guarani International Airport (AGT) - PY',
  id: 'AGT',
  obj: {
    iata: 'AGT',
    iso: 'PY',
    coordinates: '-54.842682, -25.454516',
    municipality: 'Ciudad del Este'
  }
}, {
  label: 'North Central West Virginia Airport (CKB) - US',
  id: 'CKB',
  obj: {
    iata: 'CKB',
    iso: 'US',
    coordinates: '-80.2281036377, 39.2966003418',
    municipality: 'Clarksburg'
  }
}, {
  label: 'Clermont-Ferrand Auvergne Airport (CFE) - FR',
  id: 'CFE',
  obj: {
    iata: 'CFE',
    iso: 'FR',
    coordinates: '3.1691699028, 45.7867012024',
    municipality: 'Clermont-Ferrand/Auvergne'
  }
}, {
  label: 'Burke Lakefront Airport (BKL) - US',
  id: 'BKL',
  obj: {
    iata: 'BKL',
    iso: 'US',
    coordinates: '-81.68329620361328, 41.51750183105469',
    municipality: 'Cleveland'
  }
}, {
  label: 'Cuyahoga County Airport (CGF) - US',
  id: 'CGF',
  obj: {
    iata: 'CGF',
    iso: 'US',
    coordinates: '-81.4863967896, 41.5651016235',
    municipality: 'Cleveland'
  }
}, {
  label: 'Cleveland Hopkins International Airport (CLE) - US',
  id: 'CLE',
  obj: {
    iata: 'CLE',
    iso: 'US',
    coordinates: '-81.8498001099, 41.4117012024',
    municipality: 'Cleveland'
  }
}, {
  label: 'Cloncurry Airport (CNJ) - AU',
  id: 'CNJ',
  obj: {
    iata: 'CNJ',
    iso: 'AU',
    coordinates: '140.503997803, -20.668600082399998',
    municipality: 'Cloncurry'
  }
}, {
  label: 'Cannon Air Force Base (CVS) - US',
  id: 'CVS',
  obj: {
    iata: 'CVS',
    iso: 'US',
    coordinates: '-103.321998596, 34.3828010559',
    municipality: 'Clovis'
  }
}, {
  label: 'Cluj-Napoca International Airport (CLJ) - RO',
  id: 'CLJ',
  obj: {
    iata: 'CLJ',
    iso: 'RO',
    coordinates: '23.686199, 46.785198',
    municipality: 'Cluj-Napoca'
  }
}, {
  label: 'Clyde River Airport (YCY) - CA',
  id: 'YCY',
  obj: {
    iata: 'YCY',
    iso: 'CA',
    coordinates: '-68.5167007446, 70.4860992432',
    municipality: 'Clyde River'
  }
}, {
  label: 'Coban Airport (CBV) - GT',
  id: 'CBV',
  obj: {
    iata: 'CBV',
    iso: 'GT',
    coordinates: '-90.40670013427734, 15.468999862670898',
    municipality: 'Coban'
  }
}, {
  label: 'Capit\u00c3\u00a1n An\u00c3\u00adbal Arab Airport (CIJ) - BO',
  id: 'CIJ',
  obj: {
    iata: 'CIJ',
    iso: 'BO',
    coordinates: '-68.7829971313, -11.040399551400002',
    municipality: 'Cobija'
  }
}, {
  label: 'Francisco De Orellana Airport (OCC) - EC',
  id: 'OCC',
  obj: {
    iata: 'OCC',
    iso: 'EC',
    coordinates: '-76.98680114746094, -0.4628860056400299',
    municipality: 'Coca'
  }
}, {
  label: 'Jorge Wilsterman International Airport (CBB) - BO',
  id: 'CBB',
  obj: {
    iata: 'CBB',
    iso: 'BO',
    coordinates: '-66.1771011352539, -17.421100616455078',
    municipality: 'Cochabamba'
  }
}, {
  label: 'Cochrane Airport (YCN) - CA',
  id: 'YCN',
  obj: {
    iata: 'YCN',
    iso: 'CA',
    coordinates: '-81.01360321044922, 49.10559844970703',
    municipality: 'Cochrane'
  }
}, {
  label: 'Cochrane Airport (LGR) - CL',
  id: 'LGR',
  obj: {
    iata: 'LGR',
    iso: 'CL',
    coordinates: '-72.5884017944336, -47.24380111694336',
    municipality: 'Cochrane'
  }
}, {
  label: 'JAGS McCartney International Airport (GDT) - TC',
  id: 'GDT',
  obj: {
    iata: 'GDT',
    iso: 'TC',
    coordinates: '-71.14230346679688, 21.444499969482422',
    municipality: 'Cockburn Town'
  }
}, {
  label: 'Patrick Air Force Base (COF) - US',
  id: 'COF',
  obj: {
    iata: 'COF',
    iso: 'US',
    coordinates: '-80.6100997925, 28.2348995209',
    municipality: 'Cocoa Beach'
  }
}, {
  label: 'Cocos (Keeling) Islands Airport (CCK) - CC',
  id: 'CCK',
  obj: {
    iata: 'CCK',
    iso: 'CC',
    coordinates: '96.8339004517, -12.1883001328',
    municipality: 'Cocos (Keeling) Islands'
  }
}, {
  label: 'Yellowstone Regional Airport (COD) - US',
  id: 'COD',
  obj: {
    iata: 'COD',
    iso: 'US',
    coordinates: '-109.024002075, 44.520198822',
    municipality: 'Cody'
  }
}, {
  label: 'Coen Airport (CUQ) - AU',
  id: 'CUQ',
  obj: {
    iata: 'CUQ',
    iso: 'AU',
    coordinates: '143.113311, -13.761133',
    municipality: 'Coen'
  }
}, {
  label: "Coeur D'Alene - Pappy Boyington Field (COE) - US",
  id: 'COE',
  obj: {
    iata: 'COE',
    iso: 'US',
    coordinates: '-116.8199997, 47.77429962',
    municipality: "Coeur d'Alene"
  }
}, {
  label: 'Coffs Harbour Airport (CFS) - AU',
  id: 'CFS',
  obj: {
    iata: 'CFS',
    iso: 'AU',
    coordinates: '153.115997, -30.320601',
    municipality: 'Coffs Harbour'
  }
}, {
  label: 'Cognac-Ch\u00c3\u00a2teaubernard (BA 709) Air Base (CNG) - FR',
  id: 'CNG',
  obj: {
    iata: 'CNG',
    iso: 'FR',
    coordinates: '-0.3174999952316284, 45.65829849243164',
    municipality: 'Cognac/Ch\u00c3\u00a2teaubernard'
  }
}, {
  label: 'Coimbatore International Airport (CJB) - IN',
  id: 'CJB',
  obj: {
    iata: 'CJB',
    iso: 'IN',
    coordinates: '77.0434036255, 11.029999733',
    municipality: 'Coimbatore'
  }
}, {
  label: 'Cold Bay Airport (CDB) - US',
  id: 'CDB',
  obj: {
    iata: 'CDB',
    iso: 'US',
    coordinates: '-162.72500610351562, 55.20610046386719',
    municipality: 'Cold Bay'
  }
}, {
  label: 'CFB Cold Lake (YOD) - CA',
  id: 'YOD',
  obj: {
    iata: 'YOD',
    iso: 'CA',
    coordinates: '-110.27899932861328, 54.404998779296875',
    municipality: 'Cold Lake'
  }
}, {
  label: 'Licenciado Miguel de la Madrid Airport (CLQ) - MX',
  id: 'CLQ',
  obj: {
    iata: 'CLQ',
    iso: 'MX',
    coordinates: '-103.577002, 19.277',
    municipality: 'Colima'
  }
}, {
  label: 'Easterwood Field (CLL) - US',
  id: 'CLL',
  obj: {
    iata: 'CLL',
    iso: 'US',
    coordinates: '-96.36380005, 30.58860016',
    municipality: 'College Station'
  }
}, {
  label: 'Colmar-Houssen Airport (CMR) - FR',
  id: 'CMR',
  obj: {
    iata: 'CMR',
    iso: 'FR',
    coordinates: '7.359010219573975, 48.109901428222656',
    municipality: 'Colmar/Houssen'
  }
}, {
  label: 'Cologne Bonn Airport (CGN) - DE',
  id: 'CGN',
  obj: {
    iata: 'CGN',
    iso: 'DE',
    coordinates: '7.1427397728, 50.8658981323',
    municipality: 'Cologne'
  }
}, {
  label: 'Bandaranaike International Colombo Airport (CMB) - LK',
  id: 'CMB',
  obj: {
    iata: 'CMB',
    iso: 'LK',
    coordinates: '79.88410186767578, 7.180759906768799',
    municipality: 'Colombo'
  }
}, {
  label: 'Colombo Ratmalana Airport (RML) - LK',
  id: 'RML',
  obj: {
    iata: 'RML',
    iso: 'LK',
    coordinates: '79.88619995117188, 6.821990013122559',
    municipality: 'Colombo'
  }
}, {
  label: 'Colonel Hill Airport (CRI) - BS',
  id: 'CRI',
  obj: {
    iata: 'CRI',
    iso: 'BS',
    coordinates: '-74.1824035645, 22.745599746699998',
    municipality: 'Colonel Hill'
  }
}, {
  label: 'City of Colorado Springs Municipal Airport (COS) - US',
  id: 'COS',
  obj: {
    iata: 'COS',
    iso: 'US',
    coordinates: '-104.700996, 38.805801',
    municipality: 'Colorado Springs'
  }
}, {
  label: 'Columbia Metropolitan Airport (CAE) - US',
  id: 'CAE',
  obj: {
    iata: 'CAE',
    iso: 'US',
    coordinates: '-81.11949920654297, 33.93880081176758',
    municipality: 'Columbia'
  }
}, {
  label: 'Columbia Regional Airport (COU) - US',
  id: 'COU',
  obj: {
    iata: 'COU',
    iso: 'US',
    coordinates: '-92.219597, 38.8181',
    municipality: 'Columbia'
  }
}, {
  label: 'Jim Hamilton L.B. Owens Airport (CUB) - US',
  id: 'CUB',
  obj: {
    iata: 'CUB',
    iso: 'US',
    coordinates: '-80.9952011108, 33.970500946',
    municipality: 'Columbia'
  }
}, {
  label: 'Columbus Municipal Airport (CLU) - US',
  id: 'CLU',
  obj: {
    iata: 'CLU',
    iso: 'US',
    coordinates: '-85.8963012695, 39.2619018555',
    municipality: 'Columbus'
  }
}, {
  label: 'Columbus Air Force Base (CBM) - US',
  id: 'CBM',
  obj: {
    iata: 'CBM',
    iso: 'US',
    coordinates: '-88.44380187990001, 33.6437988281',
    municipality: 'Columbus'
  }
}, {
  label: 'John Glenn Columbus International Airport (CMH) - US',
  id: 'CMH',
  obj: {
    iata: 'CMH',
    iso: 'US',
    coordinates: '-82.891899, 39.998001',
    municipality: 'Columbus'
  }
}, {
  label: 'Columbus Metropolitan Airport (CSG) - US',
  id: 'CSG',
  obj: {
    iata: 'CSG',
    iso: 'US',
    coordinates: '-84.93890380859375, 32.516300201416016',
    municipality: 'Columbus'
  }
}, {
  label: 'Rickenbacker International Airport (LCK) - US',
  id: 'LCK',
  obj: {
    iata: 'LCK',
    iso: 'US',
    coordinates: '-82.927803, 39.813801',
    municipality: 'Columbus'
  }
}, {
  label: 'The Ohio State University Airport - Don Scott Field (OSU) - US',
  id: 'OSU',
  obj: {
    iata: 'OSU',
    iso: 'US',
    coordinates: '-83.072998, 40.0798',
    municipality: 'Columbus'
  }
}, {
  label: 'Golden Triangle Regional Airport (GTR) - US',
  id: 'GTR',
  obj: {
    iata: 'GTR',
    iso: 'US',
    coordinates: '-88.5914001465, 33.450298309299995',
    municipality: 'Columbus/W Point/Starkville'
  }
}, {
  label: 'Enrique Adolfo Jimenez Airport (ONX) - PA',
  id: 'ONX',
  obj: {
    iata: 'ONX',
    iso: 'PA',
    coordinates: '-79.86740112304688, 9.356639862060547',
    municipality: 'Col\u00c3\u00b3n'
  }
}, {
  label: 'Coronel Enrique Soto Cano Air Base (XPL) - HN',
  id: 'XPL',
  obj: {
    iata: 'XPL',
    iso: 'HN',
    coordinates: '-87.621201, 14.3824',
    municipality: 'Comayagua'
  }
}, {
  label: 'Comiso Airport (CIY) - IT',
  id: 'CIY',
  obj: {
    iata: 'CIY',
    iso: 'IT',
    coordinates: '14.607182, 36.994601',
    municipality: 'Comiso'
  }
}, {
  label: 'General E. Mosconi Airport (CRD) - AR',
  id: 'CRD',
  obj: {
    iata: 'CRD',
    iso: 'AR',
    coordinates: '-67.4655, -45.7853',
    municipality: 'Comodoro Rivadavia'
  }
}, {
  label: 'Comox Airport (YQQ) - CA',
  id: 'YQQ',
  obj: {
    iata: 'YQQ',
    iso: 'CA',
    coordinates: '-124.88700103759766, 49.71080017089844',
    municipality: 'Comox'
  }
}, {
  label: 'Co Ong Airport (VCS) - VN',
  id: 'VCS',
  obj: {
    iata: 'VCS',
    iso: 'VN',
    coordinates: '106.633003, 8.73183',
    municipality: 'Con Dao'
  }
}, {
  label: 'Conakry International Airport (CKY) - GN',
  id: 'CKY',
  obj: {
    iata: 'CKY',
    iso: 'GN',
    coordinates: '-13.612, 9.57689',
    municipality: 'Conakry'
  }
}, {
  label: 'Concei\u00c3\u00a7\u00c3\u00a3o do Araguaia Airport (CDJ) - BR',
  id: 'CDJ',
  obj: {
    iata: 'CDJ',
    iso: 'BR',
    coordinates: '-49.301498, -8.34835',
    municipality: 'Concei\u00c3\u00a7\u00c3\u00a3o do Araguaia'
  }
}, {
  label: 'Carriel Sur Airport (CCP) - CL',
  id: 'CCP',
  obj: {
    iata: 'CCP',
    iso: 'CL',
    coordinates: '-73.063103, -36.772701',
    municipality: 'Concepcion'
  }
}, {
  label: 'Concord Municipal Airport (CON) - US',
  id: 'CON',
  obj: {
    iata: 'CON',
    iso: 'US',
    coordinates: '-71.50229645, 43.20270157',
    municipality: 'Concord'
  }
}, {
  label: 'Comodoro Pierrestegui Airport (COC) - AR',
  id: 'COC',
  obj: {
    iata: 'COC',
    iso: 'AR',
    coordinates: '-57.9966, -31.2969',
    municipality: 'Concordia'
  }
}, {
  label: 'RAF Coningsby (QCY) - GB',
  id: 'QCY',
  obj: {
    iata: 'QCY',
    iso: 'GB',
    coordinates: '-0.166014000773, 53.0929985046',
    municipality: 'Coningsby'
  }
}, {
  label: 'Mohamed Boudiaf International Airport (CZL) - DZ',
  id: 'CZL',
  obj: {
    iata: 'CZL',
    iso: 'DZ',
    coordinates: '6.620389938354492, 36.2760009765625',
    municipality: 'Constantine'
  }
}, {
  label: 'Mihail Kog\u00c4\u0083lniceanu International Airport (CND) - RO',
  id: 'CND',
  obj: {
    iata: 'CND',
    iso: 'RO',
    coordinates: '28.488300323486328, 44.36220169067383',
    municipality: 'Constan\u00c5\u00a3a'
  }
}, {
  label: 'Cooma Snowy Mountains Airport (OOM) - AU',
  id: 'OOM',
  obj: {
    iata: 'OOM',
    iso: 'AU',
    coordinates: '148.973999023, -36.3005981445',
    municipality: 'Cooma'
  }
}, {
  label: 'Copenhagen Kastrup Airport (CPH) - DK',
  id: 'CPH',
  obj: {
    iata: 'CPH',
    iso: 'DK',
    coordinates: '12.656000137329, 55.617900848389',
    municipality: 'Copenhagen'
  }
}, {
  label: 'Copenhagen Roskilde Airport (RKE) - DK',
  id: 'RKE',
  obj: {
    iata: 'RKE',
    iso: 'DK',
    coordinates: '12.131400108337402, 55.585601806640625',
    municipality: 'Copenhagen'
  }
}, {
  label: 'Desierto de Atacama Airport (CPO) - CL',
  id: 'CPO',
  obj: {
    iata: 'CPO',
    iso: 'CL',
    coordinates: '-70.7791976929, -27.2611999512',
    municipality: 'Copiapo'
  }
}, {
  label: 'Coral Harbour Airport (YZS) - CA',
  id: 'YZS',
  obj: {
    iata: 'YZS',
    iso: 'CA',
    coordinates: '-83.3593978882, 64.1932983398',
    municipality: 'Coral Harbour'
  }
}, {
  label: 'Ingeniero Ambrosio Taravella Airport (COR) - AR',
  id: 'COR',
  obj: {
    iata: 'COR',
    iso: 'AR',
    coordinates: '-64.208, -31.323601',
    municipality: 'Cordoba'
  }
}, {
  label: 'Merle K (Mudhole) Smith Airport (CDV) - US',
  id: 'CDV',
  obj: {
    iata: 'CDV',
    iso: 'US',
    coordinates: '-145.4779968, 60.4917984',
    municipality: 'Cordova'
  }
}, {
  label: 'Cork Airport (ORK) - IE',
  id: 'ORK',
  obj: {
    iata: 'ORK',
    iso: 'IE',
    coordinates: '-8.491109848022461, 51.84130096435547',
    municipality: 'Cork'
  }
}, {
  label: 'A\u00c3\u00a9rodrome de Pontoise - Cormeilles en Vexin (POX) - FR',
  id: 'POX',
  obj: {
    iata: 'POX',
    iso: 'FR',
    coordinates: '2.040833, 49.096667',
    municipality: 'Cormeilles-en-Vexin'
  }
}, {
  label: 'Cornwall Regional Airport (YCC) - CA',
  id: 'YCC',
  obj: {
    iata: 'YCC',
    iso: 'CA',
    coordinates: '-74.56330108642578, 45.09280014038086',
    municipality: 'Cornwall'
  }
}, {
  label: 'Jos\u00c3\u00a9 Leonardo Chirinos Airport (CZE) - VE',
  id: 'CZE',
  obj: {
    iata: 'CZE',
    iso: 'VE',
    coordinates: '-69.68090057373047, 11.41494369506836',
    municipality: 'Coro'
  }
}, {
  label: 'Francisco B. Reyes Airport (USU) - PH',
  id: 'USU',
  obj: {
    iata: 'USU',
    iso: 'PH',
    coordinates: '120.099998474, 12.1215000153',
    municipality: 'Coron'
  }
}, {
  label: 'Corozal Municipal Airport (CZH) - BZ',
  id: 'CZH',
  obj: {
    iata: 'CZH',
    iso: 'BZ',
    coordinates: '-88.41190338134766, 18.382200241088867',
    municipality: 'Corozal'
  }
}, {
  label: 'Las Brujas Airport (CZU) - CO',
  id: 'CZU',
  obj: {
    iata: 'CZU',
    iso: 'CO',
    coordinates: '-75.2856, 9.33274',
    municipality: 'Corozal'
  }
}, {
  label: 'Corpus Christi International Airport (CRP) - US',
  id: 'CRP',
  obj: {
    iata: 'CRP',
    iso: 'US',
    coordinates: '-97.5011978149414, 27.77039909362793',
    municipality: 'Corpus Christi'
  }
}, {
  label: 'Coto 47 Airport (OTR) - CR',
  id: 'OTR',
  obj: {
    iata: 'OTR',
    iso: 'CR',
    coordinates: '-82.96859741210938, 8.60155963897705',
    municipality: 'Corredores'
  }
}, {
  label: 'Corrientes Airport (CNQ) - AR',
  id: 'CNQ',
  obj: {
    iata: 'CNQ',
    iso: 'AR',
    coordinates: '-58.7619, -27.4455',
    municipality: 'Corrientes'
  }
}, {
  label: 'Corumb\u00c3\u00a1 International Airport (CMG) - BR',
  id: 'CMG',
  obj: {
    iata: 'CMG',
    iso: 'BR',
    coordinates: '-57.6713905334, -19.0119438171',
    municipality: 'Corumb\u00c3\u00a1'
  }
}, {
  label: 'Corvallis Municipal Airport (CVO) - US',
  id: 'CVO',
  obj: {
    iata: 'CVO',
    iso: 'US',
    coordinates: '-123.2900009, 44.49720001',
    municipality: 'Corvallis'
  }
}, {
  label: 'Regi\u00c3\u00b3n de Murcia International Airport (RMU) - ES',
  id: 'RMU',
  obj: {
    iata: 'RMU',
    iso: 'ES',
    coordinates: '-1.125, 37.803',
    municipality: 'Corvera'
  }
}, {
  label: 'Awang Airport (CBO) - PH',
  id: 'CBO',
  obj: {
    iata: 'CBO',
    iso: 'PH',
    coordinates: '124.20999908447266, 7.1652398109436035',
    municipality: 'Cotabato City'
  }
}, {
  label: 'San Vito De Java Airport (TOO) - CR',
  id: 'TOO',
  obj: {
    iata: 'TOO',
    iso: 'CR',
    coordinates: '-82.95890045166016, 8.826109886169434',
    municipality: 'Coto Brus'
  }
}, {
  label: 'Cadjehoun Airport (COO) - BJ',
  id: 'COO',
  obj: {
    iata: 'COO',
    iso: 'BJ',
    coordinates: '2.384350061416626, 6.357230186462402',
    municipality: 'Cotonou'
  }
}, {
  label: 'Coventry Airport (CVT) - GB',
  id: 'CVT',
  obj: {
    iata: 'CVT',
    iso: 'GB',
    coordinates: '-1.4797199964499999, 52.3697013855',
    municipality: 'Coventry'
  }
}, {
  label: 'Cove\u00c3\u00b1as Airport (CVE) - CO',
  id: 'CVE',
  obj: {
    iata: 'CVE',
    iso: 'CO',
    coordinates: '-75.6913, 9.40092',
    municipality: 'Cove\u00c3\u00b1as'
  }
}, {
  label: "Cox's Bazar Airport (CXB) - BD",
  id: 'CXB',
  obj: {
    iata: 'CXB',
    iso: 'BD',
    coordinates: '91.96389770507812, 21.452199935913086',
    municipality: "Cox's Bazar"
  }
}, {
  label: 'Teniente Vidal Airport (GXQ) - CL',
  id: 'GXQ',
  obj: {
    iata: 'GXQ',
    iso: 'CL',
    coordinates: '-72.1061019897461, -45.594200134277344',
    municipality: 'Coyhaique'
  }
}, {
  label: 'Cozumel International Airport (CZM) - MX',
  id: 'CZM',
  obj: {
    iata: 'CZM',
    iso: 'MX',
    coordinates: '-86.92559814453125, 20.52239990234375',
    municipality: 'Cozumel'
  }
}, {
  label: 'Craiova Airport (CRA) - RO',
  id: 'CRA',
  obj: {
    iata: 'CRA',
    iso: 'RO',
    coordinates: '23.888599395751953, 44.31809997558594',
    municipality: 'Craiova'
  }
}, {
  label: 'Cranbrook/Canadian Rockies International Airport (YXC) - CA',
  id: 'YXC',
  obj: {
    iata: 'YXC',
    iso: 'CA',
    coordinates: '-115.78199768066, 49.610801696777',
    municipality: 'Cranbrook'
  }
}, {
  label: 'Creil Air Base (CSF) - FR',
  id: 'CSF',
  obj: {
    iata: 'CSF',
    iso: 'FR',
    coordinates: '2.5191400051116943, 49.253501892089844',
    municipality: 'Creil'
  }
}, {
  label: 'Jack Mc Namara Field Airport (CEC) - US',
  id: 'CEC',
  obj: {
    iata: 'CEC',
    iso: 'US',
    coordinates: '-124.2369995, 41.78020096',
    municipality: 'Crescent City'
  }
}, {
  label: 'Bob Sikes Airport (CEW) - US',
  id: 'CEW',
  obj: {
    iata: 'CEW',
    iso: 'US',
    coordinates: '-86.522102356, 30.778799057',
    municipality: 'Crestview'
  }
}, {
  label: 'Duke Field (EGI) - US',
  id: 'EGI',
  obj: {
    iata: 'EGI',
    iso: 'US',
    coordinates: '-86.52290344, 30.65040016',
    municipality: 'Crestview'
  }
}, {
  label: 'Sitia Airport (JSH) - GR',
  id: 'JSH',
  obj: {
    iata: 'JSH',
    iso: 'GR',
    coordinates: '26.101299285888672, 35.21609878540039',
    municipality: 'Crete Island'
  }
}, {
  label: 'Diom\u00c3\u00adcio Freitas Airport (CCM) - BR',
  id: 'CCM',
  obj: {
    iata: 'CCM',
    iso: 'BR',
    coordinates: '-49.4213905334, -28.7244434357',
    municipality: 'Crici\u00c3\u00bama'
  }
}, {
  label: 'Cross Lake (Charlie Sinclair Memorial) Airport (YCR) - CA',
  id: 'YCR',
  obj: {
    iata: 'YCR',
    iso: 'CA',
    coordinates: '-97.76080322265625, 54.610599517822266',
    municipality: 'Cross Lake'
  }
}, {
  label: 'Crossville Memorial Whitson Field (CSV) - US',
  id: 'CSV',
  obj: {
    iata: 'CSV',
    iso: 'US',
    coordinates: '-85.08499908450001, 35.9513015747',
    municipality: 'Crossville'
  }
}, {
  label: 'Crotone Airport (CRV) - IT',
  id: 'CRV',
  obj: {
    iata: 'CRV',
    iso: 'IT',
    coordinates: '17.0802, 38.9972',
    municipality: 'Crotone'
  }
}, {
  label: 'Cruzeiro do Sul Airport (CZS) - BR',
  id: 'CZS',
  obj: {
    iata: 'CZS',
    iso: 'BR',
    coordinates: '-72.769501, -7.59991',
    municipality: 'Cruzeiro Do Sul'
  }
}, {
  label: 'Mariscal Lamar Airport (CUE) - EC',
  id: 'CUE',
  obj: {
    iata: 'CUE',
    iso: 'EC',
    coordinates: '-78.984398, -2.88947',
    municipality: 'Cuenca'
  }
}, {
  label: 'Marechal Rondon Airport (CGB) - BR',
  id: 'CGB',
  obj: {
    iata: 'CGB',
    iso: 'BR',
    coordinates: '-56.1166992188, -15.6528997421',
    municipality: 'Cuiab\u00c3\u00a1'
  }
}, {
  label: 'Bachigualato Federal International Airport (CUL) - MX',
  id: 'CUL',
  obj: {
    iata: 'CUL',
    iso: 'MX',
    coordinates: '-107.474998474, 24.7644996643',
    municipality: 'Culiac\u00c3\u00a1n'
  }
}, {
  label: 'A Coru\u00c3\u00b1a Airport (LCG) - ES',
  id: 'LCG',
  obj: {
    iata: 'LCG',
    iso: 'ES',
    coordinates: '-8.37726, 43.302101',
    municipality: 'Culleredo'
  }
}, {
  label: 'Cuneo International Airport (CUF) - IT',
  id: 'CUF',
  obj: {
    iata: 'CUF',
    iso: 'IT',
    coordinates: '7.62322, 44.547001',
    municipality: 'Cuneo'
  }
}, {
  label: 'Bacacheri Airport (BFH) - BR',
  id: 'BFH',
  obj: {
    iata: 'BFH',
    iso: 'BR',
    coordinates: '-49.23199844359999, -25.4050998688',
    municipality: 'Curitiba'
  }
}, {
  label: 'Afonso Pena Airport (CWB) - BR',
  id: 'CWB',
  obj: {
    iata: 'CWB',
    iso: 'BR',
    coordinates: '-49.1758003235, -25.5284996033',
    municipality: 'Curitiba'
  }
}, {
  label: 'Curuzu Cuatia Airport (UZU) - AR',
  id: 'UZU',
  obj: {
    iata: 'UZU',
    iso: 'AR',
    coordinates: '-57.9789, -29.7706',
    municipality: 'Curuzu Cuatia'
  }
}, {
  label: 'Alejandro Velasco Astete International Airport (CUZ) - PE',
  id: 'CUZ',
  obj: {
    iata: 'CUZ',
    iso: 'PE',
    coordinates: '-71.9387969971, -13.535699844400002',
    municipality: 'Cusco'
  }
}, {
  label: 'Cut Bank International Airport (CTB) - US',
  id: 'CTB',
  obj: {
    iata: 'CTB',
    iso: 'US',
    coordinates: '-112.375999451, 48.6083984375',
    municipality: 'Cut Bank'
  }
}, {
  label: 'Cutral-Co Airport (CUT) - AR',
  id: 'CUT',
  obj: {
    iata: 'CUT',
    iso: 'AR',
    coordinates: '-69.2646026611, -38.939701080300004',
    municipality: 'Cutral-Co'
  }
}, {
  label: 'Nordholz Naval Airbase (FCN) - DE',
  id: 'FCN',
  obj: {
    iata: 'FCN',
    iso: 'DE',
    coordinates: '8.658499717709999, 53.7677001953',
    municipality: 'Cuxhaven'
  }
}, {
  label: 'C\u00c3\u00b3rdoba Airport (ODB) - ES',
  id: 'ODB',
  obj: {
    iata: 'ODB',
    iso: 'ES',
    coordinates: '-4.848879814147949, 37.84199905395508',
    municipality: 'C\u00c3\u00b3rdoba'
  }
}, {
  label: 'Camilo Daza International Airport (CUC) - CO',
  id: 'CUC',
  obj: {
    iata: 'CUC',
    iso: 'CO',
    coordinates: '-72.5115, 7.92757',
    municipality: 'C\u00c3\u00bacuta'
  }
}, {
  label: 'Lien Khuong Airport (DLI) - VN',
  id: 'DLI',
  obj: {
    iata: 'DLI',
    iso: 'VN',
    coordinates: '108.366997, 11.75',
    municipality: 'Da Lat'
  }
}, {
  label: 'Da Nang International Airport (DAD) - VN',
  id: 'DAD',
  obj: {
    iata: 'DAD',
    iso: 'VN',
    coordinates: '108.1989974975586, 16.043899536132812',
    municipality: 'Da Nang'
  }
}, {
  label: 'Daegu Airport (TAE) - KR',
  id: 'TAE',
  obj: {
    iata: 'TAE',
    iso: 'KR',
    coordinates: '128.65531, 35.896872',
    municipality: 'Daegu'
  }
}, {
  label: 'Daet Airport (DTE) - PH',
  id: 'DTE',
  obj: {
    iata: 'DTE',
    iso: 'PH',
    coordinates: '122.9800033569336, 14.129199981689453',
    municipality: 'Daet'
  }
}, {
  label: 'Barstow Daggett Airport (DAG) - US',
  id: 'DAG',
  obj: {
    iata: 'DAG',
    iso: 'US',
    coordinates: '-116.7870026, 34.85369873',
    municipality: 'Daggett'
  }
}, {
  label: 'Blaise Diagne International Airport (DSS) - SN',
  id: 'DSS',
  obj: {
    iata: 'DSS',
    iso: 'SN',
    coordinates: '-17.073333, 14.67',
    municipality: 'Dakar'
  }
}, {
  label: 'L\u00c3\u00a9opold S\u00c3\u00a9dar Senghor International Airport (DKR) - SN',
  id: 'DKR',
  obj: {
    iata: 'DKR',
    iso: 'SN',
    coordinates: '-17.49020004272461, 14.739700317382812',
    municipality: 'Dakar'
  }
}, {
  label: 'Dakhla Airport (VIL) - EH',
  id: 'VIL',
  obj: {
    iata: 'VIL',
    iso: 'EH',
    coordinates: '-15.932, 23.7183',
    municipality: 'Dakhla'
  }
}, {
  label: 'Dalaman International Airport (DLM) - TR',
  id: 'DLM',
  obj: {
    iata: 'DLM',
    iso: 'TR',
    coordinates: '28.7924995422, 36.7131004333',
    municipality: 'Dalaman'
  }
}, {
  label: 'Dalhart Municipal Airport (DHT) - US',
  id: 'DHT',
  obj: {
    iata: 'DHT',
    iso: 'US',
    coordinates: '-102.54699707, 36.0225982666',
    municipality: 'Dalhart'
  }
}, {
  label: 'Dallas Love Field (DAL) - US',
  id: 'DAL',
  obj: {
    iata: 'DAL',
    iso: 'US',
    coordinates: '-96.851799, 32.847099',
    municipality: 'Dallas'
  }
}, {
  label: 'Dallas Fort Worth International Airport (DFW) - US',
  id: 'DFW',
  obj: {
    iata: 'DFW',
    iso: 'US',
    coordinates: '-97.038002, 32.896801',
    municipality: 'Dallas-Fort Worth'
  }
}, {
  label: 'Damascus International Airport (DAM) - SY',
  id: 'DAM',
  obj: {
    iata: 'DAM',
    iso: 'SY',
    coordinates: '36.51559829711914, 33.4114990234375',
    municipality: 'Damascus'
  }
}, {
  label: 'Dandong Airport (DDG) - CN',
  id: 'DDG',
  obj: {
    iata: 'DDG',
    iso: 'CN',
    coordinates: '124.286003, 40.0247',
    municipality: 'Dandong'
  }
}, {
  label: 'Dangriga Airport (DGA) - BZ',
  id: 'DGA',
  obj: {
    iata: 'DGA',
    iso: 'BZ',
    coordinates: '-88.23098754882812, 16.98250961303711',
    municipality: 'Dangriga'
  }
}, {
  label: 'Danville Regional Airport (DAN) - US',
  id: 'DAN',
  obj: {
    iata: 'DAN',
    iso: 'US',
    coordinates: '-79.33609771728516, 36.572898864746094',
    municipality: 'Danville'
  }
}, {
  label: 'Julius Nyerere International Airport (DAR) - TZ',
  id: 'DAR',
  obj: {
    iata: 'DAR',
    iso: 'TZ',
    coordinates: '39.202599, -6.87811',
    municipality: 'Dar es Salaam'
  }
}, {
  label: 'Daru Airport (DAU) - PG',
  id: 'DAU',
  obj: {
    iata: 'DAU',
    iso: 'PG',
    coordinates: '143.207992554, -9.08675956726',
    municipality: 'Daru'
  }
}, {
  label: 'Darwin International Airport (DRW) - AU',
  id: 'DRW',
  obj: {
    iata: 'DRW',
    iso: 'AU',
    coordinates: '130.8769989013672, -12.41469955444336',
    municipality: 'Darwin'
  }
}, {
  label: 'Daugavpils Intrenational Airport (DGP) - LV',
  id: 'DGP',
  obj: {
    iata: 'DGP',
    iso: 'LV',
    coordinates: '26.6650009155, 55.944721221900004',
    municipality: 'Daugavpils'
  }
}, {
  label: 'Dauphin Barker Airport (YDN) - CA',
  id: 'YDN',
  obj: {
    iata: 'YDN',
    iso: 'CA',
    coordinates: '-100.052001953125, 51.100799560546875',
    municipality: 'Dauphin'
  }
}, {
  label: 'Francisco Bangoy International Airport (DVO) - PH',
  id: 'DVO',
  obj: {
    iata: 'DVO',
    iso: 'PH',
    coordinates: '125.64600372314453, 7.1255202293396',
    municipality: 'Davao City'
  }
}, {
  label: 'Enrique Malek International Airport (DAV) - PA',
  id: 'DAV',
  obj: {
    iata: 'DAV',
    iso: 'PA',
    coordinates: '-82.43499755859375, 8.390999794006348',
    municipality: 'David'
  }
}, {
  label: 'King Salman Abdulaziz Airport (DWD) - SA',
  id: 'DWD',
  obj: {
    iata: 'DWD',
    iso: 'SA',
    coordinates: '44.121201, 24.4499',
    municipality: 'Dawadmi'
  }
}, {
  label: 'Dawei Airport (TVY) - MM',
  id: 'TVY',
  obj: {
    iata: 'TVY',
    iso: 'MM',
    coordinates: '98.20359802246094, 14.103899955749512',
    municipality: 'Dawei'
  }
}, {
  label: 'Dawson City Airport (YDA) - CA',
  id: 'YDA',
  obj: {
    iata: 'YDA',
    iso: 'CA',
    coordinates: '-139.1280059814453, 64.04309844970703',
    municipality: 'Dawson City'
  }
}, {
  label: 'Dawson Creek Airport (YDQ) - CA',
  id: 'YDQ',
  obj: {
    iata: 'YDQ',
    iso: 'CA',
    coordinates: '-120.18299865722656, 55.7422981262207',
    municipality: 'Dawson Creek'
  }
}, {
  label: 'James M Cox Dayton International Airport (DAY) - US',
  id: 'DAY',
  obj: {
    iata: 'DAY',
    iso: 'US',
    coordinates: '-84.21939849853516, 39.902400970458984',
    municipality: 'Dayton'
  }
}, {
  label: 'Wright-Patterson Air Force Base (FFO) - US',
  id: 'FFO',
  obj: {
    iata: 'FFO',
    iso: 'US',
    coordinates: '-84.0483016968, 39.8260993958',
    municipality: 'Dayton'
  }
}, {
  label: 'Daytona Beach International Airport (DAB) - US',
  id: 'DAB',
  obj: {
    iata: 'DAB',
    iso: 'US',
    coordinates: '-81.058098, 29.179899',
    municipality: 'Daytona Beach'
  }
}, {
  label: 'Da\u00c5\u009foguz Airport (TAZ) - TM',
  id: 'TAZ',
  obj: {
    iata: 'TAZ',
    iso: 'TM',
    coordinates: '59.826698, 41.761101',
    municipality: 'Da\u00c5\u009foguz'
  }
}, {
  label: 'Beauregard Regional Airport (DRI) - US',
  id: 'DRI',
  obj: {
    iata: 'DRI',
    iso: 'US',
    coordinates: '-93.33989715579999, 30.8316993713',
    municipality: 'De Ridder'
  }
}, {
  label: 'Deadhorse Airport (SCC) - US',
  id: 'SCC',
  obj: {
    iata: 'SCC',
    iso: 'US',
    coordinates: '-148.4649963, 70.19470215',
    municipality: 'Deadhorse'
  }
}, {
  label: "Deadman's Cay Airport (LGI) - BS",
  id: 'LGI',
  obj: {
    iata: 'LGI',
    iso: 'BS',
    coordinates: '-75.09359741210001, 23.1790008545',
    municipality: "Deadman's Cay"
  }
}, {
  label: 'Deauville-Saint-Gatien Airport (DOL) - FR',
  id: 'DOL',
  obj: {
    iata: 'DOL',
    iso: 'FR',
    coordinates: '0.154305994511, 49.3652992249',
    municipality: 'Deauville'
  }
}, {
  label: 'Harar Meda Airport (QHR) - ET',
  id: 'QHR',
  obj: {
    iata: 'QHR',
    iso: 'ET',
    coordinates: '39.0059, 8.7163',
    municipality: 'Debre Zeyit'
  }
}, {
  label: 'Debrecen International Airport (DEB) - HU',
  id: 'DEB',
  obj: {
    iata: 'DEB',
    iso: 'HU',
    coordinates: '21.615299224853516, 47.48889923095703',
    municipality: 'Debrecen'
  }
}, {
  label: 'Decatur Airport (DEC) - US',
  id: 'DEC',
  obj: {
    iata: 'DEC',
    iso: 'US',
    coordinates: '-88.8656997680664, 39.834598541259766',
    municipality: 'Decatur'
  }
}, {
  label: 'Decimomannu Air Base (DCI) - IT',
  id: 'DCI',
  obj: {
    iata: 'DCI',
    iso: 'IT',
    coordinates: '8.97248, 39.354198',
    municipality: 'Decimomannu'
  }
}, {
  label: 'Deer Lake Airport (YDF) - CA',
  id: 'YDF',
  obj: {
    iata: 'YDF',
    iso: 'CA',
    coordinates: '-57.39139938354492, 49.21080017089844',
    municipality: 'Deer Lake'
  }
}, {
  label: 'Deer Lake Airport (YVZ) - CA',
  id: 'YVZ',
  obj: {
    iata: 'YVZ',
    iso: 'CA',
    coordinates: '-94.0614013671875, 52.655799865722656',
    municipality: 'Deer Lake'
  }
}, {
  label: 'Deering Airport (DRG) - US',
  id: 'DRG',
  obj: {
    iata: 'DRG',
    iso: 'US',
    coordinates: '-162.766006, 66.069603',
    municipality: 'Deering'
  }
}, {
  label: 'Dehradun Airport (DED) - IN',
  id: 'DED',
  obj: {
    iata: 'DED',
    iso: 'IN',
    coordinates: '78.180298, 30.189699',
    municipality: 'Dehradun'
  }
}, {
  label: 'Deir ez-Zor Air Base (DEZ) - SY',
  id: 'DEZ',
  obj: {
    iata: 'DEZ',
    iso: 'SY',
    coordinates: '40.175999, 35.2854',
    municipality: 'Deir ez-Zor'
  }
}, {
  label: 'DLF Airport (DLF) - US',
  id: 'DLF',
  obj: {
    iata: 'DLF',
    iso: 'US',
    coordinates: '-100.778002, 29.359501',
    municipality: 'Del Rio'
  }
}, {
  label: 'Del Rio International Airport (DRT) - US',
  id: 'DRT',
  obj: {
    iata: 'DRT',
    iso: 'US',
    coordinates: '-100.927001953, 29.3742008209',
    municipality: 'Del Rio'
  }
}, {
  label: 'Allen Army Airfield (BIG) - US',
  id: 'BIG',
  obj: {
    iata: 'BIG',
    iso: 'US',
    coordinates: '-145.722000122, 63.9944992065',
    municipality: 'Delta Junction Ft Greely'
  }
}, {
  label: 'Deming Municipal Airport (DMN) - US',
  id: 'DMN',
  obj: {
    iata: 'DMN',
    iso: 'US',
    coordinates: '-107.721000671, 32.262298584',
    municipality: 'Deming'
  }
}, {
  label: 'De Kooy Airport (DHR) - NL',
  id: 'DHR',
  obj: {
    iata: 'DHR',
    iso: 'NL',
    coordinates: '4.780620098114014, 52.92340087890625',
    municipality: 'Den Helder'
  }
}, {
  label: 'Shark Bay Airport (MJK) - AU',
  id: 'MJK',
  obj: {
    iata: 'MJK',
    iso: 'AU',
    coordinates: '113.577003479, -25.8938999176',
    municipality: 'Denham'
  }
}, {
  label: 'Deniliquin Airport (DNQ) - AU',
  id: 'DNQ',
  obj: {
    iata: 'DNQ',
    iso: 'AU',
    coordinates: '144.945999146, -35.5593986511',
    municipality: 'Deniliquin'
  }
}, {
  label: '\u00c3\u0087ardak Airport (DNZ) - TR',
  id: 'DNZ',
  obj: {
    iata: 'DNZ',
    iso: 'TR',
    coordinates: '29.7012996674, 37.7855987549',
    municipality: 'Denizli'
  }
}, {
  label: 'Ngurah Rai (Bali) International Airport (DPS) - ID',
  id: 'DPS',
  obj: {
    iata: 'DPS',
    iso: 'ID',
    coordinates: '115.16699981689, -8.7481698989868',
    municipality: 'Denpasar-Bali Island'
  }
}, {
  label: 'Centennial Airport (APA) - US',
  id: 'APA',
  obj: {
    iata: 'APA',
    iso: 'US',
    coordinates: '-104.848999, 39.57009888',
    municipality: 'Denver'
  }
}, {
  label: 'Rocky Mountain Metropolitan Airport (BJC) - US',
  id: 'BJC',
  obj: {
    iata: 'BJC',
    iso: 'US',
    coordinates: '-105.1169968, 39.90879822',
    municipality: 'Denver'
  }
}, {
  label: 'Denver International Airport (DEN) - US',
  id: 'DEN',
  obj: {
    iata: 'DEN',
    iso: 'US',
    coordinates: '-104.672996521, 39.861698150635',
    municipality: 'Denver'
  }
}, {
  label: 'Dera Ghazi Khan Airport (DEA) - PK',
  id: 'DEA',
  obj: {
    iata: 'DEA',
    iso: 'PK',
    coordinates: '70.48590087890625, 29.961000442504883',
    municipality: 'Dera Ghazi Khan'
  }
}, {
  label: 'Dera Ismael Khan Airport (DSK) - PK',
  id: 'DSK',
  obj: {
    iata: 'DSK',
    iso: 'PK',
    coordinates: '70.89659881591797, 31.909400939941406',
    municipality: 'Dera Ismael Khan'
  }
}, {
  label: 'City of Derry Airport (LDY) - GB',
  id: 'LDY',
  obj: {
    iata: 'LDY',
    iso: 'GB',
    coordinates: '-7.161109924316406, 55.04280090332031',
    municipality: 'Derry'
  }
}, {
  label: 'Des Moines International Airport (DSM) - US',
  id: 'DSM',
  obj: {
    iata: 'DSM',
    iso: 'US',
    coordinates: '-93.66310119628906, 41.534000396728516',
    municipality: 'Des Moines'
  }
}, {
  label: 'Coleman A. Young Municipal Airport (DET) - US',
  id: 'DET',
  obj: {
    iata: 'DET',
    iso: 'US',
    coordinates: '-83.00990295, 42.40919876',
    municipality: 'Detroit'
  }
}, {
  label: 'Detroit Metropolitan Wayne County Airport (DTW) - US',
  id: 'DTW',
  obj: {
    iata: 'DTW',
    iso: 'US',
    coordinates: '-83.35340118408203, 42.212398529052734',
    municipality: 'Detroit'
  }
}, {
  label: 'Willow Run Airport (YIP) - US',
  id: 'YIP',
  obj: {
    iata: 'YIP',
    iso: 'US',
    coordinates: '-83.53040314, 42.23789978',
    municipality: 'Detroit'
  }
}, {
  label: 'Devonport Airport (DPO) - AU',
  id: 'DPO',
  obj: {
    iata: 'DPO',
    iso: 'AU',
    coordinates: '146.429992676, -41.1697006226',
    municipality: 'Devonport'
  }
}, {
  label: 'Hazrat Shahjalal International Airport (DAC) - BD',
  id: 'DAC',
  obj: {
    iata: 'DAC',
    iso: 'BD',
    coordinates: '90.397783, 23.843347',
    municipality: 'Dhaka'
  }
}, {
  label: 'Dibrugarh Airport (DIB) - IN',
  id: 'DIB',
  obj: {
    iata: 'DIB',
    iso: 'IN',
    coordinates: '95.0168991089, 27.4839000702',
    municipality: 'Dibrugarh'
  }
}, {
  label: 'Dickinson Theodore Roosevelt Regional Airport (DIK) - US',
  id: 'DIK',
  obj: {
    iata: 'DIK',
    iso: 'US',
    coordinates: '-102.802001953, 46.7974014282',
    municipality: 'Dickinson'
  }
}, {
  label: 'Diego Garcia Naval Support Facility (NKW) - IO',
  id: 'NKW',
  obj: {
    iata: 'NKW',
    iso: 'IO',
    coordinates: '72.411102, -7.31327',
    municipality: 'Diego Garcia'
  }
}, {
  label: 'Dien Bien Phu Airport (DIN) - VN',
  id: 'DIN',
  obj: {
    iata: 'DIN',
    iso: 'VN',
    coordinates: '103.008003235, 21.3974990845',
    municipality: 'Dien Bien Phu'
  }
}, {
  label: 'Digby / Annapolis Regional Airport (YDG) - CA',
  id: 'YDG',
  obj: {
    iata: 'YDG',
    iso: 'CA',
    coordinates: '-65.7854247093, 44.5458450365',
    municipality: 'Digby'
  }
}, {
  label: 'Dijon-Bourgogne Airport (DIJ) - FR',
  id: 'DIJ',
  obj: {
    iata: 'DIJ',
    iso: 'FR',
    coordinates: '5.09, 47.268902',
    municipality: 'Dijon/Longvic'
  }
}, {
  label: 'Dikson Airport (DKS) - RU',
  id: 'DKS',
  obj: {
    iata: 'DKS',
    iso: 'RU',
    coordinates: '80.37966918945312, 73.51780700683594',
    municipality: 'Dikson'
  }
}, {
  label: 'Presidente Nicolau Lobato International Airport (DIL) - TL',
  id: 'DIL',
  obj: {
    iata: 'DIL',
    iso: 'TL',
    coordinates: '125.526000977, -8.54640007019',
    municipality: 'Dili'
  }
}, {
  label: 'Dillingham Airport (DLG) - US',
  id: 'DLG',
  obj: {
    iata: 'DLG',
    iso: 'US',
    coordinates: '-158.5050049, 59.04470062',
    municipality: 'Dillingham'
  }
}, {
  label: 'Dimapur Airport (DMU) - IN',
  id: 'DMU',
  obj: {
    iata: 'DMU',
    iso: 'IN',
    coordinates: '93.77110290530001, 25.883899688699998',
    municipality: 'Dimapur'
  }
}, {
  label: 'Dinard-Pleurtuit-Saint-Malo Airport (DNR) - FR',
  id: 'DNR',
  obj: {
    iata: 'DNR',
    iso: 'FR',
    coordinates: '-2.0799601078033447, 48.58769989013672',
    municipality: 'Dinard/Pleurtuit/Saint-Malo'
  }
}, {
  label: 'Dipolog Airport (DPL) - PH',
  id: 'DPL',
  obj: {
    iata: 'DPL',
    iso: 'PH',
    coordinates: '123.341875076, 8.60198349877',
    municipality: 'Dipolog City'
  }
}, {
  label: 'Aba Tenna Dejazmach Yilma International Airport (DIR) - ET',
  id: 'DIR',
  obj: {
    iata: 'DIR',
    iso: 'ET',
    coordinates: '41.85419845581055, 9.624699592590332',
    municipality: 'Dire Dawa'
  }
}, {
  label: 'Diyarbakir Airport (DIY) - TR',
  id: 'DIY',
  obj: {
    iata: 'DIY',
    iso: 'TR',
    coordinates: '40.201000213600004, 37.893901825',
    municipality: 'Diyarbakir'
  }
}, {
  label: 'Djanet Inedbirene Airport (DJG) - DZ',
  id: 'DJG',
  obj: {
    iata: 'DJG',
    iso: 'DZ',
    coordinates: '9.45244, 24.292801',
    municipality: 'Djanet'
  }
}, {
  label: 'Djerba Zarzis International Airport (DJE) - TN',
  id: 'DJE',
  obj: {
    iata: 'DJE',
    iso: 'TN',
    coordinates: '10.775500297546387, 33.875',
    municipality: 'Djerba'
  }
}, {
  label: 'Djibouti-Ambouli Airport (JIB) - DJ',
  id: 'JIB',
  obj: {
    iata: 'JIB',
    iso: 'DJ',
    coordinates: '43.15950012207031, 11.547300338745117',
    municipality: 'Djibouti City'
  }
}, {
  label: 'Dnipropetrovsk International Airport (DNK) - UA',
  id: 'DNK',
  obj: {
    iata: 'DNK',
    iso: 'UA',
    coordinates: '35.10060119628906, 48.357200622558594',
    municipality: 'Dnipropetrovsk'
  }
}, {
  label: 'Dodge City Regional Airport (DDC) - US',
  id: 'DDC',
  obj: {
    iata: 'DDC',
    iso: 'US',
    coordinates: '-99.9655990600586, 37.76340103149414',
    municipality: 'Dodge City'
  }
}, {
  label: 'Dodoma Airport (DOD) - TZ',
  id: 'DOD',
  obj: {
    iata: 'DOD',
    iso: 'TZ',
    coordinates: '35.752601623535156, -6.170440196990967',
    municipality: 'Dodoma'
  }
}, {
  label: 'Doha International Airport (DIA) - QA',
  id: 'DIA',
  obj: {
    iata: 'DIA',
    iso: 'QA',
    coordinates: '51.565102, 25.261101',
    municipality: 'Doha'
  }
}, {
  label: 'Hamad International Airport (DOH) - QA',
  id: 'DOH',
  obj: {
    iata: 'DOH',
    iso: 'QA',
    coordinates: '51.608056, 25.273056',
    municipality: 'Doha'
  }
}, {
  label: 'Dolbeau St Felicien Airport (YDO) - CA',
  id: 'YDO',
  obj: {
    iata: 'YDO',
    iso: 'CA',
    coordinates: '-72.375, 48.778499603271',
    municipality: 'Dolbeau-St-F\u00c3\u00a9licien'
  }
}, {
  label: 'Dole-Tavaux Airport (DLE) - FR',
  id: 'DLE',
  obj: {
    iata: 'DLE',
    iso: 'FR',
    coordinates: '5.435063, 47.042686',
    municipality: 'Dole/Tavaux'
  }
}, {
  label: 'Ngot Nzoungou Airport (DIS) - CG',
  id: 'DIS',
  obj: {
    iata: 'DIS',
    iso: 'CG',
    coordinates: '12.6599, -4.20635',
    municipality: 'Dolisie'
  }
}, {
  label: 'Donaueschingen-Villingen Airport (ZQL) - DE',
  id: 'ZQL',
  obj: {
    iata: 'ZQL',
    iso: 'DE',
    coordinates: '8.52222156525, 47.97333145139999',
    municipality: 'Donaueschingen'
  }
}, {
  label: 'Robin Hood Doncaster Sheffield Airport (DSA) - GB',
  id: 'DSA',
  obj: {
    iata: 'DSA',
    iso: 'GB',
    coordinates: '-1.01065635681, 53.4805378105',
    municipality: 'Doncaster'
  }
}, {
  label: 'Donegal Airport (CFN) - IE',
  id: 'CFN',
  obj: {
    iata: 'CFN',
    iso: 'IE',
    coordinates: '-8.340999603271484, 55.0442008972168',
    municipality: 'Donegal'
  }
}, {
  label: 'Dong Hoi Airport (VDH) - VN',
  id: 'VDH',
  obj: {
    iata: 'VDH',
    iso: 'VN',
    coordinates: '106.590556, 17.515',
    municipality: 'Dong Hoi'
  }
}, {
  label: 'Dongola Airport (DOG) - SD',
  id: 'DOG',
  obj: {
    iata: 'DOG',
    iso: 'SD',
    coordinates: '30.430099487299998, 19.153900146499996',
    municipality: 'Dongola'
  }
}, {
  label: 'Dongying Shengli Airport (DOY) - CN',
  id: 'DOY',
  obj: {
    iata: 'DOY',
    iso: 'CN',
    coordinates: '118.788002014, 37.5085983276',
    municipality: 'Dongying'
  }
}, {
  label: 'Dortmund Airport (DTM) - DE',
  id: 'DTM',
  obj: {
    iata: 'DTM',
    iso: 'DE',
    coordinates: '7.61223983765, 51.51829910279999',
    municipality: 'Dortmund'
  }
}, {
  label: 'Dothan Regional Airport (DHN) - US',
  id: 'DHN',
  obj: {
    iata: 'DHN',
    iso: 'US',
    coordinates: '-85.44960021972656, 31.321300506591797',
    municipality: 'Dothan'
  }
}, {
  label: 'Douala International Airport (DLA) - CM',
  id: 'DLA',
  obj: {
    iata: 'DLA',
    iso: 'CM',
    coordinates: '9.719479560849999, 4.0060801506',
    municipality: 'Douala'
  }
}, {
  label: 'Bisbee Douglas International Airport (DUG) - US',
  id: 'DUG',
  obj: {
    iata: 'DUG',
    iso: 'US',
    coordinates: '-109.603996277, 31.4689998627',
    municipality: 'Douglas Bisbee'
  }
}, {
  label: 'Dover Air Force Base (DOV) - US',
  id: 'DOV',
  obj: {
    iata: 'DOV',
    iso: 'US',
    coordinates: '-75.46600342, 39.12950134',
    municipality: 'Dover'
  }
}, {
  label: 'Dresden Airport (DRS) - DE',
  id: 'DRS',
  obj: {
    iata: 'DRS',
    iso: 'DE',
    coordinates: '13.767200469970703, 51.1328010559082',
    municipality: 'Dresden'
  }
}, {
  label: 'Dryden Regional Airport (YHD) - CA',
  id: 'YHD',
  obj: {
    iata: 'YHD',
    iso: 'CA',
    coordinates: '-92.744202, 49.831699',
    municipality: 'Dryden'
  }
}, {
  label: 'Dubai International Airport (DXB) - AE',
  id: 'DXB',
  obj: {
    iata: 'DXB',
    iso: 'AE',
    coordinates: '55.3643989563, 25.2527999878',
    municipality: 'Dubai'
  }
}, {
  label: 'Al Minhad Air Base (NHD) - AE',
  id: 'NHD',
  obj: {
    iata: 'NHD',
    iso: 'AE',
    coordinates: '55.3661994934, 25.0268001556',
    municipality: 'Dubai'
  }
}, {
  label: 'Dubbo City Regional Airport (DBO) - AU',
  id: 'DBO',
  obj: {
    iata: 'DBO',
    iso: 'AU',
    coordinates: '148.574996948, -32.2167015076',
    municipality: 'Dubbo'
  }
}, {
  label: 'Dublin Airport (DUB) - IE',
  id: 'DUB',
  obj: {
    iata: 'DUB',
    iso: 'IE',
    coordinates: '-6.27007, 53.421299',
    municipality: 'Dublin'
  }
}, {
  label: 'DuBois Regional Airport (DUJ) - US',
  id: 'DUJ',
  obj: {
    iata: 'DUJ',
    iso: 'US',
    coordinates: '-78.8986969, 41.17829895',
    municipality: 'Dubois'
  }
}, {
  label: 'Dubrovnik Airport (DBV) - HR',
  id: 'DBV',
  obj: {
    iata: 'DBV',
    iso: 'HR',
    coordinates: '18.268199920654297, 42.5614013671875',
    municipality: 'Dubrovnik'
  }
}, {
  label: 'Dubuque Regional Airport (DBQ) - US',
  id: 'DBQ',
  obj: {
    iata: 'DBQ',
    iso: 'US',
    coordinates: '-90.70950317, 42.40200043',
    municipality: 'Dubuque'
  }
}, {
  label: 'Duluth International Airport (DLH) - US',
  id: 'DLH',
  obj: {
    iata: 'DLH',
    iso: 'US',
    coordinates: '-92.19360351559999, 46.8420982361',
    municipality: 'Duluth'
  }
}, {
  label: 'Sibulan Airport (DGT) - PH',
  id: 'DGT',
  obj: {
    iata: 'DGT',
    iso: 'PH',
    coordinates: '123.300003052, 9.3337097168',
    municipality: 'Dumaguete City'
  }
}, {
  label: 'Pinang Kampai Airport (DUM) - ID',
  id: 'DUM',
  obj: {
    iata: 'DUM',
    iso: 'ID',
    coordinates: '101.433998, 1.60919',
    municipality: 'Dumai-Sumatra Island'
  }
}, {
  label: 'Dundee Airport (DND) - GB',
  id: 'DND',
  obj: {
    iata: 'DND',
    iso: 'GB',
    coordinates: '-3.025830030441284, 56.45249938964844',
    municipality: 'Dundee'
  }
}, {
  label: 'Dunedin Airport (DUD) - NZ',
  id: 'DUD',
  obj: {
    iata: 'DUD',
    iso: 'NZ',
    coordinates: '170.197998046875, -45.9281005859375',
    municipality: 'Dunedin'
  }
}, {
  label: 'Dunhuang Airport (DNH) - CN',
  id: 'DNH',
  obj: {
    iata: 'DNH',
    iso: 'CN',
    coordinates: '94.80919647216797, 40.16109848022461',
    municipality: 'Dunhuang'
  }
}, {
  label: 'Duqm International Airport (DQM) - OM',
  id: 'DQM',
  obj: {
    iata: 'DQM',
    iso: 'OM',
    coordinates: '57.634167, 19.501944',
    municipality: 'Duqm'
  }
}, {
  label: 'General Guadalupe Victoria International Airport (DGO) - MX',
  id: 'DGO',
  obj: {
    iata: 'DGO',
    iso: 'MX',
    coordinates: '-104.527999878, 24.1242008209',
    municipality: 'Durango'
  }
}, {
  label: 'Santa Bernardina International Airport (DZO) - UY',
  id: 'DZO',
  obj: {
    iata: 'DZO',
    iso: 'UY',
    coordinates: '-56.49919891357422, -33.3588981628418',
    municipality: 'Durazno'
  }
}, {
  label: 'King Shaka International Airport (DUR) - ZA',
  id: 'DUR',
  obj: {
    iata: 'DUR',
    iso: 'ZA',
    coordinates: '31.1197222222, -29.6144444444',
    municipality: 'Durban'
  }
}, {
  label: 'Virginia Airport (VIR) - ZA',
  id: 'VIR',
  obj: {
    iata: 'VIR',
    iso: 'ZA',
    coordinates: '31.058399200439453, -29.770599365234375',
    municipality: 'Durban'
  }
}, {
  label: 'Kazi Nazrul Islam Airport (RDP) - IN',
  id: 'RDP',
  obj: {
    iata: 'RDP',
    iso: 'IN',
    coordinates: '87.243, 23.6225',
    municipality: 'Durgapur'
  }
}, {
  label: 'Durham Tees Valley Airport (MME) - GB',
  id: 'MME',
  obj: {
    iata: 'MME',
    iso: 'GB',
    coordinates: '-1.4294099807739258, 54.50920104980469',
    municipality: 'Durham'
  }
}, {
  label: 'Dushanbe Airport (DYU) - TJ',
  id: 'DYU',
  obj: {
    iata: 'DYU',
    iso: 'TJ',
    coordinates: '68.8249969482, 38.543300628699996',
    municipality: 'Dushanbe'
  }
}, {
  label: 'Dwangwa Airport (DWA) - MW',
  id: 'DWA',
  obj: {
    iata: 'DWA',
    iso: 'MW',
    coordinates: '34.131901, -12.5183',
    municipality: 'Dwangwa'
  }
}, {
  label: 'Dzaoudzi Pamandzi International Airport (DZA) - YT',
  id: 'DZA',
  obj: {
    iata: 'DZA',
    iso: 'YT',
    coordinates: '45.28110122680664, -12.804699897766113',
    municipality: 'Dzaoudzi'
  }
}, {
  label: 'D\u00c3\u00a9line Airport (YWJ) - CA',
  id: 'YWJ',
  obj: {
    iata: 'YWJ',
    iso: 'CA',
    coordinates: '-123.43599700927734, 65.21109771728516',
    municipality: 'D\u00c3\u00a9line'
  }
}, {
  label: 'D\u00c3\u00bcsseldorf Airport (DUS) - DE',
  id: 'DUS',
  obj: {
    iata: 'DUS',
    iso: 'DE',
    coordinates: '6.76678, 51.289501',
    municipality: 'D\u00c3\u00bcsseldorf'
  }
}, {
  label: 'Eagle County Regional Airport (EGE) - US',
  id: 'EGE',
  obj: {
    iata: 'EGE',
    iso: 'US',
    coordinates: '-106.9179993, 39.64260101',
    municipality: 'Eagle'
  }
}, {
  label: 'Earlton (Timiskaming Regional) Airport (YXR) - CA',
  id: 'YXR',
  obj: {
    iata: 'YXR',
    iso: 'CA',
    coordinates: '-79.8473453522, 47.697400654599996',
    municipality: 'Earlton'
  }
}, {
  label: 'Ben Schoeman Airport (ELS) - ZA',
  id: 'ELS',
  obj: {
    iata: 'ELS',
    iso: 'ZA',
    coordinates: '27.825899124099998, -33.0355987549',
    municipality: 'East London'
  }
}, {
  label: 'Eastmain River Airport (ZEM) - CA',
  id: 'ZEM',
  obj: {
    iata: 'ZEM',
    iso: 'CA',
    coordinates: '-78.52249908447266, 52.22639846801758',
    municipality: 'Eastmain River'
  }
}, {
  label: 'Mc Entire Joint National Guard Base (MMT) - US',
  id: 'MMT',
  obj: {
    iata: 'MMT',
    iso: 'US',
    coordinates: '-80.80130005, 33.92079926',
    municipality: 'Eastover'
  }
}, {
  label: 'Chippewa Valley Regional Airport (EAU) - US',
  id: 'EAU',
  obj: {
    iata: 'EAU',
    iso: 'US',
    coordinates: '-91.48429870605469, 44.86579895019531',
    municipality: 'Eau Claire'
  }
}, {
  label: 'Eday Airport (EOI) - GB',
  id: 'EOI',
  obj: {
    iata: 'EOI',
    iso: 'GB',
    coordinates: '-2.7722198963165283, 59.19060134887695',
    municipality: 'Eday'
  }
}, {
  label: 'Edinburgh Airport (EDI) - GB',
  id: 'EDI',
  obj: {
    iata: 'EDI',
    iso: 'GB',
    coordinates: '-3.372499942779541, 55.95000076293945',
    municipality: 'Edinburgh'
  }
}, {
  label: 'Edmonton International Airport (YEG) - CA',
  id: 'YEG',
  obj: {
    iata: 'YEG',
    iso: 'CA',
    coordinates: '-113.580001831, 53.309700012200004',
    municipality: 'Edmonton'
  }
}, {
  label: 'Bal\u00c4\u00b1kesir K\u00c3\u00b6rfez Airport (EDO) - TR',
  id: 'EDO',
  obj: {
    iata: 'EDO',
    iso: 'TR',
    coordinates: '27.0137996674, 39.554599762',
    municipality: 'Edremit'
  }
}, {
  label: 'Edson Airport (YET) - CA',
  id: 'YET',
  obj: {
    iata: 'YET',
    iso: 'CA',
    coordinates: '-116.464996338, 53.578899383499994',
    municipality: 'Edson'
  }
}, {
  label: 'Edwards Air Force Base (EDW) - US',
  id: 'EDW',
  obj: {
    iata: 'EDW',
    iso: 'US',
    coordinates: '-117.884003, 34.905399',
    municipality: 'Edwards'
  }
}, {
  label: 'Egegik Airport (EGX) - US',
  id: 'EGX',
  obj: {
    iata: 'EGX',
    iso: 'US',
    coordinates: '-157.375, 58.1855010986',
    municipality: 'Egegik'
  }
}, {
  label: 'Egilssta\u00c3\u00b0ir Airport (EGS) - IS',
  id: 'EGS',
  obj: {
    iata: 'EGS',
    iso: 'IS',
    coordinates: '-14.401399612426758, 65.2833023071289',
    municipality: 'Egilssta\u00c3\u00b0ir'
  }
}, {
  label: 'Ramon Airport (ETM) - IL',
  id: 'ETM',
  obj: {
    iata: 'ETM',
    iso: 'IL',
    coordinates: '35.011416, 29.723694',
    municipality: 'Eilat'
  }
}, {
  label: 'Ovda International Airport (VDA) - IL',
  id: 'VDA',
  obj: {
    iata: 'VDA',
    iso: 'IL',
    coordinates: '34.93579864501953, 29.94029998779297',
    municipality: 'Eilat'
  }
}, {
  label: 'Eindhoven Airport (EIN) - NL',
  id: 'EIN',
  obj: {
    iata: 'EIN',
    iso: 'NL',
    coordinates: '5.37452983856, 51.4500999451',
    municipality: 'Eindhoven'
  }
}, {
  label: 'Eisenach-Kindel Airport (EIB) - DE',
  id: 'EIB',
  obj: {
    iata: 'EIB',
    iso: 'DE',
    coordinates: '10.47973, 50.991604',
    municipality: 'Eisenach'
  }
}, {
  label: 'Ekati Airport (YOA) - CA',
  id: 'YOA',
  obj: {
    iata: 'YOA',
    iso: 'CA',
    coordinates: '-110.614997864, 64.6988983154',
    municipality: 'Ekati'
  }
}, {
  label: 'Ekibastuz Airport (EKB) - KZ',
  id: 'EKB',
  obj: {
    iata: 'EKB',
    iso: 'KZ',
    coordinates: '75.21499633789062, 51.590999603271484',
    municipality: 'Ekibastuz'
  }
}, {
  label: 'Hassan I Airport (EUN) - EH',
  id: 'EUN',
  obj: {
    iata: 'EUN',
    iso: 'EH',
    coordinates: '-13.2192, 27.151699',
    municipality: 'El Aai\u00c3\u00ban'
  }
}, {
  label: 'El Alamein International Airport (DBB) - EG',
  id: 'DBB',
  obj: {
    iata: 'DBB',
    iso: 'EG',
    coordinates: '28.46139907836914, 30.92449951171875',
    municipality: 'El Alamein'
  }
}, {
  label: 'El Arish International Airport (AAC) - EG',
  id: 'AAC',
  obj: {
    iata: 'AAC',
    iso: 'EG',
    coordinates: '33.8358001709, 31.073299408',
    municipality: 'El Arish'
  }
}, {
  label: 'El Bagre Airport (EBG) - CO',
  id: 'EBG',
  obj: {
    iata: 'EBG',
    iso: 'CO',
    coordinates: '-74.8089, 7.59647',
    municipality: 'El Bagre'
  }
}, {
  label: 'Las Flores Airport (ELB) - CO',
  id: 'ELB',
  obj: {
    iata: 'ELB',
    iso: 'CO',
    coordinates: '-73.9749, 9.04554',
    municipality: 'El Banco'
  }
}, {
  label: 'El Bolson Airport (EHL) - AR',
  id: 'EHL',
  obj: {
    iata: 'EHL',
    iso: 'AR',
    coordinates: '-71.5323028564, -41.9431991577',
    municipality: 'El Bolson'
  }
}, {
  label: 'El Borma Airport (EBM) - TN',
  id: 'EBM',
  obj: {
    iata: 'EBM',
    iso: 'TN',
    coordinates: '9.254619598388672, 31.704299926757812',
    municipality: 'El Borma'
  }
}, {
  label: 'El Calafate Airport (FTE) - AR',
  id: 'FTE',
  obj: {
    iata: 'FTE',
    iso: 'AR',
    coordinates: '-72.053101, -50.2803',
    municipality: 'El Calafate'
  }
}, {
  label: 'El Centro NAF Airport (Vraciu Field) (NJK) - US',
  id: 'NJK',
  obj: {
    iata: 'NJK',
    iso: 'US',
    coordinates: '-115.671996, 32.829201',
    municipality: 'El Centro'
  }
}, {
  label: 'South Arkansas Regional At Goodwin Field (ELD) - US',
  id: 'ELD',
  obj: {
    iata: 'ELD',
    iso: 'US',
    coordinates: '-92.81330108642578, 33.22100067138672',
    municipality: 'El Dorado'
  }
}, {
  label: 'El Fasher Airport (ELF) - SD',
  id: 'ELF',
  obj: {
    iata: 'ELF',
    iso: 'SD',
    coordinates: '25.324600219726562, 13.614899635314941',
    municipality: 'El Fasher'
  }
}, {
  label: 'El Gora Airport (EGH) - EG',
  id: 'EGH',
  obj: {
    iata: 'EGH',
    iso: 'EG',
    coordinates: '34.129629, 31.068559',
    municipality: 'El Gora'
  }
}, {
  label: 'Hierro Airport (VDE) - ES',
  id: 'VDE',
  obj: {
    iata: 'VDE',
    iso: 'ES',
    coordinates: '-17.887100219726562, 27.814800262451172',
    municipality: 'El Hierro Island'
  }
}, {
  label: 'El Palomar Airport (EPA) - AR',
  id: 'EPA',
  obj: {
    iata: 'EPA',
    iso: 'AR',
    coordinates: '-58.6126, -34.6099',
    municipality: 'El Palomar'
  }
}, {
  label: 'El Paso International Airport (ELP) - US',
  id: 'ELP',
  obj: {
    iata: 'ELP',
    iso: 'US',
    coordinates: '-106.3779984, 31.80719948',
    municipality: 'El Paso'
  }
}, {
  label: 'Ricardo Garc\u00c3\u00ada Posada Airport (ESR) - CL',
  id: 'ESR',
  obj: {
    iata: 'ESR',
    iso: 'CL',
    coordinates: '-69.76519775390625, -26.311100006103516',
    municipality: 'El Salvador'
  }
}, {
  label: 'San Tom\u00c3\u00a9 Airport (SOM) - VE',
  id: 'SOM',
  obj: {
    iata: 'SOM',
    iso: 'VE',
    coordinates: '-64.151084899902, 8.9451465606689',
    municipality: 'El Tigre'
  }
}, {
  label: 'Juan Pablo P\u00c3\u00a9rez Alfonso Airport (VIG) - VE',
  id: 'VIG',
  obj: {
    iata: 'VIG',
    iso: 'VE',
    coordinates: '-71.672668, 8.624139',
    municipality: 'El Vig\u00c3\u00ada'
  }
}, {
  label: 'El Yopal Airport (EYP) - CO',
  id: 'EYP',
  obj: {
    iata: 'EYP',
    iso: 'CO',
    coordinates: '-72.384, 5.31911',
    municipality: 'El Yopal'
  }
}, {
  label: 'Elaz\u00c4\u00b1\u00c4\u009f Airport (EZS) - TR',
  id: 'EZS',
  obj: {
    iata: 'EZS',
    iso: 'TR',
    coordinates: '39.2914009094, 38.6068992615',
    municipality: 'Elaz\u00c4\u00b1\u00c4\u009f'
  }
}, {
  label: 'Elcho Island Airport (ELC) - AU',
  id: 'ELC',
  obj: {
    iata: 'ELC',
    iso: 'AU',
    coordinates: '135.570999146, -12.019399642899998',
    municipality: 'Elcho Island'
  }
}, {
  label: 'Eldoret International Airport (EDL) - KE',
  id: 'EDL',
  obj: {
    iata: 'EDL',
    iso: 'KE',
    coordinates: '35.23889923095703, 0.4044579863548279',
    municipality: 'Eldoret'
  }
}, {
  label: 'Elista Airport (ESL) - RU',
  id: 'ESL',
  obj: {
    iata: 'ESL',
    iso: 'RU',
    coordinates: '44.33089828491211, 46.3739013671875',
    municipality: 'Elista'
  }
}, {
  label: 'Elizabeth City Regional Airport & Coast Guard Air Station (ECG) - US',
  id: 'ECG',
  obj: {
    iata: 'ECG',
    iso: 'US',
    coordinates: '-76.17459869, 36.26060104',
    municipality: 'Elizabeth City'
  }
}, {
  label: 'Elkins-Randolph Co-Jennings Randolph Field (EKN) - US',
  id: 'EKN',
  obj: {
    iata: 'EKN',
    iso: 'US',
    coordinates: '-79.85710144, 38.88940048',
    municipality: 'Elkins'
  }
}, {
  label: 'Elko Regional Airport (EKO) - US',
  id: 'EKO',
  obj: {
    iata: 'EKO',
    iso: 'US',
    coordinates: '-115.79199981689453, 40.82490158081055',
    municipality: 'Elko'
  }
}, {
  label: 'Elliot Lake Municipal Airport (YEL) - CA',
  id: 'YEL',
  obj: {
    iata: 'YEL',
    iso: 'CA',
    coordinates: '-82.5614013672, 46.351398468',
    municipality: 'Elliot Lake'
  }
}, {
  label: 'Elmira Corning Regional Airport (ELM) - US',
  id: 'ELM',
  obj: {
    iata: 'ELM',
    iso: 'US',
    coordinates: '-76.8916015625, 42.1599006652832',
    municipality: 'Elmira/Corning'
  }
}, {
  label: 'Ely Municipal Airport (LYU) - US',
  id: 'LYU',
  obj: {
    iata: 'LYU',
    iso: 'US',
    coordinates: '-91.83070374, 47.82450104',
    municipality: 'Ely'
  }
}, {
  label: 'Ely Airport Yelland Field (ELY) - US',
  id: 'ELY',
  obj: {
    iata: 'ELY',
    iso: 'US',
    coordinates: '-114.8420029, 39.29970169',
    municipality: 'Ely'
  }
}, {
  label: 'Emerald Airport (EMD) - AU',
  id: 'EMD',
  obj: {
    iata: 'EMD',
    iso: 'AU',
    coordinates: '148.179000854, -23.5674991608',
    municipality: 'Emerald'
  }
}, {
  label: 'Emmonak Airport (EMK) - US',
  id: 'EMK',
  obj: {
    iata: 'EMK',
    iso: 'US',
    coordinates: '-164.4909973, 62.78609848',
    municipality: 'Emmonak'
  }
}, {
  label: 'Akanu Ibiam International Airport (ENU) - NG',
  id: 'ENU',
  obj: {
    iata: 'ENU',
    iso: 'NG',
    coordinates: '7.561960220336914, 6.474269866943359',
    municipality: 'Enegu'
  }
}, {
  label: 'Enfidha - Hammamet International Airport (NBE) - TN',
  id: 'NBE',
  obj: {
    iata: 'NBE',
    iso: 'TN',
    coordinates: '10.438611, 36.075833',
    municipality: 'Enfidha'
  }
}, {
  label: 'Vance Air Force Base (END) - US',
  id: 'END',
  obj: {
    iata: 'END',
    iso: 'US',
    coordinates: '-97.9164962769, 36.339199066199996',
    municipality: 'Enid'
  }
}, {
  label: 'St Angelo Airport (ENK) - GB',
  id: 'ENK',
  obj: {
    iata: 'ENK',
    iso: 'GB',
    coordinates: '-7.651669979095459, 54.39889907836914',
    municipality: 'Enniskillen'
  }
}, {
  label: 'Enontekio Airport (ENF) - FI',
  id: 'ENF',
  obj: {
    iata: 'ENF',
    iso: 'FI',
    coordinates: '23.424299240112, 68.362602233887',
    municipality: 'Enontekio'
  }
}, {
  label: 'Twente Airport (ENS) - NL',
  id: 'ENS',
  obj: {
    iata: 'ENS',
    iso: 'NL',
    coordinates: '6.889167, 52.275833',
    municipality: 'Enschede'
  }
}, {
  label: 'Barra Airport (BRR) - GB',
  id: 'BRR',
  obj: {
    iata: 'BRR',
    iso: 'GB',
    coordinates: '-7.44306, 57.0228',
    municipality: 'Eoligarry'
  }
}, {
  label: 'Erenhot Saiwusu International Airport (ERL) - CN',
  id: 'ERL',
  obj: {
    iata: 'ERL',
    iso: 'CN',
    coordinates: '112.096667, 43.4225',
    municipality: 'Erenhot'
  }
}, {
  label: 'Erfurt Airport (ERF) - DE',
  id: 'ERF',
  obj: {
    iata: 'ERF',
    iso: 'DE',
    coordinates: '10.958100318908691, 50.979801177978516',
    municipality: 'Erfurt'
  }
}, {
  label: 'Erie International Tom Ridge Field (ERI) - US',
  id: 'ERI',
  obj: {
    iata: 'ERI',
    iso: 'US',
    coordinates: '-80.1738667488, 42.0831270134',
    municipality: 'Erie'
  }
}, {
  label: 'Moulay Ali Cherif Airport (ERH) - MA',
  id: 'ERH',
  obj: {
    iata: 'ERH',
    iso: 'MA',
    coordinates: '-4.39833021164, 31.9475002289',
    municipality: 'Errachidia'
  }
}, {
  label: 'Erzincan Airport (ERC) - TR',
  id: 'ERC',
  obj: {
    iata: 'ERC',
    iso: 'TR',
    coordinates: '39.527000427199994, 39.7102012634',
    municipality: 'Erzincan'
  }
}, {
  label: 'Erzurum International Airport (ERZ) - TR',
  id: 'ERZ',
  obj: {
    iata: 'ERZ',
    iso: 'TR',
    coordinates: '41.17020034789999, 39.9565010071',
    municipality: 'Erzurum'
  }
}, {
  label: 'Esbjerg Airport (EBJ) - DK',
  id: 'EBJ',
  obj: {
    iata: 'EBJ',
    iso: 'DK',
    coordinates: '8.5534, 55.525902',
    municipality: 'Esbjerg'
  }
}, {
  label: 'Eskilstuna Airport (EKT) - SE',
  id: 'EKT',
  obj: {
    iata: 'EKT',
    iso: 'SE',
    coordinates: '16.70840072631836, 59.35110092163086',
    municipality: 'Eskilstuna'
  }
}, {
  label: 'Anadolu Airport (AOE) - TR',
  id: 'AOE',
  obj: {
    iata: 'AOE',
    iso: 'TR',
    coordinates: '30.5194, 39.809898',
    municipality: 'Eski\u00c5\u009fehir'
  }
}, {
  label: 'Am\u00c3\u00adlcar Cabral International Airport (SID) - CV',
  id: 'SID',
  obj: {
    iata: 'SID',
    iso: 'CV',
    coordinates: '-22.9494, 16.7414',
    municipality: 'Espargos'
  }
}, {
  label: 'Esperance Airport (EPR) - AU',
  id: 'EPR',
  obj: {
    iata: 'EPR',
    iso: 'AU',
    coordinates: '121.822998, -33.684399',
    municipality: 'Esperance'
  }
}, {
  label: 'Brigadier Antonio Parodi Airport (EQS) - AR',
  id: 'EQS',
  obj: {
    iata: 'EQS',
    iso: 'AR',
    coordinates: '-71.139503479, -42.908000946',
    municipality: 'Esquel'
  }
}, {
  label: 'Estevan Airport (YEN) - CA',
  id: 'YEN',
  obj: {
    iata: 'YEN',
    iso: 'CA',
    coordinates: '-102.966003418, 49.2103004456',
    municipality: 'Estevan'
  }
}, {
  label: 'Mahlon Sweet Field (EUG) - US',
  id: 'EUG',
  obj: {
    iata: 'EUG',
    iso: 'US',
    coordinates: '-123.21199798583984, 44.12459945678711',
    municipality: 'Eugene'
  }
}, {
  label: 'Murray Field (EKA) - US',
  id: 'EKA',
  obj: {
    iata: 'EKA',
    iso: 'US',
    coordinates: '-124.112998962, 40.803398132299996',
    municipality: 'Eureka'
  }
}, {
  label: 'Evanston-Uinta County Airport-Burns Field (EVW) - US',
  id: 'EVW',
  obj: {
    iata: 'EVW',
    iso: 'US',
    coordinates: '-111.0350037, 41.27479935',
    municipality: 'Evanston'
  }
}, {
  label: 'Evansville Regional Airport (EVV) - US',
  id: 'EVV',
  obj: {
    iata: 'EVV',
    iso: 'US',
    coordinates: '-87.5324020386, 38.0369987488',
    municipality: 'Evansville'
  }
}, {
  label: 'Harstad/Narvik Airport, Evenes (EVE) - NO',
  id: 'EVE',
  obj: {
    iata: 'EVE',
    iso: 'NO',
    coordinates: '16.678100585938, 68.491302490234',
    municipality: 'Evenes'
  }
}, {
  label: 'Snohomish County (Paine Field) Airport (PAE) - US',
  id: 'PAE',
  obj: {
    iata: 'PAE',
    iso: 'US',
    coordinates: '-122.2819977, 47.90629959',
    municipality: 'Everett'
  }
}, {
  label: 'Exeter International Airport (EXT) - GB',
  id: 'EXT',
  obj: {
    iata: 'EXT',
    iso: 'GB',
    coordinates: '-3.4138898849487305, 50.73440170288086',
    municipality: 'Exeter'
  }
}, {
  label: 'Learmonth Airport (LEA) - AU',
  id: 'LEA',
  obj: {
    iata: 'LEA',
    iso: 'AU',
    coordinates: '114.088996887, -22.235599517799997',
    municipality: 'Exmouth'
  }
}, {
  label: 'Fair Isle Airport (FIE) - GB',
  id: 'FIE',
  obj: {
    iata: 'FIE',
    iso: 'GB',
    coordinates: '-1.628059983253479, 59.53580093383789',
    municipality: 'Fair Isle'
  }
}, {
  label: 'Eielson Air Force Base (EIL) - US',
  id: 'EIL',
  obj: {
    iata: 'EIL',
    iso: 'US',
    coordinates: '-147.102005, 64.66570282',
    municipality: 'Fairbanks'
  }
}, {
  label: 'Fairbanks International Airport (FAI) - US',
  id: 'FAI',
  obj: {
    iata: 'FAI',
    iso: 'US',
    coordinates: '-147.8560028, 64.81510162',
    municipality: 'Fairbanks'
  }
}, {
  label: 'Ladd AAF Airfield (FBK) - US',
  id: 'FBK',
  obj: {
    iata: 'FBK',
    iso: 'US',
    coordinates: '-147.6139984, 64.83750153',
    municipality: 'Fairbanks/Ft Wainwright'
  }
}, {
  label: 'Travis Air Force Base (SUU) - US',
  id: 'SUU',
  obj: {
    iata: 'SUU',
    iso: 'US',
    coordinates: '-121.92700195312, 38.262699127197',
    municipality: 'Fairfield'
  }
}, {
  label: 'RAF Fairford (FFD) - GB',
  id: 'FFD',
  obj: {
    iata: 'FFD',
    iso: 'GB',
    coordinates: '-1.7900300025900002, 51.6822013855',
    municipality: 'Fairford'
  }
}, {
  label: 'Faisalabad International Airport (LYP) - PK',
  id: 'LYP',
  obj: {
    iata: 'LYP',
    iso: 'PK',
    coordinates: '72.99479675292969, 31.364999771118164',
    municipality: 'Faisalabad'
  }
}, {
  label: 'Diego Jimenez Torres Airport (FAJ) - PR',
  id: 'FAJ',
  obj: {
    iata: 'FAJ',
    iso: 'PR',
    coordinates: '-65.66190338134766, 18.308900833129883',
    municipality: 'Fajardo'
  }
}, {
  label: 'Fakfak Airport (FKQ) - ID',
  id: 'FKQ',
  obj: {
    iata: 'FKQ',
    iso: 'ID',
    coordinates: '132.26699829101562, -2.9201900959014893',
    municipality: 'Fakfak-Papua Island'
  }
}, {
  label: 'Fallon Naval Air Station (NFL) - US',
  id: 'NFL',
  obj: {
    iata: 'NFL',
    iso: 'US',
    coordinates: '-118.7009964, 39.41659927',
    municipality: 'Fallon'
  }
}, {
  label: 'Huahine-Fare Airport (HUH) - PF',
  id: 'HUH',
  obj: {
    iata: 'HUH',
    iso: 'PF',
    coordinates: '-151.02200317382812, -16.68720054626465',
    municipality: 'Fare'
  }
}, {
  label: 'Hector International Airport (FAR) - US',
  id: 'FAR',
  obj: {
    iata: 'FAR',
    iso: 'US',
    coordinates: '-96.81580352783203, 46.92070007324219',
    municipality: 'Fargo'
  }
}, {
  label: 'Republic Airport (FRG) - US',
  id: 'FRG',
  obj: {
    iata: 'FRG',
    iso: 'US',
    coordinates: '-73.4133987427, 40.7288017273',
    municipality: 'Farmingdale'
  }
}, {
  label: 'Four Corners Regional Airport (FMN) - US',
  id: 'FMN',
  obj: {
    iata: 'FMN',
    iso: 'US',
    coordinates: '-108.230003357, 36.741199493399996',
    municipality: 'Farmington'
  }
}, {
  label: 'Farnborough Airport (FAB) - GB',
  id: 'FAB',
  obj: {
    iata: 'FAB',
    iso: 'GB',
    coordinates: '-0.776332974434, 51.2757987976',
    municipality: 'Farnborough'
  }
}, {
  label: 'Faro Airport (ZFA) - CA',
  id: 'ZFA',
  obj: {
    iata: 'ZFA',
    iso: 'CA',
    coordinates: '-133.37600708007812, 62.20750045776367',
    municipality: 'Faro'
  }
}, {
  label: 'Faro Airport (FAO) - PT',
  id: 'FAO',
  obj: {
    iata: 'FAO',
    iso: 'PT',
    coordinates: '-7.96590995789, 37.0144004822',
    municipality: 'Faro'
  }
}, {
  label: 'Fasa Airport (FAZ) - IR',
  id: 'FAZ',
  obj: {
    iata: 'FAZ',
    iso: 'IR',
    coordinates: '53.72330093383789, 28.891799926757812',
    municipality: 'Fasa'
  }
}, {
  label: 'Fayetteville Regional Grannis Field (FAY) - US',
  id: 'FAY',
  obj: {
    iata: 'FAY',
    iso: 'US',
    coordinates: '-78.88030242919922, 34.9911994934082',
    municipality: 'Fayetteville'
  }
}, {
  label: 'Drake Field (FYV) - US',
  id: 'FYV',
  obj: {
    iata: 'FYV',
    iso: 'US',
    coordinates: '-94.17009735107422, 36.00510025024414',
    municipality: 'Fayetteville'
  }
}, {
  label: 'Pope Field (POB) - US',
  id: 'POB',
  obj: {
    iata: 'POB',
    iso: 'US',
    coordinates: '-79.014503479004, 35.1708984375',
    municipality: 'Fayetteville'
  }
}, {
  label: 'Northwest Arkansas Regional Airport (XNA) - US',
  id: 'XNA',
  obj: {
    iata: 'XNA',
    iso: 'US',
    coordinates: '-94.306801, 36.281898',
    municipality: 'Fayetteville/Springdale/Rogers'
  }
}, {
  label: 'Fernando de Noronha Airport (FEN) - BR',
  id: 'FEN',
  obj: {
    iata: 'FEN',
    iso: 'BR',
    coordinates: '-32.423302, -3.85493',
    municipality: 'Fernando De Noronha'
  }
}, {
  label: 'Sa\u00c3\u00afss Airport (FEZ) - MA',
  id: 'FEZ',
  obj: {
    iata: 'FEZ',
    iso: 'MA',
    coordinates: '-4.977960109709999, 33.9272994995',
    municipality: 'Fes'
  }
}, {
  label: 'Ficksburg Sentraoes Airport (FCB) - ZA',
  id: 'FCB',
  obj: {
    iata: 'FCB',
    iso: 'ZA',
    coordinates: '27.908899307250977, -28.82309913635254',
    municipality: 'Ficksburg'
  }
}, {
  label: 'Figari Sud-Corse Airport (FSC) - FR',
  id: 'FSC',
  obj: {
    iata: 'FSC',
    iso: 'FR',
    coordinates: '9.097780227661133, 41.5005989074707',
    municipality: 'Figari Sud-Corse'
  }
}, {
  label: 'Findlay Airport (FDY) - US',
  id: 'FDY',
  obj: {
    iata: 'FDY',
    iso: 'US',
    coordinates: '-83.66870117190001, 41.013500213600004',
    municipality: 'Findlay'
  }
}, {
  label: 'Peretola Airport (FLR) - IT',
  id: 'FLR',
  obj: {
    iata: 'FLR',
    iso: 'IT',
    coordinates: '11.2051, 43.810001',
    municipality: 'Firenze'
  }
}, {
  label: 'Fitiuta Airport (FTI) - AS',
  id: 'FTI',
  obj: {
    iata: 'FTI',
    iso: 'AS',
    coordinates: '-169.425003, -14.2172',
    municipality: 'Fitiuta Village'
  }
}, {
  label: 'Flagstaff Pulliam Airport (FLG) - US',
  id: 'FLG',
  obj: {
    iata: 'FLG',
    iso: 'US',
    coordinates: '-111.6709976, 35.13850021',
    municipality: 'Flagstaff'
  }
}, {
  label: 'Flin Flon Airport (YFO) - CA',
  id: 'YFO',
  obj: {
    iata: 'YFO',
    iso: 'CA',
    coordinates: '-101.68199920654297, 54.6781005859375',
    municipality: 'Flin Flon'
  }
}, {
  label: 'Bishop International Airport (FNT) - US',
  id: 'FNT',
  obj: {
    iata: 'FNT',
    iso: 'US',
    coordinates: '-83.74359893798828, 42.96540069580078',
    municipality: 'Flint'
  }
}, {
  label: 'Florence Regional Airport (FLO) - US',
  id: 'FLO',
  obj: {
    iata: 'FLO',
    iso: 'US',
    coordinates: '-79.7238998413086, 34.18539810180664',
    municipality: 'Florence'
  }
}, {
  label: 'Gustavo Artunduaga Paredes Airport (FLA) - CO',
  id: 'FLA',
  obj: {
    iata: 'FLA',
    iso: 'CO',
    coordinates: '-75.5644, 1.58919',
    municipality: 'Florencia'
  }
}, {
  label: 'Herc\u00c3\u00adlio Luz International Airport (FLN) - BR',
  id: 'FLN',
  obj: {
    iata: 'FLN',
    iso: 'BR',
    coordinates: '-48.5525016784668, -27.670278549194336',
    municipality: 'Florian\u00c3\u00b3polis'
  }
}, {
  label: 'Flor\u00c3\u00b8 Airport (FRO) - NO',
  id: 'FRO',
  obj: {
    iata: 'FRO',
    iso: 'NO',
    coordinates: '5.0247201919556, 61.583599090576',
    municipality: 'Flor\u00c3\u00b8'
  }
}, {
  label: 'Foggia "Gino Lisa" Airport (FOG) - IT',
  id: 'FOG',
  obj: {
    iata: 'FOG',
    iso: 'IT',
    coordinates: '15.535, 41.432899',
    municipality: 'Foggia'
  }
}, {
  label: 'Fond-Du-Lac Airport (ZFD) - CA',
  id: 'ZFD',
  obj: {
    iata: 'ZFD',
    iso: 'CA',
    coordinates: '-107.18199920654297, 59.33440017700195',
    municipality: 'Fond-Du-Lac'
  }
}, {
  label: 'Forbes Airport (FRB) - AU',
  id: 'FRB',
  obj: {
    iata: 'FRB',
    iso: 'AU',
    coordinates: '147.934998, -33.363602',
    municipality: 'Forbes'
  }
}, {
  label: 'Forestville Airport (YFE) - CA',
  id: 'YFE',
  obj: {
    iata: 'YFE',
    iso: 'CA',
    coordinates: '-69.09719848632812, 48.74610137939453',
    municipality: 'Forestville'
  }
}, {
  label: 'Forl\u00c3\u00ac Airport (FRL) - IT',
  id: 'FRL',
  obj: {
    iata: 'FRL',
    iso: 'IT',
    coordinates: '12.0701, 44.194801',
    municipality: 'Forl\u00c3\u00ac (FC)'
  }
}, {
  label: 'Formosa Airport (FMA) - AR',
  id: 'FMA',
  obj: {
    iata: 'FMA',
    iso: 'AR',
    coordinates: '-58.2281, -26.2127',
    municipality: 'Formosa'
  }
}, {
  label: 'Fort Albany Airport (YFA) - CA',
  id: 'YFA',
  obj: {
    iata: 'YFA',
    iso: 'CA',
    coordinates: '-81.6968994140625, 52.20140075683594',
    municipality: 'Fort Albany'
  }
}, {
  label: 'Davison Army Air Field (DAA) - US',
  id: 'DAA',
  obj: {
    iata: 'DAA',
    iso: 'US',
    coordinates: '-77.1809997559, 38.715000152600005',
    municipality: 'Fort Belvoir'
  }
}, {
  label: 'Lawson Army Air Field (Fort Benning) (LSF) - US',
  id: 'LSF',
  obj: {
    iata: 'LSF',
    iso: 'US',
    coordinates: '-84.9913024902, 32.337299346900004',
    municipality: 'Fort Benning(Columbus)'
  }
}, {
  label: 'Biggs Army Air Field (Fort Bliss) (BIF) - US',
  id: 'BIF',
  obj: {
    iata: 'BIF',
    iso: 'US',
    coordinates: '-106.3799973, 31.84950066',
    municipality: 'Fort Bliss/El Paso'
  }
}, {
  label: 'Simmons Army Air Field (FBG) - US',
  id: 'FBG',
  obj: {
    iata: 'FBG',
    iso: 'US',
    coordinates: '-78.93669891, 35.13180161',
    municipality: 'Fort Bragg'
  }
}, {
  label: 'Campbell AAF (Fort Campbell) Air Field (HOP) - US',
  id: 'HOP',
  obj: {
    iata: 'HOP',
    iso: 'US',
    coordinates: '-87.49620056150002, 36.668598175',
    municipality: 'Fort Campbell/Hopkinsville'
  }
}, {
  label: 'Butts AAF (Fort Carson) Air Field (FCS) - US',
  id: 'FCS',
  obj: {
    iata: 'FCS',
    iso: 'US',
    coordinates: '-104.7570038, 38.67839813',
    municipality: 'Fort Carson'
  }
}, {
  label: 'Fort Chipewyan Airport (YPY) - CA',
  id: 'YPY',
  obj: {
    iata: 'YPY',
    iso: 'CA',
    coordinates: '-111.11699676513672, 58.7672004699707',
    municipality: 'Fort Chipewyan'
  }
}, {
  label: 'Fort Dodge Regional Airport (FOD) - US',
  id: 'FOD',
  obj: {
    iata: 'FOD',
    iso: 'US',
    coordinates: '-94.19259644, 42.55149841',
    municipality: 'Fort Dodge'
  }
}, {
  label: 'Felker Army Air Field (FAF) - US',
  id: 'FAF',
  obj: {
    iata: 'FAF',
    iso: 'US',
    coordinates: '-76.60880279540001, 37.132499694799996',
    municipality: 'Fort Eustis'
  }
}, {
  label: 'Fort Frances Municipal Airport (YAG) - CA',
  id: 'YAG',
  obj: {
    iata: 'YAG',
    iso: 'CA',
    coordinates: '-93.439697265625, 48.65420150756836',
    municipality: 'Fort Frances'
  }
}, {
  label: 'Fort Good Hope Airport (YGH) - CA',
  id: 'YGH',
  obj: {
    iata: 'YGH',
    iso: 'CA',
    coordinates: '-128.6510009765625, 66.24079895019531',
    municipality: 'Fort Good Hope'
  }
}, {
  label: 'Hood Army Air Field (HLR) - US',
  id: 'HLR',
  obj: {
    iata: 'HLR',
    iso: 'US',
    coordinates: '-97.71450042720001, 31.138700485199998',
    municipality: 'Fort Hood(Killeen)'
  }
}, {
  label: 'Robert Gray  Army Air Field Airport (GRK) - US',
  id: 'GRK',
  obj: {
    iata: 'GRK',
    iso: 'US',
    coordinates: '-97.82890319820001, 31.067199707',
    municipality: 'Fort Hood/Killeen'
  }
}, {
  label: 'Fort Hope Airport (YFH) - CA',
  id: 'YFH',
  obj: {
    iata: 'YFH',
    iso: 'CA',
    coordinates: '-87.90779876708984, 51.5619010925293',
    municipality: 'Fort Hope'
  }
}, {
  label: 'Sierra Vista Municipal Airport / Libby Army Air Field (FHU) - US',
  id: 'FHU',
  obj: {
    iata: 'FHU',
    iso: 'US',
    coordinates: '-110.348225, 31.587383',
    municipality: 'Fort Huachuca / Sierra Vista'
  }
}, {
  label: 'Muir Army Air Field (Fort Indiantown Gap) Airport (MUI) - US',
  id: 'MUI',
  obj: {
    iata: 'MUI',
    iso: 'US',
    coordinates: '-76.569397, 40.434799',
    municipality: 'Fort Indiantown Gap(Annville)'
  }
}, {
  label: 'Bicycle Lake Army Air Field (BYS) - US',
  id: 'BYS',
  obj: {
    iata: 'BYS',
    iso: 'US',
    coordinates: '-116.629997253, 35.2804985046',
    municipality: 'Fort Irwin/Barstow'
  }
}, {
  label: 'Godman Army Air Field (FTK) - US',
  id: 'FTK',
  obj: {
    iata: 'FTK',
    iso: 'US',
    coordinates: '-85.9720993042, 37.907100677500004',
    municipality: 'Fort Knox'
  }
}, {
  label: 'Fort Lauderdale Hollywood International Airport (FLL) - US',
  id: 'FLL',
  obj: {
    iata: 'FLL',
    iso: 'US',
    coordinates: '-80.152702, 26.072599',
    municipality: 'Fort Lauderdale'
  }
}, {
  label: 'Fort Lauderdale Executive Airport (FXE) - US',
  id: 'FXE',
  obj: {
    iata: 'FXE',
    iso: 'US',
    coordinates: '-80.1707000732, 26.1972999573',
    municipality: 'Fort Lauderdale'
  }
}, {
  label: 'Waynesville-St. Robert Regional Forney field (TBN) - US',
  id: 'TBN',
  obj: {
    iata: 'TBN',
    iso: 'US',
    coordinates: '-92.14070129, 37.74160004',
    municipality: 'Fort Leonard Wood'
  }
}, {
  label: 'Gray Army Air Field (GRF) - US',
  id: 'GRF',
  obj: {
    iata: 'GRF',
    iso: 'US',
    coordinates: '-122.5810013, 47.07920074',
    municipality: 'Fort Lewis/Tacoma'
  }
}, {
  label: 'Fort Liard Airport (YJF) - CA',
  id: 'YJF',
  obj: {
    iata: 'YJF',
    iso: 'CA',
    coordinates: '-123.46900177, 60.235801696799996',
    municipality: 'Fort Liard'
  }
}, {
  label: 'Fort McMurray Airport (YMM) - CA',
  id: 'YMM',
  obj: {
    iata: 'YMM',
    iso: 'CA',
    coordinates: '-111.222000122, 56.653301239',
    municipality: 'Fort McMurray'
  }
}, {
  label: 'Fort Mcpherson Airport (ZFM) - CA',
  id: 'ZFM',
  obj: {
    iata: 'ZFM',
    iso: 'CA',
    coordinates: '-134.86099243164062, 67.40750122070312',
    municipality: 'Fort Mcpherson'
  }
}, {
  label: 'Tipton Airport (FME) - US',
  id: 'FME',
  obj: {
    iata: 'FME',
    iso: 'US',
    coordinates: '-76.7593994141, 39.08539962769999',
    municipality: 'Fort Meade(Odenton)'
  }
}, {
  label: 'Page Field (FMY) - US',
  id: 'FMY',
  obj: {
    iata: 'FMY',
    iso: 'US',
    coordinates: '-81.86329650879999, 26.58659935',
    municipality: 'Fort Myers'
  }
}, {
  label: 'Southwest Florida International Airport (RSW) - US',
  id: 'RSW',
  obj: {
    iata: 'RSW',
    iso: 'US',
    coordinates: '-81.75520324707031, 26.53619956970215',
    municipality: 'Fort Myers'
  }
}, {
  label: 'Fort Nelson Airport (YYE) - CA',
  id: 'YYE',
  obj: {
    iata: 'YYE',
    iso: 'CA',
    coordinates: '-122.597000122, 58.8363990784',
    municipality: 'Fort Nelson'
  }
}, {
  label: 'St Lucie County International Airport (FPR) - US',
  id: 'FPR',
  obj: {
    iata: 'FPR',
    iso: 'US',
    coordinates: '-80.36830139, 27.49510002',
    municipality: 'Fort Pierce'
  }
}, {
  label: 'Polk Army Air Field (POE) - US',
  id: 'POE',
  obj: {
    iata: 'POE',
    iso: 'US',
    coordinates: '-93.1917038, 31.0447998',
    municipality: 'Fort Polk'
  }
}, {
  label: 'Fort Resolution Airport (YFR) - CA',
  id: 'YFR',
  obj: {
    iata: 'YFR',
    iso: 'CA',
    coordinates: '-113.690002441, 61.1808013916',
    municipality: 'Fort Resolution'
  }
}, {
  label: 'Marshall Army Air Field (FRI) - US',
  id: 'FRI',
  obj: {
    iata: 'FRI',
    iso: 'US',
    coordinates: '-96.76450348, 39.05530167',
    municipality: 'Fort Riley(Junction City)'
  }
}, {
  label: 'Cairns AAF (Fort Rucker) Air Field (OZR) - US',
  id: 'OZR',
  obj: {
    iata: 'OZR',
    iso: 'US',
    coordinates: '-85.71340179, 31.27569962',
    municipality: 'Fort Rucker/Ozark'
  }
}, {
  label: 'Zhob Airport (PZH) - PK',
  id: 'PZH',
  obj: {
    iata: 'PZH',
    iso: 'PK',
    coordinates: '69.4636001586914, 31.358400344848633',
    municipality: 'Fort Sandeman'
  }
}, {
  label: 'Fort Severn Airport (YER) - CA',
  id: 'YER',
  obj: {
    iata: 'YER',
    iso: 'CA',
    coordinates: '-87.67610168457031, 56.01890182495117',
    municipality: 'Fort Severn'
  }
}, {
  label: 'Henry Post Army Air Field (Fort Sill) (FSI) - US',
  id: 'FSI',
  obj: {
    iata: 'FSI',
    iso: 'US',
    coordinates: '-98.40219879, 34.64979935',
    municipality: 'Fort Sill'
  }
}, {
  label: 'Fort Simpson Airport (YFS) - CA',
  id: 'YFS',
  obj: {
    iata: 'YFS',
    iso: 'CA',
    coordinates: '-121.23699951171875, 61.76020050048828',
    municipality: 'Fort Simpson'
  }
}, {
  label: 'Fort Smith Airport (YSM) - CA',
  id: 'YSM',
  obj: {
    iata: 'YSM',
    iso: 'CA',
    coordinates: '-111.96199798583984, 60.020301818847656',
    municipality: 'Fort Smith'
  }
}, {
  label: 'Fort Smith Regional Airport (FSM) - US',
  id: 'FSM',
  obj: {
    iata: 'FSM',
    iso: 'US',
    coordinates: '-94.36740112304688, 35.33660125732422',
    municipality: 'Fort Smith'
  }
}, {
  label: 'Fort St John Airport (YXJ) - CA',
  id: 'YXJ',
  obj: {
    iata: 'YXJ',
    iso: 'CA',
    coordinates: '-120.739998, 56.238098',
    municipality: 'Fort St.John'
  }
}, {
  label: 'Fort Stockton Pecos County Airport (FST) - US',
  id: 'FST',
  obj: {
    iata: 'FST',
    iso: 'US',
    coordinates: '-102.916000366, 30.9157009125',
    municipality: 'Fort Stockton'
  }
}, {
  label: 'Fort Wayne International Airport (FWA) - US',
  id: 'FWA',
  obj: {
    iata: 'FWA',
    iso: 'US',
    coordinates: '-85.19509888, 40.97850037',
    municipality: 'Fort Wayne'
  }
}, {
  label: 'Fort Worth Alliance Airport (AFW) - US',
  id: 'AFW',
  obj: {
    iata: 'AFW',
    iso: 'US',
    coordinates: '-97.31880187990001, 32.9875984192',
    municipality: 'Fort Worth'
  }
}, {
  label: 'Fort Worth Meacham International Airport (FTW) - US',
  id: 'FTW',
  obj: {
    iata: 'FTW',
    iso: 'US',
    coordinates: '-97.362396, 32.819801',
    municipality: 'Fort Worth'
  }
}, {
  label: 'NAS Fort Worth JRB/Carswell Field (FWH) - US',
  id: 'FWH',
  obj: {
    iata: 'FWH',
    iso: 'US',
    coordinates: '-97.4414978, 32.76919937',
    municipality: 'Fort Worth'
  }
}, {
  label: 'Fort Yukon Airport (FYU) - US',
  id: 'FYU',
  obj: {
    iata: 'FYU',
    iso: 'US',
    coordinates: '-145.25, 66.57150268554688',
    municipality: 'Fort Yukon'
  }
}, {
  label: 'Martinique Aim\u00c3\u00a9 C\u00c3\u00a9saire International Airport (FDF) - MQ',
  id: 'FDF',
  obj: {
    iata: 'FDF',
    iso: 'MQ',
    coordinates: '-61.00320053100586, 14.590999603271484',
    municipality: 'Fort-de-France'
  }
}, {
  label: 'Pinto Martins International Airport (FOR) - BR',
  id: 'FOR',
  obj: {
    iata: 'FOR',
    iso: 'BR',
    coordinates: '-38.53260040283203, -3.776279926300049',
    municipality: 'Fortaleza'
  }
}, {
  label: 'Foshan Shadi Airport (FUO) - CN',
  id: 'FUO',
  obj: {
    iata: 'FUO',
    iso: 'CN',
    coordinates: '113.069999695, 23.083299636799996',
    municipality: 'Foshan'
  }
}, {
  label: 'Foumban Nkounja Airport (FOM) - CM',
  id: 'FOM',
  obj: {
    iata: 'FOM',
    iso: 'CM',
    coordinates: '10.750800132751465, 5.636919975280762',
    municipality: 'Foumban'
  }
}, {
  label: 'Cataratas International Airport (IGU) - BR',
  id: 'IGU',
  obj: {
    iata: 'IGU',
    iso: 'BR',
    coordinates: '-54.48500061035156, -25.600278854370117',
    municipality: 'Foz Do Igua\u00c3\u00a7u'
  }
}, {
  label: "M'Vengue El Hadj Omar Bongo Ondimba International Airport (MVB) - GA",
  id: 'MVB',
  obj: {
    iata: 'MVB',
    iso: 'GA',
    coordinates: '13.437999725341797, -1.6561599969863892',
    municipality: 'Franceville'
  }
}, {
  label: 'Francistown Airport (FRW) - BW',
  id: 'FRW',
  obj: {
    iata: 'FRW',
    iso: 'BW',
    coordinates: '27.47450065612793, -21.15959930419922',
    municipality: 'Francistown'
  }
}, {
  label: 'Frankfurt am Main Airport (FRA) - DE',
  id: 'FRA',
  obj: {
    iata: 'FRA',
    iso: 'DE',
    coordinates: '8.570556, 50.033333',
    municipality: 'Frankfurt am Main'
  }
}, {
  label: 'Frankfurt-Hahn Airport (HHN) - DE',
  id: 'HHN',
  obj: {
    iata: 'HHN',
    iso: 'DE',
    coordinates: '7.26389, 49.9487',
    municipality: 'Frankfurt am Main'
  }
}, {
  label: 'Venango Regional Airport (FKL) - US',
  id: 'FKL',
  obj: {
    iata: 'FKL',
    iso: 'US',
    coordinates: '-79.8603973389, 41.3778991699',
    municipality: 'Franklin'
  }
}, {
  label: 'Fredericton Airport (YFC) - CA',
  id: 'YFC',
  obj: {
    iata: 'YFC',
    iso: 'CA',
    coordinates: '-66.53720092773438, 45.868900299072266',
    municipality: 'Fredericton'
  }
}, {
  label: 'Grand Bahama International Airport (FPO) - BS',
  id: 'FPO',
  obj: {
    iata: 'FPO',
    iso: 'BS',
    coordinates: '-78.695602417, 26.5587005615',
    municipality: 'Freeport'
  }
}, {
  label: 'Lungi International Airport (FNA) - SL',
  id: 'FNA',
  obj: {
    iata: 'FNA',
    iso: 'SL',
    coordinates: '-13.1955, 8.61644',
    municipality: 'Freetown'
  }
}, {
  label: 'Fresno Yosemite International Airport (FAT) - US',
  id: 'FAT',
  obj: {
    iata: 'FAT',
    iso: 'US',
    coordinates: '-119.718002, 36.776199',
    municipality: 'Fresno'
  }
}, {
  label: 'Friedrichshafen Airport (FDH) - DE',
  id: 'FDH',
  obj: {
    iata: 'FDH',
    iso: 'DE',
    coordinates: '9.51148986816, 47.671298980699994',
    municipality: 'Friedrichshafen'
  }
}, {
  label: 'Fritzlar Army Airfield (FRZ) - DE',
  id: 'FRZ',
  obj: {
    iata: 'FRZ',
    iso: 'DE',
    coordinates: '9.286, 51.1146',
    municipality: 'Fritzlar'
  }
}, {
  label: 'Fuerteventura Airport (FUE) - ES',
  id: 'FUE',
  obj: {
    iata: 'FUE',
    iso: 'ES',
    coordinates: '-13.863800048828125, 28.452699661254883',
    municipality: 'Fuerteventura Island'
  }
}, {
  label: 'Fukuoka Airport (FUK) - JP',
  id: 'FUK',
  obj: {
    iata: 'FUK',
    iso: 'JP',
    coordinates: '130.4510040283203, 33.585899353027344',
    municipality: 'Fukuoka'
  }
}, {
  label: 'Funafuti International Airport (FUN) - TV',
  id: 'FUN',
  obj: {
    iata: 'FUN',
    iso: 'TV',
    coordinates: '179.195999, -8.525',
    municipality: 'Funafuti'
  }
}, {
  label: 'Madeira Airport (FNC) - PT',
  id: 'FNC',
  obj: {
    iata: 'FNC',
    iso: 'PT',
    coordinates: '-16.7745, 32.697899',
    municipality: 'Funchal'
  }
}, {
  label: 'Yokota Air Base (OKO) - JP',
  id: 'OKO',
  obj: {
    iata: 'OKO',
    iso: 'JP',
    coordinates: '139.34800720214844, 35.74850082397461',
    municipality: 'Fussa'
  }
}, {
  label: 'Pointe Vele Airport (FUT) - WF',
  id: 'FUT',
  obj: {
    iata: 'FUT',
    iso: 'WF',
    coordinates: '-178.065994263, -14.3114004135',
    municipality: 'Futuna Island'
  }
}, {
  label: 'Gabala International Airport (GBB) - AZ',
  id: 'GBB',
  obj: {
    iata: 'GBB',
    iso: 'AZ',
    coordinates: '47.7125, 40.826667',
    municipality: 'Gabala'
  }
}, {
  label: 'Sir Seretse Khama International Airport (GBE) - BW',
  id: 'GBE',
  obj: {
    iata: 'GBE',
    iso: 'BW',
    coordinates: '25.9182, -24.555201',
    municipality: 'Gaborone'
  }
}, {
  label: 'Gab\u00c3\u00a8s Matmata International Airport (GAE) - TN',
  id: 'GAE',
  obj: {
    iata: 'GAE',
    iso: 'TN',
    coordinates: '10.103300094604492, 33.87689971923828',
    municipality: 'Gab\u00c3\u00a8s'
  }
}, {
  label: 'Gachsaran Airport (GCH) - IR',
  id: 'GCH',
  obj: {
    iata: 'GCH',
    iso: 'IR',
    coordinates: '50.827999115, 30.337600708',
    municipality: 'Gachsaran'
  }
}, {
  label: 'Gafsa Ksar International Airport (GAF) - TN',
  id: 'GAF',
  obj: {
    iata: 'GAF',
    iso: 'TN',
    coordinates: '8.822500228881836, 34.422000885009766',
    municipality: 'Gafsa'
  }
}, {
  label: 'Gainesville Regional Airport (GNV) - US',
  id: 'GNV',
  obj: {
    iata: 'GNV',
    iso: 'US',
    coordinates: '-82.2717971802, 29.6900997162',
    municipality: 'Gainesville'
  }
}, {
  label: 'Edward G. Pitka Sr Airport (GAL) - US',
  id: 'GAL',
  obj: {
    iata: 'GAL',
    iso: 'US',
    coordinates: '-156.9369965, 64.73619843',
    municipality: 'Galena'
  }
}, {
  label: 'Koggala Airport (KCT) - LK',
  id: 'KCT',
  obj: {
    iata: 'KCT',
    iso: 'LK',
    coordinates: '80.32029724121094, 5.993680000305176',
    municipality: 'Galle'
  }
}, {
  label: 'Gallup Municipal Airport (GUP) - US',
  id: 'GUP',
  obj: {
    iata: 'GUP',
    iso: 'US',
    coordinates: '-108.789001465, 35.511100769',
    municipality: 'Gallup'
  }
}, {
  label: 'Scholes International At Galveston Airport (GLS) - US',
  id: 'GLS',
  obj: {
    iata: 'GLS',
    iso: 'US',
    coordinates: '-94.86039733886719, 29.265300750732422',
    municipality: 'Galveston'
  }
}, {
  label: 'Galway Airport (GWY) - IE',
  id: 'GWY',
  obj: {
    iata: 'GWY',
    iso: 'IE',
    coordinates: '-8.941590309143066, 53.300201416015625',
    municipality: 'Galway'
  }
}, {
  label: 'Gambella Airport (GMB) - ET',
  id: 'GMB',
  obj: {
    iata: 'GMB',
    iso: 'ET',
    coordinates: '34.5630989074707, 8.12876033782959',
    municipality: 'Gambela'
  }
}, {
  label: 'Gambell Airport (GAM) - US',
  id: 'GAM',
  obj: {
    iata: 'GAM',
    iso: 'US',
    coordinates: '-171.73300170898438, 63.76679992675781',
    municipality: 'Gambell'
  }
}, {
  label: 'Rae Lakes Airport (YRA) - CA',
  id: 'YRA',
  obj: {
    iata: 'YRA',
    iso: 'CA',
    coordinates: '-117.30999755859375, 64.11609649658203',
    municipality: 'Gam\u00c3\u00a8t\u00c3\u00ac'
  }
}, {
  label: 'Gan International Airport (GAN) - MV',
  id: 'GAN',
  obj: {
    iata: 'GAN',
    iso: 'MV',
    coordinates: '73.155602, -0.693342',
    municipality: 'Gan'
  }
}, {
  label: 'Gander International Airport (YQX) - CA',
  id: 'YQX',
  obj: {
    iata: 'YQX',
    iso: 'CA',
    coordinates: '-54.56809997558594, 48.9369010925293',
    municipality: 'Gander'
  }
}, {
  label: 'Gangneung Airport (K-18) (KAG) - KR',
  id: 'KAG',
  obj: {
    iata: 'KAG',
    iso: 'KR',
    coordinates: '128.943915, 37.753601',
    municipality: 'Gangneung'
  }
}, {
  label: 'Ganja International Airport (KVD) - AZ',
  id: 'KVD',
  obj: {
    iata: 'KVD',
    iso: 'AZ',
    coordinates: '46.3176, 40.737701',
    municipality: 'Ganja'
  }
}, {
  label: 'Vijayawada Airport (VGA) - IN',
  id: 'VGA',
  obj: {
    iata: 'VGA',
    iso: 'IN',
    coordinates: '80.796799, 16.530399',
    municipality: 'Gannavaram'
  }
}, {
  label: 'Garden City Regional Airport (GCK) - US',
  id: 'GCK',
  obj: {
    iata: 'GCK',
    iso: 'US',
    coordinates: '-100.723999023, 37.9275016785',
    municipality: 'Garden City'
  }
}, {
  label: 'Garoua International Airport (GOU) - CM',
  id: 'GOU',
  obj: {
    iata: 'GOU',
    iso: 'CM',
    coordinates: '13.370100021362305, 9.33588981628418',
    municipality: 'Garoua'
  }
}, {
  label: 'Gary Chicago International Airport (GYY) - US',
  id: 'GYY',
  obj: {
    iata: 'GYY',
    iso: 'US',
    coordinates: '-87.41280364990234, 41.61629867553711',
    municipality: 'Gary'
  }
}, {
  label: 'Marinduque Airport (MRQ) - PH',
  id: 'MRQ',
  obj: {
    iata: 'MRQ',
    iso: 'PH',
    coordinates: '121.82599639892578, 13.361000061035156',
    municipality: 'Gasan'
  }
}, {
  label: 'Gasp\u00c3\u00a9 (Michel-Pouliot) Airport (YGP) - CA',
  id: 'YGP',
  obj: {
    iata: 'YGP',
    iso: 'CA',
    coordinates: '-64.4785995483, 48.7752990723',
    municipality: 'Gasp\u00c3\u00a9'
  }
}, {
  label: 'Ottawa / Gatineau Airport (YND) - CA',
  id: 'YND',
  obj: {
    iata: 'YND',
    iso: 'CA',
    coordinates: '-75.563599, 45.521702',
    municipality: 'Gatineau'
  }
}, {
  label: 'Gaua Island Airport (ZGU) - VU',
  id: 'ZGU',
  obj: {
    iata: 'ZGU',
    iso: 'VU',
    coordinates: '167.587005615, -14.218099594099998',
    municipality: 'Gaua Island'
  }
}, {
  label: 'Gaziantep International Airport (GZT) - TR',
  id: 'GZT',
  obj: {
    iata: 'GZT',
    iso: 'TR',
    coordinates: '37.4786987305, 36.9472007751',
    municipality: 'Gaziantep'
  }
}, {
  label: 'Gazipa\u00c5\u009fa Airport (GZP) - TR',
  id: 'GZP',
  obj: {
    iata: 'GZP',
    iso: 'TR',
    coordinates: '32.300598, 36.299217',
    municipality: 'Gazipa\u00c5\u009fa'
  }
}, {
  label: 'Gda\u00c5\u0084sk Lech Wa\u00c5\u0082\u00c4\u0099sa Airport (GDN) - PL',
  id: 'GDN',
  obj: {
    iata: 'GDN',
    iso: 'PL',
    coordinates: '18.46619987487793, 54.377601623535156',
    municipality: 'Gda\u00c5\u0084sk'
  }
}, {
  label: 'Oksywie Military Air Base (QYD) - PL',
  id: 'QYD',
  obj: {
    iata: 'QYD',
    iso: 'PL',
    coordinates: '18.51720047, 54.57970047',
    municipality: 'Gdynia'
  }
}, {
  label: 'Skien Airport (SKE) - NO',
  id: 'SKE',
  obj: {
    iata: 'SKE',
    iso: 'NO',
    coordinates: '9.566940307617188, 59.185001373291016',
    municipality: 'Geiteryggen'
  }
}, {
  label: 'Gelendzhik Airport (GDZ) - RU',
  id: 'GDZ',
  obj: {
    iata: 'GDZ',
    iso: 'RU',
    coordinates: '38.0124807358, 44.5820926295',
    municipality: 'Gelendzhik'
  }
}, {
  label: 'Gelephu Airport (GLU) - BT',
  id: 'GLU',
  obj: {
    iata: 'GLU',
    iso: 'BT',
    coordinates: '90.46412, 26.88456',
    municipality: 'Gelephu'
  }
}, {
  label: 'Gemena Airport (GMA) - CD',
  id: 'GMA',
  obj: {
    iata: 'GMA',
    iso: 'CD',
    coordinates: '19.771299362199997, 3.2353699207299997',
    municipality: 'Gemena'
  }
}, {
  label: 'General Pico Airport (GPO) - AR',
  id: 'GPO',
  obj: {
    iata: 'GPO',
    iso: 'AR',
    coordinates: '-63.7583007812, -35.6962013245',
    municipality: 'General Pico'
  }
}, {
  label: 'General Santos International Airport (GES) - PH',
  id: 'GES',
  obj: {
    iata: 'GES',
    iso: 'PH',
    coordinates: '125.096000671, 6.05800008774',
    municipality: 'General Santos'
  }
}, {
  label: 'Geneva Cointrin International Airport (GVA) - CH',
  id: 'GVA',
  obj: {
    iata: 'GVA',
    iso: 'CH',
    coordinates: '6.108950138092041, 46.23809814453125',
    municipality: 'Geneva'
  }
}, {
  label: 'Genoa Cristoforo Colombo Airport (GOA) - IT',
  id: 'GOA',
  obj: {
    iata: 'GOA',
    iso: 'IT',
    coordinates: '8.8375, 44.4133',
    municipality: 'Genova'
  }
}, {
  label: 'George Airport (GRJ) - ZA',
  id: 'GRJ',
  obj: {
    iata: 'GRJ',
    iso: 'ZA',
    coordinates: '22.378902, -34.0056',
    municipality: 'George'
  }
}, {
  label: 'Exuma International Airport (GGT) - BS',
  id: 'GGT',
  obj: {
    iata: 'GGT',
    iso: 'BS',
    coordinates: '-75.8779983521, 23.5625991821',
    municipality: 'George Town'
  }
}, {
  label: 'Owen Roberts International Airport (GCM) - KY',
  id: 'GCM',
  obj: {
    iata: 'GCM',
    iso: 'KY',
    coordinates: '-81.3576965332, 19.292800903299998',
    municipality: 'Georgetown'
  }
}, {
  label: 'Cheddi Jagan International Airport (GEO) - GY',
  id: 'GEO',
  obj: {
    iata: 'GEO',
    iso: 'GY',
    coordinates: '-58.25410079956055, 6.498549938201904',
    municipality: 'Georgetown'
  }
}, {
  label: 'Geraldton Greenstone Regional Airport (YGQ) - CA',
  id: 'YGQ',
  obj: {
    iata: 'YGQ',
    iso: 'CA',
    coordinates: '-86.93939971923828, 49.77830123901367',
    municipality: 'Geraldton'
  }
}, {
  label: 'Geraldton Airport (GET) - AU',
  id: 'GET',
  obj: {
    iata: 'GET',
    iso: 'AU',
    coordinates: '114.707001, -28.796101',
    municipality: 'Geraldton'
  }
}, {
  label: 'Lefkoniko Airport (GEC) - CY',
  id: 'GEC',
  obj: {
    iata: 'GEC',
    iso: 'CY',
    coordinates: '33.724358, 35.235947',
    municipality: 'Ge\u00c3\u00a7itkale'
  }
}, {
  label: 'Ghadames East Airport (LTD) - LY',
  id: 'LTD',
  obj: {
    iata: 'LTD',
    iso: 'LY',
    coordinates: '9.715310096740723, 30.15169906616211',
    municipality: 'Ghadames'
  }
}, {
  label: 'Noum\u00c3\u00a9rat - Moufdi Zakaria Airport (GHA) - DZ',
  id: 'GHA',
  obj: {
    iata: 'GHA',
    iso: 'DZ',
    coordinates: '3.794110059738159, 32.38410186767578',
    municipality: 'Gharda\u00c3\u00afa'
  }
}, {
  label: 'Ghat Airport (GHT) - LY',
  id: 'GHT',
  obj: {
    iata: 'GHT',
    iso: 'LY',
    coordinates: '10.142600059500001, 25.1455993652',
    municipality: 'Ghat'
  }
}, {
  label: 'Gibraltar Airport (GIB) - GI',
  id: 'GIB',
  obj: {
    iata: 'GIB',
    iso: 'GI',
    coordinates: '-5.3496599197400005, 36.1511993408',
    municipality: 'Gibraltar'
  }
}, {
  label: 'Gifu Airport (QGU) - JP',
  id: 'QGU',
  obj: {
    iata: 'QGU',
    iso: 'JP',
    coordinates: '136.8699951171875, 35.394100189208984',
    municipality: 'Gifu'
  }
}, {
  label: 'Gilgit Airport (GIL) - PK',
  id: 'GIL',
  obj: {
    iata: 'GIL',
    iso: 'PK',
    coordinates: '74.33360290527344, 35.918800354003906',
    municipality: 'Gilgit'
  }
}, {
  label: 'Gillam Airport (YGX) - CA',
  id: 'YGX',
  obj: {
    iata: 'YGX',
    iso: 'CA',
    coordinates: '-94.71060180664062, 56.35749816894531',
    municipality: 'Gillam'
  }
}, {
  label: 'Gillette Campbell County Airport (GCC) - US',
  id: 'GCC',
  obj: {
    iata: 'GCC',
    iso: 'US',
    coordinates: '-105.539001465, 44.348899841299996',
    municipality: 'Gillette'
  }
}, {
  label: 'Gimli Industrial Park Airport (YGM) - CA',
  id: 'YGM',
  obj: {
    iata: 'YGM',
    iso: 'CA',
    coordinates: '-97.04329681396484, 50.62810134887695',
    municipality: 'Gimli'
  }
}, {
  label: 'Santiago Vila Airport (GIR) - CO',
  id: 'GIR',
  obj: {
    iata: 'GIR',
    iso: 'CO',
    coordinates: '-74.7967, 4.27624',
    municipality: 'Girardot'
  }
}, {
  label: 'Girona Airport (GRO) - ES',
  id: 'GRO',
  obj: {
    iata: 'GRO',
    iso: 'ES',
    coordinates: '2.7605500221, 41.901000977',
    municipality: 'Girona'
  }
}, {
  label: 'Gisborne Airport (GIS) - NZ',
  id: 'GIS',
  obj: {
    iata: 'GIS',
    iso: 'NZ',
    coordinates: '177.97799682617188, -38.663299560546875',
    municipality: 'Gisborne'
  }
}, {
  label: 'Gisenyi Airport (GYI) - RW',
  id: 'GYI',
  obj: {
    iata: 'GYI',
    iso: 'RW',
    coordinates: '29.258899688720703, -1.6771999597549438',
    municipality: 'Gisenyi'
  }
}, {
  label: 'Sphinx International Airport (SPX) - EG',
  id: 'SPX',
  obj: {
    iata: 'SPX',
    iso: 'EG',
    coordinates: '30.89569, 30.108148',
    municipality: 'Giza'
  }
}, {
  label: 'Gjoa Haven Airport (YHK) - CA',
  id: 'YHK',
  obj: {
    iata: 'YHK',
    iso: 'CA',
    coordinates: '-95.84970092770001, 68.635597229',
    municipality: 'Gjoa Haven'
  }
}, {
  label: 'Gladstone Airport (GLT) - AU',
  id: 'GLT',
  obj: {
    iata: 'GLT',
    iso: 'AU',
    coordinates: '151.223007, -23.869699',
    municipality: 'Gladstone'
  }
}, {
  label: 'Glasgow International Airport (GLA) - GB',
  id: 'GLA',
  obj: {
    iata: 'GLA',
    iso: 'GB',
    coordinates: '-4.43306, 55.871899',
    municipality: 'Glasgow'
  }
}, {
  label: 'Glasgow Prestwick Airport (PIK) - GB',
  id: 'PIK',
  obj: {
    iata: 'PIK',
    iso: 'GB',
    coordinates: '-4.586669921875, 55.5093994140625',
    municipality: 'Glasgow'
  }
}, {
  label: 'Wokal Field/Glasgow-Valley County Airport (GGW) - US',
  id: 'GGW',
  obj: {
    iata: 'GGW',
    iso: 'US',
    coordinates: '-106.614998, 48.212502',
    municipality: 'Glasgow'
  }
}, {
  label: 'Luke Air Force Base (LUF) - US',
  id: 'LUF',
  obj: {
    iata: 'LUF',
    iso: 'US',
    coordinates: '-112.383003235, 33.534999847399995',
    municipality: 'Glendale'
  }
}, {
  label: 'Dawson Community Airport (GDV) - US',
  id: 'GDV',
  obj: {
    iata: 'GDV',
    iso: 'US',
    coordinates: '-104.8069992, 47.13869858',
    municipality: 'Glendive'
  }
}, {
  label: 'Floyd Bennett Memorial Airport (GFL) - US',
  id: 'GFL',
  obj: {
    iata: 'GFL',
    iso: 'US',
    coordinates: '-73.6102981567, 43.3412017822',
    municipality: 'Glens Falls'
  }
}, {
  label: 'Glentanner Airport (GTN) - NZ',
  id: 'GTN',
  obj: {
    iata: 'GTN',
    iso: 'NZ',
    coordinates: '170.1280059814453, -43.906700134277344',
    municipality: 'Glentanner Station'
  }
}, {
  label: 'Gode Airport (GDE) - ET',
  id: 'GDE',
  obj: {
    iata: 'GDE',
    iso: 'ET',
    coordinates: '43.5786018372, 5.93513011932',
    municipality: 'Gode'
  }
}, {
  label: 'Gods Lake Narrows Airport (YGO) - CA',
  id: 'YGO',
  obj: {
    iata: 'YGO',
    iso: 'CA',
    coordinates: '-94.49140167236328, 54.55889892578125',
    municipality: 'Gods Lake Narrows'
  }
}, {
  label: 'Gods River Airport (ZGI) - CA',
  id: 'ZGI',
  obj: {
    iata: 'ZGI',
    iso: 'CA',
    coordinates: '-94.07859802246094, 54.839698791503906',
    municipality: 'Gods River'
  }
}, {
  label: 'Santa Genoveva Airport (GYN) - BR',
  id: 'GYN',
  obj: {
    iata: 'GYN',
    iso: 'BR',
    coordinates: '-49.220699310302734, -16.631999969482422',
    municipality: 'Goi\u00c3\u00a2nia'
  }
}, {
  label: 'Gold Coast Airport (OOL) - AU',
  id: 'OOL',
  obj: {
    iata: 'OOL',
    iso: 'AU',
    coordinates: '153.505004883, -28.1644001007',
    municipality: 'Gold Coast'
  }
}, {
  label: 'Seymour Johnson Air Force Base (GSB) - US',
  id: 'GSB',
  obj: {
    iata: 'GSB',
    iso: 'US',
    coordinates: '-77.96060181, 35.33940125',
    municipality: 'Goldsboro'
  }
}, {
  label: 'Szczecin-Goleni\u00c3\u00b3w "Solidarno\u00c5\u009b\u00c4\u0087" Airport (SZZ) - PL',
  id: 'SZZ',
  obj: {
    iata: 'SZZ',
    iso: 'PL',
    coordinates: '14.902199745199999, 53.584701538100006',
    municipality: 'Goleniow'
  }
}, {
  label: 'Golfito Airport (GLF) - CR',
  id: 'GLF',
  obj: {
    iata: 'GLF',
    iso: 'CR',
    coordinates: '-83.18219757080078, 8.654009819030762',
    municipality: 'Golfito'
  }
}, {
  label: 'Golmud Airport (GOQ) - CN',
  id: 'GOQ',
  obj: {
    iata: 'GOQ',
    iso: 'CN',
    coordinates: '94.786102, 36.4006',
    municipality: 'Golmud'
  }
}, {
  label: 'Golog Maqin Airport (GMQ) - CN',
  id: 'GMQ',
  obj: {
    iata: 'GMQ',
    iso: 'CN',
    coordinates: '100.301144, 34.418066',
    municipality: 'Golog'
  }
}, {
  label: 'Goma International Airport (GOM) - CD',
  id: 'GOM',
  obj: {
    iata: 'GOM',
    iso: 'CD',
    coordinates: '29.238500595092773, -1.6708099842071533',
    municipality: 'Goma'
  }
}, {
  label: 'Gombe Lawanti International Airport (GMO) - NG',
  id: 'GMO',
  obj: {
    iata: 'GMO',
    iso: 'NG',
    coordinates: '10.896388888899999, 10.298333333299999',
    municipality: 'Gombe'
  }
}, {
  label: 'Gomel Airport (GME) - BY',
  id: 'GME',
  obj: {
    iata: 'GME',
    iso: 'BY',
    coordinates: '31.016700744628906, 52.527000427246094',
    municipality: 'Gomel'
  }
}, {
  label: 'Gonder Airport (GDQ) - ET',
  id: 'GDQ',
  obj: {
    iata: 'GDQ',
    iso: 'ET',
    coordinates: '37.433998107910156, 12.51990032196045',
    municipality: 'Gondar'
  }
}, {
  label: 'Yangyang International Airport (YNY) - KR',
  id: 'YNY',
  obj: {
    iata: 'YNY',
    iso: 'KR',
    coordinates: '128.669006, 38.061298',
    municipality: 'Gonghang-ro'
  }
}, {
  label: 'Renner Field-Goodland Municipal Airport (GLD) - US',
  id: 'GLD',
  obj: {
    iata: 'GLD',
    iso: 'US',
    coordinates: '-101.6989975, 39.37060165',
    municipality: 'Goodland'
  }
}, {
  label: 'Goose Bay Airport (YYR) - CA',
  id: 'YYR',
  obj: {
    iata: 'YYR',
    iso: 'CA',
    coordinates: '-60.4258003235, 53.3191986084',
    municipality: 'Goose Bay'
  }
}, {
  label: 'Gorakhpur Airport (GOP) - IN',
  id: 'GOP',
  obj: {
    iata: 'GOP',
    iso: 'IN',
    coordinates: '83.4496994019, 26.739700317399997',
    municipality: 'Gorakhpur'
  }
}, {
  label: 'Gore Bay Manitoulin Airport (YZE) - CA',
  id: 'YZE',
  obj: {
    iata: 'YZE',
    iso: 'CA',
    coordinates: '-82.56780242919922, 45.88529968261719',
    municipality: 'Gore Bay'
  }
}, {
  label: 'Gorgan Airport (GBT) - IR',
  id: 'GBT',
  obj: {
    iata: 'GBT',
    iso: 'IR',
    coordinates: '54.4012985229, 36.909400939899996',
    municipality: 'Gorgan'
  }
}, {
  label: 'Gorna Oryahovitsa Airport (GOZ) - BG',
  id: 'GOZ',
  obj: {
    iata: 'GOZ',
    iso: 'BG',
    coordinates: '25.712900161743164, 43.15140151977539',
    municipality: 'Gorna Oryahovitsa'
  }
}, {
  label: 'Gorno-Altaysk Airport (RGK) - RU',
  id: 'RGK',
  obj: {
    iata: 'RGK',
    iso: 'RU',
    coordinates: '85.8332977295, 51.9667015076',
    municipality: 'Gorno-Altaysk'
  }
}, {
  label: 'Goroka Airport (GKA) - PG',
  id: 'GKA',
  obj: {
    iata: 'GKA',
    iso: 'PG',
    coordinates: '145.391998291, -6.081689834590001',
    municipality: 'Goronka'
  }
}, {
  label: 'Pitu Airport (OTI) - ID',
  id: 'OTI',
  obj: {
    iata: 'OTI',
    iso: 'ID',
    coordinates: '128.324996948, 2.0459899902300003',
    municipality: 'Gotalalamo-Morotai Island'
  }
}, {
  label: 'Gothenburg-Landvetter Airport (GOT) - SE',
  id: 'GOT',
  obj: {
    iata: 'GOT',
    iso: 'SE',
    coordinates: '12.279800415039, 57.662799835205',
    municipality: 'Gothenburg'
  }
}, {
  label: 'Gothenburg City Airport (GSE) - SE',
  id: 'GSE',
  obj: {
    iata: 'GSE',
    iso: 'SE',
    coordinates: '11.8704, 57.7747',
    municipality: 'Gothenburg'
  }
}, {
  label: 'Fukue Airport (FUJ) - JP',
  id: 'FUJ',
  obj: {
    iata: 'FUJ',
    iso: 'JP',
    coordinates: '128.83299255371094, 32.66630172729492',
    municipality: 'Goto'
  }
}, {
  label: "Governor's Harbour Airport (GHB) - BS",
  id: 'GHB',
  obj: {
    iata: 'GHB',
    iso: 'BS',
    coordinates: '-76.3310012817, 25.2847003937',
    municipality: "Governor's Harbour"
  }
}, {
  label: 'Goya Airport (OYA) - AR',
  id: 'OYA',
  obj: {
    iata: 'OYA',
    iso: 'AR',
    coordinates: '-59.2189, -29.1058',
    municipality: 'Goya'
  }
}, {
  label: 'Gran Canaria Airport (LPA) - ES',
  id: 'LPA',
  obj: {
    iata: 'LPA',
    iso: 'ES',
    coordinates: '-15.38659954071045, 27.931900024414062',
    municipality: 'Gran Canaria Island'
  }
}, {
  label: 'Federico Garcia Lorca Airport (GRX) - ES',
  id: 'GRX',
  obj: {
    iata: 'GRX',
    iso: 'ES',
    coordinates: '-3.777359962463379, 37.18870162963867',
    municipality: 'Granada'
  }
}, {
  label: 'Les Bases Airport (GBJ) - GP',
  id: 'GBJ',
  obj: {
    iata: 'GBJ',
    iso: 'GP',
    coordinates: '-61.27000045776367, 15.86870002746582',
    municipality: 'Grand Bourg'
  }
}, {
  label: 'Grand Canyon National Park Airport (GCN) - US',
  id: 'GCN',
  obj: {
    iata: 'GCN',
    iso: 'US',
    coordinates: '-112.14700317382812, 35.95240020751953',
    municipality: 'Grand Canyon'
  }
}, {
  label: "L'Esp\u00c3\u00a9rance Airport (SFG) - MF",
  id: 'SFG',
  obj: {
    iata: 'SFG',
    iso: 'MF',
    coordinates: '-63.047199, 18.099899',
    municipality: 'Grand Case'
  }
}, {
  label: 'Grand Forks Airport (ZGF) - CA',
  id: 'ZGF',
  obj: {
    iata: 'ZGF',
    iso: 'CA',
    coordinates: '-118.43099975585938, 49.01559829711914',
    municipality: 'Grand Forks'
  }
}, {
  label: 'Grand Forks International Airport (GFK) - US',
  id: 'GFK',
  obj: {
    iata: 'GFK',
    iso: 'US',
    coordinates: '-97.176102, 47.949299',
    municipality: 'Grand Forks'
  }
}, {
  label: 'Grand Forks Air Force Base (RDR) - US',
  id: 'RDR',
  obj: {
    iata: 'RDR',
    iso: 'US',
    coordinates: '-97.4011993408, 47.961101532',
    municipality: 'Grand Forks'
  }
}, {
  label: 'Central Nebraska Regional Airport (GRI) - US',
  id: 'GRI',
  obj: {
    iata: 'GRI',
    iso: 'US',
    coordinates: '-98.30960083007812, 40.967498779296875',
    municipality: 'Grand Island'
  }
}, {
  label: 'Grand Junction Regional Airport (GJT) - US',
  id: 'GJT',
  obj: {
    iata: 'GJT',
    iso: 'US',
    coordinates: '-108.527000427, 39.1223983765',
    municipality: 'Grand Junction'
  }
}, {
  label: 'Gerald R. Ford International Airport (GRR) - US',
  id: 'GRR',
  obj: {
    iata: 'GRR',
    iso: 'US',
    coordinates: '-85.52279663, 42.88079834',
    municipality: 'Grand Rapids'
  }
}, {
  label: 'Grande Prairie Airport (YQU) - CA',
  id: 'YQU',
  obj: {
    iata: 'YQU',
    iso: 'CA',
    coordinates: '-118.885002136, 55.1796989441',
    municipality: 'Grande Prairie'
  }
}, {
  label: 'Granville Airport (GFR) - FR',
  id: 'GFR',
  obj: {
    iata: 'GFR',
    iso: 'FR',
    coordinates: '-1.564170002937317, 48.88309860229492',
    municipality: 'Granville'
  }
}, {
  label: 'Graz Airport (GRZ) - AT',
  id: 'GRZ',
  obj: {
    iata: 'GRZ',
    iso: 'AT',
    coordinates: '15.439599990844727, 46.9911003112793',
    municipality: 'Graz'
  }
}, {
  label: 'Great Falls International Airport (GTF) - US',
  id: 'GTF',
  obj: {
    iata: 'GTF',
    iso: 'US',
    coordinates: '-111.3710022, 47.48199844',
    municipality: 'Great Falls'
  }
}, {
  label: 'Austin Straubel International Airport (GRB) - US',
  id: 'GRB',
  obj: {
    iata: 'GRB',
    iso: 'US',
    coordinates: '-88.12960052490234, 44.48509979248047',
    municipality: 'Green Bay'
  }
}, {
  label: 'Piedmont Triad International Airport (GSO) - US',
  id: 'GSO',
  obj: {
    iata: 'GSO',
    iso: 'US',
    coordinates: '-79.93730163574219, 36.097801208496094',
    municipality: 'Greensboro'
  }
}, {
  label: 'Mid Delta Regional Airport (GLH) - US',
  id: 'GLH',
  obj: {
    iata: 'GLH',
    iso: 'US',
    coordinates: '-90.98560333251953, 33.4828987121582',
    municipality: 'Greenville'
  }
}, {
  label: 'Greenville Downtown Airport (GMU) - US',
  id: 'GMU',
  obj: {
    iata: 'GMU',
    iso: 'US',
    coordinates: '-82.34999847410002, 34.847900390599996',
    municipality: 'Greenville'
  }
}, {
  label: 'Greenville Spartanburg International Airport (GSP) - US',
  id: 'GSP',
  obj: {
    iata: 'GSP',
    iso: 'US',
    coordinates: '-82.2189025879, 34.8956985474',
    municipality: 'Greenville'
  }
}, {
  label: 'Pitt Greenville Airport (PGV) - US',
  id: 'PGV',
  obj: {
    iata: 'PGV',
    iso: 'US',
    coordinates: '-77.38529968, 35.6352005',
    municipality: 'Greenville'
  }
}, {
  label: 'CFB Greenwood (YZX) - CA',
  id: 'YZX',
  obj: {
    iata: 'YZX',
    iso: 'CA',
    coordinates: '-64.91690063476562, 44.98440170288086',
    municipality: 'Greenwood'
  }
}, {
  label: 'Greenwood\u00e2\u0080\u0093Leflore Airport (GWO) - US',
  id: 'GWO',
  obj: {
    iata: 'GWO',
    iso: 'US',
    coordinates: '-90.0847015381, 33.4943008423',
    municipality: 'Greenwood'
  }
}, {
  label: 'Grenchen Airport (ZHI) - CH',
  id: 'ZHI',
  obj: {
    iata: 'ZHI',
    iso: 'CH',
    coordinates: '7.41719, 47.181599',
    municipality: 'Grenchen'
  }
}, {
  label: 'Griffith Airport (GFF) - AU',
  id: 'GFF',
  obj: {
    iata: 'GFF',
    iso: 'AU',
    coordinates: '146.067001343, -34.2508010864',
    municipality: 'Griffith'
  }
}, {
  label: 'Humberside Airport (HUY) - GB',
  id: 'HUY',
  obj: {
    iata: 'HUY',
    iso: 'GB',
    coordinates: '-0.350832998752594, 53.57440185546875',
    municipality: 'Grimsby'
  }
}, {
  label: 'Grise Fiord Airport (YGZ) - CA',
  id: 'YGZ',
  obj: {
    iata: 'YGZ',
    iso: 'CA',
    coordinates: '-82.90920257570001, 76.4261016846',
    municipality: 'Grise Fiord'
  }
}, {
  label: 'Eelde Airport (GRQ) - NL',
  id: 'GRQ',
  obj: {
    iata: 'GRQ',
    iso: 'NL',
    coordinates: '6.57944011688, 53.1197013855',
    municipality: 'Groningen'
  }
}, {
  label: 'Groote Eylandt Airport (GTE) - AU',
  id: 'GTE',
  obj: {
    iata: 'GTE',
    iso: 'AU',
    coordinates: '136.460006714, -13.975000381500001',
    municipality: 'Groote Eylandt'
  }
}, {
  label: 'Grootfontein Airport (GFY) - NA',
  id: 'GFY',
  obj: {
    iata: 'GFY',
    iso: 'NA',
    coordinates: '18.122699737548828, -19.60219955444336',
    municipality: 'Grootfontein'
  }
}, {
  label: 'Grosseto Air Base (GRS) - IT',
  id: 'GRS',
  obj: {
    iata: 'GRS',
    iso: 'IT',
    coordinates: '11.0719, 42.759701',
    municipality: 'Grosetto'
  }
}, {
  label: 'Groton New London Airport (GON) - US',
  id: 'GON',
  obj: {
    iata: 'GON',
    iso: 'US',
    coordinates: '-72.04509735107422, 41.330101013183594',
    municipality: 'Groton (New London)'
  }
}, {
  label: 'Taranto-Grottaglie "Marcello Arlotta" Airport (TAR) - IT',
  id: 'TAR',
  obj: {
    iata: 'TAR',
    iso: 'IT',
    coordinates: '17.4032, 40.517502',
    municipality: 'Grottaglie'
  }
}, {
  label: 'Grozny North Airport (GRV) - RU',
  id: 'GRV',
  obj: {
    iata: 'GRV',
    iso: 'RU',
    coordinates: '45.698601, 43.388302',
    municipality: 'Grozny'
  }
}, {
  label: 'Outer Skerries Airport (OUK) - GB',
  id: 'OUK',
  obj: {
    iata: 'OUK',
    iso: 'GB',
    coordinates: '-0.75, 60.4252',
    municipality: 'Grunay Island'
  }
}, {
  label: 'Don Miguel Hidalgo Y Costilla International Airport (GDL) - MX',
  id: 'GDL',
  obj: {
    iata: 'GDL',
    iso: 'MX',
    coordinates: '-103.31099700927734, 20.521799087524414',
    municipality: 'Guadalajara'
  }
}, {
  label: 'Guajar\u00c3\u00a1-Mirim Airport (GJM) - BR',
  id: 'GJM',
  obj: {
    iata: 'GJM',
    iso: 'BR',
    coordinates: '-65.28479766845703, -10.786399841308594',
    municipality: 'Guajar\u00c3\u00a1-Mirim'
  }
}, {
  label: 'Gualeguaychu Airport (GHU) - AR',
  id: 'GHU',
  obj: {
    iata: 'GHU',
    iso: 'AR',
    coordinates: '-58.6131, -33.0103',
    municipality: 'Gualeguaychu'
  }
}, {
  label: 'La Laguna Airport (GJA) - HN',
  id: 'GJA',
  obj: {
    iata: 'GJA',
    iso: 'HN',
    coordinates: '-85.906601, 16.4454',
    municipality: 'Guanaja'
  }
}, {
  label: 'Guanare Airport (GUQ) - VE',
  id: 'GUQ',
  obj: {
    iata: 'GUQ',
    iso: 'VE',
    coordinates: '-69.7551498413086, 9.026944160461426',
    municipality: 'Guanare'
  }
}, {
  label: 'Guangzhou MR Air Base (LHK) - CN',
  id: 'LHK',
  obj: {
    iata: 'LHK',
    iso: 'CN',
    coordinates: '111.69499969482422, 32.389400482177734',
    municipality: 'Guanghua'
  }
}, {
  label: 'Guangzhou Baiyun International Airport (CAN) - CN',
  id: 'CAN',
  obj: {
    iata: 'CAN',
    iso: 'CN',
    coordinates: '113.29900360107422, 23.39240074157715',
    municipality: 'Guangzhou'
  }
}, {
  label: 'Leeward Point Field (NBW) - CU',
  id: 'NBW',
  obj: {
    iata: 'NBW',
    iso: 'CU',
    coordinates: '-75.207099914551, 19.906499862671',
    municipality: 'Guantanamo Bay Naval Station'
  }
}, {
  label: 'Mariana Grajales Airport (GAO) - CU',
  id: 'GAO',
  obj: {
    iata: 'GAO',
    iso: 'CU',
    coordinates: '-75.1583023071289, 20.08530044555664',
    municipality: 'Guant\u00c3\u00a1namo'
  }
}, {
  label: 'Juan Casiano Airport (GPI) - CO',
  id: 'GPI',
  obj: {
    iata: 'GPI',
    iso: 'CO',
    coordinates: '-77.8986, 2.57013',
    municipality: 'Guapi'
  }
}, {
  label: 'Guaratinguet\u00c3\u00a1 Airport (GUJ) - BR',
  id: 'GUJ',
  obj: {
    iata: 'GUJ',
    iso: 'BR',
    coordinates: '-45.20479965209961, -22.79159927368164',
    municipality: 'Guaratinguet\u00c3\u00a1'
  }
}, {
  label: 'Calabozo Airport (CLZ) - VE',
  id: 'CLZ',
  obj: {
    iata: 'CLZ',
    iso: 'VE',
    coordinates: '-67.4170913696289, 8.92465591430664',
    municipality: 'Guarico'
  }
}, {
  label: 'Base A\u00c3\u00a9rea de Santos Airport (SSZ) - BR',
  id: 'SSZ',
  obj: {
    iata: 'SSZ',
    iso: 'BR',
    coordinates: '-46.299720764160156, -23.928056716918945',
    municipality: 'Guaruj\u00c3\u00a1'
  }
}, {
  label: 'La Aurora Airport (GUA) - GT',
  id: 'GUA',
  obj: {
    iata: 'GUA',
    iso: 'GT',
    coordinates: '-90.527496, 14.5833',
    municipality: 'Guatemala City'
  }
}, {
  label: 'Jos\u00c3\u00a9 Joaqu\u00c3\u00adn de Olmedo International Airport (GYE) - EC',
  id: 'GYE',
  obj: {
    iata: 'GYE',
    iso: 'EC',
    coordinates: '-79.88359832760001, -2.1574199199699997',
    municipality: 'Guayaquil'
  }
}, {
  label: 'General Jos\u00c3\u00a9 Mar\u00c3\u00ada Y\u00c3\u00a1\u00c3\u00b1ez International Airport (GYM) - MX',
  id: 'GYM',
  obj: {
    iata: 'GYM',
    iso: 'MX',
    coordinates: '-110.92500305175781, 27.9689998626709',
    municipality: 'Guaymas'
  }
}, {
  label: 'Guemar Airport (ELU) - DZ',
  id: 'ELU',
  obj: {
    iata: 'ELU',
    iso: 'DZ',
    coordinates: '6.77679014206, 33.5113983154',
    municipality: 'Guemar'
  }
}, {
  label: 'Guilin Liangjiang International Airport (KWL) - CN',
  id: 'KWL',
  obj: {
    iata: 'KWL',
    iso: 'CN',
    coordinates: '110.03900146484375, 25.21809959411621',
    municipality: 'Guilin City'
  }
}, {
  label: 'Gulfport Biloxi International Airport (GPT) - US',
  id: 'GPT',
  obj: {
    iata: 'GPT',
    iso: 'US',
    coordinates: '-89.07009887695312, 30.40730094909668',
    municipality: 'Gulfport'
  }
}, {
  label: 'Gulkana Airport (GKN) - US',
  id: 'GKN',
  obj: {
    iata: 'GKN',
    iso: 'US',
    coordinates: '-145.4570007, 62.1548996',
    municipality: 'Gulkana'
  }
}, {
  label: 'Gulu Airport (ULU) - UG',
  id: 'ULU',
  obj: {
    iata: 'ULU',
    iso: 'UG',
    coordinates: '32.27180099487305, 2.8055601119995117',
    municipality: 'Gulu'
  }
}, {
  label: 'Binaka Airport (GNS) - ID',
  id: 'GNS',
  obj: {
    iata: 'GNS',
    iso: 'ID',
    coordinates: '97.704697, 1.16638',
    municipality: 'Gunung Sitoli-Nias Island'
  }
}, {
  label: 'Gurayat Domestic Airport (URY) - SA',
  id: 'URY',
  obj: {
    iata: 'URY',
    iso: 'SA',
    coordinates: '37.278898, 31.412413',
    municipality: 'Gurayat'
  }
}, {
  label: 'Gurney Airport (GUR) - PG',
  id: 'GUR',
  obj: {
    iata: 'GUR',
    iso: 'PG',
    coordinates: '150.333999634, -10.3114995956',
    municipality: 'Gurney'
  }
}, {
  label: 'Gustaf III Airport (SBH) - BL',
  id: 'SBH',
  obj: {
    iata: 'SBH',
    iso: 'BL',
    coordinates: '-62.84360122680664, 17.904399871826172',
    municipality: 'Gustavia'
  }
}, {
  label: 'Gustavus Airport (GST) - US',
  id: 'GST',
  obj: {
    iata: 'GST',
    iso: 'US',
    coordinates: '-135.7070007, 58.4253006',
    municipality: 'Gustavus'
  }
}, {
  label: 'Lokpriya Gopinath Bordoloi International Airport (GAU) - IN',
  id: 'GAU',
  obj: {
    iata: 'GAU',
    iso: 'IN',
    coordinates: '91.58589935302734, 26.10610008239746',
    municipality: 'Guwahati'
  }
}, {
  label: 'Guymon Municipal Airport (GUY) - US',
  id: 'GUY',
  obj: {
    iata: 'GUY',
    iso: 'US',
    coordinates: '-101.508003235, 36.6851005554',
    municipality: 'Guymon'
  }
}, {
  label: 'Guyuan Liupanshan Airport (GYU) - CN',
  id: 'GYU',
  obj: {
    iata: 'GYU',
    iso: 'CN',
    coordinates: '106.216944444, 36.0788888889',
    municipality: 'Guyuan'
  }
}, {
  label: 'Gwadar International Airport (GWD) - PK',
  id: 'GWD',
  obj: {
    iata: 'GWD',
    iso: 'PK',
    coordinates: '62.329498291015625, 25.233299255371094',
    municipality: 'Gwadar'
  }
}, {
  label: 'Gwalior Airport (GWL) - IN',
  id: 'GWL',
  obj: {
    iata: 'GWL',
    iso: 'IN',
    coordinates: '78.22779846191406, 26.29330062866211',
    municipality: 'Gwalior'
  }
}, {
  label: 'Gwangju Airport (KWJ) - KR',
  id: 'KWJ',
  obj: {
    iata: 'KWJ',
    iso: 'KR',
    coordinates: '126.805444, 35.123173',
    municipality: 'Gwangju'
  }
}, {
  label: 'Thornhill Air Base (GWE) - ZW',
  id: 'GWE',
  obj: {
    iata: 'GWE',
    iso: 'ZW',
    coordinates: '29.861900329589844, -19.436399459838867',
    municipality: 'Gweru'
  }
}, {
  label: 'Gyumri Shirak Airport (LWN) - AM',
  id: 'LWN',
  obj: {
    iata: 'LWN',
    iso: 'AM',
    coordinates: '43.859298706100006, 40.7504005432',
    municipality: 'Gyumri'
  }
}, {
  label: 'G\u00c3\u00a4llivare Airport (GEV) - SE',
  id: 'GEV',
  obj: {
    iata: 'GEV',
    iso: 'SE',
    coordinates: '20.814599990844727, 67.13240051269531',
    municipality: 'G\u00c3\u00a4llivare'
  }
}, {
  label: 'G\u00c3\u00a4vle Sandviken Airport (GVX) - SE',
  id: 'GVX',
  obj: {
    iata: 'GVX',
    iso: 'SE',
    coordinates: '16.951400756835938, 60.593299865722656',
    municipality: 'G\u00c3\u00a4vle / Sandviken'
  }
}, {
  label: 'V\u00c3\u00a2n \u00c4\u0090\u00e1\u00bb\u0093n International Airport (VDO) - VN',
  id: 'VDO',
  obj: {
    iata: 'VDO',
    iso: 'VN',
    coordinates: '107.414167, 21.117778',
    municipality: 'Ha Long'
  }
}, {
  label: "Ha'il Airport (HAS) - SA",
  id: 'HAS',
  obj: {
    iata: 'HAS',
    iso: 'SA',
    coordinates: '41.686298, 27.437901',
    municipality: "Ha'il"
  }
}, {
  label: 'Hanimaadhoo Airport (HAQ) - MV',
  id: 'HAQ',
  obj: {
    iata: 'HAQ',
    iso: 'MV',
    coordinates: '73.17050170898438, 6.744229793548584',
    municipality: 'Haa Dhaalu Atoll'
  }
}, {
  label: 'Hachijojima Airport (HAC) - JP',
  id: 'HAC',
  obj: {
    iata: 'HAC',
    iso: 'JP',
    coordinates: '139.785995483, 33.1150016785',
    municipality: 'Hachijojima'
  }
}, {
  label: 'Stokmarknes Skagen Airport (SKN) - NO',
  id: 'SKN',
  obj: {
    iata: 'SKN',
    iso: 'NO',
    coordinates: '15.033416748047, 68.578826904297',
    municipality: 'Hadsel'
  }
}, {
  label: 'Hagerstown Regional Richard A Henson Field (HGR) - US',
  id: 'HGR',
  obj: {
    iata: 'HGR',
    iso: 'US',
    coordinates: '-77.72949982, 39.707901',
    municipality: 'Hagerstown'
  }
}, {
  label: 'Antonio B. Won Pat International Airport (GUM) - GU',
  id: 'GUM',
  obj: {
    iata: 'GUM',
    iso: 'GU',
    coordinates: '144.796005249, 13.4834003448',
    municipality: 'Hag\u00c3\u00a5t\u00c3\u00b1a, Guam International Airport'
  }
}, {
  label: 'Haifa International Airport (HFA) - IL',
  id: 'HFA',
  obj: {
    iata: 'HFA',
    iso: 'IL',
    coordinates: '35.04309844970703, 32.80939865112305',
    municipality: 'Haifa'
  }
}, {
  label: 'Haikou Meilan International Airport (HAK) - CN',
  id: 'HAK',
  obj: {
    iata: 'HAK',
    iso: 'CN',
    coordinates: '110.45899963378906, 19.934900283813477',
    municipality: 'Haikou'
  }
}, {
  label: 'Hulunbuir Hailar Airport (HLD) - CN',
  id: 'HLD',
  obj: {
    iata: 'HLD',
    iso: 'CN',
    coordinates: '119.824997, 49.205002',
    municipality: 'Hailar'
  }
}, {
  label: 'Friedman Memorial Airport (SUN) - US',
  id: 'SUN',
  obj: {
    iata: 'SUN',
    iso: 'US',
    coordinates: '-114.2959976, 43.50439835',
    municipality: 'Hailey'
  }
}, {
  label: 'Haines Airport (HNS) - US',
  id: 'HNS',
  obj: {
    iata: 'HNS',
    iso: 'US',
    coordinates: '-135.5240020751953, 59.24380111694336',
    municipality: 'Haines'
  }
}, {
  label: 'Haines Junction Airport (YHT) - CA',
  id: 'YHT',
  obj: {
    iata: 'YHT',
    iso: 'CA',
    coordinates: '-137.54600524902344, 60.78919982910156',
    municipality: 'Haines Junction'
  }
}, {
  label: 'Cat Bi International Airport (HPH) - VN',
  id: 'HPH',
  obj: {
    iata: 'HPH',
    iso: 'VN',
    coordinates: '106.7249984741211, 20.819400787353516',
    municipality: 'Haiphong'
  }
}, {
  label: 'Hakkari Y\u00c3\u00bcksekova Airport (YKO) - TR',
  id: 'YKO',
  obj: {
    iata: 'YKO',
    iso: 'TR',
    coordinates: '44.2381, 37.5497',
    municipality: 'Hakkari'
  }
}, {
  label: 'Hakodate Airport (HKD) - JP',
  id: 'HKD',
  obj: {
    iata: 'HKD',
    iso: 'JP',
    coordinates: '140.822006226, 41.7700004578',
    municipality: 'Hakodate'
  }
}, {
  label: 'Halifax / Stanfield International Airport (YHZ) - CA',
  id: 'YHZ',
  obj: {
    iata: 'YHZ',
    iso: 'CA',
    coordinates: '-63.5085983276, 44.8807983398',
    municipality: 'Halifax'
  }
}, {
  label: 'Hall Beach Airport (YUX) - CA',
  id: 'YUX',
  obj: {
    iata: 'YUX',
    iso: 'CA',
    coordinates: '-81.2425, 68.77610015869999',
    municipality: 'Hall Beach'
  }
}, {
  label: 'Halli Airport (KEV) - FI',
  id: 'KEV',
  obj: {
    iata: 'KEV',
    iso: 'FI',
    coordinates: '24.786686, 61.856039',
    municipality: 'Halli / Kuorevesi'
  }
}, {
  label: 'Halmstad Airport (HAD) - SE',
  id: 'HAD',
  obj: {
    iata: 'HAD',
    iso: 'SE',
    coordinates: '12.820199966430664, 56.69110107421875',
    municipality: 'Halmstad'
  }
}, {
  label: 'Hamadan Airport (HDM) - IR',
  id: 'HDM',
  obj: {
    iata: 'HDM',
    iso: 'IR',
    coordinates: '48.5525016784668, 34.86920166015625',
    municipality: 'Hamadan'
  }
}, {
  label: 'Hamburg Airport (HAM) - DE',
  id: 'HAM',
  obj: {
    iata: 'HAM',
    iso: 'DE',
    coordinates: '9.9882297515869, 53.630401611328',
    municipality: 'Hamburg'
  }
}, {
  label: 'Hamburg-Finkenwerder Airport (XFW) - DE',
  id: 'XFW',
  obj: {
    iata: 'XFW',
    iso: 'DE',
    coordinates: '9.835556030273438, 53.5352783203125',
    municipality: 'Hamburg'
  }
}, {
  label: 'John C. Munro Hamilton International Airport (YHM) - CA',
  id: 'YHM',
  obj: {
    iata: 'YHM',
    iso: 'CA',
    coordinates: '-79.93499755859999, 43.173599243199995',
    municipality: 'Hamilton'
  }
}, {
  label: 'Hamilton International Airport (HLZ) - NZ',
  id: 'HLZ',
  obj: {
    iata: 'HLZ',
    iso: 'NZ',
    coordinates: '175.332000732, -37.8666992188',
    municipality: 'Hamilton'
  }
}, {
  label: 'L.F. Wade International International Airport (BDA) - BM',
  id: 'BDA',
  obj: {
    iata: 'BDA',
    iso: 'BM',
    coordinates: '-64.67870330810547, 32.36399841308594',
    municipality: 'Hamilton'
  }
}, {
  label: 'Hamilton Island Airport (HTI) - AU',
  id: 'HTI',
  obj: {
    iata: 'HTI',
    iso: 'AU',
    coordinates: '148.95199585, -20.3581008911',
    municipality: 'Hamilton Island'
  }
}, {
  label: 'Hammerfest Airport (HFT) - NO',
  id: 'HFT',
  obj: {
    iata: 'HFT',
    iso: 'NO',
    coordinates: '23.668600082397, 70.679702758789',
    municipality: 'Hammerfest'
  }
}, {
  label: 'Langley Air Force Base (LFI) - US',
  id: 'LFI',
  obj: {
    iata: 'LFI',
    iso: 'US',
    coordinates: '-76.360496521, 37.082901001',
    municipality: 'Hampton'
  }
}, {
  label: 'Hana Airport (HNM) - US',
  id: 'HNM',
  obj: {
    iata: 'HNM',
    iso: 'US',
    coordinates: '-156.01400756835938, 20.79560089111328',
    municipality: 'Hana'
  }
}, {
  label: 'Houghton County Memorial Airport (CMX) - US',
  id: 'CMX',
  obj: {
    iata: 'CMX',
    iso: 'US',
    coordinates: '-88.48909759521484, 47.168399810791016',
    municipality: 'Hancock'
  }
}, {
  label: 'Handan Airport (HDG) - CN',
  id: 'HDG',
  obj: {
    iata: 'HDG',
    iso: 'CN',
    coordinates: '114.425555556, 36.5258333333',
    municipality: 'Handan'
  }
}, {
  label: 'Hannover Airport (HAJ) - DE',
  id: 'HAJ',
  obj: {
    iata: 'HAJ',
    iso: 'DE',
    coordinates: '9.685079574580001, 52.461101532',
    municipality: 'Hannover'
  }
}, {
  label: 'Noi Bai International Airport (HAN) - VN',
  id: 'HAN',
  obj: {
    iata: 'HAN',
    iso: 'VN',
    coordinates: '105.80699920654297, 21.221200942993164',
    municipality: 'Hanoi'
  }
}, {
  label: 'Robert Gabriel Mugabe International Airport (HRE) - ZW',
  id: 'HRE',
  obj: {
    iata: 'HRE',
    iso: 'ZW',
    coordinates: '31.0928, -17.931801',
    municipality: 'Harare'
  }
}, {
  label: 'Egal International Airport (HGA) - SO',
  id: 'HGA',
  obj: {
    iata: 'HGA',
    iso: 'SO',
    coordinates: '44.082389, 9.513207',
    municipality: 'Hargeisa'
  }
}, {
  label: 'Valley International Airport (HRL) - US',
  id: 'HRL',
  obj: {
    iata: 'HRL',
    iso: 'US',
    coordinates: '-97.65440368652344, 26.228500366210938',
    municipality: 'Harlingen'
  }
}, {
  label: 'Harrisburg International Airport (MDT) - US',
  id: 'MDT',
  obj: {
    iata: 'MDT',
    iso: 'US',
    coordinates: '-76.7633972168, 40.1935005188',
    municipality: 'Harrisburg'
  }
}, {
  label: 'Harrismith Airport (HRS) - ZA',
  id: 'HRS',
  obj: {
    iata: 'HRS',
    iso: 'ZA',
    coordinates: '29.106199264526367, -28.23509979248047',
    municipality: 'Harrismith'
  }
}, {
  label: 'Boone County Airport (HRO) - US',
  id: 'HRO',
  obj: {
    iata: 'HRO',
    iso: 'US',
    coordinates: '-93.15470123291016, 36.26150131225586',
    municipality: 'Harrison'
  }
}, {
  label: 'Bradley International Airport (BDL) - US',
  id: 'BDL',
  obj: {
    iata: 'BDL',
    iso: 'US',
    coordinates: '-72.68319702149999, 41.9388999939',
    municipality: 'Hartford'
  }
}, {
  label: 'Hartford Brainard Airport (HFD) - US',
  id: 'HFD',
  obj: {
    iata: 'HFD',
    iso: 'US',
    coordinates: '-72.649398803711, 41.736698150635',
    municipality: 'Hartford'
  }
}, {
  label: 'Oued Irara Airport (HME) - DZ',
  id: 'HME',
  obj: {
    iata: 'HME',
    iso: 'DZ',
    coordinates: '6.140439987180001, 31.673000335699996',
    municipality: 'Hassi Messaoud'
  }
}, {
  label: 'Hat Yai International Airport (HDY) - TH',
  id: 'HDY',
  obj: {
    iata: 'HDY',
    iso: 'TH',
    coordinates: '100.392997742, 6.93320989609',
    municipality: 'Hat Yai'
  }
}, {
  label: 'Hatay Airport (HTY) - TR',
  id: 'HTY',
  obj: {
    iata: 'HTY',
    iso: 'TR',
    coordinates: '36.282222747800006, 36.36277771',
    municipality: 'Hatay'
  }
}, {
  label: 'Hattiesburg Bobby L Chain Municipal Airport (HBG) - US',
  id: 'HBG',
  obj: {
    iata: 'HBG',
    iso: 'US',
    coordinates: '-89.25279999, 31.26479912',
    municipality: 'Hattiesburg'
  }
}, {
  label: 'Hattiesburg Laurel Regional Airport (PIB) - US',
  id: 'PIB',
  obj: {
    iata: 'PIB',
    iso: 'US',
    coordinates: '-89.33709716796875, 31.467100143432617',
    municipality: 'Hattiesburg/Laurel'
  }
}, {
  label: 'Jos\u00c3\u00a9 Mart\u00c3\u00ad International Airport (HAV) - CU',
  id: 'HAV',
  obj: {
    iata: 'HAV',
    iso: 'CU',
    coordinates: '-82.40910339355469, 22.989200592041016',
    municipality: 'Havana'
  }
}, {
  label: 'Playa Baracoa Airport (UPB) - CU',
  id: 'UPB',
  obj: {
    iata: 'UPB',
    iso: 'CU',
    coordinates: '-82.5793991089, 23.032800674399997',
    municipality: 'Havana'
  }
}, {
  label: 'Haverfordwest Airport (HAW) - GB',
  id: 'HAW',
  obj: {
    iata: 'HAW',
    iso: 'GB',
    coordinates: '-4.9611101150512695, 51.833099365234375',
    municipality: 'Haverfordwest'
  }
}, {
  label: 'Havre City County Airport (HVR) - US',
  id: 'HVR',
  obj: {
    iata: 'HVR',
    iso: 'US',
    coordinates: '-109.762001, 48.54299927',
    municipality: 'Havre'
  }
}, {
  label: 'Havre St Pierre Airport (YGV) - CA',
  id: 'YGV',
  obj: {
    iata: 'YGV',
    iso: 'CA',
    coordinates: '-63.61140060424805, 50.281898498535156',
    municipality: 'Havre St-Pierre'
  }
}, {
  label: 'Hawarden Airport (CEG) - GB',
  id: 'CEG',
  obj: {
    iata: 'CEG',
    iso: 'GB',
    coordinates: '-2.9777801036834717, 53.1781005859375',
    municipality: 'Hawarden'
  }
}, {
  label: 'Upolu Airport (UPP) - US',
  id: 'UPP',
  obj: {
    iata: 'UPP',
    iso: 'US',
    coordinates: '-155.86000061035156, 20.265300750732422',
    municipality: 'Hawi'
  }
}, {
  label: 'Jack Northrop Field Hawthorne Municipal Airport (HHR) - US',
  id: 'HHR',
  obj: {
    iata: 'HHR',
    iso: 'US',
    coordinates: '-118.334999, 33.922798',
    municipality: 'Hawthorne'
  }
}, {
  label: 'Hay River / Merlyn Carter Airport (YHY) - CA',
  id: 'YHY',
  obj: {
    iata: 'YHY',
    iso: 'CA',
    coordinates: '-115.782997131, 60.8396987915',
    municipality: 'Hay River'
  }
}, {
  label: 'Hays Regional Airport (HYS) - US',
  id: 'HYS',
  obj: {
    iata: 'HYS',
    iso: 'US',
    coordinates: '-99.27320099, 38.84220123',
    municipality: 'Hays'
  }
}, {
  label: 'Sawyer County Airport (HYR) - US',
  id: 'HYR',
  obj: {
    iata: 'HYR',
    iso: 'US',
    coordinates: '-91.44429779050002, 46.025199890100005',
    municipality: 'Hayward'
  }
}, {
  label: 'Hearst Ren\u00c3\u00a9 Fontaine Municipal Airport (YHF) - CA',
  id: 'YHF',
  obj: {
    iata: 'YHF',
    iso: 'CA',
    coordinates: '-83.68609619140625, 49.71419906616211',
    municipality: 'Hearst'
  }
}, {
  label: 'Hechi Jinchengjiang Airport (HCJ) - CN',
  id: 'HCJ',
  obj: {
    iata: 'HCJ',
    iso: 'CN',
    coordinates: '107.6997, 24.805',
    municipality: 'Hechi'
  }
}, {
  label: 'Heho Airport (HEH) - MM',
  id: 'HEH',
  obj: {
    iata: 'HEH',
    iso: 'MM',
    coordinates: '96.79199981689453, 20.746999740600586',
    municipality: 'Heho'
  }
}, {
  label: 'Helena Regional Airport (HLN) - US',
  id: 'HLN',
  obj: {
    iata: 'HLN',
    iso: 'US',
    coordinates: '-111.98300170898438, 46.6068000793457',
    municipality: 'Helena'
  }
}, {
  label: 'Helsinki Malmi Airport (HEM) - FI',
  id: 'HEM',
  obj: {
    iata: 'HEM',
    iso: 'FI',
    coordinates: '25.042800903320312, 60.254600524902344',
    municipality: 'Helsinki'
  }
}, {
  label: 'Helsinki Vantaa Airport (HEL) - FI',
  id: 'HEL',
  obj: {
    iata: 'HEL',
    iso: 'FI',
    coordinates: '24.963300704956, 60.317199707031',
    municipality: 'Helsinki'
  }
}, {
  label: 'Hemavan Airport (HMV) - SE',
  id: 'HMV',
  obj: {
    iata: 'HMV',
    iso: 'SE',
    coordinates: '15.0828, 65.806099',
    municipality: 'Hemavan'
  }
}, {
  label: 'Hengchun Airport (HCN) - TW',
  id: 'HCN',
  obj: {
    iata: 'HCN',
    iso: 'TW',
    coordinates: '120.7300033569336, 22.041099548339844',
    municipality: 'Hengchung'
  }
}, {
  label: 'Heraklion International Nikos Kazantzakis Airport (HER) - GR',
  id: 'HER',
  obj: {
    iata: 'HER',
    iso: 'GR',
    coordinates: '25.180299758900002, 35.3396987915',
    municipality: 'Heraklion'
  }
}, {
  label: 'Heringsdorf Airport (HDF) - DE',
  id: 'HDF',
  obj: {
    iata: 'HDF',
    iso: 'DE',
    coordinates: '14.152299881, 53.8787002563',
    municipality: 'Heringsdorf'
  }
}, {
  label: 'General Ignacio P. Garcia International Airport (HMO) - MX',
  id: 'HMO',
  obj: {
    iata: 'HMO',
    iso: 'MX',
    coordinates: '-111.047996521, 29.095899581900003',
    municipality: 'Hermosillo'
  }
}, {
  label: 'Hervey Bay Airport (HVB) - AU',
  id: 'HVB',
  obj: {
    iata: 'HVB',
    iso: 'AU',
    coordinates: '152.880004883, -25.3188991547',
    municipality: 'Hervey Bay'
  }
}, {
  label: 'Range Regional Airport (HIB) - US',
  id: 'HIB',
  obj: {
    iata: 'HIB',
    iso: 'US',
    coordinates: '-92.83899689, 47.38660049',
    municipality: 'Hibbing'
  }
}, {
  label: 'Hickory Regional Airport (HKY) - US',
  id: 'HKY',
  obj: {
    iata: 'HKY',
    iso: 'US',
    coordinates: '-81.38950348, 35.74110031',
    municipality: 'Hickory'
  }
}, {
  label: 'High Level Airport (YOJ) - CA',
  id: 'YOJ',
  obj: {
    iata: 'YOJ',
    iso: 'CA',
    coordinates: '-117.16500091552734, 58.62139892578125',
    municipality: 'High Level'
  }
}, {
  label: 'Paloich Airport, Heliport (HGI) - SS',
  id: 'HGI',
  obj: {
    iata: 'HGI',
    iso: 'SS',
    coordinates: '32.500556, 10.529167',
    municipality: 'Higleig'
  }
}, {
  label: 'Hilo International Airport (ITO) - US',
  id: 'ITO',
  obj: {
    iata: 'ITO',
    iso: 'US',
    coordinates: '-155.04800415039062, 19.721399307250977',
    municipality: 'Hilo'
  }
}, {
  label: 'Hiroshima Airport (HIJ) - JP',
  id: 'HIJ',
  obj: {
    iata: 'HIJ',
    iso: 'JP',
    coordinates: '132.919006, 34.4361',
    municipality: 'Hiroshima'
  }
}, {
  label: 'Hiva Oa-Atuona Airport (AUQ) - PF',
  id: 'AUQ',
  obj: {
    iata: 'AUQ',
    iso: 'PF',
    coordinates: '-139.011001587, -9.76879024506',
    municipality: 'Hiva Oa Island'
  }
}, {
  label: 'Tan Son Nhat International Airport (SGN) - VN',
  id: 'SGN',
  obj: {
    iata: 'SGN',
    iso: 'VN',
    coordinates: '106.652000427, 10.8187999725',
    municipality: 'Ho Chi Minh City'
  }
}, {
  label: 'Hobart Regional Airport (HBR) - US',
  id: 'HBR',
  obj: {
    iata: 'HBR',
    iso: 'US',
    coordinates: '-99.051313, 34.991317',
    municipality: 'Hobart'
  }
}, {
  label: 'Hobart International Airport (HBA) - AU',
  id: 'HBA',
  obj: {
    iata: 'HBA',
    iso: 'AU',
    coordinates: '147.509994507, -42.836101532',
    municipality: 'Hobart'
  }
}, {
  label: 'Lea County Regional Airport (HOB) - US',
  id: 'HOB',
  obj: {
    iata: 'HOB',
    iso: 'US',
    coordinates: '-103.2170029, 32.6875',
    municipality: 'Hobbs'
  }
}, {
  label: 'Hodeidah International Airport (HOD) - YE',
  id: 'HOD',
  obj: {
    iata: 'HOD',
    iso: 'YE',
    coordinates: '42.97629928588867, 14.753000259399414',
    municipality: 'Hodeida'
  }
}, {
  label: 'Orang Airport (RGO) - KP',
  id: 'RGO',
  obj: {
    iata: 'RGO',
    iso: 'KP',
    coordinates: '129.647555, 41.428538',
    municipality: 'Hoemun-ri'
  }
}, {
  label: 'Hof-Plauen Airport (HOQ) - DE',
  id: 'HOQ',
  obj: {
    iata: 'HOQ',
    iso: 'DE',
    coordinates: '11.856389045715332, 50.288612365722656',
    municipality: 'Hof'
  }
}, {
  label: 'Baita International Airport (HET) - CN',
  id: 'HET',
  obj: {
    iata: 'HET',
    iso: 'CN',
    coordinates: '111.823997, 40.851398',
    municipality: 'Hohhot'
  }
}, {
  label: 'Frank Pais International Airport (HOG) - CU',
  id: 'HOG',
  obj: {
    iata: 'HOG',
    iso: 'CU',
    coordinates: '-76.31510162353516, 20.785600662231445',
    municipality: 'Holguin'
  }
}, {
  label: 'Holingol Huolinhe Airport (HUO) - CN',
  id: 'HUO',
  obj: {
    iata: 'HUO',
    iso: 'CN',
    coordinates: '119.407222, 45.487222',
    municipality: 'Holingol'
  }
}, {
  label: 'Holy Cross Airport (HCR) - US',
  id: 'HCR',
  obj: {
    iata: 'HCR',
    iso: 'US',
    coordinates: '-159.77499389648438, 62.18830108642578',
    municipality: 'Holy Cross'
  }
}, {
  label: 'Homer Airport (HOM) - US',
  id: 'HOM',
  obj: {
    iata: 'HOM',
    iso: 'US',
    coordinates: '-151.4770050048828, 59.645599365234375',
    municipality: 'Homer'
  }
}, {
  label: 'Homestead ARB Airport (HST) - US',
  id: 'HST',
  obj: {
    iata: 'HST',
    iso: 'US',
    coordinates: '-80.38359833, 25.48859978',
    municipality: 'Homestead'
  }
}, {
  label: 'San Sebastian Airport (EAS) - ES',
  id: 'EAS',
  obj: {
    iata: 'EAS',
    iso: 'ES',
    coordinates: '-1.7906099557876587, 43.35649871826172',
    municipality: 'Hondarribia'
  }
}, {
  label: 'Honiara International Airport (HIR) - SB',
  id: 'HIR',
  obj: {
    iata: 'HIR',
    iso: 'SB',
    coordinates: '160.05499267578, -9.4280004501343',
    municipality: 'Honiara'
  }
}, {
  label: 'Valan Airport (HVG) - NO',
  id: 'HVG',
  obj: {
    iata: 'HVG',
    iso: 'NO',
    coordinates: '25.983600616455, 71.009696960449',
    municipality: 'Honningsv\u00c3\u00a5g'
  }
}, {
  label: 'Daniel K Inouye International Airport (HNL) - US',
  id: 'HNL',
  obj: {
    iata: 'HNL',
    iso: 'US',
    coordinates: '-157.924228, 21.32062',
    municipality: 'Honolulu'
  }
}, {
  label: 'Hooper Bay Airport (HPB) - US',
  id: 'HPB',
  obj: {
    iata: 'HPB',
    iso: 'US',
    coordinates: '-166.1470032, 61.52389908',
    municipality: 'Hooper Bay'
  }
}, {
  label: 'Hope Airport (YHE) - CA',
  id: 'YHE',
  obj: {
    iata: 'YHE',
    iso: 'CA',
    coordinates: '-121.498001099, 49.3683013916',
    municipality: 'Hope'
  }
}, {
  label: 'Hopedale Airport (YHO) - CA',
  id: 'YHO',
  obj: {
    iata: 'YHO',
    iso: 'CA',
    coordinates: '-60.228599548339844, 55.448299407958984',
    municipality: 'Hopedale'
  }
}, {
  label: 'Bowerman Airport (HQM) - US',
  id: 'HQM',
  obj: {
    iata: 'HQM',
    iso: 'US',
    coordinates: '-123.93699646, 46.971199035599994',
    municipality: 'Hoquiam'
  }
}, {
  label: 'Horn Island Airport (HID) - AU',
  id: 'HID',
  obj: {
    iata: 'HID',
    iso: 'AU',
    coordinates: '142.289993286, -10.586400032',
    municipality: 'Horn Island'
  }
}, {
  label: 'Hornepayne Municipal Airport (YHN) - CA',
  id: 'YHN',
  obj: {
    iata: 'YHN',
    iso: 'CA',
    coordinates: '-84.75890350341797, 49.19309997558594',
    municipality: 'Hornepayne'
  }
}, {
  label: 'Horta Airport (HOR) - PT',
  id: 'HOR',
  obj: {
    iata: 'HOR',
    iso: 'PT',
    coordinates: '-28.715900421142578, 38.519901275634766',
    municipality: 'Horta'
  }
}, {
  label: 'Kimbe Airport (HKN) - PG',
  id: 'HKN',
  obj: {
    iata: 'HKN',
    iso: 'PG',
    coordinates: '150.40499877929688, -5.462170124053955',
    municipality: 'Hoskins'
  }
}, {
  label: 'Memorial Field (HOT) - US',
  id: 'HOT',
  obj: {
    iata: 'HOT',
    iso: 'US',
    coordinates: '-93.09619903564453, 34.47800064086914',
    municipality: 'Hot Springs'
  }
}, {
  label: 'Houlton International Airport (HUL) - US',
  id: 'HUL',
  obj: {
    iata: 'HUL',
    iso: 'US',
    coordinates: '-67.792098999, 46.1231002808',
    municipality: 'Houlton'
  }
}, {
  label: 'Conroe-North Houston Regional Airport (CXO) - US',
  id: 'CXO',
  obj: {
    iata: 'CXO',
    iso: 'US',
    coordinates: '-95.414497, 30.351801',
    municipality: 'Houston'
  }
}, {
  label: 'Ellington Airport (EFD) - US',
  id: 'EFD',
  obj: {
    iata: 'EFD',
    iso: 'US',
    coordinates: '-95.1587982178, 29.607299804700002',
    municipality: 'Houston'
  }
}, {
  label: 'William P Hobby Airport (HOU) - US',
  id: 'HOU',
  obj: {
    iata: 'HOU',
    iso: 'US',
    coordinates: '-95.27890015, 29.64539909',
    municipality: 'Houston'
  }
}, {
  label: 'George Bush Intercontinental Houston Airport (IAH) - US',
  id: 'IAH',
  obj: {
    iata: 'IAH',
    iso: 'US',
    coordinates: '-95.34140014648438, 29.984399795532227',
    municipality: 'Houston'
  }
}, {
  label: 'Sugar Land Regional Airport (SGR) - US',
  id: 'SGR',
  obj: {
    iata: 'SGR',
    iso: 'US',
    coordinates: '-95.65650177002, 29.622299194336',
    municipality: 'Houston'
  }
}, {
  label: 'Hrodna Airport (GNA) - BY',
  id: 'GNA',
  obj: {
    iata: 'GNA',
    iso: 'BY',
    coordinates: '24.053800582885742, 53.60200119018555',
    municipality: 'Hrodna'
  }
}, {
  label: 'Hsinchu Air Base (HSZ) - TW',
  id: 'HSZ',
  obj: {
    iata: 'HSZ',
    iso: 'TW',
    coordinates: '120.939002991, 24.8180007935',
    municipality: 'Hsinchu City'
  }
}, {
  label: 'Hua Hin Airport (HHQ) - TH',
  id: 'HHQ',
  obj: {
    iata: 'HHQ',
    iso: 'TH',
    coordinates: '99.951499939, 12.6361999512',
    municipality: 'Hua Hin'
  }
}, {
  label: 'Lianshui Airport (HIA) - CN',
  id: 'HIA',
  obj: {
    iata: 'HIA',
    iso: 'CN',
    coordinates: '119.125, 33.7908333333',
    municipality: "Huai'an"
  }
}, {
  label: 'Zhijiang Airport (HJJ) - CN',
  id: 'HJJ',
  obj: {
    iata: 'HJJ',
    iso: 'CN',
    coordinates: '109.7, 27.4411111111',
    municipality: 'Huaihua'
  }
}, {
  label: 'Hualien Airport (HUN) - TW',
  id: 'HUN',
  obj: {
    iata: 'HUN',
    iso: 'TW',
    coordinates: '121.61799621582031, 24.023099899291992',
    municipality: 'Hualien City'
  }
}, {
  label: 'Nova Lisboa Airport (NOV) - AO',
  id: 'NOV',
  obj: {
    iata: 'NOV',
    iso: 'AO',
    coordinates: '15.760499954223633, -12.808899879455566',
    municipality: 'Huambo'
  }
}, {
  label: 'Bah\u00c3\u00adas de Huatulco International Airport (HUX) - MX',
  id: 'HUX',
  obj: {
    iata: 'HUX',
    iso: 'MX',
    coordinates: '-96.262604, 15.7753',
    municipality: 'Huatulco'
  }
}, {
  label: 'Hubli Airport (HBX) - IN',
  id: 'HBX',
  obj: {
    iata: 'HBX',
    iso: 'IN',
    coordinates: '75.08489990230001, 15.361700058',
    municipality: 'Hubli'
  }
}, {
  label: 'Phu Bai Airport (HUI) - VN',
  id: 'HUI',
  obj: {
    iata: 'HUI',
    iso: 'VN',
    coordinates: '107.70300293, 16.401500701899998',
    municipality: 'Hue'
  }
}, {
  label: 'Huizhou Airport (HUZ) - CN',
  id: 'HUZ',
  obj: {
    iata: 'HUZ',
    iso: 'CN',
    coordinates: '114.599998474, 23.0499992371',
    municipality: 'Huizhou'
  }
}, {
  label: 'Tri-State/Milton J. Ferguson Field (HTS) - US',
  id: 'HTS',
  obj: {
    iata: 'HTS',
    iso: 'US',
    coordinates: '-82.55799866, 38.36669922',
    municipality: 'Huntington'
  }
}, {
  label: 'Huntsville International Carl T Jones Field (HSV) - US',
  id: 'HSV',
  obj: {
    iata: 'HSV',
    iso: 'US',
    coordinates: '-86.775100708008, 34.637199401855',
    municipality: 'Huntsville'
  }
}, {
  label: 'Huntsville Regional Airport (HTV) - US',
  id: 'HTV',
  obj: {
    iata: 'HTV',
    iso: 'US',
    coordinates: '-95.5871963501, 30.7469005585',
    municipality: 'Huntsville'
  }
}, {
  label: 'Hurghada International Airport (HRG) - EG',
  id: 'HRG',
  obj: {
    iata: 'HRG',
    iso: 'EG',
    coordinates: '33.799400329589844, 27.178300857543945',
    municipality: 'Hurghada'
  }
}, {
  label: 'Huron Regional Airport (HON) - US',
  id: 'HON',
  obj: {
    iata: 'HON',
    iso: 'US',
    coordinates: '-98.22850036621094, 44.38520050048828',
    municipality: 'Huron'
  }
}, {
  label: 'Huslia Airport (HSL) - US',
  id: 'HSL',
  obj: {
    iata: 'HSL',
    iso: 'US',
    coordinates: '-156.3509979, 65.69789886',
    municipality: 'Huslia'
  }
}, {
  label: 'Hutchinson Municipal Airport (HUT) - US',
  id: 'HUT',
  obj: {
    iata: 'HUT',
    iso: 'US',
    coordinates: '-97.86060333250002, 38.0654983521',
    municipality: 'Hutchinson'
  }
}, {
  label: 'Kaadedhdhoo Airport (KDM) - MV',
  id: 'KDM',
  obj: {
    iata: 'KDM',
    iso: 'MV',
    coordinates: '72.99690246582031, 0.48813098669052124',
    municipality: 'Huvadhu Atoll'
  }
}, {
  label: 'Alferez Fap David Figueroa Fernandini Airport (HUU) - PE',
  id: 'HUU',
  obj: {
    iata: 'HUU',
    iso: 'PE',
    coordinates: '-76.20480346679688, -9.878809928894043',
    municipality: 'Hu\u00c3\u00a1nuco'
  }
}, {
  label: 'Hwange National Park Airport (HWN) - ZW',
  id: 'HWN',
  obj: {
    iata: 'HWN',
    iso: 'ZW',
    coordinates: '27.020999908447266, -18.629899978637695',
    municipality: 'Hwange'
  }
}, {
  label: 'Barnstable Municipal Boardman Polando Field (HYA) - US',
  id: 'HYA',
  obj: {
    iata: 'HYA',
    iso: 'US',
    coordinates: '-70.28040314, 41.66930008',
    municipality: 'Hyannis'
  }
}, {
  label: 'Rajiv Gandhi International Airport (HYD) - IN',
  id: 'HYD',
  obj: {
    iata: 'HYD',
    iso: 'IN',
    coordinates: '78.429855, 17.231318',
    municipality: 'Hyderabad'
  }
}, {
  label: 'Begumpet Airport (BPM) - IN',
  id: 'BPM',
  obj: {
    iata: 'BPM',
    iso: 'IN',
    coordinates: '78.4675979614, 17.4531002045',
    municipality: 'Hyderabad'
  }
}, {
  label: 'Hornafj\u00c3\u00b6r\u00c3\u00b0ur Airport (HFN) - IS',
  id: 'HFN',
  obj: {
    iata: 'HFN',
    iso: 'IS',
    coordinates: '-15.2272, 64.295601',
    municipality: 'H\u00c3\u00b6fn'
  }
}, {
  label: 'H\u00c3\u00basav\u00c3\u00adk Airport (HZK) - IS',
  id: 'HZK',
  obj: {
    iata: 'HZK',
    iso: 'IS',
    coordinates: '-17.426001, 65.952301',
    municipality: 'H\u00c3\u00basav\u00c3\u00adk'
  }
}, {
  label: 'Al Asad Air Base (IQA) - IQ',
  id: 'IQA',
  obj: {
    iata: 'IQA',
    iso: 'IQ',
    coordinates: '42.4412002563, 33.7855987549',
    municipality: 'H\u00c4\u00abt'
  }
}, {
  label: 'Ia\u00c5\u009fi Airport (IAS) - RO',
  id: 'IAS',
  obj: {
    iata: 'IAS',
    iso: 'RO',
    coordinates: '27.6205997467041, 47.17850112915039',
    municipality: 'Ia\u00c5\u009fi'
  }
}, {
  label: 'Ibadan Airport (IBA) - NG',
  id: 'IBA',
  obj: {
    iata: 'IBA',
    iso: 'NG',
    coordinates: '3.97832989692688, 7.362460136413574',
    municipality: 'Ibadan'
  }
}, {
  label: 'Perales Airport (IBE) - CO',
  id: 'IBE',
  obj: {
    iata: 'IBE',
    iso: 'CO',
    coordinates: '-75.1333, 4.42161',
    municipality: 'Ibagu\u00c3\u00a9'
  }
}, {
  label: 'Iberia Airport (IBP) - PE',
  id: 'IBP',
  obj: {
    iata: 'IBP',
    iso: 'PE',
    coordinates: '-69.48870086669922, -11.411600112915039',
    municipality: 'Iberia'
  }
}, {
  label: 'Ibiza Airport (IBZ) - ES',
  id: 'IBZ',
  obj: {
    iata: 'IBZ',
    iso: 'ES',
    coordinates: '1.3731199502899998, 38.872898101800004',
    municipality: 'Ibiza'
  }
}, {
  label: 'Idaho Falls Regional Airport (IDA) - US',
  id: 'IDA',
  obj: {
    iata: 'IDA',
    iso: 'US',
    coordinates: '-112.070999, 43.514599',
    municipality: 'Idaho Falls'
  }
}, {
  label: 'Ie Jima Airport (IEJ) - JP',
  id: 'IEJ',
  obj: {
    iata: 'IEJ',
    iso: 'JP',
    coordinates: '127.785003662, 26.7220001221',
    municipality: 'Ie'
  }
}, {
  label: 'Igarka Airport (IAA) - RU',
  id: 'IAA',
  obj: {
    iata: 'IAA',
    iso: 'RU',
    coordinates: '86.62190246582031, 67.43720245361328',
    municipality: 'Igarka'
  }
}, {
  label: 'Igloolik Airport (YGT) - CA',
  id: 'YGT',
  obj: {
    iata: 'YGT',
    iso: 'CA',
    coordinates: '-81.8161010742, 69.3647003174',
    municipality: 'Igloolik'
  }
}, {
  label: 'Ignace Municipal Airport (ZUC) - CA',
  id: 'ZUC',
  obj: {
    iata: 'ZUC',
    iso: 'CA',
    coordinates: '-91.7177963256836, 49.4296989440918',
    municipality: 'Ignace'
  }
}, {
  label: 'Iki Airport (IKI) - JP',
  id: 'IKI',
  obj: {
    iata: 'IKI',
    iso: 'JP',
    coordinates: '129.785003662, 33.7490005493',
    municipality: 'Iki'
  }
}, {
  label: 'Ilam Airport (IIL) - IR',
  id: 'IIL',
  obj: {
    iata: 'IIL',
    iso: 'IR',
    coordinates: '46.40480041503906, 33.58660125732422',
    municipality: 'Ilam'
  }
}, {
  label: 'Ilford Airport (ILF) - CA',
  id: 'ILF',
  obj: {
    iata: 'ILF',
    iso: 'CA',
    coordinates: '-95.613899231, 56.0614013672',
    municipality: 'Ilford'
  }
}, {
  label: 'Bahia - Jorge Amado Airport (IOS) - BR',
  id: 'IOS',
  obj: {
    iata: 'IOS',
    iso: 'BR',
    coordinates: '-39.033199310303, -14.815999984741',
    municipality: 'Ilh\u00c3\u00a9us'
  }
}, {
  label: 'Iliamna Airport (ILI) - US',
  id: 'ILI',
  obj: {
    iata: 'ILI',
    iso: 'US',
    coordinates: '-154.9109955, 59.75439835',
    municipality: 'Iliamna'
  }
}, {
  label: 'Illizi Takhamalt Airport (VVZ) - DZ',
  id: 'VVZ',
  obj: {
    iata: 'VVZ',
    iso: 'DZ',
    coordinates: '8.62265014648, 26.7234992981',
    municipality: 'Illizi'
  }
}, {
  label: 'Ilo Airport (ILQ) - PE',
  id: 'ILQ',
  obj: {
    iata: 'ILQ',
    iso: 'PE',
    coordinates: '-71.34400177001953, -17.69499969482422',
    municipality: 'Ilo'
  }
}, {
  label: 'Iloilo International Airport (ILO) - PH',
  id: 'ILO',
  obj: {
    iata: 'ILO',
    iso: 'PH',
    coordinates: '122.493358, 10.833017',
    municipality: 'Iloilo City'
  }
}, {
  label: 'Ilorin International Airport (ILR) - NG',
  id: 'ILR',
  obj: {
    iata: 'ILR',
    iso: 'NG',
    coordinates: '4.493919849395752, 8.440210342407227',
    municipality: 'Ilorin'
  }
}, {
  label: 'Prefeito Renato Moreira Airport (IMP) - BR',
  id: 'IMP',
  obj: {
    iata: 'IMP',
    iso: 'BR',
    coordinates: '-47.459999, -5.53129',
    municipality: 'Imperatriz'
  }
}, {
  label: 'Imperial County Airport (IPL) - US',
  id: 'IPL',
  obj: {
    iata: 'IPL',
    iso: 'US',
    coordinates: '-115.57900238, 32.834201812699995',
    municipality: 'Imperial'
  }
}, {
  label: 'Imphal Airport (IMF) - IN',
  id: 'IMF',
  obj: {
    iata: 'IMF',
    iso: 'IN',
    coordinates: '93.896697998, 24.7600002289',
    municipality: 'Imphal'
  }
}, {
  label: 'In Salah Airport (INZ) - DZ',
  id: 'INZ',
  obj: {
    iata: 'INZ',
    iso: 'DZ',
    coordinates: '2.51202011108, 27.250999450699997',
    municipality: 'In Salah'
  }
}, {
  label: 'Indianapolis International Airport (IND) - US',
  id: 'IND',
  obj: {
    iata: 'IND',
    iso: 'US',
    coordinates: '-86.294403, 39.7173',
    municipality: 'Indianapolis'
  }
}, {
  label: 'Devi Ahilyabai Holkar Airport (IDR) - IN',
  id: 'IDR',
  obj: {
    iata: 'IDR',
    iso: 'IN',
    coordinates: '75.8011016846, 22.7217998505',
    municipality: 'Indore'
  }
}, {
  label: 'San Fernando De Apure Airport (SFD) - VE',
  id: 'SFD',
  obj: {
    iata: 'SFD',
    iso: 'VE',
    coordinates: '-67.44400024414062, 7.883319854736328',
    municipality: 'Inglaterra'
  }
}, {
  label: 'Inhambane Airport (INH) - MZ',
  id: 'INH',
  obj: {
    iata: 'INH',
    iso: 'MZ',
    coordinates: '35.40850067138672, -23.876399993896484',
    municipality: 'Inhambabe'
  }
}, {
  label: 'Innsbruck Airport (INN) - AT',
  id: 'INN',
  obj: {
    iata: 'INN',
    iso: 'AT',
    coordinates: '11.344, 47.260201',
    municipality: 'Innsbruck'
  }
}, {
  label: 'Inta Airport (INA) - RU',
  id: 'INA',
  obj: {
    iata: 'INA',
    iso: 'RU',
    coordinates: '60.110321044921875, 66.0548324584961',
    municipality: 'Inta'
  }
}, {
  label: 'Falls International Airport (INL) - US',
  id: 'INL',
  obj: {
    iata: 'INL',
    iso: 'US',
    coordinates: '-93.4030990600586, 48.566200256347656',
    municipality: 'International Falls'
  }
}, {
  label: 'Inukjuak Airport (YPH) - CA',
  id: 'YPH',
  obj: {
    iata: 'YPH',
    iso: 'CA',
    coordinates: '-78.07689666748047, 58.471900939941406',
    municipality: 'Inukjuak'
  }
}, {
  label: 'Inuvik Mike Zubko Airport (YEV) - CA',
  id: 'YEV',
  obj: {
    iata: 'YEV',
    iso: 'CA',
    coordinates: '-133.483001709, 68.30419921880001',
    municipality: 'Inuvik'
  }
}, {
  label: 'Invercargill Airport (IVC) - NZ',
  id: 'IVC',
  obj: {
    iata: 'IVC',
    iso: 'NZ',
    coordinates: '168.31300354003906, -46.41239929199219',
    municipality: 'Invercargill'
  }
}, {
  label: 'Inverell Airport (IVR) - AU',
  id: 'IVR',
  obj: {
    iata: 'IVR',
    iso: 'AU',
    coordinates: '151.143997192, -29.888299942',
    municipality: 'Inverell'
  }
}, {
  label: 'Inverness Airport (INV) - GB',
  id: 'INV',
  obj: {
    iata: 'INV',
    iso: 'GB',
    coordinates: '-4.047500133514404, 57.54249954223633',
    municipality: 'Inverness'
  }
}, {
  label: 'Ioannina Airport (IOA) - GR',
  id: 'IOA',
  obj: {
    iata: 'IOA',
    iso: 'GR',
    coordinates: '20.822500228881836, 39.6963996887207',
    municipality: 'Ioannina'
  }
}, {
  label: 'Usiminas Airport (IPN) - BR',
  id: 'IPN',
  obj: {
    iata: 'IPN',
    iso: 'BR',
    coordinates: '-42.487598419189, -19.470699310303',
    municipality: 'Ipatinga'
  }
}, {
  label: 'San Luis Airport (IPI) - CO',
  id: 'IPI',
  obj: {
    iata: 'IPI',
    iso: 'CO',
    coordinates: '-77.6718, 0.861925',
    municipality: 'Ipiales'
  }
}, {
  label: 'Sultan Azlan Shah Airport (IPH) - MY',
  id: 'IPH',
  obj: {
    iata: 'IPH',
    iso: 'MY',
    coordinates: '101.09200286865234, 4.567969799041748',
    municipality: 'Ipoh'
  }
}, {
  label: 'Iqaluit Airport (YFB) - CA',
  id: 'YFB',
  obj: {
    iata: 'YFB',
    iso: 'CA',
    coordinates: '-68.555801, 63.756402',
    municipality: 'Iqaluit'
  }
}, {
  label: 'Diego Aracena Airport (IQQ) - CL',
  id: 'IQQ',
  obj: {
    iata: 'IQQ',
    iso: 'CL',
    coordinates: '-70.1812973022461, -20.535200119018555',
    municipality: 'Iquique'
  }
}, {
  label: 'Coronel FAP Francisco Secada Vignetta International Airport (IQT) - PE',
  id: 'IQT',
  obj: {
    iata: 'IQT',
    iso: 'PE',
    coordinates: '-73.30879974365234, -3.7847399711608887',
    municipality: 'Iquitos'
  }
}, {
  label: 'Iran Shahr Airport (IHR) - IR',
  id: 'IHR',
  obj: {
    iata: 'IHR',
    iso: 'IR',
    coordinates: '60.7200012207, 27.2360992432',
    municipality: 'Iranshahr'
  }
}, {
  label: 'Irkutsk Airport (IKT) - RU',
  id: 'IKT',
  obj: {
    iata: 'IKT',
    iso: 'RU',
    coordinates: '104.38899993896, 52.268001556396',
    municipality: 'Irkutsk'
  }
}, {
  label: 'Esfahan Shahid Beheshti International Airport (IFN) - IR',
  id: 'IFN',
  obj: {
    iata: 'IFN',
    iso: 'IR',
    coordinates: '51.86130142211914, 32.75080108642578',
    municipality: 'Isfahan'
  }
}, {
  label: 'New Ishigaki Airport (ISG) - JP',
  id: 'ISG',
  obj: {
    iata: 'ISG',
    iso: 'JP',
    coordinates: '124.245, 24.396389',
    municipality: 'Ishigaki'
  }
}, {
  label: 'Ishurdi Airport (IRD) - BD',
  id: 'IRD',
  obj: {
    iata: 'IRD',
    iso: 'BD',
    coordinates: '89.04940032958984, 24.15250015258789',
    municipality: 'Ishurdi'
  }
}, {
  label: 'Bocas Del Toro International Airport (BOC) - PA',
  id: 'BOC',
  obj: {
    iata: 'BOC',
    iso: 'PA',
    coordinates: '-82.25080108642578, 9.340849876403809',
    municipality: 'Isla Col\u00c3\u00b3n'
  }
}, {
  label: 'Mataveri Airport (IPC) - CL',
  id: 'IPC',
  obj: {
    iata: 'IPC',
    iso: 'CL',
    coordinates: '-109.42199707, -27.1648006439',
    municipality: 'Isla De Pascua'
  }
}, {
  label: 'Del Caribe Santiago Mari\u00c3\u00b1o International Airport (PMV) - VE',
  id: 'PMV',
  obj: {
    iata: 'PMV',
    iso: 'VE',
    coordinates: '-63.96659851074219, 10.912603378295898',
    municipality: 'Isla Margarita'
  }
}, {
  label: 'Siguanea Airport (SZJ) - CU',
  id: 'SZJ',
  obj: {
    iata: 'SZJ',
    iso: 'CU',
    coordinates: '-82.9551010131836, 21.642499923706055',
    municipality: 'Isla de la Juventud'
  }
}, {
  label: 'Islamabad International Airport (ISB) - PK',
  id: 'ISB',
  obj: {
    iata: 'ISB',
    iso: 'PK',
    coordinates: '72.82566, 33.549',
    municipality: 'Islamabad'
  }
}, {
  label: 'Island Lake Airport (YIV) - CA',
  id: 'YIV',
  obj: {
    iata: 'YIV',
    iso: 'CA',
    coordinates: '-94.65360260009766, 53.857200622558594',
    municipality: 'Island Lake'
  }
}, {
  label: 'Long Island Mac Arthur Airport (ISP) - US',
  id: 'ISP',
  obj: {
    iata: 'ISP',
    iso: 'US',
    coordinates: '-73.10019684, 40.79520035',
    municipality: 'Islip'
  }
}, {
  label: 'S\u00c3\u00bcleyman Demirel International Airport (ISE) - TR',
  id: 'ISE',
  obj: {
    iata: 'ISE',
    iso: 'TR',
    coordinates: '30.368400573699997, 37.8554000854',
    municipality: 'Isparta'
  }
}, {
  label: 'Atat\u00c3\u00bcrk International Airport (ISL) - TR',
  id: 'ISL',
  obj: {
    iata: 'ISL',
    iso: 'TR',
    coordinates: '28.8146, 40.976898',
    municipality: 'Istanbul'
  }
}, {
  label: 'Sabiha G\u00c3\u00b6k\u00c3\u00a7en International Airport (SAW) - TR',
  id: 'SAW',
  obj: {
    iata: 'SAW',
    iso: 'TR',
    coordinates: '29.3092002869, 40.898601532',
    municipality: 'Istanbul'
  }
}, {
  label: 'Istanbul Airport (IST) - TR',
  id: 'IST',
  obj: {
    iata: 'IST',
    iso: 'TR',
    coordinates: '28.751944, 41.275278',
    municipality: 'Istanbul'
  }
}, {
  label: 'Itacoatiara Airport (ITA) - BR',
  id: 'ITA',
  obj: {
    iata: 'ITA',
    iso: 'BR',
    coordinates: '-58.481201171875, -3.1272599697113037',
    municipality: 'Itacoatiara'
  }
}, {
  label: 'Itaituba Airport (ITB) - BR',
  id: 'ITB',
  obj: {
    iata: 'ITB',
    iso: 'BR',
    coordinates: '-56.000701904297, -4.2423400878906',
    municipality: 'Itaituba'
  }
}, {
  label: 'Ithaca Tompkins Regional Airport (ITH) - US',
  id: 'ITH',
  obj: {
    iata: 'ITH',
    iso: 'US',
    coordinates: '-76.4583969116211, 42.49100112915039',
    municipality: 'Ithaca'
  }
}, {
  label: 'Ivalo Airport (IVL) - FI',
  id: 'IVL',
  obj: {
    iata: 'IVL',
    iso: 'FI',
    coordinates: '27.405300140381, 68.607299804688',
    municipality: 'Ivalo'
  }
}, {
  label: 'Ivano-Frankivsk International Airport (IFO) - UA',
  id: 'IFO',
  obj: {
    iata: 'IFO',
    iso: 'UA',
    coordinates: '24.686100006103516, 48.88420104980469',
    municipality: 'Ivano-Frankivsk'
  }
}, {
  label: 'Ivanovo South Airport (IWA) - RU',
  id: 'IWA',
  obj: {
    iata: 'IWA',
    iso: 'RU',
    coordinates: '40.940799713134766, 56.93939971923828',
    municipality: 'Ivanovo'
  }
}, {
  label: 'Ivujivik Airport (YIK) - CA',
  id: 'YIK',
  obj: {
    iata: 'YIK',
    iso: 'CA',
    coordinates: '-77.92530059814453, 62.417301177978516',
    municipality: 'Ivujivik'
  }
}, {
  label: 'Iwakuni Kintaikyo Airport / Marine Corps Air Station Iwakuni (IWK) - JP',
  id: 'IWK',
  obj: {
    iata: 'IWK',
    iso: 'JP',
    coordinates: '132.247238, 34.146333',
    municipality: 'Iwakuni'
  }
}, {
  label: 'Ixtapa Zihuatanejo International Airport (ZIH) - MX',
  id: 'ZIH',
  obj: {
    iata: 'ZIH',
    iso: 'MX',
    coordinates: '-101.460998535, 17.601600647',
    municipality: 'Ixtapa'
  }
}, {
  label: 'Ixtepec Airport (IZT) - MX',
  id: 'IZT',
  obj: {
    iata: 'IZT',
    iso: 'MX',
    coordinates: '-95.093697, 16.449301',
    municipality: 'Ixtepec'
  }
}, {
  label: 'Izhevsk Airport (IJK) - RU',
  id: 'IJK',
  obj: {
    iata: 'IJK',
    iso: 'RU',
    coordinates: '53.45750045776367, 56.82809829711914',
    municipality: 'Izhevsk'
  }
}, {
  label: 'Oshima Airport (OIM) - JP',
  id: 'OIM',
  obj: {
    iata: 'OIM',
    iso: 'JP',
    coordinates: '139.36000061, 34.782001495399996',
    municipality: 'Izu Oshima'
  }
}, {
  label: 'Izumo En-Musubi Airport (IZO) - JP',
  id: 'IZO',
  obj: {
    iata: 'IZO',
    iso: 'JP',
    coordinates: '132.889999, 35.413601',
    municipality: 'Izumo'
  }
}, {
  label: 'I\u00c4\u009fd\u00c4\u00b1r Airport (IGD) - TR',
  id: 'IGD',
  obj: {
    iata: 'IGD',
    iso: 'TR',
    coordinates: '43.8766479492, 39.9766273499',
    municipality: 'I\u00c4\u009fd\u00c4\u00b1r'
  }
}, {
  label: 'Jacareacanga Airport (JCR) - BR',
  id: 'JCR',
  obj: {
    iata: 'JCR',
    iso: 'BR',
    coordinates: '-57.77690124511719, -6.233160018920898',
    municipality: 'Jacareacanga'
  }
}, {
  label: 'Jackson Hole Airport (JAC) - US',
  id: 'JAC',
  obj: {
    iata: 'JAC',
    iso: 'US',
    coordinates: '-110.73799896240234, 43.6072998046875',
    municipality: 'Jackson'
  }
}, {
  label: 'Jackson-Medgar Wiley Evers International Airport (JAN) - US',
  id: 'JAN',
  obj: {
    iata: 'JAN',
    iso: 'US',
    coordinates: '-90.0758972168, 32.3111991882',
    municipality: 'Jackson'
  }
}, {
  label: 'Jackson County Reynolds Field (JXN) - US',
  id: 'JXN',
  obj: {
    iata: 'JXN',
    iso: 'US',
    coordinates: '-84.45939636230001, 42.259799957300004',
    municipality: 'Jackson'
  }
}, {
  label: 'McKellar-Sipes Regional Airport (MKL) - US',
  id: 'MKL',
  obj: {
    iata: 'MKL',
    iso: 'US',
    coordinates: '-88.915604, 35.599899',
    municipality: 'Jackson'
  }
}, {
  label: 'Jacksonville Executive at Craig Airport (CRG) - US',
  id: 'CRG',
  obj: {
    iata: 'CRG',
    iso: 'US',
    coordinates: '-81.51439666750001, 30.3362998962',
    municipality: 'Jacksonville'
  }
}, {
  label: 'Jacksonville International Airport (JAX) - US',
  id: 'JAX',
  obj: {
    iata: 'JAX',
    iso: 'US',
    coordinates: '-81.68789672851562, 30.49410057067871',
    municipality: 'Jacksonville'
  }
}, {
  label: 'Little Rock Air Force Base (LRF) - US',
  id: 'LRF',
  obj: {
    iata: 'LRF',
    iso: 'US',
    coordinates: '-92.14969635010002, 34.916900634799994',
    municipality: 'Jacksonville'
  }
}, {
  label: 'Jacksonville Naval Air Station (Towers Field) (NIP) - US',
  id: 'NIP',
  obj: {
    iata: 'NIP',
    iso: 'US',
    coordinates: '-81.680603, 30.2358',
    municipality: 'Jacksonville'
  }
}, {
  label: 'Albert J Ellis Airport (OAJ) - US',
  id: 'OAJ',
  obj: {
    iata: 'OAJ',
    iso: 'US',
    coordinates: '-77.61209869380001, 34.8292007446',
    municipality: 'Jacksonville'
  }
}, {
  label: 'Jacmel Airport (JAK) - HT',
  id: 'JAK',
  obj: {
    iata: 'JAK',
    iso: 'HT',
    coordinates: '-72.51850128173828, 18.241100311279297',
    municipality: 'Jacmel'
  }
}, {
  label: 'Shahbaz Air Base (JAG) - PK',
  id: 'JAG',
  obj: {
    iata: 'JAG',
    iso: 'PK',
    coordinates: '68.44969940185547, 28.28420066833496',
    municipality: 'Jacobabad'
  }
}, {
  label: 'Kankesanturai Airport (JAF) - LK',
  id: 'JAF',
  obj: {
    iata: 'JAF',
    iso: 'LK',
    coordinates: '80.07009887695312, 9.792329788208008',
    municipality: 'Jaffna'
  }
}, {
  label: 'Schleswig Air Base (WBG) - DE',
  id: 'WBG',
  obj: {
    iata: 'WBG',
    iso: 'DE',
    coordinates: '9.51633, 54.459301',
    municipality: 'Jagel'
  }
}, {
  label: 'Jaipur International Airport (JAI) - IN',
  id: 'JAI',
  obj: {
    iata: 'JAI',
    iso: 'IN',
    coordinates: '75.812202, 26.8242',
    municipality: 'Jaipur'
  }
}, {
  label: 'Halim Perdanakusuma International Airport (HLP) - ID',
  id: 'HLP',
  obj: {
    iata: 'HLP',
    iso: 'ID',
    coordinates: '106.89099884033203, -6.266610145568848',
    municipality: 'Jakarta'
  }
}, {
  label: 'Soekarno-Hatta International Airport (CGK) - ID',
  id: 'CGK',
  obj: {
    iata: 'CGK',
    iso: 'ID',
    coordinates: '106.65599823, -6.1255698204',
    municipality: 'Jakarta'
  }
}, {
  label: 'Chautauqua County-Jamestown Airport (JHW) - US',
  id: 'JHW',
  obj: {
    iata: 'JHW',
    iso: 'US',
    coordinates: '-79.25800323, 42.15340042',
    municipality: 'Jamestown'
  }
}, {
  label: 'Jamestown Regional Airport (JMS) - US',
  id: 'JMS',
  obj: {
    iata: 'JMS',
    iso: 'US',
    coordinates: '-98.67819977, 46.92969894',
    municipality: 'Jamestown'
  }
}, {
  label: 'Jammu Airport (IXJ) - IN',
  id: 'IXJ',
  obj: {
    iata: 'IXJ',
    iso: 'IN',
    coordinates: '74.837402, 32.689098',
    municipality: 'Jammu'
  }
}, {
  label: 'Jamnagar Airport (JGA) - IN',
  id: 'JGA',
  obj: {
    iata: 'JGA',
    iso: 'IN',
    coordinates: '70.01260375976562, 22.465499877929688',
    municipality: 'Jamnagar'
  }
}, {
  label: 'Sonari Airport (IXW) - IN',
  id: 'IXW',
  obj: {
    iata: 'IXW',
    iso: 'IN',
    coordinates: '86.1688, 22.8132',
    municipality: 'Jamshedpur'
  }
}, {
  label: 'Janakpur Airport (JKR) - NP',
  id: 'JKR',
  obj: {
    iata: 'JKR',
    iso: 'NP',
    coordinates: '85.9224014282, 26.708799362199997',
    municipality: 'Janakpur'
  }
}, {
  label: 'Jessore Airport (JSR) - BD',
  id: 'JSR',
  obj: {
    iata: 'JSR',
    iso: 'BD',
    coordinates: '89.16079711914062, 23.183799743652344',
    municipality: 'Jashahor'
  }
}, {
  label: 'Francisco Carle Airport (JAU) - PE',
  id: 'JAU',
  obj: {
    iata: 'JAU',
    iso: 'PE',
    coordinates: '-75.47339630130001, -11.7831001282',
    municipality: 'Jauja'
  }
}, {
  label: 'Sentani International Airport (DJJ) - ID',
  id: 'DJJ',
  obj: {
    iata: 'DJJ',
    iso: 'ID',
    coordinates: '140.5160064698, -2.5769500733',
    municipality: 'Jayapura-Papua Island'
  }
}, {
  label: 'Shumba Airport (JAE) - PE',
  id: 'JAE',
  obj: {
    iata: 'JAE',
    iso: 'PE',
    coordinates: '-78.774002, -5.59248',
    municipality: 'Ja\u00c3\u00a9n'
  }
}, {
  label: 'Al Maktoum International Airport (DWC) - AE',
  id: 'DWC',
  obj: {
    iata: 'DWC',
    iso: 'AE',
    coordinates: '55.161389, 24.896356',
    municipality: 'Jebel Ali'
  }
}, {
  label: 'King Abdulaziz International Airport (JED) - SA',
  id: 'JED',
  obj: {
    iata: 'JED',
    iso: 'SA',
    coordinates: '39.156502, 21.6796',
    municipality: 'Jeddah'
  }
}, {
  label: 'Jeju International Airport (CJU) - KR',
  id: 'CJU',
  obj: {
    iata: 'CJU',
    iso: 'KR',
    coordinates: '126.49299621582031, 33.51129913330078',
    municipality: 'Jeju City'
  }
}, {
  label: 'Jeongseok Airport (JDG) - KR',
  id: 'JDG',
  obj: {
    iata: 'JDG',
    iso: 'KR',
    coordinates: '126.711997986, 33.3996009827',
    municipality: 'Jeju Island'
  }
}, {
  label: 'Jenpeg Airport (ZJG) - CA',
  id: 'ZJG',
  obj: {
    iata: 'ZJG',
    iso: 'CA',
    coordinates: '-98.04609680175781, 54.51890182495117',
    municipality: 'Jenpeg'
  }
}, {
  label: 'J\u00c3\u00a9r\u00c3\u00a9mie Airport (JEE) - HT',
  id: 'JEE',
  obj: {
    iata: 'JEE',
    iso: 'HT',
    coordinates: '-74.17030334472656, 18.66309928894043',
    municipality: 'Jeremie'
  }
}, {
  label: 'Jerez Airport (XRY) - ES',
  id: 'XRY',
  obj: {
    iata: 'XRY',
    iso: 'ES',
    coordinates: '-6.060110092163086, 36.744598388671875',
    municipality: 'Jerez de la Forntera'
  }
}, {
  label: 'Jinggangshan Airport (JGS) - CN',
  id: 'JGS',
  obj: {
    iata: 'JGS',
    iso: 'CN',
    coordinates: '114.736999512, 26.856899261499997',
    municipality: "Ji'an"
  }
}, {
  label: 'Jiagedaqi Airport (JGD) - CN',
  id: 'JGD',
  obj: {
    iata: 'JGD',
    iso: 'CN',
    coordinates: '124.1175, 50.371389',
    municipality: 'Jiagedaqi'
  }
}, {
  label: 'Jiayuguan Airport (JGN) - CN',
  id: 'JGN',
  obj: {
    iata: 'JGN',
    iso: 'CN',
    coordinates: '98.3414, 39.856899',
    municipality: 'Jiayuguan'
  }
}, {
  label: 'Jijel Ferhat Abbas Airport (GJL) - DZ',
  id: 'GJL',
  obj: {
    iata: 'GJL',
    iso: 'DZ',
    coordinates: '5.87361001968, 36.7951011658',
    municipality: 'Jijel'
  }
}, {
  label: 'Wilwal International Airport (JIJ) - ET',
  id: 'JIJ',
  obj: {
    iata: 'JIJ',
    iso: 'ET',
    coordinates: '42.9121, 9.3325',
    municipality: 'Jijiga'
  }
}, {
  label: 'Comandante Ariston Pessoa Airport (JJD) - BR',
  id: 'JJD',
  obj: {
    iata: 'JJD',
    iso: 'BR',
    coordinates: '-40.357338, -2.906425',
    municipality: 'Jijoca de Jericoacoara'
  }
}, {
  label: 'Jimma Airport (JIM) - ET',
  id: 'JIM',
  obj: {
    iata: 'JIM',
    iso: 'ET',
    coordinates: '36.81660079956055, 7.66609001159668',
    municipality: 'Jimma'
  }
}, {
  label: 'Jining Qufu Airport (JNG) - CN',
  id: 'JNG',
  obj: {
    iata: 'JNG',
    iso: 'CN',
    coordinates: '116.346667, 35.292778',
    municipality: 'Jining'
  }
}, {
  label: 'Jiroft Airport (JYR) - IR',
  id: 'JYR',
  obj: {
    iata: 'JYR',
    iso: 'IR',
    coordinates: '57.67029953, 28.726900100699996',
    municipality: 'Jiroft'
  }
}, {
  label: 'Jizan Regional Airport (GIZ) - SA',
  id: 'GIZ',
  obj: {
    iata: 'GIZ',
    iso: 'SA',
    coordinates: '42.58580017089844, 16.901100158691406',
    municipality: 'Jizan'
  }
}, {
  label: 'Jodhpur Airport (JDH) - IN',
  id: 'JDH',
  obj: {
    iata: 'JDH',
    iso: 'IN',
    coordinates: '73.04889678955078, 26.251100540161133',
    municipality: 'Jodhpur'
  }
}, {
  label: 'Joensuu Airport (JOE) - FI',
  id: 'JOE',
  obj: {
    iata: 'JOE',
    iso: 'FI',
    coordinates: '29.607500076294, 62.662899017334',
    municipality: 'Joensuu / Liperi'
  }
}, {
  label: 'Rand Airport (QRA) - ZA',
  id: 'QRA',
  obj: {
    iata: 'QRA',
    iso: 'ZA',
    coordinates: '28.1511993408, -26.2425003052',
    municipality: 'Johannesburg'
  }
}, {
  label: 'Lanseria Airport (HLA) - ZA',
  id: 'HLA',
  obj: {
    iata: 'HLA',
    iso: 'ZA',
    coordinates: '27.9260997772, -25.938499450699997',
    municipality: 'Johannesburg'
  }
}, {
  label: 'OR Tambo International Airport (JNB) - ZA',
  id: 'JNB',
  obj: {
    iata: 'JNB',
    iso: 'ZA',
    coordinates: '28.246, -26.1392',
    municipality: 'Johannesburg'
  }
}, {
  label: 'John Murtha Johnstown Cambria County Airport (JST) - US',
  id: 'JST',
  obj: {
    iata: 'JST',
    iso: 'US',
    coordinates: '-78.83390045166016, 40.31610107421875',
    municipality: 'Johnstown'
  }
}, {
  label: 'Senai International Airport (JHB) - MY',
  id: 'JHB',
  obj: {
    iata: 'JHB',
    iso: 'MY',
    coordinates: '103.669998, 1.64131',
    municipality: 'Johor Bahru'
  }
}, {
  label: 'Lauro Carneiro de Loyola Airport (JOI) - BR',
  id: 'JOI',
  obj: {
    iata: 'JOI',
    iso: 'BR',
    coordinates: '-48.797401428222656, -26.22450065612793',
    municipality: 'Joinville'
  }
}, {
  label: 'Jonesboro Municipal Airport (JBR) - US',
  id: 'JBR',
  obj: {
    iata: 'JBR',
    iso: 'US',
    coordinates: '-90.64640045166016, 35.83169937133789',
    municipality: 'Jonesboro'
  }
}, {
  label: 'Joplin Regional Airport (JLN) - US',
  id: 'JLN',
  obj: {
    iata: 'JLN',
    iso: 'US',
    coordinates: '-94.49829864501953, 37.151798248291016',
    municipality: 'Joplin'
  }
}, {
  label: 'Jorhat Airport (JRH) - IN',
  id: 'JRH',
  obj: {
    iata: 'JRH',
    iso: 'IN',
    coordinates: '94.1754989624, 26.7315006256',
    municipality: 'Jorhat'
  }
}, {
  label: 'Yakubu Gowon Airport (JOS) - NG',
  id: 'JOS',
  obj: {
    iata: 'JOS',
    iso: 'NG',
    coordinates: '8.869050025939941, 9.639829635620117',
    municipality: 'Jos'
  }
}, {
  label: 'Presidente Castro Pinto International Airport (JPA) - BR',
  id: 'JPA',
  obj: {
    iata: 'JPA',
    iso: 'BR',
    coordinates: '-34.9486122131, -7.145833015440001',
    municipality: 'Jo\u00c3\u00a3o Pessoa'
  }
}, {
  label: 'Juanjui Airport (JJI) - PE',
  id: 'JJI',
  obj: {
    iata: 'JJI',
    iso: 'PE',
    coordinates: '-76.72859954833984, -7.169099807739258',
    municipality: 'Juanju\u00c3\u00ad'
  }
}, {
  label: 'Juba International Airport (JUB) - SS',
  id: 'JUB',
  obj: {
    iata: 'JUB',
    iso: 'SS',
    coordinates: '31.6011009216, 4.87201023102',
    municipality: 'Juba'
  }
}, {
  label: 'Jubail Airport (QJB) - SA',
  id: 'QJB',
  obj: {
    iata: 'QJB',
    iso: 'SA',
    coordinates: '49.40510177612305, 27.038999557495117',
    municipality: 'Jubail'
  }
}, {
  label: 'Francisco de Assis Airport (JDF) - BR',
  id: 'JDF',
  obj: {
    iata: 'JDF',
    iso: 'BR',
    coordinates: '-43.38679885864258, -21.791500091552734',
    municipality: 'Juiz De Fora'
  }
}, {
  label: 'Zona da Mata Regional Airport (IZA) - BR',
  id: 'IZA',
  obj: {
    iata: 'IZA',
    iso: 'BR',
    coordinates: '-43.1730575562, -21.5130558014',
    municipality: 'Juiz De Fora'
  }
}, {
  label: 'Inca Manco Capac International Airport (JUL) - PE',
  id: 'JUL',
  obj: {
    iata: 'JUL',
    iso: 'PE',
    coordinates: '-70.158203125, -15.467100143432617',
    municipality: 'Juliaca'
  }
}, {
  label: 'Kimble County Airport (JCT) - US',
  id: 'JCT',
  obj: {
    iata: 'JCT',
    iso: 'US',
    coordinates: '-99.7634963989, 30.5112991333',
    municipality: 'Junction'
  }
}, {
  label: 'Juneau International Airport (JNU) - US',
  id: 'JNU',
  obj: {
    iata: 'JNU',
    iso: 'US',
    coordinates: '-134.5760040283203, 58.35499954223633',
    municipality: 'Juneau'
  }
}, {
  label: 'Jyvaskyla Airport (JYV) - FI',
  id: 'JYV',
  obj: {
    iata: 'JYV',
    iso: 'FI',
    coordinates: '25.678300857544, 62.399501800537',
    municipality: 'Jyv\u00c3\u00a4skyl\u00c3\u00a4n Maalaiskunta'
  }
}, {
  label: 'J\u00c3\u00b6nk\u00c3\u00b6ping Airport (JKG) - SE',
  id: 'JKG',
  obj: {
    iata: 'JKG',
    iso: 'SE',
    coordinates: '14.068699836730957, 57.757598876953125',
    municipality: 'J\u00c3\u00b6nk\u00c3\u00b6ping'
  }
}, {
  label: 'Hamid Karzai International Airport (KBL) - AF',
  id: 'KBL',
  obj: {
    iata: 'KBL',
    iso: 'AF',
    coordinates: '69.212303, 34.565899',
    municipality: 'Kabul'
  }
}, {
  label: 'Kadapa Airport (CDP) - IN',
  id: 'CDP',
  obj: {
    iata: 'CDP',
    iso: 'IN',
    coordinates: '78.772778, 14.51',
    municipality: 'Kadapa'
  }
}, {
  label: 'Kadhdhoo Airport (KDO) - MV',
  id: 'KDO',
  obj: {
    iata: 'KDO',
    iso: 'MV',
    coordinates: '73.52189636230469, 1.8591699600219727',
    municipality: 'Kadhdhoo'
  }
}, {
  label: 'Kaduna Airport (KAD) - NG',
  id: 'KAD',
  obj: {
    iata: 'KAD',
    iso: 'NG',
    coordinates: '7.320109844207764, 10.696000099182129',
    municipality: 'Kaduna'
  }
}, {
  label: 'Kagoshima Airport (KOJ) - JP',
  id: 'KOJ',
  obj: {
    iata: 'KOJ',
    iso: 'JP',
    coordinates: '130.718994140625, 31.80340003967285',
    municipality: 'Kagoshima'
  }
}, {
  label: 'Kahramanmara\u00c5\u009f Airport (KCM) - TR',
  id: 'KCM',
  obj: {
    iata: 'KCM',
    iso: 'TR',
    coordinates: '36.9535217285, 37.5388259888',
    municipality: 'Kahramanmara\u00c5\u009f'
  }
}, {
  label: 'Kahului Airport (OGG) - US',
  id: 'OGG',
  obj: {
    iata: 'OGG',
    iso: 'US',
    coordinates: '-156.429993, 20.8986',
    municipality: 'Kahului'
  }
}, {
  label: 'Kaieteur International Airport (KAI) - GY',
  id: 'KAI',
  obj: {
    iata: 'KAI',
    iso: 'GY',
    coordinates: '-59.491481781, 5.17275476456',
    municipality: 'Kaieteur Falls'
  }
}, {
  label: 'Ellison Onizuka Kona International At Keahole Airport (KOA) - US',
  id: 'KOA',
  obj: {
    iata: 'KOA',
    iso: 'US',
    coordinates: '-156.045603, 19.738783',
    municipality: 'Kailua/Kona'
  }
}, {
  label: 'Kaimana Airport (KNG) - ID',
  id: 'KNG',
  obj: {
    iata: 'KNG',
    iso: 'ID',
    coordinates: '133.6959991455078, -3.6445200443267822',
    municipality: 'Kaimana-Papua Island'
  }
}, {
  label: 'Kaitaia Airport (KAT) - NZ',
  id: 'KAT',
  obj: {
    iata: 'KAT',
    iso: 'NZ',
    coordinates: '173.28500366210938, -35.06999969482422',
    municipality: 'Kaitaia'
  }
}, {
  label: 'Kajaani Airport (KAJ) - FI',
  id: 'KAJ',
  obj: {
    iata: 'KAJ',
    iso: 'FI',
    coordinates: '27.692399978638, 64.285499572754',
    municipality: 'Kajaani'
  }
}, {
  label: 'Kalamata Airport (KLX) - GR',
  id: 'KLX',
  obj: {
    iata: 'KLX',
    iso: 'GR',
    coordinates: '22.02549934387207, 37.06829833984375',
    municipality: 'Kalamata'
  }
}, {
  label: 'Kalamazoo Battle Creek International Airport (AZO) - US',
  id: 'AZO',
  obj: {
    iata: 'AZO',
    iso: 'US',
    coordinates: '-85.5521011352539, 42.234901428222656',
    municipality: 'Kalamazoo'
  }
}, {
  label: 'Kalgoorlie Boulder Airport (KGI) - AU',
  id: 'KGI',
  obj: {
    iata: 'KGI',
    iso: 'AU',
    coordinates: '121.461997986, -30.789400100699996',
    municipality: 'Kalgoorlie'
  }
}, {
  label: 'Kalibo International Airport (KLO) - PH',
  id: 'KLO',
  obj: {
    iata: 'KLO',
    iso: 'PH',
    coordinates: '122.375999451, 11.679400444',
    municipality: 'Kalibo'
  }
}, {
  label: 'Khrabrovo Airport (KGD) - RU',
  id: 'KGD',
  obj: {
    iata: 'KGD',
    iso: 'RU',
    coordinates: '20.592599868774414, 54.88999938964844',
    municipality: 'Kaliningrad'
  }
}, {
  label: 'Glacier Park International Airport (FCA) - US',
  id: 'FCA',
  obj: {
    iata: 'FCA',
    iso: 'US',
    coordinates: '-114.25599670410156, 48.31050109863281',
    municipality: 'Kalispell'
  }
}, {
  label: 'Grabtsevo Airport (KLF) - RU',
  id: 'KLF',
  obj: {
    iata: 'KLF',
    iso: 'RU',
    coordinates: '36.3666687012, 54.5499992371',
    municipality: 'Kaluga'
  }
}, {
  label: 'Kamembe Airport (KME) - RW',
  id: 'KME',
  obj: {
    iata: 'KME',
    iso: 'RW',
    coordinates: '28.907899856567383, -2.462239980697632',
    municipality: 'Kamembe'
  }
}, {
  label: 'Kamloops Airport (YKA) - CA',
  id: 'YKA',
  obj: {
    iata: 'YKA',
    iso: 'CA',
    coordinates: '-120.444000244, 50.7022018433',
    municipality: 'Kamloops'
  }
}, {
  label: 'Entebbe International Airport (EBB) - UG',
  id: 'EBB',
  obj: {
    iata: 'EBB',
    iso: 'UG',
    coordinates: '32.443501, 0.042386',
    municipality: 'Kampala'
  }
}, {
  label: 'Kampong Chhnang Airport (KZC) - KH',
  id: 'KZC',
  obj: {
    iata: 'KZC',
    iso: 'KH',
    coordinates: '104.564002991, 12.255200386',
    municipality: 'Kampong Chhnang'
  }
}, {
  label: 'Minhas Air Base (ATG) - PK',
  id: 'ATG',
  obj: {
    iata: 'ATG',
    iso: 'PK',
    coordinates: '72.4009017944, 33.8690986633',
    municipality: 'Kamra'
  }
}, {
  label: 'Waimea Kohala Airport (MUE) - US',
  id: 'MUE',
  obj: {
    iata: 'MUE',
    iso: 'US',
    coordinates: '-155.66799926757812, 20.001300811767578',
    municipality: 'Kamuela'
  }
}, {
  label: 'Kananga Airport (KGA) - CD',
  id: 'KGA',
  obj: {
    iata: 'KGA',
    iso: 'CD',
    coordinates: '22.4692001343, -5.90005016327',
    municipality: 'Kananga'
  }
}, {
  label: 'Komatsu Airport (KMQ) - JP',
  id: 'KMQ',
  obj: {
    iata: 'KMQ',
    iso: 'JP',
    coordinates: '136.40699768066406, 36.39459991455078',
    municipality: 'Kanazawa'
  }
}, {
  label: 'Kandla Airport (IXY) - IN',
  id: 'IXY',
  obj: {
    iata: 'IXY',
    iso: 'IN',
    coordinates: '70.100304, 23.1127',
    municipality: 'Kandla'
  }
}, {
  label: 'Kaneohe Bay MCAS (Marion E. Carl Field) Airport (NGF) - US',
  id: 'NGF',
  obj: {
    iata: 'NGF',
    iso: 'US',
    coordinates: '-157.768005371, 21.4505004883',
    municipality: 'Kaneohe'
  }
}, {
  label: 'Jam Airport (KNR) - IR',
  id: 'KNR',
  obj: {
    iata: 'KNR',
    iso: 'IR',
    coordinates: '52.35219955444336, 27.820499420166016',
    municipality: 'Kangan'
  }
}, {
  label: 'Kangerlussuaq Airport (SFJ) - GL',
  id: 'SFJ',
  obj: {
    iata: 'SFJ',
    iso: 'GL',
    coordinates: '-50.7116031647, 67.0122218992',
    municipality: 'Kangerlussuaq'
  }
}, {
  label: 'Kangiqsualujjuaq (Georges River) Airport (XGR) - CA',
  id: 'XGR',
  obj: {
    iata: 'XGR',
    iso: 'CA',
    coordinates: '-65.9927978515625, 58.71139907836914',
    municipality: 'Kangiqsualujjuaq'
  }
}, {
  label: 'Kangiqsujuaq (Wakeham Bay) Airport (YWB) - CA',
  id: 'YWB',
  obj: {
    iata: 'YWB',
    iso: 'CA',
    coordinates: '-71.929397583, 61.5886001587',
    municipality: 'Kangiqsujuaq'
  }
}, {
  label: 'Kangirsuk Airport (YKG) - CA',
  id: 'YKG',
  obj: {
    iata: 'YKG',
    iso: 'CA',
    coordinates: '-69.99919891357422, 60.027198791503906',
    municipality: 'Kangirsuk'
  }
}, {
  label: 'Greater Kankakee Airport (IKK) - US',
  id: 'IKK',
  obj: {
    iata: 'IKK',
    iso: 'US',
    coordinates: '-87.8462982178, 41.07139968869999',
    municipality: 'Kankakee'
  }
}, {
  label: 'Kannur International Airport (CNN) - IN',
  id: 'CNN',
  obj: {
    iata: 'CNN',
    iso: 'IN',
    coordinates: '75.547211, 11.918614',
    municipality: 'Kannur'
  }
}, {
  label: 'Mallam Aminu International Airport (KAN) - NG',
  id: 'KAN',
  obj: {
    iata: 'KAN',
    iso: 'NG',
    coordinates: '8.52462, 12.0476',
    municipality: 'Kano'
  }
}, {
  label: 'Kanpur Airport (KNU) - IN',
  id: 'KNU',
  obj: {
    iata: 'KNU',
    iso: 'IN',
    coordinates: '80.410103, 26.404301',
    municipality: 'Kanpur'
  }
}, {
  label: 'Kansas City International Airport (MCI) - US',
  id: 'MCI',
  obj: {
    iata: 'MCI',
    iso: 'US',
    coordinates: '-94.713898, 39.2976',
    municipality: 'Kansas City'
  }
}, {
  label: 'Charles B. Wheeler Downtown Airport (MKC) - US',
  id: 'MKC',
  obj: {
    iata: 'MKC',
    iso: 'US',
    coordinates: '-94.5927963256836, 39.123199462890625',
    municipality: 'Kansas City'
  }
}, {
  label: 'Kaohsiung International Airport (KHH) - TW',
  id: 'KHH',
  obj: {
    iata: 'KHH',
    iso: 'TW',
    coordinates: '120.3499984741211, 22.57710075378418',
    municipality: 'Kaohsiung City'
  }
}, {
  label: 'Kaolack Airport (KLC) - SN',
  id: 'KLC',
  obj: {
    iata: 'KLC',
    iso: 'SN',
    coordinates: '-16.051300048828125, 14.146900177001953',
    municipality: 'Kaolack'
  }
}, {
  label: 'Kalaeloa Airport (JRF) - US',
  id: 'JRF',
  obj: {
    iata: 'JRF',
    iso: 'US',
    coordinates: '-158.070009, 21.3074',
    municipality: 'Kapolei'
  }
}, {
  label: 'Kapuskasing Airport (YYU) - CA',
  id: 'YYU',
  obj: {
    iata: 'YYU',
    iso: 'CA',
    coordinates: '-82.46749877929688, 49.41389846801758',
    municipality: 'Kapuskasing'
  }
}, {
  label: 'Jinnah International Airport (KHI) - PK',
  id: 'KHI',
  obj: {
    iata: 'KHI',
    iso: 'PK',
    coordinates: '67.160797, 24.9065',
    municipality: 'Karachi'
  }
}, {
  label: 'Sary-Arka Airport (KGF) - KZ',
  id: 'KGF',
  obj: {
    iata: 'KGF',
    iso: 'KZ',
    coordinates: '73.33439636230469, 49.670799255371094',
    municipality: 'Karaganda'
  }
}, {
  label: 'Payam International Airport (PYK) - IR',
  id: 'PYK',
  obj: {
    iata: 'PYK',
    iso: 'IR',
    coordinates: '50.826698303223, 35.776100158691',
    municipality: 'Karaj'
  }
}, {
  label: 'Kariba International Airport (KAB) - ZW',
  id: 'KAB',
  obj: {
    iata: 'KAB',
    iso: 'ZW',
    coordinates: '28.885000228881836, -16.519800186157227',
    municipality: 'Kariba'
  }
}, {
  label: 'Karlovy Vary International Airport (KLV) - CZ',
  id: 'KLV',
  obj: {
    iata: 'KLV',
    iso: 'CZ',
    coordinates: '12.914999961853027, 50.202999114990234',
    municipality: 'Karlovy Vary'
  }
}, {
  label: 'Karlstad Airport (KSD) - SE',
  id: 'KSD',
  obj: {
    iata: 'KSD',
    iso: 'SE',
    coordinates: '13.337400436400001, 59.444698333699996',
    municipality: 'Karlstad'
  }
}, {
  label: 'Haugesund Airport (HAU) - NO',
  id: 'HAU',
  obj: {
    iata: 'HAU',
    iso: 'NO',
    coordinates: '5.2083601951599, 59.34529876709',
    municipality: 'Karm\u00c3\u00b8y'
  }
}, {
  label: 'Karonga Airport (KGJ) - MW',
  id: 'KGJ',
  obj: {
    iata: 'KGJ',
    iso: 'MW',
    coordinates: '33.893001556396484, -9.953570365905762',
    municipality: 'Karonga'
  }
}, {
  label: 'Karpathos Airport (AOK) - GR',
  id: 'AOK',
  obj: {
    iata: 'AOK',
    iso: 'GR',
    coordinates: '27.145999908447266, 35.4213981628418',
    municipality: 'Karpathos Island'
  }
}, {
  label: 'Karratha Airport (KTA) - AU',
  id: 'KTA',
  obj: {
    iata: 'KTA',
    iso: 'AU',
    coordinates: '116.773002625, -20.712200164799995',
    municipality: 'Karratha'
  }
}, {
  label: 'Kars Airport (KSY) - TR',
  id: 'KSY',
  obj: {
    iata: 'KSY',
    iso: 'TR',
    coordinates: '43.1150016784668, 40.562198638916016',
    municipality: 'Kars'
  }
}, {
  label: 'Karup Airport (KRP) - DK',
  id: 'KRP',
  obj: {
    iata: 'KRP',
    iso: 'DK',
    coordinates: '9.124629974365234, 56.29750061035156',
    municipality: 'Karup'
  }
}, {
  label: 'Kasabonika Airport (XKS) - CA',
  id: 'XKS',
  obj: {
    iata: 'XKS',
    iso: 'CA',
    coordinates: '-88.6427993774414, 53.52470016479492',
    municipality: 'Kasabonika'
  }
}, {
  label: 'Kasane Airport (BBK) - BW',
  id: 'BBK',
  obj: {
    iata: 'BBK',
    iso: 'BW',
    coordinates: '25.162399291992188, -17.83289909362793',
    municipality: 'Kasane'
  }
}, {
  label: 'Kashan Airport (KKS) - IR',
  id: 'KKS',
  obj: {
    iata: 'KKS',
    iso: 'IR',
    coordinates: '51.577, 33.895302',
    municipality: 'Kashan'
  }
}, {
  label: 'Kashechewan Airport (ZKE) - CA',
  id: 'ZKE',
  obj: {
    iata: 'ZKE',
    iso: 'CA',
    coordinates: '-81.67780303955078, 52.282501220703125',
    municipality: 'Kashechewan'
  }
}, {
  label: 'Kassala Airport (KSL) - SD',
  id: 'KSL',
  obj: {
    iata: 'KSL',
    iso: 'SD',
    coordinates: '36.328800201416016, 15.387499809265137',
    municipality: 'Kassala'
  }
}, {
  label: 'Kassel-Calden Airport (KSF) - DE',
  id: 'KSF',
  obj: {
    iata: 'KSF',
    iso: 'DE',
    coordinates: '9.384967, 51.417273',
    municipality: 'Kassel'
  }
}, {
  label: 'Tribhuvan International Airport (KTM) - NP',
  id: 'KTM',
  obj: {
    iata: 'KTM',
    iso: 'NP',
    coordinates: '85.3591, 27.6966',
    municipality: 'Kathmandu'
  }
}, {
  label: 'Katowice International Airport (KTW) - PL',
  id: 'KTW',
  obj: {
    iata: 'KTW',
    iso: 'PL',
    coordinates: '19.08, 50.4743',
    municipality: 'Katowice'
  }
}, {
  label: 'Kauhava Airport (KAU) - FI',
  id: 'KAU',
  obj: {
    iata: 'KAU',
    iso: 'FI',
    coordinates: '23.051399, 63.127102',
    municipality: 'Kauhava'
  }
}, {
  label: 'Molokai Airport (MKK) - US',
  id: 'MKK',
  obj: {
    iata: 'MKK',
    iso: 'US',
    coordinates: '-157.0959930419922, 21.15290069580078',
    municipality: 'Kaunakakai'
  }
}, {
  label: 'Kaunas International Airport (KUN) - LT',
  id: 'KUN',
  obj: {
    iata: 'KUN',
    iso: 'LT',
    coordinates: '24.084800720214844, 54.96390151977539',
    municipality: 'Kaunas'
  }
}, {
  label: 'Alexander the Great International Airport (KVA) - GR',
  id: 'KVA',
  obj: {
    iata: 'KVA',
    iso: 'GR',
    coordinates: '24.619199752807617, 40.913299560546875',
    municipality: 'Kavala'
  }
}, {
  label: 'Kavieng Airport (KVG) - PG',
  id: 'KVG',
  obj: {
    iata: 'KVG',
    iso: 'PG',
    coordinates: '150.807998657, -2.57940006256',
    municipality: 'Kavieng'
  }
}, {
  label: 'Kawthoung Airport (KAW) - MM',
  id: 'KAW',
  obj: {
    iata: 'KAW',
    iso: 'MM',
    coordinates: '98.53800201416016, 10.049300193786621',
    municipality: 'Kawthoung'
  }
}, {
  label: 'Kayseri Erkilet Airport (ASR) - TR',
  id: 'ASR',
  obj: {
    iata: 'ASR',
    iso: 'TR',
    coordinates: '35.4953994751, 38.770401001',
    municipality: 'Kayseri'
  }
}, {
  label: 'Kazan International Airport (KZN) - RU',
  id: 'KZN',
  obj: {
    iata: 'KZN',
    iso: 'RU',
    coordinates: '49.278701782227, 55.606201171875',
    municipality: 'Kazan'
  }
}, {
  label: 'Dillant Hopkins Airport (EEN) - US',
  id: 'EEN',
  obj: {
    iata: 'EEN',
    iso: 'US',
    coordinates: '-72.27079772949219, 42.898399353027344',
    municipality: 'Keene'
  }
}, {
  label: 'Keetmanshoop Airport (KMP) - NA',
  id: 'KMP',
  obj: {
    iata: 'KMP',
    iso: 'NA',
    coordinates: '18.111400604248047, -26.5398006439209',
    municipality: 'Keetmanshoop'
  }
}, {
  label: 'Kefallinia Airport (EFL) - GR',
  id: 'EFL',
  obj: {
    iata: 'EFL',
    iso: 'GR',
    coordinates: '20.500499725341797, 38.12009811401367',
    municipality: 'Kefallinia Island'
  }
}, {
  label: 'Barking Sands Airport (BKH) - US',
  id: 'BKH',
  obj: {
    iata: 'BKH',
    iso: 'US',
    coordinates: '-159.785003662, 22.022800445599998',
    municipality: 'Kekaha'
  }
}, {
  label: 'Kelowna International Airport (YLW) - CA',
  id: 'YLW',
  obj: {
    iata: 'YLW',
    iso: 'CA',
    coordinates: '-119.377998352, 49.9561004639',
    municipality: 'Kelowna'
  }
}, {
  label: 'Kelsey Airport (KES) - CA',
  id: 'KES',
  obj: {
    iata: 'KES',
    iso: 'CA',
    coordinates: '-96.50969696039999, 56.0374984741',
    municipality: 'Kelsey'
  }
}, {
  label: 'Southwest Washington Regional Airport (KLS) - US',
  id: 'KLS',
  obj: {
    iata: 'KLS',
    iso: 'US',
    coordinates: '-122.898002625, 46.11800003049999',
    municipality: 'Kelso'
  }
}, {
  label: 'Kemerovo Airport (KEJ) - RU',
  id: 'KEJ',
  obj: {
    iata: 'KEJ',
    iso: 'RU',
    coordinates: '86.1072006225586, 55.27009963989258',
    municipality: 'Kemerovo'
  }
}, {
  label: 'Kemi-Tornio Airport (KEM) - FI',
  id: 'KEM',
  obj: {
    iata: 'KEM',
    iso: 'FI',
    coordinates: '24.582099914551, 65.778701782227',
    municipality: 'Kemi / Tornio'
  }
}, {
  label: 'Ken Jones Airport (POT) - JM',
  id: 'POT',
  obj: {
    iata: 'POT',
    iso: 'JM',
    coordinates: '-76.53450012210001, 18.1987991333',
    municipality: 'Ken Jones'
  }
}, {
  label: 'Kenai Municipal Airport (ENA) - US',
  id: 'ENA',
  obj: {
    iata: 'ENA',
    iso: 'US',
    coordinates: '-151.2449951171875, 60.57310104370117',
    municipality: 'Kenai'
  }
}, {
  label: 'Kenema Airport (KEN) - SL',
  id: 'KEN',
  obj: {
    iata: 'KEN',
    iso: 'SL',
    coordinates: '-11.176600456237793, 7.891290187835693',
    municipality: 'Kenema'
  }
}, {
  label: 'Kengtung Airport (KET) - MM',
  id: 'KET',
  obj: {
    iata: 'KET',
    iso: 'MM',
    coordinates: '99.63600158691406, 21.301599502563477',
    municipality: 'Kengtung'
  }
}, {
  label: 'Kenora Airport (YQK) - CA',
  id: 'YQK',
  obj: {
    iata: 'YQK',
    iso: 'CA',
    coordinates: '-94.36309814453125, 49.788299560546875',
    municipality: 'Kenora'
  }
}, {
  label: 'Kenosha Regional Airport (ENW) - US',
  id: 'ENW',
  obj: {
    iata: 'ENW',
    iso: 'US',
    coordinates: '-87.92780304, 42.59569931',
    municipality: 'Kenosha'
  }
}, {
  label: 'Keperveem Airport (KPW) - RU',
  id: 'KPW',
  obj: {
    iata: 'KPW',
    iso: 'RU',
    coordinates: '166.139999, 67.845001',
    municipality: 'Keperveem'
  }
}, {
  label: 'Kerema Airport (KMA) - PG',
  id: 'KMA',
  obj: {
    iata: 'KMA',
    iso: 'PG',
    coordinates: '145.770996094, -7.96361017227',
    municipality: 'Kerema'
  }
}, {
  label: 'Kerikeri Airport (KKE) - NZ',
  id: 'KKE',
  obj: {
    iata: 'KKE',
    iso: 'NZ',
    coordinates: '173.91200256347656, -35.26279830932617',
    municipality: 'Kerikeri'
  }
}, {
  label: 'Ioannis Kapodistrias International Airport (CFU) - GR',
  id: 'CFU',
  obj: {
    iata: 'CFU',
    iso: 'GR',
    coordinates: '19.911699295043945, 39.601898193359375',
    municipality: 'Kerkyra Island'
  }
}, {
  label: 'Kerman Airport (KER) - IR',
  id: 'KER',
  obj: {
    iata: 'KER',
    iso: 'IR',
    coordinates: '56.9510993958, 30.274400711099997',
    municipality: 'Kerman'
  }
}, {
  label: 'Shahid Ashrafi Esfahani Airport (KSH) - IR',
  id: 'KSH',
  obj: {
    iata: 'KSH',
    iso: 'IR',
    coordinates: '47.1581001282, 34.3459014893',
    municipality: 'Kermanshah'
  }
}, {
  label: 'Kertajati International Airport (KJT) - ID',
  id: 'KJT',
  obj: {
    iata: 'KJT',
    iso: 'ID',
    coordinates: '108.166692, -6.648924',
    municipality: 'Kertajati'
  }
}, {
  label: 'Kerteh Airport (KTE) - MY',
  id: 'KTE',
  obj: {
    iata: 'KTE',
    iso: 'MY',
    coordinates: '103.427001953125, 4.537220001220703',
    municipality: 'Kerteh'
  }
}, {
  label: 'Ketapang(Rahadi Usman) Airport (KTG) - ID',
  id: 'KTG',
  obj: {
    iata: 'KTG',
    iso: 'ID',
    coordinates: '109.96299743652344, -1.816640019416809',
    municipality: 'Ketapang-Borneo Island'
  }
}, {
  label: 'Minangkabau International Airport (PDG) - ID',
  id: 'PDG',
  obj: {
    iata: 'PDG',
    iso: 'ID',
    coordinates: '100.280998, -0.786917',
    municipality: 'Ketaping/Padang - Sumatra Island'
  }
}, {
  label: 'Ketchikan International Airport (KTN) - US',
  id: 'KTN',
  obj: {
    iata: 'KTN',
    iso: 'US',
    coordinates: '-131.7140045, 55.35559845',
    municipality: 'Ketchikan'
  }
}, {
  label: 'Key Lake Airport (YKJ) - CA',
  id: 'YKJ',
  obj: {
    iata: 'YKJ',
    iso: 'CA',
    coordinates: '-105.61799621582031, 57.256099700927734',
    municipality: 'Key Lake'
  }
}, {
  label: 'Key West International Airport (EYW) - US',
  id: 'EYW',
  obj: {
    iata: 'EYW',
    iso: 'US',
    coordinates: '-81.75959777832031, 24.556100845336914',
    municipality: 'Key West'
  }
}, {
  label: 'Naval Air Station Key West/Boca Chica Field (NQX) - US',
  id: 'NQX',
  obj: {
    iata: 'NQX',
    iso: 'US',
    coordinates: '-81.68890381, 24.57579994',
    municipality: 'Key West'
  }
}, {
  label: 'Khabarovsk-Novy Airport (KHV) - RU',
  id: 'KHV',
  obj: {
    iata: 'KHV',
    iso: 'RU',
    coordinates: '135.18800354004, 48.52799987793',
    municipality: 'Khabarovsk'
  }
}, {
  label: 'Khajuraho Airport (HJR) - IN',
  id: 'HJR',
  obj: {
    iata: 'HJR',
    iso: 'IN',
    coordinates: '79.91860198970001, 24.817199707',
    municipality: 'Khajuraho'
  }
}, {
  label: 'Khanty Mansiysk Airport (HMA) - RU',
  id: 'HMA',
  obj: {
    iata: 'HMA',
    iso: 'RU',
    coordinates: '69.08609771728516, 61.028499603271484',
    municipality: 'Khanty-Mansiysk'
  }
}, {
  label: 'Kharkiv International Airport (HRK) - UA',
  id: 'HRK',
  obj: {
    iata: 'HRK',
    iso: 'UA',
    coordinates: '36.290000915527344, 49.924800872802734',
    municipality: 'Kharkiv'
  }
}, {
  label: 'Khartoum International Airport (KRT) - SD',
  id: 'KRT',
  obj: {
    iata: 'KRT',
    iso: 'SD',
    coordinates: '32.553199768066406, 15.589500427246094',
    municipality: 'Khartoum'
  }
}, {
  label: 'Khasab Air Base (KHS) - OM',
  id: 'KHS',
  obj: {
    iata: 'KHS',
    iso: 'OM',
    coordinates: '56.2406005859375, 26.17099952697754',
    municipality: 'Khasab'
  }
}, {
  label: 'Khatanga Airport (HTG) - RU',
  id: 'HTG',
  obj: {
    iata: 'HTG',
    iso: 'RU',
    coordinates: '102.49099731445312, 71.97810363769531',
    municipality: 'Khatanga'
  }
}, {
  label: 'Khmelnytskyi Airport (HMJ) - UA',
  id: 'HMJ',
  obj: {
    iata: 'HMJ',
    iso: 'UA',
    coordinates: '26.933399, 49.359699',
    municipality: 'Khmelnytskyi'
  }
}, {
  label: 'Khon Kaen Airport (KKC) - TH',
  id: 'KKC',
  obj: {
    iata: 'KKC',
    iso: 'TH',
    coordinates: '102.783996582, 16.466600418099997',
    municipality: 'Khon Kaen'
  }
}, {
  label: 'Moma Airport (MQJ) - RU',
  id: 'MQJ',
  obj: {
    iata: 'MQJ',
    iso: 'RU',
    coordinates: '143.261551, 66.450861',
    municipality: 'Khonuu'
  }
}, {
  label: 'Khudzhand Airport (LBD) - TJ',
  id: 'LBD',
  obj: {
    iata: 'LBD',
    iso: 'TJ',
    coordinates: '69.6947021484375, 40.21540069580078',
    municipality: 'Khudzhand'
  }
}, {
  label: 'Bob Baker Memorial Airport (IAN) - US',
  id: 'IAN',
  obj: {
    iata: 'IAN',
    iso: 'US',
    coordinates: '-160.43699646, 66.9759979248',
    municipality: 'Kiana'
  }
}, {
  label: 'Oxford (Kidlington) Airport (OXF) - GB',
  id: 'OXF',
  obj: {
    iata: 'OXF',
    iso: 'GB',
    coordinates: '-1.32000005245, 51.8368988037',
    municipality: 'Kidlington'
  }
}, {
  label: 'Kiel-Holtenau Airport (KEL) - DE',
  id: 'KEL',
  obj: {
    iata: 'KEL',
    iso: 'DE',
    coordinates: '10.145277976989746, 54.37944412231445',
    municipality: 'Kiel'
  }
}, {
  label: 'Boryspil International Airport (KBP) - UA',
  id: 'KBP',
  obj: {
    iata: 'KBP',
    iso: 'UA',
    coordinates: '30.894699096679688, 50.345001220703125',
    municipality: 'Kiev'
  }
}, {
  label: 'Kiev Zhuliany International Airport (IEV) - UA',
  id: 'IEV',
  obj: {
    iata: 'IEV',
    iso: 'UA',
    coordinates: '30.45194, 50.40194',
    municipality: 'Kiev'
  }
}, {
  label: 'Gostomel Airport (GML) - UA',
  id: 'GML',
  obj: {
    iata: 'GML',
    iso: 'UA',
    coordinates: '30.1919002532959, 50.60350036621094',
    municipality: 'Kiev'
  }
}, {
  label: 'Kigali International Airport (KGL) - RW',
  id: 'KGL',
  obj: {
    iata: 'KGL',
    iso: 'RW',
    coordinates: '30.1395, -1.96863',
    municipality: 'Kigali'
  }
}, {
  label: 'Kikai Airport (KKX) - JP',
  id: 'KKX',
  obj: {
    iata: 'KKX',
    iso: 'JP',
    coordinates: '129.927993774, 28.321300506599997',
    municipality: 'Kikai'
  }
}, {
  label: 'Kerry Airport (KIR) - IE',
  id: 'KIR',
  obj: {
    iata: 'KIR',
    iso: 'IE',
    coordinates: '-9.52377986907959, 52.18090057373047',
    municipality: 'Killarney'
  }
}, {
  label: 'Kimberley Airport (KIM) - ZA',
  id: 'KIM',
  obj: {
    iata: 'KIM',
    iso: 'ZA',
    coordinates: '24.7651996613, -28.802799224900003',
    municipality: 'Kimberley'
  }
}, {
  label: 'Kimmirut Airport (YLC) - CA',
  id: 'YLC',
  obj: {
    iata: 'YLC',
    iso: 'CA',
    coordinates: '-69.88330078119999, 62.8499984741',
    municipality: 'Kimmirut'
  }
}, {
  label: 'Kindersley Airport (YKY) - CA',
  id: 'YKY',
  obj: {
    iata: 'YKY',
    iso: 'CA',
    coordinates: '-109.180999756, 51.5175018311',
    municipality: 'Kindersley'
  }
}, {
  label: 'Kindu Airport (KND) - CD',
  id: 'KND',
  obj: {
    iata: 'KND',
    iso: 'CD',
    coordinates: '25.915399551399997, -2.91917991638',
    municipality: 'Kindu'
  }
}, {
  label: 'King Khaled Military City Airport (KMC) - SA',
  id: 'KMC',
  obj: {
    iata: 'KMC',
    iso: 'SA',
    coordinates: '45.528198, 27.9009',
    municipality: 'King Khaled Military City'
  }
}, {
  label: 'King Salmon Airport (AKN) - US',
  id: 'AKN',
  obj: {
    iata: 'AKN',
    iso: 'US',
    coordinates: '-156.6490021, 58.67679977',
    municipality: 'King Salmon'
  }
}, {
  label: 'Kingston Norman Rogers Airport (YGK) - CA',
  id: 'YGK',
  obj: {
    iata: 'YGK',
    iso: 'CA',
    coordinates: '-76.5969009399414, 44.22529983520508',
    municipality: 'Kingston'
  }
}, {
  label: 'Norman Manley International Airport (KIN) - JM',
  id: 'KIN',
  obj: {
    iata: 'KIN',
    iso: 'JM',
    coordinates: '-76.7874984741211, 17.935699462890625',
    municipality: 'Kingston'
  }
}, {
  label: 'Kingsville Naval Air Station (NQI) - US',
  id: 'NQI',
  obj: {
    iata: 'NQI',
    iso: 'US',
    coordinates: '-97.8097000122, 27.5072002411',
    municipality: 'Kingsville'
  }
}, {
  label: 'RAF Kinloss (FSS) - GB',
  id: 'FSS',
  obj: {
    iata: 'FSS',
    iso: 'GB',
    coordinates: '-3.56064009666, 57.6493988037',
    municipality: 'Kinloss'
  }
}, {
  label: 'Ndjili International Airport (FIH) - CD',
  id: 'FIH',
  obj: {
    iata: 'FIH',
    iso: 'CD',
    coordinates: '15.4446, -4.38575',
    municipality: 'Kinshasa'
  }
}, {
  label: 'Kinston Regional Jetport At Stallings Field (ISO) - US',
  id: 'ISO',
  obj: {
    iata: 'ISO',
    iso: 'US',
    coordinates: '-77.60880279540001, 35.331401825',
    municipality: 'Kinston'
  }
}, {
  label: 'Kirkenes Airport (H\u00c3\u00b8ybuktmoen) (KKN) - NO',
  id: 'KKN',
  obj: {
    iata: 'KKN',
    iso: 'NO',
    coordinates: '29.891300201416, 69.725799560547',
    municipality: 'Kirkenes'
  }
}, {
  label: 'Kirkland Lake Airport (YKX) - CA',
  id: 'YKX',
  obj: {
    iata: 'YKX',
    iso: 'CA',
    coordinates: '-79.98139953613281, 48.21030044555664',
    municipality: 'Kirkland Lake'
  }
}, {
  label: 'Kirksville Regional Airport (IRK) - US',
  id: 'IRK',
  obj: {
    iata: 'IRK',
    iso: 'US',
    coordinates: '-92.5448989868164, 40.09349822998047',
    municipality: 'Kirksville'
  }
}, {
  label: 'Kirkuk Air Base (KIK) - IQ',
  id: 'KIK',
  obj: {
    iata: 'KIK',
    iso: 'IQ',
    coordinates: '44.348899841308594, 35.46950149536133',
    municipality: 'Kirkuk'
  }
}, {
  label: 'Pobedilovo Airport (KVX) - RU',
  id: 'KVX',
  obj: {
    iata: 'KVX',
    iso: 'RU',
    coordinates: '49.348300933838, 58.503299713135',
    municipality: 'Kirov'
  }
}, {
  label: 'Kiruna Airport (KRN) - SE',
  id: 'KRN',
  obj: {
    iata: 'KRN',
    iso: 'SE',
    coordinates: '20.336799621582, 67.821998596191',
    municipality: 'Kiruna'
  }
}, {
  label: 'Bangoka International Airport (FKI) - CD',
  id: 'FKI',
  obj: {
    iata: 'FKI',
    iso: 'CD',
    coordinates: '25.3379993439, 0.481638997793',
    municipality: 'Kisangani'
  }
}, {
  label: 'Kish International Airport (KIH) - IR',
  id: 'KIH',
  obj: {
    iata: 'KIH',
    iso: 'IR',
    coordinates: '53.980201721200004, 26.5261993408',
    municipality: 'Kish Island'
  }
}, {
  label: 'Kisumu Airport (KIS) - KE',
  id: 'KIS',
  obj: {
    iata: 'KIS',
    iso: 'KE',
    coordinates: '34.72890090942383, -0.0861390009522438',
    municipality: 'Kisumu'
  }
}, {
  label: 'Kitadaito Airport (KTD) - JP',
  id: 'KTD',
  obj: {
    iata: 'KTD',
    iso: 'JP',
    coordinates: '131.32699585, 25.9447002411',
    municipality: 'Kitadait\u00c5\u008djima'
  }
}, {
  label: 'Kitakyushu Airport (KKJ) - JP',
  id: 'KKJ',
  obj: {
    iata: 'KKJ',
    iso: 'JP',
    coordinates: '131.035004, 33.845901',
    municipality: 'Kitakyushu'
  }
}, {
  label: 'Kitale Airport (KTL) - KE',
  id: 'KTL',
  obj: {
    iata: 'KTL',
    iso: 'KE',
    coordinates: '34.95859909057617, 0.9719889760017395',
    municipality: 'Kitale'
  }
}, {
  label: 'Waterloo Airport (YKF) - CA',
  id: 'YKF',
  obj: {
    iata: 'YKF',
    iso: 'CA',
    coordinates: '-80.3786010742, 43.460800170899994',
    municipality: 'Kitchener'
  }
}, {
  label: 'Kittil\u00c3\u00a4 Airport (KTT) - FI',
  id: 'KTT',
  obj: {
    iata: 'KTT',
    iso: 'FI',
    coordinates: '24.846799850464, 67.700996398926',
    municipality: 'Kittil\u00c3\u00a4'
  }
}, {
  label: 'Southdowns Airport (KIW) - ZM',
  id: 'KIW',
  obj: {
    iata: 'KIW',
    iso: 'ZM',
    coordinates: '28.149900436401367, -12.900500297546387',
    municipality: 'Kitwe'
  }
}, {
  label: 'Kivalina Airport (KVL) - US',
  id: 'KVL',
  obj: {
    iata: 'KVL',
    iso: 'US',
    coordinates: '-164.56300354003906, 67.73619842529297',
    municipality: 'Kivalina'
  }
}, {
  label: 'Kiwayu Airport (KWY) - KE',
  id: 'KWY',
  obj: {
    iata: 'KWY',
    iso: 'KE',
    coordinates: '41.29750061035156, -1.9605599641799927',
    municipality: 'Kiwayu'
  }
}, {
  label: 'Kristiansand Airport (KRS) - NO',
  id: 'KRS',
  obj: {
    iata: 'KRS',
    iso: 'NO',
    coordinates: '8.08537, 58.204201',
    municipality: 'Kjevik'
  }
}, {
  label: 'Klagenfurt Airport (KLU) - AT',
  id: 'KLU',
  obj: {
    iata: 'KLU',
    iso: 'AT',
    coordinates: '14.3377, 46.642502',
    municipality: 'Klagenfurt am W\u00c3\u00b6rthersee'
  }
}, {
  label: 'Crater Lake-Klamath Regional Airport (LMT) - US',
  id: 'LMT',
  obj: {
    iata: 'LMT',
    iso: 'US',
    coordinates: '-121.733002, 42.156101',
    municipality: 'Klamath Falls'
  }
}, {
  label: 'Klawock Airport (KLW) - US',
  id: 'KLW',
  obj: {
    iata: 'KLW',
    iso: 'US',
    coordinates: '-133.076004028, 55.579200744599994',
    municipality: 'Klawock'
  }
}, {
  label: 'Kleinsee Airport (KLZ) - ZA',
  id: 'KLZ',
  obj: {
    iata: 'KLZ',
    iso: 'ZA',
    coordinates: '17.093999862700002, -29.6884002686',
    municipality: 'Kleinsee'
  }
}, {
  label: 'P C Pelser Airport (KXE) - ZA',
  id: 'KXE',
  obj: {
    iata: 'KXE',
    iso: 'ZA',
    coordinates: '26.718000411987305, -26.8710994720459',
    municipality: 'Klerksdorp'
  }
}, {
  label: 'Whiteman Air Force Base (SZL) - US',
  id: 'SZL',
  obj: {
    iata: 'SZL',
    iso: 'US',
    coordinates: '-93.547897338867, 38.73030090332',
    municipality: 'Knob Noster'
  }
}, {
  label: 'McGhee Tyson Airport (TYS) - US',
  id: 'TYS',
  obj: {
    iata: 'TYS',
    iso: 'US',
    coordinates: '-83.9940033, 35.81100082',
    municipality: 'Knoxville'
  }
}, {
  label: 'Kobe Airport (UKB) - JP',
  id: 'UKB',
  obj: {
    iata: 'UKB',
    iso: 'JP',
    coordinates: '135.2239990234375, 34.6328010559082',
    municipality: 'Kobe'
  }
}, {
  label: 'Cochin International Airport (COK) - IN',
  id: 'COK',
  obj: {
    iata: 'COK',
    iso: 'IN',
    coordinates: '76.401901, 10.152',
    municipality: 'Kochi'
  }
}, {
  label: 'Kodiak Airport (ADQ) - US',
  id: 'ADQ',
  obj: {
    iata: 'ADQ',
    iso: 'US',
    coordinates: '-152.4940033, 57.75',
    municipality: 'Kodiak'
  }
}, {
  label: 'Kogalym International Airport (KGP) - RU',
  id: 'KGP',
  obj: {
    iata: 'KGP',
    iso: 'RU',
    coordinates: '74.53379821777344, 62.190399169921875',
    municipality: 'Kogalym'
  }
}, {
  label: 'Kokkola-Pietarsaari Airport (KOK) - FI',
  id: 'KOK',
  obj: {
    iata: 'KOK',
    iso: 'FI',
    coordinates: '23.143100738525, 63.721199035645',
    municipality: 'Kokkola / Kruunupyy'
  }
}, {
  label: 'Kokshetau Airport (KOV) - KZ',
  id: 'KOV',
  obj: {
    iata: 'KOV',
    iso: 'KZ',
    coordinates: '69.594597, 53.329102',
    municipality: 'Kokshetau'
  }
}, {
  label: 'Netaji Subhash Chandra Bose International Airport (CCU) - IN',
  id: 'CCU',
  obj: {
    iata: 'CCU',
    iso: 'IN',
    coordinates: '88.44670104980469, 22.654699325561523',
    municipality: 'Kolkata'
  }
}, {
  label: 'Komsomolsk-on-Amur Airport (KXK) - RU',
  id: 'KXK',
  obj: {
    iata: 'KXK',
    iso: 'RU',
    coordinates: '136.9340057373047, 50.409000396728516',
    municipality: 'Komsomolsk-on-Amur'
  }
}, {
  label: 'Kontum Airport (KON) - VN',
  id: 'KON',
  obj: {
    iata: 'KON',
    iso: 'VN',
    coordinates: '108.01699829101562, 14.350000381469727',
    municipality: 'Kontum'
  }
}, {
  label: 'Konya Airport (KYA) - TR',
  id: 'KYA',
  obj: {
    iata: 'KYA',
    iso: 'TR',
    coordinates: '32.561901, 37.979',
    municipality: 'Konya'
  }
}, {
  label: 'Kon\u00c3\u00a9 Airport (KNQ) - NC',
  id: 'KNQ',
  obj: {
    iata: 'KNQ',
    iso: 'NC',
    coordinates: '164.83700561523438, -21.05430030822754',
    municipality: 'Kon\u00c3\u00a9'
  }
}, {
  label: 'Korhogo Airport (HGO) - CI',
  id: 'HGO',
  obj: {
    iata: 'HGO',
    iso: 'CI',
    coordinates: '-5.55666017532, 9.38718032837',
    municipality: 'Korhogo'
  }
}, {
  label: 'Kos Airport (KGS) - GR',
  id: 'KGS',
  obj: {
    iata: 'KGS',
    iso: 'GR',
    coordinates: '27.091699600219727, 36.79330062866211',
    municipality: 'Kos Island'
  }
}, {
  label: 'Kostanay West Airport (KSN) - KZ',
  id: 'KSN',
  obj: {
    iata: 'KSN',
    iso: 'KZ',
    coordinates: '63.55030059814453, 53.20690155029297',
    municipality: 'Kostanay'
  }
}, {
  label: 'Kostroma Sokerkino Airport (KMW) - RU',
  id: 'KMW',
  obj: {
    iata: 'KMW',
    iso: 'RU',
    coordinates: '41.019401550299996, 57.7969017029',
    municipality: 'Kostroma'
  }
}, {
  label: 'Kota Airport (KTU) - IN',
  id: 'KTU',
  obj: {
    iata: 'KTU',
    iso: 'IN',
    coordinates: '75.84559631350001, 25.160200119',
    municipality: 'Kota'
  }
}, {
  label: 'Sultan Ismail Petra Airport (KBR) - MY',
  id: 'KBR',
  obj: {
    iata: 'KBR',
    iso: 'MY',
    coordinates: '102.29299926757812, 6.1668500900268555',
    municipality: 'Kota Baharu'
  }
}, {
  label: 'Kota Kinabalu International Airport (BKI) - MY',
  id: 'BKI',
  obj: {
    iata: 'BKI',
    iso: 'MY',
    coordinates: '116.0510025024414, 5.9372100830078125',
    municipality: 'Kota Kinabalu'
  }
}, {
  label: 'Kotlas Airport (KSZ) - RU',
  id: 'KSZ',
  obj: {
    iata: 'KSZ',
    iso: 'RU',
    coordinates: '46.6974983215332, 61.235801696777344',
    municipality: 'Kotlas'
  }
}, {
  label: 'Ralph Wien Memorial Airport (OTZ) - US',
  id: 'OTZ',
  obj: {
    iata: 'OTZ',
    iso: 'US',
    coordinates: '-162.598999, 66.88469696',
    municipality: 'Kotzebue'
  }
}, {
  label: 'Koulamoutou Mabimbi Airport (KOU) - GA',
  id: 'KOU',
  obj: {
    iata: 'KOU',
    iso: 'GA',
    coordinates: '12.441300392151, -1.1846100091934',
    municipality: 'Koulamoutou'
  }
}, {
  label: 'Koumac Airport (KOC) - NC',
  id: 'KOC',
  obj: {
    iata: 'KOC',
    iso: 'NC',
    coordinates: '164.25599670410156, -20.546300888061523',
    municipality: 'Koumac'
  }
}, {
  label: 'Kowanyama Airport (KWM) - AU',
  id: 'KWM',
  obj: {
    iata: 'KWM',
    iso: 'AU',
    coordinates: '141.75100708007812, -15.485600471496582',
    municipality: 'Kowanyama'
  }
}, {
  label: 'Filippos Airport (KZI) - GR',
  id: 'KZI',
  obj: {
    iata: 'KZI',
    iso: 'GR',
    coordinates: '21.84079933166504, 40.28609848022461',
    municipality: 'Kozani'
  }
}, {
  label: 'Ko\u00c5\u00a1ice Airport (KSC) - SK',
  id: 'KSC',
  obj: {
    iata: 'KSC',
    iso: 'SK',
    coordinates: '21.241100311279297, 48.66310119628906',
    municipality: 'Ko\u00c5\u00a1ice'
  }
}, {
  label: 'Krabi Airport (KBV) - TH',
  id: 'KBV',
  obj: {
    iata: 'KBV',
    iso: 'TH',
    coordinates: '98.9861984253, 8.09912014008',
    municipality: 'Krabi'
  }
}, {
  label: 'Krak\u00c3\u00b3w John Paul II International Airport (KRK) - PL',
  id: 'KRK',
  obj: {
    iata: 'KRK',
    iso: 'PL',
    coordinates: '19.7848, 50.077702',
    municipality: 'Krak\u00c3\u00b3w'
  }
}, {
  label: 'Flamingo International Airport (BON) - BQ',
  id: 'BON',
  obj: {
    iata: 'BON',
    iso: 'BQ',
    coordinates: '-68.26850128173828, 12.130999565124512',
    municipality: 'Kralendijk'
  }
}, {
  label: 'Kramfors Sollefte\u00c3\u00a5 Airport (KRF) - SE',
  id: 'KRF',
  obj: {
    iata: 'KRF',
    iso: 'SE',
    coordinates: '17.76889991760254, 63.04859924316406',
    municipality: 'Kramfors / Sollefte\u00c3\u00a5'
  }
}, {
  label: 'Krasnodar Pashkovsky International Airport (KRR) - RU',
  id: 'KRR',
  obj: {
    iata: 'KRR',
    iso: 'RU',
    coordinates: '39.170501708984, 45.034698486328',
    municipality: 'Krasnodar'
  }
}, {
  label: 'Turkmenbashi Airport (KRW) - TM',
  id: 'KRW',
  obj: {
    iata: 'KRW',
    iso: 'TM',
    coordinates: '53.007198, 40.063301',
    municipality: 'Krasnovodsk'
  }
}, {
  label: 'Yemelyanovo Airport (KJA) - RU',
  id: 'KJA',
  obj: {
    iata: 'KJA',
    iso: 'RU',
    coordinates: '92.493301, 56.172901',
    municipality: 'Krasnoyarsk'
  }
}, {
  label: 'Kristianstad Airport (KID) - SE',
  id: 'KID',
  obj: {
    iata: 'KID',
    iso: 'SE',
    coordinates: '14.08549976348877, 55.92169952392578',
    municipality: 'Kristianstad'
  }
}, {
  label: 'Kryvyi Rih International Airport (KWG) - UA',
  id: 'KWG',
  obj: {
    iata: 'KWG',
    iso: 'UA',
    coordinates: '33.209999084472656, 48.04330062866211',
    municipality: 'Kryvyi Rih'
  }
}, {
  label: 'Kuala Lumpur International Airport (KUL) - MY',
  id: 'KUL',
  obj: {
    iata: 'KUL',
    iso: 'MY',
    coordinates: '101.70999908447, 2.745579957962',
    municipality: 'Kuala Lumpur'
  }
}, {
  label: 'Sultan Mahmud Airport (TGG) - MY',
  id: 'TGG',
  obj: {
    iata: 'TGG',
    iso: 'MY',
    coordinates: '103.10299682617188, 5.3826398849487305',
    municipality: 'Kuala Terengganu'
  }
}, {
  label: 'Kuantan Airport (KUA) - MY',
  id: 'KUA',
  obj: {
    iata: 'KUA',
    iso: 'MY',
    coordinates: '103.20899963378906, 3.7753899097442627',
    municipality: 'Kuantan'
  }
}, {
  label: 'Kuching International Airport (KCH) - MY',
  id: 'KCH',
  obj: {
    iata: 'KCH',
    iso: 'MY',
    coordinates: '110.34700012207031, 1.4846999645233154',
    municipality: 'Kuching'
  }
}, {
  label: 'Kufra Airport (AKF) - LY',
  id: 'AKF',
  obj: {
    iata: 'AKF',
    iso: 'LY',
    coordinates: '23.31399917602539, 24.178699493408203',
    municipality: 'Kufra'
  }
}, {
  label: 'Kugaaruk Airport (YBB) - CA',
  id: 'YBB',
  obj: {
    iata: 'YBB',
    iso: 'CA',
    coordinates: '-89.808098, 68.534401',
    municipality: 'Kugaaruk'
  }
}, {
  label: 'Kugluktuk Airport (YCO) - CA',
  id: 'YCO',
  obj: {
    iata: 'YCO',
    iso: 'CA',
    coordinates: '-115.143997, 67.816704',
    municipality: 'Kugluktuk'
  }
}, {
  label: 'Kuito Airport (SVP) - AO',
  id: 'SVP',
  obj: {
    iata: 'SVP',
    iso: 'AO',
    coordinates: '16.947399139404, -12.404600143433',
    municipality: 'Kuito'
  }
}, {
  label: 'Kulob Airport (TJU) - TJ',
  id: 'TJU',
  obj: {
    iata: 'TJU',
    iso: 'TJ',
    coordinates: '69.80500030517578, 37.98809814453125',
    municipality: 'Kulyab'
  }
}, {
  label: 'Kumamoto Airport (KMJ) - JP',
  id: 'KMJ',
  obj: {
    iata: 'KMJ',
    iso: 'JP',
    coordinates: '130.85499572753906, 32.83729934692383',
    municipality: 'Kumamoto'
  }
}, {
  label: 'Kumasi Airport (KMS) - GH',
  id: 'KMS',
  obj: {
    iata: 'KMS',
    iso: 'GH',
    coordinates: '-1.5908199548721313, 6.714560031890869',
    municipality: 'Kumasi'
  }
}, {
  label: 'Chimbu Airport (CMU) - PG',
  id: 'CMU',
  obj: {
    iata: 'CMU',
    iso: 'PG',
    coordinates: '144.9709930419922, -6.024290084838867',
    municipality: 'Kundiawa'
  }
}, {
  label: 'Kunsan Air Base (KUV) - KR',
  id: 'KUV',
  obj: {
    iata: 'KUV',
    iso: 'KR',
    coordinates: '126.61599731445312, 35.90380096435547',
    municipality: 'Kunsan'
  }
}, {
  label: 'Kununurra Airport (KNX) - AU',
  id: 'KNX',
  obj: {
    iata: 'KNX',
    iso: 'AU',
    coordinates: '128.707992554, -15.7781000137',
    municipality: 'Kununurra'
  }
}, {
  label: 'Kuopio Airport (KUO) - FI',
  id: 'KUO',
  obj: {
    iata: 'KUO',
    iso: 'FI',
    coordinates: '27.797800064087, 63.007099151611',
    municipality: 'Kuopio / Siilinj\u00c3\u00a4rvi'
  }
}, {
  label: 'Kuressaare Airport (URE) - EE',
  id: 'URE',
  obj: {
    iata: 'URE',
    iso: 'EE',
    coordinates: '22.50950050354004, 58.22990036010742',
    municipality: 'Kuressaare'
  }
}, {
  label: 'Kurgan Airport (KRO) - RU',
  id: 'KRO',
  obj: {
    iata: 'KRO',
    iso: 'RU',
    coordinates: '65.41560363769531, 55.47529983520508',
    municipality: 'Kurgan'
  }
}, {
  label: 'Qurghonteppa International Airport (KQT) - TJ',
  id: 'KQT',
  obj: {
    iata: 'KQT',
    iso: 'TJ',
    coordinates: '68.86470031738281, 37.86640167236328',
    municipality: 'Kurgan-Tyube'
  }
}, {
  label: 'Kursk East Airport (URS) - RU',
  id: 'URS',
  obj: {
    iata: 'URS',
    iso: 'RU',
    coordinates: '36.29560089111328, 51.7505989074707',
    municipality: 'Kursk'
  }
}, {
  label: 'Johan Pienaar Airport (KMH) - ZA',
  id: 'KMH',
  obj: {
    iata: 'KMH',
    iso: 'ZA',
    coordinates: '23.411399841308594, -27.45669937133789',
    municipality: 'Kuruman'
  }
}, {
  label: 'Kushiro Airport (KUH) - JP',
  id: 'KUH',
  obj: {
    iata: 'KUH',
    iso: 'JP',
    coordinates: '144.192993164, 43.041000366199995',
    municipality: 'Kushiro'
  }
}, {
  label: 'Kopitnari Airport (KUT) - GE',
  id: 'KUT',
  obj: {
    iata: 'KUT',
    iso: 'GE',
    coordinates: '42.4826011658, 42.176700592',
    municipality: 'Kutaisi'
  }
}, {
  label: 'Kuujjuaq Airport (YVP) - CA',
  id: 'YVP',
  obj: {
    iata: 'YVP',
    iso: 'CA',
    coordinates: '-68.4269027709961, 58.096099853515625',
    municipality: 'Kuujjuaq'
  }
}, {
  label: 'Kuujjuarapik Airport (YGW) - CA',
  id: 'YGW',
  obj: {
    iata: 'YGW',
    iso: 'CA',
    coordinates: '-77.76529693603516, 55.281898498535156',
    municipality: 'Kuujjuarapik'
  }
}, {
  label: 'Kuusamo Airport (KAO) - FI',
  id: 'KAO',
  obj: {
    iata: 'KAO',
    iso: 'FI',
    coordinates: '29.239400863647, 65.987602233887',
    municipality: 'Kuusamo'
  }
}, {
  label: 'Kuwait International Airport (KWI) - KW',
  id: 'KWI',
  obj: {
    iata: 'KWI',
    iso: 'KW',
    coordinates: '47.96889877319336, 29.226600646972656',
    municipality: 'Kuwait City'
  }
}, {
  label: 'Kristiansund Airport (Kvernberget) (KSU) - NO',
  id: 'KSU',
  obj: {
    iata: 'KSU',
    iso: 'NO',
    coordinates: '7.824520111084, 63.111801147461',
    municipality: 'Kvernberget'
  }
}, {
  label: 'Bucholz Army Air Field (KWA) - MH',
  id: 'KWA',
  obj: {
    iata: 'KWA',
    iso: 'MH',
    coordinates: '167.73199462890625, 8.720120429992676',
    municipality: 'Kwajalein'
  }
}, {
  label: 'Kyaukpyu Airport (KYP) - MM',
  id: 'KYP',
  obj: {
    iata: 'KYP',
    iso: 'MM',
    coordinates: '93.53479766845703, 19.42639923095703',
    municipality: 'Kyaukpyu'
  }
}, {
  label: 'Kyzyl Airport (KYZ) - RU',
  id: 'KYZ',
  obj: {
    iata: 'KYZ',
    iso: 'RU',
    coordinates: '94.40059661865234, 51.66939926147461',
    municipality: 'Kyzyl'
  }
}, {
  label: 'K\u00c3\u00a4rdla Airport (KDL) - EE',
  id: 'KDL',
  obj: {
    iata: 'KDL',
    iso: 'EE',
    coordinates: '22.830699920654297, 58.99079895019531',
    municipality: 'K\u00c3\u00a4rdla'
  }
}, {
  label: 'K\u00c3\u00a9dougou Airport (KGG) - SN',
  id: 'KGG',
  obj: {
    iata: 'KGG',
    iso: 'SN',
    coordinates: '-12.22029972076416, 12.57229995727539',
    municipality: 'K\u00c3\u00a9dougou'
  }
}, {
  label: 'La Baule-Escoublac Airport (LBY) - FR',
  id: 'LBY',
  obj: {
    iata: 'LBY',
    iso: 'FR',
    coordinates: '-2.3463900089263916, 47.289398193359375',
    municipality: 'La Baule-Escoublac'
  }
}, {
  label: 'Goloson International Airport (LCE) - HN',
  id: 'LCE',
  obj: {
    iata: 'LCE',
    iso: 'HN',
    coordinates: '-86.852997, 15.7425',
    municipality: 'La Ceiba'
  }
}, {
  label: 'La Crosse Municipal Airport (LSE) - US',
  id: 'LSE',
  obj: {
    iata: 'LSE',
    iso: 'US',
    coordinates: '-91.256699, 43.879002',
    municipality: 'La Crosse'
  }
}, {
  label: 'German Olano Air Base (PAL) - CO',
  id: 'PAL',
  obj: {
    iata: 'PAL',
    iso: 'CO',
    coordinates: '-74.6574, 5.48361',
    municipality: 'La Dorada'
  }
}, {
  label: 'La Grande Rivi\u00c3\u00a8re Airport (YGL) - CA',
  id: 'YGL',
  obj: {
    iata: 'YGL',
    iso: 'CA',
    coordinates: '-77.7042007446289, 53.625301361083984',
    municipality: 'La Grande Rivi\u00c3\u00a8re'
  }
}, {
  label: 'La Grande-4 Airport (YAH) - CA',
  id: 'YAH',
  obj: {
    iata: 'YAH',
    iso: 'CA',
    coordinates: '-73.6753005981, 53.754699707',
    municipality: 'La Grande-4'
  }
}, {
  label: 'La Isabela International Airport (JBQ) - DO',
  id: 'JBQ',
  obj: {
    iata: 'JBQ',
    iso: 'DO',
    coordinates: '-69.98560333251953, 18.572500228881836',
    municipality: 'La Isabela'
  }
}, {
  label: 'Jorge Isaac Airport (MCJ) - CO',
  id: 'MCJ',
  obj: {
    iata: 'MCJ',
    iso: 'CO',
    coordinates: '-72.4901, 11.2325',
    municipality: 'La Mina-Maicao'
  }
}, {
  label: 'Manuel M\u00c3\u00a1rquez de Le\u00c3\u00b3n International Airport (LAP) - MX',
  id: 'LAP',
  obj: {
    iata: 'LAP',
    iso: 'MX',
    coordinates: '-110.361999512, 24.072700500499998',
    municipality: 'La Paz'
  }
}, {
  label: 'El Alto International Airport (LPB) - BO',
  id: 'LPB',
  obj: {
    iata: 'LPB',
    iso: 'BO',
    coordinates: '-68.19229888916016, -16.5132999420166',
    municipality: 'La Paz / El Alto'
  }
}, {
  label: 'La Plata Airport (LPG) - AR',
  id: 'LPG',
  obj: {
    iata: 'LPG',
    iso: 'AR',
    coordinates: '-57.8947, -34.9722',
    municipality: 'La Plata'
  }
}, {
  label: 'Capitan V A Almonacid Airport (IRJ) - AR',
  id: 'IRJ',
  obj: {
    iata: 'IRJ',
    iso: 'AR',
    coordinates: '-66.7957992554, -29.3815994263',
    municipality: 'La Rioja'
  }
}, {
  label: 'La Roche-sur-Yon Airport (EDM) - FR',
  id: 'EDM',
  obj: {
    iata: 'EDM',
    iso: 'FR',
    coordinates: '-1.3786300420761108, 46.701900482177734',
    municipality: 'La Roche-sur-Yon/Les Ajoncs'
  }
}, {
  label: 'La Rochelle-\u00c3\u008ele de R\u00c3\u00a9 Airport (LRH) - FR',
  id: 'LRH',
  obj: {
    iata: 'LRH',
    iso: 'FR',
    coordinates: '-1.1952799558639526, 46.17919921875',
    municipality: 'La Rochelle/\u00c3\u008ele de R\u00c3\u00a9'
  }
}, {
  label: 'Casa De Campo International Airport (LRM) - DO',
  id: 'LRM',
  obj: {
    iata: 'LRM',
    iso: 'DO',
    coordinates: '-68.91179656982422, 18.450700759887695',
    municipality: 'La Romana'
  }
}, {
  label: 'La Ronge Airport (YVC) - CA',
  id: 'YVC',
  obj: {
    iata: 'YVC',
    iso: 'CA',
    coordinates: '-105.262001038, 55.151401519800004',
    municipality: 'La Ronge'
  }
}, {
  label: 'La Florida Airport (LSC) - CL',
  id: 'LSC',
  obj: {
    iata: 'LSC',
    iso: 'CL',
    coordinates: '-71.199501, -29.916201',
    municipality: 'La Serena-Coquimbo'
  }
}, {
  label: 'Labuan Airport (LBU) - MY',
  id: 'LBU',
  obj: {
    iata: 'LBU',
    iso: 'MY',
    coordinates: '115.25, 5.300680160522461',
    municipality: 'Labuan'
  }
}, {
  label: 'Lac Brochet Airport (XLB) - CA',
  id: 'XLB',
  obj: {
    iata: 'XLB',
    iso: 'CA',
    coordinates: '-101.46900177, 58.6175003052',
    municipality: 'Lac Brochet'
  }
}, {
  label: 'Ladysmith Airport (LAY) - ZA',
  id: 'LAY',
  obj: {
    iata: 'LAY',
    iso: 'ZA',
    coordinates: '29.749700546299998, -28.5816993713',
    municipality: 'Ladysmith'
  }
}, {
  label: 'Nadzab Airport (LAE) - PG',
  id: 'LAE',
  obj: {
    iata: 'LAE',
    iso: 'PG',
    coordinates: '146.725977, -6.569803',
    municipality: 'Lae'
  }
}, {
  label: 'Purdue University Airport (LAF) - US',
  id: 'LAF',
  obj: {
    iata: 'LAF',
    iso: 'US',
    coordinates: '-86.93689727783203, 40.41230010986328',
    municipality: 'Lafayette'
  }
}, {
  label: 'Lafayette Regional Airport (LFT) - US',
  id: 'LFT',
  obj: {
    iata: 'LFT',
    iso: 'US',
    coordinates: '-91.98760223, 30.20529938',
    municipality: 'Lafayette'
  }
}, {
  label: 'Lages Airport (LAJ) - BR',
  id: 'LAJ',
  obj: {
    iata: 'LAJ',
    iso: 'BR',
    coordinates: '-50.28150177, -27.782100677499997',
    municipality: 'Lages'
  }
}, {
  label: 'Laghouat Airport (LOO) - DZ',
  id: 'LOO',
  obj: {
    iata: 'LOO',
    iso: 'DZ',
    coordinates: '2.92833995819, 33.764400482199996',
    municipality: 'Laghouat'
  }
}, {
  label: 'Murtala Muhammed International Airport (LOS) - NG',
  id: 'LOS',
  obj: {
    iata: 'LOS',
    iso: 'NG',
    coordinates: '3.321160078048706, 6.5773701667785645',
    municipality: 'Lagos'
  }
}, {
  label: 'Lahad Datu Airport (LDU) - MY',
  id: 'LDU',
  obj: {
    iata: 'LDU',
    iso: 'MY',
    coordinates: '118.3239974975586, 5.032249927520752',
    municipality: 'Lahad Datu'
  }
}, {
  label: 'Kapalua Airport (JHM) - US',
  id: 'JHM',
  obj: {
    iata: 'JHM',
    iso: 'US',
    coordinates: '-156.67300415039062, 20.962900161743164',
    municipality: 'Lahaina'
  }
}, {
  label: 'Alama Iqbal International Airport (LHE) - PK',
  id: 'LHE',
  obj: {
    iata: 'LHE',
    iso: 'PK',
    coordinates: '74.40360260009766, 31.5216007232666',
    municipality: 'Lahore'
  }
}, {
  label: 'Lake Charles Regional Airport (LCH) - US',
  id: 'LCH',
  obj: {
    iata: 'LCH',
    iso: 'US',
    coordinates: '-93.22329711914062, 30.126100540161133',
    municipality: 'Lake Charles'
  }
}, {
  label: 'Lake Manyara Airport (LKY) - TZ',
  id: 'LKY',
  obj: {
    iata: 'LKY',
    iso: 'TZ',
    coordinates: '35.81829833984375, -3.376310110092163',
    municipality: 'Lake Manyara National Park'
  }
}, {
  label: 'Lakehurst Maxfield Field Airport (NEL) - US',
  id: 'NEL',
  obj: {
    iata: 'NEL',
    iso: 'US',
    coordinates: '-74.353302, 40.03329849',
    municipality: 'Lakehurst'
  }
}, {
  label: 'Lakeland Linder International Airport (LAL) - US',
  id: 'LAL',
  obj: {
    iata: 'LAL',
    iso: 'US',
    coordinates: '-82.018602, 27.988899',
    municipality: 'Lakeland'
  }
}, {
  label: 'RAF Lakenheath (LKZ) - GB',
  id: 'LKZ',
  obj: {
    iata: 'LKZ',
    iso: 'GB',
    coordinates: '0.56099998951, 52.409301757799994',
    municipality: 'Lakenheath'
  }
}, {
  label: 'Banak Airport (LKL) - NO',
  id: 'LKL',
  obj: {
    iata: 'LKL',
    iso: 'NO',
    coordinates: '24.973499298096, 70.068801879883',
    municipality: 'Lakselv'
  }
}, {
  label: 'Lambarene Airport (LBQ) - GA',
  id: 'LBQ',
  obj: {
    iata: 'LBQ',
    iso: 'GA',
    coordinates: '10.245699882507324, -0.7043889760971069',
    municipality: 'Lambarene'
  }
}, {
  label: 'Lamezia Terme Airport (SUF) - IT',
  id: 'SUF',
  obj: {
    iata: 'SUF',
    iso: 'IT',
    coordinates: '16.2423, 38.905399',
    municipality: 'Lamezia Terme (CZ)'
  }
}, {
  label: 'Lampedusa Airport (LMP) - IT',
  id: 'LMP',
  obj: {
    iata: 'LMP',
    iso: 'IT',
    coordinates: '12.6181, 35.497898',
    municipality: 'Lampedusa'
  }
}, {
  label: 'Manda Airstrip (LAU) - KE',
  id: 'LAU',
  obj: {
    iata: 'LAU',
    iso: 'KE',
    coordinates: '40.91310119628906, -2.252419948577881',
    municipality: 'Lamu'
  }
}, {
  label: 'Lanai Airport (LNY) - US',
  id: 'LNY',
  obj: {
    iata: 'LNY',
    iso: 'US',
    coordinates: '-156.9510040283203, 20.785600662231445',
    municipality: 'Lanai City'
  }
}, {
  label: 'Lancaster Airport (LNS) - US',
  id: 'LNS',
  obj: {
    iata: 'LNS',
    iso: 'US',
    coordinates: '-76.29609680175781, 40.121700286865234',
    municipality: 'Lancaster'
  }
}, {
  label: 'General WM J Fox Airfield (WJF) - US',
  id: 'WJF',
  obj: {
    iata: 'WJF',
    iso: 'US',
    coordinates: '-118.2190018, 34.74110031',
    municipality: 'Lancaster'
  }
}, {
  label: "Land's End Airport (LEQ) - GB",
  id: 'LEQ',
  obj: {
    iata: 'LEQ',
    iso: 'GB',
    coordinates: '-5.67056, 50.102798',
    municipality: "Land's End"
  }
}, {
  label: 'Hunt Field (LND) - US',
  id: 'LND',
  obj: {
    iata: 'LND',
    iso: 'US',
    coordinates: '-108.730003357, 42.8152008057',
    municipality: 'Lander'
  }
}, {
  label: 'Landivisiau Air Base (LDV) - FR',
  id: 'LDV',
  obj: {
    iata: 'LDV',
    iso: 'FR',
    coordinates: '-4.151639938354492, 48.53030014038086',
    municipality: 'Landivisiau'
  }
}, {
  label: 'Langebaanweg Airport (SDB) - ZA',
  id: 'SDB',
  obj: {
    iata: 'SDB',
    iso: 'ZA',
    coordinates: '18.1602993011, -32.968898773199996',
    municipality: 'Langebaanweg'
  }
}, {
  label: 'Karel Sadsuitubun Airport (LUV) - ID',
  id: 'LUV',
  obj: {
    iata: 'LUV',
    iso: 'ID',
    coordinates: '132.759444, -5.760278',
    municipality: 'Langgur'
  }
}, {
  label: 'Langkawi International Airport (LGK) - MY',
  id: 'LGK',
  obj: {
    iata: 'LGK',
    iso: 'MY',
    coordinates: '99.72869873046875, 6.329730033874512',
    municipality: 'Langkawi'
  }
}, {
  label: 'Lannion-C\u00c3\u00b4te de Granit Airport (LAI) - FR',
  id: 'LAI',
  obj: {
    iata: 'LAI',
    iso: 'FR',
    coordinates: '-3.47166, 48.754398',
    municipality: 'Lannion'
  }
}, {
  label: 'Lansdowne House Airport (YLH) - CA',
  id: 'YLH',
  obj: {
    iata: 'YLH',
    iso: 'CA',
    coordinates: '-87.93419647216797, 52.19559860229492',
    municipality: 'Lansdowne House'
  }
}, {
  label: 'Capital City Airport (LAN) - US',
  id: 'LAN',
  obj: {
    iata: 'LAN',
    iso: 'US',
    coordinates: '-84.58740234375, 42.77870178222656',
    municipality: 'Lansing'
  }
}, {
  label: 'Lanzarote Airport (ACE) - ES',
  id: 'ACE',
  obj: {
    iata: 'ACE',
    iso: 'ES',
    coordinates: '-13.6052, 28.945499',
    municipality: 'Lanzarote Island'
  }
}, {
  label: 'Lanzhou Zhongchuan Airport (LHW) - CN',
  id: 'LHW',
  obj: {
    iata: 'LHW',
    iso: 'CN',
    coordinates: '103.620002747, 36.5152015686',
    municipality: 'Lanzhou'
  }
}, {
  label: 'Laoag International Airport (LAO) - PH',
  id: 'LAO',
  obj: {
    iata: 'LAO',
    iso: 'PH',
    coordinates: '120.53199768066406, 18.1781005859375',
    municipality: 'Laoag City'
  }
}, {
  label: 'Lappeenranta Airport (LPP) - FI',
  id: 'LPP',
  obj: {
    iata: 'LPP',
    iso: 'FI',
    coordinates: '28.144743, 61.044601',
    municipality: 'Lappeenranta'
  }
}, {
  label: 'Mactan Cebu International Airport (CEB) - PH',
  id: 'CEB',
  obj: {
    iata: 'CEB',
    iso: 'PH',
    coordinates: '123.97899627686, 10.307499885559',
    municipality: 'Lapu-Lapu City'
  }
}, {
  label: 'Lar Airport (LRR) - IR',
  id: 'LRR',
  obj: {
    iata: 'LRR',
    iso: 'IR',
    coordinates: '54.3833007812, 27.6746997833',
    municipality: 'Lar'
  }
}, {
  label: 'Laramie Regional Airport (LAR) - US',
  id: 'LAR',
  obj: {
    iata: 'LAR',
    iso: 'US',
    coordinates: '-105.67500305175781, 41.31209945678711',
    municipality: 'Laramie'
  }
}, {
  label: 'Laredo International Airport (LRD) - US',
  id: 'LRD',
  obj: {
    iata: 'LRD',
    iso: 'US',
    coordinates: '-99.46160125732422, 27.543800354003906',
    municipality: 'Laredo'
  }
}, {
  label: 'Larnaca International Airport (LCA) - CY',
  id: 'LCA',
  obj: {
    iata: 'LCA',
    iso: 'CY',
    coordinates: '33.624900817871094, 34.875099182128906',
    municipality: 'Larnarca'
  }
}, {
  label: 'Las Cruces International Airport (LRU) - US',
  id: 'LRU',
  obj: {
    iata: 'LRU',
    iso: 'US',
    coordinates: '-106.9219970703125, 32.289398193359375',
    municipality: 'Las Cruces'
  }
}, {
  label: 'Las Heras Airport (LHS) - AR',
  id: 'LHS',
  obj: {
    iata: 'LHS',
    iso: 'AR',
    coordinates: '-68.9653015137, -46.53829956049999',
    municipality: 'Las Heras'
  }
}, {
  label: 'Hermanos Ameijeiras Airport (VTU) - CU',
  id: 'VTU',
  obj: {
    iata: 'VTU',
    iso: 'CU',
    coordinates: '-76.93579864501953, 20.987600326538086',
    municipality: 'Las Tunas'
  }
}, {
  label: 'McCarran International Airport (LAS) - US',
  id: 'LAS',
  obj: {
    iata: 'LAS',
    iso: 'US',
    coordinates: '-115.1520004, 36.08010101',
    municipality: 'Las Vegas'
  }
}, {
  label: 'Nellis Air Force Base (LSV) - US',
  id: 'LSV',
  obj: {
    iata: 'LSV',
    iso: 'US',
    coordinates: '-115.033996582, 36.2361984253',
    municipality: 'Las Vegas'
  }
}, {
  label: 'Las Vegas Municipal Airport (LVS) - US',
  id: 'LVS',
  obj: {
    iata: 'LVS',
    iso: 'US',
    coordinates: '-105.141998291, 35.6542015076',
    municipality: 'Las Vegas'
  }
}, {
  label: 'North Las Vegas Airport (VGT) - US',
  id: 'VGT',
  obj: {
    iata: 'VGT',
    iso: 'US',
    coordinates: '-115.19400024414, 36.21070098877',
    municipality: 'Las Vegas'
  }
}, {
  label: 'Lashio Airport (LSH) - MM',
  id: 'LSH',
  obj: {
    iata: 'LSH',
    iso: 'MM',
    coordinates: '97.752197265625, 22.9778995513916',
    municipality: 'Lashio'
  }
}, {
  label: 'Cotopaxi International Airport (LTX) - EC',
  id: 'LTX',
  obj: {
    iata: 'LTX',
    iso: 'EC',
    coordinates: '-78.615799, -0.906833',
    municipality: 'Latacunga'
  }
}, {
  label: 'Bassel Al-Assad International Airport (LTK) - SY',
  id: 'LTK',
  obj: {
    iata: 'LTK',
    iso: 'SY',
    coordinates: '35.948699951171875, 35.401100158691406',
    municipality: 'Latakia'
  }
}, {
  label: 'Latina Air Base (QLT) - IT',
  id: 'QLT',
  obj: {
    iata: 'QLT',
    iso: 'IT',
    coordinates: '12.909, 41.5424',
    municipality: 'Latina'
  }
}, {
  label: 'Arnold Palmer Regional Airport (LBE) - US',
  id: 'LBE',
  obj: {
    iata: 'LBE',
    iso: 'US',
    coordinates: '-79.40480042, 40.27590179',
    municipality: 'Latrobe'
  }
}, {
  label: 'Murod Kond Airport (LTU) - IN',
  id: 'LTU',
  obj: {
    iata: 'LTU',
    iso: 'IN',
    coordinates: '76.464699, 18.411501',
    municipality: 'Latur'
  }
}, {
  label: 'Launceston Airport (LST) - AU',
  id: 'LST',
  obj: {
    iata: 'LST',
    iso: 'AU',
    coordinates: '147.214004517, -41.54529953',
    municipality: 'Launceston'
  }
}, {
  label: 'Laval-Entrammes Airport (LVA) - FR',
  id: 'LVA',
  obj: {
    iata: 'LVA',
    iso: 'FR',
    coordinates: '-0.7429860234260559, 48.03139877319336',
    municipality: 'Laval/Entrammes'
  }
}, {
  label: 'Lawrence Municipal Airport (LWM) - US',
  id: 'LWM',
  obj: {
    iata: 'LWM',
    iso: 'US',
    coordinates: '-71.1233978271, 42.717201232899995',
    municipality: 'Lawrence'
  }
}, {
  label: 'Lawton Fort Sill Regional Airport (LAW) - US',
  id: 'LAW',
  obj: {
    iata: 'LAW',
    iso: 'US',
    coordinates: '-98.4166030884, 34.5676994324',
    municipality: 'Lawton'
  }
}, {
  label: 'Le Castellet Airport (CTT) - FR',
  id: 'CTT',
  obj: {
    iata: 'CTT',
    iso: 'FR',
    coordinates: '5.785190105438232, 43.252498626708984',
    municipality: 'Le Castellet'
  }
}, {
  label: 'Le Havre Octeville Airport (LEH) - FR',
  id: 'LEH',
  obj: {
    iata: 'LEH',
    iso: 'FR',
    coordinates: '0.08805599808692932, 49.53390121459961',
    municipality: 'Le Havre/Octeville'
  }
}, {
  label: 'Le Mans-Arnage Airport (LME) - FR',
  id: 'LME',
  obj: {
    iata: 'LME',
    iso: 'FR',
    coordinates: '0.20166699588298798, 47.94860076904297',
    municipality: 'Le Mans/Arnage'
  }
}, {
  label: 'Le Puy-Loudes Airport (LPY) - FR',
  id: 'LPY',
  obj: {
    iata: 'LPY',
    iso: 'FR',
    coordinates: '3.762890100479126, 45.0806999206543',
    municipality: 'Le Puy/Loudes'
  }
}, {
  label: "Le Touquet-C\u00c3\u00b4te d'Opale Airport (LTQ) - FR",
  id: 'LTQ',
  obj: {
    iata: 'LTQ',
    iso: 'FR',
    coordinates: '1.6205899715423584, 50.517398834228516',
    municipality: 'Le Touquet-Paris-Plage'
  }
}, {
  label: 'Leaf Rapids Airport (YLR) - CA',
  id: 'YLR',
  obj: {
    iata: 'YLR',
    iso: 'CA',
    coordinates: '-99.98529815673828, 56.513301849365234',
    municipality: 'Leaf Rapids'
  }
}, {
  label: 'Lebanon Municipal Airport (LEB) - US',
  id: 'LEB',
  obj: {
    iata: 'LEB',
    iso: 'US',
    coordinates: '-72.30419921880001, 43.626098632799994',
    municipality: 'Lebanon'
  }
}, {
  label: 'Leeds Bradford Airport (LBA) - GB',
  id: 'LBA',
  obj: {
    iata: 'LBA',
    iso: 'GB',
    coordinates: '-1.6605700254440308, 53.86589813232422',
    municipality: 'Leeds'
  }
}, {
  label: 'Leesburg International Airport (LEE) - US',
  id: 'LEE',
  obj: {
    iata: 'LEE',
    iso: 'US',
    coordinates: '-81.80870056, 28.82309914',
    municipality: 'Leesburg'
  }
}, {
  label: 'Leeuwarden Air Base (LWR) - NL',
  id: 'LWR',
  obj: {
    iata: 'LWR',
    iso: 'NL',
    coordinates: '5.760560035705566, 53.228599548339844',
    municipality: 'Leeuwarden'
  }
}, {
  label: 'Legazpi City International Airport (LGP) - PH',
  id: 'LGP',
  obj: {
    iata: 'LGP',
    iso: 'PH',
    coordinates: '123.735, 13.1575',
    municipality: 'Legazpi City'
  }
}, {
  label: 'Leh Kushok Bakula Rimpochee Airport (IXL) - IN',
  id: 'IXL',
  obj: {
    iata: 'IXL',
    iso: 'IN',
    coordinates: '77.5465011597, 34.1358985901',
    municipality: 'Leh'
  }
}, {
  label: 'Leipzig/Halle Airport (LEJ) - DE',
  id: 'LEJ',
  obj: {
    iata: 'LEJ',
    iso: 'DE',
    coordinates: '12.236389, 51.423889',
    municipality: 'Leipzig'
  }
}, {
  label: 'Stord Airport (SRP) - NO',
  id: 'SRP',
  obj: {
    iata: 'SRP',
    iso: 'NO',
    coordinates: '5.340849876403809, 59.791900634765625',
    municipality: 'Leirvik'
  }
}, {
  label: 'Leknes Airport (LKN) - NO',
  id: 'LKN',
  obj: {
    iata: 'LKN',
    iso: 'NO',
    coordinates: '13.609399795532, 68.152496337891',
    municipality: 'Leknes'
  }
}, {
  label: 'Lelystad Airport (LEY) - NL',
  id: 'LEY',
  obj: {
    iata: 'LEY',
    iso: 'NL',
    coordinates: '5.52722, 52.4603',
    municipality: 'Lelystad'
  }
}, {
  label: 'Lemoore Naval Air Station (Reeves Field) Airport (NLC) - US',
  id: 'NLC',
  obj: {
    iata: 'NLC',
    iso: 'US',
    coordinates: '-119.9520035, 36.33300018',
    municipality: 'Lemoore'
  }
}, {
  label: 'Lensk Airport (ULK) - RU',
  id: 'ULK',
  obj: {
    iata: 'ULK',
    iso: 'RU',
    coordinates: '114.825996399, 60.7206001282',
    municipality: 'Lensk'
  }
}, {
  label: 'Leonora Airport (LNO) - AU',
  id: 'LNO',
  obj: {
    iata: 'LNO',
    iso: 'AU',
    coordinates: '121.31500244140625, -28.87809944152832',
    municipality: 'Leonora'
  }
}, {
  label: 'Sumburgh Airport (LSI) - GB',
  id: 'LSI',
  obj: {
    iata: 'LSI',
    iso: 'GB',
    coordinates: '-1.2955600023269653, 59.87889862060547',
    municipality: 'Lerwick'
  }
}, {
  label: 'Les Cayes Airport (CYA) - HT',
  id: 'CYA',
  obj: {
    iata: 'CYA',
    iso: 'HT',
    coordinates: '-73.78829956054688, 18.271099090576172',
    municipality: 'Les Cayes'
  }
}, {
  label: 'Lethbridge County Airport (YQL) - CA',
  id: 'YQL',
  obj: {
    iata: 'YQL',
    iso: 'CA',
    coordinates: '-112.800003052, 49.6302986145',
    municipality: 'Lethbridge'
  }
}, {
  label: 'Lethem Airport (LTM) - GY',
  id: 'LTM',
  obj: {
    iata: 'LTM',
    iso: 'GY',
    coordinates: '-59.789398, 3.37276',
    municipality: 'Lethem'
  }
}, {
  label: 'Alfredo V\u00c3\u00a1squez Cobo International Airport (LET) - CO',
  id: 'LET',
  obj: {
    iata: 'LET',
    iso: 'CO',
    coordinates: '-69.9432, -4.19355',
    municipality: 'Leticia'
  }
}, {
  label: 'Greenbrier Valley Airport (LWB) - US',
  id: 'LWB',
  obj: {
    iata: 'LWB',
    iso: 'US',
    coordinates: '-80.3994979858, 37.8582992554',
    municipality: 'Lewisburg'
  }
}, {
  label: 'Lewiston Nez Perce County Airport (LWS) - US',
  id: 'LWS',
  obj: {
    iata: 'LWS',
    iso: 'US',
    coordinates: '-117.01499938964844, 46.3745002746582',
    municipality: 'Lewiston'
  }
}, {
  label: 'Lewistown Municipal Airport (LWT) - US',
  id: 'LWT',
  obj: {
    iata: 'LWT',
    iso: 'US',
    coordinates: '-109.46700286865234, 47.04930114746094',
    municipality: 'Lewistown'
  }
}, {
  label: 'Blue Grass Airport (LEX) - US',
  id: 'LEX',
  obj: {
    iata: 'LEX',
    iso: 'US',
    coordinates: '-84.60590362548828, 38.0364990234375',
    municipality: 'Lexington'
  }
}, {
  label: 'Leon Airport (LEN) - ES',
  id: 'LEN',
  obj: {
    iata: 'LEN',
    iso: 'ES',
    coordinates: '-5.65556001663208, 42.5890007019043',
    municipality: 'Le\u00c3\u00b3n'
  }
}, {
  label: 'Lhok Sukon Airport (LSX) - ID',
  id: 'LSX',
  obj: {
    iata: 'LSX',
    iso: 'ID',
    coordinates: '97.25920104980469, 5.069509983062744',
    municipality: 'Lhok Sukon-Sumatra Island'
  }
}, {
  label: 'Liberal Mid-America Regional Airport (LBL) - US',
  id: 'LBL',
  obj: {
    iata: 'LBL',
    iso: 'US',
    coordinates: '-100.9599991, 37.0442009',
    municipality: 'Liberal'
  }
}, {
  label: 'Daniel Oduber Quiros International Airport (LIR) - CR',
  id: 'LIR',
  obj: {
    iata: 'LIR',
    iso: 'CR',
    coordinates: '-85.544403, 10.5933',
    municipality: 'Liberia'
  }
}, {
  label: "Libreville Leon M'ba International Airport (LBV) - GA",
  id: 'LBV',
  obj: {
    iata: 'LBV',
    iso: 'GA',
    coordinates: '9.412280082699999, 0.458600014448',
    municipality: 'Libreville'
  }
}, {
  label: 'Lichinga Airport (VXC) - MZ',
  id: 'VXC',
  obj: {
    iata: 'VXC',
    iso: 'MZ',
    coordinates: '35.2663, -13.274',
    municipality: 'Lichinga'
  }
}, {
  label: 'Liep\u00c4\u0081ja International Airport (LPX) - LV',
  id: 'LPX',
  obj: {
    iata: 'LPX',
    iso: 'LV',
    coordinates: '21.096900939941406, 56.51750183105469',
    municipality: 'Liep\u00c4\u0081ja'
  }
}, {
  label: 'Lifou Airport (LIF) - NC',
  id: 'LIF',
  obj: {
    iata: 'LIF',
    iso: 'NC',
    coordinates: '167.24000549316406, -20.774799346923828',
    municipality: 'Lifou'
  }
}, {
  label: 'Lifuka Island Airport (HPA) - TO',
  id: 'HPA',
  obj: {
    iata: 'HPA',
    iso: 'TO',
    coordinates: '-174.34100341796875, -19.777000427246094',
    municipality: 'Lifuka'
  }
}, {
  label: 'Lihue Airport (LIH) - US',
  id: 'LIH',
  obj: {
    iata: 'LIH',
    iso: 'US',
    coordinates: '-159.33900451660156, 21.97599983215332',
    municipality: 'Lihue'
  }
}, {
  label: 'North Lakhimpur Airport (IXI) - IN',
  id: 'IXI',
  obj: {
    iata: 'IXI',
    iso: 'IN',
    coordinates: '94.09760284423828, 27.295499801635742',
    municipality: 'Lilabari'
  }
}, {
  label: 'Lille-Lesquin Airport (LIL) - FR',
  id: 'LIL',
  obj: {
    iata: 'LIL',
    iso: 'FR',
    coordinates: '3.086886, 50.563332',
    municipality: 'Lille/Lesquin'
  }
}, {
  label: 'Lilongwe International Airport (LLW) - MW',
  id: 'LLW',
  obj: {
    iata: 'LLW',
    iso: 'MW',
    coordinates: '33.78099823, -13.7894001007',
    municipality: 'Lilongwe'
  }
}, {
  label: 'Jorge Ch\u00c3\u00a1vez International Airport (LIM) - PE',
  id: 'LIM',
  obj: {
    iata: 'LIM',
    iso: 'PE',
    coordinates: '-77.114305, -12.0219',
    municipality: 'Lima'
  }
}, {
  label: 'Limbang Airport (LMN) - MY',
  id: 'LMN',
  obj: {
    iata: 'LMN',
    iso: 'MY',
    coordinates: '115.01000213623047, 4.808300018310547',
    municipality: 'Limbang'
  }
}, {
  label: 'Lime Acres Finsch Mine Airport (LMR) - ZA',
  id: 'LMR',
  obj: {
    iata: 'LMR',
    iso: 'ZA',
    coordinates: '23.43910026550293, -28.36009979248047',
    municipality: 'Lime Acres'
  }
}, {
  label: 'Limoges Airport (LIG) - FR',
  id: 'LIG',
  obj: {
    iata: 'LIG',
    iso: 'FR',
    coordinates: '1.1794400215148926, 45.86280059814453',
    municipality: 'Limoges/Bellegarde'
  }
}, {
  label: 'Lintsang Airfield (LNJ) - CN',
  id: 'LNJ',
  obj: {
    iata: 'LNJ',
    iso: 'CN',
    coordinates: '100.025001526, 23.738100051900002',
    municipality: 'Lincang'
  }
}, {
  label: 'Lincoln Airport (LNK) - US',
  id: 'LNK',
  obj: {
    iata: 'LNK',
    iso: 'US',
    coordinates: '-96.75920104980469, 40.85100173950195',
    municipality: 'Lincoln'
  }
}, {
  label: 'Linfen Qiaoli Airport (LFQ) - CN',
  id: 'LFQ',
  obj: {
    iata: 'LFQ',
    iso: 'CN',
    coordinates: '111.641236, 36.132629',
    municipality: 'Linfen'
  }
}, {
  label: 'Link\u00c3\u00b6ping City Airport (LPI) - SE',
  id: 'LPI',
  obj: {
    iata: 'LPI',
    iso: 'SE',
    coordinates: '15.680500030500001, 58.4062004089',
    municipality: 'Link\u00c3\u00b6ping'
  }
}, {
  label: 'Lins Airport (LIP) - BR',
  id: 'LIP',
  obj: {
    iata: 'LIP',
    iso: 'BR',
    coordinates: '-49.730499267578, -21.663999557495',
    municipality: 'Lins'
  }
}, {
  label: 'RAF Linton-On-Ouse (HRT) - GB',
  id: 'HRT',
  obj: {
    iata: 'HRT',
    iso: 'GB',
    coordinates: '-1.2527500391, 54.0489006042',
    municipality: 'Linton-On-Ouse'
  }
}, {
  label: 'Linz H\u00c3\u00b6rsching Airport (LNZ) - AT',
  id: 'LNZ',
  obj: {
    iata: 'LNZ',
    iso: 'AT',
    coordinates: '14.1875, 48.2332',
    municipality: 'Linz'
  }
}, {
  label: 'Lipetsk Airport (LPK) - RU',
  id: 'LPK',
  obj: {
    iata: 'LPK',
    iso: 'RU',
    coordinates: '39.53779983520508, 52.70280075073242',
    municipality: 'Lipetsk'
  }
}, {
  label: 'Humberto Delgado Airport (Lisbon Portela Airport) (LIS) - PT',
  id: 'LIS',
  obj: {
    iata: 'LIS',
    iso: 'PT',
    coordinates: '-9.13592, 38.7813',
    municipality: 'Lisbon'
  }
}, {
  label: 'Lismore Airport (LSY) - AU',
  id: 'LSY',
  obj: {
    iata: 'LSY',
    iso: 'AU',
    coordinates: '153.259994507, -28.8302993774',
    municipality: 'Lismore'
  }
}, {
  label: 'Edward Bodden Airfield (LYB) - KY',
  id: 'LYB',
  obj: {
    iata: 'LYB',
    iso: 'KY',
    coordinates: '-80.088826, 19.660161',
    municipality: 'Little Cayman'
  }
}, {
  label: 'Little Grand Rapids Airport (ZGR) - CA',
  id: 'ZGR',
  obj: {
    iata: 'ZGR',
    iso: 'CA',
    coordinates: '-95.4657974243164, 52.04560089111328',
    municipality: 'Little Grand Rapids'
  }
}, {
  label: 'Bill & Hillary Clinton National Airport/Adams Field (LIT) - US',
  id: 'LIT',
  obj: {
    iata: 'LIT',
    iso: 'US',
    coordinates: '-92.2242965698, 34.729400634799994',
    municipality: 'Little Rock'
  }
}, {
  label: 'Liuzhou Bailian Airport (LZH) - CN',
  id: 'LZH',
  obj: {
    iata: 'LZH',
    iso: 'CN',
    coordinates: '109.390999, 24.2075',
    municipality: 'Liuzhou'
  }
}, {
  label: 'Liverpool John Lennon Airport (LPL) - GB',
  id: 'LPL',
  obj: {
    iata: 'LPL',
    iso: 'GB',
    coordinates: '-2.849720001220703, 53.33359909057617',
    municipality: 'Liverpool'
  }
}, {
  label: 'Mission Field (LVM) - US',
  id: 'LVM',
  obj: {
    iata: 'LVM',
    iso: 'US',
    coordinates: '-110.447998047, 45.6994018555',
    municipality: 'Livingston'
  }
}, {
  label: 'Harry Mwanga Nkumbula International Airport (LVI) - ZM',
  id: 'LVI',
  obj: {
    iata: 'LVI',
    iso: 'ZM',
    coordinates: '25.822701, -17.8218',
    municipality: 'Livingstone'
  }
}, {
  label: 'Li\u00c3\u00a8ge Airport (LGG) - BE',
  id: 'LGG',
  obj: {
    iata: 'LGG',
    iso: 'BE',
    coordinates: '5.443220138549805, 50.63740158081055',
    municipality: 'Li\u00c3\u00a8ge'
  }
}, {
  label: 'Ljubljana Jo\u00c5\u00bee Pu\u00c4\u008dnik Airport (LJU) - SI',
  id: 'LJU',
  obj: {
    iata: 'LJU',
    iso: 'SI',
    coordinates: '14.4576, 46.223701',
    municipality: 'Ljubljana'
  }
}, {
  label: 'Lleida-Alguaire Airport (ILD) - ES',
  id: 'ILD',
  obj: {
    iata: 'ILD',
    iso: 'ES',
    coordinates: '0.535023, 41.728185',
    municipality: 'Lleida'
  }
}, {
  label: 'Lloydminster Airport (YLL) - CA',
  id: 'YLL',
  obj: {
    iata: 'YLL',
    iso: 'CA',
    coordinates: '-110.072998046875, 53.309200286865234',
    municipality: 'Lloydminster'
  }
}, {
  label: 'Lockhart River Airport (IRG) - AU',
  id: 'IRG',
  obj: {
    iata: 'IRG',
    iso: 'AU',
    coordinates: '143.304993, -12.7869',
    municipality: 'Lockhart River'
  }
}, {
  label: 'Lodwar Airport (LOK) - KE',
  id: 'LOK',
  obj: {
    iata: 'LOK',
    iso: 'KE',
    coordinates: '35.608699798583984, 3.1219699382781982',
    municipality: 'Lodwar'
  }
}, {
  label: 'Logan-Cache Airport (LGU) - US',
  id: 'LGU',
  obj: {
    iata: 'LGU',
    iso: 'US',
    coordinates: '-111.851997375, 41.7911987305',
    municipality: 'Logan'
  }
}, {
  label: 'Loikaw Airport (LIW) - MM',
  id: 'LIW',
  obj: {
    iata: 'LIW',
    iso: 'MM',
    coordinates: '97.21479797363281, 19.691499710083008',
    municipality: 'Loikaw'
  }
}, {
  label: 'Lokichoggio Airport (LKG) - KE',
  id: 'LKG',
  obj: {
    iata: 'LKG',
    iso: 'KE',
    coordinates: '34.348201751708984, 4.20412015914917',
    municipality: 'Lokichoggio'
  }
}, {
  label: 'Lolland Falster Maribo Airport (MRW) - DK',
  id: 'MRW',
  obj: {
    iata: 'MRW',
    iso: 'DK',
    coordinates: '11.4401, 54.699299',
    municipality: 'Lolland Falster / Maribo'
  }
}, {
  label: 'Vandenberg Air Force Base (VBG) - US',
  id: 'VBG',
  obj: {
    iata: 'VBG',
    iso: 'US',
    coordinates: '-120.583999634, 34.7373008728',
    municipality: 'Lompoc'
  }
}, {
  label: 'Lom\u00c3\u00a9-Tokoin Airport (LFW) - TG',
  id: 'LFW',
  obj: {
    iata: 'LFW',
    iso: 'TG',
    coordinates: '1.2545100450515747, 6.165609836578369',
    municipality: 'Lom\u00c3\u00a9'
  }
}, {
  label: 'London Airport (YXU) - CA',
  id: 'YXU',
  obj: {
    iata: 'YXU',
    iso: 'CA',
    coordinates: '-81.1539, 43.035599',
    municipality: 'London'
  }
}, {
  label: 'London Luton Airport (LTN) - GB',
  id: 'LTN',
  obj: {
    iata: 'LTN',
    iso: 'GB',
    coordinates: '-0.36833301186561584, 51.874698638916016',
    municipality: 'London'
  }
}, {
  label: 'London Biggin Hill Airport (BQH) - GB',
  id: 'BQH',
  obj: {
    iata: 'BQH',
    iso: 'GB',
    coordinates: '0.0324999988079, 51.33079910279999',
    municipality: 'London'
  }
}, {
  label: 'London Gatwick Airport (LGW) - GB',
  id: 'LGW',
  obj: {
    iata: 'LGW',
    iso: 'GB',
    coordinates: '-0.190278, 51.148102',
    municipality: 'London'
  }
}, {
  label: 'London City Airport (LCY) - GB',
  id: 'LCY',
  obj: {
    iata: 'LCY',
    iso: 'GB',
    coordinates: '0.055278, 51.505299',
    municipality: 'London'
  }
}, {
  label: 'London Heathrow Airport (LHR) - GB',
  id: 'LHR',
  obj: {
    iata: 'LHR',
    iso: 'GB',
    coordinates: '-0.461941, 51.4706',
    municipality: 'London'
  }
}, {
  label: 'London Stansted Airport (STN) - GB',
  id: 'STN',
  obj: {
    iata: 'STN',
    iso: 'GB',
    coordinates: '0.234999999404, 51.8849983215',
    municipality: 'London'
  }
}, {
  label: 'RAF Northolt (NHT) - GB',
  id: 'NHT',
  obj: {
    iata: 'NHT',
    iso: 'GB',
    coordinates: '-0.418166995049, 51.553001403799996',
    municipality: 'London'
  }
}, {
  label: 'London-Corbin Airport/Magee Field (LOZ) - US',
  id: 'LOZ',
  obj: {
    iata: 'LOZ',
    iso: 'US',
    coordinates: '-84.08489990230001, 37.0821990967',
    municipality: 'London'
  }
}, {
  label: 'Governador Jos\u00c3\u00a9 Richa Airport (LDB) - BR',
  id: 'LDB',
  obj: {
    iata: 'LDB',
    iso: 'BR',
    coordinates: '-51.1301002502, -23.333599090599996',
    municipality: 'Londrina'
  }
}, {
  label: 'Long Beach /Daugherty Field/ Airport (LGB) - US',
  id: 'LGB',
  obj: {
    iata: 'LGB',
    iso: 'US',
    coordinates: '-118.1520004, 33.81769943',
    municipality: 'Long Beach'
  }
}, {
  label: 'Longnan Chengzhou Airport (LNL) - CN',
  id: 'LNL',
  obj: {
    iata: 'LNL',
    iso: 'CN',
    coordinates: '105.797, 33.788',
    municipality: 'Longnan'
  }
}, {
  label: 'Longreach Airport (LRE) - AU',
  id: 'LRE',
  obj: {
    iata: 'LRE',
    iso: 'AU',
    coordinates: '144.279998779, -23.4342002869',
    municipality: 'Longreach'
  }
}, {
  label: 'East Texas Regional Airport (GGG) - US',
  id: 'GGG',
  obj: {
    iata: 'GGG',
    iso: 'US',
    coordinates: '-94.71150207519531, 32.38399887084961',
    municipality: 'Longview'
  }
}, {
  label: 'Svalbard Airport, Longyear (LYR) - NO',
  id: 'LYR',
  obj: {
    iata: 'LYR',
    iso: 'NO',
    coordinates: '15.465600013733, 78.246101379395',
    municipality: 'Longyearbyen'
  }
}, {
  label: 'Loreto International Airport (LTO) - MX',
  id: 'LTO',
  obj: {
    iata: 'LTO',
    iso: 'MX',
    coordinates: '-111.3479995727539, 25.989200592041016',
    municipality: 'Loreto'
  }
}, {
  label: 'Lorient South Brittany (Bretagne Sud) Airport (LRT) - FR',
  id: 'LRT',
  obj: {
    iata: 'LRT',
    iso: 'FR',
    coordinates: '-3.440000057220459, 47.76060104370117',
    municipality: 'Lorient/Lann/Bihou\u00c3\u00a9'
  }
}, {
  label: 'Los Angeles International Airport (LAX) - US',
  id: 'LAX',
  obj: {
    iata: 'LAX',
    iso: 'US',
    coordinates: '-118.407997, 33.942501',
    municipality: 'Los Angeles'
  }
}, {
  label: 'Los Chiles Airport (LSL) - CR',
  id: 'LSL',
  obj: {
    iata: 'LSL',
    iso: 'CR',
    coordinates: '-84.70610046386719, 11.035300254821777',
    municipality: 'Los Chiles'
  }
}, {
  label: 'Valle del Fuerte International Airport (LMM) - MX',
  id: 'LMM',
  obj: {
    iata: 'LMM',
    iso: 'MX',
    coordinates: '-109.081001282, 25.6851997375',
    municipality: 'Los Mochis'
  }
}, {
  label: 'RAF Lossiemouth (LMO) - GB',
  id: 'LMO',
  obj: {
    iata: 'LMO',
    iso: 'GB',
    coordinates: '-3.339169979095459, 57.7052001953125',
    municipality: 'Lossiemouth'
  }
}, {
  label: 'Bowman Field (LOU) - US',
  id: 'LOU',
  obj: {
    iata: 'LOU',
    iso: 'US',
    coordinates: '-85.6636962891, 38.2280006409',
    municipality: 'Louisville'
  }
}, {
  label: 'Louisville Muhammad Ali International Airport (SDF) - US',
  id: 'SDF',
  obj: {
    iata: 'SDF',
    iso: 'US',
    coordinates: '-85.736, 38.1744',
    municipality: 'Louisville'
  }
}, {
  label: 'Lourdes de Blanc Sablon Airport (YBX) - CA',
  id: 'YBX',
  obj: {
    iata: 'YBX',
    iso: 'CA',
    coordinates: '-57.185298919699996, 51.443599700899995',
    municipality: 'Lourdes-De-Blanc-Sablon'
  }
}, {
  label: 'Derby Field (LOL) - US',
  id: 'LOL',
  obj: {
    iata: 'LOL',
    iso: 'US',
    coordinates: '-118.565002441, 40.0663986206',
    municipality: 'Lovelock'
  }
}, {
  label: 'Quatro de Fevereiro Airport (LAD) - AO',
  id: 'LAD',
  obj: {
    iata: 'LAD',
    iso: 'AO',
    coordinates: '13.2312, -8.85837',
    municipality: 'Luanda'
  }
}, {
  label: 'Luang Phabang International Airport (LPQ) - LA',
  id: 'LPQ',
  obj: {
    iata: 'LPQ',
    iso: 'LA',
    coordinates: '102.16100311279297, 19.897300720214844',
    municipality: 'Luang Phabang'
  }
}, {
  label: 'Lubango Airport (SDD) - AO',
  id: 'SDD',
  obj: {
    iata: 'SDD',
    iso: 'AO',
    coordinates: '13.574999809265137, -14.924699783325195',
    municipality: 'Lubango'
  }
}, {
  label: 'Lubbock Preston Smith International Airport (LBB) - US',
  id: 'LBB',
  obj: {
    iata: 'LBB',
    iso: 'US',
    coordinates: '-101.822998, 33.663601',
    municipality: 'Lubbock'
  }
}, {
  label: 'Lublin Airport (LUZ) - PL',
  id: 'LUZ',
  obj: {
    iata: 'LUZ',
    iso: 'PL',
    coordinates: '22.713611, 51.240278',
    municipality: 'Lublin'
  }
}, {
  label: 'Lubumbashi International Airport (FBM) - CD',
  id: 'FBM',
  obj: {
    iata: 'FBM',
    iso: 'CD',
    coordinates: '27.5308990479, -11.5913000107',
    municipality: 'Lubumbashi'
  }
}, {
  label: 'Chaudhary Charan Singh International Airport (LKO) - IN',
  id: 'LKO',
  obj: {
    iata: 'LKO',
    iso: 'IN',
    coordinates: '80.8892974854, 26.7605991364',
    municipality: 'Lucknow'
  }
}, {
  label: 'Luderitz Airport (LUD) - NA',
  id: 'LUD',
  obj: {
    iata: 'LUD',
    iso: 'NA',
    coordinates: '15.242899894714355, -26.687400817871094',
    municipality: 'Luderitz'
  }
}, {
  label: 'Luena Airport (LUO) - AO',
  id: 'LUO',
  obj: {
    iata: 'LUO',
    iso: 'AO',
    coordinates: '19.8976993560791, -11.768099784851074',
    municipality: 'Luena'
  }
}, {
  label: 'Angelina County Airport (LFK) - US',
  id: 'LFK',
  obj: {
    iata: 'LFK',
    iso: 'US',
    coordinates: '-94.75, 31.2339992523',
    municipality: 'Lufkin'
  }
}, {
  label: 'Lugano Airport (LUG) - CH',
  id: 'LUG',
  obj: {
    iata: 'LUG',
    iso: 'CH',
    coordinates: '8.9105796814, 46.00429916379999',
    municipality: 'Lugano'
  }
}, {
  label: 'Santo Pekoa International Airport (SON) - VU',
  id: 'SON',
  obj: {
    iata: 'SON',
    iso: 'VU',
    coordinates: '167.220001221, -15.505000114399998',
    municipality: 'Luganville'
  }
}, {
  label: 'Luhansk International Airport (VSG) - UA',
  id: 'VSG',
  obj: {
    iata: 'VSG',
    iso: 'UA',
    coordinates: '39.3740997314, 48.4174003601',
    municipality: 'Luhansk'
  }
}, {
  label: 'Lule\u00c3\u00a5 Airport (LLA) - SE',
  id: 'LLA',
  obj: {
    iata: 'LLA',
    iso: 'SE',
    coordinates: '22.121999740601, 65.543800354004',
    municipality: 'Lule\u00c3\u00a5'
  }
}, {
  label: 'Lumberton Regional Airport (LBT) - US',
  id: 'LBT',
  obj: {
    iata: 'LBT',
    iso: 'US',
    coordinates: '-79.05940246579999, 34.6099014282',
    municipality: 'Lumberton'
  }
}, {
  label: 'Kenneth Kaunda International Airport (LUN) - ZM',
  id: 'LUN',
  obj: {
    iata: 'LUN',
    iso: 'ZM',
    coordinates: '28.4526, -15.3308',
    municipality: 'Lusaka'
  }
}, {
  label: "Lutselk'e Airport (YSG) - CA",
  id: 'YSG',
  obj: {
    iata: 'YSG',
    iso: 'CA',
    coordinates: '-110.681998, 62.418303',
    municipality: "Lutselk'e"
  }
}, {
  label: 'Syukuran Aminuddin Amir Airport (LUW) - ID',
  id: 'LUW',
  obj: {
    iata: 'LUW',
    iso: 'ID',
    coordinates: '122.772003, -1.03892',
    municipality: 'Luwok - Celebes Island'
  }
}, {
  label: 'Luxembourg-Findel International Airport (LUX) - LU',
  id: 'LUX',
  obj: {
    iata: 'LUX',
    iso: 'LU',
    coordinates: '6.2044444, 49.6233333',
    municipality: 'Luxembourg'
  }
}, {
  label: 'Luxor International Airport (LXR) - EG',
  id: 'LXR',
  obj: {
    iata: 'LXR',
    iso: 'EG',
    coordinates: '32.7066, 25.671',
    municipality: 'Luxor'
  }
}, {
  label: 'Lviv International Airport (LWO) - UA',
  id: 'LWO',
  obj: {
    iata: 'LWO',
    iso: 'UA',
    coordinates: '23.956100463867188, 49.8125',
    municipality: 'Lviv'
  }
}, {
  label: 'Lydd Airport (LYX) - GB',
  id: 'LYX',
  obj: {
    iata: 'LYX',
    iso: 'GB',
    coordinates: '0.9391670227050781, 50.95610046386719',
    municipality: 'Lydd, Ashford'
  }
}, {
  label: 'Lynchburg Regional Preston Glenn Field (LYH) - US',
  id: 'LYH',
  obj: {
    iata: 'LYH',
    iso: 'US',
    coordinates: '-79.20040130615234, 37.326698303222656',
    municipality: 'Lynchburg'
  }
}, {
  label: 'Lynn Lake Airport (YYL) - CA',
  id: 'YYL',
  obj: {
    iata: 'YYL',
    iso: 'CA',
    coordinates: '-101.07599639892578, 56.86389923095703',
    municipality: 'Lynn Lake'
  }
}, {
  label: 'Lyon Saint-Exup\u00c3\u00a9ry Airport (LYS) - FR',
  id: 'LYS',
  obj: {
    iata: 'LYS',
    iso: 'FR',
    coordinates: '5.081111, 45.725556',
    municipality: 'Lyon'
  }
}, {
  label: 'Lyon-Bron Airport (LYN) - FR',
  id: 'LYN',
  obj: {
    iata: 'LYN',
    iso: 'FR',
    coordinates: '4.944270133972168, 45.72719955444336',
    municipality: 'Lyon/Bron'
  }
}, {
  label: 'L\u00c3\u00a1zaro C\u00c3\u00a1rdenas Airport (LZC) - MX',
  id: 'LZC',
  obj: {
    iata: 'LZC',
    iso: 'MX',
    coordinates: '-102.221000671, 18.0016994476',
    municipality: 'L\u00c3\u00a1zaro C\u00c3\u00a1rdenas'
  }
}, {
  label: 'L\u00c3\u00bcbeck Blankensee Airport (LBC) - DE',
  id: 'LBC',
  obj: {
    iata: 'LBC',
    iso: 'DE',
    coordinates: '10.7192001343, 53.8054008484',
    municipality: 'L\u00c3\u00bcbeck'
  }
}, {
  label: 'L\u00c3\u00bcliang Airport (LLV) - CN',
  id: 'LLV',
  obj: {
    iata: 'LLV',
    iso: 'CN',
    coordinates: '111.142778, 37.683333',
    municipality: 'L\u00c3\u00bcliang'
  }
}, {
  label: 'Villa Airport (VAM) - MV',
  id: 'VAM',
  obj: {
    iata: 'VAM',
    iso: 'MV',
    coordinates: '72.8358333333, 3.47055555556',
    municipality: 'Maamigili'
  }
}, {
  label: 'Maastricht Aachen Airport (MST) - NL',
  id: 'MST',
  obj: {
    iata: 'MST',
    iso: 'NL',
    coordinates: '5.77014, 50.911701',
    municipality: 'Maastricht'
  }
}, {
  label: 'Alberto Alcolumbre Airport (MCP) - BR',
  id: 'MCP',
  obj: {
    iata: 'MCP',
    iso: 'BR',
    coordinates: '-51.0722007751, 0.0506640002131',
    municipality: 'Macap\u00c3\u00a1'
  }
}, {
  label: 'Jose Maria Velasco Ibarra Airport (MRR) - EC',
  id: 'MRR',
  obj: {
    iata: 'MRR',
    iso: 'EC',
    coordinates: '-79.94100189210002, -4.37823009491',
    municipality: 'Macar\u00c3\u00a1'
  }
}, {
  label: 'Coronel E Carvajal Airport (XMS) - EC',
  id: 'XMS',
  obj: {
    iata: 'XMS',
    iso: 'EC',
    coordinates: '-78.12079620361328, -2.2991700172424316',
    municipality: 'Macas'
  }
}, {
  label: 'Macau International Airport (MFM) - MO',
  id: 'MFM',
  obj: {
    iata: 'MFM',
    iso: 'MO',
    coordinates: '113.592003, 22.149599',
    municipality: 'Macau'
  }
}, {
  label: 'Maca\u00c3\u00a9 Airport (MEA) - BR',
  id: 'MEA',
  obj: {
    iata: 'MEA',
    iso: 'BR',
    coordinates: '-41.7659988403, -22.343000412',
    municipality: 'Maca\u00c3\u00a9'
  }
}, {
  label: 'Zumbi dos Palmares Airport (MCZ) - BR',
  id: 'MCZ',
  obj: {
    iata: 'MCZ',
    iso: 'BR',
    coordinates: '-35.79169845581055, -9.510809898376465',
    municipality: 'Macei\u00c3\u00b3'
  }
}, {
  label: 'General Manuel Serrano Airport (MCH) - EC',
  id: 'MCH',
  obj: {
    iata: 'MCH',
    iso: 'EC',
    coordinates: '-79.961601, -3.2689',
    municipality: 'Machala'
  }
}, {
  label: 'Mackay Airport (MKY) - AU',
  id: 'MKY',
  obj: {
    iata: 'MKY',
    iso: 'AU',
    coordinates: '149.179992676, -21.171699523900003',
    municipality: 'Mackay'
  }
}, {
  label: 'Middle Georgia Regional Airport (MCN) - US',
  id: 'MCN',
  obj: {
    iata: 'MCN',
    iso: 'US',
    coordinates: '-83.64920043945312, 32.69279861450195',
    municipality: 'Macon'
  }
}, {
  label: 'Madang Airport (MAG) - PG',
  id: 'MAG',
  obj: {
    iata: 'MAG',
    iso: 'PG',
    coordinates: '145.789001465, -5.20707988739',
    municipality: 'Madang'
  }
}, {
  label: 'Dane County Regional Truax Field (MSN) - US',
  id: 'MSN',
  obj: {
    iata: 'MSN',
    iso: 'US',
    coordinates: '-89.3375015258789, 43.13990020751953',
    municipality: 'Madison'
  }
}, {
  label: 'Cuatro Vientos Airport (ECV) - ES',
  id: 'ECV',
  obj: {
    iata: 'ECV',
    iso: 'ES',
    coordinates: '-3.78514, 40.370701',
    municipality: 'Madrid'
  }
}, {
  label: 'Adolfo Su\u00c3\u00a1rez Madrid\u00e2\u0080\u0093Barajas Airport (MAD) - ES',
  id: 'MAD',
  obj: {
    iata: 'MAD',
    iso: 'ES',
    coordinates: '-3.56264, 40.471926',
    municipality: 'Madrid'
  }
}, {
  label: 'Torrej\u00c3\u00b3n Airport (TOJ) - ES',
  id: 'TOJ',
  obj: {
    iata: 'TOJ',
    iso: 'ES',
    coordinates: '-3.4458699226379395, 40.496700286865234',
    municipality: 'Madrid'
  }
}, {
  label: 'Madurai Airport (IXM) - IN',
  id: 'IXM',
  obj: {
    iata: 'IXM',
    iso: 'IN',
    coordinates: '78.09339904790001, 9.83450984955',
    municipality: 'Madurai'
  }
}, {
  label: 'Mmabatho International Airport (MBD) - ZA',
  id: 'MBD',
  obj: {
    iata: 'MBD',
    iso: 'ZA',
    coordinates: '25.548000335699996, -25.798400878900004',
    municipality: 'Mafeking'
  }
}, {
  label: 'Sokol Airport (GDX) - RU',
  id: 'GDX',
  obj: {
    iata: 'GDX',
    iso: 'RU',
    coordinates: '150.72000122070312, 59.9109992980957',
    municipality: 'Magadan'
  }
}, {
  label: 'Magan Airport (GYG) - RU',
  id: 'GYG',
  obj: {
    iata: 'GYG',
    iso: 'RU',
    coordinates: '129.545288, 62.103484',
    municipality: 'Magan'
  }
}, {
  label: 'Baracoa Airport (MGN) - CO',
  id: 'MGN',
  obj: {
    iata: 'MGN',
    iso: 'CO',
    coordinates: '-74.8461, 9.28474',
    municipality: 'Magangu\u00c3\u00a9'
  }
}, {
  label: 'Magas Airport (IGT) - RU',
  id: 'IGT',
  obj: {
    iata: 'IGT',
    iso: 'RU',
    coordinates: '45.0125999451, 43.322299957300004',
    municipality: 'Magas'
  }
}, {
  label: 'Magdeburg "City" Airport (ZMG) - DE',
  id: 'ZMG',
  obj: {
    iata: 'ZMG',
    iso: 'DE',
    coordinates: '11.626389, 52.073612',
    municipality: 'Magdeburg'
  }
}, {
  label: 'Magnitogorsk International Airport (MQF) - RU',
  id: 'MQF',
  obj: {
    iata: 'MQF',
    iso: 'RU',
    coordinates: '58.755699157714844, 53.39310073852539',
    municipality: 'Magnitogorsk'
  }
}, {
  label: 'Seychelles International Airport (SEZ) - SC',
  id: 'SEZ',
  obj: {
    iata: 'SEZ',
    iso: 'SC',
    coordinates: '55.521801, -4.67434',
    municipality: 'Mahe Island'
  }
}, {
  label: 'Maiduguri International Airport (MIU) - NG',
  id: 'MIU',
  obj: {
    iata: 'MIU',
    iso: 'NG',
    coordinates: '13.080900192260742, 11.855299949645996',
    municipality: 'Maiduguri'
  }
}, {
  label: 'Marshall Islands International Airport (MAJ) - MH',
  id: 'MAJ',
  obj: {
    iata: 'MAJ',
    iso: 'MH',
    coordinates: '171.27200317382812, 7.064760208129883',
    municipality: 'Majuro Atoll'
  }
}, {
  label: 'Uytash Airport (MCX) - RU',
  id: 'MCX',
  obj: {
    iata: 'MCX',
    iso: 'RU',
    coordinates: '47.65230178833008, 42.81679916381836',
    municipality: 'Makhachkala'
  }
}, {
  label: 'Mt. Fuji Shizuoka Airport (FSZ) - JP',
  id: 'FSZ',
  obj: {
    iata: 'FSZ',
    iso: 'JP',
    coordinates: '138.18775177, 34.7960434679',
    municipality: 'Makinohara / Shimada'
  }
}, {
  label: 'Makkovik Airport (YMN) - CA',
  id: 'YMN',
  obj: {
    iata: 'YMN',
    iso: 'CA',
    coordinates: '-59.1864013671875, 55.076900482177734',
    municipality: 'Makkovik'
  }
}, {
  label: 'Makokou Airport (MKU) - GA',
  id: 'MKU',
  obj: {
    iata: 'MKU',
    iso: 'GA',
    coordinates: '12.890899658203125, 0.5792109966278076',
    municipality: 'Makokou'
  }
}, {
  label: 'Makung Airport (MZG) - TW',
  id: 'MZG',
  obj: {
    iata: 'MZG',
    iso: 'TW',
    coordinates: '119.62799835205078, 23.568700790405273',
    municipality: 'Makung City'
  }
}, {
  label: 'Makurdi Airport (MDI) - NG',
  id: 'MDI',
  obj: {
    iata: 'MDI',
    iso: 'NG',
    coordinates: '8.61394, 7.70388',
    municipality: 'Makurdi'
  }
}, {
  label: 'Malabo Airport (SSG) - GQ',
  id: 'SSG',
  obj: {
    iata: 'SSG',
    iso: 'GQ',
    coordinates: '8.708720207214355, 3.755270004272461',
    municipality: 'Malabo'
  }
}, {
  label: 'Malacca Airport (MKZ) - MY',
  id: 'MKZ',
  obj: {
    iata: 'MKZ',
    iso: 'MY',
    coordinates: '102.251998901, 2.2633600235',
    municipality: 'Malacca'
  }
}, {
  label: 'Malakal Airport (MAK) - SS',
  id: 'MAK',
  obj: {
    iata: 'MAK',
    iso: 'SS',
    coordinates: '31.65220069885254, 9.55897045135498',
    municipality: 'Malakal'
  }
}, {
  label: 'Malamala Airport (AAM) - ZA',
  id: 'AAM',
  obj: {
    iata: 'AAM',
    iso: 'ZA',
    coordinates: '31.544599533081055, -24.818099975585938',
    municipality: 'Malamala'
  }
}, {
  label: 'Malanje Airport (MEG) - AO',
  id: 'MEG',
  obj: {
    iata: 'MEG',
    iso: 'AO',
    coordinates: '16.312400817871094, -9.525090217590332',
    municipality: 'Malanje'
  }
}, {
  label: 'Comodoro D.R. Salom\u00c3\u00b3n Airport (LGS) - AR',
  id: 'LGS',
  obj: {
    iata: 'LGS',
    iso: 'AR',
    coordinates: '-69.5743026733, -35.493598938',
    municipality: 'Malargue'
  }
}, {
  label: 'Malatya Erha\u00c3\u00a7 Airport (MLX) - TR',
  id: 'MLX',
  obj: {
    iata: 'MLX',
    iso: 'TR',
    coordinates: '38.0909996033, 38.435298919699996',
    municipality: 'Malatya'
  }
}, {
  label: 'Godofredo P. Ramos Airport (MPH) - PH',
  id: 'MPH',
  obj: {
    iata: 'MPH',
    iso: 'PH',
    coordinates: '121.954002, 11.9245',
    municipality: 'Malay'
  }
}, {
  label: 'Riverside Airport (LLE) - ZA',
  id: 'LLE',
  obj: {
    iata: 'LLE',
    iso: 'ZA',
    coordinates: '31.5767002106, -25.4300003052',
    municipality: 'Malelane'
  }
}, {
  label: 'Malindi Airport (MYD) - KE',
  id: 'MYD',
  obj: {
    iata: 'MYD',
    iso: 'KE',
    coordinates: '40.10169982910156, -3.2293100357055664',
    municipality: 'Malindi'
  }
}, {
  label: 'Malm\u00c3\u00b6 Sturup Airport (MMX) - SE',
  id: 'MMX',
  obj: {
    iata: 'MMX',
    iso: 'SE',
    coordinates: '13.376197814900001, 55.536305364',
    municipality: 'Malm\u00c3\u00b6'
  }
}, {
  label: 'Mal\u00c3\u00a9 International Airport (MLE) - MV',
  id: 'MLE',
  obj: {
    iata: 'MLE',
    iso: 'MV',
    coordinates: '73.52909851074219, 4.191830158233643',
    municipality: 'Mal\u00c3\u00a9'
  }
}, {
  label: 'Camiguin Airport (CGM) - PH',
  id: 'CGM',
  obj: {
    iata: 'CGM',
    iso: 'PH',
    coordinates: '124.709115, 9.253894',
    municipality: 'Mambajao'
  }
}, {
  label: 'Sam Ratulangi Airport (MDC) - ID',
  id: 'MDC',
  obj: {
    iata: 'MDC',
    iso: 'ID',
    coordinates: '124.9260025024414, 1.5492600202560425',
    municipality: 'Manado-Celebes Island'
  }
}, {
  label: 'Augusto C. Sandino (Managua) International Airport (MGA) - NI',
  id: 'MGA',
  obj: {
    iata: 'MGA',
    iso: 'NI',
    coordinates: '-86.16819763183594, 12.141500473022461',
    municipality: 'Managua'
  }
}, {
  label: 'Bahrain International Airport (BAH) - BH',
  id: 'BAH',
  obj: {
    iata: 'BAH',
    iso: 'BH',
    coordinates: '50.63359832763672, 26.27079963684082',
    municipality: 'Manama'
  }
}, {
  label: 'Mananara Nord Airport (WMR) - MG',
  id: 'WMR',
  obj: {
    iata: 'WMR',
    iso: 'MG',
    coordinates: '49.773799896240234, -16.16390037536621',
    municipality: 'Mananara Nord'
  }
}, {
  label: 'Eduardo Gomes International Airport (MAO) - BR',
  id: 'MAO',
  obj: {
    iata: 'MAO',
    iso: 'BR',
    coordinates: '-60.049702, -3.03861',
    municipality: 'Manaus'
  }
}, {
  label: 'Ponta Pelada Airport (PLL) - BR',
  id: 'PLL',
  obj: {
    iata: 'PLL',
    iso: 'BR',
    coordinates: '-59.98630142211914, -3.1460399627685547',
    municipality: 'Manaus'
  }
}, {
  label: 'Manchester Airport (MAN) - GB',
  id: 'MAN',
  obj: {
    iata: 'MAN',
    iso: 'GB',
    coordinates: '-2.2749500274658203, 53.35369873046875',
    municipality: 'Manchester'
  }
}, {
  label: 'Manchester-Boston Regional Airport (MHT) - US',
  id: 'MHT',
  obj: {
    iata: 'MHT',
    iso: 'US',
    coordinates: '-71.435699, 42.932598',
    municipality: 'Manchester'
  }
}, {
  label: 'Ingolstadt Manching Airport (IGS) - DE',
  id: 'IGS',
  obj: {
    iata: 'IGS',
    iso: 'DE',
    coordinates: '11.534000396728516, 48.7156982421875',
    municipality: 'Manching'
  }
}, {
  label: 'Mandalay International Airport (MDL) - MM',
  id: 'MDL',
  obj: {
    iata: 'MDL',
    iso: 'MM',
    coordinates: '95.97789764404297, 21.702199935913086',
    municipality: 'Mandalay'
  }
}, {
  label: 'Mangalore International Airport (IXE) - IN',
  id: 'IXE',
  obj: {
    iata: 'IXE',
    iso: 'IN',
    coordinates: '74.8900985718, 12.9612998962',
    municipality: 'Mangalore'
  }
}, {
  label: 'Mangla Airport (XJM) - PK',
  id: 'XJM',
  obj: {
    iata: 'XJM',
    iso: 'PK',
    coordinates: '73.63839721679688, 33.05009841918945',
    municipality: 'Mangla'
  }
}, {
  label: 'Mangochi Airport (MAI) - MW',
  id: 'MAI',
  obj: {
    iata: 'MAI',
    iso: 'MW',
    coordinates: '35.266998291015625, -14.482999801635742',
    municipality: 'Mangochi'
  }
}, {
  label: 'Clarence A. Bain Airport (MAY) - BS',
  id: 'MAY',
  obj: {
    iata: 'MAY',
    iso: 'BS',
    coordinates: '-77.68460083007812, 24.287700653076172',
    municipality: 'Mangrove Cay'
  }
}, {
  label: 'Manhattan Regional Airport (MHK) - US',
  id: 'MHK',
  obj: {
    iata: 'MHK',
    iso: 'US',
    coordinates: '-96.6707992553711, 39.14099884033203',
    municipality: 'Manhattan'
  }
}, {
  label: 'Manicor\u00c3\u00a9 Airport (MNX) - BR',
  id: 'MNX',
  obj: {
    iata: 'MNX',
    iso: 'BR',
    coordinates: '-61.278301239014, -5.8113799095154',
    municipality: 'Manicor\u00c3\u00a9'
  }
}, {
  label: 'Maningrida Airport (MNG) - AU',
  id: 'MNG',
  obj: {
    iata: 'MNG',
    iso: 'AU',
    coordinates: '134.23399353, -12.0560998917',
    municipality: 'Maningrida'
  }
}, {
  label: 'Manitouwadge Airport (YMG) - CA',
  id: 'YMG',
  obj: {
    iata: 'YMG',
    iso: 'CA',
    coordinates: '-85.86060333251953, 49.083900451660156',
    municipality: 'Manitouwadge'
  }
}, {
  label: 'Manitoulin East Municipal Airport (YEM) - CA',
  id: 'YEM',
  obj: {
    iata: 'YEM',
    iso: 'CA',
    coordinates: '-81.85810089111328, 45.84280014038086',
    municipality: 'Manitowaning'
  }
}, {
  label: 'La Nubia Airport (MZL) - CO',
  id: 'MZL',
  obj: {
    iata: 'MZL',
    iso: 'CO',
    coordinates: '-75.4647, 5.0296',
    municipality: 'Manizales'
  }
}, {
  label: 'Mannheim-City Airport (MHG) - DE',
  id: 'MHG',
  obj: {
    iata: 'MHG',
    iso: 'DE',
    coordinates: '8.514167, 49.473057',
    municipality: 'Mannheim'
  }
}, {
  label: 'Rendani Airport (MKW) - ID',
  id: 'MKW',
  obj: {
    iata: 'MKW',
    iso: 'ID',
    coordinates: '134.048996, -0.891833',
    municipality: 'Manokwari-Papua Island'
  }
}, {
  label: 'Mansfield Lahm Regional Airport (MFD) - US',
  id: 'MFD',
  obj: {
    iata: 'MFD',
    iso: 'US',
    coordinates: '-82.5166015625, 40.82139968869999',
    municipality: 'Mansfield'
  }
}, {
  label: 'Eloy Alfaro International Airport (MEC) - EC',
  id: 'MEC',
  obj: {
    iata: 'MEC',
    iso: 'EC',
    coordinates: '-80.67880249023438, -0.9460780024528503',
    municipality: 'Manta'
  }
}, {
  label: 'Ardmore Airport (AMZ) - NZ',
  id: 'AMZ',
  obj: {
    iata: 'AMZ',
    iso: 'NZ',
    coordinates: '174.97300720214844, -37.029701232910156',
    municipality: 'Manurewa'
  }
}, {
  label: 'Momote Airport (MAS) - PG',
  id: 'MAS',
  obj: {
    iata: 'MAS',
    iso: 'PG',
    coordinates: '147.423996, -2.06189',
    municipality: 'Manus Island'
  }
}, {
  label: 'Playa De Oro International Airport (ZLO) - MX',
  id: 'ZLO',
  obj: {
    iata: 'ZLO',
    iso: 'MX',
    coordinates: '-104.558998108, 19.144800186199998',
    municipality: 'Manzanillo'
  }
}, {
  label: 'Sierra Maestra Airport (MZO) - CU',
  id: 'MZO',
  obj: {
    iata: 'MZO',
    iso: 'CU',
    coordinates: '-77.08920288085938, 20.28809928894043',
    municipality: 'Manzanillo'
  }
}, {
  label: 'Matsapha Airport (MTS) - SZ',
  id: 'MTS',
  obj: {
    iata: 'MTS',
    iso: 'SZ',
    coordinates: '31.307501, -26.528999',
    municipality: 'Manzini'
  }
}, {
  label: 'Maputo Airport (MPM) - MZ',
  id: 'MPM',
  obj: {
    iata: 'MPM',
    iso: 'MZ',
    coordinates: '32.572601, -25.920799',
    municipality: 'Maputo'
  }
}, {
  label: '\u00c3\u0081stor Piazzola International Airport (MDQ) - AR',
  id: 'MDQ',
  obj: {
    iata: 'MDQ',
    iso: 'AR',
    coordinates: '-57.5733, -37.9342',
    municipality: 'Mar del Plata'
  }
}, {
  label: 'Jo\u00c3\u00a3o Correa da Rocha Airport (MAB) - BR',
  id: 'MAB',
  obj: {
    iata: 'MAB',
    iso: 'BR',
    coordinates: '-49.138000488299994, -5.36858987808',
    municipality: 'Marab\u00c3\u00a1'
  }
}, {
  label: 'La Chinita International Airport (MAR) - VE',
  id: 'MAR',
  obj: {
    iata: 'MAR',
    iso: 'VE',
    coordinates: '-71.7278594971, 10.5582084656',
    municipality: 'Maracaibo'
  }
}, {
  label: 'Escuela Mariscal Sucre Airport (MYC) - VE',
  id: 'MYC',
  obj: {
    iata: 'MYC',
    iso: 'VE',
    coordinates: '-67.64942169189453, 10.249978065490723',
    municipality: 'Maracay'
  }
}, {
  label: 'Maradi Airport (MFQ) - NE',
  id: 'MFQ',
  obj: {
    iata: 'MFQ',
    iso: 'NE',
    coordinates: '7.1267499923706055, 13.5024995803833',
    municipality: 'Maradi'
  }
}, {
  label: 'Marathon Airport (YSP) - CA',
  id: 'YSP',
  obj: {
    iata: 'YSP',
    iso: 'CA',
    coordinates: '-86.34439849853516, 48.75529861450195',
    municipality: 'Marathon'
  }
}, {
  label: 'The Florida Keys Marathon Airport (MTH) - US',
  id: 'MTH',
  obj: {
    iata: 'MTH',
    iso: 'US',
    coordinates: '-81.051399, 24.726101',
    municipality: 'Marathon'
  }
}, {
  label: 'Mardin Airport (MQM) - TR',
  id: 'MQM',
  obj: {
    iata: 'MQM',
    iso: 'TR',
    coordinates: '40.6316986084, 37.223300933800004',
    municipality: 'Mardin'
  }
}, {
  label: 'Margate Airport (MGH) - ZA',
  id: 'MGH',
  obj: {
    iata: 'MGH',
    iso: 'ZA',
    coordinates: '30.343000412, -30.8574008942',
    municipality: 'Margate'
  }
}, {
  label: 'RAF Marham (KNF) - GB',
  id: 'KNF',
  obj: {
    iata: 'KNF',
    iso: 'GB',
    coordinates: '0.550692, 52.648395',
    municipality: 'Marham'
  }
}, {
  label: 'Dobbins Air Reserve Base (MGE) - US',
  id: 'MGE',
  obj: {
    iata: 'MGE',
    iso: 'US',
    coordinates: '-84.51629639, 33.91540146',
    municipality: 'Marietta'
  }
}, {
  label: 'Douglas-Charles Airport (DOM) - DM',
  id: 'DOM',
  obj: {
    iata: 'DOM',
    iso: 'DM',
    coordinates: '-61.299999, 15.547',
    municipality: 'Marigot'
  }
}, {
  label: 'Marina Di Campo Airport (EBA) - IT',
  id: 'EBA',
  obj: {
    iata: 'EBA',
    iso: 'IT',
    coordinates: '10.2394, 42.7603',
    municipality: 'Marina  Di Campo'
  }
}, {
  label: 'Regional de Maring\u00c3\u00a1 - S\u00c3\u00adlvio Name J\u00c3\u00banior Airport (MGF) - BR',
  id: 'MGF',
  obj: {
    iata: 'MGF',
    iso: 'BR',
    coordinates: '-52.016187, -23.47606',
    municipality: 'Maring\u00c3\u00a1'
  }
}, {
  label: 'Mariquita Airport (MQU) - CO',
  id: 'MQU',
  obj: {
    iata: 'MQU',
    iso: 'CO',
    coordinates: '-74.8836, 5.21256',
    municipality: 'Mariquita'
  }
}, {
  label: 'Dr. Luis Maria Arga\u00c3\u00b1a International Airport (ESG) - PY',
  id: 'ESG',
  obj: {
    iata: 'ESG',
    iso: 'PY',
    coordinates: '-60.619998931884766, -22.049999237060547',
    municipality: 'Mariscal Estigarribia'
  }
}, {
  label: 'Mariupol International Airport (MPW) - UA',
  id: 'MPW',
  obj: {
    iata: 'MPW',
    iso: 'UA',
    coordinates: '37.44960021972656, 47.07609939575195',
    municipality: 'Mariupol'
  }
}, {
  label: 'Sunshine Coast Airport (MCY) - AU',
  id: 'MCY',
  obj: {
    iata: 'MCY',
    iso: 'AU',
    coordinates: '153.091003, -26.6033',
    municipality: 'Maroochydore'
  }
}, {
  label: 'Salak Airport (MVR) - CM',
  id: 'MVR',
  obj: {
    iata: 'MVR',
    iso: 'CM',
    coordinates: '14.257399559020996, 10.451399803161621',
    municipality: 'Maroua'
  }
}, {
  label: 'Sawyer International Airport (MQT) - US',
  id: 'MQT',
  obj: {
    iata: 'MQT',
    iso: 'US',
    coordinates: '-87.395401001, 46.353599548300004',
    municipality: 'Marquette'
  }
}, {
  label: 'Menara Airport (RAK) - MA',
  id: 'RAK',
  obj: {
    iata: 'RAK',
    iso: 'MA',
    coordinates: '-8.03629970551, 31.606899261499997',
    municipality: 'Marrakech'
  }
}, {
  label: 'Marsa Alam International Airport (RMF) - EG',
  id: 'RMF',
  obj: {
    iata: 'RMF',
    iso: 'EG',
    coordinates: '34.5836982727, 25.557100296',
    municipality: 'Marsa Alam'
  }
}, {
  label: 'Marseille Provence Airport (MRS) - FR',
  id: 'MRS',
  obj: {
    iata: 'MRS',
    iso: 'FR',
    coordinates: '5.22142410278, 43.439271922',
    municipality: 'Marseille'
  }
}, {
  label: 'Leonard M Thompson International Airport (MHH) - BS',
  id: 'MHH',
  obj: {
    iata: 'MHH',
    iso: 'BS',
    coordinates: '-77.083503, 26.5114',
    municipality: 'Marsh Harbour'
  }
}, {
  label: 'Marshall Don Hunter Sr Airport (MLL) - US',
  id: 'MLL',
  obj: {
    iata: 'MLL',
    iso: 'US',
    coordinates: '-162.026000977, 61.8642997742',
    municipality: 'Marshall'
  }
}, {
  label: 'Eastern WV Regional Airport/Shepherd Field (MRB) - US',
  id: 'MRB',
  obj: {
    iata: 'MRB',
    iso: 'US',
    coordinates: '-77.98459625, 39.40190125',
    municipality: 'Martinsburg'
  }
}, {
  label: 'Marudi Airport (MUR) - MY',
  id: 'MUR',
  obj: {
    iata: 'MUR',
    iso: 'MY',
    coordinates: '114.3290023803711, 4.178979873657227',
    municipality: 'Marudi'
  }
}, {
  label: 'Mary Airport (MYP) - TM',
  id: 'MYP',
  obj: {
    iata: 'MYP',
    iso: 'TM',
    coordinates: '61.896702, 37.6194',
    municipality: 'Mary'
  }
}, {
  label: "Mary's Harbour Airport (YMH) - CA",
  id: 'YMH',
  obj: {
    iata: 'YMH',
    iso: 'CA',
    coordinates: '-55.847198486328125, 52.302799224853516',
    municipality: "Mary's Harbour"
  }
}, {
  label: 'Beale Air Force Base (BAB) - US',
  id: 'BAB',
  obj: {
    iata: 'BAB',
    iso: 'US',
    coordinates: '-121.43699646, 39.136100769',
    municipality: 'Marysville'
  }
}, {
  label: 'Yuba County Airport (MYV) - US',
  id: 'MYV',
  obj: {
    iata: 'MYV',
    iso: 'US',
    coordinates: '-121.5699997, 39.09780121',
    municipality: 'Marysville'
  }
}, {
  label: 'Mar\u00c3\u00a9 Airport (MEE) - NC',
  id: 'MEE',
  obj: {
    iata: 'MEE',
    iso: 'NC',
    coordinates: '168.03799438476562, -21.481700897216797',
    municipality: 'Mar\u00c3\u00a9'
  }
}, {
  label: 'Frank Miloye Milenkowichi\u00e2\u0080\u0093Mar\u00c3\u00adlia State Airport (MII) - BR',
  id: 'MII',
  obj: {
    iata: 'MII',
    iso: 'BR',
    coordinates: '-49.926399231, -22.1968994141',
    municipality: 'Mar\u00c3\u00adlia'
  }
}, {
  label: 'Bar Yehuda Airfield (MTZ) - IL',
  id: 'MTZ',
  obj: {
    iata: 'MTZ',
    iso: 'IL',
    coordinates: '35.38859939575195, 31.32819938659668',
    municipality: 'Masada'
  }
}, {
  label: 'Moises R. Espinosa Airport (MBT) - PH',
  id: 'MBT',
  obj: {
    iata: 'MBT',
    iso: 'PH',
    coordinates: '123.630095, 12.369682',
    municipality: 'Masbate'
  }
}, {
  label: 'Moshoeshoe I International Airport (MSU) - LS',
  id: 'MSU',
  obj: {
    iata: 'MSU',
    iso: 'LS',
    coordinates: '27.552499771118164, -29.462299346923828',
    municipality: 'Maseru'
  }
}, {
  label: 'Mashhad International Airport (MHD) - IR',
  id: 'MHD',
  obj: {
    iata: 'MHD',
    iso: 'IR',
    coordinates: '59.64099884033203, 36.235198974609375',
    municipality: 'Mashhad'
  }
}, {
  label: 'Masirah Air Base (MSH) - OM',
  id: 'MSH',
  obj: {
    iata: 'MSH',
    iso: 'OM',
    coordinates: '58.890499114990234, 20.675399780273438',
    municipality: 'Masirah'
  }
}, {
  label: 'Mason City Municipal Airport (MCW) - US',
  id: 'MCW',
  obj: {
    iata: 'MCW',
    iso: 'US',
    coordinates: '-93.3312988281, 43.157798767100005',
    municipality: 'Mason City'
  }
}, {
  label: 'Massawa International Airport (MSW) - ER',
  id: 'MSW',
  obj: {
    iata: 'MSW',
    iso: 'ER',
    coordinates: '39.37009811401367, 15.670000076293945',
    municipality: 'Massawa'
  }
}, {
  label: 'Massena International Richards Field (MSS) - US',
  id: 'MSS',
  obj: {
    iata: 'MSS',
    iso: 'US',
    coordinates: '-74.84559631347656, 44.93579864501953',
    municipality: 'Massena'
  }
}, {
  label: 'Masset Airport (ZMT) - CA',
  id: 'ZMT',
  obj: {
    iata: 'ZMT',
    iso: 'CA',
    coordinates: '-132.125, 54.02750015258789',
    municipality: 'Masset'
  }
}, {
  label: 'Hood Airport (MRO) - NZ',
  id: 'MRO',
  obj: {
    iata: 'MRO',
    iso: 'NZ',
    coordinates: '175.63400268554688, -40.97330093383789',
    municipality: 'Masterton'
  }
}, {
  label: 'Iwami Airport (IWJ) - JP',
  id: 'IWJ',
  obj: {
    iata: 'IWJ',
    iso: 'JP',
    coordinates: '131.789993286, 34.676399231',
    municipality: 'Masuda'
  }
}, {
  label: 'Masvingo International Airport (MVZ) - ZW',
  id: 'MVZ',
  obj: {
    iata: 'MVZ',
    iso: 'ZW',
    coordinates: '30.859100341796875, -20.055299758911133',
    municipality: 'Masvingo'
  }
}, {
  label: 'Matagami Airport (YNM) - CA',
  id: 'YNM',
  obj: {
    iata: 'YNM',
    iso: 'CA',
    coordinates: '-77.80280303955078, 49.76169967651367',
    municipality: 'Matagami'
  }
}, {
  label: 'General Servando Canales International Airport (MAM) - MX',
  id: 'MAM',
  obj: {
    iata: 'MAM',
    iso: 'MX',
    coordinates: '-97.5252990723, 25.7698993683',
    municipality: 'Matamoros'
  }
}, {
  label: 'Matane Airport (YME) - CA',
  id: 'YME',
  obj: {
    iata: 'YME',
    iso: 'CA',
    coordinates: '-67.45330047607422, 48.85689926147461',
    municipality: 'Matane'
  }
}, {
  label: 'Lombok International Airport (LOP) - ID',
  id: 'LOP',
  obj: {
    iata: 'LOP',
    iso: 'ID',
    coordinates: '116.276675, -8.757322',
    municipality: 'Mataram'
  }
}, {
  label: 'Mati National Airport (MXI) - PH',
  id: 'MXI',
  obj: {
    iata: 'MXI',
    iso: 'PH',
    coordinates: '126.27368, 6.949091',
    municipality: 'Mati'
  }
}, {
  label: 'Matsumoto Airport (MMJ) - JP',
  id: 'MMJ',
  obj: {
    iata: 'MMJ',
    iso: 'JP',
    coordinates: '137.92300415039062, 36.16680145263672',
    municipality: 'Matsumoto'
  }
}, {
  label: 'Matsuyama Airport (MYJ) - JP',
  id: 'MYJ',
  obj: {
    iata: 'MYJ',
    iso: 'JP',
    coordinates: '132.6999969482422, 33.82720184326172',
    municipality: 'Matsuyama'
  }
}, {
  label: 'Inagua Airport (IGA) - BS',
  id: 'IGA',
  obj: {
    iata: 'IGA',
    iso: 'BS',
    coordinates: '-73.66690063476562, 20.975000381469727',
    municipality: 'Matthew Town'
  }
}, {
  label: 'Maubeuge-\u00c3\u0089lesmes Airport (XME) - FR',
  id: 'XME',
  obj: {
    iata: 'XME',
    iso: 'FR',
    coordinates: '4.033120155334473, 50.31050109863281',
    municipality: 'Maubeuge/\u00c3\u0089lesmes'
  }
}, {
  label: 'Maun Airport (MUB) - BW',
  id: 'MUB',
  obj: {
    iata: 'MUB',
    iso: 'BW',
    coordinates: '23.431100845336914, -19.97260093688965',
    municipality: 'Maun'
  }
}, {
  label: 'Eugenio Maria De Hostos Airport (MAZ) - PR',
  id: 'MAZ',
  obj: {
    iata: 'MAZ',
    iso: 'PR',
    coordinates: '-67.14849853515625, 18.255699157714844',
    municipality: 'Mayaguez'
  }
}, {
  label: 'Mayo Airport (YMA) - CA',
  id: 'YMA',
  obj: {
    iata: 'YMA',
    iso: 'CA',
    coordinates: '-135.8679962158203, 63.61640167236328',
    municipality: 'Mayo'
  }
}, {
  label: 'Naval Station Mayport (Admiral David L. Mcdonald Field) (NRB) - US',
  id: 'NRB',
  obj: {
    iata: 'NRB',
    iso: 'US',
    coordinates: '-81.42469788, 30.39109993',
    municipality: 'Mayport'
  }
}, {
  label: 'General Rafael Buelna International Airport (MZT) - MX',
  id: 'MZT',
  obj: {
    iata: 'MZT',
    iso: 'MX',
    coordinates: '-106.26599884, 23.1613998413',
    municipality: 'Mazatl\u00c3\u00a1n'
  }
}, {
  label: 'Mbandaka Airport (MDK) - CD',
  id: 'MDK',
  obj: {
    iata: 'MDK',
    iso: 'CD',
    coordinates: '18.2887001038, 0.0226000007242',
    municipality: 'Mbandaka'
  }
}, {
  label: 'Mbanza Congo Airport (SSY) - AO',
  id: 'SSY',
  obj: {
    iata: 'SSY',
    iso: 'AO',
    coordinates: '14.246999740600586, -6.269899845123291',
    municipality: 'Mbanza Congo'
  }
}, {
  label: 'Songwe Airport (MBI) - TZ',
  id: 'MBI',
  obj: {
    iata: 'MBI',
    iso: 'TZ',
    coordinates: '33.273981, -8.919942',
    municipality: 'Mbeya'
  }
}, {
  label: 'Mbuji Mayi Airport (MJM) - CD',
  id: 'MJM',
  obj: {
    iata: 'MJM',
    iso: 'CD',
    coordinates: '23.569000244099996, -6.121240139010001',
    municipality: 'Mbuji Mayi'
  }
}, {
  label: 'Mc Alester Regional Airport (MLC) - US',
  id: 'MLC',
  obj: {
    iata: 'MLC',
    iso: 'US',
    coordinates: '-95.783501, 34.882401',
    municipality: 'Mc Alester'
  }
}, {
  label: 'Mc Allen Miller International Airport (MFE) - US',
  id: 'MFE',
  obj: {
    iata: 'MFE',
    iso: 'US',
    coordinates: '-98.23860168, 26.17580032',
    municipality: 'Mc Allen'
  }
}, {
  label: 'Mc Comb/Pike County Airport/John E Lewis Field (MCB) - US',
  id: 'MCB',
  obj: {
    iata: 'MCB',
    iso: 'US',
    coordinates: '-90.47190094, 31.17849922',
    municipality: 'Mc Comb'
  }
}, {
  label: 'Mc Cook Ben Nelson Regional Airport (MCK) - US',
  id: 'MCK',
  obj: {
    iata: 'MCK',
    iso: 'US',
    coordinates: '-100.5920029, 40.20629883',
    municipality: 'Mc Cook'
  }
}, {
  label: 'McCall Municipal Airport (MYL) - US',
  id: 'MYL',
  obj: {
    iata: 'MYL',
    iso: 'US',
    coordinates: '-116.1009979, 44.88970184',
    municipality: 'McCall'
  }
}, {
  label: 'McGrath Airport (MCG) - US',
  id: 'MCG',
  obj: {
    iata: 'MCG',
    iso: 'US',
    coordinates: '-155.6060028, 62.95289993',
    municipality: 'McGrath'
  }
}, {
  label: 'Meadow Lake Airport (YLJ) - CA',
  id: 'YLJ',
  obj: {
    iata: 'YLJ',
    iso: 'CA',
    coordinates: '-108.52300262451172, 54.125301361083984',
    municipality: 'Meadow Lake'
  }
}, {
  label: 'Mecheria Airport (MZW) - DZ',
  id: 'MZW',
  obj: {
    iata: 'MZW',
    iso: 'DZ',
    coordinates: '-0.242353007197, 33.535900116',
    municipality: 'Mecheria'
  }
}, {
  label: 'Soewondo Air Force Base (MES) - ID',
  id: 'MES',
  obj: {
    iata: 'MES',
    iso: 'ID',
    coordinates: '98.671111, 3.559167',
    municipality: 'Medan-Sumatra Island'
  }
}, {
  label: 'Enrique Olaya Herrera Airport (EOH) - CO',
  id: 'EOH',
  obj: {
    iata: 'EOH',
    iso: 'CO',
    coordinates: '-75.590582, 6.220549',
    municipality: 'Medell\u00c3\u00adn'
  }
}, {
  label: 'Jose Maria C\u00c3\u00b3rdova International Airport (MDE) - CO',
  id: 'MDE',
  obj: {
    iata: 'MDE',
    iso: 'CO',
    coordinates: '-75.4231, 6.16454',
    municipality: 'Medell\u00c3\u00adn'
  }
}, {
  label: 'Rogue Valley International Medford Airport (MFR) - US',
  id: 'MFR',
  obj: {
    iata: 'MFR',
    iso: 'US',
    coordinates: '-122.87300109863281, 42.37419891357422',
    municipality: 'Medford'
  }
}, {
  label: 'Medicine Hat Airport (YXH) - CA',
  id: 'YXH',
  obj: {
    iata: 'YXH',
    iso: 'CA',
    coordinates: '-110.72100067138672, 50.01890182495117',
    municipality: 'Medicine Hat'
  }
}, {
  label: 'Prince Mohammad Bin Abdulaziz Airport (MED) - SA',
  id: 'MED',
  obj: {
    iata: 'MED',
    iso: 'SA',
    coordinates: '39.705101, 24.5534',
    municipality: 'Medina'
  }
}, {
  label: 'Mehamn Airport (MEH) - NO',
  id: 'MEH',
  obj: {
    iata: 'MEH',
    iso: 'NO',
    coordinates: '27.826700210571, 71.02970123291',
    municipality: 'Mehamn'
  }
}, {
  label: 'Bassatine Airport (MEK) - MA',
  id: 'MEK',
  obj: {
    iata: 'MEK',
    iso: 'MA',
    coordinates: '-5.515120029449463, 33.87910079956055',
    municipality: 'Meknes'
  }
}, {
  label: 'Mekoryuk Airport (MYU) - US',
  id: 'MYU',
  obj: {
    iata: 'MYU',
    iso: 'US',
    coordinates: '-166.27099609375, 60.37139892578125',
    municipality: 'Mekoryuk'
  }
}, {
  label: 'Melbourne International Airport (MLB) - US',
  id: 'MLB',
  obj: {
    iata: 'MLB',
    iso: 'US',
    coordinates: '-80.64530181884766, 28.102800369262695',
    municipality: 'Melbourne'
  }
}, {
  label: 'Avalon Airport (AVV) - AU',
  id: 'AVV',
  obj: {
    iata: 'AVV',
    iso: 'AU',
    coordinates: '144.468994, -38.039398',
    municipality: 'Melbourne'
  }
}, {
  label: 'Melbourne Essendon Airport (MEB) - AU',
  id: 'MEB',
  obj: {
    iata: 'MEB',
    iso: 'AU',
    coordinates: '144.901993, -37.7281',
    municipality: 'Melbourne'
  }
}, {
  label: 'Melbourne Moorabbin Airport (MBW) - AU',
  id: 'MBW',
  obj: {
    iata: 'MBW',
    iso: 'AU',
    coordinates: '145.1020050048828, -37.975799560546875',
    municipality: 'Melbourne'
  }
}, {
  label: 'Melbourne International Airport (MEL) - AU',
  id: 'MEL',
  obj: {
    iata: 'MEL',
    iso: 'AU',
    coordinates: '144.843002, -37.673302',
    municipality: 'Melbourne'
  }
}, {
  label: 'Melilla Airport (MLN) - ES',
  id: 'MLN',
  obj: {
    iata: 'MLN',
    iso: 'ES',
    coordinates: '-2.9562599659, 35.279800415',
    municipality: 'Melilla'
  }
}, {
  label: 'Memmingen Allgau Airport (FMM) - DE',
  id: 'FMM',
  obj: {
    iata: 'FMM',
    iso: 'DE',
    coordinates: '10.2395000458, 47.988800048799995',
    municipality: 'Memmingen'
  }
}, {
  label: 'Memphis International Airport (MEM) - US',
  id: 'MEM',
  obj: {
    iata: 'MEM',
    iso: 'US',
    coordinates: '-89.97669982910156, 35.04240036010742',
    municipality: 'Memphis'
  }
}, {
  label: 'Mende-Brenoux Airfield (MEN) - FR',
  id: 'MEN',
  obj: {
    iata: 'MEN',
    iso: 'FR',
    coordinates: '3.53282, 44.502102',
    municipality: 'Mende/Br\u00c3\u00a9noux'
  }
}, {
  label: 'Mendi Airport (MDU) - PG',
  id: 'MDU',
  obj: {
    iata: 'MDU',
    iso: 'PG',
    coordinates: '143.656998, -6.14774',
    municipality: 'Mendi'
  }
}, {
  label: 'El Plumerillo Airport (MDZ) - AR',
  id: 'MDZ',
  obj: {
    iata: 'MDZ',
    iso: 'AR',
    coordinates: '-68.7929000854, -32.8316993713',
    municipality: 'Mendoza'
  }
}, {
  label: 'Huatugou Airport (HTT) - CN',
  id: 'HTT',
  obj: {
    iata: 'HTT',
    iso: 'CN',
    coordinates: '90.841495, 38.201984',
    municipality: 'Mengnai'
  }
}, {
  label: 'Menongue Airport (SPP) - AO',
  id: 'SPP',
  obj: {
    iata: 'SPP',
    iso: 'AO',
    coordinates: '17.71980094909668, -14.657600402832031',
    municipality: 'Menongue'
  }
}, {
  label: 'Menorca Airport (MAH) - ES',
  id: 'MAH',
  obj: {
    iata: 'MAH',
    iso: 'ES',
    coordinates: '4.218649864196777, 39.86259841918945',
    municipality: 'Menorca Island'
  }
}, {
  label: 'Mopah Airport (MKQ) - ID',
  id: 'MKQ',
  obj: {
    iata: 'MKQ',
    iso: 'ID',
    coordinates: '140.41799926757812, -8.52029037475586',
    municipality: 'Merauke-Papua Island'
  }
}, {
  label: 'Merced Regional Macready Field (MCE) - US',
  id: 'MCE',
  obj: {
    iata: 'MCE',
    iso: 'US',
    coordinates: '-120.5139999, 37.28469849',
    municipality: 'Merced'
  }
}, {
  label: 'Castle Airport (MER) - US',
  id: 'MER',
  obj: {
    iata: 'MER',
    iso: 'US',
    coordinates: '-120.5680008, 37.38050079',
    municipality: 'Merced'
  }
}, {
  label: 'Desert Rock Airport (DRA) - US',
  id: 'DRA',
  obj: {
    iata: 'DRA',
    iso: 'US',
    coordinates: '-116.032997, 36.6194',
    municipality: 'Mercury'
  }
}, {
  label: 'Key Field (MEI) - US',
  id: 'MEI',
  obj: {
    iata: 'MEI',
    iso: 'US',
    coordinates: '-88.75189971923828, 32.33259963989258',
    municipality: 'Meridian'
  }
}, {
  label: 'Merimbula Airport (MIM) - AU',
  id: 'MIM',
  obj: {
    iata: 'MIM',
    iso: 'AU',
    coordinates: '149.901000977, -36.9085998535',
    municipality: 'Merimbula'
  }
}, {
  label: 'Merowe New Airport (MWE) - SD',
  id: 'MWE',
  obj: {
    iata: 'MWE',
    iso: 'SD',
    coordinates: '31.8433333333, 18.4433333333',
    municipality: 'Merowe'
  }
}, {
  label: 'Mersa Matruh Airport (MUH) - EG',
  id: 'MUH',
  obj: {
    iata: 'MUH',
    iso: 'EG',
    coordinates: '27.221700668300002, 31.3253993988',
    municipality: 'Mersa Matruh'
  }
}, {
  label: 'Merville-Calonne Airport (HZB) - FR',
  id: 'HZB',
  obj: {
    iata: 'HZB',
    iso: 'FR',
    coordinates: '2.642240047454834, 50.61840057373047',
    municipality: 'Merville/Calonne'
  }
}, {
  label: 'Metz-Nancy-Lorraine Airport (ETZ) - FR',
  id: 'ETZ',
  obj: {
    iata: 'ETZ',
    iso: 'FR',
    coordinates: '6.25131988525, 48.9821014404',
    municipality: 'Metz / Nancy'
  }
}, {
  label: 'General Rodolfo S\u00c3\u00a1nchez Taboada International Airport (MXL) - MX',
  id: 'MXL',
  obj: {
    iata: 'MXL',
    iso: 'MX',
    coordinates: '-115.241997, 32.6306',
    municipality: 'Mexicali'
  }
}, {
  label: 'Licenciado Benito Juarez International Airport (MEX) - MX',
  id: 'MEX',
  obj: {
    iata: 'MEX',
    iso: 'MX',
    coordinates: '-99.072098, 19.4363',
    municipality: 'Mexico City'
  }
}, {
  label: 'Mfuwe Airport (MFU) - ZM',
  id: 'MFU',
  obj: {
    iata: 'MFU',
    iso: 'ZM',
    coordinates: '31.936599731445312, -13.258899688720703',
    municipality: 'Mfuwe'
  }
}, {
  label: 'Miami International Airport (MIA) - US',
  id: 'MIA',
  obj: {
    iata: 'MIA',
    iso: 'US',
    coordinates: '-80.29060363769531, 25.79319953918457',
    municipality: 'Miami'
  }
}, {
  label: 'Miami-Opa Locka Executive Airport (OPF) - US',
  id: 'OPF',
  obj: {
    iata: 'OPF',
    iso: 'US',
    coordinates: '-80.278397, 25.907',
    municipality: 'Miami'
  }
}, {
  label: 'Miami Executive Airport (TMB) - US',
  id: 'TMB',
  obj: {
    iata: 'TMB',
    iso: 'US',
    coordinates: '-80.4328, 25.6479',
    municipality: 'Miami'
  }
}, {
  label: 'Mianwali Air Base (MWD) - PK',
  id: 'MWD',
  obj: {
    iata: 'MWD',
    iso: 'PK',
    coordinates: '71.5707015991211, 32.5630989074707',
    municipality: 'Mianwali'
  }
}, {
  label: 'Midland International Airport (MAF) - US',
  id: 'MAF',
  obj: {
    iata: 'MAF',
    iso: 'US',
    coordinates: '-102.2020034790039, 31.9424991607666',
    municipality: 'Midland'
  }
}, {
  label: 'Grand Central Airport (GCJ) - ZA',
  id: 'GCJ',
  obj: {
    iata: 'GCJ',
    iso: 'ZA',
    coordinates: '28.1401004791, -25.986299514799995',
    municipality: 'Midrand'
  }
}, {
  label: 'Mikkeli Airport (MIK) - FI',
  id: 'MIK',
  obj: {
    iata: 'MIK',
    iso: 'FI',
    coordinates: '27.201799, 61.6866',
    municipality: 'Mikkeli'
  }
}, {
  label: 'Malpensa International Airport (MXP) - IT',
  id: 'MXP',
  obj: {
    iata: 'MXP',
    iso: 'IT',
    coordinates: '8.72811, 45.6306',
    municipality: 'Milan'
  }
}, {
  label: 'Milano Linate Airport (LIN) - IT',
  id: 'LIN',
  obj: {
    iata: 'LIN',
    iso: 'IT',
    coordinates: '9.27674, 45.445099',
    municipality: 'Milan'
  }
}, {
  label: 'RAF Mildenhall (MHZ) - GB',
  id: 'MHZ',
  obj: {
    iata: 'MHZ',
    iso: 'GB',
    coordinates: '0.48640599846839905, 52.361900329589844',
    municipality: 'Mildenhall'
  }
}, {
  label: 'Mildura Airport (MQL) - AU',
  id: 'MQL',
  obj: {
    iata: 'MQL',
    iso: 'AU',
    coordinates: '142.085998535, -34.229198455799995',
    municipality: 'Mildura'
  }
}, {
  label: 'Frank Wiley Field (MLS) - US',
  id: 'MLS',
  obj: {
    iata: 'MLS',
    iso: 'US',
    coordinates: '-105.88600158691406, 46.428001403808594',
    municipality: 'Miles City'
  }
}, {
  label: 'Millington-Memphis Airport (NQA) - US',
  id: 'NQA',
  obj: {
    iata: 'NQA',
    iso: 'US',
    coordinates: '-89.8703, 35.356701',
    municipality: 'Millington'
  }
}, {
  label: 'Millville Municipal Airport (MIV) - US',
  id: 'MIV',
  obj: {
    iata: 'MIV',
    iso: 'US',
    coordinates: '-75.072197, 39.367802',
    municipality: 'Millville'
  }
}, {
  label: 'Whiting Field Naval Air Station - North (NSE) - US',
  id: 'NSE',
  obj: {
    iata: 'NSE',
    iso: 'US',
    coordinates: '-87.02189636, 30.7241993',
    municipality: 'Milton'
  }
}, {
  label: 'General Mitchell International Airport (MKE) - US',
  id: 'MKE',
  obj: {
    iata: 'MKE',
    iso: 'US',
    coordinates: '-87.89659881591797, 42.947200775146484',
    municipality: 'Milwaukee'
  }
}, {
  label: 'Minami-Daito Airport (MMD) - JP',
  id: 'MMD',
  obj: {
    iata: 'MMD',
    iso: 'JP',
    coordinates: '131.263000488, 25.8465003967',
    municipality: 'Minamidait\u00c5\u008d'
  }
}, {
  label: 'Minatitl\u00c3\u00a1n/Coatzacoalcos National Airport (MTT) - MX',
  id: 'MTT',
  obj: {
    iata: 'MTT',
    iso: 'MX',
    coordinates: '-94.58070373540001, 18.1033992767',
    municipality: 'Minatitl\u00c3\u00a1n'
  }
}, {
  label: 'Mina\u00c3\u00a7u Airport (MQH) - BR',
  id: 'MQH',
  obj: {
    iata: 'MQH',
    iso: 'BR',
    coordinates: '-48.195301, -13.5491',
    municipality: 'Mina\u00c3\u00a7u'
  }
}, {
  label: 'Mineralnyye Vody Airport (MRV) - RU',
  id: 'MRV',
  obj: {
    iata: 'MRV',
    iso: 'RU',
    coordinates: '43.08190155029297, 44.225101470947266',
    municipality: 'Mineralnyye Vody'
  }
}, {
  label: 'Minna Airport (MXJ) - NG',
  id: 'MXJ',
  obj: {
    iata: 'MXJ',
    iso: 'NG',
    coordinates: '6.462259769439697, 9.652170181274414',
    municipality: 'Minna'
  }
}, {
  label: 'Minneapolis-St Paul International/Wold-Chamberlain Airport (MSP) - US',
  id: 'MSP',
  obj: {
    iata: 'MSP',
    iso: 'US',
    coordinates: '-93.221802, 44.882',
    municipality: 'Minneapolis'
  }
}, {
  label: 'Minot Air Force Base (MIB) - US',
  id: 'MIB',
  obj: {
    iata: 'MIB',
    iso: 'US',
    coordinates: '-101.358002, 48.4156',
    municipality: 'Minot'
  }
}, {
  label: 'Minot International Airport (MOT) - US',
  id: 'MOT',
  obj: {
    iata: 'MOT',
    iso: 'US',
    coordinates: '-101.27999877929688, 48.2593994140625',
    municipality: 'Minot'
  }
}, {
  label: 'Minsk National Airport (MSQ) - BY',
  id: 'MSQ',
  obj: {
    iata: 'MSQ',
    iso: 'BY',
    coordinates: '28.030700683594, 53.882499694824',
    municipality: 'Minsk'
  }
}, {
  label: 'Miquelon Airport (MQC) - PM',
  id: 'MQC',
  obj: {
    iata: 'MQC',
    iso: 'PM',
    coordinates: '-56.3802986145, 47.095500946',
    municipality: 'Miquelon'
  }
}, {
  label: 'Miramichi Airport (YCH) - CA',
  id: 'YCH',
  obj: {
    iata: 'YCH',
    iso: 'CA',
    coordinates: '-65.449203, 47.007801',
    municipality: 'Miramichi'
  }
}, {
  label: 'Miri Airport (MYY) - MY',
  id: 'MYY',
  obj: {
    iata: 'MYY',
    iso: 'MY',
    coordinates: '113.98699951171875, 4.322010040283203',
    municipality: 'Miri'
  }
}, {
  label: 'Mirny Airport (MJZ) - RU',
  id: 'MJZ',
  obj: {
    iata: 'MJZ',
    iso: 'RU',
    coordinates: '114.03900146484375, 62.534698486328125',
    municipality: 'Mirny'
  }
}, {
  label: 'Sukkur Airport (SKZ) - PK',
  id: 'SKZ',
  obj: {
    iata: 'SKZ',
    iso: 'PK',
    coordinates: '68.79170227050781, 27.722000122070312',
    municipality: 'Mirpur Khas'
  }
}, {
  label: 'Misawa Air Base (MSJ) - JP',
  id: 'MSJ',
  obj: {
    iata: 'MSJ',
    iso: 'JP',
    coordinates: '141.367996216, 40.703201293899994',
    municipality: 'Misawa'
  }
}, {
  label: 'Missoula International Airport (MSO) - US',
  id: 'MSO',
  obj: {
    iata: 'MSO',
    iso: 'US',
    coordinates: '-114.0910034, 46.91630173',
    municipality: 'Missoula'
  }
}, {
  label: 'Fabio Alberto Leon Bentley Airport (MVP) - CO',
  id: 'MVP',
  obj: {
    iata: 'MVP',
    iso: 'CO',
    coordinates: '-70.2339, 1.25366',
    municipality: 'Mit\u00c3\u00ba'
  }
}, {
  label: 'Miyakejima Airport (MYE) - JP',
  id: 'MYE',
  obj: {
    iata: 'MYE',
    iso: 'JP',
    coordinates: '139.559997559, 34.073600769',
    municipality: 'Miyakejima'
  }
}, {
  label: 'Miyako Airport (MMY) - JP',
  id: 'MMY',
  obj: {
    iata: 'MMY',
    iso: 'JP',
    coordinates: '125.294998169, 24.782800674399997',
    municipality: 'Miyako City'
  }
}, {
  label: 'Miyazaki Airport (KMI) - JP',
  id: 'KMI',
  obj: {
    iata: 'KMI',
    iso: 'JP',
    coordinates: '131.449005127, 31.877199173',
    municipality: 'Miyazaki'
  }
}, {
  label: 'Myeik Airport (MGZ) - MM',
  id: 'MGZ',
  obj: {
    iata: 'MGZ',
    iso: 'MM',
    coordinates: '98.62149810791016, 12.439800262451172',
    municipality: 'Mkeik'
  }
}, {
  label: 'Mkuze Airport (MZQ) - ZA',
  id: 'MZQ',
  obj: {
    iata: 'MZQ',
    iso: 'ZA',
    coordinates: '32.0443000793457, -27.626100540161133',
    municipality: 'Mkuze'
  }
}, {
  label: 'Mo i Rana Airport, R\u00c3\u00b8ssvoll (MQN) - NO',
  id: 'MQN',
  obj: {
    iata: 'MQN',
    iso: 'NO',
    coordinates: '14.301400184631, 66.363899230957',
    municipality: 'Mo i Rana'
  }
}, {
  label: 'Orestes Acosta Airport (MOA) - CU',
  id: 'MOA',
  obj: {
    iata: 'MOA',
    iso: 'CU',
    coordinates: '-74.92220306396484, 20.653900146484375',
    municipality: 'Moa'
  }
}, {
  label: 'Mobile Downtown Airport (BFM) - US',
  id: 'BFM',
  obj: {
    iata: 'BFM',
    iso: 'US',
    coordinates: '-88.06809997559999, 30.626800537100003',
    municipality: 'Mobile'
  }
}, {
  label: 'Mobile Regional Airport (MOB) - US',
  id: 'MOB',
  obj: {
    iata: 'MOB',
    iso: 'US',
    coordinates: '-88.242797851562, 30.691200256348',
    municipality: 'Mobile'
  }
}, {
  label: 'Mobridge Municipal Airport (MBG) - US',
  id: 'MBG',
  obj: {
    iata: 'MBG',
    iso: 'US',
    coordinates: '-100.4079971, 45.54650116',
    municipality: 'Mobridge'
  }
}, {
  label: 'Moc\u00c3\u00admboa da Praia Airport (MZB) - MZ',
  id: 'MZB',
  obj: {
    iata: 'MZB',
    iso: 'MZ',
    coordinates: '40.35490036010742, -11.361800193786621',
    municipality: 'Moc\u00c3\u00admboa da Praia'
  }
}, {
  label: 'Modesto City Co-Harry Sham Field (MOD) - US',
  id: 'MOD',
  obj: {
    iata: 'MOD',
    iso: 'US',
    coordinates: '-120.9540024, 37.62580109',
    municipality: 'Modesto'
  }
}, {
  label: 'Moenjodaro Airport (MJD) - PK',
  id: 'MJD',
  obj: {
    iata: 'MJD',
    iso: 'PK',
    coordinates: '68.14309692382812, 27.3351993560791',
    municipality: 'Moenjodaro'
  }
}, {
  label: 'Aden Adde International Airport (MGQ) - SO',
  id: 'MGQ',
  obj: {
    iata: 'MGQ',
    iso: 'SO',
    coordinates: '45.3046989440918, 2.0144400596618652',
    municipality: 'Mogadishu'
  }
}, {
  label: 'Mogilev Airport (MVQ) - BY',
  id: 'MVQ',
  obj: {
    iata: 'MVQ',
    iso: 'BY',
    coordinates: '30.09510040283203, 53.954898834228516',
    municipality: 'Mogilev'
  }
}, {
  label: 'Dillingham Airfield (HDH) - US',
  id: 'HDH',
  obj: {
    iata: 'HDH',
    iso: 'US',
    coordinates: '-158.197006226, 21.5795001984',
    municipality: 'Mokuleia'
  }
}, {
  label: 'Quad City International Airport (MLI) - US',
  id: 'MLI',
  obj: {
    iata: 'MLI',
    iso: 'US',
    coordinates: '-90.50749969482422, 41.44850158691406',
    municipality: 'Moline'
  }
}, {
  label: 'Mombasa Moi International Airport (MBA) - KE',
  id: 'MBA',
  obj: {
    iata: 'MBA',
    iso: 'KE',
    coordinates: '39.594200134277344, -4.034830093383789',
    municipality: 'Mombasa'
  }
}, {
  label: 'Monastir Habib Bourguiba International Airport (MIR) - TN',
  id: 'MIR',
  obj: {
    iata: 'MIR',
    iso: 'TN',
    coordinates: '10.75469970703125, 35.75809860229492',
    municipality: 'Monastir'
  }
}, {
  label: 'Monbetsu Airport (MBE) - JP',
  id: 'MBE',
  obj: {
    iata: 'MBE',
    iso: 'JP',
    coordinates: '143.404006958, 44.303901672399995',
    municipality: 'Monbetsu'
  }
}, {
  label: 'Greater Moncton Rom\u00c3\u00a9o LeBlanc International Airport (YQM) - CA',
  id: 'YQM',
  obj: {
    iata: 'YQM',
    iso: 'CA',
    coordinates: '-64.678596, 46.112202',
    municipality: 'Moncton'
  }
}, {
  label: 'Mong Hsat Airport (MOG) - MM',
  id: 'MOG',
  obj: {
    iata: 'MOG',
    iso: 'MM',
    coordinates: '99.25679779052734, 20.516799926757812',
    municipality: 'Mong Hsat'
  }
}, {
  label: 'Mongu Airport (MNR) - ZM',
  id: 'MNR',
  obj: {
    iata: 'MNR',
    iso: 'ZM',
    coordinates: '23.16230010986328, -15.254500389099121',
    municipality: 'Mongu'
  }
}, {
  label: 'Monroe Regional Airport (MLU) - US',
  id: 'MLU',
  obj: {
    iata: 'MLU',
    iso: 'US',
    coordinates: '-92.0376968383789, 32.51089859008789',
    municipality: 'Monroe'
  }
}, {
  label: 'Spriggs Payne Airport (MLW) - LR',
  id: 'MLW',
  obj: {
    iata: 'MLW',
    iso: 'LR',
    coordinates: '-10.758700370788574, 6.289060115814209',
    municipality: 'Monrovia'
  }
}, {
  label: 'Roberts International Airport (ROB) - LR',
  id: 'ROB',
  obj: {
    iata: 'ROB',
    iso: 'LR',
    coordinates: '-10.3623, 6.23379',
    municipality: 'Monrovia'
  }
}, {
  label: 'Mont Joli Airport (YYY) - CA',
  id: 'YYY',
  obj: {
    iata: 'YYY',
    iso: 'CA',
    coordinates: '-68.20809936523438, 48.60860061645508',
    municipality: 'Mont-Joli'
  }
}, {
  label: 'Monte Caseros Airport (MCS) - AR',
  id: 'MCS',
  obj: {
    iata: 'MCS',
    iso: 'AR',
    coordinates: '-57.6402, -30.2719',
    municipality: 'Monte Caseros'
  }
}, {
  label: 'Sangster International Airport (MBJ) - JM',
  id: 'MBJ',
  obj: {
    iata: 'MBJ',
    iso: 'JM',
    coordinates: '-77.91339874267578, 18.503700256347656',
    municipality: 'Montego Bay'
  }
}, {
  label: 'Monterey Peninsula Airport (MRY) - US',
  id: 'MRY',
  obj: {
    iata: 'MRY',
    iso: 'US',
    coordinates: '-121.84300231933594, 36.58700180053711',
    municipality: 'Monterey'
  }
}, {
  label: 'General Mariano Escobedo International Airport (MTY) - MX',
  id: 'MTY',
  obj: {
    iata: 'MTY',
    iso: 'MX',
    coordinates: '-100.107002258, 25.7784996033',
    municipality: 'Monterrey'
  }
}, {
  label: 'Los Garzones Airport (MTR) - CO',
  id: 'MTR',
  obj: {
    iata: 'MTR',
    iso: 'CO',
    coordinates: '-75.8258, 8.82374',
    municipality: 'Monter\u00c3\u00ada'
  }
}, {
  label: 'M\u00c3\u00a1rio Ribeiro Airport (MOC) - BR',
  id: 'MOC',
  obj: {
    iata: 'MOC',
    iso: 'BR',
    coordinates: '-43.818901062, -16.706899642899998',
    municipality: 'Montes Claros'
  }
}, {
  label: 'Carrasco International /General C L Berisso Airport (MVD) - UY',
  id: 'MVD',
  obj: {
    iata: 'MVD',
    iso: 'UY',
    coordinates: '-56.0308, -34.838402',
    municipality: 'Montevideo'
  }
}, {
  label: 'Montgomery Regional (Dannelly Field) Airport (MGM) - US',
  id: 'MGM',
  obj: {
    iata: 'MGM',
    iso: 'US',
    coordinates: '-86.39399719, 32.30059814',
    municipality: 'Montgomery'
  }
}, {
  label: 'Maxwell Air Force Base (MXF) - US',
  id: 'MXF',
  obj: {
    iata: 'MXF',
    iso: 'US',
    coordinates: '-86.365799, 32.3829',
    municipality: 'Montgomery'
  }
}, {
  label: 'Brescia Airport (VBS) - IT',
  id: 'VBS',
  obj: {
    iata: 'VBS',
    iso: 'IT',
    coordinates: '10.3306, 45.428902',
    municipality: 'Montichiari (BS)'
  }
}, {
  label: 'Montlu\u00c3\u00a7on-Gu\u00c3\u00a9ret Airport (MCU) - FR',
  id: 'MCU',
  obj: {
    iata: 'MCU',
    iso: 'FR',
    coordinates: '2.363960027694702, 46.222599029541016',
    municipality: 'Montlu\u00c3\u00a7on/Gu\u00c3\u00a9ret'
  }
}, {
  label: 'Montpellier-M\u00c3\u00a9diterran\u00c3\u00a9e Airport (MPL) - FR',
  id: 'MPL',
  obj: {
    iata: 'MPL',
    iso: 'FR',
    coordinates: '3.96301007270813, 43.57619857788086',
    municipality: 'Montpellier/M\u00c3\u00a9diterran\u00c3\u00a9e'
  }
}, {
  label: 'Montrose Regional Airport (MTJ) - US',
  id: 'MTJ',
  obj: {
    iata: 'MTJ',
    iso: 'US',
    coordinates: '-107.893997192, 38.509799957300004',
    municipality: 'Montrose'
  }
}, {
  label: 'Montr\u00c3\u00a9al / Saint-Hubert Airport (YHU) - CA',
  id: 'YHU',
  obj: {
    iata: 'YHU',
    iso: 'CA',
    coordinates: '-73.4169006348, 45.5175018311',
    municipality: 'Montr\u00c3\u00a9al'
  }
}, {
  label: 'Montreal International (Mirabel) Airport (YMX) - CA',
  id: 'YMX',
  obj: {
    iata: 'YMX',
    iso: 'CA',
    coordinates: '-74.038696, 45.679501',
    municipality: 'Montr\u00c3\u00a9al'
  }
}, {
  label: 'Montreal / Pierre Elliott Trudeau International Airport (YUL) - CA',
  id: 'YUL',
  obj: {
    iata: 'YUL',
    iso: 'CA',
    coordinates: '-73.7407989502, 45.4706001282',
    municipality: 'Montr\u00c3\u00a9al'
  }
}, {
  label: 'Moose Jaw Air Vice Marshal C. M. McEwen Airport (YMJ) - CA',
  id: 'YMJ',
  obj: {
    iata: 'YMJ',
    iso: 'CA',
    coordinates: '-105.55899810791016, 50.330299377441406',
    municipality: 'Moose Jaw'
  }
}, {
  label: 'Moosonee Airport (YMO) - CA',
  id: 'YMO',
  obj: {
    iata: 'YMO',
    iso: 'CA',
    coordinates: '-80.60780334472656, 51.291099548339844',
    municipality: 'Moosonee'
  }
}, {
  label: 'Mora Airport (MXX) - SE',
  id: 'MXX',
  obj: {
    iata: 'MXX',
    iso: 'SE',
    coordinates: '14.5114, 60.957901',
    municipality: 'Mora'
  }
}, {
  label: 'Moranbah Airport (MOV) - AU',
  id: 'MOV',
  obj: {
    iata: 'MOV',
    iso: 'AU',
    coordinates: '148.07699585, -22.057800293',
    municipality: 'Moranbah'
  }
}, {
  label: 'Moree Airport (MRZ) - AU',
  id: 'MRZ',
  obj: {
    iata: 'MRZ',
    iso: 'AU',
    coordinates: '149.845001221, -29.498899459799997',
    municipality: 'Moree'
  }
}, {
  label: 'General Francisco J. Mujica International Airport (MLM) - MX',
  id: 'MLM',
  obj: {
    iata: 'MLM',
    iso: 'MX',
    coordinates: '-101.025001526, 19.849899292',
    municipality: 'Morelia'
  }
}, {
  label: 'Morgantown Municipal Walter L. Bill Hart Field (MGW) - US',
  id: 'MGW',
  obj: {
    iata: 'MGW',
    iso: 'US',
    coordinates: '-79.91629791, 39.64289856',
    municipality: 'Morgantown'
  }
}, {
  label: 'Morlaix-Ploujean Airport (MXN) - FR',
  id: 'MXN',
  obj: {
    iata: 'MXN',
    iso: 'FR',
    coordinates: '-3.81577992439, 48.6031990051',
    municipality: 'Morlaix/Ploujean'
  }
}, {
  label: 'Prince Said Ibrahim International Airport (HAH) - KM',
  id: 'HAH',
  obj: {
    iata: 'HAH',
    iso: 'KM',
    coordinates: '43.2719, -11.5337',
    municipality: 'Moroni'
  }
}, {
  label: 'Morristown Municipal Airport (MMU) - US',
  id: 'MMU',
  obj: {
    iata: 'MMU',
    iso: 'US',
    coordinates: '-74.41490173339844, 40.799400329589844',
    municipality: 'Morristown'
  }
}, {
  label: 'Moruya Airport (MYA) - AU',
  id: 'MYA',
  obj: {
    iata: 'MYA',
    iso: 'AU',
    coordinates: '150.143997192, -35.8978004456',
    municipality: 'Moruya'
  }
}, {
  label: 'Latrobe Valley Airport (TGN) - AU',
  id: 'TGN',
  obj: {
    iata: 'TGN',
    iso: 'AU',
    coordinates: '146.470001, -38.207199',
    municipality: 'Morwell'
  }
}, {
  label: 'Moron Air Base (OZP) - ES',
  id: 'OZP',
  obj: {
    iata: 'OZP',
    iso: 'ES',
    coordinates: '-5.615940093994141, 37.17490005493164',
    municipality: 'Mor\u00c3\u00b3n'
  }
}, {
  label: 'Zhukovsky International Airport (ZIA) - RU',
  id: 'ZIA',
  obj: {
    iata: 'ZIA',
    iso: 'RU',
    coordinates: '38.150002, 55.553299',
    municipality: 'Moscow'
  }
}, {
  label: 'Domodedovo International Airport (DME) - RU',
  id: 'DME',
  obj: {
    iata: 'DME',
    iso: 'RU',
    coordinates: '37.90629959106445, 55.40879821777344',
    municipality: 'Moscow'
  }
}, {
  label: 'Sheremetyevo International Airport (SVO) - RU',
  id: 'SVO',
  obj: {
    iata: 'SVO',
    iso: 'RU',
    coordinates: '37.4146, 55.972599',
    municipality: 'Moscow'
  }
}, {
  label: 'Ostafyevo International Airport (OSF) - RU',
  id: 'OSF',
  obj: {
    iata: 'OSF',
    iso: 'RU',
    coordinates: '37.507222, 55.511667',
    municipality: 'Moscow'
  }
}, {
  label: 'Chkalovskiy Air Base (CKL) - RU',
  id: 'CKL',
  obj: {
    iata: 'CKL',
    iso: 'RU',
    coordinates: '38.061699, 55.8783',
    municipality: 'Moscow'
  }
}, {
  label: 'Vnukovo International Airport (VKO) - RU',
  id: 'VKO',
  obj: {
    iata: 'VKO',
    iso: 'RU',
    coordinates: '37.2615013123, 55.5914993286',
    municipality: 'Moscow'
  }
}, {
  label: 'Grant County International Airport (MWH) - US',
  id: 'MWH',
  obj: {
    iata: 'MWH',
    iso: 'US',
    coordinates: '-119.3199997, 47.20769882',
    municipality: 'Moses Lake'
  }
}, {
  label: 'Central Wisconsin Airport (CWA) - US',
  id: 'CWA',
  obj: {
    iata: 'CWA',
    iso: 'US',
    coordinates: '-89.6668014526, 44.7775993347',
    municipality: 'Mosinee'
  }
}, {
  label: 'Dix-Sept Rosado Airport (MVF) - BR',
  id: 'MVF',
  obj: {
    iata: 'MVF',
    iso: 'BR',
    coordinates: '-37.3642997742, -5.2019200324999995',
    municipality: 'Mossor\u00c3\u00b3'
  }
}, {
  label: 'Mostar International Airport (OMO) - BA',
  id: 'OMO',
  obj: {
    iata: 'OMO',
    iso: 'BA',
    coordinates: '17.84589958190918, 43.282901763916016',
    municipality: 'Mostar'
  }
}, {
  label: 'Mosul International Airport (OSM) - IQ',
  id: 'OSM',
  obj: {
    iata: 'OSM',
    iso: 'IQ',
    coordinates: '43.1474, 36.305801',
    municipality: 'Mosul'
  }
}, {
  label: 'Bora Bora Airport (BOB) - PF',
  id: 'BOB',
  obj: {
    iata: 'BOB',
    iso: 'PF',
    coordinates: '-151.75100708007812, -16.444400787353516',
    municipality: 'Motu Mute'
  }
}, {
  label: 'Mouilla Ville Airport (MJL) - GA',
  id: 'MJL',
  obj: {
    iata: 'MJL',
    iso: 'GA',
    coordinates: '11.056699752807617, -1.845139980316162',
    municipality: 'Mouila'
  }
}, {
  label: 'Selfridge Air National Guard Base Airport (MTC) - US',
  id: 'MTC',
  obj: {
    iata: 'MTC',
    iso: 'US',
    coordinates: '-82.836919, 42.613463',
    municipality: 'Mount Clemens'
  }
}, {
  label: 'Mount Hagen Kagamuga Airport (HGU) - PG',
  id: 'HGU',
  obj: {
    iata: 'HGU',
    iso: 'PG',
    coordinates: '144.29600524902344, -5.826789855957031',
    municipality: 'Mount Hagen'
  }
}, {
  label: 'Mount Hotham Airport (MHU) - AU',
  id: 'MHU',
  obj: {
    iata: 'MHU',
    iso: 'AU',
    coordinates: '147.333999634, -37.0475006104',
    municipality: 'Mount Hotham'
  }
}, {
  label: 'Mount Isa Airport (ISA) - AU',
  id: 'ISA',
  obj: {
    iata: 'ISA',
    iso: 'AU',
    coordinates: '139.488998413, -20.663900375399997',
    municipality: 'Mount Isa'
  }
}, {
  label: 'Mount Pleasant Airport (MPN) - FK',
  id: 'MPN',
  obj: {
    iata: 'MPN',
    iso: 'FK',
    coordinates: '-58.447200775146484, -51.82279968261719',
    municipality: 'Mount Pleasant'
  }
}, {
  label: 'Ozark Regional Airport (WMH) - US',
  id: 'WMH',
  obj: {
    iata: 'WMH',
    iso: 'US',
    coordinates: '-92.47049713130001, 36.3689002991',
    municipality: 'Mountain Home'
  }
}, {
  label: 'Mountain Home Air Force Base (MUO) - US',
  id: 'MUO',
  obj: {
    iata: 'MUO',
    iso: 'US',
    coordinates: '-115.872002, 43.043598',
    municipality: 'Mountain Home'
  }
}, {
  label: 'Moffett Federal Airfield (NUQ) - US',
  id: 'NUQ',
  obj: {
    iata: 'NUQ',
    iso: 'US',
    coordinates: '-122.049004, 37.4161',
    municipality: 'Mountain View'
  }
}, {
  label: 'Kruger Mpumalanga International Airport (MQP) - ZA',
  id: 'MQP',
  obj: {
    iata: 'MQP',
    iso: 'ZA',
    coordinates: '31.1056003571, -25.3831996918',
    municipality: 'Mpumalanga'
  }
}, {
  label: 'K. D. Matanzima Airport (UTT) - ZA',
  id: 'UTT',
  obj: {
    iata: 'UTT',
    iso: 'ZA',
    coordinates: '28.6733551025, -31.546363184900002',
    municipality: 'Mthatha'
  }
}, {
  label: 'Mtwara Airport (MYW) - TZ',
  id: 'MYW',
  obj: {
    iata: 'MYW',
    iso: 'TZ',
    coordinates: '40.181800842285156, -10.339099884033203',
    municipality: 'Mtwara'
  }
}, {
  label: 'Mudgee Airport (DGE) - AU',
  id: 'DGE',
  obj: {
    iata: 'DGE',
    iso: 'AU',
    coordinates: '149.610992432, -32.5625',
    municipality: 'Mudgee'
  }
}, {
  label: 'Mueda Airport (MUD) - MZ',
  id: 'MUD',
  obj: {
    iata: 'MUD',
    iso: 'MZ',
    coordinates: '39.5630989074707, -11.672900199890137',
    municipality: 'Mueda'
  }
}, {
  label: 'Multan International Airport (MUX) - PK',
  id: 'MUX',
  obj: {
    iata: 'MUX',
    iso: 'PK',
    coordinates: '71.41909790039062, 30.20319938659668',
    municipality: 'Multan'
  }
}, {
  label: 'Mulu Airport (MZV) - MY',
  id: 'MZV',
  obj: {
    iata: 'MZV',
    iso: 'MY',
    coordinates: '114.80500030517578, 4.048329830169678',
    municipality: 'Mulu'
  }
}, {
  label: 'Chhatrapati Shivaji International Airport (BOM) - IN',
  id: 'BOM',
  obj: {
    iata: 'BOM',
    iso: 'IN',
    coordinates: '72.8678970337, 19.0886993408',
    municipality: 'Mumbai'
  }
}, {
  label: 'Delaware County Johnson Field (MIE) - US',
  id: 'MIE',
  obj: {
    iata: 'MIE',
    iso: 'US',
    coordinates: '-85.3958969116211, 40.2422981262207',
    municipality: 'Muncie'
  }
}, {
  label: 'Murmansk Airport (MMK) - RU',
  id: 'MMK',
  obj: {
    iata: 'MMK',
    iso: 'RU',
    coordinates: '32.75080108642578, 68.78170013427734',
    municipality: 'Murmansk'
  }
}, {
  label: 'Muscat International Airport (MCT) - OM',
  id: 'MCT',
  obj: {
    iata: 'MCT',
    iso: 'OM',
    coordinates: '58.284400939941406, 23.593299865722656',
    municipality: 'Muscat'
  }
}, {
  label: 'Northwest Alabama Regional Airport (MSL) - US',
  id: 'MSL',
  obj: {
    iata: 'MSL',
    iso: 'US',
    coordinates: '-87.61019897, 34.74530029',
    municipality: 'Muscle Shoals'
  }
}, {
  label: 'Muskegon County Airport (MKG) - US',
  id: 'MKG',
  obj: {
    iata: 'MKG',
    iso: 'US',
    coordinates: '-86.238197, 43.169498',
    municipality: 'Muskegon'
  }
}, {
  label: 'Muskoka Airport (YQA) - CA',
  id: 'YQA',
  obj: {
    iata: 'YQA',
    iso: 'CA',
    coordinates: '-79.30329895019531, 44.974700927734375',
    municipality: 'Muskoka'
  }
}, {
  label: 'Muskrat Dam Airport (MSA) - CA',
  id: 'MSA',
  obj: {
    iata: 'MSA',
    iso: 'CA',
    coordinates: '-91.76280212402344, 53.44139862060547',
    municipality: 'Muskrat Dam'
  }
}, {
  label: 'Mustique Airport (MQS) - VC',
  id: 'MQS',
  obj: {
    iata: 'MQS',
    iso: 'VC',
    coordinates: '-61.180198669433594, 12.887900352478027',
    municipality: 'Mustique Island'
  }
}, {
  label: 'Muzaffarabad Airport (MFG) - PK',
  id: 'MFG',
  obj: {
    iata: 'MFG',
    iso: 'PK',
    coordinates: '73.50859832763672, 34.3390007019043',
    municipality: 'Muzaffarabad'
  }
}, {
  label: 'Mu\u00c5\u009f Airport (MSR) - TR',
  id: 'MSR',
  obj: {
    iata: 'MSR',
    iso: 'TR',
    coordinates: '41.66120147705078, 38.747798919677734',
    municipality: 'Mu\u00c5\u009f'
  }
}, {
  label: 'Mwanza Airport (MWZ) - TZ',
  id: 'MWZ',
  obj: {
    iata: 'MWZ',
    iso: 'TZ',
    coordinates: '32.932701110839844, -2.4444899559020996',
    municipality: 'Mwanza'
  }
}, {
  label: 'Myitkyina Airport (MYT) - MM',
  id: 'MYT',
  obj: {
    iata: 'MYT',
    iso: 'MM',
    coordinates: '97.35189819335938, 25.38360023498535',
    municipality: 'Myitkyina'
  }
}, {
  label: 'Mikonos Airport (JMK) - GR',
  id: 'JMK',
  obj: {
    iata: 'JMK',
    iso: 'GR',
    coordinates: '25.348100662231445, 37.43510055541992',
    municipality: 'Mykonos Island'
  }
}, {
  label: 'Myrtle Beach International Airport (MYR) - US',
  id: 'MYR',
  obj: {
    iata: 'MYR',
    iso: 'US',
    coordinates: '-78.9282989502, 33.6796989441',
    municipality: 'Myrtle Beach'
  }
}, {
  label: 'Mytilene International Airport (MJT) - GR',
  id: 'MJT',
  obj: {
    iata: 'MJT',
    iso: 'GR',
    coordinates: '26.5983009338, 39.0567016602',
    municipality: 'Mytilene'
  }
}, {
  label: 'Mzuzu Airport (ZZU) - MW',
  id: 'ZZU',
  obj: {
    iata: 'ZZU',
    iso: 'MW',
    coordinates: '34.01179885864258, -11.444700241088867',
    municipality: 'Mzuzu'
  }
}, {
  label: 'M\u00c3\u00a1laga Airport (AGP) - ES',
  id: 'AGP',
  obj: {
    iata: 'AGP',
    iso: 'ES',
    coordinates: '-4.499110221862793, 36.67490005493164',
    municipality: 'M\u00c3\u00a1laga'
  }
}, {
  label: 'Bardufoss Airport (BDU) - NO',
  id: 'BDU',
  obj: {
    iata: 'BDU',
    iso: 'NO',
    coordinates: '18.540399551392, 69.055801391602',
    municipality: 'M\u00c3\u00a5lselv'
  }
}, {
  label: 'Licenciado Manuel Crescencio Rejon Int Airport (MID) - MX',
  id: 'MID',
  obj: {
    iata: 'MID',
    iso: 'MX',
    coordinates: '-89.657699585, 20.937000274699997',
    municipality: 'M\u00c3\u00a9rida'
  }
}, {
  label: 'Alberto Carnevalli Airport (MRD) - VE',
  id: 'MRD',
  obj: {
    iata: 'MRD',
    iso: 'VE',
    coordinates: '-71.161041, 8.582078',
    municipality: 'M\u00c3\u00a9rida'
  }
}, {
  label: 'M\u00c3\u00b6nchengladbach Airport (MGL) - DE',
  id: 'MGL',
  obj: {
    iata: 'MGL',
    iso: 'DE',
    coordinates: '6.504444, 51.230278',
    municipality: 'M\u00c3\u00b6nchengladbach'
  }
}, {
  label: 'M\u00c3\u00bcnster Osnabr\u00c3\u00bcck Airport (FMO) - DE',
  id: 'FMO',
  obj: {
    iata: 'FMO',
    iso: 'DE',
    coordinates: '7.68483018875, 52.134601593',
    municipality: 'M\u00c3\u00bcnster'
  }
}, {
  label: "N'Djamena International Airport (NDJ) - TD",
  id: 'NDJ',
  obj: {
    iata: 'NDJ',
    iso: 'TD',
    coordinates: '15.034, 12.1337',
    municipality: "N'Djamena"
  }
}, {
  label: "N'Gaound\u00c3\u00a9r\u00c3\u00a9 Airport (NGE) - CM",
  id: 'NGE',
  obj: {
    iata: 'NGE',
    iso: 'CM',
    coordinates: '13.559200286865234, 7.3570098876953125',
    municipality: "N'Gaound\u00c3\u00a9r\u00c3\u00a9"
  }
}, {
  label: 'Ndolo Airport (NLO) - CD',
  id: 'NLO',
  obj: {
    iata: 'NLO',
    iso: 'CD',
    coordinates: '15.327500343323, -4.32666015625',
    municipality: "N'dolo"
  }
}, {
  label: 'Samui Airport (USM) - TH',
  id: 'USM',
  obj: {
    iata: 'USM',
    iso: 'TH',
    coordinates: '100.06199646, 9.547789573669998',
    municipality: 'Na Thon (Ko Samui Island)'
  }
}, {
  label: 'Nabire Airport (NBX) - ID',
  id: 'NBX',
  obj: {
    iata: 'NBX',
    iso: 'ID',
    coordinates: '135.496002, -3.36818',
    municipality: 'Nabire-Papua Island'
  }
}, {
  label: 'Nadi International Airport (NAN) - FJ',
  id: 'NAN',
  obj: {
    iata: 'NAN',
    iso: 'FJ',
    coordinates: '177.4429931640625, -17.755399703979492',
    municipality: 'Nadi'
  }
}, {
  label: 'Nador International Airport (NDR) - MA',
  id: 'NDR',
  obj: {
    iata: 'NDR',
    iso: 'MA',
    coordinates: '-3.0282099247, 34.988800048799995',
    municipality: 'Nador'
  }
}, {
  label: 'Nadym Airport (NYM) - RU',
  id: 'NYM',
  obj: {
    iata: 'NYM',
    iso: 'RU',
    coordinates: '72.69889831542969, 65.48090362548828',
    municipality: 'Nadym'
  }
}, {
  label: 'Naga Airport (WNP) - PH',
  id: 'WNP',
  obj: {
    iata: 'WNP',
    iso: 'PH',
    coordinates: '123.2699966430664, 13.58489990234375',
    municipality: 'Naga'
  }
}, {
  label: 'Nagasaki Airport (NGS) - JP',
  id: 'NGS',
  obj: {
    iata: 'NGS',
    iso: 'JP',
    coordinates: '129.914001465, 32.916900634799994',
    municipality: 'Nagasaki'
  }
}, {
  label: 'Nagoya Airport (NKM) - JP',
  id: 'NKM',
  obj: {
    iata: 'NKM',
    iso: 'JP',
    coordinates: '136.9239959716797, 35.255001068115234',
    municipality: 'Nagoya'
  }
}, {
  label: 'Dr. Babasaheb Ambedkar International Airport (NAG) - IN',
  id: 'NAG',
  obj: {
    iata: 'NAG',
    iso: 'IN',
    coordinates: '79.047203, 21.092199',
    municipality: 'Nagpur'
  }
}, {
  label: 'Naha Airport (OKA) - JP',
  id: 'OKA',
  obj: {
    iata: 'OKA',
    iso: 'JP',
    coordinates: '127.646003723, 26.1958007812',
    municipality: 'Naha'
  }
}, {
  label: 'Nain Airport (YDP) - CA',
  id: 'YDP',
  obj: {
    iata: 'YDP',
    iso: 'CA',
    coordinates: '-61.680301666259766, 56.549198150634766',
    municipality: 'Nain'
  }
}, {
  label: 'Jomo Kenyatta International Airport (NBO) - KE',
  id: 'NBO',
  obj: {
    iata: 'NBO',
    iso: 'KE',
    coordinates: '36.9277992249, -1.31923997402',
    municipality: 'Nairobi'
  }
}, {
  label: 'Nairobi Wilson Airport (WIL) - KE',
  id: 'WIL',
  obj: {
    iata: 'WIL',
    iso: 'KE',
    coordinates: '36.81480026245117, -1.321720004081726',
    municipality: 'Nairobi'
  }
}, {
  label: 'Nakashibetsu Airport (SHB) - JP',
  id: 'SHB',
  obj: {
    iata: 'SHB',
    iso: 'JP',
    coordinates: '144.960006714, 43.5774993896',
    municipality: 'Nakashibetsu'
  }
}, {
  label: 'Nakhchivan Airport (NAJ) - AZ',
  id: 'NAJ',
  obj: {
    iata: 'NAJ',
    iso: 'AZ',
    coordinates: '45.45840072631836, 39.18880081176758',
    municipality: 'Nakhchivan'
  }
}, {
  label: 'Kamphaeng Saen Airport (KDT) - TH',
  id: 'KDT',
  obj: {
    iata: 'KDT',
    iso: 'TH',
    coordinates: '99.9171981812, 14.1020002365',
    municipality: 'Nakhon Pathom'
  }
}, {
  label: 'Nakhon Si Thammarat Airport (NST) - TH',
  id: 'NST',
  obj: {
    iata: 'NST',
    iso: 'TH',
    coordinates: '99.9447021484375, 8.539620399475098',
    municipality: 'Nakhon Si Thammarat'
  }
}, {
  label: 'Nakina Airport (YQN) - CA',
  id: 'YQN',
  obj: {
    iata: 'YQN',
    iso: 'CA',
    coordinates: '-86.69640350341797, 50.18280029296875',
    municipality: 'Nakina'
  }
}, {
  label: 'Nalchik Airport (NAL) - RU',
  id: 'NAL',
  obj: {
    iata: 'NAL',
    iso: 'RU',
    coordinates: '43.636600494384766, 43.512901306152344',
    municipality: 'Nalchik'
  }
}, {
  label: 'Namibe Airport (MSZ) - AO',
  id: 'MSZ',
  obj: {
    iata: 'MSZ',
    iso: 'AO',
    coordinates: '12.14680004119873, -15.261199951171875',
    municipality: 'Namibe'
  }
}, {
  label: 'Nampula Airport (APL) - MZ',
  id: 'APL',
  obj: {
    iata: 'APL',
    iso: 'MZ',
    coordinates: '39.28179931640625, -15.105600357055664',
    municipality: 'Nampula'
  }
}, {
  label: 'Namsang Airport (NMS) - MM',
  id: 'NMS',
  obj: {
    iata: 'NMS',
    iso: 'MM',
    coordinates: '97.73590087890625, 20.890499114990234',
    municipality: 'Namsang'
  }
}, {
  label: 'Nanaimo Airport (YCD) - CA',
  id: 'YCD',
  obj: {
    iata: 'YCD',
    iso: 'CA',
    coordinates: '-123.869862556, 49.054970224899996',
    municipality: 'Nanaimo'
  }
}, {
  label: 'Nancy-Essey Airport (ENC) - FR',
  id: 'ENC',
  obj: {
    iata: 'ENC',
    iso: 'FR',
    coordinates: '6.230460166931152, 48.692100524902344',
    municipality: 'Nancy/Essey'
  }
}, {
  label: 'Nanded Airport (NDC) - IN',
  id: 'NDC',
  obj: {
    iata: 'NDC',
    iso: 'IN',
    coordinates: '77.31670379639999, 19.1833000183',
    municipality: 'Nanded'
  }
}, {
  label: 'Nanga Pinoh Airport (NPO) - ID',
  id: 'NPO',
  obj: {
    iata: 'NPO',
    iso: 'ID',
    coordinates: '111.74800109863, -0.34886899590492',
    municipality: 'Nanga Pinoh-Borneo Island'
  }
}, {
  label: 'Matsu Nangan Airport (LZN) - TW',
  id: 'LZN',
  obj: {
    iata: 'LZN',
    iso: 'TW',
    coordinates: '119.958, 26.1598',
    municipality: 'Nangang Island'
  }
}, {
  label: 'Kochi Ryoma Airport (KCZ) - JP',
  id: 'KCZ',
  obj: {
    iata: 'KCZ',
    iso: 'JP',
    coordinates: '133.669006, 33.546101',
    municipality: 'Nankoku'
  }
}, {
  label: 'Nanning Wuxu Airport (NNG) - CN',
  id: 'NNG',
  obj: {
    iata: 'NNG',
    iso: 'CN',
    coordinates: '108.1719970703125, 22.608299255371094',
    municipality: 'Nanning'
  }
}, {
  label: 'Nantes Atlantique Airport (NTE) - FR',
  id: 'NTE',
  obj: {
    iata: 'NTE',
    iso: 'FR',
    coordinates: '-1.61073005199, 47.153198242200006',
    municipality: 'Nantes'
  }
}, {
  label: 'Nantucket Memorial Airport (ACK) - US',
  id: 'ACK',
  obj: {
    iata: 'ACK',
    iso: 'US',
    coordinates: '-70.06020355, 41.25310135',
    municipality: 'Nantucket'
  }
}, {
  label: 'Nanyuki Airport (NYK) - KE',
  id: 'NYK',
  obj: {
    iata: 'NYK',
    iso: 'KE',
    coordinates: '37.041008, -0.062399',
    municipality: 'Nanyuki'
  }
}, {
  label: "Hawke's Bay Airport (NPE) - NZ",
  id: 'NPE',
  obj: {
    iata: 'NPE',
    iso: 'NZ',
    coordinates: '176.869995, -39.465801',
    municipality: 'Napier'
  }
}, {
  label: 'Naples Municipal Airport (APF) - US',
  id: 'APF',
  obj: {
    iata: 'APF',
    iso: 'US',
    coordinates: '-81.7752990723, 26.1525993347',
    municipality: 'Naples'
  }
}, {
  label: 'Narrabri Airport (NAA) - AU',
  id: 'NAA',
  obj: {
    iata: 'NAA',
    iso: 'AU',
    coordinates: '149.82699585, -30.3192005157',
    municipality: 'Narrabri'
  }
}, {
  label: 'Narrandera Airport (NRA) - AU',
  id: 'NRA',
  obj: {
    iata: 'NRA',
    iso: 'AU',
    coordinates: '146.511993408, -34.7022018433',
    municipality: 'Narrandera'
  }
}, {
  label: 'Narsarsuaq Airport (UAK) - GL',
  id: 'UAK',
  obj: {
    iata: 'UAK',
    iso: 'GL',
    coordinates: '-45.4259986877, 61.1604995728',
    municipality: 'Narsarsuaq'
  }
}, {
  label: 'Narvik Framnes Airport (NVK) - NO',
  id: 'NVK',
  obj: {
    iata: 'NVK',
    iso: 'NO',
    coordinates: '17.386699676514, 68.436897277832',
    municipality: 'Narvik'
  }
}, {
  label: 'Naryan Mar Airport (NNM) - RU',
  id: 'NNM',
  obj: {
    iata: 'NNM',
    iso: 'RU',
    coordinates: '53.12189865112305, 67.63999938964844',
    municipality: 'Naryan Mar'
  }
}, {
  label: 'Nashville International Airport (BNA) - US',
  id: 'BNA',
  obj: {
    iata: 'BNA',
    iso: 'US',
    coordinates: '-86.6781997680664, 36.1245002746582',
    municipality: 'Nashville'
  }
}, {
  label: 'Nashik Airport (ISK) - IN',
  id: 'ISK',
  obj: {
    iata: 'ISK',
    iso: 'IN',
    coordinates: '73.912903, 20.119101',
    municipality: 'Nasik'
  }
}, {
  label: 'Ali Air Base (XNH) - IQ',
  id: 'XNH',
  obj: {
    iata: 'XNH',
    iso: 'IQ',
    coordinates: '46.090099, 30.935801',
    municipality: 'Nasiriyah'
  }
}, {
  label: 'Lynden Pindling International Airport (NAS) - BS',
  id: 'NAS',
  obj: {
    iata: 'NAS',
    iso: 'BS',
    coordinates: '-77.466202, 25.039',
    municipality: 'Nassau'
  }
}, {
  label: 'Governador Alu\u00c3\u00adzio Alves International Airport (NAT) - BR',
  id: 'NAT',
  obj: {
    iata: 'NAT',
    iso: 'BR',
    coordinates: '-35.376111, -5.768056',
    municipality: 'Natal'
  }
}, {
  label: 'Natashquan Airport (YNA) - CA',
  id: 'YNA',
  obj: {
    iata: 'YNA',
    iso: 'CA',
    coordinates: '-61.78919982910156, 50.189998626708984',
    municipality: 'Natashquan'
  }
}, {
  label: 'Nausori International Airport (SUV) - FJ',
  id: 'SUV',
  obj: {
    iata: 'SUV',
    iso: 'FJ',
    coordinates: '178.5590057373047, -18.04330062866211',
    municipality: 'Nausori'
  }
}, {
  label: 'Ministro Victor Konder International Airport (NVT) - BR',
  id: 'NVT',
  obj: {
    iata: 'NVT',
    iso: 'BR',
    coordinates: '-48.651402, -26.879999',
    municipality: 'Navegantes'
  }
}, {
  label: 'Shaheed Benazirabad Airport (WNS) - PK',
  id: 'WNS',
  obj: {
    iata: 'WNS',
    iso: 'PK',
    coordinates: '68.390099, 26.2194',
    municipality: 'Nawabashah'
  }
}, {
  label: 'Maria Reiche Neuman Airport (NZC) - PE',
  id: 'NZC',
  obj: {
    iata: 'NZC',
    iso: 'PE',
    coordinates: '-74.9615020752, -14.854000091600001',
    municipality: 'Nazca'
  }
}, {
  label: 'Simon Mwansa Kapwepwe International Airport (NLA) - ZM',
  id: 'NLA',
  obj: {
    iata: 'NLA',
    iso: 'ZM',
    coordinates: '28.66489982605, -12.998100280762',
    municipality: 'Ndola'
  }
}, {
  label: 'Iringa Airport (IRI) - TZ',
  id: 'IRI',
  obj: {
    iata: 'IRI',
    iso: 'TZ',
    coordinates: '35.75210189819336, -7.668630123138428',
    municipality: 'Nduli'
  }
}, {
  label: 'Nea Anchialos Airport (VOL) - GR',
  id: 'VOL',
  obj: {
    iata: 'VOL',
    iso: 'GR',
    coordinates: '22.794300079345703, 39.219600677490234',
    municipality: 'Nea Anchialos'
  }
}, {
  label: 'Necochea Airport (NEC) - AR',
  id: 'NEC',
  obj: {
    iata: 'NEC',
    iso: 'AR',
    coordinates: '-58.8172, -38.4831',
    municipality: 'Necochea'
  }
}, {
  label: 'Needles Airport (EED) - US',
  id: 'EED',
  obj: {
    iata: 'EED',
    iso: 'US',
    coordinates: '-114.623001099, 34.7663002014',
    municipality: 'Needles'
  }
}, {
  label: 'Nefteyugansk Airport (NFG) - RU',
  id: 'NFG',
  obj: {
    iata: 'NFG',
    iso: 'RU',
    coordinates: '72.6500015258789, 61.108299255371094',
    municipality: 'Nefteyugansk'
  }
}, {
  label: 'Negage Airport (GXG) - AO',
  id: 'GXG',
  obj: {
    iata: 'GXG',
    iso: 'AO',
    coordinates: '15.287699699401855, -7.754509925842285',
    municipality: 'Negage'
  }
}, {
  label: 'Benito Salas Airport (NVA) - CO',
  id: 'NVA',
  obj: {
    iata: 'NVA',
    iso: 'CO',
    coordinates: '-75.294, 2.95015',
    municipality: 'Neiva'
  }
}, {
  label: 'Nelson Airport (NSN) - NZ',
  id: 'NSN',
  obj: {
    iata: 'NSN',
    iso: 'NZ',
    coordinates: '173.2209930419922, -41.298301696777344',
    municipality: 'Nelson'
  }
}, {
  label: 'Nemiscau Airport (YNS) - CA',
  id: 'YNS',
  obj: {
    iata: 'YNS',
    iso: 'CA',
    coordinates: '-76.1355972290039, 51.69110107421875',
    municipality: 'Nemiscau'
  }
}, {
  label: 'Nenana Municipal Airport (ENN) - US',
  id: 'ENN',
  obj: {
    iata: 'ENN',
    iso: 'US',
    coordinates: '-149.07400512695312, 64.54730224609375',
    municipality: 'Nenana'
  }
}, {
  label: 'Neom Airport (NUM) - SA',
  id: 'NUM',
  obj: {
    iata: 'NUM',
    iso: 'SA',
    coordinates: '35.28874, 27.927598',
    municipality: 'Neom'
  }
}, {
  label: 'Nepalgunj Airport (KEP) - NP',
  id: 'KEP',
  obj: {
    iata: 'KEP',
    iso: 'NP',
    coordinates: '81.66699981689453, 28.103599548339844',
    municipality: 'Nepalgunj'
  }
}, {
  label: 'Chulman Airport (NER) - RU',
  id: 'NER',
  obj: {
    iata: 'NER',
    iso: 'RU',
    coordinates: '124.91400146484, 56.913898468018',
    municipality: 'Neryungri'
  }
}, {
  label: 'Neubrandenburg Airport (FNB) - DE',
  id: 'FNB',
  obj: {
    iata: 'FNB',
    iso: 'DE',
    coordinates: '13.306, 53.6022',
    municipality: 'Neubrandenburg'
  }
}, {
  label: 'Presidente Peron Airport (NQN) - AR',
  id: 'NQN',
  obj: {
    iata: 'NQN',
    iso: 'AR',
    coordinates: '-68.155701, -38.949001',
    municipality: 'Neuquen'
  }
}, {
  label: 'Nevers-Fourchambault Airport (NVS) - FR',
  id: 'NVS',
  obj: {
    iata: 'NVS',
    iso: 'FR',
    coordinates: '3.1133298873901367, 47.002601623535156',
    municipality: 'Nevers/Fourchambault'
  }
}, {
  label: 'New Bedford Regional Airport (EWB) - US',
  id: 'EWB',
  obj: {
    iata: 'EWB',
    iso: 'US',
    coordinates: '-70.95690155029297, 41.67610168457031',
    municipality: 'New Bedford'
  }
}, {
  label: 'Coastal Carolina Regional Airport (EWN) - US',
  id: 'EWN',
  obj: {
    iata: 'EWN',
    iso: 'US',
    coordinates: '-77.04290008539999, 35.0730018616',
    municipality: 'New Bern'
  }
}, {
  label: 'Indira Gandhi International Airport (DEL) - IN',
  id: 'DEL',
  obj: {
    iata: 'DEL',
    iso: 'IN',
    coordinates: '77.103104, 28.5665',
    municipality: 'New Delhi'
  }
}, {
  label: 'Tweed New Haven Airport (HVN) - US',
  id: 'HVN',
  obj: {
    iata: 'HVN',
    iso: 'US',
    coordinates: '-72.88680267, 41.26369858',
    municipality: 'New Haven'
  }
}, {
  label: 'Acadiana Regional Airport (ARA) - US',
  id: 'ARA',
  obj: {
    iata: 'ARA',
    iso: 'US',
    coordinates: '-91.883904, 30.0378',
    municipality: 'New Iberia'
  }
}, {
  label: 'Louis Armstrong New Orleans International Airport (MSY) - US',
  id: 'MSY',
  obj: {
    iata: 'MSY',
    iso: 'US',
    coordinates: '-90.25800323486328, 29.99340057373047',
    municipality: 'New Orleans'
  }
}, {
  label: 'New Orleans NAS JRB/Alvin Callender Field (NBG) - US',
  id: 'NBG',
  obj: {
    iata: 'NBG',
    iso: 'US',
    coordinates: '-90.03500366, 29.82530022',
    municipality: 'New Orleans'
  }
}, {
  label: 'Lakefront Airport (NEW) - US',
  id: 'NEW',
  obj: {
    iata: 'NEW',
    iso: 'US',
    coordinates: '-90.028297424316, 30.042400360107',
    municipality: 'New Orleans'
  }
}, {
  label: 'New Plymouth Airport (NPL) - NZ',
  id: 'NPL',
  obj: {
    iata: 'NPL',
    iso: 'NZ',
    coordinates: '174.1790008544922, -39.00859832763672',
    municipality: 'New Plymouth'
  }
}, {
  label: 'John F Kennedy International Airport (JFK) - US',
  id: 'JFK',
  obj: {
    iata: 'JFK',
    iso: 'US',
    coordinates: '-73.7789, 40.639801',
    municipality: 'New York'
  }
}, {
  label: 'La Guardia Airport (LGA) - US',
  id: 'LGA',
  obj: {
    iata: 'LGA',
    iso: 'US',
    coordinates: '-73.872597, 40.777199',
    municipality: 'New York'
  }
}, {
  label: 'Newark Liberty International Airport (EWR) - US',
  id: 'EWR',
  obj: {
    iata: 'EWR',
    iso: 'US',
    coordinates: '-74.168701171875, 40.692501068115234',
    municipality: 'Newark'
  }
}, {
  label: 'New York Stewart International Airport (SWF) - US',
  id: 'SWF',
  obj: {
    iata: 'SWF',
    iso: 'US',
    coordinates: '-74.104797, 41.504101',
    municipality: 'Newburgh'
  }
}, {
  label: 'Newcastle Airport (NCL) - GB',
  id: 'NCL',
  obj: {
    iata: 'NCL',
    iso: 'GB',
    coordinates: '-1.6916699409484863, 55.037498474121094',
    municipality: 'Newcastle'
  }
}, {
  label: 'Newcastle Airport (NCS) - ZA',
  id: 'NCS',
  obj: {
    iata: 'NCS',
    iso: 'ZA',
    coordinates: '29.976900100699996, -27.7705993652',
    municipality: 'Newcastle'
  }
}, {
  label: 'Newman Airport (ZNE) - AU',
  id: 'ZNE',
  obj: {
    iata: 'ZNE',
    iso: 'AU',
    coordinates: '119.803001404, -23.417800903299998',
    municipality: 'Newman'
  }
}, {
  label: 'Newport Municipal Airport (ONP) - US',
  id: 'ONP',
  obj: {
    iata: 'ONP',
    iso: 'US',
    coordinates: '-124.057999, 44.580399',
    municipality: 'Newport'
  }
}, {
  label: 'Newport News Williamsburg International Airport (PHF) - US',
  id: 'PHF',
  obj: {
    iata: 'PHF',
    iso: 'US',
    coordinates: '-76.49299622, 37.13190079',
    municipality: 'Newport News'
  }
}, {
  label: 'Newquay Cornwall Airport (NQY) - GB',
  id: 'NQY',
  obj: {
    iata: 'NQY',
    iso: 'GB',
    coordinates: '-4.995409965515137, 50.44060134887695',
    municipality: 'Newquay'
  }
}, {
  label: 'Ngjiva Pereira Airport (VPE) - AO',
  id: 'VPE',
  obj: {
    iata: 'VPE',
    iso: 'AO',
    coordinates: '15.683799743700002, -17.0435009003',
    municipality: 'Ngiva'
  }
}, {
  label: 'Cam Ranh Airport (CXR) - VN',
  id: 'CXR',
  obj: {
    iata: 'CXR',
    iso: 'VN',
    coordinates: '109.21900177001953, 11.998200416564941',
    municipality: 'Nha Trang'
  }
}, {
  label: 'Gove Airport (GOV) - AU',
  id: 'GOV',
  obj: {
    iata: 'GOV',
    iso: 'AU',
    coordinates: '136.817993164, -12.269399642899998',
    municipality: 'Nhulunbuy'
  }
}, {
  label: 'Niagara Falls International Airport (IAG) - US',
  id: 'IAG',
  obj: {
    iata: 'IAG',
    iso: 'US',
    coordinates: '-78.94619750976562, 43.1072998046875',
    municipality: 'Niagara Falls'
  }
}, {
  label: 'Diori Hamani International Airport (NIM) - NE',
  id: 'NIM',
  obj: {
    iata: 'NIM',
    iso: 'NE',
    coordinates: '2.18361, 13.4815',
    municipality: 'Niamey'
  }
}, {
  label: 'Niamtougou International Airport (LRL) - TG',
  id: 'LRL',
  obj: {
    iata: 'LRL',
    iso: 'TG',
    coordinates: '1.091249942779541, 9.767330169677734',
    municipality: 'Niamtougou'
  }
}, {
  label: "Nice-C\u00c3\u00b4te d'Azur Airport (NCE) - FR",
  id: 'NCE',
  obj: {
    iata: 'NCE',
    iso: 'FR',
    coordinates: '7.215869903560001, 43.6584014893',
    municipality: 'Nice'
  }
}, {
  label: 'Ercan International Airport (ECN) - CY',
  id: 'ECN',
  obj: {
    iata: 'ECN',
    iso: 'CY',
    coordinates: '33.49610137939453, 35.154701232910156',
    municipality: 'Nicosia'
  }
}, {
  label: 'Nosara Airport (NOB) - CR',
  id: 'NOB',
  obj: {
    iata: 'NOB',
    iso: 'CR',
    coordinates: '-85.65299987790002, 9.976490020750001',
    municipality: 'Nicoya'
  }
}, {
  label: 'Niigata Airport (KIJ) - JP',
  id: 'KIJ',
  obj: {
    iata: 'KIJ',
    iso: 'JP',
    coordinates: '139.121002197, 37.9558982849',
    municipality: 'Niigata'
  }
}, {
  label: 'Mykolaiv International Airport (NLV) - UA',
  id: 'NLV',
  obj: {
    iata: 'NLV',
    iso: 'UA',
    coordinates: '31.9197998046875, 47.057899475097656',
    municipality: 'Nikolayev'
  }
}, {
  label: 'Nikolayevsk-na-Amure Airport (NLI) - RU',
  id: 'NLI',
  obj: {
    iata: 'NLI',
    iso: 'RU',
    coordinates: '140.649994, 53.154999',
    municipality: 'Nikolayevsk-na-Amure Airport'
  }
}, {
  label: 'Ninglang Luguhu Airport (NLH) - CN',
  id: 'NLH',
  obj: {
    iata: 'NLH',
    iso: 'CN',
    coordinates: '100.7593, 27.5403',
    municipality: 'Ninglang'
  }
}, {
  label: 'Niort-Souch\u00c3\u00a9 Airport (NIT) - FR',
  id: 'NIT',
  obj: {
    iata: 'NIT',
    iso: 'FR',
    coordinates: '-0.394529, 46.313477',
    municipality: 'Niort/Souch\u00c3\u00a9'
  }
}, {
  label: 'Nis Airport (INI) - RS',
  id: 'INI',
  obj: {
    iata: 'INI',
    iso: 'RS',
    coordinates: '21.853701, 43.337299',
    municipality: 'Nis'
  }
}, {
  label: 'Begishevo Airport (NBC) - RU',
  id: 'NBC',
  obj: {
    iata: 'NBC',
    iso: 'RU',
    coordinates: '52.092498779296875, 55.564701080322266',
    municipality: 'Nizhnekamsk'
  }
}, {
  label: 'Nizhnevartovsk Airport (NJC) - RU',
  id: 'NJC',
  obj: {
    iata: 'NJC',
    iso: 'RU',
    coordinates: '76.48359680175781, 60.94929885864258',
    municipality: 'Nizhnevartovsk'
  }
}, {
  label: 'Nizhny Novgorod Strigino International Airport (GOJ) - RU',
  id: 'GOJ',
  obj: {
    iata: 'GOJ',
    iso: 'RU',
    coordinates: '43.784000396729, 56.230098724365',
    municipality: 'Nizhny Novgorod'
  }
}, {
  label: 'Noatak Airport (WTK) - US',
  id: 'WTK',
  obj: {
    iata: 'WTK',
    iso: 'US',
    coordinates: '-162.97500610351562, 67.56610107421875',
    municipality: 'Noatak'
  }
}, {
  label: 'Nogales International Airport (OLS) - US',
  id: 'OLS',
  obj: {
    iata: 'OLS',
    iso: 'US',
    coordinates: '-110.848, 31.4177',
    municipality: 'Nogales'
  }
}, {
  label: 'Nome Airport (OME) - US',
  id: 'OME',
  obj: {
    iata: 'OME',
    iso: 'US',
    coordinates: '-165.44500732421875, 64.51219940185547',
    municipality: 'Nome'
  }
}, {
  label: 'Norfolk Naval Station (Chambers Field) (NGU) - US',
  id: 'NGU',
  obj: {
    iata: 'NGU',
    iso: 'US',
    coordinates: '-76.289299, 36.937599',
    municipality: 'Norfolk'
  }
}, {
  label: 'Karl Stefan Memorial Airport (OFK) - US',
  id: 'OFK',
  obj: {
    iata: 'OFK',
    iso: 'US',
    coordinates: '-97.435096740723, 41.985500335693',
    municipality: 'Norfolk'
  }
}, {
  label: 'Norfolk International Airport (ORF) - US',
  id: 'ORF',
  obj: {
    iata: 'ORF',
    iso: 'US',
    coordinates: '-76.20120239257812, 36.89459991455078',
    municipality: 'Norfolk'
  }
}, {
  label: 'Norilsk-Alykel Airport (NSK) - RU',
  id: 'NSK',
  obj: {
    iata: 'NSK',
    iso: 'RU',
    coordinates: '87.33219909667969, 69.31109619140625',
    municipality: 'Norilsk'
  }
}, {
  label: 'Norman Wells Airport (YVQ) - CA',
  id: 'YVQ',
  obj: {
    iata: 'YVQ',
    iso: 'CA',
    coordinates: '-126.7979965209961, 65.28160095214844',
    municipality: 'Norman Wells'
  }
}, {
  label: 'Normanton Airport (NTN) - AU',
  id: 'NTN',
  obj: {
    iata: 'NTN',
    iso: 'AU',
    coordinates: '141.069664, -17.68409',
    municipality: 'Normanton'
  }
}, {
  label: 'Norrk\u00c3\u00b6ping Airport (NRK) - SE',
  id: 'NRK',
  obj: {
    iata: 'NRK',
    iso: 'SE',
    coordinates: '16.250600814819336, 58.586299896240234',
    municipality: 'Norrk\u00c3\u00b6ping'
  }
}, {
  label: 'North Battleford Airport (YQW) - CA',
  id: 'YQW',
  obj: {
    iata: 'YQW',
    iso: 'CA',
    coordinates: '-108.24400329589844, 52.76919937133789',
    municipality: 'North Battleford'
  }
}, {
  label: 'North Bay Jack Garland Airport (YYB) - CA',
  id: 'YYB',
  obj: {
    iata: 'YYB',
    iso: 'CA',
    coordinates: '-79.422798, 46.363602',
    municipality: 'North Bay'
  }
}, {
  label: 'Southwest Oregon Regional Airport (OTH) - US',
  id: 'OTH',
  obj: {
    iata: 'OTH',
    iso: 'US',
    coordinates: '-124.24600219726562, 43.41709899902344',
    municipality: 'North Bend'
  }
}, {
  label: 'North Eleuthera Airport (ELH) - BS',
  id: 'ELH',
  obj: {
    iata: 'ELH',
    iso: 'BS',
    coordinates: '-76.6835021973, 25.474899292',
    municipality: 'North Eleuthera'
  }
}, {
  label: 'Quonset State Airport (NCO) - US',
  id: 'NCO',
  obj: {
    iata: 'NCO',
    iso: 'US',
    coordinates: '-71.412101745605, 41.597099304199',
    municipality: 'North Kingstown'
  }
}, {
  label: 'Grand Strand Airport (CRE) - US',
  id: 'CRE',
  obj: {
    iata: 'CRE',
    iso: 'US',
    coordinates: '-78.72389984130001, 33.8116989136',
    municipality: 'North Myrtle Beach'
  }
}, {
  label: 'North Platte Regional Airport Lee Bird Field (LBF) - US',
  id: 'LBF',
  obj: {
    iata: 'LBF',
    iso: 'US',
    coordinates: '-100.6839981, 41.12620163',
    municipality: 'North Platte'
  }
}, {
  label: 'Northway Airport (ORT) - US',
  id: 'ORT',
  obj: {
    iata: 'ORT',
    iso: 'US',
    coordinates: '-141.9290009, 62.9612999',
    municipality: 'Northway'
  }
}, {
  label: 'Norway House Airport (YNE) - CA',
  id: 'YNE',
  obj: {
    iata: 'YNE',
    iso: 'CA',
    coordinates: '-97.84420013427734, 53.95830154418945',
    municipality: 'Norway House'
  }
}, {
  label: 'Norwich International Airport (NWI) - GB',
  id: 'NWI',
  obj: {
    iata: 'NWI',
    iso: 'GB',
    coordinates: '1.28278005123, 52.6758003235',
    municipality: 'Norwich'
  }
}, {
  label: 'Norwood Memorial Airport (OWD) - US',
  id: 'OWD',
  obj: {
    iata: 'OWD',
    iso: 'US',
    coordinates: '-71.1728973389, 42.1904983521',
    municipality: 'Norwood'
  }
}, {
  label: 'Fascene Airport (NOS) - MG',
  id: 'NOS',
  obj: {
    iata: 'NOS',
    iso: 'MG',
    coordinates: '48.3148002625, -13.3121004105',
    municipality: 'Nosy Be'
  }
}, {
  label: 'Notodden Airport (NTB) - NO',
  id: 'NTB',
  obj: {
    iata: 'NTB',
    iso: 'NO',
    coordinates: '9.21222, 59.565701',
    municipality: 'Notodden'
  }
}, {
  label: 'Nottingham Airport (NQT) - GB',
  id: 'NQT',
  obj: {
    iata: 'NQT',
    iso: 'GB',
    coordinates: '-1.0791699886322021, 52.91999816894531',
    municipality: 'Nottingham'
  }
}, {
  label: 'East Midlands Airport (EMA) - GB',
  id: 'EMA',
  obj: {
    iata: 'EMA',
    iso: 'GB',
    coordinates: '-1.32806003094, 52.8311004639',
    municipality: 'Nottingham'
  }
}, {
  label: 'Nouadhibou International Airport (NDB) - MR',
  id: 'NDB',
  obj: {
    iata: 'NDB',
    iso: 'MR',
    coordinates: '-17.030000686645508, 20.9330997467041',
    municipality: 'Nouadhibou'
  }
}, {
  label: 'Nouakchott\u00e2\u0080\u0093Oumtounsy International Airport (NKC) - MR',
  id: 'NKC',
  obj: {
    iata: 'NKC',
    iso: 'MR',
    coordinates: '-15.9697222, 18.31',
    municipality: 'Nouakchott'
  }
}, {
  label: 'Noum\u00c3\u00a9a Magenta Airport (GEA) - NC',
  id: 'GEA',
  obj: {
    iata: 'GEA',
    iso: 'NC',
    coordinates: '166.47300720214844, -22.25830078125',
    municipality: 'Noum\u00c3\u00a9a'
  }
}, {
  label: 'La Tontouta International Airport (NOU) - NC',
  id: 'NOU',
  obj: {
    iata: 'NOU',
    iso: 'NC',
    coordinates: '166.21299743652344, -22.01460075378418',
    municipality: 'Noum\u00c3\u00a9a'
  }
}, {
  label: 'Spichenkovo Airport (NOZ) - RU',
  id: 'NOZ',
  obj: {
    iata: 'NOZ',
    iso: 'RU',
    coordinates: '86.877197, 53.811401',
    municipality: 'Novokuznetsk'
  }
}, {
  label: 'Tolmachevo Airport (OVB) - RU',
  id: 'OVB',
  obj: {
    iata: 'OVB',
    iso: 'RU',
    coordinates: '82.650703430176, 55.012599945068',
    municipality: 'Novosibirsk'
  }
}, {
  label: 'Novy Urengoy Airport (NUX) - RU',
  id: 'NUX',
  obj: {
    iata: 'NUX',
    iso: 'RU',
    coordinates: '76.52030181884766, 66.06939697265625',
    municipality: 'Novy Urengoy'
  }
}, {
  label: 'Noyabrsk Airport (NOJ) - RU',
  id: 'NOJ',
  obj: {
    iata: 'NOJ',
    iso: 'RU',
    coordinates: '75.2699966430664, 63.18330001831055',
    municipality: 'Noyabrsk'
  }
}, {
  label: 'Rafael Cabrera Airport (GER) - CU',
  id: 'GER',
  obj: {
    iata: 'GER',
    iso: 'CU',
    coordinates: '-82.78379821777344, 21.834699630737305',
    municipality: 'Nueva Gerona'
  }
}, {
  label: 'Quetzalc\u00c3\u00b3atl International Airport (NLD) - MX',
  id: 'NLD',
  obj: {
    iata: 'NLD',
    iso: 'MX',
    coordinates: '-99.5705032349, 27.4438991547',
    municipality: 'Nuevo Laredo'
  }
}, {
  label: 'Nuiqsut Airport (NUI) - US',
  id: 'NUI',
  obj: {
    iata: 'NUI',
    iso: 'US',
    coordinates: '-151.005996704, 70.2099990845',
    municipality: 'Nuiqsut'
  }
}, {
  label: "Fua'amotu International Airport (TBU) - TO",
  id: 'TBU',
  obj: {
    iata: 'TBU',
    iso: 'TO',
    coordinates: '-175.14999389648438, -21.241199493408203',
    municipality: "Nuku'alofa"
  }
}, {
  label: 'Nuremberg Airport (NUE) - DE',
  id: 'NUE',
  obj: {
    iata: 'NUE',
    iso: 'DE',
    coordinates: '11.078056, 49.498699',
    municipality: 'Nuremberg'
  }
}, {
  label: 'Godthaab / Nuuk Airport (GOH) - GL',
  id: 'GOH',
  obj: {
    iata: 'GOH',
    iso: 'GL',
    coordinates: '-51.6781005859, 64.19090271',
    municipality: 'Nuuk'
  }
}, {
  label: 'Nyagan Airport (NYA) - RU',
  id: 'NYA',
  obj: {
    iata: 'NYA',
    iso: 'RU',
    coordinates: '65.614998, 62.110001',
    municipality: 'Nyagan'
  }
}, {
  label: 'Naples International Airport (NAP) - IT',
  id: 'NAP',
  obj: {
    iata: 'NAP',
    iso: 'IT',
    coordinates: '14.2908, 40.886002',
    municipality: 'N\u00c3\u00a1poli'
  }
}, {
  label: 'N\u00c3\u00aemes-Arles-Camargue Airport (FNI) - FR',
  id: 'FNI',
  obj: {
    iata: 'FNI',
    iso: 'FR',
    coordinates: '4.4163498878479, 43.75740051269531',
    municipality: 'N\u00c3\u00aemes/Garons'
  }
}, {
  label: 'Whidbey Island Naval Air Station (Ault Field) (NUW) - US',
  id: 'NUW',
  obj: {
    iata: 'NUW',
    iso: 'US',
    coordinates: '-122.655998, 48.351799',
    municipality: 'Oak Harbor'
  }
}, {
  label: 'Metropolitan Oakland International Airport (OAK) - US',
  id: 'OAK',
  obj: {
    iata: 'OAK',
    iso: 'US',
    coordinates: '-122.221001, 37.721298',
    municipality: 'Oakland'
  }
}, {
  label: 'Xoxocotl\u00c3\u00a1n International Airport (OAX) - MX',
  id: 'OAX',
  obj: {
    iata: 'OAX',
    iso: 'MX',
    coordinates: '-96.726600647, 16.9999008179',
    municipality: 'Oaxaca'
  }
}, {
  label: 'Tokachi-Obihiro Airport (OBO) - JP',
  id: 'OBO',
  obj: {
    iata: 'OBO',
    iso: 'JP',
    coordinates: '143.216995239, 42.7332992554',
    municipality: 'Obihiro'
  }
}, {
  label: 'Aguas Claras Airport (OCV) - CO',
  id: 'OCV',
  obj: {
    iata: 'OCV',
    iso: 'CO',
    coordinates: '-73.3583, 8.31506',
    municipality: 'Oca\u00c3\u00b1a'
  }
}, {
  label: 'Boscobel Aerodrome (OCJ) - JM',
  id: 'OCJ',
  obj: {
    iata: 'OCJ',
    iso: 'JM',
    coordinates: '-76.96900177001953, 18.404199600219727',
    municipality: 'Ocho Rios'
  }
}, {
  label: 'Odate Noshiro Airport (ONJ) - JP',
  id: 'ONJ',
  obj: {
    iata: 'ONJ',
    iso: 'JP',
    coordinates: '140.371002197, 40.1918983459',
    municipality: 'Odate'
  }
}, {
  label: 'Odense Airport (ODE) - DK',
  id: 'ODE',
  obj: {
    iata: 'ODE',
    iso: 'DK',
    coordinates: '10.330900192260742, 55.47669982910156',
    municipality: 'Odense'
  }
}, {
  label: 'Odessa International Airport (ODS) - UA',
  id: 'ODS',
  obj: {
    iata: 'ODS',
    iso: 'UA',
    coordinates: '30.67650032043457, 46.42679977416992',
    municipality: 'Odessa'
  }
}, {
  label: 'RAF Odiham (ODH) - GB',
  id: 'ODH',
  obj: {
    iata: 'ODH',
    iso: 'GB',
    coordinates: '-0.94282501936, 51.2341003418',
    municipality: 'Odiham'
  }
}, {
  label: 'Rota Do S\u00c3\u00a2ndalo Oecusse Airport (OEC) - TL',
  id: 'OEC',
  obj: {
    iata: 'OEC',
    iso: 'TL',
    coordinates: '124.343002, -9.19806',
    municipality: 'Oecussi-Ambeno'
  }
}, {
  label: 'Hill Air Force Base (HIF) - US',
  id: 'HIF',
  obj: {
    iata: 'HIF',
    iso: 'US',
    coordinates: '-111.973086, 41.12403',
    municipality: 'Ogden'
  }
}, {
  label: 'Ogden Hinckley Airport (OGD) - US',
  id: 'OGD',
  obj: {
    iata: 'OGD',
    iso: 'US',
    coordinates: '-112.0120010376, 41.195899963379',
    municipality: 'Ogden'
  }
}, {
  label: 'Eugene F. Correira International Airport (OGL) - GY',
  id: 'OGL',
  obj: {
    iata: 'OGL',
    iso: 'GY',
    coordinates: '-58.1059, 6.80628',
    municipality: 'Ogle'
  }
}, {
  label: 'Ohrid St. Paul the Apostle Airport (OHD) - MK',
  id: 'OHD',
  obj: {
    iata: 'OHD',
    iso: 'MK',
    coordinates: '20.7423, 41.18',
    municipality: 'Ohrid'
  }
}, {
  label: 'Oiapoque Airport (OYK) - BR',
  id: 'OYK',
  obj: {
    iata: 'OYK',
    iso: 'BR',
    coordinates: '-51.79690170288086, 3.85548996925354',
    municipality: 'Oiapoque'
  }
}, {
  label: 'Oita Airport (OIT) - JP',
  id: 'OIT',
  obj: {
    iata: 'OIT',
    iso: 'JP',
    coordinates: '131.736999512, 33.479400634799994',
    municipality: 'Oita'
  }
}, {
  label: 'Kosrae International Airport (KSA) - FM',
  id: 'KSA',
  obj: {
    iata: 'KSA',
    iso: 'FM',
    coordinates: '162.957993, 5.35698',
    municipality: 'Okat'
  }
}, {
  label: 'Okayama Momotaro Airport (OKJ) - JP',
  id: 'OKJ',
  obj: {
    iata: 'OKJ',
    iso: 'JP',
    coordinates: '133.854996, 34.756901',
    municipality: 'Okayama'
  }
}, {
  label: 'Okhotsk Airport (OHO) - RU',
  id: 'OHO',
  obj: {
    iata: 'OHO',
    iso: 'RU',
    coordinates: '143.05650329589844, 59.410064697265625',
    municipality: 'Okhotsk'
  }
}, {
  label: 'Okierabu Airport (OKE) - JP',
  id: 'OKE',
  obj: {
    iata: 'OKE',
    iso: 'JP',
    coordinates: '128.701004028, 27.4255008698',
    municipality: 'Okinoerabujima'
  }
}, {
  label: 'Oki Global Geopark Airport (OKI) - JP',
  id: 'OKI',
  obj: {
    iata: 'OKI',
    iso: 'JP',
    coordinates: '133.323566, 36.178388',
    municipality: 'Okinoshima'
  }
}, {
  label: 'Will Rogers World Airport (OKC) - US',
  id: 'OKC',
  obj: {
    iata: 'OKC',
    iso: 'US',
    coordinates: '-97.60070037841797, 35.39310073852539',
    municipality: 'Oklahoma City'
  }
}, {
  label: 'Tinker Air Force Base (TIK) - US',
  id: 'TIK',
  obj: {
    iata: 'TIK',
    iso: 'US',
    coordinates: '-97.386596679688, 35.414699554443',
    municipality: 'Oklahoma City'
  }
}, {
  label: 'Okondja Airport (OKN) - GA',
  id: 'OKN',
  obj: {
    iata: 'OKN',
    iso: 'GA',
    coordinates: '13.673100471496582, -0.6652140021324158',
    municipality: 'Okondja'
  }
}, {
  label: 'Okushiri Airport (OIR) - JP',
  id: 'OIR',
  obj: {
    iata: 'OIR',
    iso: 'JP',
    coordinates: '139.432998657, 42.0717010498',
    municipality: 'Okushiri Island'
  }
}, {
  label: 'Olbia Costa Smeralda Airport (OLB) - IT',
  id: 'OLB',
  obj: {
    iata: 'OLB',
    iso: 'IT',
    coordinates: '9.51763, 40.898701',
    municipality: 'Olbia (SS)'
  }
}, {
  label: 'Old Crow Airport (YOC) - CA',
  id: 'YOC',
  obj: {
    iata: 'YOC',
    iso: 'CA',
    coordinates: '-139.83900451660156, 67.57060241699219',
    municipality: 'Old Crow'
  }
}, {
  label: 'Subic Bay International Airport (SFS) - PH',
  id: 'SFS',
  obj: {
    iata: 'SFS',
    iso: 'PH',
    coordinates: '120.27100372314453, 14.794400215148926',
    municipality: 'Olongapo City'
  }
}, {
  label: 'Olsztyn-Mazury Airport (SZY) - PL',
  id: 'SZY',
  obj: {
    iata: 'SZY',
    iso: 'PL',
    coordinates: '20.9377, 53.481899',
    municipality: 'Olsztyn'
  }
}, {
  label: 'Olympia Regional Airport (OLM) - US',
  id: 'OLM',
  obj: {
    iata: 'OLM',
    iso: 'US',
    coordinates: '-122.9029999, 46.9693985',
    municipality: 'Olympia'
  }
}, {
  label: 'Olyokminsk Airport (OLZ) - RU',
  id: 'OLZ',
  obj: {
    iata: 'OLZ',
    iso: 'RU',
    coordinates: '120.471001, 60.397499',
    municipality: 'Olyokminsk'
  }
}, {
  label: 'Offutt Air Force Base (OFF) - US',
  id: 'OFF',
  obj: {
    iata: 'OFF',
    iso: 'US',
    coordinates: '-95.912498474121, 41.118301391602',
    municipality: 'Omaha'
  }
}, {
  label: 'Eppley Airfield (OMA) - US',
  id: 'OMA',
  obj: {
    iata: 'OMA',
    iso: 'US',
    coordinates: '-95.894096, 41.3032',
    municipality: 'Omaha'
  }
}, {
  label: 'Omboue Hopital Airport (OMB) - GA',
  id: 'OMB',
  obj: {
    iata: 'OMB',
    iso: 'GA',
    coordinates: '9.262689590454102, -1.5747300386428833',
    municipality: 'Omboue'
  }
}, {
  label: 'Ibaraki Airport / JASDF Hyakuri Air Base (IBR) - JP',
  id: 'IBR',
  obj: {
    iata: 'IBR',
    iso: 'JP',
    coordinates: '140.414993, 36.181099',
    municipality: 'Omitama'
  }
}, {
  label: 'Omsk Central Airport (OMS) - RU',
  id: 'OMS',
  obj: {
    iata: 'OMS',
    iso: 'RU',
    coordinates: '73.31050109863281, 54.96699905395508',
    municipality: 'Omsk'
  }
}, {
  label: 'Ondangwa Airport (OND) - NA',
  id: 'OND',
  obj: {
    iata: 'OND',
    iso: 'NA',
    coordinates: '15.9526, -17.878201',
    municipality: 'Ondangwa'
  }
}, {
  label: 'Ontario International Airport (ONT) - US',
  id: 'ONT',
  obj: {
    iata: 'ONT',
    iso: 'US',
    coordinates: '-117.60099792480469, 34.055999755859375',
    municipality: 'Ontario'
  }
}, {
  label: 'Oradea International Airport (OMR) - RO',
  id: 'OMR',
  obj: {
    iata: 'OMR',
    iso: 'RO',
    coordinates: '21.90250015258789, 47.025299072265625',
    municipality: 'Oradea'
  }
}, {
  label: 'Es Senia Airport (ORN) - DZ',
  id: 'ORN',
  obj: {
    iata: 'ORN',
    iso: 'DZ',
    coordinates: '-0.6211829781529999, 35.6239013672',
    municipality: 'Oran'
  }
}, {
  label: 'Orange Airport (OAG) - AU',
  id: 'OAG',
  obj: {
    iata: 'OAG',
    iso: 'AU',
    coordinates: '149.132995605, -33.3816986084',
    municipality: 'Orange'
  }
}, {
  label: 'Orange-Caritat (BA 115) Air Base (XOG) - FR',
  id: 'XOG',
  obj: {
    iata: 'XOG',
    iso: 'FR',
    coordinates: '4.866720199584961, 44.140499114990234',
    municipality: 'Orange/Caritat'
  }
}, {
  label: 'Orangeburg Municipal Airport (OGB) - US',
  id: 'OGB',
  obj: {
    iata: 'OGB',
    iso: 'US',
    coordinates: '-80.859497070312, 33.456798553467',
    municipality: 'Orangeburg'
  }
}, {
  label: 'Oranjemund Airport (OMD) - NA',
  id: 'OMD',
  obj: {
    iata: 'OMD',
    iso: 'NA',
    coordinates: '16.446699, -28.5847',
    municipality: 'Oranjemund'
  }
}, {
  label: 'Queen Beatrix International Airport (AUA) - AW',
  id: 'AUA',
  obj: {
    iata: 'AUA',
    iso: 'AW',
    coordinates: '-70.015198, 12.5014',
    municipality: 'Oranjestad'
  }
}, {
  label: 'Lanyu Airport (KYD) - TW',
  id: 'KYD',
  obj: {
    iata: 'KYD',
    iso: 'TW',
    coordinates: '121.53500366210938, 22.027000427246094',
    municipality: 'Orchid Island'
  }
}, {
  label: 'Ordos Ejin Horo Airport (DSN) - CN',
  id: 'DSN',
  obj: {
    iata: 'DSN',
    iso: 'CN',
    coordinates: '109.861388889, 39.49',
    municipality: 'Ordos'
  }
}, {
  label: 'Oryol Yuzhny Airport (OEL) - RU',
  id: 'OEL',
  obj: {
    iata: 'OEL',
    iso: 'RU',
    coordinates: '36.0022010803, 52.934700012200004',
    municipality: 'Orel'
  }
}, {
  label: 'Orenburg Central Airport (REN) - RU',
  id: 'REN',
  obj: {
    iata: 'REN',
    iso: 'RU',
    coordinates: '55.45669937133789, 51.795799255371094',
    municipality: 'Orenburg'
  }
}, {
  label: 'Trombetas Airport (TMT) - BR',
  id: 'TMT',
  obj: {
    iata: 'TMT',
    iso: 'BR',
    coordinates: '-56.396800994873, -1.489599943161',
    municipality: 'Oriximin\u00c3\u00a1'
  }
}, {
  label: 'Kirkwall Airport (KOI) - GB',
  id: 'KOI',
  obj: {
    iata: 'KOI',
    iso: 'GB',
    coordinates: '-2.9049999713897705, 58.957801818847656',
    municipality: 'Orkney Islands'
  }
}, {
  label: 'Kissimmee Gateway Airport (ISM) - US',
  id: 'ISM',
  obj: {
    iata: 'ISM',
    iso: 'US',
    coordinates: '-81.4371032715, 28.2898006439',
    municipality: 'Orlando'
  }
}, {
  label: 'Orlando International Airport (MCO) - US',
  id: 'MCO',
  obj: {
    iata: 'MCO',
    iso: 'US',
    coordinates: '-81.30899810791016, 28.429399490356445',
    municipality: 'Orlando'
  }
}, {
  label: 'Orlando Sanford International Airport (SFB) - US',
  id: 'SFB',
  obj: {
    iata: 'SFB',
    iso: 'US',
    coordinates: '-81.23750305175781, 28.777599334716797',
    municipality: 'Orlando'
  }
}, {
  label: 'Orl\u00c3\u00a9ans-Bricy (BA 123) Air Base (ORE) - FR',
  id: 'ORE',
  obj: {
    iata: 'ORE',
    iso: 'FR',
    coordinates: '1.7605600357100002, 47.9878005981',
    municipality: 'Orl\u00c3\u00a9ans/Bricy'
  }
}, {
  label: 'Ormoc Airport (OMC) - PH',
  id: 'OMC',
  obj: {
    iata: 'OMC',
    iso: 'PH',
    coordinates: '124.56500244140625, 11.057999610900879',
    municipality: 'Ormoc City'
  }
}, {
  label: 'Orsk Airport (OSW) - RU',
  id: 'OSW',
  obj: {
    iata: 'OSW',
    iso: 'RU',
    coordinates: '58.59560012817383, 51.0724983215332',
    municipality: 'Orsk'
  }
}, {
  label: 'Juan Mendoza Airport (ORU) - BO',
  id: 'ORU',
  obj: {
    iata: 'ORU',
    iso: 'BO',
    coordinates: '-67.0762023926, -17.962600708',
    municipality: 'Oruro'
  }
}, {
  label: 'Or\u00c3\u00a1n Airport (ORA) - AR',
  id: 'ORA',
  obj: {
    iata: 'ORA',
    iso: 'AR',
    coordinates: '-64.3292007446, -23.1527996063',
    municipality: 'Or\u00c3\u00a1n'
  }
}, {
  label: 'Kansai International Airport (KIX) - JP',
  id: 'KIX',
  obj: {
    iata: 'KIX',
    iso: 'JP',
    coordinates: '135.24400329589844, 34.42729949951172',
    municipality: 'Osaka'
  }
}, {
  label: 'Osaka International Airport (ITM) - JP',
  id: 'ITM',
  obj: {
    iata: 'ITM',
    iso: 'JP',
    coordinates: '135.43800354003906, 34.785499572753906',
    municipality: 'Osaka'
  }
}, {
  label: 'Osh Airport (OSS) - KG',
  id: 'OSS',
  obj: {
    iata: 'OSS',
    iso: 'KG',
    coordinates: '72.793296814, 40.6090011597',
    municipality: 'Osh'
  }
}, {
  label: 'Toronto/Oshawa Executive Airport (YOO) - CA',
  id: 'YOO',
  obj: {
    iata: 'YOO',
    iso: 'CA',
    coordinates: '-78.894997, 43.922798',
    municipality: 'Oshawa'
  }
}, {
  label: 'Wittman Regional Airport (OSH) - US',
  id: 'OSH',
  obj: {
    iata: 'OSH',
    iso: 'US',
    coordinates: '-88.55699920654297, 43.98440170288086',
    municipality: 'Oshkosh'
  }
}, {
  label: 'Osijek Airport (OSI) - HR',
  id: 'OSI',
  obj: {
    iata: 'OSI',
    iso: 'HR',
    coordinates: '18.810199737548828, 45.46269989013672',
    municipality: 'Osijek'
  }
}, {
  label: 'Oslo Gardermoen Airport (OSL) - NO',
  id: 'OSL',
  obj: {
    iata: 'OSL',
    iso: 'NO',
    coordinates: '11.100399971008, 60.193901062012',
    municipality: 'Oslo'
  }
}, {
  label: 'Moss Airport, Rygge (RYG) - NO',
  id: 'RYG',
  obj: {
    iata: 'RYG',
    iso: 'NO',
    coordinates: '10.785439, 59.378817',
    municipality: 'Oslo'
  }
}, {
  label: 'Ca\u00c3\u00b1al Bajo Carlos - Hott Siebert Airport (ZOS) - CL',
  id: 'ZOS',
  obj: {
    iata: 'ZOS',
    iso: 'CL',
    coordinates: '-73.06099700927734, -40.61119842529297',
    municipality: 'Osorno'
  }
}, {
  label: 'Ostend-Bruges International Airport (OST) - BE',
  id: 'OST',
  obj: {
    iata: 'OST',
    iso: 'BE',
    coordinates: '2.8622200489, 51.198898315399994',
    municipality: 'Ostend'
  }
}, {
  label: 'Ostrava Leos Jan\u00c3\u00a1\u00c4\u008dek Airport (OSR) - CZ',
  id: 'OSR',
  obj: {
    iata: 'OSR',
    iso: 'CZ',
    coordinates: '18.111099243164062, 49.6963005065918',
    municipality: 'Ostrava'
  }
}, {
  label: 'Tokyo Haneda International Airport (HND) - JP',
  id: 'HND',
  obj: {
    iata: 'HND',
    iso: 'JP',
    coordinates: '139.779999, 35.552299',
    municipality: 'Ota, Tokyo'
  }
}, {
  label: 'Ottawa Macdonald-Cartier International Airport (YOW) - CA',
  id: 'YOW',
  obj: {
    iata: 'YOW',
    iso: 'CA',
    coordinates: '-75.66919708251953, 45.3224983215332',
    municipality: 'Ottawa'
  }
}, {
  label: 'Ottawa / Rockcliffe Airport (YRO) - CA',
  id: 'YRO',
  obj: {
    iata: 'YRO',
    iso: 'CA',
    coordinates: '-75.64610290530001, 45.4603004456',
    municipality: 'Ottawa'
  }
}, {
  label: 'Ottumwa Regional Airport (OTM) - US',
  id: 'OTM',
  obj: {
    iata: 'OTM',
    iso: 'US',
    coordinates: '-92.44789886, 41.10660172',
    municipality: 'Ottumwa'
  }
}, {
  label: 'Ouagadougou Airport (OUA) - BF',
  id: 'OUA',
  obj: {
    iata: 'OUA',
    iso: 'BF',
    coordinates: '-1.51242, 12.3532',
    municipality: 'Ouagadougou'
  }
}, {
  label: 'Ouani Airport (AJN) - KM',
  id: 'AJN',
  obj: {
    iata: 'AJN',
    iso: 'KM',
    coordinates: '44.430301666259766, -12.131699562072754',
    municipality: 'Ouani'
  }
}, {
  label: 'Ain el Beida Airport (OGX) - DZ',
  id: 'OGX',
  obj: {
    iata: 'OGX',
    iso: 'DZ',
    coordinates: '5.412779808044434, 31.917200088500977',
    municipality: 'Ouargla'
  }
}, {
  label: 'Ouarzazate Airport (OZZ) - MA',
  id: 'OZZ',
  obj: {
    iata: 'OZZ',
    iso: 'MA',
    coordinates: '-6.909430027010001, 30.9391002655',
    municipality: 'Ouarzazate'
  }
}, {
  label: 'Oudtshoorn Airport (OUH) - ZA',
  id: 'OUH',
  obj: {
    iata: 'OUH',
    iso: 'ZA',
    coordinates: '22.188999176, -33.6069984436',
    municipality: 'Oudtshoorn'
  }
}, {
  label: 'Angads Airport (OUD) - MA',
  id: 'OUD',
  obj: {
    iata: 'OUD',
    iso: 'MA',
    coordinates: '-1.92399001121521, 34.787200927734375',
    municipality: 'Oujda'
  }
}, {
  label: 'Oulu Airport (OUL) - FI',
  id: 'OUL',
  obj: {
    iata: 'OUL',
    iso: 'FI',
    coordinates: '25.354600906372, 64.930099487305',
    municipality: 'Oulu / Oulunsalo'
  }
}, {
  label: 'Ouro Sogui Airport (MAX) - SN',
  id: 'MAX',
  obj: {
    iata: 'MAX',
    iso: 'SN',
    coordinates: '-13.3228, 15.5936',
    municipality: 'Ouro Sogui'
  }
}, {
  label: 'Ouv\u00c3\u00a9a Airport (UVE) - NC',
  id: 'UVE',
  obj: {
    iata: 'UVE',
    iso: 'NC',
    coordinates: '166.572998046875, -20.640600204467773',
    municipality: 'Ouv\u00c3\u00a9a'
  }
}, {
  label: 'Owando Airport (FTX) - CG',
  id: 'FTX',
  obj: {
    iata: 'FTX',
    iso: 'CG',
    coordinates: '15.95009994506836, -0.5313500165939331',
    municipality: 'Owando'
  }
}, {
  label: 'Owen Sound / Billy Bishop Regional Airport (YOS) - CA',
  id: 'YOS',
  obj: {
    iata: 'YOS',
    iso: 'CA',
    coordinates: '-80.8375015259, 44.5903015137',
    municipality: 'Owen Sound'
  }
}, {
  label: 'Owensboro Daviess County Airport (OWB) - US',
  id: 'OWB',
  obj: {
    iata: 'OWB',
    iso: 'US',
    coordinates: '-87.16680145, 37.74010086',
    municipality: 'Owensboro'
  }
}, {
  label: 'Sam Mbakwe International Airport (QOW) - NG',
  id: 'QOW',
  obj: {
    iata: 'QOW',
    iso: 'NG',
    coordinates: '7.206029891967773, 5.427060127258301',
    municipality: 'Owerri'
  }
}, {
  label: 'University Oxford Airport (UOX) - US',
  id: 'UOX',
  obj: {
    iata: 'UOX',
    iso: 'US',
    coordinates: '-89.536796569824, 34.384300231934',
    municipality: 'Oxford'
  }
}, {
  label: 'Oxford House Airport (YOH) - CA',
  id: 'YOH',
  obj: {
    iata: 'YOH',
    iso: 'CA',
    coordinates: '-95.27890014648438, 54.93330001831055',
    municipality: 'Oxford House'
  }
}, {
  label: 'Oxnard Airport (OXR) - US',
  id: 'OXR',
  obj: {
    iata: 'OXR',
    iso: 'US',
    coordinates: '-119.20700073242, 34.200801849365',
    municipality: 'Oxnard'
  }
}, {
  label: 'Oyem Airport (OYE) - GA',
  id: 'OYE',
  obj: {
    iata: 'OYE',
    iso: 'GA',
    coordinates: '11.581399917602539, 1.5431100130081177',
    municipality: 'Oyem'
  }
}, {
  label: 'Oyo Ollombo Airport (OLL) - CG',
  id: 'OLL',
  obj: {
    iata: 'OLL',
    iso: 'CG',
    coordinates: '15.91, -1.226666',
    municipality: 'Oyo'
  }
}, {
  label: 'Labo Airport (OZC) - PH',
  id: 'OZC',
  obj: {
    iata: 'OZC',
    iso: 'PH',
    coordinates: '123.84200286865234, 8.178509712219238',
    municipality: 'Ozamiz City'
  }
}, {
  label: 'Aek Godang Airport (AEG) - ID',
  id: 'AEG',
  obj: {
    iata: 'AEG',
    iso: 'ID',
    coordinates: '99.430496, 1.4001',
    municipality: 'Padang Sidempuan-Sumatra Island'
  }
}, {
  label: 'Paderborn Lippstadt Airport (PAD) - DE',
  id: 'PAD',
  obj: {
    iata: 'PAD',
    iso: 'DE',
    coordinates: '8.616319656369999, 51.614101409899995',
    municipality: 'Paderborn'
  }
}, {
  label: 'Padova Airport (QPA) - IT',
  id: 'QPA',
  obj: {
    iata: 'QPA',
    iso: 'IT',
    coordinates: '11.8479, 45.395802',
    municipality: 'Padova'
  }
}, {
  label: 'Barkley Regional Airport (PAH) - US',
  id: 'PAH',
  obj: {
    iata: 'PAH',
    iso: 'US',
    coordinates: '-88.7738037109375, 37.06079864501953',
    municipality: 'Paducah'
  }
}, {
  label: 'Pagadian Airport (PAG) - PH',
  id: 'PAG',
  obj: {
    iata: 'PAG',
    iso: 'PH',
    coordinates: '123.461179733, 7.83073144787',
    municipality: 'Pagadian City'
  }
}, {
  label: 'Page Municipal Airport (PGA) - US',
  id: 'PGA',
  obj: {
    iata: 'PGA',
    iso: 'US',
    coordinates: '-111.447998, 36.92610168',
    municipality: 'Page'
  }
}, {
  label: 'Pago Pago International Airport (PPG) - AS',
  id: 'PPG',
  obj: {
    iata: 'PPG',
    iso: 'AS',
    coordinates: '-170.710006714, -14.3310003281',
    municipality: 'Pago Pago'
  }
}, {
  label: 'Pakse International Airport (PKZ) - LA',
  id: 'PKZ',
  obj: {
    iata: 'PKZ',
    iso: 'LA',
    coordinates: '105.78099822998047, 15.132100105285645',
    municipality: 'Pakse'
  }
}, {
  label: 'Palanga International Airport (PLQ) - LT',
  id: 'PLQ',
  obj: {
    iata: 'PLQ',
    iso: 'LT',
    coordinates: '21.093900680541992, 55.973201751708984',
    municipality: 'Palanga'
  }
}, {
  label: 'Sultan Mahmud Badaruddin II Airport (PLM) - ID',
  id: 'PLM',
  obj: {
    iata: 'PLM',
    iso: 'ID',
    coordinates: '104.69999694824, -2.8982501029968',
    municipality: 'Palembang-Sumatra Island'
  }
}, {
  label: 'Falcone\u00e2\u0080\u0093Borsellino Airport (PMO) - IT',
  id: 'PMO',
  obj: {
    iata: 'PMO',
    iso: 'IT',
    coordinates: '13.091, 38.175999',
    municipality: 'Palermo'
  }
}, {
  label: 'Palm Springs International Airport (PSP) - US',
  id: 'PSP',
  obj: {
    iata: 'PSP',
    iso: 'US',
    coordinates: '-116.50700378417969, 33.8297004699707',
    municipality: 'Palm Springs'
  }
}, {
  label: 'Jacqueline Cochran Regional Airport (TRM) - US',
  id: 'TRM',
  obj: {
    iata: 'TRM',
    iso: 'US',
    coordinates: '-116.16000366211, 33.62670135498',
    municipality: 'Palm Springs'
  }
}, {
  label: 'Palma De Mallorca Airport (PMI) - ES',
  id: 'PMI',
  obj: {
    iata: 'PMI',
    iso: 'ES',
    coordinates: '2.73881006241, 39.551700592',
    municipality: 'Palma De Mallorca'
  }
}, {
  label: 'Palmar Sur Airport (PMZ) - CR',
  id: 'PMZ',
  obj: {
    iata: 'PMZ',
    iso: 'CR',
    coordinates: '-83.46859741210938, 8.951029777526855',
    municipality: 'Palmar Sur'
  }
}, {
  label: 'Palmarito Airport (PTM) - VE',
  id: 'PTM',
  obj: {
    iata: 'PTM',
    iso: 'VE',
    coordinates: '-70.18329620361328, 7.566669940948486',
    municipality: 'Palmarito'
  }
}, {
  label: 'Brigadeiro Lysias Rodrigues Airport (PMW) - BR',
  id: 'PMW',
  obj: {
    iata: 'PMW',
    iso: 'BR',
    coordinates: '-48.35699844359999, -10.291500091600001',
    municipality: 'Palmas'
  }
}, {
  label: 'Palmdale Regional/USAF Plant 42 Airport (PMD) - US',
  id: 'PMD',
  obj: {
    iata: 'PMD',
    iso: 'US',
    coordinates: '-118.0849991, 34.62939835',
    municipality: 'Palmdale'
  }
}, {
  label: 'Warren "Bud" Woods Palmer Municipal Airport (PAQ) - US',
  id: 'PAQ',
  obj: {
    iata: 'PAQ',
    iso: 'US',
    coordinates: '-149.08901, 61.594898',
    municipality: 'Palmer'
  }
}, {
  label: 'Mutiara Airport (PLW) - ID',
  id: 'PLW',
  obj: {
    iata: 'PLW',
    iso: 'ID',
    coordinates: '119.91000366210938, -0.9185420274734497',
    municipality: 'Palu-Celebes Island'
  }
}, {
  label: 'Pamplona Airport (PNA) - ES',
  id: 'PNA',
  obj: {
    iata: 'PNA',
    iso: 'ES',
    coordinates: '-1.6463299989700317, 42.77000045776367',
    municipality: 'Pamplona'
  }
}, {
  label: 'Tyndall Air Force Base (PAM) - US',
  id: 'PAM',
  obj: {
    iata: 'PAM',
    iso: 'US',
    coordinates: '-85.57540130619999, 30.0695991516',
    municipality: 'Panama City'
  }
}, {
  label: 'Northwest Florida Beaches International Airport (ECP) - US',
  id: 'ECP',
  obj: {
    iata: 'ECP',
    iso: 'US',
    coordinates: '-85.795414, 30.357106',
    municipality: 'Panama City Beach'
  }
}, {
  label: 'Panev\u00c4\u0097\u00c5\u00beys Air Base (PNV) - LT',
  id: 'PNV',
  obj: {
    iata: 'PNV',
    iso: 'LT',
    coordinates: '24.460800170898438, 55.729400634765625',
    municipality: 'Panev\u00c4\u0097\u00c5\u00beys'
  }
}, {
  label: 'Pangnirtung Airport (YXP) - CA',
  id: 'YXP',
  obj: {
    iata: 'YXP',
    iso: 'CA',
    coordinates: '-65.71360015869999, 66.1449966431',
    municipality: 'Pangnirtung'
  }
}, {
  label: 'Panjgur Airport (PJG) - PK',
  id: 'PJG',
  obj: {
    iata: 'PJG',
    iso: 'PK',
    coordinates: '64.13249969482422, 26.954500198364258',
    municipality: 'Panjgur'
  }
}, {
  label: 'Pantelleria Airport (PNL) - IT',
  id: 'PNL',
  obj: {
    iata: 'PNL',
    iso: 'IT',
    coordinates: '11.9689, 36.816502',
    municipality: 'Pantelleria (TP)'
  }
}, {
  label: 'Pantnagar Airport (PGH) - IN',
  id: 'PGH',
  obj: {
    iata: 'PGH',
    iso: 'IN',
    coordinates: '79.473701, 29.0334',
    municipality: 'Pantnagar'
  }
}, {
  label: "Bao'anying Airport (PZI) - CN",
  id: 'PZI',
  obj: {
    iata: 'PZI',
    iso: 'CN',
    coordinates: '101.79852, 26.54',
    municipality: 'Panzhihua'
  }
}, {
  label: "Faa'a International Airport (PPT) - PF",
  id: 'PPT',
  obj: {
    iata: 'PPT',
    iso: 'PF',
    coordinates: '-149.606995, -17.553699',
    municipality: 'Papeete'
  }
}, {
  label: 'Paphos International Airport (PFO) - CY',
  id: 'PFO',
  obj: {
    iata: 'PFO',
    iso: 'CY',
    coordinates: '32.48569869995117, 34.71799850463867',
    municipality: 'Paphos'
  }
}, {
  label: 'Paraburdoo Airport (PBO) - AU',
  id: 'PBO',
  obj: {
    iata: 'PBO',
    iso: 'AU',
    coordinates: '117.745002747, -23.1711006165',
    municipality: 'Paraburdoo'
  }
}, {
  label: 'Josefa Camejo International Airport (LSP) - VE',
  id: 'LSP',
  obj: {
    iata: 'LSP',
    iso: 'VE',
    coordinates: '-70.15149688720703, 11.78077507019043',
    municipality: 'Paraguan\u00c3\u00a1'
  }
}, {
  label: 'General Urquiza Airport (PRA) - AR',
  id: 'PRA',
  obj: {
    iata: 'PRA',
    iso: 'AR',
    coordinates: '-60.4804, -31.7948',
    municipality: 'Parana'
  }
}, {
  label: 'Caraj\u00c3\u00a1s Airport (CKS) - BR',
  id: 'CKS',
  obj: {
    iata: 'CKS',
    iso: 'BR',
    coordinates: '-50.0013885498, -6.11527776718',
    municipality: 'Parauapebas'
  }
}, {
  label: 'Pardubice Airport (PED) - CZ',
  id: 'PED',
  obj: {
    iata: 'PED',
    iso: 'CZ',
    coordinates: '15.73859977722168, 50.01340103149414',
    municipality: 'Pardubice'
  }
}, {
  label: 'Cox Field (PRX) - US',
  id: 'PRX',
  obj: {
    iata: 'PRX',
    iso: 'US',
    coordinates: '-95.450798034668, 33.636600494385',
    municipality: 'Paris'
  }
}, {
  label: 'Paris-Le Bourget Airport (LBG) - FR',
  id: 'LBG',
  obj: {
    iata: 'LBG',
    iso: 'FR',
    coordinates: '2.441390037536621, 48.969398498535156',
    municipality: 'Paris'
  }
}, {
  label: 'Charles de Gaulle International Airport (CDG) - FR',
  id: 'CDG',
  obj: {
    iata: 'CDG',
    iso: 'FR',
    coordinates: '2.55, 49.012798',
    municipality: 'Paris'
  }
}, {
  label: 'Paris-Orly Airport (ORY) - FR',
  id: 'ORY',
  obj: {
    iata: 'ORY',
    iso: 'FR',
    coordinates: '2.3794444, 48.7233333',
    municipality: 'Paris'
  }
}, {
  label: 'Mid Ohio Valley Regional Airport (PKB) - US',
  id: 'PKB',
  obj: {
    iata: 'PKB',
    iso: 'US',
    coordinates: '-81.43920135498047, 39.34510040283203',
    municipality: 'Parkersburg'
  }
}, {
  label: 'Parkes Airport (PKE) - AU',
  id: 'PKE',
  obj: {
    iata: 'PKE',
    iso: 'AU',
    coordinates: '148.238998413, -33.131401062',
    municipality: 'Parkes'
  }
}, {
  label: 'Parma Airport (PMF) - IT',
  id: 'PMF',
  obj: {
    iata: 'PMF',
    iso: 'IT',
    coordinates: '10.2964, 44.824501',
    municipality: 'Parma'
  }
}, {
  label: 'Paro Airport (PBH) - BT',
  id: 'PBH',
  obj: {
    iata: 'PBH',
    iso: 'BT',
    coordinates: '89.42459869380001, 27.403200149499998',
    municipality: 'Paro'
  }
}, {
  label: 'Ninoy Aquino International Airport (MNL) - PH',
  id: 'MNL',
  obj: {
    iata: 'MNL',
    iso: 'PH',
    coordinates: '121.019997, 14.5086',
    municipality: 'Pasay / Para\u00c3\u00b1aque, Metro Manila'
  }
}, {
  label: 'Tri Cities Airport (PSC) - US',
  id: 'PSC',
  obj: {
    iata: 'PSC',
    iso: 'US',
    coordinates: '-119.11900329589844, 46.26470184326172',
    municipality: 'Pasco'
  }
}, {
  label: 'Pasni Airport (PSI) - PK',
  id: 'PSI',
  obj: {
    iata: 'PSI',
    iso: 'PK',
    coordinates: '63.34510040283203, 25.29050064086914',
    municipality: 'Pasni'
  }
}, {
  label: 'Paso Robles Municipal Airport (PRB) - US',
  id: 'PRB',
  obj: {
    iata: 'PRB',
    iso: 'US',
    coordinates: '-120.6269989, 35.67290115',
    municipality: 'Paso Robles'
  }
}, {
  label: 'Paso De Los Libres Airport (AOL) - AR',
  id: 'AOL',
  obj: {
    iata: 'AOL',
    iso: 'AR',
    coordinates: '-57.1521, -29.6894',
    municipality: 'Paso de los Libres'
  }
}, {
  label: 'Lauro Kurtz Airport (PFB) - BR',
  id: 'PFB',
  obj: {
    iata: 'PFB',
    iso: 'BR',
    coordinates: '-52.326599, -28.243999',
    municipality: 'Passo Fundo'
  }
}, {
  label: 'Antonio Narino Airport (PSO) - CO',
  id: 'PSO',
  obj: {
    iata: 'PSO',
    iso: 'CO',
    coordinates: '-77.2915, 1.39625',
    municipality: 'Pasto'
  }
}, {
  label: 'Pathankot Airport (IXP) - IN',
  id: 'IXP',
  obj: {
    iata: 'IXP',
    iso: 'IN',
    coordinates: '75.634444, 32.233611',
    municipality: 'Pathankot'
  }
}, {
  label: 'Lok Nayak Jayaprakash Airport (PAT) - IN',
  id: 'PAT',
  obj: {
    iata: 'PAT',
    iso: 'IN',
    coordinates: '85.0879974365, 25.591299057',
    municipality: 'Patna'
  }
}, {
  label: 'Araxos Airport (GPA) - GR',
  id: 'GPA',
  obj: {
    iata: 'GPA',
    iso: 'GR',
    coordinates: '21.4256, 38.1511',
    municipality: 'Patras'
  }
}, {
  label: 'Patuxent River Naval Air Station (Trapnell Field) (NHK) - US',
  id: 'NHK',
  obj: {
    iata: 'NHK',
    iso: 'US',
    coordinates: '-76.411797, 38.285999',
    municipality: 'Patuxent River'
  }
}, {
  label: 'Pau Pyr\u00c3\u00a9n\u00c3\u00a9es Airport (PUF) - FR',
  id: 'PUF',
  obj: {
    iata: 'PUF',
    iso: 'FR',
    coordinates: '-0.41861099004745483, 43.380001068115234',
    municipality: 'Pau/Pyr\u00c3\u00a9n\u00c3\u00a9es (Uzein)'
  }
}, {
  label: 'Paulatuk (Nora Aliqatchialuk Ruben) Airport (YPC) - CA',
  id: 'YPC',
  obj: {
    iata: 'YPC',
    iso: 'CA',
    coordinates: '-124.075469971, 69.3608381154',
    municipality: 'Paulatuk'
  }
}, {
  label: 'Paulo Afonso Airport (PAV) - BR',
  id: 'PAV',
  obj: {
    iata: 'PAV',
    iso: 'BR',
    coordinates: '-38.250598907471, -9.4008798599243',
    municipality: 'Paulo Afonso'
  }
}, {
  label: 'Pavlodar Airport (PWQ) - KZ',
  id: 'PWQ',
  obj: {
    iata: 'PWQ',
    iso: 'KZ',
    coordinates: '77.07389831542969, 52.19499969482422',
    municipality: 'Pavlodar'
  }
}, {
  label: 'Paz De Ariporo Airport (PZA) - CO',
  id: 'PZA',
  obj: {
    iata: 'PZA',
    iso: 'CO',
    coordinates: '-71.8866, 5.87615',
    municipality: 'Paz De Ariporo'
  }
}, {
  label: 'Peace River Airport (YPE) - CA',
  id: 'YPE',
  obj: {
    iata: 'YPE',
    iso: 'CA',
    coordinates: '-117.446999, 56.226898',
    municipality: 'Peace River'
  }
}, {
  label: 'Peawanuck Airport (YPO) - CA',
  id: 'YPO',
  obj: {
    iata: 'YPO',
    iso: 'CA',
    coordinates: '-85.44329833984375, 54.98809814453125',
    municipality: 'Peawanuck'
  }
}, {
  label: 'Pechora Airport (PEX) - RU',
  id: 'PEX',
  obj: {
    iata: 'PEX',
    iso: 'RU',
    coordinates: '57.13079833984375, 65.12110137939453',
    municipality: 'Pechora'
  }
}, {
  label: 'Comodoro Pedro Zanni Airport (PEH) - AR',
  id: 'PEH',
  obj: {
    iata: 'PEH',
    iso: 'AR',
    coordinates: '-61.8576, -35.8446',
    municipality: 'Pehuaj\u00c3\u00b3'
  }
}, {
  label: 'Sultan Syarif Kasim Ii (Simpang Tiga) Airport (PKU) - ID',
  id: 'PKU',
  obj: {
    iata: 'PKU',
    iso: 'ID',
    coordinates: '101.44499969482422, 0.46078601479530334',
    municipality: 'Pekanbaru-Sumatra Island'
  }
}, {
  label: 'Pellston Regional Airport of Emmet County Airport (PLN) - US',
  id: 'PLN',
  obj: {
    iata: 'PLN',
    iso: 'US',
    coordinates: '-84.79669952, 45.57089996',
    municipality: 'Pellston'
  }
}, {
  label: 'Jo\u00c3\u00a3o Sim\u00c3\u00b5es Lopes Neto International Airport (PET) - BR',
  id: 'PET',
  obj: {
    iata: 'PET',
    iso: 'BR',
    coordinates: '-52.327702, -31.718399',
    municipality: 'Pelotas'
  }
}, {
  label: 'Pemba Airport (POL) - MZ',
  id: 'POL',
  obj: {
    iata: 'POL',
    iso: 'MZ',
    coordinates: '40.52401351928711, -12.991762161254883',
    municipality: 'Pemba / Porto Amelia'
  }
}, {
  label: 'Pembroke Airport (YTA) - CA',
  id: 'YTA',
  obj: {
    iata: 'YTA',
    iso: 'CA',
    coordinates: '-77.25170135498047, 45.86439895629883',
    municipality: 'Pembroke'
  }
}, {
  label: 'Penang International Airport (PEN) - MY',
  id: 'PEN',
  obj: {
    iata: 'PEN',
    iso: 'MY',
    coordinates: '100.2770004272461, 5.297140121459961',
    municipality: 'Penang'
  }
}, {
  label: 'Eastern Oregon Regional At Pendleton Airport (PDT) - US',
  id: 'PDT',
  obj: {
    iata: 'PDT',
    iso: 'US',
    coordinates: '-118.841003418, 45.695098877',
    municipality: 'Pendleton'
  }
}, {
  label: 'Pensacola Naval Air Station/Forrest Sherman Field (NPA) - US',
  id: 'NPA',
  obj: {
    iata: 'NPA',
    iso: 'US',
    coordinates: '-87.31860352, 30.35269928',
    municipality: 'Pensacola'
  }
}, {
  label: 'Pensacola International Airport (PNS) - US',
  id: 'PNS',
  obj: {
    iata: 'PNS',
    iso: 'US',
    coordinates: '-87.1866, 30.4734',
    municipality: 'Pensacola'
  }
}, {
  label: 'Penticton Airport (YYF) - CA',
  id: 'YYF',
  obj: {
    iata: 'YYF',
    iso: 'CA',
    coordinates: '-119.60199737548828, 49.46310043334961',
    municipality: 'Penticton'
  }
}, {
  label: 'Penza Airport (PEZ) - RU',
  id: 'PEZ',
  obj: {
    iata: 'PEZ',
    iso: 'RU',
    coordinates: '45.02109909057617, 53.110599517822266',
    municipality: 'Penza'
  }
}, {
  label: 'General Wayne A. Downing Peoria International Airport (PIA) - US',
  id: 'PIA',
  obj: {
    iata: 'PIA',
    iso: 'US',
    coordinates: '-89.6932983398, 40.664199829100006',
    municipality: 'Peoria'
  }
}, {
  label: 'Mateca\u00c3\u00b1a International Airport (PEI) - CO',
  id: 'PEI',
  obj: {
    iata: 'PEI',
    iso: 'CO',
    coordinates: '-75.7395, 4.81267',
    municipality: 'Pereira'
  }
}, {
  label: 'Perito Moreno Airport (PMQ) - AR',
  id: 'PMQ',
  obj: {
    iata: 'PMQ',
    iso: 'AR',
    coordinates: '-70.978699, -46.537899',
    municipality: 'Perito Moreno'
  }
}, {
  label: 'Bolshoye Savino Airport (PEE) - RU',
  id: 'PEE',
  obj: {
    iata: 'PEE',
    iso: 'RU',
    coordinates: '56.021198272705, 57.914501190186',
    municipality: 'Perm'
  }
}, {
  label: 'Perpignan-Rivesaltes (Llaban\u00c3\u00a8re) Airport (PGF) - FR',
  id: 'PGF',
  obj: {
    iata: 'PGF',
    iso: 'FR',
    coordinates: '2.8706700801849365, 42.74039840698242',
    municipality: 'Perpignan/Rivesaltes'
  }
}, {
  label: 'Perth Jandakot Airport (JAD) - AU',
  id: 'JAD',
  obj: {
    iata: 'JAD',
    iso: 'AU',
    coordinates: '115.88099670410156, -32.09749984741211',
    municipality: 'Perth'
  }
}, {
  label: 'Perth International Airport (PER) - AU',
  id: 'PER',
  obj: {
    iata: 'PER',
    iso: 'AU',
    coordinates: '115.96700286865234, -31.94029998779297',
    municipality: 'Perth'
  }
}, {
  label: 'Grissom Air Reserve Base (GUS) - US',
  id: 'GUS',
  obj: {
    iata: 'GUS',
    iso: 'US',
    coordinates: '-86.1520996094, 40.648101806599996',
    municipality: 'Peru'
  }
}, {
  label: "Perugia San Francesco d'Assisi \u00e2\u0080\u0093 Umbria International Airport (PEG) - IT",
  id: 'PEG',
  obj: {
    iata: 'PEG',
    iso: 'IT',
    coordinates: '12.5132, 43.095901',
    municipality: 'Perugia'
  }
}, {
  label: 'Pescara International Airport (PSR) - IT',
  id: 'PSR',
  obj: {
    iata: 'PSR',
    iso: 'IT',
    coordinates: '14.1811, 42.431702',
    municipality: 'Pescara'
  }
}, {
  label: 'Peshawar International Airport (PEW) - PK',
  id: 'PEW',
  obj: {
    iata: 'PEW',
    iso: 'PK',
    coordinates: '71.51460266113281, 33.993900299072266',
    municipality: 'Peshawar'
  }
}, {
  label: 'Petawawa Airport (YWA) - CA',
  id: 'YWA',
  obj: {
    iata: 'YWA',
    iso: 'CA',
    coordinates: '-77.31919860839844, 45.95220184326172',
    municipality: 'Petawawa'
  }
}, {
  label: 'Peterborough Airport (YPQ) - CA',
  id: 'YPQ',
  obj: {
    iata: 'YPQ',
    iso: 'CA',
    coordinates: '-78.36329650878906, 44.22999954223633',
    municipality: 'Peterborough'
  }
}, {
  label: 'Petersburg James A Johnson Airport (PSG) - US',
  id: 'PSG',
  obj: {
    iata: 'PSG',
    iso: 'US',
    coordinates: '-132.9450073, 56.80170059',
    municipality: 'Petersburg'
  }
}, {
  label: 'Senador Nilo Coelho Airport (PNZ) - BR',
  id: 'PNZ',
  obj: {
    iata: 'PNZ',
    iso: 'BR',
    coordinates: '-40.56909942626953, -9.362409591674805',
    municipality: 'Petrolina'
  }
}, {
  label: 'Petropavlosk South Airport (PPK) - KZ',
  id: 'PPK',
  obj: {
    iata: 'PPK',
    iso: 'KZ',
    coordinates: '69.18389892578125, 54.77470016479492',
    municipality: 'Petropavlosk'
  }
}, {
  label: 'Yelizovo Airport (PKC) - RU',
  id: 'PKC',
  obj: {
    iata: 'PKC',
    iso: 'RU',
    coordinates: '158.45399475097656, 53.16790008544922',
    municipality: 'Petropavlovsk-Kamchatsky'
  }
}, {
  label: 'Petrozavodsk Airport (PES) - RU',
  id: 'PES',
  obj: {
    iata: 'PES',
    iso: 'RU',
    coordinates: '34.154701232910156, 61.88520050048828',
    municipality: 'Petrozavodsk'
  }
}, {
  label: 'Pevek Airport (PWE) - RU',
  id: 'PWE',
  obj: {
    iata: 'PWE',
    iso: 'RU',
    coordinates: '170.59700012207, 69.783302307129',
    municipality: 'Pevek'
  }
}, {
  label: 'Hendrik Van Eck Airport (PHW) - ZA',
  id: 'PHW',
  obj: {
    iata: 'PHW',
    iso: 'ZA',
    coordinates: '31.1553993225, -23.937200546299998',
    municipality: 'Phalaborwa'
  }
}, {
  label: 'Philadelphia International Airport (PHL) - US',
  id: 'PHL',
  obj: {
    iata: 'PHL',
    iso: 'US',
    coordinates: '-75.24109649658203, 39.87189865112305',
    municipality: 'Philadelphia'
  }
}, {
  label: 'Northeast Philadelphia Airport (PNE) - US',
  id: 'PNE',
  obj: {
    iata: 'PNE',
    iso: 'US',
    coordinates: '-75.010597, 40.081902',
    municipality: 'Philadelphia'
  }
}, {
  label: 'Phnom Penh International Airport (PNH) - KH',
  id: 'PNH',
  obj: {
    iata: 'PNH',
    iso: 'KH',
    coordinates: '104.84400177001953, 11.546600341796875',
    municipality: 'Phnom Penh'
  }
}, {
  label: 'Phoenix-Mesa-Gateway Airport (AZA) - US',
  id: 'AZA',
  obj: {
    iata: 'AZA',
    iso: 'US',
    coordinates: '-111.6549988, 33.30780029',
    municipality: 'Phoenix'
  }
}, {
  label: 'Phoenix Sky Harbor International Airport (PHX) - US',
  id: 'PHX',
  obj: {
    iata: 'PHX',
    iso: 'US',
    coordinates: '-112.01200103759766, 33.43429946899414',
    municipality: 'Phoenix'
  }
}, {
  label: 'Phu Quoc International Airport (PQC) - VN',
  id: 'PQC',
  obj: {
    iata: 'PQC',
    iso: 'VN',
    coordinates: '103.9931, 10.1698',
    municipality: 'Phu Quoc Island'
  }
}, {
  label: 'Phuket International Airport (HKT) - TH',
  id: 'HKT',
  obj: {
    iata: 'HKT',
    iso: 'TH',
    coordinates: '98.316902, 8.1132',
    municipality: 'Phuket'
  }
}, {
  label: 'Pickle Lake Airport (YPL) - CA',
  id: 'YPL',
  obj: {
    iata: 'YPL',
    iso: 'CA',
    coordinates: '-90.21420288085938, 51.4463996887207',
    municipality: 'Pickle Lake'
  }
}, {
  label: 'Pico Airport (PIX) - PT',
  id: 'PIX',
  obj: {
    iata: 'PIX',
    iso: 'PT',
    coordinates: '-28.441299, 38.554298',
    municipality: 'Pico Island'
  }
}, {
  label: 'Pierre Regional Airport (PIR) - US',
  id: 'PIR',
  obj: {
    iata: 'PIR',
    iso: 'US',
    coordinates: '-100.2860031, 44.38270187',
    municipality: 'Pierre'
  }
}, {
  label: 'Pietermaritzburg Airport (PZB) - ZA',
  id: 'PZB',
  obj: {
    iata: 'PZB',
    iso: 'ZA',
    coordinates: '30.3987007141, -29.649000167799997',
    municipality: 'Pietermaritzburg'
  }
}, {
  label: 'Pie\u00c5\u00a1\u00c5\u00a5any Airport (PZY) - SK',
  id: 'PZY',
  obj: {
    iata: 'PZY',
    iso: 'SK',
    coordinates: '17.828399658203125, 48.62519836425781',
    municipality: 'Pie\u00c5\u00a1\u00c5\u00a5any'
  }
}, {
  label: 'Pikangikum Airport (YPM) - CA',
  id: 'YPM',
  obj: {
    iata: 'YPM',
    iso: 'CA',
    coordinates: '-93.97329711914062, 51.819698333740234',
    municipality: 'Pikangikum'
  }
}, {
  label: 'Pikwitonei Airport (PIW) - CA',
  id: 'PIW',
  obj: {
    iata: 'PIW',
    iso: 'CA',
    coordinates: '-97.16419982910156, 55.58890151977539',
    municipality: 'Pikwitonei'
  }
}, {
  label: 'Carlos Miguel Gimenez Airport (PIL) - PY',
  id: 'PIL',
  obj: {
    iata: 'PIL',
    iso: 'PY',
    coordinates: '-58.318026, -26.881224',
    municipality: 'Pilar'
  }
}, {
  label: 'San Julian Air Base (SNJ) - CU',
  id: 'SNJ',
  obj: {
    iata: 'SNJ',
    iso: 'CU',
    coordinates: '-84.1520004272461, 22.095300674438477',
    municipality: 'Pinar Del Rio'
  }
}, {
  label: 'La Coloma Airport (LCL) - CU',
  id: 'LCL',
  obj: {
    iata: 'LCL',
    iso: 'CU',
    coordinates: '-83.64189910888672, 22.33609962463379',
    municipality: 'Pinar del Rio'
  }
}, {
  label: 'Pinar Del Rio Airport (QPD) - CU',
  id: 'QPD',
  obj: {
    iata: 'QPD',
    iso: 'CU',
    coordinates: '-83.67839813232422, 22.42140007019043',
    municipality: 'Pinar del Rio'
  }
}, {
  label: 'Pincher Creek Airport (WPC) - CA',
  id: 'WPC',
  obj: {
    iata: 'WPC',
    iso: 'CA',
    coordinates: '-113.997001648, 49.520599365200006',
    municipality: 'Pincher Creek'
  }
}, {
  label: 'Pine Bluff Regional Airport, Grider Field (PBF) - US',
  id: 'PBF',
  obj: {
    iata: 'PBF',
    iso: 'US',
    coordinates: '-91.9356, 34.1731',
    municipality: 'Pine Bluff'
  }
}, {
  label: 'Ralph Wenz Field (PWY) - US',
  id: 'PWY',
  obj: {
    iata: 'PWY',
    iso: 'US',
    coordinates: '-109.8069992, 42.79550171',
    municipality: 'Pinedale'
  }
}, {
  label: 'Pingtung North Airport (PIF) - TW',
  id: 'PIF',
  obj: {
    iata: 'PIF',
    iso: 'TW',
    coordinates: '120.48200225830078, 22.700199127197266',
    municipality: 'Pingtung'
  }
}, {
  label: 'Campo Fontenelle Airport (QPS) - BR',
  id: 'QPS',
  obj: {
    iata: 'QPS',
    iso: 'BR',
    coordinates: '-47.334800720214844, -21.984600067138672',
    municipality: 'Pirassununga'
  }
}, {
  label: 'Pisa International Airport (PSA) - IT',
  id: 'PSA',
  obj: {
    iata: 'PSA',
    iso: 'IT',
    coordinates: '10.3927, 43.683899',
    municipality: 'Pisa'
  }
}, {
  label: 'Capit\u00c3\u00a1n FAP Ren\u00c3\u00a1n El\u00c3\u00adas Olivera International Airport (PIO) - PE',
  id: 'PIO',
  obj: {
    iata: 'PIO',
    iso: 'PE',
    coordinates: '-76.22029876708984, -13.74489974975586',
    municipality: 'Pisco'
  }
}, {
  label: 'Muan International Airport (MWX) - KR',
  id: 'MWX',
  obj: {
    iata: 'MWX',
    iso: 'KR',
    coordinates: '126.382814, 34.991406',
    municipality: 'Piseo-ri (Muan)'
  }
}, {
  label: 'Pitalito Airport (PTX) - CO',
  id: 'PTX',
  obj: {
    iata: 'PTX',
    iso: 'CO',
    coordinates: '-76.0857, 1.85777',
    municipality: 'Pitalito'
  }
}, {
  label: 'Allegheny County Airport (AGC) - US',
  id: 'AGC',
  obj: {
    iata: 'AGC',
    iso: 'US',
    coordinates: '-79.9301986694336, 40.354400634765625',
    municipality: 'Pittsburgh'
  }
}, {
  label: 'Pittsburgh International Airport (PIT) - US',
  id: 'PIT',
  obj: {
    iata: 'PIT',
    iso: 'US',
    coordinates: '-80.23290253, 40.49150085',
    municipality: 'Pittsburgh'
  }
}, {
  label: 'Capit\u00c3\u00a1n FAP Guillermo Concha Iberico International Airport (PIU) - PE',
  id: 'PIU',
  obj: {
    iata: 'PIU',
    iso: 'PE',
    coordinates: '-80.61640167239999, -5.20574998856',
    municipality: 'Piura'
  }
}, {
  label: 'Placencia Airport (PLJ) - BZ',
  id: 'PLJ',
  obj: {
    iata: 'PLJ',
    iso: 'BZ',
    coordinates: '-88.36151123046875, 16.536956787109375',
    municipality: 'Placencia'
  }
}, {
  label: 'Platinum Airport (PTU) - US',
  id: 'PTU',
  obj: {
    iata: 'PTU',
    iso: 'US',
    coordinates: '-161.82000732421875, 59.01139831542969',
    municipality: 'Platinum'
  }
}, {
  label: 'Plattsburgh International Airport (PBG) - US',
  id: 'PBG',
  obj: {
    iata: 'PBG',
    iso: 'US',
    coordinates: '-73.46810150146484, 44.650901794433594',
    municipality: 'Plattsburgh'
  }
}, {
  label: 'Pleiku Airport (PXU) - VN',
  id: 'PXU',
  obj: {
    iata: 'PXU',
    iso: 'VN',
    coordinates: '108.01699829101562, 14.004500389099121',
    municipality: 'Pleiku'
  }
}, {
  label: 'Plettenberg Bay Airport (PBZ) - ZA',
  id: 'PBZ',
  obj: {
    iata: 'PBZ',
    iso: 'ZA',
    coordinates: '23.3287234306, -34.0881601675',
    municipality: 'Plettenberg Bay'
  }
}, {
  label: 'Plovdiv International Airport (PDV) - BG',
  id: 'PDV',
  obj: {
    iata: 'PDV',
    iso: 'BG',
    coordinates: '24.8508, 42.067799',
    municipality: 'Plovdiv'
  }
}, {
  label: 'Pocatello Regional Airport (PIH) - US',
  id: 'PIH',
  obj: {
    iata: 'PIH',
    iso: 'US',
    coordinates: '-112.59600067138672, 42.9098014831543',
    municipality: 'Pocatello'
  }
}, {
  label: 'Barra del Colorado Airport (BCL) - CR',
  id: 'BCL',
  obj: {
    iata: 'BCL',
    iso: 'CR',
    coordinates: '-83.58560180664062, 10.768699645996094',
    municipality: 'Pococi'
  }
}, {
  label: 'Guapiles Airport (GPL) - CR',
  id: 'GPL',
  obj: {
    iata: 'GPL',
    iso: 'CR',
    coordinates: '-83.79699707030001, 10.2172002792',
    municipality: 'Pococi'
  }
}, {
  label: 'Podgorica Airport (TGD) - ME',
  id: 'TGD',
  obj: {
    iata: 'TGD',
    iso: 'ME',
    coordinates: '19.2519, 42.359402',
    municipality: 'Podgorica'
  }
}, {
  label: 'Pohang Airport (G-815/K-3) (KPO) - KR',
  id: 'KPO',
  obj: {
    iata: 'KPO',
    iso: 'KR',
    coordinates: '129.420383, 35.987955',
    municipality: 'Pohang'
  }
}, {
  label: 'Pohnpei International Airport (PNI) - FM',
  id: 'PNI',
  obj: {
    iata: 'PNI',
    iso: 'FM',
    coordinates: '158.20899963378906, 6.985099792480469',
    municipality: 'Pohnpei Island'
  }
}, {
  label: 'Point Lay LRRS Airport (PIZ) - US',
  id: 'PIZ',
  obj: {
    iata: 'PIZ',
    iso: 'US',
    coordinates: '-163.0050049, 69.73290253',
    municipality: 'Point Lay'
  }
}, {
  label: 'Point Mugu Naval Air Station (Naval Base Ventura Co) (NTD) - US',
  id: 'NTD',
  obj: {
    iata: 'NTD',
    iso: 'US',
    coordinates: '-119.121002197, 34.120300293',
    municipality: 'Point Mugu'
  }
}, {
  label: 'Pointe Noire Airport (PNR) - CG',
  id: 'PNR',
  obj: {
    iata: 'PNR',
    iso: 'CG',
    coordinates: '11.88659954071045, -4.816030025482178',
    municipality: 'Pointe Noire'
  }
}, {
  label: 'Pointe-\u00c3\u00a0-Pitre Le Raizet (PTP) - GP',
  id: 'PTP',
  obj: {
    iata: 'PTP',
    iso: 'GP',
    coordinates: '-61.531799, 16.265301',
    municipality: 'Pointe-\u00c3\u00a0-Pitre'
  }
}, {
  label: 'Points North Landing Airport (YNL) - CA',
  id: 'YNL',
  obj: {
    iata: 'YNL',
    iso: 'CA',
    coordinates: '-104.08200073242188, 58.27669906616211',
    municipality: 'Points North Landing'
  }
}, {
  label: 'Poitiers-Biard Airport (PIS) - FR',
  id: 'PIS',
  obj: {
    iata: 'PIS',
    iso: 'FR',
    coordinates: '0.30666598677635193, 46.58769989013672',
    municipality: 'Poitiers/Biard'
  }
}, {
  label: 'Pokhara Airport (PKR) - NP',
  id: 'PKR',
  obj: {
    iata: 'PKR',
    iso: 'NP',
    coordinates: '83.98210144042969, 28.200899124145508',
    municipality: 'Pokhara'
  }
}, {
  label: 'Polokwane International Airport (PTG) - ZA',
  id: 'PTG',
  obj: {
    iata: 'PTG',
    iso: 'ZA',
    coordinates: '29.458615, -23.845269',
    municipality: 'Polokwane'
  }
}, {
  label: 'Hingurakgoda Air Force Base (HIM) - LK',
  id: 'HIM',
  obj: {
    iata: 'HIM',
    iso: 'LK',
    coordinates: '80.9814, 8.04981',
    municipality: 'Polonnaruwa Town'
  }
}, {
  label: 'Ponca City Regional Airport (PNC) - US',
  id: 'PNC',
  obj: {
    iata: 'PNC',
    iso: 'US',
    coordinates: '-97.09980011, 36.73199844',
    municipality: 'Ponca City'
  }
}, {
  label: 'Mercedita Airport (PSE) - PR',
  id: 'PSE',
  obj: {
    iata: 'PSE',
    iso: 'PR',
    coordinates: '-66.56300354003906, 18.00830078125',
    municipality: 'Ponce'
  }
}, {
  label: 'Pond Inlet Airport (YIO) - CA',
  id: 'YIO',
  obj: {
    iata: 'YIO',
    iso: 'CA',
    coordinates: '-77.9666976929, 72.6832962036',
    municipality: 'Pond Inlet'
  }
}, {
  label: 'Pondicherry Airport (PNY) - IN',
  id: 'PNY',
  obj: {
    iata: 'PNY',
    iso: 'IN',
    coordinates: '79.812, 11.968',
    municipality: 'Pondicherry'
  }
}, {
  label: 'Jo\u00c3\u00a3o Paulo II Airport (PDL) - PT',
  id: 'PDL',
  obj: {
    iata: 'PDL',
    iso: 'PT',
    coordinates: '-25.6979007721, 37.7411994934',
    municipality: 'Ponta Delgada'
  }
}, {
  label: 'Ponta Grossa Airport - Comandante Antonio Amilton Beraldo (PGZ) - BR',
  id: 'PGZ',
  obj: {
    iata: 'PGZ',
    iso: 'BR',
    coordinates: '-50.1441, -25.1847',
    municipality: 'Ponta Grossa'
  }
}, {
  label: 'Ponta Por\u00c3\u00a3 Airport (PMG) - BR',
  id: 'PMG',
  obj: {
    iata: 'PMG',
    iso: 'BR',
    coordinates: '-55.702598571777344, -22.54960060119629',
    municipality: 'Ponta Por\u00c3\u00a3'
  }
}, {
  label: 'Oakland County International Airport (PTK) - US',
  id: 'PTK',
  obj: {
    iata: 'PTK',
    iso: 'US',
    coordinates: '-83.420097351074, 42.665500640869',
    municipality: 'Pontiac'
  }
}, {
  label: 'Supadio Airport (PNK) - ID',
  id: 'PNK',
  obj: {
    iata: 'PNK',
    iso: 'ID',
    coordinates: '109.40399932861328, -0.15071099996566772',
    municipality: 'Pontianak-Borneo Island'
  }
}, {
  label: 'Guillermo Le\u00c3\u00b3n Valencia Airport (PPN) - CO',
  id: 'PPN',
  obj: {
    iata: 'PPN',
    iso: 'CO',
    coordinates: '-76.6093, 2.4544',
    municipality: 'Popay\u00c3\u00a1n'
  }
}, {
  label: 'Poplar River Airport (XPP) - CA',
  id: 'XPP',
  obj: {
    iata: 'XPP',
    iso: 'CA',
    coordinates: '-97.2741937637, 52.9965258788',
    municipality: 'Poplar River'
  }
}, {
  label: 'Girua Airport (PNP) - PG',
  id: 'PNP',
  obj: {
    iata: 'PNP',
    iso: 'PG',
    coordinates: '148.309005737, -8.80453968048',
    municipality: 'Popondetta'
  }
}, {
  label: 'Poprad-Tatry Airport (TAT) - SK',
  id: 'TAT',
  obj: {
    iata: 'TAT',
    iso: 'SK',
    coordinates: '20.2411003113, 49.073600769',
    municipality: 'Poprad'
  }
}, {
  label: 'Porbandar Airport (PBD) - IN',
  id: 'PBD',
  obj: {
    iata: 'PBD',
    iso: 'IN',
    coordinates: '69.65720367429999, 21.6487007141',
    municipality: 'Porbandar'
  }
}, {
  label: 'Pori Airport (POR) - FI',
  id: 'POR',
  obj: {
    iata: 'POR',
    iso: 'FI',
    coordinates: '21.799999237061, 61.461700439453',
    municipality: 'Pori'
  }
}, {
  label: 'Porto Amboim Airport (PBN) - AO',
  id: 'PBN',
  obj: {
    iata: 'PBN',
    iso: 'AO',
    coordinates: '13.76550006866455, -10.722000122070312',
    municipality: 'Port Amboim'
  }
}, {
  label: 'William R Fairchild International Airport (CLM) - US',
  id: 'CLM',
  obj: {
    iata: 'CLM',
    iso: 'US',
    coordinates: '-123.5, 48.120201110839844',
    municipality: 'Port Angeles'
  }
}, {
  label: 'Vir Savarkar International Airport (IXZ) - IN',
  id: 'IXZ',
  obj: {
    iata: 'IXZ',
    iso: 'IN',
    coordinates: '92.72969818115234, 11.641200065612793',
    municipality: 'Port Blair'
  }
}, {
  label: 'Port Clarence Coast Guard Station (KPC) - US',
  id: 'KPC',
  obj: {
    iata: 'KPC',
    iso: 'US',
    coordinates: '-166.85899353, 65.2537002563',
    municipality: 'Port Clarence'
  }
}, {
  label: 'Port Elizabeth Airport (PLZ) - ZA',
  id: 'PLZ',
  obj: {
    iata: 'PLZ',
    iso: 'ZA',
    coordinates: '25.6173000336, -33.9849014282',
    municipality: 'Port Elizabeth'
  }
}, {
  label: 'Islay Airport (ILY) - GB',
  id: 'ILY',
  obj: {
    iata: 'ILY',
    iso: 'GB',
    coordinates: '-6.256669998168945, 55.68190002441406',
    municipality: 'Port Ellen'
  }
}, {
  label: 'Port Gentil Airport (POG) - GA',
  id: 'POG',
  obj: {
    iata: 'POG',
    iso: 'GA',
    coordinates: '8.754380226135254, -0.7117390036582947',
    municipality: 'Port Gentil'
  }
}, {
  label: 'Port Harcourt International Airport (PHC) - NG',
  id: 'PHC',
  obj: {
    iata: 'PHC',
    iso: 'NG',
    coordinates: '6.94959020614624, 5.0154900550842285',
    municipality: 'Port Harcourt'
  }
}, {
  label: 'Port Hardy Airport (YZT) - CA',
  id: 'YZT',
  obj: {
    iata: 'YZT',
    iso: 'CA',
    coordinates: '-127.36699676513672, 50.680599212646484',
    municipality: 'Port Hardy'
  }
}, {
  label: 'Port Hawkesbury Airport (YPS) - CA',
  id: 'YPS',
  obj: {
    iata: 'YPS',
    iso: 'CA',
    coordinates: '-61.3680992126, 45.6567001343',
    municipality: 'Port Hawkesbury'
  }
}, {
  label: 'Port Hedland International Airport (PHE) - AU',
  id: 'PHE',
  obj: {
    iata: 'PHE',
    iso: 'AU',
    coordinates: '118.625999451, -20.3777999878',
    municipality: 'Port Hedland'
  }
}, {
  label: 'Port Heiden Airport (PTH) - US',
  id: 'PTH',
  obj: {
    iata: 'PTH',
    iso: 'US',
    coordinates: '-158.63299560546875, 56.95909881591797',
    municipality: 'Port Heiden'
  }
}, {
  label: 'Port Lincoln Airport (PLO) - AU',
  id: 'PLO',
  obj: {
    iata: 'PLO',
    iso: 'AU',
    coordinates: '135.880004883, -34.6053009033',
    municipality: 'Port Lincoln'
  }
}, {
  label: 'Sir Seewoosagur Ramgoolam International Airport (MRU) - MU',
  id: 'MRU',
  obj: {
    iata: 'MRU',
    iso: 'MU',
    coordinates: '57.683601, -20.430201',
    municipality: 'Port Louis'
  }
}, {
  label: 'Port Macquarie Airport (PQQ) - AU',
  id: 'PQQ',
  obj: {
    iata: 'PQQ',
    iso: 'AU',
    coordinates: '152.863006592, -31.4358005524',
    municipality: 'Port Macquarie'
  }
}, {
  label: 'Sir Charles Gaetan Duval Airport (RRG) - MU',
  id: 'RRG',
  obj: {
    iata: 'RRG',
    iso: 'MU',
    coordinates: '63.361, -19.7577',
    municipality: 'Port Mathurin'
  }
}, {
  label: 'Port Moresby Jacksons International Airport (POM) - PG',
  id: 'POM',
  obj: {
    iata: 'POM',
    iso: 'PG',
    coordinates: '147.22000122070312, -9.443380355834961',
    municipality: 'Port Moresby'
  }
}, {
  label: 'Port Said Airport (PSD) - EG',
  id: 'PSD',
  obj: {
    iata: 'PSD',
    iso: 'EG',
    coordinates: '32.2400016784668, 31.279399871826172',
    municipality: 'Port Said'
  }
}, {
  label: 'Port St Johns Airport (JOH) - ZA',
  id: 'JOH',
  obj: {
    iata: 'JOH',
    iso: 'ZA',
    coordinates: '29.519800186157227, -31.605899810791016',
    municipality: 'Port St Johns'
  }
}, {
  label: 'Port Sudan New International Airport (PZU) - SD',
  id: 'PZU',
  obj: {
    iata: 'PZU',
    iso: 'SD',
    coordinates: '37.234100341796875, 19.4335994720459',
    municipality: 'Port Sudan'
  }
}, {
  label: 'Bauerfield International Airport (VLI) - VU',
  id: 'VLI',
  obj: {
    iata: 'VLI',
    iso: 'VU',
    coordinates: '168.32000732422, -17.699300765991',
    municipality: 'Port Vila'
  }
}, {
  label: 'Piarco International Airport (POS) - TT',
  id: 'POS',
  obj: {
    iata: 'POS',
    iso: 'TT',
    coordinates: '-61.33720016479492, 10.595399856567383',
    municipality: 'Port of Spain'
  }
}, {
  label: 'Port Menier Airport (YPN) - CA',
  id: 'YPN',
  obj: {
    iata: 'YPN',
    iso: 'CA',
    coordinates: '-64.2885971069336, 49.83639907836914',
    municipality: 'Port-Menier'
  }
}, {
  label: 'Toussaint Louverture International Airport (PAP) - HT',
  id: 'PAP',
  obj: {
    iata: 'PAP',
    iso: 'HT',
    coordinates: '-72.2925033569336, 18.579999923706055',
    municipality: 'Port-au-Prince'
  }
}, {
  label: 'Port-de-Paix Airport (PAX) - HT',
  id: 'PAX',
  obj: {
    iata: 'PAX',
    iso: 'HT',
    coordinates: '-72.84860229492188, 19.9335994720459',
    municipality: 'Port-de-Paix'
  }
}, {
  label: 'Portage-la-Prairie / Southport Airport (YPG) - CA',
  id: 'YPG',
  obj: {
    iata: 'YPG',
    iso: 'CA',
    coordinates: '-98.273817, 49.903099',
    municipality: 'Portage la Prairie'
  }
}, {
  label: 'Portim\u00c3\u00a3o Airport (PRM) - PT',
  id: 'PRM',
  obj: {
    iata: 'PRM',
    iso: 'PT',
    coordinates: '-8.58396, 37.1493',
    municipality: 'Portim\u00c3\u00a3o'
  }
}, {
  label: 'Portland Hillsboro Airport (HIO) - US',
  id: 'HIO',
  obj: {
    iata: 'HIO',
    iso: 'US',
    coordinates: '-122.949997, 45.540401',
    municipality: 'Portland'
  }
}, {
  label: 'Portland International Airport (PDX) - US',
  id: 'PDX',
  obj: {
    iata: 'PDX',
    iso: 'US',
    coordinates: '-122.5979996, 45.58869934',
    municipality: 'Portland'
  }
}, {
  label: 'Portland International Jetport (PWM) - US',
  id: 'PWM',
  obj: {
    iata: 'PWM',
    iso: 'US',
    coordinates: '-70.309303, 43.646198',
    municipality: 'Portland'
  }
}, {
  label: 'Portland Troutdale Airport (TTD) - US',
  id: 'TTD',
  obj: {
    iata: 'TTD',
    iso: 'US',
    coordinates: '-122.40100097656, 45.54940032959',
    municipality: 'Portland'
  }
}, {
  label: 'Francisco de S\u00c3\u00a1 Carneiro Airport (OPO) - PT',
  id: 'OPO',
  obj: {
    iata: 'OPO',
    iso: 'PT',
    coordinates: '-8.68138980865, 41.2481002808',
    municipality: 'Porto'
  }
}, {
  label: 'Salgado Filho Airport (POA) - BR',
  id: 'POA',
  obj: {
    iata: 'POA',
    iso: 'BR',
    coordinates: '-51.1713981628418, -29.994400024414062',
    municipality: 'Porto Alegre'
  }
}, {
  label: 'Porto Nacional Airport (PNB) - BR',
  id: 'PNB',
  obj: {
    iata: 'PNB',
    iso: 'BR',
    coordinates: '-48.3997, -10.719402',
    municipality: 'Porto Nacional'
  }
}, {
  label: 'Porto Seguro Airport (BPS) - BR',
  id: 'BPS',
  obj: {
    iata: 'BPS',
    iso: 'BR',
    coordinates: '-39.080898, -16.438601',
    municipality: 'Porto Seguro'
  }
}, {
  label: 'Governador Jorge Teixeira de Oliveira Airport (PVH) - BR',
  id: 'PVH',
  obj: {
    iata: 'PVH',
    iso: 'BR',
    coordinates: '-63.90230178833008, -8.70928955078125',
    municipality: 'Porto Velho'
  }
}, {
  label: 'Portoroz Airport (POW) - SI',
  id: 'POW',
  obj: {
    iata: 'POW',
    iso: 'SI',
    coordinates: '13.614999771118164, 45.4734001159668',
    municipality: 'Portoroz'
  }
}, {
  label: 'Reales Tamarindos Airport (PVO) - EC',
  id: 'PVO',
  obj: {
    iata: 'PVO',
    iso: 'EC',
    coordinates: '-80.47219848632812, -1.0416500568389893',
    municipality: 'Portoviejo'
  }
}, {
  label: 'Portsmouth International at Pease Airport (PSM) - US',
  id: 'PSM',
  obj: {
    iata: 'PSM',
    iso: 'US',
    coordinates: '-70.8233032227, 43.0778999329',
    municipality: 'Portsmouth'
  }
}, {
  label: 'Capitan Fuentes Martinez Airport Airport (WPR) - CL',
  id: 'WPR',
  obj: {
    iata: 'WPR',
    iso: 'CL',
    coordinates: '-70.31919860839844, -53.253700256347656',
    municipality: 'Porvenir'
  }
}, {
  label: 'Libertador Gral D Jose De San Martin Airport (PSS) - AR',
  id: 'PSS',
  obj: {
    iata: 'PSS',
    iso: 'AR',
    coordinates: '-55.9707, -27.3858',
    municipality: 'Posadas'
  }
}, {
  label: 'Kasiguncu Airport (PSJ) - ID',
  id: 'PSJ',
  obj: {
    iata: 'PSJ',
    iso: 'ID',
    coordinates: '120.657997131, -1.41674995422',
    municipality: 'Poso-Celebes Island'
  }
}, {
  label: 'Potchefstroom Airport (PCF) - ZA',
  id: 'PCF',
  obj: {
    iata: 'PCF',
    iso: 'ZA',
    coordinates: '27.0818996429, -26.670999527',
    municipality: 'Potchefstroom'
  }
}, {
  label: 'Capitan Nicolas Rojas Airport (POI) - BO',
  id: 'POI',
  obj: {
    iata: 'POI',
    iso: 'BO',
    coordinates: '-65.723734, -19.543331',
    municipality: 'Potos\u00c3\u00ad'
  }
}, {
  label: 'Dutchess County Airport (POU) - US',
  id: 'POU',
  obj: {
    iata: 'POU',
    iso: 'US',
    coordinates: '-73.88420104980469, 41.6265983581543',
    municipality: 'Poughkeepsie'
  }
}, {
  label: 'Powell River Airport (YPW) - CA',
  id: 'YPW',
  obj: {
    iata: 'YPW',
    iso: 'CA',
    coordinates: '-124.5, 49.83420181274414',
    municipality: 'Powell River'
  }
}, {
  label: 'El Taj\u00c3\u00adn National Airport (PAZ) - MX',
  id: 'PAZ',
  obj: {
    iata: 'PAZ',
    iso: 'MX',
    coordinates: '-97.46080017090001, 20.6026992798',
    municipality: 'Poza Rica'
  }
}, {
  label: 'Pozna\u00c5\u0084-\u00c5\u0081awica Airport (POZ) - PL',
  id: 'POZ',
  obj: {
    iata: 'POZ',
    iso: 'PL',
    coordinates: '16.8262996674, 52.421001434299995',
    municipality: 'Pozna\u00c5\u0084'
  }
}, {
  label: 'Po\u00c3\u00a7os de Caldas - Embaixador Walther Moreira Salles Airport (POO) - BR',
  id: 'POO',
  obj: {
    iata: 'POO',
    iso: 'BR',
    coordinates: '-46.567901611328, -21.843000411987',
    municipality: 'Po\u00c3\u00a7os De Caldas'
  }
}, {
  label: 'V\u00c3\u00a1clav Havel Airport Prague (PRG) - CZ',
  id: 'PRG',
  obj: {
    iata: 'PRG',
    iso: 'CZ',
    coordinates: '14.26, 50.1008',
    municipality: 'Prague'
  }
}, {
  label: 'Praia International Airport (RAI) - CV',
  id: 'RAI',
  obj: {
    iata: 'RAI',
    iso: 'CV',
    coordinates: '-23.493499755859375, 14.924500465393066',
    municipality: 'Praia'
  }
}, {
  label: 'Lajes Airport (TER) - PT',
  id: 'TER',
  obj: {
    iata: 'TER',
    iso: 'PT',
    coordinates: '-27.090799, 38.761799',
    municipality: 'Praia da Vit\u00c3\u00b3ria'
  }
}, {
  label: 'Praslin Airport (PRI) - SC',
  id: 'PRI',
  obj: {
    iata: 'PRI',
    iso: 'SC',
    coordinates: '55.69139862060547, -4.3192901611328125',
    municipality: 'Praslin Island'
  }
}, {
  label: 'Pregui\u00c3\u00a7a Airport (SNE) - CV',
  id: 'SNE',
  obj: {
    iata: 'SNE',
    iso: 'CV',
    coordinates: '-24.284700393676758, 16.58839988708496',
    municipality: 'Pregui\u00c3\u00a7a'
  }
}, {
  label: 'Prescott Regional Airport - Ernest A. Love Field (PRC) - US',
  id: 'PRC',
  obj: {
    iata: 'PRC',
    iso: 'US',
    coordinates: '-112.419998, 34.654499',
    municipality: 'Prescott'
  }
}, {
  label: 'Presidente Prudente Airport (PPB) - BR',
  id: 'PPB',
  obj: {
    iata: 'PPB',
    iso: 'BR',
    coordinates: '-51.4245986938, -22.1751003265',
    municipality: 'Presidente Prudente'
  }
}, {
  label: 'Presque Isle International Airport (PQI) - US',
  id: 'PQI',
  obj: {
    iata: 'PQI',
    iso: 'US',
    coordinates: '-68.0448, 46.688999',
    municipality: 'Presque Isle'
  }
}, {
  label: 'Wonderboom Airport (PRY) - ZA',
  id: 'PRY',
  obj: {
    iata: 'PRY',
    iso: 'ZA',
    coordinates: '28.224199, -25.6539',
    municipality: 'Pretoria'
  }
}, {
  label: 'Waterkloof Air Force Base (WKF) - ZA',
  id: 'WKF',
  obj: {
    iata: 'WKF',
    iso: 'ZA',
    coordinates: '28.222499847399998, -25.829999923699997',
    municipality: 'Pretoria'
  }
}, {
  label: 'Aktion National Airport (PVK) - GR',
  id: 'PVK',
  obj: {
    iata: 'PVK',
    iso: 'GR',
    coordinates: '20.765300750732422, 38.925498962402344',
    municipality: 'Preveza/Lefkada'
  }
}, {
  label: 'Prince Albert Glass Field (YPA) - CA',
  id: 'YPA',
  obj: {
    iata: 'YPA',
    iso: 'CA',
    coordinates: '-105.672996521, 53.214199066199996',
    municipality: 'Prince Albert'
  }
}, {
  label: 'Prince George Airport (YXS) - CA',
  id: 'YXS',
  obj: {
    iata: 'YXS',
    iso: 'CA',
    coordinates: '-122.679000854, 53.8894004822',
    municipality: 'Prince George'
  }
}, {
  label: 'Prince Rupert Airport (YPR) - CA',
  id: 'YPR',
  obj: {
    iata: 'YPR',
    iso: 'CA',
    coordinates: '-130.445007324, 54.286098480199996',
    municipality: 'Prince Rupert'
  }
}, {
  label: 'Pri\u00c5\u00a1tina International Airport (PRN) - XK',
  id: 'PRN',
  obj: {
    iata: 'PRN',
    iso: 'XK',
    coordinates: '21.035801, 42.5728',
    municipality: 'Prishtina'
  }
}, {
  label: 'Proserpine Whitsunday Coast Airport (PPP) - AU',
  id: 'PPP',
  obj: {
    iata: 'PPP',
    iso: 'AU',
    coordinates: '148.552001953, -20.4950008392',
    municipality: 'Proserpine'
  }
}, {
  label: 'Theodore Francis Green State Airport (PVD) - US',
  id: 'PVD',
  obj: {
    iata: 'PVD',
    iso: 'US',
    coordinates: '-71.420403, 41.732601',
    municipality: 'Providence'
  }
}, {
  label: 'El Embrujo Airport (PVA) - CO',
  id: 'PVA',
  obj: {
    iata: 'PVA',
    iso: 'CO',
    coordinates: '-81.3583, 13.3569',
    municipality: 'Providencia'
  }
}, {
  label: 'Providenciales Airport (PLS) - TC',
  id: 'PLS',
  obj: {
    iata: 'PLS',
    iso: 'TC',
    coordinates: '-72.26589965820312, 21.77359962463379',
    municipality: 'Providenciales Island'
  }
}, {
  label: 'Provo Municipal Airport (PVU) - US',
  id: 'PVU',
  obj: {
    iata: 'PVU',
    iso: 'US',
    coordinates: '-111.72299957275, 40.219200134277',
    municipality: 'Provo'
  }
}, {
  label: 'Pskov Airport (PKV) - RU',
  id: 'PKV',
  obj: {
    iata: 'PKV',
    iso: 'RU',
    coordinates: '28.395599365234375, 57.78390121459961',
    municipality: 'Pskov'
  }
}, {
  label: 'Cap FAP David Abenzur Rengifo International Airport (PCL) - PE',
  id: 'PCL',
  obj: {
    iata: 'PCL',
    iso: 'PE',
    coordinates: '-74.57430267333984, -8.37794017791748',
    municipality: 'Pucallpa'
  }
}, {
  label: 'Hermanos Serd\u00c3\u00a1n International Airport (PBC) - MX',
  id: 'PBC',
  obj: {
    iata: 'PBC',
    iso: 'MX',
    coordinates: '-98.3713989258, 19.1581001282',
    municipality: 'Puebla'
  }
}, {
  label: 'Tres De Mayo Airport (PUU) - CO',
  id: 'PUU',
  obj: {
    iata: 'PUU',
    iso: 'CO',
    coordinates: '-76.5008, 0.505228',
    municipality: 'Puerto As\u00c3\u00ads'
  }
}, {
  label: 'Cacique Aramare Airport (PYH) - VE',
  id: 'PYH',
  obj: {
    iata: 'PYH',
    iso: 'VE',
    coordinates: '-67.606101989746, 5.6199898719788',
    municipality: 'Puerto Ayacucho'
  }
}, {
  label: 'Puerto Barrios Airport (PBR) - GT',
  id: 'PBR',
  obj: {
    iata: 'PBR',
    iso: 'GT',
    coordinates: '-88.583801, 15.7309',
    municipality: 'Puerto Barrios'
  }
}, {
  label: 'Puerto Cabezas Airport (PUZ) - NI',
  id: 'PUZ',
  obj: {
    iata: 'PUZ',
    iso: 'NI',
    coordinates: '-83.38670349121094, 14.047200202941895',
    municipality: 'Puerto Cabezas'
  }
}, {
  label: 'German Olano Airport (PCR) - CO',
  id: 'PCR',
  obj: {
    iata: 'PCR',
    iso: 'CO',
    coordinates: '-67.4932, 6.18472',
    municipality: 'Puerto Carre\u00c3\u00b1o'
  }
}, {
  label: 'Puerto Deseado Airport (PUD) - AR',
  id: 'PUD',
  obj: {
    iata: 'PUD',
    iso: 'AR',
    coordinates: '-65.9041, -47.7353',
    municipality: 'Puerto Deseado'
  }
}, {
  label: 'Puerto Escondido International Airport (PXM) - MX',
  id: 'PXM',
  obj: {
    iata: 'PXM',
    iso: 'MX',
    coordinates: '-97.089103, 15.8769',
    municipality: 'Puerto Escondido'
  }
}, {
  label: 'Cataratas Del Iguaz\u00c3\u00ba International Airport (IGR) - AR',
  id: 'IGR',
  obj: {
    iata: 'IGR',
    iso: 'AR',
    coordinates: '-54.4734, -25.737301',
    municipality: 'Puerto Iguazu'
  }
}, {
  label: 'Obando Airport (PDA) - CO',
  id: 'PDA',
  obj: {
    iata: 'PDA',
    iso: 'CO',
    coordinates: '-67.9062, 3.85353',
    municipality: 'Puerto In\u00c3\u00adrida'
  }
}, {
  label: 'Puerto Jimenez Airport (PJM) - CR',
  id: 'PJM',
  obj: {
    iata: 'PJM',
    iso: 'CR',
    coordinates: '-83.30000305175781, 8.533329963684082',
    municipality: 'Puerto Jimenez'
  }
}, {
  label: 'Limon International Airport (LIO) - CR',
  id: 'LIO',
  obj: {
    iata: 'LIO',
    iso: 'CR',
    coordinates: '-83.02200317382812, 9.95796012878418',
    municipality: 'Puerto Limon'
  }
}, {
  label: 'El Tehuelche Airport (PMY) - AR',
  id: 'PMY',
  obj: {
    iata: 'PMY',
    iso: 'AR',
    coordinates: '-65.1027, -42.7592',
    municipality: 'Puerto Madryn'
  }
}, {
  label: 'Padre Aldamiz International Airport (PEM) - PE',
  id: 'PEM',
  obj: {
    iata: 'PEM',
    iso: 'PE',
    coordinates: '-69.2285995483, -12.6135997772',
    municipality: 'Puerto Maldonado'
  }
}, {
  label: 'El Tepual Airport (PMC) - CL',
  id: 'PMC',
  obj: {
    iata: 'PMC',
    iso: 'CL',
    coordinates: '-73.09400177001953, -41.438899993896484',
    municipality: 'Puerto Montt'
  }
}, {
  label: 'Tte. Julio Gallardo Airport (PNT) - CL',
  id: 'PNT',
  obj: {
    iata: 'PNT',
    iso: 'CL',
    coordinates: '-72.52839660644531, -51.67150115966797',
    municipality: 'Puerto Natales'
  }
}, {
  label: 'General Manuel Carlos Piar International Airport (PZO) - VE',
  id: 'PZO',
  obj: {
    iata: 'PZO',
    iso: 'VE',
    coordinates: '-62.760398864746094, 8.288530349731445',
    municipality: 'Puerto Ordaz-Ciudad Guayana'
  }
}, {
  label: 'Gregorio Luperon International Airport (POP) - DO',
  id: 'POP',
  obj: {
    iata: 'POP',
    iso: 'DO',
    coordinates: '-70.56999969482422, 19.75790023803711',
    municipality: 'Puerto Plata'
  }
}, {
  label: 'Puerto Princesa Airport (PPS) - PH',
  id: 'PPS',
  obj: {
    iata: 'PPS',
    iso: 'PH',
    coordinates: '118.75900268554688, 9.742119789123535',
    municipality: 'Puerto Princesa City'
  }
}, {
  label: 'San Jos\u00c3\u00a9 Airport (GSJ) - GT',
  id: 'GSJ',
  obj: {
    iata: 'GSJ',
    iso: 'GT',
    coordinates: '-90.83580017090001, 13.936200141899999',
    municipality: 'Puerto San Jos\u00c3\u00a9'
  }
}, {
  label: 'Capit\u00c3\u00a1n Av. Salvador Ogaya G. airport (PSZ) - BO',
  id: 'PSZ',
  obj: {
    iata: 'PSZ',
    iso: 'BO',
    coordinates: '-57.820599, -18.975301',
    municipality: 'Puerto Su\u00c3\u00a1rez'
  }
}, {
  label: 'Licenciado Gustavo D\u00c3\u00adaz Ordaz International Airport (PVR) - MX',
  id: 'PVR',
  obj: {
    iata: 'PVR',
    iso: 'MX',
    coordinates: '-105.25399780273438, 20.680099487304688',
    municipality: 'Puerto Vallarta'
  }
}, {
  label: 'Guardiamarina Za\u00c3\u00b1artu Airport (WPU) - CL',
  id: 'WPU',
  obj: {
    iata: 'WPU',
    iso: 'CL',
    coordinates: '-67.62629699707031, -54.93109893798828',
    municipality: 'Puerto Williams'
  }
}, {
  label: 'Pukatawagan Airport (XPK) - CA',
  id: 'XPK',
  obj: {
    iata: 'XPK',
    iso: 'CA',
    coordinates: '-101.26599884, 55.7491989136',
    municipality: 'Pukatawagan'
  }
}, {
  label: 'Pula Airport (PUY) - HR',
  id: 'PUY',
  obj: {
    iata: 'PUY',
    iso: 'HR',
    coordinates: '13.922200202941895, 44.89350128173828',
    municipality: 'Pula'
  }
}, {
  label: 'Pulau Tioman Airport (TOD) - MY',
  id: 'TOD',
  obj: {
    iata: 'TOD',
    iso: 'MY',
    coordinates: '104.16000366210938, 2.8181800842285156',
    municipality: 'Pulau Tioman'
  }
}, {
  label: 'Pullman Moscow Regional Airport (PUW) - US',
  id: 'PUW',
  obj: {
    iata: 'PUW',
    iso: 'US',
    coordinates: '-117.110001, 46.7439',
    municipality: 'Pullman/Moscow'
  }
}, {
  label: 'Pune Airport (PNQ) - IN',
  id: 'PNQ',
  obj: {
    iata: 'PNQ',
    iso: 'IN',
    coordinates: '73.9197006225586, 18.58209991455078',
    municipality: 'Pune'
  }
}, {
  label: 'Buenos Aires Airport (BAI) - CR',
  id: 'BAI',
  obj: {
    iata: 'BAI',
    iso: 'CR',
    coordinates: '-83.330171, 9.163949',
    municipality: 'Punta Arenas'
  }
}, {
  label: 'Pdte. Carlos Iba\u00c3\u00b1ez del Campo Airport (PUQ) - CL',
  id: 'PUQ',
  obj: {
    iata: 'PUQ',
    iso: 'CL',
    coordinates: '-70.854599, -53.002602',
    municipality: 'Punta Arenas'
  }
}, {
  label: 'Punta Cana International Airport (PUJ) - DO',
  id: 'PUJ',
  obj: {
    iata: 'PUJ',
    iso: 'DO',
    coordinates: '-68.36340332030001, 18.567399978599997',
    municipality: 'Punta Cana'
  }
}, {
  label: 'Punta Gorda Airport (PND) - BZ',
  id: 'PND',
  obj: {
    iata: 'PND',
    iso: 'BZ',
    coordinates: '-88.80829620360001, 16.102399826',
    municipality: 'Punta Gorda'
  }
}, {
  label: 'Capitan Corbeta CA Curbelo International Airport (PDP) - UY',
  id: 'PDP',
  obj: {
    iata: 'PDP',
    iso: 'UY',
    coordinates: '-55.09429931640625, -34.855098724365234',
    municipality: 'Punta del Este'
  }
}, {
  label: 'Putao Airport (PBU) - MM',
  id: 'PBU',
  obj: {
    iata: 'PBU',
    iso: 'MM',
    coordinates: '97.42630004882812, 27.32990074157715',
    municipality: 'Putao'
  }
}, {
  label: 'Sri Sathya Sai Airport (PUT) - IN',
  id: 'PUT',
  obj: {
    iata: 'PUT',
    iso: 'IN',
    coordinates: '77.7910995483, 14.1492996216',
    municipality: 'Puttaparthi'
  }
}, {
  label: 'Pangsuma Airport (PSU) - ID',
  id: 'PSU',
  obj: {
    iata: 'PSU',
    iso: 'ID',
    coordinates: '112.93699645996094, 0.8355780243873596',
    municipality: 'Putussibau-Borneo Island'
  }
}, {
  label: 'Puvirnituq Airport (YPX) - CA',
  id: 'YPX',
  obj: {
    iata: 'YPX',
    iso: 'CA',
    coordinates: '-77.28690338134766, 60.05059814453125',
    municipality: 'Puvirnituq'
  }
}, {
  label: 'Naypyidaw Airport (NYT) - MM',
  id: 'NYT',
  obj: {
    iata: 'NYT',
    iso: 'MM',
    coordinates: '96.200996, 19.623501',
    municipality: 'Pyinmana'
  }
}, {
  label: 'Pyongyang Sunan International Airport (FNJ) - KP',
  id: 'FNJ',
  obj: {
    iata: 'FNJ',
    iso: 'KP',
    coordinates: '125.669998, 39.224098',
    municipality: 'Pyongyang'
  }
}, {
  label: 'P\u00c3\u00a4rnu Airport (EPU) - EE',
  id: 'EPU',
  obj: {
    iata: 'EPU',
    iso: 'EE',
    coordinates: '24.47279930114746, 58.41899871826172',
    municipality: 'P\u00c3\u00a4rnu'
  }
}, {
  label: 'P\u00c3\u00a9cs-Pog\u00c3\u00a1ny Airport (PEV) - HU',
  id: 'PEV',
  obj: {
    iata: 'PEV',
    iso: 'HU',
    coordinates: '18.240996, 45.990898',
    municipality: 'P\u00c3\u00a9cs-Pog\u00c3\u00a1ny'
  }
}, {
  label: 'P\u00c3\u00a9rigueux-Bassillac Airport (PGX) - FR',
  id: 'PGX',
  obj: {
    iata: 'PGX',
    iso: 'FR',
    coordinates: '0.815555989742279, 45.19810104370117',
    municipality: 'P\u00c3\u00a9rigueux/Bassillac'
  }
}, {
  label: 'P\u00c5\u0099erov Air Base (PRV) - CZ',
  id: 'PRV',
  obj: {
    iata: 'PRV',
    iso: 'CZ',
    coordinates: '17.404699325561523, 49.42580032348633',
    municipality: 'P\u00c5\u0099erov'
  }
}, {
  label: 'Al Qaisumah/Hafr Al Batin Airport (AQI) - SA',
  id: 'AQI',
  obj: {
    iata: 'AQI',
    iso: 'SA',
    coordinates: '46.125099, 28.335199',
    municipality: 'Qaisumah'
  }
}, {
  label: 'Qamishli Airport (KAC) - SY',
  id: 'KAC',
  obj: {
    iata: 'KAC',
    iso: 'SY',
    coordinates: '41.191399, 37.020599',
    municipality: 'Qamishly'
  }
}, {
  label: 'Qayyarah West Airport (RQW) - IQ',
  id: 'RQW',
  obj: {
    iata: 'RQW',
    iso: 'IQ',
    coordinates: '43.125099182099994, 35.76720047',
    municipality: 'Qayyarah'
  }
}, {
  label: 'Qazvin Airport (GZW) - IR',
  id: 'GZW',
  obj: {
    iata: 'GZW',
    iso: 'IR',
    coordinates: '50.0471, 36.240101',
    municipality: 'Qazvin'
  }
}, {
  label: 'Qianjiang Wulingshan Airport (JIQ) - CN',
  id: 'JIQ',
  obj: {
    iata: 'JIQ',
    iso: 'CN',
    coordinates: '108.831111111, 29.5133333333',
    municipality: 'Qianjiang'
  }
}, {
  label: 'Qikiqtarjuaq Airport (YVM) - CA',
  id: 'YVM',
  obj: {
    iata: 'YVM',
    iso: 'CA',
    coordinates: '-64.03140258789999, 67.5457992554',
    municipality: 'Qikiqtarjuaq'
  }
}, {
  label: 'Qilian Airport (HBQ) - CN',
  id: 'HBQ',
  obj: {
    iata: 'HBQ',
    iso: 'CN',
    coordinates: '100.644, 38.012',
    municipality: 'Qilian'
  }
}, {
  label: 'Qingyang Airport (IQN) - CN',
  id: 'IQN',
  obj: {
    iata: 'IQN',
    iso: 'CN',
    coordinates: '107.602997, 35.799702',
    municipality: 'Qingyang'
  }
}, {
  label: 'Qinhuangdao Beidaihe Airport (BPE) - CN',
  id: 'BPE',
  obj: {
    iata: 'BPE',
    iso: 'CN',
    coordinates: '119.058889, 39.666389',
    municipality: 'Qinhuangdao'
  }
}, {
  label: "Qionghai Bo'ao Airport (BAR) - CN",
  id: 'BAR',
  obj: {
    iata: 'BAR',
    iso: 'CN',
    coordinates: '110.454775, 19.13824',
    municipality: 'Qionghai'
  }
}, {
  label: 'Quaqtaq Airport (YQC) - CA',
  id: 'YQC',
  obj: {
    iata: 'YQC',
    iso: 'CA',
    coordinates: '-69.6177978515625, 61.0463981628418',
    municipality: 'Quaqtaq'
  }
}, {
  label: 'Quebec Jean Lesage International Airport (YQB) - CA',
  id: 'YQB',
  obj: {
    iata: 'YQB',
    iso: 'CA',
    coordinates: '-71.393303, 46.7911',
    municipality: 'Quebec'
  }
}, {
  label: 'Queenstown Airport (UTW) - ZA',
  id: 'UTW',
  obj: {
    iata: 'UTW',
    iso: 'ZA',
    coordinates: '26.882200241088867, -31.92020034790039',
    municipality: 'Queenstown'
  }
}, {
  label: 'Queenstown International Airport (ZQN) - NZ',
  id: 'ZQN',
  obj: {
    iata: 'ZQN',
    iso: 'NZ',
    coordinates: '168.738998413, -45.0210990906',
    municipality: 'Queenstown'
  }
}, {
  label: 'Quelimane Airport (UEL) - MZ',
  id: 'UEL',
  obj: {
    iata: 'UEL',
    iso: 'MZ',
    coordinates: '36.86909866333008, -17.855499267578125',
    municipality: 'Quelimane'
  }
}, {
  label: 'Quepos Managua Airport (XQP) - CR',
  id: 'XQP',
  obj: {
    iata: 'XQP',
    iso: 'CR',
    coordinates: '-84.12979888916016, 9.443160057067871',
    municipality: 'Quepos'
  }
}, {
  label: 'Quer\u00c3\u00a9taro Intercontinental Airport (QRO) - MX',
  id: 'QRO',
  obj: {
    iata: 'QRO',
    iso: 'MX',
    coordinates: '-100.185997, 20.6173',
    municipality: 'Quer\u00c3\u00a9taro'
  }
}, {
  label: 'Quesnel Airport (YQZ) - CA',
  id: 'YQZ',
  obj: {
    iata: 'YQZ',
    iso: 'CA',
    coordinates: '-122.51000213623047, 53.026100158691406',
    municipality: 'Quesnel'
  }
}, {
  label: 'Quetta International Airport (UET) - PK',
  id: 'UET',
  obj: {
    iata: 'UET',
    iso: 'PK',
    coordinates: '66.93779754638672, 30.251399993896484',
    municipality: 'Quetta'
  }
}, {
  label: 'El Cara\u00c3\u00b1o Airport (UIB) - CO',
  id: 'UIB',
  obj: {
    iata: 'UIB',
    iso: 'CO',
    coordinates: '-76.6412, 5.69076',
    municipality: 'Quibd\u00c3\u00b3'
  }
}, {
  label: 'Quimper-Cornouaille Airport (UIP) - FR',
  id: 'UIP',
  obj: {
    iata: 'UIP',
    iso: 'FR',
    coordinates: '-4.167789936065674, 47.974998474121094',
    municipality: 'Quimper/Pluguffan'
  }
}, {
  label: 'Quincy Regional Baldwin Field (UIN) - US',
  id: 'UIN',
  obj: {
    iata: 'UIN',
    iso: 'US',
    coordinates: '-91.19460297, 39.94269943',
    municipality: 'Quincy'
  }
}, {
  label: 'Mariscal Sucre International Airport (UIO) - EC',
  id: 'UIO',
  obj: {
    iata: 'UIO',
    iso: 'EC',
    coordinates: '-78.3575, -0.129166666667',
    municipality: 'Quito'
  }
}, {
  label: 'Phu Cat Airport (UIH) - VN',
  id: 'UIH',
  obj: {
    iata: 'UIH',
    iso: 'VN',
    coordinates: '109.042, 13.955',
    municipality: 'Quy Nohn'
  }
}, {
  label: 'Rabat-Sal\u00c3\u00a9 Airport (RBA) - MA',
  id: 'RBA',
  obj: {
    iata: 'RBA',
    iso: 'MA',
    coordinates: '-6.75152, 34.051498',
    municipality: 'Rabat'
  }
}, {
  label: 'Rabil Airport (BVC) - CV',
  id: 'BVC',
  obj: {
    iata: 'BVC',
    iso: 'CV',
    coordinates: '-22.888900756835938, 16.136499404907227',
    municipality: 'Rabil'
  }
}, {
  label: 'Rach Gia Airport (VKG) - VN',
  id: 'VKG',
  obj: {
    iata: 'VKG',
    iso: 'VN',
    coordinates: '105.132379532, 9.95802997234',
    municipality: 'Rach Gia'
  }
}, {
  label: 'Radom Airport (RDO) - PL',
  id: 'RDO',
  obj: {
    iata: 'RDO',
    iso: 'PL',
    coordinates: '21.213300705, 51.3891983032',
    municipality: 'Radom'
  }
}, {
  label: 'Rafha Domestic Airport (RAH) - SA',
  id: 'RAH',
  obj: {
    iata: 'RAH',
    iso: 'SA',
    coordinates: '43.4906005859375, 29.626399993896484',
    municipality: 'Rafha'
  }
}, {
  label: 'Shaikh Zaid Airport (RYK) - PK',
  id: 'RYK',
  obj: {
    iata: 'RYK',
    iso: 'PK',
    coordinates: '70.27960205078125, 28.383899688720703',
    municipality: 'Rahim Yar Khan'
  }
}, {
  label: 'Rainbow Lake Airport (YOP) - CA',
  id: 'YOP',
  obj: {
    iata: 'YOP',
    iso: 'CA',
    coordinates: '-119.40799713134766, 58.49140167236328',
    municipality: 'Rainbow Lake'
  }
}, {
  label: 'Rajahmundry Airport (RJA) - IN',
  id: 'RJA',
  obj: {
    iata: 'RJA',
    iso: 'IN',
    coordinates: '81.81819915770001, 17.1103992462',
    municipality: 'Rajahmundry'
  }
}, {
  label: 'Rajkot Airport (RAJ) - IN',
  id: 'RAJ',
  obj: {
    iata: 'RAJ',
    iso: 'IN',
    coordinates: '70.77950286869999, 22.3092002869',
    municipality: 'Rajkot'
  }
}, {
  label: 'Shah Mokhdum Airport (RJH) - BD',
  id: 'RJH',
  obj: {
    iata: 'RJH',
    iso: 'BD',
    coordinates: '88.61650085449219, 24.43720054626465',
    municipality: 'Rajshahi'
  }
}, {
  label: 'Raleigh Durham International Airport (RDU) - US',
  id: 'RDU',
  obj: {
    iata: 'RDU',
    iso: 'US',
    coordinates: '-78.7874984741211, 35.877601623535156',
    municipality: 'Raleigh/Durham'
  }
}, {
  label: 'Ramstein Air Base (RMS) - DE',
  id: 'RMS',
  obj: {
    iata: 'RMS',
    iso: 'DE',
    coordinates: '7.600279808044434, 49.4369010925293',
    municipality: 'Ramstein'
  }
}, {
  label: 'Ranai Airport (NTX) - ID',
  id: 'NTX',
  obj: {
    iata: 'NTX',
    iso: 'ID',
    coordinates: '108.388, 3.90871',
    municipality: 'Ranai-Natuna Besar Island'
  }
}, {
  label: 'De La Independencia Airport (QRC) - CL',
  id: 'QRC',
  obj: {
    iata: 'QRC',
    iso: 'CL',
    coordinates: '-70.77570343017578, -34.17369842529297',
    municipality: 'Rancagua'
  }
}, {
  label: 'Birsa Munda Airport (IXR) - IN',
  id: 'IXR',
  obj: {
    iata: 'IXR',
    iso: 'IN',
    coordinates: '85.3217010498, 23.314300537100003',
    municipality: 'Ranchi'
  }
}, {
  label: 'Rankin Inlet Airport (YRT) - CA',
  id: 'YRT',
  obj: {
    iata: 'YRT',
    iso: 'CA',
    coordinates: '-92.1157989502, 62.8114013672',
    municipality: 'Rankin Inlet'
  }
}, {
  label: 'Asturias Airport (OVD) - ES',
  id: 'OVD',
  obj: {
    iata: 'OVD',
    iso: 'ES',
    coordinates: '-6.0346198081970215, 43.5635986328125',
    municipality: 'Ran\u00c3\u00b3n'
  }
}, {
  label: 'Rapid City Regional Airport (RAP) - US',
  id: 'RAP',
  obj: {
    iata: 'RAP',
    iso: 'US',
    coordinates: '-103.05699920654297, 44.0452995300293',
    municipality: 'Rapid City'
  }
}, {
  label: 'Ellsworth Air Force Base (RCA) - US',
  id: 'RCA',
  obj: {
    iata: 'RCA',
    iso: 'US',
    coordinates: '-103.1039963, 44.14500046',
    municipality: 'Rapid City'
  }
}, {
  label: 'Ras Al Khaimah International Airport (RKT) - AE',
  id: 'RKT',
  obj: {
    iata: 'RKT',
    iso: 'AE',
    coordinates: '55.93880081176758, 25.613500595092773',
    municipality: 'Ras Al Khaimah'
  }
}, {
  label: 'Sardar-e-Jangal Airport (RAS) - IR',
  id: 'RAS',
  obj: {
    iata: 'RAS',
    iso: 'IR',
    coordinates: '49.617778, 37.323333',
    municipality: 'Rasht'
  }
}, {
  label: 'Ratanakiri Airport (RBE) - KH',
  id: 'RBE',
  obj: {
    iata: 'RBE',
    iso: 'KH',
    coordinates: '106.98699951171875, 13.729999542236328',
    municipality: 'Ratanakiri'
  }
}, {
  label: 'Rawalakot Airport (RAZ) - PK',
  id: 'RAZ',
  obj: {
    iata: 'RAZ',
    iso: 'PK',
    coordinates: '73.79810333251953, 33.849700927734375',
    municipality: 'Rawalakot'
  }
}, {
  label: 'Rawlins Municipal Airport/Harvey Field (RWL) - US',
  id: 'RWL',
  obj: {
    iata: 'RWL',
    iso: 'US',
    coordinates: '-107.1999969, 41.80559921',
    municipality: 'Rawlins'
  }
}, {
  label: 'Almirante Marco Andres Zar Airport (REL) - AR',
  id: 'REL',
  obj: {
    iata: 'REL',
    iso: 'AR',
    coordinates: '-65.2703, -43.2105',
    municipality: 'Rawson'
  }
}, {
  label: 'U-Tapao International Airport (UTP) - TH',
  id: 'UTP',
  obj: {
    iata: 'UTP',
    iso: 'TH',
    coordinates: '101.00499725341797, 12.679900169372559',
    municipality: 'Rayong'
  }
}, {
  label: 'Reading Regional Carl A Spaatz Field (RDG) - US',
  id: 'RDG',
  obj: {
    iata: 'RDG',
    iso: 'US',
    coordinates: '-75.96520233154297, 40.378501892089844',
    municipality: 'Reading'
  }
}, {
  label: 'Guararapes - Gilberto Freyre International Airport (REC) - BR',
  id: 'REC',
  obj: {
    iata: 'REC',
    iso: 'BR',
    coordinates: '-34.92359924316406, -8.126489639282227',
    municipality: 'Recife'
  }
}, {
  label: 'Reconquista Airport (RCQ) - AR',
  id: 'RCQ',
  obj: {
    iata: 'RCQ',
    iso: 'AR',
    coordinates: '-59.68, -29.2103',
    municipality: 'Reconquista'
  }
}, {
  label: 'Red Bluff Municipal Airport (RBL) - US',
  id: 'RBL',
  obj: {
    iata: 'RBL',
    iso: 'US',
    coordinates: '-122.251998901, 40.1506996155',
    municipality: 'Red Bluff'
  }
}, {
  label: 'Red Deer Regional Airport (YQF) - CA',
  id: 'YQF',
  obj: {
    iata: 'YQF',
    iso: 'CA',
    coordinates: '-113.89399719238281, 52.18220138549805',
    municipality: 'Red Deer'
  }
}, {
  label: 'Red Lake Airport (YRL) - CA',
  id: 'YRL',
  obj: {
    iata: 'YRL',
    iso: 'CA',
    coordinates: '-93.79309844970703, 51.066898345947266',
    municipality: 'Red Lake'
  }
}, {
  label: 'Red Sucker Lake Airport (YRS) - CA',
  id: 'YRS',
  obj: {
    iata: 'YRS',
    iso: 'CA',
    coordinates: '-93.55719757080078, 54.167198181152344',
    municipality: 'Red Sucker Lake'
  }
}, {
  label: 'Redding Municipal Airport (RDD) - US',
  id: 'RDD',
  obj: {
    iata: 'RDD',
    iso: 'US',
    coordinates: '-122.2929993, 40.50899887',
    municipality: 'Redding'
  }
}, {
  label: 'Roberts Field (RDM) - US',
  id: 'RDM',
  obj: {
    iata: 'RDM',
    iso: 'US',
    coordinates: '-121.1500015, 44.2541008',
    municipality: 'Redmond'
  }
}, {
  label: 'Redstone Army Air Field (HUA) - US',
  id: 'HUA',
  obj: {
    iata: 'HUA',
    iso: 'US',
    coordinates: '-86.68479919, 34.67869949',
    municipality: 'Redstone Arsnl Huntsville'
  }
}, {
  label: 'Redwood Falls Municipal Airport (RWF) - US',
  id: 'RWF',
  obj: {
    iata: 'RWF',
    iso: 'US',
    coordinates: '-95.08229828, 44.54719925',
    municipality: 'Redwood Falls'
  }
}, {
  label: 'Reggio Calabria Airport (REG) - IT',
  id: 'REG',
  obj: {
    iata: 'REG',
    iso: 'IT',
    coordinates: '15.6516, 38.071201',
    municipality: 'Reggio Calabria'
  }
}, {
  label: 'Regina International Airport (YQR) - CA',
  id: 'YQR',
  obj: {
    iata: 'YQR',
    iso: 'CA',
    coordinates: '-104.66600036621094, 50.43190002441406',
    municipality: 'Regina'
  }
}, {
  label: 'Japura Airport (RGT) - ID',
  id: 'RGT',
  obj: {
    iata: 'RGT',
    iso: 'ID',
    coordinates: '102.33499908447266, -0.35280799865722656',
    municipality: 'Rengat-Sumatra Island'
  }
}, {
  label: 'Rennes-Saint-Jacques Airport (RNS) - FR',
  id: 'RNS',
  obj: {
    iata: 'RNS',
    iso: 'FR',
    coordinates: '-1.73479, 48.0695',
    municipality: 'Rennes/Saint-Jacques'
  }
}, {
  label: 'Reno Tahoe International Airport (RNO) - US',
  id: 'RNO',
  obj: {
    iata: 'RNO',
    iso: 'US',
    coordinates: '-119.76799774169922, 39.49909973144531',
    municipality: 'Reno'
  }
}, {
  label: 'Naujaat Airport (YUT) - CA',
  id: 'YUT',
  obj: {
    iata: 'YUT',
    iso: 'CA',
    coordinates: '-86.224701, 66.5214',
    municipality: 'Repulse Bay'
  }
}, {
  label: 'Resistencia International Airport (RES) - AR',
  id: 'RES',
  obj: {
    iata: 'RES',
    iso: 'AR',
    coordinates: '-59.0561, -27.45',
    municipality: 'Resistencia'
  }
}, {
  label: 'Resolute Bay Airport (YRB) - CA',
  id: 'YRB',
  obj: {
    iata: 'YRB',
    iso: 'CA',
    coordinates: '-94.9693984985, 74.7169036865',
    municipality: 'Resolute Bay'
  }
}, {
  label: 'Retalhuleu Airport (RER) - GT',
  id: 'RER',
  obj: {
    iata: 'RER',
    iso: 'GT',
    coordinates: '-91.69730377197266, 14.520999908447266',
    municipality: 'Retalhuleu'
  }
}, {
  label: 'Reus Air Base (REU) - ES',
  id: 'REU',
  obj: {
    iata: 'REU',
    iso: 'ES',
    coordinates: '1.1671700477600098, 41.14739990234375',
    municipality: 'Reus'
  }
}, {
  label: 'Revelstoke Airport (YRV) - CA',
  id: 'YRV',
  obj: {
    iata: 'YRV',
    iso: 'CA',
    coordinates: '-118.182998657, 50.9667015076',
    municipality: 'Revelstoke'
  }
}, {
  label: 'Rewa Airport, Chorhata, REWA (REW) - IN',
  id: 'REW',
  obj: {
    iata: 'REW',
    iso: 'IN',
    coordinates: '81.220299, 24.503401',
    municipality: 'Rewa'
  }
}, {
  label: 'Reykjavik Airport (RKV) - IS',
  id: 'RKV',
  obj: {
    iata: 'RKV',
    iso: 'IS',
    coordinates: '-21.9405994415, 64.1299972534',
    municipality: 'Reykjavik'
  }
}, {
  label: 'Keflavik International Airport (KEF) - IS',
  id: 'KEF',
  obj: {
    iata: 'KEF',
    iso: 'IS',
    coordinates: '-22.6056, 63.985001',
    municipality: 'Reykjav\u00c3\u00adk'
  }
}, {
  label: 'General Lucio Blanco International Airport (REX) - MX',
  id: 'REX',
  obj: {
    iata: 'REX',
    iso: 'MX',
    coordinates: '-98.2285, 26.0089',
    municipality: 'Reynosa'
  }
}, {
  label: 'Rhinelander Oneida County Airport (RHI) - US',
  id: 'RHI',
  obj: {
    iata: 'RHI',
    iso: 'US',
    coordinates: '-89.46749877929688, 45.63119888305664',
    municipality: 'Rhinelander'
  }
}, {
  label: 'Leite Lopes Airport (RAO) - BR',
  id: 'RAO',
  obj: {
    iata: 'RAO',
    iso: 'BR',
    coordinates: '-47.776668548583984, -21.136388778686523',
    municipality: 'Ribeir\u00c3\u00a3o Preto'
  }
}, {
  label: 'Richards Bay Airport (RCB) - ZA',
  id: 'RCB',
  obj: {
    iata: 'RCB',
    iso: 'ZA',
    coordinates: '32.0920982361, -28.740999221800003',
    municipality: 'Richards Bay'
  }
}, {
  label: 'Richmond International Airport (RIC) - US',
  id: 'RIC',
  obj: {
    iata: 'RIC',
    iso: 'US',
    coordinates: '-77.3197021484375, 37.50519943237305',
    municipality: 'Richmond'
  }
}, {
  label: 'RAAF Base Richmond (XRH) - AU',
  id: 'XRH',
  obj: {
    iata: 'XRH',
    iso: 'AU',
    coordinates: '150.781006, -33.600601',
    municipality: 'Richmond'
  }
}, {
  label: 'Garfield County Regional Airport (RIL) - US',
  id: 'RIL',
  obj: {
    iata: 'RIL',
    iso: 'US',
    coordinates: '-107.726997, 39.526299',
    municipality: 'Rifle'
  }
}, {
  label: 'Riga International Airport (RIX) - LV',
  id: 'RIX',
  obj: {
    iata: 'RIX',
    iso: 'LV',
    coordinates: '23.971099853515625, 56.92359924316406',
    municipality: 'Riga'
  }
}, {
  label: 'Rijeka Airport (RJK) - HR',
  id: 'RJK',
  obj: {
    iata: 'RJK',
    iso: 'HR',
    coordinates: '14.570300102233887, 45.21689987182617',
    municipality: 'Rijeka'
  }
}, {
  label: 'Federico Fellini International Airport (RMI) - IT',
  id: 'RMI',
  obj: {
    iata: 'RMI',
    iso: 'IT',
    coordinates: '12.6117, 44.020302',
    municipality: 'Rimini'
  }
}, {
  label: 'Rimouski Airport (YXK) - CA',
  id: 'YXK',
  obj: {
    iata: 'YXK',
    iso: 'CA',
    coordinates: '-68.49690246582031, 48.47809982299805',
    municipality: 'Rimouski'
  }
}, {
  label: 'Rincon De Los Sauces Airport (RDS) - AR',
  id: 'RDS',
  obj: {
    iata: 'RDS',
    iso: 'AR',
    coordinates: '-68.9041976929, -37.3905982971',
    municipality: 'Rincon de los Sauces'
  }
}, {
  label: 'Rio Branco-Pl\u00c3\u00a1cido de Castro International Airport (RBR) - BR',
  id: 'RBR',
  obj: {
    iata: 'RBR',
    iso: 'BR',
    coordinates: '-67.893984, -9.869031',
    municipality: 'Rio Branco'
  }
}, {
  label: 'Area De Material Airport (RCU) - AR',
  id: 'RCU',
  obj: {
    iata: 'RCU',
    iso: 'AR',
    coordinates: '-64.2612991333, -33.0850982666',
    municipality: 'Rio Cuarto'
  }
}, {
  label: 'Rio Gale\u00c3\u00a3o \u00e2\u0080\u0093 Tom Jobim International Airport (GIG) - BR',
  id: 'GIG',
  obj: {
    iata: 'GIG',
    iso: 'BR',
    coordinates: '-43.2505569458, -22.8099994659',
    municipality: 'Rio De Janeiro'
  }
}, {
  label: 'Santos Dumont Airport (SDU) - BR',
  id: 'SDU',
  obj: {
    iata: 'SDU',
    iso: 'BR',
    coordinates: '-43.1631011963, -22.910499572799996',
    municipality: 'Rio De Janeiro'
  }
}, {
  label: 'Piloto Civil N. Fern\u00c3\u00a1ndez Airport (RGL) - AR',
  id: 'RGL',
  obj: {
    iata: 'RGL',
    iso: 'AR',
    coordinates: '-69.3126, -51.6089',
    municipality: 'Rio Gallegos'
  }
}, {
  label: 'Hermes Quijada International Airport (RGA) - AR',
  id: 'RGA',
  obj: {
    iata: 'RGA',
    iso: 'AR',
    coordinates: '-67.7494, -53.7777',
    municipality: 'Rio Grande'
  }
}, {
  label: 'Santa Cruz Air Force Base (SNZ) - BR',
  id: 'SNZ',
  obj: {
    iata: 'SNZ',
    iso: 'BR',
    coordinates: '-43.719101, -22.9324',
    municipality: 'Rio de Janeiro'
  }
}, {
  label: 'Almirante Padilla Airport (RCH) - CO',
  id: 'RCH',
  obj: {
    iata: 'RCH',
    iso: 'CO',
    coordinates: '-72.926, 11.5262',
    municipality: 'Riohacha'
  }
}, {
  label: 'Juan Simons Vela Airport (RIJ) - PE',
  id: 'RIJ',
  obj: {
    iata: 'RIJ',
    iso: 'PE',
    coordinates: '-77.16000366210938, -6.067860126495361',
    municipality: 'Rioja'
  }
}, {
  label: 'Rishiri Airport (RIS) - JP',
  id: 'RIS',
  obj: {
    iata: 'RIS',
    iso: 'JP',
    coordinates: '141.186004639, 45.2420005798',
    municipality: 'Rishiri'
  }
}, {
  label: 'Riverside Municipal Airport (RAL) - US',
  id: 'RAL',
  obj: {
    iata: 'RAL',
    iso: 'US',
    coordinates: '-117.4449997, 33.95190048',
    municipality: 'Riverside'
  }
}, {
  label: 'March ARB Airport (RIV) - US',
  id: 'RIV',
  obj: {
    iata: 'RIV',
    iso: 'US',
    coordinates: '-117.259003, 33.880699',
    municipality: 'Riverside'
  }
}, {
  label: 'Riverton Regional Airport (RIW) - US',
  id: 'RIW',
  obj: {
    iata: 'RIW',
    iso: 'US',
    coordinates: '-108.459999084, 43.064201355',
    municipality: 'Riverton'
  }
}, {
  label: 'La Macaza / Mont-Tremblant International Inc Airport (YTM) - CA',
  id: 'YTM',
  obj: {
    iata: 'YTM',
    iso: 'CA',
    coordinates: '-74.779999, 46.409401',
    municipality: 'Rivi\u00c3\u00a8re Rouge'
  }
}, {
  label: 'Rivi\u00c3\u00a8re-du-Loup Airport (YRI) - CA',
  id: 'YRI',
  obj: {
    iata: 'YRI',
    iso: 'CA',
    coordinates: '-69.58470153808594, 47.764400482177734',
    municipality: 'Rivi\u00c3\u00a8re-du-Loup'
  }
}, {
  label: 'Rivne International Airport (RWN) - UA',
  id: 'RWN',
  obj: {
    iata: 'RWN',
    iso: 'UA',
    coordinates: '26.141599655151367, 50.60710144042969',
    municipality: 'Rivne'
  }
}, {
  label: 'King Khaled International Airport (RUH) - SA',
  id: 'RUH',
  obj: {
    iata: 'RUH',
    iso: 'SA',
    coordinates: '46.69879913330078, 24.957599639892578',
    municipality: 'Riyadh'
  }
}, {
  label: 'Riyadh Air Base (XXN) - SA',
  id: 'XXN',
  obj: {
    iata: 'XXN',
    iso: 'SA',
    coordinates: '46.72520065307617, 24.709800720214844',
    municipality: 'Riyadh'
  }
}, {
  label: 'Riyan Mukalla International Airport (RIY) - YE',
  id: 'RIY',
  obj: {
    iata: 'RIY',
    iso: 'YE',
    coordinates: '49.375, 14.6626',
    municipality: 'Riyan'
  }
}, {
  label: 'Terrance B. Lettsome International Airport (EIS) - VG',
  id: 'EIS',
  obj: {
    iata: 'EIS',
    iso: 'VG',
    coordinates: '-64.54299926757812, 18.444799423217773',
    municipality: 'Road Town'
  }
}, {
  label: 'Roanne-Renaison Airport (RNE) - FR',
  id: 'RNE',
  obj: {
    iata: 'RNE',
    iso: 'FR',
    coordinates: '4.001389980316162, 46.05830001831055',
    municipality: 'Roanne/Renaison'
  }
}, {
  label: 'Roanoke\u00e2\u0080\u0093Blacksburg Regional Airport (ROA) - US',
  id: 'ROA',
  obj: {
    iata: 'ROA',
    iso: 'US',
    coordinates: '-79.975403, 37.3255',
    municipality: 'Roanoke'
  }
}, {
  label: 'Juan Manuel Galvez International Airport (RTB) - HN',
  id: 'RTB',
  obj: {
    iata: 'RTB',
    iso: 'HN',
    coordinates: '-86.523003, 16.316799',
    municipality: 'Roatan Island'
  }
}, {
  label: 'Robertson Airport (ROD) - ZA',
  id: 'ROD',
  obj: {
    iata: 'ROD',
    iso: 'ZA',
    coordinates: '19.902799606323242, -33.812198638916016',
    municipality: 'Robertson'
  }
}, {
  label: 'Roberval Airport (YRJ) - CA',
  id: 'YRJ',
  obj: {
    iata: 'YRJ',
    iso: 'CA',
    coordinates: '-72.2656021118164, 48.52000045776367',
    municipality: 'Roberval'
  }
}, {
  label: 'Rochefort-Saint-Agnant (BA 721) Airport (RCO) - FR',
  id: 'RCO',
  obj: {
    iata: 'RCO',
    iso: 'FR',
    coordinates: '-0.9830560088157654, 45.88779830932617',
    municipality: 'Rochefort/Saint-Agnant'
  }
}, {
  label: 'Greater Rochester International Airport (ROC) - US',
  id: 'ROC',
  obj: {
    iata: 'ROC',
    iso: 'US',
    coordinates: '-77.67240142822266, 43.118900299072266',
    municipality: 'Rochester'
  }
}, {
  label: 'Rochester International Airport (RST) - US',
  id: 'RST',
  obj: {
    iata: 'RST',
    iso: 'US',
    coordinates: '-92.5, 43.90829849243164',
    municipality: 'Rochester'
  }
}, {
  label: 'Rock Sound Airport (RSD) - BS',
  id: 'RSD',
  obj: {
    iata: 'RSD',
    iso: 'BS',
    coordinates: '-76.1768817902, 24.8950787333',
    municipality: 'Rock Sound'
  }
}, {
  label: 'Southwest Wyoming Regional Airport (RKS) - US',
  id: 'RKS',
  obj: {
    iata: 'RKS',
    iso: 'US',
    coordinates: '-109.065001, 41.5942',
    municipality: 'Rock Springs'
  }
}, {
  label: 'Rockhampton Airport (ROK) - AU',
  id: 'ROK',
  obj: {
    iata: 'ROK',
    iso: 'AU',
    coordinates: '150.475006104, -23.3819007874',
    municipality: 'Rockhampton'
  }
}, {
  label: 'Rocky Mount Wilson Regional Airport (RWI) - US',
  id: 'RWI',
  obj: {
    iata: 'RWI',
    iso: 'US',
    coordinates: '-77.89189910888672, 35.856300354003906',
    municipality: 'Rocky Mount'
  }
}, {
  label: 'Diagoras Airport (RHO) - GR',
  id: 'RHO',
  obj: {
    iata: 'RHO',
    iso: 'GR',
    coordinates: '28.086200714111328, 36.405399322509766',
    municipality: 'Rodes Island'
  }
}, {
  label: 'Rodez-Marcillac Airport (RDZ) - FR',
  id: 'RDZ',
  obj: {
    iata: 'RDZ',
    iso: 'FR',
    coordinates: '2.4826700687408447, 44.407901763916016',
    municipality: 'Rodez/Marcillac'
  }
}, {
  label: 'Roma Airport (RMA) - AU',
  id: 'RMA',
  obj: {
    iata: 'RMA',
    iso: 'AU',
    coordinates: '148.774993896, -26.545000076300003',
    municipality: 'Roma'
  }
}, {
  label: 'Griffiss International Airport (RME) - US',
  id: 'RME',
  obj: {
    iata: 'RME',
    iso: 'US',
    coordinates: '-75.40699768, 43.23379898',
    municipality: 'Rome'
  }
}, {
  label: 'Richard B Russell Airport (RMG) - US',
  id: 'RMG',
  obj: {
    iata: 'RMG',
    iso: 'US',
    coordinates: '-85.15799713130001, 34.3506011963',
    municipality: 'Rome'
  }
}, {
  label: 'Ciampino\u00e2\u0080\u0093G. B. Pastine International Airport (CIA) - IT',
  id: 'CIA',
  obj: {
    iata: 'CIA',
    iso: 'IT',
    coordinates: '12.5949, 41.7994',
    municipality: 'Rome'
  }
}, {
  label: 'Leonardo da Vinci\u00e2\u0080\u0093Fiumicino Airport (FCO) - IT',
  id: 'FCO',
  obj: {
    iata: 'FCO',
    iso: 'IT',
    coordinates: '12.2388889, 41.8002778',
    municipality: 'Rome'
  }
}, {
  label: 'Islas Malvinas Airport (ROS) - AR',
  id: 'ROS',
  obj: {
    iata: 'ROS',
    iso: 'AR',
    coordinates: '-60.785, -32.9036',
    municipality: 'Rosario'
  }
}, {
  label: "Ben Ya'akov Airport (RPN) - IL",
  id: 'RPN',
  obj: {
    iata: 'RPN',
    iso: 'IL',
    coordinates: '35.5718994140625, 32.98099899291992',
    municipality: 'Rosh Pina'
  }
}, {
  label: 'Ross River Airport (XRR) - CA',
  id: 'XRR',
  obj: {
    iata: 'XRR',
    iso: 'CA',
    coordinates: '-132.42300415, 61.9706001282',
    municipality: 'Ross River'
  }
}, {
  label: 'Rostock-Laage Airport (RLG) - DE',
  id: 'RLG',
  obj: {
    iata: 'RLG',
    iso: 'DE',
    coordinates: '12.278300285299999, 53.9182014465',
    municipality: 'Rostock'
  }
}, {
  label: 'Platov International Airport (ROV) - RU',
  id: 'ROV',
  obj: {
    iata: 'ROV',
    iso: 'RU',
    coordinates: '39.924722, 47.493888',
    municipality: 'Rostov-on-Don'
  }
}, {
  label: 'Roswell Air Center Airport (ROW) - US',
  id: 'ROW',
  obj: {
    iata: 'ROW',
    iso: 'US',
    coordinates: '-104.530998, 33.301601',
    municipality: 'Roswell'
  }
}, {
  label: 'Rota Naval Station Airport (ROZ) - ES',
  id: 'ROZ',
  obj: {
    iata: 'ROZ',
    iso: 'ES',
    coordinates: '-6.34946012497, 36.645198822',
    municipality: 'Rota'
  }
}, {
  label: 'Rota International Airport (ROP) - MP',
  id: 'ROP',
  obj: {
    iata: 'ROP',
    iso: 'MP',
    coordinates: '145.2429962158203, 14.174300193786621',
    municipality: 'Rota Island'
  }
}, {
  label: 'Rotorua Regional Airport (ROT) - NZ',
  id: 'ROT',
  obj: {
    iata: 'ROT',
    iso: 'NZ',
    coordinates: '176.31700134277344, -38.10919952392578',
    municipality: 'Rotorua'
  }
}, {
  label: 'Rotterdam The Hague Airport (RTM) - NL',
  id: 'RTM',
  obj: {
    iata: 'RTM',
    iso: 'NL',
    coordinates: '4.43722, 51.956902',
    municipality: 'Rotterdam'
  }
}, {
  label: 'Rouen Airport (URO) - FR',
  id: 'URO',
  obj: {
    iata: 'URO',
    iso: 'FR',
    coordinates: '1.1748000383377075, 49.38420104980469',
    municipality: 'Rouen/Vall\u00c3\u00a9e de Seine'
  }
}, {
  label: 'Round Lake (Weagamow Lake) Airport (ZRJ) - CA',
  id: 'ZRJ',
  obj: {
    iata: 'ZRJ',
    iso: 'CA',
    coordinates: '-91.31279754638672, 52.943599700927734',
    municipality: 'Round Lake'
  }
}, {
  label: 'Rouyn Noranda Airport (YUY) - CA',
  id: 'YUY',
  obj: {
    iata: 'YUY',
    iso: 'CA',
    coordinates: '-78.83560180664062, 48.20610046386719',
    municipality: 'Rouyn-Noranda'
  }
}, {
  label: 'Rovaniemi Airport (RVN) - FI',
  id: 'RVN',
  obj: {
    iata: 'RVN',
    iso: 'FI',
    coordinates: '25.830400466919, 66.564796447754',
    municipality: 'Rovaniemi'
  }
}, {
  label: 'Aerotortuguero Airport (TTQ) - CR',
  id: 'TTQ',
  obj: {
    iata: 'TTQ',
    iso: 'CR',
    coordinates: '-83.6095, 10.42',
    municipality: 'Roxana'
  }
}, {
  label: 'Roxas Airport (RXS) - PH',
  id: 'RXS',
  obj: {
    iata: 'RXS',
    iso: 'PH',
    coordinates: '122.75199890136719, 11.597700119018555',
    municipality: 'Roxas City'
  }
}, {
  label: 'Royan-M\u00c3\u00a9dis Airport (RYN) - FR',
  id: 'RYN',
  obj: {
    iata: 'RYN',
    iso: 'FR',
    coordinates: '-0.9725000262260437, 45.62810134887695',
    municipality: 'Royan/M\u00c3\u00a9dis'
  }
}, {
  label: 'Rubelsanto Airport (RUV) - GT',
  id: 'RUV',
  obj: {
    iata: 'RUV',
    iso: 'GT',
    coordinates: '-90.44529724121094, 15.991999626159668',
    municipality: 'Rubelsanto'
  }
}, {
  label: 'Ruby Airport (RBY) - US',
  id: 'RBY',
  obj: {
    iata: 'RBY',
    iso: 'US',
    coordinates: '-155.4700012, 64.72720337',
    municipality: 'Ruby'
  }
}, {
  label: 'Sierra Blanca Regional Airport (RUI) - US',
  id: 'RUI',
  obj: {
    iata: 'RUI',
    iso: 'US',
    coordinates: '-105.53500366211, 33.462799072266',
    municipality: 'Ruidoso'
  }
}, {
  label: 'Rundu Airport (NDU) - NA',
  id: 'NDU',
  obj: {
    iata: 'NDU',
    iso: 'NA',
    coordinates: '19.719400405884, -17.956499099731',
    municipality: 'Rundu'
  }
}, {
  label: 'Russell Municipal Airport (RSL) - US',
  id: 'RSL',
  obj: {
    iata: 'RSL',
    iso: 'US',
    coordinates: '-98.811798095703, 38.872100830078',
    municipality: 'Russell'
  }
}, {
  label: 'Rutland - Southern Vermont Regional Airport (RUT) - US',
  id: 'RUT',
  obj: {
    iata: 'RUT',
    iso: 'US',
    coordinates: '-72.94960022, 43.52939987',
    municipality: 'Rutland'
  }
}, {
  label: 'Staroselye Airport (RYB) - RU',
  id: 'RYB',
  obj: {
    iata: 'RYB',
    iso: 'RU',
    coordinates: '38.92940139770508, 58.10419845581055',
    municipality: 'Rybinsk'
  }
}, {
  label: 'Rzesz\u00c3\u00b3w-Jasionka Airport (RZE) - PL',
  id: 'RZE',
  obj: {
    iata: 'RZE',
    iso: 'PL',
    coordinates: '22.018999, 50.110001',
    municipality: 'Rzesz\u00c3\u00b3w'
  }
}, {
  label: 'Bornholm Airport (RNN) - DK',
  id: 'RNN',
  obj: {
    iata: 'RNN',
    iso: 'DK',
    coordinates: '14.759599685668945, 55.06330108642578',
    municipality: 'R\u00c3\u00b8nne'
  }
}, {
  label: 'R\u00c3\u00b8ros Airport (RRS) - NO',
  id: 'RRS',
  obj: {
    iata: 'RRS',
    iso: 'NO',
    coordinates: '11.342300415039, 62.578399658203',
    municipality: 'R\u00c3\u00b8ros'
  }
}, {
  label: 'R\u00c3\u00b8rvik Airport, Ryum (RVK) - NO',
  id: 'RVK',
  obj: {
    iata: 'RVK',
    iso: 'NO',
    coordinates: '11.14610004425, 64.838302612305',
    municipality: 'R\u00c3\u00b8rvik'
  }
}, {
  label: 'Saarbr\u00c3\u00bccken Airport (SCN) - DE',
  id: 'SCN',
  obj: {
    iata: 'SCN',
    iso: 'DE',
    coordinates: '7.10950994492, 49.214599609400004',
    municipality: 'Saarbr\u00c3\u00bccken'
  }
}, {
  label: 'Sabetta International Airport (SBT) - RU',
  id: 'SBT',
  obj: {
    iata: 'SBT',
    iso: 'RU',
    coordinates: '72.052222, 71.219167',
    municipality: 'Sabetta'
  }
}, {
  label: 'Sabha Airport (SEB) - LY',
  id: 'SEB',
  obj: {
    iata: 'SEB',
    iso: 'LY',
    coordinates: '14.47249984741211, 26.98699951171875',
    municipality: 'Sabha'
  }
}, {
  label: 'Sabzevar National Airport (AFZ) - IR',
  id: 'AFZ',
  obj: {
    iata: 'AFZ',
    iso: 'IR',
    coordinates: '57.59519958496094, 36.16809844970703',
    municipality: 'Sabzevar'
  }
}, {
  label: 'Sacheon Air Base/Airport (HIN) - KR',
  id: 'HIN',
  obj: {
    iata: 'HIN',
    iso: 'KR',
    coordinates: '128.071747, 35.088591',
    municipality: 'Sacheon'
  }
}, {
  label: 'Sachigo Lake Airport (ZPB) - CA',
  id: 'ZPB',
  obj: {
    iata: 'ZPB',
    iso: 'CA',
    coordinates: '-92.19640350341797, 53.8911018371582',
    municipality: 'Sachigo Lake'
  }
}, {
  label: 'Sachs Harbour (David Nasogaluak Jr. Saaryuaq) Airport (YSY) - CA',
  id: 'YSY',
  obj: {
    iata: 'YSY',
    iso: 'CA',
    coordinates: '-125.242996216, 71.9938964844',
    municipality: 'Sachs Harbour'
  }
}, {
  label: 'Mc Clellan Airfield (MCC) - US',
  id: 'MCC',
  obj: {
    iata: 'MCC',
    iso: 'US',
    coordinates: '-121.401001, 38.66759872',
    municipality: 'Sacramento'
  }
}, {
  label: 'Sacramento Mather Airport (MHR) - US',
  id: 'MHR',
  obj: {
    iata: 'MHR',
    iso: 'US',
    coordinates: '-121.2979965, 38.55390167',
    municipality: 'Sacramento'
  }
}, {
  label: 'Sacramento Executive Airport (SAC) - US',
  id: 'SAC',
  obj: {
    iata: 'SAC',
    iso: 'US',
    coordinates: '-121.492996216, 38.5125007629',
    municipality: 'Sacramento'
  }
}, {
  label: 'Sacramento International Airport (SMF) - US',
  id: 'SMF',
  obj: {
    iata: 'SMF',
    iso: 'US',
    coordinates: '-121.59100341796875, 38.69540023803711',
    municipality: 'Sacramento'
  }
}, {
  label: 'Sado Airport (SDS) - JP',
  id: 'SDS',
  obj: {
    iata: 'SDS',
    iso: 'JP',
    coordinates: '138.414001465, 38.0601997375',
    municipality: 'Sado'
  }
}, {
  label: 'Saga Airport (HSG) - JP',
  id: 'HSG',
  obj: {
    iata: 'HSG',
    iso: 'JP',
    coordinates: '130.302001953, 33.149700164799995',
    municipality: 'Saga'
  }
}, {
  label: 'MBS International Airport (MBS) - US',
  id: 'MBS',
  obj: {
    iata: 'MBS',
    iso: 'US',
    coordinates: '-84.07959747314453, 43.532901763916016',
    municipality: 'Saginaw'
  }
}, {
  label: 'Saidpur Airport (SPD) - BD',
  id: 'SPD',
  obj: {
    iata: 'SPD',
    iso: 'BD',
    coordinates: '88.90889739990234, 25.759199142456055',
    municipality: 'Saidpur'
  }
}, {
  label: 'Saidu Sharif Airport (SDT) - PK',
  id: 'SDT',
  obj: {
    iata: 'SDT',
    iso: 'PK',
    coordinates: '72.35279846191406, 34.8135986328125',
    municipality: 'Saidu Sharif'
  }
}, {
  label: 'Alderney Airport (ACI) - GG',
  id: 'ACI',
  obj: {
    iata: 'ACI',
    iso: 'GG',
    coordinates: '-2.21472, 49.706104',
    municipality: 'Saint Anne'
  }
}, {
  label: 'Point Salines International Airport (GND) - GD',
  id: 'GND',
  obj: {
    iata: 'GND',
    iso: 'GD',
    coordinates: '-61.78620147705078, 12.004199981689453',
    municipality: "Saint George's"
  }
}, {
  label: 'Jersey Airport (JER) - JE',
  id: 'JER',
  obj: {
    iata: 'JER',
    iso: 'JE',
    coordinates: '-2.195509910583496, 49.20790100097656',
    municipality: 'Saint Helier'
  }
}, {
  label: 'Saint John Airport (YSJ) - CA',
  id: 'YSJ',
  obj: {
    iata: 'YSJ',
    iso: 'CA',
    coordinates: '-65.89029693603516, 45.31610107421875',
    municipality: 'Saint John'
  }
}, {
  label: 'Saint Louis Airport (XLS) - SN',
  id: 'XLS',
  obj: {
    iata: 'XLS',
    iso: 'SN',
    coordinates: '-16.463199615478516, 16.050800323486328',
    municipality: 'Saint Louis'
  }
}, {
  label: 'Princess Juliana International Airport (SXM) - SX',
  id: 'SXM',
  obj: {
    iata: 'SXM',
    iso: 'SX',
    coordinates: '-63.1088981628, 18.041000366200002',
    municipality: 'Saint Martin'
  }
}, {
  label: 'Guernsey Airport (GCI) - GG',
  id: 'GCI',
  obj: {
    iata: 'GCI',
    iso: 'GG',
    coordinates: '-2.6019699573516846, 49.435001373291016',
    municipality: 'Saint Peter Port'
  }
}, {
  label: 'Saint-Brieuc-Armor Airport (SBK) - FR',
  id: 'SBK',
  obj: {
    iata: 'SBK',
    iso: 'FR',
    coordinates: '-2.85444, 48.5378',
    municipality: 'Saint-Brieuc/Armor'
  }
}, {
  label: "Saint-Georges-de-l'Oyapock Airport (OYP) - GF",
  id: 'OYP',
  obj: {
    iata: 'OYP',
    iso: 'GF',
    coordinates: '-51.8041000366, 3.89759993553',
    municipality: "Saint-Georges-de-l'Oyapock Airport"
  }
}, {
  label: 'Saint-Nazaire-Montoir Airport (SNR) - FR',
  id: 'SNR',
  obj: {
    iata: 'SNR',
    iso: 'FR',
    coordinates: '-2.1566667, 47.3105556',
    municipality: 'Saint-Nazaire/Montoir'
  }
}, {
  label: 'St Pierre Airport (FSP) - PM',
  id: 'FSP',
  obj: {
    iata: 'FSP',
    iso: 'PM',
    coordinates: '-56.173099517822266, 46.762901306152344',
    municipality: 'Saint-Pierre'
  }
}, {
  label: 'Saint-Yan Airport (SYT) - FR',
  id: 'SYT',
  obj: {
    iata: 'SYT',
    iso: 'FR',
    coordinates: '4.0132598876953125, 46.412498474121094',
    municipality: 'Saint-Yan'
  }
}, {
  label: 'Grenoble-Is\u00c3\u00a8re Airport (GNB) - FR',
  id: 'GNB',
  obj: {
    iata: 'GNB',
    iso: 'FR',
    coordinates: '5.32937, 45.3629',
    municipality: 'Saint-\u00c3\u0089tienne-de-Saint-Geoirs'
  }
}, {
  label: 'Saint-\u00c3\u0089tienne-Bouth\u00c3\u00a9on Airport (EBU) - FR',
  id: 'EBU',
  obj: {
    iata: 'EBU',
    iso: 'FR',
    coordinates: '4.296390056610107, 45.54059982299805',
    municipality: 'Saint-\u00c3\u0089tienne/Bouth\u00c3\u00a9on'
  }
}, {
  label: 'Saipan International Airport (SPN) - MP',
  id: 'SPN',
  obj: {
    iata: 'SPN',
    iso: 'MP',
    coordinates: '145.729004, 15.119',
    municipality: 'Saipan Island'
  }
}, {
  label: 'Salalah Airport (SLL) - OM',
  id: 'SLL',
  obj: {
    iata: 'SLL',
    iso: 'OM',
    coordinates: '54.09130096435547, 17.038700103759766',
    municipality: 'Salalah'
  }
}, {
  label: 'Salamanca Airport (SLM) - ES',
  id: 'SLM',
  obj: {
    iata: 'SLM',
    iso: 'ES',
    coordinates: '-5.501989841461182, 40.95209884643555',
    municipality: 'Salamanca'
  }
}, {
  label: 'West Sale Airport (SXE) - AU',
  id: 'SXE',
  obj: {
    iata: 'SXE',
    iso: 'AU',
    coordinates: '146.965335, -38.090827',
    municipality: 'Sale'
  }
}, {
  label: 'Salekhard Airport (SLY) - RU',
  id: 'SLY',
  obj: {
    iata: 'SLY',
    iso: 'RU',
    coordinates: '66.61100006103516, 66.5907974243164',
    municipality: 'Salekhard'
  }
}, {
  label: 'Salem Municipal Airport/McNary Field (SLE) - US',
  id: 'SLE',
  obj: {
    iata: 'SLE',
    iso: 'US',
    coordinates: '-123.0029984, 44.90950012',
    municipality: 'Salem'
  }
}, {
  label: 'Salem Airport (SXV) - IN',
  id: 'SXV',
  obj: {
    iata: 'SXV',
    iso: 'IN',
    coordinates: '78.06559753418, 11.78330039978',
    municipality: 'Salem'
  }
}, {
  label: "Salerno Costa d'Amalfi Airport (QSR) - IT",
  id: 'QSR',
  obj: {
    iata: 'QSR',
    iso: 'IT',
    coordinates: '14.9113, 40.620399',
    municipality: 'Salerno'
  }
}, {
  label: 'Salina Municipal Airport (SLN) - US',
  id: 'SLN',
  obj: {
    iata: 'SLN',
    iso: 'US',
    coordinates: '-97.6521987915039, 38.79100036621094',
    municipality: 'Salina'
  }
}, {
  label: 'Salinas Municipal Airport (SNS) - US',
  id: 'SNS',
  obj: {
    iata: 'SNS',
    iso: 'US',
    coordinates: '-121.60600280762, 36.662799835205',
    municipality: 'Salinas'
  }
}, {
  label: 'General Ulpiano Paez Airport (SNC) - EC',
  id: 'SNC',
  obj: {
    iata: 'SNC',
    iso: 'EC',
    coordinates: '-80.988899, -2.20499',
    municipality: 'Salinas'
  }
}, {
  label: 'Salisbury Ocean City Wicomico Regional Airport (SBY) - US',
  id: 'SBY',
  obj: {
    iata: 'SBY',
    iso: 'US',
    coordinates: '-75.51029968261719, 38.34049987792969',
    municipality: 'Salisbury'
  }
}, {
  label: 'Salluit Airport (YZG) - CA',
  id: 'YZG',
  obj: {
    iata: 'YZG',
    iso: 'CA',
    coordinates: '-75.66719818115234, 62.17940139770508',
    municipality: 'Salluit'
  }
}, {
  label: 'Lemhi County Airport (SMN) - US',
  id: 'SMN',
  obj: {
    iata: 'SMN',
    iso: 'US',
    coordinates: '-113.880996704, 45.1237983704',
    municipality: 'Salmon'
  }
}, {
  label: 'Shuswap Regional Airport (YSN) - CA',
  id: 'YSN',
  obj: {
    iata: 'YSN',
    iso: 'CA',
    coordinates: '-119.228996, 50.682802',
    municipality: 'Salmon Arm'
  }
}, {
  label: 'Salt Lake City International Airport (SLC) - US',
  id: 'SLC',
  obj: {
    iata: 'SLC',
    iso: 'US',
    coordinates: '-111.97799682617188, 40.78839874267578',
    municipality: 'Salt Lake City'
  }
}, {
  label: 'Martin Miguel De Guemes International Airport (SLA) - AR',
  id: 'SLA',
  obj: {
    iata: 'SLA',
    iso: 'AR',
    coordinates: '-65.4861984253, -24.856000900299996',
    municipality: 'Salta'
  }
}, {
  label: 'Plan De Guadalupe International Airport (SLW) - MX',
  id: 'SLW',
  obj: {
    iata: 'SLW',
    iso: 'MX',
    coordinates: '-100.92900085449219, 25.54949951171875',
    municipality: 'Saltillo'
  }
}, {
  label: 'Nueva Hesperides International Airport (STY) - UY',
  id: 'STY',
  obj: {
    iata: 'STY',
    iso: 'UY',
    coordinates: '-57.98529815673828, -31.438499450683594',
    municipality: 'Salto'
  }
}, {
  label: 'Deputado Luiz Eduardo Magalh\u00c3\u00a3es International Airport (SSA) - BR',
  id: 'SSA',
  obj: {
    iata: 'SSA',
    iso: 'BR',
    coordinates: '-38.3224983215, -12.9086112976',
    municipality: 'Salvador'
  }
}, {
  label: 'Salzburg Airport (SZG) - AT',
  id: 'SZG',
  obj: {
    iata: 'SZG',
    iso: 'AT',
    coordinates: '13.0043001175, 47.793300628699996',
    municipality: 'Salzburg'
  }
}, {
  label: 'Saman\u00c3\u00a1 El Catey International Airport (AZS) - DO',
  id: 'AZS',
  obj: {
    iata: 'AZS',
    iso: 'DO',
    coordinates: '-69.7419967651, 19.2670001984',
    municipality: 'Samana'
  }
}, {
  label: 'Kurumoch International Airport (KUF) - RU',
  id: 'KUF',
  obj: {
    iata: 'KUF',
    iso: 'RU',
    coordinates: '50.16429901123, 53.504901885986',
    municipality: 'Samara'
  }
}, {
  label: 'Aji Pangeran Tumenggung Pranoto International Airport (AAP) - ID',
  id: 'AAP',
  obj: {
    iata: 'AAP',
    iso: 'ID',
    coordinates: '117.249392, -0.374448',
    municipality: 'Samarinda'
  }
}, {
  label: 'Samarkand Airport (SKD) - UZ',
  id: 'SKD',
  obj: {
    iata: 'SKD',
    iso: 'UZ',
    coordinates: '66.98380279541016, 39.70050048828125',
    municipality: 'Samarkand'
  }
}, {
  label: 'Samos Airport (SMI) - GR',
  id: 'SMI',
  obj: {
    iata: 'SMI',
    iso: 'GR',
    coordinates: '26.911699295043945, 37.689998626708984',
    municipality: 'Samos Island'
  }
}, {
  label: 'Gustavo Rojas Pinilla International Airport (ADZ) - CO',
  id: 'ADZ',
  obj: {
    iata: 'ADZ',
    iso: 'CO',
    coordinates: '-81.7112, 12.5836',
    municipality: 'San Andr\u00c3\u00a9s'
  }
}, {
  label: 'San Angelo Regional Mathis Field (SJT) - US',
  id: 'SJT',
  obj: {
    iata: 'SJT',
    iso: 'US',
    coordinates: '-100.49600219726562, 31.35770034790039',
    municipality: 'San Angelo'
  }
}, {
  label: 'San Antonio International Airport (SAT) - US',
  id: 'SAT',
  obj: {
    iata: 'SAT',
    iso: 'US',
    coordinates: '-98.469803, 29.533701',
    municipality: 'San Antonio'
  }
}, {
  label: 'Lackland Air Force Base (SKF) - US',
  id: 'SKF',
  obj: {
    iata: 'SKF',
    iso: 'US',
    coordinates: '-98.58110046, 29.38419914',
    municipality: 'San Antonio'
  }
}, {
  label: 'Stinson Municipal Airport (SSF) - US',
  id: 'SSF',
  obj: {
    iata: 'SSF',
    iso: 'US',
    coordinates: '-98.471099853516, 29.336999893188',
    municipality: 'San Antonio'
  }
}, {
  label: 'Mundo Maya International Airport (FRS) - GT',
  id: 'FRS',
  obj: {
    iata: 'FRS',
    iso: 'GT',
    coordinates: '-89.86640167239999, 16.913799285899998',
    municipality: 'San Benito'
  }
}, {
  label: 'San Bernardino International Airport (SBD) - US',
  id: 'SBD',
  obj: {
    iata: 'SBD',
    iso: 'US',
    coordinates: '-117.23500061, 34.0954017639',
    municipality: 'San Bernardino'
  }
}, {
  label: 'San Carlos De Bariloche Airport (BRC) - AR',
  id: 'BRC',
  obj: {
    iata: 'BRC',
    iso: 'AR',
    coordinates: '-71.157501, -41.151199',
    municipality: 'San Carlos de Bariloche'
  }
}, {
  label: 'Miramar Marine Corps Air Station - Mitscher Field (NKX) - US',
  id: 'NKX',
  obj: {
    iata: 'NKX',
    iso: 'US',
    coordinates: '-117.1429977, 32.86840057',
    municipality: 'San Diego'
  }
}, {
  label: 'North Island Naval Air Station-Halsey Field (NZY) - US',
  id: 'NZY',
  obj: {
    iata: 'NZY',
    iso: 'US',
    coordinates: '-117.2149963, 32.69919968',
    municipality: 'San Diego'
  }
}, {
  label: 'San Diego International Airport (SAN) - US',
  id: 'SAN',
  obj: {
    iata: 'SAN',
    iso: 'US',
    coordinates: '-117.190002441, 32.7336006165',
    municipality: 'San Diego'
  }
}, {
  label: 'Brown Field Municipal Airport (SDM) - US',
  id: 'SDM',
  obj: {
    iata: 'SDM',
    iso: 'US',
    coordinates: '-116.98000335693, 32.572299957275',
    municipality: 'San Diego'
  }
}, {
  label: 'Sub Teniente Nestor Arias Airport (SNF) - VE',
  id: 'SNF',
  obj: {
    iata: 'SNF',
    iso: 'VE',
    coordinates: '-68.755203, 10.2787',
    municipality: 'San Felipe'
  }
}, {
  label: 'San Fernando Airport (FDO) - AR',
  id: 'FDO',
  obj: {
    iata: 'FDO',
    iso: 'AR',
    coordinates: '-58.5896, -34.4532',
    municipality: 'San Fernando'
  }
}, {
  label: 'San Francisco International Airport (SFO) - US',
  id: 'SFO',
  obj: {
    iata: 'SFO',
    iso: 'US',
    coordinates: '-122.375, 37.61899948120117',
    municipality: 'San Francisco'
  }
}, {
  label: 'San Javier Airport (MJV) - ES',
  id: 'MJV',
  obj: {
    iata: 'MJV',
    iso: 'ES',
    coordinates: '-0.8123890161514282, 37.775001525878906',
    municipality: 'San Javier'
  }
}, {
  label: 'Norman Y. Mineta San Jose International Airport (SJC) - US',
  id: 'SJC',
  obj: {
    iata: 'SJC',
    iso: 'US',
    coordinates: '-121.929001, 37.362598',
    municipality: 'San Jose'
  }
}, {
  label: 'Juan Santamaria International Airport (SJO) - CR',
  id: 'SJO',
  obj: {
    iata: 'SJO',
    iso: 'CR',
    coordinates: '-84.20880126953125, 9.993860244750977',
    municipality: 'San Jose'
  }
}, {
  label: 'Tobias Bolanos International Airport (SYQ) - CR',
  id: 'SYQ',
  obj: {
    iata: 'SYQ',
    iso: 'CR',
    coordinates: '-84.13980102539062, 9.957050323486328',
    municipality: 'San Jose'
  }
}, {
  label: 'San Jose Airport (SJI) - PH',
  id: 'SJI',
  obj: {
    iata: 'SJI',
    iso: 'PH',
    coordinates: '121.04699707, 12.361499786399998',
    municipality: 'San Jose'
  }
}, {
  label: 'Evelio Javier Airport (EUQ) - PH',
  id: 'EUQ',
  obj: {
    iata: 'EUQ',
    iso: 'PH',
    coordinates: '121.932998657, 10.765999794',
    municipality: 'San Jose'
  }
}, {
  label: 'Jorge E. Gonzalez Torres Airport (SJE) - CO',
  id: 'SJE',
  obj: {
    iata: 'SJE',
    iso: 'CO',
    coordinates: '-72.6394, 2.57969',
    municipality: 'San Jos\u00c3\u00a9 Del Guaviare'
  }
}, {
  label: 'Los Cabos International Airport (SJD) - MX',
  id: 'SJD',
  obj: {
    iata: 'SJD',
    iso: 'MX',
    coordinates: '-109.72100067138672, 23.15180015563965',
    municipality: 'San Jos\u00c3\u00a9 del Cabo'
  }
}, {
  label: 'Domingo Faustino Sarmiento Airport (UAQ) - AR',
  id: 'UAQ',
  obj: {
    iata: 'UAQ',
    iso: 'AR',
    coordinates: '-68.418198, -31.571501',
    municipality: 'San Juan'
  }
}, {
  label: 'Fernando Luis Ribas Dominicci Airport (SIG) - PR',
  id: 'SIG',
  obj: {
    iata: 'SIG',
    iso: 'PR',
    coordinates: '-66.09809875488281, 18.45680046081543',
    municipality: 'San Juan'
  }
}, {
  label: 'Luis Munoz Marin International Airport (SJU) - PR',
  id: 'SJU',
  obj: {
    iata: 'SJU',
    iso: 'PR',
    coordinates: '-66.0018005371, 18.4393997192',
    municipality: 'San Juan'
  }
}, {
  label: 'Capitan D Daniel Vazquez Airport (ULA) - AR',
  id: 'ULA',
  obj: {
    iata: 'ULA',
    iso: 'AR',
    coordinates: '-67.8026, -49.3068',
    municipality: 'San Julian'
  }
}, {
  label: 'Brigadier Mayor D Cesar Raul Ojeda Airport (LUQ) - AR',
  id: 'LUQ',
  obj: {
    iata: 'LUQ',
    iso: 'AR',
    coordinates: '-66.3563995361, -33.2732009888',
    municipality: 'San Luis'
  }
}, {
  label: 'San Luis County Regional Airport (SBP) - US',
  id: 'SBP',
  obj: {
    iata: 'SBP',
    iso: 'US',
    coordinates: '-120.641998291, 35.236801147499996',
    municipality: 'San Luis Obispo'
  }
}, {
  label: 'Ponciano Arriaga International Airport (SLP) - MX',
  id: 'SLP',
  obj: {
    iata: 'SLP',
    iso: 'MX',
    coordinates: '-100.930999756, 22.254299163800003',
    municipality: 'San Luis Potos\u00c3\u00ad'
  }
}, {
  label: 'Teniente Benjamin Matienzo Airport (TUC) - AR',
  id: 'TUC',
  obj: {
    iata: 'TUC',
    iso: 'AR',
    coordinates: '-65.104897, -26.8409',
    municipality: 'San Miguel de Tucum\u00c3\u00a1n'
  }
}, {
  label: 'San Nicolas De Bari Airport (QSN) - CU',
  id: 'QSN',
  obj: {
    iata: 'QSN',
    iso: 'CU',
    coordinates: '-81.9208984375, 22.756099700927734',
    municipality: 'San Nicol\u00c3\u00a1s'
  }
}, {
  label: 'San Pedro Airport (SPR) - BZ',
  id: 'SPR',
  obj: {
    iata: 'SPR',
    iso: 'BZ',
    coordinates: '-87.9711, 17.9139',
    municipality: 'San Pedro'
  }
}, {
  label: 'Ram\u00c3\u00b3n Villeda Morales International Airport (SAP) - HN',
  id: 'SAP',
  obj: {
    iata: 'SAP',
    iso: 'HN',
    coordinates: '-87.923599, 15.4526',
    municipality: 'San Pedro Sula'
  }
}, {
  label: 'Suboficial Ay Santiago Germano Airport (AFA) - AR',
  id: 'AFA',
  obj: {
    iata: 'AFA',
    iso: 'AR',
    coordinates: '-68.4039, -34.588299',
    municipality: 'San Rafael'
  }
}, {
  label: 'San Salvador Airport (ZSA) - BS',
  id: 'ZSA',
  obj: {
    iata: 'ZSA',
    iso: 'BS',
    coordinates: '-74.52400207519531, 24.06329917907715',
    municipality: 'San Salvador'
  }
}, {
  label: 'Monse\u00c3\u00b1or \u00c3\u0093scar Arnulfo Romero International Airport (SAL) - SV',
  id: 'SAL',
  obj: {
    iata: 'SAL',
    iso: 'SV',
    coordinates: '-89.055702, 13.4409',
    municipality: 'San Salvador (San Luis Talpa)'
  }
}, {
  label: 'Gobernador Horacio Guzman International Airport (JUJ) - AR',
  id: 'JUJ',
  obj: {
    iata: 'JUJ',
    iso: 'AR',
    coordinates: '-65.097801, -24.392799',
    municipality: 'San Salvador de Jujuy'
  }
}, {
  label: 'Eduardo Falla Solano Airport (SVI) - CO',
  id: 'SVI',
  obj: {
    iata: 'SVI',
    iso: 'CO',
    coordinates: '-74.7663, 2.15217',
    municipality: 'San Vicente Del Cagu\u00c3\u00a1n'
  }
}, {
  label: "Sana'a International Airport (SAH) - YE",
  id: 'SAH',
  obj: {
    iata: 'SAH',
    iso: 'YE',
    coordinates: '44.21969985961914, 15.476300239562988',
    municipality: "Sana'a"
  }
}, {
  label: 'Henderson Field (MDY) - UM',
  id: 'MDY',
  obj: {
    iata: 'MDY',
    iso: 'UM',
    coordinates: '-177.38099670410156, 28.20170021057129',
    municipality: 'Sand Island'
  }
}, {
  label: 'Sand Point Airport (SDP) - US',
  id: 'SDP',
  obj: {
    iata: 'SDP',
    iso: 'US',
    coordinates: '-160.5229949951172, 55.314998626708984',
    municipality: 'Sand Point'
  }
}, {
  label: 'Sandakan Airport (SDK) - MY',
  id: 'SDK',
  obj: {
    iata: 'SDK',
    iso: 'MY',
    coordinates: '118.05899810791016, 5.900899887084961',
    municipality: 'Sandakan'
  }
}, {
  label: 'Sandspit Airport (YZP) - CA',
  id: 'YZP',
  obj: {
    iata: 'YZP',
    iso: 'CA',
    coordinates: '-131.813995361, 53.25429916379999',
    municipality: 'Sandspit'
  }
}, {
  label: 'Sandy Lake Airport (ZSJ) - CA',
  id: 'ZSJ',
  obj: {
    iata: 'ZSJ',
    iso: 'CA',
    coordinates: '-93.34439849853516, 53.06420135498047',
    municipality: 'Sandy Lake'
  }
}, {
  label: 'Sultan Babullah Airport (TTE) - ID',
  id: 'TTE',
  obj: {
    iata: 'TTE',
    iso: 'ID',
    coordinates: '127.380997, 0.831414',
    municipality: 'Sango-Ternate Island'
  }
}, {
  label: 'Sanikiluaq Airport (YSK) - CA',
  id: 'YSK',
  obj: {
    iata: 'YSK',
    iso: 'CA',
    coordinates: '-79.2466964722, 56.5377998352',
    municipality: 'Sanikiluaq'
  }
}, {
  label: 'Shaxian Airport (SQJ) - CN',
  id: 'SQJ',
  obj: {
    iata: 'SQJ',
    iso: 'CN',
    coordinates: '117.8336, 26.4263',
    municipality: 'Sanming'
  }
}, {
  label: 'John Wayne Airport-Orange County Airport (SNA) - US',
  id: 'SNA',
  obj: {
    iata: 'SNA',
    iso: 'US',
    coordinates: '-117.8679962, 33.67570114',
    municipality: 'Santa Ana'
  }
}, {
  label: 'Santa Ana Del Yacuma Airport (SBL) - BO',
  id: 'SBL',
  obj: {
    iata: 'SBL',
    iso: 'BO',
    coordinates: '-65.4352035522, -13.762200355500001',
    municipality: 'Santa Ana del Yacuma'
  }
}, {
  label: 'Santa Barbara Municipal Airport (SBA) - US',
  id: 'SBA',
  obj: {
    iata: 'SBA',
    iso: 'US',
    coordinates: '-119.8399963, 34.42620087',
    municipality: 'Santa Barbara'
  }
}, {
  label: 'Abel Santamaria Airport (SNU) - CU',
  id: 'SNU',
  obj: {
    iata: 'SNU',
    iso: 'CU',
    coordinates: '-79.943603515625, 22.49220085144043',
    municipality: 'Santa Clara'
  }
}, {
  label: 'Santa Cruz Airport (RZA) - AR',
  id: 'RZA',
  obj: {
    iata: 'RZA',
    iso: 'AR',
    coordinates: '-68.5792, -50.0165',
    municipality: 'Santa Cruz'
  }
}, {
  label: 'El Trompillo Airport (SRZ) - BO',
  id: 'SRZ',
  obj: {
    iata: 'SRZ',
    iso: 'BO',
    coordinates: '-63.1715011597, -17.8115997314',
    municipality: 'Santa Cruz'
  }
}, {
  label: 'Viru Viru International Airport (VVI) - BO',
  id: 'VVI',
  obj: {
    iata: 'VVI',
    iso: 'BO',
    coordinates: '-63.135399, -17.6448',
    municipality: 'Santa Cruz'
  }
}, {
  label: 'Graciosa Airport (GRW) - PT',
  id: 'GRW',
  obj: {
    iata: 'GRW',
    iso: 'PT',
    coordinates: '-28.029800415039062, 39.092201232910156',
    municipality: 'Santa Cruz da Graciosa'
  }
}, {
  label: 'Flores Airport (FLW) - PT',
  id: 'FLW',
  obj: {
    iata: 'FLW',
    iso: 'PT',
    coordinates: '-31.131399154663086, 39.455299377441406',
    municipality: 'Santa Cruz das Flores'
  }
}, {
  label: 'Santa Fe Municipal Airport (SAF) - US',
  id: 'SAF',
  obj: {
    iata: 'SAF',
    iso: 'US',
    coordinates: '-106.088996887, 35.617099762',
    municipality: 'Santa Fe'
  }
}, {
  label: 'Sauce Viejo Airport (SFN) - AR',
  id: 'SFN',
  obj: {
    iata: 'SFN',
    iso: 'AR',
    coordinates: '-60.8117, -31.7117',
    municipality: 'Santa Fe'
  }
}, {
  label: 'Santa Maria Pub/Capt G Allan Hancock Field (SMX) - US',
  id: 'SMX',
  obj: {
    iata: 'SMX',
    iso: 'US',
    coordinates: '-120.4570007, 34.89889908',
    municipality: 'Santa Maria'
  }
}, {
  label: 'Santa Maria Airport (RIA) - BR',
  id: 'RIA',
  obj: {
    iata: 'RIA',
    iso: 'BR',
    coordinates: '-53.688202, -29.711399',
    municipality: 'Santa Maria'
  }
}, {
  label: 'Sim\u00c3\u00b3n Bol\u00c3\u00advar International Airport (SMR) - CO',
  id: 'SMR',
  obj: {
    iata: 'SMR',
    iso: 'CO',
    coordinates: '-74.2306, 11.1196',
    municipality: 'Santa Marta'
  }
}, {
  label: 'Charles M. Schulz Sonoma County Airport (STS) - US',
  id: 'STS',
  obj: {
    iata: 'STS',
    iso: 'US',
    coordinates: '-122.8130035, 38.50899887',
    municipality: 'Santa Rosa'
  }
}, {
  label: 'Santa Rosa Airport (RSA) - AR',
  id: 'RSA',
  obj: {
    iata: 'RSA',
    iso: 'AR',
    coordinates: '-64.275703, -36.588299',
    municipality: 'Santa Rosa'
  }
}, {
  label: 'Santa Rosa International Airport (ETR) - EC',
  id: 'ETR',
  obj: {
    iata: 'ETR',
    iso: 'EC',
    coordinates: '-79.996957, -3.441986',
    municipality: 'Santa Rosa'
  }
}, {
  label: 'Santa Teresita Airport (SST) - AR',
  id: 'SST',
  obj: {
    iata: 'SST',
    iso: 'AR',
    coordinates: '-56.7218, -36.5423',
    municipality: 'Santa Teresita'
  }
}, {
  label: 'Santander Airport (SDR) - ES',
  id: 'SDR',
  obj: {
    iata: 'SDR',
    iso: 'ES',
    coordinates: '-3.82000994682312, 43.427101135253906',
    municipality: 'Santander'
  }
}, {
  label: 'Maestro Wilson Fonseca Airport (STM) - BR',
  id: 'STM',
  obj: {
    iata: 'STM',
    iso: 'BR',
    coordinates: '-54.785831451416016, -2.4247219562530518',
    municipality: 'Santar\u00c3\u00a9m'
  }
}, {
  label: 'Cibao International Airport (STI) - DO',
  id: 'STI',
  obj: {
    iata: 'STI',
    iso: 'DO',
    coordinates: '-70.60469818115234, 19.406099319458008',
    municipality: 'Santiago'
  }
}, {
  label: 'Ruben Cantu Airport (SYP) - PA',
  id: 'SYP',
  obj: {
    iata: 'SYP',
    iso: 'PA',
    coordinates: '-80.94529724121094, 8.085599899291992',
    municipality: 'Santiago'
  }
}, {
  label: 'Antonio Maceo International Airport (SCU) - CU',
  id: 'SCU',
  obj: {
    iata: 'SCU',
    iso: 'CU',
    coordinates: '-75.83540344238281, 19.96980094909668',
    municipality: 'Santiago'
  }
}, {
  label: 'Comodoro Arturo Merino Ben\u00c3\u00adtez International Airport (SCL) - CL',
  id: 'SCL',
  obj: {
    iata: 'SCL',
    iso: 'CL',
    coordinates: '-70.78579711914062, -33.393001556396484',
    municipality: 'Santiago'
  }
}, {
  label: 'Santiago de Compostela Airport (SCQ) - ES',
  id: 'SCQ',
  obj: {
    iata: 'SCQ',
    iso: 'ES',
    coordinates: '-8.415140151977539, 42.89630126953125',
    municipality: 'Santiago de Compostela'
  }
}, {
  label: 'Vicecomodoro Angel D. La Paz Aragon\u00c3\u00a9s Airport (SDE) - AR',
  id: 'SDE',
  obj: {
    iata: 'SDE',
    iso: 'AR',
    coordinates: '-64.3099975586, -27.765556335399996',
    municipality: 'Santiago del Estero'
  }
}, {
  label: 'Las Am\u00c3\u00a9ricas International Airport (SDQ) - DO',
  id: 'SDQ',
  obj: {
    iata: 'SDQ',
    iso: 'DO',
    coordinates: '-69.668899536133, 18.42970085144',
    municipality: 'Santo Domingo'
  }
}, {
  label: 'Mayor Buenaventura Vivas International Airport (STD) - VE',
  id: 'STD',
  obj: {
    iata: 'STD',
    iso: 'VE',
    coordinates: '-72.035103, 7.56538',
    municipality: 'Santo Domingo'
  }
}, {
  label: 'Santo \u00c3\u0082ngelo Airport (GEL) - BR',
  id: 'GEL',
  obj: {
    iata: 'GEL',
    iso: 'BR',
    coordinates: '-54.169102, -28.2817',
    municipality: 'Santo \u00c3\u0082ngelo'
  }
}, {
  label: 'Santorini Airport (JTR) - GR',
  id: 'JTR',
  obj: {
    iata: 'JTR',
    iso: 'GR',
    coordinates: '25.479299545288086, 36.399200439453125',
    municipality: 'Santorini Island'
  }
}, {
  label: 'Sanya Phoenix International Airport (SYX) - CN',
  id: 'SYX',
  obj: {
    iata: 'SYX',
    iso: 'CN',
    coordinates: '109.41200256347656, 18.302900314331055',
    municipality: 'Sanya'
  }
}, {
  label: 'Okadama Airport (OKD) - JP',
  id: 'OKD',
  obj: {
    iata: 'OKD',
    iso: 'JP',
    coordinates: '141.38134, 43.117447',
    municipality: 'Sapporo'
  }
}, {
  label: 'Sarajevo International Airport (SJJ) - BA',
  id: 'SJJ',
  obj: {
    iata: 'SJJ',
    iso: 'BA',
    coordinates: '18.331499099731445, 43.82460021972656',
    municipality: 'Sarajevo'
  }
}, {
  label: 'Sarakhs Airport (CKT) - IR',
  id: 'CKT',
  obj: {
    iata: 'CKT',
    iso: 'IR',
    coordinates: '61.06489944458008, 36.50120162963867',
    municipality: 'Sarakhs'
  }
}, {
  label: 'Adirondack Regional Airport (SLK) - US',
  id: 'SLK',
  obj: {
    iata: 'SLK',
    iso: 'US',
    coordinates: '-74.2061996459961, 44.38529968261719',
    municipality: 'Saranac Lake'
  }
}, {
  label: 'Saransk Airport (SKX) - RU',
  id: 'SKX',
  obj: {
    iata: 'SKX',
    iso: 'RU',
    coordinates: '45.212257385253906, 54.12512969970703',
    municipality: 'Saransk'
  }
}, {
  label: 'Sarasota Bradenton International Airport (SRQ) - US',
  id: 'SRQ',
  obj: {
    iata: 'SRQ',
    iso: 'US',
    coordinates: '-82.55439758300781, 27.39539909362793',
    municipality: 'Sarasota/Bradenton'
  }
}, {
  label: 'Saratov Central Airport (RTW) - RU',
  id: 'RTW',
  obj: {
    iata: 'RTW',
    iso: 'RU',
    coordinates: '46.04669952392578, 51.564998626708984',
    municipality: 'Saratov'
  }
}, {
  label: 'Mushaf Air Base (SGI) - PK',
  id: 'SGI',
  obj: {
    iata: 'SGI',
    iso: 'PK',
    coordinates: '72.66500091552734, 32.04859924316406',
    municipality: 'Sargodha'
  }
}, {
  label: 'Dasht-e Naz Airport (SRY) - IR',
  id: 'SRY',
  obj: {
    iata: 'SRY',
    iso: 'IR',
    coordinates: '53.193599700899995, 36.635799408',
    municipality: 'Sari'
  }
}, {
  label: 'Chris Hadfield Airport (YZR) - CA',
  id: 'YZR',
  obj: {
    iata: 'YZR',
    iso: 'CA',
    coordinates: '-82.30889892578125, 42.9994010925293',
    municipality: 'Sarnia'
  }
}, {
  label: 'Sartaneja Airport (SJX) - BZ',
  id: 'SJX',
  obj: {
    iata: 'SJX',
    iso: 'BZ',
    coordinates: '-88.13079833984375, 18.35610008239746',
    municipality: 'Sartaneja'
  }
}, {
  label: 'Sarzana-Luni Air Base (QLP) - IT',
  id: 'QLP',
  obj: {
    iata: 'QLP',
    iso: 'IT',
    coordinates: '9.98795, 44.088001',
    municipality: 'Sarzana (SP)'
  }
}, {
  label: 'Saskatoon John G. Diefenbaker International Airport (YXE) - CA',
  id: 'YXE',
  obj: {
    iata: 'YXE',
    iso: 'CA',
    coordinates: '-106.69999694824219, 52.170799255371094',
    municipality: 'Saskatoon'
  }
}, {
  label: 'Saskylakh Airport (SYS) - RU',
  id: 'SYS',
  obj: {
    iata: 'SYS',
    iso: 'RU',
    coordinates: '114.08000183105, 71.92790222168',
    municipality: 'Saskylakh'
  }
}, {
  label: 'Satu Mare Airport (SUJ) - RO',
  id: 'SUJ',
  obj: {
    iata: 'SUJ',
    iso: 'RO',
    coordinates: '22.885700225830078, 47.70330047607422',
    municipality: 'Satu Mare'
  }
}, {
  label: 'Sault Ste Marie Airport (YAM) - CA',
  id: 'YAM',
  obj: {
    iata: 'YAM',
    iso: 'CA',
    coordinates: '-84.509399, 46.485001',
    municipality: 'Sault Ste Marie'
  }
}, {
  label: 'Chippewa County International Airport (CIU) - US',
  id: 'CIU',
  obj: {
    iata: 'CIU',
    iso: 'US',
    coordinates: '-84.47239685058594, 46.25080108642578',
    municipality: 'Sault Ste Marie'
  }
}, {
  label: 'Saurimo Airport (VHC) - AO',
  id: 'VHC',
  obj: {
    iata: 'VHC',
    iso: 'AO',
    coordinates: '20.431900024414062, -9.689069747924805',
    municipality: 'Saurimo'
  }
}, {
  label: 'Savannah Hilton Head International Airport (SAV) - US',
  id: 'SAV',
  obj: {
    iata: 'SAV',
    iso: 'US',
    coordinates: '-81.20210266, 32.12760162',
    municipality: 'Savannah'
  }
}, {
  label: 'Hunter Army Air Field (SVN) - US',
  id: 'SVN',
  obj: {
    iata: 'SVN',
    iso: 'US',
    coordinates: '-81.14569855, 32.00999832',
    municipality: 'Savannah'
  }
}, {
  label: 'Savonlinna Airport (SVL) - FI',
  id: 'SVL',
  obj: {
    iata: 'SVL',
    iso: 'FI',
    coordinates: '28.945100784302, 61.943099975586',
    municipality: 'Savonlinna'
  }
}, {
  label: 'Savoonga Airport (SVA) - US',
  id: 'SVA',
  obj: {
    iata: 'SVA',
    iso: 'US',
    coordinates: '-170.4929962158203, 63.6864013671875',
    municipality: 'Savoonga'
  }
}, {
  label: 'Sayun International Airport (GXF) - YE',
  id: 'GXF',
  obj: {
    iata: 'GXF',
    iso: 'YE',
    coordinates: '48.78829956049999, 15.9660997391',
    municipality: 'Sayun'
  }
}, {
  label: 'Scammon Bay Airport (SCM) - US',
  id: 'SCM',
  obj: {
    iata: 'SCM',
    iso: 'US',
    coordinates: '-165.570999146, 61.845298767100005',
    municipality: 'Scammon Bay'
  }
}, {
  label: 'RAF Scampton (SQZ) - GB',
  id: 'SQZ',
  obj: {
    iata: 'SQZ',
    iso: 'GB',
    coordinates: '-0.550832986832, 53.307800293',
    municipality: 'Scampton'
  }
}, {
  label: 'Tobago-Crown Point Airport (TAB) - TT',
  id: 'TAB',
  obj: {
    iata: 'TAB',
    iso: 'TT',
    coordinates: '-60.83219909667969, 11.149700164794922',
    municipality: 'Scarborough'
  }
}, {
  label: 'Schefferville Airport (YKL) - CA',
  id: 'YKL',
  obj: {
    iata: 'YKL',
    iso: 'CA',
    coordinates: '-66.8052978515625, 54.805301666259766',
    municipality: 'Schefferville'
  }
}, {
  label: 'Schenectady County Airport (SCH) - US',
  id: 'SCH',
  obj: {
    iata: 'SCH',
    iso: 'US',
    coordinates: '-73.928901672363, 42.852500915527',
    municipality: 'Schenectady'
  }
}, {
  label: 'Western Neb. Rgnl/William B. Heilig Airport (BFF) - US',
  id: 'BFF',
  obj: {
    iata: 'BFF',
    iso: 'US',
    coordinates: '-103.5960007, 41.87400055',
    municipality: 'Scottsbluff'
  }
}, {
  label: 'Boeing Field King County International Airport (BFI) - US',
  id: 'BFI',
  obj: {
    iata: 'BFI',
    iso: 'US',
    coordinates: '-122.302001953125, 47.529998779296875',
    municipality: 'Seattle'
  }
}, {
  label: 'Seattle Tacoma International Airport (SEA) - US',
  id: 'SEA',
  obj: {
    iata: 'SEA',
    iso: 'US',
    coordinates: '-122.308998, 47.449001',
    municipality: 'Seattle'
  }
}, {
  label: 'Secunda Airport (ZEC) - ZA',
  id: 'ZEC',
  obj: {
    iata: 'ZEC',
    iso: 'ZA',
    coordinates: '29.170099258399997, -26.52409935',
    municipality: 'Secunda'
  }
}, {
  label: 'Sehwan Sharif Airport (SYW) - PK',
  id: 'SYW',
  obj: {
    iata: 'SYW',
    iso: 'PK',
    coordinates: '67.71720123291016, 26.473100662231445',
    municipality: 'Sehwan Sharif'
  }
}, {
  label: 'Sein\u00c3\u00a4joki Airport (SJY) - FI',
  id: 'SJY',
  obj: {
    iata: 'SJY',
    iso: 'FI',
    coordinates: '22.8323, 62.692101',
    municipality: 'Sein\u00c3\u00a4joki / Ilmajoki'
  }
}, {
  label: 'Takoradi Airport (TKD) - GH',
  id: 'TKD',
  obj: {
    iata: 'TKD',
    iso: 'GH',
    coordinates: '-1.7747600078582764, 4.896059989929199',
    municipality: 'Sekondi-Takoradi'
  }
}, {
  label: 'Selawik Airport (WLK) - US',
  id: 'WLK',
  obj: {
    iata: 'WLK',
    iso: 'US',
    coordinates: '-159.9859924, 66.60009766',
    municipality: 'Selawik'
  }
}, {
  label: 'Seletar Airport (XSP) - SG',
  id: 'XSP',
  obj: {
    iata: 'XSP',
    iso: 'SG',
    coordinates: '103.86799621582031, 1.416949987411499',
    municipality: 'Seletar'
  }
}, {
  label: 'Semipalatinsk Airport (PLX) - KZ',
  id: 'PLX',
  obj: {
    iata: 'PLX',
    iso: 'KZ',
    coordinates: '80.234398, 50.351295',
    municipality: 'Semey'
  }
}, {
  label: 'Sendai Airport (SDJ) - JP',
  id: 'SDJ',
  obj: {
    iata: 'SDJ',
    iso: 'JP',
    coordinates: '140.917007446, 38.1397018433',
    municipality: 'Sendai'
  }
}, {
  label: 'Incheon International Airport (ICN) - KR',
  id: 'ICN',
  obj: {
    iata: 'ICN',
    iso: 'KR',
    coordinates: '126.45099639892578, 37.46910095214844',
    municipality: 'Seoul'
  }
}, {
  label: 'Gimpo International Airport (GMP) - KR',
  id: 'GMP',
  obj: {
    iata: 'GMP',
    iso: 'KR',
    coordinates: '126.791, 37.5583',
    municipality: 'Seoul'
  }
}, {
  label: 'Sept-\u00c3\u008eles Airport (YZV) - CA',
  id: 'YZV',
  obj: {
    iata: 'YZV',
    iso: 'CA',
    coordinates: '-66.2656021118164, 50.22330093383789',
    municipality: 'Sept-\u00c3\u008eles'
  }
}, {
  label: 'Belbek Airport (UKS) - UA',
  id: 'UKS',
  obj: {
    iata: 'UKS',
    iso: 'UA',
    coordinates: '33.570999145500004, 44.688999176',
    municipality: 'Sevastopol'
  }
}, {
  label: 'Sevilla Airport (SVQ) - ES',
  id: 'SVQ',
  obj: {
    iata: 'SVQ',
    iso: 'ES',
    coordinates: '-5.8931097984313965, 37.417999267578125',
    municipality: 'Sevilla'
  }
}, {
  label: 'Seward Airport (SWD) - US',
  id: 'SWD',
  obj: {
    iata: 'SWD',
    iso: 'US',
    coordinates: '-149.41900634765625, 60.12689971923828',
    municipality: 'Seward'
  }
}, {
  label: 'Sfax Thyna International Airport (SFA) - TN',
  id: 'SFA',
  obj: {
    iata: 'SFA',
    iso: 'TN',
    coordinates: '10.690999984741211, 34.71799850463867',
    municipality: 'Sfax'
  }
}, {
  label: 'Shahrekord Airport (CQD) - IR',
  id: 'CQD',
  obj: {
    iata: 'CQD',
    iso: 'IR',
    coordinates: '50.842201232899995, 32.2971992493',
    municipality: 'Shahrekord'
  }
}, {
  label: 'Shamattawa Airport (ZTM) - CA',
  id: 'ZTM',
  obj: {
    iata: 'ZTM',
    iso: 'CA',
    coordinates: '-92.0813980102539, 55.8656005859375',
    municipality: 'Shamattawa'
  }
}, {
  label: 'Kinmen Airport (KNH) - TW',
  id: 'KNH',
  obj: {
    iata: 'KNH',
    iso: 'TW',
    coordinates: '118.359001, 24.4279',
    municipality: 'Shang-I'
  }
}, {
  label: 'Shangrao Sanqingshan Airport (SQD) - CN',
  id: 'SQD',
  obj: {
    iata: 'SQD',
    iso: 'CN',
    coordinates: '117.9643, 28.3797',
    municipality: 'Shangrao'
  }
}, {
  label: 'Shannon Airport (SNN) - IE',
  id: 'SNN',
  obj: {
    iata: 'SNN',
    iso: 'IE',
    coordinates: '-8.92482, 52.702',
    municipality: 'Shannon'
  }
}, {
  label: 'Jieyang Chaoshan International Airport (SWA) - CN',
  id: 'SWA',
  obj: {
    iata: 'SWA',
    iso: 'CN',
    coordinates: '116.5033, 23.552',
    municipality: 'Shantou'
  }
}, {
  label: 'Shaoguan Guitou Airport (HSC) - CN',
  id: 'HSC',
  obj: {
    iata: 'HSC',
    iso: 'CN',
    coordinates: '113.42099762, 24.9785995483',
    municipality: 'Shaoguan'
  }
}, {
  label: 'Shaoyang Wugang Airport (WGN) - CN',
  id: 'WGN',
  obj: {
    iata: 'WGN',
    iso: 'CN',
    coordinates: '110.642, 26.802',
    municipality: 'Shaoyang'
  }
}, {
  label: 'Sharjah International Airport (SHJ) - AE',
  id: 'SHJ',
  obj: {
    iata: 'SHJ',
    iso: 'AE',
    coordinates: '55.5172004699707, 25.32859992980957',
    municipality: 'Sharjah'
  }
}, {
  label: 'Sharm El Sheikh International Airport (SSH) - EG',
  id: 'SSH',
  obj: {
    iata: 'SSH',
    iso: 'EG',
    coordinates: '34.3950004578, 27.9773006439',
    municipality: 'Sharm el-Sheikh'
  }
}, {
  label: 'Eareckson Air Station (SYA) - US',
  id: 'SYA',
  obj: {
    iata: 'SYA',
    iso: 'US',
    coordinates: '174.1139984, 52.71229935',
    municipality: 'Shemya'
  }
}, {
  label: 'Shennongjia Hongping Airport (HPG) - CN',
  id: 'HPG',
  obj: {
    iata: 'HPG',
    iso: 'CN',
    coordinates: '110.34, 31.626',
    municipality: 'Shennongjia'
  }
}, {
  label: "Shenzhen Bao'an International Airport (SZX) - CN",
  id: 'SZX',
  obj: {
    iata: 'SZX',
    iso: 'CN',
    coordinates: '113.81099700927734, 22.639299392700195',
    municipality: 'Shenzhen'
  }
}, {
  label: 'Sherbrooke Airport (YSC) - CA',
  id: 'YSC',
  obj: {
    iata: 'YSC',
    iso: 'CA',
    coordinates: '-71.69139862060547, 45.4385986328125',
    municipality: 'Sherbrooke'
  }
}, {
  label: 'Sheridan County Airport (SHR) - US',
  id: 'SHR',
  obj: {
    iata: 'SHR',
    iso: 'US',
    coordinates: '-106.9800033569336, 44.76919937133789',
    municipality: 'Sheridan'
  }
}, {
  label: 'Scatsta Airport (SCS) - GB',
  id: 'SCS',
  obj: {
    iata: 'SCS',
    iso: 'GB',
    coordinates: '-1.2961100339889526, 60.43280029296875',
    municipality: 'Shetland Islands'
  }
}, {
  label: 'Shijiazhuang Daguocun International Airport (SJW) - CN',
  id: 'SJW',
  obj: {
    iata: 'SJW',
    iso: 'CN',
    coordinates: '114.6969985961914, 38.28070068359375',
    municipality: 'Shijiazhuang'
  }
}, {
  label: 'Shillong Airport (SHL) - IN',
  id: 'SHL',
  obj: {
    iata: 'SHL',
    iso: 'IN',
    coordinates: '91.97869873046875, 25.70359992980957',
    municipality: 'Shillong'
  }
}, {
  label: 'Shimojishima Airport (SHI) - JP',
  id: 'SHI',
  obj: {
    iata: 'SHI',
    iso: 'JP',
    coordinates: '125.144996643, 24.8267002106',
    municipality: 'Shimojishima'
  }
}, {
  label: 'Nanki Shirahama Airport (SHM) - JP',
  id: 'SHM',
  obj: {
    iata: 'SHM',
    iso: 'JP',
    coordinates: '135.363998413, 33.6622009277',
    municipality: 'Shirahama'
  }
}, {
  label: 'Shiraz Shahid Dastghaib International Airport (SYZ) - IR',
  id: 'SYZ',
  obj: {
    iata: 'SYZ',
    iso: 'IR',
    coordinates: '52.589802, 29.5392',
    municipality: 'Shiraz'
  }
}, {
  label: 'Shirdi Airport (SAG) - IN',
  id: 'SAG',
  obj: {
    iata: 'SAG',
    iso: 'IN',
    coordinates: '74.378889, 19.688611',
    municipality: 'Shirdi'
  }
}, {
  label: 'Shishmaref Airport (SHH) - US',
  id: 'SHH',
  obj: {
    iata: 'SHH',
    iso: 'US',
    coordinates: '-166.089112, 66.249604',
    municipality: 'Shishmaref'
  }
}, {
  label: 'Shiyan Wudangshan Airport (WDS) - CN',
  id: 'WDS',
  obj: {
    iata: 'WDS',
    iso: 'CN',
    coordinates: '110.907778, 32.591667',
    municipality: 'Shiyan'
  }
}, {
  label: 'Shonai Airport (SYO) - JP',
  id: 'SYO',
  obj: {
    iata: 'SYO',
    iso: 'JP',
    coordinates: '139.787002563, 38.81219863889999',
    municipality: 'Shonai'
  }
}, {
  label: 'Shreveport Regional Airport (SHV) - US',
  id: 'SHV',
  obj: {
    iata: 'SHV',
    iso: 'US',
    coordinates: '-93.8256, 32.446602',
    municipality: 'Shreveport'
  }
}, {
  label: 'Shymkent Airport (CIT) - KZ',
  id: 'CIT',
  obj: {
    iata: 'CIT',
    iso: 'KZ',
    coordinates: '69.47889709472656, 42.364200592041016',
    municipality: 'Shymkent'
  }
}, {
  label: 'Sialkot Airport (SKT) - PK',
  id: 'SKT',
  obj: {
    iata: 'SKT',
    iso: 'PK',
    coordinates: '74.3638916016, 32.5355567932',
    municipality: 'Sialkot'
  }
}, {
  label: 'Sibiu International Airport (SBZ) - RO',
  id: 'SBZ',
  obj: {
    iata: 'SBZ',
    iso: 'RO',
    coordinates: '24.091299057006836, 45.78559875488281',
    municipality: 'Sibiu'
  }
}, {
  label: 'Sibu Airport (SBW) - MY',
  id: 'SBW',
  obj: {
    iata: 'SBW',
    iso: 'MY',
    coordinates: '111.98500061035156, 2.2616000175476074',
    municipality: 'Sibu'
  }
}, {
  label: 'Sidney - Richland Regional Airport (SDY) - US',
  id: 'SDY',
  obj: {
    iata: 'SDY',
    iso: 'US',
    coordinates: '-104.193001, 47.706902',
    municipality: 'Sidney'
  }
}, {
  label: 'Sidney Municipal-Lloyd W Carr Field (SNY) - US',
  id: 'SNY',
  obj: {
    iata: 'SNY',
    iso: 'US',
    coordinates: '-102.9850006, 41.10129929',
    municipality: 'Sidney'
  }
}, {
  label: 'Siem Reap International Airport (REP) - KH',
  id: 'REP',
  obj: {
    iata: 'REP',
    iso: 'KH',
    coordinates: '103.81300354, 13.410699844400002',
    municipality: 'Siem Reap'
  }
}, {
  label: 'Siena-Ampugnano Airport (SAY) - IT',
  id: 'SAY',
  obj: {
    iata: 'SAY',
    iso: 'IT',
    coordinates: '11.255, 43.256302',
    municipality: 'Siena'
  }
}, {
  label: 'Siglufj\u00c3\u00b6r\u00c3\u00b0ur Airport (SIJ) - IS',
  id: 'SIJ',
  obj: {
    iata: 'SIJ',
    iso: 'IS',
    coordinates: '-18.9167, 66.133301',
    municipality: 'Siglufj\u00c3\u00b6r\u00c3\u00b0ur'
  }
}, {
  label: 'Sigonella Navy Air Base (NSY) - IT',
  id: 'NSY',
  obj: {
    iata: 'NSY',
    iso: 'IT',
    coordinates: '14.9224, 37.401699',
    municipality: 'Sigonella (CT)'
  }
}, {
  label: 'Siirt Airport (SXZ) - TR',
  id: 'SXZ',
  obj: {
    iata: 'SXZ',
    iso: 'TR',
    coordinates: '41.84040069580078, 37.97890090942383',
    municipality: 'Siirt'
  }
}, {
  label: 'Del Baj\u00c3\u00ado International Airport (BJX) - MX',
  id: 'BJX',
  obj: {
    iata: 'BJX',
    iso: 'MX',
    coordinates: '-101.481003, 20.9935',
    municipality: 'Silao'
  }
}, {
  label: 'Silchar Airport (IXS) - IN',
  id: 'IXS',
  obj: {
    iata: 'IXS',
    iso: 'IN',
    coordinates: '92.97869873050001, 24.9129009247',
    municipality: 'Silchar'
  }
}, {
  label: 'Bagdogra Airport (IXB) - IN',
  id: 'IXB',
  obj: {
    iata: 'IXB',
    iso: 'IN',
    coordinates: '88.32859802246094, 26.68120002746582',
    municipality: 'Siliguri'
  }
}, {
  label: 'Simferopol International Airport (SIP) - UA',
  id: 'SIP',
  obj: {
    iata: 'SIP',
    iso: 'UA',
    coordinates: '33.975101, 45.0522',
    municipality: 'Simferopol'
  }
}, {
  label: 'Seoul Air Base (K-16) (SSN) - KR',
  id: 'SSN',
  obj: {
    iata: 'SSN',
    iso: 'KR',
    coordinates: '127.112718, 37.444744',
    municipality: 'Simgok-dong'
  }
}, {
  label: 'Sindal Airport (CNL) - DK',
  id: 'CNL',
  obj: {
    iata: 'CNL',
    iso: 'DK',
    coordinates: '10.2294, 57.503502',
    municipality: 'Sindal'
  }
}, {
  label: 'Singapore Changi Airport (SIN) - SG',
  id: 'SIN',
  obj: {
    iata: 'SIN',
    iso: 'SG',
    coordinates: '103.994003, 1.35019',
    municipality: 'Singapore'
  }
}, {
  label: 'F. D. Roosevelt Airport (EUX) - BQ',
  id: 'EUX',
  obj: {
    iata: 'EUX',
    iso: 'BQ',
    coordinates: '-62.979400634765625, 17.49650001525879',
    municipality: 'Sint Eustatius'
  }
}, {
  label: 'Sintang(Susilo) Airport (SQG) - ID',
  id: 'SQG',
  obj: {
    iata: 'SQG',
    iso: 'ID',
    coordinates: '111.4729995727539, 0.06361900269985199',
    municipality: 'Sintang-Borneo Island'
  }
}, {
  label: 'Sion Airport (SIR) - CH',
  id: 'SIR',
  obj: {
    iata: 'SIR',
    iso: 'CH',
    coordinates: '7.326944, 46.219166',
    municipality: 'Sion'
  }
}, {
  label: 'Sioux Gateway Airport/Brigadier General Bud Day Field (SUX) - US',
  id: 'SUX',
  obj: {
    iata: 'SUX',
    iso: 'US',
    coordinates: '-96.384399, 42.402599',
    municipality: 'Sioux City'
  }
}, {
  label: 'Joe Foss Field Airport (FSD) - US',
  id: 'FSD',
  obj: {
    iata: 'FSD',
    iso: 'US',
    coordinates: '-96.741897583, 43.582000732400004',
    municipality: 'Sioux Falls'
  }
}, {
  label: 'Sioux Lookout Airport (YXL) - CA',
  id: 'YXL',
  obj: {
    iata: 'YXL',
    iso: 'CA',
    coordinates: '-91.9052963256836, 50.11389923095703',
    municipality: 'Sioux Lookout'
  }
}, {
  label: 'Gardabya Airport (SRX) - LY',
  id: 'SRX',
  obj: {
    iata: 'SRX',
    iso: 'LY',
    coordinates: '16.5949993134, 31.063499450699997',
    municipality: 'Sirt'
  }
}, {
  label: 'Sishen Airport (SIS) - ZA',
  id: 'SIS',
  obj: {
    iata: 'SIS',
    iso: 'ZA',
    coordinates: '22.9993000031, -27.6485996246',
    municipality: 'Sishen'
  }
}, {
  label: 'Sisimiut Airport (JHS) - GL',
  id: 'JHS',
  obj: {
    iata: 'JHS',
    iso: 'GL',
    coordinates: '-53.729301, 66.951302',
    municipality: 'Sisimiut'
  }
}, {
  label: 'Sitka Rocky Gutierrez Airport (SIT) - US',
  id: 'SIT',
  obj: {
    iata: 'SIT',
    iso: 'US',
    coordinates: '-135.36199951171875, 57.04710006713867',
    municipality: 'Sitka'
  }
}, {
  label: 'Sittwe Airport (AKY) - MM',
  id: 'AKY',
  obj: {
    iata: 'AKY',
    iso: 'MM',
    coordinates: '92.87259674072266, 20.132699966430664',
    municipality: 'Sittwe'
  }
}, {
  label: 'Skardu Airport (KDU) - PK',
  id: 'KDU',
  obj: {
    iata: 'KDU',
    iso: 'PK',
    coordinates: '75.53600311279297, 35.33549880981445',
    municipality: 'Skardu'
  }
}, {
  label: 'Skellefte\u00c3\u00a5 Airport (SFT) - SE',
  id: 'SFT',
  obj: {
    iata: 'SFT',
    iso: 'SE',
    coordinates: '21.076900482177734, 64.62480163574219',
    municipality: 'Skellefte\u00c3\u00a5'
  }
}, {
  label: 'Skiathos Island National Airport (JSI) - GR',
  id: 'JSI',
  obj: {
    iata: 'JSI',
    iso: 'GR',
    coordinates: '23.503700256347656, 39.177101135253906',
    municipality: 'Skiathos'
  }
}, {
  label: 'Skive Airport (SQW) - DK',
  id: 'SQW',
  obj: {
    iata: 'SQW',
    iso: 'DK',
    coordinates: '9.172980308532715, 56.550201416015625',
    municipality: 'Skive'
  }
}, {
  label: 'Stauning Airport (STA) - DK',
  id: 'STA',
  obj: {
    iata: 'STA',
    iso: 'DK',
    coordinates: '8.353910446166992, 55.9901008605957',
    municipality: 'Skjern / Ringk\u00c3\u00b8bing'
  }
}, {
  label: 'Skopje International Airport (SKP) - MK',
  id: 'SKP',
  obj: {
    iata: 'SKP',
    iso: 'MK',
    coordinates: '21.621401, 41.961601',
    municipality: 'Skopje'
  }
}, {
  label: 'Skukuza Airport (SZK) - ZA',
  id: 'SZK',
  obj: {
    iata: 'SZK',
    iso: 'ZA',
    coordinates: '31.5886993408, -24.960899353',
    municipality: 'Skukuza'
  }
}, {
  label: 'Sk\u00c3\u00b6vde Airport (KVB) - SE',
  id: 'KVB',
  obj: {
    iata: 'KVB',
    iso: 'SE',
    coordinates: '13.972700119018555, 58.45640182495117',
    municipality: 'Sk\u00c3\u00b6vde'
  }
}, {
  label: 'Slave Lake Airport (YZH) - CA',
  id: 'YZH',
  obj: {
    iata: 'YZH',
    iso: 'CA',
    coordinates: '-114.777000427, 55.2930984497',
    municipality: 'Slave Lake'
  }
}, {
  label: 'Slia\u00c4\u008d Airport (SLD) - SK',
  id: 'SLD',
  obj: {
    iata: 'SLD',
    iso: 'SK',
    coordinates: '19.13409996032715, 48.63779830932617',
    municipality: 'Slia\u00c4\u008d'
  }
}, {
  label: 'Sligo Airport (SXL) - IE',
  id: 'SXL',
  obj: {
    iata: 'SXL',
    iso: 'IE',
    coordinates: '-8.5992097854614, 54.280200958252',
    municipality: 'Sligo'
  }
}, {
  label: 'Smara Airport (SMW) - EH',
  id: 'SMW',
  obj: {
    iata: 'SMW',
    iso: 'EH',
    coordinates: '-11.6847, 26.7318',
    municipality: 'Smara'
  }
}, {
  label: 'Smithers Airport (YYD) - CA',
  id: 'YYD',
  obj: {
    iata: 'YYD',
    iso: 'CA',
    coordinates: '-127.18299865722656, 54.82469940185547',
    municipality: 'Smithers'
  }
}, {
  label: 'Smiths Falls-Montague (Russ Beach) Airport (YSH) - CA',
  id: 'YSH',
  obj: {
    iata: 'YSH',
    iso: 'CA',
    coordinates: '-75.94059753417969, 44.94580078125',
    municipality: 'Smiths Falls'
  }
}, {
  label: 'Smolensk North Airport (LNX) - RU',
  id: 'LNX',
  obj: {
    iata: 'LNX',
    iso: 'RU',
    coordinates: '32.025, 54.824',
    municipality: 'Smolensk'
  }
}, {
  label: 'Smyrna Airport (MQY) - US',
  id: 'MQY',
  obj: {
    iata: 'MQY',
    iso: 'US',
    coordinates: '-86.5201034546, 36.0089988708',
    municipality: 'Smyrna'
  }
}, {
  label: 'Sochi International Airport (AER) - RU',
  id: 'AER',
  obj: {
    iata: 'AER',
    iso: 'RU',
    coordinates: '39.9566, 43.449902',
    municipality: 'Sochi'
  }
}, {
  label: 'Socotra International Airport (SCT) - YE',
  id: 'SCT',
  obj: {
    iata: 'SCT',
    iso: 'YE',
    coordinates: '53.905799865722656, 12.63070011138916',
    municipality: 'Socotra Islands'
  }
}, {
  label: 'Sodankyla Airport (SOT) - FI',
  id: 'SOT',
  obj: {
    iata: 'SOT',
    iso: 'FI',
    coordinates: '26.6191005707, 67.3949966431',
    municipality: 'Sodankyla'
  }
}, {
  label: 'Sofia Airport (SOF) - BG',
  id: 'SOF',
  obj: {
    iata: 'SOF',
    iso: 'BG',
    coordinates: '23.411436080932617, 42.696693420410156',
    municipality: 'Sofia'
  }
}, {
  label: 'Sohag International Airport (HMB) - EG',
  id: 'HMB',
  obj: {
    iata: 'HMB',
    iso: 'EG',
    coordinates: '31.742778, 26.342778',
    municipality: 'Sohag'
  }
}, {
  label: 'Sadiq Abubakar III International Airport (SKO) - NG',
  id: 'SKO',
  obj: {
    iata: 'SKO',
    iso: 'NG',
    coordinates: '5.207190036773682, 12.916299819946289',
    municipality: 'Sokoto'
  }
}, {
  label: 'Solapur Airport (SSE) - IN',
  id: 'SSE',
  obj: {
    iata: 'SSE',
    iso: 'IN',
    coordinates: '75.93479919430001, 17.6280002594',
    municipality: 'Solapur'
  }
}, {
  label: 'Soldotna Airport (SXQ) - US',
  id: 'SXQ',
  obj: {
    iata: 'SXQ',
    iso: 'US',
    coordinates: '-151.03399658203125, 60.47570037841797',
    municipality: 'Soldotna'
  }
}, {
  label: 'Solenzara (BA 126) Air Base (SOZ) - FR',
  id: 'SOZ',
  obj: {
    iata: 'SOZ',
    iso: 'FR',
    coordinates: '9.406000137329102, 41.924400329589844',
    municipality: 'Solenzara'
  }
}, {
  label: 'Lake Cumberland Regional Airport (SME) - US',
  id: 'SME',
  obj: {
    iata: 'SME',
    iso: 'US',
    coordinates: '-84.6158981323, 37.053398132299996',
    municipality: 'Somerset'
  }
}, {
  label: 'Dominique Edward Osok Airport (SOQ) - ID',
  id: 'SOQ',
  obj: {
    iata: 'SOQ',
    iso: 'ID',
    coordinates: '131.287, -0.894',
    municipality: 'Sorong-Papua Island'
  }
}, {
  label: 'Soroti Airport (SRT) - UG',
  id: 'SRT',
  obj: {
    iata: 'SRT',
    iso: 'UG',
    coordinates: '33.622798919677734, 1.7276899814605713',
    municipality: 'Soroti'
  }
}, {
  label: 'Chania International Airport (CHQ) - GR',
  id: 'CHQ',
  obj: {
    iata: 'CHQ',
    iso: 'GR',
    coordinates: '24.149700164794922, 35.531700134277344',
    municipality: 'Souda'
  }
}, {
  label: 'South Bend Regional Airport (SBN) - US',
  id: 'SBN',
  obj: {
    iata: 'SBN',
    iso: 'US',
    coordinates: '-86.31729888916016, 41.70869827270508',
    municipality: 'South Bend'
  }
}, {
  label: 'South Bimini Airport (BIM) - BS',
  id: 'BIM',
  obj: {
    iata: 'BIM',
    iso: 'BS',
    coordinates: '-79.2647018433, 25.6998996735',
    municipality: 'South Bimini'
  }
}, {
  label: 'South Indian Lake Airport (XSI) - CA',
  id: 'XSI',
  obj: {
    iata: 'XSI',
    iso: 'CA',
    coordinates: '-98.9072036743, 56.7928009033',
    municipality: 'South Indian Lake'
  }
}, {
  label: 'Lake Tahoe Airport (TVL) - US',
  id: 'TVL',
  obj: {
    iata: 'TVL',
    iso: 'US',
    coordinates: '-119.99500274658203, 38.89390182495117',
    municipality: 'South Lake Tahoe'
  }
}, {
  label: 'Southampton Airport (SOU) - GB',
  id: 'SOU',
  obj: {
    iata: 'SOU',
    iso: 'GB',
    coordinates: '-1.3567999601364136, 50.95029830932617',
    municipality: 'Southampton'
  }
}, {
  label: 'Southend Airport (SEN) - GB',
  id: 'SEN',
  obj: {
    iata: 'SEN',
    iso: 'GB',
    coordinates: '0.6955559849739075, 51.5713996887207',
    municipality: 'Southend'
  }
}, {
  label: 'Maygatka Airport. (GVN) - RU',
  id: 'GVN',
  obj: {
    iata: 'GVN',
    iso: 'RU',
    coordinates: '140.033996582, 48.926998138399995',
    municipality: 'Sovetskaya Gavan'
  }
}, {
  label: 'Sovetskiy Airport (OVS) - RU',
  id: 'OVS',
  obj: {
    iata: 'OVS',
    iso: 'RU',
    coordinates: '63.60191345214844, 61.326622009277344',
    municipality: 'Sovetskiy'
  }
}, {
  label: 'Sua Pan Airport (SXN) - BW',
  id: 'SXN',
  obj: {
    iata: 'SXN',
    iso: 'BW',
    coordinates: '26.115801, -20.5534',
    municipality: 'Sowa'
  }
}, {
  label: 'Soyo Airport (SZA) - AO',
  id: 'SZA',
  obj: {
    iata: 'SZA',
    iso: 'AO',
    coordinates: '12.371800422668457, -6.141089916229248',
    municipality: 'Soyo'
  }
}, {
  label: 'Sparrevohn LRRS Airport (SVW) - US',
  id: 'SVW',
  obj: {
    iata: 'SVW',
    iso: 'US',
    coordinates: '-155.5740051, 61.09740067',
    municipality: 'Sparrevohn'
  }
}, {
  label: 'Split Airport (SPU) - HR',
  id: 'SPU',
  obj: {
    iata: 'SPU',
    iso: 'HR',
    coordinates: '16.29800033569336, 43.53889846801758',
    municipality: 'Split'
  }
}, {
  label: 'Spokane International Airport (GEG) - US',
  id: 'GEG',
  obj: {
    iata: 'GEG',
    iso: 'US',
    coordinates: '-117.53399658203125, 47.61989974975586',
    municipality: 'Spokane'
  }
}, {
  label: 'Felts Field (SFF) - US',
  id: 'SFF',
  obj: {
    iata: 'SFF',
    iso: 'US',
    coordinates: '-117.32299804688, 47.682800292969',
    municipality: 'Spokane'
  }
}, {
  label: 'Fairchild Air Force Base (SKA) - US',
  id: 'SKA',
  obj: {
    iata: 'SKA',
    iso: 'US',
    coordinates: '-117.65599823, 47.6151008606',
    municipality: 'Spokane'
  }
}, {
  label: 'Spring Point Airport (AXP) - BS',
  id: 'AXP',
  obj: {
    iata: 'AXP',
    iso: 'BS',
    coordinates: '-73.97090148930002, 22.441799163800003',
    municipality: 'Spring Point'
  }
}, {
  label: 'Springbok Airport (SBU) - ZA',
  id: 'SBU',
  obj: {
    iata: 'SBU',
    iso: 'ZA',
    coordinates: '17.939599990844727, -29.689300537109375',
    municipality: 'Springbok'
  }
}, {
  label: 'Springfield Branson National Airport (SGF) - US',
  id: 'SGF',
  obj: {
    iata: 'SGF',
    iso: 'US',
    coordinates: '-93.38860321, 37.24570084',
    municipality: 'Springfield'
  }
}, {
  label: 'Springfield-Beckley Municipal Airport (SGH) - US',
  id: 'SGH',
  obj: {
    iata: 'SGH',
    iso: 'US',
    coordinates: '-83.840202331543, 39.840301513672',
    municipality: 'Springfield'
  }
}, {
  label: 'Abraham Lincoln Capital Airport (SPI) - US',
  id: 'SPI',
  obj: {
    iata: 'SPI',
    iso: 'US',
    coordinates: '-89.67790222, 39.84410095',
    municipality: 'Springfield'
  }
}, {
  label: 'Westover ARB/Metropolitan Airport (CEF) - US',
  id: 'CEF',
  obj: {
    iata: 'CEF',
    iso: 'US',
    coordinates: '-72.53479767, 42.19400024',
    municipality: 'Springfield/Chicopee'
  }
}, {
  label: 'Srednekolymsk Airport (SEK) - RU',
  id: 'SEK',
  obj: {
    iata: 'SEK',
    iso: 'RU',
    coordinates: '153.7364, 67.4805',
    municipality: 'Srednekolymsk'
  }
}, {
  label: 'Sheikh ul Alam Airport (SXR) - IN',
  id: 'SXR',
  obj: {
    iata: 'SXR',
    iso: 'IN',
    coordinates: '74.77420043945312, 33.987098693847656',
    municipality: 'Srinagar'
  }
}, {
  label: 'Northeast Florida Regional Airport (UST) - US',
  id: 'UST',
  obj: {
    iata: 'UST',
    iso: 'US',
    coordinates: '-81.339798, 29.9592',
    municipality: 'St Augustine'
  }
}, {
  label: 'Niagara District Airport (YCM) - CA',
  id: 'YCM',
  obj: {
    iata: 'YCM',
    iso: 'CA',
    coordinates: '-79.17169952392578, 43.19169998168945',
    municipality: 'St Catharines'
  }
}, {
  label: 'St Cloud Regional Airport (STC) - US',
  id: 'STC',
  obj: {
    iata: 'STC',
    iso: 'US',
    coordinates: '-94.05989837646484, 45.546600341796875',
    municipality: 'St Cloud'
  }
}, {
  label: 'Roland Garros Airport (RUN) - RE',
  id: 'RUN',
  obj: {
    iata: 'RUN',
    iso: 'RE',
    coordinates: '55.51029968261719, -20.887100219726562',
    municipality: 'St Denis'
  }
}, {
  label: 'St George Municipal Airport (SGU) - US',
  id: 'SGU',
  obj: {
    iata: 'SGU',
    iso: 'US',
    coordinates: '-113.510306, 37.036389',
    municipality: 'St George'
  }
}, {
  label: 'St George Airport (STG) - US',
  id: 'STG',
  obj: {
    iata: 'STG',
    iso: 'US',
    coordinates: '-169.662002563, 56.578300476100004',
    municipality: 'St George'
  }
}, {
  label: 'St Jean Airport (YJN) - CA',
  id: 'YJN',
  obj: {
    iata: 'YJN',
    iso: 'CA',
    coordinates: '-73.28109741210938, 45.29439926147461',
    municipality: 'St Jean'
  }
}, {
  label: 'Rosecrans Memorial Airport (STJ) - US',
  id: 'STJ',
  obj: {
    iata: 'STJ',
    iso: 'US',
    coordinates: '-94.909698486328, 39.771900177002',
    municipality: 'St Joseph'
  }
}, {
  label: 'St Leonard Airport (YSL) - CA',
  id: 'YSL',
  obj: {
    iata: 'YSL',
    iso: 'CA',
    coordinates: '-67.83470153808594, 47.157501220703125',
    municipality: 'St Leonard'
  }
}, {
  label: 'St Louis Lambert International Airport (STL) - US',
  id: 'STL',
  obj: {
    iata: 'STL',
    iso: 'US',
    coordinates: '-90.370003, 38.748697',
    municipality: 'St Louis'
  }
}, {
  label: 'Spirit of St Louis Airport (SUS) - US',
  id: 'SUS',
  obj: {
    iata: 'SUS',
    iso: 'US',
    coordinates: '-90.652000427246, 38.662101745605',
    municipality: 'St Louis'
  }
}, {
  label: "St Mary's Airport (KSM) - US",
  id: 'KSM',
  obj: {
    iata: 'KSM',
    iso: 'US',
    coordinates: '-163.302002, 62.0605011',
    municipality: "St Mary's"
  }
}, {
  label: 'St Paul Downtown Holman Field (STP) - US',
  id: 'STP',
  obj: {
    iata: 'STP',
    iso: 'US',
    coordinates: '-93.05999755859375, 44.93450164794922',
    municipality: 'St Paul'
  }
}, {
  label: 'St Paul Island Airport (SNP) - US',
  id: 'SNP',
  obj: {
    iata: 'SNP',
    iso: 'US',
    coordinates: '-170.22000122070312, 57.167301177978516',
    municipality: 'St Paul Island'
  }
}, {
  label: 'St Petersburg Clearwater International Airport (PIE) - US',
  id: 'PIE',
  obj: {
    iata: 'PIE',
    iso: 'US',
    coordinates: '-82.68740082, 27.91020012',
    municipality: 'St Petersburg-Clearwater'
  }
}, {
  label: 'Pierrefonds Airport (ZSE) - RE',
  id: 'ZSE',
  obj: {
    iata: 'ZSE',
    iso: 'RE',
    coordinates: '55.42499923706055, -21.320899963378906',
    municipality: 'St Pierre'
  }
}, {
  label: 'St Simons Island Airport (SSI) - US',
  id: 'SSI',
  obj: {
    iata: 'SSI',
    iso: 'US',
    coordinates: '-81.391296, 31.1518',
    municipality: 'St Simons Island'
  }
}, {
  label: 'St Thomas Municipal Airport (YQS) - CA',
  id: 'YQS',
  obj: {
    iata: 'YQS',
    iso: 'CA',
    coordinates: '-81.11080169677734, 42.77000045776367',
    municipality: 'St Thomas'
  }
}, {
  label: 'St Augustin Airport (YIF) - CA',
  id: 'YIF',
  obj: {
    iata: 'YIF',
    iso: 'CA',
    coordinates: '-58.6582984924, 51.2117004395',
    municipality: 'St-Augustin'
  }
}, {
  label: 'RAF Leuchars (ADX) - GB',
  id: 'ADX',
  obj: {
    iata: 'ADX',
    iso: 'GB',
    coordinates: '-2.8684399127960205, 56.37289810180664',
    municipality: 'St. Andrews'
  }
}, {
  label: 'St. Anthony Airport (YAY) - CA',
  id: 'YAY',
  obj: {
    iata: 'YAY',
    iso: 'CA',
    coordinates: '-56.083099365200006, 51.3918991089',
    municipality: 'St. Anthony'
  }
}, {
  label: 'RAF Wyton (QUY) - GB',
  id: 'QUY',
  obj: {
    iata: 'QUY',
    iso: 'GB',
    coordinates: '-0.107832998037, 52.3572006226',
    municipality: 'St. Ives'
  }
}, {
  label: "St. John's International Airport (YYT) - CA",
  id: 'YYT',
  obj: {
    iata: 'YYT',
    iso: 'CA',
    coordinates: '-52.7518997192, 47.618598938',
    municipality: "St. John's"
  }
}, {
  label: 'V.C. Bird International Airport (ANU) - AG',
  id: 'ANU',
  obj: {
    iata: 'ANU',
    iso: 'AG',
    coordinates: '-61.792702, 17.1367',
    municipality: "St. John's"
  }
}, {
  label: "St. Mary's Airport (ISC) - GB",
  id: 'ISC',
  obj: {
    iata: 'ISC',
    iso: 'GB',
    coordinates: '-6.291669845581055, 49.913299560546875',
    municipality: "St. Mary's"
  }
}, {
  label: 'Pulkovo Airport (LED) - RU',
  id: 'LED',
  obj: {
    iata: 'LED',
    iso: 'RU',
    coordinates: '30.262500762939453, 59.80030059814453',
    municipality: 'St. Petersburg'
  }
}, {
  label: 'St. Theresa Point Airport (YST) - CA',
  id: 'YST',
  obj: {
    iata: 'YST',
    iso: 'CA',
    coordinates: '-94.85189819335938, 53.84560012817383',
    municipality: 'St. Theresa Point'
  }
}, {
  label: 'La Palma Airport (SPC) - ES',
  id: 'SPC',
  obj: {
    iata: 'SPC',
    iso: 'ES',
    coordinates: '-17.7556, 28.626499',
    municipality: 'Sta Cruz de la Palma, La Palma Island'
  }
}, {
  label: 'Port Stanley Airport (PSY) - FK',
  id: 'PSY',
  obj: {
    iata: 'PSY',
    iso: 'FK',
    coordinates: '-57.777599334717, -51.685699462891',
    municipality: 'Stanley'
  }
}, {
  label: 'University Park Airport (SCE) - US',
  id: 'SCE',
  obj: {
    iata: 'SCE',
    iso: 'US',
    coordinates: '-77.84870147710001, 40.8493003845',
    municipality: 'State College'
  }
}, {
  label: 'Stavanger Airport Sola (SVG) - NO',
  id: 'SVG',
  obj: {
    iata: 'SVG',
    iso: 'NO',
    coordinates: '5.6377801895, 58.876701354',
    municipality: 'Stavanger'
  }
}, {
  label: 'Gloucestershire Airport (GLO) - GB',
  id: 'GLO',
  obj: {
    iata: 'GLO',
    iso: 'GB',
    coordinates: '-2.167220115661621, 51.89419937133789',
    municipality: 'Staverton'
  }
}, {
  label: 'Stavropol Shpakovskoye Airport (STW) - RU',
  id: 'STW',
  obj: {
    iata: 'STW',
    iso: 'RU',
    coordinates: '42.11280059814453, 45.10919952392578',
    municipality: 'Stavropol'
  }
}, {
  label: 'Stella Maris Airport (SML) - BS',
  id: 'SML',
  obj: {
    iata: 'SML',
    iso: 'BS',
    coordinates: '-75.268621, 23.582317',
    municipality: 'Stella Maris'
  }
}, {
  label: 'Stephenville Airport (YJT) - CA',
  id: 'YJT',
  obj: {
    iata: 'YJT',
    iso: 'CA',
    coordinates: '-58.54999923706055, 48.5442008972168',
    municipality: 'Stephenville'
  }
}, {
  label: 'Stewart Airport (ZST) - CA',
  id: 'ZST',
  obj: {
    iata: 'ZST',
    iso: 'CA',
    coordinates: '-129.982434511, 55.935410448',
    municipality: 'Stewart'
  }
}, {
  label: 'Stillwater Regional Airport (SWO) - US',
  id: 'SWO',
  obj: {
    iata: 'SWO',
    iso: 'US',
    coordinates: '-97.08570098877, 36.161201477051',
    municipality: 'Stillwater'
  }
}, {
  label: 'Stockholm-Arlanda Airport (ARN) - SE',
  id: 'ARN',
  obj: {
    iata: 'ARN',
    iso: 'SE',
    coordinates: '17.918600082397, 59.651901245117',
    municipality: 'Stockholm'
  }
}, {
  label: 'Stockholm-Bromma Airport (BMA) - SE',
  id: 'BMA',
  obj: {
    iata: 'BMA',
    iso: 'SE',
    coordinates: '17.941699981689453, 59.354400634765625',
    municipality: 'Stockholm'
  }
}, {
  label: 'Stockholm Skavsta Airport (NYO) - SE',
  id: 'NYO',
  obj: {
    iata: 'NYO',
    iso: 'SE',
    coordinates: '16.912200927734375, 58.78860092163086',
    municipality: 'Stockholm / Nyk\u00c3\u00b6ping'
  }
}, {
  label: 'Stockholm V\u00c3\u00a4ster\u00c3\u00a5s Airport (VST) - SE',
  id: 'VST',
  obj: {
    iata: 'VST',
    iso: 'SE',
    coordinates: '16.63360023498535, 59.58940124511719',
    municipality: 'Stockholm / V\u00c3\u00a4ster\u00c3\u00a5s'
  }
}, {
  label: 'Stockton Metropolitan Airport (SCK) - US',
  id: 'SCK',
  obj: {
    iata: 'SCK',
    iso: 'US',
    coordinates: '-121.2379989624, 37.894199371338',
    municipality: 'Stockton'
  }
}, {
  label: 'Stony Rapids Airport (YSF) - CA',
  id: 'YSF',
  obj: {
    iata: 'YSF',
    iso: 'CA',
    coordinates: '-105.84100341796875, 59.250301361083984',
    municipality: 'Stony Rapids'
  }
}, {
  label: 'Stornoway Airport (SYY) - GB',
  id: 'SYY',
  obj: {
    iata: 'SYY',
    iso: 'GB',
    coordinates: '-6.331110000610352, 58.215599060058594',
    municipality: 'Stornoway'
  }
}, {
  label: 'Strasbourg Airport (SXB) - FR',
  id: 'SXB',
  obj: {
    iata: 'SXB',
    iso: 'FR',
    coordinates: '7.628230094909668, 48.538299560546875',
    municipality: 'Strasbourg'
  }
}, {
  label: 'Strezhevoy Airport (SWT) - RU',
  id: 'SWT',
  obj: {
    iata: 'SWT',
    iso: 'RU',
    coordinates: '77.66000366210001, 60.709400177',
    municipality: 'Strezhevoy'
  }
}, {
  label: 'Stung Treng Airport (TNX) - KH',
  id: 'TNX',
  obj: {
    iata: 'TNX',
    iso: 'KH',
    coordinates: '106.01499938964844, 13.531900405883789',
    municipality: 'Stung Treng'
  }
}, {
  label: 'Stuttgart Airport (STR) - DE',
  id: 'STR',
  obj: {
    iata: 'STR',
    iso: 'DE',
    coordinates: '9.22196006775, 48.689899444599995',
    municipality: 'Stuttgart'
  }
}, {
  label: 'Suai Airport (UAI) - TL',
  id: 'UAI',
  obj: {
    iata: 'UAI',
    iso: 'TL',
    coordinates: '125.28700256347656, -9.30331039428711',
    municipality: 'Suai'
  }
}, {
  label: 'Sultan Abdul Aziz Shah International Airport (SZB) - MY',
  id: 'SZB',
  obj: {
    iata: 'SZB',
    iso: 'MY',
    coordinates: '101.54900360107422, 3.130579948425293',
    municipality: 'Subang'
  }
}, {
  label: 'Suceava Stefan cel Mare Airport (SCV) - RO',
  id: 'SCV',
  obj: {
    iata: 'SCV',
    iso: 'RO',
    coordinates: '26.35409927368164, 47.6875',
    municipality: 'Suceava'
  }
}, {
  label: 'Sudbury Airport (YSB) - CA',
  id: 'YSB',
  obj: {
    iata: 'YSB',
    iso: 'CA',
    coordinates: '-80.79889678955078, 46.625',
    municipality: 'Sudbury'
  }
}, {
  label: 'Bilogai-Sugapa Airport (UGU) - ID',
  id: 'UGU',
  obj: {
    iata: 'UGU',
    iso: 'ID',
    coordinates: '137.031998, -3.73956',
    municipality: 'Sugapa-Papua Island'
  }
}, {
  label: 'Sui Airport (SUL) - PK',
  id: 'SUL',
  obj: {
    iata: 'SUL',
    iso: 'PK',
    coordinates: '69.1769027709961, 28.645099639892578',
    municipality: 'Sui'
  }
}, {
  label: 'Fukushima Airport (FKS) - JP',
  id: 'FKS',
  obj: {
    iata: 'FKS',
    iso: 'JP',
    coordinates: '140.43099975585938, 37.22740173339844',
    municipality: 'Sukagawa'
  }
}, {
  label: 'Sukhumi Dranda Airport (SUI) - GE',
  id: 'SUI',
  obj: {
    iata: 'SUI',
    iso: 'GE',
    coordinates: '41.128101348899996, 42.8582000732',
    municipality: 'Sukhumi'
  }
}, {
  label: 'Sulaymaniyah International Airport (ISU) - IQ',
  id: 'ISU',
  obj: {
    iata: 'ISU',
    iso: 'IQ',
    coordinates: '45.316738128699996, 35.5617485046',
    municipality: 'Sulaymaniyah'
  }
}, {
  label: 'Sumbe Airport (NDD) - AO',
  id: 'NDD',
  obj: {
    iata: 'NDD',
    iso: 'AO',
    coordinates: '13.84749984741211, -11.167900085449219',
    municipality: 'Sumbe'
  }
}, {
  label: 'Summerside Airport (YSU) - CA',
  id: 'YSU',
  obj: {
    iata: 'YSU',
    iso: 'CA',
    coordinates: '-63.83359909057617, 46.44060134887695',
    municipality: 'Summerside'
  }
}, {
  label: 'Shaw Air Force Base (SSC) - US',
  id: 'SSC',
  obj: {
    iata: 'SSC',
    iso: 'US',
    coordinates: '-80.47059631, 33.97269821',
    municipality: 'Sumter'
  }
}, {
  label: 'Sundsvall-H\u00c3\u00a4rn\u00c3\u00b6sand Airport (SDL) - SE',
  id: 'SDL',
  obj: {
    iata: 'SDL',
    iso: 'SE',
    coordinates: '17.443899154663086, 62.528099060058594',
    municipality: 'Sundsvall/ H\u00c3\u00a4rn\u00c3\u00b6sand'
  }
}, {
  label: 'Sunyani Airport (NYI) - GH',
  id: 'NYI',
  obj: {
    iata: 'NYI',
    iso: 'GH',
    coordinates: '-2.3287599086761475, 7.361830234527588',
    municipality: 'Sunyani'
  }
}, {
  label: 'Juanda International Airport (SUB) - ID',
  id: 'SUB',
  obj: {
    iata: 'SUB',
    iso: 'ID',
    coordinates: '112.78700256347656, -7.3798298835754395',
    municipality: 'Surabaya'
  }
}, {
  label: 'Allah Valley Airport (AAV) - PH',
  id: 'AAV',
  obj: {
    iata: 'AAV',
    iso: 'PH',
    coordinates: '124.7509994506836, 6.366819858551025',
    municipality: 'Surallah'
  }
}, {
  label: 'Surat Thani Airport (URT) - TH',
  id: 'URT',
  obj: {
    iata: 'URT',
    iso: 'TH',
    coordinates: '99.135597229, 9.13259983063',
    municipality: 'Surat Thani'
  }
}, {
  label: 'Surgut Airport (SGC) - RU',
  id: 'SGC',
  obj: {
    iata: 'SGC',
    iso: 'RU',
    coordinates: '73.40180206298828, 61.34370040893555',
    municipality: 'Surgut'
  }
}, {
  label: 'Surigao Airport (SUG) - PH',
  id: 'SUG',
  obj: {
    iata: 'SUG',
    iso: 'PH',
    coordinates: '125.480947495, 9.755838325629998',
    municipality: 'Surigao City'
  }
}, {
  label: 'Surin Airport (PXR) - TH',
  id: 'PXR',
  obj: {
    iata: 'PXR',
    iso: 'TH',
    coordinates: '103.49800109863, 14.868300437927',
    municipality: 'Surin'
  }
}, {
  label: 'Svolv\u00c3\u00a6r Helle Airport (SVJ) - NO',
  id: 'SVJ',
  obj: {
    iata: 'SVJ',
    iso: 'NO',
    coordinates: '14.669199943542, 68.243301391602',
    municipality: 'Svolv\u00c3\u00a6r'
  }
}, {
  label: 'Swan River Airport (ZJN) - CA',
  id: 'ZJN',
  obj: {
    iata: 'ZJN',
    iso: 'CA',
    coordinates: '-101.23600006103516, 52.120601654052734',
    municipality: 'Swan River'
  }
}, {
  label: 'Swansea Airport (SWS) - GB',
  id: 'SWS',
  obj: {
    iata: 'SWS',
    iso: 'GB',
    coordinates: '-4.0678300857543945, 51.60530090332031',
    municipality: 'Swansea'
  }
}, {
  label: 'Swift Current Airport (YYN) - CA',
  id: 'YYN',
  obj: {
    iata: 'YYN',
    iso: 'CA',
    coordinates: '-107.691001892, 50.291900634799994',
    municipality: 'Swift Current'
  }
}, {
  label: 'Sydney / J.A. Douglas McCurdy Airport (YQY) - CA',
  id: 'YQY',
  obj: {
    iata: 'YQY',
    iso: 'CA',
    coordinates: '-60.047798, 46.1614',
    municipality: 'Sydney'
  }
}, {
  label: 'Sydney Bankstown Airport (BWU) - AU',
  id: 'BWU',
  obj: {
    iata: 'BWU',
    iso: 'AU',
    coordinates: '150.98800659179688, -33.924400329589844',
    municipality: 'Sydney'
  }
}, {
  label: 'Sydney Kingsford Smith International Airport (SYD) - AU',
  id: 'SYD',
  obj: {
    iata: 'SYD',
    iso: 'AU',
    coordinates: '151.177001953125, -33.94609832763672',
    municipality: 'Sydney'
  }
}, {
  label: 'Syktyvkar Airport (SCW) - RU',
  id: 'SCW',
  obj: {
    iata: 'SCW',
    iso: 'RU',
    coordinates: '50.84510040283203, 61.64699935913086',
    municipality: 'Syktyvkar'
  }
}, {
  label: 'Osmany International Airport (ZYL) - BD',
  id: 'ZYL',
  obj: {
    iata: 'ZYL',
    iso: 'BD',
    coordinates: '91.8667984008789, 24.963199615478516',
    municipality: 'Sylhet'
  }
}, {
  label: 'Syracuse Hancock International Airport (SYR) - US',
  id: 'SYR',
  obj: {
    iata: 'SYR',
    iso: 'US',
    coordinates: '-76.1063003540039, 43.11119842529297',
    municipality: 'Syracuse'
  }
}, {
  label: 'H\u00c3\u00a9v\u00c3\u00adz\u00e2\u0080\u0093Balaton Airport (SOB) - HU',
  id: 'SOB',
  obj: {
    iata: 'SOB',
    iso: 'HU',
    coordinates: '17.159084, 46.686391',
    municipality: 'S\u00c3\u00a1rmell\u00c3\u00a9k'
  }
}, {
  label: 'S\u00c3\u00a3o Gabriel da Cachoeira Airport (SJL) - BR',
  id: 'SJL',
  obj: {
    iata: 'SJL',
    iso: 'BR',
    coordinates: '-66.9855, -0.14835',
    municipality: 'S\u00c3\u00a3o Gabriel Da Cachoeira'
  }
}, {
  label: 'Prof. Eribelto Manoel Reino State Airport (SJP) - BR',
  id: 'SJP',
  obj: {
    iata: 'SJP',
    iso: 'BR',
    coordinates: '-49.40650177, -20.816600799599996',
    municipality: 'S\u00c3\u00a3o Jos\u00c3\u00a9 Do Rio Preto'
  }
}, {
  label: 'Professor Urbano Ernesto Stumpf Airport (SJK) - BR',
  id: 'SJK',
  obj: {
    iata: 'SJK',
    iso: 'BR',
    coordinates: '-45.86149978637695, -23.22920036315918',
    municipality: 'S\u00c3\u00a3o Jos\u00c3\u00a9 Dos Campos'
  }
}, {
  label: 'Marechal Cunha Machado International Airport (SLZ) - BR',
  id: 'SLZ',
  obj: {
    iata: 'SLZ',
    iso: 'BR',
    coordinates: '-44.234100341796875, -2.585360050201416',
    municipality: 'S\u00c3\u00a3o Lu\u00c3\u00ads'
  }
}, {
  label: 'Guarulhos - Governador Andr\u00c3\u00a9 Franco Montoro International Airport (GRU) - BR',
  id: 'GRU',
  obj: {
    iata: 'GRU',
    iso: 'BR',
    coordinates: '-46.47305679321289, -23.435556411743164',
    municipality: 'S\u00c3\u00a3o Paulo'
  }
}, {
  label: 'Congonhas Airport (CGH) - BR',
  id: 'CGH',
  obj: {
    iata: 'CGH',
    iso: 'BR',
    coordinates: '-46.65638732910156, -23.626110076904297',
    municipality: 'S\u00c3\u00a3o Paulo'
  }
}, {
  label: 'S\u00c3\u00a3o Pedro Airport (VXE) - CV',
  id: 'VXE',
  obj: {
    iata: 'VXE',
    iso: 'CV',
    coordinates: '-25.055299758911133, 16.833200454711914',
    municipality: 'S\u00c3\u00a3o Pedro'
  }
}, {
  label: 'S\u00c3\u00a3o Tom\u00c3\u00a9 International Airport (TMS) - ST',
  id: 'TMS',
  obj: {
    iata: 'TMS',
    iso: 'ST',
    coordinates: '6.7121500968933105, 0.3781749904155731',
    municipality: 'S\u00c3\u00a3o Tom\u00c3\u00a9'
  }
}, {
  label: 'Scandinavian Mountains Airport (SCR) - SE',
  id: 'SCR',
  obj: {
    iata: 'SCR',
    iso: 'SE',
    coordinates: '12.840676, 61.159092',
    municipality: 'S\u00c3\u00a4len and Trysil'
  }
}, {
  label: 'Ain Arnat Airport (QSF) - DZ',
  id: 'QSF',
  obj: {
    iata: 'QSF',
    iso: 'DZ',
    coordinates: '5.3244900703399995, 36.178100585900005',
    municipality: 'S\u00c3\u00a9tif'
  }
}, {
  label: 'S\u00c3\u00b6derhamn Airport (SOO) - SE',
  id: 'SOO',
  obj: {
    iata: 'SOO',
    iso: 'SE',
    coordinates: '17.09910011291504, 61.26150131225586',
    municipality: 'S\u00c3\u00b6derhamn'
  }
}, {
  label: 'S\u00c3\u00b8nderborg Airport (SGD) - DK',
  id: 'SGD',
  obj: {
    iata: 'SGD',
    iso: 'DK',
    coordinates: '9.791729927062988, 54.96440124511719',
    municipality: 'S\u00c3\u00b8nderborg'
  }
}, {
  label: 'S\u00c3\u00b8rkjosen Airport (SOJ) - NO',
  id: 'SOJ',
  obj: {
    iata: 'SOJ',
    iso: 'NO',
    coordinates: '20.959400177002, 69.786796569824',
    municipality: 'S\u00c3\u00b8rkjosen'
  }
}, {
  label: 'Sondok Airport (DSO) - KP',
  id: 'DSO',
  obj: {
    iata: 'DSO',
    iso: 'KP',
    coordinates: '127.473999, 39.745201',
    municipality: 'S\u00c5\u008fnd\u00c5\u008fng-ni'
  }
}, {
  label: "Ta'izz International Airport (TAI) - YE",
  id: 'TAI',
  obj: {
    iata: 'TAI',
    iso: 'YE',
    coordinates: '44.139099121099996, 13.6859998703',
    municipality: "Ta'izz"
  }
}, {
  label: 'Taba International Airport (TCP) - EG',
  id: 'TCP',
  obj: {
    iata: 'TCP',
    iso: 'EG',
    coordinates: '34.7780990601, 29.587799072299998',
    municipality: 'Taba'
  }
}, {
  label: 'Tabarka 7 Novembre Airport (TBJ) - TN',
  id: 'TBJ',
  obj: {
    iata: 'TBJ',
    iso: 'TN',
    coordinates: '8.87693977355957, 36.97999954223633',
    municipality: 'Tabarka'
  }
}, {
  label: 'Tabas Airport (TCX) - IR',
  id: 'TCX',
  obj: {
    iata: 'TCX',
    iso: 'IR',
    coordinates: '56.8927001953, 33.6678009033',
    municipality: 'Tabas'
  }
}, {
  label: 'Tabatinga Airport (TBT) - BR',
  id: 'TBT',
  obj: {
    iata: 'TBT',
    iso: 'BR',
    coordinates: '-69.93579864502, -4.2556700706482',
    municipality: 'Tabatinga'
  }
}, {
  label: 'Tugdan Airport (TBH) - PH',
  id: 'TBH',
  obj: {
    iata: 'TBH',
    iso: 'PH',
    coordinates: '122.084999084, 12.3109998703',
    municipality: 'Tablas Island'
  }
}, {
  label: 'Tabriz International Airport (TBZ) - IR',
  id: 'TBZ',
  obj: {
    iata: 'TBZ',
    iso: 'IR',
    coordinates: '46.23500061035156, 38.1338996887207',
    municipality: 'Tabriz'
  }
}, {
  label: 'Tabuk Airport (TUU) - SA',
  id: 'TUU',
  obj: {
    iata: 'TUU',
    iso: 'SA',
    coordinates: '36.6189, 28.3654',
    municipality: 'Tabuk'
  }
}, {
  label: 'Tachileik Airport (THL) - MM',
  id: 'THL',
  obj: {
    iata: 'THL',
    iso: 'MM',
    coordinates: '99.9354019165039, 20.483800888061523',
    municipality: 'Tachileik'
  }
}, {
  label: 'Daniel Z. Romualdez Airport (TAC) - PH',
  id: 'TAC',
  obj: {
    iata: 'TAC',
    iso: 'PH',
    coordinates: '125.027761, 11.228035',
    municipality: 'Tacloban City'
  }
}, {
  label: 'Coronel FAP Carlos Ciriani Santa Rosa International Airport (TCQ) - PE',
  id: 'TCQ',
  obj: {
    iata: 'TCQ',
    iso: 'PE',
    coordinates: '-70.2758026123, -18.053300857500002',
    municipality: 'Tacna'
  }
}, {
  label: 'McChord Air Force Base (TCM) - US',
  id: 'TCM',
  obj: {
    iata: 'TCM',
    iso: 'US',
    coordinates: '-122.475997925, 47.1376991272',
    municipality: 'Tacoma'
  }
}, {
  label: 'Tacoma Narrows Airport (TIW) - US',
  id: 'TIW',
  obj: {
    iata: 'TIW',
    iso: 'US',
    coordinates: '-122.5780029, 47.26789856',
    municipality: 'Tacoma'
  }
}, {
  label: 'Palmyra Airport (PMS) - SY',
  id: 'PMS',
  obj: {
    iata: 'PMS',
    iso: 'SY',
    coordinates: '38.316898, 34.5574',
    municipality: 'Tadmur'
  }
}, {
  label: 'Tadoule Lake Airport (XTL) - CA',
  id: 'XTL',
  obj: {
    iata: 'XTL',
    iso: 'CA',
    coordinates: '-98.512199, 58.7061',
    municipality: 'Tadoule Lake'
  }
}, {
  label: 'Taganrog Yuzhny Airport (TGK) - RU',
  id: 'TGK',
  obj: {
    iata: 'TGK',
    iso: 'RU',
    coordinates: '38.8491667, 47.1983333',
    municipality: 'Taganrog'
  }
}, {
  label: 'Tagbilaran Airport (TAG) - PH',
  id: 'TAG',
  obj: {
    iata: 'TAG',
    iso: 'PH',
    coordinates: '123.853533, 9.665442',
    municipality: 'Tagbilaran City'
  }
}, {
  label: 'Tahoua Airport (THZ) - NE',
  id: 'THZ',
  obj: {
    iata: 'THZ',
    iso: 'NE',
    coordinates: '5.265359878540039, 14.875699996948242',
    municipality: 'Tahoua'
  }
}, {
  label: 'Naha Airport (NAH) - ID',
  id: 'NAH',
  obj: {
    iata: 'NAH',
    iso: 'ID',
    coordinates: '125.52799987792969, 3.6832098960876465',
    municipality: 'Tahuna-Sangihe Island'
  }
}, {
  label: 'Taichung Ching Chuang Kang Airport (RMQ) - TW',
  id: 'RMQ',
  obj: {
    iata: 'RMQ',
    iso: 'TW',
    coordinates: '120.62100219726562, 24.264699935913086',
    municipality: 'Taichung City'
  }
}, {
  label: 'Tainan Airport (TNN) - TW',
  id: 'TNN',
  obj: {
    iata: 'TNN',
    iso: 'TW',
    coordinates: '120.20600128173828, 22.95039939880371',
    municipality: 'Tainan City'
  }
}, {
  label: 'Taiwan Taoyuan International Airport (TPE) - TW',
  id: 'TPE',
  obj: {
    iata: 'TPE',
    iso: 'TW',
    coordinates: '121.233002, 25.0777',
    municipality: 'Taipei'
  }
}, {
  label: 'Taipei Songshan Airport (TSA) - TW',
  id: 'TSA',
  obj: {
    iata: 'TSA',
    iso: 'TW',
    coordinates: '121.552001953125, 25.069400787353516',
    municipality: 'Taipei City'
  }
}, {
  label: 'Taitung Airport (TTT) - TW',
  id: 'TTT',
  obj: {
    iata: 'TTT',
    iso: 'TW',
    coordinates: '121.10199737548828, 22.7549991607666',
    municipality: 'Taitung City'
  }
}, {
  label: 'Taiyuan Wusu Airport (TYN) - CN',
  id: 'TYN',
  obj: {
    iata: 'TYN',
    iso: 'CN',
    coordinates: '112.62799835205078, 37.74689865112305',
    municipality: 'Taiyuan'
  }
}, {
  label: 'Takamatsu Airport (TAK) - JP',
  id: 'TAK',
  obj: {
    iata: 'TAK',
    iso: 'JP',
    coordinates: '134.01600647, 34.214199066199996',
    municipality: 'Takamatsu'
  }
}, {
  label: 'Rembele Airport (TXE) - ID',
  id: 'TXE',
  obj: {
    iata: 'TXE',
    iso: 'ID',
    coordinates: '96.849444, 4.720833',
    municipality: 'Takengon'
  }
}, {
  label: 'Tatalina LRRS Airport (TLJ) - US',
  id: 'TLJ',
  obj: {
    iata: 'TLJ',
    iso: 'US',
    coordinates: '-155.977005005, 62.894401550299996',
    municipality: 'Takotna'
  }
}, {
  label: 'Pendopo Airport (PDO) - ID',
  id: 'PDO',
  obj: {
    iata: 'PDO',
    iso: 'ID',
    coordinates: '103.87999725341797, -3.2860701084136963',
    municipality: 'Talang Gudang-Sumatra Island'
  }
}, {
  label: 'Capitan Montes Airport (TYL) - PE',
  id: 'TYL',
  obj: {
    iata: 'TYL',
    iso: 'PE',
    coordinates: '-81.254096984863, -4.5766401290894',
    municipality: 'Talara'
  }
}, {
  label: 'Panguilemo Airport (TLX) - CL',
  id: 'TLX',
  obj: {
    iata: 'TLX',
    iso: 'CL',
    coordinates: '-71.60169982910156, -35.37779998779297',
    municipality: 'Talca'
  }
}, {
  label: 'Taldykorgan Airport (TDK) - KZ',
  id: 'TDK',
  obj: {
    iata: 'TDK',
    iso: 'KZ',
    coordinates: '78.4469985961914, 45.12620162963867',
    municipality: 'Taldy Kurgan'
  }
}, {
  label: 'Talkeetna Airport (TKA) - US',
  id: 'TKA',
  obj: {
    iata: 'TKA',
    iso: 'US',
    coordinates: '-150.09399414062, 62.320499420166',
    municipality: 'Talkeetna'
  }
}, {
  label: 'Tallahassee Regional Airport (TLH) - US',
  id: 'TLH',
  obj: {
    iata: 'TLH',
    iso: 'US',
    coordinates: '-84.35030364990234, 30.396499633789062',
    municipality: 'Tallahassee'
  }
}, {
  label: 'Lennart Meri Tallinn Airport (TLL) - EE',
  id: 'TLL',
  obj: {
    iata: 'TLL',
    iso: 'EE',
    coordinates: '24.832799911499997, 59.41329956049999',
    municipality: 'Tallinn'
  }
}, {
  label: 'Taloyoak Airport (YYH) - CA',
  id: 'YYH',
  obj: {
    iata: 'YYH',
    iso: 'CA',
    coordinates: '-93.576698, 69.5467',
    municipality: 'Taloyoak'
  }
}, {
  label: 'Las Breas Airport (TTC) - CL',
  id: 'TTC',
  obj: {
    iata: 'TTC',
    iso: 'CL',
    coordinates: '-70.37590026855469, -25.564300537109375',
    municipality: 'Taltal'
  }
}, {
  label: 'Tamale Airport (TML) - GH',
  id: 'TML',
  obj: {
    iata: 'TML',
    iso: 'GH',
    coordinates: '-0.8632140159606934, 9.55718994140625',
    municipality: 'Tamale'
  }
}, {
  label: 'Aguenar \u00e2\u0080\u0093 Hadj Bey Akhamok Airport (TMR) - DZ',
  id: 'TMR',
  obj: {
    iata: 'TMR',
    iso: 'DZ',
    coordinates: '5.45107984543, 22.8115005493',
    municipality: 'Tamanrasset'
  }
}, {
  label: 'Tambacounda Airport (TUD) - SN',
  id: 'TUD',
  obj: {
    iata: 'TUD',
    iso: 'SN',
    coordinates: '-13.65310001373291, 13.736800193786621',
    municipality: 'Tambacounda'
  }
}, {
  label: 'Donskoye Airport (TBW) - RU',
  id: 'TBW',
  obj: {
    iata: 'TBW',
    iso: 'RU',
    coordinates: '41.482799530029, 52.806098937988',
    municipality: 'Tambov'
  }
}, {
  label: 'Issyk-Kul International Airport (IKU) - KG',
  id: 'IKU',
  obj: {
    iata: 'IKU',
    iso: 'KG',
    coordinates: '76.713046, 42.58792',
    municipality: 'Tamchy'
  }
}, {
  label: 'Gustavo Vargas Airport (TME) - CO',
  id: 'TME',
  obj: {
    iata: 'TME',
    iso: 'CO',
    coordinates: '-71.7603, 6.45108',
    municipality: 'Tame'
  }
}, {
  label: 'Mac Dill Air Force Base (MCF) - US',
  id: 'MCF',
  obj: {
    iata: 'MCF',
    iso: 'US',
    coordinates: '-82.52120209, 27.84930038',
    municipality: 'Tampa'
  }
}, {
  label: 'Tampa International Airport (TPA) - US',
  id: 'TPA',
  obj: {
    iata: 'TPA',
    iso: 'US',
    coordinates: '-82.533203125, 27.975500106811523',
    municipality: 'Tampa'
  }
}, {
  label: 'Tampere-Pirkkala Airport (TMP) - FI',
  id: 'TMP',
  obj: {
    iata: 'TMP',
    iso: 'FI',
    coordinates: '23.604400634766, 61.414100646973',
    municipality: 'Tampere / Pirkkala'
  }
}, {
  label: 'General Francisco Javier Mina International Airport (TAM) - MX',
  id: 'TAM',
  obj: {
    iata: 'TAM',
    iso: 'MX',
    coordinates: '-97.8658981323, 22.2964000702',
    municipality: 'Tampico'
  }
}, {
  label: 'Tamworth Airport (TMW) - AU',
  id: 'TMW',
  obj: {
    iata: 'TMW',
    iso: 'AU',
    coordinates: '150.847000122, -31.0839004517',
    municipality: 'Tamworth'
  }
}, {
  label: 'Tan Tan Airport (TTA) - MA',
  id: 'TTA',
  obj: {
    iata: 'TTA',
    iso: 'MA',
    coordinates: '-11.161299705505371, 28.448200225830078',
    municipality: 'Tan Tan'
  }
}, {
  label: 'H\u00c3\u00a9roes De Malvinas Airport (TDL) - AR',
  id: 'TDL',
  obj: {
    iata: 'TDL',
    iso: 'AR',
    coordinates: '-59.2279014587, -37.2374000549',
    municipality: 'Tandil'
  }
}, {
  label: 'New Tanegashima Airport (TNE) - JP',
  id: 'TNE',
  obj: {
    iata: 'TNE',
    iso: 'JP',
    coordinates: '130.990997314, 30.605100631699997',
    municipality: 'Tanegashima'
  }
}, {
  label: 'Tanga Airport (TGT) - TZ',
  id: 'TGT',
  obj: {
    iata: 'TGT',
    iso: 'TZ',
    coordinates: '39.07120132446289, -5.092360019683838',
    municipality: 'Tanga'
  }
}, {
  label: 'Ibn Batouta Airport (TNG) - MA',
  id: 'TNG',
  obj: {
    iata: 'TNG',
    iso: 'MA',
    coordinates: '-5.91689014435, 35.726898193400004',
    municipality: 'Tangier'
  }
}, {
  label: 'Kalimarau Airport (BEJ) - ID',
  id: 'BEJ',
  obj: {
    iata: 'BEJ',
    iso: 'ID',
    coordinates: '117.431999, 2.1555',
    municipality: 'Tanjung Redeb - Borneo Island'
  }
}, {
  label: 'Warukin Airport (TJG) - ID',
  id: 'TJG',
  obj: {
    iata: 'TJG',
    iso: 'ID',
    coordinates: '115.435997009, -2.21655988693',
    municipality: 'Tanta-Tabalong-Borneo Island'
  }
}, {
  label: 'Tapachula International Airport (TAP) - MX',
  id: 'TAP',
  obj: {
    iata: 'TAP',
    iso: 'MX',
    coordinates: '-92.3700027466, 14.7943000793',
    municipality: 'Tapachula'
  }
}, {
  label: 'Taplejung Airport (TPJ) - NP',
  id: 'TPJ',
  obj: {
    iata: 'TPJ',
    iso: 'NP',
    coordinates: '87.69525, 27.3509',
    municipality: 'Taplejung'
  }
}, {
  label: 'Juwata Airport (TRK) - ID',
  id: 'TRK',
  obj: {
    iata: 'TRK',
    iso: 'ID',
    coordinates: '117.569444, 3.326667',
    municipality: 'Tarakan Island'
  }
}, {
  label: 'Tarama Airport (TRA) - JP',
  id: 'TRA',
  obj: {
    iata: 'TRA',
    iso: 'JP',
    coordinates: '124.675003052, 24.653900146499996',
    municipality: 'Tarama'
  }
}, {
  label: 'Tarapoa Airport (TPC) - EC',
  id: 'TPC',
  obj: {
    iata: 'TPC',
    iso: 'EC',
    coordinates: '-76.33779907226562, -0.12295600026845932',
    municipality: 'Tarapoa'
  }
}, {
  label: 'Cadete FAP Guillermo Del Castillo Paredes Airport (TPP) - PE',
  id: 'TPP',
  obj: {
    iata: 'TPP',
    iso: 'PE',
    coordinates: '-76.37319946289062, -6.508739948272705',
    municipality: 'Tarapoto'
  }
}, {
  label: 'Tarauac\u00c3\u00a1 Airport (TRQ) - BR',
  id: 'TRQ',
  obj: {
    iata: 'TRQ',
    iso: 'BR',
    coordinates: '-70.783302307129, -8.1552600860596',
    municipality: 'Tarauac\u00c3\u00a1'
  }
}, {
  label: 'Bonriki International Airport (TRW) - KI',
  id: 'TRW',
  obj: {
    iata: 'TRW',
    iso: 'KI',
    coordinates: '173.14700317382812, 1.3816399574279785',
    municipality: 'Tarawa'
  }
}, {
  label: 'Taraz Airport (DMB) - KZ',
  id: 'DMB',
  obj: {
    iata: 'DMB',
    iso: 'KZ',
    coordinates: '71.30359649658203, 42.853599548339844',
    municipality: 'Taraz'
  }
}, {
  label: 'Tarbes-Lourdes-Pyr\u00c3\u00a9n\u00c3\u00a9es Airport (LDE) - FR',
  id: 'LDE',
  obj: {
    iata: 'LDE',
    iso: 'FR',
    coordinates: '-0.006438999902456999, 43.1786994934082',
    municipality: 'Tarbes/Lourdes/Pyr\u00c3\u00a9n\u00c3\u00a9es'
  }
}, {
  label: 'Taree Airport (TRO) - AU',
  id: 'TRO',
  obj: {
    iata: 'TRO',
    iso: 'AU',
    coordinates: '152.514007568, -31.8885993958',
    municipality: 'Taree'
  }
}, {
  label: 'Capitan Oriel Lea Plaza Airport (TJA) - BO',
  id: 'TJA',
  obj: {
    iata: 'TJA',
    iso: 'BO',
    coordinates: '-64.7013015747, -21.5557003021',
    municipality: 'Tarija'
  }
}, {
  label: 'General Enrique Mosconi Airport (TTG) - AR',
  id: 'TTG',
  obj: {
    iata: 'TTG',
    iso: 'AR',
    coordinates: '-63.7937011719, -22.619600296',
    municipality: 'Tartagal'
  }
}, {
  label: 'Tartu Airport (TAY) - EE',
  id: 'TAY',
  obj: {
    iata: 'TAY',
    iso: 'EE',
    coordinates: '26.690399169900004, 58.3074989319',
    municipality: 'Tartu'
  }
}, {
  label: 'Tashkent International Airport (TAS) - UZ',
  id: 'TAS',
  obj: {
    iata: 'TAS',
    iso: 'UZ',
    coordinates: '69.2811965942, 41.257900238',
    municipality: 'Tashkent'
  }
}, {
  label: 'Tasiujaq Airport (YTQ) - CA',
  id: 'YTQ',
  obj: {
    iata: 'YTQ',
    iso: 'CA',
    coordinates: '-69.95580291748047, 58.66780090332031',
    municipality: 'Tasiujaq'
  }
}, {
  label: 'Tasz\u00c3\u00a1r Air Base (TZR) - HU',
  id: 'TZR',
  obj: {
    iata: 'TZR',
    iso: 'HU',
    coordinates: '17.917499542236328, 46.39310073852539',
    municipality: 'Tasz\u00c3\u00a1r'
  }
}, {
  label: 'Base de Avia\u00c3\u00a7\u00c3\u00a3o de Taubat\u00c3\u00a9 Airport (QHP) - BR',
  id: 'QHP',
  obj: {
    iata: 'QHP',
    iso: 'BR',
    coordinates: '-45.51599884033203, -23.04010009765625',
    municipality: 'Taubat\u00c3\u00a9'
  }
}, {
  label: 'Taupo Airport (TUO) - NZ',
  id: 'TUO',
  obj: {
    iata: 'TUO',
    iso: 'NZ',
    coordinates: '176.08399963378906, -38.73970031738281',
    municipality: 'Taupo'
  }
}, {
  label: 'Tauranga Airport (TRG) - NZ',
  id: 'TRG',
  obj: {
    iata: 'TRG',
    iso: 'NZ',
    coordinates: '176.1959991455078, -37.67190170288086',
    municipality: 'Tauranga'
  }
}, {
  label: 'Tawau Airport (TWU) - MY',
  id: 'TWU',
  obj: {
    iata: 'TWU',
    iso: 'MY',
    coordinates: '118.12799835205078, 4.320159912109375',
    municipality: 'Tawau'
  }
}, {
  label: 'Ta\u00e2\u0080\u0099if Regional Airport (TIF) - SA',
  id: 'TIF',
  obj: {
    iata: 'TIF',
    iso: 'SA',
    coordinates: '40.543442, 21.483001',
    municipality: 'Ta\u00e2\u0080\u0099if'
  }
}, {
  label: 'Tbilisi International Airport (TBS) - GE',
  id: 'TBS',
  obj: {
    iata: 'TBS',
    iso: 'GE',
    coordinates: '44.95470047, 41.6692008972',
    municipality: 'Tbilisi'
  }
}, {
  label: 'Tef\u00c3\u00a9 Airport (TFF) - BR',
  id: 'TFF',
  obj: {
    iata: 'TFF',
    iso: 'BR',
    coordinates: '-64.7240982056, -3.38294005394',
    municipality: 'Tef\u00c3\u00a9'
  }
}, {
  label: 'Toncont\u00c3\u00adn International Airport (TGU) - HN',
  id: 'TGU',
  obj: {
    iata: 'TGU',
    iso: 'HN',
    coordinates: '-87.21720123291016, 14.06089973449707',
    municipality: 'Tegucigalpa'
  }
}, {
  label: 'Imam Khomeini International Airport (IKA) - IR',
  id: 'IKA',
  obj: {
    iata: 'IKA',
    iso: 'IR',
    coordinates: '51.152198791503906, 35.416099548339844',
    municipality: 'Tehran'
  }
}, {
  label: 'Mehrabad International Airport (THR) - IR',
  id: 'THR',
  obj: {
    iata: 'THR',
    iso: 'IR',
    coordinates: '51.31340026855469, 35.68920135498047',
    municipality: 'Tehran'
  }
}, {
  label: 'Ben Gurion International Airport (TLV) - IL',
  id: 'TLV',
  obj: {
    iata: 'TLV',
    iso: 'IL',
    coordinates: '34.88669967651367, 32.01139831542969',
    municipality: 'Tel Aviv'
  }
}, {
  label: 'Tela Airport (TEA) - HN',
  id: 'TEA',
  obj: {
    iata: 'TEA',
    iso: 'HN',
    coordinates: '-87.4758, 15.7759',
    municipality: 'Tela'
  }
}, {
  label: 'Tel\u00c3\u00aamaco Borba Airport (TEC) - BR',
  id: 'TEC',
  obj: {
    iata: 'TEC',
    iso: 'BR',
    coordinates: '-50.6516, -24.317801',
    municipality: 'Tel\u00c3\u00aamaco Borba'
  }
}, {
  label: 'Draughon Miller Central Texas Regional Airport (TPL) - US',
  id: 'TPL',
  obj: {
    iata: 'TPL',
    iso: 'US',
    coordinates: '-97.40779876708984, 31.15250015258789',
    municipality: 'Temple'
  }
}, {
  label: 'La Araucan\u00c3\u00ada Airport (ZCO) - CL',
  id: 'ZCO',
  obj: {
    iata: 'ZCO',
    iso: 'CL',
    coordinates: '-72.6515, -38.9259',
    municipality: 'Temuco'
  }
}, {
  label: 'Maquehue Airport (PZS) - CL',
  id: 'PZS',
  obj: {
    iata: 'PZS',
    iso: 'CL',
    coordinates: '-72.637100219727, -38.766799926758',
    municipality: 'Temuco'
  }
}, {
  label: 'Jumandy Airport (TNW) - EC',
  id: 'TNW',
  obj: {
    iata: 'TNW',
    iso: 'EC',
    coordinates: '-77.583333, -1.059722',
    municipality: 'Tena'
  }
}, {
  label: 'Tenerife South Airport (TFS) - ES',
  id: 'TFS',
  obj: {
    iata: 'TFS',
    iso: 'ES',
    coordinates: '-16.5725002289, 28.044500351',
    municipality: 'Tenerife Island'
  }
}, {
  label: 'Tenerife Norte Airport (TFN) - ES',
  id: 'TFN',
  obj: {
    iata: 'TFN',
    iso: 'ES',
    coordinates: '-16.3414993286, 28.4827003479',
    municipality: 'Tenerife Island'
  }
}, {
  label: 'Tennant Creek Airport (TCA) - AU',
  id: 'TCA',
  obj: {
    iata: 'TCA',
    iso: 'AU',
    coordinates: '134.18299865722656, -19.6343994140625',
    municipality: 'Tennant Creek'
  }
}, {
  label: 'Amado Nervo National Airport (TPQ) - MX',
  id: 'TPQ',
  obj: {
    iata: 'TPQ',
    iso: 'MX',
    coordinates: '-104.843002, 21.4195',
    municipality: 'Tepic'
  }
}, {
  label: 'Senador Petr\u00c3\u00b4nio Portela Airport (THE) - BR',
  id: 'THE',
  obj: {
    iata: 'THE',
    iso: 'BR',
    coordinates: '-42.8235015869, -5.0599398613',
    municipality: 'Teresina'
  }
}, {
  label: 'Termas de R\u00c3\u00ado Hondo international Airport (RHD) - AR',
  id: 'RHD',
  obj: {
    iata: 'RHD',
    iso: 'AR',
    coordinates: '-64.93595, -27.4966',
    municipality: 'Termas de R\u00c3\u00ado Hondo'
  }
}, {
  label: 'Termez Airport (TMJ) - UZ',
  id: 'TMJ',
  obj: {
    iata: 'TMJ',
    iso: 'UZ',
    coordinates: '67.30999755859375, 37.28670120239258',
    municipality: 'Termez'
  }
}, {
  label: 'Northwest Regional Airport Terrace-Kitimat (YXT) - CA',
  id: 'YXT',
  obj: {
    iata: 'YXT',
    iso: 'CA',
    coordinates: '-128.576009, 54.468498',
    municipality: 'Terrace'
  }
}, {
  label: 'Terre Haute Regional Airport, Hulman Field (HUF) - US',
  id: 'HUF',
  obj: {
    iata: 'HUF',
    iso: 'US',
    coordinates: '-87.307602, 39.4515',
    municipality: 'Terre Haute'
  }
}, {
  label: 'Teruel Airport (TEV) - ES',
  id: 'TEV',
  obj: {
    iata: 'TEV',
    iso: 'ES',
    coordinates: '-1.2183, 40.403',
    municipality: 'Teruel'
  }
}, {
  label: 'Teslin Airport (YZW) - CA',
  id: 'YZW',
  obj: {
    iata: 'YZW',
    iso: 'CA',
    coordinates: '-132.7429962158203, 60.17279815673828',
    municipality: 'Teslin'
  }
}, {
  label: 'Chingozi Airport (TET) - MZ',
  id: 'TET',
  obj: {
    iata: 'TET',
    iso: 'MZ',
    coordinates: '33.640201568603516, -16.104799270629883',
    municipality: 'Tete'
  }
}, {
  label: 'Teterboro Airport (TEB) - US',
  id: 'TEB',
  obj: {
    iata: 'TEB',
    iso: 'US',
    coordinates: '-74.060798645, 40.85010147089999',
    municipality: 'Teterboro'
  }
}, {
  label: 'Texada Gillies Bay Airport (YGB) - CA',
  id: 'YGB',
  obj: {
    iata: 'YGB',
    iso: 'CA',
    coordinates: '-124.51799774169922, 49.69419860839844',
    municipality: 'Texada'
  }
}, {
  label: 'Texarkana Regional Webb Field (TXK) - US',
  id: 'TXK',
  obj: {
    iata: 'TXK',
    iso: 'US',
    coordinates: '-93.99099731445312, 33.45370101928711',
    municipality: 'Texarkana'
  }
}, {
  label: 'Thandwe Airport (SNW) - MM',
  id: 'SNW',
  obj: {
    iata: 'SNW',
    iso: 'MM',
    coordinates: '94.30010223388672, 18.4606990814209',
    municipality: 'Thandwe'
  }
}, {
  label: 'Columbia Gorge Regional the Dalles Municipal Airport (DLS) - US',
  id: 'DLS',
  obj: {
    iata: 'DLS',
    iso: 'US',
    coordinates: '-121.166999817, 45.6184997559',
    municipality: 'The Dalles'
  }
}, {
  label: 'The Pas Airport (YQD) - CA',
  id: 'YQD',
  obj: {
    iata: 'YQD',
    iso: 'CA',
    coordinates: '-101.09100341796875, 53.97140121459961',
    municipality: 'The Pas'
  }
}, {
  label: 'Clayton J Lloyd International Airport (AXA) - AI',
  id: 'AXA',
  obj: {
    iata: 'AXA',
    iso: 'AI',
    coordinates: '-63.055099, 18.2048',
    municipality: 'The Valley'
  }
}, {
  label: 'Thessaloniki Macedonia International Airport (SKG) - GR',
  id: 'SKG',
  obj: {
    iata: 'SKG',
    iso: 'GR',
    coordinates: '22.97089958190918, 40.51969909667969',
    municipality: 'Thessaloniki'
  }
}, {
  label: 'RAF Honington (BEQ) - GB',
  id: 'BEQ',
  obj: {
    iata: 'BEQ',
    iso: 'GB',
    coordinates: '0.7729390263557434, 52.34260177612305',
    municipality: 'Thetford'
  }
}, {
  label: 'Thicket Portage Airport (YTD) - CA',
  id: 'YTD',
  obj: {
    iata: 'YTD',
    iso: 'CA',
    coordinates: '-97.70780181884766, 55.31890106201172',
    municipality: 'Thicket Portage'
  }
}, {
  label: 'Trivandrum International Airport (TRV) - IN',
  id: 'TRV',
  obj: {
    iata: 'TRV',
    iso: 'IN',
    coordinates: '76.9200973511, 8.48211956024',
    municipality: 'Thiruvananthapuram'
  }
}, {
  label: 'Thisted Airport (TED) - DK',
  id: 'TED',
  obj: {
    iata: 'TED',
    iso: 'DK',
    coordinates: '8.705220222473145, 57.06880187988281',
    municipality: 'Thisted'
  }
}, {
  label: 'Thompson Airport (YTH) - CA',
  id: 'YTH',
  obj: {
    iata: 'YTH',
    iso: 'CA',
    coordinates: '-97.86419677734375, 55.80110168457031',
    municipality: 'Thompson'
  }
}, {
  label: 'Thule Air Base (THU) - GL',
  id: 'THU',
  obj: {
    iata: 'THU',
    iso: 'GL',
    coordinates: '-68.7032012939, 76.5311965942',
    municipality: 'Thule'
  }
}, {
  label: 'Thumrait Air Base (TTH) - OM',
  id: 'TTH',
  obj: {
    iata: 'TTH',
    iso: 'OM',
    coordinates: '54.024600982666016, 17.666000366210938',
    municipality: 'Thumrait'
  }
}, {
  label: 'Thunder Bay Airport (YQT) - CA',
  id: 'YQT',
  obj: {
    iata: 'YQT',
    iso: 'CA',
    coordinates: '-89.32389831542969, 48.37189865112305',
    municipality: 'Thunder Bay'
  }
}, {
  label: 'Tianjin Binhai International Airport (TSN) - CN',
  id: 'TSN',
  obj: {
    iata: 'TSN',
    iso: 'CN',
    coordinates: '117.346000671, 39.124401092499994',
    municipality: 'Tianjin'
  }
}, {
  label: 'Tianshui Maijishan Airport (THQ) - CN',
  id: 'THQ',
  obj: {
    iata: 'THQ',
    iso: 'CN',
    coordinates: '105.86000061, 34.5593986511',
    municipality: 'Tianshui'
  }
}, {
  label: 'Bou Chekif Airport (TID) - DZ',
  id: 'TID',
  obj: {
    iata: 'TID',
    iso: 'DZ',
    coordinates: '1.46315002441, 35.3410987854',
    municipality: 'Tiaret'
  }
}, {
  label: 'Tiga Airport (TGJ) - NC',
  id: 'TGJ',
  obj: {
    iata: 'TGJ',
    iso: 'NC',
    coordinates: '167.8040008544922, -21.096099853515625',
    municipality: 'Tiga'
  }
}, {
  label: 'General Abelardo L. Rodr\u00c3\u00adguez International Airport (TIJ) - MX',
  id: 'TIJ',
  obj: {
    iata: 'TIJ',
    iso: 'MX',
    coordinates: '-116.97000122070312, 32.541099548339844',
    municipality: 'Tijuana'
  }
}, {
  label: 'Tiko Airport (TKC) - CM',
  id: 'TKC',
  obj: {
    iata: 'TKC',
    iso: 'CM',
    coordinates: '9.360529899600001, 4.08919000626',
    municipality: 'Tiko'
  }
}, {
  label: 'Tiksi Airport (IKS) - RU',
  id: 'IKS',
  obj: {
    iata: 'IKS',
    iso: 'RU',
    coordinates: '128.90299987793, 71.697700500488',
    municipality: 'Tiksi'
  }
}, {
  label: 'Timbuktu Airport (TOM) - ML',
  id: 'TOM',
  obj: {
    iata: 'TOM',
    iso: 'ML',
    coordinates: '-3.007580041885376, 16.730499267578125',
    municipality: 'Timbuktu'
  }
}, {
  label: 'Moses Kilangin Airport (TIM) - ID',
  id: 'TIM',
  obj: {
    iata: 'TIM',
    iso: 'ID',
    coordinates: '136.886993, -4.52828',
    municipality: 'Timika-Papua Island'
  }
}, {
  label: 'Timimoun Airport (TMX) - DZ',
  id: 'TMX',
  obj: {
    iata: 'TMX',
    iso: 'DZ',
    coordinates: '0.276033014059, 29.2371006012',
    municipality: 'Timimoun'
  }
}, {
  label: 'Timi\u00c5\u009foara Traian Vuia Airport (TSR) - RO',
  id: 'TSR',
  obj: {
    iata: 'TSR',
    iso: 'RO',
    coordinates: '21.337900161743164, 45.809898376464844',
    municipality: 'Timi\u00c5\u009foara'
  }
}, {
  label: 'Timmins/Victor M. Power (YTS) - CA',
  id: 'YTS',
  obj: {
    iata: 'YTS',
    iso: 'CA',
    coordinates: '-81.376701355, 48.569698333699996',
    municipality: 'Timmins'
  }
}, {
  label: 'Tindouf Airport (TIN) - DZ',
  id: 'TIN',
  obj: {
    iata: 'TIN',
    iso: 'DZ',
    coordinates: '-8.167099952700001, 27.7003993988',
    municipality: 'Tindouf'
  }
}, {
  label: 'Tinian International Airport (TIQ) - MP',
  id: 'TIQ',
  obj: {
    iata: 'TIQ',
    iso: 'MP',
    coordinates: '145.61900329589844, 14.999199867248535',
    municipality: 'Tinian Island'
  }
}, {
  label: 'Tinson Pen Airport (KTP) - JM',
  id: 'KTP',
  obj: {
    iata: 'KTP',
    iso: 'JM',
    coordinates: '-76.82379913330078, 17.98859977722168',
    municipality: 'Tinson Pen'
  }
}, {
  label: 'Tirana International Airport Mother Teresa (TIA) - AL',
  id: 'TIA',
  obj: {
    iata: 'TIA',
    iso: 'AL',
    coordinates: '19.7206001282, 41.4146995544',
    municipality: 'Tirana'
  }
}, {
  label: 'Tiruchirapally Civil Airport Airport (TRZ) - IN',
  id: 'TRZ',
  obj: {
    iata: 'TRZ',
    iso: 'IN',
    coordinates: '78.70970153808594, 10.765399932861328',
    municipality: 'Tiruchirappally'
  }
}, {
  label: 'Space Coast Regional Airport (TIX) - US',
  id: 'TIX',
  obj: {
    iata: 'TIX',
    iso: 'US',
    coordinates: '-80.799201965332, 28.514799118042',
    municipality: 'Titusville'
  }
}, {
  label: 'Tivat Airport (TIV) - ME',
  id: 'TIV',
  obj: {
    iata: 'TIV',
    iso: 'ME',
    coordinates: '18.72330093383789, 42.404701232910156',
    municipality: 'Tivat'
  }
}, {
  label: 'Zenata \u00e2\u0080\u0093 Messali El Hadj Airport (TLM) - DZ',
  id: 'TLM',
  obj: {
    iata: 'TLM',
    iso: 'DZ',
    coordinates: '-1.45000004768, 35.0167007446',
    municipality: 'Tlemcen'
  }
}, {
  label: 'Barriles Airport (TOQ) - CL',
  id: 'TOQ',
  obj: {
    iata: 'TOQ',
    iso: 'CL',
    coordinates: '-70.06289672851562, -22.14109992980957',
    municipality: 'Tocopilla'
  }
}, {
  label: 'Tocumen International Airport (PTY) - PA',
  id: 'PTY',
  obj: {
    iata: 'PTY',
    iso: 'PA',
    coordinates: '-79.3834991455, 9.0713596344',
    municipality: 'Tocumen'
  }
}, {
  label: 'Tofino / Long Beach Airport (YAZ) - CA',
  id: 'YAZ',
  obj: {
    iata: 'YAZ',
    iso: 'CA',
    coordinates: '-125.775583, 49.079833',
    municipality: 'Tofino'
  }
}, {
  label: 'Togiak Airport (TOG) - US',
  id: 'TOG',
  obj: {
    iata: 'TOG',
    iso: 'US',
    coordinates: '-160.39700317382812, 59.052799224853516',
    municipality: 'Togiak Village'
  }
}, {
  label: 'Tokat Airport (TJK) - TR',
  id: 'TJK',
  obj: {
    iata: 'TJK',
    iso: 'TR',
    coordinates: '36.367408752441406, 40.307430267333984',
    municipality: 'Tokat'
  }
}, {
  label: 'Chubu Centrair International Airport (NGO) - JP',
  id: 'NGO',
  obj: {
    iata: 'NGO',
    iso: 'JP',
    coordinates: '136.80499267578125, 34.8583984375',
    municipality: 'Tokoname'
  }
}, {
  label: 'Tokua Airport (RAB) - PG',
  id: 'RAB',
  obj: {
    iata: 'RAB',
    iso: 'PG',
    coordinates: '152.380004883, -4.34045982361',
    municipality: 'Tokua'
  }
}, {
  label: 'Tokunoshima Airport (TKN) - JP',
  id: 'TKN',
  obj: {
    iata: 'TKN',
    iso: 'JP',
    coordinates: '128.88099670410156, 27.83639907836914',
    municipality: 'Tokunoshima'
  }
}, {
  label: 'Tokushima Airport/JMSDF Air Base (TKS) - JP',
  id: 'TKS',
  obj: {
    iata: 'TKS',
    iso: 'JP',
    coordinates: '134.606995, 34.132801',
    municipality: 'Tokushima'
  }
}, {
  label: 'Narita International Airport (NRT) - JP',
  id: 'NRT',
  obj: {
    iata: 'NRT',
    iso: 'JP',
    coordinates: '140.386002, 35.764702',
    municipality: 'Tokyo / Narita'
  }
}, {
  label: 'Toledo Express Airport (TOL) - US',
  id: 'TOL',
  obj: {
    iata: 'TOL',
    iso: 'US',
    coordinates: '-83.80780029, 41.58679962',
    municipality: 'Toledo'
  }
}, {
  label: 'Licenciado Adolfo Lopez Mateos International Airport (TLC) - MX',
  id: 'TLC',
  obj: {
    iata: 'TLC',
    iso: 'MX',
    coordinates: '-99.56600189210002, 19.3370990753',
    municipality: 'Toluca'
  }
}, {
  label: 'Bogashevo Airport (TOF) - RU',
  id: 'TOF',
  obj: {
    iata: 'TOF',
    iso: 'RU',
    coordinates: '85.208297729492, 56.380298614502',
    municipality: 'Tomsk'
  }
}, {
  label: 'Tongliao Airport (TGO) - CN',
  id: 'TGO',
  obj: {
    iata: 'TGO',
    iso: 'CN',
    coordinates: '122.199997, 43.556702',
    municipality: 'Tongliao'
  }
}, {
  label: 'Tonopah Airport (TPH) - US',
  id: 'TPH',
  obj: {
    iata: 'TPH',
    iso: 'US',
    coordinates: '-117.086998, 38.06019974',
    municipality: 'Tonopah'
  }
}, {
  label: 'Toowoomba Wellcamp Airport (WTB) - AU',
  id: 'WTB',
  obj: {
    iata: 'WTB',
    iso: 'AU',
    coordinates: '151.793335, -27.558332',
    municipality: 'Toowoomba'
  }
}, {
  label: 'Topeka Regional Airport - Forbes Field (FOE) - US',
  id: 'FOE',
  obj: {
    iata: 'FOE',
    iso: 'US',
    coordinates: '-95.66359710690001, 38.950901031499995',
    municipality: 'Topeka'
  }
}, {
  label: 'Philip Billard Municipal Airport (TOP) - US',
  id: 'TOP',
  obj: {
    iata: 'TOP',
    iso: 'US',
    coordinates: '-95.622497558594, 39.068698883057',
    municipality: 'Topeka'
  }
}, {
  label: 'Turin Airport (TRN) - IT',
  id: 'TRN',
  obj: {
    iata: 'TRN',
    iso: 'IT',
    coordinates: '7.64963, 45.200802',
    municipality: 'Torino'
  }
}, {
  label: 'Buttonville Municipal Airport (YKZ) - CA',
  id: 'YKZ',
  obj: {
    iata: 'YKZ',
    iso: 'CA',
    coordinates: '-79.37000274658203, 43.86220169067383',
    municipality: 'Toronto'
  }
}, {
  label: 'Billy Bishop Toronto City Centre Airport (YTZ) - CA',
  id: 'YTZ',
  obj: {
    iata: 'YTZ',
    iso: 'CA',
    coordinates: '-79.396202, 43.627499',
    municipality: 'Toronto'
  }
}, {
  label: 'Lester B. Pearson International Airport (YYZ) - CA',
  id: 'YYZ',
  obj: {
    iata: 'YYZ',
    iso: 'CA',
    coordinates: '-79.63059997559999, 43.6772003174',
    municipality: 'Toronto'
  }
}, {
  label: 'Sandefjord Airport, Torp (TRF) - NO',
  id: 'TRF',
  obj: {
    iata: 'TRF',
    iso: 'NO',
    coordinates: '10.258600235, 59.1866989136',
    municipality: 'Torp'
  }
}, {
  label: 'Francisco Sarabia International Airport (TRC) - MX',
  id: 'TRC',
  obj: {
    iata: 'TRC',
    iso: 'MX',
    coordinates: '-103.411003113, 25.568300247199996',
    municipality: 'Torre\u00c3\u00b3n'
  }
}, {
  label: 'Tottori Sand Dunes Conan Airport (TTJ) - JP',
  id: 'TTJ',
  obj: {
    iata: 'TTJ',
    iso: 'JP',
    coordinates: '134.167007, 35.530102',
    municipality: 'Tottori'
  }
}, {
  label: 'Touggourt Sidi Madhi Airport (TGR) - DZ',
  id: 'TGR',
  obj: {
    iata: 'TGR',
    iso: 'DZ',
    coordinates: '6.088669776916504, 33.06779861450195',
    municipality: 'Touggourt'
  }
}, {
  label: 'Touho Airport (TOU) - NC',
  id: 'TOU',
  obj: {
    iata: 'TOU',
    iso: 'NC',
    coordinates: '165.25900268554688, -20.790000915527344',
    municipality: 'Touho'
  }
}, {
  label: 'Toulon-Hy\u00c3\u00a8res Airport (TLN) - FR',
  id: 'TLN',
  obj: {
    iata: 'TLN',
    iso: 'FR',
    coordinates: '6.14602994919, 43.0973014832',
    municipality: 'Toulon/Hy\u00c3\u00a8res/Le Palyvestre'
  }
}, {
  label: 'Toulouse-Blagnac Airport (TLS) - FR',
  id: 'TLS',
  obj: {
    iata: 'TLS',
    iso: 'FR',
    coordinates: '1.36382, 43.629101',
    municipality: 'Toulouse/Blagnac'
  }
}, {
  label: 'Tours-Val-de-Loire Airport (TUF) - FR',
  id: 'TUF',
  obj: {
    iata: 'TUF',
    iso: 'FR',
    coordinates: '0.727605998516, 47.4322013855',
    municipality: 'Tours/Val de Loire (Loire Valley)'
  }
}, {
  label: 'Toussus-le-Noble Airport (TNF) - FR',
  id: 'TNF',
  obj: {
    iata: 'TNF',
    iso: 'FR',
    coordinates: '2.1061899662017822, 48.75189971923828',
    municipality: 'Toussus-le-Noble'
  }
}, {
  label: 'Townsville Airport (TSV) - AU',
  id: 'TSV',
  obj: {
    iata: 'TSV',
    iso: 'AU',
    coordinates: '146.76499938964844, -19.252500534057617',
    municipality: 'Townsville'
  }
}, {
  label: 'Toyama Airport (TOY) - JP',
  id: 'TOY',
  obj: {
    iata: 'TOY',
    iso: 'JP',
    coordinates: '137.18800354003906, 36.64830017089844',
    municipality: 'Toyama'
  }
}, {
  label: 'Konotori Tajima Airport (TJH) - JP',
  id: 'TJH',
  obj: {
    iata: 'TJH',
    iso: 'JP',
    coordinates: '134.787003, 35.512798',
    municipality: 'Toyooka'
  }
}, {
  label: 'Tozeur Nefta International Airport (TOE) - TN',
  id: 'TOE',
  obj: {
    iata: 'TOE',
    iso: 'TN',
    coordinates: '8.110560417175293, 33.939701080322266',
    municipality: 'Tozeur'
  }
}, {
  label: 'Trabzon International Airport (TZX) - TR',
  id: 'TZX',
  obj: {
    iata: 'TZX',
    iso: 'TR',
    coordinates: '39.78969955444336, 40.99509811401367',
    municipality: 'Trabzon'
  }
}, {
  label: 'Vincenzo Florio Airport Trapani-Birgi (TPS) - IT',
  id: 'TPS',
  obj: {
    iata: 'TPS',
    iso: 'IT',
    coordinates: '12.488, 37.9114',
    municipality: 'Trapani (TP)'
  }
}, {
  label: 'Cherry Capital Airport (TVC) - US',
  id: 'TVC',
  obj: {
    iata: 'TVC',
    iso: 'US',
    coordinates: '-85.58219909667969, 44.74140167236328',
    municipality: 'Traverse City'
  }
}, {
  label: 'Treasure Cay Airport (TCB) - BS',
  id: 'TCB',
  obj: {
    iata: 'TCB',
    iso: 'BS',
    coordinates: '-77.3912963867, 26.745300293',
    municipality: 'Treasure Cay'
  }
}, {
  label: 'CFB Trenton (YTR) - CA',
  id: 'YTR',
  obj: {
    iata: 'YTR',
    iso: 'CA',
    coordinates: '-77.5280990600586, 44.118900299072266',
    municipality: 'Trenton'
  }
}, {
  label: 'Trenton Mercer Airport (TTN) - US',
  id: 'TTN',
  obj: {
    iata: 'TTN',
    iso: 'US',
    coordinates: '-74.8134994506836, 40.27669906616211',
    municipality: 'Trenton'
  }
}, {
  label: 'Tres Arroyos Airport (OYO) - AR',
  id: 'OYO',
  obj: {
    iata: 'OYO',
    iso: 'AR',
    coordinates: '-60.3297, -38.3869',
    municipality: 'Tres Arroyos'
  }
}, {
  label: 'Tres Esquinas Air Base (TQS) - CO',
  id: 'TQS',
  obj: {
    iata: 'TQS',
    iso: 'CO',
    coordinates: '-75.234, 0.7459',
    municipality: 'Tres Esquinas'
  }
}, {
  label: "Treviso-Sant'Angelo Airport (TSF) - IT",
  id: 'TSF',
  obj: {
    iata: 'TSF',
    iso: 'IT',
    coordinates: '12.1944, 45.648399',
    municipality: 'Treviso'
  }
}, {
  label: 'Spangdahlem Air Base (SPM) - DE',
  id: 'SPM',
  obj: {
    iata: 'SPM',
    iso: 'DE',
    coordinates: '6.69250011444, 49.9726982117',
    municipality: 'Trier'
  }
}, {
  label: 'Trieste\u00e2\u0080\u0093Friuli Venezia Giulia Airport (TRS) - IT',
  id: 'TRS',
  obj: {
    iata: 'TRS',
    iso: 'IT',
    coordinates: '13.4722, 45.827499',
    municipality: 'Trieste'
  }
}, {
  label: 'China Bay Airport (TRR) - LK',
  id: 'TRR',
  obj: {
    iata: 'TRR',
    iso: 'LK',
    coordinates: '81.18190002441406, 8.5385103225708',
    municipality: 'Trincomalee'
  }
}, {
  label: 'Alberto Delgado Airport (TND) - CU',
  id: 'TND',
  obj: {
    iata: 'TND',
    iso: 'CU',
    coordinates: '-79.99720001220703, 21.788299560546875',
    municipality: 'Trinidad'
  }
}, {
  label: 'Teniente Av. Jorge Henrich Arauz Airport (TDD) - BO',
  id: 'TDD',
  obj: {
    iata: 'TDD',
    iso: 'BO',
    coordinates: '-64.9179992676, -14.8186998367',
    municipality: 'Trinidad'
  }
}, {
  label: 'Mitiga Airport (MJI) - LY',
  id: 'MJI',
  obj: {
    iata: 'MJI',
    iso: 'LY',
    coordinates: '13.276000022888184, 32.894100189208984',
    municipality: 'Tripoli'
  }
}, {
  label: 'Tripoli International Airport (TIP) - LY',
  id: 'TIP',
  obj: {
    iata: 'TIP',
    iso: 'LY',
    coordinates: '13.1590003967, 32.6635017395',
    municipality: 'Tripoli'
  }
}, {
  label: 'Rene Mouawad Air Base (KYE) - LB',
  id: 'KYE',
  obj: {
    iata: 'KYE',
    iso: 'LB',
    coordinates: '36.01129913330078, 34.589298248291016',
    municipality: 'Tripoli'
  }
}, {
  label: 'Trois-Rivi\u00c3\u00a8res Airport (YRQ) - CA',
  id: 'YRQ',
  obj: {
    iata: 'YRQ',
    iso: 'CA',
    coordinates: '-72.67939758300781, 46.35279846191406',
    municipality: 'Trois-Rivi\u00c3\u00a8res'
  }
}, {
  label: 'Trollh\u00c3\u00a4ttan-V\u00c3\u00a4nersborg Airport (THN) - SE',
  id: 'THN',
  obj: {
    iata: 'THN',
    iso: 'SE',
    coordinates: '12.345000267028809, 58.31809997558594',
    municipality: 'Trollh\u00c3\u00a4ttan'
  }
}, {
  label: 'Troms\u00c3\u00b8 Airport (TOS) - NO',
  id: 'TOS',
  obj: {
    iata: 'TOS',
    iso: 'NO',
    coordinates: '18.918899536132812, 69.68329620361328',
    municipality: 'Troms\u00c3\u00b8'
  }
}, {
  label: 'Trondheim Airport V\u00c3\u00a6rnes (TRD) - NO',
  id: 'TRD',
  obj: {
    iata: 'TRD',
    iso: 'NO',
    coordinates: '10.9239998, 63.4578018',
    municipality: 'Trondheim'
  }
}, {
  label: 'Troy Municipal Airport at N Kenneth Campbell Field (TOI) - US',
  id: 'TOI',
  obj: {
    iata: 'TOI',
    iso: 'US',
    coordinates: '-86.012101, 31.860399',
    municipality: 'Troy'
  }
}, {
  label: 'Truckee Tahoe Airport (TKF) - US',
  id: 'TKF',
  obj: {
    iata: 'TKF',
    iso: 'US',
    coordinates: '-120.13999939, 39.319999694799996',
    municipality: 'Truckee'
  }
}, {
  label: 'Trujillo Airport (TJI) - HN',
  id: 'TJI',
  obj: {
    iata: 'TJI',
    iso: 'HN',
    coordinates: '-85.938202, 15.9268',
    municipality: 'Trujillo'
  }
}, {
  label: 'Capitan FAP Carlos Martinez De Pinillos International Airport (TRU) - PE',
  id: 'TRU',
  obj: {
    iata: 'TRU',
    iso: 'PE',
    coordinates: '-79.10880279541016, -8.08141040802002',
    municipality: 'Trujillo'
  }
}, {
  label: 'Truth Or Consequences Municipal Airport (TCS) - US',
  id: 'TCS',
  obj: {
    iata: 'TCS',
    iso: 'US',
    coordinates: '-107.272003174, 33.2369003296',
    municipality: 'Truth Or Consequences'
  }
}, {
  label: 'Tsumeb Airport (TSB) - NA',
  id: 'TSB',
  obj: {
    iata: 'TSB',
    iso: 'NA',
    coordinates: '17.732500076294, -19.26189994812',
    municipality: 'Tsumeb'
  }
}, {
  label: 'Tsushima Airport (TSJ) - JP',
  id: 'TSJ',
  obj: {
    iata: 'TSJ',
    iso: 'JP',
    coordinates: '129.330993652, 34.2849006653',
    municipality: 'Tsushima'
  }
}, {
  label: 'Davis Monthan Air Force Base (DMA) - US',
  id: 'DMA',
  obj: {
    iata: 'DMA',
    iso: 'US',
    coordinates: '-110.883003235, 32.1665000916',
    municipality: 'Tucson'
  }
}, {
  label: 'Tucson International Airport / Morris Air National Guard Base (TUS) - US',
  id: 'TUS',
  obj: {
    iata: 'TUS',
    iso: 'US',
    coordinates: '-110.938053, 32.115004',
    municipality: 'Tucson'
  }
}, {
  label: 'Tucumcari Municipal Airport (TCC) - US',
  id: 'TCC',
  obj: {
    iata: 'TCC',
    iso: 'US',
    coordinates: '-103.602996826, 35.182800293',
    municipality: 'Tucumcari'
  }
}, {
  label: 'Tucupita Airport (TUV) - VE',
  id: 'TUV',
  obj: {
    iata: 'TUV',
    iso: 'VE',
    coordinates: '-62.094173431396484, 9.088994026184082',
    municipality: 'Tucupita'
  }
}, {
  label: 'Tucuru\u00c3\u00ad Airport (TUR) - BR',
  id: 'TUR',
  obj: {
    iata: 'TUR',
    iso: 'BR',
    coordinates: '-49.72029876709, -3.7860100269318',
    municipality: 'Tucuru\u00c3\u00ad'
  }
}, {
  label: 'Tuguegarao Airport (TUG) - PH',
  id: 'TUG',
  obj: {
    iata: 'TUG',
    iso: 'PH',
    coordinates: '121.733150482, 17.6433676823',
    municipality: 'Tuguegarao City'
  }
}, {
  label: 'Tuktoyaktuk Airport (YUB) - CA',
  id: 'YUB',
  obj: {
    iata: 'YUB',
    iso: 'CA',
    coordinates: '-133.0260009765625, 69.43329620361328',
    municipality: 'Tuktoyaktuk'
  }
}, {
  label: 'Tulcea Airport (TCE) - RO',
  id: 'TCE',
  obj: {
    iata: 'TCE',
    iso: 'RO',
    coordinates: '28.71430015563965, 45.0625',
    municipality: 'Tulcea'
  }
}, {
  label: 'Teniente Coronel Luis a Mantilla Airport (TUA) - EC',
  id: 'TUA',
  obj: {
    iata: 'TUA',
    iso: 'EC',
    coordinates: '-77.70809936523438, 0.8095059990882874',
    municipality: 'Tulc\u00c3\u00a1n'
  }
}, {
  label: 'Tulita Airport (ZFN) - CA',
  id: 'ZFN',
  obj: {
    iata: 'ZFN',
    iso: 'CA',
    coordinates: '-125.572998, 64.909697',
    municipality: 'Tulita'
  }
}, {
  label: 'Richard Lloyd Jones Jr Airport (RVS) - US',
  id: 'RVS',
  obj: {
    iata: 'RVS',
    iso: 'US',
    coordinates: '-95.984596252441, 36.039600372314',
    municipality: 'Tulsa'
  }
}, {
  label: 'Tulsa International Airport (TUL) - US',
  id: 'TUL',
  obj: {
    iata: 'TUL',
    iso: 'US',
    coordinates: '-95.88809967041016, 36.19839859008789',
    municipality: 'Tulsa'
  }
}, {
  label: 'Heriberto G\u00c3\u00adl Mart\u00c3\u00adnez Airport (ULQ) - CO',
  id: 'ULQ',
  obj: {
    iata: 'ULQ',
    iso: 'CO',
    coordinates: '-76.2351, 4.08836',
    municipality: 'Tulu\u00c3\u00a1'
  }
}, {
  label: 'La Florida Airport (TCO) - CO',
  id: 'TCO',
  obj: {
    iata: 'TCO',
    iso: 'CO',
    coordinates: '-78.7492, 1.81442',
    municipality: 'Tumaco'
  }
}, {
  label: 'Capitan FAP Pedro Canga Rodriguez Airport (TBP) - PE',
  id: 'TBP',
  obj: {
    iata: 'TBP',
    iso: 'PE',
    coordinates: '-80.38140106201172, -3.55253005027771',
    municipality: 'Tumbes'
  }
}, {
  label: 'Tunis Carthage International Airport (TUN) - TN',
  id: 'TUN',
  obj: {
    iata: 'TUN',
    iso: 'TN',
    coordinates: '10.22719955444336, 36.85100173950195',
    municipality: 'Tunis'
  }
}, {
  label: 'Tupelo Regional Airport (TUP) - US',
  id: 'TUP',
  obj: {
    iata: 'TUP',
    iso: 'US',
    coordinates: '-88.7698974609375, 34.26810073852539',
    municipality: 'Tupelo'
  }
}, {
  label: 'Turaif Domestic Airport (TUI) - SA',
  id: 'TUI',
  obj: {
    iata: 'TUI',
    iso: 'SA',
    coordinates: '38.731544, 31.692188',
    municipality: 'Turaif'
  }
}, {
  label: 'Turbat International Airport (TUK) - PK',
  id: 'TUK',
  obj: {
    iata: 'TUK',
    iso: 'PK',
    coordinates: '63.03020095825195, 25.986400604248047',
    municipality: 'Turbat'
  }
}, {
  label: 'Turku Airport (TKU) - FI',
  id: 'TKU',
  obj: {
    iata: 'TKU',
    iso: 'FI',
    coordinates: '22.262800216675, 60.514099121094',
    municipality: 'Turku'
  }
}, {
  label: 'Tuscaloosa Regional Airport (TCL) - US',
  id: 'TCL',
  obj: {
    iata: 'TCL',
    iso: 'US',
    coordinates: '-87.611396789551, 33.220600128174',
    municipality: 'Tuscaloosa'
  }
}, {
  label: 'Angel Albino Corzo International Airport (TGZ) - MX',
  id: 'TGZ',
  obj: {
    iata: 'TGZ',
    iso: 'MX',
    coordinates: '-93.02249908450001, 16.5636005402',
    municipality: 'Tuxtla Guti\u00c3\u00a9rrez'
  }
}, {
  label: 'Dong Tac Airport (TBB) - VN',
  id: 'TBB',
  obj: {
    iata: 'TBB',
    iso: 'VN',
    coordinates: '109.333999634, 13.049599647500001',
    municipality: 'Tuy Hoa'
  }
}, {
  label: 'Tuzla International Airport (TZL) - BA',
  id: 'TZL',
  obj: {
    iata: 'TZL',
    iso: 'BA',
    coordinates: '18.72480010986328, 44.45869827270508',
    municipality: 'Tuzla'
  }
}, {
  label: 'Migalovo Air Base (KLD) - RU',
  id: 'KLD',
  obj: {
    iata: 'KLD',
    iso: 'RU',
    coordinates: '35.7577018737793, 56.82469940185547',
    municipality: 'Tver'
  }
}, {
  label: 'Joslin Field Magic Valley Regional Airport (TWF) - US',
  id: 'TWF',
  obj: {
    iata: 'TWF',
    iso: 'US',
    coordinates: '-114.487999, 42.4818',
    municipality: 'Twin Falls'
  }
}, {
  label: 'Pukaki Airport (TWZ) - NZ',
  id: 'TWZ',
  obj: {
    iata: 'TWZ',
    iso: 'NZ',
    coordinates: '170.117996216, -44.2350006104',
    municipality: 'Twitzel'
  }
}, {
  label: 'Tyler Pounds Regional Airport (TYR) - US',
  id: 'TYR',
  obj: {
    iata: 'TYR',
    iso: 'US',
    coordinates: '-95.40239715576172, 32.35409927368164',
    municipality: 'Tyler'
  }
}, {
  label: 'Roshchino International Airport (TJM) - RU',
  id: 'TJM',
  obj: {
    iata: 'TJM',
    iso: 'RU',
    coordinates: '65.3243026733, 57.189601898199996',
    municipality: 'Tyumen'
  }
}, {
  label: 'Tzaneen Airport (LTA) - ZA',
  id: 'LTA',
  obj: {
    iata: 'LTA',
    iso: 'ZA',
    coordinates: '30.329299926799997, -23.8243999481',
    municipality: 'Tzaneen'
  }
}, {
  label: 'Transilvania T\u00c3\u00a2rgu Mure\u00c5\u009f International Airport (TGM) - RO',
  id: 'TGM',
  obj: {
    iata: 'TGM',
    iso: 'RO',
    coordinates: '24.412500381469727, 46.46770095825195',
    municipality: 'T\u00c3\u00a2rgu Mure\u00c5\u009f'
  }
}, {
  label: 'Cheikh Larbi T\u00c3\u00a9bessi Airport (TEE) - DZ',
  id: 'TEE',
  obj: {
    iata: 'TEE',
    iso: 'DZ',
    coordinates: '8.12071990967, 35.4315986633',
    municipality: 'T\u00c3\u00a9bessi'
  }
}, {
  label: "Saniat R'mel Airport (TTU) - MA",
  id: 'TTU',
  obj: {
    iata: 'TTU',
    iso: 'MA',
    coordinates: '-5.320020198822, 35.594299316406',
    municipality: 'T\u00c3\u00a9touan'
  }
}, {
  label: 'T\u00c3\u00b4lanaro Airport (FTU) - MG',
  id: 'FTU',
  obj: {
    iata: 'FTU',
    iso: 'MG',
    coordinates: '46.95610046386719, -25.03809928894043',
    municipality: 'T\u00c3\u00b4lanaro'
  }
}, {
  label: 'Turkmenabat Airport (CRZ) - TM',
  id: 'CRZ',
  obj: {
    iata: 'CRZ',
    iso: 'TM',
    coordinates: '63.61330032348633, 39.08330154418945',
    municipality: 'T\u00c3\u00bcrkmenabat'
  }
}, {
  label: 'Yamaguchi Ube Airport (UBJ) - JP',
  id: 'UBJ',
  obj: {
    iata: 'UBJ',
    iso: 'JP',
    coordinates: '131.279006958, 33.930000305200004',
    municipality: 'Ube'
  }
}, {
  label: 'M\u00c3\u00a1rio de Almeida Franco Airport (UBA) - BR',
  id: 'UBA',
  obj: {
    iata: 'UBA',
    iso: 'BR',
    coordinates: '-47.966110229492, -19.764722824097',
    municipality: 'Uberaba'
  }
}, {
  label: 'Ten. Cel. Aviador C\u00c3\u00a9sar Bombonato Airport (UDI) - BR',
  id: 'UDI',
  obj: {
    iata: 'UDI',
    iso: 'BR',
    coordinates: '-48.225277, -18.883612',
    municipality: 'Uberl\u00c3\u00a2ndia'
  }
}, {
  label: 'Ubon Ratchathani Airport (UBP) - TH',
  id: 'UBP',
  obj: {
    iata: 'UBP',
    iso: 'TH',
    coordinates: '104.870002747, 15.2512998581',
    municipality: 'Ubon Ratchathani'
  }
}, {
  label: 'Maharana Pratap Airport (UDR) - IN',
  id: 'UDR',
  obj: {
    iata: 'UDR',
    iso: 'IN',
    coordinates: '73.89610290530001, 24.617700576799997',
    municipality: 'Udaipur'
  }
}, {
  label: 'Udon Thani Airport (UTH) - TH',
  id: 'UTH',
  obj: {
    iata: 'UTH',
    iso: 'TH',
    coordinates: '102.788002014, 17.386400222800003',
    municipality: 'Udon Thani'
  }
}, {
  label: 'Ufa International Airport (UFA) - RU',
  id: 'UFA',
  obj: {
    iata: 'UFA',
    iso: 'RU',
    coordinates: '55.874401092529, 54.557498931885',
    municipality: 'Ufa'
  }
}, {
  label: 'Kunovice Airport (UHE) - CZ',
  id: 'UHE',
  obj: {
    iata: 'UHE',
    iso: 'CZ',
    coordinates: '17.439699172973633, 49.02939987182617',
    municipality: 'Uhersk\u00c3\u00a9 Hradi\u00c5\u00a1t\u00c4\u009b'
  }
}, {
  label: 'Uige Airport (UGO) - AO',
  id: 'UGO',
  obj: {
    iata: 'UGO',
    iso: 'AO',
    coordinates: '15.027799606323242, -7.60306978225708',
    municipality: 'Uige'
  }
}, {
  label: 'Hasanuddin International Airport (UPG) - ID',
  id: 'UPG',
  obj: {
    iata: 'UPG',
    iso: 'ID',
    coordinates: '119.55400085449219, -5.061629772186279',
    municipality: 'Ujung Pandang-Celebes Island'
  }
}, {
  label: 'Ukhta Airport (UCT) - RU',
  id: 'UCT',
  obj: {
    iata: 'UCT',
    iso: 'RU',
    coordinates: '53.8046989440918, 63.566898345947266',
    municipality: 'Ukhta'
  }
}, {
  label: 'Ukiah Municipal Airport (UKI) - US',
  id: 'UKI',
  obj: {
    iata: 'UKI',
    iso: 'US',
    coordinates: '-123.20099639893, 39.125999450684',
    municipality: 'Ukiah'
  }
}, {
  label: 'Ulan-Ude Airport (Mukhino) (UUD) - RU',
  id: 'UUD',
  obj: {
    iata: 'UUD',
    iso: 'RU',
    coordinates: '107.43800354003906, 51.80780029296875',
    municipality: 'Ulan Ude'
  }
}, {
  label: 'Ulanqab Jining Airport (UCB) - CN',
  id: 'UCB',
  obj: {
    iata: 'UCB',
    iso: 'CN',
    coordinates: '113.108056, 41.129722',
    municipality: 'Ulanqab'
  }
}, {
  label: 'Ulsan Airport (USN) - KR',
  id: 'USN',
  obj: {
    iata: 'USN',
    iso: 'KR',
    coordinates: '129.352005005, 35.59349823',
    municipality: 'Ulsan'
  }
}, {
  label: 'Ulukhaktok Holman Airport (YHI) - CA',
  id: 'YHI',
  obj: {
    iata: 'YHI',
    iso: 'CA',
    coordinates: '-117.80599975585938, 70.76280212402344',
    municipality: 'Ulukhaktok'
  }
}, {
  label: 'Prince Mangosuthu Buthelezi Airport (ULD) - ZA',
  id: 'ULD',
  obj: {
    iata: 'ULD',
    iso: 'ZA',
    coordinates: '31.4165000916, -28.3206005096',
    municipality: 'Ulundi'
  }
}, {
  label: 'Ulyanovsk Baratayevka Airport (ULV) - RU',
  id: 'ULV',
  obj: {
    iata: 'ULV',
    iso: 'RU',
    coordinates: '48.226699829100006, 54.26829910279999',
    municipality: 'Ulyanovsk'
  }
}, {
  label: 'Ulyanovsk East Airport (ULY) - RU',
  id: 'ULY',
  obj: {
    iata: 'ULY',
    iso: 'RU',
    coordinates: '48.80270004272461, 54.4010009765625',
    municipality: 'Ulyanovsk'
  }
}, {
  label: 'Ume\u00c3\u00a5 Airport (UME) - SE',
  id: 'UME',
  obj: {
    iata: 'UME',
    iso: 'SE',
    coordinates: '20.282800674438, 63.791801452637',
    municipality: 'Ume\u00c3\u00a5'
  }
}, {
  label: 'Umiujaq Airport (YUD) - CA',
  id: 'YUD',
  obj: {
    iata: 'YUD',
    iso: 'CA',
    coordinates: '-76.51830291748047, 56.53609848022461',
    municipality: 'Umiujaq'
  }
}, {
  label: 'Unalaska Airport (DUT) - US',
  id: 'DUT',
  obj: {
    iata: 'DUT',
    iso: 'US',
    coordinates: '-166.544006348, 53.900100708',
    municipality: 'Unalaska'
  }
}, {
  label: 'Union Island International Airport (UNI) - VC',
  id: 'UNI',
  obj: {
    iata: 'UNI',
    iso: 'VC',
    coordinates: '-61.41194534301758, 12.60013484954834',
    municipality: 'Union Island'
  }
}, {
  label: 'Randolph Air Force Base (RND) - US',
  id: 'RND',
  obj: {
    iata: 'RND',
    iso: 'US',
    coordinates: '-98.27890015, 29.52969933',
    municipality: 'Universal City'
  }
}, {
  label: 'Upala Airport (UPL) - CR',
  id: 'UPL',
  obj: {
    iata: 'UPL',
    iso: 'CR',
    coordinates: '-85.016197, 10.8922',
    municipality: 'Upala'
  }
}, {
  label: 'Pierre Van Ryneveld Airport (UTN) - ZA',
  id: 'UTN',
  obj: {
    iata: 'UTN',
    iso: 'ZA',
    coordinates: '21.260200500499998, -28.39909935',
    municipality: 'Upington'
  }
}, {
  label: 'Uralsk Airport (URA) - KZ',
  id: 'URA',
  obj: {
    iata: 'URA',
    iso: 'KZ',
    coordinates: '51.54309844970703, 51.15079879760742',
    municipality: 'Uralsk'
  }
}, {
  label: 'Uranium City Airport (YBE) - CA',
  id: 'YBE',
  obj: {
    iata: 'YBE',
    iso: 'CA',
    coordinates: '-108.48100280761719, 59.5614013671875',
    municipality: 'Uranium City'
  }
}, {
  label: 'Uray Airport (URJ) - RU',
  id: 'URJ',
  obj: {
    iata: 'URJ',
    iso: 'RU',
    coordinates: '64.82669830322266, 60.10329818725586',
    municipality: 'Uray'
  }
}, {
  label: 'Urgench Airport (UGC) - UZ',
  id: 'UGC',
  obj: {
    iata: 'UGC',
    iso: 'UZ',
    coordinates: '60.641700744628906, 41.58430099487305',
    municipality: 'Urgench'
  }
}, {
  label: 'Urmia Airport (OMH) - IR',
  id: 'OMH',
  obj: {
    iata: 'OMH',
    iso: 'IR',
    coordinates: '45.0686988831, 37.6680984497',
    municipality: 'Urmia'
  }
}, {
  label: 'Rubem Berta Airport (URG) - BR',
  id: 'URG',
  obj: {
    iata: 'URG',
    iso: 'BR',
    coordinates: '-57.0382003784, -29.7821998596',
    municipality: 'Uruguaiana'
  }
}, {
  label: 'Malvinas Argentinas Airport (USH) - AR',
  id: 'USH',
  obj: {
    iata: 'USH',
    iso: 'AR',
    coordinates: '-68.2958, -54.8433',
    municipality: 'Ushuahia'
  }
}, {
  label: 'Usinsk Airport (USK) - RU',
  id: 'USK',
  obj: {
    iata: 'USK',
    iso: 'RU',
    coordinates: '57.3671989440918, 66.00469970703125',
    municipality: 'Usinsk'
  }
}, {
  label: 'Ust-Kamennogorsk Airport (UKK) - KZ',
  id: 'UKK',
  obj: {
    iata: 'UKK',
    iso: 'KZ',
    coordinates: '82.49420166015625, 50.036598205566406',
    municipality: 'Ust Kamenogorsk'
  }
}, {
  label: 'Ust-Kut Airport (UKX) - RU',
  id: 'UKX',
  obj: {
    iata: 'UKX',
    iso: 'RU',
    coordinates: '105.7300033569336, 56.8567008972168',
    municipality: 'Ust-Kut'
  }
}, {
  label: 'Ust-Nera Airport (USR) - RU',
  id: 'USR',
  obj: {
    iata: 'USR',
    iso: 'RU',
    coordinates: '143.11500549316, 64.550003051758',
    municipality: 'Ust-Nera'
  }
}, {
  label: 'Ust-Tsylma Airport (UTS) - RU',
  id: 'UTS',
  obj: {
    iata: 'UTS',
    iso: 'RU',
    coordinates: '52.20033645629999, 65.43729400630001',
    municipality: 'Ust-Tsylma'
  }
}, {
  label: 'Indian Mountain LRRS Airport (UTO) - US',
  id: 'UTO',
  obj: {
    iata: 'UTO',
    iso: 'US',
    coordinates: '-153.7039948, 65.99279785',
    municipality: 'Utopia Creek'
  }
}, {
  label: 'Wiley Post Will Rogers Memorial Airport (BRW) - US',
  id: 'BRW',
  obj: {
    iata: 'BRW',
    iso: 'US',
    coordinates: '-156.766008, 71.285402',
    municipality: 'Utqia\u00c4\u00a1vik'
  }
}, {
  label: 'Utti Air Base (UTI) - FI',
  id: 'UTI',
  obj: {
    iata: 'UTI',
    iso: 'FI',
    coordinates: '26.938400268555, 60.89640045166',
    municipality: 'Utti / Valkeala'
  }
}, {
  label: 'Raiatea Airport (RFP) - PF',
  id: 'RFP',
  obj: {
    iata: 'RFP',
    iso: 'PF',
    coordinates: '-151.466003, -16.7229',
    municipality: 'Uturoa'
  }
}, {
  label: 'Akwa Ibom International Airport (QUO) - NG',
  id: 'QUO',
  obj: {
    iata: 'QUO',
    iso: 'NG',
    coordinates: '8.093, 4.8725',
    municipality: 'Uyo'
  }
}, {
  label: 'Uzhhorod International Airport (UDJ) - UA',
  id: 'UDJ',
  obj: {
    iata: 'UDJ',
    iso: 'UA',
    coordinates: '22.263399124145508, 48.634300231933594',
    municipality: 'Uzhhorod'
  }
}, {
  label: 'Vaasa Airport (VAA) - FI',
  id: 'VAA',
  obj: {
    iata: 'VAA',
    iso: 'FI',
    coordinates: '21.762199401855, 63.050701141357',
    municipality: 'Vaasa'
  }
}, {
  label: 'Vadodara Airport (BDQ) - IN',
  id: 'BDQ',
  obj: {
    iata: 'BDQ',
    iso: 'IN',
    coordinates: '73.226303, 22.336201',
    municipality: 'Vadodara'
  }
}, {
  label: 'Vads\u00c3\u00b8 Airport (VDS) - NO',
  id: 'VDS',
  obj: {
    iata: 'VDS',
    iso: 'NO',
    coordinates: '29.844699859619, 70.065299987793',
    municipality: 'Vads\u00c3\u00b8'
  }
}, {
  label: 'Vagar Airport (FAE) - FO',
  id: 'FAE',
  obj: {
    iata: 'FAE',
    iso: 'FO',
    coordinates: '-7.277219772338867, 62.0635986328125',
    municipality: 'Vagar'
  }
}, {
  label: "Val-d'Or Airport (YVO) - CA",
  id: 'YVO',
  obj: {
    iata: 'YVO',
    iso: 'CA',
    coordinates: '-77.7827987671, 48.0532989502',
    municipality: "Val-d'Or"
  }
}, {
  label: 'Valdez Pioneer Field (VDZ) - US',
  id: 'VDZ',
  obj: {
    iata: 'VDZ',
    iso: 'US',
    coordinates: '-146.2480011, 61.13389969',
    municipality: 'Valdez'
  }
}, {
  label: 'Pichoy Airport (ZAL) - CL',
  id: 'ZAL',
  obj: {
    iata: 'ZAL',
    iso: 'CL',
    coordinates: '-73.0860977173, -39.6500015259',
    municipality: 'Valdivia'
  }
}, {
  label: 'Moody Air Force Base (VAD) - US',
  id: 'VAD',
  obj: {
    iata: 'VAD',
    iso: 'US',
    coordinates: '-83.1930007935, 30.9678001404',
    municipality: 'Valdosta'
  }
}, {
  label: 'Valdosta Regional Airport (VLD) - US',
  id: 'VLD',
  obj: {
    iata: 'VLD',
    iso: 'US',
    coordinates: '-83.27670288085938, 30.782499313354492',
    municipality: 'Valdosta'
  }
}, {
  label: 'Valence-Chabeuil Airport (VAF) - FR',
  id: 'VAF',
  obj: {
    iata: 'VAF',
    iso: 'FR',
    coordinates: '4.9699, 44.9216',
    municipality: 'Valence/Chabeuil'
  }
}, {
  label: 'Valencia Airport (VLC) - ES',
  id: 'VLC',
  obj: {
    iata: 'VLC',
    iso: 'ES',
    coordinates: '-0.481625, 39.4893',
    municipality: 'Valencia'
  }
}, {
  label: 'Arturo Michelena International Airport (VLN) - VE',
  id: 'VLN',
  obj: {
    iata: 'VLN',
    iso: 'VE',
    coordinates: '-67.92839813232422, 10.14973258972168',
    municipality: 'Valencia'
  }
}, {
  label: 'Valenciennes-Denain Airport (XVS) - FR',
  id: 'XVS',
  obj: {
    iata: 'XVS',
    iso: 'FR',
    coordinates: '3.46126, 50.325802',
    municipality: 'Valenciennes/Denain'
  }
}, {
  label: 'Miller Field (VTN) - US',
  id: 'VTN',
  obj: {
    iata: 'VTN',
    iso: 'US',
    coordinates: '-100.5479965, 42.85779953',
    municipality: 'Valentine'
  }
}, {
  label: 'Dr. Antonio Nicol\u00c3\u00a1s Brice\u00c3\u00b1o Airport (VLV) - VE',
  id: 'VLV',
  obj: {
    iata: 'VLV',
    iso: 'VE',
    coordinates: '-70.58406066894531, 9.34047794342041',
    municipality: 'Valera'
  }
}, {
  label: 'Valladolid Airport (VLL) - ES',
  id: 'VLL',
  obj: {
    iata: 'VLL',
    iso: 'ES',
    coordinates: '-4.85194015503, 41.7061004639',
    municipality: 'Valladolid'
  }
}, {
  label: 'Alfonso L\u00c3\u00b3pez Pumarejo Airport (VUP) - CO',
  id: 'VUP',
  obj: {
    iata: 'VUP',
    iso: 'CO',
    coordinates: '-73.2495, 10.435',
    municipality: 'Valledupar'
  }
}, {
  label: 'Vallenar Airport (VLR) - CL',
  id: 'VLR',
  obj: {
    iata: 'VLR',
    iso: 'CL',
    coordinates: '-70.75599670410156, -28.596399307250977',
    municipality: 'Vallenar'
  }
}, {
  label: 'Malta International Airport (MLA) - MT',
  id: 'MLA',
  obj: {
    iata: 'MLA',
    iso: 'MT',
    coordinates: '14.4775, 35.857498',
    municipality: 'Valletta'
  }
}, {
  label: 'Destin-Ft Walton Beach Airport (VPS) - US',
  id: 'VPS',
  obj: {
    iata: 'VPS',
    iso: 'US',
    coordinates: '-86.525398, 30.4832',
    municipality: 'Valparaiso'
  }
}, {
  label: 'Porter County Municipal Airport (VPZ) - US',
  id: 'VPZ',
  obj: {
    iata: 'VPZ',
    iso: 'US',
    coordinates: '-87.00710297, 41.45399857',
    municipality: 'Valparaiso'
  }
}, {
  label: 'Van Ferit Melen Airport (VAN) - TR',
  id: 'VAN',
  obj: {
    iata: 'VAN',
    iso: 'TR',
    coordinates: '43.332298278808594, 38.46820068359375',
    municipality: 'Van'
  }
}, {
  label: 'Van Nuys Airport (VNY) - US',
  id: 'VNY',
  obj: {
    iata: 'VNY',
    iso: 'US',
    coordinates: '-118.48999786377, 34.209800720215',
    municipality: 'Van Nuys'
  }
}, {
  label: 'Vancouver International Airport (YVR) - CA',
  id: 'YVR',
  obj: {
    iata: 'YVR',
    iso: 'CA',
    coordinates: '-123.183998108, 49.193901062',
    municipality: 'Vancouver'
  }
}, {
  label: 'Boundary Bay Airport (YDT) - CA',
  id: 'YDT',
  obj: {
    iata: 'YDT',
    iso: 'CA',
    coordinates: '-123.012001, 49.0742',
    municipality: 'Vancouver'
  }
}, {
  label: 'Vanimo Airport (VAI) - PG',
  id: 'VAI',
  obj: {
    iata: 'VAI',
    iso: 'PG',
    coordinates: '141.3028, -2.6926',
    municipality: 'Vanimo'
  }
}, {
  label: 'Vannes-Meucon Airport (VNE) - FR',
  id: 'VNE',
  obj: {
    iata: 'VNE',
    iso: 'FR',
    coordinates: '-2.718559980392456, 47.72330093383789',
    municipality: 'Vannes/Meucon'
  }
}, {
  label: 'Kawama Airport (VRO) - CU',
  id: 'VRO',
  obj: {
    iata: 'VRO',
    iso: 'CU',
    coordinates: '-81.301598, 23.124001',
    municipality: 'Varadero'
  }
}, {
  label: 'Juan Gualberto Gomez International Airport (VRA) - CU',
  id: 'VRA',
  obj: {
    iata: 'VRA',
    iso: 'CU',
    coordinates: '-81.435302734375, 23.034400939941406',
    municipality: 'Varadero'
  }
}, {
  label: 'Lal Bahadur Shastri Airport (VNS) - IN',
  id: 'VNS',
  obj: {
    iata: 'VNS',
    iso: 'IN',
    coordinates: '82.859299, 25.4524',
    municipality: 'Varanasi'
  }
}, {
  label: 'Vard\u00c3\u00b8 Airport, Svartnes (VAW) - NO',
  id: 'VAW',
  obj: {
    iata: 'VAW',
    iso: 'NO',
    coordinates: '31.044900894165, 70.355400085449',
    municipality: 'Vard\u00c3\u00b8'
  }
}, {
  label: 'Major Brigadeiro Trompowsky Airport (VAG) - BR',
  id: 'VAG',
  obj: {
    iata: 'VAG',
    iso: 'BR',
    coordinates: '-45.4733009338, -21.5900993347',
    municipality: 'Varginha'
  }
}, {
  label: 'Varkaus Airport (VRK) - FI',
  id: 'VRK',
  obj: {
    iata: 'VRK',
    iso: 'FI',
    coordinates: '27.868600845337, 62.171100616455',
    municipality: 'Varkaus / Joroinen'
  }
}, {
  label: 'Varna Airport (VAR) - BG',
  id: 'VAR',
  obj: {
    iata: 'VAR',
    iso: 'BG',
    coordinates: '27.8251, 43.232101',
    municipality: 'Varna'
  }
}, {
  label: 'Dabolim Airport (GOI) - IN',
  id: 'GOI',
  obj: {
    iata: 'GOI',
    iso: 'IN',
    coordinates: '73.8313980103, 15.3808002472',
    municipality: 'Vasco da Gama'
  }
}, {
  label: 'Ch\u00c3\u00a2lons-Vatry Airport (XCR) - FR',
  id: 'XCR',
  obj: {
    iata: 'XCR',
    iso: 'FR',
    coordinates: '4.206111111, 48.7733333333',
    municipality: 'Vatry'
  }
}, {
  label: "Vava'u International Airport (VAV) - TO",
  id: 'VAV',
  obj: {
    iata: 'VAV',
    iso: 'TO',
    coordinates: '-173.96200561523438, -18.58530044555664',
    municipality: "Vava'u Island"
  }
}, {
  label: 'S\u00c3\u00a3o Jorge Airport (SJZ) - PT',
  id: 'SJZ',
  obj: {
    iata: 'SJZ',
    iso: 'PT',
    coordinates: '-28.1758, 38.665501',
    municipality: 'Velas'
  }
}, {
  label: 'Velikiye Luki Airport (VLU) - RU',
  id: 'VLU',
  obj: {
    iata: 'VLU',
    iso: 'RU',
    coordinates: '30.60810089111328, 56.381099700927734',
    municipality: 'Velikiye Luki'
  }
}, {
  label: 'Venice Marco Polo Airport (VCE) - IT',
  id: 'VCE',
  obj: {
    iata: 'VCE',
    iso: 'IT',
    coordinates: '12.3519, 45.505299',
    municipality: 'Venice'
  }
}, {
  label: 'Ventspils International Airport (VNT) - LV',
  id: 'VNT',
  obj: {
    iata: 'VNT',
    iso: 'LV',
    coordinates: '21.5442008972, 57.35779953',
    municipality: 'Ventspils'
  }
}, {
  label: 'General Heriberto Jara International Airport (VER) - MX',
  id: 'VER',
  obj: {
    iata: 'VER',
    iso: 'MX',
    coordinates: '-96.1873016357, 19.1459007263',
    municipality: 'Veracruz'
  }
}, {
  label: 'Vernal Regional Airport (VEL) - US',
  id: 'VEL',
  obj: {
    iata: 'VEL',
    iso: 'US',
    coordinates: '-109.5100021, 40.4408989',
    municipality: 'Vernal'
  }
}, {
  label: 'Vernon Airport (YVE) - CA',
  id: 'YVE',
  obj: {
    iata: 'YVE',
    iso: 'CA',
    coordinates: '-119.33100128173828, 50.24810028076172',
    municipality: 'Vernon'
  }
}, {
  label: 'Vero Beach Regional Airport (VRB) - US',
  id: 'VRB',
  obj: {
    iata: 'VRB',
    iso: 'US',
    coordinates: '-80.417901, 27.6556',
    municipality: 'Vero Beach'
  }
}, {
  label: 'Verona Villafranca Airport (VRN) - IT',
  id: 'VRN',
  obj: {
    iata: 'VRN',
    iso: 'IT',
    coordinates: '10.8885, 45.395699',
    municipality: 'Verona'
  }
}, {
  label: 'Vestmannaeyjar Airport (VEY) - IS',
  id: 'VEY',
  obj: {
    iata: 'VEY',
    iso: 'IS',
    coordinates: '-20.278900146484375, 63.42430114746094',
    municipality: 'Vestmannaeyjar'
  }
}, {
  label: 'Vichy-Charmeil Airport (VHY) - FR',
  id: 'VHY',
  obj: {
    iata: 'VHY',
    iso: 'FR',
    coordinates: '3.4037399291992188, 46.169700622558594',
    municipality: 'Vichy/Charmeil'
  }
}, {
  label: 'Victoria International Airport (YYJ) - CA',
  id: 'YYJ',
  obj: {
    iata: 'YYJ',
    iso: 'CA',
    coordinates: '-123.426002502, 48.646900177',
    municipality: 'Victoria'
  }
}, {
  label: 'Victoria Regional Airport (VCT) - US',
  id: 'VCT',
  obj: {
    iata: 'VCT',
    iso: 'US',
    coordinates: '-96.91850280761719, 28.85260009765625',
    municipality: 'Victoria'
  }
}, {
  label: 'Victoria Airport (ZIC) - CL',
  id: 'ZIC',
  obj: {
    iata: 'ZIC',
    iso: 'CL',
    coordinates: '-72.34860229492188, -38.245601654052734',
    municipality: 'Victoria'
  }
}, {
  label: 'Victoria Falls International Airport (VFA) - ZW',
  id: 'VFA',
  obj: {
    iata: 'VFA',
    iso: 'ZW',
    coordinates: '25.839000701904297, -18.09589958190918',
    municipality: 'Victoria Falls'
  }
}, {
  label: 'Gobernador Castello Airport (VDM) - AR',
  id: 'VDM',
  obj: {
    iata: 'VDM',
    iso: 'AR',
    coordinates: '-63.0004, -40.8692',
    municipality: 'Viedma / Carmen de Patagones'
  }
}, {
  label: 'Vienna International Airport (VIE) - AT',
  id: 'VIE',
  obj: {
    iata: 'VIE',
    iso: 'AT',
    coordinates: '16.569700241089, 48.110298156738',
    municipality: 'Vienna'
  }
}, {
  label: 'Wattay International Airport (VTE) - LA',
  id: 'VTE',
  obj: {
    iata: 'VTE',
    iso: 'LA',
    coordinates: '102.56300354, 17.988300323500003',
    municipality: 'Vientiane'
  }
}, {
  label: 'Hewanorra International Airport (UVF) - LC',
  id: 'UVF',
  obj: {
    iata: 'UVF',
    iso: 'LC',
    coordinates: '-60.952599, 13.7332',
    municipality: 'Vieux Fort'
  }
}, {
  label: 'Vigo Airport (VGO) - ES',
  id: 'VGO',
  obj: {
    iata: 'VGO',
    iso: 'ES',
    coordinates: '-8.62677001953125, 42.2318000793457',
    municipality: 'Vigo'
  }
}, {
  label: 'Porto Santo Airport (PXO) - PT',
  id: 'PXO',
  obj: {
    iata: 'PXO',
    iso: 'PT',
    coordinates: '-16.3500003815, 33.0733985901',
    municipality: 'Vila Baleira'
  }
}, {
  label: 'Alverca Air Base (AVR) - PT',
  id: 'AVR',
  obj: {
    iata: 'AVR',
    iso: 'PT',
    coordinates: '-9.0301, 38.883301',
    municipality: 'Vila Franca de Xira'
  }
}, {
  label: 'Vila Real Airport (VRL) - PT',
  id: 'VRL',
  obj: {
    iata: 'VRL',
    iso: 'PT',
    coordinates: '-7.72047, 41.2743',
    municipality: 'Vila Real'
  }
}, {
  label: 'Maio Airport (MMO) - CV',
  id: 'MMO',
  obj: {
    iata: 'MMO',
    iso: 'CV',
    coordinates: '-23.213699340820312, 15.155900001525879',
    municipality: 'Vila do Maio'
  }
}, {
  label: 'Santa Maria Airport (SMA) - PT',
  id: 'SMA',
  obj: {
    iata: 'SMA',
    iso: 'PT',
    coordinates: '-25.17060089111328, 36.97140121459961',
    municipality: 'Vila do Porto'
  }
}, {
  label: 'Vilankulo Airport (VNX) - MZ',
  id: 'VNX',
  obj: {
    iata: 'VNX',
    iso: 'MZ',
    coordinates: '35.31330108642578, -22.018400192260742',
    municipality: 'Vilanculo'
  }
}, {
  label: 'Brigadeiro Camar\u00c3\u00a3o Airport (BVH) - BR',
  id: 'BVH',
  obj: {
    iata: 'BVH',
    iso: 'BR',
    coordinates: '-60.098300933838, -12.694399833679',
    municipality: 'Vilhena'
  }
}, {
  label: 'Villa Dolores Airport (VDR) - AR',
  id: 'VDR',
  obj: {
    iata: 'VDR',
    iso: 'AR',
    coordinates: '-65.1463012695, -31.9451999664',
    municipality: 'Villa Dolores'
  }
}, {
  label: 'Villa Gesell Airport (VLG) - AR',
  id: 'VLG',
  obj: {
    iata: 'VLG',
    iso: 'AR',
    coordinates: '-57.0292, -37.2354',
    municipality: 'Villa Gesell'
  }
}, {
  label: 'Villa Reynolds Airport (VME) - AR',
  id: 'VME',
  obj: {
    iata: 'VME',
    iso: 'AR',
    coordinates: '-65.3873977661, -33.7299003601',
    municipality: 'Villa Mercedes'
  }
}, {
  label: 'Villacoublay-V\u00c3\u00a9lizy (BA 107) Air Base (VIY) - FR',
  id: 'VIY',
  obj: {
    iata: 'VIY',
    iso: 'FR',
    coordinates: '2.1916667, 48.7741667',
    municipality: 'Villacoublay/V\u00c3\u00a9lizy'
  }
}, {
  label: 'Carlos Rovirosa P\u00c3\u00a9rez International Airport (VSA) - MX',
  id: 'VSA',
  obj: {
    iata: 'VSA',
    iso: 'MX',
    coordinates: '-92.81739807128906, 17.996999740600586',
    municipality: 'Villahermosa'
  }
}, {
  label: 'Teniente Coronel Rafael Pab\u00c3\u00b3n Airport (VLM) - BO',
  id: 'VLM',
  obj: {
    iata: 'VLM',
    iso: 'BO',
    coordinates: '-63.4056015015, -21.255199432399998',
    municipality: 'Villamontes'
  }
}, {
  label: 'Vanguardia Airport (VVC) - CO',
  id: 'VVC',
  obj: {
    iata: 'VVC',
    iso: 'CO',
    coordinates: '-73.6138, 4.16787',
    municipality: 'Villavicencio'
  }
}, {
  label: 'Vilnius International Airport (VNO) - LT',
  id: 'VNO',
  obj: {
    iata: 'VNO',
    iso: 'LT',
    coordinates: '25.285801, 54.634102',
    municipality: 'Vilnius'
  }
}, {
  label: 'Vilyuisk Airport (VYI) - RU',
  id: 'VYI',
  obj: {
    iata: 'VYI',
    iso: 'RU',
    coordinates: '121.69333648682, 63.75666809082',
    municipality: 'Vilyuisk'
  }
}, {
  label: 'Vinh Airport (VII) - VN',
  id: 'VII',
  obj: {
    iata: 'VII',
    iso: 'VN',
    coordinates: '105.67099762, 18.7376003265',
    municipality: 'Vinh'
  }
}, {
  label: 'Virac Airport (VRC) - PH',
  id: 'VRC',
  obj: {
    iata: 'VRC',
    iso: 'PH',
    coordinates: '124.20600128173828, 13.576399803161621',
    municipality: 'Virac'
  }
}, {
  label: 'Oceana Naval Air Station (NTU) - US',
  id: 'NTU',
  obj: {
    iata: 'NTU',
    iso: 'US',
    coordinates: '-76.033501, 36.820702',
    municipality: 'Virginia Beach'
  }
}, {
  label: 'Visby Airport (VBY) - SE',
  id: 'VBY',
  obj: {
    iata: 'VBY',
    iso: 'SE',
    coordinates: '18.346200942993, 57.662799835205',
    municipality: 'Visby'
  }
}, {
  label: 'Aerodromo Goncalves Lobato (Viseu Airport) (VSE) - PT',
  id: 'VSE',
  obj: {
    iata: 'VSE',
    iso: 'PT',
    coordinates: '-7.88899, 40.725498',
    municipality: 'Viseu'
  }
}, {
  label: 'Vitebsk Vostochny Airport (VTB) - BY',
  id: 'VTB',
  obj: {
    iata: 'VTB',
    iso: 'BY',
    coordinates: '30.349599838257, 55.126499176025',
    municipality: 'Vitebsk'
  }
}, {
  label: 'Eurico de Aguiar Salles Airport (VIX) - BR',
  id: 'VIX',
  obj: {
    iata: 'VIX',
    iso: 'BR',
    coordinates: '-40.286388, -20.258057',
    municipality: 'Vit\u00c3\u00b3ria'
  }
}, {
  label: 'Vi\u00c3\u00b1a del mar Airport (KNA) - CL',
  id: 'KNA',
  obj: {
    iata: 'KNA',
    iso: 'CL',
    coordinates: '-71.4786, -32.9496',
    municipality: 'Vi\u00c3\u00b1a Del Mar'
  }
}, {
  label: 'Vladivostok International Airport (VVO) - RU',
  id: 'VVO',
  obj: {
    iata: 'VVO',
    iso: 'RU',
    coordinates: '132.1479949951172, 43.39899826049805',
    municipality: 'Vladivostok'
  }
}, {
  label: 'Vodochody Airport (VOD) - CZ',
  id: 'VOD',
  obj: {
    iata: 'VOD',
    iso: 'CZ',
    coordinates: '14.3958, 50.216599',
    municipality: 'Vodochody'
  }
}, {
  label: 'Skrydstrup Air Base (SKS) - DK',
  id: 'SKS',
  obj: {
    iata: 'SKS',
    iso: 'DK',
    coordinates: '9.26702, 55.221048',
    municipality: 'Vojens'
  }
}, {
  label: 'Volgograd International Airport (VOG) - RU',
  id: 'VOG',
  obj: {
    iata: 'VOG',
    iso: 'RU',
    coordinates: '44.34550094604492, 48.782501220703125',
    municipality: 'Volgograd'
  }
}, {
  label: 'Vologda Airport (VGD) - RU',
  id: 'VGD',
  obj: {
    iata: 'VGD',
    iso: 'RU',
    coordinates: '39.944400787353516, 59.282501220703125',
    municipality: 'Vologda'
  }
}, {
  label: 'Vorkuta Airport (VKT) - RU',
  id: 'VKT',
  obj: {
    iata: 'VKT',
    iso: 'RU',
    coordinates: '63.993099212646484, 67.48860168457031',
    municipality: 'Vorkuta'
  }
}, {
  label: 'Voronezh International Airport (VOZ) - RU',
  id: 'VOZ',
  obj: {
    iata: 'VOZ',
    iso: 'RU',
    coordinates: '39.22959899902344, 51.81420135498047',
    municipality: 'Voronezh'
  }
}, {
  label: 'Vredendal Airport (VRE) - ZA',
  id: 'VRE',
  obj: {
    iata: 'VRE',
    iso: 'ZA',
    coordinates: '18.5447998046875, -31.641000747680664',
    municipality: 'Vredendal'
  }
}, {
  label: 'Vryburg Airport (VRU) - ZA',
  id: 'VRU',
  obj: {
    iata: 'VRU',
    iso: 'ZA',
    coordinates: '24.7287998199, -26.9824008942',
    municipality: 'Vyrburg'
  }
}, {
  label: 'V\u00c3\u00a4xj\u00c3\u00b6 Kronoberg Airport (VXO) - SE',
  id: 'VXO',
  obj: {
    iata: 'VXO',
    iso: 'SE',
    coordinates: '14.727999687194824, 56.929100036621094',
    municipality: 'V\u00c3\u00a4xj\u00c3\u00b6'
  }
}, {
  label: '\u00c3\u008ele Art - Waala Airport (BMY) - NC',
  id: 'BMY',
  obj: {
    iata: 'BMY',
    iso: 'NC',
    coordinates: '163.66099548339844, -19.720600128173828',
    municipality: 'Waala'
  }
}, {
  label: 'Wabush Airport (YWK) - CA',
  id: 'YWK',
  obj: {
    iata: 'YWK',
    iso: 'CA',
    coordinates: '-66.8644027709961, 52.92190170288086',
    municipality: 'Wabush'
  }
}, {
  label: 'Waco Regional Airport (ACT) - US',
  id: 'ACT',
  obj: {
    iata: 'ACT',
    iso: 'US',
    coordinates: '-97.23049926757812, 31.611299514770508',
    municipality: 'Waco'
  }
}, {
  label: 'RAF Waddington (WTN) - GB',
  id: 'WTN',
  obj: {
    iata: 'WTN',
    iso: 'GB',
    coordinates: '-0.523810982704, 53.1661987305',
    municipality: 'Waddington'
  }
}, {
  label: 'Wagga Wagga City Airport (WGA) - AU',
  id: 'WGA',
  obj: {
    iata: 'WGA',
    iso: 'AU',
    coordinates: '147.466003418, -35.1652984619',
    municipality: 'Wagga Wagga'
  }
}, {
  label: 'Wheeler Army Airfield (HHI) - US',
  id: 'HHI',
  obj: {
    iata: 'HHI',
    iso: 'US',
    coordinates: '-158.0399933, 21.48349953',
    municipality: 'Wahiawa'
  }
}, {
  label: 'Wainwright Airport (AIN) - US',
  id: 'AIN',
  obj: {
    iata: 'AIN',
    iso: 'US',
    coordinates: '-159.994995117, 70.6380004883',
    municipality: 'Wainwright'
  }
}, {
  label: 'Wairoa Airport (WIR) - NZ',
  id: 'WIR',
  obj: {
    iata: 'WIR',
    iso: 'NZ',
    coordinates: '177.40699768066406, -39.006900787353516',
    municipality: 'Wairoa'
  }
}, {
  label: 'Chatham Islands-Tuuta Airport (CHT) - NZ',
  id: 'CHT',
  obj: {
    iata: 'CHT',
    iso: 'NZ',
    coordinates: '-176.45700073242188, -43.810001373291016',
    municipality: 'Waitangi'
  }
}, {
  label: 'Noto Airport (NTQ) - JP',
  id: 'NTQ',
  obj: {
    iata: 'NTQ',
    iso: 'JP',
    coordinates: '136.962005615, 37.2930984497',
    municipality: 'Wajima'
  }
}, {
  label: 'Wajir Airport (WJR) - KE',
  id: 'WJR',
  obj: {
    iata: 'WJR',
    iso: 'KE',
    coordinates: '40.091599, 1.73324',
    municipality: 'Wajir'
  }
}, {
  label: 'Wake Island Airfield (AWK) - UM',
  id: 'AWK',
  obj: {
    iata: 'AWK',
    iso: 'UM',
    coordinates: '166.63600158691406, 19.282100677490234',
    municipality: 'Wake Island'
  }
}, {
  label: 'Wakkanai Airport (WKJ) - JP',
  id: 'WKJ',
  obj: {
    iata: 'WKJ',
    iso: 'JP',
    coordinates: '141.800994873, 45.4042015076',
    municipality: 'Wakkanai'
  }
}, {
  label: 'Walla Walla Regional Airport (ALW) - US',
  id: 'ALW',
  obj: {
    iata: 'ALW',
    iso: 'US',
    coordinates: '-118.288002, 46.09489822',
    municipality: 'Walla Walla'
  }
}, {
  label: 'Hihifo Airport (WLS) - WF',
  id: 'WLS',
  obj: {
    iata: 'WLS',
    iso: 'WF',
    coordinates: '-176.199005127, -13.2383003235',
    municipality: 'Wallis Island'
  }
}, {
  label: 'Walvis Bay Airport (WVB) - NA',
  id: 'WVB',
  obj: {
    iata: 'WVB',
    iso: 'NA',
    coordinates: '14.6453, -22.9799',
    municipality: 'Walvis Bay'
  }
}, {
  label: 'Wamena Airport (WMX) - ID',
  id: 'WMX',
  obj: {
    iata: 'WMX',
    iso: 'ID',
    coordinates: '138.957001, -4.10251',
    municipality: 'Wamena-Papua Island'
  }
}, {
  label: 'Wanganui Airport (WAG) - NZ',
  id: 'WAG',
  obj: {
    iata: 'WAG',
    iso: 'NZ',
    coordinates: '175.02499389648438, -39.96220016479492',
    municipality: 'Wanganui'
  }
}, {
  label: 'Matahora Airport (WNI) - ID',
  id: 'WNI',
  obj: {
    iata: 'WNI',
    iso: 'ID',
    coordinates: '123.634, -5.293996',
    municipality: 'Wangi-wangi Island'
  }
}, {
  label: 'Robins Air Force Base (WRB) - US',
  id: 'WRB',
  obj: {
    iata: 'WRB',
    iso: 'US',
    coordinates: '-83.5919036865, 32.6400985718',
    municipality: 'Warner Robins'
  }
}, {
  label: 'Warri Airport (QRW) - NG',
  id: 'QRW',
  obj: {
    iata: 'QRW',
    iso: 'NG',
    coordinates: '5.81778, 5.59611',
    municipality: 'Warri'
  }
}, {
  label: 'Modlin Airport (WMI) - PL',
  id: 'WMI',
  obj: {
    iata: 'WMI',
    iso: 'PL',
    coordinates: '20.6518, 52.451099',
    municipality: 'Warsaw'
  }
}, {
  label: 'Warsaw Chopin Airport (WAW) - PL',
  id: 'WAW',
  obj: {
    iata: 'WAW',
    iso: 'PL',
    coordinates: '20.967100143399996, 52.1656990051',
    municipality: 'Warsaw'
  }
}, {
  label: 'Warton Aerodrome (WRT) - GB',
  id: 'WRT',
  obj: {
    iata: 'WRT',
    iso: 'GB',
    coordinates: '-2.88306, 53.745098',
    municipality: 'Warton'
  }
}, {
  label: 'Ronald Reagan Washington National Airport (DCA) - US',
  id: 'DCA',
  obj: {
    iata: 'DCA',
    iso: 'US',
    coordinates: '-77.037697, 38.8521',
    municipality: 'Washington'
  }
}, {
  label: 'Washington Dulles International Airport (IAD) - US',
  id: 'IAD',
  obj: {
    iata: 'IAD',
    iso: 'US',
    coordinates: '-77.45580292, 38.94449997',
    municipality: 'Washington'
  }
}, {
  label: 'Wasilla Airport (WWA) - US',
  id: 'WWA',
  obj: {
    iata: 'WWA',
    iso: 'US',
    coordinates: '-149.539993286, 61.5717010498',
    municipality: 'Wasilla'
  }
}, {
  label: 'Waskaganish Airport (YKQ) - CA',
  id: 'YKQ',
  obj: {
    iata: 'YKQ',
    iso: 'CA',
    coordinates: '-78.75830078125, 51.47330093383789',
    municipality: 'Waskaganish'
  }
}, {
  label: 'Waterford Airport (WAT) - IE',
  id: 'WAT',
  obj: {
    iata: 'WAT',
    iso: 'IE',
    coordinates: '-7.0869598388671875, 52.187198638916016',
    municipality: 'Waterford'
  }
}, {
  label: 'Waterloo Regional Airport (ALO) - US',
  id: 'ALO',
  obj: {
    iata: 'ALO',
    iso: 'US',
    coordinates: '-92.40029907226562, 42.557098388671875',
    municipality: 'Waterloo'
  }
}, {
  label: 'Watertown International Airport (ART) - US',
  id: 'ART',
  obj: {
    iata: 'ART',
    iso: 'US',
    coordinates: '-76.02169799804688, 43.99190139770508',
    municipality: 'Watertown'
  }
}, {
  label: 'Watertown Regional Airport (ATY) - US',
  id: 'ATY',
  obj: {
    iata: 'ATY',
    iso: 'US',
    coordinates: '-97.15470123, 44.91400146',
    municipality: 'Watertown'
  }
}, {
  label: 'Watson Lake Airport (YQH) - CA',
  id: 'YQH',
  obj: {
    iata: 'YQH',
    iso: 'CA',
    coordinates: '-128.82200622558594, 60.11640167236328',
    municipality: 'Watson Lake'
  }
}, {
  label: 'Wau Airport (WUU) - SS',
  id: 'WUU',
  obj: {
    iata: 'WUU',
    iso: 'SS',
    coordinates: '27.9750003815, 7.7258300781199996',
    municipality: 'Wau'
  }
}, {
  label: 'Wausau Downtown Airport (AUW) - US',
  id: 'AUW',
  obj: {
    iata: 'AUW',
    iso: 'US',
    coordinates: '-89.6266021729, 44.9262008667',
    municipality: 'Wausau'
  }
}, {
  label: 'Wawa Airport (YXZ) - CA',
  id: 'YXZ',
  obj: {
    iata: 'YXZ',
    iso: 'CA',
    coordinates: '-84.78669738769531, 47.96670150756836',
    municipality: 'Wawa'
  }
}, {
  label: 'Webequie Airport (YWP) - CA',
  id: 'YWP',
  obj: {
    iata: 'YWP',
    iso: 'CA',
    coordinates: '-87.3748683929, 52.9593933975',
    municipality: 'Webequie'
  }
}, {
  label: 'Weeze Airport (NRN) - DE',
  id: 'NRN',
  obj: {
    iata: 'NRN',
    iso: 'DE',
    coordinates: '6.14216995239, 51.6024017334',
    municipality: 'Weeze'
  }
}, {
  label: 'Weipa Airport (WEI) - AU',
  id: 'WEI',
  obj: {
    iata: 'WEI',
    iso: 'AU',
    coordinates: '141.925003052, -12.6786003113',
    municipality: 'Weipa'
  }
}, {
  label: 'Wellington International Airport (WLG) - NZ',
  id: 'WLG',
  obj: {
    iata: 'WLG',
    iso: 'NZ',
    coordinates: '174.804992676, -41.3272018433',
    municipality: 'Wellington'
  }
}, {
  label: 'Wemindji Airport (YNC) - CA',
  id: 'YNC',
  obj: {
    iata: 'YNC',
    iso: 'CA',
    coordinates: '-78.83110046386719, 53.01060104370117',
    municipality: 'Wemindji'
  }
}, {
  label: 'Pangborn Memorial Airport (EAT) - US',
  id: 'EAT',
  obj: {
    iata: 'EAT',
    iso: 'US',
    coordinates: '-120.207000732, 47.3988990784',
    municipality: 'Wenatchee'
  }
}, {
  label: 'Wendover Airport (ENV) - US',
  id: 'ENV',
  obj: {
    iata: 'ENV',
    iso: 'US',
    coordinates: '-114.03099823, 40.7187004089',
    municipality: 'Wendover'
  }
}, {
  label: 'Chuuk International Airport (TKK) - FM',
  id: 'TKK',
  obj: {
    iata: 'TKK',
    iso: 'FM',
    coordinates: '151.84300231933594, 7.461870193481445',
    municipality: 'Weno Island'
  }
}, {
  label: 'Palm Beach International Airport (PBI) - US',
  id: 'PBI',
  obj: {
    iata: 'PBI',
    iso: 'US',
    coordinates: '-80.09559631347656, 26.68320083618164',
    municipality: 'West Palm Beach'
  }
}, {
  label: 'West Wyalong Airport (WWY) - AU',
  id: 'WWY',
  obj: {
    iata: 'WWY',
    iso: 'AU',
    coordinates: '147.190994263, -33.9371986389',
    municipality: 'West Wyalong'
  }
}, {
  label: 'Yellowstone Airport (WYS) - US',
  id: 'WYS',
  obj: {
    iata: 'WYS',
    iso: 'US',
    coordinates: '-111.1179962, 44.68840027',
    municipality: 'West Yellowstone'
  }
}, {
  label: 'Westerland Sylt Airport (GWT) - DE',
  id: 'GWT',
  obj: {
    iata: 'GWT',
    iso: 'DE',
    coordinates: '8.34047031403, 54.9132003784',
    municipality: 'Westerland'
  }
}, {
  label: 'Westfield-Barnes Regional Airport (BAF) - US',
  id: 'BAF',
  obj: {
    iata: 'BAF',
    iso: 'US',
    coordinates: '-72.715599, 42.157799',
    municipality: 'Westfield/Springfield'
  }
}, {
  label: 'Wevelgem Airport (KJK) - BE',
  id: 'KJK',
  obj: {
    iata: 'KJK',
    iso: 'BE',
    coordinates: '3.20472002029, 50.817199707',
    municipality: 'Wevelgem'
  }
}, {
  label: 'Wewak International Airport (WWK) - PG',
  id: 'WWK',
  obj: {
    iata: 'WWK',
    iso: 'PG',
    coordinates: '143.669006348, -3.58383011818',
    municipality: 'Wewak'
  }
}, {
  label: 'Whale Cove Airport (YXN) - CA',
  id: 'YXN',
  obj: {
    iata: 'YXN',
    iso: 'CA',
    coordinates: '-92.59809875490001, 62.24000167849999',
    municipality: 'Whale Cove'
  }
}, {
  label: 'Wheeling Ohio County Airport (HLG) - US',
  id: 'HLG',
  obj: {
    iata: 'HLG',
    iso: 'US',
    coordinates: '-80.6463012695, 40.1749992371',
    municipality: 'Wheeling'
  }
}, {
  label: 'Westchester County Airport (HPN) - US',
  id: 'HPN',
  obj: {
    iata: 'HPN',
    iso: 'US',
    coordinates: '-73.70760345458984, 41.06700134277344',
    municipality: 'White Plains'
  }
}, {
  label: 'Whitecourt Airport (YZU) - CA',
  id: 'YZU',
  obj: {
    iata: 'YZU',
    iso: 'CA',
    coordinates: '-115.78700256347656, 54.14390182495117',
    municipality: 'Whitecourt'
  }
}, {
  label: 'Whitehorse / Erik Nielsen International Airport (YXY) - CA',
  id: 'YXY',
  obj: {
    iata: 'YXY',
    iso: 'CA',
    coordinates: '-135.067001343, 60.7095985413',
    municipality: 'Whitehorse'
  }
}, {
  label: 'Whyalla Airport (WYA) - AU',
  id: 'WYA',
  obj: {
    iata: 'WYA',
    iso: 'AU',
    coordinates: '137.51400756835938, -33.05889892578125',
    municipality: 'Whyalla'
  }
}, {
  label: 'Wiarton Airport (YVV) - CA',
  id: 'YVV',
  obj: {
    iata: 'YVV',
    iso: 'CA',
    coordinates: '-81.107201, 44.7458',
    municipality: 'Wiarton'
  }
}, {
  label: 'Mc Connell Air Force Base (IAB) - US',
  id: 'IAB',
  obj: {
    iata: 'IAB',
    iso: 'US',
    coordinates: '-97.26820374, 37.62189865',
    municipality: 'Wichita'
  }
}, {
  label: 'Wichita Eisenhower National Airport (ICT) - US',
  id: 'ICT',
  obj: {
    iata: 'ICT',
    iso: 'US',
    coordinates: '-97.433098, 37.649899',
    municipality: 'Wichita'
  }
}, {
  label: 'Sheppard Air Force Base-Wichita Falls Municipal Airport (SPS) - US',
  id: 'SPS',
  obj: {
    iata: 'SPS',
    iso: 'US',
    coordinates: '-98.491898, 33.9888',
    municipality: 'Wichita Falls'
  }
}, {
  label: 'Wick Airport (WIC) - GB',
  id: 'WIC',
  obj: {
    iata: 'WIC',
    iso: 'GB',
    coordinates: '-3.09306001663208, 58.458900451660156',
    municipality: 'Wick'
  }
}, {
  label: 'Wiesbaden Army Airfield (WIE) - DE',
  id: 'WIE',
  obj: {
    iata: 'WIE',
    iso: 'DE',
    coordinates: '8.325400352478027, 50.049800872802734',
    municipality: 'Wiesbaden'
  }
}, {
  label: 'Cape May County Airport (WWD) - US',
  id: 'WWD',
  obj: {
    iata: 'WWD',
    iso: 'US',
    coordinates: '-74.9083023071, 39.008499145500004',
    municipality: 'Wildwood'
  }
}, {
  label: 'Wilkes Barre Scranton International Airport (AVP) - US',
  id: 'AVP',
  obj: {
    iata: 'AVP',
    iso: 'US',
    coordinates: '-75.72339630130001, 41.338500976599995',
    municipality: 'Wilkes-Barre/Scranton'
  }
}, {
  label: 'Hato International Airport (CUR) - CW',
  id: 'CUR',
  obj: {
    iata: 'CUR',
    iso: 'CW',
    coordinates: '-68.959801, 12.1889',
    municipality: 'Willemstad'
  }
}, {
  label: 'Williams Lake Airport (YWL) - CA',
  id: 'YWL',
  obj: {
    iata: 'YWL',
    iso: 'CA',
    coordinates: '-122.054000854, 52.1831016541',
    municipality: 'Williams Lake'
  }
}, {
  label: 'Williamsport Regional Airport (IPT) - US',
  id: 'IPT',
  obj: {
    iata: 'IPT',
    iso: 'US',
    coordinates: '-76.92109680175781, 41.241798400878906',
    municipality: 'Williamsport'
  }
}, {
  label: 'Newcastle Airport (NTL) - AU',
  id: 'NTL',
  obj: {
    iata: 'NTL',
    iso: 'AU',
    coordinates: '151.83399963378906, -32.79499816894531',
    municipality: 'Williamtown'
  }
}, {
  label: 'Sloulin Field International Airport (ISN) - US',
  id: 'ISN',
  obj: {
    iata: 'ISN',
    iso: 'US',
    coordinates: '-103.641998291, 48.177898407',
    municipality: 'Williston'
  }
}, {
  label: 'Williston Basin International Airport (XWA) - US',
  id: 'XWA',
  obj: {
    iata: 'XWA',
    iso: 'US',
    coordinates: '-103.748797, 48.258387',
    municipality: 'Williston'
  }
}, {
  label: 'New Castle Airport (ILG) - US',
  id: 'ILG',
  obj: {
    iata: 'ILG',
    iso: 'US',
    coordinates: '-75.60649872, 39.67869949',
    municipality: 'Wilmington'
  }
}, {
  label: 'Wilmington International Airport (ILM) - US',
  id: 'ILM',
  obj: {
    iata: 'ILM',
    iso: 'US',
    coordinates: '-77.90260314941406, 34.270599365234375',
    municipality: 'Wilmington'
  }
}, {
  label: 'Wilmington Airpark (ILN) - US',
  id: 'ILN',
  obj: {
    iata: 'ILN',
    iso: 'US',
    coordinates: '-83.792098999, 39.427898407',
    municipality: 'Wilmington'
  }
}, {
  label: 'Eros Airport (ERS) - NA',
  id: 'ERS',
  obj: {
    iata: 'ERS',
    iso: 'NA',
    coordinates: '17.080400466918945, -22.612199783325195',
    municipality: 'Windhoek'
  }
}, {
  label: 'Hosea Kutako International Airport (WDH) - NA',
  id: 'WDH',
  obj: {
    iata: 'WDH',
    iso: 'NA',
    coordinates: '17.4709, -22.4799',
    municipality: 'Windhoek'
  }
}, {
  label: 'Windsor Airport (YQG) - CA',
  id: 'YQG',
  obj: {
    iata: 'YQG',
    iso: 'CA',
    coordinates: '-82.95559692382812, 42.27560043334961',
    municipality: 'Windsor'
  }
}, {
  label: 'Winkler County Airport (INK) - US',
  id: 'INK',
  obj: {
    iata: 'INK',
    iso: 'US',
    coordinates: '-103.200996399, 31.779600143399996',
    municipality: 'Wink'
  }
}, {
  label: 'Winnemucca Municipal Airport (WMC) - US',
  id: 'WMC',
  obj: {
    iata: 'WMC',
    iso: 'US',
    coordinates: '-117.805999756, 40.8965988159',
    municipality: 'Winnemucca'
  }
}, {
  label: 'Winnipeg / James Armstrong Richardson International Airport (YWG) - CA',
  id: 'YWG',
  obj: {
    iata: 'YWG',
    iso: 'CA',
    coordinates: '-97.2398986816, 49.909999847399995',
    municipality: 'Winnipeg'
  }
}, {
  label: 'Winslow Lindbergh Regional Airport (INW) - US',
  id: 'INW',
  obj: {
    iata: 'INW',
    iso: 'US',
    coordinates: '-110.722999573, 35.021900177',
    municipality: 'Winslow'
  }
}, {
  label: 'Smith Reynolds Airport (INT) - US',
  id: 'INT',
  obj: {
    iata: 'INT',
    iso: 'US',
    coordinates: '-80.22200012207031, 36.13370132446289',
    municipality: 'Winston Salem'
  }
}, {
  label: 'L M Clayton Airport (OLF) - US',
  id: 'OLF',
  obj: {
    iata: 'OLF',
    iso: 'US',
    coordinates: '-105.574996948, 48.094501495399996',
    municipality: 'Wolf Point'
  }
}, {
  label: 'Wollaston Lake Airport (ZWL) - CA',
  id: 'ZWL',
  obj: {
    iata: 'ZWL',
    iso: 'CA',
    coordinates: '-103.1719970703125, 58.10689926147461',
    municipality: 'Wollaston Lake'
  }
}, {
  label: 'Wonju/Hoengseong Air Base (K-38/K-46) (WJU) - KR',
  id: 'WJU',
  obj: {
    iata: 'WJU',
    iso: 'KR',
    coordinates: '127.963858, 37.441201',
    municipality: 'Wonju'
  }
}, {
  label: 'Wonsan Kalma International Airport (WOS) - KP',
  id: 'WOS',
  obj: {
    iata: 'WOS',
    iso: 'KP',
    coordinates: '127.486, 39.166801',
    municipality: 'Wonsan'
  }
}, {
  label: 'West Woodward Airport (WWR) - US',
  id: 'WWR',
  obj: {
    iata: 'WWR',
    iso: 'US',
    coordinates: '-99.5226667, 36.438',
    municipality: 'Woodward'
  }
}, {
  label: 'Worcester Regional Airport (ORH) - US',
  id: 'ORH',
  obj: {
    iata: 'ORH',
    iso: 'US',
    coordinates: '-71.87570190429688, 42.26729965209961',
    municipality: 'Worcester'
  }
}, {
  label: 'Worland Municipal Airport (WRL) - US',
  id: 'WRL',
  obj: {
    iata: 'WRL',
    iso: 'US',
    coordinates: '-107.95099639892578, 43.9656982421875',
    municipality: 'Worland'
  }
}, {
  label: 'Wrangell Airport (WRG) - US',
  id: 'WRG',
  obj: {
    iata: 'WRG',
    iso: 'US',
    coordinates: '-132.3699951, 56.48429871',
    municipality: 'Wrangell'
  }
}, {
  label: 'Mc Guire Air Force Base (WRI) - US',
  id: 'WRI',
  obj: {
    iata: 'WRI',
    iso: 'US',
    coordinates: '-74.59169769, 40.0155983',
    municipality: 'Wrightstown'
  }
}, {
  label: 'Wrigley Airport (YWY) - CA',
  id: 'YWY',
  obj: {
    iata: 'YWY',
    iso: 'CA',
    coordinates: '-123.43699645996094, 63.20940017700195',
    municipality: 'Wrigley'
  }
}, {
  label: 'Copernicus Wroc\u00c5\u0082aw Airport (WRO) - PL',
  id: 'WRO',
  obj: {
    iata: 'WRO',
    iso: 'PL',
    coordinates: '16.885799408, 51.1026992798',
    municipality: 'Wroc\u00c5\u0082aw'
  }
}, {
  label: 'Wuhan Tianhe International Airport (WUH) - CN',
  id: 'WUH',
  obj: {
    iata: 'WUH',
    iso: 'CN',
    coordinates: '114.208, 30.7838',
    municipality: 'Wuhan'
  }
}, {
  label: 'El Lencero Airport (JAL) - MX',
  id: 'JAL',
  obj: {
    iata: 'JAL',
    iso: 'MX',
    coordinates: '-96.7975006104, 19.4750995636',
    municipality: 'Xalapa'
  }
}, {
  label: 'Xangongo Airport (XGN) - AO',
  id: 'XGN',
  obj: {
    iata: 'XGN',
    iso: 'AO',
    coordinates: '14.965299606323242, -16.755399703979492',
    municipality: 'Xangongo'
  }
}, {
  label: "Xi'an Xiguan Airport (SIA) - CN",
  id: 'SIA',
  obj: {
    iata: 'SIA',
    iso: 'CN',
    coordinates: '109.120003, 34.376701',
    municipality: "Xi'an"
  }
}, {
  label: "Xi'an Xianyang International Airport (XIY) - CN",
  id: 'XIY',
  obj: {
    iata: 'XIY',
    iso: 'CN',
    coordinates: '108.751999, 34.447102',
    municipality: "Xi'an"
  }
}, {
  label: 'Gannan Xiahe Airport (GXH) - CN',
  id: 'GXH',
  obj: {
    iata: 'GXH',
    iso: 'CN',
    coordinates: '102.6447, 34.8105',
    municipality: 'Xiahe'
  }
}, {
  label: 'Shigatse Air Base (RKZ) - CN',
  id: 'RKZ',
  obj: {
    iata: 'RKZ',
    iso: 'CN',
    coordinates: '89.311401, 29.3519',
    municipality: 'Xigaz\u00c3\u00aa'
  }
}, {
  label: 'Xilinhot Airport (XIL) - CN',
  id: 'XIL',
  obj: {
    iata: 'XIL',
    iso: 'CN',
    coordinates: '115.96399688720703, 43.91559982299805',
    municipality: 'Xilinhot'
  }
}, {
  label: 'Xining Caojiabu Airport (XNN) - CN',
  id: 'XNN',
  obj: {
    iata: 'XNN',
    iso: 'CN',
    coordinates: '102.042999, 36.5275',
    municipality: 'Xining'
  }
}, {
  label: 'Xinyang Minggang Airport (XAI) - CN',
  id: 'XAI',
  obj: {
    iata: 'XAI',
    iso: 'CN',
    coordinates: '114.079141, 32.540819',
    municipality: 'Xinyang'
  }
}, {
  label: 'Yacuiba Airport (BYC) - BO',
  id: 'BYC',
  obj: {
    iata: 'BYC',
    iso: 'BO',
    coordinates: '-63.65169906616211, -21.960899353027344',
    municipality: 'Yacu\u00c3\u00adba'
  }
}, {
  label: 'Yakima Air Terminal McAllister Field (YKM) - US',
  id: 'YKM',
  obj: {
    iata: 'YKM',
    iso: 'US',
    coordinates: '-120.5439987, 46.56819916',
    municipality: 'Yakima'
  }
}, {
  label: 'Yakushima Airport (KUM) - JP',
  id: 'KUM',
  obj: {
    iata: 'KUM',
    iso: 'JP',
    coordinates: '130.658996582, 30.3855991364',
    municipality: 'Yakushima'
  }
}, {
  label: 'Yakutat Airport (YAK) - US',
  id: 'YAK',
  obj: {
    iata: 'YAK',
    iso: 'US',
    coordinates: '-139.660003662, 59.5032997131',
    municipality: 'Yakutat'
  }
}, {
  label: 'Polyarny Airport (PYJ) - RU',
  id: 'PYJ',
  obj: {
    iata: 'PYJ',
    iso: 'RU',
    coordinates: '112.029998779, 66.4003982544',
    municipality: 'Yakutia'
  }
}, {
  label: 'Yakutsk Airport (YKS) - RU',
  id: 'YKS',
  obj: {
    iata: 'YKS',
    iso: 'RU',
    coordinates: '129.77099609375, 62.093299865722656',
    municipality: 'Yakutsk'
  }
}, {
  label: 'Yamagata Airport (GAJ) - JP',
  id: 'GAJ',
  obj: {
    iata: 'GAJ',
    iso: 'JP',
    coordinates: '140.371002197, 38.411899566699994',
    municipality: 'Yamagata'
  }
}, {
  label: 'Bezmer Air Base (JAM) - BG',
  id: 'JAM',
  obj: {
    iata: 'JAM',
    iso: 'BG',
    coordinates: '26.3521995544, 42.4548988342',
    municipality: 'Yambol'
  }
}, {
  label: 'Yamoussoukro Airport (ASK) - CI',
  id: 'ASK',
  obj: {
    iata: 'ASK',
    iso: 'CI',
    coordinates: '-5.36558008194, 6.9031701088',
    municipality: 'Yamoussoukro'
  }
}, {
  label: 'Alcantar\u00c3\u00ad Airport (SRE) - BO',
  id: 'SRE',
  obj: {
    iata: 'SRE',
    iso: 'BO',
    coordinates: '-65.149611, -19.246835',
    municipality: 'Yamparaez'
  }
}, {
  label: 'Prince Abdulmohsin Bin Abdulaziz Airport (YNB) - SA',
  id: 'YNB',
  obj: {
    iata: 'YNB',
    iso: 'SA',
    coordinates: '38.0634, 24.144199',
    municipality: 'Yanbu'
  }
}, {
  label: 'Yangon International Airport (RGN) - MM',
  id: 'RGN',
  obj: {
    iata: 'RGN',
    iso: 'MM',
    coordinates: '96.1332015991, 16.907300949099998',
    municipality: 'Yangon'
  }
}, {
  label: 'Chan Gurney Municipal Airport (YKN) - US',
  id: 'YKN',
  obj: {
    iata: 'YKN',
    iso: 'US',
    coordinates: '-97.385902404785, 42.916698455811',
    municipality: 'Yankton'
  }
}, {
  label: 'Yantai Penglai International Airport (YNT) - CN',
  id: 'YNT',
  obj: {
    iata: 'YNT',
    iso: 'CN',
    coordinates: '120.987222, 37.657222',
    municipality: 'Yantai'
  }
}, {
  label: 'Yaound\u00c3\u00a9 Airport (YAO) - CM',
  id: 'YAO',
  obj: {
    iata: 'YAO',
    iso: 'CM',
    coordinates: '11.523500442504883, 3.8360400199890137',
    municipality: 'Yaound\u00c3\u00a9'
  }
}, {
  label: 'Yaound\u00c3\u00a9 Nsimalen International Airport (NSI) - CM',
  id: 'NSI',
  obj: {
    iata: 'NSI',
    iso: 'CM',
    coordinates: '11.553299903869629, 3.722559928894043',
    municipality: 'Yaound\u00c3\u00a9'
  }
}, {
  label: 'Yap International Airport (YAP) - FM',
  id: 'YAP',
  obj: {
    iata: 'YAP',
    iso: 'FM',
    coordinates: '138.082993, 9.49891',
    municipality: 'Yap Island'
  }
}, {
  label: 'Nauru International Airport (INU) - NR',
  id: 'INU',
  obj: {
    iata: 'INU',
    iso: 'NR',
    coordinates: '166.919006, -0.547458',
    municipality: 'Yaren District'
  }
}, {
  label: 'Yarmouth Airport (YQI) - CA',
  id: 'YQI',
  obj: {
    iata: 'YQI',
    iso: 'CA',
    coordinates: '-66.08809661865234, 43.826900482177734',
    municipality: 'Yarmouth'
  }
}, {
  label: 'Yasouj Airport (YES) - IR',
  id: 'YES',
  obj: {
    iata: 'YES',
    iso: 'IR',
    coordinates: '51.545101165771, 30.700500488281',
    municipality: 'Yasouj'
  }
}, {
  label: 'Blackbushe Airport (BBS) - GB',
  id: 'BBS',
  obj: {
    iata: 'BBS',
    iso: 'GB',
    coordinates: '-0.8475000262260437, 51.32389831542969',
    municipality: 'Yateley'
  }
}, {
  label: 'Shahid Sadooghi Airport (AZD) - IR',
  id: 'AZD',
  obj: {
    iata: 'AZD',
    iso: 'IR',
    coordinates: '54.2765007019, 31.9048995972',
    municipality: 'Yazd'
  }
}, {
  label: 'Yecheon Airbase (YEC) - KR',
  id: 'YEC',
  obj: {
    iata: 'YEC',
    iso: 'KR',
    coordinates: '128.34971, 36.630373',
    municipality: 'Yecheon-ri'
  }
}, {
  label: 'Koltsovo Airport (SVX) - RU',
  id: 'SVX',
  obj: {
    iata: 'SVX',
    iso: 'RU',
    coordinates: '60.802700042725, 56.743099212646',
    municipality: 'Yekaterinburg'
  }
}, {
  label: 'Yellowknife Airport (YZF) - CA',
  id: 'YZF',
  obj: {
    iata: 'YZF',
    iso: 'CA',
    coordinates: '-114.44000244140625, 62.462799072265625',
    municipality: 'Yellowknife'
  }
}, {
  label: 'Yengema Airport (WYE) - SL',
  id: 'WYE',
  obj: {
    iata: 'WYE',
    iso: 'SL',
    coordinates: '-11.04539966583252, 8.610469818115234',
    municipality: 'Yengema'
  }
}, {
  label: 'Yeniseysk Airport (EIE) - RU',
  id: 'EIE',
  obj: {
    iata: 'EIE',
    iso: 'RU',
    coordinates: '92.11250305175781, 58.47420120239258',
    municipality: 'Yeniseysk'
  }
}, {
  label: 'Yeosu Airport (RSU) - KR',
  id: 'RSU',
  obj: {
    iata: 'RSU',
    iso: 'KR',
    coordinates: '127.61699676513672, 34.84230041503906',
    municipality: 'Yeosu'
  }
}, {
  label: 'RNAS Yeovilton (YEO) - GB',
  id: 'YEO',
  obj: {
    iata: 'YEO',
    iso: 'GB',
    coordinates: '-2.638819932937622, 51.0093994140625',
    municipality: 'Yeovil'
  }
}, {
  label: 'Zvartnots International Airport (EVN) - AM',
  id: 'EVN',
  obj: {
    iata: 'EVN',
    iso: 'AM',
    coordinates: '44.3959007263, 40.1473007202',
    municipality: 'Yerevan'
  }
}, {
  label: 'Yeysk Airport (EIK) - RU',
  id: 'EIK',
  obj: {
    iata: 'EIK',
    iso: 'RU',
    coordinates: '38.21, 46.68',
    municipality: 'Yeysk'
  }
}, {
  label: 'Yichang Sanxia Airport (YIH) - CN',
  id: 'YIH',
  obj: {
    iata: 'YIH',
    iso: 'CN',
    coordinates: '111.479988, 30.55655',
    municipality: 'Yichang'
  }
}, {
  label: 'Andersen Air Force Base (UAM) - GU',
  id: 'UAM',
  obj: {
    iata: 'UAM',
    iso: 'GU',
    coordinates: '144.929998, 13.584',
    municipality: 'Yigo, Mariana Island'
  }
}, {
  label: 'Yinchuan Hedong International Airport (INC) - CN',
  id: 'INC',
  obj: {
    iata: 'INC',
    iso: 'CN',
    coordinates: '106.393214, 38.322758',
    municipality: 'Yinchuan'
  }
}, {
  label: 'Yogyakarta International Airport (YIA) - ID',
  id: 'YIA',
  obj: {
    iata: 'YIA',
    iso: 'ID',
    coordinates: '110.057264, -7.905338',
    municipality: 'Yogyakarta'
  }
}, {
  label: 'Yola Airport (YOL) - NG',
  id: 'YOL',
  obj: {
    iata: 'YOL',
    iso: 'NG',
    coordinates: '12.430399894714355, 9.257550239562988',
    municipality: 'Yola'
  }
}, {
  label: 'Yonago Kitaro Airport / JASDF Miho Air Base (YGJ) - JP',
  id: 'YGJ',
  obj: {
    iata: 'YGJ',
    iso: 'JP',
    coordinates: '133.235992, 35.492199',
    municipality: 'Yonago'
  }
}, {
  label: 'Lingling Airport (LLF) - CN',
  id: 'LLF',
  obj: {
    iata: 'LLF',
    iso: 'CN',
    coordinates: '111.610043, 26.338661',
    municipality: 'Yongzhou'
  }
}, {
  label: 'York Landing Airport (ZAC) - CA',
  id: 'ZAC',
  obj: {
    iata: 'ZAC',
    iso: 'CA',
    coordinates: '-96.08920288085938, 56.08940124511719',
    municipality: 'York Landing'
  }
}, {
  label: 'Yorkton Municipal Airport (YQV) - CA',
  id: 'YQV',
  obj: {
    iata: 'YQV',
    iso: 'CA',
    coordinates: '-102.46199798583984, 51.26470184326172',
    municipality: 'Yorkton'
  }
}, {
  label: 'Yoron Airport (RNJ) - JP',
  id: 'RNJ',
  obj: {
    iata: 'RNJ',
    iso: 'JP',
    coordinates: '128.401992798, 27.0440006256',
    municipality: 'Yoronjima'
  }
}, {
  label: 'Yoshkar-Ola Airport (JOK) - RU',
  id: 'JOK',
  obj: {
    iata: 'JOK',
    iso: 'RU',
    coordinates: '47.904701232910156, 56.700599670410156',
    municipality: 'Yoshkar-Ola'
  }
}, {
  label: 'Youngstown Warren Regional Airport (YNG) - US',
  id: 'YNG',
  obj: {
    iata: 'YNG',
    iso: 'US',
    coordinates: '-80.67910004, 41.26070023',
    municipality: 'Youngstown/Warren'
  }
}, {
  label: 'Yuanmou Air Base (YUA) - CN',
  id: 'YUA',
  obj: {
    iata: 'YUA',
    iso: 'CN',
    coordinates: '101.88200378418, 25.737499237061',
    municipality: 'Yuanmou'
  }
}, {
  label: 'Sanhe Airport (YYA) - CN',
  id: 'YYA',
  obj: {
    iata: 'YYA',
    iso: 'CN',
    coordinates: '113.278, 29.314',
    municipality: 'Yueyang'
  }
}, {
  label: 'Yuma MCAS/Yuma International Airport (YUM) - US',
  id: 'YUM',
  obj: {
    iata: 'YUM',
    iso: 'US',
    coordinates: '-114.6060028, 32.65660095',
    municipality: 'Yuma'
  }
}, {
  label: 'Moises Benzaquen Rengifo Airport (YMS) - PE',
  id: 'YMS',
  obj: {
    iata: 'YMS',
    iso: 'PE',
    coordinates: '-76.11820220947266, -5.893770217895508',
    municipality: 'Yurimaguas'
  }
}, {
  label: 'Yuzhno-Sakhalinsk Airport (UUS) - RU',
  id: 'UUS',
  obj: {
    iata: 'UUS',
    iso: 'RU',
    coordinates: '142.71800231933594, 46.88869857788086',
    municipality: 'Yuzhno-Sakhalinsk'
  }
}, {
  label: 'General Leobardo C. Ruiz International Airport (ZCL) - MX',
  id: 'ZCL',
  obj: {
    iata: 'ZCL',
    iso: 'MX',
    coordinates: '-102.68699646, 22.8971004486',
    municipality: 'Zacatecas'
  }
}, {
  label: 'Zagreb Airport (ZAG) - HR',
  id: 'ZAG',
  obj: {
    iata: 'ZAG',
    iso: 'HR',
    coordinates: '16.0687999725, 45.7429008484',
    municipality: 'Zagreb'
  }
}, {
  label: 'Zahedan International Airport (ZAH) - IR',
  id: 'ZAH',
  obj: {
    iata: 'ZAH',
    iso: 'IR',
    coordinates: '60.90620040893555, 29.47570037841797',
    municipality: 'Zahedan'
  }
}, {
  label: 'Zakynthos International Airport "Dionysios Solomos" (ZTH) - GR',
  id: 'ZTH',
  obj: {
    iata: 'ZTH',
    iso: 'GR',
    coordinates: '20.8843, 37.7509',
    municipality: 'Zakynthos Island'
  }
}, {
  label: 'Zamboanga International Airport (ZAM) - PH',
  id: 'ZAM',
  obj: {
    iata: 'ZAM',
    iso: 'PH',
    coordinates: '122.05999755859375, 6.922420024871826',
    municipality: 'Zamboanga City'
  }
}, {
  label: 'Johan Adolf Pengel International Airport (PBM) - SR',
  id: 'PBM',
  obj: {
    iata: 'PBM',
    iso: 'SR',
    coordinates: '-55.1878013611, 5.4528298377999995',
    municipality: 'Zandery'
  }
}, {
  label: 'Zanesville Municipal Airport (ZZV) - US',
  id: 'ZZV',
  obj: {
    iata: 'ZZV',
    iso: 'US',
    coordinates: '-81.89209747310001, 39.9444007874',
    municipality: 'Zanesville'
  }
}, {
  label: 'Zanjan Airport (JWN) - IR',
  id: 'JWN',
  obj: {
    iata: 'JWN',
    iso: 'IR',
    coordinates: '48.3594017029, 36.7737007141',
    municipality: 'Zanjan'
  }
}, {
  label: 'Abeid Amani Karume International Airport (ZNZ) - TZ',
  id: 'ZNZ',
  obj: {
    iata: 'ZNZ',
    iso: 'TZ',
    coordinates: '39.224899, -6.22202',
    municipality: 'Zanzibar'
  }
}, {
  label: 'Zapala Airport (APZ) - AR',
  id: 'APZ',
  obj: {
    iata: 'APZ',
    iso: 'AR',
    coordinates: '-70.113602, -38.975498',
    municipality: 'Zapala'
  }
}, {
  label: 'Zaporizhzhia International Airport (OZH) - UA',
  id: 'OZH',
  obj: {
    iata: 'OZH',
    iso: 'UA',
    coordinates: '35.31570053100586, 47.867000579833984',
    municipality: 'Zaporizhia'
  }
}, {
  label: 'Zaragoza Air Base (ZAZ) - ES',
  id: 'ZAZ',
  obj: {
    iata: 'ZAZ',
    iso: 'ES',
    coordinates: '-1.0415500402450562, 41.66619873046875',
    municipality: 'Zaragoza'
  }
}, {
  label: 'Zaria Airport (ZAR) - NG',
  id: 'ZAR',
  obj: {
    iata: 'ZAR',
    iso: 'NG',
    coordinates: '7.68581, 11.1302',
    municipality: 'Zaria'
  }
}, {
  label: 'Zadar Airport (ZAD) - HR',
  id: 'ZAD',
  obj: {
    iata: 'ZAD',
    iso: 'HR',
    coordinates: '15.3467, 44.108299',
    municipality: 'Zemunik (Zadar)'
  }
}, {
  label: 'Chengjisihan Airport (NZL) - CN',
  id: 'NZL',
  obj: {
    iata: 'NZL',
    iso: 'CN',
    coordinates: '122.767503, 47.865833',
    municipality: 'Zhalantun'
  }
}, {
  label: 'Zhangjiakou Ningyuan Airport (ZQZ) - CN',
  id: 'ZQZ',
  obj: {
    iata: 'ZQZ',
    iso: 'CN',
    coordinates: '114.930000305, 40.7386016846',
    municipality: 'Zhangjiakou'
  }
}, {
  label: 'Zhangye Ganzhou Airport (YZY) - CN',
  id: 'YZY',
  obj: {
    iata: 'YZY',
    iso: 'CN',
    coordinates: '100.675003052, 38.8018989563',
    municipality: 'Zhangye'
  }
}, {
  label: 'Zhanjiang Airport (ZHA) - CN',
  id: 'ZHA',
  obj: {
    iata: 'ZHA',
    iso: 'CN',
    coordinates: '110.358002, 21.214399',
    municipality: 'Zhanjiang'
  }
}, {
  label: 'Zhengzhou Xinzheng International Airport (CGO) - CN',
  id: 'CGO',
  obj: {
    iata: 'CGO',
    iso: 'CN',
    coordinates: '113.841003418, 34.519699096699995',
    municipality: 'Zhengzhou'
  }
}, {
  label: 'Zhezkazgan Airport (DZN) - KZ',
  id: 'DZN',
  obj: {
    iata: 'DZN',
    iso: 'KZ',
    coordinates: '67.733299, 47.708302',
    municipality: 'Zhezkazgan'
  }
}, {
  label: 'Zhigansk Airport (ZIX) - RU',
  id: 'ZIX',
  obj: {
    iata: 'ZIX',
    iso: 'RU',
    coordinates: '123.361000061, 66.7965011597',
    municipality: 'Zhigansk'
  }
}, {
  label: 'Zhongwei Shapotou Airport (ZHY) - CN',
  id: 'ZHY',
  obj: {
    iata: 'ZHY',
    iso: 'CN',
    coordinates: '105.154454, 37.573125',
    municipality: 'Zhongwei'
  }
}, {
  label: 'Zhuhai Jinwan Airport (ZUH) - CN',
  id: 'ZUH',
  obj: {
    iata: 'ZUH',
    iso: 'CN',
    coordinates: '113.375999, 22.006399',
    municipality: 'Zhuhai'
  }
}, {
  label: 'Ziguinchor Airport (ZIG) - SN',
  id: 'ZIG',
  obj: {
    iata: 'ZIG',
    iso: 'SN',
    coordinates: '-16.281799, 12.5556',
    municipality: 'Ziguinchor'
  }
}, {
  label: 'Zinder Airport (ZND) - NE',
  id: 'ZND',
  obj: {
    iata: 'ZND',
    iso: 'NE',
    coordinates: '8.983759880065918, 13.779000282287598',
    municipality: 'Zinder'
  }
}, {
  label: 'Ziro Airport (ZER) - IN',
  id: 'ZER',
  obj: {
    iata: 'ZER',
    iso: 'IN',
    coordinates: '93.828102, 27.588301',
    municipality: 'Ziro'
  }
}, {
  label: 'Z\u00c3\u00bcrich Airport (ZRH) - CH',
  id: 'ZRH',
  obj: {
    iata: 'ZRH',
    iso: 'CH',
    coordinates: '8.54917, 47.464699',
    municipality: 'Zurich'
  }
}, {
  label: 'Zyryanka Airport (ZKP) - RU',
  id: 'ZKP',
  obj: {
    iata: 'ZKP',
    iso: 'RU',
    coordinates: '150.8889, 65.7485',
    municipality: 'Zyryanka'
  }
}, {
  label: '\u00c3\u0084ngelholm-Helsingborg Airport (AGH) - SE',
  id: 'AGH',
  obj: {
    iata: 'AGH',
    iso: 'SE',
    coordinates: '12.847100257873535, 56.29610061645508',
    municipality: '\u00c3\u0084ngelholm'
  }
}, {
  label: '\u00c3\u0085lesund Airport (AES) - NO',
  id: 'AES',
  obj: {
    iata: 'AES',
    iso: 'NO',
    coordinates: '6.119699954986572, 62.5625',
    municipality: '\u00c3\u0085lesund'
  }
}, {
  label: 'Molde Airport (MOL) - NO',
  id: 'MOL',
  obj: {
    iata: 'MOL',
    iso: 'NO',
    coordinates: '7.2624998092651, 62.744701385498',
    municipality: '\u00c3\u0085r\u00c3\u00b8'
  }
}, {
  label: '\u00c3\u0087anakkale Airport (CKZ) - TR',
  id: 'CKZ',
  obj: {
    iata: 'CKZ',
    iso: 'TR',
    coordinates: '26.4267997742, 40.1376991272',
    municipality: '\u00c3\u0087anakkale'
  }
}, {
  label: 'Tekirda\u00c4\u009f \u00c3\u0087orlu Airport (TEQ) - TR',
  id: 'TEQ',
  obj: {
    iata: 'TEQ',
    iso: 'TR',
    coordinates: '27.919099807739258, 41.13819885253906',
    municipality: '\u00c3\u0087orlu'
  }
}, {
  label: '\u00c3\u0089pinal-Mirecourt Airport (EPL) - FR',
  id: 'EPL',
  obj: {
    iata: 'EPL',
    iso: 'FR',
    coordinates: '6.06998, 48.325001',
    municipality: '\u00c3\u0089pinal/Mirecourt'
  }
}, {
  label: '\u00c3\u0089vreux-Fauville (BA 105) Air Base (EVX) - FR',
  id: 'EVX',
  obj: {
    iata: 'EVX',
    iso: 'FR',
    coordinates: '1.2198599576950073, 49.02870178222656',
    municipality: '\u00c3\u0089vreux/Fauville'
  }
}, {
  label: '\u00c3\u008dsafj\u00c3\u00b6r\u00c3\u00b0ur Airport (IFJ) - IS',
  id: 'IFJ',
  obj: {
    iata: 'IFJ',
    iso: 'IS',
    coordinates: '-23.135299682617188, 66.05809783935547',
    municipality: '\u00c3\u008dsafj\u00c3\u00b6r\u00c3\u00b0ur'
  }
}, {
  label: "\u00c3\u008ele d'Yeu Airport (IDY) - FR",
  id: 'IDY',
  obj: {
    iata: 'IDY',
    iso: 'FR',
    coordinates: '-2.3911099433898926, 46.71860122680664',
    municipality: "\u00c3\u008ele d'Yeu"
  }
}, {
  label: '\u00c3\u008ele des Pins Airport (ILP) - NC',
  id: 'ILP',
  obj: {
    iata: 'ILP',
    iso: 'NC',
    coordinates: '167.45599365234375, -22.588899612426758',
    municipality: '\u00c3\u008ele des Pins'
  }
}, {
  label: '\u00c3\u008eles-de-la-Madeleine Airport (YGR) - CA',
  id: 'YGR',
  obj: {
    iata: 'YGR',
    iso: 'CA',
    coordinates: '-61.778099060058594, 47.42470169067383',
    municipality: '\u00c3\u008eles-de-la-Madeleine'
  }
}, {
  label: '\u00c3\u0096rebro Airport (ORB) - SE',
  id: 'ORB',
  obj: {
    iata: 'ORB',
    iso: 'SE',
    coordinates: '15.038000106811523, 59.22370147705078',
    municipality: '\u00c3\u0096rebro'
  }
}, {
  label: '\u00c3\u0096rnsk\u00c3\u00b6ldsvik Airport (OER) - SE',
  id: 'OER',
  obj: {
    iata: 'OER',
    iso: 'SE',
    coordinates: '18.989999771118164, 63.40829849243164',
    municipality: '\u00c3\u0096rnsk\u00c3\u00b6ldsvik'
  }
}, {
  label: '\u00c3\u0085re \u00c3\u0096stersund Airport (OSD) - SE',
  id: 'OSD',
  obj: {
    iata: 'OSD',
    iso: 'SE',
    coordinates: '14.50030040741, 63.194400787354',
    municipality: '\u00c3\u0096stersund'
  }
}, {
  label: '\u00c3\u0098rland Airport (OLA) - NO',
  id: 'OLA',
  obj: {
    iata: 'OLA',
    iso: 'NO',
    coordinates: '9.604000091552734, 63.69889831542969',
    municipality: '\u00c3\u0098rland'
  }
}, {
  label: '\u00c3\u0098rsta-Volda Airport, Hovden (HOV) - NO',
  id: 'HOV',
  obj: {
    iata: 'HOV',
    iso: 'NO',
    coordinates: '6.0741000175476, 62.180000305176',
    municipality: '\u00c3\u0098rsta'
  }
}, {
  label: 'Adnan Menderes International Airport (ADB) - TR',
  id: 'ADB',
  obj: {
    iata: 'ADB',
    iso: 'TR',
    coordinates: '27.156999588, 38.2924003601',
    municipality: '\u00c4\u00b0zmir'
  }
}, {
  label: '\u00c5\u0081\u00c3\u00b3d\u00c5\u00ba W\u00c5\u0082adys\u00c5\u0082aw Reymont Airport (LCJ) - PL',
  id: 'LCJ',
  obj: {
    iata: 'LCJ',
    iso: 'PL',
    coordinates: '19.3980998993, 51.721900939899996',
    municipality: '\u00c5\u0081\u00c3\u00b3d\u00c5\u00ba'
  }
}, {
  label: 'Memanbetsu Airport (MMB) - JP',
  id: 'MMB',
  obj: {
    iata: 'MMB',
    iso: 'JP',
    coordinates: '144.164001465, 43.8805999756',
    municipality: '\u00c5\u008czora'
  }
}, {
  label: '\u00c5\u009eanl\u00c4\u00b1urfa Airport (SFQ) - TR',
  id: 'SFQ',
  obj: {
    iata: 'SFQ',
    iso: 'TR',
    coordinates: '38.84709930419922, 37.09429931640625',
    municipality: '\u00c5\u009eanl\u00c4\u00b1urfa'
  }
}, {
  label: '\u00c5\u009eanl\u00c4\u00b1urfa GAP Airport (GNY) - TR',
  id: 'GNY',
  obj: {
    iata: 'GNY',
    iso: 'TR',
    coordinates: '38.895592, 37.445663',
    municipality: '\u00c5\u009eanl\u00c4\u00b1urfa'
  }
}, {
  label: '\u00c5\u009e\u00c4\u00b1rnak \u00c5\u009eerafettin El\u00c3\u00a7i Airport (NKT) - TR',
  id: 'NKT',
  obj: {
    iata: 'NKT',
    iso: 'TR',
    coordinates: '42.0582, 37.3647',
    municipality: '\u00c5\u009e\u00c4\u00b1rnak'
  }
}, {
  label: '\u00c5\u00a0iauliai International Airport (SQQ) - LT',
  id: 'SQQ',
  obj: {
    iata: 'SQQ',
    iso: 'LT',
    coordinates: '23.395000457763672, 55.89390182495117',
    municipality: '\u00c5\u00a0iauliai'
  }
}, {
  label: '\u00c5\u00bdilina Airport (ILZ) - SK',
  id: 'ILZ',
  obj: {
    iata: 'ILZ',
    iso: 'SK',
    coordinates: '18.6135005951, 49.231498718299996',
    municipality: '\u00c5\u00bdilina'
  }
}];

const ExpandMore = styled(props => {
  const {
    expand,
    ...other
  } = props;
  return /*#__PURE__*/React__default.createElement(IconButton, Object.assign({}, other));
})(({
  theme,
  expand
}) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  })
}));

const CollapseList = styled(props => {
  return /*#__PURE__*/React__default.createElement(Collapse, Object.assign({}, props));
})(() => ({
  '& .MuiCollapse-wrapperInner': {
    position: 'relative'
  }
}));
const CollapsibleListEntry = ({
  children,
  keyValues,
  startOpen,
  endAdornment,
  dataTestId,
  isErrored = false
}) => {
  const [expanded, setExpanded] = useState(startOpen ?? false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Box, {
    "data-testid": dataTestId,
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    margin: '16px 0px',
    onClick: handleExpandClick
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'center',
    gap: '32px'
  }, keyValues.map((k, index) => ( /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular',
    key: index,
    style: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      display: 'inline-flex',
      textOverflow: 'ellipsis'
    }
  }, isErrored && /*#__PURE__*/React__default.createElement(Icon, {
    iconColour: ColoursObj.states.error,
    name: 'Info'
  }), " ", k)))), endAdornment && /*#__PURE__*/React__default.createElement(Box, null, endAdornment), /*#__PURE__*/React__default.createElement(ExpandMore, {
    style: {
      marginRight: '12px'
    },
    expand: expanded,
    "aria-expanded": expanded,
    tabIndex: -1,
    "aria-label": 'show more'
  }, /*#__PURE__*/React__default.createElement(Chevron_Down, null))), /*#__PURE__*/React__default.createElement(CollapseList, {
    sx: {
      position: 'relative'
    },
    in: expanded,
    timeout: 'auto',
    unmountOnExit: true
  }, children), /*#__PURE__*/React__default.createElement(Divider, null));
};

const AdvanceFieldContainer = ({
  children,
  switchLabel = 'Advanced...',
  open,
  onChange,
  disabled
}) => {
  return /*#__PURE__*/React__default.createElement(Stack, {
    spacing: '24px'
  }, /*#__PURE__*/React__default.createElement(FormGroup, null, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      disabled: disabled,
      checked: open,
      onChange: (_, open) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(open);
      }
    }),
    label: switchLabel
  })), /*#__PURE__*/React__default.createElement(CollapseList, {
    mountOnEnter: true,
    in: open
  }, /*#__PURE__*/React__default.createElement(Stack, {
    spacing: '24px'
  }, /*#__PURE__*/React__default.createElement(Divider, null), children)));
};

const AdvanceFieldsForm = props => {
  const {
    control,
    name,
    ...baseProps
  } = props;
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    render: ({
      field: {
        onChange,
        value
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(AdvanceFieldContainer, Object.assign({}, baseProps, {
        onChange: onChange,
        open: value
      }));
    }
  });
};

const FormDateTimePicker = props => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: props.name,
    control: props.control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => {
      const _onChange = val => {
        if (props.onChange) {
          props.onChange(val);
        }
        onChange(val);
      };
      return /*#__PURE__*/React__default.createElement(DatetimePickerV3, Object.assign({}, props, {
        setDatetimeString: _onChange,
        datetimeString: value,
        errorMessage: error ? error.message : '',
        error: !!error,
        onClear: () => onChange('')
      }));
    }
  });
};

const HiddenInput = props => {
  const [show, setShow] = useState(false);
  const handleToggleShow = () => {
    setShow(!show);
  };
  return /*#__PURE__*/React__default.createElement(TextInputField, Object.assign({}, props, {
    type: show ? 'text' : 'password',
    iconRight: /*#__PURE__*/React__default.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      onClick: handleToggleShow
    }, !show ? ( /*#__PURE__*/React__default.createElement(Icon, {
      name: "Visible",
      iconColour: ColoursObj.shades.shade2
    })) : ( /*#__PURE__*/React__default.createElement(Icon, {
      name: "Hide",
      iconColour: ColoursObj.shades.shade2
    }))))
  }));
};

const FormHiddenInputField = props => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: props.name,
    control: props.control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(HiddenInput, Object.assign({}, props, {
        onChange: onChange,
        value: value,
        error: !!error,
        errorMessage: error ? error.message : undefined,
        uncontrolled: true
      }));
    }
  });
};

const DEFAULT_MAX_FILE_SIZE = 6 * 1024 * 1024;
const ImageSelectionField = ({
  value,
  onChange,
  onUpload,
  disabled,
  onError,
  height = '120px',
  label = 'Cover image',
  maxFileSize = DEFAULT_MAX_FILE_SIZE,
  messages,
  openFileDialog,
  helperText,
  allowedMimeTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp']
}) => {
  const [uploading, setUploading] = useState(false);
  const handleFileSelected = function (file) {
    try {
      if (file.size > maxFileSize) {
        onError === null || onError === void 0 ? void 0 : onError(`File size is too large. Please upload a file less than ${maxFileSize / (1024 * 1024)}mb.`, 'error');
        return Promise.resolve();
      }
      if (allowedMimeTypes.length > 0 && !allowedMimeTypes.includes(file.type)) {
        onError === null || onError === void 0 ? void 0 : onError((messages === null || messages === void 0 ? void 0 : messages.errorWrongImageType) || 'Wrong Image type', 'error');
        return Promise.resolve();
      }
      setUploading(true);
      return Promise.resolve(_finallyRethrows(function () {
        return _catch(function () {
          return Promise.resolve(onUpload === null || onUpload === void 0 ? void 0 : onUpload(file)).then(function (resp) {
            var _resp$data;
            if (!resp) {
              onError === null || onError === void 0 ? void 0 : onError((messages === null || messages === void 0 ? void 0 : messages.errorWithImageUpload) || 'Error uploading image', 'error');
              return;
            }
            if (resp.status === 'success' && (_resp$data = resp.data) !== null && _resp$data !== void 0 && _resp$data.source_url) {
              onChange === null || onChange === void 0 ? void 0 : onChange(resp.data.source_url);
            } else {
              onError === null || onError === void 0 ? void 0 : onError(resp.message || (messages === null || messages === void 0 ? void 0 : messages.errorWithImageUpload) || 'Error uploading image', 'error');
            }
          });
        }, function (err) {
          console.error('Upload failed:', err);
          onError === null || onError === void 0 ? void 0 : onError((messages === null || messages === void 0 ? void 0 : messages.errorWithImageUpload) || 'Error uploading image', 'error');
        });
      }, function (_wasThrown, _result) {
        setUploading(false);
        if (_wasThrown) throw _result;
        return _result;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  allowedMimeTypes.forEach(type => {
  });
  const handleCardClick = () => {
    if (uploading) return;
    if (disabled) return;
    openFileDialog === null || openFileDialog === void 0 ? void 0 : openFileDialog(handleFileSelected);
  };
  return /*#__PURE__*/React__default.createElement(Box, null, label && ( /*#__PURE__*/React__default.createElement(Box, {
    padding: '0 0 4px 0'
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext'
  }, label))), /*#__PURE__*/React__default.createElement(Card, {
    variant: 'outlined',
    style: {
      background: ColoursObj.backgrounds.input,
      height: 'fit-content',
      cursor: 'pointer'
    },
    onClick: handleCardClick
  }, /*#__PURE__*/React__default.createElement(Stack, {
    borderRadius: 'inherit',
    style: {
      height: height,
      backgroundImage: value ? `url(${value})` : 'none',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative'
    },
    padding: '16px',
    alignItems: 'center',
    justifyContent: 'center'
  }, uploading && ( /*#__PURE__*/React__default.createElement(Box, {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 1
  }, /*#__PURE__*/React__default.createElement(Loading, null))), !value && !uploading && ( /*#__PURE__*/React__default.createElement(Stack, {
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    height: '100%',
    textAlign: 'center'
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Upload'
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyBold'
  }, (messages === null || messages === void 0 ? void 0 : messages.clickToUpload) || 'Click to upload '), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext'
  }, `Allowed: ${allowedMimeTypes.map(type => type.split('/')[1].toUpperCase()).join(', ')} (max ${maxFileSize / (1024 * 1024)}mb)`), helperText && /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext'
  }, helperText))))));
};

const ImageSelectionForm = props => {
  const {
    control,
    name,
    ...baseProps
  } = props;
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    render: ({
      field: {
        onChange,
        value
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(ImageSelectionField, Object.assign({}, baseProps, {
        onChange: onChange,
        value: value
      }));
    }
  });
};

const FormInputText = props => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: props.name,
    control: props.control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(TextInputField, Object.assign({}, props, {
        onChange: onChange,
        "data-testid": props.name,
        value: value,
        error: !!error,
        errorMessage: error ? error.message : undefined,
        uncontrolled: true
      }));
    }
  });
};

const SelectInputField = ({
  data,
  noneSelect,
  restrictedIds,
  setSelected,
  defaultValue,
  defaultValues,
  multiple,
  onChange,
  fieldLabel,
  required,
  error,
  disabled,
  readOnly,
  errorMessage,
  helperTooltip,
  tag,
  chip,
  removable,
  style,
  placeholder,
  helperTextStyle,
  allowDeselect,
  hapticFeedback,
  formControlMarginTop,
  menuPaperProps,
  helperIcon
}) => {
  const [singleSelected, setSingleSelected] = useState(defaultValue ?? '');
  const [multiSelected, setMultiSelected] = useState(defaultValues ?? []);
  const [badgeNumber, setBadgeNumber] = useState(0);
  const chipMultiContainer = useRef(null);
  const selectMultiContainer = useRef(null);
  const nonOption = {
    id: 'none',
    displayName: noneSelect ? noneSelect : 'None'
  };
  const fullData = noneSelect ? [...data, nonOption] : data;
  useEffect(() => {
    setSingleSelected(defaultValue);
  }, [defaultValue]);
  useEffect(() => {
    if (defaultValues) {
      setMultiSelected(defaultValues);
      if (defaultValues.length === 0) {
        setBadgeNumber(0);
      }
    }
  }, [defaultValues]);
  function handleMultiChange(e) {
    onChange && onChange(e);
    const IDs = e.target.value;
    if (IDs.length < multiSelected.length) {
      badgeNumber > 0 && setBadgeNumber(badgeNumber - 1);
    }
    if (IDs.includes('none')) {
      setMultiSelected(['none']);
    } else {
      setMultiSelected(IDs);
    }
    var returnList = [];
    IDs.forEach(id => {
      const temp = fullData.find(entry => entry.id === id);
      temp && (returnList = returnList.concat(temp));
    });
    returnList && setSelected && setSelected(returnList);
  }
  function handleSingleChange(e) {
    onChange && onChange(e);
    const ID = e.target.value;
    (ID || ID === 0) && setSingleSelected(ID);
    var returnEntry = fullData.find(entry => entry.id === ID);
    returnEntry && setSelected && setSelected(returnEntry);
  }
  useEffect(() => {
    checkSizes();
  }, [multiSelected]);
  function selectedInData(selected) {
    var listIds = [];
    if (fullData) {
      fullData.forEach(entry => listIds = listIds.concat(entry.id.toString()));
      if ((selected || selected === 0) && listIds.includes(selected.toString())) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  function multiSelectinData() {
    var validData = true;
    multiSelected.forEach(selected => {
      if (!selectedInData(selected)) {
        validData = false;
      }
    });
    return validData;
  }
  function checkSizes() {
    if (selectMultiContainer.current && chipMultiContainer.current) {
      if (selectMultiContainer.current.offsetWidth < chipMultiContainer.current.offsetWidth + 106) {
        setBadgeNumber(badgeNumber + 1);
        return false;
      }
    }
    return true;
  }
  const handleDeselect = () => {
    setSingleSelected(undefined);
    const event = {
      target: {
        value: undefined
      }
    };
    onChange && onChange(event);
  };
  function returnMultiChip(selectedId, index) {
    const selectedEntry = fullData.find(entry => entry.id === selectedId);
    return selectedEntry && index < multiSelected.length - badgeNumber && ( /*#__PURE__*/React__default.createElement(Chip, {
      key: index,
      label: /*#__PURE__*/React__default.createElement(Stack, {
        display: 'flex',
        flexDirection: 'row',
        gap: '4px',
        onMouseDown: event => event.stopPropagation()
      }, /*#__PURE__*/React__default.createElement(Typography$1, null, selectedEntry.displayName), removable && ( /*#__PURE__*/React__default.createElement(Icon, {
        name: 'Cancel',
        iconColour: ColoursObj.shades.shade5,
        onClick: () => {
          const temp = multiSelected.filter(id => {
            if (id !== selectedId) {
              return true;
            } else {
              return false;
            }
          });
          setMultiSelected(temp);
          const event = {
            target: {
              value: temp
            }
          };
          onChange && onChange(event);
          badgeNumber > 0 && setBadgeNumber(badgeNumber - 1);
        }
      })))
    }));
  }
  function returnMultiTag(selectedId, index) {
    var localBadgeNumber = badgeNumber;
    const selectedEntry = fullData.find(entry => entry.id === selectedId);
    return selectedEntry && index < multiSelected.length - localBadgeNumber && ( /*#__PURE__*/React__default.createElement(Stack, {
      key: index,
      display: 'flex',
      flexDirection: 'row',
      gap: '4px',
      onMouseDown: event => event.stopPropagation(),
      sx: {
        backgroundColor: ColoursObj.core.secondary,
        borderRadius: '4px',
        padding: '4px 8px 4px 8px'
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      color: ColoursObj.shades.shade5
    }, selectedEntry.displayName), removable && ( /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Cancel',
      iconColour: ColoursObj.shades.shade5,
      onClick: () => {
        const temp = multiSelected.filter(id => {
          if (id !== selectedId) {
            return true;
          } else {
            return false;
          }
        });
        setMultiSelected(temp);
        const event = {
          target: {
            value: temp
          }
        };
        onChange && onChange(event);
        badgeNumber > 0 && setBadgeNumber(badgeNumber - 1);
      }
    }))));
  }
  function returnMulti(selectedId, index) {
    var localBadgeNumber = badgeNumber;
    const selectedEntry = fullData.find(entry => entry.id === selectedId);
    return selectedEntry && index < multiSelected.length - localBadgeNumber && ( /*#__PURE__*/React__default.createElement(Typography$1, {
      key: index
    }, selectedEntry.displayName, (index !== multiSelected.length - localBadgeNumber - 1 || index === multiSelected.length - localBadgeNumber - 1 && badgeNumber > 0) && multiSelected.length > 1 && ', '));
  }
  function returnSingleChip(selectedId) {
    const selectedEntry = fullData.find(entry => entry.id === selectedId);
    return selectedEntry && ( /*#__PURE__*/React__default.createElement(Chip, {
      label: /*#__PURE__*/React__default.createElement(Stack, {
        display: 'flex',
        flexDirection: 'row',
        gap: '4px',
        onMouseDown: event => event.stopPropagation()
      }, /*#__PURE__*/React__default.createElement(Typography$1, null, selectedEntry.displayName), removable && ( /*#__PURE__*/React__default.createElement(Icon, {
        name: 'Cancel',
        iconColour: ColoursObj.shades.shade5,
        onClick: () => {
          setSingleSelected(undefined);
        }
      })))
    }));
  }
  function returnSingleTag(selectedId) {
    const selectedEntry = fullData.find(entry => entry.id === selectedId);
    return selectedEntry && ( /*#__PURE__*/React__default.createElement(Stack, {
      display: 'flex',
      flexDirection: 'row',
      gap: '4px',
      onMouseDown: event => event.stopPropagation(),
      sx: {
        backgroundColor: ColoursObj.core.secondary,
        borderRadius: '4px',
        padding: '4px 8px 4px 8px'
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      color: ColoursObj.shades.shade5
    }, selectedEntry.displayName), removable && ( /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Cancel',
      iconColour: ColoursObj.shades.shade5,
      onClick: () => {
        setMultiSelected(multiSelected.filter(id => {
          if (id !== selectedId) {
            return true;
          } else {
            return false;
          }
        }));
        badgeNumber > 0 && setBadgeNumber(badgeNumber - 1);
      }
    }))));
  }
  function returnSingle(selectedId) {
    const selectedEntry = fullData.find(entry => entry.id === selectedId);
    return selectedEntry && ( /*#__PURE__*/React__default.createElement(Typography$1, {
      style: {
        paddingLeft: '8px'
      },
      color: ColoursObj.core.primary,
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }, selectedEntry.displayName));
  }
  return multiple ? ( /*#__PURE__*/React__default.createElement(FormControl, {
    style: {
      marginTop: formControlMarginTop || formControlMarginTop === 0 ? formControlMarginTop + 'px' : '8px'
    }
  }, /*#__PURE__*/React__default.createElement(InputLabel, {
    shrink: true,
    id: 'multi-select-label',
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext',
    style: {
      opacity: disabled ? '0.38' : '1'
    }
  }, fieldLabel, required && ' *'), helperTooltip && ( /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: helperTooltip,
    placement: 'right-start',
    arrow: true
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: 'fit-content',
      padding: '0 0 0 8px'
    }
  }, helperIcon && helperIcon, !helperIcon && /*#__PURE__*/React__default.createElement(Help, {
    height: 16,
    width: 16
  }))))), /*#__PURE__*/React__default.createElement(Select, {
    multiple: true,
    onClick: () => {
      hapticFeedback && NativeUtils.hapticFeedback(hapticFeedback);
    },
    value: multiSelectinData() ? multiSelected : [],
    ref: selectMultiContainer,
    readOnly: readOnly,
    IconComponent: () => readOnly ? ( /*#__PURE__*/React__default.createElement("div", null)) : ( /*#__PURE__*/React__default.createElement("div", {
      style: {
        pointerEvents: 'none',
        position: 'absolute',
        right: 10
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Chevron_Down'
    }))),
    error: error,
    disabled: disabled,
    labelId: 'multi-select-label',
    sx: {
      padding: '4px',
      '&.Mui-focused': {
        padding: '4px 3px'
      },
      '&.Mui-error': {
        padding: '4px 3px'
      },
      ':hover': {
        padding: '4px 3px'
      },
      ':focus': {
        padding: '4px 3px'
      },
      background: ColoursObj.backgrounds.input
    },
    style: style,
    displayEmpty: true,
    MenuProps: {
      PaperProps: {
        sx: {
          '&.MuiPopover-paper': {
            ...menuPaperProps
          },
          borderRadius: '8px',
          boxShadow: MuiShaddows[1],
          background: ColoursObj.backgrounds.input
        }
      }
    },
    renderValue: selected => ( /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        gap: '8px'
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        gap: '8px',
        width: 'fit-content',
        paddingLeft: !chip && !tag ? '8px' : ''
      },
      ref: chipMultiContainer
    }, selected.length > 0 ? selected.map((selectedId, index) => {
      if (selectedId === 'none') {
        return /*#__PURE__*/React__default.createElement(Typography$1, {
          key: index,
          variant: 'bodyRegular',
          color: ColoursObj.core.primary
        }, noneSelect ? noneSelect : 'None');
      }
      return chip ? returnMultiChip(selectedId, index) : tag ? returnMultiTag(selectedId, index) : returnMulti(selectedId, index);
    }) : ( /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: 'bodyRegular',
      color: ColoursObj.shades.shade2
    }, placeholder))), badgeNumber > 0 && ( /*#__PURE__*/React__default.createElement("div", {
      style: {
        height: '32px',
        width: '32px',
        borderRadius: chip ? '16px' : tag ? '4px' : '0',
        padding: '0 8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: chip || tag ? ColoursObj.core.secondary : 'unset'
      }
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      color: chip || tag ? ColoursObj.shades.shade5 : ColoursObj.core.primary
    }, "+", badgeNumber))))),
    onChange: event => {
      const value = event.target.value;
      if (noneSelect && value[value.length - 1] === 'none') {
        handleMultiChange({
          target: {
            value: ['none']
          }
        });
      } else {
        const updatedValue = value.filter(val => val !== 'none');
        handleMultiChange({
          target: {
            value: updatedValue
          }
        });
      }
    }
  }, fullData.sort((a, b) => {
    if (a.id === 'none') return -1;
    if (b.id === 'none') return 1;
    return 0;
  }).filter(item => !(restrictedIds !== null && restrictedIds !== void 0 && restrictedIds.includes(item.id))).map((entry, index) => ( /*#__PURE__*/React__default.createElement(MenuItem, {
    value: entry.id,
    key: index,
    disabled: entry.locked,
    style: {
      backgroundColor: index % 2 === 0 ? ColoursObj.backgrounds.primary : ColoursObj.shades.shade4
    }
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    checked: multiSelected.indexOf(entry.id) > -1 && multiSelectinData(),
    style: {
      color: multiSelected.indexOf(entry.id) > -1 && multiSelectinData() ? ColoursObj.core.secondary : ColoursObj.shades.shade1
    },
    disabled: entry.locked
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      width: '100%',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    style: {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, entry.displayName), entry.locked && ( /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: entry.lockedText,
    placement: 'right'
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'inline-flex',
      pointerEvents: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Locked',
    iconColour: ColoursObj.shades.shade2
  }))))))))), error && ( /*#__PURE__*/React__default.createElement(FormHelperText, {
    sx: helperTextStyle
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext',
    color: disabled ? ColoursObj.shades.shade2 : error ? ColoursObj.states.error : ColoursObj.core.primary
  }, errorMessage))))) : ( /*#__PURE__*/React__default.createElement(FormControl, {
    style: {
      marginTop: formControlMarginTop || formControlMarginTop === 0 ? formControlMarginTop + 'px' : '8px'
    }
  }, /*#__PURE__*/React__default.createElement(InputLabel, {
    shrink: true,
    id: 'single-select-label',
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext',
    style: {
      opacity: disabled ? '0.38' : '1'
    }
  }, fieldLabel, required && ' *'), helperTooltip && ( /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: helperTooltip,
    placement: 'right-start',
    arrow: true
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: 'fit-content',
      padding: '0 0 0 8px'
    }
  }, helperIcon && helperIcon, !helperIcon && /*#__PURE__*/React__default.createElement(Help, {
    height: 16,
    width: 16
  }))))), /*#__PURE__*/React__default.createElement(Select, {
    onClick: () => {
      hapticFeedback && NativeUtils.hapticFeedback(hapticFeedback);
    },
    value: selectedInData(singleSelected) ? singleSelected : '',
    labelId: 'single-select-label',
    variant: 'outlined',
    readOnly: readOnly,
    IconComponent: () => readOnly ? ( /*#__PURE__*/React__default.createElement("div", null)) : ( /*#__PURE__*/React__default.createElement("div", {
      style: {
        pointerEvents: 'none',
        position: 'absolute',
        right: 10
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Chevron_Down'
    }))),
    error: error,
    disabled: disabled,
    displayEmpty: true,
    MenuProps: {
      PaperProps: {
        sx: {
          '&.MuiMenu-paper': {
            ...menuPaperProps
          },
          borderRadius: '8px',
          boxShadow: MuiShaddows[1],
          background: ColoursObj.backgrounds.input
        }
      }
    },
    sx: {
      padding: '4px',
      '&.Mui-focused': {
        padding: '4px 3px'
      },
      '&.Mui-error': {
        padding: '4px 3px'
      },
      ':hover': {
        padding: '4px 3px'
      },
      ':focus': {
        padding: '4px 3px'
      },
      background: ColoursObj.backgrounds.input
    },
    style: style,
    renderValue: selected => ( /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        gap: '2px',
        width: '100%'
      }
    }, chip ? returnSingleChip(selected) : tag ? returnSingleTag(selected) : returnSingle(selected), selected === '' && ( /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: 'bodyRegular',
      color: ColoursObj.core.primary,
      style: {
        paddingLeft: '8px'
      }
    }, placeholder))))),
    onChange: handleSingleChange
  }, fullData.filter(item => !(restrictedIds !== null && restrictedIds !== void 0 && restrictedIds.includes(item.id))).map((entry, index) => ( /*#__PURE__*/React__default.createElement(MenuItem, {
    value: entry.id,
    key: index,
    style: {
      backgroundColor: ColoursObj.backgrounds.input,
      width: '100%'
    },
    disabled: entry.locked,
    onClick: () => {
      singleSelected !== undefined && singleSelected === entry.id && allowDeselect && handleDeselect();
    }
  }, /*#__PURE__*/React__default.createElement(Radio, {
    disabled: entry.locked,
    checked: singleSelected !== undefined && singleSelected === entry.id
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      width: '100%',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    style: {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    color: ColoursObj.font.primary === ColoursObj.backgrounds.input ? ColoursObj.shades.shade1 : ColoursObj.font.primary
  }, entry.displayName), entry.locked && ( /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: entry.lockedText,
    placement: 'right'
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'inline-flex',
      pointerEvents: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Locked',
    iconColour: ColoursObj.shades.shade2
  }))))))))), error && ( /*#__PURE__*/React__default.createElement(FormHelperText, {
    sx: helperTextStyle
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext',
    color: disabled ? ColoursObj.shades.shade2 : error ? ColoursObj.states.error : ColoursObj.core.primary
  }, errorMessage)))));
};

const FormSelectInput = props => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: props.name,
    control: props.control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(SelectInputField, Object.assign({}, props, {
        onChange: onChange,
        defaultValue: value ?? props.defaultValue,
        defaultValues: value ?? props.defaultValues,
        error: !!error,
        errorMessage: error ? error.message : undefined
      }));
    }
  });
};

const EventrLogoDark = props => ( /*#__PURE__*/createElement("div", {
  style: {
    height: props.height,
    width: props.width
  }
}, /*#__PURE__*/createElement("svg", Object.assign({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 137,
  height: 136,
  viewBox: '0 0 137 136',
  fill: 'none'
}, props), /*#__PURE__*/createElement("path", {
  fill: '#18B1AB',
  d: 'M20.5 40c11.046 0 20-8.954 20-20s-8.954-20-20-20S.5 8.954.5 20s8.954 20 20 20Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#464D77',
  d: 'M68.5 40c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#18B1AB',
  d: 'M116.5 40c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#10375C',
  d: 'M20.5 88c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#FF565C',
  d: 'M68.5 88c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#F3C724',
  d: 'M116.5 88c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#18B1AB',
  d: 'M20.5 136c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#464D77',
  d: 'M68.5 136c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}), /*#__PURE__*/createElement("path", {
  fill: '#18B1AB',
  d: 'M116.5 136c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z'
}))));

const MobileInfoDialog = ({
  text,
  buttonText = 'Confirm',
  onClose,
  buttonVariantOverride = 'dialogue'
}) => {
  return /*#__PURE__*/React__default.createElement(MobileFrameDialog, null, /*#__PURE__*/React__default.createElement(DialogTitle, {
    style: {
      background: ColoursObj.backgrounds.dialogue
    }
  }, text), /*#__PURE__*/React__default.createElement(Divider, {
    orientation: 'horizontal',
    flexItem: true,
    style: {
      background: ColoursObj.shades.shade3,
      height: 'auto'
    }
  }), /*#__PURE__*/React__default.createElement(DialogActions, {
    style: {
      padding: '0px'
    }
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    style: {
      width: '100%'
    },
    onClick: onClose,
    variant: buttonVariantOverride
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: ColoursObj.core.secondary
  }, buttonText))));
};

const AddressLookup = ({
  selectedAddress,
  setSelectedAddress,
  apiClient,
  label,
  addressLabels = {
    use_lookup: 'Use Address Lookup',
    manually: 'Enter Address Manually',
    line1: 'Line 1',
    line2: 'Line 2',
    town: 'Town',
    country: 'Country',
    postcode: 'Postcode',
    clearButtonText: 'Clear Address',
    noTimezoneFound: 'Could not find a timezone for that address. Please manually select one.'
  },
  disabled = false,
  readOnly = false,
  showManualOnDisabled = false,
  centerAround,
  useTzAsCenter,
  setTzOnSelect,
  onSetTzOnSelect,
  isMobile,
  manual
}) => {
  var _selectedAddress$addr, _selectedAddress$addr2, _selectedAddress$addr3, _selectedAddress$addr4, _selectedAddress$addr5, _selectedAddress$addr6, _selectedAddress$addr7, _selectedAddress$addr8, _selectedAddress$addr9, _selectedAddress$addr10, _selectedAddress$addr11;
  const [manualInput, setManualInput] = useState(manual ?? false);
  const [searchResults, setSearchResults] = useState([]);
  const [lastRequestTime, setLastRequestTime] = useState(Date.now());
  const [displaySearchResults, setDisplaySearchResults] = useState([]);
  const [usedToRerenderField, setUsedToRerenderField] = useState(false);
  useEffect(() => {
    if (selectedAddress && selectedAddress.address) {
      setManualInput(true);
    }
  }, []);
  useEffect(() => {
    if (apiClient === undefined) {
      setManualInput(true);
    }
  }, [apiClient]);
  function setSelectedAddressSafe(selectedAddressTmp) {
    if (selectedAddressTmp) {
      if (setTzOnSelect && selectedAddressTmp.timeZone) {
        const newCountryObj = CountryCodesWithNames.find(countryObj => {
          var _selectedAddressTmp$a, _selectedAddressTmp$a2;
          return countryObj.id === ((_selectedAddressTmp$a = selectedAddressTmp.address) === null || _selectedAddressTmp$a === void 0 ? void 0 : (_selectedAddressTmp$a2 = _selectedAddressTmp$a.country_code) === null || _selectedAddressTmp$a2 === void 0 ? void 0 : _selectedAddressTmp$a2.toUpperCase());
        });
        let newTz = selectedAddressTmp.timeZone;
        if (newCountryObj && newCountryObj !== null && newCountryObj !== void 0 && newCountryObj.timezones) {
          if ((newCountryObj === null || newCountryObj === void 0 ? void 0 : newCountryObj.timezones.length) === 1) {
            newTz = newCountryObj === null || newCountryObj === void 0 ? void 0 : newCountryObj.timezones[0];
          } else {
            let change = false;
            for (const timezone of newCountryObj.timezones) {
              var _selectedAddressTmp$d;
              if ((_selectedAddressTmp$d = selectedAddressTmp.display_name) !== null && _selectedAddressTmp$d !== void 0 && _selectedAddressTmp$d.includes(timezone.split('/')[1])) {
                newTz = timezone;
                change = true;
              }
            }
            if (!change) {
              if (isMobile) {
                useDialogStore.getState().replaceDialog({
                  node: ( /*#__PURE__*/React__default.createElement(MobileInfoDialog, {
                    text: addressLabels.noTimezoneFound,
                    onClose: () => {
                      useDialogStore.getState().clearDialog();
                      setSelectedAddress(selectedAddressTmp);
                      setManualInput(true);
                    }
                  })),
                  backdropClosable: true
                });
              } else {
                if (onSetTzOnSelect) {
                  onSetTzOnSelect(false);
                }
              }
            }
          }
        }
        if (newTz !== (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.timeZone)) {
          if (isMobile) {
            useDialogStore.getState().replaceDialog({
              node: ( /*#__PURE__*/React__default.createElement(MobileConfirmDialog, {
                text: `Confirm changing the timezone of the Itinerary from ${selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.timeZone} to ${newTz}.`,
                onCancel: () => {
                  useDialogStore.getState().clearDialog();
                },
                onConfirm: () => {
                  selectedAddressTmp.timeZone = newTz;
                  setSelectedAddress(selectedAddressTmp);
                  setManualInput(true);
                  useDialogStore.getState().clearDialog();
                }
              })),
              backdropClosable: false
            });
          } else {
            if (onSetTzOnSelect) {
              onSetTzOnSelect(newTz);
            }
          }
        } else {
          setSelectedAddress(selectedAddressTmp);
          setManualInput(true);
        }
      } else {
        setSelectedAddress(selectedAddressTmp);
        setManualInput(true);
      }
    }
  }
  useEffect(() => {
    if (showManualOnDisabled && disabled || showManualOnDisabled && readOnly) {
      setManualInput(true);
    }
  }, [disabled, readOnly]);
  function runRequest(query) {
    if (apiClient) {
      if (lastRequestTime + 200 < Date.now()) {
        if (query && query.length > 2) {
          setLastRequestTime(Date.now());
          const formattedQuery = encodeURIComponent(query);
          let latToUse;
          let lonToUse;
          if (centerAround && centerAround.lat && centerAround.lon) {
            latToUse = centerAround.lat;
            lonToUse = centerAround.lon;
          }
          if (useTzAsCenter) {
            const selectedCountryObj = CountryCodesWithNames.find(countryObj => {
              if (selectedAddress !== null && selectedAddress !== void 0 && selectedAddress.timeZone) {
                return countryObj.timezones.includes(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.timeZone);
              }
              return countryObj.id === (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.selectedCountryCode);
            });
            if (selectedCountryObj) {
              latToUse = selectedCountryObj.lat;
              lonToUse = selectedCountryObj.lon;
            }
          }
          apiClient.get(`/addresslookup/v3?q=${formattedQuery}${latToUse && lonToUse ? '&lat=' + latToUse + '&lon=' + lonToUse : ''}`).then(request => {
            if (request.data && request.data.length > 0) {
              var v1MappedAndFiltered = [];
              request.data.forEach(v1OSMAddress => {
                if (v1OSMAddress) {
                  var alreadyAdded = false;
                  for (const v1OSMAddressAlreadyAdded of v1MappedAndFiltered) {
                    if (v1OSMAddress.display_name === v1OSMAddressAlreadyAdded.display_name) {
                      alreadyAdded = true;
                    }
                  }
                  if (!alreadyAdded) {
                    v1MappedAndFiltered.push(v1OSMAddress);
                  }
                }
              });
              setSearchResults(v1MappedAndFiltered);
            }
          });
        }
      }
    }
  }
  useEffect(() => {
    let tmpResultsToDisplay = [];
    for (const result of searchResults) {
      tmpResultsToDisplay.push({
        label: result.display_name ?? ''
      });
    }
    setDisplaySearchResults(tmpResultsToDisplay);
  }, [searchResults]);
  function onChangeSetAddress(set, key, keys) {
    if (selectedAddress && selectedAddress.address) {
      if (key) {
        setSelectedAddress({
          ...selectedAddress,
          address: {
            ...selectedAddress.address,
            [key]: set
          }
        });
      } else if (keys && keys.length > 0) {
        var tmpAddress = {
          ...selectedAddress.address
        };
        keys.forEach(addressKey => {
          tmpAddress[addressKey] = set;
        });
        setSelectedAddress({
          ...selectedAddress,
          address: tmpAddress
        });
      }
    } else {
      if (key) {
        setSelectedAddress({
          ...selectedAddress,
          place_id: 0,
          licence: '',
          osm_type: '',
          osm_id: 0,
          boundingbox: [],
          lat: '',
          lon: '',
          display_name: '',
          class: '',
          type: '',
          importance: 0,
          address: {
            [key]: set
          }
        });
      } else if (keys && keys.length > 0) {
        var tmpAddress = {};
        keys.forEach(addressKey => {
          tmpAddress[addressKey] = set;
        });
        setSelectedAddress({
          ...selectedAddress,
          place_id: 0,
          licence: '',
          osm_type: '',
          osm_id: 0,
          boundingbox: [],
          lat: '',
          lon: '',
          display_name: '',
          class: '',
          type: '',
          importance: 0,
          address: tmpAddress
        });
      }
    }
  }
  function findAndSelectFromList(displayName) {
    var tmpResult = searchResults.find(result => {
      return result.display_name === displayName;
    });
    if (tmpResult) {
      setSelectedAddressSafe({
        ...selectedAddress,
        ...tmpResult
      });
    }
  }
  function handleClear() {
    setSelectedAddress({
      timeZone: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.timeZone
    });
    setDisplaySearchResults([]);
    setUsedToRerenderField(!usedToRerenderField);
    setManualInput(false);
  }
  return /*#__PURE__*/React__default.createElement(Stack, {
    display: 'grid'
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid'
  }, /*#__PURE__*/React__default.createElement(VerticalExpander, {
    open: !manualInput
  }, /*#__PURE__*/React__default.createElement(Stack, {
    margin: '0 0 16px 0'
  }, apiClient && ( /*#__PURE__*/React__default.createElement(Autocomplete, {
    id: 'addressInput',
    key: usedToRerenderField ? 'usedToRerenderField' : 'usedToRerenderFieldPleaseIgnore',
    freeSolo: true,
    options: displaySearchResults,
    filterOptions: options => options,
    disabled: disabled || manualInput,
    readOnly: readOnly,
    renderInput: params => {
      return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, params, {
        size: 'medium',
        placeholder: addressLabels === null || addressLabels === void 0 ? void 0 : addressLabels.placeholder,
        style: {
          padding: '0'
        },
        label: /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/React__default.createElement(Typography$1, {
          variant: 'bodySubtext'
        }, label)),
        InputLabelProps: {
          shrink: true
        },
        disabled: disabled,
        sx: {
          Label: {
            transform: 'translateY(-8px)'
          }
        }
      })));
    },
    onInputChange: (event, value, reason) => {
      if (reason === 'clear') {
        handleClear();
      }
      if (disabled || readOnly || !value) {
        return;
      }
      if (event.type === 'click' || event.type === 'keydown') {
        findAndSelectFromList(value);
        return;
      }
      runRequest(value);
    },
    onSelect: event => {
      if (!event) {
        return;
      }
      if (event.type === 'select' && event.nativeEvent.key === 'Enter') {
        findAndSelectFromList(event.target.value);
      }
    },
    PaperComponent: props => ( /*#__PURE__*/React__default.createElement(Paper, Object.assign({}, props, {
      style: {
        background: ColoursObj.backgrounds.primary,
        color: ColoursObj.core.primary
      },
      sx: {
        '& .MuiAutocomplete-listbox': {
          '& .MuiAutocomplete-option': {
            minHeight: '32px'
          }
        }
      }
    }))),
    clearIcon: /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Cancel'
    })
  })))), apiClient && !showManualOnDisabled && !disabled && ( /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'addressEntryOptionsButton',
    variant: 'secondary',
    text: manualInput ? addressLabels.use_lookup : addressLabels.manually,
    onClick: () => {
      if (apiClient === undefined) {
        setManualInput(true);
      } else {
        setManualInput(!manualInput);
      }
    }
  }))), /*#__PURE__*/React__default.createElement(VerticalExpander, {
    unmountOnClose: true,
    open: manualInput
  }, /*#__PURE__*/React__default.createElement(Stack, {
    gap: '8px',
    margin: '8px 0 0 0'
  }, /*#__PURE__*/React__default.createElement(TextInputField, {
    id: 'addressLine1',
    value: (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr = selectedAddress.address) === null || _selectedAddress$addr === void 0 ? void 0 : _selectedAddress$addr.house_number) ?? (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr2 = selectedAddress.address) === null || _selectedAddress$addr2 === void 0 ? void 0 : _selectedAddress$addr2.tourism) ?? (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr3 = selectedAddress.address) === null || _selectedAddress$addr3 === void 0 ? void 0 : _selectedAddress$addr3.amenity) ?? (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr4 = selectedAddress.address) === null || _selectedAddress$addr4 === void 0 ? void 0 : _selectedAddress$addr4.leisure) ?? (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr5 = selectedAddress.address) === null || _selectedAddress$addr5 === void 0 ? void 0 : _selectedAddress$addr5.building) ?? '',
    onChange: e => {
      onChangeSetAddress(e.target.value, undefined, ['house_number', 'tourism', 'amenity', 'leisure', 'building']);
    },
    fieldLabel: addressLabels.line1,
    disabled: disabled,
    readOnly: readOnly
  }), /*#__PURE__*/React__default.createElement(TextInputField, {
    id: 'addressLine2',
    value: (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr6 = selectedAddress.address) === null || _selectedAddress$addr6 === void 0 ? void 0 : _selectedAddress$addr6.road) ?? '',
    onChange: e => {
      onChangeSetAddress(e.target.value, 'road');
    },
    fieldLabel: addressLabels.line2,
    disabled: disabled,
    readOnly: readOnly
  }), /*#__PURE__*/React__default.createElement(TextInputField, {
    id: 'city',
    value: (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr7 = selectedAddress.address) === null || _selectedAddress$addr7 === void 0 ? void 0 : _selectedAddress$addr7.village) ?? (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr8 = selectedAddress.address) === null || _selectedAddress$addr8 === void 0 ? void 0 : _selectedAddress$addr8.town) ?? (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr9 = selectedAddress.address) === null || _selectedAddress$addr9 === void 0 ? void 0 : _selectedAddress$addr9.city) ?? '',
    onChange: e => {
      onChangeSetAddress(e.target.value, undefined, ['village', 'town', 'city']);
    },
    fieldLabel: addressLabels.town,
    disabled: disabled,
    readOnly: readOnly
  }), /*#__PURE__*/React__default.createElement(TextInputField, {
    id: 'country',
    value: (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr10 = selectedAddress.address) === null || _selectedAddress$addr10 === void 0 ? void 0 : _selectedAddress$addr10.country) ?? '',
    onChange: e => {
      onChangeSetAddress(e.target.value, 'country');
    },
    fieldLabel: addressLabels.country,
    disabled: disabled,
    readOnly: readOnly
  }), /*#__PURE__*/React__default.createElement(TextInputField, {
    id: 'postcode',
    value: (selectedAddress === null || selectedAddress === void 0 ? void 0 : (_selectedAddress$addr11 = selectedAddress.address) === null || _selectedAddress$addr11 === void 0 ? void 0 : _selectedAddress$addr11.postcode) ?? '',
    onChange: e => {
      onChangeSetAddress(e.target.value.toUpperCase(), 'postcode');
    },
    fieldLabel: addressLabels.postcode,
    disabled: disabled,
    readOnly: readOnly
  }), /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'addressEntryClearButton',
    variant: 'destructiveSecondary',
    onClick: handleClear,
    text: addressLabels.clearButtonText
  }))));
};

const CheckboxField = props => {
  return /*#__PURE__*/React__default.createElement(Checkbox, Object.assign({}, props));
};

const useIpInfo = create()(persist((set, _) => {
  const api = new ApiClient({
    baseURL: 'https://freeipapi.com/api/json'
  });
  api.get('').then(res => {
    if (res && res.status === 'success' && res.data) {
      set({
        ipInfo: res.data
      });
    } else {
      spErrorTags('Failed request for api info: ' + JSON.stringify(res), ['ERROR', 'HTTPS', 'IPINFO']);
    }
  }).catch(error => {
    spErrorTags('Failed request for api info: ' + JSON.stringify(error), ['ERROR', 'HTTPS', 'IPINFO']);
  });
  return {
    ipInfo: {
      ipVersion: 0,
      ipAddress: '',
      latitude: 0,
      longitude: 0,
      countryName: '',
      countryCode: 'GB',
      timeZone: '',
      timeZones: [],
      zipCode: '',
      cityName: '',
      regionName: '',
      isProxy: false,
      continent: '',
      continentCode: ''
    }
  };
}, {
  name: 'ipInfoStore'
}));

const CountryInputDropDown = props => {
  return /*#__PURE__*/React__default.createElement(SelectInputField, Object.assign({}, props, {
    data: CountryCodesWithNames
  }));
};
const CountryInputDropDownSorted = props => {
  return /*#__PURE__*/React__default.createElement(SelectInputField, Object.assign({}, props, {
    data: CountryCodesWithNames.sort((itemA, _) => {
      if (itemA.id === 'GB') {
        return -1;
      } else {
        return 0;
      }
    })
  }));
};
const CountryInputDropDownSortedInput = props => {
  const mapCountriesToItemOptions = [];
  if (props.defaultCountryCode) {
    var _defaultCountryCodeIt;
    const defaultCountryCodeItemProp = {
      id: `${props.defaultCountryCode.id}|${props.defaultCountryCode.timezones[0]}`,
      label: `${props.defaultCountryCode.displayName} ${props.defaultCountryCode.timezones[0]}`,
      obj: {
        timezone: props.defaultCountryCode.timezones[0],
        isTimezone: true,
        cleanTimezone: props.defaultCountryCode.timezones[0].replace(/_/g, ' ').split('/').reverse()[0],
        countryDisplayName: props.defaultCountryCode.displayName
      }
    };
    mapCountriesToItemOptions.push({
      id: defaultCountryCodeItemProp.id,
      label: getFlagEmojiFromCountryCode(((_defaultCountryCodeIt = defaultCountryCodeItemProp.id) === null || _defaultCountryCodeIt === void 0 ? void 0 : _defaultCountryCodeIt.toString()) ?? '') + '  ' + `(${defaultCountryCodeItemProp.obj})` + '  ' + defaultCountryCodeItemProp.label,
      obj: defaultCountryCodeItemProp.obj
    });
  }
  CountryCodesWithNames.forEach(country => {
    if (country.timezoneGroups) {
      country.timezoneGroups.forEach((timezoneGroup, i) => {
        if (i === 0) {
          mapCountriesToItemOptions.push({
            id: `${country.id}|${timezoneGroup.mainTimezone}`,
            label: `${getFlagEmojiFromCountryCode(country.id)} (${timezoneGroup.mainTimezone}) ${country.displayName}`,
            obj: {
              timezone: timezoneGroup.mainTimezone,
              cleanTimezone: timezoneGroup.label,
              countryDisplayName: country.displayName
            }
          });
        } else {
          mapCountriesToItemOptions.push({
            id: `${country.id}|${timezoneGroup.mainTimezone}`,
            label: `${country.displayName} ${timezoneGroup.label}`,
            obj: {
              timezone: timezoneGroup.mainTimezone,
              isTimezone: true,
              cleanTimezone: timezoneGroup.label,
              countryDisplayName: country.displayName
            }
          });
        }
      });
    } else {
      country.timezones.forEach((timezone, i) => {
        if (i === 0) {
          mapCountriesToItemOptions.push({
            id: `${country.id}|${timezone}`,
            label: `${getFlagEmojiFromCountryCode(country.id)} ${country.displayName}`,
            obj: {
              timezone: timezone,
              cleanTimezone: timezone.replace(/_/g, ' ').split('/').reverse()[0],
              countryDisplayName: country.displayName
            }
          });
        } else {
          mapCountriesToItemOptions.push({
            id: `${country.id}|${timezone}`,
            label: `${country.displayName} ${timezone}`,
            obj: {
              timezone: timezone,
              isTimezone: true,
              cleanTimezone: timezone.replace(/_/g, ' ').split('/').reverse()[0],
              countryDisplayName: country.displayName
            }
          });
        }
      });
    }
  });
  const ipCountryCode = useIpInfo(state => {
    var _state$ipInfo;
    return (state === null || state === void 0 ? void 0 : (_state$ipInfo = state.ipInfo) === null || _state$ipInfo === void 0 ? void 0 : _state$ipInfo.countryCode) ?? 'GB';
  });
  return /*#__PURE__*/React__default.createElement(AutoCompleteInputFieldV2, Object.assign({}, props, {
    renderOption: (optionProps, option) => {
      var _option$obj, _option$obj2;
      const label = getFlagEmojiFromCountryCode(option === null || option === void 0 ? void 0 : option.id.split('|')[0]);
      return /*#__PURE__*/React__default.createElement("li", Object.assign({}, optionProps), label, /*#__PURE__*/React__default.createElement(Typography$1, {
        paddingLeft: '10px'
      }, option === null || option === void 0 ? void 0 : (_option$obj = option.obj) === null || _option$obj === void 0 ? void 0 : _option$obj.countryDisplayName), /*#__PURE__*/React__default.createElement(Box, {
        width: '8px'
      }), /*#__PURE__*/React__default.createElement(Typography$1, {
        variant: 'bodySubtext'
      }, option === null || option === void 0 ? void 0 : (_option$obj2 = option.obj) === null || _option$obj2 === void 0 ? void 0 : _option$obj2.cleanTimezone));
    },
    options: mapCountriesToItemOptions,
    listLimit: 1000,
    value: mapCountriesToItemOptions.find(countryObject => {
      return countryObject.id.startsWith(props.selectedCountryCode ?? ipCountryCode);
    }) ?? {
      label: '',
      id: 'GB|Europe/London'
    },
    disabled: props.disabled,
    readOnly: props.readOnly,
    fieldLabel: props.countryInputLabel ?? '',
    getOptionLabel: option => {
      if (typeof option === 'object') {
        var _option$obj3, _option$obj4, _option$obj5;
        const label = option !== null && option !== void 0 && (_option$obj3 = option.obj) !== null && _option$obj3 !== void 0 && _option$obj3.isTimezone ? `${getFlagEmojiFromCountryCode(option === null || option === void 0 ? void 0 : option.id.split('|')[0])} ${option === null || option === void 0 ? void 0 : (_option$obj4 = option.obj) === null || _option$obj4 === void 0 ? void 0 : _option$obj4.countryDisplayName} ${option === null || option === void 0 ? void 0 : (_option$obj5 = option.obj) === null || _option$obj5 === void 0 ? void 0 : _option$obj5.cleanTimezone}` : option === null || option === void 0 ? void 0 : option.label;
        return label ?? '';
      }
      return option;
    }
  }));
};
const FormInputCountry = props => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: props.name,
    control: props.control,
    render: ({
      field: {
        onChange,
        value
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(CountryInputDropDownSortedInput, Object.assign({}, props, {
        selectedCountryCode: value,
        onChange: value => {
          onChange(value === null || value === void 0 ? void 0 : value.id);
        }
      }));
    }
  });
};

const MappedCountries = () => {
  let mappedList = [];
  CountryCodesWithNames.forEach(country => {
    const base = {
      cc: country.id,
      ccDisplayName: country.displayName
    };
    mappedList.push(base);
  });
  return mappedList;
};
const MappedCountriesForAutoComplete = () => {
  let mappedList = [];
  MappedCountries().forEach(mappedCountry => {
    mappedList.push({
      id: mappedCountry.cc,
      label: getFlagEmojiFromCountryCode(mappedCountry.cc) + ' ' + mappedCountry.ccDisplayName,
      obj: {}
    });
  });
  return mappedList;
};

const CountrySelectorV2 = ({
  id = 'countryselectorv2',
  selected,
  setSelected,
  disabled = false,
  fieldLabel = 'Country',
  placeholder = 'Please select a country'
}) => {
  const [localSelectedState, setLocalSelectedState] = useState(undefined);
  const mapCountriesToItemOptions = MappedCountriesForAutoComplete();
  useEffect(() => {
    setLocalSelectedState(selected ?? undefined);
  }, [selected]);
  return /*#__PURE__*/React__default.createElement(AutoCompleteInputFieldV2, {
    id: id,
    disabled: disabled,
    fieldLabel: fieldLabel,
    renderOption: (optionProps, option) => {
      return /*#__PURE__*/React__default.createElement("li", Object.assign({}, optionProps), /*#__PURE__*/React__default.createElement(Typography, {
        color: ColoursObj.font.primary === ColoursObj.backgrounds.input ? ColoursObj.shades.shade1 : ColoursObj.font.primary,
        style: {
          opacity: disabled ? '0.38' : '1'
        }
      }, option === null || option === void 0 ? void 0 : option.label));
    },
    options: mapCountriesToItemOptions,
    listLimit: 1000,
    value: localSelectedState ? mapCountriesToItemOptions.find(countryObj => {
      return localSelectedState === countryObj.id;
    }) : null,
    onChange: value => {
      if (setSelected && value && value.id && typeof value.id === 'string') {
        setSelected(value === null || value === void 0 ? void 0 : value.id);
      }
    },
    placeholder: placeholder
  });
};
const FormInputCountrySelectorV2 = props => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: props.name,
    control: props.control,
    render: ({
      field: {
        onChange,
        value
      }
    }) => {
      return /*#__PURE__*/React__default.createElement(CountrySelectorV2, Object.assign({}, props, {
        selected: value,
        setSelected: setCC => {
          onChange(setCC);
        }
      }));
    }
  });
};

const UploadFileField = ({
  fieldLabel,
  disabled,
  required,
  helperTooltip,
  uploadButtonLabel,
  onFilesChanged,
  maxFileSize = 5242880,
  maxFiles,
  accept,
  waitForUpload,
  onItemRemove,
  mobile,
  style,
  values,
  displayFileList = true,
  fileUploadError,
  beforeItemRemove = () => Promise.resolve(true)
}) => {
  const [files, setFiles] = useState([]);
  const [uploadError, setUploadError] = useState({
    error: false,
    message: ''
  });
  useEffect(() => {
    const hasError = files.some(f => f.status === 'error');
    if (fileUploadError) {
      fileUploadError(hasError);
    }
  }, [files, fileUploadError]);
  useEffect(() => {
    if (values) {
      setFiles(values);
    }
  }, [values]);
  const _onDrop = (acceptedFiles, fileRejections) => {
    let newFilesAdded = false;
    for (const file of acceptedFiles) {
      if (files.find(f => {
        var _f$file;
        return ((_f$file = f.file) === null || _f$file === void 0 ? void 0 : _f$file.name) === file.name;
      })) {
        continue;
      }
      newFilesAdded = true;
      const fileWithStatus = {
        file: file,
        status: 'uploaded'
      };
      if (waitForUpload) {
        fileWithStatus.status = 'uploading';
      } else {
        fileWithStatus.status = 'uploaded';
      }
      files.push(fileWithStatus);
    }
    if (newFilesAdded) {
      setUploadError({
        error: false,
        message: ''
      });
    }
    if (fileRejections.length > 0) {
      for (const file of fileRejections) {
        if (files.find(f => {
          var _f$file2;
          return ((_f$file2 = f.file) === null || _f$file2 === void 0 ? void 0 : _f$file2.name) === file.file.name;
        })) {
          continue;
        }
        const fileTooLarge = file.errors[0].code === 'file-too-large';
        const fileWithStatus = {
          file: file.file,
          status: 'error'
        };
        setUploadError({
          error: true,
          message: fileTooLarge ? `File is larger than ${bytesToMB(maxFileSize)} MB` : file.errors[0].message
        });
        removeFile(fileWithStatus, true);
      }
    }
    setFiles([...files]);
    if (onFilesChanged) {
      onFilesChanged(files);
    }
  };
  const removeFile = function (file, skipDialog) {
    try {
      let _exit = false;
      function _temp2(_result) {
        if (_exit) return _result;
        const newFiles = files.filter(f => f !== file);
        setFiles(newFiles);
        if (onItemRemove) {
          onItemRemove(file);
        }
        if (onFilesChanged) {
          onFilesChanged(newFiles);
        }
      }
      const _temp = function () {
        if (!skipDialog) {
          return Promise.resolve(beforeItemRemove(file)).then(function (_beforeItemRemove) {
            if (!_beforeItemRemove) {
              _exit = true;
            }
          });
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  const {
    open,
    getInputProps
  } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop: _onDrop,
    maxSize: maxFileSize,
    maxFiles: maxFiles,
    multiple: false,
    accept: accept
  });
  const getErroredFileMessage = () => {
    return uploadError.message;
  };
  return /*#__PURE__*/React__default.createElement(Stack, {
    spacing: '8px',
    sx: style
  }, fieldLabel && ( /*#__PURE__*/React__default.createElement(Stack, {
    direction: 'row',
    alignItems: 'center',
    spacing: '8px'
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext',
    style: {
      color: ColoursObj.font.primary,
      opacity: disabled ? '0.38' : '1'
    }
  }, fieldLabel, required && ' *'), helperTooltip && ( /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: helperTooltip,
    placement: 'right-start',
    arrow: true
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: 'fit-content'
    }
  }, /*#__PURE__*/React__default.createElement(Help, {
    height: 24,
    width: 24
  })))))), /*#__PURE__*/React__default.createElement(Stack, {
    direction: mobile ? 'column' : 'row',
    spacing: '16px'
  }, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Box, {
    height: mobile ? '72px' : '108px',
    width: mobile ? '100%' : '306px',
    border: 'dashed 2px',
    borderRadius: '4px',
    borderColor: uploadError.error ? ColoursObj.states.error : ColoursObj.shades.shade3,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'uploadFileButton',
    disabled: disabled,
    style: {
      width: '90%'
    },
    onClick: () => {
      open();
    }
  }, uploadButtonLabel ?? 'Upload File', /*#__PURE__*/React__default.createElement("input", Object.assign({}, getInputProps(), {
    style: {
      display: 'none'
    }
  })))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodySubtext',
    color: ColoursObj.states.error
  }, getErroredFileMessage())), files.length > 0 && displayFileList && ( /*#__PURE__*/React__default.createElement(Stack, {
    className: 'noScrollBar',
    width: mobile ? 'calc(100vw - 40px)' : 'auto',
    maxHeight: '108px',
    overflow: 'auto',
    spacing: '8px',
    direction: 'column'
  }, files.map((f, i) => {
    var _f$file3;
    return /*#__PURE__*/React__default.createElement(Box, {
      key: i,
      width: mobile ? 'calc(100% - 16px)' : '262px',
      bgcolor: '#10375C14',
      borderRadius: '8px',
      padding: '8px 8px 8px 8px'
    }, /*#__PURE__*/React__default.createElement(Stack, {
      alignItems: 'center',
      justifyContent: 'space-between',
      direction: 'row'
    }, /*#__PURE__*/React__default.createElement(Typography$1, {
      noWrap: true,
      color: f.status === 'error' ? ColoursObj.states.error : ColoursObj.shades.shade1,
      variant: 'bodySubtext'
    }, (_f$file3 = f.file) === null || _f$file3 === void 0 ? void 0 : _f$file3.name), /*#__PURE__*/React__default.createElement(Stack, {
      alignItems: 'center',
      spacing: '8px',
      direction: 'row'
    }, f.status === 'uploading' && /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: '20px'
    }), /*#__PURE__*/React__default.createElement(IconButton, {
      onClick: () => {
        removeFile(f);
      },
      style: {
        padding: '0'
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      iconColour: ColoursObj.shades.shade1,
      name: 'Delete'
    })))));
  })))));
};
function bytesToMB(bytes) {
  return Math.round(bytes / (1024 * 1024));
}

const SearchInput = ({
  onInputChange,
  value,
  onEnterPress
}) => {
  useEffect(() => {
    var _window$document$getE;
    (_window$document$getE = window.document.getElementById('searchFieldForUserList')) === null || _window$document$getE === void 0 ? void 0 : _window$document$getE.focus();
  }, []);
  return /*#__PURE__*/React__default.createElement(TextInputField, {
    id: 'searchFieldForUserList',
    style: {
      marginTop: '0px'
    },
    helperText: 'Search',
    value: value,
    onChange: e => onInputChange(e.target.value),
    iconLeft: /*#__PURE__*/React__default.createElement(Search, null),
    muiTextFieldProps: {
      onKeyDown: event => {
        if (event.key === 'Enter') {
          onEnterPress === null || onEnterPress === void 0 ? void 0 : onEnterPress();
        }
      }
    }
  });
};

const TickBox = ({
  selected = false,
  setSelected
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: clickEvent => {
      clickEvent.stopPropagation();
      if (setSelected) {
        setSelected();
      }
      clickEvent.preventDefault();
    },
    style: {
      width: '23px',
      height: '23px',
      border: '1px solid ' + ColoursObj.shades.shade2,
      borderRadius: '4px',
      cursor: 'pointer'
    }
  }, selected && /*#__PURE__*/React__default.createElement(Tick, null));
};

function generateLocale(countryCode) {
  if (typeof countryCode !== 'string') {
    throw new Error('Country code must be a string');
  }
  countryCode = countryCode.toUpperCase();
  try {
    return 'en-GB';
  } catch (error) {
    console.error(`Error generating locale for country code: ${countryCode}. ${error.message}`);
    return countryCode;
  }
}

const RequiredActionDialog = ({
  open = true,
  header,
  marketingOptIn,
  body,
  onCancel,
  onConfirm,
  onMarketingOptInChange,
  subtext
}) => {
  const theme = useTheme();
  const matchesDesktop = useMediaQuery(theme.breakpoints.up('desktop'));
  const dialogBody = /*#__PURE__*/React__default.createElement(Gutters, {
    style: {
      height: '100%'
    },
    topPadding: '0px'
  }, /*#__PURE__*/React__default.createElement(motion.div, {
    style: {
      position: 'relative'
    },
    initial: {
      top: 500
    },
    animate: {
      top: 0
    },
    transition: {
      ease: 'easeOut',
      duration: 0.3
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    paddingTop: 'calc(env(safe-area-inset-top) + 24px )',
    width: '100%',
    height: '100%',
    gridTemplateRows: '1fr auto',
    display: 'grid'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    spacing: '24px'
  }, /*#__PURE__*/React__default.createElement(BriefcaseRobbin, null), /*#__PURE__*/React__default.createElement(Stack, {
    spacing: '16px'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    spacing: '8px'
  }, /*#__PURE__*/React__default.createElement(Typography, {
    id: 'overlay-mobile-required-action-dialogue-header',
    variant: 'mobileH2'
  }, header), /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodySubtext'
  }, subtext)), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular'
  }, body), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyBold'
  }, "Optional Marketing"), /*#__PURE__*/React__default.createElement(Stack, {
    paddingTop: '5px',
    direction: 'row'
  }, /*#__PURE__*/React__default.createElement(CheckboxField, {
    id: 'overlay-mobile-required-action-dialogue-optional-marketing-checkbox',
    style: {
      marginLeft: '-10px'
    },
    checked: marketingOptIn === true,
    onChange: v => {
      if (onMarketingOptInChange) onMarketingOptInChange(v.currentTarget.checked);
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodySubtext'
  }, "I agree to receiving emails and relevant marketing from Soft Pauer Global Limited and affiliates.")))), /*#__PURE__*/React__default.createElement(Stack, {
    width: '100%',
    paddingBottom: '24px',
    paddingTop: '24px',
    spacing: '8px',
    direction: 'row'
  }, /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'overlay-mobile-required-action-dialogue-decline-button',
    style: {
      width: '100%'
    },
    variant: 'secondary',
    onClick: () => {
      if (onCancel) onCancel();
    }
  }, "Decline"), /*#__PURE__*/React__default.createElement(MainButton, {
    id: 'overlay-mobile-required-action-dialogue-accept-button',
    onClick: () => {
      if (onConfirm) onConfirm();
    },
    style: {
      width: '100%'
    }
  }, "Accept")))));
  const desktopContainer = /*#__PURE__*/React__default.createElement(Card, {
    variant: 'elevation'
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: '100%',
    height: '100%',
    maxWidth: '460px'
  }, dialogBody));
  if (matchesDesktop) {
    return /*#__PURE__*/React__default.createElement(Backdrop, {
      sx: {
        color: ColoursObj.shades.shade3,
        backgroundColor: ColoursObj.backgrounds.primary,
        backdropFilter: 'blur(15px)',
        zIndex: theme => theme.zIndex.modal - 1
      },
      open: open
    }, desktopContainer);
  }
  return /*#__PURE__*/React__default.createElement(Card, {
    sx: {
      backgroundColor: ColoursObj.backgrounds.primary
    }
  }, dialogBody);
};

const TermsNotAcceptedProps = {
  open: true,
  header: 'Terms of Service',
  body: ( /*#__PURE__*/React__default.createElement(Stack, {
    spacing: '16px'
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular'
  }, "Please accept our ", /*#__PURE__*/React__default.createElement("a", {
    href: 'https://eventr.softpauer.com/user-agreement/'
  }, "User Agreement"), " and", ' ', /*#__PURE__*/React__default.createElement("a", {
    href: 'https://eventr.softpauer.com/privacy-policy/'
  }, "User Privacy Notice"), "."), /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular'
  }, "Accepting these updates is a requirement to continue using Eventr.")))
};

const BasePopover = ({
  id,
  open,
  anchorEl,
  handleClose,
  width = '306px',
  headerText,
  children,
  onBackClicked
}) => {
  return /*#__PURE__*/React__default.createElement(Popover, {
    id: id,
    open: open,
    anchorEl: anchorEl.current,
    onClose: handleClose,
    "aria-hidden": 'false',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    }
  }, /*#__PURE__*/React__default.createElement(Paper, {
    variant: 'outlined'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    width: width
  }, /*#__PURE__*/React__default.createElement(Stack, {
    paddingLeft: '10px',
    alignItems: 'center',
    direction: 'row'
  }, onBackClicked && /*#__PURE__*/React__default.createElement(Icon, {
    onClick: onBackClicked,
    name: 'Chevron_Left'
  }), /*#__PURE__*/React__default.createElement(Stack, {
    width: '84%',
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(Typography, {
    padding: '8px',
    variant: 'bodyRegular'
  }, headerText))), /*#__PURE__*/React__default.createElement(Divider, null), children)));
};

const IconSelectionPopover = props => {
  const {
    onChange,
    selected,
    ...baseProps
  } = props;
  const [search, setSearch] = useState('');
  const filteredIcons = useMemo(() => {
    if (!search) {
      return ActivityIcons;
    }
    return ActivityIcons.filter(iconName => iconName.toLowerCase().includes(search.toLowerCase()));
  }, [search]);
  return /*#__PURE__*/React__default.createElement(BasePopover, Object.assign({}, baseProps, {
    id: 'iconSelection-popover'
  }), /*#__PURE__*/React__default.createElement(Box, {
    padding: '0px 14px 10px 14px'
  }, /*#__PURE__*/React__default.createElement(SearchInput, {
    value: search,
    onInputChange: q => {
      setSearch(q);
    }
  })), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Box, {
    padding: '10px',
    maxHeight: '200px',
    overflow: 'auto'
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, filteredIcons.map(iconName => ( /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    key: iconName,
    xs: 1.5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: () => onChange(iconName),
    sx: {
      padding: '2px',
      borderRadius: '4px',
      border: `1px solid ${selected === iconName ? ColoursObj.core.secondary : ColoursObj.shades.shade3}`
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: iconName,
    iconColour: selected === iconName ? ColoursObj.core.secondary : ColoursObj.core.primary
  }))))))));
};

const VisibilityPopover = props => {
  const {
    onChange,
    selected,
    availableValues,
    ...baseProps
  } = props;
  const _availableValues = availableValues || ['Team', 'Public', 'Private'];
  const visibilityList = [{
    id: 'Team',
    name: 'Team',
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      name: 'LetterT',
      iconColour: ColoursObj.core.secondary
    })
  }, {
    id: 'Public',
    name: 'Public',
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Public',
      iconColour: ColoursObj.core.secondary
    })
  }, {
    id: 'Private',
    name: 'Private',
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Private',
      iconColour: ColoursObj.core.secondary
    })
  }].filter(v => _availableValues === null || _availableValues === void 0 ? void 0 : _availableValues.includes(v.id));
  return /*#__PURE__*/React__default.createElement(BasePopover, Object.assign({}, baseProps, {
    headerText: 'Visibility',
    width: '193px',
    id: 'visibility-popover'
  }), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Stack, null, visibilityList.map(v => ( /*#__PURE__*/React__default.createElement(Stack, {
    key: v.id,
    direction: 'row',
    justifyContent: 'flex-start',
    spacing: '8px',
    padding: '10px 14px'
  }, /*#__PURE__*/React__default.createElement(TickBox, {
    selected: selected === v.id,
    setSelected: () => {
      onChange(v.id);
    }
  }), v.icon, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodyRegular'
  }, v.name)))))), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Box, {
    padding: '10px 14px'
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodySubtext'
  }, "Private: Only activity members. Team: All team members. Public: Everyone.")));
};

var sortingType;
(function (sortingType) {
  sortingType["Default"] = "default";
  sortingType["Ascending"] = "ascending";
  sortingType["Descending"] = "descending";
})(sortingType || (sortingType = {}));
const GenericTable = props => {
  const [rowsPerPageOptions] = useState(props.listOfRowsPerPage ?? [10, 25, 50, 100]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(props.defaultRowsPerPage ?? rowsPerPageOptions[0]);
  const [filteredData, setFilteredData] = useState(props.data);
  const [sorting, setSorting] = useState({
    key: props.columns && props.columns.length > 0 ? props.columns[0] : '',
    order: sortingType.Default
  });
  const defaultOrder = props.data;
  useEffect(() => {
    setFilteredData(props.data);
  }, [props.data]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    return event;
  };
  function onSort(column) {
    if (column === 'SelectBox') return;
    if (column === sorting.key) setSorting({
      ...sorting,
      order: getNextSortingOrder(sorting.order)
    });else setSorting({
      key: column,
      order: sortingType.Ascending
    });
  }
  useEffect(() => {
    const isAscending = sorting.order === sortingType.Ascending;
    const isDescending = sorting.order === sortingType.Descending;
    const sortedData = sorting.order === sortingType.Default ? [...defaultOrder] : [...filteredData].sort((a, b) => {
      let aValue = a[sorting.key];
      let bValue = b[sorting.key];
      if (props.sortingVarientCallback) [aValue, bValue] = props.sortingVarientCallback(a, b, sorting);
      if (isAscending) return aValue.localeCompare(bValue);
      if (isDescending) return bValue.localeCompare(aValue);
      return 0;
    });
    if (!sortedData.every((item, index) => item === filteredData[index])) {
      setFilteredData(sortedData);
    }
  }, [sorting.key, sorting.order, defaultOrder]);
  useEffect(() => {
    if (props.injectPage) setPage(props.injectPage);
  }, [props.injectPage]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TableContainer, null, /*#__PURE__*/React__default.createElement(Table, null, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      alignItems: 'center'
    }
  }, props.columns && props.columns.map(column => ( /*#__PURE__*/React__default.createElement(TableCell, {
    width: column !== 'SelectBox' ? `${100 / props.columns.length}%` : `${1}%`,
    style: {
      cursor: 'pointer'
    },
    key: column,
    onClick: () => onSort(column)
  }, /*#__PURE__*/React__default.createElement(Stack, {
    direction: 'row',
    justifyContent: 'space-between'
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyBold'
  }, column !== 'SelectBox' ? column : ''), /*#__PURE__*/React__default.createElement(Stack, {
    justifyContent: 'center'
  }, column !== 'SelectBox' ? ( /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Chevron_Up, {
    height: 10,
    fill: sorting.key === column && sorting.order === sortingType.Ascending ? ColoursObj.shades.shade2 : ColoursObj.shades.shade1
  }), /*#__PURE__*/React__default.createElement(Chevron_Down, {
    height: 10,
    fill: sorting.key === column && sorting.order === sortingType.Descending ? ColoursObj.shades.shade2 : ColoursObj.shades.shade1
  }))) : ( /*#__PURE__*/React__default.createElement("div", null))))))))), /*#__PURE__*/React__default.createElement(TableBody, null, filteredData && filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((rowObject, rowIndex) => ( /*#__PURE__*/React__default.createElement(TableRow, {
    hover: true,
    sx: {
      backgroundColor: rowIndex % 2 - 1 !== 0 ? ColoursObj.backgrounds.primary : ColoursObj.backgrounds.secondary
    },
    key: rowIndex
  }, props.columns.map((column, columnIndex) => ( /*#__PURE__*/React__default.createElement(TableCell, {
    key: column,
    onClick: () => {
      if (props.onRowClick) {
        props.onRowClick(rowObject.id, rowIndex, columnIndex);
      }
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: 'bodyRegular'
  }, rowObject[column])))))))))), props.showPagination && ( /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: rowsPerPageOptions,
    component: 'div',
    count: props.data.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: event => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    }
  })));
};
const getNextSortingOrder = sortingOrder => {
  return sortingOrder === sortingType.Ascending ? sortingType.Descending : sortingOrder === sortingType.Descending ? sortingType.Default : sortingType.Ascending;
};

const getLuminance = hex => {
  const rgb = parseInt(hex.slice(1), 16);
  const r = rgb >> 16 & 0xff;
  const g = rgb >> 8 & 0xff;
  const b = rgb & 0xff;
  const [rNorm, gNorm, bNorm] = [r, g, b].map(v => v / 255);
  const [rLin, gLin, bLin] = [rNorm, gNorm, bNorm].map(v => v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4));
  return 0.2126 * rLin + 0.7152 * gLin + 0.0722 * bLin;
};
const getTextColor = bgColor => {
  const luminance = getLuminance(bgColor);
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
};

const ItinTag = ({
  colour,
  tag,
  size = 'small',
  onClick,
  tagExpended,
  expansionFunction,
  iconRight
}) => {
  const textColor = getTextColor(colour);
  const width = useMemo(() => {
    if (size === 'small' && !tagExpended) return '45px';
    return size === 'small' ? 'fit-content' : '100%';
  }, [size, tagExpended]);
  const height = useMemo(() => {
    if (size === 'small' && !tagExpended) return '0px';
    return size === 'small' ? '16px' : '32px';
  }, [size, tagExpended]);
  const padding = size === 'small' ? '4px 8px' : 'unset';
  const showText = useMemo(() => {
    if (!tagExpended && size === 'small') return false;
    return true;
  }, [tagExpended, size]);
  const right = useMemo(() => {
    if (typeof iconRight === 'string') {
      return /*#__PURE__*/createElement(Icon, {
        name: iconRight,
        width: '16px'
      });
    }
    return iconRight;
  }, [iconRight]);
  return /*#__PURE__*/createElement(AnimatePresence, null, /*#__PURE__*/createElement(motion.div, {
    initial: false,
    onClick: () => {
      onClick && onClick();
      if (size === 'large') return;
      expansionFunction && expansionFunction(tagExpended ? 'small' : 'large');
    },
    animate: {
      height: height
    },
    style: {
      cursor: 'pointer',
      borderRadius: '4px',
      backgroundColor: colour,
      padding: padding,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: width
    }
  }, showText && ( /*#__PURE__*/createElement(Stack, {
    alignItems: 'center',
    direction: 'row',
    gap: '8px'
  }, /*#__PURE__*/createElement(Typography, {
    color: textColor,
    variant: 'bodySubtext'
  }, tag), right))));
};

const Tag = props => {
  return /*#__PURE__*/React__default.createElement(Stack, {
    style: props.style,
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    onMouseDown: event => event.stopPropagation(),
    sx: {
      backgroundColor: props.Colour ?? ColoursObj.core.secondary,
      borderRadius: props.isChip ? '16px' : '4px',
      padding: '4px 8px',
      width: 'fit-content'
    },
    onClick: props.onRemove
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    color: props.textColour ?? ColoursObj.shades.shade5
  }, props.title), props.iconRight && /*#__PURE__*/React__default.createElement(Icon, {
    name: props.iconRight,
    iconColour: props.textColour ?? ColoursObj.shades.shade5
  }), props.removable && /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Cancel',
    iconColour: ColoursObj.shades.shade5
  }));
};

const TagList = ({
  tags,
  fieldLabel,
  disabled = false
}) => {
  return /*#__PURE__*/React__default.createElement(Stack, {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: 'bodySubtext',
    style: {
      color: ColoursObj.font.secondary,
      opacity: disabled ? '0.38' : '1',
      paddingBottom: '4px'
    }
  }, fieldLabel), /*#__PURE__*/React__default.createElement(Stack, {
    style: {
      background: ColoursObj.shades.shade4,
      borderRadius: '8px',
      width: '100%',
      flexWrap: 'wrap',
      minHeight: '48px'
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    direction: 'row',
    padding: '8px 16px',
    gap: '8px',
    alignItems: 'center',
    style: {
      width: '100%'
    }
  }, tags.length > 0 ? tags.map((tag, index) => ( /*#__PURE__*/React__default.createElement(Tag, {
    key: index,
    title: tag,
    style: {
      backgroundColor: ColoursObj.core.secondary
    }
  }))) : ( /*#__PURE__*/React__default.createElement("div", null)))));
};

const TypoDT = ({
  eventrDate,
  zone = 'itinLocal',
  type = 'shortDate',
  languageLocal = 'en-GB'
}) => {
  if (!eventrDate.isValid) {
    return /*#__PURE__*/React__default.createElement(Typography$1, null);
  }
  let luxonToDisplay = eventrDate.itinLocalLuxon;
  switch (zone) {
    case 'userLocal':
      luxonToDisplay = eventrDate.userLocalLuxon;
      break;
    case 'itinLocal':
      luxonToDisplay = eventrDate.itinLocalLuxon;
      break;
    case 'utc':
      luxonToDisplay = eventrDate.utcLuxon;
      break;
  }
  switch (type) {
    case 'shortDate':
      return /*#__PURE__*/React__default.createElement(Typography$1, null, luxonToDisplay.setLocale(languageLocal).toLocaleString(DateTime.DATE_SHORT));
    case 'longDate':
      return /*#__PURE__*/React__default.createElement(Typography$1, null, luxonToDisplay.setLocale(languageLocal).toLocaleString(DateTime.DATE_HUGE));
    case 'time':
      return /*#__PURE__*/React__default.createElement(Typography$1, null, luxonToDisplay.setLocale(languageLocal).toLocaleString(DateTime.TIME_24_SIMPLE));
    case 'shortDateTime':
      return /*#__PURE__*/React__default.createElement(Typography$1, null, luxonToDisplay.setLocale(languageLocal).toLocaleString(DateTime.DATETIME_SHORT));
    case 'longDateTime':
      return /*#__PURE__*/React__default.createElement(Typography$1, null, luxonToDisplay.setLocale(languageLocal).toLocaleString(DateTime.DATETIME_MED));
  }
};

const ErrorWrapper = ({
  children,
  fallback,
  presetFallback,
  onReset,
  onError
}) => {
  const defaultOnError = e => {
    try {
      spLogTags('There has been an error rendering a component', ['error']);
      spLogTags(e, ['error']);
    } catch {}
  };
  function getFallback() {
    if (presetFallback != undefined) {
      switch (presetFallback) {
        case 'textField':
          return /*#__PURE__*/React__default.createElement(TextInputField, null);
        case 'selectField':
          return /*#__PURE__*/React__default.createElement("div", {
            style: {
              position: 'relative'
            }
          }, /*#__PURE__*/React__default.createElement(SelectInputField, {
            data: [],
            disabled: true
          }), /*#__PURE__*/React__default.createElement("div", {
            style: {
              position: 'absolute',
              display: 'flex',
              height: '100%',
              width: '100%',
              backgroundColor: ColoursObj.states.error,
              opacity: '0.3',
              top: '0'
            }
          }));
        case 'section':
          return /*#__PURE__*/React__default.createElement(Typography$1, {
            variant: 'bodyRegular',
            style: {
              height: '80%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }
          }, "There was an error in displaying this information, please contact eventr-admin@softpauer.com");
        case 'sectionForm':
          return /*#__PURE__*/React__default.createElement(Typography$1, {
            variant: 'bodyRegular',
            style: {
              height: '458px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }
          }, "There was an error in displaying this information, please contact eventr-admin@softpauer.com");
      }
    } else if (fallback) {
      return /*#__PURE__*/React__default.createElement("div", null, fallback);
    } else {
      return /*#__PURE__*/React__default.createElement(Typography$1, {
        variant: 'bodyRegular',
        style: {
          height: '458px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, "There was an error in displaying this information, please contact eventr-admin@softpauer.com");
    }
  }
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, {
    fallbackRender: getFallback,
    onReset: onReset,
    onError: onError ? onError : defaultOnError
  }, children);
};

var style$1 = {"InnerAppFrame":"_2itP1"};

const MobileAppFrame = ({
  width = '100%',
  height = '100%',
  topSafeArea = '0px',
  rightSafeArea = '0px',
  bottomSafeArea = '0px',
  leftSafeArea = '0px',
  overflow = 'auto',
  overscrollBehaviour,
  children,
  passedRef,
  scrollStyle,
  backgroundImageUrl,
  backgroundColour,
  userSelect = 'none'
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'grid',
      height: height,
      width: width,
      gridTemplateColumns: leftSafeArea + ' 1fr ' + rightSafeArea,
      overscrollBehavior: 'none',
      backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : 'none',
      backgroundColor: backgroundColour ? backgroundColour : ColoursObj.backgrounds.primary,
      backgroundSize: 'cover',
      userSelect: userSelect,
      msUserSelect: userSelect === 'auto' ? 'element' : 'none',
      MozUserSelect: userSelect,
      KhtmlUserSelect: userSelect,
      WebkitUserSelect: userSelect,
      WebkitTouchCallout: userSelect === 'auto' ? 'default' : 'none'
    }
  }, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", {
    className: style$1.InnerAppFrame,
    style: {
      display: 'grid',
      gridTemplateRows: topSafeArea + ' 1fr ' + bottomSafeArea,
      overflowX: 'hidden',
      overflowY: overflow,
      overscrollBehaviorBlock: overscrollBehaviour,
      ...scrollStyle
    },
    ref: passedRef
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'sticky',
      top: '0',
      zIndex: 55,
      backgroundColor: backgroundImageUrl ? 'transparent' : backgroundColour ? backgroundColour : ColoursObj.backgrounds.primary
    }
  }), children, /*#__PURE__*/React__default.createElement("div", null)), /*#__PURE__*/React__default.createElement("div", null));
};

const useSnackListStore = create()((set, get) => ({
  snackList: [],
  getUId: () => {
    return Date.now();
  },
  addSnackToList: (nodeComp, uId) => {
    const newList = [...get().snackList, {
      uId: uId,
      nodeComp: nodeComp
    }];
    set({
      snackList: newList
    });
  },
  removeSnackFromList: uId => {
    const newList = get().snackList.filter(listItem => {
      return listItem.uId !== uId;
    });
    set({
      snackList: newList
    });
  },
  clearList: () => {
    set({
      snackList: []
    });
  }
}));
const MobileSnackBar = ({
  snackList = [],
  onClose
}) => {
  return /*#__PURE__*/React__default.createElement(Snackbar, {
    open: snackList.length > 0,
    autoHideDuration: 6000,
    onClose: onClose,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    disableWindowBlurListener: true,
    resumeHideDuration: 3000
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    width: '100%'
  }, snackList.map((snack, index) => {
    return /*#__PURE__*/React__default.createElement(Box, {
      display: 'grid',
      key: 'snackBarNode' + index
    }, snack.nodeComp);
  })));
};

const MobileSnackBarCard = ({
  severity,
  icon,
  onXClick,
  children
}) => {
  let bgColour = () => {
    switch (severity) {
      case 'error':
        {
          return ColoursObj.states.error;
        }
      case 'warning':
        {
          return ColoursObj.states.warning;
        }
      case 'success':
        {
          return ColoursObj.states.success;
        }
      default:
        {
          return ColoursObj.backgrounds.primary;
        }
    }
  };
  let fontColour = () => {
    switch (severity) {
      case 'error':
        {
          return ColoursObj.shades.shade5;
        }
      case 'warning':
        {
          return ColoursObj.shades.shade5;
        }
      case 'success':
        {
          return ColoursObj.shades.shade5;
        }
      default:
        {
          return ColoursObj.font.primary;
        }
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid'
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    sx: {
      backgroundColor: bgColour,
      borderRadius: '8px'
    },
    padding: '4px 16px 4px 16px',
    margin: '4px 16px'
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: 'auto 1fr auto',
    justifyItems: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: icon ?? 'Important',
    iconColour: fontColour()
  }), /*#__PURE__*/React__default.createElement(Box, null, children), /*#__PURE__*/React__default.createElement(Box, null, onXClick && ( /*#__PURE__*/React__default.createElement(Box, {
    display: 'grid',
    marginLeft: '16px'
  }, /*#__PURE__*/React__default.createElement(Divider, {
    color: 'white',
    orientation: 'vertical',
    flexItem: true
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: onXClick
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'Exit',
    iconColour: fontColour()
  }))))))));
};

const PullToRefreshSP = props => {
  return /*#__PURE__*/React__default.createElement(PullToRefresh, Object.assign({}, props), props.children);
};
const StyledPullToRefresh = props => {
  const onRefresh = function () {
    try {
      const _temp = function () {
        if (props.promiseFunction) {
          return Promise.resolve(props.promiseFunction()).then(function () {});
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(PullToRefreshSP, Object.assign({}, props, {
    children: /*#__PURE__*/React__default.createElement(Stack, null, props.children),
    onRefresh: onRefresh,
    refreshingContent: /*#__PURE__*/React__default.createElement(Stack, {
      display: 'grid',
      gridTemplateColumns: '1fr',
      justifyItems: 'center',
      alignItems: 'center',
      padding: '16px 0 0 0'
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Loading'
    })),
    pullingContent: /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'grid',
        width: '100%',
        justifyItems: 'center'
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: 'Chevron_Down'
    }))
  }));
};

const ValidatorContext = /*#__PURE__*/createContext({
  isFieldValid: () => true,
  isAllValid: true,
  showErrors: false,
  fieldStates: [],
  setValidationOn: () => {},
  removeFieldState: () => {},
  setShowErrors: () => {}
});
const findPathById = (obj, id, path = []) => {
  if (obj === undefined || obj === null) {
    return undefined;
  }
  if (obj._id === id) {
    return path;
  }
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      var _i;
      const result = findPathById(obj[i], id, [...path, (_i = i) === null || _i === void 0 ? void 0 : _i.toString()]);
      if (result) {
        return result;
      }
    }
  } else if (typeof obj === 'object') {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const result = findPathById(obj[key], id, [...path, key]);
        if (result) {
          return result;
        }
      }
    }
  }
  return undefined;
};
const getFieldValueFromPath = (obj, path) => {
  let value = obj;
  for (let i = 0; i < path.length; i++) {
    if (Array.isArray(value)) {
      value = value[0];
    }
    value = value[path[i]];
  }
  return value;
};
const findParentObjectById = (obj, _id) => {
  if (_id) {
    const path = findPathById(obj, _id);
    if (path) {
      return buildObjectFromPath(obj, path);
    }
  }
  return obj;
};
const buildObjectFromPath = (obj, path) => {
  if (path.length === 0) {
    return obj;
  }
  const [head, ...tail] = path;
  if (Array.isArray(obj)) {
    const index = parseInt(head, 10);
    const newArray = [buildObjectFromPath(obj[index], tail)];
    return newArray;
  } else if (typeof obj === 'object') {
    const newObj = {
      ...obj,
      [head]: buildObjectFromPath(obj[head], tail)
    };
    return newObj;
  }
  return obj;
};
const ValidatorProvider = ({
  children,
  buildPathToField
}) => {
  const [isAllValid, setIsAllValid] = useState(true);
  const [fieldStates, setFieldStates] = useState([]);
  const [validationOn, setValidationOn] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  useEffect(() => {
    fieldStates.some(f => !f.isValid) ? setIsAllValid(false) : setIsAllValid(true);
  }, [fieldStates, setIsAllValid]);
  const _setValidationOn = on => {
    setValidationOn(on);
    if (!on) {
      setFieldStates([]);
    }
  };
  const setFieldState = useCallback((field, isValid, _id) => {
    const jsonKey = getJsonKeyFromField(field);
    const idWithJsonKey = _id ? `${_id}.${jsonKey}` : jsonKey;
    const index = fieldStates.findIndex(f => f.id === idWithJsonKey);
    if (index === -1) {
      setFieldStates([...fieldStates, {
        id: idWithJsonKey,
        isValid
      }]);
    } else {
      if (fieldStates[index].isValid !== isValid) {
        fieldStates[index].isValid = isValid;
        setFieldStates([...fieldStates]);
      }
    }
  }, [fieldStates, setFieldStates]);
  const removeFieldState = useCallback((field, _id) => {
    const jsonKey = getJsonKeyFromField(field);
    const idWithJsonKey = _id ? `${_id}.${jsonKey}` : jsonKey;
    const index = fieldStates.findIndex(f => f.id === idWithJsonKey);
    if (index !== -1) {
      fieldStates.splice(index, 1);
      setFieldStates([...fieldStates]);
    } else {
      setFieldStates([]);
    }
  }, [fieldStates, setFieldStates]);
  const validateBeforeDate = useCallback((validation, fieldValue, sectionValues, _id) => {
    if (!fieldValue) return false;
    if (sectionValues === undefined) {
      spLog('section values undefined', 'validate before date in ${fieldValue}');
      return false;
    }
    const parentObject = findParentObjectById(sectionValues, _id);
    const comparePath = buildPathToField(validation.fieldValue);
    const compareValue = getFieldValueFromPath(parentObject, comparePath);
    if (compareValue) {
      if (new EventrDate(fieldValue).getUnixMs > new EventrDate(compareValue).getUnixMs) return true;
    }
    return false;
  }, [buildPathToField]);
  const validateAfterDate = useCallback((validation, fieldValue, sectionValues, _id) => {
    if (!fieldValue) return false;
    if (sectionValues === undefined) return false;
    const parentObject = findParentObjectById(sectionValues, _id);
    const comparePath = buildPathToField(validation.fieldValue);
    const compareValue = getFieldValueFromPath(parentObject, comparePath);
    if (compareValue) {
      if (new EventrDate(fieldValue).getUnixMs < new EventrDate(compareValue).getUnixMs) return true;
    }
    return false;
  }, [buildPathToField]);
  const isFieldValid = useCallback((field, _id, fieldValue, sectionValues) => {
    var _field$type_propertie, _field$type_propertie2;
    if (!validationOn) return true;
    if (!((_field$type_propertie = field.type_properties) !== null && _field$type_propertie !== void 0 && _field$type_propertie.validations)) {
      return true;
    }
    const error = (_field$type_propertie2 = field.type_properties) === null || _field$type_propertie2 === void 0 ? void 0 : _field$type_propertie2.validations.find(v => {
      switch (v.type) {
        case ValidationTypes.required:
          if (!fieldValue || fieldValue === '') return true;
          break;
        case ValidationTypes.minLength:
          if (fieldValue.length < v.rawValue) return true;
          break;
        case ValidationTypes.maxLength:
          if (fieldValue.length > v.rawValue) return true;
          break;
        case ValidationTypes.beforeDate:
          return validateBeforeDate(v, fieldValue, sectionValues, _id);
        case ValidationTypes.afterDate:
          return validateAfterDate(v, fieldValue, sectionValues, _id);
        case ValidationTypes.url:
          if (!fieldValue || fieldValue === '') return false;
          return !/^\S+$/.test(fieldValue);
        case ValidationTypes.number:
          if (typeof fieldValue === 'number' || fieldValue === '') return false;
          return !RegExpCheckInteger(fieldValue);
      }
      return false;
    });
    setFieldState(field, !error, _id);
    if (!showErrors) return true;
    return error ? error.errorMessage : true;
  }, [setFieldState, validationOn, showErrors, validateBeforeDate, validateAfterDate]);
  return /*#__PURE__*/React__default.createElement(ValidatorContext.Provider, {
    value: {
      isFieldValid,
      isAllValid,
      removeFieldState,
      fieldStates,
      setValidationOn: _setValidationOn,
      setShowErrors,
      showErrors
    }
  }, children);
};
const useValidatorContext = () => {
  return useContext(ValidatorContext);
};

export { Activity, ActivityIcons, Add, Add_Group, Add_User, Additional_Information, AddressLookup, Admin, AdminBobbin, AdminBobbinDark, Admin_Boarder, AdvanceFieldContainer, AdvanceFieldsForm, Airline, AirportAutoComplete, Amenities, Archive, Arrive, Attach, AuthImage, AutoCompleteInputField, AutoCompleteInputFieldV2, BasePopover, Bike, Billing, BobbinBus, BobbinCar, BobbinGroup, BobbinGroupDark, BobbinParking, BobbingInBed, BriefcaseRobbin, Building, Bus, CEventrIcons, Calendar, Calendar_Today, CalenderDrawer, Camera, Cancel, Cancel_Event, Car_Allocation, Car_Type, CelebrateBobbin, CelebrateBobbinDark, Chart, Chat, Chat_Notf, CheckboxField, Chevron_Down, Chevron_Expand, Chevron_Left, Chevron_Right, Chevron_Up, Circle, ClaimHide, Clive, CliveDark, ClockFaceDrawer, CollapseList, CollapsibleListEntry, ColoursObj, Contact_Phone, Copy, CoreImagesStoriesComp, CountryInputDropDown, CountryInputDropDownSorted, CountryInputDropDownSortedInput, CountrySelectorV2, CoverImageUploadButtonPreview, Cross, Customise, Dashboard, DatePicker, DateRangeFilterButton, DateRangePicker, DateTimeDrawer, DateTimePicker, DatetimePickerPopover, DatetimePickerV3, DatetimePickerV3Calendar, DatetimePickerV3YearSelector, DatetimeV3FormatList, DatetimeV3SeparatorsList, DefaultCoverImage, Delete, Depart, Diagonal_Enlarge, Document, Download, Dress_Code, Driver, Duplicate, Edit, Edit_Text, Email, EmailBobbin, Emergency_Contact, Enhance, Enlarge, ErrorBobbin, ErrorWrapper, Event_Session, Event_Type, EventrLogoDark, Exit, ExpandMore, Expand_Field, Ferry, Filter, Filter2, FilterButtonDropdown, Find, Flight, FlightBobbin, Flight_Booking, Flight_Side, FormDatePicker, FormDateTimePicker, FormHiddenInputField, FormInputCountry, FormInputCountrySelectorV2, FormInputText, FormMobileDateOfBirthPicker, FormSelectInput, Free_Edit, GenericTable, Globe, Group, Gutters, Hamburger, Help, HiddenInput, Hide, Hire_Car, History, Home, HorizontalExpander, Hotel, Icon, IconSelectionPopover, IconsActions, IconsArrows, IconsGeneral, IconsNavigation, IconsOther, IconsStatus, ImageRenderer, ImageSelectionField, ImageSelectionForm, ImageUploadButton, Important, Info, Internet, ItinTag, Itinerary, Kebab, Keyboard, Keyboard_Hide, Languages, Layover, Leave_App, Left, LetterT, Link, List, Loading, LoadingSpinner, Location, Location_Pin, Lock_Visibility, Locked, Log_Out, Low_Data, MainButton, Map$1 as Map, MappedCountries, MappedCountriesForAutoComplete, MappedTimezones, MappedTimezonesForAutoComplete, Meal, MenuButton, MicrophoneBobbin, Minimise, MobileAppFrame, MobileConfirmDialog, MobileDateOfBirthPicker, MobileDateRangePicker, MobileDateRangePickerUtils, MobileDialog, MobileDrawer, MobileDrawerFrame, MobileFrameDialog, MobileInfoDialog, MobileRangeCalenderForDrawer, MobileSnackBar, MobileSnackBarCard, More, MuiShaddows, NativeUtils, New_Itinerary, Night, Notification, NumberCounter, NumberInputForDatetimePickerV3, Okay, Parking, Phone, Photos, Private, Public, PullToRefreshSP, Push_Pin, Qr_Code, Redo, Refresh, Reports, RequiredActionDialog, Right, Room_Leave, Room_Type, Route, RsuiteDateRangePicker, RunningBobbin, RunningBobbinDark, Schedule, Search, SearchInput, Seat, Security, SelectButton, SelectInputField, SelectedTheme, Send, Settings, Share, Share_Location, Sidebar_Left, Sidebar_Right, SnackBarAlert, SnorkelBobbin, Sort, Sort_Down, Sort_Up, Stand, Stays, StyledPullToRefresh, Subtract, Subway, Suitcase, Swap, Sync, Tag, TagIcon, TagList, Taxi, Team_Code, Team_Members, TermsNotAcceptedProps, TextInputField, Tick, TickBox, Ticket, TicketIcon, Time, TimePicker, TimeZoneClickable, TimezoneDropdown, ToDo, Tooltip, Train, Tram, Transfer, TypoDT, Typography, Undo, Unlocked, Upload, UploadFileField, User, Users, ValidatorProvider, VerticalExpander, VisibilityPopover, Visible, Walk, Wifi, Wifi_Off, drawerStore, findParentObjectById, generateLocale, generateTheme, getBeforeSeparatorFromV3Format, getContrastYIQ, getCountryCodeFromTimezoneEnum, getFieldValueFromPath, getFlagEmojiFromCountryCode, getFlagEmojiFromTimezoneEnum, getGraphColour, getLengthValueFromV3Format, getLuminance, getMaxValueFromV3Format, getMinValueFromV3Format, getNextInputFromV3Format, getNiceNameFromV3Format, getPlaceholderFromV3Format, getPrevInputFromV3Format, getSafariVersion, getSectionColour, getTagColourHex, getTextColor, getTimezoneTextForV3DatePicker, isLastInFromV3FormatList, isStringNotValidNumber, selectInputText, setColourScheme, sortingType, theme, useDialogStore, useDrawerStore, useIpInfo, useMobileDateRangePickerStore, useSnackListStore, useToken, useValidatorContext, v3HelperGetDatetimeDisplayObjFromEventrDate, v3HelperGetEventrDateFromDatetimeString, v3HelperGetEventrDateFromObj };
//# sourceMappingURL=index.modern.js.map
